
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequireb728"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequireb728"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("1b2ls", function(module, exports) {

$parcel$export(module.exports, "Fragment", () => $0db8a335f84591c1$export$ffb0004e005737fa, (v) => $0db8a335f84591c1$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "jsx", () => $0db8a335f84591c1$export$34b9dba7ce09269b, (v) => $0db8a335f84591c1$export$34b9dba7ce09269b = v);
$parcel$export(module.exports, "jsxs", () => $0db8a335f84591c1$export$25062201e9e25d76, (v) => $0db8a335f84591c1$export$25062201e9e25d76 = v);
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $0db8a335f84591c1$export$ffb0004e005737fa;
var $0db8a335f84591c1$export$34b9dba7ce09269b;
var $0db8a335f84591c1$export$25062201e9e25d76;
'use strict';

var $acw62 = parcelRequire("acw62");
var $0db8a335f84591c1$var$k = Symbol.for("react.element"), $0db8a335f84591c1$var$l = Symbol.for("react.fragment"), $0db8a335f84591c1$var$m = Object.prototype.hasOwnProperty, $0db8a335f84591c1$var$n = $acw62.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, $0db8a335f84591c1$var$p = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $0db8a335f84591c1$var$q(c, a, g) {
    var b, d = {}, e = null, h = null;
    void 0 !== g && (e = "" + g);
    void 0 !== a.key && (e = "" + a.key);
    void 0 !== a.ref && (h = a.ref);
    for(b in a)$0db8a335f84591c1$var$m.call(a, b) && !$0db8a335f84591c1$var$p.hasOwnProperty(b) && (d[b] = a[b]);
    if (c && c.defaultProps) for(b in a = c.defaultProps, a)void 0 === d[b] && (d[b] = a[b]);
    return {
        $$typeof: $0db8a335f84591c1$var$k,
        type: c,
        key: e,
        ref: h,
        props: d,
        _owner: $0db8a335f84591c1$var$n.current
    };
}
$0db8a335f84591c1$export$ffb0004e005737fa = $0db8a335f84591c1$var$l;
$0db8a335f84591c1$export$34b9dba7ce09269b = $0db8a335f84591c1$var$q;
$0db8a335f84591c1$export$25062201e9e25d76 = $0db8a335f84591c1$var$q;

});
parcelRegister("acw62", function(module, exports) {
'use strict';

module.exports = (parcelRequire("2pUnB"));

});
parcelRegister("2pUnB", function(module, exports) {

$parcel$export(module.exports, "Children", () => $1c29a66706a62afd$export$dca3b0875bd9a954, (v) => $1c29a66706a62afd$export$dca3b0875bd9a954 = v);
$parcel$export(module.exports, "Component", () => $1c29a66706a62afd$export$16fa2f45be04daa8, (v) => $1c29a66706a62afd$export$16fa2f45be04daa8 = v);
$parcel$export(module.exports, "Fragment", () => $1c29a66706a62afd$export$ffb0004e005737fa, (v) => $1c29a66706a62afd$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "Profiler", () => $1c29a66706a62afd$export$e2c29f18771995cb, (v) => $1c29a66706a62afd$export$e2c29f18771995cb = v);
$parcel$export(module.exports, "PureComponent", () => $1c29a66706a62afd$export$221d75b3f55bb0bd, (v) => $1c29a66706a62afd$export$221d75b3f55bb0bd = v);
$parcel$export(module.exports, "StrictMode", () => $1c29a66706a62afd$export$5f8d39834fd61797, (v) => $1c29a66706a62afd$export$5f8d39834fd61797 = v);
$parcel$export(module.exports, "Suspense", () => $1c29a66706a62afd$export$74bf444e3cd11ea5, (v) => $1c29a66706a62afd$export$74bf444e3cd11ea5 = v);
$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", () => $1c29a66706a62afd$export$ae55be85d98224ed, (v) => $1c29a66706a62afd$export$ae55be85d98224ed = v);
$parcel$export(module.exports, "act", () => $1c29a66706a62afd$export$3ba232387fd5d6dd, (v) => $1c29a66706a62afd$export$3ba232387fd5d6dd = v);
$parcel$export(module.exports, "cloneElement", () => $1c29a66706a62afd$export$e530037191fcd5d7, (v) => $1c29a66706a62afd$export$e530037191fcd5d7 = v);
$parcel$export(module.exports, "createContext", () => $1c29a66706a62afd$export$fd42f52fd3ae1109, (v) => $1c29a66706a62afd$export$fd42f52fd3ae1109 = v);
$parcel$export(module.exports, "createElement", () => $1c29a66706a62afd$export$c8a8987d4410bf2d, (v) => $1c29a66706a62afd$export$c8a8987d4410bf2d = v);
$parcel$export(module.exports, "createFactory", () => $1c29a66706a62afd$export$d38cd72104c1f0e9, (v) => $1c29a66706a62afd$export$d38cd72104c1f0e9 = v);
$parcel$export(module.exports, "createRef", () => $1c29a66706a62afd$export$7d1e3a5e95ceca43, (v) => $1c29a66706a62afd$export$7d1e3a5e95ceca43 = v);
$parcel$export(module.exports, "forwardRef", () => $1c29a66706a62afd$export$257a8862b851cb5b, (v) => $1c29a66706a62afd$export$257a8862b851cb5b = v);
$parcel$export(module.exports, "isValidElement", () => $1c29a66706a62afd$export$a8257692ac88316c, (v) => $1c29a66706a62afd$export$a8257692ac88316c = v);
$parcel$export(module.exports, "lazy", () => $1c29a66706a62afd$export$488013bae63b21da, (v) => $1c29a66706a62afd$export$488013bae63b21da = v);
$parcel$export(module.exports, "memo", () => $1c29a66706a62afd$export$7c73462e0d25e514, (v) => $1c29a66706a62afd$export$7c73462e0d25e514 = v);
$parcel$export(module.exports, "startTransition", () => $1c29a66706a62afd$export$7568632d0d33d16d, (v) => $1c29a66706a62afd$export$7568632d0d33d16d = v);
$parcel$export(module.exports, "unstable_act", () => $1c29a66706a62afd$export$88948ce120ea2619, (v) => $1c29a66706a62afd$export$88948ce120ea2619 = v);
$parcel$export(module.exports, "useCallback", () => $1c29a66706a62afd$export$35808ee640e87ca7, (v) => $1c29a66706a62afd$export$35808ee640e87ca7 = v);
$parcel$export(module.exports, "useContext", () => $1c29a66706a62afd$export$fae74005e78b1a27, (v) => $1c29a66706a62afd$export$fae74005e78b1a27 = v);
$parcel$export(module.exports, "useDebugValue", () => $1c29a66706a62afd$export$dc8fbce3eb94dc1e, (v) => $1c29a66706a62afd$export$dc8fbce3eb94dc1e = v);
$parcel$export(module.exports, "useDeferredValue", () => $1c29a66706a62afd$export$6a7bc4e911dc01cf, (v) => $1c29a66706a62afd$export$6a7bc4e911dc01cf = v);
$parcel$export(module.exports, "useEffect", () => $1c29a66706a62afd$export$6d9c69b0de29b591, (v) => $1c29a66706a62afd$export$6d9c69b0de29b591 = v);
$parcel$export(module.exports, "useId", () => $1c29a66706a62afd$export$f680877a34711e37, (v) => $1c29a66706a62afd$export$f680877a34711e37 = v);
$parcel$export(module.exports, "useImperativeHandle", () => $1c29a66706a62afd$export$d5a552a76deda3c2, (v) => $1c29a66706a62afd$export$d5a552a76deda3c2 = v);
$parcel$export(module.exports, "useInsertionEffect", () => $1c29a66706a62afd$export$aaabe4eda9ed9969, (v) => $1c29a66706a62afd$export$aaabe4eda9ed9969 = v);
$parcel$export(module.exports, "useLayoutEffect", () => $1c29a66706a62afd$export$e5c5a5f917a5871c, (v) => $1c29a66706a62afd$export$e5c5a5f917a5871c = v);
$parcel$export(module.exports, "useMemo", () => $1c29a66706a62afd$export$1538c33de8887b59, (v) => $1c29a66706a62afd$export$1538c33de8887b59 = v);
$parcel$export(module.exports, "useReducer", () => $1c29a66706a62afd$export$13e3392192263954, (v) => $1c29a66706a62afd$export$13e3392192263954 = v);
$parcel$export(module.exports, "useRef", () => $1c29a66706a62afd$export$b8f5890fc79d6aca, (v) => $1c29a66706a62afd$export$b8f5890fc79d6aca = v);
$parcel$export(module.exports, "useState", () => $1c29a66706a62afd$export$60241385465d0a34, (v) => $1c29a66706a62afd$export$60241385465d0a34 = v);
$parcel$export(module.exports, "useSyncExternalStore", () => $1c29a66706a62afd$export$306c0aa65ff9ec16, (v) => $1c29a66706a62afd$export$306c0aa65ff9ec16 = v);
$parcel$export(module.exports, "useTransition", () => $1c29a66706a62afd$export$7b286972b8d8ccbf, (v) => $1c29a66706a62afd$export$7b286972b8d8ccbf = v);
$parcel$export(module.exports, "version", () => $1c29a66706a62afd$export$83d89fbfd8236492, (v) => $1c29a66706a62afd$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $1c29a66706a62afd$export$dca3b0875bd9a954;
var $1c29a66706a62afd$export$16fa2f45be04daa8;
var $1c29a66706a62afd$export$ffb0004e005737fa;
var $1c29a66706a62afd$export$e2c29f18771995cb;
var $1c29a66706a62afd$export$221d75b3f55bb0bd;
var $1c29a66706a62afd$export$5f8d39834fd61797;
var $1c29a66706a62afd$export$74bf444e3cd11ea5;
var $1c29a66706a62afd$export$ae55be85d98224ed;
var $1c29a66706a62afd$export$3ba232387fd5d6dd;
var $1c29a66706a62afd$export$e530037191fcd5d7;
var $1c29a66706a62afd$export$fd42f52fd3ae1109;
var $1c29a66706a62afd$export$c8a8987d4410bf2d;
var $1c29a66706a62afd$export$d38cd72104c1f0e9;
var $1c29a66706a62afd$export$7d1e3a5e95ceca43;
var $1c29a66706a62afd$export$257a8862b851cb5b;
var $1c29a66706a62afd$export$a8257692ac88316c;
var $1c29a66706a62afd$export$488013bae63b21da;
var $1c29a66706a62afd$export$7c73462e0d25e514;
var $1c29a66706a62afd$export$7568632d0d33d16d;
var $1c29a66706a62afd$export$88948ce120ea2619;
var $1c29a66706a62afd$export$35808ee640e87ca7;
var $1c29a66706a62afd$export$fae74005e78b1a27;
var $1c29a66706a62afd$export$dc8fbce3eb94dc1e;
var $1c29a66706a62afd$export$6a7bc4e911dc01cf;
var $1c29a66706a62afd$export$6d9c69b0de29b591;
var $1c29a66706a62afd$export$f680877a34711e37;
var $1c29a66706a62afd$export$d5a552a76deda3c2;
var $1c29a66706a62afd$export$aaabe4eda9ed9969;
var $1c29a66706a62afd$export$e5c5a5f917a5871c;
var $1c29a66706a62afd$export$1538c33de8887b59;
var $1c29a66706a62afd$export$13e3392192263954;
var $1c29a66706a62afd$export$b8f5890fc79d6aca;
var $1c29a66706a62afd$export$60241385465d0a34;
var $1c29a66706a62afd$export$306c0aa65ff9ec16;
var $1c29a66706a62afd$export$7b286972b8d8ccbf;
var $1c29a66706a62afd$export$83d89fbfd8236492;
'use strict';
var $1c29a66706a62afd$var$l = Symbol.for("react.element"), $1c29a66706a62afd$var$n = Symbol.for("react.portal"), $1c29a66706a62afd$var$p = Symbol.for("react.fragment"), $1c29a66706a62afd$var$q = Symbol.for("react.strict_mode"), $1c29a66706a62afd$var$r = Symbol.for("react.profiler"), $1c29a66706a62afd$var$t = Symbol.for("react.provider"), $1c29a66706a62afd$var$u = Symbol.for("react.context"), $1c29a66706a62afd$var$v = Symbol.for("react.forward_ref"), $1c29a66706a62afd$var$w = Symbol.for("react.suspense"), $1c29a66706a62afd$var$x = Symbol.for("react.memo"), $1c29a66706a62afd$var$y = Symbol.for("react.lazy"), $1c29a66706a62afd$var$z = Symbol.iterator;
function $1c29a66706a62afd$var$A(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $1c29a66706a62afd$var$z && a[$1c29a66706a62afd$var$z] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $1c29a66706a62afd$var$B = {
    isMounted: function() {
        return !1;
    },
    enqueueForceUpdate: function() {},
    enqueueReplaceState: function() {},
    enqueueSetState: function() {}
}, $1c29a66706a62afd$var$C = Object.assign, $1c29a66706a62afd$var$D = {};
function $1c29a66706a62afd$var$E(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $1c29a66706a62afd$var$D;
    this.updater = e || $1c29a66706a62afd$var$B;
}
$1c29a66706a62afd$var$E.prototype.isReactComponent = {};
$1c29a66706a62afd$var$E.prototype.setState = function(a, b) {
    if ("object" !== typeof a && "function" !== typeof a && null != a) throw Error("setState(...): takes an object of state variables to update or a function which returns an object of state variables.");
    this.updater.enqueueSetState(this, a, b, "setState");
};
$1c29a66706a62afd$var$E.prototype.forceUpdate = function(a) {
    this.updater.enqueueForceUpdate(this, a, "forceUpdate");
};
function $1c29a66706a62afd$var$F() {}
$1c29a66706a62afd$var$F.prototype = $1c29a66706a62afd$var$E.prototype;
function $1c29a66706a62afd$var$G(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $1c29a66706a62afd$var$D;
    this.updater = e || $1c29a66706a62afd$var$B;
}
var $1c29a66706a62afd$var$H = $1c29a66706a62afd$var$G.prototype = new $1c29a66706a62afd$var$F;
$1c29a66706a62afd$var$H.constructor = $1c29a66706a62afd$var$G;
$1c29a66706a62afd$var$C($1c29a66706a62afd$var$H, $1c29a66706a62afd$var$E.prototype);
$1c29a66706a62afd$var$H.isPureReactComponent = !0;
var $1c29a66706a62afd$var$I = Array.isArray, $1c29a66706a62afd$var$J = Object.prototype.hasOwnProperty, $1c29a66706a62afd$var$K = {
    current: null
}, $1c29a66706a62afd$var$L = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $1c29a66706a62afd$var$M(a, b, e) {
    var d, c = {}, k = null, h = null;
    if (null != b) for(d in void 0 !== b.ref && (h = b.ref), void 0 !== b.key && (k = "" + b.key), b)$1c29a66706a62afd$var$J.call(b, d) && !$1c29a66706a62afd$var$L.hasOwnProperty(d) && (c[d] = b[d]);
    var g = arguments.length - 2;
    if (1 === g) c.children = e;
    else if (1 < g) {
        for(var f = Array(g), m = 0; m < g; m++)f[m] = arguments[m + 2];
        c.children = f;
    }
    if (a && a.defaultProps) for(d in g = a.defaultProps, g)void 0 === c[d] && (c[d] = g[d]);
    return {
        $$typeof: $1c29a66706a62afd$var$l,
        type: a,
        key: k,
        ref: h,
        props: c,
        _owner: $1c29a66706a62afd$var$K.current
    };
}
function $1c29a66706a62afd$var$N(a, b) {
    return {
        $$typeof: $1c29a66706a62afd$var$l,
        type: a.type,
        key: b,
        ref: a.ref,
        props: a.props,
        _owner: a._owner
    };
}
function $1c29a66706a62afd$var$O(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $1c29a66706a62afd$var$l;
}
function $1c29a66706a62afd$var$escape(a) {
    var b = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + a.replace(/[=:]/g, function(a) {
        return b[a];
    });
}
var $1c29a66706a62afd$var$P = /\/+/g;
function $1c29a66706a62afd$var$Q(a, b) {
    return "object" === typeof a && null !== a && null != a.key ? $1c29a66706a62afd$var$escape("" + a.key) : b.toString(36);
}
function $1c29a66706a62afd$var$R(a, b, e, d, c) {
    var k = typeof a;
    if ("undefined" === k || "boolean" === k) a = null;
    var h = !1;
    if (null === a) h = !0;
    else switch(k){
        case "string":
        case "number":
            h = !0;
            break;
        case "object":
            switch(a.$$typeof){
                case $1c29a66706a62afd$var$l:
                case $1c29a66706a62afd$var$n:
                    h = !0;
            }
    }
    if (h) return h = a, c = c(h), a = "" === d ? "." + $1c29a66706a62afd$var$Q(h, 0) : d, $1c29a66706a62afd$var$I(c) ? (e = "", null != a && (e = a.replace($1c29a66706a62afd$var$P, "$&/") + "/"), $1c29a66706a62afd$var$R(c, b, e, "", function(a) {
        return a;
    })) : null != c && ($1c29a66706a62afd$var$O(c) && (c = $1c29a66706a62afd$var$N(c, e + (!c.key || h && h.key === c.key ? "" : ("" + c.key).replace($1c29a66706a62afd$var$P, "$&/") + "/") + a)), b.push(c)), 1;
    h = 0;
    d = "" === d ? "." : d + ":";
    if ($1c29a66706a62afd$var$I(a)) for(var g = 0; g < a.length; g++){
        k = a[g];
        var f = d + $1c29a66706a62afd$var$Q(k, g);
        h += $1c29a66706a62afd$var$R(k, b, e, f, c);
    }
    else if (f = $1c29a66706a62afd$var$A(a), "function" === typeof f) for(a = f.call(a), g = 0; !(k = a.next()).done;)k = k.value, f = d + $1c29a66706a62afd$var$Q(k, g++), h += $1c29a66706a62afd$var$R(k, b, e, f, c);
    else if ("object" === k) throw b = String(a), Error("Objects are not valid as a React child (found: " + ("[object Object]" === b ? "object with keys {" + Object.keys(a).join(", ") + "}" : b) + "). If you meant to render a collection of children, use an array instead.");
    return h;
}
function $1c29a66706a62afd$var$S(a, b, e) {
    if (null == a) return a;
    var d = [], c = 0;
    $1c29a66706a62afd$var$R(a, d, "", "", function(a) {
        return b.call(e, a, c++);
    });
    return d;
}
function $1c29a66706a62afd$var$T(a) {
    if (-1 === a._status) {
        var b = a._result;
        b = b();
        b.then(function(b) {
            if (0 === a._status || -1 === a._status) a._status = 1, a._result = b;
        }, function(b) {
            if (0 === a._status || -1 === a._status) a._status = 2, a._result = b;
        });
        -1 === a._status && (a._status = 0, a._result = b);
    }
    if (1 === a._status) return a._result.default;
    throw a._result;
}
var $1c29a66706a62afd$var$U = {
    current: null
}, $1c29a66706a62afd$var$V = {
    transition: null
}, $1c29a66706a62afd$var$W = {
    ReactCurrentDispatcher: $1c29a66706a62afd$var$U,
    ReactCurrentBatchConfig: $1c29a66706a62afd$var$V,
    ReactCurrentOwner: $1c29a66706a62afd$var$K
};
function $1c29a66706a62afd$var$X() {
    throw Error("act(...) is not supported in production builds of React.");
}
$1c29a66706a62afd$export$dca3b0875bd9a954 = {
    map: $1c29a66706a62afd$var$S,
    forEach: function(a, b, e) {
        $1c29a66706a62afd$var$S(a, function() {
            b.apply(this, arguments);
        }, e);
    },
    count: function(a) {
        var b = 0;
        $1c29a66706a62afd$var$S(a, function() {
            b++;
        });
        return b;
    },
    toArray: function(a) {
        return $1c29a66706a62afd$var$S(a, function(a) {
            return a;
        }) || [];
    },
    only: function(a) {
        if (!$1c29a66706a62afd$var$O(a)) throw Error("React.Children.only expected to receive a single React element child.");
        return a;
    }
};
$1c29a66706a62afd$export$16fa2f45be04daa8 = $1c29a66706a62afd$var$E;
$1c29a66706a62afd$export$ffb0004e005737fa = $1c29a66706a62afd$var$p;
$1c29a66706a62afd$export$e2c29f18771995cb = $1c29a66706a62afd$var$r;
$1c29a66706a62afd$export$221d75b3f55bb0bd = $1c29a66706a62afd$var$G;
$1c29a66706a62afd$export$5f8d39834fd61797 = $1c29a66706a62afd$var$q;
$1c29a66706a62afd$export$74bf444e3cd11ea5 = $1c29a66706a62afd$var$w;
$1c29a66706a62afd$export$ae55be85d98224ed = $1c29a66706a62afd$var$W;
$1c29a66706a62afd$export$3ba232387fd5d6dd = $1c29a66706a62afd$var$X;
$1c29a66706a62afd$export$e530037191fcd5d7 = function(a, b, e) {
    if (null === a || void 0 === a) throw Error("React.cloneElement(...): The argument must be a React element, but you passed " + a + ".");
    var d = $1c29a66706a62afd$var$C({}, a.props), c = a.key, k = a.ref, h = a._owner;
    if (null != b) {
        void 0 !== b.ref && (k = b.ref, h = $1c29a66706a62afd$var$K.current);
        void 0 !== b.key && (c = "" + b.key);
        if (a.type && a.type.defaultProps) var g = a.type.defaultProps;
        for(f in b)$1c29a66706a62afd$var$J.call(b, f) && !$1c29a66706a62afd$var$L.hasOwnProperty(f) && (d[f] = void 0 === b[f] && void 0 !== g ? g[f] : b[f]);
    }
    var f = arguments.length - 2;
    if (1 === f) d.children = e;
    else if (1 < f) {
        g = Array(f);
        for(var m = 0; m < f; m++)g[m] = arguments[m + 2];
        d.children = g;
    }
    return {
        $$typeof: $1c29a66706a62afd$var$l,
        type: a.type,
        key: c,
        ref: k,
        props: d,
        _owner: h
    };
};
$1c29a66706a62afd$export$fd42f52fd3ae1109 = function(a) {
    a = {
        $$typeof: $1c29a66706a62afd$var$u,
        _currentValue: a,
        _currentValue2: a,
        _threadCount: 0,
        Provider: null,
        Consumer: null,
        _defaultValue: null,
        _globalName: null
    };
    a.Provider = {
        $$typeof: $1c29a66706a62afd$var$t,
        _context: a
    };
    return a.Consumer = a;
};
$1c29a66706a62afd$export$c8a8987d4410bf2d = $1c29a66706a62afd$var$M;
$1c29a66706a62afd$export$d38cd72104c1f0e9 = function(a) {
    var b = $1c29a66706a62afd$var$M.bind(null, a);
    b.type = a;
    return b;
};
$1c29a66706a62afd$export$7d1e3a5e95ceca43 = function() {
    return {
        current: null
    };
};
$1c29a66706a62afd$export$257a8862b851cb5b = function(a) {
    return {
        $$typeof: $1c29a66706a62afd$var$v,
        render: a
    };
};
$1c29a66706a62afd$export$a8257692ac88316c = $1c29a66706a62afd$var$O;
$1c29a66706a62afd$export$488013bae63b21da = function(a) {
    return {
        $$typeof: $1c29a66706a62afd$var$y,
        _payload: {
            _status: -1,
            _result: a
        },
        _init: $1c29a66706a62afd$var$T
    };
};
$1c29a66706a62afd$export$7c73462e0d25e514 = function(a, b) {
    return {
        $$typeof: $1c29a66706a62afd$var$x,
        type: a,
        compare: void 0 === b ? null : b
    };
};
$1c29a66706a62afd$export$7568632d0d33d16d = function(a) {
    var b = $1c29a66706a62afd$var$V.transition;
    $1c29a66706a62afd$var$V.transition = {};
    try {
        a();
    } finally{
        $1c29a66706a62afd$var$V.transition = b;
    }
};
$1c29a66706a62afd$export$88948ce120ea2619 = $1c29a66706a62afd$var$X;
$1c29a66706a62afd$export$35808ee640e87ca7 = function(a, b) {
    return $1c29a66706a62afd$var$U.current.useCallback(a, b);
};
$1c29a66706a62afd$export$fae74005e78b1a27 = function(a) {
    return $1c29a66706a62afd$var$U.current.useContext(a);
};
$1c29a66706a62afd$export$dc8fbce3eb94dc1e = function() {};
$1c29a66706a62afd$export$6a7bc4e911dc01cf = function(a) {
    return $1c29a66706a62afd$var$U.current.useDeferredValue(a);
};
$1c29a66706a62afd$export$6d9c69b0de29b591 = function(a, b) {
    return $1c29a66706a62afd$var$U.current.useEffect(a, b);
};
$1c29a66706a62afd$export$f680877a34711e37 = function() {
    return $1c29a66706a62afd$var$U.current.useId();
};
$1c29a66706a62afd$export$d5a552a76deda3c2 = function(a, b, e) {
    return $1c29a66706a62afd$var$U.current.useImperativeHandle(a, b, e);
};
$1c29a66706a62afd$export$aaabe4eda9ed9969 = function(a, b) {
    return $1c29a66706a62afd$var$U.current.useInsertionEffect(a, b);
};
$1c29a66706a62afd$export$e5c5a5f917a5871c = function(a, b) {
    return $1c29a66706a62afd$var$U.current.useLayoutEffect(a, b);
};
$1c29a66706a62afd$export$1538c33de8887b59 = function(a, b) {
    return $1c29a66706a62afd$var$U.current.useMemo(a, b);
};
$1c29a66706a62afd$export$13e3392192263954 = function(a, b, e) {
    return $1c29a66706a62afd$var$U.current.useReducer(a, b, e);
};
$1c29a66706a62afd$export$b8f5890fc79d6aca = function(a) {
    return $1c29a66706a62afd$var$U.current.useRef(a);
};
$1c29a66706a62afd$export$60241385465d0a34 = function(a) {
    return $1c29a66706a62afd$var$U.current.useState(a);
};
$1c29a66706a62afd$export$306c0aa65ff9ec16 = function(a, b, e) {
    return $1c29a66706a62afd$var$U.current.useSyncExternalStore(a, b, e);
};
$1c29a66706a62afd$export$7b286972b8d8ccbf = function() {
    return $1c29a66706a62afd$var$U.current.useTransition();
};
$1c29a66706a62afd$export$83d89fbfd8236492 = "18.3.1";

});



parcelRegister("Xw6Mv", function(module, exports) {

$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", () => $0b2e6adb871a3b94$export$ae55be85d98224ed, (v) => $0b2e6adb871a3b94$export$ae55be85d98224ed = v);
$parcel$export(module.exports, "createPortal", () => $0b2e6adb871a3b94$export$d39a5bbd09211389, (v) => $0b2e6adb871a3b94$export$d39a5bbd09211389 = v);
$parcel$export(module.exports, "createRoot", () => $0b2e6adb871a3b94$export$882461b6382ed46c, (v) => $0b2e6adb871a3b94$export$882461b6382ed46c = v);
$parcel$export(module.exports, "findDOMNode", () => $0b2e6adb871a3b94$export$466bfc07425424d5, (v) => $0b2e6adb871a3b94$export$466bfc07425424d5 = v);
$parcel$export(module.exports, "flushSync", () => $0b2e6adb871a3b94$export$cd75ccfd720a3cd4, (v) => $0b2e6adb871a3b94$export$cd75ccfd720a3cd4 = v);
$parcel$export(module.exports, "hydrate", () => $0b2e6adb871a3b94$export$fa8d919ba61d84db, (v) => $0b2e6adb871a3b94$export$fa8d919ba61d84db = v);
$parcel$export(module.exports, "hydrateRoot", () => $0b2e6adb871a3b94$export$757ceba2d55c277e, (v) => $0b2e6adb871a3b94$export$757ceba2d55c277e = v);
$parcel$export(module.exports, "render", () => $0b2e6adb871a3b94$export$b3890eb0ae9dca99, (v) => $0b2e6adb871a3b94$export$b3890eb0ae9dca99 = v);
$parcel$export(module.exports, "unmountComponentAtNode", () => $0b2e6adb871a3b94$export$502457920280e6be, (v) => $0b2e6adb871a3b94$export$502457920280e6be = v);
$parcel$export(module.exports, "unstable_batchedUpdates", () => $0b2e6adb871a3b94$export$c78a37762a8d58e1, (v) => $0b2e6adb871a3b94$export$c78a37762a8d58e1 = v);
$parcel$export(module.exports, "unstable_renderSubtreeIntoContainer", () => $0b2e6adb871a3b94$export$dc54d992c10e8a18, (v) => $0b2e6adb871a3b94$export$dc54d992c10e8a18 = v);
$parcel$export(module.exports, "version", () => $0b2e6adb871a3b94$export$83d89fbfd8236492, (v) => $0b2e6adb871a3b94$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ var $0b2e6adb871a3b94$export$ae55be85d98224ed;
var $0b2e6adb871a3b94$export$d39a5bbd09211389;
var $0b2e6adb871a3b94$export$882461b6382ed46c;
var $0b2e6adb871a3b94$export$466bfc07425424d5;
var $0b2e6adb871a3b94$export$cd75ccfd720a3cd4;
var $0b2e6adb871a3b94$export$fa8d919ba61d84db;
var $0b2e6adb871a3b94$export$757ceba2d55c277e;
var $0b2e6adb871a3b94$export$b3890eb0ae9dca99;
var $0b2e6adb871a3b94$export$502457920280e6be;
var $0b2e6adb871a3b94$export$c78a37762a8d58e1;
var $0b2e6adb871a3b94$export$dc54d992c10e8a18;
var $0b2e6adb871a3b94$export$83d89fbfd8236492;
'use strict';

var $acw62 = parcelRequire("acw62");

var $fO90s = parcelRequire("fO90s");
function $0b2e6adb871a3b94$var$p(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
var $0b2e6adb871a3b94$var$da = new Set, $0b2e6adb871a3b94$var$ea = {};
function $0b2e6adb871a3b94$var$fa(a, b) {
    $0b2e6adb871a3b94$var$ha(a, b);
    $0b2e6adb871a3b94$var$ha(a + "Capture", b);
}
function $0b2e6adb871a3b94$var$ha(a, b) {
    $0b2e6adb871a3b94$var$ea[a] = b;
    for(a = 0; a < b.length; a++)$0b2e6adb871a3b94$var$da.add(b[a]);
}
var $0b2e6adb871a3b94$var$ia = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), $0b2e6adb871a3b94$var$ja = Object.prototype.hasOwnProperty, $0b2e6adb871a3b94$var$ka = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, $0b2e6adb871a3b94$var$la = {}, $0b2e6adb871a3b94$var$ma = {};
function $0b2e6adb871a3b94$var$oa(a) {
    if ($0b2e6adb871a3b94$var$ja.call($0b2e6adb871a3b94$var$ma, a)) return !0;
    if ($0b2e6adb871a3b94$var$ja.call($0b2e6adb871a3b94$var$la, a)) return !1;
    if ($0b2e6adb871a3b94$var$ka.test(a)) return $0b2e6adb871a3b94$var$ma[a] = !0;
    $0b2e6adb871a3b94$var$la[a] = !0;
    return !1;
}
function $0b2e6adb871a3b94$var$pa(a, b, c, d) {
    if (null !== c && 0 === c.type) return !1;
    switch(typeof b){
        case "function":
        case "symbol":
            return !0;
        case "boolean":
            if (d) return !1;
            if (null !== c) return !c.acceptsBooleans;
            a = a.toLowerCase().slice(0, 5);
            return "data-" !== a && "aria-" !== a;
        default:
            return !1;
    }
}
function $0b2e6adb871a3b94$var$qa(a, b, c, d) {
    if (null === b || "undefined" === typeof b || $0b2e6adb871a3b94$var$pa(a, b, c, d)) return !0;
    if (d) return !1;
    if (null !== c) switch(c.type){
        case 3:
            return !b;
        case 4:
            return !1 === b;
        case 5:
            return isNaN(b);
        case 6:
            return isNaN(b) || 1 > b;
    }
    return !1;
}
function $0b2e6adb871a3b94$var$v(a, b, c, d, e, f, g) {
    this.acceptsBooleans = 2 === b || 3 === b || 4 === b;
    this.attributeName = d;
    this.attributeNamespace = e;
    this.mustUseProperty = c;
    this.propertyName = a;
    this.type = b;
    this.sanitizeURL = f;
    this.removeEmptyString = g;
}
var $0b2e6adb871a3b94$var$z = {};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 0, !1, a, null, !1, !1);
});
[
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "className",
        "class"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ]
].forEach(function(a) {
    var b = a[0];
    $0b2e6adb871a3b94$var$z[b] = new $0b2e6adb871a3b94$var$v(b, 1, !1, a[1], null, !1, !1);
});
[
    "contentEditable",
    "draggable",
    "spellCheck",
    "value"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 2, !1, a.toLowerCase(), null, !1, !1);
});
[
    "autoReverse",
    "externalResourcesRequired",
    "focusable",
    "preserveAlpha"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 2, !1, a, null, !1, !1);
});
"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 3, !1, a.toLowerCase(), null, !1, !1);
});
[
    "checked",
    "multiple",
    "muted",
    "selected"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 3, !0, a, null, !1, !1);
});
[
    "capture",
    "download"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 4, !1, a, null, !1, !1);
});
[
    "cols",
    "rows",
    "size",
    "span"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 6, !1, a, null, !1, !1);
});
[
    "rowSpan",
    "start"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 5, !1, a.toLowerCase(), null, !1, !1);
});
var $0b2e6adb871a3b94$var$ra = /[\-:]([a-z])/g;
function $0b2e6adb871a3b94$var$sa(a) {
    return a[1].toUpperCase();
}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a) {
    var b = a.replace($0b2e6adb871a3b94$var$ra, $0b2e6adb871a3b94$var$sa);
    $0b2e6adb871a3b94$var$z[b] = new $0b2e6adb871a3b94$var$v(b, 1, !1, a, null, !1, !1);
});
"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a) {
    var b = a.replace($0b2e6adb871a3b94$var$ra, $0b2e6adb871a3b94$var$sa);
    $0b2e6adb871a3b94$var$z[b] = new $0b2e6adb871a3b94$var$v(b, 1, !1, a, "http://www.w3.org/1999/xlink", !1, !1);
});
[
    "xml:base",
    "xml:lang",
    "xml:space"
].forEach(function(a) {
    var b = a.replace($0b2e6adb871a3b94$var$ra, $0b2e6adb871a3b94$var$sa);
    $0b2e6adb871a3b94$var$z[b] = new $0b2e6adb871a3b94$var$v(b, 1, !1, a, "http://www.w3.org/XML/1998/namespace", !1, !1);
});
[
    "tabIndex",
    "crossOrigin"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 1, !1, a.toLowerCase(), null, !1, !1);
});
$0b2e6adb871a3b94$var$z.xlinkHref = new $0b2e6adb871a3b94$var$v("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1);
[
    "src",
    "href",
    "action",
    "formAction"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 1, !1, a.toLowerCase(), null, !0, !0);
});
function $0b2e6adb871a3b94$var$ta(a, b, c, d) {
    var e = $0b2e6adb871a3b94$var$z.hasOwnProperty(b) ? $0b2e6adb871a3b94$var$z[b] : null;
    if (null !== e ? 0 !== e.type : d || !(2 < b.length) || "o" !== b[0] && "O" !== b[0] || "n" !== b[1] && "N" !== b[1]) $0b2e6adb871a3b94$var$qa(b, c, e, d) && (c = null), d || null === e ? $0b2e6adb871a3b94$var$oa(b) && (null === c ? a.removeAttribute(b) : a.setAttribute(b, "" + c)) : e.mustUseProperty ? a[e.propertyName] = null === c ? 3 === e.type ? !1 : "" : c : (b = e.attributeName, d = e.attributeNamespace, null === c ? a.removeAttribute(b) : (e = e.type, c = 3 === e || 4 === e && !0 === c ? "" : "" + c, d ? a.setAttributeNS(d, b, c) : a.setAttribute(b, c)));
}
var $0b2e6adb871a3b94$var$ua = $acw62.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED, $0b2e6adb871a3b94$var$va = Symbol.for("react.element"), $0b2e6adb871a3b94$var$wa = Symbol.for("react.portal"), $0b2e6adb871a3b94$var$ya = Symbol.for("react.fragment"), $0b2e6adb871a3b94$var$za = Symbol.for("react.strict_mode"), $0b2e6adb871a3b94$var$Aa = Symbol.for("react.profiler"), $0b2e6adb871a3b94$var$Ba = Symbol.for("react.provider"), $0b2e6adb871a3b94$var$Ca = Symbol.for("react.context"), $0b2e6adb871a3b94$var$Da = Symbol.for("react.forward_ref"), $0b2e6adb871a3b94$var$Ea = Symbol.for("react.suspense"), $0b2e6adb871a3b94$var$Fa = Symbol.for("react.suspense_list"), $0b2e6adb871a3b94$var$Ga = Symbol.for("react.memo"), $0b2e6adb871a3b94$var$Ha = Symbol.for("react.lazy");
Symbol.for("react.scope");
Symbol.for("react.debug_trace_mode");
var $0b2e6adb871a3b94$var$Ia = Symbol.for("react.offscreen");
Symbol.for("react.legacy_hidden");
Symbol.for("react.cache");
Symbol.for("react.tracing_marker");
var $0b2e6adb871a3b94$var$Ja = Symbol.iterator;
function $0b2e6adb871a3b94$var$Ka(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $0b2e6adb871a3b94$var$Ja && a[$0b2e6adb871a3b94$var$Ja] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $0b2e6adb871a3b94$var$A = Object.assign, $0b2e6adb871a3b94$var$La;
function $0b2e6adb871a3b94$var$Ma(a) {
    if (void 0 === $0b2e6adb871a3b94$var$La) try {
        throw Error();
    } catch (c) {
        var b = c.stack.trim().match(/\n( *(at )?)/);
        $0b2e6adb871a3b94$var$La = b && b[1] || "";
    }
    return "\n" + $0b2e6adb871a3b94$var$La + a;
}
var $0b2e6adb871a3b94$var$Na = !1;
function $0b2e6adb871a3b94$var$Oa(a, b) {
    if (!a || $0b2e6adb871a3b94$var$Na) return "";
    $0b2e6adb871a3b94$var$Na = !0;
    var c = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
        if (b) {
            if (b = function() {
                throw Error();
            }, Object.defineProperty(b.prototype, "props", {
                set: function() {
                    throw Error();
                }
            }), "object" === typeof Reflect && Reflect.construct) {
                try {
                    Reflect.construct(b, []);
                } catch (l) {
                    var d = l;
                }
                Reflect.construct(a, [], b);
            } else {
                try {
                    b.call();
                } catch (l) {
                    d = l;
                }
                a.call(b.prototype);
            }
        } else {
            try {
                throw Error();
            } catch (l) {
                d = l;
            }
            a();
        }
    } catch (l) {
        if (l && d && "string" === typeof l.stack) {
            for(var e = l.stack.split("\n"), f = d.stack.split("\n"), g = e.length - 1, h = f.length - 1; 1 <= g && 0 <= h && e[g] !== f[h];)h--;
            for(; 1 <= g && 0 <= h; g--, h--)if (e[g] !== f[h]) {
                if (1 !== g || 1 !== h) {
                    do if (g--, h--, 0 > h || e[g] !== f[h]) {
                        var k = "\n" + e[g].replace(" at new ", " at ");
                        a.displayName && k.includes("<anonymous>") && (k = k.replace("<anonymous>", a.displayName));
                        return k;
                    }
                    while (1 <= g && 0 <= h);
                }
                break;
            }
        }
    } finally{
        $0b2e6adb871a3b94$var$Na = !1, Error.prepareStackTrace = c;
    }
    return (a = a ? a.displayName || a.name : "") ? $0b2e6adb871a3b94$var$Ma(a) : "";
}
function $0b2e6adb871a3b94$var$Pa(a) {
    switch(a.tag){
        case 5:
            return $0b2e6adb871a3b94$var$Ma(a.type);
        case 16:
            return $0b2e6adb871a3b94$var$Ma("Lazy");
        case 13:
            return $0b2e6adb871a3b94$var$Ma("Suspense");
        case 19:
            return $0b2e6adb871a3b94$var$Ma("SuspenseList");
        case 0:
        case 2:
        case 15:
            return a = $0b2e6adb871a3b94$var$Oa(a.type, !1), a;
        case 11:
            return a = $0b2e6adb871a3b94$var$Oa(a.type.render, !1), a;
        case 1:
            return a = $0b2e6adb871a3b94$var$Oa(a.type, !0), a;
        default:
            return "";
    }
}
function $0b2e6adb871a3b94$var$Qa(a) {
    if (null == a) return null;
    if ("function" === typeof a) return a.displayName || a.name || null;
    if ("string" === typeof a) return a;
    switch(a){
        case $0b2e6adb871a3b94$var$ya:
            return "Fragment";
        case $0b2e6adb871a3b94$var$wa:
            return "Portal";
        case $0b2e6adb871a3b94$var$Aa:
            return "Profiler";
        case $0b2e6adb871a3b94$var$za:
            return "StrictMode";
        case $0b2e6adb871a3b94$var$Ea:
            return "Suspense";
        case $0b2e6adb871a3b94$var$Fa:
            return "SuspenseList";
    }
    if ("object" === typeof a) switch(a.$$typeof){
        case $0b2e6adb871a3b94$var$Ca:
            return (a.displayName || "Context") + ".Consumer";
        case $0b2e6adb871a3b94$var$Ba:
            return (a._context.displayName || "Context") + ".Provider";
        case $0b2e6adb871a3b94$var$Da:
            var b = a.render;
            a = a.displayName;
            a || (a = b.displayName || b.name || "", a = "" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
            return a;
        case $0b2e6adb871a3b94$var$Ga:
            return b = a.displayName || null, null !== b ? b : $0b2e6adb871a3b94$var$Qa(a.type) || "Memo";
        case $0b2e6adb871a3b94$var$Ha:
            b = a._payload;
            a = a._init;
            try {
                return $0b2e6adb871a3b94$var$Qa(a(b));
            } catch (c) {}
    }
    return null;
}
function $0b2e6adb871a3b94$var$Ra(a) {
    var b = a.type;
    switch(a.tag){
        case 24:
            return "Cache";
        case 9:
            return (b.displayName || "Context") + ".Consumer";
        case 10:
            return (b._context.displayName || "Context") + ".Provider";
        case 18:
            return "DehydratedFragment";
        case 11:
            return a = b.render, a = a.displayName || a.name || "", b.displayName || ("" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
        case 7:
            return "Fragment";
        case 5:
            return b;
        case 4:
            return "Portal";
        case 3:
            return "Root";
        case 6:
            return "Text";
        case 16:
            return $0b2e6adb871a3b94$var$Qa(b);
        case 8:
            return b === $0b2e6adb871a3b94$var$za ? "StrictMode" : "Mode";
        case 22:
            return "Offscreen";
        case 12:
            return "Profiler";
        case 21:
            return "Scope";
        case 13:
            return "Suspense";
        case 19:
            return "SuspenseList";
        case 25:
            return "TracingMarker";
        case 1:
        case 0:
        case 17:
        case 2:
        case 14:
        case 15:
            if ("function" === typeof b) return b.displayName || b.name || null;
            if ("string" === typeof b) return b;
    }
    return null;
}
function $0b2e6adb871a3b94$var$Sa(a) {
    switch(typeof a){
        case "boolean":
        case "number":
        case "string":
        case "undefined":
            return a;
        case "object":
            return a;
        default:
            return "";
    }
}
function $0b2e6adb871a3b94$var$Ta(a) {
    var b = a.type;
    return (a = a.nodeName) && "input" === a.toLowerCase() && ("checkbox" === b || "radio" === b);
}
function $0b2e6adb871a3b94$var$Ua(a) {
    var b = $0b2e6adb871a3b94$var$Ta(a) ? "checked" : "value", c = Object.getOwnPropertyDescriptor(a.constructor.prototype, b), d = "" + a[b];
    if (!a.hasOwnProperty(b) && "undefined" !== typeof c && "function" === typeof c.get && "function" === typeof c.set) {
        var e = c.get, f = c.set;
        Object.defineProperty(a, b, {
            configurable: !0,
            get: function() {
                return e.call(this);
            },
            set: function(a) {
                d = "" + a;
                f.call(this, a);
            }
        });
        Object.defineProperty(a, b, {
            enumerable: c.enumerable
        });
        return {
            getValue: function() {
                return d;
            },
            setValue: function(a) {
                d = "" + a;
            },
            stopTracking: function() {
                a._valueTracker = null;
                delete a[b];
            }
        };
    }
}
function $0b2e6adb871a3b94$var$Va(a) {
    a._valueTracker || (a._valueTracker = $0b2e6adb871a3b94$var$Ua(a));
}
function $0b2e6adb871a3b94$var$Wa(a) {
    if (!a) return !1;
    var b = a._valueTracker;
    if (!b) return !0;
    var c = b.getValue();
    var d = "";
    a && (d = $0b2e6adb871a3b94$var$Ta(a) ? a.checked ? "true" : "false" : a.value);
    a = d;
    return a !== c ? (b.setValue(a), !0) : !1;
}
function $0b2e6adb871a3b94$var$Xa(a) {
    a = a || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof a) return null;
    try {
        return a.activeElement || a.body;
    } catch (b) {
        return a.body;
    }
}
function $0b2e6adb871a3b94$var$Ya(a, b) {
    var c = b.checked;
    return $0b2e6adb871a3b94$var$A({}, b, {
        defaultChecked: void 0,
        defaultValue: void 0,
        value: void 0,
        checked: null != c ? c : a._wrapperState.initialChecked
    });
}
function $0b2e6adb871a3b94$var$Za(a, b) {
    var c = null == b.defaultValue ? "" : b.defaultValue, d = null != b.checked ? b.checked : b.defaultChecked;
    c = $0b2e6adb871a3b94$var$Sa(null != b.value ? b.value : c);
    a._wrapperState = {
        initialChecked: d,
        initialValue: c,
        controlled: "checkbox" === b.type || "radio" === b.type ? null != b.checked : null != b.value
    };
}
function $0b2e6adb871a3b94$var$ab(a, b) {
    b = b.checked;
    null != b && $0b2e6adb871a3b94$var$ta(a, "checked", b, !1);
}
function $0b2e6adb871a3b94$var$bb(a, b) {
    $0b2e6adb871a3b94$var$ab(a, b);
    var c = $0b2e6adb871a3b94$var$Sa(b.value), d = b.type;
    if (null != c) {
        if ("number" === d) {
            if (0 === c && "" === a.value || a.value != c) a.value = "" + c;
        } else a.value !== "" + c && (a.value = "" + c);
    } else if ("submit" === d || "reset" === d) {
        a.removeAttribute("value");
        return;
    }
    b.hasOwnProperty("value") ? $0b2e6adb871a3b94$var$cb(a, b.type, c) : b.hasOwnProperty("defaultValue") && $0b2e6adb871a3b94$var$cb(a, b.type, $0b2e6adb871a3b94$var$Sa(b.defaultValue));
    null == b.checked && null != b.defaultChecked && (a.defaultChecked = !!b.defaultChecked);
}
function $0b2e6adb871a3b94$var$db(a, b, c) {
    if (b.hasOwnProperty("value") || b.hasOwnProperty("defaultValue")) {
        var d = b.type;
        if (!("submit" !== d && "reset" !== d || void 0 !== b.value && null !== b.value)) return;
        b = "" + a._wrapperState.initialValue;
        c || b === a.value || (a.value = b);
        a.defaultValue = b;
    }
    c = a.name;
    "" !== c && (a.name = "");
    a.defaultChecked = !!a._wrapperState.initialChecked;
    "" !== c && (a.name = c);
}
function $0b2e6adb871a3b94$var$cb(a, b, c) {
    if ("number" !== b || $0b2e6adb871a3b94$var$Xa(a.ownerDocument) !== a) null == c ? a.defaultValue = "" + a._wrapperState.initialValue : a.defaultValue !== "" + c && (a.defaultValue = "" + c);
}
var $0b2e6adb871a3b94$var$eb = Array.isArray;
function $0b2e6adb871a3b94$var$fb(a, b, c, d) {
    a = a.options;
    if (b) {
        b = {};
        for(var e = 0; e < c.length; e++)b["$" + c[e]] = !0;
        for(c = 0; c < a.length; c++)e = b.hasOwnProperty("$" + a[c].value), a[c].selected !== e && (a[c].selected = e), e && d && (a[c].defaultSelected = !0);
    } else {
        c = "" + $0b2e6adb871a3b94$var$Sa(c);
        b = null;
        for(e = 0; e < a.length; e++){
            if (a[e].value === c) {
                a[e].selected = !0;
                d && (a[e].defaultSelected = !0);
                return;
            }
            null !== b || a[e].disabled || (b = a[e]);
        }
        null !== b && (b.selected = !0);
    }
}
function $0b2e6adb871a3b94$var$gb(a, b) {
    if (null != b.dangerouslySetInnerHTML) throw Error($0b2e6adb871a3b94$var$p(91));
    return $0b2e6adb871a3b94$var$A({}, b, {
        value: void 0,
        defaultValue: void 0,
        children: "" + a._wrapperState.initialValue
    });
}
function $0b2e6adb871a3b94$var$hb(a, b) {
    var c = b.value;
    if (null == c) {
        c = b.children;
        b = b.defaultValue;
        if (null != c) {
            if (null != b) throw Error($0b2e6adb871a3b94$var$p(92));
            if ($0b2e6adb871a3b94$var$eb(c)) {
                if (1 < c.length) throw Error($0b2e6adb871a3b94$var$p(93));
                c = c[0];
            }
            b = c;
        }
        null == b && (b = "");
        c = b;
    }
    a._wrapperState = {
        initialValue: $0b2e6adb871a3b94$var$Sa(c)
    };
}
function $0b2e6adb871a3b94$var$ib(a, b) {
    var c = $0b2e6adb871a3b94$var$Sa(b.value), d = $0b2e6adb871a3b94$var$Sa(b.defaultValue);
    null != c && (c = "" + c, c !== a.value && (a.value = c), null == b.defaultValue && a.defaultValue !== c && (a.defaultValue = c));
    null != d && (a.defaultValue = "" + d);
}
function $0b2e6adb871a3b94$var$jb(a) {
    var b = a.textContent;
    b === a._wrapperState.initialValue && "" !== b && null !== b && (a.value = b);
}
function $0b2e6adb871a3b94$var$kb(a) {
    switch(a){
        case "svg":
            return "http://www.w3.org/2000/svg";
        case "math":
            return "http://www.w3.org/1998/Math/MathML";
        default:
            return "http://www.w3.org/1999/xhtml";
    }
}
function $0b2e6adb871a3b94$var$lb(a, b) {
    return null == a || "http://www.w3.org/1999/xhtml" === a ? $0b2e6adb871a3b94$var$kb(b) : "http://www.w3.org/2000/svg" === a && "foreignObject" === b ? "http://www.w3.org/1999/xhtml" : a;
}
var $0b2e6adb871a3b94$var$mb, $0b2e6adb871a3b94$var$nb = function(a) {
    return "undefined" !== typeof MSApp && MSApp.execUnsafeLocalFunction ? function(b, c, d, e) {
        MSApp.execUnsafeLocalFunction(function() {
            return a(b, c, d, e);
        });
    } : a;
}(function(a, b) {
    if ("http://www.w3.org/2000/svg" !== a.namespaceURI || "innerHTML" in a) a.innerHTML = b;
    else {
        $0b2e6adb871a3b94$var$mb = $0b2e6adb871a3b94$var$mb || document.createElement("div");
        $0b2e6adb871a3b94$var$mb.innerHTML = "<svg>" + b.valueOf().toString() + "</svg>";
        for(b = $0b2e6adb871a3b94$var$mb.firstChild; a.firstChild;)a.removeChild(a.firstChild);
        for(; b.firstChild;)a.appendChild(b.firstChild);
    }
});
function $0b2e6adb871a3b94$var$ob(a, b) {
    if (b) {
        var c = a.firstChild;
        if (c && c === a.lastChild && 3 === c.nodeType) {
            c.nodeValue = b;
            return;
        }
    }
    a.textContent = b;
}
var $0b2e6adb871a3b94$var$pb = {
    animationIterationCount: !0,
    aspectRatio: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
}, $0b2e6adb871a3b94$var$qb = [
    "Webkit",
    "ms",
    "Moz",
    "O"
];
Object.keys($0b2e6adb871a3b94$var$pb).forEach(function(a) {
    $0b2e6adb871a3b94$var$qb.forEach(function(b) {
        b = b + a.charAt(0).toUpperCase() + a.substring(1);
        $0b2e6adb871a3b94$var$pb[b] = $0b2e6adb871a3b94$var$pb[a];
    });
});
function $0b2e6adb871a3b94$var$rb(a, b, c) {
    return null == b || "boolean" === typeof b || "" === b ? "" : c || "number" !== typeof b || 0 === b || $0b2e6adb871a3b94$var$pb.hasOwnProperty(a) && $0b2e6adb871a3b94$var$pb[a] ? ("" + b).trim() : b + "px";
}
function $0b2e6adb871a3b94$var$sb(a, b) {
    a = a.style;
    for(var c in b)if (b.hasOwnProperty(c)) {
        var d = 0 === c.indexOf("--"), e = $0b2e6adb871a3b94$var$rb(c, b[c], d);
        "float" === c && (c = "cssFloat");
        d ? a.setProperty(c, e) : a[c] = e;
    }
}
var $0b2e6adb871a3b94$var$tb = $0b2e6adb871a3b94$var$A({
    menuitem: !0
}, {
    area: !0,
    base: !0,
    br: !0,
    col: !0,
    embed: !0,
    hr: !0,
    img: !0,
    input: !0,
    keygen: !0,
    link: !0,
    meta: !0,
    param: !0,
    source: !0,
    track: !0,
    wbr: !0
});
function $0b2e6adb871a3b94$var$ub(a, b) {
    if (b) {
        if ($0b2e6adb871a3b94$var$tb[a] && (null != b.children || null != b.dangerouslySetInnerHTML)) throw Error($0b2e6adb871a3b94$var$p(137, a));
        if (null != b.dangerouslySetInnerHTML) {
            if (null != b.children) throw Error($0b2e6adb871a3b94$var$p(60));
            if ("object" !== typeof b.dangerouslySetInnerHTML || !("__html" in b.dangerouslySetInnerHTML)) throw Error($0b2e6adb871a3b94$var$p(61));
        }
        if (null != b.style && "object" !== typeof b.style) throw Error($0b2e6adb871a3b94$var$p(62));
    }
}
function $0b2e6adb871a3b94$var$vb(a, b) {
    if (-1 === a.indexOf("-")) return "string" === typeof b.is;
    switch(a){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
var $0b2e6adb871a3b94$var$wb = null;
function $0b2e6adb871a3b94$var$xb(a) {
    a = a.target || a.srcElement || window;
    a.correspondingUseElement && (a = a.correspondingUseElement);
    return 3 === a.nodeType ? a.parentNode : a;
}
var $0b2e6adb871a3b94$var$yb = null, $0b2e6adb871a3b94$var$zb = null, $0b2e6adb871a3b94$var$Ab = null;
function $0b2e6adb871a3b94$var$Bb(a) {
    if (a = $0b2e6adb871a3b94$var$Cb(a)) {
        if ("function" !== typeof $0b2e6adb871a3b94$var$yb) throw Error($0b2e6adb871a3b94$var$p(280));
        var b = a.stateNode;
        b && (b = $0b2e6adb871a3b94$var$Db(b), $0b2e6adb871a3b94$var$yb(a.stateNode, a.type, b));
    }
}
function $0b2e6adb871a3b94$var$Eb(a) {
    $0b2e6adb871a3b94$var$zb ? $0b2e6adb871a3b94$var$Ab ? $0b2e6adb871a3b94$var$Ab.push(a) : $0b2e6adb871a3b94$var$Ab = [
        a
    ] : $0b2e6adb871a3b94$var$zb = a;
}
function $0b2e6adb871a3b94$var$Fb() {
    if ($0b2e6adb871a3b94$var$zb) {
        var a = $0b2e6adb871a3b94$var$zb, b = $0b2e6adb871a3b94$var$Ab;
        $0b2e6adb871a3b94$var$Ab = $0b2e6adb871a3b94$var$zb = null;
        $0b2e6adb871a3b94$var$Bb(a);
        if (b) for(a = 0; a < b.length; a++)$0b2e6adb871a3b94$var$Bb(b[a]);
    }
}
function $0b2e6adb871a3b94$var$Gb(a, b) {
    return a(b);
}
function $0b2e6adb871a3b94$var$Hb() {}
var $0b2e6adb871a3b94$var$Ib = !1;
function $0b2e6adb871a3b94$var$Jb(a, b, c) {
    if ($0b2e6adb871a3b94$var$Ib) return a(b, c);
    $0b2e6adb871a3b94$var$Ib = !0;
    try {
        return $0b2e6adb871a3b94$var$Gb(a, b, c);
    } finally{
        if ($0b2e6adb871a3b94$var$Ib = !1, null !== $0b2e6adb871a3b94$var$zb || null !== $0b2e6adb871a3b94$var$Ab) $0b2e6adb871a3b94$var$Hb(), $0b2e6adb871a3b94$var$Fb();
    }
}
function $0b2e6adb871a3b94$var$Kb(a, b) {
    var c = a.stateNode;
    if (null === c) return null;
    var d = $0b2e6adb871a3b94$var$Db(c);
    if (null === d) return null;
    c = d[b];
    a: switch(b){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (d = !d.disabled) || (a = a.type, d = !("button" === a || "input" === a || "select" === a || "textarea" === a));
            a = !d;
            break a;
        default:
            a = !1;
    }
    if (a) return null;
    if (c && "function" !== typeof c) throw Error($0b2e6adb871a3b94$var$p(231, b, typeof c));
    return c;
}
var $0b2e6adb871a3b94$var$Lb = !1;
if ($0b2e6adb871a3b94$var$ia) try {
    var $0b2e6adb871a3b94$var$Mb = {};
    Object.defineProperty($0b2e6adb871a3b94$var$Mb, "passive", {
        get: function() {
            $0b2e6adb871a3b94$var$Lb = !0;
        }
    });
    window.addEventListener("test", $0b2e6adb871a3b94$var$Mb, $0b2e6adb871a3b94$var$Mb);
    window.removeEventListener("test", $0b2e6adb871a3b94$var$Mb, $0b2e6adb871a3b94$var$Mb);
} catch (a) {
    $0b2e6adb871a3b94$var$Lb = !1;
}
function $0b2e6adb871a3b94$var$Nb(a, b, c, d, e, f, g, h, k) {
    var l = Array.prototype.slice.call(arguments, 3);
    try {
        b.apply(c, l);
    } catch (m) {
        this.onError(m);
    }
}
var $0b2e6adb871a3b94$var$Ob = !1, $0b2e6adb871a3b94$var$Pb = null, $0b2e6adb871a3b94$var$Qb = !1, $0b2e6adb871a3b94$var$Rb = null, $0b2e6adb871a3b94$var$Sb = {
    onError: function(a) {
        $0b2e6adb871a3b94$var$Ob = !0;
        $0b2e6adb871a3b94$var$Pb = a;
    }
};
function $0b2e6adb871a3b94$var$Tb(a, b, c, d, e, f, g, h, k) {
    $0b2e6adb871a3b94$var$Ob = !1;
    $0b2e6adb871a3b94$var$Pb = null;
    $0b2e6adb871a3b94$var$Nb.apply($0b2e6adb871a3b94$var$Sb, arguments);
}
function $0b2e6adb871a3b94$var$Ub(a, b, c, d, e, f, g, h, k) {
    $0b2e6adb871a3b94$var$Tb.apply(this, arguments);
    if ($0b2e6adb871a3b94$var$Ob) {
        if ($0b2e6adb871a3b94$var$Ob) {
            var l = $0b2e6adb871a3b94$var$Pb;
            $0b2e6adb871a3b94$var$Ob = !1;
            $0b2e6adb871a3b94$var$Pb = null;
        } else throw Error($0b2e6adb871a3b94$var$p(198));
        $0b2e6adb871a3b94$var$Qb || ($0b2e6adb871a3b94$var$Qb = !0, $0b2e6adb871a3b94$var$Rb = l);
    }
}
function $0b2e6adb871a3b94$var$Vb(a) {
    var b = a, c = a;
    if (a.alternate) for(; b.return;)b = b.return;
    else {
        a = b;
        do b = a, 0 !== (b.flags & 4098) && (c = b.return), a = b.return;
        while (a);
    }
    return 3 === b.tag ? c : null;
}
function $0b2e6adb871a3b94$var$Wb(a) {
    if (13 === a.tag) {
        var b = a.memoizedState;
        null === b && (a = a.alternate, null !== a && (b = a.memoizedState));
        if (null !== b) return b.dehydrated;
    }
    return null;
}
function $0b2e6adb871a3b94$var$Xb(a) {
    if ($0b2e6adb871a3b94$var$Vb(a) !== a) throw Error($0b2e6adb871a3b94$var$p(188));
}
function $0b2e6adb871a3b94$var$Yb(a) {
    var b = a.alternate;
    if (!b) {
        b = $0b2e6adb871a3b94$var$Vb(a);
        if (null === b) throw Error($0b2e6adb871a3b94$var$p(188));
        return b !== a ? null : a;
    }
    for(var c = a, d = b;;){
        var e = c.return;
        if (null === e) break;
        var f = e.alternate;
        if (null === f) {
            d = e.return;
            if (null !== d) {
                c = d;
                continue;
            }
            break;
        }
        if (e.child === f.child) {
            for(f = e.child; f;){
                if (f === c) return $0b2e6adb871a3b94$var$Xb(e), a;
                if (f === d) return $0b2e6adb871a3b94$var$Xb(e), b;
                f = f.sibling;
            }
            throw Error($0b2e6adb871a3b94$var$p(188));
        }
        if (c.return !== d.return) c = e, d = f;
        else {
            for(var g = !1, h = e.child; h;){
                if (h === c) {
                    g = !0;
                    c = e;
                    d = f;
                    break;
                }
                if (h === d) {
                    g = !0;
                    d = e;
                    c = f;
                    break;
                }
                h = h.sibling;
            }
            if (!g) {
                for(h = f.child; h;){
                    if (h === c) {
                        g = !0;
                        c = f;
                        d = e;
                        break;
                    }
                    if (h === d) {
                        g = !0;
                        d = f;
                        c = e;
                        break;
                    }
                    h = h.sibling;
                }
                if (!g) throw Error($0b2e6adb871a3b94$var$p(189));
            }
        }
        if (c.alternate !== d) throw Error($0b2e6adb871a3b94$var$p(190));
    }
    if (3 !== c.tag) throw Error($0b2e6adb871a3b94$var$p(188));
    return c.stateNode.current === c ? a : b;
}
function $0b2e6adb871a3b94$var$Zb(a) {
    a = $0b2e6adb871a3b94$var$Yb(a);
    return null !== a ? $0b2e6adb871a3b94$var$$b(a) : null;
}
function $0b2e6adb871a3b94$var$$b(a) {
    if (5 === a.tag || 6 === a.tag) return a;
    for(a = a.child; null !== a;){
        var b = $0b2e6adb871a3b94$var$$b(a);
        if (null !== b) return b;
        a = a.sibling;
    }
    return null;
}
var $0b2e6adb871a3b94$var$ac = $fO90s.unstable_scheduleCallback, $0b2e6adb871a3b94$var$bc = $fO90s.unstable_cancelCallback, $0b2e6adb871a3b94$var$cc = $fO90s.unstable_shouldYield, $0b2e6adb871a3b94$var$dc = $fO90s.unstable_requestPaint, $0b2e6adb871a3b94$var$B = $fO90s.unstable_now, $0b2e6adb871a3b94$var$ec = $fO90s.unstable_getCurrentPriorityLevel, $0b2e6adb871a3b94$var$fc = $fO90s.unstable_ImmediatePriority, $0b2e6adb871a3b94$var$gc = $fO90s.unstable_UserBlockingPriority, $0b2e6adb871a3b94$var$hc = $fO90s.unstable_NormalPriority, $0b2e6adb871a3b94$var$ic = $fO90s.unstable_LowPriority, $0b2e6adb871a3b94$var$jc = $fO90s.unstable_IdlePriority, $0b2e6adb871a3b94$var$kc = null, $0b2e6adb871a3b94$var$lc = null;
function $0b2e6adb871a3b94$var$mc(a) {
    if ($0b2e6adb871a3b94$var$lc && "function" === typeof $0b2e6adb871a3b94$var$lc.onCommitFiberRoot) try {
        $0b2e6adb871a3b94$var$lc.onCommitFiberRoot($0b2e6adb871a3b94$var$kc, a, void 0, 128 === (a.current.flags & 128));
    } catch (b) {}
}
var $0b2e6adb871a3b94$var$oc = Math.clz32 ? Math.clz32 : $0b2e6adb871a3b94$var$nc, $0b2e6adb871a3b94$var$pc = Math.log, $0b2e6adb871a3b94$var$qc = Math.LN2;
function $0b2e6adb871a3b94$var$nc(a) {
    a >>>= 0;
    return 0 === a ? 32 : 31 - ($0b2e6adb871a3b94$var$pc(a) / $0b2e6adb871a3b94$var$qc | 0) | 0;
}
var $0b2e6adb871a3b94$var$rc = 64, $0b2e6adb871a3b94$var$sc = 4194304;
function $0b2e6adb871a3b94$var$tc(a) {
    switch(a & -a){
        case 1:
            return 1;
        case 2:
            return 2;
        case 4:
            return 4;
        case 8:
            return 8;
        case 16:
            return 16;
        case 32:
            return 32;
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return a & 4194240;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return a & 130023424;
        case 134217728:
            return 134217728;
        case 268435456:
            return 268435456;
        case 536870912:
            return 536870912;
        case 1073741824:
            return 1073741824;
        default:
            return a;
    }
}
function $0b2e6adb871a3b94$var$uc(a, b) {
    var c = a.pendingLanes;
    if (0 === c) return 0;
    var d = 0, e = a.suspendedLanes, f = a.pingedLanes, g = c & 268435455;
    if (0 !== g) {
        var h = g & ~e;
        0 !== h ? d = $0b2e6adb871a3b94$var$tc(h) : (f &= g, 0 !== f && (d = $0b2e6adb871a3b94$var$tc(f)));
    } else g = c & ~e, 0 !== g ? d = $0b2e6adb871a3b94$var$tc(g) : 0 !== f && (d = $0b2e6adb871a3b94$var$tc(f));
    if (0 === d) return 0;
    if (0 !== b && b !== d && 0 === (b & e) && (e = d & -d, f = b & -b, e >= f || 16 === e && 0 !== (f & 4194240))) return b;
    0 !== (d & 4) && (d |= c & 16);
    b = a.entangledLanes;
    if (0 !== b) for(a = a.entanglements, b &= d; 0 < b;)c = 31 - $0b2e6adb871a3b94$var$oc(b), e = 1 << c, d |= a[c], b &= ~e;
    return d;
}
function $0b2e6adb871a3b94$var$vc(a, b) {
    switch(a){
        case 1:
        case 2:
        case 4:
            return b + 250;
        case 8:
        case 16:
        case 32:
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return b + 5E3;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return -1;
        case 134217728:
        case 268435456:
        case 536870912:
        case 1073741824:
            return -1;
        default:
            return -1;
    }
}
function $0b2e6adb871a3b94$var$wc(a, b) {
    for(var c = a.suspendedLanes, d = a.pingedLanes, e = a.expirationTimes, f = a.pendingLanes; 0 < f;){
        var g = 31 - $0b2e6adb871a3b94$var$oc(f), h = 1 << g, k = e[g];
        if (-1 === k) {
            if (0 === (h & c) || 0 !== (h & d)) e[g] = $0b2e6adb871a3b94$var$vc(h, b);
        } else k <= b && (a.expiredLanes |= h);
        f &= ~h;
    }
}
function $0b2e6adb871a3b94$var$xc(a) {
    a = a.pendingLanes & -1073741825;
    return 0 !== a ? a : a & 1073741824 ? 1073741824 : 0;
}
function $0b2e6adb871a3b94$var$yc() {
    var a = $0b2e6adb871a3b94$var$rc;
    $0b2e6adb871a3b94$var$rc <<= 1;
    0 === ($0b2e6adb871a3b94$var$rc & 4194240) && ($0b2e6adb871a3b94$var$rc = 64);
    return a;
}
function $0b2e6adb871a3b94$var$zc(a) {
    for(var b = [], c = 0; 31 > c; c++)b.push(a);
    return b;
}
function $0b2e6adb871a3b94$var$Ac(a, b, c) {
    a.pendingLanes |= b;
    536870912 !== b && (a.suspendedLanes = 0, a.pingedLanes = 0);
    a = a.eventTimes;
    b = 31 - $0b2e6adb871a3b94$var$oc(b);
    a[b] = c;
}
function $0b2e6adb871a3b94$var$Bc(a, b) {
    var c = a.pendingLanes & ~b;
    a.pendingLanes = b;
    a.suspendedLanes = 0;
    a.pingedLanes = 0;
    a.expiredLanes &= b;
    a.mutableReadLanes &= b;
    a.entangledLanes &= b;
    b = a.entanglements;
    var d = a.eventTimes;
    for(a = a.expirationTimes; 0 < c;){
        var e = 31 - $0b2e6adb871a3b94$var$oc(c), f = 1 << e;
        b[e] = 0;
        d[e] = -1;
        a[e] = -1;
        c &= ~f;
    }
}
function $0b2e6adb871a3b94$var$Cc(a, b) {
    var c = a.entangledLanes |= b;
    for(a = a.entanglements; c;){
        var d = 31 - $0b2e6adb871a3b94$var$oc(c), e = 1 << d;
        e & b | a[d] & b && (a[d] |= b);
        c &= ~e;
    }
}
var $0b2e6adb871a3b94$var$C = 0;
function $0b2e6adb871a3b94$var$Dc(a) {
    a &= -a;
    return 1 < a ? 4 < a ? 0 !== (a & 268435455) ? 16 : 536870912 : 4 : 1;
}
var $0b2e6adb871a3b94$var$Ec, $0b2e6adb871a3b94$var$Fc, $0b2e6adb871a3b94$var$Gc, $0b2e6adb871a3b94$var$Hc, $0b2e6adb871a3b94$var$Ic, $0b2e6adb871a3b94$var$Jc = !1, $0b2e6adb871a3b94$var$Kc = [], $0b2e6adb871a3b94$var$Lc = null, $0b2e6adb871a3b94$var$Mc = null, $0b2e6adb871a3b94$var$Nc = null, $0b2e6adb871a3b94$var$Oc = new Map, $0b2e6adb871a3b94$var$Pc = new Map, $0b2e6adb871a3b94$var$Qc = [], $0b2e6adb871a3b94$var$Rc = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset submit".split(" ");
function $0b2e6adb871a3b94$var$Sc(a, b) {
    switch(a){
        case "focusin":
        case "focusout":
            $0b2e6adb871a3b94$var$Lc = null;
            break;
        case "dragenter":
        case "dragleave":
            $0b2e6adb871a3b94$var$Mc = null;
            break;
        case "mouseover":
        case "mouseout":
            $0b2e6adb871a3b94$var$Nc = null;
            break;
        case "pointerover":
        case "pointerout":
            $0b2e6adb871a3b94$var$Oc.delete(b.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            $0b2e6adb871a3b94$var$Pc.delete(b.pointerId);
    }
}
function $0b2e6adb871a3b94$var$Tc(a, b, c, d, e, f) {
    if (null === a || a.nativeEvent !== f) return a = {
        blockedOn: b,
        domEventName: c,
        eventSystemFlags: d,
        nativeEvent: f,
        targetContainers: [
            e
        ]
    }, null !== b && (b = $0b2e6adb871a3b94$var$Cb(b), null !== b && $0b2e6adb871a3b94$var$Fc(b)), a;
    a.eventSystemFlags |= d;
    b = a.targetContainers;
    null !== e && -1 === b.indexOf(e) && b.push(e);
    return a;
}
function $0b2e6adb871a3b94$var$Uc(a, b, c, d, e) {
    switch(b){
        case "focusin":
            return $0b2e6adb871a3b94$var$Lc = $0b2e6adb871a3b94$var$Tc($0b2e6adb871a3b94$var$Lc, a, b, c, d, e), !0;
        case "dragenter":
            return $0b2e6adb871a3b94$var$Mc = $0b2e6adb871a3b94$var$Tc($0b2e6adb871a3b94$var$Mc, a, b, c, d, e), !0;
        case "mouseover":
            return $0b2e6adb871a3b94$var$Nc = $0b2e6adb871a3b94$var$Tc($0b2e6adb871a3b94$var$Nc, a, b, c, d, e), !0;
        case "pointerover":
            var f = e.pointerId;
            $0b2e6adb871a3b94$var$Oc.set(f, $0b2e6adb871a3b94$var$Tc($0b2e6adb871a3b94$var$Oc.get(f) || null, a, b, c, d, e));
            return !0;
        case "gotpointercapture":
            return f = e.pointerId, $0b2e6adb871a3b94$var$Pc.set(f, $0b2e6adb871a3b94$var$Tc($0b2e6adb871a3b94$var$Pc.get(f) || null, a, b, c, d, e)), !0;
    }
    return !1;
}
function $0b2e6adb871a3b94$var$Vc(a) {
    var b = $0b2e6adb871a3b94$var$Wc(a.target);
    if (null !== b) {
        var c = $0b2e6adb871a3b94$var$Vb(b);
        if (null !== c) {
            if (b = c.tag, 13 === b) {
                if (b = $0b2e6adb871a3b94$var$Wb(c), null !== b) {
                    a.blockedOn = b;
                    $0b2e6adb871a3b94$var$Ic(a.priority, function() {
                        $0b2e6adb871a3b94$var$Gc(c);
                    });
                    return;
                }
            } else if (3 === b && c.stateNode.current.memoizedState.isDehydrated) {
                a.blockedOn = 3 === c.tag ? c.stateNode.containerInfo : null;
                return;
            }
        }
    }
    a.blockedOn = null;
}
function $0b2e6adb871a3b94$var$Xc(a) {
    if (null !== a.blockedOn) return !1;
    for(var b = a.targetContainers; 0 < b.length;){
        var c = $0b2e6adb871a3b94$var$Yc(a.domEventName, a.eventSystemFlags, b[0], a.nativeEvent);
        if (null === c) {
            c = a.nativeEvent;
            var d = new c.constructor(c.type, c);
            $0b2e6adb871a3b94$var$wb = d;
            c.target.dispatchEvent(d);
            $0b2e6adb871a3b94$var$wb = null;
        } else return b = $0b2e6adb871a3b94$var$Cb(c), null !== b && $0b2e6adb871a3b94$var$Fc(b), a.blockedOn = c, !1;
        b.shift();
    }
    return !0;
}
function $0b2e6adb871a3b94$var$Zc(a, b, c) {
    $0b2e6adb871a3b94$var$Xc(a) && c.delete(b);
}
function $0b2e6adb871a3b94$var$$c() {
    $0b2e6adb871a3b94$var$Jc = !1;
    null !== $0b2e6adb871a3b94$var$Lc && $0b2e6adb871a3b94$var$Xc($0b2e6adb871a3b94$var$Lc) && ($0b2e6adb871a3b94$var$Lc = null);
    null !== $0b2e6adb871a3b94$var$Mc && $0b2e6adb871a3b94$var$Xc($0b2e6adb871a3b94$var$Mc) && ($0b2e6adb871a3b94$var$Mc = null);
    null !== $0b2e6adb871a3b94$var$Nc && $0b2e6adb871a3b94$var$Xc($0b2e6adb871a3b94$var$Nc) && ($0b2e6adb871a3b94$var$Nc = null);
    $0b2e6adb871a3b94$var$Oc.forEach($0b2e6adb871a3b94$var$Zc);
    $0b2e6adb871a3b94$var$Pc.forEach($0b2e6adb871a3b94$var$Zc);
}
function $0b2e6adb871a3b94$var$ad(a, b) {
    a.blockedOn === b && (a.blockedOn = null, $0b2e6adb871a3b94$var$Jc || ($0b2e6adb871a3b94$var$Jc = !0, $fO90s.unstable_scheduleCallback($fO90s.unstable_NormalPriority, $0b2e6adb871a3b94$var$$c)));
}
function $0b2e6adb871a3b94$var$bd(a) {
    function b(b) {
        return $0b2e6adb871a3b94$var$ad(b, a);
    }
    if (0 < $0b2e6adb871a3b94$var$Kc.length) {
        $0b2e6adb871a3b94$var$ad($0b2e6adb871a3b94$var$Kc[0], a);
        for(var c = 1; c < $0b2e6adb871a3b94$var$Kc.length; c++){
            var d = $0b2e6adb871a3b94$var$Kc[c];
            d.blockedOn === a && (d.blockedOn = null);
        }
    }
    null !== $0b2e6adb871a3b94$var$Lc && $0b2e6adb871a3b94$var$ad($0b2e6adb871a3b94$var$Lc, a);
    null !== $0b2e6adb871a3b94$var$Mc && $0b2e6adb871a3b94$var$ad($0b2e6adb871a3b94$var$Mc, a);
    null !== $0b2e6adb871a3b94$var$Nc && $0b2e6adb871a3b94$var$ad($0b2e6adb871a3b94$var$Nc, a);
    $0b2e6adb871a3b94$var$Oc.forEach(b);
    $0b2e6adb871a3b94$var$Pc.forEach(b);
    for(c = 0; c < $0b2e6adb871a3b94$var$Qc.length; c++)d = $0b2e6adb871a3b94$var$Qc[c], d.blockedOn === a && (d.blockedOn = null);
    for(; 0 < $0b2e6adb871a3b94$var$Qc.length && (c = $0b2e6adb871a3b94$var$Qc[0], null === c.blockedOn);)$0b2e6adb871a3b94$var$Vc(c), null === c.blockedOn && $0b2e6adb871a3b94$var$Qc.shift();
}
var $0b2e6adb871a3b94$var$cd = $0b2e6adb871a3b94$var$ua.ReactCurrentBatchConfig, $0b2e6adb871a3b94$var$dd = !0;
function $0b2e6adb871a3b94$var$ed(a, b, c, d) {
    var e = $0b2e6adb871a3b94$var$C, f = $0b2e6adb871a3b94$var$cd.transition;
    $0b2e6adb871a3b94$var$cd.transition = null;
    try {
        $0b2e6adb871a3b94$var$C = 1, $0b2e6adb871a3b94$var$fd(a, b, c, d);
    } finally{
        $0b2e6adb871a3b94$var$C = e, $0b2e6adb871a3b94$var$cd.transition = f;
    }
}
function $0b2e6adb871a3b94$var$gd(a, b, c, d) {
    var e = $0b2e6adb871a3b94$var$C, f = $0b2e6adb871a3b94$var$cd.transition;
    $0b2e6adb871a3b94$var$cd.transition = null;
    try {
        $0b2e6adb871a3b94$var$C = 4, $0b2e6adb871a3b94$var$fd(a, b, c, d);
    } finally{
        $0b2e6adb871a3b94$var$C = e, $0b2e6adb871a3b94$var$cd.transition = f;
    }
}
function $0b2e6adb871a3b94$var$fd(a, b, c, d) {
    if ($0b2e6adb871a3b94$var$dd) {
        var e = $0b2e6adb871a3b94$var$Yc(a, b, c, d);
        if (null === e) $0b2e6adb871a3b94$var$hd(a, b, d, $0b2e6adb871a3b94$var$id, c), $0b2e6adb871a3b94$var$Sc(a, d);
        else if ($0b2e6adb871a3b94$var$Uc(e, a, b, c, d)) d.stopPropagation();
        else if ($0b2e6adb871a3b94$var$Sc(a, d), b & 4 && -1 < $0b2e6adb871a3b94$var$Rc.indexOf(a)) {
            for(; null !== e;){
                var f = $0b2e6adb871a3b94$var$Cb(e);
                null !== f && $0b2e6adb871a3b94$var$Ec(f);
                f = $0b2e6adb871a3b94$var$Yc(a, b, c, d);
                null === f && $0b2e6adb871a3b94$var$hd(a, b, d, $0b2e6adb871a3b94$var$id, c);
                if (f === e) break;
                e = f;
            }
            null !== e && d.stopPropagation();
        } else $0b2e6adb871a3b94$var$hd(a, b, d, null, c);
    }
}
var $0b2e6adb871a3b94$var$id = null;
function $0b2e6adb871a3b94$var$Yc(a, b, c, d) {
    $0b2e6adb871a3b94$var$id = null;
    a = $0b2e6adb871a3b94$var$xb(d);
    a = $0b2e6adb871a3b94$var$Wc(a);
    if (null !== a) {
        if (b = $0b2e6adb871a3b94$var$Vb(a), null === b) a = null;
        else if (c = b.tag, 13 === c) {
            a = $0b2e6adb871a3b94$var$Wb(b);
            if (null !== a) return a;
            a = null;
        } else if (3 === c) {
            if (b.stateNode.current.memoizedState.isDehydrated) return 3 === b.tag ? b.stateNode.containerInfo : null;
            a = null;
        } else b !== a && (a = null);
    }
    $0b2e6adb871a3b94$var$id = a;
    return null;
}
function $0b2e6adb871a3b94$var$jd(a) {
    switch(a){
        case "cancel":
        case "click":
        case "close":
        case "contextmenu":
        case "copy":
        case "cut":
        case "auxclick":
        case "dblclick":
        case "dragend":
        case "dragstart":
        case "drop":
        case "focusin":
        case "focusout":
        case "input":
        case "invalid":
        case "keydown":
        case "keypress":
        case "keyup":
        case "mousedown":
        case "mouseup":
        case "paste":
        case "pause":
        case "play":
        case "pointercancel":
        case "pointerdown":
        case "pointerup":
        case "ratechange":
        case "reset":
        case "resize":
        case "seeked":
        case "submit":
        case "touchcancel":
        case "touchend":
        case "touchstart":
        case "volumechange":
        case "change":
        case "selectionchange":
        case "textInput":
        case "compositionstart":
        case "compositionend":
        case "compositionupdate":
        case "beforeblur":
        case "afterblur":
        case "beforeinput":
        case "blur":
        case "fullscreenchange":
        case "focus":
        case "hashchange":
        case "popstate":
        case "select":
        case "selectstart":
            return 1;
        case "drag":
        case "dragenter":
        case "dragexit":
        case "dragleave":
        case "dragover":
        case "mousemove":
        case "mouseout":
        case "mouseover":
        case "pointermove":
        case "pointerout":
        case "pointerover":
        case "scroll":
        case "toggle":
        case "touchmove":
        case "wheel":
        case "mouseenter":
        case "mouseleave":
        case "pointerenter":
        case "pointerleave":
            return 4;
        case "message":
            switch($0b2e6adb871a3b94$var$ec()){
                case $0b2e6adb871a3b94$var$fc:
                    return 1;
                case $0b2e6adb871a3b94$var$gc:
                    return 4;
                case $0b2e6adb871a3b94$var$hc:
                case $0b2e6adb871a3b94$var$ic:
                    return 16;
                case $0b2e6adb871a3b94$var$jc:
                    return 536870912;
                default:
                    return 16;
            }
        default:
            return 16;
    }
}
var $0b2e6adb871a3b94$var$kd = null, $0b2e6adb871a3b94$var$ld = null, $0b2e6adb871a3b94$var$md = null;
function $0b2e6adb871a3b94$var$nd() {
    if ($0b2e6adb871a3b94$var$md) return $0b2e6adb871a3b94$var$md;
    var a, b = $0b2e6adb871a3b94$var$ld, c = b.length, d, e = "value" in $0b2e6adb871a3b94$var$kd ? $0b2e6adb871a3b94$var$kd.value : $0b2e6adb871a3b94$var$kd.textContent, f = e.length;
    for(a = 0; a < c && b[a] === e[a]; a++);
    var g = c - a;
    for(d = 1; d <= g && b[c - d] === e[f - d]; d++);
    return $0b2e6adb871a3b94$var$md = e.slice(a, 1 < d ? 1 - d : void 0);
}
function $0b2e6adb871a3b94$var$od(a) {
    var b = a.keyCode;
    "charCode" in a ? (a = a.charCode, 0 === a && 13 === b && (a = 13)) : a = b;
    10 === a && (a = 13);
    return 32 <= a || 13 === a ? a : 0;
}
function $0b2e6adb871a3b94$var$pd() {
    return !0;
}
function $0b2e6adb871a3b94$var$qd() {
    return !1;
}
function $0b2e6adb871a3b94$var$rd(a) {
    function b(b, d, e, f, g) {
        this._reactName = b;
        this._targetInst = e;
        this.type = d;
        this.nativeEvent = f;
        this.target = g;
        this.currentTarget = null;
        for(var c in a)a.hasOwnProperty(c) && (b = a[c], this[c] = b ? b(f) : f[c]);
        this.isDefaultPrevented = (null != f.defaultPrevented ? f.defaultPrevented : !1 === f.returnValue) ? $0b2e6adb871a3b94$var$pd : $0b2e6adb871a3b94$var$qd;
        this.isPropagationStopped = $0b2e6adb871a3b94$var$qd;
        return this;
    }
    $0b2e6adb871a3b94$var$A(b.prototype, {
        preventDefault: function() {
            this.defaultPrevented = !0;
            var a = this.nativeEvent;
            a && (a.preventDefault ? a.preventDefault() : "unknown" !== typeof a.returnValue && (a.returnValue = !1), this.isDefaultPrevented = $0b2e6adb871a3b94$var$pd);
        },
        stopPropagation: function() {
            var a = this.nativeEvent;
            a && (a.stopPropagation ? a.stopPropagation() : "unknown" !== typeof a.cancelBubble && (a.cancelBubble = !0), this.isPropagationStopped = $0b2e6adb871a3b94$var$pd);
        },
        persist: function() {},
        isPersistent: $0b2e6adb871a3b94$var$pd
    });
    return b;
}
var $0b2e6adb871a3b94$var$sd = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function(a) {
        return a.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
}, $0b2e6adb871a3b94$var$td = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$sd), $0b2e6adb871a3b94$var$ud = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$sd, {
    view: 0,
    detail: 0
}), $0b2e6adb871a3b94$var$vd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$ud), $0b2e6adb871a3b94$var$wd, $0b2e6adb871a3b94$var$xd, $0b2e6adb871a3b94$var$yd, $0b2e6adb871a3b94$var$Ad = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$ud, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: $0b2e6adb871a3b94$var$zd,
    button: 0,
    buttons: 0,
    relatedTarget: function(a) {
        return void 0 === a.relatedTarget ? a.fromElement === a.srcElement ? a.toElement : a.fromElement : a.relatedTarget;
    },
    movementX: function(a) {
        if ("movementX" in a) return a.movementX;
        a !== $0b2e6adb871a3b94$var$yd && ($0b2e6adb871a3b94$var$yd && "mousemove" === a.type ? ($0b2e6adb871a3b94$var$wd = a.screenX - $0b2e6adb871a3b94$var$yd.screenX, $0b2e6adb871a3b94$var$xd = a.screenY - $0b2e6adb871a3b94$var$yd.screenY) : $0b2e6adb871a3b94$var$xd = $0b2e6adb871a3b94$var$wd = 0, $0b2e6adb871a3b94$var$yd = a);
        return $0b2e6adb871a3b94$var$wd;
    },
    movementY: function(a) {
        return "movementY" in a ? a.movementY : $0b2e6adb871a3b94$var$xd;
    }
}), $0b2e6adb871a3b94$var$Bd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Ad), $0b2e6adb871a3b94$var$Cd = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$Ad, {
    dataTransfer: 0
}), $0b2e6adb871a3b94$var$Dd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Cd), $0b2e6adb871a3b94$var$Ed = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$ud, {
    relatedTarget: 0
}), $0b2e6adb871a3b94$var$Fd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Ed), $0b2e6adb871a3b94$var$Gd = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$sd, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $0b2e6adb871a3b94$var$Hd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Gd), $0b2e6adb871a3b94$var$Id = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$sd, {
    clipboardData: function(a) {
        return "clipboardData" in a ? a.clipboardData : window.clipboardData;
    }
}), $0b2e6adb871a3b94$var$Jd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Id), $0b2e6adb871a3b94$var$Kd = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$sd, {
    data: 0
}), $0b2e6adb871a3b94$var$Ld = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Kd), $0b2e6adb871a3b94$var$Md = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, $0b2e6adb871a3b94$var$Nd = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, $0b2e6adb871a3b94$var$Od = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function $0b2e6adb871a3b94$var$Pd(a) {
    var b = this.nativeEvent;
    return b.getModifierState ? b.getModifierState(a) : (a = $0b2e6adb871a3b94$var$Od[a]) ? !!b[a] : !1;
}
function $0b2e6adb871a3b94$var$zd() {
    return $0b2e6adb871a3b94$var$Pd;
}
var $0b2e6adb871a3b94$var$Qd = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$ud, {
    key: function(a) {
        if (a.key) {
            var b = $0b2e6adb871a3b94$var$Md[a.key] || a.key;
            if ("Unidentified" !== b) return b;
        }
        return "keypress" === a.type ? (a = $0b2e6adb871a3b94$var$od(a), 13 === a ? "Enter" : String.fromCharCode(a)) : "keydown" === a.type || "keyup" === a.type ? $0b2e6adb871a3b94$var$Nd[a.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: $0b2e6adb871a3b94$var$zd,
    charCode: function(a) {
        return "keypress" === a.type ? $0b2e6adb871a3b94$var$od(a) : 0;
    },
    keyCode: function(a) {
        return "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    },
    which: function(a) {
        return "keypress" === a.type ? $0b2e6adb871a3b94$var$od(a) : "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    }
}), $0b2e6adb871a3b94$var$Rd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Qd), $0b2e6adb871a3b94$var$Sd = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$Ad, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
}), $0b2e6adb871a3b94$var$Td = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Sd), $0b2e6adb871a3b94$var$Ud = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$ud, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: $0b2e6adb871a3b94$var$zd
}), $0b2e6adb871a3b94$var$Vd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Ud), $0b2e6adb871a3b94$var$Wd = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$sd, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $0b2e6adb871a3b94$var$Xd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Wd), $0b2e6adb871a3b94$var$Yd = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$Ad, {
    deltaX: function(a) {
        return "deltaX" in a ? a.deltaX : "wheelDeltaX" in a ? -a.wheelDeltaX : 0;
    },
    deltaY: function(a) {
        return "deltaY" in a ? a.deltaY : "wheelDeltaY" in a ? -a.wheelDeltaY : "wheelDelta" in a ? -a.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
}), $0b2e6adb871a3b94$var$Zd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Yd), $0b2e6adb871a3b94$var$$d = [
    9,
    13,
    27,
    32
], $0b2e6adb871a3b94$var$ae = $0b2e6adb871a3b94$var$ia && "CompositionEvent" in window, $0b2e6adb871a3b94$var$be = null;
$0b2e6adb871a3b94$var$ia && "documentMode" in document && ($0b2e6adb871a3b94$var$be = document.documentMode);
var $0b2e6adb871a3b94$var$ce = $0b2e6adb871a3b94$var$ia && "TextEvent" in window && !$0b2e6adb871a3b94$var$be, $0b2e6adb871a3b94$var$de = $0b2e6adb871a3b94$var$ia && (!$0b2e6adb871a3b94$var$ae || $0b2e6adb871a3b94$var$be && 8 < $0b2e6adb871a3b94$var$be && 11 >= $0b2e6adb871a3b94$var$be), $0b2e6adb871a3b94$var$ee = String.fromCharCode(32), $0b2e6adb871a3b94$var$fe = !1;
function $0b2e6adb871a3b94$var$ge(a, b) {
    switch(a){
        case "keyup":
            return -1 !== $0b2e6adb871a3b94$var$$d.indexOf(b.keyCode);
        case "keydown":
            return 229 !== b.keyCode;
        case "keypress":
        case "mousedown":
        case "focusout":
            return !0;
        default:
            return !1;
    }
}
function $0b2e6adb871a3b94$var$he(a) {
    a = a.detail;
    return "object" === typeof a && "data" in a ? a.data : null;
}
var $0b2e6adb871a3b94$var$ie = !1;
function $0b2e6adb871a3b94$var$je(a, b) {
    switch(a){
        case "compositionend":
            return $0b2e6adb871a3b94$var$he(b);
        case "keypress":
            if (32 !== b.which) return null;
            $0b2e6adb871a3b94$var$fe = !0;
            return $0b2e6adb871a3b94$var$ee;
        case "textInput":
            return a = b.data, a === $0b2e6adb871a3b94$var$ee && $0b2e6adb871a3b94$var$fe ? null : a;
        default:
            return null;
    }
}
function $0b2e6adb871a3b94$var$ke(a, b) {
    if ($0b2e6adb871a3b94$var$ie) return "compositionend" === a || !$0b2e6adb871a3b94$var$ae && $0b2e6adb871a3b94$var$ge(a, b) ? (a = $0b2e6adb871a3b94$var$nd(), $0b2e6adb871a3b94$var$md = $0b2e6adb871a3b94$var$ld = $0b2e6adb871a3b94$var$kd = null, $0b2e6adb871a3b94$var$ie = !1, a) : null;
    switch(a){
        case "paste":
            return null;
        case "keypress":
            if (!(b.ctrlKey || b.altKey || b.metaKey) || b.ctrlKey && b.altKey) {
                if (b.char && 1 < b.char.length) return b.char;
                if (b.which) return String.fromCharCode(b.which);
            }
            return null;
        case "compositionend":
            return $0b2e6adb871a3b94$var$de && "ko" !== b.locale ? null : b.data;
        default:
            return null;
    }
}
var $0b2e6adb871a3b94$var$le = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function $0b2e6adb871a3b94$var$me(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return "input" === b ? !!$0b2e6adb871a3b94$var$le[a.type] : "textarea" === b ? !0 : !1;
}
function $0b2e6adb871a3b94$var$ne(a, b, c, d) {
    $0b2e6adb871a3b94$var$Eb(d);
    b = $0b2e6adb871a3b94$var$oe(b, "onChange");
    0 < b.length && (c = new $0b2e6adb871a3b94$var$td("onChange", "change", null, c, d), a.push({
        event: c,
        listeners: b
    }));
}
var $0b2e6adb871a3b94$var$pe = null, $0b2e6adb871a3b94$var$qe = null;
function $0b2e6adb871a3b94$var$re(a) {
    $0b2e6adb871a3b94$var$se(a, 0);
}
function $0b2e6adb871a3b94$var$te(a) {
    var b = $0b2e6adb871a3b94$var$ue(a);
    if ($0b2e6adb871a3b94$var$Wa(b)) return a;
}
function $0b2e6adb871a3b94$var$ve(a, b) {
    if ("change" === a) return b;
}
var $0b2e6adb871a3b94$var$we = !1;
if ($0b2e6adb871a3b94$var$ia) {
    var $0b2e6adb871a3b94$var$xe;
    if ($0b2e6adb871a3b94$var$ia) {
        var $0b2e6adb871a3b94$var$ye = "oninput" in document;
        if (!$0b2e6adb871a3b94$var$ye) {
            var $0b2e6adb871a3b94$var$ze = document.createElement("div");
            $0b2e6adb871a3b94$var$ze.setAttribute("oninput", "return;");
            $0b2e6adb871a3b94$var$ye = "function" === typeof $0b2e6adb871a3b94$var$ze.oninput;
        }
        $0b2e6adb871a3b94$var$xe = $0b2e6adb871a3b94$var$ye;
    } else $0b2e6adb871a3b94$var$xe = !1;
    $0b2e6adb871a3b94$var$we = $0b2e6adb871a3b94$var$xe && (!document.documentMode || 9 < document.documentMode);
}
function $0b2e6adb871a3b94$var$Ae() {
    $0b2e6adb871a3b94$var$pe && ($0b2e6adb871a3b94$var$pe.detachEvent("onpropertychange", $0b2e6adb871a3b94$var$Be), $0b2e6adb871a3b94$var$qe = $0b2e6adb871a3b94$var$pe = null);
}
function $0b2e6adb871a3b94$var$Be(a) {
    if ("value" === a.propertyName && $0b2e6adb871a3b94$var$te($0b2e6adb871a3b94$var$qe)) {
        var b = [];
        $0b2e6adb871a3b94$var$ne(b, $0b2e6adb871a3b94$var$qe, a, $0b2e6adb871a3b94$var$xb(a));
        $0b2e6adb871a3b94$var$Jb($0b2e6adb871a3b94$var$re, b);
    }
}
function $0b2e6adb871a3b94$var$Ce(a, b, c) {
    "focusin" === a ? ($0b2e6adb871a3b94$var$Ae(), $0b2e6adb871a3b94$var$pe = b, $0b2e6adb871a3b94$var$qe = c, $0b2e6adb871a3b94$var$pe.attachEvent("onpropertychange", $0b2e6adb871a3b94$var$Be)) : "focusout" === a && $0b2e6adb871a3b94$var$Ae();
}
function $0b2e6adb871a3b94$var$De(a) {
    if ("selectionchange" === a || "keyup" === a || "keydown" === a) return $0b2e6adb871a3b94$var$te($0b2e6adb871a3b94$var$qe);
}
function $0b2e6adb871a3b94$var$Ee(a, b) {
    if ("click" === a) return $0b2e6adb871a3b94$var$te(b);
}
function $0b2e6adb871a3b94$var$Fe(a, b) {
    if ("input" === a || "change" === a) return $0b2e6adb871a3b94$var$te(b);
}
function $0b2e6adb871a3b94$var$Ge(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $0b2e6adb871a3b94$var$He = "function" === typeof Object.is ? Object.is : $0b2e6adb871a3b94$var$Ge;
function $0b2e6adb871a3b94$var$Ie(a, b) {
    if ($0b2e6adb871a3b94$var$He(a, b)) return !0;
    if ("object" !== typeof a || null === a || "object" !== typeof b || null === b) return !1;
    var c = Object.keys(a), d = Object.keys(b);
    if (c.length !== d.length) return !1;
    for(d = 0; d < c.length; d++){
        var e = c[d];
        if (!$0b2e6adb871a3b94$var$ja.call(b, e) || !$0b2e6adb871a3b94$var$He(a[e], b[e])) return !1;
    }
    return !0;
}
function $0b2e6adb871a3b94$var$Je(a) {
    for(; a && a.firstChild;)a = a.firstChild;
    return a;
}
function $0b2e6adb871a3b94$var$Ke(a, b) {
    var c = $0b2e6adb871a3b94$var$Je(a);
    a = 0;
    for(var d; c;){
        if (3 === c.nodeType) {
            d = a + c.textContent.length;
            if (a <= b && d >= b) return {
                node: c,
                offset: b - a
            };
            a = d;
        }
        a: {
            for(; c;){
                if (c.nextSibling) {
                    c = c.nextSibling;
                    break a;
                }
                c = c.parentNode;
            }
            c = void 0;
        }
        c = $0b2e6adb871a3b94$var$Je(c);
    }
}
function $0b2e6adb871a3b94$var$Le(a, b) {
    return a && b ? a === b ? !0 : a && 3 === a.nodeType ? !1 : b && 3 === b.nodeType ? $0b2e6adb871a3b94$var$Le(a, b.parentNode) : "contains" in a ? a.contains(b) : a.compareDocumentPosition ? !!(a.compareDocumentPosition(b) & 16) : !1 : !1;
}
function $0b2e6adb871a3b94$var$Me() {
    for(var a = window, b = $0b2e6adb871a3b94$var$Xa(); b instanceof a.HTMLIFrameElement;){
        try {
            var c = "string" === typeof b.contentWindow.location.href;
        } catch (d) {
            c = !1;
        }
        if (c) a = b.contentWindow;
        else break;
        b = $0b2e6adb871a3b94$var$Xa(a.document);
    }
    return b;
}
function $0b2e6adb871a3b94$var$Ne(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return b && ("input" === b && ("text" === a.type || "search" === a.type || "tel" === a.type || "url" === a.type || "password" === a.type) || "textarea" === b || "true" === a.contentEditable);
}
function $0b2e6adb871a3b94$var$Oe(a) {
    var b = $0b2e6adb871a3b94$var$Me(), c = a.focusedElem, d = a.selectionRange;
    if (b !== c && c && c.ownerDocument && $0b2e6adb871a3b94$var$Le(c.ownerDocument.documentElement, c)) {
        if (null !== d && $0b2e6adb871a3b94$var$Ne(c)) {
            if (b = d.start, a = d.end, void 0 === a && (a = b), "selectionStart" in c) c.selectionStart = b, c.selectionEnd = Math.min(a, c.value.length);
            else if (a = (b = c.ownerDocument || document) && b.defaultView || window, a.getSelection) {
                a = a.getSelection();
                var e = c.textContent.length, f = Math.min(d.start, e);
                d = void 0 === d.end ? f : Math.min(d.end, e);
                !a.extend && f > d && (e = d, d = f, f = e);
                e = $0b2e6adb871a3b94$var$Ke(c, f);
                var g = $0b2e6adb871a3b94$var$Ke(c, d);
                e && g && (1 !== a.rangeCount || a.anchorNode !== e.node || a.anchorOffset !== e.offset || a.focusNode !== g.node || a.focusOffset !== g.offset) && (b = b.createRange(), b.setStart(e.node, e.offset), a.removeAllRanges(), f > d ? (a.addRange(b), a.extend(g.node, g.offset)) : (b.setEnd(g.node, g.offset), a.addRange(b)));
            }
        }
        b = [];
        for(a = c; a = a.parentNode;)1 === a.nodeType && b.push({
            element: a,
            left: a.scrollLeft,
            top: a.scrollTop
        });
        "function" === typeof c.focus && c.focus();
        for(c = 0; c < b.length; c++)a = b[c], a.element.scrollLeft = a.left, a.element.scrollTop = a.top;
    }
}
var $0b2e6adb871a3b94$var$Pe = $0b2e6adb871a3b94$var$ia && "documentMode" in document && 11 >= document.documentMode, $0b2e6adb871a3b94$var$Qe = null, $0b2e6adb871a3b94$var$Re = null, $0b2e6adb871a3b94$var$Se = null, $0b2e6adb871a3b94$var$Te = !1;
function $0b2e6adb871a3b94$var$Ue(a, b, c) {
    var d = c.window === c ? c.document : 9 === c.nodeType ? c : c.ownerDocument;
    $0b2e6adb871a3b94$var$Te || null == $0b2e6adb871a3b94$var$Qe || $0b2e6adb871a3b94$var$Qe !== $0b2e6adb871a3b94$var$Xa(d) || (d = $0b2e6adb871a3b94$var$Qe, "selectionStart" in d && $0b2e6adb871a3b94$var$Ne(d) ? d = {
        start: d.selectionStart,
        end: d.selectionEnd
    } : (d = (d.ownerDocument && d.ownerDocument.defaultView || window).getSelection(), d = {
        anchorNode: d.anchorNode,
        anchorOffset: d.anchorOffset,
        focusNode: d.focusNode,
        focusOffset: d.focusOffset
    }), $0b2e6adb871a3b94$var$Se && $0b2e6adb871a3b94$var$Ie($0b2e6adb871a3b94$var$Se, d) || ($0b2e6adb871a3b94$var$Se = d, d = $0b2e6adb871a3b94$var$oe($0b2e6adb871a3b94$var$Re, "onSelect"), 0 < d.length && (b = new $0b2e6adb871a3b94$var$td("onSelect", "select", null, b, c), a.push({
        event: b,
        listeners: d
    }), b.target = $0b2e6adb871a3b94$var$Qe)));
}
function $0b2e6adb871a3b94$var$Ve(a, b) {
    var c = {};
    c[a.toLowerCase()] = b.toLowerCase();
    c["Webkit" + a] = "webkit" + b;
    c["Moz" + a] = "moz" + b;
    return c;
}
var $0b2e6adb871a3b94$var$We = {
    animationend: $0b2e6adb871a3b94$var$Ve("Animation", "AnimationEnd"),
    animationiteration: $0b2e6adb871a3b94$var$Ve("Animation", "AnimationIteration"),
    animationstart: $0b2e6adb871a3b94$var$Ve("Animation", "AnimationStart"),
    transitionend: $0b2e6adb871a3b94$var$Ve("Transition", "TransitionEnd")
}, $0b2e6adb871a3b94$var$Xe = {}, $0b2e6adb871a3b94$var$Ye = {};
$0b2e6adb871a3b94$var$ia && ($0b2e6adb871a3b94$var$Ye = document.createElement("div").style, "AnimationEvent" in window || (delete $0b2e6adb871a3b94$var$We.animationend.animation, delete $0b2e6adb871a3b94$var$We.animationiteration.animation, delete $0b2e6adb871a3b94$var$We.animationstart.animation), "TransitionEvent" in window || delete $0b2e6adb871a3b94$var$We.transitionend.transition);
function $0b2e6adb871a3b94$var$Ze(a) {
    if ($0b2e6adb871a3b94$var$Xe[a]) return $0b2e6adb871a3b94$var$Xe[a];
    if (!$0b2e6adb871a3b94$var$We[a]) return a;
    var b = $0b2e6adb871a3b94$var$We[a], c;
    for(c in b)if (b.hasOwnProperty(c) && c in $0b2e6adb871a3b94$var$Ye) return $0b2e6adb871a3b94$var$Xe[a] = b[c];
    return a;
}
var $0b2e6adb871a3b94$var$$e = $0b2e6adb871a3b94$var$Ze("animationend"), $0b2e6adb871a3b94$var$af = $0b2e6adb871a3b94$var$Ze("animationiteration"), $0b2e6adb871a3b94$var$bf = $0b2e6adb871a3b94$var$Ze("animationstart"), $0b2e6adb871a3b94$var$cf = $0b2e6adb871a3b94$var$Ze("transitionend"), $0b2e6adb871a3b94$var$df = new Map, $0b2e6adb871a3b94$var$ef = "abort auxClick cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
function $0b2e6adb871a3b94$var$ff(a, b) {
    $0b2e6adb871a3b94$var$df.set(a, b);
    $0b2e6adb871a3b94$var$fa(b, [
        a
    ]);
}
for(var $0b2e6adb871a3b94$var$gf = 0; $0b2e6adb871a3b94$var$gf < $0b2e6adb871a3b94$var$ef.length; $0b2e6adb871a3b94$var$gf++){
    var $0b2e6adb871a3b94$var$hf = $0b2e6adb871a3b94$var$ef[$0b2e6adb871a3b94$var$gf], $0b2e6adb871a3b94$var$jf = $0b2e6adb871a3b94$var$hf.toLowerCase(), $0b2e6adb871a3b94$var$kf = $0b2e6adb871a3b94$var$hf[0].toUpperCase() + $0b2e6adb871a3b94$var$hf.slice(1);
    $0b2e6adb871a3b94$var$ff($0b2e6adb871a3b94$var$jf, "on" + $0b2e6adb871a3b94$var$kf);
}
$0b2e6adb871a3b94$var$ff($0b2e6adb871a3b94$var$$e, "onAnimationEnd");
$0b2e6adb871a3b94$var$ff($0b2e6adb871a3b94$var$af, "onAnimationIteration");
$0b2e6adb871a3b94$var$ff($0b2e6adb871a3b94$var$bf, "onAnimationStart");
$0b2e6adb871a3b94$var$ff("dblclick", "onDoubleClick");
$0b2e6adb871a3b94$var$ff("focusin", "onFocus");
$0b2e6adb871a3b94$var$ff("focusout", "onBlur");
$0b2e6adb871a3b94$var$ff($0b2e6adb871a3b94$var$cf, "onTransitionEnd");
$0b2e6adb871a3b94$var$ha("onMouseEnter", [
    "mouseout",
    "mouseover"
]);
$0b2e6adb871a3b94$var$ha("onMouseLeave", [
    "mouseout",
    "mouseover"
]);
$0b2e6adb871a3b94$var$ha("onPointerEnter", [
    "pointerout",
    "pointerover"
]);
$0b2e6adb871a3b94$var$ha("onPointerLeave", [
    "pointerout",
    "pointerover"
]);
$0b2e6adb871a3b94$var$fa("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
$0b2e6adb871a3b94$var$fa("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
$0b2e6adb871a3b94$var$fa("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
]);
$0b2e6adb871a3b94$var$fa("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
$0b2e6adb871a3b94$var$fa("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
$0b2e6adb871a3b94$var$fa("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var $0b2e6adb871a3b94$var$lf = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), $0b2e6adb871a3b94$var$mf = new Set("cancel close invalid load scroll toggle".split(" ").concat($0b2e6adb871a3b94$var$lf));
function $0b2e6adb871a3b94$var$nf(a, b, c) {
    var d = a.type || "unknown-event";
    a.currentTarget = c;
    $0b2e6adb871a3b94$var$Ub(d, b, void 0, a);
    a.currentTarget = null;
}
function $0b2e6adb871a3b94$var$se(a, b) {
    b = 0 !== (b & 4);
    for(var c = 0; c < a.length; c++){
        var d = a[c], e = d.event;
        d = d.listeners;
        a: {
            var f = void 0;
            if (b) for(var g = d.length - 1; 0 <= g; g--){
                var h = d[g], k = h.instance, l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $0b2e6adb871a3b94$var$nf(e, h, l);
                f = k;
            }
            else for(g = 0; g < d.length; g++){
                h = d[g];
                k = h.instance;
                l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $0b2e6adb871a3b94$var$nf(e, h, l);
                f = k;
            }
        }
    }
    if ($0b2e6adb871a3b94$var$Qb) throw a = $0b2e6adb871a3b94$var$Rb, $0b2e6adb871a3b94$var$Qb = !1, $0b2e6adb871a3b94$var$Rb = null, a;
}
function $0b2e6adb871a3b94$var$D(a, b) {
    var c = b[$0b2e6adb871a3b94$var$of];
    void 0 === c && (c = b[$0b2e6adb871a3b94$var$of] = new Set);
    var d = a + "__bubble";
    c.has(d) || ($0b2e6adb871a3b94$var$pf(b, a, 2, !1), c.add(d));
}
function $0b2e6adb871a3b94$var$qf(a, b, c) {
    var d = 0;
    b && (d |= 4);
    $0b2e6adb871a3b94$var$pf(c, a, d, b);
}
var $0b2e6adb871a3b94$var$rf = "_reactListening" + Math.random().toString(36).slice(2);
function $0b2e6adb871a3b94$var$sf(a) {
    if (!a[$0b2e6adb871a3b94$var$rf]) {
        a[$0b2e6adb871a3b94$var$rf] = !0;
        $0b2e6adb871a3b94$var$da.forEach(function(b) {
            "selectionchange" !== b && ($0b2e6adb871a3b94$var$mf.has(b) || $0b2e6adb871a3b94$var$qf(b, !1, a), $0b2e6adb871a3b94$var$qf(b, !0, a));
        });
        var b = 9 === a.nodeType ? a : a.ownerDocument;
        null === b || b[$0b2e6adb871a3b94$var$rf] || (b[$0b2e6adb871a3b94$var$rf] = !0, $0b2e6adb871a3b94$var$qf("selectionchange", !1, b));
    }
}
function $0b2e6adb871a3b94$var$pf(a, b, c, d) {
    switch($0b2e6adb871a3b94$var$jd(b)){
        case 1:
            var e = $0b2e6adb871a3b94$var$ed;
            break;
        case 4:
            e = $0b2e6adb871a3b94$var$gd;
            break;
        default:
            e = $0b2e6adb871a3b94$var$fd;
    }
    c = e.bind(null, b, c, a);
    e = void 0;
    !$0b2e6adb871a3b94$var$Lb || "touchstart" !== b && "touchmove" !== b && "wheel" !== b || (e = !0);
    d ? void 0 !== e ? a.addEventListener(b, c, {
        capture: !0,
        passive: e
    }) : a.addEventListener(b, c, !0) : void 0 !== e ? a.addEventListener(b, c, {
        passive: e
    }) : a.addEventListener(b, c, !1);
}
function $0b2e6adb871a3b94$var$hd(a, b, c, d, e) {
    var f = d;
    if (0 === (b & 1) && 0 === (b & 2) && null !== d) a: for(;;){
        if (null === d) return;
        var g = d.tag;
        if (3 === g || 4 === g) {
            var h = d.stateNode.containerInfo;
            if (h === e || 8 === h.nodeType && h.parentNode === e) break;
            if (4 === g) for(g = d.return; null !== g;){
                var k = g.tag;
                if (3 === k || 4 === k) {
                    if (k = g.stateNode.containerInfo, k === e || 8 === k.nodeType && k.parentNode === e) return;
                }
                g = g.return;
            }
            for(; null !== h;){
                g = $0b2e6adb871a3b94$var$Wc(h);
                if (null === g) return;
                k = g.tag;
                if (5 === k || 6 === k) {
                    d = f = g;
                    continue a;
                }
                h = h.parentNode;
            }
        }
        d = d.return;
    }
    $0b2e6adb871a3b94$var$Jb(function() {
        var d = f, e = $0b2e6adb871a3b94$var$xb(c), g = [];
        a: {
            var h = $0b2e6adb871a3b94$var$df.get(a);
            if (void 0 !== h) {
                var k = $0b2e6adb871a3b94$var$td, n = a;
                switch(a){
                    case "keypress":
                        if (0 === $0b2e6adb871a3b94$var$od(c)) break a;
                    case "keydown":
                    case "keyup":
                        k = $0b2e6adb871a3b94$var$Rd;
                        break;
                    case "focusin":
                        n = "focus";
                        k = $0b2e6adb871a3b94$var$Fd;
                        break;
                    case "focusout":
                        n = "blur";
                        k = $0b2e6adb871a3b94$var$Fd;
                        break;
                    case "beforeblur":
                    case "afterblur":
                        k = $0b2e6adb871a3b94$var$Fd;
                        break;
                    case "click":
                        if (2 === c.button) break a;
                    case "auxclick":
                    case "dblclick":
                    case "mousedown":
                    case "mousemove":
                    case "mouseup":
                    case "mouseout":
                    case "mouseover":
                    case "contextmenu":
                        k = $0b2e6adb871a3b94$var$Bd;
                        break;
                    case "drag":
                    case "dragend":
                    case "dragenter":
                    case "dragexit":
                    case "dragleave":
                    case "dragover":
                    case "dragstart":
                    case "drop":
                        k = $0b2e6adb871a3b94$var$Dd;
                        break;
                    case "touchcancel":
                    case "touchend":
                    case "touchmove":
                    case "touchstart":
                        k = $0b2e6adb871a3b94$var$Vd;
                        break;
                    case $0b2e6adb871a3b94$var$$e:
                    case $0b2e6adb871a3b94$var$af:
                    case $0b2e6adb871a3b94$var$bf:
                        k = $0b2e6adb871a3b94$var$Hd;
                        break;
                    case $0b2e6adb871a3b94$var$cf:
                        k = $0b2e6adb871a3b94$var$Xd;
                        break;
                    case "scroll":
                        k = $0b2e6adb871a3b94$var$vd;
                        break;
                    case "wheel":
                        k = $0b2e6adb871a3b94$var$Zd;
                        break;
                    case "copy":
                    case "cut":
                    case "paste":
                        k = $0b2e6adb871a3b94$var$Jd;
                        break;
                    case "gotpointercapture":
                    case "lostpointercapture":
                    case "pointercancel":
                    case "pointerdown":
                    case "pointermove":
                    case "pointerout":
                    case "pointerover":
                    case "pointerup":
                        k = $0b2e6adb871a3b94$var$Td;
                }
                var t = 0 !== (b & 4), J = !t && "scroll" === a, x = t ? null !== h ? h + "Capture" : null : h;
                t = [];
                for(var w = d, u; null !== w;){
                    u = w;
                    var F = u.stateNode;
                    5 === u.tag && null !== F && (u = F, null !== x && (F = $0b2e6adb871a3b94$var$Kb(w, x), null != F && t.push($0b2e6adb871a3b94$var$tf(w, F, u))));
                    if (J) break;
                    w = w.return;
                }
                0 < t.length && (h = new k(h, n, null, c, e), g.push({
                    event: h,
                    listeners: t
                }));
            }
        }
        if (0 === (b & 7)) {
            a: {
                h = "mouseover" === a || "pointerover" === a;
                k = "mouseout" === a || "pointerout" === a;
                if (h && c !== $0b2e6adb871a3b94$var$wb && (n = c.relatedTarget || c.fromElement) && ($0b2e6adb871a3b94$var$Wc(n) || n[$0b2e6adb871a3b94$var$uf])) break a;
                if (k || h) {
                    h = e.window === e ? e : (h = e.ownerDocument) ? h.defaultView || h.parentWindow : window;
                    if (k) {
                        if (n = c.relatedTarget || c.toElement, k = d, n = n ? $0b2e6adb871a3b94$var$Wc(n) : null, null !== n && (J = $0b2e6adb871a3b94$var$Vb(n), n !== J || 5 !== n.tag && 6 !== n.tag)) n = null;
                    } else k = null, n = d;
                    if (k !== n) {
                        t = $0b2e6adb871a3b94$var$Bd;
                        F = "onMouseLeave";
                        x = "onMouseEnter";
                        w = "mouse";
                        if ("pointerout" === a || "pointerover" === a) t = $0b2e6adb871a3b94$var$Td, F = "onPointerLeave", x = "onPointerEnter", w = "pointer";
                        J = null == k ? h : $0b2e6adb871a3b94$var$ue(k);
                        u = null == n ? h : $0b2e6adb871a3b94$var$ue(n);
                        h = new t(F, w + "leave", k, c, e);
                        h.target = J;
                        h.relatedTarget = u;
                        F = null;
                        $0b2e6adb871a3b94$var$Wc(e) === d && (t = new t(x, w + "enter", n, c, e), t.target = u, t.relatedTarget = J, F = t);
                        J = F;
                        if (k && n) b: {
                            t = k;
                            x = n;
                            w = 0;
                            for(u = t; u; u = $0b2e6adb871a3b94$var$vf(u))w++;
                            u = 0;
                            for(F = x; F; F = $0b2e6adb871a3b94$var$vf(F))u++;
                            for(; 0 < w - u;)t = $0b2e6adb871a3b94$var$vf(t), w--;
                            for(; 0 < u - w;)x = $0b2e6adb871a3b94$var$vf(x), u--;
                            for(; w--;){
                                if (t === x || null !== x && t === x.alternate) break b;
                                t = $0b2e6adb871a3b94$var$vf(t);
                                x = $0b2e6adb871a3b94$var$vf(x);
                            }
                            t = null;
                        }
                        else t = null;
                        null !== k && $0b2e6adb871a3b94$var$wf(g, h, k, t, !1);
                        null !== n && null !== J && $0b2e6adb871a3b94$var$wf(g, J, n, t, !0);
                    }
                }
            }
            a: {
                h = d ? $0b2e6adb871a3b94$var$ue(d) : window;
                k = h.nodeName && h.nodeName.toLowerCase();
                if ("select" === k || "input" === k && "file" === h.type) var na = $0b2e6adb871a3b94$var$ve;
                else if ($0b2e6adb871a3b94$var$me(h)) {
                    if ($0b2e6adb871a3b94$var$we) na = $0b2e6adb871a3b94$var$Fe;
                    else {
                        na = $0b2e6adb871a3b94$var$De;
                        var xa = $0b2e6adb871a3b94$var$Ce;
                    }
                } else (k = h.nodeName) && "input" === k.toLowerCase() && ("checkbox" === h.type || "radio" === h.type) && (na = $0b2e6adb871a3b94$var$Ee);
                if (na && (na = na(a, d))) {
                    $0b2e6adb871a3b94$var$ne(g, na, c, e);
                    break a;
                }
                xa && xa(a, h, d);
                "focusout" === a && (xa = h._wrapperState) && xa.controlled && "number" === h.type && $0b2e6adb871a3b94$var$cb(h, "number", h.value);
            }
            xa = d ? $0b2e6adb871a3b94$var$ue(d) : window;
            switch(a){
                case "focusin":
                    if ($0b2e6adb871a3b94$var$me(xa) || "true" === xa.contentEditable) $0b2e6adb871a3b94$var$Qe = xa, $0b2e6adb871a3b94$var$Re = d, $0b2e6adb871a3b94$var$Se = null;
                    break;
                case "focusout":
                    $0b2e6adb871a3b94$var$Se = $0b2e6adb871a3b94$var$Re = $0b2e6adb871a3b94$var$Qe = null;
                    break;
                case "mousedown":
                    $0b2e6adb871a3b94$var$Te = !0;
                    break;
                case "contextmenu":
                case "mouseup":
                case "dragend":
                    $0b2e6adb871a3b94$var$Te = !1;
                    $0b2e6adb871a3b94$var$Ue(g, c, e);
                    break;
                case "selectionchange":
                    if ($0b2e6adb871a3b94$var$Pe) break;
                case "keydown":
                case "keyup":
                    $0b2e6adb871a3b94$var$Ue(g, c, e);
            }
            var $a;
            if ($0b2e6adb871a3b94$var$ae) b: {
                switch(a){
                    case "compositionstart":
                        var ba = "onCompositionStart";
                        break b;
                    case "compositionend":
                        ba = "onCompositionEnd";
                        break b;
                    case "compositionupdate":
                        ba = "onCompositionUpdate";
                        break b;
                }
                ba = void 0;
            }
            else $0b2e6adb871a3b94$var$ie ? $0b2e6adb871a3b94$var$ge(a, c) && (ba = "onCompositionEnd") : "keydown" === a && 229 === c.keyCode && (ba = "onCompositionStart");
            ba && ($0b2e6adb871a3b94$var$de && "ko" !== c.locale && ($0b2e6adb871a3b94$var$ie || "onCompositionStart" !== ba ? "onCompositionEnd" === ba && $0b2e6adb871a3b94$var$ie && ($a = $0b2e6adb871a3b94$var$nd()) : ($0b2e6adb871a3b94$var$kd = e, $0b2e6adb871a3b94$var$ld = "value" in $0b2e6adb871a3b94$var$kd ? $0b2e6adb871a3b94$var$kd.value : $0b2e6adb871a3b94$var$kd.textContent, $0b2e6adb871a3b94$var$ie = !0)), xa = $0b2e6adb871a3b94$var$oe(d, ba), 0 < xa.length && (ba = new $0b2e6adb871a3b94$var$Ld(ba, a, null, c, e), g.push({
                event: ba,
                listeners: xa
            }), $a ? ba.data = $a : ($a = $0b2e6adb871a3b94$var$he(c), null !== $a && (ba.data = $a))));
            if ($a = $0b2e6adb871a3b94$var$ce ? $0b2e6adb871a3b94$var$je(a, c) : $0b2e6adb871a3b94$var$ke(a, c)) d = $0b2e6adb871a3b94$var$oe(d, "onBeforeInput"), 0 < d.length && (e = new $0b2e6adb871a3b94$var$Ld("onBeforeInput", "beforeinput", null, c, e), g.push({
                event: e,
                listeners: d
            }), e.data = $a);
        }
        $0b2e6adb871a3b94$var$se(g, b);
    });
}
function $0b2e6adb871a3b94$var$tf(a, b, c) {
    return {
        instance: a,
        listener: b,
        currentTarget: c
    };
}
function $0b2e6adb871a3b94$var$oe(a, b) {
    for(var c = b + "Capture", d = []; null !== a;){
        var e = a, f = e.stateNode;
        5 === e.tag && null !== f && (e = f, f = $0b2e6adb871a3b94$var$Kb(a, c), null != f && d.unshift($0b2e6adb871a3b94$var$tf(a, f, e)), f = $0b2e6adb871a3b94$var$Kb(a, b), null != f && d.push($0b2e6adb871a3b94$var$tf(a, f, e)));
        a = a.return;
    }
    return d;
}
function $0b2e6adb871a3b94$var$vf(a) {
    if (null === a) return null;
    do a = a.return;
    while (a && 5 !== a.tag);
    return a ? a : null;
}
function $0b2e6adb871a3b94$var$wf(a, b, c, d, e) {
    for(var f = b._reactName, g = []; null !== c && c !== d;){
        var h = c, k = h.alternate, l = h.stateNode;
        if (null !== k && k === d) break;
        5 === h.tag && null !== l && (h = l, e ? (k = $0b2e6adb871a3b94$var$Kb(c, f), null != k && g.unshift($0b2e6adb871a3b94$var$tf(c, k, h))) : e || (k = $0b2e6adb871a3b94$var$Kb(c, f), null != k && g.push($0b2e6adb871a3b94$var$tf(c, k, h))));
        c = c.return;
    }
    0 !== g.length && a.push({
        event: b,
        listeners: g
    });
}
var $0b2e6adb871a3b94$var$xf = /\r\n?/g, $0b2e6adb871a3b94$var$yf = /\u0000|\uFFFD/g;
function $0b2e6adb871a3b94$var$zf(a) {
    return ("string" === typeof a ? a : "" + a).replace($0b2e6adb871a3b94$var$xf, "\n").replace($0b2e6adb871a3b94$var$yf, "");
}
function $0b2e6adb871a3b94$var$Af(a, b, c) {
    b = $0b2e6adb871a3b94$var$zf(b);
    if ($0b2e6adb871a3b94$var$zf(a) !== b && c) throw Error($0b2e6adb871a3b94$var$p(425));
}
function $0b2e6adb871a3b94$var$Bf() {}
var $0b2e6adb871a3b94$var$Cf = null, $0b2e6adb871a3b94$var$Df = null;
function $0b2e6adb871a3b94$var$Ef(a, b) {
    return "textarea" === a || "noscript" === a || "string" === typeof b.children || "number" === typeof b.children || "object" === typeof b.dangerouslySetInnerHTML && null !== b.dangerouslySetInnerHTML && null != b.dangerouslySetInnerHTML.__html;
}
var $0b2e6adb871a3b94$var$Ff = "function" === typeof setTimeout ? setTimeout : void 0, $0b2e6adb871a3b94$var$Gf = "function" === typeof clearTimeout ? clearTimeout : void 0, $0b2e6adb871a3b94$var$Hf = "function" === typeof Promise ? Promise : void 0, $0b2e6adb871a3b94$var$Jf = "function" === typeof queueMicrotask ? queueMicrotask : "undefined" !== typeof $0b2e6adb871a3b94$var$Hf ? function(a) {
    return $0b2e6adb871a3b94$var$Hf.resolve(null).then(a).catch($0b2e6adb871a3b94$var$If);
} : $0b2e6adb871a3b94$var$Ff;
function $0b2e6adb871a3b94$var$If(a) {
    setTimeout(function() {
        throw a;
    });
}
function $0b2e6adb871a3b94$var$Kf(a, b) {
    var c = b, d = 0;
    do {
        var e = c.nextSibling;
        a.removeChild(c);
        if (e && 8 === e.nodeType) {
            if (c = e.data, "/$" === c) {
                if (0 === d) {
                    a.removeChild(e);
                    $0b2e6adb871a3b94$var$bd(b);
                    return;
                }
                d--;
            } else "$" !== c && "$?" !== c && "$!" !== c || d++;
        }
        c = e;
    }while (c);
    $0b2e6adb871a3b94$var$bd(b);
}
function $0b2e6adb871a3b94$var$Lf(a) {
    for(; null != a; a = a.nextSibling){
        var b = a.nodeType;
        if (1 === b || 3 === b) break;
        if (8 === b) {
            b = a.data;
            if ("$" === b || "$!" === b || "$?" === b) break;
            if ("/$" === b) return null;
        }
    }
    return a;
}
function $0b2e6adb871a3b94$var$Mf(a) {
    a = a.previousSibling;
    for(var b = 0; a;){
        if (8 === a.nodeType) {
            var c = a.data;
            if ("$" === c || "$!" === c || "$?" === c) {
                if (0 === b) return a;
                b--;
            } else "/$" === c && b++;
        }
        a = a.previousSibling;
    }
    return null;
}
var $0b2e6adb871a3b94$var$Nf = Math.random().toString(36).slice(2), $0b2e6adb871a3b94$var$Of = "__reactFiber$" + $0b2e6adb871a3b94$var$Nf, $0b2e6adb871a3b94$var$Pf = "__reactProps$" + $0b2e6adb871a3b94$var$Nf, $0b2e6adb871a3b94$var$uf = "__reactContainer$" + $0b2e6adb871a3b94$var$Nf, $0b2e6adb871a3b94$var$of = "__reactEvents$" + $0b2e6adb871a3b94$var$Nf, $0b2e6adb871a3b94$var$Qf = "__reactListeners$" + $0b2e6adb871a3b94$var$Nf, $0b2e6adb871a3b94$var$Rf = "__reactHandles$" + $0b2e6adb871a3b94$var$Nf;
function $0b2e6adb871a3b94$var$Wc(a) {
    var b = a[$0b2e6adb871a3b94$var$Of];
    if (b) return b;
    for(var c = a.parentNode; c;){
        if (b = c[$0b2e6adb871a3b94$var$uf] || c[$0b2e6adb871a3b94$var$Of]) {
            c = b.alternate;
            if (null !== b.child || null !== c && null !== c.child) for(a = $0b2e6adb871a3b94$var$Mf(a); null !== a;){
                if (c = a[$0b2e6adb871a3b94$var$Of]) return c;
                a = $0b2e6adb871a3b94$var$Mf(a);
            }
            return b;
        }
        a = c;
        c = a.parentNode;
    }
    return null;
}
function $0b2e6adb871a3b94$var$Cb(a) {
    a = a[$0b2e6adb871a3b94$var$Of] || a[$0b2e6adb871a3b94$var$uf];
    return !a || 5 !== a.tag && 6 !== a.tag && 13 !== a.tag && 3 !== a.tag ? null : a;
}
function $0b2e6adb871a3b94$var$ue(a) {
    if (5 === a.tag || 6 === a.tag) return a.stateNode;
    throw Error($0b2e6adb871a3b94$var$p(33));
}
function $0b2e6adb871a3b94$var$Db(a) {
    return a[$0b2e6adb871a3b94$var$Pf] || null;
}
var $0b2e6adb871a3b94$var$Sf = [], $0b2e6adb871a3b94$var$Tf = -1;
function $0b2e6adb871a3b94$var$Uf(a) {
    return {
        current: a
    };
}
function $0b2e6adb871a3b94$var$E(a) {
    0 > $0b2e6adb871a3b94$var$Tf || (a.current = $0b2e6adb871a3b94$var$Sf[$0b2e6adb871a3b94$var$Tf], $0b2e6adb871a3b94$var$Sf[$0b2e6adb871a3b94$var$Tf] = null, $0b2e6adb871a3b94$var$Tf--);
}
function $0b2e6adb871a3b94$var$G(a, b) {
    $0b2e6adb871a3b94$var$Tf++;
    $0b2e6adb871a3b94$var$Sf[$0b2e6adb871a3b94$var$Tf] = a.current;
    a.current = b;
}
var $0b2e6adb871a3b94$var$Vf = {}, $0b2e6adb871a3b94$var$H = $0b2e6adb871a3b94$var$Uf($0b2e6adb871a3b94$var$Vf), $0b2e6adb871a3b94$var$Wf = $0b2e6adb871a3b94$var$Uf(!1), $0b2e6adb871a3b94$var$Xf = $0b2e6adb871a3b94$var$Vf;
function $0b2e6adb871a3b94$var$Yf(a, b) {
    var c = a.type.contextTypes;
    if (!c) return $0b2e6adb871a3b94$var$Vf;
    var d = a.stateNode;
    if (d && d.__reactInternalMemoizedUnmaskedChildContext === b) return d.__reactInternalMemoizedMaskedChildContext;
    var e = {}, f;
    for(f in c)e[f] = b[f];
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = b, a.__reactInternalMemoizedMaskedChildContext = e);
    return e;
}
function $0b2e6adb871a3b94$var$Zf(a) {
    a = a.childContextTypes;
    return null !== a && void 0 !== a;
}
function $0b2e6adb871a3b94$var$$f() {
    $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Wf);
    $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$H);
}
function $0b2e6adb871a3b94$var$ag(a, b, c) {
    if ($0b2e6adb871a3b94$var$H.current !== $0b2e6adb871a3b94$var$Vf) throw Error($0b2e6adb871a3b94$var$p(168));
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$H, b);
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$Wf, c);
}
function $0b2e6adb871a3b94$var$bg(a, b, c) {
    var d = a.stateNode;
    b = b.childContextTypes;
    if ("function" !== typeof d.getChildContext) return c;
    d = d.getChildContext();
    for(var e in d)if (!(e in b)) throw Error($0b2e6adb871a3b94$var$p(108, $0b2e6adb871a3b94$var$Ra(a) || "Unknown", e));
    return $0b2e6adb871a3b94$var$A({}, c, d);
}
function $0b2e6adb871a3b94$var$cg(a) {
    a = (a = a.stateNode) && a.__reactInternalMemoizedMergedChildContext || $0b2e6adb871a3b94$var$Vf;
    $0b2e6adb871a3b94$var$Xf = $0b2e6adb871a3b94$var$H.current;
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$H, a);
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$Wf, $0b2e6adb871a3b94$var$Wf.current);
    return !0;
}
function $0b2e6adb871a3b94$var$dg(a, b, c) {
    var d = a.stateNode;
    if (!d) throw Error($0b2e6adb871a3b94$var$p(169));
    c ? (a = $0b2e6adb871a3b94$var$bg(a, b, $0b2e6adb871a3b94$var$Xf), d.__reactInternalMemoizedMergedChildContext = a, $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Wf), $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$H), $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$H, a)) : $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Wf);
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$Wf, c);
}
var $0b2e6adb871a3b94$var$eg = null, $0b2e6adb871a3b94$var$fg = !1, $0b2e6adb871a3b94$var$gg = !1;
function $0b2e6adb871a3b94$var$hg(a) {
    null === $0b2e6adb871a3b94$var$eg ? $0b2e6adb871a3b94$var$eg = [
        a
    ] : $0b2e6adb871a3b94$var$eg.push(a);
}
function $0b2e6adb871a3b94$var$ig(a) {
    $0b2e6adb871a3b94$var$fg = !0;
    $0b2e6adb871a3b94$var$hg(a);
}
function $0b2e6adb871a3b94$var$jg() {
    if (!$0b2e6adb871a3b94$var$gg && null !== $0b2e6adb871a3b94$var$eg) {
        $0b2e6adb871a3b94$var$gg = !0;
        var a = 0, b = $0b2e6adb871a3b94$var$C;
        try {
            var c = $0b2e6adb871a3b94$var$eg;
            for($0b2e6adb871a3b94$var$C = 1; a < c.length; a++){
                var d = c[a];
                do d = d(!0);
                while (null !== d);
            }
            $0b2e6adb871a3b94$var$eg = null;
            $0b2e6adb871a3b94$var$fg = !1;
        } catch (e) {
            throw null !== $0b2e6adb871a3b94$var$eg && ($0b2e6adb871a3b94$var$eg = $0b2e6adb871a3b94$var$eg.slice(a + 1)), $0b2e6adb871a3b94$var$ac($0b2e6adb871a3b94$var$fc, $0b2e6adb871a3b94$var$jg), e;
        } finally{
            $0b2e6adb871a3b94$var$C = b, $0b2e6adb871a3b94$var$gg = !1;
        }
    }
    return null;
}
var $0b2e6adb871a3b94$var$kg = [], $0b2e6adb871a3b94$var$lg = 0, $0b2e6adb871a3b94$var$mg = null, $0b2e6adb871a3b94$var$ng = 0, $0b2e6adb871a3b94$var$og = [], $0b2e6adb871a3b94$var$pg = 0, $0b2e6adb871a3b94$var$qg = null, $0b2e6adb871a3b94$var$rg = 1, $0b2e6adb871a3b94$var$sg = "";
function $0b2e6adb871a3b94$var$tg(a, b) {
    $0b2e6adb871a3b94$var$kg[$0b2e6adb871a3b94$var$lg++] = $0b2e6adb871a3b94$var$ng;
    $0b2e6adb871a3b94$var$kg[$0b2e6adb871a3b94$var$lg++] = $0b2e6adb871a3b94$var$mg;
    $0b2e6adb871a3b94$var$mg = a;
    $0b2e6adb871a3b94$var$ng = b;
}
function $0b2e6adb871a3b94$var$ug(a, b, c) {
    $0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg++] = $0b2e6adb871a3b94$var$rg;
    $0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg++] = $0b2e6adb871a3b94$var$sg;
    $0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg++] = $0b2e6adb871a3b94$var$qg;
    $0b2e6adb871a3b94$var$qg = a;
    var d = $0b2e6adb871a3b94$var$rg;
    a = $0b2e6adb871a3b94$var$sg;
    var e = 32 - $0b2e6adb871a3b94$var$oc(d) - 1;
    d &= ~(1 << e);
    c += 1;
    var f = 32 - $0b2e6adb871a3b94$var$oc(b) + e;
    if (30 < f) {
        var g = e - e % 5;
        f = (d & (1 << g) - 1).toString(32);
        d >>= g;
        e -= g;
        $0b2e6adb871a3b94$var$rg = 1 << 32 - $0b2e6adb871a3b94$var$oc(b) + e | c << e | d;
        $0b2e6adb871a3b94$var$sg = f + a;
    } else $0b2e6adb871a3b94$var$rg = 1 << f | c << e | d, $0b2e6adb871a3b94$var$sg = a;
}
function $0b2e6adb871a3b94$var$vg(a) {
    null !== a.return && ($0b2e6adb871a3b94$var$tg(a, 1), $0b2e6adb871a3b94$var$ug(a, 1, 0));
}
function $0b2e6adb871a3b94$var$wg(a) {
    for(; a === $0b2e6adb871a3b94$var$mg;)$0b2e6adb871a3b94$var$mg = $0b2e6adb871a3b94$var$kg[--$0b2e6adb871a3b94$var$lg], $0b2e6adb871a3b94$var$kg[$0b2e6adb871a3b94$var$lg] = null, $0b2e6adb871a3b94$var$ng = $0b2e6adb871a3b94$var$kg[--$0b2e6adb871a3b94$var$lg], $0b2e6adb871a3b94$var$kg[$0b2e6adb871a3b94$var$lg] = null;
    for(; a === $0b2e6adb871a3b94$var$qg;)$0b2e6adb871a3b94$var$qg = $0b2e6adb871a3b94$var$og[--$0b2e6adb871a3b94$var$pg], $0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg] = null, $0b2e6adb871a3b94$var$sg = $0b2e6adb871a3b94$var$og[--$0b2e6adb871a3b94$var$pg], $0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg] = null, $0b2e6adb871a3b94$var$rg = $0b2e6adb871a3b94$var$og[--$0b2e6adb871a3b94$var$pg], $0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg] = null;
}
var $0b2e6adb871a3b94$var$xg = null, $0b2e6adb871a3b94$var$yg = null, $0b2e6adb871a3b94$var$I = !1, $0b2e6adb871a3b94$var$zg = null;
function $0b2e6adb871a3b94$var$Ag(a, b) {
    var c = $0b2e6adb871a3b94$var$Bg(5, null, null, 0);
    c.elementType = "DELETED";
    c.stateNode = b;
    c.return = a;
    b = a.deletions;
    null === b ? (a.deletions = [
        c
    ], a.flags |= 16) : b.push(c);
}
function $0b2e6adb871a3b94$var$Cg(a, b) {
    switch(a.tag){
        case 5:
            var c = a.type;
            b = 1 !== b.nodeType || c.toLowerCase() !== b.nodeName.toLowerCase() ? null : b;
            return null !== b ? (a.stateNode = b, $0b2e6adb871a3b94$var$xg = a, $0b2e6adb871a3b94$var$yg = $0b2e6adb871a3b94$var$Lf(b.firstChild), !0) : !1;
        case 6:
            return b = "" === a.pendingProps || 3 !== b.nodeType ? null : b, null !== b ? (a.stateNode = b, $0b2e6adb871a3b94$var$xg = a, $0b2e6adb871a3b94$var$yg = null, !0) : !1;
        case 13:
            return b = 8 !== b.nodeType ? null : b, null !== b ? (c = null !== $0b2e6adb871a3b94$var$qg ? {
                id: $0b2e6adb871a3b94$var$rg,
                overflow: $0b2e6adb871a3b94$var$sg
            } : null, a.memoizedState = {
                dehydrated: b,
                treeContext: c,
                retryLane: 1073741824
            }, c = $0b2e6adb871a3b94$var$Bg(18, null, null, 0), c.stateNode = b, c.return = a, a.child = c, $0b2e6adb871a3b94$var$xg = a, $0b2e6adb871a3b94$var$yg = null, !0) : !1;
        default:
            return !1;
    }
}
function $0b2e6adb871a3b94$var$Dg(a) {
    return 0 !== (a.mode & 1) && 0 === (a.flags & 128);
}
function $0b2e6adb871a3b94$var$Eg(a) {
    if ($0b2e6adb871a3b94$var$I) {
        var b = $0b2e6adb871a3b94$var$yg;
        if (b) {
            var c = b;
            if (!$0b2e6adb871a3b94$var$Cg(a, b)) {
                if ($0b2e6adb871a3b94$var$Dg(a)) throw Error($0b2e6adb871a3b94$var$p(418));
                b = $0b2e6adb871a3b94$var$Lf(c.nextSibling);
                var d = $0b2e6adb871a3b94$var$xg;
                b && $0b2e6adb871a3b94$var$Cg(a, b) ? $0b2e6adb871a3b94$var$Ag(d, c) : (a.flags = a.flags & -4097 | 2, $0b2e6adb871a3b94$var$I = !1, $0b2e6adb871a3b94$var$xg = a);
            }
        } else {
            if ($0b2e6adb871a3b94$var$Dg(a)) throw Error($0b2e6adb871a3b94$var$p(418));
            a.flags = a.flags & -4097 | 2;
            $0b2e6adb871a3b94$var$I = !1;
            $0b2e6adb871a3b94$var$xg = a;
        }
    }
}
function $0b2e6adb871a3b94$var$Fg(a) {
    for(a = a.return; null !== a && 5 !== a.tag && 3 !== a.tag && 13 !== a.tag;)a = a.return;
    $0b2e6adb871a3b94$var$xg = a;
}
function $0b2e6adb871a3b94$var$Gg(a) {
    if (a !== $0b2e6adb871a3b94$var$xg) return !1;
    if (!$0b2e6adb871a3b94$var$I) return $0b2e6adb871a3b94$var$Fg(a), $0b2e6adb871a3b94$var$I = !0, !1;
    var b;
    (b = 3 !== a.tag) && !(b = 5 !== a.tag) && (b = a.type, b = "head" !== b && "body" !== b && !$0b2e6adb871a3b94$var$Ef(a.type, a.memoizedProps));
    if (b && (b = $0b2e6adb871a3b94$var$yg)) {
        if ($0b2e6adb871a3b94$var$Dg(a)) throw $0b2e6adb871a3b94$var$Hg(), Error($0b2e6adb871a3b94$var$p(418));
        for(; b;)$0b2e6adb871a3b94$var$Ag(a, b), b = $0b2e6adb871a3b94$var$Lf(b.nextSibling);
    }
    $0b2e6adb871a3b94$var$Fg(a);
    if (13 === a.tag) {
        a = a.memoizedState;
        a = null !== a ? a.dehydrated : null;
        if (!a) throw Error($0b2e6adb871a3b94$var$p(317));
        a: {
            a = a.nextSibling;
            for(b = 0; a;){
                if (8 === a.nodeType) {
                    var c = a.data;
                    if ("/$" === c) {
                        if (0 === b) {
                            $0b2e6adb871a3b94$var$yg = $0b2e6adb871a3b94$var$Lf(a.nextSibling);
                            break a;
                        }
                        b--;
                    } else "$" !== c && "$!" !== c && "$?" !== c || b++;
                }
                a = a.nextSibling;
            }
            $0b2e6adb871a3b94$var$yg = null;
        }
    } else $0b2e6adb871a3b94$var$yg = $0b2e6adb871a3b94$var$xg ? $0b2e6adb871a3b94$var$Lf(a.stateNode.nextSibling) : null;
    return !0;
}
function $0b2e6adb871a3b94$var$Hg() {
    for(var a = $0b2e6adb871a3b94$var$yg; a;)a = $0b2e6adb871a3b94$var$Lf(a.nextSibling);
}
function $0b2e6adb871a3b94$var$Ig() {
    $0b2e6adb871a3b94$var$yg = $0b2e6adb871a3b94$var$xg = null;
    $0b2e6adb871a3b94$var$I = !1;
}
function $0b2e6adb871a3b94$var$Jg(a) {
    null === $0b2e6adb871a3b94$var$zg ? $0b2e6adb871a3b94$var$zg = [
        a
    ] : $0b2e6adb871a3b94$var$zg.push(a);
}
var $0b2e6adb871a3b94$var$Kg = $0b2e6adb871a3b94$var$ua.ReactCurrentBatchConfig;
function $0b2e6adb871a3b94$var$Lg(a, b, c) {
    a = c.ref;
    if (null !== a && "function" !== typeof a && "object" !== typeof a) {
        if (c._owner) {
            c = c._owner;
            if (c) {
                if (1 !== c.tag) throw Error($0b2e6adb871a3b94$var$p(309));
                var d = c.stateNode;
            }
            if (!d) throw Error($0b2e6adb871a3b94$var$p(147, a));
            var e = d, f = "" + a;
            if (null !== b && null !== b.ref && "function" === typeof b.ref && b.ref._stringRef === f) return b.ref;
            b = function(a) {
                var b = e.refs;
                null === a ? delete b[f] : b[f] = a;
            };
            b._stringRef = f;
            return b;
        }
        if ("string" !== typeof a) throw Error($0b2e6adb871a3b94$var$p(284));
        if (!c._owner) throw Error($0b2e6adb871a3b94$var$p(290, a));
    }
    return a;
}
function $0b2e6adb871a3b94$var$Mg(a, b) {
    a = Object.prototype.toString.call(b);
    throw Error($0b2e6adb871a3b94$var$p(31, "[object Object]" === a ? "object with keys {" + Object.keys(b).join(", ") + "}" : a));
}
function $0b2e6adb871a3b94$var$Ng(a) {
    var b = a._init;
    return b(a._payload);
}
function $0b2e6adb871a3b94$var$Og(a) {
    function b(b, c) {
        if (a) {
            var d = b.deletions;
            null === d ? (b.deletions = [
                c
            ], b.flags |= 16) : d.push(c);
        }
    }
    function c(c, d) {
        if (!a) return null;
        for(; null !== d;)b(c, d), d = d.sibling;
        return null;
    }
    function d(a, b) {
        for(a = new Map; null !== b;)null !== b.key ? a.set(b.key, b) : a.set(b.index, b), b = b.sibling;
        return a;
    }
    function e(a, b) {
        a = $0b2e6adb871a3b94$var$Pg(a, b);
        a.index = 0;
        a.sibling = null;
        return a;
    }
    function f(b, c, d) {
        b.index = d;
        if (!a) return b.flags |= 1048576, c;
        d = b.alternate;
        if (null !== d) return d = d.index, d < c ? (b.flags |= 2, c) : d;
        b.flags |= 2;
        return c;
    }
    function g(b) {
        a && null === b.alternate && (b.flags |= 2);
        return b;
    }
    function h(a, b, c, d) {
        if (null === b || 6 !== b.tag) return b = $0b2e6adb871a3b94$var$Qg(c, a.mode, d), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function k(a, b, c, d) {
        var f = c.type;
        if (f === $0b2e6adb871a3b94$var$ya) return m(a, b, c.props.children, d, c.key);
        if (null !== b && (b.elementType === f || "object" === typeof f && null !== f && f.$$typeof === $0b2e6adb871a3b94$var$Ha && $0b2e6adb871a3b94$var$Ng(f) === b.type)) return d = e(b, c.props), d.ref = $0b2e6adb871a3b94$var$Lg(a, b, c), d.return = a, d;
        d = $0b2e6adb871a3b94$var$Rg(c.type, c.key, c.props, null, a.mode, d);
        d.ref = $0b2e6adb871a3b94$var$Lg(a, b, c);
        d.return = a;
        return d;
    }
    function l(a, b, c, d) {
        if (null === b || 4 !== b.tag || b.stateNode.containerInfo !== c.containerInfo || b.stateNode.implementation !== c.implementation) return b = $0b2e6adb871a3b94$var$Sg(c, a.mode, d), b.return = a, b;
        b = e(b, c.children || []);
        b.return = a;
        return b;
    }
    function m(a, b, c, d, f) {
        if (null === b || 7 !== b.tag) return b = $0b2e6adb871a3b94$var$Tg(c, a.mode, d, f), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function q(a, b, c) {
        if ("string" === typeof b && "" !== b || "number" === typeof b) return b = $0b2e6adb871a3b94$var$Qg("" + b, a.mode, c), b.return = a, b;
        if ("object" === typeof b && null !== b) {
            switch(b.$$typeof){
                case $0b2e6adb871a3b94$var$va:
                    return c = $0b2e6adb871a3b94$var$Rg(b.type, b.key, b.props, null, a.mode, c), c.ref = $0b2e6adb871a3b94$var$Lg(a, null, b), c.return = a, c;
                case $0b2e6adb871a3b94$var$wa:
                    return b = $0b2e6adb871a3b94$var$Sg(b, a.mode, c), b.return = a, b;
                case $0b2e6adb871a3b94$var$Ha:
                    var d = b._init;
                    return q(a, d(b._payload), c);
            }
            if ($0b2e6adb871a3b94$var$eb(b) || $0b2e6adb871a3b94$var$Ka(b)) return b = $0b2e6adb871a3b94$var$Tg(b, a.mode, c, null), b.return = a, b;
            $0b2e6adb871a3b94$var$Mg(a, b);
        }
        return null;
    }
    function r(a, b, c, d) {
        var e = null !== b ? b.key : null;
        if ("string" === typeof c && "" !== c || "number" === typeof c) return null !== e ? null : h(a, b, "" + c, d);
        if ("object" === typeof c && null !== c) {
            switch(c.$$typeof){
                case $0b2e6adb871a3b94$var$va:
                    return c.key === e ? k(a, b, c, d) : null;
                case $0b2e6adb871a3b94$var$wa:
                    return c.key === e ? l(a, b, c, d) : null;
                case $0b2e6adb871a3b94$var$Ha:
                    return e = c._init, r(a, b, e(c._payload), d);
            }
            if ($0b2e6adb871a3b94$var$eb(c) || $0b2e6adb871a3b94$var$Ka(c)) return null !== e ? null : m(a, b, c, d, null);
            $0b2e6adb871a3b94$var$Mg(a, c);
        }
        return null;
    }
    function y(a, b, c, d, e) {
        if ("string" === typeof d && "" !== d || "number" === typeof d) return a = a.get(c) || null, h(b, a, "" + d, e);
        if ("object" === typeof d && null !== d) {
            switch(d.$$typeof){
                case $0b2e6adb871a3b94$var$va:
                    return a = a.get(null === d.key ? c : d.key) || null, k(b, a, d, e);
                case $0b2e6adb871a3b94$var$wa:
                    return a = a.get(null === d.key ? c : d.key) || null, l(b, a, d, e);
                case $0b2e6adb871a3b94$var$Ha:
                    var f = d._init;
                    return y(a, b, c, f(d._payload), e);
            }
            if ($0b2e6adb871a3b94$var$eb(d) || $0b2e6adb871a3b94$var$Ka(d)) return a = a.get(c) || null, m(b, a, d, e, null);
            $0b2e6adb871a3b94$var$Mg(b, d);
        }
        return null;
    }
    function n(e, g, h, k) {
        for(var l = null, m = null, u = g, w = g = 0, x = null; null !== u && w < h.length; w++){
            u.index > w ? (x = u, u = null) : x = u.sibling;
            var n = r(e, u, h[w], k);
            if (null === n) {
                null === u && (u = x);
                break;
            }
            a && u && null === n.alternate && b(e, u);
            g = f(n, g, w);
            null === m ? l = n : m.sibling = n;
            m = n;
            u = x;
        }
        if (w === h.length) return c(e, u), $0b2e6adb871a3b94$var$I && $0b2e6adb871a3b94$var$tg(e, w), l;
        if (null === u) {
            for(; w < h.length; w++)u = q(e, h[w], k), null !== u && (g = f(u, g, w), null === m ? l = u : m.sibling = u, m = u);
            $0b2e6adb871a3b94$var$I && $0b2e6adb871a3b94$var$tg(e, w);
            return l;
        }
        for(u = d(e, u); w < h.length; w++)x = y(u, e, w, h[w], k), null !== x && (a && null !== x.alternate && u.delete(null === x.key ? w : x.key), g = f(x, g, w), null === m ? l = x : m.sibling = x, m = x);
        a && u.forEach(function(a) {
            return b(e, a);
        });
        $0b2e6adb871a3b94$var$I && $0b2e6adb871a3b94$var$tg(e, w);
        return l;
    }
    function t(e, g, h, k) {
        var l = $0b2e6adb871a3b94$var$Ka(h);
        if ("function" !== typeof l) throw Error($0b2e6adb871a3b94$var$p(150));
        h = l.call(h);
        if (null == h) throw Error($0b2e6adb871a3b94$var$p(151));
        for(var u = l = null, m = g, w = g = 0, x = null, n = h.next(); null !== m && !n.done; w++, n = h.next()){
            m.index > w ? (x = m, m = null) : x = m.sibling;
            var t = r(e, m, n.value, k);
            if (null === t) {
                null === m && (m = x);
                break;
            }
            a && m && null === t.alternate && b(e, m);
            g = f(t, g, w);
            null === u ? l = t : u.sibling = t;
            u = t;
            m = x;
        }
        if (n.done) return c(e, m), $0b2e6adb871a3b94$var$I && $0b2e6adb871a3b94$var$tg(e, w), l;
        if (null === m) {
            for(; !n.done; w++, n = h.next())n = q(e, n.value, k), null !== n && (g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
            $0b2e6adb871a3b94$var$I && $0b2e6adb871a3b94$var$tg(e, w);
            return l;
        }
        for(m = d(e, m); !n.done; w++, n = h.next())n = y(m, e, w, n.value, k), null !== n && (a && null !== n.alternate && m.delete(null === n.key ? w : n.key), g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
        a && m.forEach(function(a) {
            return b(e, a);
        });
        $0b2e6adb871a3b94$var$I && $0b2e6adb871a3b94$var$tg(e, w);
        return l;
    }
    function J(a, d, f, h) {
        "object" === typeof f && null !== f && f.type === $0b2e6adb871a3b94$var$ya && null === f.key && (f = f.props.children);
        if ("object" === typeof f && null !== f) {
            switch(f.$$typeof){
                case $0b2e6adb871a3b94$var$va:
                    a: {
                        for(var k = f.key, l = d; null !== l;){
                            if (l.key === k) {
                                k = f.type;
                                if (k === $0b2e6adb871a3b94$var$ya) {
                                    if (7 === l.tag) {
                                        c(a, l.sibling);
                                        d = e(l, f.props.children);
                                        d.return = a;
                                        a = d;
                                        break a;
                                    }
                                } else if (l.elementType === k || "object" === typeof k && null !== k && k.$$typeof === $0b2e6adb871a3b94$var$Ha && $0b2e6adb871a3b94$var$Ng(k) === l.type) {
                                    c(a, l.sibling);
                                    d = e(l, f.props);
                                    d.ref = $0b2e6adb871a3b94$var$Lg(a, l, f);
                                    d.return = a;
                                    a = d;
                                    break a;
                                }
                                c(a, l);
                                break;
                            } else b(a, l);
                            l = l.sibling;
                        }
                        f.type === $0b2e6adb871a3b94$var$ya ? (d = $0b2e6adb871a3b94$var$Tg(f.props.children, a.mode, h, f.key), d.return = a, a = d) : (h = $0b2e6adb871a3b94$var$Rg(f.type, f.key, f.props, null, a.mode, h), h.ref = $0b2e6adb871a3b94$var$Lg(a, d, f), h.return = a, a = h);
                    }
                    return g(a);
                case $0b2e6adb871a3b94$var$wa:
                    a: {
                        for(l = f.key; null !== d;){
                            if (d.key === l) {
                                if (4 === d.tag && d.stateNode.containerInfo === f.containerInfo && d.stateNode.implementation === f.implementation) {
                                    c(a, d.sibling);
                                    d = e(d, f.children || []);
                                    d.return = a;
                                    a = d;
                                    break a;
                                } else {
                                    c(a, d);
                                    break;
                                }
                            } else b(a, d);
                            d = d.sibling;
                        }
                        d = $0b2e6adb871a3b94$var$Sg(f, a.mode, h);
                        d.return = a;
                        a = d;
                    }
                    return g(a);
                case $0b2e6adb871a3b94$var$Ha:
                    return l = f._init, J(a, d, l(f._payload), h);
            }
            if ($0b2e6adb871a3b94$var$eb(f)) return n(a, d, f, h);
            if ($0b2e6adb871a3b94$var$Ka(f)) return t(a, d, f, h);
            $0b2e6adb871a3b94$var$Mg(a, f);
        }
        return "string" === typeof f && "" !== f || "number" === typeof f ? (f = "" + f, null !== d && 6 === d.tag ? (c(a, d.sibling), d = e(d, f), d.return = a, a = d) : (c(a, d), d = $0b2e6adb871a3b94$var$Qg(f, a.mode, h), d.return = a, a = d), g(a)) : c(a, d);
    }
    return J;
}
var $0b2e6adb871a3b94$var$Ug = $0b2e6adb871a3b94$var$Og(!0), $0b2e6adb871a3b94$var$Vg = $0b2e6adb871a3b94$var$Og(!1), $0b2e6adb871a3b94$var$Wg = $0b2e6adb871a3b94$var$Uf(null), $0b2e6adb871a3b94$var$Xg = null, $0b2e6adb871a3b94$var$Yg = null, $0b2e6adb871a3b94$var$Zg = null;
function $0b2e6adb871a3b94$var$$g() {
    $0b2e6adb871a3b94$var$Zg = $0b2e6adb871a3b94$var$Yg = $0b2e6adb871a3b94$var$Xg = null;
}
function $0b2e6adb871a3b94$var$ah(a) {
    var b = $0b2e6adb871a3b94$var$Wg.current;
    $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Wg);
    a._currentValue = b;
}
function $0b2e6adb871a3b94$var$bh(a, b, c) {
    for(; null !== a;){
        var d = a.alternate;
        (a.childLanes & b) !== b ? (a.childLanes |= b, null !== d && (d.childLanes |= b)) : null !== d && (d.childLanes & b) !== b && (d.childLanes |= b);
        if (a === c) break;
        a = a.return;
    }
}
function $0b2e6adb871a3b94$var$ch(a, b) {
    $0b2e6adb871a3b94$var$Xg = a;
    $0b2e6adb871a3b94$var$Zg = $0b2e6adb871a3b94$var$Yg = null;
    a = a.dependencies;
    null !== a && null !== a.firstContext && (0 !== (a.lanes & b) && ($0b2e6adb871a3b94$var$dh = !0), a.firstContext = null);
}
function $0b2e6adb871a3b94$var$eh(a) {
    var b = a._currentValue;
    if ($0b2e6adb871a3b94$var$Zg !== a) {
        if (a = {
            context: a,
            memoizedValue: b,
            next: null
        }, null === $0b2e6adb871a3b94$var$Yg) {
            if (null === $0b2e6adb871a3b94$var$Xg) throw Error($0b2e6adb871a3b94$var$p(308));
            $0b2e6adb871a3b94$var$Yg = a;
            $0b2e6adb871a3b94$var$Xg.dependencies = {
                lanes: 0,
                firstContext: a
            };
        } else $0b2e6adb871a3b94$var$Yg = $0b2e6adb871a3b94$var$Yg.next = a;
    }
    return b;
}
var $0b2e6adb871a3b94$var$fh = null;
function $0b2e6adb871a3b94$var$gh(a) {
    null === $0b2e6adb871a3b94$var$fh ? $0b2e6adb871a3b94$var$fh = [
        a
    ] : $0b2e6adb871a3b94$var$fh.push(a);
}
function $0b2e6adb871a3b94$var$hh(a, b, c, d) {
    var e = b.interleaved;
    null === e ? (c.next = c, $0b2e6adb871a3b94$var$gh(b)) : (c.next = e.next, e.next = c);
    b.interleaved = c;
    return $0b2e6adb871a3b94$var$ih(a, d);
}
function $0b2e6adb871a3b94$var$ih(a, b) {
    a.lanes |= b;
    var c = a.alternate;
    null !== c && (c.lanes |= b);
    c = a;
    for(a = a.return; null !== a;)a.childLanes |= b, c = a.alternate, null !== c && (c.childLanes |= b), c = a, a = a.return;
    return 3 === c.tag ? c.stateNode : null;
}
var $0b2e6adb871a3b94$var$jh = !1;
function $0b2e6adb871a3b94$var$kh(a) {
    a.updateQueue = {
        baseState: a.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
            pending: null,
            interleaved: null,
            lanes: 0
        },
        effects: null
    };
}
function $0b2e6adb871a3b94$var$lh(a, b) {
    a = a.updateQueue;
    b.updateQueue === a && (b.updateQueue = {
        baseState: a.baseState,
        firstBaseUpdate: a.firstBaseUpdate,
        lastBaseUpdate: a.lastBaseUpdate,
        shared: a.shared,
        effects: a.effects
    });
}
function $0b2e6adb871a3b94$var$mh(a, b) {
    return {
        eventTime: a,
        lane: b,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
}
function $0b2e6adb871a3b94$var$nh(a, b, c) {
    var d = a.updateQueue;
    if (null === d) return null;
    d = d.shared;
    if (0 !== ($0b2e6adb871a3b94$var$K & 2)) {
        var e = d.pending;
        null === e ? b.next = b : (b.next = e.next, e.next = b);
        d.pending = b;
        return $0b2e6adb871a3b94$var$ih(a, c);
    }
    e = d.interleaved;
    null === e ? (b.next = b, $0b2e6adb871a3b94$var$gh(d)) : (b.next = e.next, e.next = b);
    d.interleaved = b;
    return $0b2e6adb871a3b94$var$ih(a, c);
}
function $0b2e6adb871a3b94$var$oh(a, b, c) {
    b = b.updateQueue;
    if (null !== b && (b = b.shared, 0 !== (c & 4194240))) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $0b2e6adb871a3b94$var$Cc(a, c);
    }
}
function $0b2e6adb871a3b94$var$ph(a, b) {
    var c = a.updateQueue, d = a.alternate;
    if (null !== d && (d = d.updateQueue, c === d)) {
        var e = null, f = null;
        c = c.firstBaseUpdate;
        if (null !== c) {
            do {
                var g = {
                    eventTime: c.eventTime,
                    lane: c.lane,
                    tag: c.tag,
                    payload: c.payload,
                    callback: c.callback,
                    next: null
                };
                null === f ? e = f = g : f = f.next = g;
                c = c.next;
            }while (null !== c);
            null === f ? e = f = b : f = f.next = b;
        } else e = f = b;
        c = {
            baseState: d.baseState,
            firstBaseUpdate: e,
            lastBaseUpdate: f,
            shared: d.shared,
            effects: d.effects
        };
        a.updateQueue = c;
        return;
    }
    a = c.lastBaseUpdate;
    null === a ? c.firstBaseUpdate = b : a.next = b;
    c.lastBaseUpdate = b;
}
function $0b2e6adb871a3b94$var$qh(a, b, c, d) {
    var e = a.updateQueue;
    $0b2e6adb871a3b94$var$jh = !1;
    var f = e.firstBaseUpdate, g = e.lastBaseUpdate, h = e.shared.pending;
    if (null !== h) {
        e.shared.pending = null;
        var k = h, l = k.next;
        k.next = null;
        null === g ? f = l : g.next = l;
        g = k;
        var m = a.alternate;
        null !== m && (m = m.updateQueue, h = m.lastBaseUpdate, h !== g && (null === h ? m.firstBaseUpdate = l : h.next = l, m.lastBaseUpdate = k));
    }
    if (null !== f) {
        var q = e.baseState;
        g = 0;
        m = l = k = null;
        h = f;
        do {
            var r = h.lane, y = h.eventTime;
            if ((d & r) === r) {
                null !== m && (m = m.next = {
                    eventTime: y,
                    lane: 0,
                    tag: h.tag,
                    payload: h.payload,
                    callback: h.callback,
                    next: null
                });
                a: {
                    var n = a, t = h;
                    r = b;
                    y = c;
                    switch(t.tag){
                        case 1:
                            n = t.payload;
                            if ("function" === typeof n) {
                                q = n.call(y, q, r);
                                break a;
                            }
                            q = n;
                            break a;
                        case 3:
                            n.flags = n.flags & -65537 | 128;
                        case 0:
                            n = t.payload;
                            r = "function" === typeof n ? n.call(y, q, r) : n;
                            if (null === r || void 0 === r) break a;
                            q = $0b2e6adb871a3b94$var$A({}, q, r);
                            break a;
                        case 2:
                            $0b2e6adb871a3b94$var$jh = !0;
                    }
                }
                null !== h.callback && 0 !== h.lane && (a.flags |= 64, r = e.effects, null === r ? e.effects = [
                    h
                ] : r.push(h));
            } else y = {
                eventTime: y,
                lane: r,
                tag: h.tag,
                payload: h.payload,
                callback: h.callback,
                next: null
            }, null === m ? (l = m = y, k = q) : m = m.next = y, g |= r;
            h = h.next;
            if (null === h) {
                if (h = e.shared.pending, null === h) break;
                else r = h, h = r.next, r.next = null, e.lastBaseUpdate = r, e.shared.pending = null;
            }
        }while (1);
        null === m && (k = q);
        e.baseState = k;
        e.firstBaseUpdate = l;
        e.lastBaseUpdate = m;
        b = e.shared.interleaved;
        if (null !== b) {
            e = b;
            do g |= e.lane, e = e.next;
            while (e !== b);
        } else null === f && (e.shared.lanes = 0);
        $0b2e6adb871a3b94$var$rh |= g;
        a.lanes = g;
        a.memoizedState = q;
    }
}
function $0b2e6adb871a3b94$var$sh(a, b, c) {
    a = b.effects;
    b.effects = null;
    if (null !== a) for(b = 0; b < a.length; b++){
        var d = a[b], e = d.callback;
        if (null !== e) {
            d.callback = null;
            d = c;
            if ("function" !== typeof e) throw Error($0b2e6adb871a3b94$var$p(191, e));
            e.call(d);
        }
    }
}
var $0b2e6adb871a3b94$var$th = {}, $0b2e6adb871a3b94$var$uh = $0b2e6adb871a3b94$var$Uf($0b2e6adb871a3b94$var$th), $0b2e6adb871a3b94$var$vh = $0b2e6adb871a3b94$var$Uf($0b2e6adb871a3b94$var$th), $0b2e6adb871a3b94$var$wh = $0b2e6adb871a3b94$var$Uf($0b2e6adb871a3b94$var$th);
function $0b2e6adb871a3b94$var$xh(a) {
    if (a === $0b2e6adb871a3b94$var$th) throw Error($0b2e6adb871a3b94$var$p(174));
    return a;
}
function $0b2e6adb871a3b94$var$yh(a, b) {
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$wh, b);
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$vh, a);
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$uh, $0b2e6adb871a3b94$var$th);
    a = b.nodeType;
    switch(a){
        case 9:
        case 11:
            b = (b = b.documentElement) ? b.namespaceURI : $0b2e6adb871a3b94$var$lb(null, "");
            break;
        default:
            a = 8 === a ? b.parentNode : b, b = a.namespaceURI || null, a = a.tagName, b = $0b2e6adb871a3b94$var$lb(b, a);
    }
    $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$uh);
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$uh, b);
}
function $0b2e6adb871a3b94$var$zh() {
    $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$uh);
    $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$vh);
    $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$wh);
}
function $0b2e6adb871a3b94$var$Ah(a) {
    $0b2e6adb871a3b94$var$xh($0b2e6adb871a3b94$var$wh.current);
    var b = $0b2e6adb871a3b94$var$xh($0b2e6adb871a3b94$var$uh.current);
    var c = $0b2e6adb871a3b94$var$lb(b, a.type);
    b !== c && ($0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$vh, a), $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$uh, c));
}
function $0b2e6adb871a3b94$var$Bh(a) {
    $0b2e6adb871a3b94$var$vh.current === a && ($0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$uh), $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$vh));
}
var $0b2e6adb871a3b94$var$L = $0b2e6adb871a3b94$var$Uf(0);
function $0b2e6adb871a3b94$var$Ch(a) {
    for(var b = a; null !== b;){
        if (13 === b.tag) {
            var c = b.memoizedState;
            if (null !== c && (c = c.dehydrated, null === c || "$?" === c.data || "$!" === c.data)) return b;
        } else if (19 === b.tag && void 0 !== b.memoizedProps.revealOrder) {
            if (0 !== (b.flags & 128)) return b;
        } else if (null !== b.child) {
            b.child.return = b;
            b = b.child;
            continue;
        }
        if (b === a) break;
        for(; null === b.sibling;){
            if (null === b.return || b.return === a) return null;
            b = b.return;
        }
        b.sibling.return = b.return;
        b = b.sibling;
    }
    return null;
}
var $0b2e6adb871a3b94$var$Dh = [];
function $0b2e6adb871a3b94$var$Eh() {
    for(var a = 0; a < $0b2e6adb871a3b94$var$Dh.length; a++)$0b2e6adb871a3b94$var$Dh[a]._workInProgressVersionPrimary = null;
    $0b2e6adb871a3b94$var$Dh.length = 0;
}
var $0b2e6adb871a3b94$var$Fh = $0b2e6adb871a3b94$var$ua.ReactCurrentDispatcher, $0b2e6adb871a3b94$var$Gh = $0b2e6adb871a3b94$var$ua.ReactCurrentBatchConfig, $0b2e6adb871a3b94$var$Hh = 0, $0b2e6adb871a3b94$var$M = null, $0b2e6adb871a3b94$var$N = null, $0b2e6adb871a3b94$var$O = null, $0b2e6adb871a3b94$var$Ih = !1, $0b2e6adb871a3b94$var$Jh = !1, $0b2e6adb871a3b94$var$Kh = 0, $0b2e6adb871a3b94$var$Lh = 0;
function $0b2e6adb871a3b94$var$P() {
    throw Error($0b2e6adb871a3b94$var$p(321));
}
function $0b2e6adb871a3b94$var$Mh(a, b) {
    if (null === b) return !1;
    for(var c = 0; c < b.length && c < a.length; c++)if (!$0b2e6adb871a3b94$var$He(a[c], b[c])) return !1;
    return !0;
}
function $0b2e6adb871a3b94$var$Nh(a, b, c, d, e, f) {
    $0b2e6adb871a3b94$var$Hh = f;
    $0b2e6adb871a3b94$var$M = b;
    b.memoizedState = null;
    b.updateQueue = null;
    b.lanes = 0;
    $0b2e6adb871a3b94$var$Fh.current = null === a || null === a.memoizedState ? $0b2e6adb871a3b94$var$Oh : $0b2e6adb871a3b94$var$Ph;
    a = c(d, e);
    if ($0b2e6adb871a3b94$var$Jh) {
        f = 0;
        do {
            $0b2e6adb871a3b94$var$Jh = !1;
            $0b2e6adb871a3b94$var$Kh = 0;
            if (25 <= f) throw Error($0b2e6adb871a3b94$var$p(301));
            f += 1;
            $0b2e6adb871a3b94$var$O = $0b2e6adb871a3b94$var$N = null;
            b.updateQueue = null;
            $0b2e6adb871a3b94$var$Fh.current = $0b2e6adb871a3b94$var$Qh;
            a = c(d, e);
        }while ($0b2e6adb871a3b94$var$Jh);
    }
    $0b2e6adb871a3b94$var$Fh.current = $0b2e6adb871a3b94$var$Rh;
    b = null !== $0b2e6adb871a3b94$var$N && null !== $0b2e6adb871a3b94$var$N.next;
    $0b2e6adb871a3b94$var$Hh = 0;
    $0b2e6adb871a3b94$var$O = $0b2e6adb871a3b94$var$N = $0b2e6adb871a3b94$var$M = null;
    $0b2e6adb871a3b94$var$Ih = !1;
    if (b) throw Error($0b2e6adb871a3b94$var$p(300));
    return a;
}
function $0b2e6adb871a3b94$var$Sh() {
    var a = 0 !== $0b2e6adb871a3b94$var$Kh;
    $0b2e6adb871a3b94$var$Kh = 0;
    return a;
}
function $0b2e6adb871a3b94$var$Th() {
    var a = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === $0b2e6adb871a3b94$var$O ? $0b2e6adb871a3b94$var$M.memoizedState = $0b2e6adb871a3b94$var$O = a : $0b2e6adb871a3b94$var$O = $0b2e6adb871a3b94$var$O.next = a;
    return $0b2e6adb871a3b94$var$O;
}
function $0b2e6adb871a3b94$var$Uh() {
    if (null === $0b2e6adb871a3b94$var$N) {
        var a = $0b2e6adb871a3b94$var$M.alternate;
        a = null !== a ? a.memoizedState : null;
    } else a = $0b2e6adb871a3b94$var$N.next;
    var b = null === $0b2e6adb871a3b94$var$O ? $0b2e6adb871a3b94$var$M.memoizedState : $0b2e6adb871a3b94$var$O.next;
    if (null !== b) $0b2e6adb871a3b94$var$O = b, $0b2e6adb871a3b94$var$N = a;
    else {
        if (null === a) throw Error($0b2e6adb871a3b94$var$p(310));
        $0b2e6adb871a3b94$var$N = a;
        a = {
            memoizedState: $0b2e6adb871a3b94$var$N.memoizedState,
            baseState: $0b2e6adb871a3b94$var$N.baseState,
            baseQueue: $0b2e6adb871a3b94$var$N.baseQueue,
            queue: $0b2e6adb871a3b94$var$N.queue,
            next: null
        };
        null === $0b2e6adb871a3b94$var$O ? $0b2e6adb871a3b94$var$M.memoizedState = $0b2e6adb871a3b94$var$O = a : $0b2e6adb871a3b94$var$O = $0b2e6adb871a3b94$var$O.next = a;
    }
    return $0b2e6adb871a3b94$var$O;
}
function $0b2e6adb871a3b94$var$Vh(a, b) {
    return "function" === typeof b ? b(a) : b;
}
function $0b2e6adb871a3b94$var$Wh(a) {
    var b = $0b2e6adb871a3b94$var$Uh(), c = b.queue;
    if (null === c) throw Error($0b2e6adb871a3b94$var$p(311));
    c.lastRenderedReducer = a;
    var d = $0b2e6adb871a3b94$var$N, e = d.baseQueue, f = c.pending;
    if (null !== f) {
        if (null !== e) {
            var g = e.next;
            e.next = f.next;
            f.next = g;
        }
        d.baseQueue = e = f;
        c.pending = null;
    }
    if (null !== e) {
        f = e.next;
        d = d.baseState;
        var h = g = null, k = null, l = f;
        do {
            var m = l.lane;
            if (($0b2e6adb871a3b94$var$Hh & m) === m) null !== k && (k = k.next = {
                lane: 0,
                action: l.action,
                hasEagerState: l.hasEagerState,
                eagerState: l.eagerState,
                next: null
            }), d = l.hasEagerState ? l.eagerState : a(d, l.action);
            else {
                var q = {
                    lane: m,
                    action: l.action,
                    hasEagerState: l.hasEagerState,
                    eagerState: l.eagerState,
                    next: null
                };
                null === k ? (h = k = q, g = d) : k = k.next = q;
                $0b2e6adb871a3b94$var$M.lanes |= m;
                $0b2e6adb871a3b94$var$rh |= m;
            }
            l = l.next;
        }while (null !== l && l !== f);
        null === k ? g = d : k.next = h;
        $0b2e6adb871a3b94$var$He(d, b.memoizedState) || ($0b2e6adb871a3b94$var$dh = !0);
        b.memoizedState = d;
        b.baseState = g;
        b.baseQueue = k;
        c.lastRenderedState = d;
    }
    a = c.interleaved;
    if (null !== a) {
        e = a;
        do f = e.lane, $0b2e6adb871a3b94$var$M.lanes |= f, $0b2e6adb871a3b94$var$rh |= f, e = e.next;
        while (e !== a);
    } else null === e && (c.lanes = 0);
    return [
        b.memoizedState,
        c.dispatch
    ];
}
function $0b2e6adb871a3b94$var$Xh(a) {
    var b = $0b2e6adb871a3b94$var$Uh(), c = b.queue;
    if (null === c) throw Error($0b2e6adb871a3b94$var$p(311));
    c.lastRenderedReducer = a;
    var d = c.dispatch, e = c.pending, f = b.memoizedState;
    if (null !== e) {
        c.pending = null;
        var g = e = e.next;
        do f = a(f, g.action), g = g.next;
        while (g !== e);
        $0b2e6adb871a3b94$var$He(f, b.memoizedState) || ($0b2e6adb871a3b94$var$dh = !0);
        b.memoizedState = f;
        null === b.baseQueue && (b.baseState = f);
        c.lastRenderedState = f;
    }
    return [
        f,
        d
    ];
}
function $0b2e6adb871a3b94$var$Yh() {}
function $0b2e6adb871a3b94$var$Zh(a, b) {
    var c = $0b2e6adb871a3b94$var$M, d = $0b2e6adb871a3b94$var$Uh(), e = b(), f = !$0b2e6adb871a3b94$var$He(d.memoizedState, e);
    f && (d.memoizedState = e, $0b2e6adb871a3b94$var$dh = !0);
    d = d.queue;
    $0b2e6adb871a3b94$var$$h($0b2e6adb871a3b94$var$ai.bind(null, c, d, a), [
        a
    ]);
    if (d.getSnapshot !== b || f || null !== $0b2e6adb871a3b94$var$O && $0b2e6adb871a3b94$var$O.memoizedState.tag & 1) {
        c.flags |= 2048;
        $0b2e6adb871a3b94$var$bi(9, $0b2e6adb871a3b94$var$ci.bind(null, c, d, e, b), void 0, null);
        if (null === $0b2e6adb871a3b94$var$Q) throw Error($0b2e6adb871a3b94$var$p(349));
        0 !== ($0b2e6adb871a3b94$var$Hh & 30) || $0b2e6adb871a3b94$var$di(c, b, e);
    }
    return e;
}
function $0b2e6adb871a3b94$var$di(a, b, c) {
    a.flags |= 16384;
    a = {
        getSnapshot: b,
        value: c
    };
    b = $0b2e6adb871a3b94$var$M.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $0b2e6adb871a3b94$var$M.updateQueue = b, b.stores = [
        a
    ]) : (c = b.stores, null === c ? b.stores = [
        a
    ] : c.push(a));
}
function $0b2e6adb871a3b94$var$ci(a, b, c, d) {
    b.value = c;
    b.getSnapshot = d;
    $0b2e6adb871a3b94$var$ei(b) && $0b2e6adb871a3b94$var$fi(a);
}
function $0b2e6adb871a3b94$var$ai(a, b, c) {
    return c(function() {
        $0b2e6adb871a3b94$var$ei(b) && $0b2e6adb871a3b94$var$fi(a);
    });
}
function $0b2e6adb871a3b94$var$ei(a) {
    var b = a.getSnapshot;
    a = a.value;
    try {
        var c = b();
        return !$0b2e6adb871a3b94$var$He(a, c);
    } catch (d) {
        return !0;
    }
}
function $0b2e6adb871a3b94$var$fi(a) {
    var b = $0b2e6adb871a3b94$var$ih(a, 1);
    null !== b && $0b2e6adb871a3b94$var$gi(b, a, 1, -1);
}
function $0b2e6adb871a3b94$var$hi(a) {
    var b = $0b2e6adb871a3b94$var$Th();
    "function" === typeof a && (a = a());
    b.memoizedState = b.baseState = a;
    a = {
        pending: null,
        interleaved: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $0b2e6adb871a3b94$var$Vh,
        lastRenderedState: a
    };
    b.queue = a;
    a = a.dispatch = $0b2e6adb871a3b94$var$ii.bind(null, $0b2e6adb871a3b94$var$M, a);
    return [
        b.memoizedState,
        a
    ];
}
function $0b2e6adb871a3b94$var$bi(a, b, c, d) {
    a = {
        tag: a,
        create: b,
        destroy: c,
        deps: d,
        next: null
    };
    b = $0b2e6adb871a3b94$var$M.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $0b2e6adb871a3b94$var$M.updateQueue = b, b.lastEffect = a.next = a) : (c = b.lastEffect, null === c ? b.lastEffect = a.next = a : (d = c.next, c.next = a, a.next = d, b.lastEffect = a));
    return a;
}
function $0b2e6adb871a3b94$var$ji() {
    return $0b2e6adb871a3b94$var$Uh().memoizedState;
}
function $0b2e6adb871a3b94$var$ki(a, b, c, d) {
    var e = $0b2e6adb871a3b94$var$Th();
    $0b2e6adb871a3b94$var$M.flags |= a;
    e.memoizedState = $0b2e6adb871a3b94$var$bi(1 | b, c, void 0, void 0 === d ? null : d);
}
function $0b2e6adb871a3b94$var$li(a, b, c, d) {
    var e = $0b2e6adb871a3b94$var$Uh();
    d = void 0 === d ? null : d;
    var f = void 0;
    if (null !== $0b2e6adb871a3b94$var$N) {
        var g = $0b2e6adb871a3b94$var$N.memoizedState;
        f = g.destroy;
        if (null !== d && $0b2e6adb871a3b94$var$Mh(d, g.deps)) {
            e.memoizedState = $0b2e6adb871a3b94$var$bi(b, c, f, d);
            return;
        }
    }
    $0b2e6adb871a3b94$var$M.flags |= a;
    e.memoizedState = $0b2e6adb871a3b94$var$bi(1 | b, c, f, d);
}
function $0b2e6adb871a3b94$var$mi(a, b) {
    return $0b2e6adb871a3b94$var$ki(8390656, 8, a, b);
}
function $0b2e6adb871a3b94$var$$h(a, b) {
    return $0b2e6adb871a3b94$var$li(2048, 8, a, b);
}
function $0b2e6adb871a3b94$var$ni(a, b) {
    return $0b2e6adb871a3b94$var$li(4, 2, a, b);
}
function $0b2e6adb871a3b94$var$oi(a, b) {
    return $0b2e6adb871a3b94$var$li(4, 4, a, b);
}
function $0b2e6adb871a3b94$var$pi(a, b) {
    if ("function" === typeof b) return a = a(), b(a), function() {
        b(null);
    };
    if (null !== b && void 0 !== b) return a = a(), b.current = a, function() {
        b.current = null;
    };
}
function $0b2e6adb871a3b94$var$qi(a, b, c) {
    c = null !== c && void 0 !== c ? c.concat([
        a
    ]) : null;
    return $0b2e6adb871a3b94$var$li(4, 4, $0b2e6adb871a3b94$var$pi.bind(null, b, a), c);
}
function $0b2e6adb871a3b94$var$ri() {}
function $0b2e6adb871a3b94$var$si(a, b) {
    var c = $0b2e6adb871a3b94$var$Uh();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $0b2e6adb871a3b94$var$Mh(b, d[1])) return d[0];
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $0b2e6adb871a3b94$var$ti(a, b) {
    var c = $0b2e6adb871a3b94$var$Uh();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $0b2e6adb871a3b94$var$Mh(b, d[1])) return d[0];
    a = a();
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $0b2e6adb871a3b94$var$ui(a, b, c) {
    if (0 === ($0b2e6adb871a3b94$var$Hh & 21)) return a.baseState && (a.baseState = !1, $0b2e6adb871a3b94$var$dh = !0), a.memoizedState = c;
    $0b2e6adb871a3b94$var$He(c, b) || (c = $0b2e6adb871a3b94$var$yc(), $0b2e6adb871a3b94$var$M.lanes |= c, $0b2e6adb871a3b94$var$rh |= c, a.baseState = !0);
    return b;
}
function $0b2e6adb871a3b94$var$vi(a, b) {
    var c = $0b2e6adb871a3b94$var$C;
    $0b2e6adb871a3b94$var$C = 0 !== c && 4 > c ? c : 4;
    a(!0);
    var d = $0b2e6adb871a3b94$var$Gh.transition;
    $0b2e6adb871a3b94$var$Gh.transition = {};
    try {
        a(!1), b();
    } finally{
        $0b2e6adb871a3b94$var$C = c, $0b2e6adb871a3b94$var$Gh.transition = d;
    }
}
function $0b2e6adb871a3b94$var$wi() {
    return $0b2e6adb871a3b94$var$Uh().memoizedState;
}
function $0b2e6adb871a3b94$var$xi(a, b, c) {
    var d = $0b2e6adb871a3b94$var$yi(a);
    c = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($0b2e6adb871a3b94$var$zi(a)) $0b2e6adb871a3b94$var$Ai(b, c);
    else if (c = $0b2e6adb871a3b94$var$hh(a, b, c, d), null !== c) {
        var e = $0b2e6adb871a3b94$var$R();
        $0b2e6adb871a3b94$var$gi(c, a, d, e);
        $0b2e6adb871a3b94$var$Bi(c, b, d);
    }
}
function $0b2e6adb871a3b94$var$ii(a, b, c) {
    var d = $0b2e6adb871a3b94$var$yi(a), e = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($0b2e6adb871a3b94$var$zi(a)) $0b2e6adb871a3b94$var$Ai(b, e);
    else {
        var f = a.alternate;
        if (0 === a.lanes && (null === f || 0 === f.lanes) && (f = b.lastRenderedReducer, null !== f)) try {
            var g = b.lastRenderedState, h = f(g, c);
            e.hasEagerState = !0;
            e.eagerState = h;
            if ($0b2e6adb871a3b94$var$He(h, g)) {
                var k = b.interleaved;
                null === k ? (e.next = e, $0b2e6adb871a3b94$var$gh(b)) : (e.next = k.next, k.next = e);
                b.interleaved = e;
                return;
            }
        } catch (l) {} finally{}
        c = $0b2e6adb871a3b94$var$hh(a, b, e, d);
        null !== c && (e = $0b2e6adb871a3b94$var$R(), $0b2e6adb871a3b94$var$gi(c, a, d, e), $0b2e6adb871a3b94$var$Bi(c, b, d));
    }
}
function $0b2e6adb871a3b94$var$zi(a) {
    var b = a.alternate;
    return a === $0b2e6adb871a3b94$var$M || null !== b && b === $0b2e6adb871a3b94$var$M;
}
function $0b2e6adb871a3b94$var$Ai(a, b) {
    $0b2e6adb871a3b94$var$Jh = $0b2e6adb871a3b94$var$Ih = !0;
    var c = a.pending;
    null === c ? b.next = b : (b.next = c.next, c.next = b);
    a.pending = b;
}
function $0b2e6adb871a3b94$var$Bi(a, b, c) {
    if (0 !== (c & 4194240)) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $0b2e6adb871a3b94$var$Cc(a, c);
    }
}
var $0b2e6adb871a3b94$var$Rh = {
    readContext: $0b2e6adb871a3b94$var$eh,
    useCallback: $0b2e6adb871a3b94$var$P,
    useContext: $0b2e6adb871a3b94$var$P,
    useEffect: $0b2e6adb871a3b94$var$P,
    useImperativeHandle: $0b2e6adb871a3b94$var$P,
    useInsertionEffect: $0b2e6adb871a3b94$var$P,
    useLayoutEffect: $0b2e6adb871a3b94$var$P,
    useMemo: $0b2e6adb871a3b94$var$P,
    useReducer: $0b2e6adb871a3b94$var$P,
    useRef: $0b2e6adb871a3b94$var$P,
    useState: $0b2e6adb871a3b94$var$P,
    useDebugValue: $0b2e6adb871a3b94$var$P,
    useDeferredValue: $0b2e6adb871a3b94$var$P,
    useTransition: $0b2e6adb871a3b94$var$P,
    useMutableSource: $0b2e6adb871a3b94$var$P,
    useSyncExternalStore: $0b2e6adb871a3b94$var$P,
    useId: $0b2e6adb871a3b94$var$P,
    unstable_isNewReconciler: !1
}, $0b2e6adb871a3b94$var$Oh = {
    readContext: $0b2e6adb871a3b94$var$eh,
    useCallback: function(a, b) {
        $0b2e6adb871a3b94$var$Th().memoizedState = [
            a,
            void 0 === b ? null : b
        ];
        return a;
    },
    useContext: $0b2e6adb871a3b94$var$eh,
    useEffect: $0b2e6adb871a3b94$var$mi,
    useImperativeHandle: function(a, b, c) {
        c = null !== c && void 0 !== c ? c.concat([
            a
        ]) : null;
        return $0b2e6adb871a3b94$var$ki(4194308, 4, $0b2e6adb871a3b94$var$pi.bind(null, b, a), c);
    },
    useLayoutEffect: function(a, b) {
        return $0b2e6adb871a3b94$var$ki(4194308, 4, a, b);
    },
    useInsertionEffect: function(a, b) {
        return $0b2e6adb871a3b94$var$ki(4, 2, a, b);
    },
    useMemo: function(a, b) {
        var c = $0b2e6adb871a3b94$var$Th();
        b = void 0 === b ? null : b;
        a = a();
        c.memoizedState = [
            a,
            b
        ];
        return a;
    },
    useReducer: function(a, b, c) {
        var d = $0b2e6adb871a3b94$var$Th();
        b = void 0 !== c ? c(b) : b;
        d.memoizedState = d.baseState = b;
        a = {
            pending: null,
            interleaved: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: a,
            lastRenderedState: b
        };
        d.queue = a;
        a = a.dispatch = $0b2e6adb871a3b94$var$xi.bind(null, $0b2e6adb871a3b94$var$M, a);
        return [
            d.memoizedState,
            a
        ];
    },
    useRef: function(a) {
        var b = $0b2e6adb871a3b94$var$Th();
        a = {
            current: a
        };
        return b.memoizedState = a;
    },
    useState: $0b2e6adb871a3b94$var$hi,
    useDebugValue: $0b2e6adb871a3b94$var$ri,
    useDeferredValue: function(a) {
        return $0b2e6adb871a3b94$var$Th().memoizedState = a;
    },
    useTransition: function() {
        var a = $0b2e6adb871a3b94$var$hi(!1), b = a[0];
        a = $0b2e6adb871a3b94$var$vi.bind(null, a[1]);
        $0b2e6adb871a3b94$var$Th().memoizedState = a;
        return [
            b,
            a
        ];
    },
    useMutableSource: function() {},
    useSyncExternalStore: function(a, b, c) {
        var d = $0b2e6adb871a3b94$var$M, e = $0b2e6adb871a3b94$var$Th();
        if ($0b2e6adb871a3b94$var$I) {
            if (void 0 === c) throw Error($0b2e6adb871a3b94$var$p(407));
            c = c();
        } else {
            c = b();
            if (null === $0b2e6adb871a3b94$var$Q) throw Error($0b2e6adb871a3b94$var$p(349));
            0 !== ($0b2e6adb871a3b94$var$Hh & 30) || $0b2e6adb871a3b94$var$di(d, b, c);
        }
        e.memoizedState = c;
        var f = {
            value: c,
            getSnapshot: b
        };
        e.queue = f;
        $0b2e6adb871a3b94$var$mi($0b2e6adb871a3b94$var$ai.bind(null, d, f, a), [
            a
        ]);
        d.flags |= 2048;
        $0b2e6adb871a3b94$var$bi(9, $0b2e6adb871a3b94$var$ci.bind(null, d, f, c, b), void 0, null);
        return c;
    },
    useId: function() {
        var a = $0b2e6adb871a3b94$var$Th(), b = $0b2e6adb871a3b94$var$Q.identifierPrefix;
        if ($0b2e6adb871a3b94$var$I) {
            var c = $0b2e6adb871a3b94$var$sg;
            var d = $0b2e6adb871a3b94$var$rg;
            c = (d & ~(1 << 32 - $0b2e6adb871a3b94$var$oc(d) - 1)).toString(32) + c;
            b = ":" + b + "R" + c;
            c = $0b2e6adb871a3b94$var$Kh++;
            0 < c && (b += "H" + c.toString(32));
            b += ":";
        } else c = $0b2e6adb871a3b94$var$Lh++, b = ":" + b + "r" + c.toString(32) + ":";
        return a.memoizedState = b;
    },
    unstable_isNewReconciler: !1
}, $0b2e6adb871a3b94$var$Ph = {
    readContext: $0b2e6adb871a3b94$var$eh,
    useCallback: $0b2e6adb871a3b94$var$si,
    useContext: $0b2e6adb871a3b94$var$eh,
    useEffect: $0b2e6adb871a3b94$var$$h,
    useImperativeHandle: $0b2e6adb871a3b94$var$qi,
    useInsertionEffect: $0b2e6adb871a3b94$var$ni,
    useLayoutEffect: $0b2e6adb871a3b94$var$oi,
    useMemo: $0b2e6adb871a3b94$var$ti,
    useReducer: $0b2e6adb871a3b94$var$Wh,
    useRef: $0b2e6adb871a3b94$var$ji,
    useState: function() {
        return $0b2e6adb871a3b94$var$Wh($0b2e6adb871a3b94$var$Vh);
    },
    useDebugValue: $0b2e6adb871a3b94$var$ri,
    useDeferredValue: function(a) {
        var b = $0b2e6adb871a3b94$var$Uh();
        return $0b2e6adb871a3b94$var$ui(b, $0b2e6adb871a3b94$var$N.memoizedState, a);
    },
    useTransition: function() {
        var a = $0b2e6adb871a3b94$var$Wh($0b2e6adb871a3b94$var$Vh)[0], b = $0b2e6adb871a3b94$var$Uh().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $0b2e6adb871a3b94$var$Yh,
    useSyncExternalStore: $0b2e6adb871a3b94$var$Zh,
    useId: $0b2e6adb871a3b94$var$wi,
    unstable_isNewReconciler: !1
}, $0b2e6adb871a3b94$var$Qh = {
    readContext: $0b2e6adb871a3b94$var$eh,
    useCallback: $0b2e6adb871a3b94$var$si,
    useContext: $0b2e6adb871a3b94$var$eh,
    useEffect: $0b2e6adb871a3b94$var$$h,
    useImperativeHandle: $0b2e6adb871a3b94$var$qi,
    useInsertionEffect: $0b2e6adb871a3b94$var$ni,
    useLayoutEffect: $0b2e6adb871a3b94$var$oi,
    useMemo: $0b2e6adb871a3b94$var$ti,
    useReducer: $0b2e6adb871a3b94$var$Xh,
    useRef: $0b2e6adb871a3b94$var$ji,
    useState: function() {
        return $0b2e6adb871a3b94$var$Xh($0b2e6adb871a3b94$var$Vh);
    },
    useDebugValue: $0b2e6adb871a3b94$var$ri,
    useDeferredValue: function(a) {
        var b = $0b2e6adb871a3b94$var$Uh();
        return null === $0b2e6adb871a3b94$var$N ? b.memoizedState = a : $0b2e6adb871a3b94$var$ui(b, $0b2e6adb871a3b94$var$N.memoizedState, a);
    },
    useTransition: function() {
        var a = $0b2e6adb871a3b94$var$Xh($0b2e6adb871a3b94$var$Vh)[0], b = $0b2e6adb871a3b94$var$Uh().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $0b2e6adb871a3b94$var$Yh,
    useSyncExternalStore: $0b2e6adb871a3b94$var$Zh,
    useId: $0b2e6adb871a3b94$var$wi,
    unstable_isNewReconciler: !1
};
function $0b2e6adb871a3b94$var$Ci(a, b) {
    if (a && a.defaultProps) {
        b = $0b2e6adb871a3b94$var$A({}, b);
        a = a.defaultProps;
        for(var c in a)void 0 === b[c] && (b[c] = a[c]);
        return b;
    }
    return b;
}
function $0b2e6adb871a3b94$var$Di(a, b, c, d) {
    b = a.memoizedState;
    c = c(d, b);
    c = null === c || void 0 === c ? b : $0b2e6adb871a3b94$var$A({}, b, c);
    a.memoizedState = c;
    0 === a.lanes && (a.updateQueue.baseState = c);
}
var $0b2e6adb871a3b94$var$Ei = {
    isMounted: function(a) {
        return (a = a._reactInternals) ? $0b2e6adb871a3b94$var$Vb(a) === a : !1;
    },
    enqueueSetState: function(a, b, c) {
        a = a._reactInternals;
        var d = $0b2e6adb871a3b94$var$R(), e = $0b2e6adb871a3b94$var$yi(a), f = $0b2e6adb871a3b94$var$mh(d, e);
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $0b2e6adb871a3b94$var$nh(a, f, e);
        null !== b && ($0b2e6adb871a3b94$var$gi(b, a, e, d), $0b2e6adb871a3b94$var$oh(b, a, e));
    },
    enqueueReplaceState: function(a, b, c) {
        a = a._reactInternals;
        var d = $0b2e6adb871a3b94$var$R(), e = $0b2e6adb871a3b94$var$yi(a), f = $0b2e6adb871a3b94$var$mh(d, e);
        f.tag = 1;
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $0b2e6adb871a3b94$var$nh(a, f, e);
        null !== b && ($0b2e6adb871a3b94$var$gi(b, a, e, d), $0b2e6adb871a3b94$var$oh(b, a, e));
    },
    enqueueForceUpdate: function(a, b) {
        a = a._reactInternals;
        var c = $0b2e6adb871a3b94$var$R(), d = $0b2e6adb871a3b94$var$yi(a), e = $0b2e6adb871a3b94$var$mh(c, d);
        e.tag = 2;
        void 0 !== b && null !== b && (e.callback = b);
        b = $0b2e6adb871a3b94$var$nh(a, e, d);
        null !== b && ($0b2e6adb871a3b94$var$gi(b, a, d, c), $0b2e6adb871a3b94$var$oh(b, a, d));
    }
};
function $0b2e6adb871a3b94$var$Fi(a, b, c, d, e, f, g) {
    a = a.stateNode;
    return "function" === typeof a.shouldComponentUpdate ? a.shouldComponentUpdate(d, f, g) : b.prototype && b.prototype.isPureReactComponent ? !$0b2e6adb871a3b94$var$Ie(c, d) || !$0b2e6adb871a3b94$var$Ie(e, f) : !0;
}
function $0b2e6adb871a3b94$var$Gi(a, b, c) {
    var d = !1, e = $0b2e6adb871a3b94$var$Vf;
    var f = b.contextType;
    "object" === typeof f && null !== f ? f = $0b2e6adb871a3b94$var$eh(f) : (e = $0b2e6adb871a3b94$var$Zf(b) ? $0b2e6adb871a3b94$var$Xf : $0b2e6adb871a3b94$var$H.current, d = b.contextTypes, f = (d = null !== d && void 0 !== d) ? $0b2e6adb871a3b94$var$Yf(a, e) : $0b2e6adb871a3b94$var$Vf);
    b = new b(c, f);
    a.memoizedState = null !== b.state && void 0 !== b.state ? b.state : null;
    b.updater = $0b2e6adb871a3b94$var$Ei;
    a.stateNode = b;
    b._reactInternals = a;
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = e, a.__reactInternalMemoizedMaskedChildContext = f);
    return b;
}
function $0b2e6adb871a3b94$var$Hi(a, b, c, d) {
    a = b.state;
    "function" === typeof b.componentWillReceiveProps && b.componentWillReceiveProps(c, d);
    "function" === typeof b.UNSAFE_componentWillReceiveProps && b.UNSAFE_componentWillReceiveProps(c, d);
    b.state !== a && $0b2e6adb871a3b94$var$Ei.enqueueReplaceState(b, b.state, null);
}
function $0b2e6adb871a3b94$var$Ii(a, b, c, d) {
    var e = a.stateNode;
    e.props = c;
    e.state = a.memoizedState;
    e.refs = {};
    $0b2e6adb871a3b94$var$kh(a);
    var f = b.contextType;
    "object" === typeof f && null !== f ? e.context = $0b2e6adb871a3b94$var$eh(f) : (f = $0b2e6adb871a3b94$var$Zf(b) ? $0b2e6adb871a3b94$var$Xf : $0b2e6adb871a3b94$var$H.current, e.context = $0b2e6adb871a3b94$var$Yf(a, f));
    e.state = a.memoizedState;
    f = b.getDerivedStateFromProps;
    "function" === typeof f && ($0b2e6adb871a3b94$var$Di(a, b, f, c), e.state = a.memoizedState);
    "function" === typeof b.getDerivedStateFromProps || "function" === typeof e.getSnapshotBeforeUpdate || "function" !== typeof e.UNSAFE_componentWillMount && "function" !== typeof e.componentWillMount || (b = e.state, "function" === typeof e.componentWillMount && e.componentWillMount(), "function" === typeof e.UNSAFE_componentWillMount && e.UNSAFE_componentWillMount(), b !== e.state && $0b2e6adb871a3b94$var$Ei.enqueueReplaceState(e, e.state, null), $0b2e6adb871a3b94$var$qh(a, c, e, d), e.state = a.memoizedState);
    "function" === typeof e.componentDidMount && (a.flags |= 4194308);
}
function $0b2e6adb871a3b94$var$Ji(a, b) {
    try {
        var c = "", d = b;
        do c += $0b2e6adb871a3b94$var$Pa(d), d = d.return;
        while (d);
        var e = c;
    } catch (f) {
        e = "\nError generating stack: " + f.message + "\n" + f.stack;
    }
    return {
        value: a,
        source: b,
        stack: e,
        digest: null
    };
}
function $0b2e6adb871a3b94$var$Ki(a, b, c) {
    return {
        value: a,
        source: null,
        stack: null != c ? c : null,
        digest: null != b ? b : null
    };
}
function $0b2e6adb871a3b94$var$Li(a, b) {
    try {
        console.error(b.value);
    } catch (c) {
        setTimeout(function() {
            throw c;
        });
    }
}
var $0b2e6adb871a3b94$var$Mi = "function" === typeof WeakMap ? WeakMap : Map;
function $0b2e6adb871a3b94$var$Ni(a, b, c) {
    c = $0b2e6adb871a3b94$var$mh(-1, c);
    c.tag = 3;
    c.payload = {
        element: null
    };
    var d = b.value;
    c.callback = function() {
        $0b2e6adb871a3b94$var$Oi || ($0b2e6adb871a3b94$var$Oi = !0, $0b2e6adb871a3b94$var$Pi = d);
        $0b2e6adb871a3b94$var$Li(a, b);
    };
    return c;
}
function $0b2e6adb871a3b94$var$Qi(a, b, c) {
    c = $0b2e6adb871a3b94$var$mh(-1, c);
    c.tag = 3;
    var d = a.type.getDerivedStateFromError;
    if ("function" === typeof d) {
        var e = b.value;
        c.payload = function() {
            return d(e);
        };
        c.callback = function() {
            $0b2e6adb871a3b94$var$Li(a, b);
        };
    }
    var f = a.stateNode;
    null !== f && "function" === typeof f.componentDidCatch && (c.callback = function() {
        $0b2e6adb871a3b94$var$Li(a, b);
        "function" !== typeof d && (null === $0b2e6adb871a3b94$var$Ri ? $0b2e6adb871a3b94$var$Ri = new Set([
            this
        ]) : $0b2e6adb871a3b94$var$Ri.add(this));
        var c = b.stack;
        this.componentDidCatch(b.value, {
            componentStack: null !== c ? c : ""
        });
    });
    return c;
}
function $0b2e6adb871a3b94$var$Si(a, b, c) {
    var d = a.pingCache;
    if (null === d) {
        d = a.pingCache = new $0b2e6adb871a3b94$var$Mi;
        var e = new Set;
        d.set(b, e);
    } else e = d.get(b), void 0 === e && (e = new Set, d.set(b, e));
    e.has(c) || (e.add(c), a = $0b2e6adb871a3b94$var$Ti.bind(null, a, b, c), b.then(a, a));
}
function $0b2e6adb871a3b94$var$Ui(a) {
    do {
        var b;
        if (b = 13 === a.tag) b = a.memoizedState, b = null !== b ? null !== b.dehydrated ? !0 : !1 : !0;
        if (b) return a;
        a = a.return;
    }while (null !== a);
    return null;
}
function $0b2e6adb871a3b94$var$Vi(a, b, c, d, e) {
    if (0 === (a.mode & 1)) return a === b ? a.flags |= 65536 : (a.flags |= 128, c.flags |= 131072, c.flags &= -52805, 1 === c.tag && (null === c.alternate ? c.tag = 17 : (b = $0b2e6adb871a3b94$var$mh(-1, 1), b.tag = 2, $0b2e6adb871a3b94$var$nh(c, b, 1))), c.lanes |= 1), a;
    a.flags |= 65536;
    a.lanes = e;
    return a;
}
var $0b2e6adb871a3b94$var$Wi = $0b2e6adb871a3b94$var$ua.ReactCurrentOwner, $0b2e6adb871a3b94$var$dh = !1;
function $0b2e6adb871a3b94$var$Xi(a, b, c, d) {
    b.child = null === a ? $0b2e6adb871a3b94$var$Vg(b, null, c, d) : $0b2e6adb871a3b94$var$Ug(b, a.child, c, d);
}
function $0b2e6adb871a3b94$var$Yi(a, b, c, d, e) {
    c = c.render;
    var f = b.ref;
    $0b2e6adb871a3b94$var$ch(b, e);
    d = $0b2e6adb871a3b94$var$Nh(a, b, c, d, f, e);
    c = $0b2e6adb871a3b94$var$Sh();
    if (null !== a && !$0b2e6adb871a3b94$var$dh) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $0b2e6adb871a3b94$var$Zi(a, b, e);
    $0b2e6adb871a3b94$var$I && c && $0b2e6adb871a3b94$var$vg(b);
    b.flags |= 1;
    $0b2e6adb871a3b94$var$Xi(a, b, d, e);
    return b.child;
}
function $0b2e6adb871a3b94$var$$i(a, b, c, d, e) {
    if (null === a) {
        var f = c.type;
        if ("function" === typeof f && !$0b2e6adb871a3b94$var$aj(f) && void 0 === f.defaultProps && null === c.compare && void 0 === c.defaultProps) return b.tag = 15, b.type = f, $0b2e6adb871a3b94$var$bj(a, b, f, d, e);
        a = $0b2e6adb871a3b94$var$Rg(c.type, null, d, b, b.mode, e);
        a.ref = b.ref;
        a.return = b;
        return b.child = a;
    }
    f = a.child;
    if (0 === (a.lanes & e)) {
        var g = f.memoizedProps;
        c = c.compare;
        c = null !== c ? c : $0b2e6adb871a3b94$var$Ie;
        if (c(g, d) && a.ref === b.ref) return $0b2e6adb871a3b94$var$Zi(a, b, e);
    }
    b.flags |= 1;
    a = $0b2e6adb871a3b94$var$Pg(f, d);
    a.ref = b.ref;
    a.return = b;
    return b.child = a;
}
function $0b2e6adb871a3b94$var$bj(a, b, c, d, e) {
    if (null !== a) {
        var f = a.memoizedProps;
        if ($0b2e6adb871a3b94$var$Ie(f, d) && a.ref === b.ref) {
            if ($0b2e6adb871a3b94$var$dh = !1, b.pendingProps = d = f, 0 !== (a.lanes & e)) 0 !== (a.flags & 131072) && ($0b2e6adb871a3b94$var$dh = !0);
            else return b.lanes = a.lanes, $0b2e6adb871a3b94$var$Zi(a, b, e);
        }
    }
    return $0b2e6adb871a3b94$var$cj(a, b, c, d, e);
}
function $0b2e6adb871a3b94$var$dj(a, b, c) {
    var d = b.pendingProps, e = d.children, f = null !== a ? a.memoizedState : null;
    if ("hidden" === d.mode) {
        if (0 === (b.mode & 1)) b.memoizedState = {
            baseLanes: 0,
            cachePool: null,
            transitions: null
        }, $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$ej, $0b2e6adb871a3b94$var$fj), $0b2e6adb871a3b94$var$fj |= c;
        else {
            if (0 === (c & 1073741824)) return a = null !== f ? f.baseLanes | c : c, b.lanes = b.childLanes = 1073741824, b.memoizedState = {
                baseLanes: a,
                cachePool: null,
                transitions: null
            }, b.updateQueue = null, $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$ej, $0b2e6adb871a3b94$var$fj), $0b2e6adb871a3b94$var$fj |= a, null;
            b.memoizedState = {
                baseLanes: 0,
                cachePool: null,
                transitions: null
            };
            d = null !== f ? f.baseLanes : c;
            $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$ej, $0b2e6adb871a3b94$var$fj);
            $0b2e6adb871a3b94$var$fj |= d;
        }
    } else null !== f ? (d = f.baseLanes | c, b.memoizedState = null) : d = c, $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$ej, $0b2e6adb871a3b94$var$fj), $0b2e6adb871a3b94$var$fj |= d;
    $0b2e6adb871a3b94$var$Xi(a, b, e, c);
    return b.child;
}
function $0b2e6adb871a3b94$var$gj(a, b) {
    var c = b.ref;
    if (null === a && null !== c || null !== a && a.ref !== c) b.flags |= 512, b.flags |= 2097152;
}
function $0b2e6adb871a3b94$var$cj(a, b, c, d, e) {
    var f = $0b2e6adb871a3b94$var$Zf(c) ? $0b2e6adb871a3b94$var$Xf : $0b2e6adb871a3b94$var$H.current;
    f = $0b2e6adb871a3b94$var$Yf(b, f);
    $0b2e6adb871a3b94$var$ch(b, e);
    c = $0b2e6adb871a3b94$var$Nh(a, b, c, d, f, e);
    d = $0b2e6adb871a3b94$var$Sh();
    if (null !== a && !$0b2e6adb871a3b94$var$dh) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $0b2e6adb871a3b94$var$Zi(a, b, e);
    $0b2e6adb871a3b94$var$I && d && $0b2e6adb871a3b94$var$vg(b);
    b.flags |= 1;
    $0b2e6adb871a3b94$var$Xi(a, b, c, e);
    return b.child;
}
function $0b2e6adb871a3b94$var$hj(a, b, c, d, e) {
    if ($0b2e6adb871a3b94$var$Zf(c)) {
        var f = !0;
        $0b2e6adb871a3b94$var$cg(b);
    } else f = !1;
    $0b2e6adb871a3b94$var$ch(b, e);
    if (null === b.stateNode) $0b2e6adb871a3b94$var$ij(a, b), $0b2e6adb871a3b94$var$Gi(b, c, d), $0b2e6adb871a3b94$var$Ii(b, c, d, e), d = !0;
    else if (null === a) {
        var g = b.stateNode, h = b.memoizedProps;
        g.props = h;
        var k = g.context, l = c.contextType;
        "object" === typeof l && null !== l ? l = $0b2e6adb871a3b94$var$eh(l) : (l = $0b2e6adb871a3b94$var$Zf(c) ? $0b2e6adb871a3b94$var$Xf : $0b2e6adb871a3b94$var$H.current, l = $0b2e6adb871a3b94$var$Yf(b, l));
        var m = c.getDerivedStateFromProps, q = "function" === typeof m || "function" === typeof g.getSnapshotBeforeUpdate;
        q || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== d || k !== l) && $0b2e6adb871a3b94$var$Hi(b, g, d, l);
        $0b2e6adb871a3b94$var$jh = !1;
        var r = b.memoizedState;
        g.state = r;
        $0b2e6adb871a3b94$var$qh(b, d, g, e);
        k = b.memoizedState;
        h !== d || r !== k || $0b2e6adb871a3b94$var$Wf.current || $0b2e6adb871a3b94$var$jh ? ("function" === typeof m && ($0b2e6adb871a3b94$var$Di(b, c, m, d), k = b.memoizedState), (h = $0b2e6adb871a3b94$var$jh || $0b2e6adb871a3b94$var$Fi(b, c, h, d, r, k, l)) ? (q || "function" !== typeof g.UNSAFE_componentWillMount && "function" !== typeof g.componentWillMount || ("function" === typeof g.componentWillMount && g.componentWillMount(), "function" === typeof g.UNSAFE_componentWillMount && g.UNSAFE_componentWillMount()), "function" === typeof g.componentDidMount && (b.flags |= 4194308)) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), b.memoizedProps = d, b.memoizedState = k), g.props = d, g.state = k, g.context = l, d = h) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), d = !1);
    } else {
        g = b.stateNode;
        $0b2e6adb871a3b94$var$lh(a, b);
        h = b.memoizedProps;
        l = b.type === b.elementType ? h : $0b2e6adb871a3b94$var$Ci(b.type, h);
        g.props = l;
        q = b.pendingProps;
        r = g.context;
        k = c.contextType;
        "object" === typeof k && null !== k ? k = $0b2e6adb871a3b94$var$eh(k) : (k = $0b2e6adb871a3b94$var$Zf(c) ? $0b2e6adb871a3b94$var$Xf : $0b2e6adb871a3b94$var$H.current, k = $0b2e6adb871a3b94$var$Yf(b, k));
        var y = c.getDerivedStateFromProps;
        (m = "function" === typeof y || "function" === typeof g.getSnapshotBeforeUpdate) || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== q || r !== k) && $0b2e6adb871a3b94$var$Hi(b, g, d, k);
        $0b2e6adb871a3b94$var$jh = !1;
        r = b.memoizedState;
        g.state = r;
        $0b2e6adb871a3b94$var$qh(b, d, g, e);
        var n = b.memoizedState;
        h !== q || r !== n || $0b2e6adb871a3b94$var$Wf.current || $0b2e6adb871a3b94$var$jh ? ("function" === typeof y && ($0b2e6adb871a3b94$var$Di(b, c, y, d), n = b.memoizedState), (l = $0b2e6adb871a3b94$var$jh || $0b2e6adb871a3b94$var$Fi(b, c, l, d, r, n, k) || !1) ? (m || "function" !== typeof g.UNSAFE_componentWillUpdate && "function" !== typeof g.componentWillUpdate || ("function" === typeof g.componentWillUpdate && g.componentWillUpdate(d, n, k), "function" === typeof g.UNSAFE_componentWillUpdate && g.UNSAFE_componentWillUpdate(d, n, k)), "function" === typeof g.componentDidUpdate && (b.flags |= 4), "function" === typeof g.getSnapshotBeforeUpdate && (b.flags |= 1024)) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), b.memoizedProps = d, b.memoizedState = n), g.props = d, g.state = n, g.context = k, d = l) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), d = !1);
    }
    return $0b2e6adb871a3b94$var$jj(a, b, c, d, f, e);
}
function $0b2e6adb871a3b94$var$jj(a, b, c, d, e, f) {
    $0b2e6adb871a3b94$var$gj(a, b);
    var g = 0 !== (b.flags & 128);
    if (!d && !g) return e && $0b2e6adb871a3b94$var$dg(b, c, !1), $0b2e6adb871a3b94$var$Zi(a, b, f);
    d = b.stateNode;
    $0b2e6adb871a3b94$var$Wi.current = b;
    var h = g && "function" !== typeof c.getDerivedStateFromError ? null : d.render();
    b.flags |= 1;
    null !== a && g ? (b.child = $0b2e6adb871a3b94$var$Ug(b, a.child, null, f), b.child = $0b2e6adb871a3b94$var$Ug(b, null, h, f)) : $0b2e6adb871a3b94$var$Xi(a, b, h, f);
    b.memoizedState = d.state;
    e && $0b2e6adb871a3b94$var$dg(b, c, !0);
    return b.child;
}
function $0b2e6adb871a3b94$var$kj(a) {
    var b = a.stateNode;
    b.pendingContext ? $0b2e6adb871a3b94$var$ag(a, b.pendingContext, b.pendingContext !== b.context) : b.context && $0b2e6adb871a3b94$var$ag(a, b.context, !1);
    $0b2e6adb871a3b94$var$yh(a, b.containerInfo);
}
function $0b2e6adb871a3b94$var$lj(a, b, c, d, e) {
    $0b2e6adb871a3b94$var$Ig();
    $0b2e6adb871a3b94$var$Jg(e);
    b.flags |= 256;
    $0b2e6adb871a3b94$var$Xi(a, b, c, d);
    return b.child;
}
var $0b2e6adb871a3b94$var$mj = {
    dehydrated: null,
    treeContext: null,
    retryLane: 0
};
function $0b2e6adb871a3b94$var$nj(a) {
    return {
        baseLanes: a,
        cachePool: null,
        transitions: null
    };
}
function $0b2e6adb871a3b94$var$oj(a, b, c) {
    var d = b.pendingProps, e = $0b2e6adb871a3b94$var$L.current, f = !1, g = 0 !== (b.flags & 128), h;
    (h = g) || (h = null !== a && null === a.memoizedState ? !1 : 0 !== (e & 2));
    if (h) f = !0, b.flags &= -129;
    else if (null === a || null !== a.memoizedState) e |= 1;
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$L, e & 1);
    if (null === a) {
        $0b2e6adb871a3b94$var$Eg(b);
        a = b.memoizedState;
        if (null !== a && (a = a.dehydrated, null !== a)) return 0 === (b.mode & 1) ? b.lanes = 1 : "$!" === a.data ? b.lanes = 8 : b.lanes = 1073741824, null;
        g = d.children;
        a = d.fallback;
        return f ? (d = b.mode, f = b.child, g = {
            mode: "hidden",
            children: g
        }, 0 === (d & 1) && null !== f ? (f.childLanes = 0, f.pendingProps = g) : f = $0b2e6adb871a3b94$var$pj(g, d, 0, null), a = $0b2e6adb871a3b94$var$Tg(a, d, c, null), f.return = b, a.return = b, f.sibling = a, b.child = f, b.child.memoizedState = $0b2e6adb871a3b94$var$nj(c), b.memoizedState = $0b2e6adb871a3b94$var$mj, a) : $0b2e6adb871a3b94$var$qj(b, g);
    }
    e = a.memoizedState;
    if (null !== e && (h = e.dehydrated, null !== h)) return $0b2e6adb871a3b94$var$rj(a, b, g, d, h, e, c);
    if (f) {
        f = d.fallback;
        g = b.mode;
        e = a.child;
        h = e.sibling;
        var k = {
            mode: "hidden",
            children: d.children
        };
        0 === (g & 1) && b.child !== e ? (d = b.child, d.childLanes = 0, d.pendingProps = k, b.deletions = null) : (d = $0b2e6adb871a3b94$var$Pg(e, k), d.subtreeFlags = e.subtreeFlags & 14680064);
        null !== h ? f = $0b2e6adb871a3b94$var$Pg(h, f) : (f = $0b2e6adb871a3b94$var$Tg(f, g, c, null), f.flags |= 2);
        f.return = b;
        d.return = b;
        d.sibling = f;
        b.child = d;
        d = f;
        f = b.child;
        g = a.child.memoizedState;
        g = null === g ? $0b2e6adb871a3b94$var$nj(c) : {
            baseLanes: g.baseLanes | c,
            cachePool: null,
            transitions: g.transitions
        };
        f.memoizedState = g;
        f.childLanes = a.childLanes & ~c;
        b.memoizedState = $0b2e6adb871a3b94$var$mj;
        return d;
    }
    f = a.child;
    a = f.sibling;
    d = $0b2e6adb871a3b94$var$Pg(f, {
        mode: "visible",
        children: d.children
    });
    0 === (b.mode & 1) && (d.lanes = c);
    d.return = b;
    d.sibling = null;
    null !== a && (c = b.deletions, null === c ? (b.deletions = [
        a
    ], b.flags |= 16) : c.push(a));
    b.child = d;
    b.memoizedState = null;
    return d;
}
function $0b2e6adb871a3b94$var$qj(a, b) {
    b = $0b2e6adb871a3b94$var$pj({
        mode: "visible",
        children: b
    }, a.mode, 0, null);
    b.return = a;
    return a.child = b;
}
function $0b2e6adb871a3b94$var$sj(a, b, c, d) {
    null !== d && $0b2e6adb871a3b94$var$Jg(d);
    $0b2e6adb871a3b94$var$Ug(b, a.child, null, c);
    a = $0b2e6adb871a3b94$var$qj(b, b.pendingProps.children);
    a.flags |= 2;
    b.memoizedState = null;
    return a;
}
function $0b2e6adb871a3b94$var$rj(a, b, c, d, e, f, g) {
    if (c) {
        if (b.flags & 256) return b.flags &= -257, d = $0b2e6adb871a3b94$var$Ki(Error($0b2e6adb871a3b94$var$p(422))), $0b2e6adb871a3b94$var$sj(a, b, g, d);
        if (null !== b.memoizedState) return b.child = a.child, b.flags |= 128, null;
        f = d.fallback;
        e = b.mode;
        d = $0b2e6adb871a3b94$var$pj({
            mode: "visible",
            children: d.children
        }, e, 0, null);
        f = $0b2e6adb871a3b94$var$Tg(f, e, g, null);
        f.flags |= 2;
        d.return = b;
        f.return = b;
        d.sibling = f;
        b.child = d;
        0 !== (b.mode & 1) && $0b2e6adb871a3b94$var$Ug(b, a.child, null, g);
        b.child.memoizedState = $0b2e6adb871a3b94$var$nj(g);
        b.memoizedState = $0b2e6adb871a3b94$var$mj;
        return f;
    }
    if (0 === (b.mode & 1)) return $0b2e6adb871a3b94$var$sj(a, b, g, null);
    if ("$!" === e.data) {
        d = e.nextSibling && e.nextSibling.dataset;
        if (d) var h = d.dgst;
        d = h;
        f = Error($0b2e6adb871a3b94$var$p(419));
        d = $0b2e6adb871a3b94$var$Ki(f, d, void 0);
        return $0b2e6adb871a3b94$var$sj(a, b, g, d);
    }
    h = 0 !== (g & a.childLanes);
    if ($0b2e6adb871a3b94$var$dh || h) {
        d = $0b2e6adb871a3b94$var$Q;
        if (null !== d) {
            switch(g & -g){
                case 4:
                    e = 2;
                    break;
                case 16:
                    e = 8;
                    break;
                case 64:
                case 128:
                case 256:
                case 512:
                case 1024:
                case 2048:
                case 4096:
                case 8192:
                case 16384:
                case 32768:
                case 65536:
                case 131072:
                case 262144:
                case 524288:
                case 1048576:
                case 2097152:
                case 4194304:
                case 8388608:
                case 16777216:
                case 33554432:
                case 67108864:
                    e = 32;
                    break;
                case 536870912:
                    e = 268435456;
                    break;
                default:
                    e = 0;
            }
            e = 0 !== (e & (d.suspendedLanes | g)) ? 0 : e;
            0 !== e && e !== f.retryLane && (f.retryLane = e, $0b2e6adb871a3b94$var$ih(a, e), $0b2e6adb871a3b94$var$gi(d, a, e, -1));
        }
        $0b2e6adb871a3b94$var$tj();
        d = $0b2e6adb871a3b94$var$Ki(Error($0b2e6adb871a3b94$var$p(421)));
        return $0b2e6adb871a3b94$var$sj(a, b, g, d);
    }
    if ("$?" === e.data) return b.flags |= 128, b.child = a.child, b = $0b2e6adb871a3b94$var$uj.bind(null, a), e._reactRetry = b, null;
    a = f.treeContext;
    $0b2e6adb871a3b94$var$yg = $0b2e6adb871a3b94$var$Lf(e.nextSibling);
    $0b2e6adb871a3b94$var$xg = b;
    $0b2e6adb871a3b94$var$I = !0;
    $0b2e6adb871a3b94$var$zg = null;
    null !== a && ($0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg++] = $0b2e6adb871a3b94$var$rg, $0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg++] = $0b2e6adb871a3b94$var$sg, $0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg++] = $0b2e6adb871a3b94$var$qg, $0b2e6adb871a3b94$var$rg = a.id, $0b2e6adb871a3b94$var$sg = a.overflow, $0b2e6adb871a3b94$var$qg = b);
    b = $0b2e6adb871a3b94$var$qj(b, d.children);
    b.flags |= 4096;
    return b;
}
function $0b2e6adb871a3b94$var$vj(a, b, c) {
    a.lanes |= b;
    var d = a.alternate;
    null !== d && (d.lanes |= b);
    $0b2e6adb871a3b94$var$bh(a.return, b, c);
}
function $0b2e6adb871a3b94$var$wj(a, b, c, d, e) {
    var f = a.memoizedState;
    null === f ? a.memoizedState = {
        isBackwards: b,
        rendering: null,
        renderingStartTime: 0,
        last: d,
        tail: c,
        tailMode: e
    } : (f.isBackwards = b, f.rendering = null, f.renderingStartTime = 0, f.last = d, f.tail = c, f.tailMode = e);
}
function $0b2e6adb871a3b94$var$xj(a, b, c) {
    var d = b.pendingProps, e = d.revealOrder, f = d.tail;
    $0b2e6adb871a3b94$var$Xi(a, b, d.children, c);
    d = $0b2e6adb871a3b94$var$L.current;
    if (0 !== (d & 2)) d = d & 1 | 2, b.flags |= 128;
    else {
        if (null !== a && 0 !== (a.flags & 128)) a: for(a = b.child; null !== a;){
            if (13 === a.tag) null !== a.memoizedState && $0b2e6adb871a3b94$var$vj(a, c, b);
            else if (19 === a.tag) $0b2e6adb871a3b94$var$vj(a, c, b);
            else if (null !== a.child) {
                a.child.return = a;
                a = a.child;
                continue;
            }
            if (a === b) break a;
            for(; null === a.sibling;){
                if (null === a.return || a.return === b) break a;
                a = a.return;
            }
            a.sibling.return = a.return;
            a = a.sibling;
        }
        d &= 1;
    }
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$L, d);
    if (0 === (b.mode & 1)) b.memoizedState = null;
    else switch(e){
        case "forwards":
            c = b.child;
            for(e = null; null !== c;)a = c.alternate, null !== a && null === $0b2e6adb871a3b94$var$Ch(a) && (e = c), c = c.sibling;
            c = e;
            null === c ? (e = b.child, b.child = null) : (e = c.sibling, c.sibling = null);
            $0b2e6adb871a3b94$var$wj(b, !1, e, c, f);
            break;
        case "backwards":
            c = null;
            e = b.child;
            for(b.child = null; null !== e;){
                a = e.alternate;
                if (null !== a && null === $0b2e6adb871a3b94$var$Ch(a)) {
                    b.child = e;
                    break;
                }
                a = e.sibling;
                e.sibling = c;
                c = e;
                e = a;
            }
            $0b2e6adb871a3b94$var$wj(b, !0, c, null, f);
            break;
        case "together":
            $0b2e6adb871a3b94$var$wj(b, !1, null, null, void 0);
            break;
        default:
            b.memoizedState = null;
    }
    return b.child;
}
function $0b2e6adb871a3b94$var$ij(a, b) {
    0 === (b.mode & 1) && null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2);
}
function $0b2e6adb871a3b94$var$Zi(a, b, c) {
    null !== a && (b.dependencies = a.dependencies);
    $0b2e6adb871a3b94$var$rh |= b.lanes;
    if (0 === (c & b.childLanes)) return null;
    if (null !== a && b.child !== a.child) throw Error($0b2e6adb871a3b94$var$p(153));
    if (null !== b.child) {
        a = b.child;
        c = $0b2e6adb871a3b94$var$Pg(a, a.pendingProps);
        b.child = c;
        for(c.return = b; null !== a.sibling;)a = a.sibling, c = c.sibling = $0b2e6adb871a3b94$var$Pg(a, a.pendingProps), c.return = b;
        c.sibling = null;
    }
    return b.child;
}
function $0b2e6adb871a3b94$var$yj(a, b, c) {
    switch(b.tag){
        case 3:
            $0b2e6adb871a3b94$var$kj(b);
            $0b2e6adb871a3b94$var$Ig();
            break;
        case 5:
            $0b2e6adb871a3b94$var$Ah(b);
            break;
        case 1:
            $0b2e6adb871a3b94$var$Zf(b.type) && $0b2e6adb871a3b94$var$cg(b);
            break;
        case 4:
            $0b2e6adb871a3b94$var$yh(b, b.stateNode.containerInfo);
            break;
        case 10:
            var d = b.type._context, e = b.memoizedProps.value;
            $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$Wg, d._currentValue);
            d._currentValue = e;
            break;
        case 13:
            d = b.memoizedState;
            if (null !== d) {
                if (null !== d.dehydrated) return $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$L, $0b2e6adb871a3b94$var$L.current & 1), b.flags |= 128, null;
                if (0 !== (c & b.child.childLanes)) return $0b2e6adb871a3b94$var$oj(a, b, c);
                $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$L, $0b2e6adb871a3b94$var$L.current & 1);
                a = $0b2e6adb871a3b94$var$Zi(a, b, c);
                return null !== a ? a.sibling : null;
            }
            $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$L, $0b2e6adb871a3b94$var$L.current & 1);
            break;
        case 19:
            d = 0 !== (c & b.childLanes);
            if (0 !== (a.flags & 128)) {
                if (d) return $0b2e6adb871a3b94$var$xj(a, b, c);
                b.flags |= 128;
            }
            e = b.memoizedState;
            null !== e && (e.rendering = null, e.tail = null, e.lastEffect = null);
            $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$L, $0b2e6adb871a3b94$var$L.current);
            if (d) break;
            else return null;
        case 22:
        case 23:
            return b.lanes = 0, $0b2e6adb871a3b94$var$dj(a, b, c);
    }
    return $0b2e6adb871a3b94$var$Zi(a, b, c);
}
var $0b2e6adb871a3b94$var$zj, $0b2e6adb871a3b94$var$Aj, $0b2e6adb871a3b94$var$Bj, $0b2e6adb871a3b94$var$Cj;
$0b2e6adb871a3b94$var$zj = function(a, b) {
    for(var c = b.child; null !== c;){
        if (5 === c.tag || 6 === c.tag) a.appendChild(c.stateNode);
        else if (4 !== c.tag && null !== c.child) {
            c.child.return = c;
            c = c.child;
            continue;
        }
        if (c === b) break;
        for(; null === c.sibling;){
            if (null === c.return || c.return === b) return;
            c = c.return;
        }
        c.sibling.return = c.return;
        c = c.sibling;
    }
};
$0b2e6adb871a3b94$var$Aj = function() {};
$0b2e6adb871a3b94$var$Bj = function(a, b, c, d) {
    var e = a.memoizedProps;
    if (e !== d) {
        a = b.stateNode;
        $0b2e6adb871a3b94$var$xh($0b2e6adb871a3b94$var$uh.current);
        var f = null;
        switch(c){
            case "input":
                e = $0b2e6adb871a3b94$var$Ya(a, e);
                d = $0b2e6adb871a3b94$var$Ya(a, d);
                f = [];
                break;
            case "select":
                e = $0b2e6adb871a3b94$var$A({}, e, {
                    value: void 0
                });
                d = $0b2e6adb871a3b94$var$A({}, d, {
                    value: void 0
                });
                f = [];
                break;
            case "textarea":
                e = $0b2e6adb871a3b94$var$gb(a, e);
                d = $0b2e6adb871a3b94$var$gb(a, d);
                f = [];
                break;
            default:
                "function" !== typeof e.onClick && "function" === typeof d.onClick && (a.onclick = $0b2e6adb871a3b94$var$Bf);
        }
        $0b2e6adb871a3b94$var$ub(c, d);
        var g;
        c = null;
        for(l in e)if (!d.hasOwnProperty(l) && e.hasOwnProperty(l) && null != e[l]) {
            if ("style" === l) {
                var h = e[l];
                for(g in h)h.hasOwnProperty(g) && (c || (c = {}), c[g] = "");
            } else "dangerouslySetInnerHTML" !== l && "children" !== l && "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && "autoFocus" !== l && ($0b2e6adb871a3b94$var$ea.hasOwnProperty(l) ? f || (f = []) : (f = f || []).push(l, null));
        }
        for(l in d){
            var k = d[l];
            h = null != e ? e[l] : void 0;
            if (d.hasOwnProperty(l) && k !== h && (null != k || null != h)) {
                if ("style" === l) {
                    if (h) {
                        for(g in h)!h.hasOwnProperty(g) || k && k.hasOwnProperty(g) || (c || (c = {}), c[g] = "");
                        for(g in k)k.hasOwnProperty(g) && h[g] !== k[g] && (c || (c = {}), c[g] = k[g]);
                    } else c || (f || (f = []), f.push(l, c)), c = k;
                } else "dangerouslySetInnerHTML" === l ? (k = k ? k.__html : void 0, h = h ? h.__html : void 0, null != k && h !== k && (f = f || []).push(l, k)) : "children" === l ? "string" !== typeof k && "number" !== typeof k || (f = f || []).push(l, "" + k) : "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && ($0b2e6adb871a3b94$var$ea.hasOwnProperty(l) ? (null != k && "onScroll" === l && $0b2e6adb871a3b94$var$D("scroll", a), f || h === k || (f = [])) : (f = f || []).push(l, k));
            }
        }
        c && (f = f || []).push("style", c);
        var l = f;
        if (b.updateQueue = l) b.flags |= 4;
    }
};
$0b2e6adb871a3b94$var$Cj = function(a, b, c, d) {
    c !== d && (b.flags |= 4);
};
function $0b2e6adb871a3b94$var$Dj(a, b) {
    if (!$0b2e6adb871a3b94$var$I) switch(a.tailMode){
        case "hidden":
            b = a.tail;
            for(var c = null; null !== b;)null !== b.alternate && (c = b), b = b.sibling;
            null === c ? a.tail = null : c.sibling = null;
            break;
        case "collapsed":
            c = a.tail;
            for(var d = null; null !== c;)null !== c.alternate && (d = c), c = c.sibling;
            null === d ? b || null === a.tail ? a.tail = null : a.tail.sibling = null : d.sibling = null;
    }
}
function $0b2e6adb871a3b94$var$S(a) {
    var b = null !== a.alternate && a.alternate.child === a.child, c = 0, d = 0;
    if (b) for(var e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags & 14680064, d |= e.flags & 14680064, e.return = a, e = e.sibling;
    else for(e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags, d |= e.flags, e.return = a, e = e.sibling;
    a.subtreeFlags |= d;
    a.childLanes = c;
    return b;
}
function $0b2e6adb871a3b94$var$Ej(a, b, c) {
    var d = b.pendingProps;
    $0b2e6adb871a3b94$var$wg(b);
    switch(b.tag){
        case 2:
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return $0b2e6adb871a3b94$var$S(b), null;
        case 1:
            return $0b2e6adb871a3b94$var$Zf(b.type) && $0b2e6adb871a3b94$var$$f(), $0b2e6adb871a3b94$var$S(b), null;
        case 3:
            d = b.stateNode;
            $0b2e6adb871a3b94$var$zh();
            $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Wf);
            $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$H);
            $0b2e6adb871a3b94$var$Eh();
            d.pendingContext && (d.context = d.pendingContext, d.pendingContext = null);
            if (null === a || null === a.child) $0b2e6adb871a3b94$var$Gg(b) ? b.flags |= 4 : null === a || a.memoizedState.isDehydrated && 0 === (b.flags & 256) || (b.flags |= 1024, null !== $0b2e6adb871a3b94$var$zg && ($0b2e6adb871a3b94$var$Fj($0b2e6adb871a3b94$var$zg), $0b2e6adb871a3b94$var$zg = null));
            $0b2e6adb871a3b94$var$Aj(a, b);
            $0b2e6adb871a3b94$var$S(b);
            return null;
        case 5:
            $0b2e6adb871a3b94$var$Bh(b);
            var e = $0b2e6adb871a3b94$var$xh($0b2e6adb871a3b94$var$wh.current);
            c = b.type;
            if (null !== a && null != b.stateNode) $0b2e6adb871a3b94$var$Bj(a, b, c, d, e), a.ref !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            else {
                if (!d) {
                    if (null === b.stateNode) throw Error($0b2e6adb871a3b94$var$p(166));
                    $0b2e6adb871a3b94$var$S(b);
                    return null;
                }
                a = $0b2e6adb871a3b94$var$xh($0b2e6adb871a3b94$var$uh.current);
                if ($0b2e6adb871a3b94$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.type;
                    var f = b.memoizedProps;
                    d[$0b2e6adb871a3b94$var$Of] = b;
                    d[$0b2e6adb871a3b94$var$Pf] = f;
                    a = 0 !== (b.mode & 1);
                    switch(c){
                        case "dialog":
                            $0b2e6adb871a3b94$var$D("cancel", d);
                            $0b2e6adb871a3b94$var$D("close", d);
                            break;
                        case "iframe":
                        case "object":
                        case "embed":
                            $0b2e6adb871a3b94$var$D("load", d);
                            break;
                        case "video":
                        case "audio":
                            for(e = 0; e < $0b2e6adb871a3b94$var$lf.length; e++)$0b2e6adb871a3b94$var$D($0b2e6adb871a3b94$var$lf[e], d);
                            break;
                        case "source":
                            $0b2e6adb871a3b94$var$D("error", d);
                            break;
                        case "img":
                        case "image":
                        case "link":
                            $0b2e6adb871a3b94$var$D("error", d);
                            $0b2e6adb871a3b94$var$D("load", d);
                            break;
                        case "details":
                            $0b2e6adb871a3b94$var$D("toggle", d);
                            break;
                        case "input":
                            $0b2e6adb871a3b94$var$Za(d, f);
                            $0b2e6adb871a3b94$var$D("invalid", d);
                            break;
                        case "select":
                            d._wrapperState = {
                                wasMultiple: !!f.multiple
                            };
                            $0b2e6adb871a3b94$var$D("invalid", d);
                            break;
                        case "textarea":
                            $0b2e6adb871a3b94$var$hb(d, f), $0b2e6adb871a3b94$var$D("invalid", d);
                    }
                    $0b2e6adb871a3b94$var$ub(c, f);
                    e = null;
                    for(var g in f)if (f.hasOwnProperty(g)) {
                        var h = f[g];
                        "children" === g ? "string" === typeof h ? d.textContent !== h && (!0 !== f.suppressHydrationWarning && $0b2e6adb871a3b94$var$Af(d.textContent, h, a), e = [
                            "children",
                            h
                        ]) : "number" === typeof h && d.textContent !== "" + h && (!0 !== f.suppressHydrationWarning && $0b2e6adb871a3b94$var$Af(d.textContent, h, a), e = [
                            "children",
                            "" + h
                        ]) : $0b2e6adb871a3b94$var$ea.hasOwnProperty(g) && null != h && "onScroll" === g && $0b2e6adb871a3b94$var$D("scroll", d);
                    }
                    switch(c){
                        case "input":
                            $0b2e6adb871a3b94$var$Va(d);
                            $0b2e6adb871a3b94$var$db(d, f, !0);
                            break;
                        case "textarea":
                            $0b2e6adb871a3b94$var$Va(d);
                            $0b2e6adb871a3b94$var$jb(d);
                            break;
                        case "select":
                        case "option":
                            break;
                        default:
                            "function" === typeof f.onClick && (d.onclick = $0b2e6adb871a3b94$var$Bf);
                    }
                    d = e;
                    b.updateQueue = d;
                    null !== d && (b.flags |= 4);
                } else {
                    g = 9 === e.nodeType ? e : e.ownerDocument;
                    "http://www.w3.org/1999/xhtml" === a && (a = $0b2e6adb871a3b94$var$kb(c));
                    "http://www.w3.org/1999/xhtml" === a ? "script" === c ? (a = g.createElement("div"), a.innerHTML = "<script>\x3c/script>", a = a.removeChild(a.firstChild)) : "string" === typeof d.is ? a = g.createElement(c, {
                        is: d.is
                    }) : (a = g.createElement(c), "select" === c && (g = a, d.multiple ? g.multiple = !0 : d.size && (g.size = d.size))) : a = g.createElementNS(a, c);
                    a[$0b2e6adb871a3b94$var$Of] = b;
                    a[$0b2e6adb871a3b94$var$Pf] = d;
                    $0b2e6adb871a3b94$var$zj(a, b, !1, !1);
                    b.stateNode = a;
                    a: {
                        g = $0b2e6adb871a3b94$var$vb(c, d);
                        switch(c){
                            case "dialog":
                                $0b2e6adb871a3b94$var$D("cancel", a);
                                $0b2e6adb871a3b94$var$D("close", a);
                                e = d;
                                break;
                            case "iframe":
                            case "object":
                            case "embed":
                                $0b2e6adb871a3b94$var$D("load", a);
                                e = d;
                                break;
                            case "video":
                            case "audio":
                                for(e = 0; e < $0b2e6adb871a3b94$var$lf.length; e++)$0b2e6adb871a3b94$var$D($0b2e6adb871a3b94$var$lf[e], a);
                                e = d;
                                break;
                            case "source":
                                $0b2e6adb871a3b94$var$D("error", a);
                                e = d;
                                break;
                            case "img":
                            case "image":
                            case "link":
                                $0b2e6adb871a3b94$var$D("error", a);
                                $0b2e6adb871a3b94$var$D("load", a);
                                e = d;
                                break;
                            case "details":
                                $0b2e6adb871a3b94$var$D("toggle", a);
                                e = d;
                                break;
                            case "input":
                                $0b2e6adb871a3b94$var$Za(a, d);
                                e = $0b2e6adb871a3b94$var$Ya(a, d);
                                $0b2e6adb871a3b94$var$D("invalid", a);
                                break;
                            case "option":
                                e = d;
                                break;
                            case "select":
                                a._wrapperState = {
                                    wasMultiple: !!d.multiple
                                };
                                e = $0b2e6adb871a3b94$var$A({}, d, {
                                    value: void 0
                                });
                                $0b2e6adb871a3b94$var$D("invalid", a);
                                break;
                            case "textarea":
                                $0b2e6adb871a3b94$var$hb(a, d);
                                e = $0b2e6adb871a3b94$var$gb(a, d);
                                $0b2e6adb871a3b94$var$D("invalid", a);
                                break;
                            default:
                                e = d;
                        }
                        $0b2e6adb871a3b94$var$ub(c, e);
                        h = e;
                        for(f in h)if (h.hasOwnProperty(f)) {
                            var k = h[f];
                            "style" === f ? $0b2e6adb871a3b94$var$sb(a, k) : "dangerouslySetInnerHTML" === f ? (k = k ? k.__html : void 0, null != k && $0b2e6adb871a3b94$var$nb(a, k)) : "children" === f ? "string" === typeof k ? ("textarea" !== c || "" !== k) && $0b2e6adb871a3b94$var$ob(a, k) : "number" === typeof k && $0b2e6adb871a3b94$var$ob(a, "" + k) : "suppressContentEditableWarning" !== f && "suppressHydrationWarning" !== f && "autoFocus" !== f && ($0b2e6adb871a3b94$var$ea.hasOwnProperty(f) ? null != k && "onScroll" === f && $0b2e6adb871a3b94$var$D("scroll", a) : null != k && $0b2e6adb871a3b94$var$ta(a, f, k, g));
                        }
                        switch(c){
                            case "input":
                                $0b2e6adb871a3b94$var$Va(a);
                                $0b2e6adb871a3b94$var$db(a, d, !1);
                                break;
                            case "textarea":
                                $0b2e6adb871a3b94$var$Va(a);
                                $0b2e6adb871a3b94$var$jb(a);
                                break;
                            case "option":
                                null != d.value && a.setAttribute("value", "" + $0b2e6adb871a3b94$var$Sa(d.value));
                                break;
                            case "select":
                                a.multiple = !!d.multiple;
                                f = d.value;
                                null != f ? $0b2e6adb871a3b94$var$fb(a, !!d.multiple, f, !1) : null != d.defaultValue && $0b2e6adb871a3b94$var$fb(a, !!d.multiple, d.defaultValue, !0);
                                break;
                            default:
                                "function" === typeof e.onClick && (a.onclick = $0b2e6adb871a3b94$var$Bf);
                        }
                        switch(c){
                            case "button":
                            case "input":
                            case "select":
                            case "textarea":
                                d = !!d.autoFocus;
                                break a;
                            case "img":
                                d = !0;
                                break a;
                            default:
                                d = !1;
                        }
                    }
                    d && (b.flags |= 4);
                }
                null !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            }
            $0b2e6adb871a3b94$var$S(b);
            return null;
        case 6:
            if (a && null != b.stateNode) $0b2e6adb871a3b94$var$Cj(a, b, a.memoizedProps, d);
            else {
                if ("string" !== typeof d && null === b.stateNode) throw Error($0b2e6adb871a3b94$var$p(166));
                c = $0b2e6adb871a3b94$var$xh($0b2e6adb871a3b94$var$wh.current);
                $0b2e6adb871a3b94$var$xh($0b2e6adb871a3b94$var$uh.current);
                if ($0b2e6adb871a3b94$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.memoizedProps;
                    d[$0b2e6adb871a3b94$var$Of] = b;
                    if (f = d.nodeValue !== c) {
                        if (a = $0b2e6adb871a3b94$var$xg, null !== a) switch(a.tag){
                            case 3:
                                $0b2e6adb871a3b94$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                                break;
                            case 5:
                                !0 !== a.memoizedProps.suppressHydrationWarning && $0b2e6adb871a3b94$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                        }
                    }
                    f && (b.flags |= 4);
                } else d = (9 === c.nodeType ? c : c.ownerDocument).createTextNode(d), d[$0b2e6adb871a3b94$var$Of] = b, b.stateNode = d;
            }
            $0b2e6adb871a3b94$var$S(b);
            return null;
        case 13:
            $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$L);
            d = b.memoizedState;
            if (null === a || null !== a.memoizedState && null !== a.memoizedState.dehydrated) {
                if ($0b2e6adb871a3b94$var$I && null !== $0b2e6adb871a3b94$var$yg && 0 !== (b.mode & 1) && 0 === (b.flags & 128)) $0b2e6adb871a3b94$var$Hg(), $0b2e6adb871a3b94$var$Ig(), b.flags |= 98560, f = !1;
                else if (f = $0b2e6adb871a3b94$var$Gg(b), null !== d && null !== d.dehydrated) {
                    if (null === a) {
                        if (!f) throw Error($0b2e6adb871a3b94$var$p(318));
                        f = b.memoizedState;
                        f = null !== f ? f.dehydrated : null;
                        if (!f) throw Error($0b2e6adb871a3b94$var$p(317));
                        f[$0b2e6adb871a3b94$var$Of] = b;
                    } else $0b2e6adb871a3b94$var$Ig(), 0 === (b.flags & 128) && (b.memoizedState = null), b.flags |= 4;
                    $0b2e6adb871a3b94$var$S(b);
                    f = !1;
                } else null !== $0b2e6adb871a3b94$var$zg && ($0b2e6adb871a3b94$var$Fj($0b2e6adb871a3b94$var$zg), $0b2e6adb871a3b94$var$zg = null), f = !0;
                if (!f) return b.flags & 65536 ? b : null;
            }
            if (0 !== (b.flags & 128)) return b.lanes = c, b;
            d = null !== d;
            d !== (null !== a && null !== a.memoizedState) && d && (b.child.flags |= 8192, 0 !== (b.mode & 1) && (null === a || 0 !== ($0b2e6adb871a3b94$var$L.current & 1) ? 0 === $0b2e6adb871a3b94$var$T && ($0b2e6adb871a3b94$var$T = 3) : $0b2e6adb871a3b94$var$tj()));
            null !== b.updateQueue && (b.flags |= 4);
            $0b2e6adb871a3b94$var$S(b);
            return null;
        case 4:
            return $0b2e6adb871a3b94$var$zh(), $0b2e6adb871a3b94$var$Aj(a, b), null === a && $0b2e6adb871a3b94$var$sf(b.stateNode.containerInfo), $0b2e6adb871a3b94$var$S(b), null;
        case 10:
            return $0b2e6adb871a3b94$var$ah(b.type._context), $0b2e6adb871a3b94$var$S(b), null;
        case 17:
            return $0b2e6adb871a3b94$var$Zf(b.type) && $0b2e6adb871a3b94$var$$f(), $0b2e6adb871a3b94$var$S(b), null;
        case 19:
            $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$L);
            f = b.memoizedState;
            if (null === f) return $0b2e6adb871a3b94$var$S(b), null;
            d = 0 !== (b.flags & 128);
            g = f.rendering;
            if (null === g) {
                if (d) $0b2e6adb871a3b94$var$Dj(f, !1);
                else {
                    if (0 !== $0b2e6adb871a3b94$var$T || null !== a && 0 !== (a.flags & 128)) for(a = b.child; null !== a;){
                        g = $0b2e6adb871a3b94$var$Ch(a);
                        if (null !== g) {
                            b.flags |= 128;
                            $0b2e6adb871a3b94$var$Dj(f, !1);
                            d = g.updateQueue;
                            null !== d && (b.updateQueue = d, b.flags |= 4);
                            b.subtreeFlags = 0;
                            d = c;
                            for(c = b.child; null !== c;)f = c, a = d, f.flags &= 14680066, g = f.alternate, null === g ? (f.childLanes = 0, f.lanes = a, f.child = null, f.subtreeFlags = 0, f.memoizedProps = null, f.memoizedState = null, f.updateQueue = null, f.dependencies = null, f.stateNode = null) : (f.childLanes = g.childLanes, f.lanes = g.lanes, f.child = g.child, f.subtreeFlags = 0, f.deletions = null, f.memoizedProps = g.memoizedProps, f.memoizedState = g.memoizedState, f.updateQueue = g.updateQueue, f.type = g.type, a = g.dependencies, f.dependencies = null === a ? null : {
                                lanes: a.lanes,
                                firstContext: a.firstContext
                            }), c = c.sibling;
                            $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$L, $0b2e6adb871a3b94$var$L.current & 1 | 2);
                            return b.child;
                        }
                        a = a.sibling;
                    }
                    null !== f.tail && $0b2e6adb871a3b94$var$B() > $0b2e6adb871a3b94$var$Gj && (b.flags |= 128, d = !0, $0b2e6adb871a3b94$var$Dj(f, !1), b.lanes = 4194304);
                }
            } else {
                if (!d) {
                    if (a = $0b2e6adb871a3b94$var$Ch(g), null !== a) {
                        if (b.flags |= 128, d = !0, c = a.updateQueue, null !== c && (b.updateQueue = c, b.flags |= 4), $0b2e6adb871a3b94$var$Dj(f, !0), null === f.tail && "hidden" === f.tailMode && !g.alternate && !$0b2e6adb871a3b94$var$I) return $0b2e6adb871a3b94$var$S(b), null;
                    } else 2 * $0b2e6adb871a3b94$var$B() - f.renderingStartTime > $0b2e6adb871a3b94$var$Gj && 1073741824 !== c && (b.flags |= 128, d = !0, $0b2e6adb871a3b94$var$Dj(f, !1), b.lanes = 4194304);
                }
                f.isBackwards ? (g.sibling = b.child, b.child = g) : (c = f.last, null !== c ? c.sibling = g : b.child = g, f.last = g);
            }
            if (null !== f.tail) return b = f.tail, f.rendering = b, f.tail = b.sibling, f.renderingStartTime = $0b2e6adb871a3b94$var$B(), b.sibling = null, c = $0b2e6adb871a3b94$var$L.current, $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$L, d ? c & 1 | 2 : c & 1), b;
            $0b2e6adb871a3b94$var$S(b);
            return null;
        case 22:
        case 23:
            return $0b2e6adb871a3b94$var$Hj(), d = null !== b.memoizedState, null !== a && null !== a.memoizedState !== d && (b.flags |= 8192), d && 0 !== (b.mode & 1) ? 0 !== ($0b2e6adb871a3b94$var$fj & 1073741824) && ($0b2e6adb871a3b94$var$S(b), b.subtreeFlags & 6 && (b.flags |= 8192)) : $0b2e6adb871a3b94$var$S(b), null;
        case 24:
            return null;
        case 25:
            return null;
    }
    throw Error($0b2e6adb871a3b94$var$p(156, b.tag));
}
function $0b2e6adb871a3b94$var$Ij(a, b) {
    $0b2e6adb871a3b94$var$wg(b);
    switch(b.tag){
        case 1:
            return $0b2e6adb871a3b94$var$Zf(b.type) && $0b2e6adb871a3b94$var$$f(), a = b.flags, a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 3:
            return $0b2e6adb871a3b94$var$zh(), $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Wf), $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$H), $0b2e6adb871a3b94$var$Eh(), a = b.flags, 0 !== (a & 65536) && 0 === (a & 128) ? (b.flags = a & -65537 | 128, b) : null;
        case 5:
            return $0b2e6adb871a3b94$var$Bh(b), null;
        case 13:
            $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$L);
            a = b.memoizedState;
            if (null !== a && null !== a.dehydrated) {
                if (null === b.alternate) throw Error($0b2e6adb871a3b94$var$p(340));
                $0b2e6adb871a3b94$var$Ig();
            }
            a = b.flags;
            return a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 19:
            return $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$L), null;
        case 4:
            return $0b2e6adb871a3b94$var$zh(), null;
        case 10:
            return $0b2e6adb871a3b94$var$ah(b.type._context), null;
        case 22:
        case 23:
            return $0b2e6adb871a3b94$var$Hj(), null;
        case 24:
            return null;
        default:
            return null;
    }
}
var $0b2e6adb871a3b94$var$Jj = !1, $0b2e6adb871a3b94$var$U = !1, $0b2e6adb871a3b94$var$Kj = "function" === typeof WeakSet ? WeakSet : Set, $0b2e6adb871a3b94$var$V = null;
function $0b2e6adb871a3b94$var$Lj(a, b) {
    var c = a.ref;
    if (null !== c) {
        if ("function" === typeof c) try {
            c(null);
        } catch (d) {
            $0b2e6adb871a3b94$var$W(a, b, d);
        }
        else c.current = null;
    }
}
function $0b2e6adb871a3b94$var$Mj(a, b, c) {
    try {
        c();
    } catch (d) {
        $0b2e6adb871a3b94$var$W(a, b, d);
    }
}
var $0b2e6adb871a3b94$var$Nj = !1;
function $0b2e6adb871a3b94$var$Oj(a, b) {
    $0b2e6adb871a3b94$var$Cf = $0b2e6adb871a3b94$var$dd;
    a = $0b2e6adb871a3b94$var$Me();
    if ($0b2e6adb871a3b94$var$Ne(a)) {
        if ("selectionStart" in a) var c = {
            start: a.selectionStart,
            end: a.selectionEnd
        };
        else a: {
            c = (c = a.ownerDocument) && c.defaultView || window;
            var d = c.getSelection && c.getSelection();
            if (d && 0 !== d.rangeCount) {
                c = d.anchorNode;
                var e = d.anchorOffset, f = d.focusNode;
                d = d.focusOffset;
                try {
                    c.nodeType, f.nodeType;
                } catch (F) {
                    c = null;
                    break a;
                }
                var g = 0, h = -1, k = -1, l = 0, m = 0, q = a, r = null;
                b: for(;;){
                    for(var y;;){
                        q !== c || 0 !== e && 3 !== q.nodeType || (h = g + e);
                        q !== f || 0 !== d && 3 !== q.nodeType || (k = g + d);
                        3 === q.nodeType && (g += q.nodeValue.length);
                        if (null === (y = q.firstChild)) break;
                        r = q;
                        q = y;
                    }
                    for(;;){
                        if (q === a) break b;
                        r === c && ++l === e && (h = g);
                        r === f && ++m === d && (k = g);
                        if (null !== (y = q.nextSibling)) break;
                        q = r;
                        r = q.parentNode;
                    }
                    q = y;
                }
                c = -1 === h || -1 === k ? null : {
                    start: h,
                    end: k
                };
            } else c = null;
        }
        c = c || {
            start: 0,
            end: 0
        };
    } else c = null;
    $0b2e6adb871a3b94$var$Df = {
        focusedElem: a,
        selectionRange: c
    };
    $0b2e6adb871a3b94$var$dd = !1;
    for($0b2e6adb871a3b94$var$V = b; null !== $0b2e6adb871a3b94$var$V;)if (b = $0b2e6adb871a3b94$var$V, a = b.child, 0 !== (b.subtreeFlags & 1028) && null !== a) a.return = b, $0b2e6adb871a3b94$var$V = a;
    else for(; null !== $0b2e6adb871a3b94$var$V;){
        b = $0b2e6adb871a3b94$var$V;
        try {
            var n = b.alternate;
            if (0 !== (b.flags & 1024)) switch(b.tag){
                case 0:
                case 11:
                case 15:
                    break;
                case 1:
                    if (null !== n) {
                        var t = n.memoizedProps, J = n.memoizedState, x = b.stateNode, w = x.getSnapshotBeforeUpdate(b.elementType === b.type ? t : $0b2e6adb871a3b94$var$Ci(b.type, t), J);
                        x.__reactInternalSnapshotBeforeUpdate = w;
                    }
                    break;
                case 3:
                    var u = b.stateNode.containerInfo;
                    1 === u.nodeType ? u.textContent = "" : 9 === u.nodeType && u.documentElement && u.removeChild(u.documentElement);
                    break;
                case 5:
                case 6:
                case 4:
                case 17:
                    break;
                default:
                    throw Error($0b2e6adb871a3b94$var$p(163));
            }
        } catch (F) {
            $0b2e6adb871a3b94$var$W(b, b.return, F);
        }
        a = b.sibling;
        if (null !== a) {
            a.return = b.return;
            $0b2e6adb871a3b94$var$V = a;
            break;
        }
        $0b2e6adb871a3b94$var$V = b.return;
    }
    n = $0b2e6adb871a3b94$var$Nj;
    $0b2e6adb871a3b94$var$Nj = !1;
    return n;
}
function $0b2e6adb871a3b94$var$Pj(a, b, c) {
    var d = b.updateQueue;
    d = null !== d ? d.lastEffect : null;
    if (null !== d) {
        var e = d = d.next;
        do {
            if ((e.tag & a) === a) {
                var f = e.destroy;
                e.destroy = void 0;
                void 0 !== f && $0b2e6adb871a3b94$var$Mj(b, c, f);
            }
            e = e.next;
        }while (e !== d);
    }
}
function $0b2e6adb871a3b94$var$Qj(a, b) {
    b = b.updateQueue;
    b = null !== b ? b.lastEffect : null;
    if (null !== b) {
        var c = b = b.next;
        do {
            if ((c.tag & a) === a) {
                var d = c.create;
                c.destroy = d();
            }
            c = c.next;
        }while (c !== b);
    }
}
function $0b2e6adb871a3b94$var$Rj(a) {
    var b = a.ref;
    if (null !== b) {
        var c = a.stateNode;
        switch(a.tag){
            case 5:
                a = c;
                break;
            default:
                a = c;
        }
        "function" === typeof b ? b(a) : b.current = a;
    }
}
function $0b2e6adb871a3b94$var$Sj(a) {
    var b = a.alternate;
    null !== b && (a.alternate = null, $0b2e6adb871a3b94$var$Sj(b));
    a.child = null;
    a.deletions = null;
    a.sibling = null;
    5 === a.tag && (b = a.stateNode, null !== b && (delete b[$0b2e6adb871a3b94$var$Of], delete b[$0b2e6adb871a3b94$var$Pf], delete b[$0b2e6adb871a3b94$var$of], delete b[$0b2e6adb871a3b94$var$Qf], delete b[$0b2e6adb871a3b94$var$Rf]));
    a.stateNode = null;
    a.return = null;
    a.dependencies = null;
    a.memoizedProps = null;
    a.memoizedState = null;
    a.pendingProps = null;
    a.stateNode = null;
    a.updateQueue = null;
}
function $0b2e6adb871a3b94$var$Tj(a) {
    return 5 === a.tag || 3 === a.tag || 4 === a.tag;
}
function $0b2e6adb871a3b94$var$Uj(a) {
    a: for(;;){
        for(; null === a.sibling;){
            if (null === a.return || $0b2e6adb871a3b94$var$Tj(a.return)) return null;
            a = a.return;
        }
        a.sibling.return = a.return;
        for(a = a.sibling; 5 !== a.tag && 6 !== a.tag && 18 !== a.tag;){
            if (a.flags & 2) continue a;
            if (null === a.child || 4 === a.tag) continue a;
            else a.child.return = a, a = a.child;
        }
        if (!(a.flags & 2)) return a.stateNode;
    }
}
function $0b2e6adb871a3b94$var$Vj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? 8 === c.nodeType ? c.parentNode.insertBefore(a, b) : c.insertBefore(a, b) : (8 === c.nodeType ? (b = c.parentNode, b.insertBefore(a, c)) : (b = c, b.appendChild(a)), c = c._reactRootContainer, null !== c && void 0 !== c || null !== b.onclick || (b.onclick = $0b2e6adb871a3b94$var$Bf));
    else if (4 !== d && (a = a.child, null !== a)) for($0b2e6adb871a3b94$var$Vj(a, b, c), a = a.sibling; null !== a;)$0b2e6adb871a3b94$var$Vj(a, b, c), a = a.sibling;
}
function $0b2e6adb871a3b94$var$Wj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? c.insertBefore(a, b) : c.appendChild(a);
    else if (4 !== d && (a = a.child, null !== a)) for($0b2e6adb871a3b94$var$Wj(a, b, c), a = a.sibling; null !== a;)$0b2e6adb871a3b94$var$Wj(a, b, c), a = a.sibling;
}
var $0b2e6adb871a3b94$var$X = null, $0b2e6adb871a3b94$var$Xj = !1;
function $0b2e6adb871a3b94$var$Yj(a, b, c) {
    for(c = c.child; null !== c;)$0b2e6adb871a3b94$var$Zj(a, b, c), c = c.sibling;
}
function $0b2e6adb871a3b94$var$Zj(a, b, c) {
    if ($0b2e6adb871a3b94$var$lc && "function" === typeof $0b2e6adb871a3b94$var$lc.onCommitFiberUnmount) try {
        $0b2e6adb871a3b94$var$lc.onCommitFiberUnmount($0b2e6adb871a3b94$var$kc, c);
    } catch (h) {}
    switch(c.tag){
        case 5:
            $0b2e6adb871a3b94$var$U || $0b2e6adb871a3b94$var$Lj(c, b);
        case 6:
            var d = $0b2e6adb871a3b94$var$X, e = $0b2e6adb871a3b94$var$Xj;
            $0b2e6adb871a3b94$var$X = null;
            $0b2e6adb871a3b94$var$Yj(a, b, c);
            $0b2e6adb871a3b94$var$X = d;
            $0b2e6adb871a3b94$var$Xj = e;
            null !== $0b2e6adb871a3b94$var$X && ($0b2e6adb871a3b94$var$Xj ? (a = $0b2e6adb871a3b94$var$X, c = c.stateNode, 8 === a.nodeType ? a.parentNode.removeChild(c) : a.removeChild(c)) : $0b2e6adb871a3b94$var$X.removeChild(c.stateNode));
            break;
        case 18:
            null !== $0b2e6adb871a3b94$var$X && ($0b2e6adb871a3b94$var$Xj ? (a = $0b2e6adb871a3b94$var$X, c = c.stateNode, 8 === a.nodeType ? $0b2e6adb871a3b94$var$Kf(a.parentNode, c) : 1 === a.nodeType && $0b2e6adb871a3b94$var$Kf(a, c), $0b2e6adb871a3b94$var$bd(a)) : $0b2e6adb871a3b94$var$Kf($0b2e6adb871a3b94$var$X, c.stateNode));
            break;
        case 4:
            d = $0b2e6adb871a3b94$var$X;
            e = $0b2e6adb871a3b94$var$Xj;
            $0b2e6adb871a3b94$var$X = c.stateNode.containerInfo;
            $0b2e6adb871a3b94$var$Xj = !0;
            $0b2e6adb871a3b94$var$Yj(a, b, c);
            $0b2e6adb871a3b94$var$X = d;
            $0b2e6adb871a3b94$var$Xj = e;
            break;
        case 0:
        case 11:
        case 14:
        case 15:
            if (!$0b2e6adb871a3b94$var$U && (d = c.updateQueue, null !== d && (d = d.lastEffect, null !== d))) {
                e = d = d.next;
                do {
                    var f = e, g = f.destroy;
                    f = f.tag;
                    void 0 !== g && (0 !== (f & 2) ? $0b2e6adb871a3b94$var$Mj(c, b, g) : 0 !== (f & 4) && $0b2e6adb871a3b94$var$Mj(c, b, g));
                    e = e.next;
                }while (e !== d);
            }
            $0b2e6adb871a3b94$var$Yj(a, b, c);
            break;
        case 1:
            if (!$0b2e6adb871a3b94$var$U && ($0b2e6adb871a3b94$var$Lj(c, b), d = c.stateNode, "function" === typeof d.componentWillUnmount)) try {
                d.props = c.memoizedProps, d.state = c.memoizedState, d.componentWillUnmount();
            } catch (h) {
                $0b2e6adb871a3b94$var$W(c, b, h);
            }
            $0b2e6adb871a3b94$var$Yj(a, b, c);
            break;
        case 21:
            $0b2e6adb871a3b94$var$Yj(a, b, c);
            break;
        case 22:
            c.mode & 1 ? ($0b2e6adb871a3b94$var$U = (d = $0b2e6adb871a3b94$var$U) || null !== c.memoizedState, $0b2e6adb871a3b94$var$Yj(a, b, c), $0b2e6adb871a3b94$var$U = d) : $0b2e6adb871a3b94$var$Yj(a, b, c);
            break;
        default:
            $0b2e6adb871a3b94$var$Yj(a, b, c);
    }
}
function $0b2e6adb871a3b94$var$ak(a) {
    var b = a.updateQueue;
    if (null !== b) {
        a.updateQueue = null;
        var c = a.stateNode;
        null === c && (c = a.stateNode = new $0b2e6adb871a3b94$var$Kj);
        b.forEach(function(b) {
            var d = $0b2e6adb871a3b94$var$bk.bind(null, a, b);
            c.has(b) || (c.add(b), b.then(d, d));
        });
    }
}
function $0b2e6adb871a3b94$var$ck(a, b) {
    var c = b.deletions;
    if (null !== c) for(var d = 0; d < c.length; d++){
        var e = c[d];
        try {
            var f = a, g = b, h = g;
            a: for(; null !== h;){
                switch(h.tag){
                    case 5:
                        $0b2e6adb871a3b94$var$X = h.stateNode;
                        $0b2e6adb871a3b94$var$Xj = !1;
                        break a;
                    case 3:
                        $0b2e6adb871a3b94$var$X = h.stateNode.containerInfo;
                        $0b2e6adb871a3b94$var$Xj = !0;
                        break a;
                    case 4:
                        $0b2e6adb871a3b94$var$X = h.stateNode.containerInfo;
                        $0b2e6adb871a3b94$var$Xj = !0;
                        break a;
                }
                h = h.return;
            }
            if (null === $0b2e6adb871a3b94$var$X) throw Error($0b2e6adb871a3b94$var$p(160));
            $0b2e6adb871a3b94$var$Zj(f, g, e);
            $0b2e6adb871a3b94$var$X = null;
            $0b2e6adb871a3b94$var$Xj = !1;
            var k = e.alternate;
            null !== k && (k.return = null);
            e.return = null;
        } catch (l) {
            $0b2e6adb871a3b94$var$W(e, b, l);
        }
    }
    if (b.subtreeFlags & 12854) for(b = b.child; null !== b;)$0b2e6adb871a3b94$var$dk(b, a), b = b.sibling;
}
function $0b2e6adb871a3b94$var$dk(a, b) {
    var c = a.alternate, d = a.flags;
    switch(a.tag){
        case 0:
        case 11:
        case 14:
        case 15:
            $0b2e6adb871a3b94$var$ck(b, a);
            $0b2e6adb871a3b94$var$ek(a);
            if (d & 4) {
                try {
                    $0b2e6adb871a3b94$var$Pj(3, a, a.return), $0b2e6adb871a3b94$var$Qj(3, a);
                } catch (t) {
                    $0b2e6adb871a3b94$var$W(a, a.return, t);
                }
                try {
                    $0b2e6adb871a3b94$var$Pj(5, a, a.return);
                } catch (t) {
                    $0b2e6adb871a3b94$var$W(a, a.return, t);
                }
            }
            break;
        case 1:
            $0b2e6adb871a3b94$var$ck(b, a);
            $0b2e6adb871a3b94$var$ek(a);
            d & 512 && null !== c && $0b2e6adb871a3b94$var$Lj(c, c.return);
            break;
        case 5:
            $0b2e6adb871a3b94$var$ck(b, a);
            $0b2e6adb871a3b94$var$ek(a);
            d & 512 && null !== c && $0b2e6adb871a3b94$var$Lj(c, c.return);
            if (a.flags & 32) {
                var e = a.stateNode;
                try {
                    $0b2e6adb871a3b94$var$ob(e, "");
                } catch (t) {
                    $0b2e6adb871a3b94$var$W(a, a.return, t);
                }
            }
            if (d & 4 && (e = a.stateNode, null != e)) {
                var f = a.memoizedProps, g = null !== c ? c.memoizedProps : f, h = a.type, k = a.updateQueue;
                a.updateQueue = null;
                if (null !== k) try {
                    "input" === h && "radio" === f.type && null != f.name && $0b2e6adb871a3b94$var$ab(e, f);
                    $0b2e6adb871a3b94$var$vb(h, g);
                    var l = $0b2e6adb871a3b94$var$vb(h, f);
                    for(g = 0; g < k.length; g += 2){
                        var m = k[g], q = k[g + 1];
                        "style" === m ? $0b2e6adb871a3b94$var$sb(e, q) : "dangerouslySetInnerHTML" === m ? $0b2e6adb871a3b94$var$nb(e, q) : "children" === m ? $0b2e6adb871a3b94$var$ob(e, q) : $0b2e6adb871a3b94$var$ta(e, m, q, l);
                    }
                    switch(h){
                        case "input":
                            $0b2e6adb871a3b94$var$bb(e, f);
                            break;
                        case "textarea":
                            $0b2e6adb871a3b94$var$ib(e, f);
                            break;
                        case "select":
                            var r = e._wrapperState.wasMultiple;
                            e._wrapperState.wasMultiple = !!f.multiple;
                            var y = f.value;
                            null != y ? $0b2e6adb871a3b94$var$fb(e, !!f.multiple, y, !1) : r !== !!f.multiple && (null != f.defaultValue ? $0b2e6adb871a3b94$var$fb(e, !!f.multiple, f.defaultValue, !0) : $0b2e6adb871a3b94$var$fb(e, !!f.multiple, f.multiple ? [] : "", !1));
                    }
                    e[$0b2e6adb871a3b94$var$Pf] = f;
                } catch (t) {
                    $0b2e6adb871a3b94$var$W(a, a.return, t);
                }
            }
            break;
        case 6:
            $0b2e6adb871a3b94$var$ck(b, a);
            $0b2e6adb871a3b94$var$ek(a);
            if (d & 4) {
                if (null === a.stateNode) throw Error($0b2e6adb871a3b94$var$p(162));
                e = a.stateNode;
                f = a.memoizedProps;
                try {
                    e.nodeValue = f;
                } catch (t) {
                    $0b2e6adb871a3b94$var$W(a, a.return, t);
                }
            }
            break;
        case 3:
            $0b2e6adb871a3b94$var$ck(b, a);
            $0b2e6adb871a3b94$var$ek(a);
            if (d & 4 && null !== c && c.memoizedState.isDehydrated) try {
                $0b2e6adb871a3b94$var$bd(b.containerInfo);
            } catch (t) {
                $0b2e6adb871a3b94$var$W(a, a.return, t);
            }
            break;
        case 4:
            $0b2e6adb871a3b94$var$ck(b, a);
            $0b2e6adb871a3b94$var$ek(a);
            break;
        case 13:
            $0b2e6adb871a3b94$var$ck(b, a);
            $0b2e6adb871a3b94$var$ek(a);
            e = a.child;
            e.flags & 8192 && (f = null !== e.memoizedState, e.stateNode.isHidden = f, !f || null !== e.alternate && null !== e.alternate.memoizedState || ($0b2e6adb871a3b94$var$fk = $0b2e6adb871a3b94$var$B()));
            d & 4 && $0b2e6adb871a3b94$var$ak(a);
            break;
        case 22:
            m = null !== c && null !== c.memoizedState;
            a.mode & 1 ? ($0b2e6adb871a3b94$var$U = (l = $0b2e6adb871a3b94$var$U) || m, $0b2e6adb871a3b94$var$ck(b, a), $0b2e6adb871a3b94$var$U = l) : $0b2e6adb871a3b94$var$ck(b, a);
            $0b2e6adb871a3b94$var$ek(a);
            if (d & 8192) {
                l = null !== a.memoizedState;
                if ((a.stateNode.isHidden = l) && !m && 0 !== (a.mode & 1)) for($0b2e6adb871a3b94$var$V = a, m = a.child; null !== m;){
                    for(q = $0b2e6adb871a3b94$var$V = m; null !== $0b2e6adb871a3b94$var$V;){
                        r = $0b2e6adb871a3b94$var$V;
                        y = r.child;
                        switch(r.tag){
                            case 0:
                            case 11:
                            case 14:
                            case 15:
                                $0b2e6adb871a3b94$var$Pj(4, r, r.return);
                                break;
                            case 1:
                                $0b2e6adb871a3b94$var$Lj(r, r.return);
                                var n = r.stateNode;
                                if ("function" === typeof n.componentWillUnmount) {
                                    d = r;
                                    c = r.return;
                                    try {
                                        b = d, n.props = b.memoizedProps, n.state = b.memoizedState, n.componentWillUnmount();
                                    } catch (t) {
                                        $0b2e6adb871a3b94$var$W(d, c, t);
                                    }
                                }
                                break;
                            case 5:
                                $0b2e6adb871a3b94$var$Lj(r, r.return);
                                break;
                            case 22:
                                if (null !== r.memoizedState) {
                                    $0b2e6adb871a3b94$var$gk(q);
                                    continue;
                                }
                        }
                        null !== y ? (y.return = r, $0b2e6adb871a3b94$var$V = y) : $0b2e6adb871a3b94$var$gk(q);
                    }
                    m = m.sibling;
                }
                a: for(m = null, q = a;;){
                    if (5 === q.tag) {
                        if (null === m) {
                            m = q;
                            try {
                                e = q.stateNode, l ? (f = e.style, "function" === typeof f.setProperty ? f.setProperty("display", "none", "important") : f.display = "none") : (h = q.stateNode, k = q.memoizedProps.style, g = void 0 !== k && null !== k && k.hasOwnProperty("display") ? k.display : null, h.style.display = $0b2e6adb871a3b94$var$rb("display", g));
                            } catch (t) {
                                $0b2e6adb871a3b94$var$W(a, a.return, t);
                            }
                        }
                    } else if (6 === q.tag) {
                        if (null === m) try {
                            q.stateNode.nodeValue = l ? "" : q.memoizedProps;
                        } catch (t) {
                            $0b2e6adb871a3b94$var$W(a, a.return, t);
                        }
                    } else if ((22 !== q.tag && 23 !== q.tag || null === q.memoizedState || q === a) && null !== q.child) {
                        q.child.return = q;
                        q = q.child;
                        continue;
                    }
                    if (q === a) break a;
                    for(; null === q.sibling;){
                        if (null === q.return || q.return === a) break a;
                        m === q && (m = null);
                        q = q.return;
                    }
                    m === q && (m = null);
                    q.sibling.return = q.return;
                    q = q.sibling;
                }
            }
            break;
        case 19:
            $0b2e6adb871a3b94$var$ck(b, a);
            $0b2e6adb871a3b94$var$ek(a);
            d & 4 && $0b2e6adb871a3b94$var$ak(a);
            break;
        case 21:
            break;
        default:
            $0b2e6adb871a3b94$var$ck(b, a), $0b2e6adb871a3b94$var$ek(a);
    }
}
function $0b2e6adb871a3b94$var$ek(a) {
    var b = a.flags;
    if (b & 2) {
        try {
            a: {
                for(var c = a.return; null !== c;){
                    if ($0b2e6adb871a3b94$var$Tj(c)) {
                        var d = c;
                        break a;
                    }
                    c = c.return;
                }
                throw Error($0b2e6adb871a3b94$var$p(160));
            }
            switch(d.tag){
                case 5:
                    var e = d.stateNode;
                    d.flags & 32 && ($0b2e6adb871a3b94$var$ob(e, ""), d.flags &= -33);
                    var f = $0b2e6adb871a3b94$var$Uj(a);
                    $0b2e6adb871a3b94$var$Wj(a, f, e);
                    break;
                case 3:
                case 4:
                    var g = d.stateNode.containerInfo, h = $0b2e6adb871a3b94$var$Uj(a);
                    $0b2e6adb871a3b94$var$Vj(a, h, g);
                    break;
                default:
                    throw Error($0b2e6adb871a3b94$var$p(161));
            }
        } catch (k) {
            $0b2e6adb871a3b94$var$W(a, a.return, k);
        }
        a.flags &= -3;
    }
    b & 4096 && (a.flags &= -4097);
}
function $0b2e6adb871a3b94$var$hk(a, b, c) {
    $0b2e6adb871a3b94$var$V = a;
    $0b2e6adb871a3b94$var$ik(a, b, c);
}
function $0b2e6adb871a3b94$var$ik(a, b, c) {
    for(var d = 0 !== (a.mode & 1); null !== $0b2e6adb871a3b94$var$V;){
        var e = $0b2e6adb871a3b94$var$V, f = e.child;
        if (22 === e.tag && d) {
            var g = null !== e.memoizedState || $0b2e6adb871a3b94$var$Jj;
            if (!g) {
                var h = e.alternate, k = null !== h && null !== h.memoizedState || $0b2e6adb871a3b94$var$U;
                h = $0b2e6adb871a3b94$var$Jj;
                var l = $0b2e6adb871a3b94$var$U;
                $0b2e6adb871a3b94$var$Jj = g;
                if (($0b2e6adb871a3b94$var$U = k) && !l) for($0b2e6adb871a3b94$var$V = e; null !== $0b2e6adb871a3b94$var$V;)g = $0b2e6adb871a3b94$var$V, k = g.child, 22 === g.tag && null !== g.memoizedState ? $0b2e6adb871a3b94$var$jk(e) : null !== k ? (k.return = g, $0b2e6adb871a3b94$var$V = k) : $0b2e6adb871a3b94$var$jk(e);
                for(; null !== f;)$0b2e6adb871a3b94$var$V = f, $0b2e6adb871a3b94$var$ik(f, b, c), f = f.sibling;
                $0b2e6adb871a3b94$var$V = e;
                $0b2e6adb871a3b94$var$Jj = h;
                $0b2e6adb871a3b94$var$U = l;
            }
            $0b2e6adb871a3b94$var$kk(a, b, c);
        } else 0 !== (e.subtreeFlags & 8772) && null !== f ? (f.return = e, $0b2e6adb871a3b94$var$V = f) : $0b2e6adb871a3b94$var$kk(a, b, c);
    }
}
function $0b2e6adb871a3b94$var$kk(a) {
    for(; null !== $0b2e6adb871a3b94$var$V;){
        var b = $0b2e6adb871a3b94$var$V;
        if (0 !== (b.flags & 8772)) {
            var c = b.alternate;
            try {
                if (0 !== (b.flags & 8772)) switch(b.tag){
                    case 0:
                    case 11:
                    case 15:
                        $0b2e6adb871a3b94$var$U || $0b2e6adb871a3b94$var$Qj(5, b);
                        break;
                    case 1:
                        var d = b.stateNode;
                        if (b.flags & 4 && !$0b2e6adb871a3b94$var$U) {
                            if (null === c) d.componentDidMount();
                            else {
                                var e = b.elementType === b.type ? c.memoizedProps : $0b2e6adb871a3b94$var$Ci(b.type, c.memoizedProps);
                                d.componentDidUpdate(e, c.memoizedState, d.__reactInternalSnapshotBeforeUpdate);
                            }
                        }
                        var f = b.updateQueue;
                        null !== f && $0b2e6adb871a3b94$var$sh(b, f, d);
                        break;
                    case 3:
                        var g = b.updateQueue;
                        if (null !== g) {
                            c = null;
                            if (null !== b.child) switch(b.child.tag){
                                case 5:
                                    c = b.child.stateNode;
                                    break;
                                case 1:
                                    c = b.child.stateNode;
                            }
                            $0b2e6adb871a3b94$var$sh(b, g, c);
                        }
                        break;
                    case 5:
                        var h = b.stateNode;
                        if (null === c && b.flags & 4) {
                            c = h;
                            var k = b.memoizedProps;
                            switch(b.type){
                                case "button":
                                case "input":
                                case "select":
                                case "textarea":
                                    k.autoFocus && c.focus();
                                    break;
                                case "img":
                                    k.src && (c.src = k.src);
                            }
                        }
                        break;
                    case 6:
                        break;
                    case 4:
                        break;
                    case 12:
                        break;
                    case 13:
                        if (null === b.memoizedState) {
                            var l = b.alternate;
                            if (null !== l) {
                                var m = l.memoizedState;
                                if (null !== m) {
                                    var q = m.dehydrated;
                                    null !== q && $0b2e6adb871a3b94$var$bd(q);
                                }
                            }
                        }
                        break;
                    case 19:
                    case 17:
                    case 21:
                    case 22:
                    case 23:
                    case 25:
                        break;
                    default:
                        throw Error($0b2e6adb871a3b94$var$p(163));
                }
                $0b2e6adb871a3b94$var$U || b.flags & 512 && $0b2e6adb871a3b94$var$Rj(b);
            } catch (r) {
                $0b2e6adb871a3b94$var$W(b, b.return, r);
            }
        }
        if (b === a) {
            $0b2e6adb871a3b94$var$V = null;
            break;
        }
        c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $0b2e6adb871a3b94$var$V = c;
            break;
        }
        $0b2e6adb871a3b94$var$V = b.return;
    }
}
function $0b2e6adb871a3b94$var$gk(a) {
    for(; null !== $0b2e6adb871a3b94$var$V;){
        var b = $0b2e6adb871a3b94$var$V;
        if (b === a) {
            $0b2e6adb871a3b94$var$V = null;
            break;
        }
        var c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $0b2e6adb871a3b94$var$V = c;
            break;
        }
        $0b2e6adb871a3b94$var$V = b.return;
    }
}
function $0b2e6adb871a3b94$var$jk(a) {
    for(; null !== $0b2e6adb871a3b94$var$V;){
        var b = $0b2e6adb871a3b94$var$V;
        try {
            switch(b.tag){
                case 0:
                case 11:
                case 15:
                    var c = b.return;
                    try {
                        $0b2e6adb871a3b94$var$Qj(4, b);
                    } catch (k) {
                        $0b2e6adb871a3b94$var$W(b, c, k);
                    }
                    break;
                case 1:
                    var d = b.stateNode;
                    if ("function" === typeof d.componentDidMount) {
                        var e = b.return;
                        try {
                            d.componentDidMount();
                        } catch (k) {
                            $0b2e6adb871a3b94$var$W(b, e, k);
                        }
                    }
                    var f = b.return;
                    try {
                        $0b2e6adb871a3b94$var$Rj(b);
                    } catch (k) {
                        $0b2e6adb871a3b94$var$W(b, f, k);
                    }
                    break;
                case 5:
                    var g = b.return;
                    try {
                        $0b2e6adb871a3b94$var$Rj(b);
                    } catch (k) {
                        $0b2e6adb871a3b94$var$W(b, g, k);
                    }
            }
        } catch (k) {
            $0b2e6adb871a3b94$var$W(b, b.return, k);
        }
        if (b === a) {
            $0b2e6adb871a3b94$var$V = null;
            break;
        }
        var h = b.sibling;
        if (null !== h) {
            h.return = b.return;
            $0b2e6adb871a3b94$var$V = h;
            break;
        }
        $0b2e6adb871a3b94$var$V = b.return;
    }
}
var $0b2e6adb871a3b94$var$lk = Math.ceil, $0b2e6adb871a3b94$var$mk = $0b2e6adb871a3b94$var$ua.ReactCurrentDispatcher, $0b2e6adb871a3b94$var$nk = $0b2e6adb871a3b94$var$ua.ReactCurrentOwner, $0b2e6adb871a3b94$var$ok = $0b2e6adb871a3b94$var$ua.ReactCurrentBatchConfig, $0b2e6adb871a3b94$var$K = 0, $0b2e6adb871a3b94$var$Q = null, $0b2e6adb871a3b94$var$Y = null, $0b2e6adb871a3b94$var$Z = 0, $0b2e6adb871a3b94$var$fj = 0, $0b2e6adb871a3b94$var$ej = $0b2e6adb871a3b94$var$Uf(0), $0b2e6adb871a3b94$var$T = 0, $0b2e6adb871a3b94$var$pk = null, $0b2e6adb871a3b94$var$rh = 0, $0b2e6adb871a3b94$var$qk = 0, $0b2e6adb871a3b94$var$rk = 0, $0b2e6adb871a3b94$var$sk = null, $0b2e6adb871a3b94$var$tk = null, $0b2e6adb871a3b94$var$fk = 0, $0b2e6adb871a3b94$var$Gj = Infinity, $0b2e6adb871a3b94$var$uk = null, $0b2e6adb871a3b94$var$Oi = !1, $0b2e6adb871a3b94$var$Pi = null, $0b2e6adb871a3b94$var$Ri = null, $0b2e6adb871a3b94$var$vk = !1, $0b2e6adb871a3b94$var$wk = null, $0b2e6adb871a3b94$var$xk = 0, $0b2e6adb871a3b94$var$yk = 0, $0b2e6adb871a3b94$var$zk = null, $0b2e6adb871a3b94$var$Ak = -1, $0b2e6adb871a3b94$var$Bk = 0;
function $0b2e6adb871a3b94$var$R() {
    return 0 !== ($0b2e6adb871a3b94$var$K & 6) ? $0b2e6adb871a3b94$var$B() : -1 !== $0b2e6adb871a3b94$var$Ak ? $0b2e6adb871a3b94$var$Ak : $0b2e6adb871a3b94$var$Ak = $0b2e6adb871a3b94$var$B();
}
function $0b2e6adb871a3b94$var$yi(a) {
    if (0 === (a.mode & 1)) return 1;
    if (0 !== ($0b2e6adb871a3b94$var$K & 2) && 0 !== $0b2e6adb871a3b94$var$Z) return $0b2e6adb871a3b94$var$Z & -$0b2e6adb871a3b94$var$Z;
    if (null !== $0b2e6adb871a3b94$var$Kg.transition) return 0 === $0b2e6adb871a3b94$var$Bk && ($0b2e6adb871a3b94$var$Bk = $0b2e6adb871a3b94$var$yc()), $0b2e6adb871a3b94$var$Bk;
    a = $0b2e6adb871a3b94$var$C;
    if (0 !== a) return a;
    a = window.event;
    a = void 0 === a ? 16 : $0b2e6adb871a3b94$var$jd(a.type);
    return a;
}
function $0b2e6adb871a3b94$var$gi(a, b, c, d) {
    if (50 < $0b2e6adb871a3b94$var$yk) throw $0b2e6adb871a3b94$var$yk = 0, $0b2e6adb871a3b94$var$zk = null, Error($0b2e6adb871a3b94$var$p(185));
    $0b2e6adb871a3b94$var$Ac(a, c, d);
    if (0 === ($0b2e6adb871a3b94$var$K & 2) || a !== $0b2e6adb871a3b94$var$Q) a === $0b2e6adb871a3b94$var$Q && (0 === ($0b2e6adb871a3b94$var$K & 2) && ($0b2e6adb871a3b94$var$qk |= c), 4 === $0b2e6adb871a3b94$var$T && $0b2e6adb871a3b94$var$Ck(a, $0b2e6adb871a3b94$var$Z)), $0b2e6adb871a3b94$var$Dk(a, d), 1 === c && 0 === $0b2e6adb871a3b94$var$K && 0 === (b.mode & 1) && ($0b2e6adb871a3b94$var$Gj = $0b2e6adb871a3b94$var$B() + 500, $0b2e6adb871a3b94$var$fg && $0b2e6adb871a3b94$var$jg());
}
function $0b2e6adb871a3b94$var$Dk(a, b) {
    var c = a.callbackNode;
    $0b2e6adb871a3b94$var$wc(a, b);
    var d = $0b2e6adb871a3b94$var$uc(a, a === $0b2e6adb871a3b94$var$Q ? $0b2e6adb871a3b94$var$Z : 0);
    if (0 === d) null !== c && $0b2e6adb871a3b94$var$bc(c), a.callbackNode = null, a.callbackPriority = 0;
    else if (b = d & -d, a.callbackPriority !== b) {
        null != c && $0b2e6adb871a3b94$var$bc(c);
        if (1 === b) 0 === a.tag ? $0b2e6adb871a3b94$var$ig($0b2e6adb871a3b94$var$Ek.bind(null, a)) : $0b2e6adb871a3b94$var$hg($0b2e6adb871a3b94$var$Ek.bind(null, a)), $0b2e6adb871a3b94$var$Jf(function() {
            0 === ($0b2e6adb871a3b94$var$K & 6) && $0b2e6adb871a3b94$var$jg();
        }), c = null;
        else {
            switch($0b2e6adb871a3b94$var$Dc(d)){
                case 1:
                    c = $0b2e6adb871a3b94$var$fc;
                    break;
                case 4:
                    c = $0b2e6adb871a3b94$var$gc;
                    break;
                case 16:
                    c = $0b2e6adb871a3b94$var$hc;
                    break;
                case 536870912:
                    c = $0b2e6adb871a3b94$var$jc;
                    break;
                default:
                    c = $0b2e6adb871a3b94$var$hc;
            }
            c = $0b2e6adb871a3b94$var$Fk(c, $0b2e6adb871a3b94$var$Gk.bind(null, a));
        }
        a.callbackPriority = b;
        a.callbackNode = c;
    }
}
function $0b2e6adb871a3b94$var$Gk(a, b) {
    $0b2e6adb871a3b94$var$Ak = -1;
    $0b2e6adb871a3b94$var$Bk = 0;
    if (0 !== ($0b2e6adb871a3b94$var$K & 6)) throw Error($0b2e6adb871a3b94$var$p(327));
    var c = a.callbackNode;
    if ($0b2e6adb871a3b94$var$Hk() && a.callbackNode !== c) return null;
    var d = $0b2e6adb871a3b94$var$uc(a, a === $0b2e6adb871a3b94$var$Q ? $0b2e6adb871a3b94$var$Z : 0);
    if (0 === d) return null;
    if (0 !== (d & 30) || 0 !== (d & a.expiredLanes) || b) b = $0b2e6adb871a3b94$var$Ik(a, d);
    else {
        b = d;
        var e = $0b2e6adb871a3b94$var$K;
        $0b2e6adb871a3b94$var$K |= 2;
        var f = $0b2e6adb871a3b94$var$Jk();
        if ($0b2e6adb871a3b94$var$Q !== a || $0b2e6adb871a3b94$var$Z !== b) $0b2e6adb871a3b94$var$uk = null, $0b2e6adb871a3b94$var$Gj = $0b2e6adb871a3b94$var$B() + 500, $0b2e6adb871a3b94$var$Kk(a, b);
        for(;;)try {
            $0b2e6adb871a3b94$var$Lk();
            break;
        } catch (h) {
            $0b2e6adb871a3b94$var$Mk(a, h);
        }
        $0b2e6adb871a3b94$var$$g();
        $0b2e6adb871a3b94$var$mk.current = f;
        $0b2e6adb871a3b94$var$K = e;
        null !== $0b2e6adb871a3b94$var$Y ? b = 0 : ($0b2e6adb871a3b94$var$Q = null, $0b2e6adb871a3b94$var$Z = 0, b = $0b2e6adb871a3b94$var$T);
    }
    if (0 !== b) {
        2 === b && (e = $0b2e6adb871a3b94$var$xc(a), 0 !== e && (d = e, b = $0b2e6adb871a3b94$var$Nk(a, e)));
        if (1 === b) throw c = $0b2e6adb871a3b94$var$pk, $0b2e6adb871a3b94$var$Kk(a, 0), $0b2e6adb871a3b94$var$Ck(a, d), $0b2e6adb871a3b94$var$Dk(a, $0b2e6adb871a3b94$var$B()), c;
        if (6 === b) $0b2e6adb871a3b94$var$Ck(a, d);
        else {
            e = a.current.alternate;
            if (0 === (d & 30) && !$0b2e6adb871a3b94$var$Ok(e) && (b = $0b2e6adb871a3b94$var$Ik(a, d), 2 === b && (f = $0b2e6adb871a3b94$var$xc(a), 0 !== f && (d = f, b = $0b2e6adb871a3b94$var$Nk(a, f))), 1 === b)) throw c = $0b2e6adb871a3b94$var$pk, $0b2e6adb871a3b94$var$Kk(a, 0), $0b2e6adb871a3b94$var$Ck(a, d), $0b2e6adb871a3b94$var$Dk(a, $0b2e6adb871a3b94$var$B()), c;
            a.finishedWork = e;
            a.finishedLanes = d;
            switch(b){
                case 0:
                case 1:
                    throw Error($0b2e6adb871a3b94$var$p(345));
                case 2:
                    $0b2e6adb871a3b94$var$Pk(a, $0b2e6adb871a3b94$var$tk, $0b2e6adb871a3b94$var$uk);
                    break;
                case 3:
                    $0b2e6adb871a3b94$var$Ck(a, d);
                    if ((d & 130023424) === d && (b = $0b2e6adb871a3b94$var$fk + 500 - $0b2e6adb871a3b94$var$B(), 10 < b)) {
                        if (0 !== $0b2e6adb871a3b94$var$uc(a, 0)) break;
                        e = a.suspendedLanes;
                        if ((e & d) !== d) {
                            $0b2e6adb871a3b94$var$R();
                            a.pingedLanes |= a.suspendedLanes & e;
                            break;
                        }
                        a.timeoutHandle = $0b2e6adb871a3b94$var$Ff($0b2e6adb871a3b94$var$Pk.bind(null, a, $0b2e6adb871a3b94$var$tk, $0b2e6adb871a3b94$var$uk), b);
                        break;
                    }
                    $0b2e6adb871a3b94$var$Pk(a, $0b2e6adb871a3b94$var$tk, $0b2e6adb871a3b94$var$uk);
                    break;
                case 4:
                    $0b2e6adb871a3b94$var$Ck(a, d);
                    if ((d & 4194240) === d) break;
                    b = a.eventTimes;
                    for(e = -1; 0 < d;){
                        var g = 31 - $0b2e6adb871a3b94$var$oc(d);
                        f = 1 << g;
                        g = b[g];
                        g > e && (e = g);
                        d &= ~f;
                    }
                    d = e;
                    d = $0b2e6adb871a3b94$var$B() - d;
                    d = (120 > d ? 120 : 480 > d ? 480 : 1080 > d ? 1080 : 1920 > d ? 1920 : 3E3 > d ? 3E3 : 4320 > d ? 4320 : 1960 * $0b2e6adb871a3b94$var$lk(d / 1960)) - d;
                    if (10 < d) {
                        a.timeoutHandle = $0b2e6adb871a3b94$var$Ff($0b2e6adb871a3b94$var$Pk.bind(null, a, $0b2e6adb871a3b94$var$tk, $0b2e6adb871a3b94$var$uk), d);
                        break;
                    }
                    $0b2e6adb871a3b94$var$Pk(a, $0b2e6adb871a3b94$var$tk, $0b2e6adb871a3b94$var$uk);
                    break;
                case 5:
                    $0b2e6adb871a3b94$var$Pk(a, $0b2e6adb871a3b94$var$tk, $0b2e6adb871a3b94$var$uk);
                    break;
                default:
                    throw Error($0b2e6adb871a3b94$var$p(329));
            }
        }
    }
    $0b2e6adb871a3b94$var$Dk(a, $0b2e6adb871a3b94$var$B());
    return a.callbackNode === c ? $0b2e6adb871a3b94$var$Gk.bind(null, a) : null;
}
function $0b2e6adb871a3b94$var$Nk(a, b) {
    var c = $0b2e6adb871a3b94$var$sk;
    a.current.memoizedState.isDehydrated && ($0b2e6adb871a3b94$var$Kk(a, b).flags |= 256);
    a = $0b2e6adb871a3b94$var$Ik(a, b);
    2 !== a && (b = $0b2e6adb871a3b94$var$tk, $0b2e6adb871a3b94$var$tk = c, null !== b && $0b2e6adb871a3b94$var$Fj(b));
    return a;
}
function $0b2e6adb871a3b94$var$Fj(a) {
    null === $0b2e6adb871a3b94$var$tk ? $0b2e6adb871a3b94$var$tk = a : $0b2e6adb871a3b94$var$tk.push.apply($0b2e6adb871a3b94$var$tk, a);
}
function $0b2e6adb871a3b94$var$Ok(a) {
    for(var b = a;;){
        if (b.flags & 16384) {
            var c = b.updateQueue;
            if (null !== c && (c = c.stores, null !== c)) for(var d = 0; d < c.length; d++){
                var e = c[d], f = e.getSnapshot;
                e = e.value;
                try {
                    if (!$0b2e6adb871a3b94$var$He(f(), e)) return !1;
                } catch (g) {
                    return !1;
                }
            }
        }
        c = b.child;
        if (b.subtreeFlags & 16384 && null !== c) c.return = b, b = c;
        else {
            if (b === a) break;
            for(; null === b.sibling;){
                if (null === b.return || b.return === a) return !0;
                b = b.return;
            }
            b.sibling.return = b.return;
            b = b.sibling;
        }
    }
    return !0;
}
function $0b2e6adb871a3b94$var$Ck(a, b) {
    b &= ~$0b2e6adb871a3b94$var$rk;
    b &= ~$0b2e6adb871a3b94$var$qk;
    a.suspendedLanes |= b;
    a.pingedLanes &= ~b;
    for(a = a.expirationTimes; 0 < b;){
        var c = 31 - $0b2e6adb871a3b94$var$oc(b), d = 1 << c;
        a[c] = -1;
        b &= ~d;
    }
}
function $0b2e6adb871a3b94$var$Ek(a) {
    if (0 !== ($0b2e6adb871a3b94$var$K & 6)) throw Error($0b2e6adb871a3b94$var$p(327));
    $0b2e6adb871a3b94$var$Hk();
    var b = $0b2e6adb871a3b94$var$uc(a, 0);
    if (0 === (b & 1)) return $0b2e6adb871a3b94$var$Dk(a, $0b2e6adb871a3b94$var$B()), null;
    var c = $0b2e6adb871a3b94$var$Ik(a, b);
    if (0 !== a.tag && 2 === c) {
        var d = $0b2e6adb871a3b94$var$xc(a);
        0 !== d && (b = d, c = $0b2e6adb871a3b94$var$Nk(a, d));
    }
    if (1 === c) throw c = $0b2e6adb871a3b94$var$pk, $0b2e6adb871a3b94$var$Kk(a, 0), $0b2e6adb871a3b94$var$Ck(a, b), $0b2e6adb871a3b94$var$Dk(a, $0b2e6adb871a3b94$var$B()), c;
    if (6 === c) throw Error($0b2e6adb871a3b94$var$p(345));
    a.finishedWork = a.current.alternate;
    a.finishedLanes = b;
    $0b2e6adb871a3b94$var$Pk(a, $0b2e6adb871a3b94$var$tk, $0b2e6adb871a3b94$var$uk);
    $0b2e6adb871a3b94$var$Dk(a, $0b2e6adb871a3b94$var$B());
    return null;
}
function $0b2e6adb871a3b94$var$Qk(a, b) {
    var c = $0b2e6adb871a3b94$var$K;
    $0b2e6adb871a3b94$var$K |= 1;
    try {
        return a(b);
    } finally{
        $0b2e6adb871a3b94$var$K = c, 0 === $0b2e6adb871a3b94$var$K && ($0b2e6adb871a3b94$var$Gj = $0b2e6adb871a3b94$var$B() + 500, $0b2e6adb871a3b94$var$fg && $0b2e6adb871a3b94$var$jg());
    }
}
function $0b2e6adb871a3b94$var$Rk(a) {
    null !== $0b2e6adb871a3b94$var$wk && 0 === $0b2e6adb871a3b94$var$wk.tag && 0 === ($0b2e6adb871a3b94$var$K & 6) && $0b2e6adb871a3b94$var$Hk();
    var b = $0b2e6adb871a3b94$var$K;
    $0b2e6adb871a3b94$var$K |= 1;
    var c = $0b2e6adb871a3b94$var$ok.transition, d = $0b2e6adb871a3b94$var$C;
    try {
        if ($0b2e6adb871a3b94$var$ok.transition = null, $0b2e6adb871a3b94$var$C = 1, a) return a();
    } finally{
        $0b2e6adb871a3b94$var$C = d, $0b2e6adb871a3b94$var$ok.transition = c, $0b2e6adb871a3b94$var$K = b, 0 === ($0b2e6adb871a3b94$var$K & 6) && $0b2e6adb871a3b94$var$jg();
    }
}
function $0b2e6adb871a3b94$var$Hj() {
    $0b2e6adb871a3b94$var$fj = $0b2e6adb871a3b94$var$ej.current;
    $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$ej);
}
function $0b2e6adb871a3b94$var$Kk(a, b) {
    a.finishedWork = null;
    a.finishedLanes = 0;
    var c = a.timeoutHandle;
    -1 !== c && (a.timeoutHandle = -1, $0b2e6adb871a3b94$var$Gf(c));
    if (null !== $0b2e6adb871a3b94$var$Y) for(c = $0b2e6adb871a3b94$var$Y.return; null !== c;){
        var d = c;
        $0b2e6adb871a3b94$var$wg(d);
        switch(d.tag){
            case 1:
                d = d.type.childContextTypes;
                null !== d && void 0 !== d && $0b2e6adb871a3b94$var$$f();
                break;
            case 3:
                $0b2e6adb871a3b94$var$zh();
                $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Wf);
                $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$H);
                $0b2e6adb871a3b94$var$Eh();
                break;
            case 5:
                $0b2e6adb871a3b94$var$Bh(d);
                break;
            case 4:
                $0b2e6adb871a3b94$var$zh();
                break;
            case 13:
                $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$L);
                break;
            case 19:
                $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$L);
                break;
            case 10:
                $0b2e6adb871a3b94$var$ah(d.type._context);
                break;
            case 22:
            case 23:
                $0b2e6adb871a3b94$var$Hj();
        }
        c = c.return;
    }
    $0b2e6adb871a3b94$var$Q = a;
    $0b2e6adb871a3b94$var$Y = a = $0b2e6adb871a3b94$var$Pg(a.current, null);
    $0b2e6adb871a3b94$var$Z = $0b2e6adb871a3b94$var$fj = b;
    $0b2e6adb871a3b94$var$T = 0;
    $0b2e6adb871a3b94$var$pk = null;
    $0b2e6adb871a3b94$var$rk = $0b2e6adb871a3b94$var$qk = $0b2e6adb871a3b94$var$rh = 0;
    $0b2e6adb871a3b94$var$tk = $0b2e6adb871a3b94$var$sk = null;
    if (null !== $0b2e6adb871a3b94$var$fh) {
        for(b = 0; b < $0b2e6adb871a3b94$var$fh.length; b++)if (c = $0b2e6adb871a3b94$var$fh[b], d = c.interleaved, null !== d) {
            c.interleaved = null;
            var e = d.next, f = c.pending;
            if (null !== f) {
                var g = f.next;
                f.next = e;
                d.next = g;
            }
            c.pending = d;
        }
        $0b2e6adb871a3b94$var$fh = null;
    }
    return a;
}
function $0b2e6adb871a3b94$var$Mk(a, b) {
    do {
        var c = $0b2e6adb871a3b94$var$Y;
        try {
            $0b2e6adb871a3b94$var$$g();
            $0b2e6adb871a3b94$var$Fh.current = $0b2e6adb871a3b94$var$Rh;
            if ($0b2e6adb871a3b94$var$Ih) {
                for(var d = $0b2e6adb871a3b94$var$M.memoizedState; null !== d;){
                    var e = d.queue;
                    null !== e && (e.pending = null);
                    d = d.next;
                }
                $0b2e6adb871a3b94$var$Ih = !1;
            }
            $0b2e6adb871a3b94$var$Hh = 0;
            $0b2e6adb871a3b94$var$O = $0b2e6adb871a3b94$var$N = $0b2e6adb871a3b94$var$M = null;
            $0b2e6adb871a3b94$var$Jh = !1;
            $0b2e6adb871a3b94$var$Kh = 0;
            $0b2e6adb871a3b94$var$nk.current = null;
            if (null === c || null === c.return) {
                $0b2e6adb871a3b94$var$T = 1;
                $0b2e6adb871a3b94$var$pk = b;
                $0b2e6adb871a3b94$var$Y = null;
                break;
            }
            a: {
                var f = a, g = c.return, h = c, k = b;
                b = $0b2e6adb871a3b94$var$Z;
                h.flags |= 32768;
                if (null !== k && "object" === typeof k && "function" === typeof k.then) {
                    var l = k, m = h, q = m.tag;
                    if (0 === (m.mode & 1) && (0 === q || 11 === q || 15 === q)) {
                        var r = m.alternate;
                        r ? (m.updateQueue = r.updateQueue, m.memoizedState = r.memoizedState, m.lanes = r.lanes) : (m.updateQueue = null, m.memoizedState = null);
                    }
                    var y = $0b2e6adb871a3b94$var$Ui(g);
                    if (null !== y) {
                        y.flags &= -257;
                        $0b2e6adb871a3b94$var$Vi(y, g, h, f, b);
                        y.mode & 1 && $0b2e6adb871a3b94$var$Si(f, l, b);
                        b = y;
                        k = l;
                        var n = b.updateQueue;
                        if (null === n) {
                            var t = new Set;
                            t.add(k);
                            b.updateQueue = t;
                        } else n.add(k);
                        break a;
                    } else {
                        if (0 === (b & 1)) {
                            $0b2e6adb871a3b94$var$Si(f, l, b);
                            $0b2e6adb871a3b94$var$tj();
                            break a;
                        }
                        k = Error($0b2e6adb871a3b94$var$p(426));
                    }
                } else if ($0b2e6adb871a3b94$var$I && h.mode & 1) {
                    var J = $0b2e6adb871a3b94$var$Ui(g);
                    if (null !== J) {
                        0 === (J.flags & 65536) && (J.flags |= 256);
                        $0b2e6adb871a3b94$var$Vi(J, g, h, f, b);
                        $0b2e6adb871a3b94$var$Jg($0b2e6adb871a3b94$var$Ji(k, h));
                        break a;
                    }
                }
                f = k = $0b2e6adb871a3b94$var$Ji(k, h);
                4 !== $0b2e6adb871a3b94$var$T && ($0b2e6adb871a3b94$var$T = 2);
                null === $0b2e6adb871a3b94$var$sk ? $0b2e6adb871a3b94$var$sk = [
                    f
                ] : $0b2e6adb871a3b94$var$sk.push(f);
                f = g;
                do {
                    switch(f.tag){
                        case 3:
                            f.flags |= 65536;
                            b &= -b;
                            f.lanes |= b;
                            var x = $0b2e6adb871a3b94$var$Ni(f, k, b);
                            $0b2e6adb871a3b94$var$ph(f, x);
                            break a;
                        case 1:
                            h = k;
                            var w = f.type, u = f.stateNode;
                            if (0 === (f.flags & 128) && ("function" === typeof w.getDerivedStateFromError || null !== u && "function" === typeof u.componentDidCatch && (null === $0b2e6adb871a3b94$var$Ri || !$0b2e6adb871a3b94$var$Ri.has(u)))) {
                                f.flags |= 65536;
                                b &= -b;
                                f.lanes |= b;
                                var F = $0b2e6adb871a3b94$var$Qi(f, h, b);
                                $0b2e6adb871a3b94$var$ph(f, F);
                                break a;
                            }
                    }
                    f = f.return;
                }while (null !== f);
            }
            $0b2e6adb871a3b94$var$Sk(c);
        } catch (na) {
            b = na;
            $0b2e6adb871a3b94$var$Y === c && null !== c && ($0b2e6adb871a3b94$var$Y = c = c.return);
            continue;
        }
        break;
    }while (1);
}
function $0b2e6adb871a3b94$var$Jk() {
    var a = $0b2e6adb871a3b94$var$mk.current;
    $0b2e6adb871a3b94$var$mk.current = $0b2e6adb871a3b94$var$Rh;
    return null === a ? $0b2e6adb871a3b94$var$Rh : a;
}
function $0b2e6adb871a3b94$var$tj() {
    if (0 === $0b2e6adb871a3b94$var$T || 3 === $0b2e6adb871a3b94$var$T || 2 === $0b2e6adb871a3b94$var$T) $0b2e6adb871a3b94$var$T = 4;
    null === $0b2e6adb871a3b94$var$Q || 0 === ($0b2e6adb871a3b94$var$rh & 268435455) && 0 === ($0b2e6adb871a3b94$var$qk & 268435455) || $0b2e6adb871a3b94$var$Ck($0b2e6adb871a3b94$var$Q, $0b2e6adb871a3b94$var$Z);
}
function $0b2e6adb871a3b94$var$Ik(a, b) {
    var c = $0b2e6adb871a3b94$var$K;
    $0b2e6adb871a3b94$var$K |= 2;
    var d = $0b2e6adb871a3b94$var$Jk();
    if ($0b2e6adb871a3b94$var$Q !== a || $0b2e6adb871a3b94$var$Z !== b) $0b2e6adb871a3b94$var$uk = null, $0b2e6adb871a3b94$var$Kk(a, b);
    for(;;)try {
        $0b2e6adb871a3b94$var$Tk();
        break;
    } catch (e) {
        $0b2e6adb871a3b94$var$Mk(a, e);
    }
    $0b2e6adb871a3b94$var$$g();
    $0b2e6adb871a3b94$var$K = c;
    $0b2e6adb871a3b94$var$mk.current = d;
    if (null !== $0b2e6adb871a3b94$var$Y) throw Error($0b2e6adb871a3b94$var$p(261));
    $0b2e6adb871a3b94$var$Q = null;
    $0b2e6adb871a3b94$var$Z = 0;
    return $0b2e6adb871a3b94$var$T;
}
function $0b2e6adb871a3b94$var$Tk() {
    for(; null !== $0b2e6adb871a3b94$var$Y;)$0b2e6adb871a3b94$var$Uk($0b2e6adb871a3b94$var$Y);
}
function $0b2e6adb871a3b94$var$Lk() {
    for(; null !== $0b2e6adb871a3b94$var$Y && !$0b2e6adb871a3b94$var$cc();)$0b2e6adb871a3b94$var$Uk($0b2e6adb871a3b94$var$Y);
}
function $0b2e6adb871a3b94$var$Uk(a) {
    var b = $0b2e6adb871a3b94$var$Vk(a.alternate, a, $0b2e6adb871a3b94$var$fj);
    a.memoizedProps = a.pendingProps;
    null === b ? $0b2e6adb871a3b94$var$Sk(a) : $0b2e6adb871a3b94$var$Y = b;
    $0b2e6adb871a3b94$var$nk.current = null;
}
function $0b2e6adb871a3b94$var$Sk(a) {
    var b = a;
    do {
        var c = b.alternate;
        a = b.return;
        if (0 === (b.flags & 32768)) {
            if (c = $0b2e6adb871a3b94$var$Ej(c, b, $0b2e6adb871a3b94$var$fj), null !== c) {
                $0b2e6adb871a3b94$var$Y = c;
                return;
            }
        } else {
            c = $0b2e6adb871a3b94$var$Ij(c, b);
            if (null !== c) {
                c.flags &= 32767;
                $0b2e6adb871a3b94$var$Y = c;
                return;
            }
            if (null !== a) a.flags |= 32768, a.subtreeFlags = 0, a.deletions = null;
            else {
                $0b2e6adb871a3b94$var$T = 6;
                $0b2e6adb871a3b94$var$Y = null;
                return;
            }
        }
        b = b.sibling;
        if (null !== b) {
            $0b2e6adb871a3b94$var$Y = b;
            return;
        }
        $0b2e6adb871a3b94$var$Y = b = a;
    }while (null !== b);
    0 === $0b2e6adb871a3b94$var$T && ($0b2e6adb871a3b94$var$T = 5);
}
function $0b2e6adb871a3b94$var$Pk(a, b, c) {
    var d = $0b2e6adb871a3b94$var$C, e = $0b2e6adb871a3b94$var$ok.transition;
    try {
        $0b2e6adb871a3b94$var$ok.transition = null, $0b2e6adb871a3b94$var$C = 1, $0b2e6adb871a3b94$var$Wk(a, b, c, d);
    } finally{
        $0b2e6adb871a3b94$var$ok.transition = e, $0b2e6adb871a3b94$var$C = d;
    }
    return null;
}
function $0b2e6adb871a3b94$var$Wk(a, b, c, d) {
    do $0b2e6adb871a3b94$var$Hk();
    while (null !== $0b2e6adb871a3b94$var$wk);
    if (0 !== ($0b2e6adb871a3b94$var$K & 6)) throw Error($0b2e6adb871a3b94$var$p(327));
    c = a.finishedWork;
    var e = a.finishedLanes;
    if (null === c) return null;
    a.finishedWork = null;
    a.finishedLanes = 0;
    if (c === a.current) throw Error($0b2e6adb871a3b94$var$p(177));
    a.callbackNode = null;
    a.callbackPriority = 0;
    var f = c.lanes | c.childLanes;
    $0b2e6adb871a3b94$var$Bc(a, f);
    a === $0b2e6adb871a3b94$var$Q && ($0b2e6adb871a3b94$var$Y = $0b2e6adb871a3b94$var$Q = null, $0b2e6adb871a3b94$var$Z = 0);
    0 === (c.subtreeFlags & 2064) && 0 === (c.flags & 2064) || $0b2e6adb871a3b94$var$vk || ($0b2e6adb871a3b94$var$vk = !0, $0b2e6adb871a3b94$var$Fk($0b2e6adb871a3b94$var$hc, function() {
        $0b2e6adb871a3b94$var$Hk();
        return null;
    }));
    f = 0 !== (c.flags & 15990);
    if (0 !== (c.subtreeFlags & 15990) || f) {
        f = $0b2e6adb871a3b94$var$ok.transition;
        $0b2e6adb871a3b94$var$ok.transition = null;
        var g = $0b2e6adb871a3b94$var$C;
        $0b2e6adb871a3b94$var$C = 1;
        var h = $0b2e6adb871a3b94$var$K;
        $0b2e6adb871a3b94$var$K |= 4;
        $0b2e6adb871a3b94$var$nk.current = null;
        $0b2e6adb871a3b94$var$Oj(a, c);
        $0b2e6adb871a3b94$var$dk(c, a);
        $0b2e6adb871a3b94$var$Oe($0b2e6adb871a3b94$var$Df);
        $0b2e6adb871a3b94$var$dd = !!$0b2e6adb871a3b94$var$Cf;
        $0b2e6adb871a3b94$var$Df = $0b2e6adb871a3b94$var$Cf = null;
        a.current = c;
        $0b2e6adb871a3b94$var$hk(c, a, e);
        $0b2e6adb871a3b94$var$dc();
        $0b2e6adb871a3b94$var$K = h;
        $0b2e6adb871a3b94$var$C = g;
        $0b2e6adb871a3b94$var$ok.transition = f;
    } else a.current = c;
    $0b2e6adb871a3b94$var$vk && ($0b2e6adb871a3b94$var$vk = !1, $0b2e6adb871a3b94$var$wk = a, $0b2e6adb871a3b94$var$xk = e);
    f = a.pendingLanes;
    0 === f && ($0b2e6adb871a3b94$var$Ri = null);
    $0b2e6adb871a3b94$var$mc(c.stateNode, d);
    $0b2e6adb871a3b94$var$Dk(a, $0b2e6adb871a3b94$var$B());
    if (null !== b) for(d = a.onRecoverableError, c = 0; c < b.length; c++)e = b[c], d(e.value, {
        componentStack: e.stack,
        digest: e.digest
    });
    if ($0b2e6adb871a3b94$var$Oi) throw $0b2e6adb871a3b94$var$Oi = !1, a = $0b2e6adb871a3b94$var$Pi, $0b2e6adb871a3b94$var$Pi = null, a;
    0 !== ($0b2e6adb871a3b94$var$xk & 1) && 0 !== a.tag && $0b2e6adb871a3b94$var$Hk();
    f = a.pendingLanes;
    0 !== (f & 1) ? a === $0b2e6adb871a3b94$var$zk ? $0b2e6adb871a3b94$var$yk++ : ($0b2e6adb871a3b94$var$yk = 0, $0b2e6adb871a3b94$var$zk = a) : $0b2e6adb871a3b94$var$yk = 0;
    $0b2e6adb871a3b94$var$jg();
    return null;
}
function $0b2e6adb871a3b94$var$Hk() {
    if (null !== $0b2e6adb871a3b94$var$wk) {
        var a = $0b2e6adb871a3b94$var$Dc($0b2e6adb871a3b94$var$xk), b = $0b2e6adb871a3b94$var$ok.transition, c = $0b2e6adb871a3b94$var$C;
        try {
            $0b2e6adb871a3b94$var$ok.transition = null;
            $0b2e6adb871a3b94$var$C = 16 > a ? 16 : a;
            if (null === $0b2e6adb871a3b94$var$wk) var d = !1;
            else {
                a = $0b2e6adb871a3b94$var$wk;
                $0b2e6adb871a3b94$var$wk = null;
                $0b2e6adb871a3b94$var$xk = 0;
                if (0 !== ($0b2e6adb871a3b94$var$K & 6)) throw Error($0b2e6adb871a3b94$var$p(331));
                var e = $0b2e6adb871a3b94$var$K;
                $0b2e6adb871a3b94$var$K |= 4;
                for($0b2e6adb871a3b94$var$V = a.current; null !== $0b2e6adb871a3b94$var$V;){
                    var f = $0b2e6adb871a3b94$var$V, g = f.child;
                    if (0 !== ($0b2e6adb871a3b94$var$V.flags & 16)) {
                        var h = f.deletions;
                        if (null !== h) {
                            for(var k = 0; k < h.length; k++){
                                var l = h[k];
                                for($0b2e6adb871a3b94$var$V = l; null !== $0b2e6adb871a3b94$var$V;){
                                    var m = $0b2e6adb871a3b94$var$V;
                                    switch(m.tag){
                                        case 0:
                                        case 11:
                                        case 15:
                                            $0b2e6adb871a3b94$var$Pj(8, m, f);
                                    }
                                    var q = m.child;
                                    if (null !== q) q.return = m, $0b2e6adb871a3b94$var$V = q;
                                    else for(; null !== $0b2e6adb871a3b94$var$V;){
                                        m = $0b2e6adb871a3b94$var$V;
                                        var r = m.sibling, y = m.return;
                                        $0b2e6adb871a3b94$var$Sj(m);
                                        if (m === l) {
                                            $0b2e6adb871a3b94$var$V = null;
                                            break;
                                        }
                                        if (null !== r) {
                                            r.return = y;
                                            $0b2e6adb871a3b94$var$V = r;
                                            break;
                                        }
                                        $0b2e6adb871a3b94$var$V = y;
                                    }
                                }
                            }
                            var n = f.alternate;
                            if (null !== n) {
                                var t = n.child;
                                if (null !== t) {
                                    n.child = null;
                                    do {
                                        var J = t.sibling;
                                        t.sibling = null;
                                        t = J;
                                    }while (null !== t);
                                }
                            }
                            $0b2e6adb871a3b94$var$V = f;
                        }
                    }
                    if (0 !== (f.subtreeFlags & 2064) && null !== g) g.return = f, $0b2e6adb871a3b94$var$V = g;
                    else b: for(; null !== $0b2e6adb871a3b94$var$V;){
                        f = $0b2e6adb871a3b94$var$V;
                        if (0 !== (f.flags & 2048)) switch(f.tag){
                            case 0:
                            case 11:
                            case 15:
                                $0b2e6adb871a3b94$var$Pj(9, f, f.return);
                        }
                        var x = f.sibling;
                        if (null !== x) {
                            x.return = f.return;
                            $0b2e6adb871a3b94$var$V = x;
                            break b;
                        }
                        $0b2e6adb871a3b94$var$V = f.return;
                    }
                }
                var w = a.current;
                for($0b2e6adb871a3b94$var$V = w; null !== $0b2e6adb871a3b94$var$V;){
                    g = $0b2e6adb871a3b94$var$V;
                    var u = g.child;
                    if (0 !== (g.subtreeFlags & 2064) && null !== u) u.return = g, $0b2e6adb871a3b94$var$V = u;
                    else b: for(g = w; null !== $0b2e6adb871a3b94$var$V;){
                        h = $0b2e6adb871a3b94$var$V;
                        if (0 !== (h.flags & 2048)) try {
                            switch(h.tag){
                                case 0:
                                case 11:
                                case 15:
                                    $0b2e6adb871a3b94$var$Qj(9, h);
                            }
                        } catch (na) {
                            $0b2e6adb871a3b94$var$W(h, h.return, na);
                        }
                        if (h === g) {
                            $0b2e6adb871a3b94$var$V = null;
                            break b;
                        }
                        var F = h.sibling;
                        if (null !== F) {
                            F.return = h.return;
                            $0b2e6adb871a3b94$var$V = F;
                            break b;
                        }
                        $0b2e6adb871a3b94$var$V = h.return;
                    }
                }
                $0b2e6adb871a3b94$var$K = e;
                $0b2e6adb871a3b94$var$jg();
                if ($0b2e6adb871a3b94$var$lc && "function" === typeof $0b2e6adb871a3b94$var$lc.onPostCommitFiberRoot) try {
                    $0b2e6adb871a3b94$var$lc.onPostCommitFiberRoot($0b2e6adb871a3b94$var$kc, a);
                } catch (na) {}
                d = !0;
            }
            return d;
        } finally{
            $0b2e6adb871a3b94$var$C = c, $0b2e6adb871a3b94$var$ok.transition = b;
        }
    }
    return !1;
}
function $0b2e6adb871a3b94$var$Xk(a, b, c) {
    b = $0b2e6adb871a3b94$var$Ji(c, b);
    b = $0b2e6adb871a3b94$var$Ni(a, b, 1);
    a = $0b2e6adb871a3b94$var$nh(a, b, 1);
    b = $0b2e6adb871a3b94$var$R();
    null !== a && ($0b2e6adb871a3b94$var$Ac(a, 1, b), $0b2e6adb871a3b94$var$Dk(a, b));
}
function $0b2e6adb871a3b94$var$W(a, b, c) {
    if (3 === a.tag) $0b2e6adb871a3b94$var$Xk(a, a, c);
    else for(; null !== b;){
        if (3 === b.tag) {
            $0b2e6adb871a3b94$var$Xk(b, a, c);
            break;
        } else if (1 === b.tag) {
            var d = b.stateNode;
            if ("function" === typeof b.type.getDerivedStateFromError || "function" === typeof d.componentDidCatch && (null === $0b2e6adb871a3b94$var$Ri || !$0b2e6adb871a3b94$var$Ri.has(d))) {
                a = $0b2e6adb871a3b94$var$Ji(c, a);
                a = $0b2e6adb871a3b94$var$Qi(b, a, 1);
                b = $0b2e6adb871a3b94$var$nh(b, a, 1);
                a = $0b2e6adb871a3b94$var$R();
                null !== b && ($0b2e6adb871a3b94$var$Ac(b, 1, a), $0b2e6adb871a3b94$var$Dk(b, a));
                break;
            }
        }
        b = b.return;
    }
}
function $0b2e6adb871a3b94$var$Ti(a, b, c) {
    var d = a.pingCache;
    null !== d && d.delete(b);
    b = $0b2e6adb871a3b94$var$R();
    a.pingedLanes |= a.suspendedLanes & c;
    $0b2e6adb871a3b94$var$Q === a && ($0b2e6adb871a3b94$var$Z & c) === c && (4 === $0b2e6adb871a3b94$var$T || 3 === $0b2e6adb871a3b94$var$T && ($0b2e6adb871a3b94$var$Z & 130023424) === $0b2e6adb871a3b94$var$Z && 500 > $0b2e6adb871a3b94$var$B() - $0b2e6adb871a3b94$var$fk ? $0b2e6adb871a3b94$var$Kk(a, 0) : $0b2e6adb871a3b94$var$rk |= c);
    $0b2e6adb871a3b94$var$Dk(a, b);
}
function $0b2e6adb871a3b94$var$Yk(a, b) {
    0 === b && (0 === (a.mode & 1) ? b = 1 : (b = $0b2e6adb871a3b94$var$sc, $0b2e6adb871a3b94$var$sc <<= 1, 0 === ($0b2e6adb871a3b94$var$sc & 130023424) && ($0b2e6adb871a3b94$var$sc = 4194304)));
    var c = $0b2e6adb871a3b94$var$R();
    a = $0b2e6adb871a3b94$var$ih(a, b);
    null !== a && ($0b2e6adb871a3b94$var$Ac(a, b, c), $0b2e6adb871a3b94$var$Dk(a, c));
}
function $0b2e6adb871a3b94$var$uj(a) {
    var b = a.memoizedState, c = 0;
    null !== b && (c = b.retryLane);
    $0b2e6adb871a3b94$var$Yk(a, c);
}
function $0b2e6adb871a3b94$var$bk(a, b) {
    var c = 0;
    switch(a.tag){
        case 13:
            var d = a.stateNode;
            var e = a.memoizedState;
            null !== e && (c = e.retryLane);
            break;
        case 19:
            d = a.stateNode;
            break;
        default:
            throw Error($0b2e6adb871a3b94$var$p(314));
    }
    null !== d && d.delete(b);
    $0b2e6adb871a3b94$var$Yk(a, c);
}
var $0b2e6adb871a3b94$var$Vk;
$0b2e6adb871a3b94$var$Vk = function(a, b, c) {
    if (null !== a) {
        if (a.memoizedProps !== b.pendingProps || $0b2e6adb871a3b94$var$Wf.current) $0b2e6adb871a3b94$var$dh = !0;
        else {
            if (0 === (a.lanes & c) && 0 === (b.flags & 128)) return $0b2e6adb871a3b94$var$dh = !1, $0b2e6adb871a3b94$var$yj(a, b, c);
            $0b2e6adb871a3b94$var$dh = 0 !== (a.flags & 131072) ? !0 : !1;
        }
    } else $0b2e6adb871a3b94$var$dh = !1, $0b2e6adb871a3b94$var$I && 0 !== (b.flags & 1048576) && $0b2e6adb871a3b94$var$ug(b, $0b2e6adb871a3b94$var$ng, b.index);
    b.lanes = 0;
    switch(b.tag){
        case 2:
            var d = b.type;
            $0b2e6adb871a3b94$var$ij(a, b);
            a = b.pendingProps;
            var e = $0b2e6adb871a3b94$var$Yf(b, $0b2e6adb871a3b94$var$H.current);
            $0b2e6adb871a3b94$var$ch(b, c);
            e = $0b2e6adb871a3b94$var$Nh(null, b, d, a, e, c);
            var f = $0b2e6adb871a3b94$var$Sh();
            b.flags |= 1;
            "object" === typeof e && null !== e && "function" === typeof e.render && void 0 === e.$$typeof ? (b.tag = 1, b.memoizedState = null, b.updateQueue = null, $0b2e6adb871a3b94$var$Zf(d) ? (f = !0, $0b2e6adb871a3b94$var$cg(b)) : f = !1, b.memoizedState = null !== e.state && void 0 !== e.state ? e.state : null, $0b2e6adb871a3b94$var$kh(b), e.updater = $0b2e6adb871a3b94$var$Ei, b.stateNode = e, e._reactInternals = b, $0b2e6adb871a3b94$var$Ii(b, d, a, c), b = $0b2e6adb871a3b94$var$jj(null, b, d, !0, f, c)) : (b.tag = 0, $0b2e6adb871a3b94$var$I && f && $0b2e6adb871a3b94$var$vg(b), $0b2e6adb871a3b94$var$Xi(null, b, e, c), b = b.child);
            return b;
        case 16:
            d = b.elementType;
            a: {
                $0b2e6adb871a3b94$var$ij(a, b);
                a = b.pendingProps;
                e = d._init;
                d = e(d._payload);
                b.type = d;
                e = b.tag = $0b2e6adb871a3b94$var$Zk(d);
                a = $0b2e6adb871a3b94$var$Ci(d, a);
                switch(e){
                    case 0:
                        b = $0b2e6adb871a3b94$var$cj(null, b, d, a, c);
                        break a;
                    case 1:
                        b = $0b2e6adb871a3b94$var$hj(null, b, d, a, c);
                        break a;
                    case 11:
                        b = $0b2e6adb871a3b94$var$Yi(null, b, d, a, c);
                        break a;
                    case 14:
                        b = $0b2e6adb871a3b94$var$$i(null, b, d, $0b2e6adb871a3b94$var$Ci(d.type, a), c);
                        break a;
                }
                throw Error($0b2e6adb871a3b94$var$p(306, d, ""));
            }
            return b;
        case 0:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $0b2e6adb871a3b94$var$Ci(d, e), $0b2e6adb871a3b94$var$cj(a, b, d, e, c);
        case 1:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $0b2e6adb871a3b94$var$Ci(d, e), $0b2e6adb871a3b94$var$hj(a, b, d, e, c);
        case 3:
            a: {
                $0b2e6adb871a3b94$var$kj(b);
                if (null === a) throw Error($0b2e6adb871a3b94$var$p(387));
                d = b.pendingProps;
                f = b.memoizedState;
                e = f.element;
                $0b2e6adb871a3b94$var$lh(a, b);
                $0b2e6adb871a3b94$var$qh(b, d, null, c);
                var g = b.memoizedState;
                d = g.element;
                if (f.isDehydrated) {
                    if (f = {
                        element: d,
                        isDehydrated: !1,
                        cache: g.cache,
                        pendingSuspenseBoundaries: g.pendingSuspenseBoundaries,
                        transitions: g.transitions
                    }, b.updateQueue.baseState = f, b.memoizedState = f, b.flags & 256) {
                        e = $0b2e6adb871a3b94$var$Ji(Error($0b2e6adb871a3b94$var$p(423)), b);
                        b = $0b2e6adb871a3b94$var$lj(a, b, d, c, e);
                        break a;
                    } else if (d !== e) {
                        e = $0b2e6adb871a3b94$var$Ji(Error($0b2e6adb871a3b94$var$p(424)), b);
                        b = $0b2e6adb871a3b94$var$lj(a, b, d, c, e);
                        break a;
                    } else for($0b2e6adb871a3b94$var$yg = $0b2e6adb871a3b94$var$Lf(b.stateNode.containerInfo.firstChild), $0b2e6adb871a3b94$var$xg = b, $0b2e6adb871a3b94$var$I = !0, $0b2e6adb871a3b94$var$zg = null, c = $0b2e6adb871a3b94$var$Vg(b, null, d, c), b.child = c; c;)c.flags = c.flags & -3 | 4096, c = c.sibling;
                } else {
                    $0b2e6adb871a3b94$var$Ig();
                    if (d === e) {
                        b = $0b2e6adb871a3b94$var$Zi(a, b, c);
                        break a;
                    }
                    $0b2e6adb871a3b94$var$Xi(a, b, d, c);
                }
                b = b.child;
            }
            return b;
        case 5:
            return $0b2e6adb871a3b94$var$Ah(b), null === a && $0b2e6adb871a3b94$var$Eg(b), d = b.type, e = b.pendingProps, f = null !== a ? a.memoizedProps : null, g = e.children, $0b2e6adb871a3b94$var$Ef(d, e) ? g = null : null !== f && $0b2e6adb871a3b94$var$Ef(d, f) && (b.flags |= 32), $0b2e6adb871a3b94$var$gj(a, b), $0b2e6adb871a3b94$var$Xi(a, b, g, c), b.child;
        case 6:
            return null === a && $0b2e6adb871a3b94$var$Eg(b), null;
        case 13:
            return $0b2e6adb871a3b94$var$oj(a, b, c);
        case 4:
            return $0b2e6adb871a3b94$var$yh(b, b.stateNode.containerInfo), d = b.pendingProps, null === a ? b.child = $0b2e6adb871a3b94$var$Ug(b, null, d, c) : $0b2e6adb871a3b94$var$Xi(a, b, d, c), b.child;
        case 11:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $0b2e6adb871a3b94$var$Ci(d, e), $0b2e6adb871a3b94$var$Yi(a, b, d, e, c);
        case 7:
            return $0b2e6adb871a3b94$var$Xi(a, b, b.pendingProps, c), b.child;
        case 8:
            return $0b2e6adb871a3b94$var$Xi(a, b, b.pendingProps.children, c), b.child;
        case 12:
            return $0b2e6adb871a3b94$var$Xi(a, b, b.pendingProps.children, c), b.child;
        case 10:
            a: {
                d = b.type._context;
                e = b.pendingProps;
                f = b.memoizedProps;
                g = e.value;
                $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$Wg, d._currentValue);
                d._currentValue = g;
                if (null !== f) {
                    if ($0b2e6adb871a3b94$var$He(f.value, g)) {
                        if (f.children === e.children && !$0b2e6adb871a3b94$var$Wf.current) {
                            b = $0b2e6adb871a3b94$var$Zi(a, b, c);
                            break a;
                        }
                    } else for(f = b.child, null !== f && (f.return = b); null !== f;){
                        var h = f.dependencies;
                        if (null !== h) {
                            g = f.child;
                            for(var k = h.firstContext; null !== k;){
                                if (k.context === d) {
                                    if (1 === f.tag) {
                                        k = $0b2e6adb871a3b94$var$mh(-1, c & -c);
                                        k.tag = 2;
                                        var l = f.updateQueue;
                                        if (null !== l) {
                                            l = l.shared;
                                            var m = l.pending;
                                            null === m ? k.next = k : (k.next = m.next, m.next = k);
                                            l.pending = k;
                                        }
                                    }
                                    f.lanes |= c;
                                    k = f.alternate;
                                    null !== k && (k.lanes |= c);
                                    $0b2e6adb871a3b94$var$bh(f.return, c, b);
                                    h.lanes |= c;
                                    break;
                                }
                                k = k.next;
                            }
                        } else if (10 === f.tag) g = f.type === b.type ? null : f.child;
                        else if (18 === f.tag) {
                            g = f.return;
                            if (null === g) throw Error($0b2e6adb871a3b94$var$p(341));
                            g.lanes |= c;
                            h = g.alternate;
                            null !== h && (h.lanes |= c);
                            $0b2e6adb871a3b94$var$bh(g, c, b);
                            g = f.sibling;
                        } else g = f.child;
                        if (null !== g) g.return = f;
                        else for(g = f; null !== g;){
                            if (g === b) {
                                g = null;
                                break;
                            }
                            f = g.sibling;
                            if (null !== f) {
                                f.return = g.return;
                                g = f;
                                break;
                            }
                            g = g.return;
                        }
                        f = g;
                    }
                }
                $0b2e6adb871a3b94$var$Xi(a, b, e.children, c);
                b = b.child;
            }
            return b;
        case 9:
            return e = b.type, d = b.pendingProps.children, $0b2e6adb871a3b94$var$ch(b, c), e = $0b2e6adb871a3b94$var$eh(e), d = d(e), b.flags |= 1, $0b2e6adb871a3b94$var$Xi(a, b, d, c), b.child;
        case 14:
            return d = b.type, e = $0b2e6adb871a3b94$var$Ci(d, b.pendingProps), e = $0b2e6adb871a3b94$var$Ci(d.type, e), $0b2e6adb871a3b94$var$$i(a, b, d, e, c);
        case 15:
            return $0b2e6adb871a3b94$var$bj(a, b, b.type, b.pendingProps, c);
        case 17:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $0b2e6adb871a3b94$var$Ci(d, e), $0b2e6adb871a3b94$var$ij(a, b), b.tag = 1, $0b2e6adb871a3b94$var$Zf(d) ? (a = !0, $0b2e6adb871a3b94$var$cg(b)) : a = !1, $0b2e6adb871a3b94$var$ch(b, c), $0b2e6adb871a3b94$var$Gi(b, d, e), $0b2e6adb871a3b94$var$Ii(b, d, e, c), $0b2e6adb871a3b94$var$jj(null, b, d, !0, a, c);
        case 19:
            return $0b2e6adb871a3b94$var$xj(a, b, c);
        case 22:
            return $0b2e6adb871a3b94$var$dj(a, b, c);
    }
    throw Error($0b2e6adb871a3b94$var$p(156, b.tag));
};
function $0b2e6adb871a3b94$var$Fk(a, b) {
    return $0b2e6adb871a3b94$var$ac(a, b);
}
function $0b2e6adb871a3b94$var$$k(a, b, c, d) {
    this.tag = a;
    this.key = c;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.ref = null;
    this.pendingProps = b;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = d;
    this.subtreeFlags = this.flags = 0;
    this.deletions = null;
    this.childLanes = this.lanes = 0;
    this.alternate = null;
}
function $0b2e6adb871a3b94$var$Bg(a, b, c, d) {
    return new $0b2e6adb871a3b94$var$$k(a, b, c, d);
}
function $0b2e6adb871a3b94$var$aj(a) {
    a = a.prototype;
    return !(!a || !a.isReactComponent);
}
function $0b2e6adb871a3b94$var$Zk(a) {
    if ("function" === typeof a) return $0b2e6adb871a3b94$var$aj(a) ? 1 : 0;
    if (void 0 !== a && null !== a) {
        a = a.$$typeof;
        if (a === $0b2e6adb871a3b94$var$Da) return 11;
        if (a === $0b2e6adb871a3b94$var$Ga) return 14;
    }
    return 2;
}
function $0b2e6adb871a3b94$var$Pg(a, b) {
    var c = a.alternate;
    null === c ? (c = $0b2e6adb871a3b94$var$Bg(a.tag, b, a.key, a.mode), c.elementType = a.elementType, c.type = a.type, c.stateNode = a.stateNode, c.alternate = a, a.alternate = c) : (c.pendingProps = b, c.type = a.type, c.flags = 0, c.subtreeFlags = 0, c.deletions = null);
    c.flags = a.flags & 14680064;
    c.childLanes = a.childLanes;
    c.lanes = a.lanes;
    c.child = a.child;
    c.memoizedProps = a.memoizedProps;
    c.memoizedState = a.memoizedState;
    c.updateQueue = a.updateQueue;
    b = a.dependencies;
    c.dependencies = null === b ? null : {
        lanes: b.lanes,
        firstContext: b.firstContext
    };
    c.sibling = a.sibling;
    c.index = a.index;
    c.ref = a.ref;
    return c;
}
function $0b2e6adb871a3b94$var$Rg(a, b, c, d, e, f) {
    var g = 2;
    d = a;
    if ("function" === typeof a) $0b2e6adb871a3b94$var$aj(a) && (g = 1);
    else if ("string" === typeof a) g = 5;
    else a: switch(a){
        case $0b2e6adb871a3b94$var$ya:
            return $0b2e6adb871a3b94$var$Tg(c.children, e, f, b);
        case $0b2e6adb871a3b94$var$za:
            g = 8;
            e |= 8;
            break;
        case $0b2e6adb871a3b94$var$Aa:
            return a = $0b2e6adb871a3b94$var$Bg(12, c, b, e | 2), a.elementType = $0b2e6adb871a3b94$var$Aa, a.lanes = f, a;
        case $0b2e6adb871a3b94$var$Ea:
            return a = $0b2e6adb871a3b94$var$Bg(13, c, b, e), a.elementType = $0b2e6adb871a3b94$var$Ea, a.lanes = f, a;
        case $0b2e6adb871a3b94$var$Fa:
            return a = $0b2e6adb871a3b94$var$Bg(19, c, b, e), a.elementType = $0b2e6adb871a3b94$var$Fa, a.lanes = f, a;
        case $0b2e6adb871a3b94$var$Ia:
            return $0b2e6adb871a3b94$var$pj(c, e, f, b);
        default:
            if ("object" === typeof a && null !== a) switch(a.$$typeof){
                case $0b2e6adb871a3b94$var$Ba:
                    g = 10;
                    break a;
                case $0b2e6adb871a3b94$var$Ca:
                    g = 9;
                    break a;
                case $0b2e6adb871a3b94$var$Da:
                    g = 11;
                    break a;
                case $0b2e6adb871a3b94$var$Ga:
                    g = 14;
                    break a;
                case $0b2e6adb871a3b94$var$Ha:
                    g = 16;
                    d = null;
                    break a;
            }
            throw Error($0b2e6adb871a3b94$var$p(130, null == a ? a : typeof a, ""));
    }
    b = $0b2e6adb871a3b94$var$Bg(g, c, b, e);
    b.elementType = a;
    b.type = d;
    b.lanes = f;
    return b;
}
function $0b2e6adb871a3b94$var$Tg(a, b, c, d) {
    a = $0b2e6adb871a3b94$var$Bg(7, a, d, b);
    a.lanes = c;
    return a;
}
function $0b2e6adb871a3b94$var$pj(a, b, c, d) {
    a = $0b2e6adb871a3b94$var$Bg(22, a, d, b);
    a.elementType = $0b2e6adb871a3b94$var$Ia;
    a.lanes = c;
    a.stateNode = {
        isHidden: !1
    };
    return a;
}
function $0b2e6adb871a3b94$var$Qg(a, b, c) {
    a = $0b2e6adb871a3b94$var$Bg(6, a, null, b);
    a.lanes = c;
    return a;
}
function $0b2e6adb871a3b94$var$Sg(a, b, c) {
    b = $0b2e6adb871a3b94$var$Bg(4, null !== a.children ? a.children : [], a.key, b);
    b.lanes = c;
    b.stateNode = {
        containerInfo: a.containerInfo,
        pendingChildren: null,
        implementation: a.implementation
    };
    return b;
}
function $0b2e6adb871a3b94$var$al(a, b, c, d, e) {
    this.tag = b;
    this.containerInfo = a;
    this.finishedWork = this.pingCache = this.current = this.pendingChildren = null;
    this.timeoutHandle = -1;
    this.callbackNode = this.pendingContext = this.context = null;
    this.callbackPriority = 0;
    this.eventTimes = $0b2e6adb871a3b94$var$zc(0);
    this.expirationTimes = $0b2e6adb871a3b94$var$zc(-1);
    this.entangledLanes = this.finishedLanes = this.mutableReadLanes = this.expiredLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
    this.entanglements = $0b2e6adb871a3b94$var$zc(0);
    this.identifierPrefix = d;
    this.onRecoverableError = e;
    this.mutableSourceEagerHydrationData = null;
}
function $0b2e6adb871a3b94$var$bl(a, b, c, d, e, f, g, h, k) {
    a = new $0b2e6adb871a3b94$var$al(a, b, c, h, k);
    1 === b ? (b = 1, !0 === f && (b |= 8)) : b = 0;
    f = $0b2e6adb871a3b94$var$Bg(3, null, null, b);
    a.current = f;
    f.stateNode = a;
    f.memoizedState = {
        element: d,
        isDehydrated: c,
        cache: null,
        transitions: null,
        pendingSuspenseBoundaries: null
    };
    $0b2e6adb871a3b94$var$kh(f);
    return a;
}
function $0b2e6adb871a3b94$var$cl(a, b, c) {
    var d = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: $0b2e6adb871a3b94$var$wa,
        key: null == d ? null : "" + d,
        children: a,
        containerInfo: b,
        implementation: c
    };
}
function $0b2e6adb871a3b94$var$dl(a) {
    if (!a) return $0b2e6adb871a3b94$var$Vf;
    a = a._reactInternals;
    a: {
        if ($0b2e6adb871a3b94$var$Vb(a) !== a || 1 !== a.tag) throw Error($0b2e6adb871a3b94$var$p(170));
        var b = a;
        do {
            switch(b.tag){
                case 3:
                    b = b.stateNode.context;
                    break a;
                case 1:
                    if ($0b2e6adb871a3b94$var$Zf(b.type)) {
                        b = b.stateNode.__reactInternalMemoizedMergedChildContext;
                        break a;
                    }
            }
            b = b.return;
        }while (null !== b);
        throw Error($0b2e6adb871a3b94$var$p(171));
    }
    if (1 === a.tag) {
        var c = a.type;
        if ($0b2e6adb871a3b94$var$Zf(c)) return $0b2e6adb871a3b94$var$bg(a, c, b);
    }
    return b;
}
function $0b2e6adb871a3b94$var$el(a, b, c, d, e, f, g, h, k) {
    a = $0b2e6adb871a3b94$var$bl(c, d, !0, a, e, f, g, h, k);
    a.context = $0b2e6adb871a3b94$var$dl(null);
    c = a.current;
    d = $0b2e6adb871a3b94$var$R();
    e = $0b2e6adb871a3b94$var$yi(c);
    f = $0b2e6adb871a3b94$var$mh(d, e);
    f.callback = void 0 !== b && null !== b ? b : null;
    $0b2e6adb871a3b94$var$nh(c, f, e);
    a.current.lanes = e;
    $0b2e6adb871a3b94$var$Ac(a, e, d);
    $0b2e6adb871a3b94$var$Dk(a, d);
    return a;
}
function $0b2e6adb871a3b94$var$fl(a, b, c, d) {
    var e = b.current, f = $0b2e6adb871a3b94$var$R(), g = $0b2e6adb871a3b94$var$yi(e);
    c = $0b2e6adb871a3b94$var$dl(c);
    null === b.context ? b.context = c : b.pendingContext = c;
    b = $0b2e6adb871a3b94$var$mh(f, g);
    b.payload = {
        element: a
    };
    d = void 0 === d ? null : d;
    null !== d && (b.callback = d);
    a = $0b2e6adb871a3b94$var$nh(e, b, g);
    null !== a && ($0b2e6adb871a3b94$var$gi(a, e, g, f), $0b2e6adb871a3b94$var$oh(a, e, g));
    return g;
}
function $0b2e6adb871a3b94$var$gl(a) {
    a = a.current;
    if (!a.child) return null;
    switch(a.child.tag){
        case 5:
            return a.child.stateNode;
        default:
            return a.child.stateNode;
    }
}
function $0b2e6adb871a3b94$var$hl(a, b) {
    a = a.memoizedState;
    if (null !== a && null !== a.dehydrated) {
        var c = a.retryLane;
        a.retryLane = 0 !== c && c < b ? c : b;
    }
}
function $0b2e6adb871a3b94$var$il(a, b) {
    $0b2e6adb871a3b94$var$hl(a, b);
    (a = a.alternate) && $0b2e6adb871a3b94$var$hl(a, b);
}
function $0b2e6adb871a3b94$var$jl() {
    return null;
}
var $0b2e6adb871a3b94$var$kl = "function" === typeof reportError ? reportError : function(a) {
    console.error(a);
};
function $0b2e6adb871a3b94$var$ll(a) {
    this._internalRoot = a;
}
$0b2e6adb871a3b94$var$ml.prototype.render = $0b2e6adb871a3b94$var$ll.prototype.render = function(a) {
    var b = this._internalRoot;
    if (null === b) throw Error($0b2e6adb871a3b94$var$p(409));
    $0b2e6adb871a3b94$var$fl(a, b, null, null);
};
$0b2e6adb871a3b94$var$ml.prototype.unmount = $0b2e6adb871a3b94$var$ll.prototype.unmount = function() {
    var a = this._internalRoot;
    if (null !== a) {
        this._internalRoot = null;
        var b = a.containerInfo;
        $0b2e6adb871a3b94$var$Rk(function() {
            $0b2e6adb871a3b94$var$fl(null, a, null, null);
        });
        b[$0b2e6adb871a3b94$var$uf] = null;
    }
};
function $0b2e6adb871a3b94$var$ml(a) {
    this._internalRoot = a;
}
$0b2e6adb871a3b94$var$ml.prototype.unstable_scheduleHydration = function(a) {
    if (a) {
        var b = $0b2e6adb871a3b94$var$Hc();
        a = {
            blockedOn: null,
            target: a,
            priority: b
        };
        for(var c = 0; c < $0b2e6adb871a3b94$var$Qc.length && 0 !== b && b < $0b2e6adb871a3b94$var$Qc[c].priority; c++);
        $0b2e6adb871a3b94$var$Qc.splice(c, 0, a);
        0 === c && $0b2e6adb871a3b94$var$Vc(a);
    }
};
function $0b2e6adb871a3b94$var$nl(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType);
}
function $0b2e6adb871a3b94$var$ol(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType && (8 !== a.nodeType || " react-mount-point-unstable " !== a.nodeValue));
}
function $0b2e6adb871a3b94$var$pl() {}
function $0b2e6adb871a3b94$var$ql(a, b, c, d, e) {
    if (e) {
        if ("function" === typeof d) {
            var f = d;
            d = function() {
                var a = $0b2e6adb871a3b94$var$gl(g);
                f.call(a);
            };
        }
        var g = $0b2e6adb871a3b94$var$el(b, d, a, 0, null, !1, !1, "", $0b2e6adb871a3b94$var$pl);
        a._reactRootContainer = g;
        a[$0b2e6adb871a3b94$var$uf] = g.current;
        $0b2e6adb871a3b94$var$sf(8 === a.nodeType ? a.parentNode : a);
        $0b2e6adb871a3b94$var$Rk();
        return g;
    }
    for(; e = a.lastChild;)a.removeChild(e);
    if ("function" === typeof d) {
        var h = d;
        d = function() {
            var a = $0b2e6adb871a3b94$var$gl(k);
            h.call(a);
        };
    }
    var k = $0b2e6adb871a3b94$var$bl(a, 0, !1, null, null, !1, !1, "", $0b2e6adb871a3b94$var$pl);
    a._reactRootContainer = k;
    a[$0b2e6adb871a3b94$var$uf] = k.current;
    $0b2e6adb871a3b94$var$sf(8 === a.nodeType ? a.parentNode : a);
    $0b2e6adb871a3b94$var$Rk(function() {
        $0b2e6adb871a3b94$var$fl(b, k, c, d);
    });
    return k;
}
function $0b2e6adb871a3b94$var$rl(a, b, c, d, e) {
    var f = c._reactRootContainer;
    if (f) {
        var g = f;
        if ("function" === typeof e) {
            var h = e;
            e = function() {
                var a = $0b2e6adb871a3b94$var$gl(g);
                h.call(a);
            };
        }
        $0b2e6adb871a3b94$var$fl(b, g, a, e);
    } else g = $0b2e6adb871a3b94$var$ql(c, b, a, e, d);
    return $0b2e6adb871a3b94$var$gl(g);
}
$0b2e6adb871a3b94$var$Ec = function(a) {
    switch(a.tag){
        case 3:
            var b = a.stateNode;
            if (b.current.memoizedState.isDehydrated) {
                var c = $0b2e6adb871a3b94$var$tc(b.pendingLanes);
                0 !== c && ($0b2e6adb871a3b94$var$Cc(b, c | 1), $0b2e6adb871a3b94$var$Dk(b, $0b2e6adb871a3b94$var$B()), 0 === ($0b2e6adb871a3b94$var$K & 6) && ($0b2e6adb871a3b94$var$Gj = $0b2e6adb871a3b94$var$B() + 500, $0b2e6adb871a3b94$var$jg()));
            }
            break;
        case 13:
            $0b2e6adb871a3b94$var$Rk(function() {
                var b = $0b2e6adb871a3b94$var$ih(a, 1);
                if (null !== b) {
                    var c = $0b2e6adb871a3b94$var$R();
                    $0b2e6adb871a3b94$var$gi(b, a, 1, c);
                }
            }), $0b2e6adb871a3b94$var$il(a, 1);
    }
};
$0b2e6adb871a3b94$var$Fc = function(a) {
    if (13 === a.tag) {
        var b = $0b2e6adb871a3b94$var$ih(a, 134217728);
        if (null !== b) {
            var c = $0b2e6adb871a3b94$var$R();
            $0b2e6adb871a3b94$var$gi(b, a, 134217728, c);
        }
        $0b2e6adb871a3b94$var$il(a, 134217728);
    }
};
$0b2e6adb871a3b94$var$Gc = function(a) {
    if (13 === a.tag) {
        var b = $0b2e6adb871a3b94$var$yi(a), c = $0b2e6adb871a3b94$var$ih(a, b);
        if (null !== c) {
            var d = $0b2e6adb871a3b94$var$R();
            $0b2e6adb871a3b94$var$gi(c, a, b, d);
        }
        $0b2e6adb871a3b94$var$il(a, b);
    }
};
$0b2e6adb871a3b94$var$Hc = function() {
    return $0b2e6adb871a3b94$var$C;
};
$0b2e6adb871a3b94$var$Ic = function(a, b) {
    var c = $0b2e6adb871a3b94$var$C;
    try {
        return $0b2e6adb871a3b94$var$C = a, b();
    } finally{
        $0b2e6adb871a3b94$var$C = c;
    }
};
$0b2e6adb871a3b94$var$yb = function(a, b, c) {
    switch(b){
        case "input":
            $0b2e6adb871a3b94$var$bb(a, c);
            b = c.name;
            if ("radio" === c.type && null != b) {
                for(c = a; c.parentNode;)c = c.parentNode;
                c = c.querySelectorAll("input[name=" + JSON.stringify("" + b) + '][type="radio"]');
                for(b = 0; b < c.length; b++){
                    var d = c[b];
                    if (d !== a && d.form === a.form) {
                        var e = $0b2e6adb871a3b94$var$Db(d);
                        if (!e) throw Error($0b2e6adb871a3b94$var$p(90));
                        $0b2e6adb871a3b94$var$Wa(d);
                        $0b2e6adb871a3b94$var$bb(d, e);
                    }
                }
            }
            break;
        case "textarea":
            $0b2e6adb871a3b94$var$ib(a, c);
            break;
        case "select":
            b = c.value, null != b && $0b2e6adb871a3b94$var$fb(a, !!c.multiple, b, !1);
    }
};
$0b2e6adb871a3b94$var$Gb = $0b2e6adb871a3b94$var$Qk;
$0b2e6adb871a3b94$var$Hb = $0b2e6adb871a3b94$var$Rk;
var $0b2e6adb871a3b94$var$sl = {
    usingClientEntryPoint: !1,
    Events: [
        $0b2e6adb871a3b94$var$Cb,
        $0b2e6adb871a3b94$var$ue,
        $0b2e6adb871a3b94$var$Db,
        $0b2e6adb871a3b94$var$Eb,
        $0b2e6adb871a3b94$var$Fb,
        $0b2e6adb871a3b94$var$Qk
    ]
}, $0b2e6adb871a3b94$var$tl = {
    findFiberByHostInstance: $0b2e6adb871a3b94$var$Wc,
    bundleType: 0,
    version: "18.3.1",
    rendererPackageName: "react-dom"
};
var $0b2e6adb871a3b94$var$ul = {
    bundleType: $0b2e6adb871a3b94$var$tl.bundleType,
    version: $0b2e6adb871a3b94$var$tl.version,
    rendererPackageName: $0b2e6adb871a3b94$var$tl.rendererPackageName,
    rendererConfig: $0b2e6adb871a3b94$var$tl.rendererConfig,
    overrideHookState: null,
    overrideHookStateDeletePath: null,
    overrideHookStateRenamePath: null,
    overrideProps: null,
    overridePropsDeletePath: null,
    overridePropsRenamePath: null,
    setErrorHandler: null,
    setSuspenseHandler: null,
    scheduleUpdate: null,
    currentDispatcherRef: $0b2e6adb871a3b94$var$ua.ReactCurrentDispatcher,
    findHostInstanceByFiber: function(a) {
        a = $0b2e6adb871a3b94$var$Zb(a);
        return null === a ? null : a.stateNode;
    },
    findFiberByHostInstance: $0b2e6adb871a3b94$var$tl.findFiberByHostInstance || $0b2e6adb871a3b94$var$jl,
    findHostInstancesForRefresh: null,
    scheduleRefresh: null,
    scheduleRoot: null,
    setRefreshHandler: null,
    getCurrentFiber: null,
    reconcilerVersion: "18.3.1-next-f1338f8080-20240426"
};
if ("undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
    var $0b2e6adb871a3b94$var$vl = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!$0b2e6adb871a3b94$var$vl.isDisabled && $0b2e6adb871a3b94$var$vl.supportsFiber) try {
        $0b2e6adb871a3b94$var$kc = $0b2e6adb871a3b94$var$vl.inject($0b2e6adb871a3b94$var$ul), $0b2e6adb871a3b94$var$lc = $0b2e6adb871a3b94$var$vl;
    } catch (a) {}
}
$0b2e6adb871a3b94$export$ae55be85d98224ed = $0b2e6adb871a3b94$var$sl;
$0b2e6adb871a3b94$export$d39a5bbd09211389 = function(a, b) {
    var c = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!$0b2e6adb871a3b94$var$nl(b)) throw Error($0b2e6adb871a3b94$var$p(200));
    return $0b2e6adb871a3b94$var$cl(a, b, null, c);
};
$0b2e6adb871a3b94$export$882461b6382ed46c = function(a, b) {
    if (!$0b2e6adb871a3b94$var$nl(a)) throw Error($0b2e6adb871a3b94$var$p(299));
    var c = !1, d = "", e = $0b2e6adb871a3b94$var$kl;
    null !== b && void 0 !== b && (!0 === b.unstable_strictMode && (c = !0), void 0 !== b.identifierPrefix && (d = b.identifierPrefix), void 0 !== b.onRecoverableError && (e = b.onRecoverableError));
    b = $0b2e6adb871a3b94$var$bl(a, 1, !1, null, null, c, !1, d, e);
    a[$0b2e6adb871a3b94$var$uf] = b.current;
    $0b2e6adb871a3b94$var$sf(8 === a.nodeType ? a.parentNode : a);
    return new $0b2e6adb871a3b94$var$ll(b);
};
$0b2e6adb871a3b94$export$466bfc07425424d5 = function(a) {
    if (null == a) return null;
    if (1 === a.nodeType) return a;
    var b = a._reactInternals;
    if (void 0 === b) {
        if ("function" === typeof a.render) throw Error($0b2e6adb871a3b94$var$p(188));
        a = Object.keys(a).join(",");
        throw Error($0b2e6adb871a3b94$var$p(268, a));
    }
    a = $0b2e6adb871a3b94$var$Zb(b);
    a = null === a ? null : a.stateNode;
    return a;
};
$0b2e6adb871a3b94$export$cd75ccfd720a3cd4 = function(a) {
    return $0b2e6adb871a3b94$var$Rk(a);
};
$0b2e6adb871a3b94$export$fa8d919ba61d84db = function(a, b, c) {
    if (!$0b2e6adb871a3b94$var$ol(b)) throw Error($0b2e6adb871a3b94$var$p(200));
    return $0b2e6adb871a3b94$var$rl(null, a, b, !0, c);
};
$0b2e6adb871a3b94$export$757ceba2d55c277e = function(a, b, c) {
    if (!$0b2e6adb871a3b94$var$nl(a)) throw Error($0b2e6adb871a3b94$var$p(405));
    var d = null != c && c.hydratedSources || null, e = !1, f = "", g = $0b2e6adb871a3b94$var$kl;
    null !== c && void 0 !== c && (!0 === c.unstable_strictMode && (e = !0), void 0 !== c.identifierPrefix && (f = c.identifierPrefix), void 0 !== c.onRecoverableError && (g = c.onRecoverableError));
    b = $0b2e6adb871a3b94$var$el(b, null, a, 1, null != c ? c : null, e, !1, f, g);
    a[$0b2e6adb871a3b94$var$uf] = b.current;
    $0b2e6adb871a3b94$var$sf(a);
    if (d) for(a = 0; a < d.length; a++)c = d[a], e = c._getVersion, e = e(c._source), null == b.mutableSourceEagerHydrationData ? b.mutableSourceEagerHydrationData = [
        c,
        e
    ] : b.mutableSourceEagerHydrationData.push(c, e);
    return new $0b2e6adb871a3b94$var$ml(b);
};
$0b2e6adb871a3b94$export$b3890eb0ae9dca99 = function(a, b, c) {
    if (!$0b2e6adb871a3b94$var$ol(b)) throw Error($0b2e6adb871a3b94$var$p(200));
    return $0b2e6adb871a3b94$var$rl(null, a, b, !1, c);
};
$0b2e6adb871a3b94$export$502457920280e6be = function(a) {
    if (!$0b2e6adb871a3b94$var$ol(a)) throw Error($0b2e6adb871a3b94$var$p(40));
    return a._reactRootContainer ? ($0b2e6adb871a3b94$var$Rk(function() {
        $0b2e6adb871a3b94$var$rl(null, null, a, !1, function() {
            a._reactRootContainer = null;
            a[$0b2e6adb871a3b94$var$uf] = null;
        });
    }), !0) : !1;
};
$0b2e6adb871a3b94$export$c78a37762a8d58e1 = $0b2e6adb871a3b94$var$Qk;
$0b2e6adb871a3b94$export$dc54d992c10e8a18 = function(a, b, c, d) {
    if (!$0b2e6adb871a3b94$var$ol(c)) throw Error($0b2e6adb871a3b94$var$p(200));
    if (null == a || void 0 === a._reactInternals) throw Error($0b2e6adb871a3b94$var$p(38));
    return $0b2e6adb871a3b94$var$rl(a, b, c, !1, d);
};
$0b2e6adb871a3b94$export$83d89fbfd8236492 = "18.3.1-next-f1338f8080-20240426";

});
parcelRegister("fO90s", function(module, exports) {
'use strict';

module.exports = (parcelRequire("gcnCG"));

});
parcelRegister("gcnCG", function(module, exports) {

$parcel$export(module.exports, "unstable_now", () => $bcb017604639e9d7$export$c4744153514ff05d, (v) => $bcb017604639e9d7$export$c4744153514ff05d = v);
$parcel$export(module.exports, "unstable_IdlePriority", () => $bcb017604639e9d7$export$3e506c1ccc9cc1a7, (v) => $bcb017604639e9d7$export$3e506c1ccc9cc1a7 = v);
$parcel$export(module.exports, "unstable_ImmediatePriority", () => $bcb017604639e9d7$export$e26fe2ed2fa76875, (v) => $bcb017604639e9d7$export$e26fe2ed2fa76875 = v);
$parcel$export(module.exports, "unstable_LowPriority", () => $bcb017604639e9d7$export$502329bbf4b505b1, (v) => $bcb017604639e9d7$export$502329bbf4b505b1 = v);
$parcel$export(module.exports, "unstable_NormalPriority", () => $bcb017604639e9d7$export$6e3807111c4874c4, (v) => $bcb017604639e9d7$export$6e3807111c4874c4 = v);
$parcel$export(module.exports, "unstable_Profiling", () => $bcb017604639e9d7$export$c27134553091fb3a, (v) => $bcb017604639e9d7$export$c27134553091fb3a = v);
$parcel$export(module.exports, "unstable_UserBlockingPriority", () => $bcb017604639e9d7$export$33ee1acdc04fd2a2, (v) => $bcb017604639e9d7$export$33ee1acdc04fd2a2 = v);
$parcel$export(module.exports, "unstable_cancelCallback", () => $bcb017604639e9d7$export$b00a404bbd5edef2, (v) => $bcb017604639e9d7$export$b00a404bbd5edef2 = v);
$parcel$export(module.exports, "unstable_continueExecution", () => $bcb017604639e9d7$export$8352ce38b91d0c62, (v) => $bcb017604639e9d7$export$8352ce38b91d0c62 = v);
$parcel$export(module.exports, "unstable_forceFrameRate", () => $bcb017604639e9d7$export$d66a1c1c77bd778b, (v) => $bcb017604639e9d7$export$d66a1c1c77bd778b = v);
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", () => $bcb017604639e9d7$export$d3dfb8e4810cb555, (v) => $bcb017604639e9d7$export$d3dfb8e4810cb555 = v);
$parcel$export(module.exports, "unstable_getFirstCallbackNode", () => $bcb017604639e9d7$export$839f9183b0465a69, (v) => $bcb017604639e9d7$export$839f9183b0465a69 = v);
$parcel$export(module.exports, "unstable_next", () => $bcb017604639e9d7$export$72fdf0e06517287b, (v) => $bcb017604639e9d7$export$72fdf0e06517287b = v);
$parcel$export(module.exports, "unstable_pauseExecution", () => $bcb017604639e9d7$export$4b844e58a3e414b4, (v) => $bcb017604639e9d7$export$4b844e58a3e414b4 = v);
$parcel$export(module.exports, "unstable_requestPaint", () => $bcb017604639e9d7$export$816d2913ae6b83b1, (v) => $bcb017604639e9d7$export$816d2913ae6b83b1 = v);
$parcel$export(module.exports, "unstable_runWithPriority", () => $bcb017604639e9d7$export$61bcfe829111a1d0, (v) => $bcb017604639e9d7$export$61bcfe829111a1d0 = v);
$parcel$export(module.exports, "unstable_scheduleCallback", () => $bcb017604639e9d7$export$7ee8c9beb337bc3f, (v) => $bcb017604639e9d7$export$7ee8c9beb337bc3f = v);
$parcel$export(module.exports, "unstable_shouldYield", () => $bcb017604639e9d7$export$b5836b71941fa3ed, (v) => $bcb017604639e9d7$export$b5836b71941fa3ed = v);
$parcel$export(module.exports, "unstable_wrapCallback", () => $bcb017604639e9d7$export$cf845f2c119da08a, (v) => $bcb017604639e9d7$export$cf845f2c119da08a = v);
/**
 * @license React
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $bcb017604639e9d7$export$c4744153514ff05d;
var $bcb017604639e9d7$export$3e506c1ccc9cc1a7;
var $bcb017604639e9d7$export$e26fe2ed2fa76875;
var $bcb017604639e9d7$export$502329bbf4b505b1;
var $bcb017604639e9d7$export$6e3807111c4874c4;
var $bcb017604639e9d7$export$c27134553091fb3a;
var $bcb017604639e9d7$export$33ee1acdc04fd2a2;
var $bcb017604639e9d7$export$b00a404bbd5edef2;
var $bcb017604639e9d7$export$8352ce38b91d0c62;
var $bcb017604639e9d7$export$d66a1c1c77bd778b;
var $bcb017604639e9d7$export$d3dfb8e4810cb555;
var $bcb017604639e9d7$export$839f9183b0465a69;
var $bcb017604639e9d7$export$72fdf0e06517287b;
var $bcb017604639e9d7$export$4b844e58a3e414b4;
var $bcb017604639e9d7$export$816d2913ae6b83b1;
var $bcb017604639e9d7$export$61bcfe829111a1d0;
var $bcb017604639e9d7$export$7ee8c9beb337bc3f;
var $bcb017604639e9d7$export$b5836b71941fa3ed;
var $bcb017604639e9d7$export$cf845f2c119da08a;
'use strict';
function $bcb017604639e9d7$var$f(a, b) {
    var c = a.length;
    a.push(b);
    a: for(; 0 < c;){
        var d = c - 1 >>> 1, e = a[d];
        if (0 < $bcb017604639e9d7$var$g(e, b)) a[d] = b, a[c] = e, c = d;
        else break a;
    }
}
function $bcb017604639e9d7$var$h(a) {
    return 0 === a.length ? null : a[0];
}
function $bcb017604639e9d7$var$k(a) {
    if (0 === a.length) return null;
    var b = a[0], c = a.pop();
    if (c !== b) {
        a[0] = c;
        a: for(var d = 0, e = a.length, w = e >>> 1; d < w;){
            var m = 2 * (d + 1) - 1, C = a[m], n = m + 1, x = a[n];
            if (0 > $bcb017604639e9d7$var$g(C, c)) n < e && 0 > $bcb017604639e9d7$var$g(x, C) ? (a[d] = x, a[n] = c, d = n) : (a[d] = C, a[m] = c, d = m);
            else if (n < e && 0 > $bcb017604639e9d7$var$g(x, c)) a[d] = x, a[n] = c, d = n;
            else break a;
        }
    }
    return b;
}
function $bcb017604639e9d7$var$g(a, b) {
    var c = a.sortIndex - b.sortIndex;
    return 0 !== c ? c : a.id - b.id;
}
if ("object" === typeof performance && "function" === typeof performance.now) {
    var $bcb017604639e9d7$var$l = performance;
    $bcb017604639e9d7$export$c4744153514ff05d = function() {
        return $bcb017604639e9d7$var$l.now();
    };
} else {
    var $bcb017604639e9d7$var$p = Date, $bcb017604639e9d7$var$q = $bcb017604639e9d7$var$p.now();
    $bcb017604639e9d7$export$c4744153514ff05d = function() {
        return $bcb017604639e9d7$var$p.now() - $bcb017604639e9d7$var$q;
    };
}
var $bcb017604639e9d7$var$r = [], $bcb017604639e9d7$var$t = [], $bcb017604639e9d7$var$u = 1, $bcb017604639e9d7$var$v = null, $bcb017604639e9d7$var$y = 3, $bcb017604639e9d7$var$z = !1, $bcb017604639e9d7$var$A = !1, $bcb017604639e9d7$var$B = !1, $bcb017604639e9d7$var$D = "function" === typeof setTimeout ? setTimeout : null, $bcb017604639e9d7$var$E = "function" === typeof clearTimeout ? clearTimeout : null, $bcb017604639e9d7$var$F = "undefined" !== typeof setImmediate ? setImmediate : null;
"undefined" !== typeof navigator && void 0 !== navigator.scheduling && void 0 !== navigator.scheduling.isInputPending && navigator.scheduling.isInputPending.bind(navigator.scheduling);
function $bcb017604639e9d7$var$G(a) {
    for(var b = $bcb017604639e9d7$var$h($bcb017604639e9d7$var$t); null !== b;){
        if (null === b.callback) $bcb017604639e9d7$var$k($bcb017604639e9d7$var$t);
        else if (b.startTime <= a) $bcb017604639e9d7$var$k($bcb017604639e9d7$var$t), b.sortIndex = b.expirationTime, $bcb017604639e9d7$var$f($bcb017604639e9d7$var$r, b);
        else break;
        b = $bcb017604639e9d7$var$h($bcb017604639e9d7$var$t);
    }
}
function $bcb017604639e9d7$var$H(a) {
    $bcb017604639e9d7$var$B = !1;
    $bcb017604639e9d7$var$G(a);
    if (!$bcb017604639e9d7$var$A) {
        if (null !== $bcb017604639e9d7$var$h($bcb017604639e9d7$var$r)) $bcb017604639e9d7$var$A = !0, $bcb017604639e9d7$var$I($bcb017604639e9d7$var$J);
        else {
            var b = $bcb017604639e9d7$var$h($bcb017604639e9d7$var$t);
            null !== b && $bcb017604639e9d7$var$K($bcb017604639e9d7$var$H, b.startTime - a);
        }
    }
}
function $bcb017604639e9d7$var$J(a, b) {
    $bcb017604639e9d7$var$A = !1;
    $bcb017604639e9d7$var$B && ($bcb017604639e9d7$var$B = !1, $bcb017604639e9d7$var$E($bcb017604639e9d7$var$L), $bcb017604639e9d7$var$L = -1);
    $bcb017604639e9d7$var$z = !0;
    var c = $bcb017604639e9d7$var$y;
    try {
        $bcb017604639e9d7$var$G(b);
        for($bcb017604639e9d7$var$v = $bcb017604639e9d7$var$h($bcb017604639e9d7$var$r); null !== $bcb017604639e9d7$var$v && (!($bcb017604639e9d7$var$v.expirationTime > b) || a && !$bcb017604639e9d7$var$M());){
            var d = $bcb017604639e9d7$var$v.callback;
            if ("function" === typeof d) {
                $bcb017604639e9d7$var$v.callback = null;
                $bcb017604639e9d7$var$y = $bcb017604639e9d7$var$v.priorityLevel;
                var e = d($bcb017604639e9d7$var$v.expirationTime <= b);
                b = $bcb017604639e9d7$export$c4744153514ff05d();
                "function" === typeof e ? $bcb017604639e9d7$var$v.callback = e : $bcb017604639e9d7$var$v === $bcb017604639e9d7$var$h($bcb017604639e9d7$var$r) && $bcb017604639e9d7$var$k($bcb017604639e9d7$var$r);
                $bcb017604639e9d7$var$G(b);
            } else $bcb017604639e9d7$var$k($bcb017604639e9d7$var$r);
            $bcb017604639e9d7$var$v = $bcb017604639e9d7$var$h($bcb017604639e9d7$var$r);
        }
        if (null !== $bcb017604639e9d7$var$v) var w = !0;
        else {
            var m = $bcb017604639e9d7$var$h($bcb017604639e9d7$var$t);
            null !== m && $bcb017604639e9d7$var$K($bcb017604639e9d7$var$H, m.startTime - b);
            w = !1;
        }
        return w;
    } finally{
        $bcb017604639e9d7$var$v = null, $bcb017604639e9d7$var$y = c, $bcb017604639e9d7$var$z = !1;
    }
}
var $bcb017604639e9d7$var$N = !1, $bcb017604639e9d7$var$O = null, $bcb017604639e9d7$var$L = -1, $bcb017604639e9d7$var$P = 5, $bcb017604639e9d7$var$Q = -1;
function $bcb017604639e9d7$var$M() {
    return $bcb017604639e9d7$export$c4744153514ff05d() - $bcb017604639e9d7$var$Q < $bcb017604639e9d7$var$P ? !1 : !0;
}
function $bcb017604639e9d7$var$R() {
    if (null !== $bcb017604639e9d7$var$O) {
        var a = $bcb017604639e9d7$export$c4744153514ff05d();
        $bcb017604639e9d7$var$Q = a;
        var b = !0;
        try {
            b = $bcb017604639e9d7$var$O(!0, a);
        } finally{
            b ? $bcb017604639e9d7$var$S() : ($bcb017604639e9d7$var$N = !1, $bcb017604639e9d7$var$O = null);
        }
    } else $bcb017604639e9d7$var$N = !1;
}
var $bcb017604639e9d7$var$S;
if ("function" === typeof $bcb017604639e9d7$var$F) $bcb017604639e9d7$var$S = function() {
    $bcb017604639e9d7$var$F($bcb017604639e9d7$var$R);
};
else if ("undefined" !== typeof MessageChannel) {
    var $bcb017604639e9d7$var$T = new MessageChannel, $bcb017604639e9d7$var$U = $bcb017604639e9d7$var$T.port2;
    $bcb017604639e9d7$var$T.port1.onmessage = $bcb017604639e9d7$var$R;
    $bcb017604639e9d7$var$S = function() {
        $bcb017604639e9d7$var$U.postMessage(null);
    };
} else $bcb017604639e9d7$var$S = function() {
    $bcb017604639e9d7$var$D($bcb017604639e9d7$var$R, 0);
};
function $bcb017604639e9d7$var$I(a) {
    $bcb017604639e9d7$var$O = a;
    $bcb017604639e9d7$var$N || ($bcb017604639e9d7$var$N = !0, $bcb017604639e9d7$var$S());
}
function $bcb017604639e9d7$var$K(a, b) {
    $bcb017604639e9d7$var$L = $bcb017604639e9d7$var$D(function() {
        a($bcb017604639e9d7$export$c4744153514ff05d());
    }, b);
}
$bcb017604639e9d7$export$3e506c1ccc9cc1a7 = 5;
$bcb017604639e9d7$export$e26fe2ed2fa76875 = 1;
$bcb017604639e9d7$export$502329bbf4b505b1 = 4;
$bcb017604639e9d7$export$6e3807111c4874c4 = 3;
$bcb017604639e9d7$export$c27134553091fb3a = null;
$bcb017604639e9d7$export$33ee1acdc04fd2a2 = 2;
$bcb017604639e9d7$export$b00a404bbd5edef2 = function(a) {
    a.callback = null;
};
$bcb017604639e9d7$export$8352ce38b91d0c62 = function() {
    $bcb017604639e9d7$var$A || $bcb017604639e9d7$var$z || ($bcb017604639e9d7$var$A = !0, $bcb017604639e9d7$var$I($bcb017604639e9d7$var$J));
};
$bcb017604639e9d7$export$d66a1c1c77bd778b = function(a) {
    0 > a || 125 < a ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : $bcb017604639e9d7$var$P = 0 < a ? Math.floor(1E3 / a) : 5;
};
$bcb017604639e9d7$export$d3dfb8e4810cb555 = function() {
    return $bcb017604639e9d7$var$y;
};
$bcb017604639e9d7$export$839f9183b0465a69 = function() {
    return $bcb017604639e9d7$var$h($bcb017604639e9d7$var$r);
};
$bcb017604639e9d7$export$72fdf0e06517287b = function(a) {
    switch($bcb017604639e9d7$var$y){
        case 1:
        case 2:
        case 3:
            var b = 3;
            break;
        default:
            b = $bcb017604639e9d7$var$y;
    }
    var c = $bcb017604639e9d7$var$y;
    $bcb017604639e9d7$var$y = b;
    try {
        return a();
    } finally{
        $bcb017604639e9d7$var$y = c;
    }
};
$bcb017604639e9d7$export$4b844e58a3e414b4 = function() {};
$bcb017604639e9d7$export$816d2913ae6b83b1 = function() {};
$bcb017604639e9d7$export$61bcfe829111a1d0 = function(a, b) {
    switch(a){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            a = 3;
    }
    var c = $bcb017604639e9d7$var$y;
    $bcb017604639e9d7$var$y = a;
    try {
        return b();
    } finally{
        $bcb017604639e9d7$var$y = c;
    }
};
$bcb017604639e9d7$export$7ee8c9beb337bc3f = function(a, b, c) {
    var d = $bcb017604639e9d7$export$c4744153514ff05d();
    "object" === typeof c && null !== c ? (c = c.delay, c = "number" === typeof c && 0 < c ? d + c : d) : c = d;
    switch(a){
        case 1:
            var e = -1;
            break;
        case 2:
            e = 250;
            break;
        case 5:
            e = 1073741823;
            break;
        case 4:
            e = 1E4;
            break;
        default:
            e = 5E3;
    }
    e = c + e;
    a = {
        id: $bcb017604639e9d7$var$u++,
        callback: b,
        priorityLevel: a,
        startTime: c,
        expirationTime: e,
        sortIndex: -1
    };
    c > d ? (a.sortIndex = c, $bcb017604639e9d7$var$f($bcb017604639e9d7$var$t, a), null === $bcb017604639e9d7$var$h($bcb017604639e9d7$var$r) && a === $bcb017604639e9d7$var$h($bcb017604639e9d7$var$t) && ($bcb017604639e9d7$var$B ? ($bcb017604639e9d7$var$E($bcb017604639e9d7$var$L), $bcb017604639e9d7$var$L = -1) : $bcb017604639e9d7$var$B = !0, $bcb017604639e9d7$var$K($bcb017604639e9d7$var$H, c - d))) : (a.sortIndex = e, $bcb017604639e9d7$var$f($bcb017604639e9d7$var$r, a), $bcb017604639e9d7$var$A || $bcb017604639e9d7$var$z || ($bcb017604639e9d7$var$A = !0, $bcb017604639e9d7$var$I($bcb017604639e9d7$var$J)));
    return a;
};
$bcb017604639e9d7$export$b5836b71941fa3ed = $bcb017604639e9d7$var$M;
$bcb017604639e9d7$export$cf845f2c119da08a = function(a) {
    var b = $bcb017604639e9d7$var$y;
    return function() {
        var c = $bcb017604639e9d7$var$y;
        $bcb017604639e9d7$var$y = b;
        try {
            return a.apply(this, arguments);
        } finally{
            $bcb017604639e9d7$var$y = c;
        }
    };
};

});



parcelRegister("jreHA", function(module, exports) {
"use strict";
var $e26bf16cebf2d56f$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

const $e26bf16cebf2d56f$var$PostgrestQueryBuilder_1 = $e26bf16cebf2d56f$var$__importDefault((parcelRequire("dBXeq")));

const $e26bf16cebf2d56f$var$PostgrestFilterBuilder_1 = $e26bf16cebf2d56f$var$__importDefault((parcelRequire("dSHX3")));

var $3C7Gg = parcelRequire("3C7Gg");
/**
 * PostgREST client.
 *
 * @typeParam Database - Types for the schema from the [type
 * generator](https://supabase.com/docs/reference/javascript/next/typescript-support)
 *
 * @typeParam SchemaName - Postgres schema to switch to. Must be a string
 * literal, the same one passed to the constructor. If the schema is not
 * `"public"`, this must be supplied manually.
 */ class $e26bf16cebf2d56f$var$PostgrestClient {
    // TODO: Add back shouldThrowOnError once we figure out the typings
    /**
     * Creates a PostgREST client.
     *
     * @param url - URL of the PostgREST endpoint
     * @param options - Named parameters
     * @param options.headers - Custom headers
     * @param options.schema - Postgres schema to switch to
     * @param options.fetch - Custom fetch
     */ constructor(url, { headers: headers = {}, schema: schema, fetch: fetch } = {}){
        this.url = url;
        this.headers = Object.assign(Object.assign({}, $3C7Gg.DEFAULT_HEADERS), headers);
        this.schemaName = schema;
        this.fetch = fetch;
    }
    /**
     * Perform a query on a table or a view.
     *
     * @param relation - The table or view name to query
     */ from(relation) {
        const url = new URL(`${this.url}/${relation}`);
        return new $e26bf16cebf2d56f$var$PostgrestQueryBuilder_1.default(url, {
            headers: Object.assign({}, this.headers),
            schema: this.schemaName,
            fetch: this.fetch
        });
    }
    /**
     * Select a schema to query or perform an function (rpc) call.
     *
     * The schema needs to be on the list of exposed schemas inside Supabase.
     *
     * @param schema - The schema to query
     */ schema(schema) {
        return new $e26bf16cebf2d56f$var$PostgrestClient(this.url, {
            headers: this.headers,
            schema: schema,
            fetch: this.fetch
        });
    }
    /**
     * Perform a function call.
     *
     * @param fn - The function name to call
     * @param args - The arguments to pass to the function call
     * @param options - Named parameters
     * @param options.head - When set to `true`, `data` will not be returned.
     * Useful if you only need the count.
     * @param options.get - When set to `true`, the function will be called with
     * read-only access mode.
     * @param options.count - Count algorithm to use to count rows returned by the
     * function. Only applicable for [set-returning
     * functions](https://www.postgresql.org/docs/current/functions-srf.html).
     *
     * `"exact"`: Exact but slow count algorithm. Performs a `COUNT(*)` under the
     * hood.
     *
     * `"planned"`: Approximated but fast count algorithm. Uses the Postgres
     * statistics under the hood.
     *
     * `"estimated"`: Uses exact count for low numbers and planned count for high
     * numbers.
     */ rpc(fn, args = {}, { head: head = false, get: get = false, count: count } = {}) {
        let method;
        const url = new URL(`${this.url}/rpc/${fn}`);
        let body;
        if (head || get) {
            method = head ? 'HEAD' : 'GET';
            Object.entries(args)// params with undefined value needs to be filtered out, otherwise it'll
            // show up as `?param=undefined`
            .filter(([_, value])=>value !== undefined)// array values need special syntax
            .map(([name, value])=>[
                    name,
                    Array.isArray(value) ? `{${value.join(',')}}` : `${value}`
                ]).forEach(([name, value])=>{
                url.searchParams.append(name, value);
            });
        } else {
            method = 'POST';
            body = args;
        }
        const headers = Object.assign({}, this.headers);
        if (count) headers['Prefer'] = `count=${count}`;
        return new $e26bf16cebf2d56f$var$PostgrestFilterBuilder_1.default({
            method: method,
            url: url,
            headers: headers,
            schema: this.schemaName,
            body: body,
            fetch: this.fetch,
            allowEmpty: false
        });
    }
}
module.exports.default = $e26bf16cebf2d56f$var$PostgrestClient;

});
parcelRegister("dBXeq", function(module, exports) {
"use strict";
var $9e8cad397b4a7e77$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

const $9e8cad397b4a7e77$var$PostgrestFilterBuilder_1 = $9e8cad397b4a7e77$var$__importDefault((parcelRequire("dSHX3")));
class $9e8cad397b4a7e77$var$PostgrestQueryBuilder {
    constructor(url, { headers: headers = {}, schema: schema, fetch: fetch }){
        this.url = url;
        this.headers = headers;
        this.schema = schema;
        this.fetch = fetch;
    }
    /**
     * Perform a SELECT query on the table or view.
     *
     * @param columns - The columns to retrieve, separated by commas. Columns can be renamed when returned with `customName:columnName`
     *
     * @param options - Named parameters
     *
     * @param options.head - When set to `true`, `data` will not be returned.
     * Useful if you only need the count.
     *
     * @param options.count - Count algorithm to use to count rows in the table or view.
     *
     * `"exact"`: Exact but slow count algorithm. Performs a `COUNT(*)` under the
     * hood.
     *
     * `"planned"`: Approximated but fast count algorithm. Uses the Postgres
     * statistics under the hood.
     *
     * `"estimated"`: Uses exact count for low numbers and planned count for high
     * numbers.
     */ select(columns, { head: head = false, count: count } = {}) {
        const method = head ? 'HEAD' : 'GET';
        // Remove whitespaces except when quoted
        let quoted = false;
        const cleanedColumns = (columns !== null && columns !== void 0 ? columns : '*').split('').map((c)=>{
            if (/\s/.test(c) && !quoted) return '';
            if (c === '"') quoted = !quoted;
            return c;
        }).join('');
        this.url.searchParams.set('select', cleanedColumns);
        if (count) this.headers['Prefer'] = `count=${count}`;
        return new $9e8cad397b4a7e77$var$PostgrestFilterBuilder_1.default({
            method: method,
            url: this.url,
            headers: this.headers,
            schema: this.schema,
            fetch: this.fetch,
            allowEmpty: false
        });
    }
    /**
     * Perform an INSERT into the table or view.
     *
     * By default, inserted rows are not returned. To return it, chain the call
     * with `.select()`.
     *
     * @param values - The values to insert. Pass an object to insert a single row
     * or an array to insert multiple rows.
     *
     * @param options - Named parameters
     *
     * @param options.count - Count algorithm to use to count inserted rows.
     *
     * `"exact"`: Exact but slow count algorithm. Performs a `COUNT(*)` under the
     * hood.
     *
     * `"planned"`: Approximated but fast count algorithm. Uses the Postgres
     * statistics under the hood.
     *
     * `"estimated"`: Uses exact count for low numbers and planned count for high
     * numbers.
     *
     * @param options.defaultToNull - Make missing fields default to `null`.
     * Otherwise, use the default value for the column. Only applies for bulk
     * inserts.
     */ insert(values, { count: count, defaultToNull: defaultToNull = true } = {}) {
        const method = 'POST';
        const prefersHeaders = [];
        if (this.headers['Prefer']) prefersHeaders.push(this.headers['Prefer']);
        if (count) prefersHeaders.push(`count=${count}`);
        if (!defaultToNull) prefersHeaders.push('missing=default');
        this.headers['Prefer'] = prefersHeaders.join(',');
        if (Array.isArray(values)) {
            const columns = values.reduce((acc, x)=>acc.concat(Object.keys(x)), []);
            if (columns.length > 0) {
                const uniqueColumns = [
                    ...new Set(columns)
                ].map((column)=>`"${column}"`);
                this.url.searchParams.set('columns', uniqueColumns.join(','));
            }
        }
        return new $9e8cad397b4a7e77$var$PostgrestFilterBuilder_1.default({
            method: method,
            url: this.url,
            headers: this.headers,
            schema: this.schema,
            body: values,
            fetch: this.fetch,
            allowEmpty: false
        });
    }
    /**
     * Perform an UPSERT on the table or view. Depending on the column(s) passed
     * to `onConflict`, `.upsert()` allows you to perform the equivalent of
     * `.insert()` if a row with the corresponding `onConflict` columns doesn't
     * exist, or if it does exist, perform an alternative action depending on
     * `ignoreDuplicates`.
     *
     * By default, upserted rows are not returned. To return it, chain the call
     * with `.select()`.
     *
     * @param values - The values to upsert with. Pass an object to upsert a
     * single row or an array to upsert multiple rows.
     *
     * @param options - Named parameters
     *
     * @param options.onConflict - Comma-separated UNIQUE column(s) to specify how
     * duplicate rows are determined. Two rows are duplicates if all the
     * `onConflict` columns are equal.
     *
     * @param options.ignoreDuplicates - If `true`, duplicate rows are ignored. If
     * `false`, duplicate rows are merged with existing rows.
     *
     * @param options.count - Count algorithm to use to count upserted rows.
     *
     * `"exact"`: Exact but slow count algorithm. Performs a `COUNT(*)` under the
     * hood.
     *
     * `"planned"`: Approximated but fast count algorithm. Uses the Postgres
     * statistics under the hood.
     *
     * `"estimated"`: Uses exact count for low numbers and planned count for high
     * numbers.
     *
     * @param options.defaultToNull - Make missing fields default to `null`.
     * Otherwise, use the default value for the column. This only applies when
     * inserting new rows, not when merging with existing rows under
     * `ignoreDuplicates: false`. This also only applies when doing bulk upserts.
     */ upsert(values, { onConflict: onConflict, ignoreDuplicates: ignoreDuplicates = false, count: count, defaultToNull: defaultToNull = true } = {}) {
        const method = 'POST';
        const prefersHeaders = [
            `resolution=${ignoreDuplicates ? 'ignore' : 'merge'}-duplicates`
        ];
        if (onConflict !== undefined) this.url.searchParams.set('on_conflict', onConflict);
        if (this.headers['Prefer']) prefersHeaders.push(this.headers['Prefer']);
        if (count) prefersHeaders.push(`count=${count}`);
        if (!defaultToNull) prefersHeaders.push('missing=default');
        this.headers['Prefer'] = prefersHeaders.join(',');
        if (Array.isArray(values)) {
            const columns = values.reduce((acc, x)=>acc.concat(Object.keys(x)), []);
            if (columns.length > 0) {
                const uniqueColumns = [
                    ...new Set(columns)
                ].map((column)=>`"${column}"`);
                this.url.searchParams.set('columns', uniqueColumns.join(','));
            }
        }
        return new $9e8cad397b4a7e77$var$PostgrestFilterBuilder_1.default({
            method: method,
            url: this.url,
            headers: this.headers,
            schema: this.schema,
            body: values,
            fetch: this.fetch,
            allowEmpty: false
        });
    }
    /**
     * Perform an UPDATE on the table or view.
     *
     * By default, updated rows are not returned. To return it, chain the call
     * with `.select()` after filters.
     *
     * @param values - The values to update with
     *
     * @param options - Named parameters
     *
     * @param options.count - Count algorithm to use to count updated rows.
     *
     * `"exact"`: Exact but slow count algorithm. Performs a `COUNT(*)` under the
     * hood.
     *
     * `"planned"`: Approximated but fast count algorithm. Uses the Postgres
     * statistics under the hood.
     *
     * `"estimated"`: Uses exact count for low numbers and planned count for high
     * numbers.
     */ update(values, { count: count } = {}) {
        const method = 'PATCH';
        const prefersHeaders = [];
        if (this.headers['Prefer']) prefersHeaders.push(this.headers['Prefer']);
        if (count) prefersHeaders.push(`count=${count}`);
        this.headers['Prefer'] = prefersHeaders.join(',');
        return new $9e8cad397b4a7e77$var$PostgrestFilterBuilder_1.default({
            method: method,
            url: this.url,
            headers: this.headers,
            schema: this.schema,
            body: values,
            fetch: this.fetch,
            allowEmpty: false
        });
    }
    /**
     * Perform a DELETE on the table or view.
     *
     * By default, deleted rows are not returned. To return it, chain the call
     * with `.select()` after filters.
     *
     * @param options - Named parameters
     *
     * @param options.count - Count algorithm to use to count deleted rows.
     *
     * `"exact"`: Exact but slow count algorithm. Performs a `COUNT(*)` under the
     * hood.
     *
     * `"planned"`: Approximated but fast count algorithm. Uses the Postgres
     * statistics under the hood.
     *
     * `"estimated"`: Uses exact count for low numbers and planned count for high
     * numbers.
     */ delete({ count: count } = {}) {
        const method = 'DELETE';
        const prefersHeaders = [];
        if (count) prefersHeaders.push(`count=${count}`);
        if (this.headers['Prefer']) prefersHeaders.unshift(this.headers['Prefer']);
        this.headers['Prefer'] = prefersHeaders.join(',');
        return new $9e8cad397b4a7e77$var$PostgrestFilterBuilder_1.default({
            method: method,
            url: this.url,
            headers: this.headers,
            schema: this.schema,
            fetch: this.fetch,
            allowEmpty: false
        });
    }
}
module.exports.default = $9e8cad397b4a7e77$var$PostgrestQueryBuilder;

});
parcelRegister("dSHX3", function(module, exports) {
"use strict";
var $a1b269604a69632c$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

const $a1b269604a69632c$var$PostgrestTransformBuilder_1 = $a1b269604a69632c$var$__importDefault((parcelRequire("kkZ1b")));
class $a1b269604a69632c$var$PostgrestFilterBuilder extends $a1b269604a69632c$var$PostgrestTransformBuilder_1.default {
    /**
     * Match only rows where `column` is equal to `value`.
     *
     * To check if the value of `column` is NULL, you should use `.is()` instead.
     *
     * @param column - The column to filter on
     * @param value - The value to filter with
     */ eq(column, value) {
        this.url.searchParams.append(column, `eq.${value}`);
        return this;
    }
    /**
     * Match only rows where `column` is not equal to `value`.
     *
     * @param column - The column to filter on
     * @param value - The value to filter with
     */ neq(column, value) {
        this.url.searchParams.append(column, `neq.${value}`);
        return this;
    }
    /**
     * Match only rows where `column` is greater than `value`.
     *
     * @param column - The column to filter on
     * @param value - The value to filter with
     */ gt(column, value) {
        this.url.searchParams.append(column, `gt.${value}`);
        return this;
    }
    /**
     * Match only rows where `column` is greater than or equal to `value`.
     *
     * @param column - The column to filter on
     * @param value - The value to filter with
     */ gte(column, value) {
        this.url.searchParams.append(column, `gte.${value}`);
        return this;
    }
    /**
     * Match only rows where `column` is less than `value`.
     *
     * @param column - The column to filter on
     * @param value - The value to filter with
     */ lt(column, value) {
        this.url.searchParams.append(column, `lt.${value}`);
        return this;
    }
    /**
     * Match only rows where `column` is less than or equal to `value`.
     *
     * @param column - The column to filter on
     * @param value - The value to filter with
     */ lte(column, value) {
        this.url.searchParams.append(column, `lte.${value}`);
        return this;
    }
    /**
     * Match only rows where `column` matches `pattern` case-sensitively.
     *
     * @param column - The column to filter on
     * @param pattern - The pattern to match with
     */ like(column, pattern) {
        this.url.searchParams.append(column, `like.${pattern}`);
        return this;
    }
    /**
     * Match only rows where `column` matches all of `patterns` case-sensitively.
     *
     * @param column - The column to filter on
     * @param patterns - The patterns to match with
     */ likeAllOf(column, patterns) {
        this.url.searchParams.append(column, `like(all).{${patterns.join(',')}}`);
        return this;
    }
    /**
     * Match only rows where `column` matches any of `patterns` case-sensitively.
     *
     * @param column - The column to filter on
     * @param patterns - The patterns to match with
     */ likeAnyOf(column, patterns) {
        this.url.searchParams.append(column, `like(any).{${patterns.join(',')}}`);
        return this;
    }
    /**
     * Match only rows where `column` matches `pattern` case-insensitively.
     *
     * @param column - The column to filter on
     * @param pattern - The pattern to match with
     */ ilike(column, pattern) {
        this.url.searchParams.append(column, `ilike.${pattern}`);
        return this;
    }
    /**
     * Match only rows where `column` matches all of `patterns` case-insensitively.
     *
     * @param column - The column to filter on
     * @param patterns - The patterns to match with
     */ ilikeAllOf(column, patterns) {
        this.url.searchParams.append(column, `ilike(all).{${patterns.join(',')}}`);
        return this;
    }
    /**
     * Match only rows where `column` matches any of `patterns` case-insensitively.
     *
     * @param column - The column to filter on
     * @param patterns - The patterns to match with
     */ ilikeAnyOf(column, patterns) {
        this.url.searchParams.append(column, `ilike(any).{${patterns.join(',')}}`);
        return this;
    }
    /**
     * Match only rows where `column` IS `value`.
     *
     * For non-boolean columns, this is only relevant for checking if the value of
     * `column` is NULL by setting `value` to `null`.
     *
     * For boolean columns, you can also set `value` to `true` or `false` and it
     * will behave the same way as `.eq()`.
     *
     * @param column - The column to filter on
     * @param value - The value to filter with
     */ is(column, value) {
        this.url.searchParams.append(column, `is.${value}`);
        return this;
    }
    /**
     * Match only rows where `column` is included in the `values` array.
     *
     * @param column - The column to filter on
     * @param values - The values array to filter with
     */ in(column, values) {
        const cleanedValues = Array.from(new Set(values)).map((s)=>{
            // handle postgrest reserved characters
            // https://postgrest.org/en/v7.0.0/api.html#reserved-characters
            if (typeof s === 'string' && new RegExp('[,()]').test(s)) return `"${s}"`;
            else return `${s}`;
        }).join(',');
        this.url.searchParams.append(column, `in.(${cleanedValues})`);
        return this;
    }
    /**
     * Only relevant for jsonb, array, and range columns. Match only rows where
     * `column` contains every element appearing in `value`.
     *
     * @param column - The jsonb, array, or range column to filter on
     * @param value - The jsonb, array, or range value to filter with
     */ contains(column, value) {
        if (typeof value === 'string') // range types can be inclusive '[', ']' or exclusive '(', ')' so just
        // keep it simple and accept a string
        this.url.searchParams.append(column, `cs.${value}`);
        else if (Array.isArray(value)) // array
        this.url.searchParams.append(column, `cs.{${value.join(',')}}`);
        else // json
        this.url.searchParams.append(column, `cs.${JSON.stringify(value)}`);
        return this;
    }
    /**
     * Only relevant for jsonb, array, and range columns. Match only rows where
     * every element appearing in `column` is contained by `value`.
     *
     * @param column - The jsonb, array, or range column to filter on
     * @param value - The jsonb, array, or range value to filter with
     */ containedBy(column, value) {
        if (typeof value === 'string') // range
        this.url.searchParams.append(column, `cd.${value}`);
        else if (Array.isArray(value)) // array
        this.url.searchParams.append(column, `cd.{${value.join(',')}}`);
        else // json
        this.url.searchParams.append(column, `cd.${JSON.stringify(value)}`);
        return this;
    }
    /**
     * Only relevant for range columns. Match only rows where every element in
     * `column` is greater than any element in `range`.
     *
     * @param column - The range column to filter on
     * @param range - The range to filter with
     */ rangeGt(column, range) {
        this.url.searchParams.append(column, `sr.${range}`);
        return this;
    }
    /**
     * Only relevant for range columns. Match only rows where every element in
     * `column` is either contained in `range` or greater than any element in
     * `range`.
     *
     * @param column - The range column to filter on
     * @param range - The range to filter with
     */ rangeGte(column, range) {
        this.url.searchParams.append(column, `nxl.${range}`);
        return this;
    }
    /**
     * Only relevant for range columns. Match only rows where every element in
     * `column` is less than any element in `range`.
     *
     * @param column - The range column to filter on
     * @param range - The range to filter with
     */ rangeLt(column, range) {
        this.url.searchParams.append(column, `sl.${range}`);
        return this;
    }
    /**
     * Only relevant for range columns. Match only rows where every element in
     * `column` is either contained in `range` or less than any element in
     * `range`.
     *
     * @param column - The range column to filter on
     * @param range - The range to filter with
     */ rangeLte(column, range) {
        this.url.searchParams.append(column, `nxr.${range}`);
        return this;
    }
    /**
     * Only relevant for range columns. Match only rows where `column` is
     * mutually exclusive to `range` and there can be no element between the two
     * ranges.
     *
     * @param column - The range column to filter on
     * @param range - The range to filter with
     */ rangeAdjacent(column, range) {
        this.url.searchParams.append(column, `adj.${range}`);
        return this;
    }
    /**
     * Only relevant for array and range columns. Match only rows where
     * `column` and `value` have an element in common.
     *
     * @param column - The array or range column to filter on
     * @param value - The array or range value to filter with
     */ overlaps(column, value) {
        if (typeof value === 'string') // range
        this.url.searchParams.append(column, `ov.${value}`);
        else // array
        this.url.searchParams.append(column, `ov.{${value.join(',')}}`);
        return this;
    }
    /**
     * Only relevant for text and tsvector columns. Match only rows where
     * `column` matches the query string in `query`.
     *
     * @param column - The text or tsvector column to filter on
     * @param query - The query text to match with
     * @param options - Named parameters
     * @param options.config - The text search configuration to use
     * @param options.type - Change how the `query` text is interpreted
     */ textSearch(column, query, { config: config, type: type } = {}) {
        let typePart = '';
        if (type === 'plain') typePart = 'pl';
        else if (type === 'phrase') typePart = 'ph';
        else if (type === 'websearch') typePart = 'w';
        const configPart = config === undefined ? '' : `(${config})`;
        this.url.searchParams.append(column, `${typePart}fts${configPart}.${query}`);
        return this;
    }
    /**
     * Match only rows where each column in `query` keys is equal to its
     * associated value. Shorthand for multiple `.eq()`s.
     *
     * @param query - The object to filter with, with column names as keys mapped
     * to their filter values
     */ match(query) {
        Object.entries(query).forEach(([column, value])=>{
            this.url.searchParams.append(column, `eq.${value}`);
        });
        return this;
    }
    /**
     * Match only rows which doesn't satisfy the filter.
     *
     * Unlike most filters, `opearator` and `value` are used as-is and need to
     * follow [PostgREST
     * syntax](https://postgrest.org/en/stable/api.html#operators). You also need
     * to make sure they are properly sanitized.
     *
     * @param column - The column to filter on
     * @param operator - The operator to be negated to filter with, following
     * PostgREST syntax
     * @param value - The value to filter with, following PostgREST syntax
     */ not(column, operator, value) {
        this.url.searchParams.append(column, `not.${operator}.${value}`);
        return this;
    }
    /**
     * Match only rows which satisfy at least one of the filters.
     *
     * Unlike most filters, `filters` is used as-is and needs to follow [PostgREST
     * syntax](https://postgrest.org/en/stable/api.html#operators). You also need
     * to make sure it's properly sanitized.
     *
     * It's currently not possible to do an `.or()` filter across multiple tables.
     *
     * @param filters - The filters to use, following PostgREST syntax
     * @param options - Named parameters
     * @param options.referencedTable - Set this to filter on referenced tables
     * instead of the parent table
     * @param options.foreignTable - Deprecated, use `referencedTable` instead
     */ or(filters, { foreignTable: foreignTable, referencedTable: referencedTable = foreignTable } = {}) {
        const key = referencedTable ? `${referencedTable}.or` : 'or';
        this.url.searchParams.append(key, `(${filters})`);
        return this;
    }
    /**
     * Match only rows which satisfy the filter. This is an escape hatch - you
     * should use the specific filter methods wherever possible.
     *
     * Unlike most filters, `opearator` and `value` are used as-is and need to
     * follow [PostgREST
     * syntax](https://postgrest.org/en/stable/api.html#operators). You also need
     * to make sure they are properly sanitized.
     *
     * @param column - The column to filter on
     * @param operator - The operator to filter with, following PostgREST syntax
     * @param value - The value to filter with, following PostgREST syntax
     */ filter(column, operator, value) {
        this.url.searchParams.append(column, `${operator}.${value}`);
        return this;
    }
}
module.exports.default = $a1b269604a69632c$var$PostgrestFilterBuilder;

});
parcelRegister("kkZ1b", function(module, exports) {
"use strict";
var $ece501d5ff408d7d$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

const $ece501d5ff408d7d$var$PostgrestBuilder_1 = $ece501d5ff408d7d$var$__importDefault((parcelRequire("9WNOL")));
class $ece501d5ff408d7d$var$PostgrestTransformBuilder extends $ece501d5ff408d7d$var$PostgrestBuilder_1.default {
    /**
     * Perform a SELECT on the query result.
     *
     * By default, `.insert()`, `.update()`, `.upsert()`, and `.delete()` do not
     * return modified rows. By calling this method, modified rows are returned in
     * `data`.
     *
     * @param columns - The columns to retrieve, separated by commas
     */ select(columns) {
        // Remove whitespaces except when quoted
        let quoted = false;
        const cleanedColumns = (columns !== null && columns !== void 0 ? columns : '*').split('').map((c)=>{
            if (/\s/.test(c) && !quoted) return '';
            if (c === '"') quoted = !quoted;
            return c;
        }).join('');
        this.url.searchParams.set('select', cleanedColumns);
        if (this.headers['Prefer']) this.headers['Prefer'] += ',';
        this.headers['Prefer'] += 'return=representation';
        return this;
    }
    /**
     * Order the query result by `column`.
     *
     * You can call this method multiple times to order by multiple columns.
     *
     * You can order referenced tables, but it only affects the ordering of the
     * parent table if you use `!inner` in the query.
     *
     * @param column - The column to order by
     * @param options - Named parameters
     * @param options.ascending - If `true`, the result will be in ascending order
     * @param options.nullsFirst - If `true`, `null`s appear first. If `false`,
     * `null`s appear last.
     * @param options.referencedTable - Set this to order a referenced table by
     * its columns
     * @param options.foreignTable - Deprecated, use `options.referencedTable`
     * instead
     */ order(column, { ascending: ascending = true, nullsFirst: nullsFirst, foreignTable: foreignTable, referencedTable: referencedTable = foreignTable } = {}) {
        const key = referencedTable ? `${referencedTable}.order` : 'order';
        const existingOrder = this.url.searchParams.get(key);
        this.url.searchParams.set(key, `${existingOrder ? `${existingOrder},` : ''}${column}.${ascending ? 'asc' : 'desc'}${nullsFirst === undefined ? '' : nullsFirst ? '.nullsfirst' : '.nullslast'}`);
        return this;
    }
    /**
     * Limit the query result by `count`.
     *
     * @param count - The maximum number of rows to return
     * @param options - Named parameters
     * @param options.referencedTable - Set this to limit rows of referenced
     * tables instead of the parent table
     * @param options.foreignTable - Deprecated, use `options.referencedTable`
     * instead
     */ limit(count, { foreignTable: foreignTable, referencedTable: referencedTable = foreignTable } = {}) {
        const key = typeof referencedTable === 'undefined' ? 'limit' : `${referencedTable}.limit`;
        this.url.searchParams.set(key, `${count}`);
        return this;
    }
    /**
     * Limit the query result by starting at an offset `from` and ending at the offset `to`.
     * Only records within this range are returned.
     * This respects the query order and if there is no order clause the range could behave unexpectedly.
     * The `from` and `to` values are 0-based and inclusive: `range(1, 3)` will include the second, third
     * and fourth rows of the query.
     *
     * @param from - The starting index from which to limit the result
     * @param to - The last index to which to limit the result
     * @param options - Named parameters
     * @param options.referencedTable - Set this to limit rows of referenced
     * tables instead of the parent table
     * @param options.foreignTable - Deprecated, use `options.referencedTable`
     * instead
     */ range(from, to, { foreignTable: foreignTable, referencedTable: referencedTable = foreignTable } = {}) {
        const keyOffset = typeof referencedTable === 'undefined' ? 'offset' : `${referencedTable}.offset`;
        const keyLimit = typeof referencedTable === 'undefined' ? 'limit' : `${referencedTable}.limit`;
        this.url.searchParams.set(keyOffset, `${from}`);
        // Range is inclusive, so add 1
        this.url.searchParams.set(keyLimit, `${to - from + 1}`);
        return this;
    }
    /**
     * Set the AbortSignal for the fetch request.
     *
     * @param signal - The AbortSignal to use for the fetch request
     */ abortSignal(signal) {
        this.signal = signal;
        return this;
    }
    /**
     * Return `data` as a single object instead of an array of objects.
     *
     * Query result must be one row (e.g. using `.limit(1)`), otherwise this
     * returns an error.
     */ single() {
        this.headers['Accept'] = 'application/vnd.pgrst.object+json';
        return this;
    }
    /**
     * Return `data` as a single object instead of an array of objects.
     *
     * Query result must be zero or one row (e.g. using `.limit(1)`), otherwise
     * this returns an error.
     */ maybeSingle() {
        // Temporary partial fix for https://github.com/supabase/postgrest-js/issues/361
        // Issue persists e.g. for `.insert([...]).select().maybeSingle()`
        if (this.method === 'GET') this.headers['Accept'] = 'application/json';
        else this.headers['Accept'] = 'application/vnd.pgrst.object+json';
        this.isMaybeSingle = true;
        return this;
    }
    /**
     * Return `data` as a string in CSV format.
     */ csv() {
        this.headers['Accept'] = 'text/csv';
        return this;
    }
    /**
     * Return `data` as an object in [GeoJSON](https://geojson.org) format.
     */ geojson() {
        this.headers['Accept'] = 'application/geo+json';
        return this;
    }
    /**
     * Return `data` as the EXPLAIN plan for the query.
     *
     * You need to enable the
     * [db_plan_enabled](https://supabase.com/docs/guides/database/debugging-performance#enabling-explain)
     * setting before using this method.
     *
     * @param options - Named parameters
     *
     * @param options.analyze - If `true`, the query will be executed and the
     * actual run time will be returned
     *
     * @param options.verbose - If `true`, the query identifier will be returned
     * and `data` will include the output columns of the query
     *
     * @param options.settings - If `true`, include information on configuration
     * parameters that affect query planning
     *
     * @param options.buffers - If `true`, include information on buffer usage
     *
     * @param options.wal - If `true`, include information on WAL record generation
     *
     * @param options.format - The format of the output, can be `"text"` (default)
     * or `"json"`
     */ explain({ analyze: analyze = false, verbose: verbose = false, settings: settings = false, buffers: buffers = false, wal: wal = false, format: format = 'text' } = {}) {
        var _a;
        const options = [
            analyze ? 'analyze' : null,
            verbose ? 'verbose' : null,
            settings ? 'settings' : null,
            buffers ? 'buffers' : null,
            wal ? 'wal' : null
        ].filter(Boolean).join('|');
        // An Accept header can carry multiple media types but postgrest-js always sends one
        const forMediatype = (_a = this.headers['Accept']) !== null && _a !== void 0 ? _a : 'application/json';
        this.headers['Accept'] = `application/vnd.pgrst.plan+${format}; for="${forMediatype}"; options=${options};`;
        if (format === 'json') return this;
        else return this;
    }
    /**
     * Rollback the query.
     *
     * `data` will still be returned, but the query is not committed.
     */ rollback() {
        var _a;
        if (((_a = this.headers['Prefer']) !== null && _a !== void 0 ? _a : '').trim().length > 0) this.headers['Prefer'] += ',tx=rollback';
        else this.headers['Prefer'] = 'tx=rollback';
        return this;
    }
    /**
     * Override the type of the returned `data`.
     *
     * @typeParam NewResult - The new result type to override with
     * @deprecated Use overrideTypes<yourType, { merge: false }>() method at the end of your call chain instead
     */ returns() {
        return this;
    }
}
module.exports.default = $ece501d5ff408d7d$var$PostgrestTransformBuilder;

});
parcelRegister("9WNOL", function(module, exports) {
"use strict";
var $73e02ca1f3b16d8b$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

// @ts-ignore
const $73e02ca1f3b16d8b$var$node_fetch_1 = $73e02ca1f3b16d8b$var$__importDefault((parcelRequire("979Ct")));

const $73e02ca1f3b16d8b$var$PostgrestError_1 = $73e02ca1f3b16d8b$var$__importDefault((parcelRequire("iN95t")));
class $73e02ca1f3b16d8b$var$PostgrestBuilder {
    constructor(builder){
        this.shouldThrowOnError = false;
        this.method = builder.method;
        this.url = builder.url;
        this.headers = builder.headers;
        this.schema = builder.schema;
        this.body = builder.body;
        this.shouldThrowOnError = builder.shouldThrowOnError;
        this.signal = builder.signal;
        this.isMaybeSingle = builder.isMaybeSingle;
        if (builder.fetch) this.fetch = builder.fetch;
        else if (typeof fetch === 'undefined') this.fetch = $73e02ca1f3b16d8b$var$node_fetch_1.default;
        else this.fetch = fetch;
    }
    /**
     * If there's an error with the query, throwOnError will reject the promise by
     * throwing the error instead of returning it as part of a successful response.
     *
     * {@link https://github.com/supabase/supabase-js/issues/92}
     */ throwOnError() {
        this.shouldThrowOnError = true;
        return this;
    }
    /**
     * Set an HTTP header for the request.
     */ setHeader(name, value) {
        this.headers = Object.assign({}, this.headers);
        this.headers[name] = value;
        return this;
    }
    then(onfulfilled, onrejected) {
        // https://postgrest.org/en/stable/api.html#switching-schemas
        if (this.schema === undefined) ;
        else if ([
            'GET',
            'HEAD'
        ].includes(this.method)) this.headers['Accept-Profile'] = this.schema;
        else this.headers['Content-Profile'] = this.schema;
        if (this.method !== 'GET' && this.method !== 'HEAD') this.headers['Content-Type'] = 'application/json';
        // NOTE: Invoke w/o `this` to avoid illegal invocation error.
        // https://github.com/supabase/postgrest-js/pull/247
        const _fetch = this.fetch;
        let res = _fetch(this.url.toString(), {
            method: this.method,
            headers: this.headers,
            body: JSON.stringify(this.body),
            signal: this.signal
        }).then(async (res)=>{
            var _a, _b, _c;
            let error = null;
            let data = null;
            let count = null;
            let status = res.status;
            let statusText = res.statusText;
            if (res.ok) {
                if (this.method !== 'HEAD') {
                    const body = await res.text();
                    if (body === '') ;
                    else if (this.headers['Accept'] === 'text/csv') data = body;
                    else if (this.headers['Accept'] && this.headers['Accept'].includes('application/vnd.pgrst.plan+text')) data = body;
                    else data = JSON.parse(body);
                }
                const countHeader = (_a = this.headers['Prefer']) === null || _a === void 0 ? void 0 : _a.match(/count=(exact|planned|estimated)/);
                const contentRange = (_b = res.headers.get('content-range')) === null || _b === void 0 ? void 0 : _b.split('/');
                if (countHeader && contentRange && contentRange.length > 1) count = parseInt(contentRange[1]);
                // Temporary partial fix for https://github.com/supabase/postgrest-js/issues/361
                // Issue persists e.g. for `.insert([...]).select().maybeSingle()`
                if (this.isMaybeSingle && this.method === 'GET' && Array.isArray(data)) {
                    if (data.length > 1) {
                        error = {
                            // https://github.com/PostgREST/postgrest/blob/a867d79c42419af16c18c3fb019eba8df992626f/src/PostgREST/Error.hs#L553
                            code: 'PGRST116',
                            details: `Results contain ${data.length} rows, application/vnd.pgrst.object+json requires 1 row`,
                            hint: null,
                            message: 'JSON object requested, multiple (or no) rows returned'
                        };
                        data = null;
                        count = null;
                        status = 406;
                        statusText = 'Not Acceptable';
                    } else if (data.length === 1) data = data[0];
                    else data = null;
                }
            } else {
                const body = await res.text();
                try {
                    error = JSON.parse(body);
                    // Workaround for https://github.com/supabase/postgrest-js/issues/295
                    if (Array.isArray(error) && res.status === 404) {
                        data = [];
                        error = null;
                        status = 200;
                        statusText = 'OK';
                    }
                } catch (_d) {
                    // Workaround for https://github.com/supabase/postgrest-js/issues/295
                    if (res.status === 404 && body === '') {
                        status = 204;
                        statusText = 'No Content';
                    } else error = {
                        message: body
                    };
                }
                if (error && this.isMaybeSingle && ((_c = error === null || error === void 0 ? void 0 : error.details) === null || _c === void 0 ? void 0 : _c.includes('0 rows'))) {
                    error = null;
                    status = 200;
                    statusText = 'OK';
                }
                if (error && this.shouldThrowOnError) throw new $73e02ca1f3b16d8b$var$PostgrestError_1.default(error);
            }
            const postgrestResponse = {
                error: error,
                data: data,
                count: count,
                status: status,
                statusText: statusText
            };
            return postgrestResponse;
        });
        if (!this.shouldThrowOnError) res = res.catch((fetchError)=>{
            var _a, _b, _c;
            return {
                error: {
                    message: `${(_a = fetchError === null || fetchError === void 0 ? void 0 : fetchError.name) !== null && _a !== void 0 ? _a : 'FetchError'}: ${fetchError === null || fetchError === void 0 ? void 0 : fetchError.message}`,
                    details: `${(_b = fetchError === null || fetchError === void 0 ? void 0 : fetchError.stack) !== null && _b !== void 0 ? _b : ''}`,
                    hint: '',
                    code: `${(_c = fetchError === null || fetchError === void 0 ? void 0 : fetchError.code) !== null && _c !== void 0 ? _c : ''}`
                },
                data: null,
                count: null,
                status: 0,
                statusText: ''
            };
        });
        return res.then(onfulfilled, onrejected);
    }
    /**
     * Override the type of the returned `data`.
     *
     * @typeParam NewResult - The new result type to override with
     * @deprecated Use overrideTypes<yourType, { merge: false }>() method at the end of your call chain instead
     */ returns() {
        /* istanbul ignore next */ return this;
    }
    /**
     * Override the type of the returned `data` field in the response.
     *
     * @typeParam NewResult - The new type to cast the response data to
     * @typeParam Options - Optional type configuration (defaults to { merge: true })
     * @typeParam Options.merge - When true, merges the new type with existing return type. When false, replaces the existing types entirely (defaults to true)
     * @example
     * ```typescript
     * // Merge with existing types (default behavior)
     * const query = supabase
     *   .from('users')
     *   .select()
     *   .overrideTypes<{ custom_field: string }>()
     *
     * // Replace existing types completely
     * const replaceQuery = supabase
     *   .from('users')
     *   .select()
     *   .overrideTypes<{ id: number; name: string }, { merge: false }>()
     * ```
     * @returns A PostgrestBuilder instance with the new type
     */ overrideTypes() {
        return this;
    }
}
module.exports.default = $73e02ca1f3b16d8b$var$PostgrestBuilder;

});
parcelRegister("979Ct", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "fetch", () => $6a2c3abb9894d801$export$e7aa7bc5c1b3cfb3);
$parcel$export(module.exports, "default", () => $6a2c3abb9894d801$export$2e2bcd8739ae039);
$parcel$export(module.exports, "Headers", () => $6a2c3abb9894d801$export$79b704688b15c0f4);
$parcel$export(module.exports, "Request", () => $6a2c3abb9894d801$export$7fa6c5b6f8193917);
$parcel$export(module.exports, "Response", () => $6a2c3abb9894d801$export$9f633d56d7ec90d3);
"use strict";
// ref: https://github.com/tc39/proposal-global
var $6a2c3abb9894d801$var$getGlobal = function() {
    // the only reliable means to get the global object is
    // `Function('return this')()`
    // However, this causes CSP violations in Chrome apps.
    if (typeof self !== 'undefined') return self;
    if (typeof window !== 'undefined') return window;
    if (typeof $parcel$global !== 'undefined') return $parcel$global;
    throw new Error('unable to locate global object');
};
var $6a2c3abb9894d801$var$globalObject = $6a2c3abb9894d801$var$getGlobal();
const $6a2c3abb9894d801$export$e7aa7bc5c1b3cfb3 = $6a2c3abb9894d801$var$globalObject.fetch;
var $6a2c3abb9894d801$export$2e2bcd8739ae039 = $6a2c3abb9894d801$var$globalObject.fetch.bind($6a2c3abb9894d801$var$globalObject);
const $6a2c3abb9894d801$export$79b704688b15c0f4 = $6a2c3abb9894d801$var$globalObject.Headers;
const $6a2c3abb9894d801$export$7fa6c5b6f8193917 = $6a2c3abb9894d801$var$globalObject.Request;
const $6a2c3abb9894d801$export$9f633d56d7ec90d3 = $6a2c3abb9894d801$var$globalObject.Response;

});

parcelRegister("iN95t", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
/**
 * Error format
 *
 * {@link https://postgrest.org/en/stable/api.html?highlight=options#errors-and-http-status-codes}
 */ class $dae3da29d0e217db$var$PostgrestError extends Error {
    constructor(context){
        super(context.message);
        this.name = 'PostgrestError';
        this.details = context.details;
        this.hint = context.hint;
        this.code = context.code;
    }
}
module.exports.default = $dae3da29d0e217db$var$PostgrestError;

});





parcelRegister("3C7Gg", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.DEFAULT_HEADERS = void 0;

var $k7pAC = parcelRequire("k7pAC");
module.exports.DEFAULT_HEADERS = {
    'X-Client-Info': `postgrest-js/${$k7pAC.version}`
};

});
parcelRegister("k7pAC", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.version = void 0;
module.exports.version = '0.0.0-automated';

});



parcelRegister("8Ue2z", function(module, exports) {
'use strict';

var $eeVib = parcelRequire("eeVib");

var $2zDyE = parcelRequire("2zDyE");
var $67be71da2970b7a8$var$html = $2zDyE($eeVib, 'div');
$67be71da2970b7a8$var$html.displayName = 'html';
module.exports = $67be71da2970b7a8$var$html;

});
parcelRegister("eeVib", function(module, exports) {
'use strict';

var $cOWZl = parcelRequire("cOWZl");

var $7hVQP = parcelRequire("7hVQP");

var $dp35F = parcelRequire("dp35F");

var $9cvpo = parcelRequire("9cvpo");

var $cnARV = parcelRequire("cnARV");

var $9M0Ux = parcelRequire("9M0Ux");
module.exports = $cOWZl([
    $dp35F,
    $7hVQP,
    $9cvpo,
    $cnARV,
    $9M0Ux
]);

});
parcelRegister("cOWZl", function(module, exports) {
'use strict';

var $h0kNM = parcelRequire("h0kNM");

var $kf7Oc = parcelRequire("kf7Oc");
module.exports = $9557e96728c042cf$var$merge;
function $9557e96728c042cf$var$merge(definitions) {
    var length = definitions.length;
    var property = [];
    var normal = [];
    var index = -1;
    var info;
    var space;
    while(++index < length){
        info = definitions[index];
        property.push(info.property);
        normal.push(info.normal);
        space = info.space;
    }
    return new $kf7Oc($h0kNM.apply(null, property), $h0kNM.apply(null, normal), space);
}

});
parcelRegister("h0kNM", function(module, exports) {
module.exports = $c61292941889f8f2$var$extend;
var $c61292941889f8f2$var$hasOwnProperty = Object.prototype.hasOwnProperty;
function $c61292941889f8f2$var$extend() {
    var target = {};
    for(var i = 0; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if ($c61292941889f8f2$var$hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
}

});

parcelRegister("kf7Oc", function(module, exports) {
'use strict';
module.exports = $ebcb43fb277eac89$var$Schema;
var $ebcb43fb277eac89$var$proto = $ebcb43fb277eac89$var$Schema.prototype;
$ebcb43fb277eac89$var$proto.space = null;
$ebcb43fb277eac89$var$proto.normal = {};
$ebcb43fb277eac89$var$proto.property = {};
function $ebcb43fb277eac89$var$Schema(property, normal, space) {
    this.property = property;
    this.normal = normal;
    if (space) this.space = space;
}

});


parcelRegister("7hVQP", function(module, exports) {
'use strict';

var $dhyvo = parcelRequire("dhyvo");
module.exports = $dhyvo({
    space: 'xlink',
    transform: $54e6fef78f3cbe14$var$xlinkTransform,
    properties: {
        xLinkActuate: null,
        xLinkArcRole: null,
        xLinkHref: null,
        xLinkRole: null,
        xLinkShow: null,
        xLinkTitle: null,
        xLinkType: null
    }
});
function $54e6fef78f3cbe14$var$xlinkTransform(_, prop) {
    return 'xlink:' + prop.slice(5).toLowerCase();
}

});
parcelRegister("dhyvo", function(module, exports) {
'use strict';

var $7b46O = parcelRequire("7b46O");

var $kf7Oc = parcelRequire("kf7Oc");

var $j4RPW = parcelRequire("j4RPW");
module.exports = $9ab7a0f2f5273cb1$var$create;
function $9ab7a0f2f5273cb1$var$create(definition) {
    var space = definition.space;
    var mustUseProperty = definition.mustUseProperty || [];
    var attributes = definition.attributes || {};
    var props = definition.properties;
    var transform = definition.transform;
    var property = {};
    var normal = {};
    var prop;
    var info;
    for(prop in props){
        info = new $j4RPW(prop, transform(attributes, prop), props[prop], space);
        if (mustUseProperty.indexOf(prop) !== -1) info.mustUseProperty = true;
        property[prop] = info;
        normal[$7b46O(prop)] = prop;
        normal[$7b46O(info.attribute)] = prop;
    }
    return new $kf7Oc(property, normal, space);
}

});
parcelRegister("7b46O", function(module, exports) {
'use strict';
module.exports = $539cbf68cfd34429$var$normalize;
function $539cbf68cfd34429$var$normalize(value) {
    return value.toLowerCase();
}

});

parcelRegister("j4RPW", function(module, exports) {
'use strict';

var $7kNqS = parcelRequire("7kNqS");

var $aCrbx = parcelRequire("aCrbx");
module.exports = $de3826e2cce515f8$var$DefinedInfo;
$de3826e2cce515f8$var$DefinedInfo.prototype = new $7kNqS();
$de3826e2cce515f8$var$DefinedInfo.prototype.defined = true;
var $de3826e2cce515f8$var$checks = [
    'boolean',
    'booleanish',
    'overloadedBoolean',
    'number',
    'commaSeparated',
    'spaceSeparated',
    'commaOrSpaceSeparated'
];
var $de3826e2cce515f8$var$checksLength = $de3826e2cce515f8$var$checks.length;
function $de3826e2cce515f8$var$DefinedInfo(property, attribute, mask, space) {
    var index = -1;
    var check;
    $de3826e2cce515f8$var$mark(this, 'space', space);
    $7kNqS.call(this, property, attribute);
    while(++index < $de3826e2cce515f8$var$checksLength){
        check = $de3826e2cce515f8$var$checks[index];
        $de3826e2cce515f8$var$mark(this, check, (mask & $aCrbx[check]) === $aCrbx[check]);
    }
}
function $de3826e2cce515f8$var$mark(values, key, value) {
    if (value) values[key] = value;
}

});
parcelRegister("7kNqS", function(module, exports) {
'use strict';
module.exports = $5570beed4f72c7cb$var$Info;
var $5570beed4f72c7cb$var$proto = $5570beed4f72c7cb$var$Info.prototype;
$5570beed4f72c7cb$var$proto.space = null;
$5570beed4f72c7cb$var$proto.attribute = null;
$5570beed4f72c7cb$var$proto.property = null;
$5570beed4f72c7cb$var$proto.boolean = false;
$5570beed4f72c7cb$var$proto.booleanish = false;
$5570beed4f72c7cb$var$proto.overloadedBoolean = false;
$5570beed4f72c7cb$var$proto.number = false;
$5570beed4f72c7cb$var$proto.commaSeparated = false;
$5570beed4f72c7cb$var$proto.spaceSeparated = false;
$5570beed4f72c7cb$var$proto.commaOrSpaceSeparated = false;
$5570beed4f72c7cb$var$proto.mustUseProperty = false;
$5570beed4f72c7cb$var$proto.defined = false;
function $5570beed4f72c7cb$var$Info(property, attribute) {
    this.property = property;
    this.attribute = attribute;
}

});

parcelRegister("aCrbx", function(module, exports) {

$parcel$export(module.exports, "boolean", () => $7bb28a628b951544$export$4a21f16c33752377, (v) => $7bb28a628b951544$export$4a21f16c33752377 = v);
$parcel$export(module.exports, "booleanish", () => $7bb28a628b951544$export$55e9e1fbc638dc8f, (v) => $7bb28a628b951544$export$55e9e1fbc638dc8f = v);
$parcel$export(module.exports, "overloadedBoolean", () => $7bb28a628b951544$export$242ac3d3042558aa, (v) => $7bb28a628b951544$export$242ac3d3042558aa = v);
$parcel$export(module.exports, "number", () => $7bb28a628b951544$export$98e628dec113755e, (v) => $7bb28a628b951544$export$98e628dec113755e = v);
$parcel$export(module.exports, "spaceSeparated", () => $7bb28a628b951544$export$ab8645c862eb5a3e, (v) => $7bb28a628b951544$export$ab8645c862eb5a3e = v);
$parcel$export(module.exports, "commaSeparated", () => $7bb28a628b951544$export$9c8d678629b3d3, (v) => $7bb28a628b951544$export$9c8d678629b3d3 = v);
$parcel$export(module.exports, "commaOrSpaceSeparated", () => $7bb28a628b951544$export$2ad25cfebf36cacd, (v) => $7bb28a628b951544$export$2ad25cfebf36cacd = v);
var $7bb28a628b951544$export$4a21f16c33752377;
var $7bb28a628b951544$export$55e9e1fbc638dc8f;
var $7bb28a628b951544$export$242ac3d3042558aa;
var $7bb28a628b951544$export$98e628dec113755e;
var $7bb28a628b951544$export$ab8645c862eb5a3e;
var $7bb28a628b951544$export$9c8d678629b3d3;
var $7bb28a628b951544$export$2ad25cfebf36cacd;
'use strict';
var $7bb28a628b951544$var$powers = 0;
$7bb28a628b951544$export$4a21f16c33752377 = $7bb28a628b951544$var$increment();
$7bb28a628b951544$export$55e9e1fbc638dc8f = $7bb28a628b951544$var$increment();
$7bb28a628b951544$export$242ac3d3042558aa = $7bb28a628b951544$var$increment();
$7bb28a628b951544$export$98e628dec113755e = $7bb28a628b951544$var$increment();
$7bb28a628b951544$export$ab8645c862eb5a3e = $7bb28a628b951544$var$increment();
$7bb28a628b951544$export$9c8d678629b3d3 = $7bb28a628b951544$var$increment();
$7bb28a628b951544$export$2ad25cfebf36cacd = $7bb28a628b951544$var$increment();
function $7bb28a628b951544$var$increment() {
    return Math.pow(2, ++$7bb28a628b951544$var$powers);
}

});




parcelRegister("dp35F", function(module, exports) {
'use strict';

var $dhyvo = parcelRequire("dhyvo");
module.exports = $dhyvo({
    space: 'xml',
    transform: $9c2001df32d7e0eb$var$xmlTransform,
    properties: {
        xmlLang: null,
        xmlBase: null,
        xmlSpace: null
    }
});
function $9c2001df32d7e0eb$var$xmlTransform(_, prop) {
    return 'xml:' + prop.slice(3).toLowerCase();
}

});

parcelRegister("9cvpo", function(module, exports) {
'use strict';

var $dhyvo = parcelRequire("dhyvo");

var $kPKic = parcelRequire("kPKic");
module.exports = $dhyvo({
    space: 'xmlns',
    attributes: {
        xmlnsxlink: 'xmlns:xlink'
    },
    transform: $kPKic,
    properties: {
        xmlns: null,
        xmlnsXLink: null
    }
});

});
parcelRegister("kPKic", function(module, exports) {
'use strict';

var $luIs3 = parcelRequire("luIs3");
module.exports = $f2ac7ad36db76cd1$var$caseInsensitiveTransform;
function $f2ac7ad36db76cd1$var$caseInsensitiveTransform(attributes, property) {
    return $luIs3(attributes, property.toLowerCase());
}

});
parcelRegister("luIs3", function(module, exports) {
'use strict';
module.exports = $fa5ee16f731231fb$var$caseSensitiveTransform;
function $fa5ee16f731231fb$var$caseSensitiveTransform(attributes, attribute) {
    return attribute in attributes ? attributes[attribute] : attribute;
}

});



parcelRegister("cnARV", function(module, exports) {
'use strict';

var $aCrbx = parcelRequire("aCrbx");

var $dhyvo = parcelRequire("dhyvo");
var $90343b68c9a7ed34$var$booleanish = $aCrbx.booleanish;
var $90343b68c9a7ed34$var$number = $aCrbx.number;
var $90343b68c9a7ed34$var$spaceSeparated = $aCrbx.spaceSeparated;
module.exports = $dhyvo({
    transform: $90343b68c9a7ed34$var$ariaTransform,
    properties: {
        ariaActiveDescendant: null,
        ariaAtomic: $90343b68c9a7ed34$var$booleanish,
        ariaAutoComplete: null,
        ariaBusy: $90343b68c9a7ed34$var$booleanish,
        ariaChecked: $90343b68c9a7ed34$var$booleanish,
        ariaColCount: $90343b68c9a7ed34$var$number,
        ariaColIndex: $90343b68c9a7ed34$var$number,
        ariaColSpan: $90343b68c9a7ed34$var$number,
        ariaControls: $90343b68c9a7ed34$var$spaceSeparated,
        ariaCurrent: null,
        ariaDescribedBy: $90343b68c9a7ed34$var$spaceSeparated,
        ariaDetails: null,
        ariaDisabled: $90343b68c9a7ed34$var$booleanish,
        ariaDropEffect: $90343b68c9a7ed34$var$spaceSeparated,
        ariaErrorMessage: null,
        ariaExpanded: $90343b68c9a7ed34$var$booleanish,
        ariaFlowTo: $90343b68c9a7ed34$var$spaceSeparated,
        ariaGrabbed: $90343b68c9a7ed34$var$booleanish,
        ariaHasPopup: null,
        ariaHidden: $90343b68c9a7ed34$var$booleanish,
        ariaInvalid: null,
        ariaKeyShortcuts: null,
        ariaLabel: null,
        ariaLabelledBy: $90343b68c9a7ed34$var$spaceSeparated,
        ariaLevel: $90343b68c9a7ed34$var$number,
        ariaLive: null,
        ariaModal: $90343b68c9a7ed34$var$booleanish,
        ariaMultiLine: $90343b68c9a7ed34$var$booleanish,
        ariaMultiSelectable: $90343b68c9a7ed34$var$booleanish,
        ariaOrientation: null,
        ariaOwns: $90343b68c9a7ed34$var$spaceSeparated,
        ariaPlaceholder: null,
        ariaPosInSet: $90343b68c9a7ed34$var$number,
        ariaPressed: $90343b68c9a7ed34$var$booleanish,
        ariaReadOnly: $90343b68c9a7ed34$var$booleanish,
        ariaRelevant: null,
        ariaRequired: $90343b68c9a7ed34$var$booleanish,
        ariaRoleDescription: $90343b68c9a7ed34$var$spaceSeparated,
        ariaRowCount: $90343b68c9a7ed34$var$number,
        ariaRowIndex: $90343b68c9a7ed34$var$number,
        ariaRowSpan: $90343b68c9a7ed34$var$number,
        ariaSelected: $90343b68c9a7ed34$var$booleanish,
        ariaSetSize: $90343b68c9a7ed34$var$number,
        ariaSort: null,
        ariaValueMax: $90343b68c9a7ed34$var$number,
        ariaValueMin: $90343b68c9a7ed34$var$number,
        ariaValueNow: $90343b68c9a7ed34$var$number,
        ariaValueText: null,
        role: null
    }
});
function $90343b68c9a7ed34$var$ariaTransform(_, prop) {
    return prop === 'role' ? prop : 'aria-' + prop.slice(4).toLowerCase();
}

});

parcelRegister("9M0Ux", function(module, exports) {
'use strict';

var $aCrbx = parcelRequire("aCrbx");

var $dhyvo = parcelRequire("dhyvo");

var $kPKic = parcelRequire("kPKic");
var $71d94da779c1399e$var$boolean = $aCrbx.boolean;
var $71d94da779c1399e$var$overloadedBoolean = $aCrbx.overloadedBoolean;
var $71d94da779c1399e$var$booleanish = $aCrbx.booleanish;
var $71d94da779c1399e$var$number = $aCrbx.number;
var $71d94da779c1399e$var$spaceSeparated = $aCrbx.spaceSeparated;
var $71d94da779c1399e$var$commaSeparated = $aCrbx.commaSeparated;
module.exports = $dhyvo({
    space: 'html',
    attributes: {
        acceptcharset: 'accept-charset',
        classname: 'class',
        htmlfor: 'for',
        httpequiv: 'http-equiv'
    },
    transform: $kPKic,
    mustUseProperty: [
        'checked',
        'multiple',
        'muted',
        'selected'
    ],
    properties: {
        // Standard Properties.
        abbr: null,
        accept: $71d94da779c1399e$var$commaSeparated,
        acceptCharset: $71d94da779c1399e$var$spaceSeparated,
        accessKey: $71d94da779c1399e$var$spaceSeparated,
        action: null,
        allow: null,
        allowFullScreen: $71d94da779c1399e$var$boolean,
        allowPaymentRequest: $71d94da779c1399e$var$boolean,
        allowUserMedia: $71d94da779c1399e$var$boolean,
        alt: null,
        as: null,
        async: $71d94da779c1399e$var$boolean,
        autoCapitalize: null,
        autoComplete: $71d94da779c1399e$var$spaceSeparated,
        autoFocus: $71d94da779c1399e$var$boolean,
        autoPlay: $71d94da779c1399e$var$boolean,
        capture: $71d94da779c1399e$var$boolean,
        charSet: null,
        checked: $71d94da779c1399e$var$boolean,
        cite: null,
        className: $71d94da779c1399e$var$spaceSeparated,
        cols: $71d94da779c1399e$var$number,
        colSpan: null,
        content: null,
        contentEditable: $71d94da779c1399e$var$booleanish,
        controls: $71d94da779c1399e$var$boolean,
        controlsList: $71d94da779c1399e$var$spaceSeparated,
        coords: $71d94da779c1399e$var$number | $71d94da779c1399e$var$commaSeparated,
        crossOrigin: null,
        data: null,
        dateTime: null,
        decoding: null,
        default: $71d94da779c1399e$var$boolean,
        defer: $71d94da779c1399e$var$boolean,
        dir: null,
        dirName: null,
        disabled: $71d94da779c1399e$var$boolean,
        download: $71d94da779c1399e$var$overloadedBoolean,
        draggable: $71d94da779c1399e$var$booleanish,
        encType: null,
        enterKeyHint: null,
        form: null,
        formAction: null,
        formEncType: null,
        formMethod: null,
        formNoValidate: $71d94da779c1399e$var$boolean,
        formTarget: null,
        headers: $71d94da779c1399e$var$spaceSeparated,
        height: $71d94da779c1399e$var$number,
        hidden: $71d94da779c1399e$var$boolean,
        high: $71d94da779c1399e$var$number,
        href: null,
        hrefLang: null,
        htmlFor: $71d94da779c1399e$var$spaceSeparated,
        httpEquiv: $71d94da779c1399e$var$spaceSeparated,
        id: null,
        imageSizes: null,
        imageSrcSet: $71d94da779c1399e$var$commaSeparated,
        inputMode: null,
        integrity: null,
        is: null,
        isMap: $71d94da779c1399e$var$boolean,
        itemId: null,
        itemProp: $71d94da779c1399e$var$spaceSeparated,
        itemRef: $71d94da779c1399e$var$spaceSeparated,
        itemScope: $71d94da779c1399e$var$boolean,
        itemType: $71d94da779c1399e$var$spaceSeparated,
        kind: null,
        label: null,
        lang: null,
        language: null,
        list: null,
        loading: null,
        loop: $71d94da779c1399e$var$boolean,
        low: $71d94da779c1399e$var$number,
        manifest: null,
        max: null,
        maxLength: $71d94da779c1399e$var$number,
        media: null,
        method: null,
        min: null,
        minLength: $71d94da779c1399e$var$number,
        multiple: $71d94da779c1399e$var$boolean,
        muted: $71d94da779c1399e$var$boolean,
        name: null,
        nonce: null,
        noModule: $71d94da779c1399e$var$boolean,
        noValidate: $71d94da779c1399e$var$boolean,
        onAbort: null,
        onAfterPrint: null,
        onAuxClick: null,
        onBeforePrint: null,
        onBeforeUnload: null,
        onBlur: null,
        onCancel: null,
        onCanPlay: null,
        onCanPlayThrough: null,
        onChange: null,
        onClick: null,
        onClose: null,
        onContextMenu: null,
        onCopy: null,
        onCueChange: null,
        onCut: null,
        onDblClick: null,
        onDrag: null,
        onDragEnd: null,
        onDragEnter: null,
        onDragExit: null,
        onDragLeave: null,
        onDragOver: null,
        onDragStart: null,
        onDrop: null,
        onDurationChange: null,
        onEmptied: null,
        onEnded: null,
        onError: null,
        onFocus: null,
        onFormData: null,
        onHashChange: null,
        onInput: null,
        onInvalid: null,
        onKeyDown: null,
        onKeyPress: null,
        onKeyUp: null,
        onLanguageChange: null,
        onLoad: null,
        onLoadedData: null,
        onLoadedMetadata: null,
        onLoadEnd: null,
        onLoadStart: null,
        onMessage: null,
        onMessageError: null,
        onMouseDown: null,
        onMouseEnter: null,
        onMouseLeave: null,
        onMouseMove: null,
        onMouseOut: null,
        onMouseOver: null,
        onMouseUp: null,
        onOffline: null,
        onOnline: null,
        onPageHide: null,
        onPageShow: null,
        onPaste: null,
        onPause: null,
        onPlay: null,
        onPlaying: null,
        onPopState: null,
        onProgress: null,
        onRateChange: null,
        onRejectionHandled: null,
        onReset: null,
        onResize: null,
        onScroll: null,
        onSecurityPolicyViolation: null,
        onSeeked: null,
        onSeeking: null,
        onSelect: null,
        onSlotChange: null,
        onStalled: null,
        onStorage: null,
        onSubmit: null,
        onSuspend: null,
        onTimeUpdate: null,
        onToggle: null,
        onUnhandledRejection: null,
        onUnload: null,
        onVolumeChange: null,
        onWaiting: null,
        onWheel: null,
        open: $71d94da779c1399e$var$boolean,
        optimum: $71d94da779c1399e$var$number,
        pattern: null,
        ping: $71d94da779c1399e$var$spaceSeparated,
        placeholder: null,
        playsInline: $71d94da779c1399e$var$boolean,
        poster: null,
        preload: null,
        readOnly: $71d94da779c1399e$var$boolean,
        referrerPolicy: null,
        rel: $71d94da779c1399e$var$spaceSeparated,
        required: $71d94da779c1399e$var$boolean,
        reversed: $71d94da779c1399e$var$boolean,
        rows: $71d94da779c1399e$var$number,
        rowSpan: $71d94da779c1399e$var$number,
        sandbox: $71d94da779c1399e$var$spaceSeparated,
        scope: null,
        scoped: $71d94da779c1399e$var$boolean,
        seamless: $71d94da779c1399e$var$boolean,
        selected: $71d94da779c1399e$var$boolean,
        shape: null,
        size: $71d94da779c1399e$var$number,
        sizes: null,
        slot: null,
        span: $71d94da779c1399e$var$number,
        spellCheck: $71d94da779c1399e$var$booleanish,
        src: null,
        srcDoc: null,
        srcLang: null,
        srcSet: $71d94da779c1399e$var$commaSeparated,
        start: $71d94da779c1399e$var$number,
        step: null,
        style: null,
        tabIndex: $71d94da779c1399e$var$number,
        target: null,
        title: null,
        translate: null,
        type: null,
        typeMustMatch: $71d94da779c1399e$var$boolean,
        useMap: null,
        value: $71d94da779c1399e$var$booleanish,
        width: $71d94da779c1399e$var$number,
        wrap: null,
        // Legacy.
        // See: https://html.spec.whatwg.org/#other-elements,-attributes-and-apis
        align: null,
        aLink: null,
        archive: $71d94da779c1399e$var$spaceSeparated,
        axis: null,
        background: null,
        bgColor: null,
        border: $71d94da779c1399e$var$number,
        borderColor: null,
        bottomMargin: $71d94da779c1399e$var$number,
        cellPadding: null,
        cellSpacing: null,
        char: null,
        charOff: null,
        classId: null,
        clear: null,
        code: null,
        codeBase: null,
        codeType: null,
        color: null,
        compact: $71d94da779c1399e$var$boolean,
        declare: $71d94da779c1399e$var$boolean,
        event: null,
        face: null,
        frame: null,
        frameBorder: null,
        hSpace: $71d94da779c1399e$var$number,
        leftMargin: $71d94da779c1399e$var$number,
        link: null,
        longDesc: null,
        lowSrc: null,
        marginHeight: $71d94da779c1399e$var$number,
        marginWidth: $71d94da779c1399e$var$number,
        noResize: $71d94da779c1399e$var$boolean,
        noHref: $71d94da779c1399e$var$boolean,
        noShade: $71d94da779c1399e$var$boolean,
        noWrap: $71d94da779c1399e$var$boolean,
        object: null,
        profile: null,
        prompt: null,
        rev: null,
        rightMargin: $71d94da779c1399e$var$number,
        rules: null,
        scheme: null,
        scrolling: $71d94da779c1399e$var$booleanish,
        standby: null,
        summary: null,
        text: null,
        topMargin: $71d94da779c1399e$var$number,
        valueType: null,
        version: null,
        vAlign: null,
        vLink: null,
        vSpace: $71d94da779c1399e$var$number,
        // Non-standard Properties.
        allowTransparency: null,
        autoCorrect: null,
        autoSave: null,
        disablePictureInPicture: $71d94da779c1399e$var$boolean,
        disableRemotePlayback: $71d94da779c1399e$var$boolean,
        prefix: null,
        property: null,
        results: $71d94da779c1399e$var$number,
        security: null,
        unselectable: null
    }
});

});


parcelRegister("2zDyE", function(module, exports) {
'use strict';

var $1uYJZ = parcelRequire("1uYJZ");

var $7b46O = parcelRequire("7b46O");

var $eRzmM = parcelRequire("eRzmM");

var $4T1Yz = parcelRequire("4T1Yz");
var $1dfd890cf7562da5$require$spaces = $4T1Yz.parse;

var $ath1E = parcelRequire("ath1E");
var $1dfd890cf7562da5$require$commas = $ath1E.parse;
module.exports = $1dfd890cf7562da5$var$factory;
var $1dfd890cf7562da5$var$own = {}.hasOwnProperty;
function $1dfd890cf7562da5$var$factory(schema, defaultTagName, caseSensitive) {
    var adjust = caseSensitive ? $1dfd890cf7562da5$var$createAdjustMap(caseSensitive) : null;
    return h;
    // Hyperscript compatible DSL for creating virtual hast trees.
    function h(selector, properties) {
        var node = $eRzmM(selector, defaultTagName);
        var children = Array.prototype.slice.call(arguments, 2);
        var name = node.tagName.toLowerCase();
        var property;
        node.tagName = adjust && $1dfd890cf7562da5$var$own.call(adjust, name) ? adjust[name] : name;
        if (properties && $1dfd890cf7562da5$var$isChildren(properties, node)) {
            children.unshift(properties);
            properties = null;
        }
        if (properties) for(property in properties)addProperty(node.properties, property, properties[property]);
        $1dfd890cf7562da5$var$addChild(node.children, children);
        if (node.tagName === 'template') {
            node.content = {
                type: 'root',
                children: node.children
            };
            node.children = [];
        }
        return node;
    }
    function addProperty(properties, key, value) {
        var info;
        var property;
        var result;
        // Ignore nullish and NaN values.
        if (value === null || value === undefined || value !== value) return;
        info = $1uYJZ(schema, key);
        property = info.property;
        result = value;
        // Handle list values.
        if (typeof result === 'string') {
            if (info.spaceSeparated) result = $1dfd890cf7562da5$require$spaces(result);
            else if (info.commaSeparated) result = $1dfd890cf7562da5$require$commas(result);
            else if (info.commaOrSpaceSeparated) result = $1dfd890cf7562da5$require$spaces($1dfd890cf7562da5$require$commas(result).join(' '));
        }
        // Accept `object` on style.
        if (property === 'style' && typeof value !== 'string') result = $1dfd890cf7562da5$var$style(result);
        // Class-names (which can be added both on the `selector` and here).
        if (property === 'className' && properties.className) result = properties.className.concat(result);
        properties[property] = $1dfd890cf7562da5$var$parsePrimitives(info, property, result);
    }
}
function $1dfd890cf7562da5$var$isChildren(value, node) {
    return typeof value === 'string' || 'length' in value || $1dfd890cf7562da5$var$isNode(node.tagName, value);
}
function $1dfd890cf7562da5$var$isNode(tagName, value) {
    var type = value.type;
    if (tagName === 'input' || !type || typeof type !== 'string') return false;
    if (typeof value.children === 'object' && 'length' in value.children) return true;
    type = type.toLowerCase();
    if (tagName === 'button') return type !== 'menu' && type !== 'submit' && type !== 'reset' && type !== 'button';
    return 'value' in value;
}
function $1dfd890cf7562da5$var$addChild(nodes, value) {
    var index;
    var length;
    if (typeof value === 'string' || typeof value === 'number') {
        nodes.push({
            type: 'text',
            value: String(value)
        });
        return;
    }
    if (typeof value === 'object' && 'length' in value) {
        index = -1;
        length = value.length;
        while(++index < length)$1dfd890cf7562da5$var$addChild(nodes, value[index]);
        return;
    }
    if (typeof value !== 'object' || !('type' in value)) throw new Error('Expected node, nodes, or string, got `' + value + '`');
    nodes.push(value);
}
// Parse a (list of) primitives.
function $1dfd890cf7562da5$var$parsePrimitives(info, name, value) {
    var index;
    var length;
    var result;
    if (typeof value !== 'object' || !('length' in value)) return $1dfd890cf7562da5$var$parsePrimitive(info, name, value);
    length = value.length;
    index = -1;
    result = [];
    while(++index < length)result[index] = $1dfd890cf7562da5$var$parsePrimitive(info, name, value[index]);
    return result;
}
// Parse a single primitives.
function $1dfd890cf7562da5$var$parsePrimitive(info, name, value) {
    var result = value;
    if (info.number || info.positiveNumber) {
        if (!isNaN(result) && result !== '') result = Number(result);
    } else if (info.boolean || info.overloadedBoolean) // Accept `boolean` and `string`.
    {
        if (typeof result === 'string' && (result === '' || $7b46O(value) === $7b46O(name))) result = true;
    }
    return result;
}
function $1dfd890cf7562da5$var$style(value) {
    var result = [];
    var key;
    for(key in value)result.push([
        key,
        value[key]
    ].join(': '));
    return result.join('; ');
}
function $1dfd890cf7562da5$var$createAdjustMap(values) {
    var length = values.length;
    var index = -1;
    var result = {};
    var value;
    while(++index < length){
        value = values[index];
        result[value.toLowerCase()] = value;
    }
    return result;
}

});
parcelRegister("1uYJZ", function(module, exports) {
'use strict';

var $7b46O = parcelRequire("7b46O");

var $j4RPW = parcelRequire("j4RPW");

var $7kNqS = parcelRequire("7kNqS");
var $1177b5a900e67f19$var$data = 'data';
module.exports = $1177b5a900e67f19$var$find;
var $1177b5a900e67f19$var$valid = /^data[-\w.:]+$/i;
var $1177b5a900e67f19$var$dash = /-[a-z]/g;
var $1177b5a900e67f19$var$cap = /[A-Z]/g;
function $1177b5a900e67f19$var$find(schema, value) {
    var normal = $7b46O(value);
    var prop = value;
    var Type = $7kNqS;
    if (normal in schema.normal) return schema.property[schema.normal[normal]];
    if (normal.length > 4 && normal.slice(0, 4) === $1177b5a900e67f19$var$data && $1177b5a900e67f19$var$valid.test(value)) {
        // Attribute or property.
        if (value.charAt(4) === '-') prop = $1177b5a900e67f19$var$datasetToProperty(value);
        else value = $1177b5a900e67f19$var$datasetToAttribute(value);
        Type = $j4RPW;
    }
    return new Type(prop, value);
}
function $1177b5a900e67f19$var$datasetToProperty(attribute) {
    var value = attribute.slice(5).replace($1177b5a900e67f19$var$dash, $1177b5a900e67f19$var$camelcase);
    return $1177b5a900e67f19$var$data + value.charAt(0).toUpperCase() + value.slice(1);
}
function $1177b5a900e67f19$var$datasetToAttribute(property) {
    var value = property.slice(4);
    if ($1177b5a900e67f19$var$dash.test(value)) return property;
    value = value.replace($1177b5a900e67f19$var$cap, $1177b5a900e67f19$var$kebab);
    if (value.charAt(0) !== '-') value = '-' + value;
    return $1177b5a900e67f19$var$data + value;
}
function $1177b5a900e67f19$var$kebab($0) {
    return '-' + $0.toLowerCase();
}
function $1177b5a900e67f19$var$camelcase($0) {
    return $0.charAt(1).toUpperCase();
}

});

parcelRegister("eRzmM", function(module, exports) {
'use strict';
module.exports = $ad2172fab45600d8$var$parse;
var $ad2172fab45600d8$var$search = /[#.]/g;
// Create a hast element from a simple CSS selector.
function $ad2172fab45600d8$var$parse(selector, defaultTagName) {
    var value = selector || '';
    var name = defaultTagName || 'div';
    var props = {};
    var start = 0;
    var subvalue;
    var previous;
    var match;
    while(start < value.length){
        $ad2172fab45600d8$var$search.lastIndex = start;
        match = $ad2172fab45600d8$var$search.exec(value);
        subvalue = value.slice(start, match ? match.index : value.length);
        if (subvalue) {
            if (!previous) name = subvalue;
            else if (previous === '#') props.id = subvalue;
            else if (props.className) props.className.push(subvalue);
            else props.className = [
                subvalue
            ];
            start += subvalue.length;
        }
        if (match) {
            previous = match[0];
            start++;
        }
    }
    return {
        type: 'element',
        tagName: name,
        properties: props,
        children: []
    };
}

});

parcelRegister("4T1Yz", function(module, exports) {

$parcel$export(module.exports, "parse", () => $38edd4def83e695e$export$98e6a39c04603d36, (v) => $38edd4def83e695e$export$98e6a39c04603d36 = v);
var $38edd4def83e695e$export$98e6a39c04603d36;
var $38edd4def83e695e$export$fac44ee5b035f737;
'use strict';
$38edd4def83e695e$export$98e6a39c04603d36 = $38edd4def83e695e$var$parse;
$38edd4def83e695e$export$fac44ee5b035f737 = $38edd4def83e695e$var$stringify;
var $38edd4def83e695e$var$empty = '';
var $38edd4def83e695e$var$space = ' ';
var $38edd4def83e695e$var$whiteSpace = /[ \t\n\r\f]+/g;
function $38edd4def83e695e$var$parse(value) {
    var input = String(value || $38edd4def83e695e$var$empty).trim();
    return input === $38edd4def83e695e$var$empty ? [] : input.split($38edd4def83e695e$var$whiteSpace);
}
function $38edd4def83e695e$var$stringify(values) {
    return values.join($38edd4def83e695e$var$space).trim();
}

});

parcelRegister("ath1E", function(module, exports) {

$parcel$export(module.exports, "parse", () => $79f9d1c25aee8303$export$98e6a39c04603d36, (v) => $79f9d1c25aee8303$export$98e6a39c04603d36 = v);
var $79f9d1c25aee8303$export$98e6a39c04603d36;
var $79f9d1c25aee8303$export$fac44ee5b035f737;
'use strict';
$79f9d1c25aee8303$export$98e6a39c04603d36 = $79f9d1c25aee8303$var$parse;
$79f9d1c25aee8303$export$fac44ee5b035f737 = $79f9d1c25aee8303$var$stringify;
var $79f9d1c25aee8303$var$comma = ',';
var $79f9d1c25aee8303$var$space = ' ';
var $79f9d1c25aee8303$var$empty = '';
// Parse comma-separated tokens to an array.
function $79f9d1c25aee8303$var$parse(value) {
    var values = [];
    var input = String(value || $79f9d1c25aee8303$var$empty);
    var index = input.indexOf($79f9d1c25aee8303$var$comma);
    var lastIndex = 0;
    var end = false;
    var val;
    while(!end){
        if (index === -1) {
            index = input.length;
            end = true;
        }
        val = input.slice(lastIndex, index).trim();
        if (val || !end) values.push(val);
        lastIndex = index + 1;
        index = input.indexOf($79f9d1c25aee8303$var$comma, lastIndex);
    }
    return values;
}
// Compile an array to comma-separated tokens.
// `options.padLeft` (default: `true`) pads a space left of each token, and
// `options.padRight` (default: `false`) pads a space to the right of each token.
function $79f9d1c25aee8303$var$stringify(values, options) {
    var settings = options || {};
    var left = settings.padLeft === false ? $79f9d1c25aee8303$var$empty : $79f9d1c25aee8303$var$space;
    var right = settings.padRight ? $79f9d1c25aee8303$var$space : $79f9d1c25aee8303$var$empty;
    // Ensure the last empty entry is seen.
    if (values[values.length - 1] === $79f9d1c25aee8303$var$empty) values = values.concat($79f9d1c25aee8303$var$empty);
    return values.join(right + $79f9d1c25aee8303$var$comma + left).trim();
}

});



parcelRegister("Txy2b", function(module, exports) {
'use strict';
module.exports = $0a6f2917458e855b$var$abap;
$0a6f2917458e855b$var$abap.displayName = 'abap';
$0a6f2917458e855b$var$abap.aliases = [];
function $0a6f2917458e855b$var$abap(Prism) {
    Prism.languages.abap = {
        comment: /^\*.*/m,
        string: /(`|')(?:\\.|(?!\1)[^\\\r\n])*\1/,
        'string-template': {
            pattern: /([|}])(?:\\.|[^\\|{\r\n])*(?=[|{])/,
            lookbehind: true,
            alias: 'string'
        },
        /* End Of Line comments should not interfere with strings when the
quote character occurs within them. We assume a string being highlighted
inside an EOL comment is more acceptable than the opposite.
*/ 'eol-comment': {
            pattern: /(^|\s)".*/m,
            lookbehind: true,
            alias: 'comment'
        },
        keyword: {
            pattern: /(\s|\.|^)(?:SCIENTIFIC_WITH_LEADING_ZERO|SCALE_PRESERVING_SCIENTIFIC|RMC_COMMUNICATION_FAILURE|END-ENHANCEMENT-SECTION|MULTIPLY-CORRESPONDING|SUBTRACT-CORRESPONDING|VERIFICATION-MESSAGE|DIVIDE-CORRESPONDING|ENHANCEMENT-SECTION|CURRENCY_CONVERSION|RMC_SYSTEM_FAILURE|START-OF-SELECTION|MOVE-CORRESPONDING|RMC_INVALID_STATUS|CUSTOMER-FUNCTION|END-OF-DEFINITION|ENHANCEMENT-POINT|SYSTEM-EXCEPTIONS|ADD-CORRESPONDING|SCALE_PRESERVING|SELECTION-SCREEN|CURSOR-SELECTION|END-OF-SELECTION|LOAD-OF-PROGRAM|SCROLL-BOUNDARY|SELECTION-TABLE|EXCEPTION-TABLE|IMPLEMENTATIONS|PARAMETER-TABLE|RIGHT-JUSTIFIED|UNIT_CONVERSION|AUTHORITY-CHECK|LIST-PROCESSING|SIGN_AS_POSTFIX|COL_BACKGROUND|IMPLEMENTATION|INTERFACE-POOL|TRANSFORMATION|IDENTIFICATION|ENDENHANCEMENT|LINE-SELECTION|INITIALIZATION|LEFT-JUSTIFIED|SELECT-OPTIONS|SELECTION-SETS|COMMUNICATION|CORRESPONDING|DECIMAL_SHIFT|PRINT-CONTROL|VALUE-REQUEST|CHAIN-REQUEST|FUNCTION-POOL|FIELD-SYMBOLS|FUNCTIONALITY|INVERTED-DATE|SELECTION-SET|CLASS-METHODS|OUTPUT-LENGTH|CLASS-CODING|COL_NEGATIVE|ERRORMESSAGE|FIELD-GROUPS|HELP-REQUEST|NO-EXTENSION|NO-TOPOFPAGE|REDEFINITION|DISPLAY-MODE|ENDINTERFACE|EXIT-COMMAND|FIELD-SYMBOL|NO-SCROLLING|SHORTDUMP-ID|ACCESSPOLICY|CLASS-EVENTS|COL_POSITIVE|DECLARATIONS|ENHANCEMENTS|FILTER-TABLE|SWITCHSTATES|SYNTAX-CHECK|TRANSPORTING|ASYNCHRONOUS|SYNTAX-TRACE|TOKENIZATION|USER-COMMAND|WITH-HEADING|ABAP-SOURCE|BREAK-POINT|CHAIN-INPUT|COMPRESSION|FIXED-POINT|NEW-SECTION|NON-UNICODE|OCCURRENCES|RESPONSIBLE|SYSTEM-CALL|TRACE-TABLE|ABBREVIATED|CHAR-TO-HEX|END-OF-FILE|ENDFUNCTION|ENVIRONMENT|ASSOCIATION|COL_HEADING|EDITOR-CALL|END-OF-PAGE|ENGINEERING|IMPLEMENTED|INTENSIFIED|RADIOBUTTON|SYSTEM-EXIT|TOP-OF-PAGE|TRANSACTION|APPLICATION|CONCATENATE|DESTINATION|ENHANCEMENT|IMMEDIATELY|NO-GROUPING|PRECOMPILED|REPLACEMENT|TITLE-LINES|ACTIVATION|BYTE-ORDER|CLASS-POOL|CONNECTION|CONVERSION|DEFINITION|DEPARTMENT|EXPIRATION|INHERITING|MESSAGE-ID|NO-HEADING|PERFORMING|QUEUE-ONLY|RIGHTSPACE|SCIENTIFIC|STATUSINFO|STRUCTURES|SYNCPOINTS|WITH-TITLE|ATTRIBUTES|BOUNDARIES|CLASS-DATA|COL_NORMAL|DD\/MM\/YYYY|DESCENDING|INTERFACES|LINE-COUNT|MM\/DD\/YYYY|NON-UNIQUE|PRESERVING|SELECTIONS|STATEMENTS|SUBROUTINE|TRUNCATION|TYPE-POOLS|ARITHMETIC|BACKGROUND|ENDPROVIDE|EXCEPTIONS|IDENTIFIER|INDEX-LINE|OBLIGATORY|PARAMETERS|PERCENTAGE|PUSHBUTTON|RESOLUTION|COMPONENTS|DEALLOCATE|DISCONNECT|DUPLICATES|FIRST-LINE|HEAD-LINES|NO-DISPLAY|OCCURRENCE|RESPECTING|RETURNCODE|SUBMATCHES|TRACE-FILE|ASCENDING|BYPASSING|ENDMODULE|EXCEPTION|EXCLUDING|EXPORTING|INCREMENT|MATCHCODE|PARAMETER|PARTIALLY|PREFERRED|REFERENCE|REPLACING|RETURNING|SELECTION|SEPARATED|SPECIFIED|STATEMENT|TIMESTAMP|TYPE-POOL|ACCEPTING|APPENDAGE|ASSIGNING|COL_GROUP|COMPARING|CONSTANTS|DANGEROUS|IMPORTING|INSTANCES|LEFTSPACE|LOG-POINT|QUICKINFO|READ-ONLY|SCROLLING|SQLSCRIPT|STEP-LOOP|TOP-LINES|TRANSLATE|APPENDING|AUTHORITY|CHARACTER|COMPONENT|CONDITION|DIRECTORY|DUPLICATE|MESSAGING|RECEIVING|SUBSCREEN|ACCORDING|COL_TOTAL|END-LINES|ENDMETHOD|ENDSELECT|EXPANDING|EXTENSION|INCLUDING|INFOTYPES|INTERFACE|INTERVALS|LINE-SIZE|PF-STATUS|PROCEDURE|PROTECTED|REQUESTED|RESUMABLE|RIGHTPLUS|SAP-SPOOL|SECONDARY|STRUCTURE|SUBSTRING|TABLEVIEW|NUMOFCHAR|ADJACENT|ANALYSIS|ASSIGNED|BACKWARD|CHANNELS|CHECKBOX|CONTINUE|CRITICAL|DATAINFO|DD\/MM\/YY|DURATION|ENCODING|ENDCLASS|FUNCTION|LEFTPLUS|LINEFEED|MM\/DD\/YY|OVERFLOW|RECEIVED|SKIPPING|SORTABLE|STANDARD|SUBTRACT|SUPPRESS|TABSTRIP|TITLEBAR|TRUNCATE|UNASSIGN|WHENEVER|ANALYZER|COALESCE|COMMENTS|CONDENSE|DECIMALS|DEFERRED|ENDWHILE|EXPLICIT|KEYWORDS|MESSAGES|POSITION|PRIORITY|RECEIVER|RENAMING|TIMEZONE|TRAILING|ALLOCATE|CENTERED|CIRCULAR|CONTROLS|CURRENCY|DELETING|DESCRIBE|DISTANCE|ENDCATCH|EXPONENT|EXTENDED|GENERATE|IGNORING|INCLUDES|INTERNAL|MAJOR-ID|MODIFIER|NEW-LINE|OPTIONAL|PROPERTY|ROLLBACK|STARTING|SUPPLIED|ABSTRACT|CHANGING|CONTEXTS|CREATING|CUSTOMER|DATABASE|DAYLIGHT|DEFINING|DISTINCT|DIVISION|ENABLING|ENDCHAIN|ESCAPING|HARMLESS|IMPLICIT|INACTIVE|LANGUAGE|MINOR-ID|MULTIPLY|NEW-PAGE|NO-TITLE|POS_HIGH|SEPARATE|TEXTPOOL|TRANSFER|SELECTOR|DBMAXLEN|ITERATOR|ARCHIVE|BIT-XOR|BYTE-CO|COLLECT|COMMENT|CURRENT|DEFAULT|DISPLAY|ENDFORM|EXTRACT|LEADING|LISTBOX|LOCATOR|MEMBERS|METHODS|NESTING|POS_LOW|PROCESS|PROVIDE|RAISING|RESERVE|SECONDS|SUMMARY|VISIBLE|BETWEEN|BIT-AND|BYTE-CS|CLEANUP|COMPUTE|CONTROL|CONVERT|DATASET|ENDCASE|FORWARD|HEADERS|HOTSPOT|INCLUDE|INVERSE|KEEPING|NO-ZERO|OBJECTS|OVERLAY|PADDING|PATTERN|PROGRAM|REFRESH|SECTION|SUMMING|TESTING|VERSION|WINDOWS|WITHOUT|BIT-NOT|BYTE-CA|BYTE-NA|CASTING|CONTEXT|COUNTRY|DYNAMIC|ENABLED|ENDLOOP|EXECUTE|FRIENDS|HANDLER|HEADING|INITIAL|\*-INPUT|LOGFILE|MAXIMUM|MINIMUM|NO-GAPS|NO-SIGN|PRAGMAS|PRIMARY|PRIVATE|REDUCED|REPLACE|REQUEST|RESULTS|UNICODE|WARNING|ALIASES|BYTE-CN|BYTE-NS|CALLING|COL_KEY|COLUMNS|CONNECT|ENDEXEC|ENTRIES|EXCLUDE|FILTERS|FURTHER|HELP-ID|LOGICAL|MAPPING|MESSAGE|NAMETAB|OPTIONS|PACKAGE|PERFORM|RECEIVE|STATICS|VARYING|BINDING|CHARLEN|GREATER|XSTRLEN|ACCEPT|APPEND|DETAIL|ELSEIF|ENDING|ENDTRY|FORMAT|FRAMES|GIVING|HASHED|HEADER|IMPORT|INSERT|MARGIN|MODULE|NATIVE|OBJECT|OFFSET|REMOTE|RESUME|SAVING|SIMPLE|SUBMIT|TABBED|TOKENS|UNIQUE|UNPACK|UPDATE|WINDOW|YELLOW|ACTUAL|ASPECT|CENTER|CURSOR|DELETE|DIALOG|DIVIDE|DURING|ERRORS|EVENTS|EXTEND|FILTER|HANDLE|HAVING|IGNORE|LITTLE|MEMORY|NO-GAP|OCCURS|OPTION|PERSON|PLACES|PUBLIC|REDUCE|REPORT|RESULT|SINGLE|SORTED|SWITCH|SYNTAX|TARGET|VALUES|WRITER|ASSERT|BLOCKS|BOUNDS|BUFFER|CHANGE|COLUMN|COMMIT|CONCAT|COPIES|CREATE|DDMMYY|DEFINE|ENDIAN|ESCAPE|EXPAND|KERNEL|LAYOUT|LEGACY|LEVELS|MMDDYY|NUMBER|OUTPUT|RANGES|READER|RETURN|SCREEN|SEARCH|SELECT|SHARED|SOURCE|STABLE|STATIC|SUBKEY|SUFFIX|TABLES|UNWIND|YYMMDD|ASSIGN|BACKUP|BEFORE|BINARY|BIT-OR|BLANKS|CLIENT|CODING|COMMON|DEMAND|DYNPRO|EXCEPT|EXISTS|EXPORT|FIELDS|GLOBAL|GROUPS|LENGTH|LOCALE|MEDIUM|METHOD|MODIFY|NESTED|OTHERS|REJECT|SCROLL|SUPPLY|SYMBOL|ENDFOR|STRLEN|ALIGN|BEGIN|BOUND|ENDAT|ENTRY|EVENT|FINAL|FLUSH|GRANT|INNER|SHORT|USING|WRITE|AFTER|BLACK|BLOCK|CLOCK|COLOR|COUNT|DUMMY|EMPTY|ENDDO|ENDON|GREEN|INDEX|INOUT|LEAVE|LEVEL|LINES|MODIF|ORDER|OUTER|RANGE|RESET|RETRY|RIGHT|SMART|SPLIT|STYLE|TABLE|THROW|UNDER|UNTIL|UPPER|UTF-8|WHERE|ALIAS|BLANK|CLEAR|CLOSE|EXACT|FETCH|FIRST|FOUND|GROUP|LLANG|LOCAL|OTHER|REGEX|SPOOL|TITLE|TYPES|VALID|WHILE|ALPHA|BOXED|CATCH|CHAIN|CHECK|CLASS|COVER|ENDIF|EQUIV|FIELD|FLOOR|FRAME|INPUT|LOWER|MATCH|NODES|PAGES|PRINT|RAISE|ROUND|SHIFT|SPACE|SPOTS|STAMP|STATE|TASKS|TIMES|TRMAC|ULINE|UNION|VALUE|WIDTH|EQUAL|LOG10|TRUNC|BLOB|CASE|CEIL|CLOB|COND|EXIT|FILE|GAPS|HOLD|INCL|INTO|KEEP|KEYS|LAST|LINE|LONG|LPAD|MAIL|MODE|OPEN|PINK|READ|ROWS|TEST|THEN|ZERO|AREA|BACK|BADI|BYTE|CAST|EDIT|EXEC|FAIL|FIND|FKEQ|FONT|FREE|GKEQ|HIDE|INIT|ITNO|LATE|LOOP|MAIN|MARK|MOVE|NEXT|NULL|RISK|ROLE|UNIT|WAIT|ZONE|BASE|CALL|CODE|DATA|DATE|FKGE|GKGE|HIGH|KIND|LEFT|LIST|MASK|MESH|NAME|NODE|PACK|PAGE|POOL|SEND|SIGN|SIZE|SOME|STOP|TASK|TEXT|TIME|USER|VARY|WITH|WORD|BLUE|CONV|COPY|DEEP|ELSE|FORM|FROM|HINT|ICON|JOIN|LIKE|LOAD|ONLY|PART|SCAN|SKIP|SORT|TYPE|UNIX|VIEW|WHEN|WORK|ACOS|ASIN|ATAN|COSH|EACH|FRAC|LESS|RTTI|SINH|SQRT|TANH|AVG|BIT|DIV|ISO|LET|OUT|PAD|SQL|ALL|CI_|CPI|END|LOB|LPI|MAX|MIN|NEW|OLE|RUN|SET|\?TO|YES|ABS|ADD|AND|BIG|FOR|HDB|JOB|LOW|NOT|SAP|TRY|VIA|XML|ANY|GET|IDS|KEY|MOD|OFF|PUT|RAW|RED|REF|SUM|TAB|XSD|CNT|COS|EXP|LOG|SIN|TAN|XOR|AT|CO|CP|DO|GT|ID|IF|NS|OR|BT|CA|CS|GE|NA|NB|EQ|IN|LT|NE|NO|OF|ON|PF|TO|AS|BY|CN|IS|LE|NP|UP|E|I|M|O|Z|C|X)\b/i,
            lookbehind: true
        },
        /* Numbers can be only integers. Decimal or Hex appear only as strings */ number: /\b\d+\b/,
        /* Operators must always be surrounded by whitespace, they cannot be put
adjacent to operands.
*/ operator: {
            pattern: /(\s)(?:\*\*?|<[=>]?|>=?|\?=|[-+\/=])(?=\s)/,
            lookbehind: true
        },
        'string-operator': {
            pattern: /(\s)&&?(?=\s)/,
            lookbehind: true,
            /* The official editor highlights */ alias: 'keyword'
        },
        'token-operator': [
            {
                /* Special operators used to access structure components, class methods/attributes, etc. */ pattern: /(\w)(?:->?|=>|[~|{}])(?=\w)/,
                lookbehind: true,
                alias: 'punctuation'
            },
            {
                /* Special tokens used do delimit string templates */ pattern: /[|{}]/,
                alias: 'punctuation'
            }
        ],
        punctuation: /[,.:()]/
    };
}

});

parcelRegister("hm5YG", function(module, exports) {
'use strict';
module.exports = $ca2920d2c852a964$var$abnf;
$ca2920d2c852a964$var$abnf.displayName = 'abnf';
$ca2920d2c852a964$var$abnf.aliases = [];
function $ca2920d2c852a964$var$abnf(Prism) {
    (function(Prism) {
        var coreRules = '(?:ALPHA|BIT|CHAR|CR|CRLF|CTL|DIGIT|DQUOTE|HEXDIG|HTAB|LF|LWSP|OCTET|SP|VCHAR|WSP)';
        Prism.languages.abnf = {
            comment: /;.*/,
            string: {
                pattern: /(?:%[is])?"[^"\n\r]*"/,
                greedy: true,
                inside: {
                    punctuation: /^%[is]/
                }
            },
            range: {
                pattern: /%(?:b[01]+-[01]+|d\d+-\d+|x[A-F\d]+-[A-F\d]+)/i,
                alias: 'number'
            },
            terminal: {
                pattern: /%(?:b[01]+(?:\.[01]+)*|d\d+(?:\.\d+)*|x[A-F\d]+(?:\.[A-F\d]+)*)/i,
                alias: 'number'
            },
            repetition: {
                pattern: /(^|[^\w-])(?:\d*\*\d*|\d+)/,
                lookbehind: true,
                alias: 'operator'
            },
            definition: {
                pattern: /(^[ \t]*)(?:[a-z][\w-]*|<[^<>\r\n]*>)(?=\s*=)/m,
                lookbehind: true,
                alias: 'keyword',
                inside: {
                    punctuation: /<|>/
                }
            },
            'core-rule': {
                pattern: RegExp('(?:(^|[^<\\w-])' + coreRules + '|<' + coreRules + '>)(?![\\w-])', 'i'),
                lookbehind: true,
                alias: [
                    'rule',
                    'constant'
                ],
                inside: {
                    punctuation: /<|>/
                }
            },
            rule: {
                pattern: /(^|[^<\w-])[a-z][\w-]*|<[^<>\r\n]*>/i,
                lookbehind: true,
                inside: {
                    punctuation: /<|>/
                }
            },
            operator: /=\/?|\//,
            punctuation: /[()\[\]]/
        };
    })(Prism);
}

});

parcelRegister("kHzqh", function(module, exports) {
'use strict';
module.exports = $f1234d103ba18cce$var$actionscript;
$f1234d103ba18cce$var$actionscript.displayName = 'actionscript';
$f1234d103ba18cce$var$actionscript.aliases = [];
function $f1234d103ba18cce$var$actionscript(Prism) {
    Prism.languages.actionscript = Prism.languages.extend('javascript', {
        keyword: /\b(?:as|break|case|catch|class|const|default|delete|do|dynamic|each|else|extends|final|finally|for|function|get|if|implements|import|in|include|instanceof|interface|internal|is|namespace|native|new|null|override|package|private|protected|public|return|set|static|super|switch|this|throw|try|typeof|use|var|void|while|with)\b/,
        operator: /\+\+|--|(?:[+\-*\/%^]|&&?|\|\|?|<<?|>>?>?|[!=]=?)=?|[~?@]/
    });
    Prism.languages.actionscript['class-name'].alias = 'function' // doesn't work with AS because AS is too complex
    ;
    delete Prism.languages.actionscript['parameter'];
    delete Prism.languages.actionscript['literal-property'];
    if (Prism.languages.markup) Prism.languages.insertBefore('actionscript', 'string', {
        xml: {
            pattern: /(^|[^.])<\/?\w+(?:\s+[^\s>\/=]+=("|')(?:\\[\s\S]|(?!\2)[^\\])*\2)*\s*\/?>/,
            lookbehind: true,
            inside: Prism.languages.markup
        }
    });
}

});

parcelRegister("6aOpc", function(module, exports) {
'use strict';
module.exports = $47eac6b8d3d2faf5$var$ada;
$47eac6b8d3d2faf5$var$ada.displayName = 'ada';
$47eac6b8d3d2faf5$var$ada.aliases = [];
function $47eac6b8d3d2faf5$var$ada(Prism) {
    Prism.languages.ada = {
        comment: /--.*/,
        string: /"(?:""|[^"\r\f\n])*"/,
        number: [
            {
                pattern: /\b\d(?:_?\d)*#[\dA-F](?:_?[\dA-F])*(?:\.[\dA-F](?:_?[\dA-F])*)?#(?:E[+-]?\d(?:_?\d)*)?/i
            },
            {
                pattern: /\b\d(?:_?\d)*(?:\.\d(?:_?\d)*)?(?:E[+-]?\d(?:_?\d)*)?\b/i
            }
        ],
        'attr-name': /\b'\w+/,
        keyword: /\b(?:abort|abs|abstract|accept|access|aliased|all|and|array|at|begin|body|case|constant|declare|delay|delta|digits|do|else|elsif|end|entry|exception|exit|for|function|generic|goto|if|in|interface|is|limited|loop|mod|new|not|null|of|others|out|overriding|package|pragma|private|procedure|protected|raise|range|record|rem|renames|requeue|return|reverse|select|separate|some|subtype|synchronized|tagged|task|terminate|then|type|until|use|when|while|with|xor)\b/i,
        boolean: /\b(?:false|true)\b/i,
        operator: /<[=>]?|>=?|=>?|:=|\/=?|\*\*?|[&+-]/,
        punctuation: /\.\.?|[,;():]/,
        char: /'.'/,
        variable: /\b[a-z](?:\w)*\b/i
    };
}

});

parcelRegister("9TMK5", function(module, exports) {
'use strict';
module.exports = $734f0f4eeceda8a9$var$agda;
$734f0f4eeceda8a9$var$agda.displayName = 'agda';
$734f0f4eeceda8a9$var$agda.aliases = [];
function $734f0f4eeceda8a9$var$agda(Prism) {
    (function(Prism) {
        Prism.languages.agda = {
            comment: /\{-[\s\S]*?(?:-\}|$)|--.*/,
            string: {
                pattern: /"(?:\\(?:\r\n|[\s\S])|[^\\\r\n"])*"/,
                greedy: true
            },
            punctuation: /[(){}⦃⦄.;@]/,
            'class-name': {
                pattern: /((?:data|record) +)\S+/,
                lookbehind: true
            },
            function: {
                pattern: /(^[ \t]*)(?!\s)[^:\r\n]+(?=:)/m,
                lookbehind: true
            },
            operator: {
                pattern: /(^\s*|\s)(?:[=|:∀→λ\\?_]|->)(?=\s)/,
                lookbehind: true
            },
            keyword: /\b(?:Set|abstract|constructor|data|eta-equality|field|forall|hiding|import|in|inductive|infix|infixl|infixr|instance|let|macro|module|mutual|no-eta-equality|open|overlap|pattern|postulate|primitive|private|public|quote|quoteContext|quoteGoal|quoteTerm|record|renaming|rewrite|syntax|tactic|unquote|unquoteDecl|unquoteDef|using|variable|where|with)\b/
        };
    })(Prism);
}

});

parcelRegister("1DSDX", function(module, exports) {
'use strict';
module.exports = $1323d208ce33485a$var$al;
$1323d208ce33485a$var$al.displayName = 'al';
$1323d208ce33485a$var$al.aliases = [];
function $1323d208ce33485a$var$al(Prism) {
    // based on https://github.com/microsoft/AL/blob/master/grammar/alsyntax.tmlanguage
    Prism.languages.al = {
        comment: /\/\/.*|\/\*[\s\S]*?\*\//,
        string: {
            pattern: /'(?:''|[^'\r\n])*'(?!')|"(?:""|[^"\r\n])*"(?!")/,
            greedy: true
        },
        function: {
            pattern: /(\b(?:event|procedure|trigger)\s+|(?:^|[^.])\.\s*)[a-z_]\w*(?=\s*\()/i,
            lookbehind: true
        },
        keyword: [
            // keywords
            /\b(?:array|asserterror|begin|break|case|do|downto|else|end|event|exit|for|foreach|function|if|implements|in|indataset|interface|internal|local|of|procedure|program|protected|repeat|runonclient|securityfiltering|suppressdispose|temporary|then|to|trigger|until|var|while|with|withevents)\b/i,
            /\b(?:action|actions|addafter|addbefore|addfirst|addlast|area|assembly|chartpart|codeunit|column|controladdin|cuegroup|customizes|dataitem|dataset|dotnet|elements|enum|enumextension|extends|field|fieldattribute|fieldelement|fieldgroup|fieldgroups|fields|filter|fixed|grid|group|key|keys|label|labels|layout|modify|moveafter|movebefore|movefirst|movelast|page|pagecustomization|pageextension|part|profile|query|repeater|report|requestpage|schema|separator|systempart|table|tableelement|tableextension|textattribute|textelement|type|usercontrol|value|xmlport)\b/i
        ],
        number: /\b(?:0x[\da-f]+|(?:\d+(?:\.\d*)?|\.\d+)(?:e[+-]?\d+)?)(?:F|LL?|U(?:LL?)?)?\b/i,
        boolean: /\b(?:false|true)\b/i,
        variable: /\b(?:Curr(?:FieldNo|Page|Report)|x?Rec|RequestOptionsPage)\b/,
        'class-name': /\b(?:automation|biginteger|bigtext|blob|boolean|byte|char|clienttype|code|completiontriggererrorlevel|connectiontype|database|dataclassification|datascope|date|dateformula|datetime|decimal|defaultlayout|dialog|dictionary|dotnetassembly|dotnettypedeclaration|duration|errorinfo|errortype|executioncontext|executionmode|fieldclass|fieldref|fieldtype|file|filterpagebuilder|guid|httpclient|httpcontent|httpheaders|httprequestmessage|httpresponsemessage|instream|integer|joker|jsonarray|jsonobject|jsontoken|jsonvalue|keyref|list|moduledependencyinfo|moduleinfo|none|notification|notificationscope|objecttype|option|outstream|pageresult|record|recordid|recordref|reportformat|securityfilter|sessionsettings|tableconnectiontype|tablefilter|testaction|testfield|testfilterfield|testpage|testpermissions|testrequestpage|text|textbuilder|textconst|textencoding|time|transactionmodel|transactiontype|variant|verbosity|version|view|views|webserviceactioncontext|webserviceactionresultcode|xmlattribute|xmlattributecollection|xmlcdata|xmlcomment|xmldeclaration|xmldocument|xmldocumenttype|xmlelement|xmlnamespacemanager|xmlnametable|xmlnode|xmlnodelist|xmlprocessinginstruction|xmlreadoptions|xmltext|xmlwriteoptions)\b/i,
        operator: /\.\.|:[=:]|[-+*/]=?|<>|[<>]=?|=|\b(?:and|div|mod|not|or|xor)\b/i,
        punctuation: /[()\[\]{}:.;,]/
    };
}

});

parcelRegister("6vMTf", function(module, exports) {
'use strict';
module.exports = $4bdb8fdfad3e47fd$var$antlr4;
$4bdb8fdfad3e47fd$var$antlr4.displayName = 'antlr4';
$4bdb8fdfad3e47fd$var$antlr4.aliases = [
    'g4'
];
function $4bdb8fdfad3e47fd$var$antlr4(Prism) {
    Prism.languages.antlr4 = {
        comment: /\/\/.*|\/\*[\s\S]*?(?:\*\/|$)/,
        string: {
            pattern: /'(?:\\.|[^\\'\r\n])*'/,
            greedy: true
        },
        'character-class': {
            pattern: /\[(?:\\.|[^\\\]\r\n])*\]/,
            greedy: true,
            alias: 'regex',
            inside: {
                range: {
                    pattern: /([^[]|(?:^|[^\\])(?:\\\\)*\\\[)-(?!\])/,
                    lookbehind: true,
                    alias: 'punctuation'
                },
                escape: /\\(?:u(?:[a-fA-F\d]{4}|\{[a-fA-F\d]+\})|[pP]\{[=\w-]+\}|[^\r\nupP])/,
                punctuation: /[\[\]]/
            }
        },
        action: {
            pattern: /\{(?:[^{}]|\{(?:[^{}]|\{(?:[^{}]|\{[^{}]*\})*\})*\})*\}/,
            greedy: true,
            inside: {
                content: {
                    // this might be C, C++, Python, Java, C#, or any other language ANTLR4 compiles to
                    pattern: /(\{)[\s\S]+(?=\})/,
                    lookbehind: true
                },
                punctuation: /[{}]/
            }
        },
        command: {
            pattern: /(->\s*(?!\s))(?:\s*(?:,\s*)?\b[a-z]\w*(?:\s*\([^()\r\n]*\))?)+(?=\s*;)/i,
            lookbehind: true,
            inside: {
                function: /\b\w+(?=\s*(?:[,(]|$))/,
                punctuation: /[,()]/
            }
        },
        annotation: {
            pattern: /@\w+(?:::\w+)*/,
            alias: 'keyword'
        },
        label: {
            pattern: /#[ \t]*\w+/,
            alias: 'punctuation'
        },
        keyword: /\b(?:catch|channels|finally|fragment|grammar|import|lexer|locals|mode|options|parser|returns|throws|tokens)\b/,
        definition: [
            {
                pattern: /\b[a-z]\w*(?=\s*:)/,
                alias: [
                    'rule',
                    'class-name'
                ]
            },
            {
                pattern: /\b[A-Z]\w*(?=\s*:)/,
                alias: [
                    'token',
                    'constant'
                ]
            }
        ],
        constant: /\b[A-Z][A-Z_]*\b/,
        operator: /\.\.|->|[|~]|[*+?]\??/,
        punctuation: /[;:()=]/
    };
    Prism.languages.g4 = Prism.languages.antlr4;
}

});

parcelRegister("gM0NZ", function(module, exports) {
'use strict';
module.exports = $c361c0eded0f6a62$var$apacheconf;
$c361c0eded0f6a62$var$apacheconf.displayName = 'apacheconf';
$c361c0eded0f6a62$var$apacheconf.aliases = [];
function $c361c0eded0f6a62$var$apacheconf(Prism) {
    Prism.languages.apacheconf = {
        comment: /#.*/,
        'directive-inline': {
            pattern: /(^[\t ]*)\b(?:AcceptFilter|AcceptPathInfo|AccessFileName|Action|Add(?:Alt|AltByEncoding|AltByType|Charset|DefaultCharset|Description|Encoding|Handler|Icon|IconByEncoding|IconByType|InputFilter|Language|ModuleInfo|OutputFilter|OutputFilterByType|Type)|Alias|AliasMatch|Allow(?:CONNECT|EncodedSlashes|Methods|Override|OverrideList)?|Anonymous(?:_LogEmail|_MustGiveEmail|_NoUserID|_VerifyEmail)?|AsyncRequestWorkerFactor|Auth(?:BasicAuthoritative|BasicFake|BasicProvider|BasicUseDigestAlgorithm|DBDUserPWQuery|DBDUserRealmQuery|DBMGroupFile|DBMType|DBMUserFile|Digest(?:Algorithm|Domain|NonceLifetime|Provider|Qop|ShmemSize)|Form(?:Authoritative|Body|DisableNoStore|FakeBasicAuth|Location|LoginRequiredLocation|LoginSuccessLocation|LogoutLocation|Method|Mimetype|Password|Provider|SitePassphrase|Size|Username)|GroupFile|LDAP(?:AuthorizePrefix|BindAuthoritative|BindDN|BindPassword|CharsetConfig|CompareAsUser|CompareDNOnServer|DereferenceAliases|GroupAttribute|GroupAttributeIsDN|InitialBindAsUser|InitialBindPattern|MaxSubGroupDepth|RemoteUserAttribute|RemoteUserIsDN|SearchAsUser|SubGroupAttribute|SubGroupClass|Url)|Merging|Name|nCache(?:Context|Enable|ProvideFor|SOCache|Timeout)|nzFcgiCheckAuthnProvider|nzFcgiDefineProvider|Type|UserFile|zDBDLoginToReferer|zDBDQuery|zDBDRedirectQuery|zDBMType|zSendForbiddenOnFailure)|BalancerGrowth|BalancerInherit|BalancerMember|BalancerPersist|BrowserMatch|BrowserMatchNoCase|BufferedLogs|BufferSize|Cache(?:DefaultExpire|DetailHeader|DirLength|DirLevels|Disable|Enable|File|Header|IgnoreCacheControl|IgnoreHeaders|IgnoreNoLastMod|IgnoreQueryString|IgnoreURLSessionIdentifiers|KeyBaseURL|LastModifiedFactor|Lock|LockMaxAge|LockPath|MaxExpire|MaxFileSize|MinExpire|MinFileSize|NegotiatedDocs|QuickHandler|ReadSize|ReadTime|Root|Socache(?:MaxSize|MaxTime|MinTime|ReadSize|ReadTime)?|StaleOnError|StoreExpired|StoreNoStore|StorePrivate)|CGIDScriptTimeout|CGIMapExtension|CharsetDefault|CharsetOptions|CharsetSourceEnc|CheckCaseOnly|CheckSpelling|ChrootDir|ContentDigest|CookieDomain|CookieExpires|CookieName|CookieStyle|CookieTracking|CoreDumpDirectory|CustomLog|Dav|DavDepthInfinity|DavGenericLockDB|DavLockDB|DavMinTimeout|DBDExptime|DBDInitSQL|DBDKeep|DBDMax|DBDMin|DBDParams|DBDPersist|DBDPrepareSQL|DBDriver|DefaultIcon|DefaultLanguage|DefaultRuntimeDir|DefaultType|Define|Deflate(?:BufferSize|CompressionLevel|FilterNote|InflateLimitRequestBody|InflateRatio(?:Burst|Limit)|MemLevel|WindowSize)|Deny|DirectoryCheckHandler|DirectoryIndex|DirectoryIndexRedirect|DirectorySlash|DocumentRoot|DTracePrivileges|DumpIOInput|DumpIOOutput|EnableExceptionHook|EnableMMAP|EnableSendfile|Error|ErrorDocument|ErrorLog|ErrorLogFormat|Example|ExpiresActive|ExpiresByType|ExpiresDefault|ExtendedStatus|ExtFilterDefine|ExtFilterOptions|FallbackResource|FileETag|FilterChain|FilterDeclare|FilterProtocol|FilterProvider|FilterTrace|ForceLanguagePriority|ForceType|ForensicLog|GprofDir|GracefulShutdownTimeout|Group|Header|HeaderName|Heartbeat(?:Address|Listen|MaxServers|Storage)|HostnameLookups|IdentityCheck|IdentityCheckTimeout|ImapBase|ImapDefault|ImapMenu|Include|IncludeOptional|Index(?:HeadInsert|Ignore|IgnoreReset|Options|OrderDefault|StyleSheet)|InputSed|ISAPI(?:AppendLogToErrors|AppendLogToQuery|CacheFile|FakeAsync|LogNotSupported|ReadAheadBuffer)|KeepAlive|KeepAliveTimeout|KeptBodySize|LanguagePriority|LDAP(?:CacheEntries|CacheTTL|ConnectionPoolTTL|ConnectionTimeout|LibraryDebug|OpCacheEntries|OpCacheTTL|ReferralHopLimit|Referrals|Retries|RetryDelay|SharedCacheFile|SharedCacheSize|Timeout|TrustedClientCert|TrustedGlobalCert|TrustedMode|VerifyServerCert)|Limit(?:InternalRecursion|Request(?:Body|Fields|FieldSize|Line)|XMLRequestBody)|Listen|ListenBackLog|LoadFile|LoadModule|LogFormat|LogLevel|LogMessage|LuaAuthzProvider|LuaCodeCache|Lua(?:Hook(?:AccessChecker|AuthChecker|CheckUserID|Fixups|InsertFilter|Log|MapToStorage|TranslateName|TypeChecker)|Inherit|InputFilter|MapHandler|OutputFilter|PackageCPath|PackagePath|QuickHandler|Root|Scope)|Max(?:ConnectionsPerChild|KeepAliveRequests|MemFree|RangeOverlaps|RangeReversals|Ranges|RequestWorkers|SpareServers|SpareThreads|Threads)|MergeTrailers|MetaDir|MetaFiles|MetaSuffix|MimeMagicFile|MinSpareServers|MinSpareThreads|MMapFile|ModemStandard|ModMimeUsePathInfo|MultiviewsMatch|Mutex|NameVirtualHost|NoProxy|NWSSLTrustedCerts|NWSSLUpgradeable|Options|Order|OutputSed|PassEnv|PidFile|PrivilegesMode|Protocol|ProtocolEcho|Proxy(?:AddHeaders|BadHeader|Block|Domain|ErrorOverride|ExpressDBMFile|ExpressDBMType|ExpressEnable|FtpDirCharset|FtpEscapeWildcards|FtpListOnWildcard|HTML(?:BufSize|CharsetOut|DocType|Enable|Events|Extended|Fixups|Interp|Links|Meta|StripComments|URLMap)|IOBufferSize|MaxForwards|Pass(?:Inherit|InterpolateEnv|Match|Reverse|ReverseCookieDomain|ReverseCookiePath)?|PreserveHost|ReceiveBufferSize|Remote|RemoteMatch|Requests|SCGIInternalRedirect|SCGISendfile|Set|SourceAddress|Status|Timeout|Via)|ReadmeName|ReceiveBufferSize|Redirect|RedirectMatch|RedirectPermanent|RedirectTemp|ReflectorHeader|RemoteIP(?:Header|InternalProxy|InternalProxyList|ProxiesHeader|TrustedProxy|TrustedProxyList)|RemoveCharset|RemoveEncoding|RemoveHandler|RemoveInputFilter|RemoveLanguage|RemoveOutputFilter|RemoveType|RequestHeader|RequestReadTimeout|Require|Rewrite(?:Base|Cond|Engine|Map|Options|Rule)|RLimitCPU|RLimitMEM|RLimitNPROC|Satisfy|ScoreBoardFile|Script(?:Alias|AliasMatch|InterpreterSource|Log|LogBuffer|LogLength|Sock)?|SecureListen|SeeRequestTail|SendBufferSize|Server(?:Admin|Alias|Limit|Name|Path|Root|Signature|Tokens)|Session(?:Cookie(?:Name|Name2|Remove)|Crypto(?:Cipher|Driver|Passphrase|PassphraseFile)|DBD(?:CookieName|CookieName2|CookieRemove|DeleteLabel|InsertLabel|PerUser|SelectLabel|UpdateLabel)|Env|Exclude|Header|Include|MaxAge)?|SetEnv|SetEnvIf|SetEnvIfExpr|SetEnvIfNoCase|SetHandler|SetInputFilter|SetOutputFilter|SSIEndTag|SSIErrorMsg|SSIETag|SSILastModified|SSILegacyExprParser|SSIStartTag|SSITimeFormat|SSIUndefinedEcho|SSL(?:CACertificateFile|CACertificatePath|CADNRequestFile|CADNRequestPath|CARevocationCheck|CARevocationFile|CARevocationPath|CertificateChainFile|CertificateFile|CertificateKeyFile|CipherSuite|Compression|CryptoDevice|Engine|FIPS|HonorCipherOrder|InsecureRenegotiation|OCSP(?:DefaultResponder|Enable|OverrideResponder|ResponderTimeout|ResponseMaxAge|ResponseTimeSkew|UseRequestNonce)|OpenSSLConfCmd|Options|PassPhraseDialog|Protocol|Proxy(?:CACertificateFile|CACertificatePath|CARevocation(?:Check|File|Path)|CheckPeer(?:CN|Expire|Name)|CipherSuite|Engine|MachineCertificate(?:ChainFile|File|Path)|Protocol|Verify|VerifyDepth)|RandomSeed|RenegBufferSize|Require|RequireSSL|Session(?:Cache|CacheTimeout|TicketKeyFile|Tickets)|SRPUnknownUserSeed|SRPVerifierFile|Stapling(?:Cache|ErrorCacheTimeout|FakeTryLater|ForceURL|ResponderTimeout|ResponseMaxAge|ResponseTimeSkew|ReturnResponderErrors|StandardCacheTimeout)|StrictSNIVHostCheck|UserName|UseStapling|VerifyClient|VerifyDepth)|StartServers|StartThreads|Substitute|Suexec|SuexecUserGroup|ThreadLimit|ThreadsPerChild|ThreadStackSize|TimeOut|TraceEnable|TransferLog|TypesConfig|UnDefine|UndefMacro|UnsetEnv|Use|UseCanonicalName|UseCanonicalPhysicalPort|User|UserDir|VHostCGIMode|VHostCGIPrivs|VHostGroup|VHostPrivs|VHostSecure|VHostUser|Virtual(?:DocumentRoot|ScriptAlias)(?:IP)?|WatchdogInterval|XBitHack|xml2EncAlias|xml2EncDefault|xml2StartParse)\b/im,
            lookbehind: true,
            alias: 'property'
        },
        'directive-block': {
            pattern: /<\/?\b(?:Auth[nz]ProviderAlias|Directory|DirectoryMatch|Else|ElseIf|Files|FilesMatch|If|IfDefine|IfModule|IfVersion|Limit|LimitExcept|Location|LocationMatch|Macro|Proxy|Require(?:All|Any|None)|VirtualHost)\b.*>/i,
            inside: {
                'directive-block': {
                    pattern: /^<\/?\w+/,
                    inside: {
                        punctuation: /^<\/?/
                    },
                    alias: 'tag'
                },
                'directive-block-parameter': {
                    pattern: /.*[^>]/,
                    inside: {
                        punctuation: /:/,
                        string: {
                            pattern: /("|').*\1/,
                            inside: {
                                variable: /[$%]\{?(?:\w\.?[-+:]?)+\}?/
                            }
                        }
                    },
                    alias: 'attr-value'
                },
                punctuation: />/
            },
            alias: 'tag'
        },
        'directive-flags': {
            pattern: /\[(?:[\w=],?)+\]/,
            alias: 'keyword'
        },
        string: {
            pattern: /("|').*\1/,
            inside: {
                variable: /[$%]\{?(?:\w\.?[-+:]?)+\}?/
            }
        },
        variable: /[$%]\{?(?:\w\.?[-+:]?)+\}?/,
        regex: /\^?.*\$|\^.*\$?/
    };
}

});

parcelRegister("d5uoG", function(module, exports) {
'use strict';

var $4lsCO = parcelRequire("4lsCO");
module.exports = $9873523e84b95e7f$var$apex;
$9873523e84b95e7f$var$apex.displayName = 'apex';
$9873523e84b95e7f$var$apex.aliases = [];
function $9873523e84b95e7f$var$apex(Prism) {
    Prism.register($4lsCO);
    (function(Prism) {
        var keywords = /\b(?:(?:after|before)(?=\s+[a-z])|abstract|activate|and|any|array|as|asc|autonomous|begin|bigdecimal|blob|boolean|break|bulk|by|byte|case|cast|catch|char|class|collect|commit|const|continue|currency|date|datetime|decimal|default|delete|desc|do|double|else|end|enum|exception|exit|export|extends|final|finally|float|for|from|get(?=\s*[{};])|global|goto|group|having|hint|if|implements|import|in|inner|insert|instanceof|int|integer|interface|into|join|like|limit|list|long|loop|map|merge|new|not|null|nulls|number|object|of|on|or|outer|override|package|parallel|pragma|private|protected|public|retrieve|return|rollback|select|set|short|sObject|sort|static|string|super|switch|synchronized|system|testmethod|then|this|throw|time|transaction|transient|trigger|try|undelete|update|upsert|using|virtual|void|webservice|when|where|while|(?:inherited|with|without)\s+sharing)\b/i;
        var className = /\b(?:(?=[a-z_]\w*\s*[<\[])|(?!<keyword>))[A-Z_]\w*(?:\s*\.\s*[A-Z_]\w*)*\b(?:\s*(?:\[\s*\]|<(?:[^<>]|<(?:[^<>]|<[^<>]*>)*>)*>))*/.source.replace(/<keyword>/g, function() {
            return keywords.source;
        });
        /** @param {string} pattern */ function insertClassName(pattern) {
            return RegExp(pattern.replace(/<CLASS-NAME>/g, function() {
                return className;
            }), 'i');
        }
        var classNameInside = {
            keyword: keywords,
            punctuation: /[()\[\]{};,:.<>]/
        };
        Prism.languages.apex = {
            comment: Prism.languages.clike.comment,
            string: Prism.languages.clike.string,
            sql: {
                pattern: /((?:[=,({:]|\breturn)\s*)\[[^\[\]]*\]/i,
                lookbehind: true,
                greedy: true,
                alias: 'language-sql',
                inside: Prism.languages.sql
            },
            annotation: {
                pattern: /@\w+\b/,
                alias: 'punctuation'
            },
            'class-name': [
                {
                    pattern: insertClassName(/(\b(?:class|enum|extends|implements|instanceof|interface|new|trigger\s+\w+\s+on)\s+)<CLASS-NAME>/.source),
                    lookbehind: true,
                    inside: classNameInside
                },
                {
                    // cast
                    pattern: insertClassName(/(\(\s*)<CLASS-NAME>(?=\s*\)\s*[\w(])/.source),
                    lookbehind: true,
                    inside: classNameInside
                },
                {
                    // variable/parameter declaration and return types
                    pattern: insertClassName(/<CLASS-NAME>(?=\s*\w+\s*[;=,(){:])/.source),
                    inside: classNameInside
                }
            ],
            trigger: {
                pattern: /(\btrigger\s+)\w+\b/i,
                lookbehind: true,
                alias: 'class-name'
            },
            keyword: keywords,
            function: /\b[a-z_]\w*(?=\s*\()/i,
            boolean: /\b(?:false|true)\b/i,
            number: /(?:\B\.\d+|\b\d+(?:\.\d+|L)?)\b/i,
            operator: /[!=](?:==?)?|\?\.?|&&|\|\||--|\+\+|[-+*/^&|]=?|:|<<?=?|>{1,3}=?/,
            punctuation: /[()\[\]{};,.]/
        };
    })(Prism);
}

});
parcelRegister("4lsCO", function(module, exports) {
'use strict';
module.exports = $329f53efc2c0e09c$var$sql;
$329f53efc2c0e09c$var$sql.displayName = 'sql';
$329f53efc2c0e09c$var$sql.aliases = [];
function $329f53efc2c0e09c$var$sql(Prism) {
    Prism.languages.sql = {
        comment: {
            pattern: /(^|[^\\])(?:\/\*[\s\S]*?\*\/|(?:--|\/\/|#).*)/,
            lookbehind: true
        },
        variable: [
            {
                pattern: /@(["'`])(?:\\[\s\S]|(?!\1)[^\\])+\1/,
                greedy: true
            },
            /@[\w.$]+/
        ],
        string: {
            pattern: /(^|[^@\\])("|')(?:\\[\s\S]|(?!\2)[^\\]|\2\2)*\2/,
            greedy: true,
            lookbehind: true
        },
        identifier: {
            pattern: /(^|[^@\\])`(?:\\[\s\S]|[^`\\]|``)*`/,
            greedy: true,
            lookbehind: true,
            inside: {
                punctuation: /^`|`$/
            }
        },
        function: /\b(?:AVG|COUNT|FIRST|FORMAT|LAST|LCASE|LEN|MAX|MID|MIN|MOD|NOW|ROUND|SUM|UCASE)(?=\s*\()/i,
        // Should we highlight user defined functions too?
        keyword: /\b(?:ACTION|ADD|AFTER|ALGORITHM|ALL|ALTER|ANALYZE|ANY|APPLY|AS|ASC|AUTHORIZATION|AUTO_INCREMENT|BACKUP|BDB|BEGIN|BERKELEYDB|BIGINT|BINARY|BIT|BLOB|BOOL|BOOLEAN|BREAK|BROWSE|BTREE|BULK|BY|CALL|CASCADED?|CASE|CHAIN|CHAR(?:ACTER|SET)?|CHECK(?:POINT)?|CLOSE|CLUSTERED|COALESCE|COLLATE|COLUMNS?|COMMENT|COMMIT(?:TED)?|COMPUTE|CONNECT|CONSISTENT|CONSTRAINT|CONTAINS(?:TABLE)?|CONTINUE|CONVERT|CREATE|CROSS|CURRENT(?:_DATE|_TIME|_TIMESTAMP|_USER)?|CURSOR|CYCLE|DATA(?:BASES?)?|DATE(?:TIME)?|DAY|DBCC|DEALLOCATE|DEC|DECIMAL|DECLARE|DEFAULT|DEFINER|DELAYED|DELETE|DELIMITERS?|DENY|DESC|DESCRIBE|DETERMINISTIC|DISABLE|DISCARD|DISK|DISTINCT|DISTINCTROW|DISTRIBUTED|DO|DOUBLE|DROP|DUMMY|DUMP(?:FILE)?|DUPLICATE|ELSE(?:IF)?|ENABLE|ENCLOSED|END|ENGINE|ENUM|ERRLVL|ERRORS|ESCAPED?|EXCEPT|EXEC(?:UTE)?|EXISTS|EXIT|EXPLAIN|EXTENDED|FETCH|FIELDS|FILE|FILLFACTOR|FIRST|FIXED|FLOAT|FOLLOWING|FOR(?: EACH ROW)?|FORCE|FOREIGN|FREETEXT(?:TABLE)?|FROM|FULL|FUNCTION|GEOMETRY(?:COLLECTION)?|GLOBAL|GOTO|GRANT|GROUP|HANDLER|HASH|HAVING|HOLDLOCK|HOUR|IDENTITY(?:COL|_INSERT)?|IF|IGNORE|IMPORT|INDEX|INFILE|INNER|INNODB|INOUT|INSERT|INT|INTEGER|INTERSECT|INTERVAL|INTO|INVOKER|ISOLATION|ITERATE|JOIN|KEYS?|KILL|LANGUAGE|LAST|LEAVE|LEFT|LEVEL|LIMIT|LINENO|LINES|LINESTRING|LOAD|LOCAL|LOCK|LONG(?:BLOB|TEXT)|LOOP|MATCH(?:ED)?|MEDIUM(?:BLOB|INT|TEXT)|MERGE|MIDDLEINT|MINUTE|MODE|MODIFIES|MODIFY|MONTH|MULTI(?:LINESTRING|POINT|POLYGON)|NATIONAL|NATURAL|NCHAR|NEXT|NO|NONCLUSTERED|NULLIF|NUMERIC|OFF?|OFFSETS?|ON|OPEN(?:DATASOURCE|QUERY|ROWSET)?|OPTIMIZE|OPTION(?:ALLY)?|ORDER|OUT(?:ER|FILE)?|OVER|PARTIAL|PARTITION|PERCENT|PIVOT|PLAN|POINT|POLYGON|PRECEDING|PRECISION|PREPARE|PREV|PRIMARY|PRINT|PRIVILEGES|PROC(?:EDURE)?|PUBLIC|PURGE|QUICK|RAISERROR|READS?|REAL|RECONFIGURE|REFERENCES|RELEASE|RENAME|REPEAT(?:ABLE)?|REPLACE|REPLICATION|REQUIRE|RESIGNAL|RESTORE|RESTRICT|RETURN(?:ING|S)?|REVOKE|RIGHT|ROLLBACK|ROUTINE|ROW(?:COUNT|GUIDCOL|S)?|RTREE|RULE|SAVE(?:POINT)?|SCHEMA|SECOND|SELECT|SERIAL(?:IZABLE)?|SESSION(?:_USER)?|SET(?:USER)?|SHARE|SHOW|SHUTDOWN|SIMPLE|SMALLINT|SNAPSHOT|SOME|SONAME|SQL|START(?:ING)?|STATISTICS|STATUS|STRIPED|SYSTEM_USER|TABLES?|TABLESPACE|TEMP(?:ORARY|TABLE)?|TERMINATED|TEXT(?:SIZE)?|THEN|TIME(?:STAMP)?|TINY(?:BLOB|INT|TEXT)|TOP?|TRAN(?:SACTIONS?)?|TRIGGER|TRUNCATE|TSEQUAL|TYPES?|UNBOUNDED|UNCOMMITTED|UNDEFINED|UNION|UNIQUE|UNLOCK|UNPIVOT|UNSIGNED|UPDATE(?:TEXT)?|USAGE|USE|USER|USING|VALUES?|VAR(?:BINARY|CHAR|CHARACTER|YING)|VIEW|WAITFOR|WARNINGS|WHEN|WHERE|WHILE|WITH(?: ROLLUP|IN)?|WORK|WRITE(?:TEXT)?|YEAR)\b/i,
        boolean: /\b(?:FALSE|NULL|TRUE)\b/i,
        number: /\b0x[\da-f]+\b|\b\d+(?:\.\d*)?|\B\.\d+\b/i,
        operator: /[-+*\/=%^~]|&&?|\|\|?|!=?|<(?:=>?|<|>)?|>[>=]?|\b(?:AND|BETWEEN|DIV|ILIKE|IN|IS|LIKE|NOT|OR|REGEXP|RLIKE|SOUNDS LIKE|XOR)\b/i,
        punctuation: /[;[\]()`,.]/
    };
}

});


parcelRegister("iJzzr", function(module, exports) {
'use strict';
module.exports = $da380589e5a6e942$var$apl;
$da380589e5a6e942$var$apl.displayName = 'apl';
$da380589e5a6e942$var$apl.aliases = [];
function $da380589e5a6e942$var$apl(Prism) {
    Prism.languages.apl = {
        comment: /(?:⍝|#[! ]).*$/m,
        string: {
            pattern: /'(?:[^'\r\n]|'')*'/,
            greedy: true
        },
        number: /¯?(?:\d*\.?\b\d+(?:e[+¯]?\d+)?|¯|∞)(?:j¯?(?:(?:\d+(?:\.\d+)?|\.\d+)(?:e[+¯]?\d+)?|¯|∞))?/i,
        statement: /:[A-Z][a-z][A-Za-z]*\b/,
        'system-function': {
            pattern: /⎕[A-Z]+/i,
            alias: 'function'
        },
        constant: /[⍬⌾#⎕⍞]/,
        function: /[-+×÷⌈⌊∣|⍳⍸?*⍟○!⌹<≤=>≥≠≡≢∊⍷∪∩~∨∧⍱⍲⍴,⍪⌽⊖⍉↑↓⊂⊃⊆⊇⌷⍋⍒⊤⊥⍕⍎⊣⊢⍁⍂≈⍯↗¤→]/,
        'monadic-operator': {
            pattern: /[\\\/⌿⍀¨⍨⌶&∥]/,
            alias: 'operator'
        },
        'dyadic-operator': {
            pattern: /[.⍣⍠⍤∘⌸@⌺⍥]/,
            alias: 'operator'
        },
        assignment: {
            pattern: /←/,
            alias: 'keyword'
        },
        punctuation: /[\[;\]()◇⋄]/,
        dfn: {
            pattern: /[{}⍺⍵⍶⍹∇⍫:]/,
            alias: 'builtin'
        }
    };
}

});

parcelRegister("6mLRz", function(module, exports) {
'use strict';
module.exports = $4a29ecc5be002b79$var$applescript;
$4a29ecc5be002b79$var$applescript.displayName = 'applescript';
$4a29ecc5be002b79$var$applescript.aliases = [];
function $4a29ecc5be002b79$var$applescript(Prism) {
    Prism.languages.applescript = {
        comment: [
            // Allow one level of nesting
            /\(\*(?:\(\*(?:[^*]|\*(?!\)))*\*\)|(?!\(\*)[\s\S])*?\*\)/,
            /--.+/,
            /#.+/
        ],
        string: /"(?:\\.|[^"\\\r\n])*"/,
        number: /(?:\b\d+(?:\.\d*)?|\B\.\d+)(?:e-?\d+)?\b/i,
        operator: [
            /[&=≠≤≥*+\-\/÷^]|[<>]=?/,
            /\b(?:(?:begin|end|start)s? with|(?:contains?|(?:does not|doesn't) contain)|(?:is|isn't|is not) (?:contained by|in)|(?:(?:is|isn't|is not) )?(?:greater|less) than(?: or equal)?(?: to)?|(?:comes|(?:does not|doesn't) come) (?:after|before)|(?:is|isn't|is not) equal(?: to)?|(?:(?:does not|doesn't) equal|equal to|equals|is not|isn't)|(?:a )?(?:ref(?: to)?|reference to)|(?:and|as|div|mod|not|or))\b/
        ],
        keyword: /\b(?:about|above|after|against|apart from|around|aside from|at|back|before|beginning|behind|below|beneath|beside|between|but|by|considering|continue|copy|does|eighth|else|end|equal|error|every|exit|false|fifth|first|for|fourth|from|front|get|given|global|if|ignoring|in|instead of|into|is|it|its|last|local|me|middle|my|ninth|of|on|onto|out of|over|prop|property|put|repeat|return|returning|second|set|seventh|since|sixth|some|tell|tenth|that|the|then|third|through|thru|timeout|times|to|transaction|true|try|until|where|while|whose|with|without)\b/,
        'class-name': /\b(?:POSIX file|RGB color|alias|application|boolean|centimeters|centimetres|class|constant|cubic centimeters|cubic centimetres|cubic feet|cubic inches|cubic meters|cubic metres|cubic yards|date|degrees Celsius|degrees Fahrenheit|degrees Kelvin|feet|file|gallons|grams|inches|integer|kilograms|kilometers|kilometres|list|liters|litres|meters|metres|miles|number|ounces|pounds|quarts|real|record|reference|script|square feet|square kilometers|square kilometres|square meters|square metres|square miles|square yards|text|yards)\b/,
        punctuation: /[{}():,¬«»《》]/
    };
}

});

parcelRegister("7PjhR", function(module, exports) {
'use strict';
module.exports = $5b2c41d28916e5c8$var$aql;
$5b2c41d28916e5c8$var$aql.displayName = 'aql';
$5b2c41d28916e5c8$var$aql.aliases = [];
function $5b2c41d28916e5c8$var$aql(Prism) {
    Prism.languages.aql = {
        comment: /\/\/.*|\/\*[\s\S]*?\*\//,
        property: {
            pattern: /([{,]\s*)(?:(?!\d)\w+|(["'´`])(?:(?!\2)[^\\\r\n]|\\.)*\2)(?=\s*:)/,
            lookbehind: true,
            greedy: true
        },
        string: {
            pattern: /(["'])(?:(?!\1)[^\\\r\n]|\\.)*\1/,
            greedy: true
        },
        identifier: {
            pattern: /([´`])(?:(?!\1)[^\\\r\n]|\\.)*\1/,
            greedy: true
        },
        variable: /@@?\w+/,
        keyword: [
            {
                pattern: /(\bWITH\s+)COUNT(?=\s+INTO\b)/i,
                lookbehind: true
            },
            /\b(?:AGGREGATE|ALL|AND|ANY|ASC|COLLECT|DESC|DISTINCT|FILTER|FOR|GRAPH|IN|INBOUND|INSERT|INTO|K_PATHS|K_SHORTEST_PATHS|LET|LIKE|LIMIT|NONE|NOT|NULL|OR|OUTBOUND|REMOVE|REPLACE|RETURN|SHORTEST_PATH|SORT|UPDATE|UPSERT|WINDOW|WITH)\b/i,
            {
                pattern: /(^|[^\w.[])(?:KEEP|PRUNE|SEARCH|TO)\b/i,
                lookbehind: true
            },
            {
                pattern: /(^|[^\w.[])(?:CURRENT|NEW|OLD)\b/,
                lookbehind: true
            },
            {
                pattern: /\bOPTIONS(?=\s*\{)/i
            }
        ],
        function: /\b(?!\d)\w+(?=\s*\()/,
        boolean: /\b(?:false|true)\b/i,
        range: {
            pattern: /\.\./,
            alias: 'operator'
        },
        number: [
            /\b0b[01]+/i,
            /\b0x[0-9a-f]+/i,
            /(?:\B\.\d+|\b(?:0|[1-9]\d*)(?:\.\d+)?)(?:e[+-]?\d+)?/i
        ],
        operator: /\*{2,}|[=!]~|[!=<>]=?|&&|\|\||[-+*/%]/,
        punctuation: /::|[?.:,;()[\]{}]/
    };
}

});

parcelRegister("gU0QR", function(module, exports) {
'use strict';

var $4TKG9 = parcelRequire("4TKG9");
module.exports = $c4e2896440f84044$var$arduino;
$c4e2896440f84044$var$arduino.displayName = 'arduino';
$c4e2896440f84044$var$arduino.aliases = [
    'ino'
];
function $c4e2896440f84044$var$arduino(Prism) {
    Prism.register($4TKG9);
    Prism.languages.arduino = Prism.languages.extend('cpp', {
        keyword: /\b(?:String|array|bool|boolean|break|byte|case|catch|continue|default|do|double|else|finally|for|function|goto|if|in|instanceof|int|integer|long|loop|new|null|return|setup|string|switch|throw|try|void|while|word)\b/,
        constant: /\b(?:ANALOG_MESSAGE|DEFAULT|DIGITAL_MESSAGE|EXTERNAL|FIRMATA_STRING|HIGH|INPUT|INPUT_PULLUP|INTERNAL|INTERNAL1V1|INTERNAL2V56|LED_BUILTIN|LOW|OUTPUT|REPORT_ANALOG|REPORT_DIGITAL|SET_PIN_MODE|SYSEX_START|SYSTEM_RESET)\b/,
        builtin: /\b(?:Audio|BSSID|Bridge|Client|Console|EEPROM|Esplora|EsploraTFT|Ethernet|EthernetClient|EthernetServer|EthernetUDP|File|FileIO|FileSystem|Firmata|GPRS|GSM|GSMBand|GSMClient|GSMModem|GSMPIN|GSMScanner|GSMServer|GSMVoiceCall|GSM_SMS|HttpClient|IPAddress|IRread|Keyboard|KeyboardController|LiquidCrystal|LiquidCrystal_I2C|Mailbox|Mouse|MouseController|PImage|Process|RSSI|RobotControl|RobotMotor|SD|SPI|SSID|Scheduler|Serial|Server|Servo|SoftwareSerial|Stepper|Stream|TFT|Task|USBHost|WiFi|WiFiClient|WiFiServer|WiFiUDP|Wire|YunClient|YunServer|abs|addParameter|analogRead|analogReadResolution|analogReference|analogWrite|analogWriteResolution|answerCall|attach|attachGPRS|attachInterrupt|attached|autoscroll|available|background|beep|begin|beginPacket|beginSD|beginSMS|beginSpeaker|beginTFT|beginTransmission|beginWrite|bit|bitClear|bitRead|bitSet|bitWrite|blink|blinkVersion|buffer|changePIN|checkPIN|checkPUK|checkReg|circle|cityNameRead|cityNameWrite|clear|clearScreen|click|close|compassRead|config|connect|connected|constrain|cos|countryNameRead|countryNameWrite|createChar|cursor|debugPrint|delay|delayMicroseconds|detach|detachInterrupt|digitalRead|digitalWrite|disconnect|display|displayLogos|drawBMP|drawCompass|encryptionType|end|endPacket|endSMS|endTransmission|endWrite|exists|exitValue|fill|find|findUntil|flush|gatewayIP|get|getAsynchronously|getBand|getButton|getCurrentCarrier|getIMEI|getKey|getModifiers|getOemKey|getPINUsed|getResult|getSignalStrength|getSocket|getVoiceCallStatus|getXChange|getYChange|hangCall|height|highByte|home|image|interrupts|isActionDone|isDirectory|isListening|isPIN|isPressed|isValid|keyPressed|keyReleased|keyboardRead|knobRead|leftToRight|line|lineFollowConfig|listen|listenOnLocalhost|loadImage|localIP|lowByte|macAddress|maintain|map|max|messageAvailable|micros|millis|min|mkdir|motorsStop|motorsWrite|mouseDragged|mouseMoved|mousePressed|mouseReleased|move|noAutoscroll|noBlink|noBuffer|noCursor|noDisplay|noFill|noInterrupts|noListenOnLocalhost|noStroke|noTone|onReceive|onRequest|open|openNextFile|overflow|parseCommand|parseFloat|parseInt|parsePacket|pauseMode|peek|pinMode|playFile|playMelody|point|pointTo|position|pow|prepare|press|print|printFirmwareVersion|printVersion|println|process|processInput|pulseIn|put|random|randomSeed|read|readAccelerometer|readBlue|readButton|readBytes|readBytesUntil|readGreen|readJoystickButton|readJoystickSwitch|readJoystickX|readJoystickY|readLightSensor|readMessage|readMicrophone|readNetworks|readRed|readSlider|readString|readStringUntil|readTemperature|ready|rect|release|releaseAll|remoteIP|remoteNumber|remotePort|remove|requestFrom|retrieveCallingNumber|rewindDirectory|rightToLeft|rmdir|robotNameRead|robotNameWrite|run|runAsynchronously|runShellCommand|runShellCommandAsynchronously|running|scanNetworks|scrollDisplayLeft|scrollDisplayRight|seek|sendAnalog|sendDigitalPortPair|sendDigitalPorts|sendString|sendSysex|serialEvent|setBand|setBitOrder|setClockDivider|setCursor|setDNS|setDataMode|setFirmwareVersion|setMode|setPINUsed|setSpeed|setTextSize|setTimeout|shiftIn|shiftOut|shutdown|sin|size|sqrt|startLoop|step|stop|stroke|subnetMask|switchPIN|tan|tempoWrite|text|tone|transfer|tuneWrite|turn|updateIR|userNameRead|userNameWrite|voiceCall|waitContinue|width|write|writeBlue|writeGreen|writeJSON|writeMessage|writeMicroseconds|writeRGB|writeRed|yield)\b/
    });
    Prism.languages.ino = Prism.languages.arduino;
}

});
parcelRegister("4TKG9", function(module, exports) {
'use strict';

var $c6Wvp = parcelRequire("c6Wvp");
module.exports = $391081ed1316414f$var$cpp;
$391081ed1316414f$var$cpp.displayName = 'cpp';
$391081ed1316414f$var$cpp.aliases = [];
function $391081ed1316414f$var$cpp(Prism) {
    Prism.register($c6Wvp);
    (function(Prism) {
        var keyword = /\b(?:alignas|alignof|asm|auto|bool|break|case|catch|char|char16_t|char32_t|char8_t|class|co_await|co_return|co_yield|compl|concept|const|const_cast|consteval|constexpr|constinit|continue|decltype|default|delete|do|double|dynamic_cast|else|enum|explicit|export|extern|final|float|for|friend|goto|if|import|inline|int|int16_t|int32_t|int64_t|int8_t|long|module|mutable|namespace|new|noexcept|nullptr|operator|override|private|protected|public|register|reinterpret_cast|requires|return|short|signed|sizeof|static|static_assert|static_cast|struct|switch|template|this|thread_local|throw|try|typedef|typeid|typename|uint16_t|uint32_t|uint64_t|uint8_t|union|unsigned|using|virtual|void|volatile|wchar_t|while)\b/;
        var modName = /\b(?!<keyword>)\w+(?:\s*\.\s*\w+)*\b/.source.replace(/<keyword>/g, function() {
            return keyword.source;
        });
        Prism.languages.cpp = Prism.languages.extend('c', {
            'class-name': [
                {
                    pattern: RegExp(/(\b(?:class|concept|enum|struct|typename)\s+)(?!<keyword>)\w+/.source.replace(/<keyword>/g, function() {
                        return keyword.source;
                    })),
                    lookbehind: true
                },
                //   void foo::bar() const {}
                // However! The `foo` in the above example could also be a namespace, so we only capture the class name if
                // it starts with an uppercase letter. This approximation should give decent results.
                /\b[A-Z]\w*(?=\s*::\s*\w+\s*\()/,
                //   Foo::~Foo() {}
                /\b[A-Z_]\w*(?=\s*::\s*~\w+\s*\()/i,
                // parameters, so it can't be a namespace (until C++ adds generic namespaces).
                /\b\w+(?=\s*<(?:[^<>]|<(?:[^<>]|<[^<>]*>)*>)*>\s*::\s*\w+\s*\()/
            ],
            keyword: keyword,
            number: {
                pattern: /(?:\b0b[01']+|\b0x(?:[\da-f']+(?:\.[\da-f']*)?|\.[\da-f']+)(?:p[+-]?[\d']+)?|(?:\b[\d']+(?:\.[\d']*)?|\B\.[\d']+)(?:e[+-]?[\d']+)?)[ful]{0,4}/i,
                greedy: true
            },
            operator: />>=?|<<=?|->|--|\+\+|&&|\|\||[?:~]|<=>|[-+*/%&|^!=<>]=?|\b(?:and|and_eq|bitand|bitor|not|not_eq|or|or_eq|xor|xor_eq)\b/,
            boolean: /\b(?:false|true)\b/
        });
        Prism.languages.insertBefore('cpp', 'string', {
            module: {
                // https://en.cppreference.com/w/cpp/language/modules
                pattern: RegExp(/(\b(?:import|module)\s+)/.source + '(?:' + // header-name
                /"(?:\\(?:\r\n|[\s\S])|[^"\\\r\n])*"|<[^<>\r\n]*>/.source + '|' + // module name or partition or both
                /<mod-name>(?:\s*:\s*<mod-name>)?|:\s*<mod-name>/.source.replace(/<mod-name>/g, function() {
                    return modName;
                }) + ')'),
                lookbehind: true,
                greedy: true,
                inside: {
                    string: /^[<"][\s\S]+/,
                    operator: /:/,
                    punctuation: /\./
                }
            },
            'raw-string': {
                pattern: /R"([^()\\ ]{0,16})\([\s\S]*?\)\1"/,
                alias: 'string',
                greedy: true
            }
        });
        Prism.languages.insertBefore('cpp', 'keyword', {
            'generic-function': {
                pattern: /\b(?!operator\b)[a-z_]\w*\s*<(?:[^<>]|<[^<>]*>)*>(?=\s*\()/i,
                inside: {
                    function: /^\w+/,
                    generic: {
                        pattern: /<[\s\S]+/,
                        alias: 'class-name',
                        inside: Prism.languages.cpp
                    }
                }
            }
        });
        Prism.languages.insertBefore('cpp', 'operator', {
            'double-colon': {
                pattern: /::/,
                alias: 'punctuation'
            }
        });
        Prism.languages.insertBefore('cpp', 'class-name', {
            // the base clause is an optional list of parent classes
            // https://en.cppreference.com/w/cpp/language/class
            'base-clause': {
                pattern: /(\b(?:class|struct)\s+\w+\s*:\s*)[^;{}"'\s]+(?:\s+[^;{}"'\s]+)*(?=\s*[;{])/,
                lookbehind: true,
                greedy: true,
                inside: Prism.languages.extend('cpp', {})
            }
        });
        Prism.languages.insertBefore('inside', 'double-colon', {
            // All untokenized words that are not namespaces should be class names
            'class-name': /\b[a-z_]\w*\b(?!\s*::)/i
        }, Prism.languages.cpp['base-clause']);
    })(Prism);
}

});
parcelRegister("c6Wvp", function(module, exports) {
'use strict';
module.exports = $8d136d95c936bb68$var$c;
$8d136d95c936bb68$var$c.displayName = 'c';
$8d136d95c936bb68$var$c.aliases = [];
function $8d136d95c936bb68$var$c(Prism) {
    Prism.languages.c = Prism.languages.extend('clike', {
        comment: {
            pattern: /\/\/(?:[^\r\n\\]|\\(?:\r\n?|\n|(?![\r\n])))*|\/\*[\s\S]*?(?:\*\/|$)/,
            greedy: true
        },
        string: {
            // https://en.cppreference.com/w/c/language/string_literal
            pattern: /"(?:\\(?:\r\n|[\s\S])|[^"\\\r\n])*"/,
            greedy: true
        },
        'class-name': {
            pattern: /(\b(?:enum|struct)\s+(?:__attribute__\s*\(\([\s\S]*?\)\)\s*)?)\w+|\b[a-z]\w*_t\b/,
            lookbehind: true
        },
        keyword: /\b(?:_Alignas|_Alignof|_Atomic|_Bool|_Complex|_Generic|_Imaginary|_Noreturn|_Static_assert|_Thread_local|__attribute__|asm|auto|break|case|char|const|continue|default|do|double|else|enum|extern|float|for|goto|if|inline|int|long|register|return|short|signed|sizeof|static|struct|switch|typedef|typeof|union|unsigned|void|volatile|while)\b/,
        function: /\b[a-z_]\w*(?=\s*\()/i,
        number: /(?:\b0x(?:[\da-f]+(?:\.[\da-f]*)?|\.[\da-f]+)(?:p[+-]?\d+)?|(?:\b\d+(?:\.\d*)?|\B\.\d+)(?:e[+-]?\d+)?)[ful]{0,4}/i,
        operator: />>=?|<<=?|->|([-+&|:])\1|[?:~]|[-+*/%&|^!=<>]=?/
    });
    Prism.languages.insertBefore('c', 'string', {
        char: {
            // https://en.cppreference.com/w/c/language/character_constant
            pattern: /'(?:\\(?:\r\n|[\s\S])|[^'\\\r\n]){0,32}'/,
            greedy: true
        }
    });
    Prism.languages.insertBefore('c', 'string', {
        macro: {
            // allow for multiline macro definitions
            // spaces after the # character compile fine with gcc
            pattern: /(^[\t ]*)#\s*[a-z](?:[^\r\n\\/]|\/(?!\*)|\/\*(?:[^*]|\*(?!\/))*\*\/|\\(?:\r\n|[\s\S]))*/im,
            lookbehind: true,
            greedy: true,
            alias: 'property',
            inside: {
                string: [
                    {
                        // highlight the path of the include statement as a string
                        pattern: /^(#\s*include\s*)<[^>]+>/,
                        lookbehind: true
                    },
                    Prism.languages.c['string']
                ],
                char: Prism.languages.c['char'],
                comment: Prism.languages.c['comment'],
                'macro-name': [
                    {
                        pattern: /(^#\s*define\s+)\w+\b(?!\()/i,
                        lookbehind: true
                    },
                    {
                        pattern: /(^#\s*define\s+)\w+\b(?=\()/i,
                        lookbehind: true,
                        alias: 'function'
                    }
                ],
                // highlight macro directives as keywords
                directive: {
                    pattern: /^(#\s*)[a-z]+/,
                    lookbehind: true,
                    alias: 'keyword'
                },
                'directive-hash': /^#/,
                punctuation: /##|\\(?=[\r\n])/,
                expression: {
                    pattern: /\S[\s\S]*/,
                    inside: Prism.languages.c
                }
            }
        }
    });
    Prism.languages.insertBefore('c', 'function', {
        // highlight predefined macros as constants
        constant: /\b(?:EOF|NULL|SEEK_CUR|SEEK_END|SEEK_SET|__DATE__|__FILE__|__LINE__|__TIMESTAMP__|__TIME__|__func__|stderr|stdin|stdout)\b/
    });
    delete Prism.languages.c['boolean'];
}

});



parcelRegister("8r1Sk", function(module, exports) {
'use strict';
module.exports = $62424cb9bbd1e54b$var$arff;
$62424cb9bbd1e54b$var$arff.displayName = 'arff';
$62424cb9bbd1e54b$var$arff.aliases = [];
function $62424cb9bbd1e54b$var$arff(Prism) {
    Prism.languages.arff = {
        comment: /%.*/,
        string: {
            pattern: /(["'])(?:\\.|(?!\1)[^\\\r\n])*\1/,
            greedy: true
        },
        keyword: /@(?:attribute|data|end|relation)\b/i,
        number: /\b\d+(?:\.\d+)?\b/,
        punctuation: /[{},]/
    };
}

});

parcelRegister("7jp9x", function(module, exports) {
'use strict';
module.exports = $552dd19aae9b772b$var$asciidoc;
$552dd19aae9b772b$var$asciidoc.displayName = 'asciidoc';
$552dd19aae9b772b$var$asciidoc.aliases = [
    'adoc'
];
function $552dd19aae9b772b$var$asciidoc(Prism) {
    (function(Prism) {
        var attributes = {
            pattern: /(^[ \t]*)\[(?!\[)(?:(["'$`])(?:(?!\2)[^\\]|\\.)*\2|\[(?:[^\[\]\\]|\\.)*\]|[^\[\]\\"'$`]|\\.)*\]/m,
            lookbehind: true,
            inside: {
                quoted: {
                    pattern: /([$`])(?:(?!\1)[^\\]|\\.)*\1/,
                    inside: {
                        punctuation: /^[$`]|[$`]$/
                    }
                },
                interpreted: {
                    pattern: /'(?:[^'\\]|\\.)*'/,
                    inside: {
                        punctuation: /^'|'$/ // See rest below
                    }
                },
                string: /"(?:[^"\\]|\\.)*"/,
                variable: /\w+(?==)/,
                punctuation: /^\[|\]$|,/,
                operator: /=/,
                // The negative look-ahead prevents blank matches
                'attr-value': /(?!^\s+$).+/
            }
        };
        var asciidoc = Prism.languages.asciidoc = {
            'comment-block': {
                pattern: /^(\/{4,})(?:\r?\n|\r)(?:[\s\S]*(?:\r?\n|\r))??\1/m,
                alias: 'comment'
            },
            table: {
                pattern: /^\|={3,}(?:(?:\r?\n|\r(?!\n)).*)*?(?:\r?\n|\r)\|={3,}$/m,
                inside: {
                    specifiers: {
                        pattern: /(?:(?:(?:\d+(?:\.\d+)?|\.\d+)[+*](?:[<^>](?:\.[<^>])?|\.[<^>])?|[<^>](?:\.[<^>])?|\.[<^>])[a-z]*|[a-z]+)(?=\|)/,
                        alias: 'attr-value'
                    },
                    punctuation: {
                        pattern: /(^|[^\\])[|!]=*/,
                        lookbehind: true
                    } // See rest below
                }
            },
            'passthrough-block': {
                pattern: /^(\+{4,})(?:\r?\n|\r)(?:[\s\S]*(?:\r?\n|\r))??\1$/m,
                inside: {
                    punctuation: /^\++|\++$/ // See rest below
                }
            },
            // Literal blocks and listing blocks
            'literal-block': {
                pattern: /^(-{4,}|\.{4,})(?:\r?\n|\r)(?:[\s\S]*(?:\r?\n|\r))??\1$/m,
                inside: {
                    punctuation: /^(?:-+|\.+)|(?:-+|\.+)$/ // See rest below
                }
            },
            // Sidebar blocks, quote blocks, example blocks and open blocks
            'other-block': {
                pattern: /^(--|\*{4,}|_{4,}|={4,})(?:\r?\n|\r)(?:[\s\S]*(?:\r?\n|\r))??\1$/m,
                inside: {
                    punctuation: /^(?:-+|\*+|_+|=+)|(?:-+|\*+|_+|=+)$/ // See rest below
                }
            },
            // list-punctuation and list-label must appear before indented-block
            'list-punctuation': {
                pattern: /(^[ \t]*)(?:-|\*{1,5}|\.{1,5}|(?:[a-z]|\d+)\.|[xvi]+\))(?= )/im,
                lookbehind: true,
                alias: 'punctuation'
            },
            'list-label': {
                pattern: /(^[ \t]*)[a-z\d].+(?::{2,4}|;;)(?=\s)/im,
                lookbehind: true,
                alias: 'symbol'
            },
            'indented-block': {
                pattern: /((\r?\n|\r)\2)([ \t]+)\S.*(?:(?:\r?\n|\r)\3.+)*(?=\2{2}|$)/,
                lookbehind: true
            },
            comment: /^\/\/.*/m,
            title: {
                pattern: /^.+(?:\r?\n|\r)(?:={3,}|-{3,}|~{3,}|\^{3,}|\+{3,})$|^={1,5} .+|^\.(?![\s.]).*/m,
                alias: 'important',
                inside: {
                    punctuation: /^(?:\.|=+)|(?:=+|-+|~+|\^+|\++)$/ // See rest below
                }
            },
            'attribute-entry': {
                pattern: /^:[^:\r\n]+:(?: .*?(?: \+(?:\r?\n|\r).*?)*)?$/m,
                alias: 'tag'
            },
            attributes: attributes,
            hr: {
                pattern: /^'{3,}$/m,
                alias: 'punctuation'
            },
            'page-break': {
                pattern: /^<{3,}$/m,
                alias: 'punctuation'
            },
            admonition: {
                pattern: /^(?:CAUTION|IMPORTANT|NOTE|TIP|WARNING):/m,
                alias: 'keyword'
            },
            callout: [
                {
                    pattern: /(^[ \t]*)<?\d*>/m,
                    lookbehind: true,
                    alias: 'symbol'
                },
                {
                    pattern: /<\d+>/,
                    alias: 'symbol'
                }
            ],
            macro: {
                pattern: /\b[a-z\d][a-z\d-]*::?(?:[^\s\[\]]*\[(?:[^\]\\"']|(["'])(?:(?!\1)[^\\]|\\.)*\1|\\.)*\])/,
                inside: {
                    function: /^[a-z\d-]+(?=:)/,
                    punctuation: /^::?/,
                    attributes: {
                        pattern: /(?:\[(?:[^\]\\"']|(["'])(?:(?!\1)[^\\]|\\.)*\1|\\.)*\])/,
                        inside: attributes.inside
                    }
                }
            },
            inline: {
                /*
The initial look-behind prevents the highlighting of escaped quoted text.
Quoted text can be multi-line but cannot span an empty line.
All quoted text can have attributes before [foobar, 'foobar', baz="bar"].
First, we handle the constrained quotes.
Those must be bounded by non-word chars and cannot have spaces between the delimiter and the first char.
They are, in order: _emphasis_, ``double quotes'', `single quotes', `monospace`, 'emphasis', *strong*, +monospace+ and #unquoted#
Then we handle the unconstrained quotes.
Those do not have the restrictions of the constrained quotes.
They are, in order: __emphasis__, **strong**, ++monospace++, +++passthrough+++, ##unquoted##, $$passthrough$$, ~subscript~, ^superscript^, {attribute-reference}, [[anchor]], [[[bibliography anchor]]], <<xref>>, (((indexes))) and ((indexes))
*/ pattern: /(^|[^\\])(?:(?:\B\[(?:[^\]\\"']|(["'])(?:(?!\2)[^\\]|\\.)*\2|\\.)*\])?(?:\b_(?!\s)(?: _|[^_\\\r\n]|\\.)+(?:(?:\r?\n|\r)(?: _|[^_\\\r\n]|\\.)+)*_\b|\B``(?!\s).+?(?:(?:\r?\n|\r).+?)*''\B|\B`(?!\s)(?:[^`'\s]|\s+\S)+['`]\B|\B(['*+#])(?!\s)(?: \3|(?!\3)[^\\\r\n]|\\.)+(?:(?:\r?\n|\r)(?: \3|(?!\3)[^\\\r\n]|\\.)+)*\3\B)|(?:\[(?:[^\]\\"']|(["'])(?:(?!\4)[^\\]|\\.)*\4|\\.)*\])?(?:(__|\*\*|\+\+\+?|##|\$\$|[~^]).+?(?:(?:\r?\n|\r).+?)*\5|\{[^}\r\n]+\}|\[\[\[?.+?(?:(?:\r?\n|\r).+?)*\]?\]\]|<<.+?(?:(?:\r?\n|\r).+?)*>>|\(\(\(?.+?(?:(?:\r?\n|\r).+?)*\)?\)\)))/m,
                lookbehind: true,
                inside: {
                    attributes: attributes,
                    url: {
                        pattern: /^(?:\[\[\[?.+?\]?\]\]|<<.+?>>)$/,
                        inside: {
                            punctuation: /^(?:\[\[\[?|<<)|(?:\]\]\]?|>>)$/
                        }
                    },
                    'attribute-ref': {
                        pattern: /^\{.+\}$/,
                        inside: {
                            variable: {
                                pattern: /(^\{)[a-z\d,+_-]+/,
                                lookbehind: true
                            },
                            operator: /^[=?!#%@$]|!(?=[:}])/,
                            punctuation: /^\{|\}$|::?/
                        }
                    },
                    italic: {
                        pattern: /^(['_])[\s\S]+\1$/,
                        inside: {
                            punctuation: /^(?:''?|__?)|(?:''?|__?)$/
                        }
                    },
                    bold: {
                        pattern: /^\*[\s\S]+\*$/,
                        inside: {
                            punctuation: /^\*\*?|\*\*?$/
                        }
                    },
                    punctuation: /^(?:``?|\+{1,3}|##?|\$\$|[~^]|\(\(\(?)|(?:''?|\+{1,3}|##?|\$\$|[~^`]|\)?\)\))$/
                }
            },
            replacement: {
                pattern: /\((?:C|R|TM)\)/,
                alias: 'builtin'
            },
            entity: /&#?[\da-z]{1,8};/i,
            'line-continuation': {
                pattern: /(^| )\+$/m,
                lookbehind: true,
                alias: 'punctuation'
            }
        } // Allow some nesting. There is no recursion though, so cloning should not be needed.
        ;
        function copyFromAsciiDoc(keys) {
            keys = keys.split(' ');
            var o = {};
            for(var i = 0, l = keys.length; i < l; i++)o[keys[i]] = asciidoc[keys[i]];
            return o;
        }
        attributes.inside['interpreted'].inside.rest = copyFromAsciiDoc('macro inline replacement entity');
        asciidoc['passthrough-block'].inside.rest = copyFromAsciiDoc('macro');
        asciidoc['literal-block'].inside.rest = copyFromAsciiDoc('callout');
        asciidoc['table'].inside.rest = copyFromAsciiDoc('comment-block passthrough-block literal-block other-block list-punctuation indented-block comment title attribute-entry attributes hr page-break admonition list-label callout macro inline replacement entity line-continuation');
        asciidoc['other-block'].inside.rest = copyFromAsciiDoc('table list-punctuation indented-block comment attribute-entry attributes hr page-break admonition list-label macro inline replacement entity line-continuation');
        asciidoc['title'].inside.rest = copyFromAsciiDoc('macro inline replacement entity') // Plugin to make entity title show the real entity, idea by Roman Komarov
        ;
        Prism.hooks.add('wrap', function(env) {
            if (env.type === 'entity') env.attributes['title'] = env.content.value.replace(/&amp;/, '&');
        });
        Prism.languages.adoc = Prism.languages.asciidoc;
    })(Prism);
}

});

parcelRegister("4JCZg", function(module, exports) {
'use strict';
module.exports = $37299b692c716969$var$asm6502;
$37299b692c716969$var$asm6502.displayName = 'asm6502';
$37299b692c716969$var$asm6502.aliases = [];
function $37299b692c716969$var$asm6502(Prism) {
    Prism.languages.asm6502 = {
        comment: /;.*/,
        directive: {
            pattern: /\.\w+(?= )/,
            alias: 'property'
        },
        string: /(["'`])(?:\\.|(?!\1)[^\\\r\n])*\1/,
        'op-code': {
            pattern: /\b(?:ADC|AND|ASL|BCC|BCS|BEQ|BIT|BMI|BNE|BPL|BRK|BVC|BVS|CLC|CLD|CLI|CLV|CMP|CPX|CPY|DEC|DEX|DEY|EOR|INC|INX|INY|JMP|JSR|LDA|LDX|LDY|LSR|NOP|ORA|PHA|PHP|PLA|PLP|ROL|ROR|RTI|RTS|SBC|SEC|SED|SEI|STA|STX|STY|TAX|TAY|TSX|TXA|TXS|TYA|adc|and|asl|bcc|bcs|beq|bit|bmi|bne|bpl|brk|bvc|bvs|clc|cld|cli|clv|cmp|cpx|cpy|dec|dex|dey|eor|inc|inx|iny|jmp|jsr|lda|ldx|ldy|lsr|nop|ora|pha|php|pla|plp|rol|ror|rti|rts|sbc|sec|sed|sei|sta|stx|sty|tax|tay|tsx|txa|txs|tya)\b/,
            alias: 'keyword'
        },
        'hex-number': {
            pattern: /#?\$[\da-f]{1,4}\b/i,
            alias: 'number'
        },
        'binary-number': {
            pattern: /#?%[01]+\b/,
            alias: 'number'
        },
        'decimal-number': {
            pattern: /#?\b\d+\b/,
            alias: 'number'
        },
        register: {
            pattern: /\b[xya]\b/i,
            alias: 'variable'
        },
        punctuation: /[(),:]/
    };
}

});

parcelRegister("7DBd5", function(module, exports) {
'use strict';
module.exports = $58f90a0d53cafe15$var$asmatmel;
$58f90a0d53cafe15$var$asmatmel.displayName = 'asmatmel';
$58f90a0d53cafe15$var$asmatmel.aliases = [];
function $58f90a0d53cafe15$var$asmatmel(Prism) {
    Prism.languages.asmatmel = {
        comment: {
            pattern: /;.*/,
            greedy: true
        },
        string: {
            pattern: /(["'`])(?:\\.|(?!\1)[^\\\r\n])*\1/,
            greedy: true
        },
        constant: /\b(?:PORT[A-Z]|DDR[A-Z]|(?:DD|P)[A-Z](?:\d|[0-2]\d|3[01]))\b/,
        directive: {
            pattern: /\.\w+(?= )/,
            alias: 'property'
        },
        'r-register': {
            pattern: /\br(?:\d|[12]\d|3[01])\b/,
            alias: 'variable'
        },
        'op-code': {
            pattern: /\b(?:ADC|ADD|ADIW|AND|ANDI|ASR|BCLR|BLD|BRBC|BRBS|BRCC|BRCS|BREAK|BREQ|BRGE|BRHC|BRHS|BRID|BRIE|BRLO|BRLT|BRMI|BRNE|BRPL|BRSH|BRTC|BRTS|BRVC|BRVS|BSET|BST|CALL|CBI|CBR|CLC|CLH|CLI|CLN|CLR|CLS|CLT|CLV|CLZ|COM|CP|CPC|CPI|CPSE|DEC|DES|EICALL|EIJMP|ELPM|EOR|FMUL|FMULS|FMULSU|ICALL|IJMP|IN|INC|JMP|LAC|LAS|LAT|LD|LD[A-Za-z0-9]|LPM|LSL|LSR|MOV|MOVW|MUL|MULS|MULSU|NEG|NOP|OR|ORI|OUT|POP|PUSH|RCALL|RET|RETI|RJMP|ROL|ROR|SBC|SBCI|SBI|SBIC|SBIS|SBIW|SBR|SBRC|SBRS|SEC|SEH|SEI|SEN|SER|SES|SET|SEV|SEZ|SLEEP|SPM|ST|ST[A-Z0-9]|SUB|SUBI|SWAP|TST|WDR|XCH|adc|add|adiw|and|andi|asr|bclr|bld|brbc|brbs|brcc|brcs|break|breq|brge|brhc|brhs|brid|brie|brlo|brlt|brmi|brne|brpl|brsh|brtc|brts|brvc|brvs|bset|bst|call|cbi|cbr|clc|clh|cli|cln|clr|cls|clt|clv|clz|com|cp|cpc|cpi|cpse|dec|des|eicall|eijmp|elpm|eor|fmul|fmuls|fmulsu|icall|ijmp|in|inc|jmp|lac|las|lat|ld|ld[a-z0-9]|lpm|lsl|lsr|mov|movw|mul|muls|mulsu|neg|nop|or|ori|out|pop|push|rcall|ret|reti|rjmp|rol|ror|sbc|sbci|sbi|sbic|sbis|sbiw|sbr|sbrc|sbrs|sec|seh|sei|sen|ser|ses|set|sev|sez|sleep|spm|st|st[a-zA-Z0-9]|sub|subi|swap|tst|wdr|xch)\b/,
            alias: 'keyword'
        },
        'hex-number': {
            pattern: /#?\$[\da-f]{2,4}\b/i,
            alias: 'number'
        },
        'binary-number': {
            pattern: /#?%[01]+\b/,
            alias: 'number'
        },
        'decimal-number': {
            pattern: /#?\b\d+\b/,
            alias: 'number'
        },
        register: {
            pattern: /\b[acznvshtixy]\b/i,
            alias: 'variable'
        },
        operator: />>=?|<<=?|&&?|\|\|?|[-+*/%&|^!=<>?]=?/,
        punctuation: /[(),:]/
    };
}

});

parcelRegister("kWo46", function(module, exports) {
'use strict';

var $kR0BX = parcelRequire("kR0BX");
module.exports = $f3ebe43f7aa33a0d$var$aspnet;
$f3ebe43f7aa33a0d$var$aspnet.displayName = 'aspnet';
$f3ebe43f7aa33a0d$var$aspnet.aliases = [];
function $f3ebe43f7aa33a0d$var$aspnet(Prism) {
    Prism.register($kR0BX);
    Prism.languages.aspnet = Prism.languages.extend('markup', {
        'page-directive': {
            pattern: /<%\s*@.*%>/,
            alias: 'tag',
            inside: {
                'page-directive': {
                    pattern: /<%\s*@\s*(?:Assembly|Control|Implements|Import|Master(?:Type)?|OutputCache|Page|PreviousPageType|Reference|Register)?|%>/i,
                    alias: 'tag'
                },
                rest: Prism.languages.markup.tag.inside
            }
        },
        directive: {
            pattern: /<%.*%>/,
            alias: 'tag',
            inside: {
                directive: {
                    pattern: /<%\s*?[$=%#:]{0,2}|%>/,
                    alias: 'tag'
                },
                rest: Prism.languages.csharp
            }
        }
    }) // Regexp copied from prism-markup, with a negative look-ahead added
    ;
    Prism.languages.aspnet.tag.pattern = /<(?!%)\/?[^\s>\/]+(?:\s+[^\s>\/=]+(?:=(?:("|')(?:\\[\s\S]|(?!\1)[^\\])*\1|[^\s'">=]+))?)*\s*\/?>/ // match directives of attribute value foo="<% Bar %>"
    ;
    Prism.languages.insertBefore('inside', 'punctuation', {
        directive: Prism.languages.aspnet['directive']
    }, Prism.languages.aspnet.tag.inside['attr-value']);
    Prism.languages.insertBefore('aspnet', 'comment', {
        'asp-comment': {
            pattern: /<%--[\s\S]*?--%>/,
            alias: [
                'asp',
                'comment'
            ]
        }
    }) // script runat="server" contains csharp, not javascript
    ;
    Prism.languages.insertBefore('aspnet', Prism.languages.javascript ? 'script' : 'tag', {
        'asp-script': {
            pattern: /(<script(?=.*runat=['"]?server\b)[^>]*>)[\s\S]*?(?=<\/script>)/i,
            lookbehind: true,
            alias: [
                'asp',
                'script'
            ],
            inside: Prism.languages.csharp || {}
        }
    });
}

});
parcelRegister("kR0BX", function(module, exports) {
'use strict';
module.exports = $f2e93b45690a9241$var$csharp;
$f2e93b45690a9241$var$csharp.displayName = 'csharp';
$f2e93b45690a9241$var$csharp.aliases = [
    'dotnet',
    'cs'
];
function $f2e93b45690a9241$var$csharp(Prism) {
    (function(Prism) {
        /**
     * Replaces all placeholders "<<n>>" of given pattern with the n-th replacement (zero based).
     *
     * Note: This is a simple text based replacement. Be careful when using backreferences!
     *
     * @param {string} pattern the given pattern.
     * @param {string[]} replacements a list of replacement which can be inserted into the given pattern.
     * @returns {string} the pattern with all placeholders replaced with their corresponding replacements.
     * @example replace(/a<<0>>a/.source, [/b+/.source]) === /a(?:b+)a/.source
     */ function replace(pattern, replacements) {
            return pattern.replace(/<<(\d+)>>/g, function(m, index) {
                return '(?:' + replacements[+index] + ')';
            });
        }
        /**
     * @param {string} pattern
     * @param {string[]} replacements
     * @param {string} [flags]
     * @returns {RegExp}
     */ function re(pattern, replacements, flags) {
            return RegExp(replace(pattern, replacements), flags || '');
        }
        /**
     * Creates a nested pattern where all occurrences of the string `<<self>>` are replaced with the pattern itself.
     *
     * @param {string} pattern
     * @param {number} depthLog2
     * @returns {string}
     */ function nested(pattern, depthLog2) {
            for(var i = 0; i < depthLog2; i++)pattern = pattern.replace(/<<self>>/g, function() {
                return '(?:' + pattern + ')';
            });
            return pattern.replace(/<<self>>/g, '[^\\s\\S]');
        } // https://docs.microsoft.com/en-us/dotnet/csharp/language-reference/keywords/
        var keywordKinds = {
            // keywords which represent a return or variable type
            type: 'bool byte char decimal double dynamic float int long object sbyte short string uint ulong ushort var void',
            // keywords which are used to declare a type
            typeDeclaration: 'class enum interface record struct',
            // contextual keywords
            // ("var" and "dynamic" are missing because they are used like types)
            contextual: 'add alias and ascending async await by descending from(?=\\s*(?:\\w|$)) get global group into init(?=\\s*;) join let nameof not notnull on or orderby partial remove select set unmanaged value when where with(?=\\s*{)',
            // all other keywords
            other: 'abstract as base break case catch checked const continue default delegate do else event explicit extern finally fixed for foreach goto if implicit in internal is lock namespace new null operator out override params private protected public readonly ref return sealed sizeof stackalloc static switch this throw try typeof unchecked unsafe using virtual volatile while yield'
        } // keywords
        ;
        function keywordsToPattern(words) {
            return '\\b(?:' + words.trim().replace(/ /g, '|') + ')\\b';
        }
        var typeDeclarationKeywords = keywordsToPattern(keywordKinds.typeDeclaration);
        var keywords = RegExp(keywordsToPattern(keywordKinds.type + ' ' + keywordKinds.typeDeclaration + ' ' + keywordKinds.contextual + ' ' + keywordKinds.other));
        var nonTypeKeywords = keywordsToPattern(keywordKinds.typeDeclaration + ' ' + keywordKinds.contextual + ' ' + keywordKinds.other);
        var nonContextualKeywords = keywordsToPattern(keywordKinds.type + ' ' + keywordKinds.typeDeclaration + ' ' + keywordKinds.other) // types
        ;
        var generic = nested(/<(?:[^<>;=+\-*/%&|^]|<<self>>)*>/.source, 2) // the idea behind the other forbidden characters is to prevent false positives. Same for tupleElement.
        ;
        var nestedRound = nested(/\((?:[^()]|<<self>>)*\)/.source, 2);
        var name = /@?\b[A-Za-z_]\w*\b/.source;
        var genericName = replace(/<<0>>(?:\s*<<1>>)?/.source, [
            name,
            generic
        ]);
        var identifier = replace(/(?!<<0>>)<<1>>(?:\s*\.\s*<<1>>)*/.source, [
            nonTypeKeywords,
            genericName
        ]);
        var array = /\[\s*(?:,\s*)*\]/.source;
        var typeExpressionWithoutTuple = replace(/<<0>>(?:\s*(?:\?\s*)?<<1>>)*(?:\s*\?)?/.source, [
            identifier,
            array
        ]);
        var tupleElement = replace(/[^,()<>[\];=+\-*/%&|^]|<<0>>|<<1>>|<<2>>/.source, [
            generic,
            nestedRound,
            array
        ]);
        var tuple = replace(/\(<<0>>+(?:,<<0>>+)+\)/.source, [
            tupleElement
        ]);
        var typeExpression = replace(/(?:<<0>>|<<1>>)(?:\s*(?:\?\s*)?<<2>>)*(?:\s*\?)?/.source, [
            tuple,
            identifier,
            array
        ]);
        var typeInside = {
            keyword: keywords,
            punctuation: /[<>()?,.:[\]]/
        } // strings & characters
        ;
        // https://docs.microsoft.com/en-us/dotnet/csharp/language-reference/language-specification/lexical-structure#character-literals
        // https://docs.microsoft.com/en-us/dotnet/csharp/language-reference/language-specification/lexical-structure#string-literals
        var character = /'(?:[^\r\n'\\]|\\.|\\[Uux][\da-fA-F]{1,8})'/.source // simplified pattern
        ;
        var regularString = /"(?:\\.|[^\\"\r\n])*"/.source;
        var verbatimString = /@"(?:""|\\[\s\S]|[^\\"])*"(?!")/.source;
        Prism.languages.csharp = Prism.languages.extend('clike', {
            string: [
                {
                    pattern: re(/(^|[^$\\])<<0>>/.source, [
                        verbatimString
                    ]),
                    lookbehind: true,
                    greedy: true
                },
                {
                    pattern: re(/(^|[^@$\\])<<0>>/.source, [
                        regularString
                    ]),
                    lookbehind: true,
                    greedy: true
                }
            ],
            'class-name': [
                {
                    // Using static
                    // using static System.Math;
                    pattern: re(/(\busing\s+static\s+)<<0>>(?=\s*;)/.source, [
                        identifier
                    ]),
                    lookbehind: true,
                    inside: typeInside
                },
                {
                    // Using alias (type)
                    // using Project = PC.MyCompany.Project;
                    pattern: re(/(\busing\s+<<0>>\s*=\s*)<<1>>(?=\s*;)/.source, [
                        name,
                        typeExpression
                    ]),
                    lookbehind: true,
                    inside: typeInside
                },
                {
                    // Using alias (alias)
                    // using Project = PC.MyCompany.Project;
                    pattern: re(/(\busing\s+)<<0>>(?=\s*=)/.source, [
                        name
                    ]),
                    lookbehind: true
                },
                {
                    // Type declarations
                    // class Foo<A, B>
                    // interface Foo<out A, B>
                    pattern: re(/(\b<<0>>\s+)<<1>>/.source, [
                        typeDeclarationKeywords,
                        genericName
                    ]),
                    lookbehind: true,
                    inside: typeInside
                },
                {
                    // Single catch exception declaration
                    // catch(Foo)
                    // (things like catch(Foo e) is covered by variable declaration)
                    pattern: re(/(\bcatch\s*\(\s*)<<0>>/.source, [
                        identifier
                    ]),
                    lookbehind: true,
                    inside: typeInside
                },
                {
                    // Name of the type parameter of generic constraints
                    // where Foo : class
                    pattern: re(/(\bwhere\s+)<<0>>/.source, [
                        name
                    ]),
                    lookbehind: true
                },
                {
                    // Casts and checks via as and is.
                    // as Foo<A>, is Bar<B>
                    // (things like if(a is Foo b) is covered by variable declaration)
                    pattern: re(/(\b(?:is(?:\s+not)?|as)\s+)<<0>>/.source, [
                        typeExpressionWithoutTuple
                    ]),
                    lookbehind: true,
                    inside: typeInside
                },
                {
                    // Variable, field and parameter declaration
                    // (Foo bar, Bar baz, Foo[,,] bay, Foo<Bar, FooBar<Bar>> bax)
                    pattern: re(/\b<<0>>(?=\s+(?!<<1>>|with\s*\{)<<2>>(?:\s*[=,;:{)\]]|\s+(?:in|when)\b))/.source, [
                        typeExpression,
                        nonContextualKeywords,
                        name
                    ]),
                    inside: typeInside
                }
            ],
            keyword: keywords,
            // https://docs.microsoft.com/en-us/dotnet/csharp/language-reference/language-specification/lexical-structure#literals
            number: /(?:\b0(?:x[\da-f_]*[\da-f]|b[01_]*[01])|(?:\B\.\d+(?:_+\d+)*|\b\d+(?:_+\d+)*(?:\.\d+(?:_+\d+)*)?)(?:e[-+]?\d+(?:_+\d+)*)?)(?:[dflmu]|lu|ul)?\b/i,
            operator: />>=?|<<=?|[-=]>|([-+&|])\1|~|\?\?=?|[-+*/%&|^!=<>]=?/,
            punctuation: /\?\.?|::|[{}[\];(),.:]/
        });
        Prism.languages.insertBefore('csharp', 'number', {
            range: {
                pattern: /\.\./,
                alias: 'operator'
            }
        });
        Prism.languages.insertBefore('csharp', 'punctuation', {
            'named-parameter': {
                pattern: re(/([(,]\s*)<<0>>(?=\s*:)/.source, [
                    name
                ]),
                lookbehind: true,
                alias: 'punctuation'
            }
        });
        Prism.languages.insertBefore('csharp', 'class-name', {
            namespace: {
                // namespace Foo.Bar {}
                // using Foo.Bar;
                pattern: re(/(\b(?:namespace|using)\s+)<<0>>(?:\s*\.\s*<<0>>)*(?=\s*[;{])/.source, [
                    name
                ]),
                lookbehind: true,
                inside: {
                    punctuation: /\./
                }
            },
            'type-expression': {
                // default(Foo), typeof(Foo<Bar>), sizeof(int)
                pattern: re(/(\b(?:default|sizeof|typeof)\s*\(\s*(?!\s))(?:[^()\s]|\s(?!\s)|<<0>>)*(?=\s*\))/.source, [
                    nestedRound
                ]),
                lookbehind: true,
                alias: 'class-name',
                inside: typeInside
            },
            'return-type': {
                // Foo<Bar> ForBar(); Foo IFoo.Bar() => 0
                // int this[int index] => 0; T IReadOnlyList<T>.this[int index] => this[index];
                // int Foo => 0; int Foo { get; set } = 0;
                pattern: re(/<<0>>(?=\s+(?:<<1>>\s*(?:=>|[({]|\.\s*this\s*\[)|this\s*\[))/.source, [
                    typeExpression,
                    identifier
                ]),
                inside: typeInside,
                alias: 'class-name'
            },
            'constructor-invocation': {
                // new List<Foo<Bar[]>> { }
                pattern: re(/(\bnew\s+)<<0>>(?=\s*[[({])/.source, [
                    typeExpression
                ]),
                lookbehind: true,
                inside: typeInside,
                alias: 'class-name'
            },
            /*'explicit-implementation': {
// int IFoo<Foo>.Bar => 0; void IFoo<Foo<Foo>>.Foo<T>();
pattern: replace(/\b<<0>>(?=\.<<1>>)/, className, methodOrPropertyDeclaration),
inside: classNameInside,
alias: 'class-name'
},*/ 'generic-method': {
                // foo<Bar>()
                pattern: re(/<<0>>\s*<<1>>(?=\s*\()/.source, [
                    name,
                    generic
                ]),
                inside: {
                    function: re(/^<<0>>/.source, [
                        name
                    ]),
                    generic: {
                        pattern: RegExp(generic),
                        alias: 'class-name',
                        inside: typeInside
                    }
                }
            },
            'type-list': {
                // The list of types inherited or of generic constraints
                // class Foo<F> : Bar, IList<FooBar>
                // where F : Bar, IList<int>
                pattern: re(/\b((?:<<0>>\s+<<1>>|record\s+<<1>>\s*<<5>>|where\s+<<2>>)\s*:\s*)(?:<<3>>|<<4>>|<<1>>\s*<<5>>|<<6>>)(?:\s*,\s*(?:<<3>>|<<4>>|<<6>>))*(?=\s*(?:where|[{;]|=>|$))/.source, [
                    typeDeclarationKeywords,
                    genericName,
                    name,
                    typeExpression,
                    keywords.source,
                    nestedRound,
                    /\bnew\s*\(\s*\)/.source
                ]),
                lookbehind: true,
                inside: {
                    'record-arguments': {
                        pattern: re(/(^(?!new\s*\()<<0>>\s*)<<1>>/.source, [
                            genericName,
                            nestedRound
                        ]),
                        lookbehind: true,
                        greedy: true,
                        inside: Prism.languages.csharp
                    },
                    keyword: keywords,
                    'class-name': {
                        pattern: RegExp(typeExpression),
                        greedy: true,
                        inside: typeInside
                    },
                    punctuation: /[,()]/
                }
            },
            preprocessor: {
                pattern: /(^[\t ]*)#.*/m,
                lookbehind: true,
                alias: 'property',
                inside: {
                    // highlight preprocessor directives as keywords
                    directive: {
                        pattern: /(#)\b(?:define|elif|else|endif|endregion|error|if|line|nullable|pragma|region|undef|warning)\b/,
                        lookbehind: true,
                        alias: 'keyword'
                    }
                }
            }
        }) // attributes
        ;
        var regularStringOrCharacter = regularString + '|' + character;
        var regularStringCharacterOrComment = replace(/\/(?![*/])|\/\/[^\r\n]*[\r\n]|\/\*(?:[^*]|\*(?!\/))*\*\/|<<0>>/.source, [
            regularStringOrCharacter
        ]);
        var roundExpression = nested(replace(/[^"'/()]|<<0>>|\(<<self>>*\)/.source, [
            regularStringCharacterOrComment
        ]), 2) // https://docs.microsoft.com/en-us/dotnet/csharp/programming-guide/concepts/attributes/#attribute-targets
        ;
        var attrTarget = /\b(?:assembly|event|field|method|module|param|property|return|type)\b/.source;
        var attr = replace(/<<0>>(?:\s*\(<<1>>*\))?/.source, [
            identifier,
            roundExpression
        ]);
        Prism.languages.insertBefore('csharp', 'class-name', {
            attribute: {
                // Attributes
                // [Foo], [Foo(1), Bar(2, Prop = "foo")], [return: Foo(1), Bar(2)], [assembly: Foo(Bar)]
                pattern: re(/((?:^|[^\s\w>)?])\s*\[\s*)(?:<<0>>\s*:\s*)?<<1>>(?:\s*,\s*<<1>>)*(?=\s*\])/.source, [
                    attrTarget,
                    attr
                ]),
                lookbehind: true,
                greedy: true,
                inside: {
                    target: {
                        pattern: re(/^<<0>>(?=\s*:)/.source, [
                            attrTarget
                        ]),
                        alias: 'keyword'
                    },
                    'attribute-arguments': {
                        pattern: re(/\(<<0>>*\)/.source, [
                            roundExpression
                        ]),
                        inside: Prism.languages.csharp
                    },
                    'class-name': {
                        pattern: RegExp(identifier),
                        inside: {
                            punctuation: /\./
                        }
                    },
                    punctuation: /[:,]/
                }
            }
        }) // string interpolation
        ;
        var formatString = /:[^}\r\n]+/.source // multi line
        ;
        var mInterpolationRound = nested(replace(/[^"'/()]|<<0>>|\(<<self>>*\)/.source, [
            regularStringCharacterOrComment
        ]), 2);
        var mInterpolation = replace(/\{(?!\{)(?:(?![}:])<<0>>)*<<1>>?\}/.source, [
            mInterpolationRound,
            formatString
        ]) // single line
        ;
        var sInterpolationRound = nested(replace(/[^"'/()]|\/(?!\*)|\/\*(?:[^*]|\*(?!\/))*\*\/|<<0>>|\(<<self>>*\)/.source, [
            regularStringOrCharacter
        ]), 2);
        var sInterpolation = replace(/\{(?!\{)(?:(?![}:])<<0>>)*<<1>>?\}/.source, [
            sInterpolationRound,
            formatString
        ]);
        function createInterpolationInside(interpolation, interpolationRound) {
            return {
                interpolation: {
                    pattern: re(/((?:^|[^{])(?:\{\{)*)<<0>>/.source, [
                        interpolation
                    ]),
                    lookbehind: true,
                    inside: {
                        'format-string': {
                            pattern: re(/(^\{(?:(?![}:])<<0>>)*)<<1>>(?=\}$)/.source, [
                                interpolationRound,
                                formatString
                            ]),
                            lookbehind: true,
                            inside: {
                                punctuation: /^:/
                            }
                        },
                        punctuation: /^\{|\}$/,
                        expression: {
                            pattern: /[\s\S]+/,
                            alias: 'language-csharp',
                            inside: Prism.languages.csharp
                        }
                    }
                },
                string: /[\s\S]+/
            };
        }
        Prism.languages.insertBefore('csharp', 'string', {
            'interpolation-string': [
                {
                    pattern: re(/(^|[^\\])(?:\$@|@\$)"(?:""|\\[\s\S]|\{\{|<<0>>|[^\\{"])*"/.source, [
                        mInterpolation
                    ]),
                    lookbehind: true,
                    greedy: true,
                    inside: createInterpolationInside(mInterpolation, mInterpolationRound)
                },
                {
                    pattern: re(/(^|[^@\\])\$"(?:\\.|\{\{|<<0>>|[^\\"{])*"/.source, [
                        sInterpolation
                    ]),
                    lookbehind: true,
                    greedy: true,
                    inside: createInterpolationInside(sInterpolation, sInterpolationRound)
                }
            ],
            char: {
                pattern: RegExp(character),
                greedy: true
            }
        });
        Prism.languages.dotnet = Prism.languages.cs = Prism.languages.csharp;
    })(Prism);
}

});


parcelRegister("aiaTs", function(module, exports) {
'use strict';
module.exports = $77e4090577a5500e$var$autohotkey;
$77e4090577a5500e$var$autohotkey.displayName = 'autohotkey';
$77e4090577a5500e$var$autohotkey.aliases = [];
function $77e4090577a5500e$var$autohotkey(Prism) {
    // NOTES - follows first-first highlight method, block is locked after highlight, different from SyntaxHl
    Prism.languages.autohotkey = {
        comment: [
            {
                pattern: /(^|\s);.*/,
                lookbehind: true
            },
            {
                pattern: /(^[\t ]*)\/\*(?:[\r\n](?![ \t]*\*\/)|[^\r\n])*(?:[\r\n][ \t]*\*\/)?/m,
                lookbehind: true,
                greedy: true
            }
        ],
        tag: {
            // labels
            pattern: /^([ \t]*)[^\s,`":]+(?=:[ \t]*$)/m,
            lookbehind: true
        },
        string: /"(?:[^"\n\r]|"")*"/,
        variable: /%\w+%/,
        number: /\b0x[\dA-Fa-f]+\b|(?:\b\d+(?:\.\d*)?|\B\.\d+)(?:[Ee]-?\d+)?/,
        operator: /\?|\/\/?=?|:=|\|[=|]?|&[=&]?|\+[=+]?|-[=-]?|\*[=*]?|<(?:<=?|>|=)?|>>?=?|[.^!=~]=?|\b(?:AND|NOT|OR)\b/,
        boolean: /\b(?:false|true)\b/,
        selector: /\b(?:AutoTrim|BlockInput|Break|Click|ClipWait|Continue|Control|ControlClick|ControlFocus|ControlGet|ControlGetFocus|ControlGetPos|ControlGetText|ControlMove|ControlSend|ControlSendRaw|ControlSetText|CoordMode|Critical|DetectHiddenText|DetectHiddenWindows|Drive|DriveGet|DriveSpaceFree|EnvAdd|EnvDiv|EnvGet|EnvMult|EnvSet|EnvSub|EnvUpdate|Exit|ExitApp|FileAppend|FileCopy|FileCopyDir|FileCreateDir|FileCreateShortcut|FileDelete|FileEncoding|FileGetAttrib|FileGetShortcut|FileGetSize|FileGetTime|FileGetVersion|FileInstall|FileMove|FileMoveDir|FileRead|FileReadLine|FileRecycle|FileRecycleEmpty|FileRemoveDir|FileSelectFile|FileSelectFolder|FileSetAttrib|FileSetTime|FormatTime|GetKeyState|Gosub|Goto|GroupActivate|GroupAdd|GroupClose|GroupDeactivate|Gui|GuiControl|GuiControlGet|Hotkey|ImageSearch|IniDelete|IniRead|IniWrite|Input|InputBox|KeyWait|ListHotkeys|ListLines|ListVars|Loop|Menu|MouseClick|MouseClickDrag|MouseGetPos|MouseMove|MsgBox|OnExit|OutputDebug|Pause|PixelGetColor|PixelSearch|PostMessage|Process|Progress|Random|RegDelete|RegRead|RegWrite|Reload|Repeat|Return|Run|RunAs|RunWait|Send|SendEvent|SendInput|SendMessage|SendMode|SendPlay|SendRaw|SetBatchLines|SetCapslockState|SetControlDelay|SetDefaultMouseSpeed|SetEnv|SetFormat|SetKeyDelay|SetMouseDelay|SetNumlockState|SetRegView|SetScrollLockState|SetStoreCapslockMode|SetTimer|SetTitleMatchMode|SetWinDelay|SetWorkingDir|Shutdown|Sleep|Sort|SoundBeep|SoundGet|SoundGetWaveVolume|SoundPlay|SoundSet|SoundSetWaveVolume|SplashImage|SplashTextOff|SplashTextOn|SplitPath|StatusBarGetText|StatusBarWait|StringCaseSense|StringGetPos|StringLeft|StringLen|StringLower|StringMid|StringReplace|StringRight|StringSplit|StringTrimLeft|StringTrimRight|StringUpper|Suspend|SysGet|Thread|ToolTip|Transform|TrayTip|URLDownloadToFile|WinActivate|WinActivateBottom|WinClose|WinGet|WinGetActiveStats|WinGetActiveTitle|WinGetClass|WinGetPos|WinGetText|WinGetTitle|WinHide|WinKill|WinMaximize|WinMenuSelectItem|WinMinimize|WinMinimizeAll|WinMinimizeAllUndo|WinMove|WinRestore|WinSet|WinSetTitle|WinShow|WinWait|WinWaitActive|WinWaitClose|WinWaitNotActive)\b/i,
        constant: /\b(?:a_ahkpath|a_ahkversion|a_appdata|a_appdatacommon|a_autotrim|a_batchlines|a_caretx|a_carety|a_computername|a_controldelay|a_cursor|a_dd|a_ddd|a_dddd|a_defaultmousespeed|a_desktop|a_desktopcommon|a_detecthiddentext|a_detecthiddenwindows|a_endchar|a_eventinfo|a_exitreason|a_fileencoding|a_formatfloat|a_formatinteger|a_gui|a_guicontrol|a_guicontrolevent|a_guievent|a_guiheight|a_guiwidth|a_guix|a_guiy|a_hour|a_iconfile|a_iconhidden|a_iconnumber|a_icontip|a_index|a_ipaddress1|a_ipaddress2|a_ipaddress3|a_ipaddress4|a_is64bitos|a_isadmin|a_iscompiled|a_iscritical|a_ispaused|a_issuspended|a_isunicode|a_keydelay|a_language|a_lasterror|a_linefile|a_linenumber|a_loopfield|a_loopfileattrib|a_loopfiledir|a_loopfileext|a_loopfilefullpath|a_loopfilelongpath|a_loopfilename|a_loopfileshortname|a_loopfileshortpath|a_loopfilesize|a_loopfilesizekb|a_loopfilesizemb|a_loopfiletimeaccessed|a_loopfiletimecreated|a_loopfiletimemodified|a_loopreadline|a_loopregkey|a_loopregname|a_loopregsubkey|a_loopregtimemodified|a_loopregtype|a_mday|a_min|a_mm|a_mmm|a_mmmm|a_mon|a_mousedelay|a_msec|a_mydocuments|a_now|a_nowutc|a_numbatchlines|a_ostype|a_osversion|a_priorhotkey|a_priorkey|a_programfiles|a_programs|a_programscommon|a_ptrsize|a_regview|a_screendpi|a_screenheight|a_screenwidth|a_scriptdir|a_scriptfullpath|a_scripthwnd|a_scriptname|a_sec|a_space|a_startmenu|a_startmenucommon|a_startup|a_startupcommon|a_stringcasesense|a_tab|a_temp|a_thisfunc|a_thishotkey|a_thislabel|a_thismenu|a_thismenuitem|a_thismenuitempos|a_tickcount|a_timeidle|a_timeidlephysical|a_timesincepriorhotkey|a_timesincethishotkey|a_titlematchmode|a_titlematchmodespeed|a_username|a_wday|a_windelay|a_windir|a_workingdir|a_yday|a_year|a_yweek|a_yyyy|clipboard|clipboardall|comspec|errorlevel|programfiles)\b/i,
        builtin: /\b(?:abs|acos|asc|asin|atan|ceil|chr|class|comobjactive|comobjarray|comobjconnect|comobjcreate|comobjerror|comobjflags|comobjget|comobjquery|comobjtype|comobjvalue|cos|dllcall|exp|fileexist|Fileopen|floor|format|il_add|il_create|il_destroy|instr|isfunc|islabel|IsObject|ln|log|ltrim|lv_add|lv_delete|lv_deletecol|lv_getcount|lv_getnext|lv_gettext|lv_insert|lv_insertcol|lv_modify|lv_modifycol|lv_setimagelist|mod|numget|numput|onmessage|regexmatch|regexreplace|registercallback|round|rtrim|sb_seticon|sb_setparts|sb_settext|sin|sqrt|strlen|strreplace|strsplit|substr|tan|tv_add|tv_delete|tv_get|tv_getchild|tv_getcount|tv_getnext|tv_getparent|tv_getprev|tv_getselection|tv_gettext|tv_modify|varsetcapacity|winactive|winexist|__Call|__Get|__New|__Set)\b/i,
        symbol: /\b(?:alt|altdown|altup|appskey|backspace|browser_back|browser_favorites|browser_forward|browser_home|browser_refresh|browser_search|browser_stop|bs|capslock|ctrl|ctrlbreak|ctrldown|ctrlup|del|delete|down|end|enter|esc|escape|f1|f10|f11|f12|f13|f14|f15|f16|f17|f18|f19|f2|f20|f21|f22|f23|f24|f3|f4|f5|f6|f7|f8|f9|home|ins|insert|joy1|joy10|joy11|joy12|joy13|joy14|joy15|joy16|joy17|joy18|joy19|joy2|joy20|joy21|joy22|joy23|joy24|joy25|joy26|joy27|joy28|joy29|joy3|joy30|joy31|joy32|joy4|joy5|joy6|joy7|joy8|joy9|joyaxes|joybuttons|joyinfo|joyname|joypov|joyr|joyu|joyv|joyx|joyy|joyz|lalt|launch_app1|launch_app2|launch_mail|launch_media|lbutton|lcontrol|lctrl|left|lshift|lwin|lwindown|lwinup|mbutton|media_next|media_play_pause|media_prev|media_stop|numlock|numpad0|numpad1|numpad2|numpad3|numpad4|numpad5|numpad6|numpad7|numpad8|numpad9|numpadadd|numpadclear|numpaddel|numpaddiv|numpaddot|numpaddown|numpadend|numpadenter|numpadhome|numpadins|numpadleft|numpadmult|numpadpgdn|numpadpgup|numpadright|numpadsub|numpadup|pgdn|pgup|printscreen|ralt|rbutton|rcontrol|rctrl|right|rshift|rwin|rwindown|rwinup|scrolllock|shift|shiftdown|shiftup|space|tab|up|volume_down|volume_mute|volume_up|wheeldown|wheelleft|wheelright|wheelup|xbutton1|xbutton2)\b/i,
        important: /#\b(?:AllowSameLineComments|ClipboardTimeout|CommentFlag|DerefChar|ErrorStdOut|EscapeChar|HotkeyInterval|HotkeyModifierTimeout|Hotstring|If|IfTimeout|IfWinActive|IfWinExist|IfWinNotActive|IfWinNotExist|Include|IncludeAgain|InputLevel|InstallKeybdHook|InstallMouseHook|KeyHistory|MaxHotkeysPerInterval|MaxMem|MaxThreads|MaxThreadsBuffer|MaxThreadsPerHotkey|MenuMaskKey|NoEnv|NoTrayIcon|Persistent|SingleInstance|UseHook|Warn|WinActivateForce)\b/i,
        keyword: /\b(?:Abort|AboveNormal|Add|ahk_class|ahk_exe|ahk_group|ahk_id|ahk_pid|All|Alnum|Alpha|AltSubmit|AltTab|AltTabAndMenu|AltTabMenu|AltTabMenuDismiss|AlwaysOnTop|AutoSize|Background|BackgroundTrans|BelowNormal|between|BitAnd|BitNot|BitOr|BitShiftLeft|BitShiftRight|BitXOr|Bold|Border|Button|ByRef|Catch|Checkbox|Checked|CheckedGray|Choose|ChooseString|Close|Color|ComboBox|Contains|ControlList|Count|Date|DateTime|Days|DDL|Default|DeleteAll|Delimiter|Deref|Destroy|Digit|Disable|Disabled|DropDownList|Edit|Eject|Else|Enable|Enabled|Error|Exist|Expand|ExStyle|FileSystem|Finally|First|Flash|Float|FloatFast|Focus|Font|for|global|Grid|Group|GroupBox|GuiClose|GuiContextMenu|GuiDropFiles|GuiEscape|GuiSize|Hdr|Hidden|Hide|High|HKCC|HKCR|HKCU|HKEY_CLASSES_ROOT|HKEY_CURRENT_CONFIG|HKEY_CURRENT_USER|HKEY_LOCAL_MACHINE|HKEY_USERS|HKLM|HKU|Hours|HScroll|Icon|IconSmall|ID|IDLast|If|IfEqual|IfExist|IfGreater|IfGreaterOrEqual|IfInString|IfLess|IfLessOrEqual|IfMsgBox|IfNotEqual|IfNotExist|IfNotInString|IfWinActive|IfWinExist|IfWinNotActive|IfWinNotExist|Ignore|ImageList|in|Integer|IntegerFast|Interrupt|is|italic|Join|Label|LastFound|LastFoundExist|Limit|Lines|List|ListBox|ListView|local|Lock|Logoff|Low|Lower|Lowercase|MainWindow|Margin|Maximize|MaximizeBox|MaxSize|Minimize|MinimizeBox|MinMax|MinSize|Minutes|MonthCal|Mouse|Move|Multi|NA|No|NoActivate|NoDefault|NoHide|NoIcon|NoMainWindow|norm|Normal|NoSort|NoSortHdr|NoStandard|Not|NoTab|NoTimers|Number|Off|Ok|On|OwnDialogs|Owner|Parse|Password|Picture|Pixel|Pos|Pow|Priority|ProcessName|Radio|Range|Read|ReadOnly|Realtime|Redraw|Region|REG_BINARY|REG_DWORD|REG_EXPAND_SZ|REG_MULTI_SZ|REG_SZ|Relative|Rename|Report|Resize|Restore|Retry|RGB|Screen|Seconds|Section|Serial|SetLabel|ShiftAltTab|Show|Single|Slider|SortDesc|Standard|static|Status|StatusBar|StatusCD|strike|Style|Submit|SysMenu|Tab2|TabStop|Text|Theme|Throw|Tile|ToggleCheck|ToggleEnable|ToolWindow|Top|Topmost|TransColor|Transparent|Tray|TreeView|Try|TryAgain|Type|UnCheck|underline|Unicode|Unlock|Until|UpDown|Upper|Uppercase|UseErrorLevel|Vis|VisFirst|Visible|VScroll|Wait|WaitClose|WantCtrlA|WantF2|WantReturn|While|Wrap|Xdigit|xm|xp|xs|Yes|ym|yp|ys)\b/i,
        function: /[^(); \t,\n+*\-=?>:\\\/<&%\[\]]+(?=\()/,
        punctuation: /[{}[\]():,]/
    };
}

});

parcelRegister("cJe6k", function(module, exports) {
'use strict';
module.exports = $9444a02bf53856f0$var$autoit;
$9444a02bf53856f0$var$autoit.displayName = 'autoit';
$9444a02bf53856f0$var$autoit.aliases = [];
function $9444a02bf53856f0$var$autoit(Prism) {
    Prism.languages.autoit = {
        comment: [
            /;.*/,
            {
                // The multi-line comments delimiters can actually be commented out with ";"
                pattern: /(^[\t ]*)#(?:comments-start|cs)[\s\S]*?^[ \t]*#(?:ce|comments-end)/m,
                lookbehind: true
            }
        ],
        url: {
            pattern: /(^[\t ]*#include\s+)(?:<[^\r\n>]+>|"[^\r\n"]+")/m,
            lookbehind: true
        },
        string: {
            pattern: /(["'])(?:\1\1|(?!\1)[^\r\n])*\1/,
            greedy: true,
            inside: {
                variable: /([%$@])\w+\1/
            }
        },
        directive: {
            pattern: /(^[\t ]*)#[\w-]+/m,
            lookbehind: true,
            alias: 'keyword'
        },
        function: /\b\w+(?=\()/,
        // Variables and macros
        variable: /[$@]\w+/,
        keyword: /\b(?:Case|Const|Continue(?:Case|Loop)|Default|Dim|Do|Else(?:If)?|End(?:Func|If|Select|Switch|With)|Enum|Exit(?:Loop)?|For|Func|Global|If|In|Local|Next|Null|ReDim|Select|Static|Step|Switch|Then|To|Until|Volatile|WEnd|While|With)\b/i,
        number: /\b(?:0x[\da-f]+|\d+(?:\.\d+)?(?:e[+-]?\d+)?)\b/i,
        boolean: /\b(?:False|True)\b/i,
        operator: /<[=>]?|[-+*\/=&>]=?|[?^]|\b(?:And|Not|Or)\b/i,
        punctuation: /[\[\]().,:]/
    };
}

});

parcelRegister("9Xvjt", function(module, exports) {
'use strict';
module.exports = $7401e9d9d1be3e46$var$avisynth;
$7401e9d9d1be3e46$var$avisynth.displayName = 'avisynth';
$7401e9d9d1be3e46$var$avisynth.aliases = [
    'avs'
];
function $7401e9d9d1be3e46$var$avisynth(Prism) {
    (function(Prism) {
        function replace(pattern, replacements) {
            return pattern.replace(/<<(\d+)>>/g, function(m, index) {
                return replacements[+index];
            });
        }
        function re(pattern, replacements, flags) {
            return RegExp(replace(pattern, replacements), flags || '');
        }
        var types = /bool|clip|float|int|string|val/.source;
        var internals = [
            // bools
            /is(?:bool|clip|float|int|string)|defined|(?:(?:internal)?function|var)?exists?/.source,
            /apply|assert|default|eval|import|nop|select|undefined/.source,
            /opt_(?:allowfloataudio|avipadscanlines|dwchannelmask|enable_(?:b64a|planartopackedrgb|v210|y3_10_10|y3_10_16)|usewaveextensible|vdubplanarhack)|set(?:cachemode|maxcpu|memorymax|planarlegacyalignment|workingdir)/.source,
            /hex(?:value)?|value/.source,
            /abs|ceil|continued(?:denominator|numerator)?|exp|floor|fmod|frac|log(?:10)?|max|min|muldiv|pi|pow|rand|round|sign|spline|sqrt/.source,
            /a?sinh?|a?cosh?|a?tan[2h]?/.source,
            /(?:bit(?:and|not|x?or|[lr]?shift[aslu]?|sh[lr]|sa[lr]|[lr]rotatel?|ro[rl]|te?st|set(?:count)?|cl(?:ea)?r|ch(?:an)?ge?))/.source,
            /average(?:[bgr]|chroma[uv]|luma)|(?:[rgb]|chroma[uv]|luma|rgb|[yuv](?=difference(?:fromprevious|tonext)))difference(?:fromprevious|tonext)?|[yuvrgb]plane(?:median|min|max|minmaxdifference)/.source,
            /getprocessinfo|logmsg|script(?:dir(?:utf8)?|file(?:utf8)?|name(?:utf8)?)|setlogparams/.source,
            /chr|(?:fill|find|left|mid|replace|rev|right)str|format|[lu]case|ord|str(?:cmpi?|fromutf8|len|toutf8)|time|trim(?:all|left|right)/.source,
            /isversionorgreater|version(?:number|string)/.source,
            /buildpixeltype|colorspacenametopixeltype/.source,
            /addautoloaddir|on(?:cpu|cuda)|prefetch|setfiltermtmode/.source
        ].join('|');
        var properties = [
            // content
            /has(?:audio|video)/.source,
            /height|width/.source,
            /frame(?:count|rate)|framerate(?:denominator|numerator)/.source,
            /getparity|is(?:field|frame)based/.source,
            /bitspercomponent|componentsize|hasalpha|is(?:planar(?:rgba?)?|interleaved|rgb(?:24|32|48|64)?|y(?:8|u(?:va?|y2))?|yv(?:12|16|24|411)|420|422|444|packedrgb)|numcomponents|pixeltype/.source,
            /audio(?:bits|channels|duration|length(?:[fs]|hi|lo)?|rate)|isaudio(?:float|int)/.source
        ].join('|');
        var filters = [
            // source
            /avi(?:file)?source|directshowsource|image(?:reader|source|sourceanim)|opendmlsource|segmented(?:avisource|directshowsource)|wavsource/.source,
            /coloryuv|convertbacktoyuy2|convertto(?:RGB(?:24|32|48|64)|(?:planar)?RGBA?|Y8?|YV(?:12|16|24|411)|YUVA?(?:411|420|422|444)|YUY2)|fixluminance|gr[ae]yscale|invert|levels|limiter|mergea?rgb|merge(?:chroma|luma)|rgbadjust|show(?:alpha|blue|green|red)|swapuv|tweak|[uv]toy8?|ytouv/.source,
            /(?:colorkey|reset)mask|layer|mask(?:hs)?|merge|overlay|subtract/.source,
            /addborders|(?:bicubic|bilinear|blackman|gauss|lanczos4|lanczos|point|sinc|spline(?:16|36|64))resize|crop(?:bottom)?|flip(?:horizontal|vertical)|(?:horizontal|vertical)?reduceby2|letterbox|skewrows|turn(?:180|left|right)/.source,
            /blur|fixbrokenchromaupsampling|generalconvolution|(?:spatial|temporal)soften|sharpen/.source,
            /trim|(?:un)?alignedsplice|(?:assume|assumescaled|change|convert)FPS|(?:delete|duplicate)frame|dissolve|fade(?:in|io|out)[02]?|freezeframe|interleave|loop|reverse|select(?:even|odd|(?:range)?every)/.source,
            /assume[bt]ff|assume(?:field|frame)based|bob|complementparity|doubleweave|peculiarblend|pulldown|separate(?:columns|fields|rows)|swapfields|weave(?:columns|rows)?/.source,
            /amplify(?:db)?|assumesamplerate|audiodub(?:ex)?|audiotrim|convertaudioto(?:(?:8|16|24|32)bit|float)|converttomono|delayaudio|ensurevbrmp3sync|get(?:left|right)?channel|kill(?:audio|video)|mergechannels|mixaudio|monotostereo|normalize|resampleaudio|ssrc|supereq|timestretch/.source,
            /animate|applyrange|conditional(?:filter|reader|select)|frameevaluate|scriptclip|tcp(?:server|source)|writefile(?:end|if|start)?/.source,
            /imagewriter/.source,
            /blackness|blankclip|colorbars(?:hd)?|compare|dumpfiltergraph|echo|histogram|info|messageclip|preroll|setgraphanalysis|show(?:framenumber|smpte|time)|showfiveversions|stack(?:horizontal|vertical)|subtitle|tone|version/.source
        ].join('|');
        var allinternals = [
            internals,
            properties,
            filters
        ].join('|');
        Prism.languages.avisynth = {
            comment: [
                {
                    // Matches [* *] nestable block comments, but only supports 1 level of nested comments
                    // /\[\*(?:[^\[*]|\[(?!\*)|\*(?!\])|<self>)*\*\]/
                    pattern: /(^|[^\\])\[\*(?:[^\[*]|\[(?!\*)|\*(?!\])|\[\*(?:[^\[*]|\[(?!\*)|\*(?!\]))*\*\])*\*\]/,
                    lookbehind: true,
                    greedy: true
                },
                {
                    // Matches /* */ block comments
                    pattern: /(^|[^\\])\/\*[\s\S]*?(?:\*\/|$)/,
                    lookbehind: true,
                    greedy: true
                },
                {
                    // Matches # comments
                    pattern: /(^|[^\\$])#.*/,
                    lookbehind: true,
                    greedy: true
                }
            ],
            // Handle before strings because optional arguments are surrounded by double quotes
            argument: {
                pattern: re(/\b(?:<<0>>)\s+("?)\w+\1/.source, [
                    types
                ], 'i'),
                inside: {
                    keyword: /^\w+/
                }
            },
            // Optional argument assignment
            'argument-label': {
                pattern: /([,(][\s\\]*)\w+\s*=(?!=)/,
                lookbehind: true,
                inside: {
                    'argument-name': {
                        pattern: /^\w+/,
                        alias: 'punctuation'
                    },
                    punctuation: /=$/
                }
            },
            string: [
                {
                    // triple double-quoted
                    pattern: /"""[\s\S]*?"""/,
                    greedy: true
                },
                {
                    // single double-quoted
                    pattern: /"(?:\\(?:\r\n|[\s\S])|[^"\\\r\n])*"/,
                    greedy: true,
                    inside: {
                        constant: {
                            // These *are* case-sensitive!
                            pattern: /\b(?:DEFAULT_MT_MODE|(?:MAINSCRIPT|PROGRAM|SCRIPT)DIR|(?:MACHINE|USER)_(?:CLASSIC|PLUS)_PLUGINS)\b/
                        }
                    }
                }
            ],
            // The special "last" variable that takes the value of the last implicitly returned clip
            variable: /\b(?:last)\b/i,
            boolean: /\b(?:false|no|true|yes)\b/i,
            keyword: /\b(?:catch|else|for|function|global|if|return|try|while|__END__)\b/i,
            constant: /\bMT_(?:MULTI_INSTANCE|NICE_FILTER|SERIALIZED|SPECIAL_MT)\b/,
            // AviSynth's internal functions, filters, and properties
            'builtin-function': {
                pattern: re(/\b(?:<<0>>)\b/.source, [
                    allinternals
                ], 'i'),
                alias: 'function'
            },
            'type-cast': {
                pattern: re(/\b(?:<<0>>)(?=\s*\()/.source, [
                    types
                ], 'i'),
                alias: 'keyword'
            },
            // External/user-defined filters
            function: {
                pattern: /\b[a-z_]\w*(?=\s*\()|(\.)[a-z_]\w*\b/i,
                lookbehind: true
            },
            // Matches a \ as the first or last character on a line
            'line-continuation': {
                pattern: /(^[ \t]*)\\|\\(?=[ \t]*$)/m,
                lookbehind: true,
                alias: 'punctuation'
            },
            number: /\B\$(?:[\da-f]{6}|[\da-f]{8})\b|(?:(?:\b|\B-)\d+(?:\.\d*)?\b|\B\.\d+\b)/i,
            operator: /\+\+?|[!=<>]=?|&&|\|\||[?:*/%-]/,
            punctuation: /[{}\[\]();,.]/
        };
        Prism.languages.avs = Prism.languages.avisynth;
    })(Prism);
}

});

parcelRegister("fulTr", function(module, exports) {
'use strict';
module.exports = $b46aa3ea75d6c90d$var$avroIdl;
$b46aa3ea75d6c90d$var$avroIdl.displayName = 'avroIdl';
$b46aa3ea75d6c90d$var$avroIdl.aliases = [];
function $b46aa3ea75d6c90d$var$avroIdl(Prism) {
    // GitHub: https://github.com/apache/avro
    // Docs: https://avro.apache.org/docs/current/idl.html
    Prism.languages['avro-idl'] = {
        comment: {
            pattern: /\/\/.*|\/\*[\s\S]*?\*\//,
            greedy: true
        },
        string: {
            pattern: /(^|[^\\])"(?:[^\r\n"\\]|\\.)*"/,
            lookbehind: true,
            greedy: true
        },
        annotation: {
            pattern: /@(?:[$\w.-]|`[^\r\n`]+`)+/,
            greedy: true,
            alias: 'function'
        },
        'function-identifier': {
            pattern: /`[^\r\n`]+`(?=\s*\()/,
            greedy: true,
            alias: 'function'
        },
        identifier: {
            pattern: /`[^\r\n`]+`/,
            greedy: true
        },
        'class-name': {
            pattern: /(\b(?:enum|error|protocol|record|throws)\b\s+)[$\w]+/,
            lookbehind: true,
            greedy: true
        },
        keyword: /\b(?:array|boolean|bytes|date|decimal|double|enum|error|false|fixed|float|idl|import|int|local_timestamp_ms|long|map|null|oneway|protocol|record|schema|string|throws|time_ms|timestamp_ms|true|union|uuid|void)\b/,
        function: /\b[a-z_]\w*(?=\s*\()/i,
        number: [
            {
                pattern: /(^|[^\w.])-?(?:(?:\d+(?:\.\d*)?|\.\d+)(?:e[+-]?\d+)?|0x(?:[a-f0-9]+(?:\.[a-f0-9]*)?|\.[a-f0-9]+)(?:p[+-]?\d+)?)[dfl]?(?![\w.])/i,
                lookbehind: true
            },
            /-?\b(?:Infinity|NaN)\b/
        ],
        operator: /=/,
        punctuation: /[()\[\]{}<>.:,;-]/
    };
    Prism.languages.avdl = Prism.languages['avro-idl'];
}

});

parcelRegister("92S56", function(module, exports) {
'use strict';
module.exports = $695e405d782e5828$var$bash;
$695e405d782e5828$var$bash.displayName = 'bash';
$695e405d782e5828$var$bash.aliases = [
    'shell'
];
function $695e405d782e5828$var$bash(Prism) {
    (function(Prism) {
        // $ set | grep '^[A-Z][^[:space:]]*=' | cut -d= -f1 | tr '\n' '|'
        // + LC_ALL, RANDOM, REPLY, SECONDS.
        // + make sure PS1..4 are here as they are not always set,
        // - some useless things.
        var envVars = '\\b(?:BASH|BASHOPTS|BASH_ALIASES|BASH_ARGC|BASH_ARGV|BASH_CMDS|BASH_COMPLETION_COMPAT_DIR|BASH_LINENO|BASH_REMATCH|BASH_SOURCE|BASH_VERSINFO|BASH_VERSION|COLORTERM|COLUMNS|COMP_WORDBREAKS|DBUS_SESSION_BUS_ADDRESS|DEFAULTS_PATH|DESKTOP_SESSION|DIRSTACK|DISPLAY|EUID|GDMSESSION|GDM_LANG|GNOME_KEYRING_CONTROL|GNOME_KEYRING_PID|GPG_AGENT_INFO|GROUPS|HISTCONTROL|HISTFILE|HISTFILESIZE|HISTSIZE|HOME|HOSTNAME|HOSTTYPE|IFS|INSTANCE|JOB|LANG|LANGUAGE|LC_ADDRESS|LC_ALL|LC_IDENTIFICATION|LC_MEASUREMENT|LC_MONETARY|LC_NAME|LC_NUMERIC|LC_PAPER|LC_TELEPHONE|LC_TIME|LESSCLOSE|LESSOPEN|LINES|LOGNAME|LS_COLORS|MACHTYPE|MAILCHECK|MANDATORY_PATH|NO_AT_BRIDGE|OLDPWD|OPTERR|OPTIND|ORBIT_SOCKETDIR|OSTYPE|PAPERSIZE|PATH|PIPESTATUS|PPID|PS1|PS2|PS3|PS4|PWD|RANDOM|REPLY|SECONDS|SELINUX_INIT|SESSION|SESSIONTYPE|SESSION_MANAGER|SHELL|SHELLOPTS|SHLVL|SSH_AUTH_SOCK|TERM|UID|UPSTART_EVENTS|UPSTART_INSTANCE|UPSTART_JOB|UPSTART_SESSION|USER|WINDOWID|XAUTHORITY|XDG_CONFIG_DIRS|XDG_CURRENT_DESKTOP|XDG_DATA_DIRS|XDG_GREETER_DATA_DIR|XDG_MENU_PREFIX|XDG_RUNTIME_DIR|XDG_SEAT|XDG_SEAT_PATH|XDG_SESSION_DESKTOP|XDG_SESSION_ID|XDG_SESSION_PATH|XDG_SESSION_TYPE|XDG_VTNR|XMODIFIERS)\\b';
        var commandAfterHeredoc = {
            pattern: /(^(["']?)\w+\2)[ \t]+\S.*/,
            lookbehind: true,
            alias: 'punctuation',
            // this looks reasonably well in all themes
            inside: null // see below
        };
        var insideString = {
            bash: commandAfterHeredoc,
            environment: {
                pattern: RegExp('\\$' + envVars),
                alias: 'constant'
            },
            variable: [
                // [0]: Arithmetic Environment
                {
                    pattern: /\$?\(\([\s\S]+?\)\)/,
                    greedy: true,
                    inside: {
                        // If there is a $ sign at the beginning highlight $(( and )) as variable
                        variable: [
                            {
                                pattern: /(^\$\(\([\s\S]+)\)\)/,
                                lookbehind: true
                            },
                            /^\$\(\(/
                        ],
                        number: /\b0x[\dA-Fa-f]+\b|(?:\b\d+(?:\.\d*)?|\B\.\d+)(?:[Ee]-?\d+)?/,
                        // Operators according to https://www.gnu.org/software/bash/manual/bashref.html#Shell-Arithmetic
                        operator: /--|\+\+|\*\*=?|<<=?|>>=?|&&|\|\||[=!+\-*/%<>^&|]=?|[?~:]/,
                        // If there is no $ sign at the beginning highlight (( and )) as punctuation
                        punctuation: /\(\(?|\)\)?|,|;/
                    }
                },
                {
                    pattern: /\$\((?:\([^)]+\)|[^()])+\)|`[^`]+`/,
                    greedy: true,
                    inside: {
                        variable: /^\$\(|^`|\)$|`$/
                    }
                },
                {
                    pattern: /\$\{[^}]+\}/,
                    greedy: true,
                    inside: {
                        operator: /:[-=?+]?|[!\/]|##?|%%?|\^\^?|,,?/,
                        punctuation: /[\[\]]/,
                        environment: {
                            pattern: RegExp('(\\{)' + envVars),
                            lookbehind: true,
                            alias: 'constant'
                        }
                    }
                },
                /\$(?:\w+|[#?*!@$])/
            ],
            // Escape sequences from echo and printf's manuals, and escaped quotes.
            entity: /\\(?:[abceEfnrtv\\"]|O?[0-7]{1,3}|U[0-9a-fA-F]{8}|u[0-9a-fA-F]{4}|x[0-9a-fA-F]{1,2})/
        };
        Prism.languages.bash = {
            shebang: {
                pattern: /^#!\s*\/.*/,
                alias: 'important'
            },
            comment: {
                pattern: /(^|[^"{\\$])#.*/,
                lookbehind: true
            },
            'function-name': [
                // a) function foo {
                // b) foo() {
                // c) function foo() {
                // but not “foo {”
                {
                    // a) and c)
                    pattern: /(\bfunction\s+)[\w-]+(?=(?:\s*\(?:\s*\))?\s*\{)/,
                    lookbehind: true,
                    alias: 'function'
                },
                {
                    // b)
                    pattern: /\b[\w-]+(?=\s*\(\s*\)\s*\{)/,
                    alias: 'function'
                }
            ],
            // Highlight variable names as variables in for and select beginnings.
            'for-or-select': {
                pattern: /(\b(?:for|select)\s+)\w+(?=\s+in\s)/,
                alias: 'variable',
                lookbehind: true
            },
            // Highlight variable names as variables in the left-hand part
            // of assignments (“=” and “+=”).
            'assign-left': {
                pattern: /(^|[\s;|&]|[<>]\()\w+(?=\+?=)/,
                inside: {
                    environment: {
                        pattern: RegExp('(^|[\\s;|&]|[<>]\\()' + envVars),
                        lookbehind: true,
                        alias: 'constant'
                    }
                },
                alias: 'variable',
                lookbehind: true
            },
            string: [
                // Support for Here-documents https://en.wikipedia.org/wiki/Here_document
                {
                    pattern: /((?:^|[^<])<<-?\s*)(\w+)\s[\s\S]*?(?:\r?\n|\r)\2/,
                    lookbehind: true,
                    greedy: true,
                    inside: insideString
                },
                // → No expansion (so no “inside”).
                {
                    pattern: /((?:^|[^<])<<-?\s*)(["'])(\w+)\2\s[\s\S]*?(?:\r?\n|\r)\3/,
                    lookbehind: true,
                    greedy: true,
                    inside: {
                        bash: commandAfterHeredoc
                    }
                },
                {
                    // https://www.gnu.org/software/bash/manual/html_node/Double-Quotes.html
                    pattern: /(^|[^\\](?:\\\\)*)"(?:\\[\s\S]|\$\([^)]+\)|\$(?!\()|`[^`]+`|[^"\\`$])*"/,
                    lookbehind: true,
                    greedy: true,
                    inside: insideString
                },
                {
                    // https://www.gnu.org/software/bash/manual/html_node/Single-Quotes.html
                    pattern: /(^|[^$\\])'[^']*'/,
                    lookbehind: true,
                    greedy: true
                },
                {
                    // https://www.gnu.org/software/bash/manual/html_node/ANSI_002dC-Quoting.html
                    pattern: /\$'(?:[^'\\]|\\[\s\S])*'/,
                    greedy: true,
                    inside: {
                        entity: insideString.entity
                    }
                }
            ],
            environment: {
                pattern: RegExp('\\$?' + envVars),
                alias: 'constant'
            },
            variable: insideString.variable,
            function: {
                pattern: /(^|[\s;|&]|[<>]\()(?:add|apropos|apt|apt-cache|apt-get|aptitude|aspell|automysqlbackup|awk|basename|bash|bc|bconsole|bg|bzip2|cal|cat|cfdisk|chgrp|chkconfig|chmod|chown|chroot|cksum|clear|cmp|column|comm|composer|cp|cron|crontab|csplit|curl|cut|date|dc|dd|ddrescue|debootstrap|df|diff|diff3|dig|dir|dircolors|dirname|dirs|dmesg|docker|docker-compose|du|egrep|eject|env|ethtool|expand|expect|expr|fdformat|fdisk|fg|fgrep|file|find|fmt|fold|format|free|fsck|ftp|fuser|gawk|git|gparted|grep|groupadd|groupdel|groupmod|groups|grub-mkconfig|gzip|halt|head|hg|history|host|hostname|htop|iconv|id|ifconfig|ifdown|ifup|import|install|ip|jobs|join|kill|killall|less|link|ln|locate|logname|logrotate|look|lpc|lpr|lprint|lprintd|lprintq|lprm|ls|lsof|lynx|make|man|mc|mdadm|mkconfig|mkdir|mke2fs|mkfifo|mkfs|mkisofs|mknod|mkswap|mmv|more|most|mount|mtools|mtr|mutt|mv|nano|nc|netstat|nice|nl|node|nohup|notify-send|npm|nslookup|op|open|parted|passwd|paste|pathchk|ping|pkill|pnpm|podman|podman-compose|popd|pr|printcap|printenv|ps|pushd|pv|quota|quotacheck|quotactl|ram|rar|rcp|reboot|remsync|rename|renice|rev|rm|rmdir|rpm|rsync|scp|screen|sdiff|sed|sendmail|seq|service|sftp|sh|shellcheck|shuf|shutdown|sleep|slocate|sort|split|ssh|stat|strace|su|sudo|sum|suspend|swapon|sync|tac|tail|tar|tee|time|timeout|top|touch|tr|traceroute|tsort|tty|umount|uname|unexpand|uniq|units|unrar|unshar|unzip|update-grub|uptime|useradd|userdel|usermod|users|uudecode|uuencode|v|vcpkg|vdir|vi|vim|virsh|vmstat|wait|watch|wc|wget|whereis|which|who|whoami|write|xargs|xdg-open|yarn|yes|zenity|zip|zsh|zypper)(?=$|[)\s;|&])/,
                lookbehind: true
            },
            keyword: {
                pattern: /(^|[\s;|&]|[<>]\()(?:case|do|done|elif|else|esac|fi|for|function|if|in|select|then|until|while)(?=$|[)\s;|&])/,
                lookbehind: true
            },
            // https://www.gnu.org/software/bash/manual/html_node/Shell-Builtin-Commands.html
            builtin: {
                pattern: /(^|[\s;|&]|[<>]\()(?:\.|:|alias|bind|break|builtin|caller|cd|command|continue|declare|echo|enable|eval|exec|exit|export|getopts|hash|help|let|local|logout|mapfile|printf|pwd|read|readarray|readonly|return|set|shift|shopt|source|test|times|trap|type|typeset|ulimit|umask|unalias|unset)(?=$|[)\s;|&])/,
                lookbehind: true,
                // Alias added to make those easier to distinguish from strings.
                alias: 'class-name'
            },
            boolean: {
                pattern: /(^|[\s;|&]|[<>]\()(?:false|true)(?=$|[)\s;|&])/,
                lookbehind: true
            },
            'file-descriptor': {
                pattern: /\B&\d\b/,
                alias: 'important'
            },
            operator: {
                // Lots of redirections here, but not just that.
                pattern: /\d?<>|>\||\+=|=[=~]?|!=?|<<[<-]?|[&\d]?>>|\d[<>]&?|[<>][&=]?|&[>&]?|\|[&|]?/,
                inside: {
                    'file-descriptor': {
                        pattern: /^\d/,
                        alias: 'important'
                    }
                }
            },
            punctuation: /\$?\(\(?|\)\)?|\.\.|[{}[\];\\]/,
            number: {
                pattern: /(^|\s)(?:[1-9]\d*|0)(?:[.,]\d+)?\b/,
                lookbehind: true
            }
        };
        commandAfterHeredoc.inside = Prism.languages.bash;
        /* Patterns in command substitution. */ var toBeCopied = [
            'comment',
            'function-name',
            'for-or-select',
            'assign-left',
            'string',
            'environment',
            'function',
            'keyword',
            'builtin',
            'boolean',
            'file-descriptor',
            'operator',
            'punctuation',
            'number'
        ];
        var inside = insideString.variable[1].inside;
        for(var i = 0; i < toBeCopied.length; i++)inside[toBeCopied[i]] = Prism.languages.bash[toBeCopied[i]];
        Prism.languages.shell = Prism.languages.bash;
    })(Prism);
}

});

parcelRegister("dzave", function(module, exports) {
'use strict';
module.exports = $9e06b0def5df738e$var$basic;
$9e06b0def5df738e$var$basic.displayName = 'basic';
$9e06b0def5df738e$var$basic.aliases = [];
function $9e06b0def5df738e$var$basic(Prism) {
    Prism.languages.basic = {
        comment: {
            pattern: /(?:!|REM\b).+/i,
            inside: {
                keyword: /^REM/i
            }
        },
        string: {
            pattern: /"(?:""|[!#$%&'()*,\/:;<=>?^\w +\-.])*"/,
            greedy: true
        },
        number: /(?:\b\d+(?:\.\d*)?|\B\.\d+)(?:E[+-]?\d+)?/i,
        keyword: /\b(?:AS|BEEP|BLOAD|BSAVE|CALL(?: ABSOLUTE)?|CASE|CHAIN|CHDIR|CLEAR|CLOSE|CLS|COM|COMMON|CONST|DATA|DECLARE|DEF(?: FN| SEG|DBL|INT|LNG|SNG|STR)|DIM|DO|DOUBLE|ELSE|ELSEIF|END|ENVIRON|ERASE|ERROR|EXIT|FIELD|FILES|FOR|FUNCTION|GET|GOSUB|GOTO|IF|INPUT|INTEGER|IOCTL|KEY|KILL|LINE INPUT|LOCATE|LOCK|LONG|LOOP|LSET|MKDIR|NAME|NEXT|OFF|ON(?: COM| ERROR| KEY| TIMER)?|OPEN|OPTION BASE|OUT|POKE|PUT|READ|REDIM|REM|RESTORE|RESUME|RETURN|RMDIR|RSET|RUN|SELECT CASE|SHARED|SHELL|SINGLE|SLEEP|STATIC|STEP|STOP|STRING|SUB|SWAP|SYSTEM|THEN|TIMER|TO|TROFF|TRON|TYPE|UNLOCK|UNTIL|USING|VIEW PRINT|WAIT|WEND|WHILE|WRITE)(?:\$|\b)/i,
        function: /\b(?:ABS|ACCESS|ACOS|ANGLE|AREA|ARITHMETIC|ARRAY|ASIN|ASK|AT|ATN|BASE|BEGIN|BREAK|CAUSE|CEIL|CHR|CLIP|COLLATE|COLOR|CON|COS|COSH|COT|CSC|DATE|DATUM|DEBUG|DECIMAL|DEF|DEG|DEGREES|DELETE|DET|DEVICE|DISPLAY|DOT|ELAPSED|EPS|ERASABLE|EXLINE|EXP|EXTERNAL|EXTYPE|FILETYPE|FIXED|FP|GO|GRAPH|HANDLER|IDN|IMAGE|IN|INT|INTERNAL|IP|IS|KEYED|LBOUND|LCASE|LEFT|LEN|LENGTH|LET|LINE|LINES|LOG|LOG10|LOG2|LTRIM|MARGIN|MAT|MAX|MAXNUM|MID|MIN|MISSING|MOD|NATIVE|NUL|NUMERIC|OF|OPTION|ORD|ORGANIZATION|OUTIN|OUTPUT|PI|POINT|POINTER|POINTS|POS|PRINT|PROGRAM|PROMPT|RAD|RADIANS|RANDOMIZE|RECORD|RECSIZE|RECTYPE|RELATIVE|REMAINDER|REPEAT|REST|RETRY|REWRITE|RIGHT|RND|ROUND|RTRIM|SAME|SEC|SELECT|SEQUENTIAL|SET|SETTER|SGN|SIN|SINH|SIZE|SKIP|SQR|STANDARD|STATUS|STR|STREAM|STYLE|TAB|TAN|TANH|TEMPLATE|TEXT|THERE|TIME|TIMEOUT|TRACE|TRANSFORM|TRUNCATE|UBOUND|UCASE|USE|VAL|VARIABLE|VIEWPORT|WHEN|WINDOW|WITH|ZER|ZONEWIDTH)(?:\$|\b)/i,
        operator: /<[=>]?|>=?|[+\-*\/^=&]|\b(?:AND|EQV|IMP|NOT|OR|XOR)\b/i,
        punctuation: /[,;:()]/
    };
}

});

parcelRegister("3JA2F", function(module, exports) {
'use strict';
module.exports = $2b8188429327795d$var$batch;
$2b8188429327795d$var$batch.displayName = 'batch';
$2b8188429327795d$var$batch.aliases = [];
function $2b8188429327795d$var$batch(Prism) {
    (function(Prism) {
        var variable = /%%?[~:\w]+%?|!\S+!/;
        var parameter = {
            pattern: /\/[a-z?]+(?=[ :]|$):?|-[a-z]\b|--[a-z-]+\b/im,
            alias: 'attr-name',
            inside: {
                punctuation: /:/
            }
        };
        var string = /"(?:[\\"]"|[^"])*"(?!")/;
        var number = /(?:\b|-)\d+\b/;
        Prism.languages.batch = {
            comment: [
                /^::.*/m,
                {
                    pattern: /((?:^|[&(])[ \t]*)rem\b(?:[^^&)\r\n]|\^(?:\r\n|[\s\S]))*/im,
                    lookbehind: true
                }
            ],
            label: {
                pattern: /^:.*/m,
                alias: 'property'
            },
            command: [
                {
                    // FOR command
                    pattern: /((?:^|[&(])[ \t]*)for(?: \/[a-z?](?:[ :](?:"[^"]*"|[^\s"/]\S*))?)* \S+ in \([^)]+\) do/im,
                    lookbehind: true,
                    inside: {
                        keyword: /\b(?:do|in)\b|^for\b/i,
                        string: string,
                        parameter: parameter,
                        variable: variable,
                        number: number,
                        punctuation: /[()',]/
                    }
                },
                {
                    // IF command
                    pattern: /((?:^|[&(])[ \t]*)if(?: \/[a-z?](?:[ :](?:"[^"]*"|[^\s"/]\S*))?)* (?:not )?(?:cmdextversion \d+|defined \w+|errorlevel \d+|exist \S+|(?:"[^"]*"|(?!")(?:(?!==)\S)+)?(?:==| (?:equ|geq|gtr|leq|lss|neq) )(?:"[^"]*"|[^\s"]\S*))/im,
                    lookbehind: true,
                    inside: {
                        keyword: /\b(?:cmdextversion|defined|errorlevel|exist|not)\b|^if\b/i,
                        string: string,
                        parameter: parameter,
                        variable: variable,
                        number: number,
                        operator: /\^|==|\b(?:equ|geq|gtr|leq|lss|neq)\b/i
                    }
                },
                {
                    // ELSE command
                    pattern: /((?:^|[&()])[ \t]*)else\b/im,
                    lookbehind: true,
                    inside: {
                        keyword: /^else\b/i
                    }
                },
                {
                    // SET command
                    pattern: /((?:^|[&(])[ \t]*)set(?: \/[a-z](?:[ :](?:"[^"]*"|[^\s"/]\S*))?)* (?:[^^&)\r\n]|\^(?:\r\n|[\s\S]))*/im,
                    lookbehind: true,
                    inside: {
                        keyword: /^set\b/i,
                        string: string,
                        parameter: parameter,
                        variable: [
                            variable,
                            /\w+(?=(?:[*\/%+\-&^|]|<<|>>)?=)/
                        ],
                        number: number,
                        operator: /[*\/%+\-&^|]=?|<<=?|>>=?|[!~_=]/,
                        punctuation: /[()',]/
                    }
                },
                {
                    // Other commands
                    pattern: /((?:^|[&(])[ \t]*@?)\w+\b(?:"(?:[\\"]"|[^"])*"(?!")|[^"^&)\r\n]|\^(?:\r\n|[\s\S]))*/m,
                    lookbehind: true,
                    inside: {
                        keyword: /^\w+\b/,
                        string: string,
                        parameter: parameter,
                        label: {
                            pattern: /(^\s*):\S+/m,
                            lookbehind: true,
                            alias: 'property'
                        },
                        variable: variable,
                        number: number,
                        operator: /\^/
                    }
                }
            ],
            operator: /[&@]/,
            punctuation: /[()']/
        };
    })(Prism);
}

});

parcelRegister("1LS19", function(module, exports) {
'use strict';
module.exports = $14a414f9e1b8a0c3$var$bbcode;
$14a414f9e1b8a0c3$var$bbcode.displayName = 'bbcode';
$14a414f9e1b8a0c3$var$bbcode.aliases = [
    'shortcode'
];
function $14a414f9e1b8a0c3$var$bbcode(Prism) {
    Prism.languages.bbcode = {
        tag: {
            pattern: /\[\/?[^\s=\]]+(?:\s*=\s*(?:"[^"]*"|'[^']*'|[^\s'"\]=]+))?(?:\s+[^\s=\]]+\s*=\s*(?:"[^"]*"|'[^']*'|[^\s'"\]=]+))*\s*\]/,
            inside: {
                tag: {
                    pattern: /^\[\/?[^\s=\]]+/,
                    inside: {
                        punctuation: /^\[\/?/
                    }
                },
                'attr-value': {
                    pattern: /=\s*(?:"[^"]*"|'[^']*'|[^\s'"\]=]+)/,
                    inside: {
                        punctuation: [
                            /^=/,
                            {
                                pattern: /^(\s*)["']|["']$/,
                                lookbehind: true
                            }
                        ]
                    }
                },
                punctuation: /\]/,
                'attr-name': /[^\s=\]]+/
            }
        }
    };
    Prism.languages.shortcode = Prism.languages.bbcode;
}

});

parcelRegister("4fsTq", function(module, exports) {
'use strict';
module.exports = $317ef9adb82c5f75$var$bicep;
$317ef9adb82c5f75$var$bicep.displayName = 'bicep';
$317ef9adb82c5f75$var$bicep.aliases = [];
function $317ef9adb82c5f75$var$bicep(Prism) {
    // based loosely upon: https://github.com/Azure/bicep/blob/main/src/textmate/bicep.tmlanguage
    Prism.languages.bicep = {
        comment: [
            {
                // multiline comments eg /* ASDF */
                pattern: /(^|[^\\])\/\*[\s\S]*?(?:\*\/|$)/,
                lookbehind: true,
                greedy: true
            },
            {
                // singleline comments eg // ASDF
                pattern: /(^|[^\\:])\/\/.*/,
                lookbehind: true,
                greedy: true
            }
        ],
        property: [
            {
                pattern: /([\r\n][ \t]*)[a-z_]\w*(?=[ \t]*:)/i,
                lookbehind: true
            },
            {
                pattern: /([\r\n][ \t]*)'(?:\\.|\$(?!\{)|[^'\\\r\n$])*'(?=[ \t]*:)/,
                lookbehind: true,
                greedy: true
            }
        ],
        string: [
            {
                pattern: /'''[^'][\s\S]*?'''/,
                greedy: true
            },
            {
                pattern: /(^|[^\\'])'(?:\\.|\$(?!\{)|[^'\\\r\n$])*'/,
                lookbehind: true,
                greedy: true
            }
        ],
        'interpolated-string': {
            pattern: /(^|[^\\'])'(?:\\.|\$(?:(?!\{)|\{[^{}\r\n]*\})|[^'\\\r\n$])*'/,
            lookbehind: true,
            greedy: true,
            inside: {
                interpolation: {
                    pattern: /\$\{[^{}\r\n]*\}/,
                    inside: {
                        expression: {
                            pattern: /(^\$\{)[\s\S]+(?=\}$)/,
                            lookbehind: true
                        },
                        punctuation: /^\$\{|\}$/
                    }
                },
                string: /[\s\S]+/
            }
        },
        datatype: {
            pattern: /(\b(?:output|param)\b[ \t]+\w+[ \t]+)\w+\b/,
            lookbehind: true,
            alias: 'class-name'
        },
        boolean: /\b(?:false|true)\b/,
        // https://github.com/Azure/bicep/blob/114a3251b4e6e30082a58729f19a8cc4e374ffa6/src/textmate/bicep.tmlanguage#L184
        keyword: /\b(?:existing|for|if|in|module|null|output|param|resource|targetScope|var)\b/,
        decorator: /@\w+\b/,
        function: /\b[a-z_]\w*(?=[ \t]*\()/i,
        number: /(?:\b\d+(?:\.\d*)?|\B\.\d+)(?:E[+-]?\d+)?/i,
        operator: /--|\+\+|\*\*=?|=>|&&=?|\|\|=?|[!=]==|<<=?|>>>?=?|[-+*/%&|^!=<>]=?|\.{3}|\?\?=?|\?\.?|[~:]/,
        punctuation: /[{}[\];(),.:]/
    };
    Prism.languages.bicep['interpolated-string'].inside['interpolation'].inside['expression'].inside = Prism.languages.bicep;
}

});

parcelRegister("h0Bo3", function(module, exports) {
'use strict';
module.exports = $c61f70054fb0d9d7$var$birb;
$c61f70054fb0d9d7$var$birb.displayName = 'birb';
$c61f70054fb0d9d7$var$birb.aliases = [];
function $c61f70054fb0d9d7$var$birb(Prism) {
    Prism.languages.birb = Prism.languages.extend('clike', {
        string: {
            pattern: /r?("|')(?:\\.|(?!\1)[^\\])*\1/,
            greedy: true
        },
        'class-name': [
            /\b[A-Z](?:[\d_]*[a-zA-Z]\w*)?\b/,
            /\b(?:[A-Z]\w*|(?!(?:var|void)\b)[a-z]\w*)(?=\s+\w+\s*[;,=()])/
        ],
        keyword: /\b(?:assert|break|case|class|const|default|else|enum|final|follows|for|grab|if|nest|new|next|noSeeb|return|static|switch|throw|var|void|while)\b/,
        operator: /\+\+|--|&&|\|\||<<=?|>>=?|~(?:\/=?)?|[+\-*\/%&^|=!<>]=?|\?|:/,
        variable: /\b[a-z_]\w*\b/
    });
    Prism.languages.insertBefore('birb', 'function', {
        metadata: {
            pattern: /<\w+>/,
            greedy: true,
            alias: 'symbol'
        }
    });
}

});

parcelRegister("ltfJv", function(module, exports) {
'use strict';

var $c6Wvp = parcelRequire("c6Wvp");
module.exports = $fa1882a70da92415$var$bison;
$fa1882a70da92415$var$bison.displayName = 'bison';
$fa1882a70da92415$var$bison.aliases = [];
function $fa1882a70da92415$var$bison(Prism) {
    Prism.register($c6Wvp);
    Prism.languages.bison = Prism.languages.extend('c', {});
    Prism.languages.insertBefore('bison', 'comment', {
        bison: {
            // This should match all the beginning of the file
            // including the prologue(s), the bison declarations and
            // the grammar rules.
            pattern: /^(?:[^%]|%(?!%))*%%[\s\S]*?%%/,
            inside: {
                c: {
                    // Allow for one level of nested braces
                    pattern: /%\{[\s\S]*?%\}|\{(?:\{[^}]*\}|[^{}])*\}/,
                    inside: {
                        delimiter: {
                            pattern: /^%?\{|%?\}$/,
                            alias: 'punctuation'
                        },
                        'bison-variable': {
                            pattern: /[$@](?:<[^\s>]+>)?[\w$]+/,
                            alias: 'variable',
                            inside: {
                                punctuation: /<|>/
                            }
                        },
                        rest: Prism.languages.c
                    }
                },
                comment: Prism.languages.c.comment,
                string: Prism.languages.c.string,
                property: /\S+(?=:)/,
                keyword: /%\w+/,
                number: {
                    pattern: /(^|[^@])\b(?:0x[\da-f]+|\d+)/i,
                    lookbehind: true
                },
                punctuation: /%[%?]|[|:;\[\]<>]/
            }
        }
    });
}

});

parcelRegister("jCr9w", function(module, exports) {
'use strict';
module.exports = $e486a0e3b8919f38$var$bnf;
$e486a0e3b8919f38$var$bnf.displayName = 'bnf';
$e486a0e3b8919f38$var$bnf.aliases = [
    'rbnf'
];
function $e486a0e3b8919f38$var$bnf(Prism) {
    Prism.languages.bnf = {
        string: {
            pattern: /"[^\r\n"]*"|'[^\r\n']*'/
        },
        definition: {
            pattern: /<[^<>\r\n\t]+>(?=\s*::=)/,
            alias: [
                'rule',
                'keyword'
            ],
            inside: {
                punctuation: /^<|>$/
            }
        },
        rule: {
            pattern: /<[^<>\r\n\t]+>/,
            inside: {
                punctuation: /^<|>$/
            }
        },
        operator: /::=|[|()[\]{}*+?]|\.{3}/
    };
    Prism.languages.rbnf = Prism.languages.bnf;
}

});

parcelRegister("fKsqK", function(module, exports) {
'use strict';
module.exports = $b77134922ecea6c1$var$brainfuck;
$b77134922ecea6c1$var$brainfuck.displayName = 'brainfuck';
$b77134922ecea6c1$var$brainfuck.aliases = [];
function $b77134922ecea6c1$var$brainfuck(Prism) {
    Prism.languages.brainfuck = {
        pointer: {
            pattern: /<|>/,
            alias: 'keyword'
        },
        increment: {
            pattern: /\+/,
            alias: 'inserted'
        },
        decrement: {
            pattern: /-/,
            alias: 'deleted'
        },
        branching: {
            pattern: /\[|\]/,
            alias: 'important'
        },
        operator: /[.,]/,
        comment: /\S+/
    };
}

});

parcelRegister("2zD35", function(module, exports) {
'use strict';
module.exports = $1dfd23e83c3c27ba$var$brightscript;
$1dfd23e83c3c27ba$var$brightscript.displayName = 'brightscript';
$1dfd23e83c3c27ba$var$brightscript.aliases = [];
function $1dfd23e83c3c27ba$var$brightscript(Prism) {
    Prism.languages.brightscript = {
        comment: /(?:\brem|').*/i,
        'directive-statement': {
            pattern: /(^[\t ]*)#(?:const|else(?:[\t ]+if)?|end[\t ]+if|error|if).*/im,
            lookbehind: true,
            alias: 'property',
            inside: {
                'error-message': {
                    pattern: /(^#error).+/,
                    lookbehind: true
                },
                directive: {
                    pattern: /^#(?:const|else(?:[\t ]+if)?|end[\t ]+if|error|if)/,
                    alias: 'keyword'
                },
                expression: {
                    pattern: /[\s\S]+/,
                    inside: null // see below
                }
            }
        },
        property: {
            pattern: /([\r\n{,][\t ]*)(?:(?!\d)\w+|"(?:[^"\r\n]|"")*"(?!"))(?=[ \t]*:)/,
            lookbehind: true,
            greedy: true
        },
        string: {
            pattern: /"(?:[^"\r\n]|"")*"(?!")/,
            greedy: true
        },
        'class-name': {
            pattern: /(\bAs[\t ]+)\w+/i,
            lookbehind: true
        },
        keyword: /\b(?:As|Dim|Each|Else|Elseif|End|Exit|For|Function|Goto|If|In|Print|Return|Step|Stop|Sub|Then|To|While)\b/i,
        boolean: /\b(?:false|true)\b/i,
        function: /\b(?!\d)\w+(?=[\t ]*\()/,
        number: /(?:\b\d+(?:\.\d+)?(?:[ed][+-]\d+)?|&h[a-f\d]+)\b[%&!#]?/i,
        operator: /--|\+\+|>>=?|<<=?|<>|[-+*/\\<>]=?|[:^=?]|\b(?:and|mod|not|or)\b/i,
        punctuation: /[.,;()[\]{}]/,
        constant: /\b(?:LINE_NUM)\b/i
    };
    Prism.languages.brightscript['directive-statement'].inside.expression.inside = Prism.languages.brightscript;
}

});

parcelRegister("dYSlH", function(module, exports) {
'use strict';
module.exports = $a2db0989fd81c617$var$bro;
$a2db0989fd81c617$var$bro.displayName = 'bro';
$a2db0989fd81c617$var$bro.aliases = [];
function $a2db0989fd81c617$var$bro(Prism) {
    Prism.languages.bro = {
        comment: {
            pattern: /(^|[^\\$])#.*/,
            lookbehind: true,
            inside: {
                italic: /\b(?:FIXME|TODO|XXX)\b/
            }
        },
        string: {
            pattern: /(["'])(?:\\(?:\r\n|[\s\S])|(?!\1)[^\\\r\n])*\1/,
            greedy: true
        },
        boolean: /\b[TF]\b/,
        function: {
            pattern: /(\b(?:event|function|hook)[ \t]+)\w+(?:::\w+)?/,
            lookbehind: true
        },
        builtin: /(?:@(?:load(?:-(?:plugin|sigs))?|unload|prefixes|ifn?def|else|(?:end)?if|DIR|FILENAME))|(?:&?(?:add_func|create_expire|default|delete_func|encrypt|error_handler|expire_func|group|log|mergeable|optional|persistent|priority|raw_output|read_expire|redef|rotate_interval|rotate_size|synchronized|type_column|write_expire))/,
        constant: {
            pattern: /(\bconst[ \t]+)\w+/i,
            lookbehind: true
        },
        keyword: /\b(?:add|addr|alarm|any|bool|break|const|continue|count|delete|double|else|enum|event|export|file|for|function|global|hook|if|in|int|interval|local|module|next|of|opaque|pattern|port|print|record|return|schedule|set|string|subnet|table|time|timeout|using|vector|when)\b/,
        operator: /--?|\+\+?|!=?=?|<=?|>=?|==?=?|&&|\|\|?|\?|\*|\/|~|\^|%/,
        number: /\b0x[\da-f]+\b|(?:\b\d+(?:\.\d*)?|\B\.\d+)(?:e[+-]?\d+)?/i,
        punctuation: /[{}[\];(),.:]/
    };
}

});

parcelRegister("kW91c", function(module, exports) {
'use strict';
module.exports = $f3e03842699e554d$var$bsl;
$f3e03842699e554d$var$bsl.displayName = 'bsl';
$f3e03842699e554d$var$bsl.aliases = [];
function $f3e03842699e554d$var$bsl(Prism) {
    /* eslint-disable no-misleading-character-class */ // 1C:Enterprise
    // https://github.com/Diversus23/
    //
    Prism.languages.bsl = {
        comment: /\/\/.*/,
        string: [
            // Строки
            // Strings
            {
                pattern: /"(?:[^"]|"")*"(?!")/,
                greedy: true
            },
            // Date & time
            {
                pattern: /'(?:[^'\r\n\\]|\\.)*'/
            }
        ],
        keyword: [
            {
                // RU
                pattern: /(^|[^\w\u0400-\u0484\u0487-\u052f\u1d2b\u1d78\u2de0-\u2dff\ua640-\ua69f\ufe2e\ufe2f])(?:пока|для|новый|прервать|попытка|исключение|вызватьисключение|иначе|конецпопытки|неопределено|функция|перем|возврат|конецфункции|если|иначеесли|процедура|конецпроцедуры|тогда|знач|экспорт|конецесли|из|каждого|истина|ложь|по|цикл|конеццикла|выполнить)(?![\w\u0400-\u0484\u0487-\u052f\u1d2b\u1d78\u2de0-\u2dff\ua640-\ua69f\ufe2e\ufe2f])/i,
                lookbehind: true
            },
            {
                // EN
                pattern: /\b(?:break|do|each|else|elseif|enddo|endfunction|endif|endprocedure|endtry|except|execute|export|false|for|function|if|in|new|null|procedure|raise|return|then|to|true|try|undefined|val|var|while)\b/i
            }
        ],
        number: {
            pattern: /(^(?=\d)|[^\w\u0400-\u0484\u0487-\u052f\u1d2b\u1d78\u2de0-\u2dff\ua640-\ua69f\ufe2e\ufe2f])(?:\d+(?:\.\d*)?|\.\d+)(?:E[+-]?\d+)?/i,
            lookbehind: true
        },
        operator: [
            /[<>+\-*/]=?|[%=]/,
            {
                pattern: /(^|[^\w\u0400-\u0484\u0487-\u052f\u1d2b\u1d78\u2de0-\u2dff\ua640-\ua69f\ufe2e\ufe2f])(?:и|или|не)(?![\w\u0400-\u0484\u0487-\u052f\u1d2b\u1d78\u2de0-\u2dff\ua640-\ua69f\ufe2e\ufe2f])/i,
                lookbehind: true
            },
            {
                pattern: /\b(?:and|not|or)\b/i
            }
        ],
        punctuation: /\(\.|\.\)|[()\[\]:;,.]/,
        directive: [
            // Теги препроцессора вида &Клиент, &Сервер, ...
            // Preprocessor tags of the type &Client, &Server, ...
            {
                pattern: /^([ \t]*)&.*/m,
                lookbehind: true,
                greedy: true,
                alias: 'important'
            },
            // #Если Сервер Тогда
            // ...
            // #КонецЕсли
            // Preprocessor instructions of the form:
            // #If Server Then
            // ...
            // #EndIf
            {
                pattern: /^([ \t]*)#.*/gm,
                lookbehind: true,
                greedy: true,
                alias: 'important'
            }
        ]
    };
    Prism.languages.oscript = Prism.languages['bsl'];
}

});

parcelRegister("9BRi5", function(module, exports) {
'use strict';
module.exports = $6ff0e8338bd345cc$var$cfscript;
$6ff0e8338bd345cc$var$cfscript.displayName = 'cfscript';
$6ff0e8338bd345cc$var$cfscript.aliases = [];
function $6ff0e8338bd345cc$var$cfscript(Prism) {
    // https://cfdocs.org/script
    Prism.languages.cfscript = Prism.languages.extend('clike', {
        comment: [
            {
                pattern: /(^|[^\\])\/\*[\s\S]*?(?:\*\/|$)/,
                lookbehind: true,
                inside: {
                    annotation: {
                        pattern: /(?:^|[^.])@[\w\.]+/,
                        alias: 'punctuation'
                    }
                }
            },
            {
                pattern: /(^|[^\\:])\/\/.*/,
                lookbehind: true,
                greedy: true
            }
        ],
        keyword: /\b(?:abstract|break|catch|component|continue|default|do|else|extends|final|finally|for|function|if|in|include|package|private|property|public|remote|required|rethrow|return|static|switch|throw|try|var|while|xml)\b(?!\s*=)/,
        operator: [
            /\+\+|--|&&|\|\||::|=>|[!=]==|<=?|>=?|[-+*/%&|^!=<>]=?|\?(?:\.|:)?|[?:]/,
            /\b(?:and|contains|eq|equal|eqv|gt|gte|imp|is|lt|lte|mod|not|or|xor)\b/
        ],
        scope: {
            pattern: /\b(?:application|arguments|cgi|client|cookie|local|session|super|this|variables)\b/,
            alias: 'global'
        },
        type: {
            pattern: /\b(?:any|array|binary|boolean|date|guid|numeric|query|string|struct|uuid|void|xml)\b/,
            alias: 'builtin'
        }
    });
    Prism.languages.insertBefore('cfscript', 'keyword', {
        // This must be declared before keyword because we use "function" inside the lookahead
        'function-variable': {
            pattern: /[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*(?=\s*[=:]\s*(?:\bfunction\b|(?:\((?:[^()]|\([^()]*\))*\)|(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*)\s*=>))/,
            alias: 'function'
        }
    });
    delete Prism.languages.cfscript['class-name'];
    Prism.languages.cfc = Prism.languages['cfscript'];
}

});

parcelRegister("dSVGO", function(module, exports) {
'use strict';

var $4TKG9 = parcelRequire("4TKG9");
module.exports = $a1bd11765c3278d3$var$chaiscript;
$a1bd11765c3278d3$var$chaiscript.displayName = 'chaiscript';
$a1bd11765c3278d3$var$chaiscript.aliases = [];
function $a1bd11765c3278d3$var$chaiscript(Prism) {
    Prism.register($4TKG9);
    Prism.languages.chaiscript = Prism.languages.extend('clike', {
        string: {
            pattern: /(^|[^\\])'(?:[^'\\]|\\[\s\S])*'/,
            lookbehind: true,
            greedy: true
        },
        'class-name': [
            {
                // e.g. class Rectangle { ... }
                pattern: /(\bclass\s+)\w+/,
                lookbehind: true
            },
            {
                // e.g. attr Rectangle::height, def Rectangle::area() { ... }
                pattern: /(\b(?:attr|def)\s+)\w+(?=\s*::)/,
                lookbehind: true
            }
        ],
        keyword: /\b(?:attr|auto|break|case|catch|class|continue|def|default|else|finally|for|fun|global|if|return|switch|this|try|var|while)\b/,
        number: [
            Prism.languages.cpp.number,
            /\b(?:Infinity|NaN)\b/
        ],
        operator: />>=?|<<=?|\|\||&&|:[:=]?|--|\+\+|[=!<>+\-*/%|&^]=?|[?~]|`[^`\r\n]{1,4}`/
    });
    Prism.languages.insertBefore('chaiscript', 'operator', {
        'parameter-type': {
            // e.g. def foo(int x, Vector y) {...}
            pattern: /([,(]\s*)\w+(?=\s+\w)/,
            lookbehind: true,
            alias: 'class-name'
        }
    });
    Prism.languages.insertBefore('chaiscript', 'string', {
        'string-interpolation': {
            pattern: /(^|[^\\])"(?:[^"$\\]|\\[\s\S]|\$(?!\{)|\$\{(?:[^{}]|\{(?:[^{}]|\{[^{}]*\})*\})*\})*"/,
            lookbehind: true,
            greedy: true,
            inside: {
                interpolation: {
                    pattern: /((?:^|[^\\])(?:\\{2})*)\$\{(?:[^{}]|\{(?:[^{}]|\{[^{}]*\})*\})*\}/,
                    lookbehind: true,
                    inside: {
                        'interpolation-expression': {
                            pattern: /(^\$\{)[\s\S]+(?=\}$)/,
                            lookbehind: true,
                            inside: Prism.languages.chaiscript
                        },
                        'interpolation-punctuation': {
                            pattern: /^\$\{|\}$/,
                            alias: 'punctuation'
                        }
                    }
                },
                string: /[\s\S]+/
            }
        }
    });
}

});

parcelRegister("3A63E", function(module, exports) {
'use strict';
module.exports = $29b96ee1c6f91d63$var$cil;
$29b96ee1c6f91d63$var$cil.displayName = 'cil';
$29b96ee1c6f91d63$var$cil.aliases = [];
function $29b96ee1c6f91d63$var$cil(Prism) {
    Prism.languages.cil = {
        comment: /\/\/.*/,
        string: {
            pattern: /(["'])(?:\\(?:\r\n|[\s\S])|(?!\1)[^\\\r\n])*\1/,
            greedy: true
        },
        directive: {
            pattern: /(^|\W)\.[a-z]+(?=\s)/,
            lookbehind: true,
            alias: 'class-name'
        },
        // Actually an assembly reference
        variable: /\[[\w\.]+\]/,
        keyword: /\b(?:abstract|ansi|assembly|auto|autochar|beforefieldinit|bool|bstr|byvalstr|catch|char|cil|class|currency|date|decimal|default|enum|error|explicit|extends|extern|famandassem|family|famorassem|final(?:ly)?|float32|float64|hidebysig|u?int(?:8|16|32|64)?|iant|idispatch|implements|import|initonly|instance|interface|iunknown|literal|lpstr|lpstruct|lptstr|lpwstr|managed|method|native(?:Type)?|nested|newslot|object(?:ref)?|pinvokeimpl|private|privatescope|public|reqsecobj|rtspecialname|runtime|sealed|sequential|serializable|specialname|static|string|struct|syschar|tbstr|unicode|unmanagedexp|unsigned|value(?:type)?|variant|virtual|void)\b/,
        function: /\b(?:(?:constrained|no|readonly|tail|unaligned|volatile)\.)?(?:conv\.(?:[iu][1248]?|ovf\.[iu][1248]?(?:\.un)?|r\.un|r4|r8)|ldc\.(?:i4(?:\.\d+|\.[mM]1|\.s)?|i8|r4|r8)|ldelem(?:\.[iu][1248]?|\.r[48]|\.ref|a)?|ldind\.(?:[iu][1248]?|r[48]|ref)|stelem\.?(?:i[1248]?|r[48]|ref)?|stind\.(?:i[1248]?|r[48]|ref)?|end(?:fault|filter|finally)|ldarg(?:\.[0-3s]|a(?:\.s)?)?|ldloc(?:\.\d+|\.s)?|sub(?:\.ovf(?:\.un)?)?|mul(?:\.ovf(?:\.un)?)?|add(?:\.ovf(?:\.un)?)?|stloc(?:\.[0-3s])?|refany(?:type|val)|blt(?:\.un)?(?:\.s)?|ble(?:\.un)?(?:\.s)?|bgt(?:\.un)?(?:\.s)?|bge(?:\.un)?(?:\.s)?|unbox(?:\.any)?|init(?:blk|obj)|call(?:i|virt)?|brfalse(?:\.s)?|bne\.un(?:\.s)?|ldloca(?:\.s)?|brzero(?:\.s)?|brtrue(?:\.s)?|brnull(?:\.s)?|brinst(?:\.s)?|starg(?:\.s)?|leave(?:\.s)?|shr(?:\.un)?|rem(?:\.un)?|div(?:\.un)?|clt(?:\.un)?|alignment|castclass|ldvirtftn|beq(?:\.s)?|ckfinite|ldsflda|ldtoken|localloc|mkrefany|rethrow|cgt\.un|arglist|switch|stsfld|sizeof|newobj|newarr|ldsfld|ldnull|ldflda|isinst|throw|stobj|stfld|ldstr|ldobj|ldlen|ldftn|ldfld|cpobj|cpblk|break|br\.s|xor|shl|ret|pop|not|nop|neg|jmp|dup|cgt|ceq|box|and|or|br)\b/,
        boolean: /\b(?:false|true)\b/,
        number: /\b-?(?:0x[0-9a-f]+|\d+)(?:\.[0-9a-f]+)?\b/i,
        punctuation: /[{}[\];(),:=]|IL_[0-9A-Za-z]+/
    };
}

});

parcelRegister("bzHaH", function(module, exports) {
'use strict';
module.exports = $86d473947928e0cc$var$clojure;
$86d473947928e0cc$var$clojure.displayName = 'clojure';
$86d473947928e0cc$var$clojure.aliases = [];
function $86d473947928e0cc$var$clojure(Prism) {
    // Copied from https://github.com/jeluard/prism-clojure
    Prism.languages.clojure = {
        comment: {
            pattern: /;.*/,
            greedy: true
        },
        string: {
            pattern: /"(?:[^"\\]|\\.)*"/,
            greedy: true
        },
        char: /\\\w+/,
        symbol: {
            pattern: /(^|[\s()\[\]{},])::?[\w*+!?'<>=/.-]+/,
            lookbehind: true
        },
        keyword: {
            pattern: /(\()(?:-|->|->>|\.|\.\.|\*|\/|\+|<|<=|=|==|>|>=|accessor|agent|agent-errors|aget|alength|all-ns|alter|and|append-child|apply|array-map|aset|aset-boolean|aset-byte|aset-char|aset-double|aset-float|aset-int|aset-long|aset-short|assert|assoc|await|await-for|bean|binding|bit-and|bit-not|bit-or|bit-shift-left|bit-shift-right|bit-xor|boolean|branch\?|butlast|byte|cast|char|children|class|clear-agent-errors|comment|commute|comp|comparator|complement|concat|cond|conj|cons|constantly|construct-proxy|contains\?|count|create-ns|create-struct|cycle|dec|declare|def|def-|definline|definterface|defmacro|defmethod|defmulti|defn|defn-|defonce|defproject|defprotocol|defrecord|defstruct|deftype|deref|difference|disj|dissoc|distinct|do|doall|doc|dorun|doseq|dosync|dotimes|doto|double|down|drop|drop-while|edit|end\?|ensure|eval|every\?|false\?|ffirst|file-seq|filter|find|find-doc|find-ns|find-var|first|float|flush|fn|fnseq|for|frest|gensym|get|get-proxy-class|hash-map|hash-set|identical\?|identity|if|if-let|if-not|import|in-ns|inc|index|insert-child|insert-left|insert-right|inspect-table|inspect-tree|instance\?|int|interleave|intersection|into|into-array|iterate|join|key|keys|keyword|keyword\?|last|lazy-cat|lazy-cons|left|lefts|let|line-seq|list|list\*|load|load-file|locking|long|loop|macroexpand|macroexpand-1|make-array|make-node|map|map-invert|map\?|mapcat|max|max-key|memfn|merge|merge-with|meta|min|min-key|monitor-enter|name|namespace|neg\?|new|newline|next|nil\?|node|not|not-any\?|not-every\?|not=|ns|ns-imports|ns-interns|ns-map|ns-name|ns-publics|ns-refers|ns-resolve|ns-unmap|nth|nthrest|or|parse|partial|path|peek|pop|pos\?|pr|pr-str|print|print-str|println|println-str|prn|prn-str|project|proxy|proxy-mappings|quot|quote|rand|rand-int|range|re-find|re-groups|re-matcher|re-matches|re-pattern|re-seq|read|read-line|recur|reduce|ref|ref-set|refer|rem|remove|remove-method|remove-ns|rename|rename-keys|repeat|replace|replicate|resolve|rest|resultset-seq|reverse|rfirst|right|rights|root|rrest|rseq|second|select|select-keys|send|send-off|seq|seq-zip|seq\?|set|set!|short|slurp|some|sort|sort-by|sorted-map|sorted-map-by|sorted-set|special-symbol\?|split-at|split-with|str|string\?|struct|struct-map|subs|subvec|symbol|symbol\?|sync|take|take-nth|take-while|test|throw|time|to-array|to-array-2d|tree-seq|true\?|try|union|up|update-proxy|val|vals|var|var-get|var-set|var\?|vector|vector-zip|vector\?|when|when-first|when-let|when-not|with-local-vars|with-meta|with-open|with-out-str|xml-seq|xml-zip|zero\?|zipmap|zipper)(?=[\s)]|$)/,
            lookbehind: true
        },
        boolean: /\b(?:false|nil|true)\b/,
        number: {
            pattern: /(^|[^\w$@])(?:\d+(?:[/.]\d+)?(?:e[+-]?\d+)?|0x[a-f0-9]+|[1-9]\d?r[a-z0-9]+)[lmn]?(?![\w$@])/i,
            lookbehind: true
        },
        function: {
            pattern: /((?:^|[^'])\()[\w*+!?'<>=/.-]+(?=[\s)]|$)/,
            lookbehind: true
        },
        operator: /[#@^`~]/,
        punctuation: /[{}\[\](),]/
    };
}

});

parcelRegister("5e0Fa", function(module, exports) {
'use strict';
module.exports = $3cdec633c82e3177$var$cmake;
$3cdec633c82e3177$var$cmake.displayName = 'cmake';
$3cdec633c82e3177$var$cmake.aliases = [];
function $3cdec633c82e3177$var$cmake(Prism) {
    Prism.languages.cmake = {
        comment: /#.*/,
        string: {
            pattern: /"(?:[^\\"]|\\.)*"/,
            greedy: true,
            inside: {
                interpolation: {
                    pattern: /\$\{(?:[^{}$]|\$\{[^{}$]*\})*\}/,
                    inside: {
                        punctuation: /\$\{|\}/,
                        variable: /\w+/
                    }
                }
            }
        },
        variable: /\b(?:CMAKE_\w+|\w+_(?:(?:BINARY|SOURCE)_DIR|DESCRIPTION|HOMEPAGE_URL|ROOT|VERSION(?:_MAJOR|_MINOR|_PATCH|_TWEAK)?)|(?:ANDROID|APPLE|BORLAND|BUILD_SHARED_LIBS|CACHE|CPACK_(?:ABSOLUTE_DESTINATION_FILES|COMPONENT_INCLUDE_TOPLEVEL_DIRECTORY|ERROR_ON_ABSOLUTE_INSTALL_DESTINATION|INCLUDE_TOPLEVEL_DIRECTORY|INSTALL_DEFAULT_DIRECTORY_PERMISSIONS|INSTALL_SCRIPT|PACKAGING_INSTALL_PREFIX|SET_DESTDIR|WARN_ON_ABSOLUTE_INSTALL_DESTINATION)|CTEST_(?:BINARY_DIRECTORY|BUILD_COMMAND|BUILD_NAME|BZR_COMMAND|BZR_UPDATE_OPTIONS|CHANGE_ID|CHECKOUT_COMMAND|CONFIGURATION_TYPE|CONFIGURE_COMMAND|COVERAGE_COMMAND|COVERAGE_EXTRA_FLAGS|CURL_OPTIONS|CUSTOM_(?:COVERAGE_EXCLUDE|ERROR_EXCEPTION|ERROR_MATCH|ERROR_POST_CONTEXT|ERROR_PRE_CONTEXT|MAXIMUM_FAILED_TEST_OUTPUT_SIZE|MAXIMUM_NUMBER_OF_(?:ERRORS|WARNINGS)|MAXIMUM_PASSED_TEST_OUTPUT_SIZE|MEMCHECK_IGNORE|POST_MEMCHECK|POST_TEST|PRE_MEMCHECK|PRE_TEST|TESTS_IGNORE|WARNING_EXCEPTION|WARNING_MATCH)|CVS_CHECKOUT|CVS_COMMAND|CVS_UPDATE_OPTIONS|DROP_LOCATION|DROP_METHOD|DROP_SITE|DROP_SITE_CDASH|DROP_SITE_PASSWORD|DROP_SITE_USER|EXTRA_COVERAGE_GLOB|GIT_COMMAND|GIT_INIT_SUBMODULES|GIT_UPDATE_CUSTOM|GIT_UPDATE_OPTIONS|HG_COMMAND|HG_UPDATE_OPTIONS|LABELS_FOR_SUBPROJECTS|MEMORYCHECK_(?:COMMAND|COMMAND_OPTIONS|SANITIZER_OPTIONS|SUPPRESSIONS_FILE|TYPE)|NIGHTLY_START_TIME|P4_CLIENT|P4_COMMAND|P4_OPTIONS|P4_UPDATE_OPTIONS|RUN_CURRENT_SCRIPT|SCP_COMMAND|SITE|SOURCE_DIRECTORY|SUBMIT_URL|SVN_COMMAND|SVN_OPTIONS|SVN_UPDATE_OPTIONS|TEST_LOAD|TEST_TIMEOUT|TRIGGER_SITE|UPDATE_COMMAND|UPDATE_OPTIONS|UPDATE_VERSION_ONLY|USE_LAUNCHERS)|CYGWIN|ENV|EXECUTABLE_OUTPUT_PATH|GHS-MULTI|IOS|LIBRARY_OUTPUT_PATH|MINGW|MSVC(?:10|11|12|14|60|70|71|80|90|_IDE|_TOOLSET_VERSION|_VERSION)?|MSYS|PROJECT_(?:BINARY_DIR|DESCRIPTION|HOMEPAGE_URL|NAME|SOURCE_DIR|VERSION|VERSION_(?:MAJOR|MINOR|PATCH|TWEAK))|UNIX|WIN32|WINCE|WINDOWS_PHONE|WINDOWS_STORE|XCODE|XCODE_VERSION))\b/,
        property: /\b(?:cxx_\w+|(?:ARCHIVE_OUTPUT_(?:DIRECTORY|NAME)|COMPILE_DEFINITIONS|COMPILE_PDB_NAME|COMPILE_PDB_OUTPUT_DIRECTORY|EXCLUDE_FROM_DEFAULT_BUILD|IMPORTED_(?:IMPLIB|LIBNAME|LINK_DEPENDENT_LIBRARIES|LINK_INTERFACE_LANGUAGES|LINK_INTERFACE_LIBRARIES|LINK_INTERFACE_MULTIPLICITY|LOCATION|NO_SONAME|OBJECTS|SONAME)|INTERPROCEDURAL_OPTIMIZATION|LIBRARY_OUTPUT_DIRECTORY|LIBRARY_OUTPUT_NAME|LINK_FLAGS|LINK_INTERFACE_LIBRARIES|LINK_INTERFACE_MULTIPLICITY|LOCATION|MAP_IMPORTED_CONFIG|OSX_ARCHITECTURES|OUTPUT_NAME|PDB_NAME|PDB_OUTPUT_DIRECTORY|RUNTIME_OUTPUT_DIRECTORY|RUNTIME_OUTPUT_NAME|STATIC_LIBRARY_FLAGS|VS_CSHARP|VS_DOTNET_REFERENCEPROP|VS_DOTNET_REFERENCE|VS_GLOBAL_SECTION_POST|VS_GLOBAL_SECTION_PRE|VS_GLOBAL|XCODE_ATTRIBUTE)_\w+|\w+_(?:CLANG_TIDY|COMPILER_LAUNCHER|CPPCHECK|CPPLINT|INCLUDE_WHAT_YOU_USE|OUTPUT_NAME|POSTFIX|VISIBILITY_PRESET)|ABSTRACT|ADDITIONAL_MAKE_CLEAN_FILES|ADVANCED|ALIASED_TARGET|ALLOW_DUPLICATE_CUSTOM_TARGETS|ANDROID_(?:ANT_ADDITIONAL_OPTIONS|API|API_MIN|ARCH|ASSETS_DIRECTORIES|GUI|JAR_DEPENDENCIES|NATIVE_LIB_DEPENDENCIES|NATIVE_LIB_DIRECTORIES|PROCESS_MAX|PROGUARD|PROGUARD_CONFIG_PATH|SECURE_PROPS_PATH|SKIP_ANT_STEP|STL_TYPE)|ARCHIVE_OUTPUT_DIRECTORY|ATTACHED_FILES|ATTACHED_FILES_ON_FAIL|AUTOGEN_(?:BUILD_DIR|ORIGIN_DEPENDS|PARALLEL|SOURCE_GROUP|TARGETS_FOLDER|TARGET_DEPENDS)|AUTOMOC|AUTOMOC_(?:COMPILER_PREDEFINES|DEPEND_FILTERS|EXECUTABLE|MACRO_NAMES|MOC_OPTIONS|SOURCE_GROUP|TARGETS_FOLDER)|AUTORCC|AUTORCC_EXECUTABLE|AUTORCC_OPTIONS|AUTORCC_SOURCE_GROUP|AUTOUIC|AUTOUIC_EXECUTABLE|AUTOUIC_OPTIONS|AUTOUIC_SEARCH_PATHS|BINARY_DIR|BUILDSYSTEM_TARGETS|BUILD_RPATH|BUILD_RPATH_USE_ORIGIN|BUILD_WITH_INSTALL_NAME_DIR|BUILD_WITH_INSTALL_RPATH|BUNDLE|BUNDLE_EXTENSION|CACHE_VARIABLES|CLEAN_NO_CUSTOM|COMMON_LANGUAGE_RUNTIME|COMPATIBLE_INTERFACE_(?:BOOL|NUMBER_MAX|NUMBER_MIN|STRING)|COMPILE_(?:DEFINITIONS|FEATURES|FLAGS|OPTIONS|PDB_NAME|PDB_OUTPUT_DIRECTORY)|COST|CPACK_DESKTOP_SHORTCUTS|CPACK_NEVER_OVERWRITE|CPACK_PERMANENT|CPACK_STARTUP_SHORTCUTS|CPACK_START_MENU_SHORTCUTS|CPACK_WIX_ACL|CROSSCOMPILING_EMULATOR|CUDA_EXTENSIONS|CUDA_PTX_COMPILATION|CUDA_RESOLVE_DEVICE_SYMBOLS|CUDA_SEPARABLE_COMPILATION|CUDA_STANDARD|CUDA_STANDARD_REQUIRED|CXX_EXTENSIONS|CXX_STANDARD|CXX_STANDARD_REQUIRED|C_EXTENSIONS|C_STANDARD|C_STANDARD_REQUIRED|DEBUG_CONFIGURATIONS|DEFINE_SYMBOL|DEFINITIONS|DEPENDS|DEPLOYMENT_ADDITIONAL_FILES|DEPLOYMENT_REMOTE_DIRECTORY|DISABLED|DISABLED_FEATURES|ECLIPSE_EXTRA_CPROJECT_CONTENTS|ECLIPSE_EXTRA_NATURES|ENABLED_FEATURES|ENABLED_LANGUAGES|ENABLE_EXPORTS|ENVIRONMENT|EXCLUDE_FROM_ALL|EXCLUDE_FROM_DEFAULT_BUILD|EXPORT_NAME|EXPORT_PROPERTIES|EXTERNAL_OBJECT|EchoString|FAIL_REGULAR_EXPRESSION|FIND_LIBRARY_USE_LIB32_PATHS|FIND_LIBRARY_USE_LIB64_PATHS|FIND_LIBRARY_USE_LIBX32_PATHS|FIND_LIBRARY_USE_OPENBSD_VERSIONING|FIXTURES_CLEANUP|FIXTURES_REQUIRED|FIXTURES_SETUP|FOLDER|FRAMEWORK|Fortran_FORMAT|Fortran_MODULE_DIRECTORY|GENERATED|GENERATOR_FILE_NAME|GENERATOR_IS_MULTI_CONFIG|GHS_INTEGRITY_APP|GHS_NO_SOURCE_GROUP_FILE|GLOBAL_DEPENDS_DEBUG_MODE|GLOBAL_DEPENDS_NO_CYCLES|GNUtoMS|HAS_CXX|HEADER_FILE_ONLY|HELPSTRING|IMPLICIT_DEPENDS_INCLUDE_TRANSFORM|IMPORTED|IMPORTED_(?:COMMON_LANGUAGE_RUNTIME|CONFIGURATIONS|GLOBAL|IMPLIB|LIBNAME|LINK_DEPENDENT_LIBRARIES|LINK_INTERFACE_(?:LANGUAGES|LIBRARIES|MULTIPLICITY)|LOCATION|NO_SONAME|OBJECTS|SONAME)|IMPORT_PREFIX|IMPORT_SUFFIX|INCLUDE_DIRECTORIES|INCLUDE_REGULAR_EXPRESSION|INSTALL_NAME_DIR|INSTALL_RPATH|INSTALL_RPATH_USE_LINK_PATH|INTERFACE_(?:AUTOUIC_OPTIONS|COMPILE_DEFINITIONS|COMPILE_FEATURES|COMPILE_OPTIONS|INCLUDE_DIRECTORIES|LINK_DEPENDS|LINK_DIRECTORIES|LINK_LIBRARIES|LINK_OPTIONS|POSITION_INDEPENDENT_CODE|SOURCES|SYSTEM_INCLUDE_DIRECTORIES)|INTERPROCEDURAL_OPTIMIZATION|IN_TRY_COMPILE|IOS_INSTALL_COMBINED|JOB_POOLS|JOB_POOL_COMPILE|JOB_POOL_LINK|KEEP_EXTENSION|LABELS|LANGUAGE|LIBRARY_OUTPUT_DIRECTORY|LINKER_LANGUAGE|LINK_(?:DEPENDS|DEPENDS_NO_SHARED|DIRECTORIES|FLAGS|INTERFACE_LIBRARIES|INTERFACE_MULTIPLICITY|LIBRARIES|OPTIONS|SEARCH_END_STATIC|SEARCH_START_STATIC|WHAT_YOU_USE)|LISTFILE_STACK|LOCATION|MACOSX_BUNDLE|MACOSX_BUNDLE_INFO_PLIST|MACOSX_FRAMEWORK_INFO_PLIST|MACOSX_PACKAGE_LOCATION|MACOSX_RPATH|MACROS|MANUALLY_ADDED_DEPENDENCIES|MEASUREMENT|MODIFIED|NAME|NO_SONAME|NO_SYSTEM_FROM_IMPORTED|OBJECT_DEPENDS|OBJECT_OUTPUTS|OSX_ARCHITECTURES|OUTPUT_NAME|PACKAGES_FOUND|PACKAGES_NOT_FOUND|PARENT_DIRECTORY|PASS_REGULAR_EXPRESSION|PDB_NAME|PDB_OUTPUT_DIRECTORY|POSITION_INDEPENDENT_CODE|POST_INSTALL_SCRIPT|PREDEFINED_TARGETS_FOLDER|PREFIX|PRE_INSTALL_SCRIPT|PRIVATE_HEADER|PROCESSORS|PROCESSOR_AFFINITY|PROJECT_LABEL|PUBLIC_HEADER|REPORT_UNDEFINED_PROPERTIES|REQUIRED_FILES|RESOURCE|RESOURCE_LOCK|RULE_LAUNCH_COMPILE|RULE_LAUNCH_CUSTOM|RULE_LAUNCH_LINK|RULE_MESSAGES|RUNTIME_OUTPUT_DIRECTORY|RUN_SERIAL|SKIP_AUTOGEN|SKIP_AUTOMOC|SKIP_AUTORCC|SKIP_AUTOUIC|SKIP_BUILD_RPATH|SKIP_RETURN_CODE|SOURCES|SOURCE_DIR|SOVERSION|STATIC_LIBRARY_FLAGS|STATIC_LIBRARY_OPTIONS|STRINGS|SUBDIRECTORIES|SUFFIX|SYMBOLIC|TARGET_ARCHIVES_MAY_BE_SHARED_LIBS|TARGET_MESSAGES|TARGET_SUPPORTS_SHARED_LIBS|TESTS|TEST_INCLUDE_FILE|TEST_INCLUDE_FILES|TIMEOUT|TIMEOUT_AFTER_MATCH|TYPE|USE_FOLDERS|VALUE|VARIABLES|VERSION|VISIBILITY_INLINES_HIDDEN|VS_(?:CONFIGURATION_TYPE|COPY_TO_OUT_DIR|DEBUGGER_(?:COMMAND|COMMAND_ARGUMENTS|ENVIRONMENT|WORKING_DIRECTORY)|DEPLOYMENT_CONTENT|DEPLOYMENT_LOCATION|DOTNET_REFERENCES|DOTNET_REFERENCES_COPY_LOCAL|GLOBAL_KEYWORD|GLOBAL_PROJECT_TYPES|GLOBAL_ROOTNAMESPACE|INCLUDE_IN_VSIX|IOT_STARTUP_TASK|KEYWORD|RESOURCE_GENERATOR|SCC_AUXPATH|SCC_LOCALPATH|SCC_PROJECTNAME|SCC_PROVIDER|SDK_REFERENCES|SHADER_(?:DISABLE_OPTIMIZATIONS|ENABLE_DEBUG|ENTRYPOINT|FLAGS|MODEL|OBJECT_FILE_NAME|OUTPUT_HEADER_FILE|TYPE|VARIABLE_NAME)|STARTUP_PROJECT|TOOL_OVERRIDE|USER_PROPS|WINRT_COMPONENT|WINRT_EXTENSIONS|WINRT_REFERENCES|XAML_TYPE)|WILL_FAIL|WIN32_EXECUTABLE|WINDOWS_EXPORT_ALL_SYMBOLS|WORKING_DIRECTORY|WRAP_EXCLUDE|XCODE_(?:EMIT_EFFECTIVE_PLATFORM_NAME|EXPLICIT_FILE_TYPE|FILE_ATTRIBUTES|LAST_KNOWN_FILE_TYPE|PRODUCT_TYPE|SCHEME_(?:ADDRESS_SANITIZER|ADDRESS_SANITIZER_USE_AFTER_RETURN|ARGUMENTS|DISABLE_MAIN_THREAD_CHECKER|DYNAMIC_LIBRARY_LOADS|DYNAMIC_LINKER_API_USAGE|ENVIRONMENT|EXECUTABLE|GUARD_MALLOC|MAIN_THREAD_CHECKER_STOP|MALLOC_GUARD_EDGES|MALLOC_SCRIBBLE|MALLOC_STACK|THREAD_SANITIZER(?:_STOP)?|UNDEFINED_BEHAVIOUR_SANITIZER(?:_STOP)?|ZOMBIE_OBJECTS))|XCTEST)\b/,
        keyword: /\b(?:add_compile_definitions|add_compile_options|add_custom_command|add_custom_target|add_definitions|add_dependencies|add_executable|add_library|add_link_options|add_subdirectory|add_test|aux_source_directory|break|build_command|build_name|cmake_host_system_information|cmake_minimum_required|cmake_parse_arguments|cmake_policy|configure_file|continue|create_test_sourcelist|ctest_build|ctest_configure|ctest_coverage|ctest_empty_binary_directory|ctest_memcheck|ctest_read_custom_files|ctest_run_script|ctest_sleep|ctest_start|ctest_submit|ctest_test|ctest_update|ctest_upload|define_property|else|elseif|enable_language|enable_testing|endforeach|endfunction|endif|endmacro|endwhile|exec_program|execute_process|export|export_library_dependencies|file|find_file|find_library|find_package|find_path|find_program|fltk_wrap_ui|foreach|function|get_cmake_property|get_directory_property|get_filename_component|get_property|get_source_file_property|get_target_property|get_test_property|if|include|include_directories|include_external_msproject|include_guard|include_regular_expression|install|install_files|install_programs|install_targets|link_directories|link_libraries|list|load_cache|load_command|macro|make_directory|mark_as_advanced|math|message|option|output_required_files|project|qt_wrap_cpp|qt_wrap_ui|remove|remove_definitions|return|separate_arguments|set|set_directory_properties|set_property|set_source_files_properties|set_target_properties|set_tests_properties|site_name|source_group|string|subdir_depends|subdirs|target_compile_definitions|target_compile_features|target_compile_options|target_include_directories|target_link_directories|target_link_libraries|target_link_options|target_sources|try_compile|try_run|unset|use_mangled_mesa|utility_source|variable_requires|variable_watch|while|write_file)(?=\s*\()\b/,
        boolean: /\b(?:FALSE|OFF|ON|TRUE)\b/,
        namespace: /\b(?:INTERFACE|PRIVATE|PROPERTIES|PUBLIC|SHARED|STATIC|TARGET_OBJECTS)\b/,
        operator: /\b(?:AND|DEFINED|EQUAL|GREATER|LESS|MATCHES|NOT|OR|STREQUAL|STRGREATER|STRLESS|VERSION_EQUAL|VERSION_GREATER|VERSION_LESS)\b/,
        inserted: {
            pattern: /\b\w+::\w+\b/,
            alias: 'class-name'
        },
        number: /\b\d+(?:\.\d+)*\b/,
        function: /\b[a-z_]\w*(?=\s*\()\b/i,
        punctuation: /[()>}]|\$[<{]/
    };
}

});

parcelRegister("i3jhi", function(module, exports) {
'use strict';
module.exports = $d24775ffb2221c9e$var$cobol;
$d24775ffb2221c9e$var$cobol.displayName = 'cobol';
$d24775ffb2221c9e$var$cobol.aliases = [];
function $d24775ffb2221c9e$var$cobol(Prism) {
    Prism.languages.cobol = {
        comment: {
            pattern: /\*>.*|(^[ \t]*)\*.*/m,
            lookbehind: true,
            greedy: true
        },
        string: {
            pattern: /[xzgn]?(?:"(?:[^\r\n"]|"")*"(?!")|'(?:[^\r\n']|'')*'(?!'))/i,
            greedy: true
        },
        level: {
            pattern: /(^[ \t]*)\d+\b/m,
            lookbehind: true,
            greedy: true,
            alias: 'number'
        },
        'class-name': {
            // https://github.com/antlr/grammars-v4/blob/42edd5b687d183b5fa679e858a82297bd27141e7/cobol85/Cobol85.g4#L1015
            pattern: /(\bpic(?:ture)?\s+)(?:(?:[-\w$/,:*+<>]|\.(?!\s|$))(?:\(\d+\))?)+/i,
            lookbehind: true,
            inside: {
                number: {
                    pattern: /(\()\d+/,
                    lookbehind: true
                },
                punctuation: /[()]/
            }
        },
        keyword: {
            pattern: /(^|[^\w-])(?:ABORT|ACCEPT|ACCESS|ADD|ADDRESS|ADVANCING|AFTER|ALIGNED|ALL|ALPHABET|ALPHABETIC|ALPHABETIC-LOWER|ALPHABETIC-UPPER|ALPHANUMERIC|ALPHANUMERIC-EDITED|ALSO|ALTER|ALTERNATE|ANY|ARE|AREA|AREAS|AS|ASCENDING|ASCII|ASSIGN|ASSOCIATED-DATA|ASSOCIATED-DATA-LENGTH|AT|ATTRIBUTE|AUTHOR|AUTO|AUTO-SKIP|BACKGROUND-COLOR|BACKGROUND-COLOUR|BASIS|BEEP|BEFORE|BEGINNING|BELL|BINARY|BIT|BLANK|BLINK|BLOCK|BOTTOM|BOUNDS|BY|BYFUNCTION|BYTITLE|CALL|CANCEL|CAPABLE|CCSVERSION|CD|CF|CH|CHAINING|CHANGED|CHANNEL|CHARACTER|CHARACTERS|CLASS|CLASS-ID|CLOCK-UNITS|CLOSE|CLOSE-DISPOSITION|COBOL|CODE|CODE-SET|COL|COLLATING|COLUMN|COM-REG|COMMA|COMMITMENT|COMMON|COMMUNICATION|COMP|COMP-1|COMP-2|COMP-3|COMP-4|COMP-5|COMPUTATIONAL|COMPUTATIONAL-1|COMPUTATIONAL-2|COMPUTATIONAL-3|COMPUTATIONAL-4|COMPUTATIONAL-5|COMPUTE|CONFIGURATION|CONTAINS|CONTENT|CONTINUE|CONTROL|CONTROL-POINT|CONTROLS|CONVENTION|CONVERTING|COPY|CORR|CORRESPONDING|COUNT|CRUNCH|CURRENCY|CURSOR|DATA|DATA-BASE|DATE|DATE-COMPILED|DATE-WRITTEN|DAY|DAY-OF-WEEK|DBCS|DE|DEBUG-CONTENTS|DEBUG-ITEM|DEBUG-LINE|DEBUG-NAME|DEBUG-SUB-1|DEBUG-SUB-2|DEBUG-SUB-3|DEBUGGING|DECIMAL-POINT|DECLARATIVES|DEFAULT|DEFAULT-DISPLAY|DEFINITION|DELETE|DELIMITED|DELIMITER|DEPENDING|DESCENDING|DESTINATION|DETAIL|DFHRESP|DFHVALUE|DISABLE|DISK|DISPLAY|DISPLAY-1|DIVIDE|DIVISION|DONTCARE|DOUBLE|DOWN|DUPLICATES|DYNAMIC|EBCDIC|EGCS|EGI|ELSE|EMI|EMPTY-CHECK|ENABLE|END|END-ACCEPT|END-ADD|END-CALL|END-COMPUTE|END-DELETE|END-DIVIDE|END-EVALUATE|END-IF|END-MULTIPLY|END-OF-PAGE|END-PERFORM|END-READ|END-RECEIVE|END-RETURN|END-REWRITE|END-SEARCH|END-START|END-STRING|END-SUBTRACT|END-UNSTRING|END-WRITE|ENDING|ENTER|ENTRY|ENTRY-PROCEDURE|ENVIRONMENT|EOL|EOP|EOS|ERASE|ERROR|ESCAPE|ESI|EVALUATE|EVENT|EVERY|EXCEPTION|EXCLUSIVE|EXHIBIT|EXIT|EXPORT|EXTEND|EXTENDED|EXTERNAL|FD|FILE|FILE-CONTROL|FILLER|FINAL|FIRST|FOOTING|FOR|FOREGROUND-COLOR|FOREGROUND-COLOUR|FROM|FULL|FUNCTION|FUNCTION-POINTER|FUNCTIONNAME|GENERATE|GIVING|GLOBAL|GO|GOBACK|GRID|GROUP|HEADING|HIGH-VALUE|HIGH-VALUES|HIGHLIGHT|I-O|I-O-CONTROL|ID|IDENTIFICATION|IF|IMPLICIT|IMPORT|IN|INDEX|INDEXED|INDICATE|INITIAL|INITIALIZE|INITIATE|INPUT|INPUT-OUTPUT|INSPECT|INSTALLATION|INTEGER|INTO|INVALID|INVOKE|IS|JUST|JUSTIFIED|KANJI|KEPT|KEY|KEYBOARD|LABEL|LANGUAGE|LAST|LB|LD|LEADING|LEFT|LEFTLINE|LENGTH|LENGTH-CHECK|LIBACCESS|LIBPARAMETER|LIBRARY|LIMIT|LIMITS|LINAGE|LINAGE-COUNTER|LINE|LINE-COUNTER|LINES|LINKAGE|LIST|LOCAL|LOCAL-STORAGE|LOCK|LONG-DATE|LONG-TIME|LOW-VALUE|LOW-VALUES|LOWER|LOWLIGHT|MEMORY|MERGE|MESSAGE|MMDDYYYY|MODE|MODULES|MORE-LABELS|MOVE|MULTIPLE|MULTIPLY|NAMED|NATIONAL|NATIONAL-EDITED|NATIVE|NEGATIVE|NETWORK|NEXT|NO|NO-ECHO|NULL|NULLS|NUMBER|NUMERIC|NUMERIC-DATE|NUMERIC-EDITED|NUMERIC-TIME|OBJECT-COMPUTER|OCCURS|ODT|OF|OFF|OMITTED|ON|OPEN|OPTIONAL|ORDER|ORDERLY|ORGANIZATION|OTHER|OUTPUT|OVERFLOW|OVERLINE|OWN|PACKED-DECIMAL|PADDING|PAGE|PAGE-COUNTER|PASSWORD|PERFORM|PF|PH|PIC|PICTURE|PLUS|POINTER|PORT|POSITION|POSITIVE|PRINTER|PRINTING|PRIVATE|PROCEDURE|PROCEDURE-POINTER|PROCEDURES|PROCEED|PROCESS|PROGRAM|PROGRAM-ID|PROGRAM-LIBRARY|PROMPT|PURGE|QUEUE|QUOTE|QUOTES|RANDOM|RD|READ|READER|REAL|RECEIVE|RECEIVED|RECORD|RECORDING|RECORDS|RECURSIVE|REDEFINES|REEL|REF|REFERENCE|REFERENCES|RELATIVE|RELEASE|REMAINDER|REMARKS|REMOTE|REMOVAL|REMOVE|RENAMES|REPLACE|REPLACING|REPORT|REPORTING|REPORTS|REQUIRED|RERUN|RESERVE|RESET|RETURN|RETURN-CODE|RETURNING|REVERSE-VIDEO|REVERSED|REWIND|REWRITE|RF|RH|RIGHT|ROUNDED|RUN|SAME|SAVE|SCREEN|SD|SEARCH|SECTION|SECURE|SECURITY|SEGMENT|SEGMENT-LIMIT|SELECT|SEND|SENTENCE|SEPARATE|SEQUENCE|SEQUENTIAL|SET|SHARED|SHAREDBYALL|SHAREDBYRUNUNIT|SHARING|SHIFT-IN|SHIFT-OUT|SHORT-DATE|SIGN|SIZE|SORT|SORT-CONTROL|SORT-CORE-SIZE|SORT-FILE-SIZE|SORT-MERGE|SORT-MESSAGE|SORT-MODE-SIZE|SORT-RETURN|SOURCE|SOURCE-COMPUTER|SPACE|SPACES|SPECIAL-NAMES|STANDARD|STANDARD-1|STANDARD-2|START|STATUS|STOP|STRING|SUB-QUEUE-1|SUB-QUEUE-2|SUB-QUEUE-3|SUBTRACT|SUM|SUPPRESS|SYMBOL|SYMBOLIC|SYNC|SYNCHRONIZED|TABLE|TALLY|TALLYING|TAPE|TASK|TERMINAL|TERMINATE|TEST|TEXT|THEN|THREAD|THREAD-LOCAL|THROUGH|THRU|TIME|TIMER|TIMES|TITLE|TO|TODAYS-DATE|TODAYS-NAME|TOP|TRAILING|TRUNCATED|TYPE|TYPEDEF|UNDERLINE|UNIT|UNSTRING|UNTIL|UP|UPON|USAGE|USE|USING|VALUE|VALUES|VARYING|VIRTUAL|WAIT|WHEN|WHEN-COMPILED|WITH|WORDS|WORKING-STORAGE|WRITE|YEAR|YYYYDDD|YYYYMMDD|ZERO-FILL|ZEROES|ZEROS)(?![\w-])/i,
            lookbehind: true
        },
        boolean: {
            pattern: /(^|[^\w-])(?:false|true)(?![\w-])/i,
            lookbehind: true
        },
        number: {
            pattern: /(^|[^\w-])(?:[+-]?(?:(?:\d+(?:[.,]\d+)?|[.,]\d+)(?:e[+-]?\d+)?|zero))(?![\w-])/i,
            lookbehind: true
        },
        operator: [
            /<>|[<>]=?|[=+*/&]/,
            {
                pattern: /(^|[^\w-])(?:-|and|equal|greater|less|not|or|than)(?![\w-])/i,
                lookbehind: true
            }
        ],
        punctuation: /[.:,()]/
    };
}

});

parcelRegister("juLmo", function(module, exports) {
'use strict';
module.exports = $e3158e6be31cda7e$var$coffeescript;
$e3158e6be31cda7e$var$coffeescript.displayName = 'coffeescript';
$e3158e6be31cda7e$var$coffeescript.aliases = [
    'coffee'
];
function $e3158e6be31cda7e$var$coffeescript(Prism) {
    (function(Prism) {
        // Ignore comments starting with { to privilege string interpolation highlighting
        var comment = /#(?!\{).+/;
        var interpolation = {
            pattern: /#\{[^}]+\}/,
            alias: 'variable'
        };
        Prism.languages.coffeescript = Prism.languages.extend('javascript', {
            comment: comment,
            string: [
                // Strings are multiline
                {
                    pattern: /'(?:\\[\s\S]|[^\\'])*'/,
                    greedy: true
                },
                {
                    // Strings are multiline
                    pattern: /"(?:\\[\s\S]|[^\\"])*"/,
                    greedy: true,
                    inside: {
                        interpolation: interpolation
                    }
                }
            ],
            keyword: /\b(?:and|break|by|catch|class|continue|debugger|delete|do|each|else|extend|extends|false|finally|for|if|in|instanceof|is|isnt|let|loop|namespace|new|no|not|null|of|off|on|or|own|return|super|switch|then|this|throw|true|try|typeof|undefined|unless|until|when|while|window|with|yes|yield)\b/,
            'class-member': {
                pattern: /@(?!\d)\w+/,
                alias: 'variable'
            }
        });
        Prism.languages.insertBefore('coffeescript', 'comment', {
            'multiline-comment': {
                pattern: /###[\s\S]+?###/,
                alias: 'comment'
            },
            // Block regexp can contain comments and interpolation
            'block-regex': {
                pattern: /\/{3}[\s\S]*?\/{3}/,
                alias: 'regex',
                inside: {
                    comment: comment,
                    interpolation: interpolation
                }
            }
        });
        Prism.languages.insertBefore('coffeescript', 'string', {
            'inline-javascript': {
                pattern: /`(?:\\[\s\S]|[^\\`])*`/,
                inside: {
                    delimiter: {
                        pattern: /^`|`$/,
                        alias: 'punctuation'
                    },
                    script: {
                        pattern: /[\s\S]+/,
                        alias: 'language-javascript',
                        inside: Prism.languages.javascript
                    }
                }
            },
            // Block strings
            'multiline-string': [
                {
                    pattern: /'''[\s\S]*?'''/,
                    greedy: true,
                    alias: 'string'
                },
                {
                    pattern: /"""[\s\S]*?"""/,
                    greedy: true,
                    alias: 'string',
                    inside: {
                        interpolation: interpolation
                    }
                }
            ]
        });
        Prism.languages.insertBefore('coffeescript', 'keyword', {
            // Object property
            property: /(?!\d)\w+(?=\s*:(?!:))/
        });
        delete Prism.languages.coffeescript['template-string'];
        Prism.languages.coffee = Prism.languages.coffeescript;
    })(Prism);
}

});

parcelRegister("lJWMS", function(module, exports) {
'use strict';
module.exports = $fd3b66e4d285e84b$var$concurnas;
$fd3b66e4d285e84b$var$concurnas.displayName = 'concurnas';
$fd3b66e4d285e84b$var$concurnas.aliases = [
    'conc'
];
function $fd3b66e4d285e84b$var$concurnas(Prism) {
    Prism.languages.concurnas = {
        comment: {
            pattern: /(^|[^\\])(?:\/\*[\s\S]*?(?:\*\/|$)|\/\/.*)/,
            lookbehind: true,
            greedy: true
        },
        langext: {
            pattern: /\b\w+\s*\|\|[\s\S]+?\|\|/,
            greedy: true,
            inside: {
                'class-name': /^\w+/,
                string: {
                    pattern: /(^\s*\|\|)[\s\S]+(?=\|\|$)/,
                    lookbehind: true
                },
                punctuation: /\|\|/
            }
        },
        function: {
            pattern: /((?:^|\s)def[ \t]+)[a-zA-Z_]\w*(?=\s*\()/,
            lookbehind: true
        },
        keyword: /\b(?:abstract|actor|also|annotation|assert|async|await|bool|boolean|break|byte|case|catch|changed|char|class|closed|constant|continue|def|default|del|double|elif|else|enum|every|extends|false|finally|float|for|from|global|gpudef|gpukernel|if|import|in|init|inject|int|lambda|local|long|loop|match|new|nodefault|null|of|onchange|open|out|override|package|parfor|parforsync|post|pre|private|protected|provide|provider|public|return|shared|short|single|size_t|sizeof|super|sync|this|throw|trait|trans|transient|true|try|typedef|unchecked|using|val|var|void|while|with)\b/,
        boolean: /\b(?:false|true)\b/,
        number: /\b0b[01][01_]*L?\b|\b0x(?:[\da-f_]*\.)?[\da-f_p+-]+\b|(?:\b\d[\d_]*(?:\.[\d_]*)?|\B\.\d[\d_]*)(?:e[+-]?\d[\d_]*)?[dfls]?/i,
        punctuation: /[{}[\];(),.:]/,
        operator: /<==|>==|=>|->|<-|<>|&==|&<>|\?:?|\.\?|\+\+|--|[-+*/=<>]=?|[!^~]|\b(?:and|as|band|bor|bxor|comp|is|isnot|mod|or)\b=?/,
        annotation: {
            pattern: /@(?:\w+:)?(?:\w+|\[[^\]]+\])?/,
            alias: 'builtin'
        }
    };
    Prism.languages.insertBefore('concurnas', 'langext', {
        'regex-literal': {
            pattern: /\br("|')(?:\\.|(?!\1)[^\\\r\n])*\1/,
            greedy: true,
            inside: {
                interpolation: {
                    pattern: /((?:^|[^\\])(?:\\{2})*)\{(?:[^{}]|\{(?:[^{}]|\{[^}]*\})*\})+\}/,
                    lookbehind: true,
                    inside: Prism.languages.concurnas
                },
                regex: /[\s\S]+/
            }
        },
        'string-literal': {
            pattern: /(?:\B|\bs)("|')(?:\\.|(?!\1)[^\\\r\n])*\1/,
            greedy: true,
            inside: {
                interpolation: {
                    pattern: /((?:^|[^\\])(?:\\{2})*)\{(?:[^{}]|\{(?:[^{}]|\{[^}]*\})*\})+\}/,
                    lookbehind: true,
                    inside: Prism.languages.concurnas
                },
                string: /[\s\S]+/
            }
        }
    });
    Prism.languages.conc = Prism.languages.concurnas;
}

});

parcelRegister("1hYUn", function(module, exports) {
'use strict';
module.exports = $0f06a01cc0aff3d3$var$coq;
$0f06a01cc0aff3d3$var$coq.displayName = 'coq';
$0f06a01cc0aff3d3$var$coq.aliases = [];
function $0f06a01cc0aff3d3$var$coq(Prism) {
    (function(Prism) {
        // https://github.com/coq/coq
        var commentSource = /\(\*(?:[^(*]|\((?!\*)|\*(?!\))|<self>)*\*\)/.source;
        for(var i = 0; i < 2; i++)commentSource = commentSource.replace(/<self>/g, function() {
            return commentSource;
        });
        commentSource = commentSource.replace(/<self>/g, '[]');
        Prism.languages.coq = {
            comment: RegExp(commentSource),
            string: {
                pattern: /"(?:[^"]|"")*"(?!")/,
                greedy: true
            },
            attribute: [
                {
                    pattern: RegExp(/#\[(?:[^\[\]("]|"(?:[^"]|"")*"(?!")|\((?!\*)|<comment>)*\]/.source.replace(/<comment>/g, function() {
                        return commentSource;
                    })),
                    greedy: true,
                    alias: 'attr-name',
                    inside: {
                        comment: RegExp(commentSource),
                        string: {
                            pattern: /"(?:[^"]|"")*"(?!")/,
                            greedy: true
                        },
                        operator: /=/,
                        punctuation: /^#\[|\]$|[,()]/
                    }
                },
                {
                    pattern: /\b(?:Cumulative|Global|Local|Monomorphic|NonCumulative|Polymorphic|Private|Program)\b/,
                    alias: 'attr-name'
                }
            ],
            keyword: /\b(?:Abort|About|Add|Admit|Admitted|All|Arguments|As|Assumptions|Axiom|Axioms|Back|BackTo|Backtrace|BinOp|BinOpSpec|BinRel|Bind|Blacklist|Canonical|Case|Cd|Check|Class|Classes|Close|CoFixpoint|CoInductive|Coercion|Coercions|Collection|Combined|Compute|Conjecture|Conjectures|Constant|Constants|Constraint|Constructors|Context|Corollary|Create|CstOp|Custom|Cut|Debug|Declare|Defined|Definition|Delimit|Dependencies|Dependent|Derive|Diffs|Drop|Elimination|End|Entry|Equality|Eval|Example|Existential|Existentials|Existing|Export|Extern|Extraction|Fact|Fail|Field|File|Firstorder|Fixpoint|Flags|Focus|From|Funclass|Function|Functional|GC|Generalizable|Goal|Grab|Grammar|Graph|Guarded|Haskell|Heap|Hide|Hint|HintDb|Hints|Hypotheses|Hypothesis|IF|Identity|Immediate|Implicit|Implicits|Import|Include|Induction|Inductive|Infix|Info|Initial|InjTyp|Inline|Inspect|Instance|Instances|Intro|Intros|Inversion|Inversion_clear|JSON|Language|Left|Lemma|Let|Lia|Libraries|Library|Load|LoadPath|Locate|Ltac|Ltac2|ML|Match|Method|Minimality|Module|Modules|Morphism|Next|NoInline|Notation|Number|OCaml|Obligation|Obligations|Opaque|Open|Optimize|Parameter|Parameters|Parametric|Path|Paths|Prenex|Preterm|Primitive|Print|Profile|Projections|Proof|Prop|PropBinOp|PropOp|PropUOp|Property|Proposition|Pwd|Qed|Quit|Rec|Record|Recursive|Redirect|Reduction|Register|Relation|Remark|Remove|Require|Reserved|Reset|Resolve|Restart|Rewrite|Right|Ring|Rings|SProp|Saturate|Save|Scheme|Scope|Scopes|Search|SearchHead|SearchPattern|SearchRewrite|Section|Separate|Set|Setoid|Show|Signatures|Solve|Solver|Sort|Sortclass|Sorted|Spec|Step|Strategies|Strategy|String|Structure|SubClass|Subgraph|SuchThat|Tactic|Term|TestCompile|Theorem|Time|Timeout|To|Transparent|Type|Typeclasses|Types|Typing|UnOp|UnOpSpec|Undelimit|Undo|Unfocus|Unfocused|Unfold|Universe|Universes|Unshelve|Variable|Variables|Variant|Verbose|View|Visibility|Zify|_|apply|as|at|by|cofix|else|end|exists|exists2|fix|for|forall|fun|if|in|let|match|measure|move|removed|return|struct|then|using|wf|where|with)\b/,
            number: /\b(?:0x[a-f0-9][a-f0-9_]*(?:\.[a-f0-9_]+)?(?:p[+-]?\d[\d_]*)?|\d[\d_]*(?:\.[\d_]+)?(?:e[+-]?\d[\d_]*)?)\b/i,
            punct: {
                pattern: /@\{|\{\||\[=|:>/,
                alias: 'punctuation'
            },
            operator: /\/\\|\\\/|\.{2,3}|:{1,2}=|\*\*|[-=]>|<(?:->?|[+:=>]|<:)|>(?:=|->)|\|[-|]?|[-!%&*+/<=>?@^~']/,
            punctuation: /\.\(|`\(|@\{|`\{|\{\||\[=|:>|[:.,;(){}\[\]]/
        };
    })(Prism);
}

});

parcelRegister("fSH4P", function(module, exports) {
'use strict';

var $2jpWm = parcelRequire("2jpWm");
module.exports = $b8fd5058e8d69a86$var$crystal;
$b8fd5058e8d69a86$var$crystal.displayName = 'crystal';
$b8fd5058e8d69a86$var$crystal.aliases = [];
function $b8fd5058e8d69a86$var$crystal(Prism) {
    Prism.register($2jpWm);
    (function(Prism) {
        Prism.languages.crystal = Prism.languages.extend('ruby', {
            keyword: [
                /\b(?:__DIR__|__END_LINE__|__FILE__|__LINE__|abstract|alias|annotation|as|asm|begin|break|case|class|def|do|else|elsif|end|ensure|enum|extend|for|fun|if|ifdef|include|instance_sizeof|lib|macro|module|next|of|out|pointerof|private|protected|ptr|require|rescue|return|select|self|sizeof|struct|super|then|type|typeof|undef|uninitialized|union|unless|until|when|while|with|yield)\b/,
                {
                    pattern: /(\.\s*)(?:is_a|responds_to)\?/,
                    lookbehind: true
                }
            ],
            number: /\b(?:0b[01_]*[01]|0o[0-7_]*[0-7]|0x[\da-fA-F_]*[\da-fA-F]|(?:\d(?:[\d_]*\d)?)(?:\.[\d_]*\d)?(?:[eE][+-]?[\d_]*\d)?)(?:_(?:[uif](?:8|16|32|64))?)?\b/,
            operator: [
                /->/,
                Prism.languages.ruby.operator
            ],
            punctuation: /[(){}[\].,;\\]/
        });
        Prism.languages.insertBefore('crystal', 'string-literal', {
            attribute: {
                pattern: /@\[.*?\]/,
                inside: {
                    delimiter: {
                        pattern: /^@\[|\]$/,
                        alias: 'punctuation'
                    },
                    attribute: {
                        pattern: /^(\s*)\w+/,
                        lookbehind: true,
                        alias: 'class-name'
                    },
                    args: {
                        pattern: /\S(?:[\s\S]*\S)?/,
                        inside: Prism.languages.crystal
                    }
                }
            },
            expansion: {
                pattern: /\{(?:\{.*?\}|%.*?%)\}/,
                inside: {
                    content: {
                        pattern: /^(\{.)[\s\S]+(?=.\}$)/,
                        lookbehind: true,
                        inside: Prism.languages.crystal
                    },
                    delimiter: {
                        pattern: /^\{[\{%]|[\}%]\}$/,
                        alias: 'operator'
                    }
                }
            },
            char: {
                pattern: /'(?:[^\\\r\n]{1,2}|\\(?:.|u(?:[A-Fa-f0-9]{1,4}|\{[A-Fa-f0-9]{1,6}\})))'/,
                greedy: true
            }
        });
    })(Prism);
}

});
parcelRegister("2jpWm", function(module, exports) {
'use strict';
module.exports = $1af17a4dcbe59c31$var$ruby;
$1af17a4dcbe59c31$var$ruby.displayName = 'ruby';
$1af17a4dcbe59c31$var$ruby.aliases = [
    'rb'
];
function $1af17a4dcbe59c31$var$ruby(Prism) {
    (function(Prism) {
        Prism.languages.ruby = Prism.languages.extend('clike', {
            comment: {
                pattern: /#.*|^=begin\s[\s\S]*?^=end/m,
                greedy: true
            },
            'class-name': {
                pattern: /(\b(?:class|module)\s+|\bcatch\s+\()[\w.\\]+|\b[A-Z_]\w*(?=\s*\.\s*new\b)/,
                lookbehind: true,
                inside: {
                    punctuation: /[.\\]/
                }
            },
            keyword: /\b(?:BEGIN|END|alias|and|begin|break|case|class|def|define_method|defined|do|each|else|elsif|end|ensure|extend|for|if|in|include|module|new|next|nil|not|or|prepend|private|protected|public|raise|redo|require|rescue|retry|return|self|super|then|throw|undef|unless|until|when|while|yield)\b/,
            operator: /\.{2,3}|&\.|===|<?=>|[!=]?~|(?:&&|\|\||<<|>>|\*\*|[+\-*/%<>!^&|=])=?|[?:]/,
            punctuation: /[(){}[\].,;]/
        });
        Prism.languages.insertBefore('ruby', 'operator', {
            'double-colon': {
                pattern: /::/,
                alias: 'punctuation'
            }
        });
        var interpolation = {
            pattern: /((?:^|[^\\])(?:\\{2})*)#\{(?:[^{}]|\{[^{}]*\})*\}/,
            lookbehind: true,
            inside: {
                content: {
                    pattern: /^(#\{)[\s\S]+(?=\}$)/,
                    lookbehind: true,
                    inside: Prism.languages.ruby
                },
                delimiter: {
                    pattern: /^#\{|\}$/,
                    alias: 'punctuation'
                }
            }
        };
        delete Prism.languages.ruby.function;
        var percentExpression = '(?:' + [
            /([^a-zA-Z0-9\s{(\[<=])(?:(?!\1)[^\\]|\\[\s\S])*\1/.source,
            /\((?:[^()\\]|\\[\s\S]|\((?:[^()\\]|\\[\s\S])*\))*\)/.source,
            /\{(?:[^{}\\]|\\[\s\S]|\{(?:[^{}\\]|\\[\s\S])*\})*\}/.source,
            /\[(?:[^\[\]\\]|\\[\s\S]|\[(?:[^\[\]\\]|\\[\s\S])*\])*\]/.source,
            /<(?:[^<>\\]|\\[\s\S]|<(?:[^<>\\]|\\[\s\S])*>)*>/.source
        ].join('|') + ')';
        var symbolName = /(?:"(?:\\.|[^"\\\r\n])*"|(?:\b[a-zA-Z_]\w*|[^\s\0-\x7F]+)[?!]?|\$.)/.source;
        Prism.languages.insertBefore('ruby', 'keyword', {
            'regex-literal': [
                {
                    pattern: RegExp(/%r/.source + percentExpression + /[egimnosux]{0,6}/.source),
                    greedy: true,
                    inside: {
                        interpolation: interpolation,
                        regex: /[\s\S]+/
                    }
                },
                {
                    pattern: /(^|[^/])\/(?!\/)(?:\[[^\r\n\]]+\]|\\.|[^[/\\\r\n])+\/[egimnosux]{0,6}(?=\s*(?:$|[\r\n,.;})#]))/,
                    lookbehind: true,
                    greedy: true,
                    inside: {
                        interpolation: interpolation,
                        regex: /[\s\S]+/
                    }
                }
            ],
            variable: /[@$]+[a-zA-Z_]\w*(?:[?!]|\b)/,
            symbol: [
                {
                    pattern: RegExp(/(^|[^:]):/.source + symbolName),
                    lookbehind: true,
                    greedy: true
                },
                {
                    pattern: RegExp(/([\r\n{(,][ \t]*)/.source + symbolName + /(?=:(?!:))/.source),
                    lookbehind: true,
                    greedy: true
                }
            ],
            'method-definition': {
                pattern: /(\bdef\s+)\w+(?:\s*\.\s*\w+)?/,
                lookbehind: true,
                inside: {
                    function: /\b\w+$/,
                    keyword: /^self\b/,
                    'class-name': /^\w+/,
                    punctuation: /\./
                }
            }
        });
        Prism.languages.insertBefore('ruby', 'string', {
            'string-literal': [
                {
                    pattern: RegExp(/%[qQiIwWs]?/.source + percentExpression),
                    greedy: true,
                    inside: {
                        interpolation: interpolation,
                        string: /[\s\S]+/
                    }
                },
                {
                    pattern: /("|')(?:#\{[^}]+\}|#(?!\{)|\\(?:\r\n|[\s\S])|(?!\1)[^\\#\r\n])*\1/,
                    greedy: true,
                    inside: {
                        interpolation: interpolation,
                        string: /[\s\S]+/
                    }
                },
                {
                    pattern: /<<[-~]?([a-z_]\w*)[\r\n](?:.*[\r\n])*?[\t ]*\1/i,
                    alias: 'heredoc-string',
                    greedy: true,
                    inside: {
                        delimiter: {
                            pattern: /^<<[-~]?[a-z_]\w*|\b[a-z_]\w*$/i,
                            inside: {
                                symbol: /\b\w+/,
                                punctuation: /^<<[-~]?/
                            }
                        },
                        interpolation: interpolation,
                        string: /[\s\S]+/
                    }
                },
                {
                    pattern: /<<[-~]?'([a-z_]\w*)'[\r\n](?:.*[\r\n])*?[\t ]*\1/i,
                    alias: 'heredoc-string',
                    greedy: true,
                    inside: {
                        delimiter: {
                            pattern: /^<<[-~]?'[a-z_]\w*'|\b[a-z_]\w*$/i,
                            inside: {
                                symbol: /\b\w+/,
                                punctuation: /^<<[-~]?'|'$/
                            }
                        },
                        string: /[\s\S]+/
                    }
                }
            ],
            'command-literal': [
                {
                    pattern: RegExp(/%x/.source + percentExpression),
                    greedy: true,
                    inside: {
                        interpolation: interpolation,
                        command: {
                            pattern: /[\s\S]+/,
                            alias: 'string'
                        }
                    }
                },
                {
                    pattern: /`(?:#\{[^}]+\}|#(?!\{)|\\(?:\r\n|[\s\S])|[^\\`#\r\n])*`/,
                    greedy: true,
                    inside: {
                        interpolation: interpolation,
                        command: {
                            pattern: /[\s\S]+/,
                            alias: 'string'
                        }
                    }
                }
            ]
        });
        delete Prism.languages.ruby.string;
        Prism.languages.insertBefore('ruby', 'number', {
            builtin: /\b(?:Array|Bignum|Binding|Class|Continuation|Dir|Exception|FalseClass|File|Fixnum|Float|Hash|IO|Integer|MatchData|Method|Module|NilClass|Numeric|Object|Proc|Range|Regexp|Stat|String|Struct|Symbol|TMS|Thread|ThreadGroup|Time|TrueClass)\b/,
            constant: /\b[A-Z][A-Z0-9_]*(?:[?!]|\b)/
        });
        Prism.languages.rb = Prism.languages.ruby;
    })(Prism);
}

});


parcelRegister("ftjau", function(module, exports) {
'use strict';

var $kR0BX = parcelRequire("kR0BX");
module.exports = $b4386edbee766a8d$var$cshtml;
$b4386edbee766a8d$var$cshtml.displayName = 'cshtml';
$b4386edbee766a8d$var$cshtml.aliases = [
    'razor'
];
function $b4386edbee766a8d$var$cshtml(Prism) {
    Prism.register($kR0BX);
    (function(Prism) {
        var commentLike = /\/(?![/*])|\/\/.*[\r\n]|\/\*[^*]*(?:\*(?!\/)[^*]*)*\*\//.source;
        var stringLike = /@(?!")|"(?:[^\r\n\\"]|\\.)*"|@"(?:[^\\"]|""|\\[\s\S])*"(?!")/.source + '|' + /'(?:(?:[^\r\n'\\]|\\.|\\[Uux][\da-fA-F]{1,8})'|(?=[^\\](?!')))/.source;
        /**
     * Creates a nested pattern where all occurrences of the string `<<self>>` are replaced with the pattern itself.
     *
     * @param {string} pattern
     * @param {number} depthLog2
     * @returns {string}
     */ function nested(pattern, depthLog2) {
            for(var i = 0; i < depthLog2; i++)pattern = pattern.replace(/<self>/g, function() {
                return '(?:' + pattern + ')';
            });
            return pattern.replace(/<self>/g, '[^\\s\\S]').replace(/<str>/g, '(?:' + stringLike + ')').replace(/<comment>/g, '(?:' + commentLike + ')');
        }
        var round = nested(/\((?:[^()'"@/]|<str>|<comment>|<self>)*\)/.source, 2);
        var square = nested(/\[(?:[^\[\]'"@/]|<str>|<comment>|<self>)*\]/.source, 2);
        var curly = nested(/\{(?:[^{}'"@/]|<str>|<comment>|<self>)*\}/.source, 2);
        var angle = nested(/<(?:[^<>'"@/]|<str>|<comment>|<self>)*>/.source, 2) // Note about the above bracket patterns:
        ;
        // They all ignore HTML expressions that might be in the C# code. This is a problem because HTML (like strings and
        // comments) is parsed differently. This is a huge problem because HTML might contain brackets and quotes which
        // messes up the bracket and string counting implemented by the above patterns.
        //
        // This problem is not fixable because 1) HTML expression are highly context sensitive and very difficult to detect
        // and 2) they require one capturing group at every nested level. See the `tagRegion` pattern to admire the
        // complexity of an HTML expression.
        //
        // To somewhat alleviate the problem a bit, the patterns for characters (e.g. 'a') is very permissive, it also
        // allows invalid characters to support HTML expressions like this: <p>That's it!</p>.
        var tagAttrs = /(?:\s(?:\s*[^\s>\/=]+(?:\s*=\s*(?:"[^"]*"|'[^']*'|[^\s'">=]+(?=[\s>]))|(?=[\s/>])))+)?/.source;
        var tagContent = /(?!\d)[^\s>\/=$<%]+/.source + tagAttrs + /\s*\/?>/.source;
        var tagRegion = /\B@?/.source + '(?:' + /<([a-zA-Z][\w:]*)/.source + tagAttrs + /\s*>/.source + '(?:' + (/[^<]/.source + '|' + // all tags that are not the start tag
        // eslint-disable-next-line regexp/strict
        /<\/?(?!\1\b)/.source + tagContent + '|' + // nested start tag
        nested(// eslint-disable-next-line regexp/strict
        /<\1/.source + tagAttrs + /\s*>/.source + '(?:' + (/[^<]/.source + '|' + // all tags that are not the start tag
        // eslint-disable-next-line regexp/strict
        /<\/?(?!\1\b)/.source + tagContent + '|' + '<self>') + ')*' + // eslint-disable-next-line regexp/strict
        /<\/\1\s*>/.source, 2)) + ')*' + // eslint-disable-next-line regexp/strict
        /<\/\1\s*>/.source + '|' + /</.source + tagContent + ')' // Now for the actual language definition(s):
        ;
        //
        // Razor as a language has 2 parts:
        //  1) CSHTML: A markup-like language that has been extended with inline C# code expressions and blocks.
        //  2) C#+HTML: A variant of C# that can contain CSHTML tags as expressions.
        //
        // In the below code, both CSHTML and C#+HTML will be create as separate language definitions that reference each
        // other. However, only CSHTML will be exported via `Prism.languages`.
        Prism.languages.cshtml = Prism.languages.extend('markup', {});
        var csharpWithHtml = Prism.languages.insertBefore('csharp', 'string', {
            html: {
                pattern: RegExp(tagRegion),
                greedy: true,
                inside: Prism.languages.cshtml
            }
        }, {
            csharp: Prism.languages.extend('csharp', {})
        });
        var cs = {
            pattern: /\S[\s\S]*/,
            alias: 'language-csharp',
            inside: csharpWithHtml
        };
        Prism.languages.insertBefore('cshtml', 'prolog', {
            'razor-comment': {
                pattern: /@\*[\s\S]*?\*@/,
                greedy: true,
                alias: 'comment'
            },
            block: {
                pattern: RegExp(/(^|[^@])@/.source + '(?:' + [
                    // @{ ... }
                    curly,
                    /(?:code|functions)\s*/.source + curly,
                    /(?:for|foreach|lock|switch|using|while)\s*/.source + round + /\s*/.source + curly,
                    /do\s*/.source + curly + /\s*while\s*/.source + round + /(?:\s*;)?/.source,
                    /try\s*/.source + curly + /\s*catch\s*/.source + round + /\s*/.source + curly + /\s*finally\s*/.source + curly,
                    /if\s*/.source + round + /\s*/.source + curly + '(?:' + /\s*else/.source + '(?:' + /\s+if\s*/.source + round + ')?' + /\s*/.source + curly + ')*'
                ].join('|') + ')'),
                lookbehind: true,
                greedy: true,
                inside: {
                    keyword: /^@\w*/,
                    csharp: cs
                }
            },
            directive: {
                pattern: /^([ \t]*)@(?:addTagHelper|attribute|implements|inherits|inject|layout|model|namespace|page|preservewhitespace|removeTagHelper|section|tagHelperPrefix|using)(?=\s).*/m,
                lookbehind: true,
                greedy: true,
                inside: {
                    keyword: /^@\w+/,
                    csharp: cs
                }
            },
            value: {
                pattern: RegExp(/(^|[^@])@/.source + /(?:await\b\s*)?/.source + '(?:' + /\w+\b/.source + '|' + round + ')' + '(?:' + /[?!]?\.\w+\b/.source + '|' + round + '|' + square + '|' + angle + round + ')*'),
                lookbehind: true,
                greedy: true,
                alias: 'variable',
                inside: {
                    keyword: /^@/,
                    csharp: cs
                }
            },
            'delegate-operator': {
                pattern: /(^|[^@])@(?=<)/,
                lookbehind: true,
                alias: 'operator'
            }
        });
        Prism.languages.razor = Prism.languages.cshtml;
    })(Prism);
}

});

parcelRegister("bylrX", function(module, exports) {
'use strict';
module.exports = $8693822dc2014622$var$csp;
$8693822dc2014622$var$csp.displayName = 'csp';
$8693822dc2014622$var$csp.aliases = [];
function $8693822dc2014622$var$csp(Prism) {
    (function(Prism) {
        /**
     * @param {string} source
     * @returns {RegExp}
     */ function value(source) {
            return RegExp(/([ \t])/.source + '(?:' + source + ')' + /(?=[\s;]|$)/.source, 'i');
        }
        Prism.languages.csp = {
            directive: {
                pattern: /(^|[\s;])(?:base-uri|block-all-mixed-content|(?:child|connect|default|font|frame|img|manifest|media|object|prefetch|script|style|worker)-src|disown-opener|form-action|frame-(?:ancestors|options)|input-protection(?:-(?:clip|selectors))?|navigate-to|plugin-types|policy-uri|referrer|reflected-xss|report-(?:to|uri)|require-sri-for|sandbox|(?:script|style)-src-(?:attr|elem)|upgrade-insecure-requests)(?=[\s;]|$)/i,
                lookbehind: true,
                alias: 'property'
            },
            scheme: {
                pattern: value(/[a-z][a-z0-9.+-]*:/.source),
                lookbehind: true
            },
            none: {
                pattern: value(/'none'/.source),
                lookbehind: true,
                alias: 'keyword'
            },
            nonce: {
                pattern: value(/'nonce-[-+/\w=]+'/.source),
                lookbehind: true,
                alias: 'number'
            },
            hash: {
                pattern: value(/'sha(?:256|384|512)-[-+/\w=]+'/.source),
                lookbehind: true,
                alias: 'number'
            },
            host: {
                pattern: value(/[a-z][a-z0-9.+-]*:\/\/[^\s;,']*/.source + '|' + /\*[^\s;,']*/.source + '|' + /[a-z0-9-]+(?:\.[a-z0-9-]+)+(?::[\d*]+)?(?:\/[^\s;,']*)?/.source),
                lookbehind: true,
                alias: 'url',
                inside: {
                    important: /\*/
                }
            },
            keyword: [
                {
                    pattern: value(/'unsafe-[a-z-]+'/.source),
                    lookbehind: true,
                    alias: 'unsafe'
                },
                {
                    pattern: value(/'[a-z-]+'/.source),
                    lookbehind: true,
                    alias: 'safe'
                }
            ],
            punctuation: /;/
        };
    })(Prism);
}

});

parcelRegister("j4tOO", function(module, exports) {
'use strict';
module.exports = $de2585606f6bc696$var$cssExtras;
$de2585606f6bc696$var$cssExtras.displayName = 'cssExtras';
$de2585606f6bc696$var$cssExtras.aliases = [];
function $de2585606f6bc696$var$cssExtras(Prism) {
    (function(Prism) {
        var string = /("|')(?:\\(?:\r\n|[\s\S])|(?!\1)[^\\\r\n])*\1/;
        var selectorInside;
        Prism.languages.css.selector = {
            pattern: Prism.languages.css.selector.pattern,
            lookbehind: true,
            inside: selectorInside = {
                'pseudo-element': /:(?:after|before|first-letter|first-line|selection)|::[-\w]+/,
                'pseudo-class': /:[-\w]+/,
                class: /\.[-\w]+/,
                id: /#[-\w]+/,
                attribute: {
                    pattern: RegExp('\\[(?:[^[\\]"\']|' + string.source + ')*\\]'),
                    greedy: true,
                    inside: {
                        punctuation: /^\[|\]$/,
                        'case-sensitivity': {
                            pattern: /(\s)[si]$/i,
                            lookbehind: true,
                            alias: 'keyword'
                        },
                        namespace: {
                            pattern: /^(\s*)(?:(?!\s)[-*\w\xA0-\uFFFF])*\|(?!=)/,
                            lookbehind: true,
                            inside: {
                                punctuation: /\|$/
                            }
                        },
                        'attr-name': {
                            pattern: /^(\s*)(?:(?!\s)[-\w\xA0-\uFFFF])+/,
                            lookbehind: true
                        },
                        'attr-value': [
                            string,
                            {
                                pattern: /(=\s*)(?:(?!\s)[-\w\xA0-\uFFFF])+(?=\s*$)/,
                                lookbehind: true
                            }
                        ],
                        operator: /[|~*^$]?=/
                    }
                },
                'n-th': [
                    {
                        pattern: /(\(\s*)[+-]?\d*[\dn](?:\s*[+-]\s*\d+)?(?=\s*\))/,
                        lookbehind: true,
                        inside: {
                            number: /[\dn]+/,
                            operator: /[+-]/
                        }
                    },
                    {
                        pattern: /(\(\s*)(?:even|odd)(?=\s*\))/i,
                        lookbehind: true
                    }
                ],
                combinator: />|\+|~|\|\|/,
                // the `tag` token has been existed and removed.
                // because we can't find a perfect tokenize to match it.
                // if you want to add it, please read https://github.com/PrismJS/prism/pull/2373 first.
                punctuation: /[(),]/
            }
        };
        Prism.languages.css['atrule'].inside['selector-function-argument'].inside = selectorInside;
        Prism.languages.insertBefore('css', 'property', {
            variable: {
                pattern: /(^|[^-\w\xA0-\uFFFF])--(?!\s)[-_a-z\xA0-\uFFFF](?:(?!\s)[-\w\xA0-\uFFFF])*/i,
                lookbehind: true
            }
        });
        var unit = {
            pattern: /(\b\d+)(?:%|[a-z]+(?![\w-]))/,
            lookbehind: true
        } // 123 -123 .123 -.123 12.3 -12.3
        ;
        var number = {
            pattern: /(^|[^\w.-])-?(?:\d+(?:\.\d+)?|\.\d+)/,
            lookbehind: true
        };
        Prism.languages.insertBefore('css', 'function', {
            operator: {
                pattern: /(\s)[+\-*\/](?=\s)/,
                lookbehind: true
            },
            // CAREFUL!
            // Previewers and Inline color use hexcode and color.
            hexcode: {
                pattern: /\B#[\da-f]{3,8}\b/i,
                alias: 'color'
            },
            color: [
                {
                    pattern: /(^|[^\w-])(?:AliceBlue|AntiqueWhite|Aqua|Aquamarine|Azure|Beige|Bisque|Black|BlanchedAlmond|Blue|BlueViolet|Brown|BurlyWood|CadetBlue|Chartreuse|Chocolate|Coral|CornflowerBlue|Cornsilk|Crimson|Cyan|DarkBlue|DarkCyan|DarkGoldenRod|DarkGr[ae]y|DarkGreen|DarkKhaki|DarkMagenta|DarkOliveGreen|DarkOrange|DarkOrchid|DarkRed|DarkSalmon|DarkSeaGreen|DarkSlateBlue|DarkSlateGr[ae]y|DarkTurquoise|DarkViolet|DeepPink|DeepSkyBlue|DimGr[ae]y|DodgerBlue|FireBrick|FloralWhite|ForestGreen|Fuchsia|Gainsboro|GhostWhite|Gold|GoldenRod|Gr[ae]y|Green|GreenYellow|HoneyDew|HotPink|IndianRed|Indigo|Ivory|Khaki|Lavender|LavenderBlush|LawnGreen|LemonChiffon|LightBlue|LightCoral|LightCyan|LightGoldenRodYellow|LightGr[ae]y|LightGreen|LightPink|LightSalmon|LightSeaGreen|LightSkyBlue|LightSlateGr[ae]y|LightSteelBlue|LightYellow|Lime|LimeGreen|Linen|Magenta|Maroon|MediumAquaMarine|MediumBlue|MediumOrchid|MediumPurple|MediumSeaGreen|MediumSlateBlue|MediumSpringGreen|MediumTurquoise|MediumVioletRed|MidnightBlue|MintCream|MistyRose|Moccasin|NavajoWhite|Navy|OldLace|Olive|OliveDrab|Orange|OrangeRed|Orchid|PaleGoldenRod|PaleGreen|PaleTurquoise|PaleVioletRed|PapayaWhip|PeachPuff|Peru|Pink|Plum|PowderBlue|Purple|Red|RosyBrown|RoyalBlue|SaddleBrown|Salmon|SandyBrown|SeaGreen|SeaShell|Sienna|Silver|SkyBlue|SlateBlue|SlateGr[ae]y|Snow|SpringGreen|SteelBlue|Tan|Teal|Thistle|Tomato|Transparent|Turquoise|Violet|Wheat|White|WhiteSmoke|Yellow|YellowGreen)(?![\w-])/i,
                    lookbehind: true
                },
                {
                    pattern: /\b(?:hsl|rgb)\(\s*\d{1,3}\s*,\s*\d{1,3}%?\s*,\s*\d{1,3}%?\s*\)\B|\b(?:hsl|rgb)a\(\s*\d{1,3}\s*,\s*\d{1,3}%?\s*,\s*\d{1,3}%?\s*,\s*(?:0|0?\.\d+|1)\s*\)\B/i,
                    inside: {
                        unit: unit,
                        number: number,
                        function: /[\w-]+(?=\()/,
                        punctuation: /[(),]/
                    }
                }
            ],
            // it's important that there is no boundary assertion after the hex digits
            entity: /\\[\da-f]{1,8}/i,
            unit: unit,
            number: number
        });
    })(Prism);
}

});

parcelRegister("5bKmo", function(module, exports) {
'use strict';
module.exports = $3c71f100438d34e1$var$csv;
$3c71f100438d34e1$var$csv.displayName = 'csv';
$3c71f100438d34e1$var$csv.aliases = [];
function $3c71f100438d34e1$var$csv(Prism) {
    // https://tools.ietf.org/html/rfc4180
    Prism.languages.csv = {
        value: /[^\r\n,"]+|"(?:[^"]|"")*"(?!")/,
        punctuation: /,/
    };
}

});

parcelRegister("ibnGi", function(module, exports) {
'use strict';
module.exports = $d3cb9fa96c6e69f9$var$cypher;
$d3cb9fa96c6e69f9$var$cypher.displayName = 'cypher';
$d3cb9fa96c6e69f9$var$cypher.aliases = [];
function $d3cb9fa96c6e69f9$var$cypher(Prism) {
    Prism.languages.cypher = {
        // https://neo4j.com/docs/cypher-manual/current/syntax/comments/
        comment: /\/\/.*/,
        string: {
            pattern: /"(?:[^"\\\r\n]|\\.)*"|'(?:[^'\\\r\n]|\\.)*'/,
            greedy: true
        },
        'class-name': {
            pattern: /(:\s*)(?:\w+|`(?:[^`\\\r\n])*`)(?=\s*[{):])/,
            lookbehind: true,
            greedy: true
        },
        relationship: {
            pattern: /(-\[\s*(?:\w+\s*|`(?:[^`\\\r\n])*`\s*)?:\s*|\|\s*:\s*)(?:\w+|`(?:[^`\\\r\n])*`)/,
            lookbehind: true,
            greedy: true,
            alias: 'property'
        },
        identifier: {
            pattern: /`(?:[^`\\\r\n])*`/,
            greedy: true
        },
        variable: /\$\w+/,
        // https://neo4j.com/docs/cypher-manual/current/syntax/reserved/
        keyword: /\b(?:ADD|ALL|AND|AS|ASC|ASCENDING|ASSERT|BY|CALL|CASE|COMMIT|CONSTRAINT|CONTAINS|CREATE|CSV|DELETE|DESC|DESCENDING|DETACH|DISTINCT|DO|DROP|ELSE|END|ENDS|EXISTS|FOR|FOREACH|IN|INDEX|IS|JOIN|KEY|LIMIT|LOAD|MANDATORY|MATCH|MERGE|NODE|NOT|OF|ON|OPTIONAL|OR|ORDER(?=\s+BY)|PERIODIC|REMOVE|REQUIRE|RETURN|SCALAR|SCAN|SET|SKIP|START|STARTS|THEN|UNION|UNIQUE|UNWIND|USING|WHEN|WHERE|WITH|XOR|YIELD)\b/i,
        function: /\b\w+\b(?=\s*\()/,
        boolean: /\b(?:false|null|true)\b/i,
        number: /\b(?:0x[\da-fA-F]+|\d+(?:\.\d+)?(?:[eE][+-]?\d+)?)\b/,
        // https://neo4j.com/docs/cypher-manual/current/syntax/operators/
        operator: /:|<--?|--?>?|<>|=~?|[<>]=?|[+*/%^|]|\.\.\.?/,
        punctuation: /[()[\]{},;.]/
    };
}

});

parcelRegister("i1Hs3", function(module, exports) {
'use strict';
module.exports = $d1fa068d5ede2df6$var$d;
$d1fa068d5ede2df6$var$d.displayName = 'd';
$d1fa068d5ede2df6$var$d.aliases = [];
function $d1fa068d5ede2df6$var$d(Prism) {
    Prism.languages.d = Prism.languages.extend('clike', {
        comment: [
            {
                // Shebang
                pattern: /^\s*#!.+/,
                greedy: true
            },
            {
                pattern: RegExp(/(^|[^\\])/.source + '(?:' + [
                    // /+ comment +/
                    // Allow one level of nesting
                    /\/\+(?:\/\+(?:[^+]|\+(?!\/))*\+\/|(?!\/\+)[\s\S])*?\+\//.source,
                    /\/\/.*/.source,
                    /\/\*[\s\S]*?\*\//.source
                ].join('|') + ')'),
                lookbehind: true,
                greedy: true
            }
        ],
        string: [
            {
                pattern: RegExp([
                    // r"", x""
                    /\b[rx]"(?:\\[\s\S]|[^\\"])*"[cwd]?/.source,
                    /\bq"(?:\[[\s\S]*?\]|\([\s\S]*?\)|<[\s\S]*?>|\{[\s\S]*?\})"/.source,
                    // ...
                    // IDENT"
                    /\bq"((?!\d)\w+)$[\s\S]*?^\1"/.source,
                    // eslint-disable-next-line regexp/strict
                    /\bq"(.)[\s\S]*?\2"/.source,
                    /(["`])(?:\\[\s\S]|(?!\3)[^\\])*\3[cwd]?/.source
                ].join('|'), 'm'),
                greedy: true
            },
            {
                pattern: /\bq\{(?:\{[^{}]*\}|[^{}])*\}/,
                greedy: true,
                alias: 'token-string'
            }
        ],
        // In order: $, keywords and special tokens, globally defined symbols
        keyword: /\$|\b(?:__(?:(?:DATE|EOF|FILE|FUNCTION|LINE|MODULE|PRETTY_FUNCTION|TIMESTAMP|TIME|VENDOR|VERSION)__|gshared|parameters|traits|vector)|abstract|alias|align|asm|assert|auto|body|bool|break|byte|case|cast|catch|cdouble|cent|cfloat|char|class|const|continue|creal|dchar|debug|default|delegate|delete|deprecated|do|double|dstring|else|enum|export|extern|false|final|finally|float|for|foreach|foreach_reverse|function|goto|idouble|if|ifloat|immutable|import|inout|int|interface|invariant|ireal|lazy|long|macro|mixin|module|new|nothrow|null|out|override|package|pragma|private|protected|ptrdiff_t|public|pure|real|ref|return|scope|shared|short|size_t|static|string|struct|super|switch|synchronized|template|this|throw|true|try|typedef|typeid|typeof|ubyte|ucent|uint|ulong|union|unittest|ushort|version|void|volatile|wchar|while|with|wstring)\b/,
        number: [
            // The lookbehind and the negative look-ahead try to prevent bad highlighting of the .. operator
            // Hexadecimal numbers must be handled separately to avoid problems with exponent "e"
            /\b0x\.?[a-f\d_]+(?:(?!\.\.)\.[a-f\d_]*)?(?:p[+-]?[a-f\d_]+)?[ulfi]{0,4}/i,
            {
                pattern: /((?:\.\.)?)(?:\b0b\.?|\b|\.)\d[\d_]*(?:(?!\.\.)\.[\d_]*)?(?:e[+-]?\d[\d_]*)?[ulfi]{0,4}/i,
                lookbehind: true
            }
        ],
        operator: /\|[|=]?|&[&=]?|\+[+=]?|-[-=]?|\.?\.\.|=[>=]?|!(?:i[ns]\b|<>?=?|>=?|=)?|\bi[ns]\b|(?:<[<>]?|>>?>?|\^\^|[*\/%^~])=?/
    });
    Prism.languages.insertBefore('d', 'string', {
        // Characters
        // 'a', '\\', '\n', '\xFF', '\377', '\uFFFF', '\U0010FFFF', '\quot'
        char: /'(?:\\(?:\W|\w+)|[^\\])'/
    });
    Prism.languages.insertBefore('d', 'keyword', {
        property: /\B@\w*/
    });
    Prism.languages.insertBefore('d', 'function', {
        register: {
            // Iasm registers
            pattern: /\b(?:[ABCD][LHX]|E?(?:BP|DI|SI|SP)|[BS]PL|[ECSDGF]S|CR[0234]|[DS]IL|DR[012367]|E[ABCD]X|X?MM[0-7]|R(?:1[0-5]|[89])[BWD]?|R[ABCD]X|R[BS]P|R[DS]I|TR[3-7]|XMM(?:1[0-5]|[89])|YMM(?:1[0-5]|\d))\b|\bST(?:\([0-7]\)|\b)/,
            alias: 'variable'
        }
    });
}

});

parcelRegister("dCoif", function(module, exports) {
'use strict';
module.exports = $9ea1ab1930553260$var$dart;
$9ea1ab1930553260$var$dart.displayName = 'dart';
$9ea1ab1930553260$var$dart.aliases = [];
function $9ea1ab1930553260$var$dart(Prism) {
    (function(Prism) {
        var keywords = [
            /\b(?:async|sync|yield)\*/,
            /\b(?:abstract|assert|async|await|break|case|catch|class|const|continue|covariant|default|deferred|do|dynamic|else|enum|export|extends|extension|external|factory|final|finally|for|get|hide|if|implements|import|in|interface|library|mixin|new|null|on|operator|part|rethrow|return|set|show|static|super|switch|sync|this|throw|try|typedef|var|void|while|with|yield)\b/
        ] // Handles named imports, such as http.Client
        ;
        var packagePrefix = /(^|[^\w.])(?:[a-z]\w*\s*\.\s*)*(?:[A-Z]\w*\s*\.\s*)*/.source // based on the dart naming conventions
        ;
        var className = {
            pattern: RegExp(packagePrefix + /[A-Z](?:[\d_A-Z]*[a-z]\w*)?\b/.source),
            lookbehind: true,
            inside: {
                namespace: {
                    pattern: /^[a-z]\w*(?:\s*\.\s*[a-z]\w*)*(?:\s*\.)?/,
                    inside: {
                        punctuation: /\./
                    }
                }
            }
        };
        Prism.languages.dart = Prism.languages.extend('clike', {
            'class-name': [
                className,
                {
                    // variables and parameters
                    // this to support class names (or generic parameters) which do not contain a lower case letter (also works for methods)
                    pattern: RegExp(packagePrefix + /[A-Z]\w*(?=\s+\w+\s*[;,=()])/.source),
                    lookbehind: true,
                    inside: className.inside
                }
            ],
            keyword: keywords,
            operator: /\bis!|\b(?:as|is)\b|\+\+|--|&&|\|\||<<=?|>>=?|~(?:\/=?)?|[+\-*\/%&^|=!<>]=?|\?/
        });
        Prism.languages.insertBefore('dart', 'string', {
            'string-literal': {
                pattern: /r?(?:("""|''')[\s\S]*?\1|(["'])(?:\\.|(?!\2)[^\\\r\n])*\2(?!\2))/,
                greedy: true,
                inside: {
                    interpolation: {
                        pattern: /((?:^|[^\\])(?:\\{2})*)\$(?:\w+|\{(?:[^{}]|\{[^{}]*\})*\})/,
                        lookbehind: true,
                        inside: {
                            punctuation: /^\$\{?|\}$/,
                            expression: {
                                pattern: /[\s\S]+/,
                                inside: Prism.languages.dart
                            }
                        }
                    },
                    string: /[\s\S]+/
                }
            },
            string: undefined
        });
        Prism.languages.insertBefore('dart', 'class-name', {
            metadata: {
                pattern: /@\w+/,
                alias: 'function'
            }
        });
        Prism.languages.insertBefore('dart', 'class-name', {
            generics: {
                pattern: /<(?:[\w\s,.&?]|<(?:[\w\s,.&?]|<(?:[\w\s,.&?]|<[\w\s,.&?]*>)*>)*>)*>/,
                inside: {
                    'class-name': className,
                    keyword: keywords,
                    punctuation: /[<>(),.:]/,
                    operator: /[?&|]/
                }
            }
        });
    })(Prism);
}

});

parcelRegister("gZhLI", function(module, exports) {
'use strict';
module.exports = $c5e0204fa380a26e$var$dataweave;
$c5e0204fa380a26e$var$dataweave.displayName = 'dataweave';
$c5e0204fa380a26e$var$dataweave.aliases = [];
function $c5e0204fa380a26e$var$dataweave(Prism) {
    (function(Prism) {
        Prism.languages.dataweave = {
            url: /\b[A-Za-z]+:\/\/[\w/:.?=&-]+|\burn:[\w:.?=&-]+/,
            property: {
                pattern: /(?:\b\w+#)?(?:"(?:\\.|[^\\"\r\n])*"|\b\w+)(?=\s*[:@])/,
                greedy: true
            },
            string: {
                pattern: /(["'`])(?:\\[\s\S]|(?!\1)[^\\])*\1/,
                greedy: true
            },
            'mime-type': /\b(?:application|audio|image|multipart|text|video)\/[\w+-]+/,
            date: {
                pattern: /\|[\w:+-]+\|/,
                greedy: true
            },
            comment: [
                {
                    pattern: /(^|[^\\])\/\*[\s\S]*?(?:\*\/|$)/,
                    lookbehind: true,
                    greedy: true
                },
                {
                    pattern: /(^|[^\\:])\/\/.*/,
                    lookbehind: true,
                    greedy: true
                }
            ],
            regex: {
                pattern: /\/(?:[^\\\/\r\n]|\\[^\r\n])+\//,
                greedy: true
            },
            keyword: /\b(?:and|as|at|case|do|else|fun|if|input|is|match|not|ns|null|or|output|type|unless|update|using|var)\b/,
            function: /\b[A-Z_]\w*(?=\s*\()/i,
            number: /-?\b\d+(?:\.\d+)?(?:e[+-]?\d+)?\b/i,
            punctuation: /[{}[\];(),.:@]/,
            operator: /<<|>>|->|[<>~=]=?|!=|--?-?|\+\+?|!|\?/,
            boolean: /\b(?:false|true)\b/
        };
    })(Prism);
}

});

parcelRegister("34JIo", function(module, exports) {
'use strict';
module.exports = $23d534dbaf9f0f3d$var$dax;
$23d534dbaf9f0f3d$var$dax.displayName = 'dax';
$23d534dbaf9f0f3d$var$dax.aliases = [];
function $23d534dbaf9f0f3d$var$dax(Prism) {
    Prism.languages.dax = {
        comment: {
            pattern: /(^|[^\\])(?:\/\*[\s\S]*?\*\/|(?:--|\/\/).*)/,
            lookbehind: true
        },
        'data-field': {
            pattern: /'(?:[^']|'')*'(?!')(?:\[[ \w\xA0-\uFFFF]+\])?|\w+\[[ \w\xA0-\uFFFF]+\]/,
            alias: 'symbol'
        },
        measure: {
            pattern: /\[[ \w\xA0-\uFFFF]+\]/,
            alias: 'constant'
        },
        string: {
            pattern: /"(?:[^"]|"")*"(?!")/,
            greedy: true
        },
        function: /\b(?:ABS|ACOS|ACOSH|ACOT|ACOTH|ADDCOLUMNS|ADDMISSINGITEMS|ALL|ALLCROSSFILTERED|ALLEXCEPT|ALLNOBLANKROW|ALLSELECTED|AND|APPROXIMATEDISTINCTCOUNT|ASIN|ASINH|ATAN|ATANH|AVERAGE|AVERAGEA|AVERAGEX|BETA\.DIST|BETA\.INV|BLANK|CALCULATE|CALCULATETABLE|CALENDAR|CALENDARAUTO|CEILING|CHISQ\.DIST|CHISQ\.DIST\.RT|CHISQ\.INV|CHISQ\.INV\.RT|CLOSINGBALANCEMONTH|CLOSINGBALANCEQUARTER|CLOSINGBALANCEYEAR|COALESCE|COMBIN|COMBINA|COMBINEVALUES|CONCATENATE|CONCATENATEX|CONFIDENCE\.NORM|CONFIDENCE\.T|CONTAINS|CONTAINSROW|CONTAINSSTRING|CONTAINSSTRINGEXACT|CONVERT|COS|COSH|COT|COTH|COUNT|COUNTA|COUNTAX|COUNTBLANK|COUNTROWS|COUNTX|CROSSFILTER|CROSSJOIN|CURRENCY|CURRENTGROUP|CUSTOMDATA|DATATABLE|DATE|DATEADD|DATEDIFF|DATESBETWEEN|DATESINPERIOD|DATESMTD|DATESQTD|DATESYTD|DATEVALUE|DAY|DEGREES|DETAILROWS|DISTINCT|DISTINCTCOUNT|DISTINCTCOUNTNOBLANK|DIVIDE|EARLIER|EARLIEST|EDATE|ENDOFMONTH|ENDOFQUARTER|ENDOFYEAR|EOMONTH|ERROR|EVEN|EXACT|EXCEPT|EXP|EXPON\.DIST|FACT|FALSE|FILTER|FILTERS|FIND|FIRSTDATE|FIRSTNONBLANK|FIRSTNONBLANKVALUE|FIXED|FLOOR|FORMAT|GCD|GENERATE|GENERATEALL|GENERATESERIES|GEOMEAN|GEOMEANX|GROUPBY|HASONEFILTER|HASONEVALUE|HOUR|IF|IF\.EAGER|IFERROR|IGNORE|INT|INTERSECT|ISBLANK|ISCROSSFILTERED|ISEMPTY|ISERROR|ISEVEN|ISFILTERED|ISINSCOPE|ISLOGICAL|ISNONTEXT|ISNUMBER|ISO\.CEILING|ISODD|ISONORAFTER|ISSELECTEDMEASURE|ISSUBTOTAL|ISTEXT|KEEPFILTERS|KEYWORDMATCH|LASTDATE|LASTNONBLANK|LASTNONBLANKVALUE|LCM|LEFT|LEN|LN|LOG|LOG10|LOOKUPVALUE|LOWER|MAX|MAXA|MAXX|MEDIAN|MEDIANX|MID|MIN|MINA|MINUTE|MINX|MOD|MONTH|MROUND|NATURALINNERJOIN|NATURALLEFTOUTERJOIN|NEXTDAY|NEXTMONTH|NEXTQUARTER|NEXTYEAR|NONVISUAL|NORM\.DIST|NORM\.INV|NORM\.S\.DIST|NORM\.S\.INV|NOT|NOW|ODD|OPENINGBALANCEMONTH|OPENINGBALANCEQUARTER|OPENINGBALANCEYEAR|OR|PARALLELPERIOD|PATH|PATHCONTAINS|PATHITEM|PATHITEMREVERSE|PATHLENGTH|PERCENTILE\.EXC|PERCENTILE\.INC|PERCENTILEX\.EXC|PERCENTILEX\.INC|PERMUT|PI|POISSON\.DIST|POWER|PREVIOUSDAY|PREVIOUSMONTH|PREVIOUSQUARTER|PREVIOUSYEAR|PRODUCT|PRODUCTX|QUARTER|QUOTIENT|RADIANS|RAND|RANDBETWEEN|RANK\.EQ|RANKX|RELATED|RELATEDTABLE|REMOVEFILTERS|REPLACE|REPT|RIGHT|ROLLUP|ROLLUPADDISSUBTOTAL|ROLLUPGROUP|ROLLUPISSUBTOTAL|ROUND|ROUNDDOWN|ROUNDUP|ROW|SAMEPERIODLASTYEAR|SAMPLE|SEARCH|SECOND|SELECTCOLUMNS|SELECTEDMEASURE|SELECTEDMEASUREFORMATSTRING|SELECTEDMEASURENAME|SELECTEDVALUE|SIGN|SIN|SINH|SQRT|SQRTPI|STARTOFMONTH|STARTOFQUARTER|STARTOFYEAR|STDEV\.P|STDEV\.S|STDEVX\.P|STDEVX\.S|SUBSTITUTE|SUBSTITUTEWITHINDEX|SUM|SUMMARIZE|SUMMARIZECOLUMNS|SUMX|SWITCH|T\.DIST|T\.DIST\.2T|T\.DIST\.RT|T\.INV|T\.INV\.2T|TAN|TANH|TIME|TIMEVALUE|TODAY|TOPN|TOPNPERLEVEL|TOPNSKIP|TOTALMTD|TOTALQTD|TOTALYTD|TREATAS|TRIM|TRUE|TRUNC|UNICHAR|UNICODE|UNION|UPPER|USERELATIONSHIP|USERNAME|USEROBJECTID|USERPRINCIPALNAME|UTCNOW|UTCTODAY|VALUE|VALUES|VAR\.P|VAR\.S|VARX\.P|VARX\.S|WEEKDAY|WEEKNUM|XIRR|XNPV|YEAR|YEARFRAC)(?=\s*\()/i,
        keyword: /\b(?:DEFINE|EVALUATE|MEASURE|ORDER\s+BY|RETURN|VAR|START\s+AT|ASC|DESC)\b/i,
        boolean: {
            pattern: /\b(?:FALSE|NULL|TRUE)\b/i,
            alias: 'constant'
        },
        number: /\b\d+(?:\.\d*)?|\B\.\d+\b/,
        operator: /:=|[-+*\/=^]|&&?|\|\||<(?:=>?|<|>)?|>[>=]?|\b(?:IN|NOT)\b/i,
        punctuation: /[;\[\](){}`,.]/
    };
}

});

parcelRegister("lSMkw", function(module, exports) {
'use strict';
module.exports = $fee421797d9afda1$var$dhall;
$fee421797d9afda1$var$dhall.displayName = 'dhall';
$fee421797d9afda1$var$dhall.aliases = [];
function $fee421797d9afda1$var$dhall(Prism) {
    // ABNF grammar:
    // https://github.com/dhall-lang/dhall-lang/blob/master/standard/dhall.abnf
    Prism.languages.dhall = {
        // Multi-line comments can be nested. E.g. {- foo {- bar -} -}
        // The multi-line pattern is essentially this:
        //   \{-(?:[^-{]|-(?!\})|\{(?!-)|<SELF>)*-\}
        comment: /--.*|\{-(?:[^-{]|-(?!\})|\{(?!-)|\{-(?:[^-{]|-(?!\})|\{(?!-))*-\})*-\}/,
        string: {
            pattern: /"(?:[^"\\]|\\.)*"|''(?:[^']|'(?!')|'''|''\$\{)*''(?!'|\$)/,
            greedy: true,
            inside: {
                interpolation: {
                    pattern: /\$\{[^{}]*\}/,
                    inside: {
                        expression: {
                            pattern: /(^\$\{)[\s\S]+(?=\}$)/,
                            lookbehind: true,
                            alias: 'language-dhall',
                            inside: null // see blow
                        },
                        punctuation: /\$\{|\}/
                    }
                }
            }
        },
        label: {
            pattern: /`[^`]*`/,
            greedy: true
        },
        url: {
            // https://github.com/dhall-lang/dhall-lang/blob/5fde8ef1bead6fb4e999d3c1ffe7044cd019d63a/standard/dhall.abnf#L596
            pattern: /\bhttps?:\/\/[\w.:%!$&'*+;=@~-]+(?:\/[\w.:%!$&'*+;=@~-]*)*(?:\?[/?\w.:%!$&'*+;=@~-]*)?/,
            greedy: true
        },
        env: {
            // https://github.com/dhall-lang/dhall-lang/blob/5fde8ef1bead6fb4e999d3c1ffe7044cd019d63a/standard/dhall.abnf#L661
            pattern: /\benv:(?:(?!\d)\w+|"(?:[^"\\=]|\\.)*")/,
            greedy: true,
            inside: {
                function: /^env/,
                operator: /^:/,
                variable: /[\s\S]+/
            }
        },
        hash: {
            // https://github.com/dhall-lang/dhall-lang/blob/5fde8ef1bead6fb4e999d3c1ffe7044cd019d63a/standard/dhall.abnf#L725
            pattern: /\bsha256:[\da-fA-F]{64}\b/,
            inside: {
                function: /sha256/,
                operator: /:/,
                number: /[\da-fA-F]{64}/
            }
        },
        // https://github.com/dhall-lang/dhall-lang/blob/5fde8ef1bead6fb4e999d3c1ffe7044cd019d63a/standard/dhall.abnf#L359
        keyword: /\b(?:as|assert|else|forall|if|in|let|merge|missing|then|toMap|using|with)\b|\u2200/,
        builtin: /\b(?:None|Some)\b/,
        boolean: /\b(?:False|True)\b/,
        number: /\bNaN\b|-?\bInfinity\b|[+-]?\b(?:0x[\da-fA-F]+|\d+(?:\.\d+)?(?:e[+-]?\d+)?)\b/,
        operator: /\/\\|\/\/\\\\|&&|\|\||===|[!=]=|\/\/|->|\+\+|::|[+*#@=:?<>|\\\u2227\u2a53\u2261\u2afd\u03bb\u2192]/,
        punctuation: /\.\.|[{}\[\](),./]/,
        // we'll just assume that every capital word left is a type name
        'class-name': /\b[A-Z]\w*\b/
    };
    Prism.languages.dhall.string.inside.interpolation.inside.expression.inside = Prism.languages.dhall;
}

});

parcelRegister("gB6T3", function(module, exports) {
'use strict';
module.exports = $c15571a9cc35ae77$var$diff;
$c15571a9cc35ae77$var$diff.displayName = 'diff';
$c15571a9cc35ae77$var$diff.aliases = [];
function $c15571a9cc35ae77$var$diff(Prism) {
    (function(Prism) {
        Prism.languages.diff = {
            coord: [
                // Match all kinds of coord lines (prefixed by "+++", "---" or "***").
                /^(?:\*{3}|-{3}|\+{3}).*$/m,
                /^@@.*@@$/m,
                /^\d.*$/m
            ] // deleted, inserted, unchanged, diff
        };
        /**
     * A map from the name of a block to its line prefix.
     *
     * @type {Object<string, string>}
     */ var PREFIXES = {
            'deleted-sign': '-',
            'deleted-arrow': '<',
            'inserted-sign': '+',
            'inserted-arrow': '>',
            unchanged: ' ',
            diff: '!'
        } // add a token for each prefix
        ;
        Object.keys(PREFIXES).forEach(function(name) {
            var prefix = PREFIXES[name];
            var alias = [];
            if (!/^\w+$/.test(name)) // "deleted-sign" -> "deleted"
            alias.push(/\w+/.exec(name)[0]);
            if (name === 'diff') alias.push('bold');
            Prism.languages.diff[name] = {
                pattern: RegExp('^(?:[' + prefix + '].*(?:\r\n?|\n|(?![\\s\\S])))+', 'm'),
                alias: alias,
                inside: {
                    line: {
                        pattern: /(.)(?=[\s\S]).*(?:\r\n?|\n)?/,
                        lookbehind: true
                    },
                    prefix: {
                        pattern: /[\s\S]/,
                        alias: /\w+/.exec(name)[0]
                    }
                }
            };
        }) // make prefixes available to Diff plugin
        ;
        Object.defineProperty(Prism.languages.diff, 'PREFIXES', {
            value: PREFIXES
        });
    })(Prism);
}

});

parcelRegister("a5PBj", function(module, exports) {
'use strict';

var $949g8 = parcelRequire("949g8");
module.exports = $759265e270d57b7f$var$django;
$759265e270d57b7f$var$django.displayName = 'django';
$759265e270d57b7f$var$django.aliases = [
    'jinja2'
];
function $759265e270d57b7f$var$django(Prism) {
    Prism.register($949g8);
    (function(Prism) {
        Prism.languages.django = {
            comment: /^\{#[\s\S]*?#\}$/,
            tag: {
                pattern: /(^\{%[+-]?\s*)\w+/,
                lookbehind: true,
                alias: 'keyword'
            },
            delimiter: {
                pattern: /^\{[{%][+-]?|[+-]?[}%]\}$/,
                alias: 'punctuation'
            },
            string: {
                pattern: /("|')(?:\\.|(?!\1)[^\\\r\n])*\1/,
                greedy: true
            },
            filter: {
                pattern: /(\|)\w+/,
                lookbehind: true,
                alias: 'function'
            },
            test: {
                pattern: /(\bis\s+(?:not\s+)?)(?!not\b)\w+/,
                lookbehind: true,
                alias: 'function'
            },
            function: /\b[a-z_]\w+(?=\s*\()/i,
            keyword: /\b(?:and|as|by|else|for|if|import|in|is|loop|not|or|recursive|with|without)\b/,
            operator: /[-+%=]=?|!=|\*\*?=?|\/\/?=?|<[<=>]?|>[=>]?|[&|^~]/,
            number: /\b\d+(?:\.\d+)?\b/,
            boolean: /[Ff]alse|[Nn]one|[Tt]rue/,
            variable: /\b\w+\b/,
            punctuation: /[{}[\](),.:;]/
        };
        var pattern = /\{\{[\s\S]*?\}\}|\{%[\s\S]*?%\}|\{#[\s\S]*?#\}/g;
        var markupTemplating = Prism.languages['markup-templating'];
        Prism.hooks.add('before-tokenize', function(env) {
            markupTemplating.buildPlaceholders(env, 'django', pattern);
        });
        Prism.hooks.add('after-tokenize', function(env) {
            markupTemplating.tokenizePlaceholders(env, 'django');
        }) // Add an Jinja2 alias
        ;
        Prism.languages.jinja2 = Prism.languages.django;
        Prism.hooks.add('before-tokenize', function(env) {
            markupTemplating.buildPlaceholders(env, 'jinja2', pattern);
        });
        Prism.hooks.add('after-tokenize', function(env) {
            markupTemplating.tokenizePlaceholders(env, 'jinja2');
        });
    })(Prism);
}

});
parcelRegister("949g8", function(module, exports) {
'use strict';
module.exports = $699bab750a44a9c3$var$markupTemplating;
$699bab750a44a9c3$var$markupTemplating.displayName = 'markupTemplating';
$699bab750a44a9c3$var$markupTemplating.aliases = [];
function $699bab750a44a9c3$var$markupTemplating(Prism) {
    (function(Prism) {
        /**
     * Returns the placeholder for the given language id and index.
     *
     * @param {string} language
     * @param {string|number} index
     * @returns {string}
     */ function getPlaceholder(language, index) {
            return '___' + language.toUpperCase() + index + '___';
        }
        Object.defineProperties(Prism.languages['markup-templating'] = {}, {
            buildPlaceholders: {
                /**
         * Tokenize all inline templating expressions matching `placeholderPattern`.
         *
         * If `replaceFilter` is provided, only matches of `placeholderPattern` for which `replaceFilter` returns
         * `true` will be replaced.
         *
         * @param {object} env The environment of the `before-tokenize` hook.
         * @param {string} language The language id.
         * @param {RegExp} placeholderPattern The matches of this pattern will be replaced by placeholders.
         * @param {(match: string) => boolean} [replaceFilter]
         */ value: function(env, language, placeholderPattern, replaceFilter) {
                    if (env.language !== language) return;
                    var tokenStack = env.tokenStack = [];
                    env.code = env.code.replace(placeholderPattern, function(match) {
                        if (typeof replaceFilter === 'function' && !replaceFilter(match)) return match;
                        var i = tokenStack.length;
                        var placeholder // Check for existing strings
                        ;
                        while(env.code.indexOf(placeholder = getPlaceholder(language, i)) !== -1)++i;
                         // Create a sparse array
                        tokenStack[i] = match;
                        return placeholder;
                    }) // Switch the grammar to markup
                    ;
                    env.grammar = Prism.languages.markup;
                }
            },
            tokenizePlaceholders: {
                /**
         * Replace placeholders with proper tokens after tokenizing.
         *
         * @param {object} env The environment of the `after-tokenize` hook.
         * @param {string} language The language id.
         */ value: function(env, language) {
                    if (env.language !== language || !env.tokenStack) return;
                     // Switch the grammar back
                    env.grammar = Prism.languages[language];
                    var j = 0;
                    var keys = Object.keys(env.tokenStack);
                    function walkTokens(tokens) {
                        for(var i = 0; i < tokens.length; i++){
                            // all placeholders are replaced already
                            if (j >= keys.length) break;
                            var token = tokens[i];
                            if (typeof token === 'string' || token.content && typeof token.content === 'string') {
                                var k = keys[j];
                                var t = env.tokenStack[k];
                                var s = typeof token === 'string' ? token : token.content;
                                var placeholder = getPlaceholder(language, k);
                                var index = s.indexOf(placeholder);
                                if (index > -1) {
                                    ++j;
                                    var before = s.substring(0, index);
                                    var middle = new Prism.Token(language, Prism.tokenize(t, env.grammar), 'language-' + language, t);
                                    var after = s.substring(index + placeholder.length);
                                    var replacement = [];
                                    if (before) replacement.push.apply(replacement, walkTokens([
                                        before
                                    ]));
                                    replacement.push(middle);
                                    if (after) replacement.push.apply(replacement, walkTokens([
                                        after
                                    ]));
                                    if (typeof token === 'string') tokens.splice.apply(tokens, [
                                        i,
                                        1
                                    ].concat(replacement));
                                    else token.content = replacement;
                                }
                            } else if (token.content) walkTokens(token.content);
                        }
                        return tokens;
                    }
                    walkTokens(env.tokens);
                }
            }
        });
    })(Prism);
}

});


parcelRegister("jRQNP", function(module, exports) {
'use strict';
module.exports = $e76bed11c8604b02$var$dnsZoneFile;
$e76bed11c8604b02$var$dnsZoneFile.displayName = 'dnsZoneFile';
$e76bed11c8604b02$var$dnsZoneFile.aliases = [];
function $e76bed11c8604b02$var$dnsZoneFile(Prism) {
    Prism.languages['dns-zone-file'] = {
        comment: /;.*/,
        string: {
            pattern: /"(?:\\.|[^"\\\r\n])*"/,
            greedy: true
        },
        variable: [
            {
                pattern: /(^\$ORIGIN[ \t]+)\S+/m,
                lookbehind: true
            },
            {
                pattern: /(^|\s)@(?=\s|$)/,
                lookbehind: true
            }
        ],
        keyword: /^\$(?:INCLUDE|ORIGIN|TTL)(?=\s|$)/m,
        class: {
            // https://tools.ietf.org/html/rfc1035#page-13
            pattern: /(^|\s)(?:CH|CS|HS|IN)(?=\s|$)/,
            lookbehind: true,
            alias: 'keyword'
        },
        type: {
            // https://en.wikipedia.org/wiki/List_of_DNS_record_types
            pattern: /(^|\s)(?:A|A6|AAAA|AFSDB|APL|ATMA|CAA|CDNSKEY|CDS|CERT|CNAME|DHCID|DLV|DNAME|DNSKEY|DS|EID|GID|GPOS|HINFO|HIP|IPSECKEY|ISDN|KEY|KX|LOC|MAILA|MAILB|MB|MD|MF|MG|MINFO|MR|MX|NAPTR|NB|NBSTAT|NIMLOC|NINFO|NS|NSAP|NSAP-PTR|NSEC|NSEC3|NSEC3PARAM|NULL|NXT|OPENPGPKEY|PTR|PX|RKEY|RP|RRSIG|RT|SIG|SINK|SMIMEA|SOA|SPF|SRV|SSHFP|TA|TKEY|TLSA|TSIG|TXT|UID|UINFO|UNSPEC|URI|WKS|X25)(?=\s|$)/,
            lookbehind: true,
            alias: 'keyword'
        },
        punctuation: /[()]/
    };
    Prism.languages['dns-zone'] = Prism.languages['dns-zone-file'];
}

});

parcelRegister("etxi4", function(module, exports) {
'use strict';
module.exports = $a89d98eeed53a756$var$docker;
$a89d98eeed53a756$var$docker.displayName = 'docker';
$a89d98eeed53a756$var$docker.aliases = [
    'dockerfile'
];
function $a89d98eeed53a756$var$docker(Prism) {
    (function(Prism) {
        // Many of the following regexes will contain negated lookaheads like `[ \t]+(?![ \t])`. This is a trick to ensure
        // that quantifiers behave *atomically*. Atomic quantifiers are necessary to prevent exponential backtracking.
        var spaceAfterBackSlash = /\\[\r\n](?:\s|\\[\r\n]|#.*(?!.))*(?![\s#]|\\[\r\n])/.source // At least one space, comment, or line break
        ;
        var space = /(?:[ \t]+(?![ \t])(?:<SP_BS>)?|<SP_BS>)/.source.replace(/<SP_BS>/g, function() {
            return spaceAfterBackSlash;
        });
        var string = /"(?:[^"\\\r\n]|\\(?:\r\n|[\s\S]))*"|'(?:[^'\\\r\n]|\\(?:\r\n|[\s\S]))*'/.source;
        var option = /--[\w-]+=(?:<STR>|(?!["'])(?:[^\s\\]|\\.)+)/.source.replace(/<STR>/g, function() {
            return string;
        });
        var stringRule = {
            pattern: RegExp(string),
            greedy: true
        };
        var commentRule = {
            pattern: /(^[ \t]*)#.*/m,
            lookbehind: true,
            greedy: true
        };
        /**
     * @param {string} source
     * @param {string} flags
     * @returns {RegExp}
     */ function re(source, flags) {
            source = source.replace(/<OPT>/g, function() {
                return option;
            }).replace(/<SP>/g, function() {
                return space;
            });
            return RegExp(source, flags);
        }
        Prism.languages.docker = {
            instruction: {
                pattern: /(^[ \t]*)(?:ADD|ARG|CMD|COPY|ENTRYPOINT|ENV|EXPOSE|FROM|HEALTHCHECK|LABEL|MAINTAINER|ONBUILD|RUN|SHELL|STOPSIGNAL|USER|VOLUME|WORKDIR)(?=\s)(?:\\.|[^\r\n\\])*(?:\\$(?:\s|#.*$)*(?![\s#])(?:\\.|[^\r\n\\])*)*/im,
                lookbehind: true,
                greedy: true,
                inside: {
                    options: {
                        pattern: re(/(^(?:ONBUILD<SP>)?\w+<SP>)<OPT>(?:<SP><OPT>)*/.source, 'i'),
                        lookbehind: true,
                        greedy: true,
                        inside: {
                            property: {
                                pattern: /(^|\s)--[\w-]+/,
                                lookbehind: true
                            },
                            string: [
                                stringRule,
                                {
                                    pattern: /(=)(?!["'])(?:[^\s\\]|\\.)+/,
                                    lookbehind: true
                                }
                            ],
                            operator: /\\$/m,
                            punctuation: /=/
                        }
                    },
                    keyword: [
                        {
                            // https://docs.docker.com/engine/reference/builder/#healthcheck
                            pattern: re(/(^(?:ONBUILD<SP>)?HEALTHCHECK<SP>(?:<OPT><SP>)*)(?:CMD|NONE)\b/.source, 'i'),
                            lookbehind: true,
                            greedy: true
                        },
                        {
                            // https://docs.docker.com/engine/reference/builder/#from
                            pattern: re(/(^(?:ONBUILD<SP>)?FROM<SP>(?:<OPT><SP>)*(?!--)[^ \t\\]+<SP>)AS/.source, 'i'),
                            lookbehind: true,
                            greedy: true
                        },
                        {
                            // https://docs.docker.com/engine/reference/builder/#onbuild
                            pattern: re(/(^ONBUILD<SP>)\w+/.source, 'i'),
                            lookbehind: true,
                            greedy: true
                        },
                        {
                            pattern: /^\w+/,
                            greedy: true
                        }
                    ],
                    comment: commentRule,
                    string: stringRule,
                    variable: /\$(?:\w+|\{[^{}"'\\]*\})/,
                    operator: /\\$/m
                }
            },
            comment: commentRule
        };
        Prism.languages.dockerfile = Prism.languages.docker;
    })(Prism);
}

});

parcelRegister("4nlhg", function(module, exports) {
'use strict';
module.exports = $32f9d0abbdb0b0fb$var$dot;
$32f9d0abbdb0b0fb$var$dot.displayName = 'dot';
$32f9d0abbdb0b0fb$var$dot.aliases = [
    'gv'
];
function $32f9d0abbdb0b0fb$var$dot(Prism) {
    (function(Prism) {
        var ID = '(?:' + [
            // an identifier
            /[a-zA-Z_\x80-\uFFFF][\w\x80-\uFFFF]*/.source,
            /-?(?:\.\d+|\d+(?:\.\d*)?)/.source,
            /"[^"\\]*(?:\\[\s\S][^"\\]*)*"/.source,
            /<(?:[^<>]|(?!<!--)<(?:[^<>"']|"[^"]*"|'[^']*')+>|<!--(?:[^-]|-(?!->))*-->)*>/.source
        ].join('|') + ')';
        var IDInside = {
            markup: {
                pattern: /(^<)[\s\S]+(?=>$)/,
                lookbehind: true,
                alias: [
                    'language-markup',
                    'language-html',
                    'language-xml'
                ],
                inside: Prism.languages.markup
            }
        };
        /**
     * @param {string} source
     * @param {string} flags
     * @returns {RegExp}
     */ function withID(source, flags) {
            return RegExp(source.replace(/<ID>/g, function() {
                return ID;
            }), flags);
        }
        Prism.languages.dot = {
            comment: {
                pattern: /\/\/.*|\/\*[\s\S]*?\*\/|^#.*/m,
                greedy: true
            },
            'graph-name': {
                pattern: withID(/(\b(?:digraph|graph|subgraph)[ \t\r\n]+)<ID>/.source, 'i'),
                lookbehind: true,
                greedy: true,
                alias: 'class-name',
                inside: IDInside
            },
            'attr-value': {
                pattern: withID(/(=[ \t\r\n]*)<ID>/.source),
                lookbehind: true,
                greedy: true,
                inside: IDInside
            },
            'attr-name': {
                pattern: withID(/([\[;, \t\r\n])<ID>(?=[ \t\r\n]*=)/.source),
                lookbehind: true,
                greedy: true,
                inside: IDInside
            },
            keyword: /\b(?:digraph|edge|graph|node|strict|subgraph)\b/i,
            'compass-point': {
                pattern: /(:[ \t\r\n]*)(?:[ewc_]|[ns][ew]?)(?![\w\x80-\uFFFF])/,
                lookbehind: true,
                alias: 'builtin'
            },
            node: {
                pattern: withID(/(^|[^-.\w\x80-\uFFFF\\])<ID>/.source),
                lookbehind: true,
                greedy: true,
                inside: IDInside
            },
            operator: /[=:]|-[->]/,
            punctuation: /[\[\]{};,]/
        };
        Prism.languages.gv = Prism.languages.dot;
    })(Prism);
}

});

parcelRegister("fa7lQ", function(module, exports) {
'use strict';
module.exports = $b09d7e049e7601a6$var$ebnf;
$b09d7e049e7601a6$var$ebnf.displayName = 'ebnf';
$b09d7e049e7601a6$var$ebnf.aliases = [];
function $b09d7e049e7601a6$var$ebnf(Prism) {
    Prism.languages.ebnf = {
        comment: /\(\*[\s\S]*?\*\)/,
        string: {
            pattern: /"[^"\r\n]*"|'[^'\r\n]*'/,
            greedy: true
        },
        special: {
            pattern: /\?[^?\r\n]*\?/,
            greedy: true,
            alias: 'class-name'
        },
        definition: {
            pattern: /^([\t ]*)[a-z]\w*(?:[ \t]+[a-z]\w*)*(?=\s*=)/im,
            lookbehind: true,
            alias: [
                'rule',
                'keyword'
            ]
        },
        rule: /\b[a-z]\w*(?:[ \t]+[a-z]\w*)*\b/i,
        punctuation: /\([:/]|[:/]\)|[.,;()[\]{}]/,
        operator: /[-=|*/!]/
    };
}

});

parcelRegister("1TWWp", function(module, exports) {
'use strict';
module.exports = $1628a5fe4b7d6512$var$editorconfig;
$1628a5fe4b7d6512$var$editorconfig.displayName = 'editorconfig';
$1628a5fe4b7d6512$var$editorconfig.aliases = [];
function $1628a5fe4b7d6512$var$editorconfig(Prism) {
    Prism.languages.editorconfig = {
        // https://editorconfig-specification.readthedocs.io
        comment: /[;#].*/,
        section: {
            pattern: /(^[ \t]*)\[.+\]/m,
            lookbehind: true,
            alias: 'selector',
            inside: {
                regex: /\\\\[\[\]{},!?.*]/,
                // Escape special characters with '\\'
                operator: /[!?]|\.\.|\*{1,2}/,
                punctuation: /[\[\]{},]/
            }
        },
        key: {
            pattern: /(^[ \t]*)[^\s=]+(?=[ \t]*=)/m,
            lookbehind: true,
            alias: 'attr-name'
        },
        value: {
            pattern: /=.*/,
            alias: 'attr-value',
            inside: {
                punctuation: /^=/
            }
        }
    };
}

});

parcelRegister("7EtQM", function(module, exports) {
'use strict';
module.exports = $59236c7d68af9a30$var$eiffel;
$59236c7d68af9a30$var$eiffel.displayName = 'eiffel';
$59236c7d68af9a30$var$eiffel.aliases = [];
function $59236c7d68af9a30$var$eiffel(Prism) {
    Prism.languages.eiffel = {
        comment: /--.*/,
        string: [
            // Aligned-verbatim-strings
            {
                pattern: /"([^[]*)\[[\s\S]*?\]\1"/,
                greedy: true
            },
            {
                pattern: /"([^{]*)\{[\s\S]*?\}\1"/,
                greedy: true
            },
            {
                pattern: /"(?:%(?:(?!\n)\s)*\n\s*%|%\S|[^%"\r\n])*"/,
                greedy: true
            }
        ],
        // normal char | special char | char code
        char: /'(?:%.|[^%'\r\n])+'/,
        keyword: /\b(?:across|agent|alias|all|and|as|assign|attached|attribute|check|class|convert|create|Current|debug|deferred|detachable|do|else|elseif|end|ensure|expanded|export|external|feature|from|frozen|if|implies|inherit|inspect|invariant|like|local|loop|not|note|obsolete|old|once|or|Precursor|redefine|rename|require|rescue|Result|retry|select|separate|some|then|undefine|until|variant|Void|when|xor)\b/i,
        boolean: /\b(?:False|True)\b/i,
        // Convention: class-names are always all upper-case characters
        'class-name': /\b[A-Z][\dA-Z_]*\b/,
        number: [
            // hexa | octal | bin
            /\b0[xcb][\da-f](?:_*[\da-f])*\b/i,
            /(?:\b\d(?:_*\d)*)?\.(?:(?:\d(?:_*\d)*)?e[+-]?)?\d(?:_*\d)*\b|\b\d(?:_*\d)*\b\.?/i
        ],
        punctuation: /:=|<<|>>|\(\||\|\)|->|\.(?=\w)|[{}[\];(),:?]/,
        operator: /\\\\|\|\.\.\||\.\.|\/[~\/=]?|[><]=?|[-+*^=~]/
    };
}

});

parcelRegister("aeSQQ", function(module, exports) {
'use strict';

var $949g8 = parcelRequire("949g8");
module.exports = $7745c28ba0b72b38$var$ejs;
$7745c28ba0b72b38$var$ejs.displayName = 'ejs';
$7745c28ba0b72b38$var$ejs.aliases = [
    'eta'
];
function $7745c28ba0b72b38$var$ejs(Prism) {
    Prism.register($949g8);
    (function(Prism) {
        Prism.languages.ejs = {
            delimiter: {
                pattern: /^<%[-_=]?|[-_]?%>$/,
                alias: 'punctuation'
            },
            comment: /^#[\s\S]*/,
            'language-javascript': {
                pattern: /[\s\S]+/,
                inside: Prism.languages.javascript
            }
        };
        Prism.hooks.add('before-tokenize', function(env) {
            var ejsPattern = /<%(?!%)[\s\S]+?%>/g;
            Prism.languages['markup-templating'].buildPlaceholders(env, 'ejs', ejsPattern);
        });
        Prism.hooks.add('after-tokenize', function(env) {
            Prism.languages['markup-templating'].tokenizePlaceholders(env, 'ejs');
        });
        Prism.languages.eta = Prism.languages.ejs;
    })(Prism);
}

});

parcelRegister("iDMCu", function(module, exports) {
'use strict';
module.exports = $d921956ac9ab76f0$var$elixir;
$d921956ac9ab76f0$var$elixir.displayName = 'elixir';
$d921956ac9ab76f0$var$elixir.aliases = [];
function $d921956ac9ab76f0$var$elixir(Prism) {
    Prism.languages.elixir = {
        doc: {
            pattern: /@(?:doc|moduledoc)\s+(?:("""|''')[\s\S]*?\1|("|')(?:\\(?:\r\n|[\s\S])|(?!\2)[^\\\r\n])*\2)/,
            inside: {
                attribute: /^@\w+/,
                string: /['"][\s\S]+/
            }
        },
        comment: {
            pattern: /#.*/,
            greedy: true
        },
        // ~r"""foo""" (multi-line), ~r'''foo''' (multi-line), ~r/foo/, ~r|foo|, ~r"foo", ~r'foo', ~r(foo), ~r[foo], ~r{foo}, ~r<foo>
        regex: {
            pattern: /~[rR](?:("""|''')(?:\\[\s\S]|(?!\1)[^\\])+\1|([\/|"'])(?:\\.|(?!\2)[^\\\r\n])+\2|\((?:\\.|[^\\)\r\n])+\)|\[(?:\\.|[^\\\]\r\n])+\]|\{(?:\\.|[^\\}\r\n])+\}|<(?:\\.|[^\\>\r\n])+>)[uismxfr]*/,
            greedy: true
        },
        string: [
            {
                // ~s"""foo""" (multi-line), ~s'''foo''' (multi-line), ~s/foo/, ~s|foo|, ~s"foo", ~s'foo', ~s(foo), ~s[foo], ~s{foo} (with interpolation care), ~s<foo>
                pattern: /~[cCsSwW](?:("""|''')(?:\\[\s\S]|(?!\1)[^\\])+\1|([\/|"'])(?:\\.|(?!\2)[^\\\r\n])+\2|\((?:\\.|[^\\)\r\n])+\)|\[(?:\\.|[^\\\]\r\n])+\]|\{(?:\\.|#\{[^}]+\}|#(?!\{)|[^#\\}\r\n])+\}|<(?:\\.|[^\\>\r\n])+>)[csa]?/,
                greedy: true,
                inside: {
                }
            },
            {
                pattern: /("""|''')[\s\S]*?\1/,
                greedy: true,
                inside: {
                }
            },
            {
                // Multi-line strings are allowed
                pattern: /("|')(?:\\(?:\r\n|[\s\S])|(?!\1)[^\\\r\n])*\1/,
                greedy: true,
                inside: {
                }
            }
        ],
        atom: {
            // Look-behind prevents bad highlighting of the :: operator
            pattern: /(^|[^:]):\w+/,
            lookbehind: true,
            alias: 'symbol'
        },
        module: {
            pattern: /\b[A-Z]\w*\b/,
            alias: 'class-name'
        },
        // Look-ahead prevents bad highlighting of the :: operator
        'attr-name': /\b\w+\??:(?!:)/,
        argument: {
            // Look-behind prevents bad highlighting of the && operator
            pattern: /(^|[^&])&\d+/,
            lookbehind: true,
            alias: 'variable'
        },
        attribute: {
            pattern: /@\w+/,
            alias: 'variable'
        },
        function: /\b[_a-zA-Z]\w*[?!]?(?:(?=\s*(?:\.\s*)?\()|(?=\/\d))/,
        number: /\b(?:0[box][a-f\d_]+|\d[\d_]*)(?:\.[\d_]+)?(?:e[+-]?[\d_]+)?\b/i,
        keyword: /\b(?:after|alias|and|case|catch|cond|def(?:callback|delegate|exception|impl|macro|module|n|np|p|protocol|struct)?|do|else|end|fn|for|if|import|not|or|quote|raise|require|rescue|try|unless|unquote|use|when)\b/,
        boolean: /\b(?:false|nil|true)\b/,
        operator: [
            /\bin\b|&&?|\|[|>]?|\\\\|::|\.\.\.?|\+\+?|-[->]?|<[-=>]|>=|!==?|\B!|=(?:==?|[>~])?|[*\/^]/,
            {
                // We don't want to match <<
                pattern: /([^<])<(?!<)/,
                lookbehind: true
            },
            {
                // We don't want to match >>
                pattern: /([^>])>(?!>)/,
                lookbehind: true
            }
        ],
        punctuation: /<<|>>|[.,%\[\]{}()]/
    };
    Prism.languages.elixir.string.forEach(function(o) {
        o.inside = {
            interpolation: {
                pattern: /#\{[^}]+\}/,
                inside: {
                    delimiter: {
                        pattern: /^#\{|\}$/,
                        alias: 'punctuation'
                    },
                    rest: Prism.languages.elixir
                }
            }
        };
    });
}

});

parcelRegister("fCvJP", function(module, exports) {
'use strict';
module.exports = $b5f3062adc7e9ef7$var$elm;
$b5f3062adc7e9ef7$var$elm.displayName = 'elm';
$b5f3062adc7e9ef7$var$elm.aliases = [];
function $b5f3062adc7e9ef7$var$elm(Prism) {
    Prism.languages.elm = {
        comment: /--.*|\{-[\s\S]*?-\}/,
        char: {
            pattern: /'(?:[^\\'\r\n]|\\(?:[abfnrtv\\']|\d+|x[0-9a-fA-F]+|u\{[0-9a-fA-F]+\}))'/,
            greedy: true
        },
        string: [
            {
                // Multiline strings are wrapped in triple ". Quotes may appear unescaped.
                pattern: /"""[\s\S]*?"""/,
                greedy: true
            },
            {
                pattern: /"(?:[^\\"\r\n]|\\.)*"/,
                greedy: true
            }
        ],
        'import-statement': {
            // The imported or hidden names are not included in this import
            // statement. This is because we want to highlight those exactly like
            // we do for the names in the program.
            pattern: /(^[\t ]*)import\s+[A-Z]\w*(?:\.[A-Z]\w*)*(?:\s+as\s+(?:[A-Z]\w*)(?:\.[A-Z]\w*)*)?(?:\s+exposing\s+)?/m,
            lookbehind: true,
            inside: {
                keyword: /\b(?:as|exposing|import)\b/
            }
        },
        keyword: /\b(?:alias|as|case|else|exposing|if|in|infixl|infixr|let|module|of|then|type)\b/,
        // These are builtin variables only. Constructors are highlighted later as a constant.
        builtin: /\b(?:abs|acos|always|asin|atan|atan2|ceiling|clamp|compare|cos|curry|degrees|e|flip|floor|fromPolar|identity|isInfinite|isNaN|logBase|max|min|negate|never|not|pi|radians|rem|round|sin|sqrt|tan|toFloat|toPolar|toString|truncate|turns|uncurry|xor)\b/,
        // decimal integers and floating point numbers | hexadecimal integers
        number: /\b(?:\d+(?:\.\d+)?(?:e[+-]?\d+)?|0x[0-9a-f]+)\b/i,
        // Most of this is needed because of the meaning of a single '.'.
        // If it stands alone freely, it is the function composition.
        // It may also be a separator between a module name and an identifier => no
        // operator. If it comes together with other special characters it is an
        // operator too.
        // Valid operator characters in 0.18: +-/*=.$<>:&|^?%#@~!
        // Ref: https://groups.google.com/forum/#!msg/elm-dev/0AHSnDdkSkQ/E0SVU70JEQAJ
        operator: /\s\.\s|[+\-/*=.$<>:&|^?%#@~!]{2,}|[+\-/*=$<>:&|^?%#@~!]/,
        // In Elm, nearly everything is a variable, do not highlight these.
        hvariable: /\b(?:[A-Z]\w*\.)*[a-z]\w*\b/,
        constant: /\b(?:[A-Z]\w*\.)*[A-Z]\w*\b/,
        punctuation: /[{}[\]|(),.:]/
    };
}

});

parcelRegister("fpVPL", function(module, exports) {
'use strict';

var $2jpWm = parcelRequire("2jpWm");

var $949g8 = parcelRequire("949g8");
module.exports = $b3960d72dfc34774$var$erb;
$b3960d72dfc34774$var$erb.displayName = 'erb';
$b3960d72dfc34774$var$erb.aliases = [];
function $b3960d72dfc34774$var$erb(Prism) {
    Prism.register($2jpWm);
    Prism.register($949g8);
    (function(Prism) {
        Prism.languages.erb = {
            delimiter: {
                pattern: /^(\s*)<%=?|%>(?=\s*$)/,
                lookbehind: true,
                alias: 'punctuation'
            },
            ruby: {
                pattern: /\s*\S[\s\S]*/,
                alias: 'language-ruby',
                inside: Prism.languages.ruby
            }
        };
        Prism.hooks.add('before-tokenize', function(env) {
            var erbPattern = /<%=?(?:[^\r\n]|[\r\n](?!=begin)|[\r\n]=begin\s(?:[^\r\n]|[\r\n](?!=end))*[\r\n]=end)+?%>/g;
            Prism.languages['markup-templating'].buildPlaceholders(env, 'erb', erbPattern);
        });
        Prism.hooks.add('after-tokenize', function(env) {
            Prism.languages['markup-templating'].tokenizePlaceholders(env, 'erb');
        });
    })(Prism);
}

});

parcelRegister("jxciR", function(module, exports) {
'use strict';
module.exports = $e38aa48a45392080$var$erlang;
$e38aa48a45392080$var$erlang.displayName = 'erlang';
$e38aa48a45392080$var$erlang.aliases = [];
function $e38aa48a45392080$var$erlang(Prism) {
    Prism.languages.erlang = {
        comment: /%.+/,
        string: {
            pattern: /"(?:\\.|[^\\"\r\n])*"/,
            greedy: true
        },
        'quoted-function': {
            pattern: /'(?:\\.|[^\\'\r\n])+'(?=\()/,
            alias: 'function'
        },
        'quoted-atom': {
            pattern: /'(?:\\.|[^\\'\r\n])+'/,
            alias: 'atom'
        },
        boolean: /\b(?:false|true)\b/,
        keyword: /\b(?:after|case|catch|end|fun|if|of|receive|try|when)\b/,
        number: [
            /\$\\?./,
            /\b\d+#[a-z0-9]+/i,
            /(?:\b\d+(?:\.\d*)?|\B\.\d+)(?:e[+-]?\d+)?/i
        ],
        function: /\b[a-z][\w@]*(?=\()/,
        variable: {
            // Look-behind is used to prevent wrong highlighting of atoms containing "@"
            pattern: /(^|[^@])(?:\b|\?)[A-Z_][\w@]*/,
            lookbehind: true
        },
        operator: [
            /[=\/<>:]=|=[:\/]=|\+\+?|--?|[=*\/!]|\b(?:and|andalso|band|bnot|bor|bsl|bsr|bxor|div|not|or|orelse|rem|xor)\b/,
            {
                // We don't want to match <<
                pattern: /(^|[^<])<(?!<)/,
                lookbehind: true
            },
            {
                // We don't want to match >>
                pattern: /(^|[^>])>(?!>)/,
                lookbehind: true
            }
        ],
        atom: /\b[a-z][\w@]*/,
        punctuation: /[()[\]{}:;,.#|]|<<|>>/
    };
}

});

parcelRegister("1NsmQ", function(module, exports) {
'use strict';

var $cPF7D = parcelRequire("cPF7D");

var $949g8 = parcelRequire("949g8");
module.exports = $14f05f3746c1f898$var$etlua;
$14f05f3746c1f898$var$etlua.displayName = 'etlua';
$14f05f3746c1f898$var$etlua.aliases = [];
function $14f05f3746c1f898$var$etlua(Prism) {
    Prism.register($cPF7D);
    Prism.register($949g8);
    (function(Prism) {
        Prism.languages.etlua = {
            delimiter: {
                pattern: /^<%[-=]?|-?%>$/,
                alias: 'punctuation'
            },
            'language-lua': {
                pattern: /[\s\S]+/,
                inside: Prism.languages.lua
            }
        };
        Prism.hooks.add('before-tokenize', function(env) {
            var pattern = /<%[\s\S]+?%>/g;
            Prism.languages['markup-templating'].buildPlaceholders(env, 'etlua', pattern);
        });
        Prism.hooks.add('after-tokenize', function(env) {
            Prism.languages['markup-templating'].tokenizePlaceholders(env, 'etlua');
        });
    })(Prism);
}

});
parcelRegister("cPF7D", function(module, exports) {
'use strict';
module.exports = $957a2577fcb6115d$var$lua;
$957a2577fcb6115d$var$lua.displayName = 'lua';
$957a2577fcb6115d$var$lua.aliases = [];
function $957a2577fcb6115d$var$lua(Prism) {
    Prism.languages.lua = {
        comment: /^#!.+|--(?:\[(=*)\[[\s\S]*?\]\1\]|.*)/m,
        // \z may be used to skip the following space
        string: {
            pattern: /(["'])(?:(?!\1)[^\\\r\n]|\\z(?:\r\n|\s)|\\(?:\r\n|[^z]))*\1|\[(=*)\[[\s\S]*?\]\2\]/,
            greedy: true
        },
        number: /\b0x[a-f\d]+(?:\.[a-f\d]*)?(?:p[+-]?\d+)?\b|\b\d+(?:\.\B|(?:\.\d*)?(?:e[+-]?\d+)?\b)|\B\.\d+(?:e[+-]?\d+)?\b/i,
        keyword: /\b(?:and|break|do|else|elseif|end|false|for|function|goto|if|in|local|nil|not|or|repeat|return|then|true|until|while)\b/,
        function: /(?!\d)\w+(?=\s*(?:[({]))/,
        operator: [
            /[-+*%^&|#]|\/\/?|<[<=]?|>[>=]?|[=~]=?/,
            {
                // Match ".." but don't break "..."
                pattern: /(^|[^.])\.\.(?!\.)/,
                lookbehind: true
            }
        ],
        punctuation: /[\[\](){},;]|\.+|:+/
    };
}

});


parcelRegister("9eFBf", function(module, exports) {
'use strict';
module.exports = $6b95b0bb1ff07551$var$excelFormula;
$6b95b0bb1ff07551$var$excelFormula.displayName = 'excelFormula';
$6b95b0bb1ff07551$var$excelFormula.aliases = [];
function $6b95b0bb1ff07551$var$excelFormula(Prism) {
    Prism.languages['excel-formula'] = {
        comment: {
            pattern: /(\bN\(\s*)"(?:[^"]|"")*"(?=\s*\))/i,
            lookbehind: true,
            greedy: true
        },
        string: {
            pattern: /"(?:[^"]|"")*"(?!")/,
            greedy: true
        },
        reference: {
            // https://www.ablebits.com/office-addins-blog/2015/12/08/excel-reference-another-sheet-workbook/
            // Sales!B2
            // 'Winter sales'!B2
            // [Sales.xlsx]Jan!B2:B5
            // D:\Reports\[Sales.xlsx]Jan!B2:B5
            // '[Sales.xlsx]Jan sales'!B2:B5
            // 'D:\Reports\[Sales.xlsx]Jan sales'!B2:B5
            pattern: /(?:'[^']*'|(?:[^\s()[\]{}<>*?"';,$&]*\[[^^\s()[\]{}<>*?"']+\])?\w+)!/,
            greedy: true,
            alias: 'string',
            inside: {
                operator: /!$/,
                punctuation: /'/,
                sheet: {
                    pattern: /[^[\]]+$/,
                    alias: 'function'
                },
                file: {
                    pattern: /\[[^[\]]+\]$/,
                    inside: {
                        punctuation: /[[\]]/
                    }
                },
                path: /[\s\S]+/
            }
        },
        'function-name': {
            pattern: /\b[A-Z]\w*(?=\()/i,
            alias: 'keyword'
        },
        range: {
            pattern: /\$?\b(?:[A-Z]+\$?\d+:\$?[A-Z]+\$?\d+|[A-Z]+:\$?[A-Z]+|\d+:\$?\d+)\b/i,
            alias: 'property',
            inside: {
                operator: /:/,
                cell: /\$?[A-Z]+\$?\d+/i,
                column: /\$?[A-Z]+/i,
                row: /\$?\d+/
            }
        },
        cell: {
            // Excel is case insensitive, so the string "foo1" could be either a variable or a cell.
            // To combat this, we match cells case insensitive, if the contain at least one "$", and case sensitive otherwise.
            pattern: /\b[A-Z]+\d+\b|\$[A-Za-z]+\$?\d+\b|\b[A-Za-z]+\$\d+\b/,
            alias: 'property'
        },
        number: /(?:\b\d+(?:\.\d+)?|\B\.\d+)(?:e[+-]?\d+)?\b/i,
        boolean: /\b(?:FALSE|TRUE)\b/i,
        operator: /[-+*/^%=&,]|<[=>]?|>=?/,
        punctuation: /[[\]();{}|]/
    };
    Prism.languages['xlsx'] = Prism.languages['xls'] = Prism.languages['excel-formula'];
}

});

parcelRegister("8qlwl", function(module, exports) {
'use strict';
module.exports = $622171fba4b97a6f$var$factor;
$622171fba4b97a6f$var$factor.displayName = 'factor';
$622171fba4b97a6f$var$factor.aliases = [];
function $622171fba4b97a6f$var$factor(Prism) {
    (function(Prism) {
        var comment_inside = {
            function: /\b(?:BUGS?|FIX(?:MES?)?|NOTES?|TODOS?|XX+|HACKS?|WARN(?:ING)?|\?{2,}|!{2,})\b/
        };
        var string_inside = {
            number: /\\[^\s']|%\w/
        };
        var factor = {
            comment: [
                {
                    // ! single-line exclamation point comments with whitespace after/around the !
                    pattern: /(^|\s)(?:! .*|!$)/,
                    lookbehind: true,
                    inside: comment_inside
                },
                /* from basis/multiline: */ {
                    // /* comment */, /* comment*/
                    pattern: /(^|\s)\/\*\s[\s\S]*?\*\/(?=\s|$)/,
                    lookbehind: true,
                    greedy: true,
                    inside: comment_inside
                },
                {
                    // ![[ comment ]] , ![===[ comment]===]
                    pattern: /(^|\s)!\[(={0,6})\[\s[\s\S]*?\]\2\](?=\s|$)/,
                    lookbehind: true,
                    greedy: true,
                    inside: comment_inside
                }
            ],
            number: [
                {
                    // basic base 10 integers 9, -9
                    pattern: /(^|\s)[+-]?\d+(?=\s|$)/,
                    lookbehind: true
                },
                {
                    // base prefix integers 0b010 0o70 0xad 0d10 0XAD -0xa9
                    pattern: /(^|\s)[+-]?0(?:b[01]+|o[0-7]+|d\d+|x[\dA-F]+)(?=\s|$)/i,
                    lookbehind: true
                },
                {
                    // fractional ratios 1/5 -1/5 and the literal float approximations 1/5. -1/5.
                    pattern: /(^|\s)[+-]?\d+\/\d+\.?(?=\s|$)/,
                    lookbehind: true
                },
                {
                    // positive mixed numbers 23+1/5 +23+1/5
                    pattern: /(^|\s)\+?\d+\+\d+\/\d+(?=\s|$)/,
                    lookbehind: true
                },
                {
                    // negative mixed numbers -23-1/5
                    pattern: /(^|\s)-\d+-\d+\/\d+(?=\s|$)/,
                    lookbehind: true
                },
                {
                    // basic decimal floats -0.01 0. .0 .1 -.1 -1. -12.13 +12.13
                    // and scientific notation with base 10 exponents 3e4 3e-4 .3e-4
                    pattern: /(^|\s)[+-]?(?:\d*\.\d+|\d+\.\d*|\d+)(?:e[+-]?\d+)?(?=\s|$)/i,
                    lookbehind: true
                },
                {
                    // NAN literal syntax NAN: 80000deadbeef, NAN: a
                    pattern: /(^|\s)NAN:\s+[\da-fA-F]+(?=\s|$)/,
                    lookbehind: true
                },
                {
                    /*
base prefix floats 0x1.0p3 (8.0) 0b1.010p2 (5.0) 0x1.p1 0b1.11111111p11111...
"The normalized hex form ±0x1.MMMMMMMMMMMMM[pP]±EEEE allows any floating-point number to be specified precisely.
The values of MMMMMMMMMMMMM and EEEE map directly to the mantissa and exponent fields of the binary IEEE 754 representation."
<https://docs.factorcode.org/content/article-syntax-floats.html>
*/ pattern: /(^|\s)[+-]?0(?:b1\.[01]*|o1\.[0-7]*|d1\.\d*|x1\.[\dA-F]*)p\d+(?=\s|$)/i,
                    lookbehind: true
                }
            ],
            // R/ regexp?\/\\/
            regexp: {
                pattern: /(^|\s)R\/\s(?:\\\S|[^\\/])*\/(?:[idmsr]*|[idmsr]+-[idmsr]+)(?=\s|$)/,
                lookbehind: true,
                alias: 'number',
                inside: {
                    variable: /\\\S/,
                    keyword: /[+?*\[\]^$(){}.|]/,
                    operator: {
                        pattern: /(\/)[idmsr]+(?:-[idmsr]+)?/,
                        lookbehind: true
                    }
                }
            },
            boolean: {
                pattern: /(^|\s)[tf](?=\s|$)/,
                lookbehind: true
            },
            // SBUF" asd", URL" ://...", P" /etc/"
            'custom-string': {
                pattern: /(^|\s)[A-Z0-9\-]+"\s(?:\\\S|[^"\\])*"/,
                lookbehind: true,
                greedy: true,
                alias: 'string',
                inside: {
                    number: /\\\S|%\w|\//
                }
            },
            'multiline-string': [
                {
                    // STRING: name \n content \n ; -> CONSTANT: name "content" (symbol)
                    pattern: /(^|\s)STRING:\s+\S+(?:\n|\r\n).*(?:\n|\r\n)\s*;(?=\s|$)/,
                    lookbehind: true,
                    greedy: true,
                    alias: 'string',
                    inside: {
                        number: string_inside.number,
                        // trailing semicolon on its own line
                        'semicolon-or-setlocal': {
                            pattern: /([\r\n][ \t]*);(?=\s|$)/,
                            lookbehind: true,
                            alias: 'function'
                        }
                    }
                },
                {
                    // HEREDOC: marker \n content \n marker ; -> "content" (immediate)
                    pattern: /(^|\s)HEREDOC:\s+\S+(?:\n|\r\n).*(?:\n|\r\n)\s*\S+(?=\s|$)/,
                    lookbehind: true,
                    greedy: true,
                    alias: 'string',
                    inside: string_inside
                },
                {
                    // [[ string ]], [==[ string]==]
                    pattern: /(^|\s)\[(={0,6})\[\s[\s\S]*?\]\2\](?=\s|$)/,
                    lookbehind: true,
                    greedy: true,
                    alias: 'string',
                    inside: string_inside
                }
            ],
            'special-using': {
                pattern: /(^|\s)USING:(?:\s\S+)*(?=\s+;(?:\s|$))/,
                lookbehind: true,
                alias: 'function',
                inside: {
                    // this is essentially a regex for vocab names, which i don't want to specify
                    // but the USING: gets picked up as a vocab name
                    string: {
                        pattern: /(\s)[^:\s]+/,
                        lookbehind: true
                    }
                }
            },
            /* this description of stack effect literal syntax is not complete and not as specific as theoretically possible
trying to do better is more work and regex-computation-time than it's worth though.
- we'd like to have the "delimiter" parts of the stack effect [ (, --, and ) ] be a different (less-important or comment-like) colour to the stack effect contents
- we'd like if nested stack effects were treated as such rather than just appearing flat (with `inside`)
- we'd like if the following variable name conventions were recognised specifically:
special row variables = ..a b..
type and stack effect annotations end with a colon = ( quot: ( a: ( -- ) -- b ) -- x ), ( x: number -- )
word throws unconditional error = *
any other word-like variable name = a ? q' etc
https://docs.factorcode.org/content/article-effects.html
these are pretty complicated to highlight properly without a real parser, and therefore out of scope
the old pattern, which may be later useful, was: (^|\s)(?:call|execute|eval)?\((?:\s+[^"\r\n\t ]\S*)*?\s+--(?:\s+[^"\n\t ]\S*)*?\s+\)(?=\s|$)
*/ // current solution is not great
            'stack-effect-delimiter': [
                {
                    // opening parenthesis
                    pattern: /(^|\s)(?:call|eval|execute)?\((?=\s)/,
                    lookbehind: true,
                    alias: 'operator'
                },
                {
                    // middle --
                    pattern: /(\s)--(?=\s)/,
                    lookbehind: true,
                    alias: 'operator'
                },
                {
                    // closing parenthesis
                    pattern: /(\s)\)(?=\s|$)/,
                    lookbehind: true,
                    alias: 'operator'
                }
            ],
            combinators: {
                pattern: null,
                lookbehind: true,
                alias: 'keyword'
            },
            'kernel-builtin': {
                pattern: null,
                lookbehind: true,
                alias: 'variable'
            },
            'sequences-builtin': {
                pattern: null,
                lookbehind: true,
                alias: 'variable'
            },
            'math-builtin': {
                pattern: null,
                lookbehind: true,
                alias: 'variable'
            },
            'constructor-word': {
                // <array> but not <=>
                pattern: /(^|\s)<(?!=+>|-+>)\S+>(?=\s|$)/,
                lookbehind: true,
                alias: 'keyword'
            },
            'other-builtin-syntax': {
                pattern: null,
                lookbehind: true,
                alias: 'operator'
            },
            /*
full list of supported word naming conventions: (the convention appears outside of the [brackets])
set-[x]
change-[x]
with-[x]
new-[x]
>[string]
[base]>
[string]>[number]
+[symbol]+
[boolean-word]?
?[of]
[slot-reader]>>
>>[slot-setter]
[slot-writer]<<
([implementation-detail])
[mutater]!
[variant]*
[prettyprint].
$[help-markup]
<constructors>, SYNTAX:, etc are supported by their own patterns.
`with` and `new` from `kernel` are their own builtins.
see <https://docs.factorcode.org/content/article-conventions.html>
*/ 'conventionally-named-word': {
                pattern: /(^|\s)(?!")(?:(?:change|new|set|with)-\S+|\$\S+|>[^>\s]+|[^:>\s]+>|[^>\s]+>[^>\s]+|\+[^+\s]+\+|[^?\s]+\?|\?[^?\s]+|[^>\s]+>>|>>[^>\s]+|[^<\s]+<<|\([^()\s]+\)|[^!\s]+!|[^*\s]\S*\*|[^.\s]\S*\.)(?=\s|$)/,
                lookbehind: true,
                alias: 'keyword'
            },
            'colon-syntax': {
                pattern: /(^|\s)(?:[A-Z0-9\-]+#?)?:{1,2}\s+(?:;\S+|(?!;)\S+)(?=\s|$)/,
                lookbehind: true,
                greedy: true,
                alias: 'function'
            },
            'semicolon-or-setlocal': {
                pattern: /(\s)(?:;|:>)(?=\s|$)/,
                lookbehind: true,
                alias: 'function'
            },
            // do not highlight leading } or trailing X{ at the begin/end of the file as it's invalid syntax
            'curly-brace-literal-delimiter': [
                {
                    // opening
                    pattern: /(^|\s)[a-z]*\{(?=\s)/i,
                    lookbehind: true,
                    alias: 'operator'
                },
                {
                    // closing
                    pattern: /(\s)\}(?=\s|$)/,
                    lookbehind: true,
                    alias: 'operator'
                }
            ],
            // do not highlight leading ] or trailing [ at the begin/end of the file as it's invalid syntax
            'quotation-delimiter': [
                {
                    // opening
                    pattern: /(^|\s)\[(?=\s)/,
                    lookbehind: true,
                    alias: 'operator'
                },
                {
                    // closing
                    pattern: /(\s)\](?=\s|$)/,
                    lookbehind: true,
                    alias: 'operator'
                }
            ],
            'normal-word': {
                pattern: /(^|\s)[^"\s]\S*(?=\s|$)/,
                lookbehind: true
            },
            /*
basic first-class string "a"
with escaped double-quote "a\""
escaped backslash "\\"
and general escapes since Factor has so many "\N"
syntax that works in the reference implementation that isn't fully
supported because it's an implementation detail:
"string 1""string 2" -> 2 strings (works anyway)
"string"5 -> string, 5
"string"[ ] -> string, quotation
{ "a"} -> array<string>
the rest of those examples all properly recognise the string, but not
the other object (number, quotation, etc)
this is fine for a regex-only implementation.
*/ string: {
                pattern: /"(?:\\\S|[^"\\])*"/,
                greedy: true,
                inside: string_inside
            }
        };
        var escape = function(str) {
            return (str + '').replace(/([.?*+\^$\[\]\\(){}|\-])/g, '\\$1');
        };
        var arrToWordsRegExp = function(arr) {
            return new RegExp('(^|\\s)(?:' + arr.map(escape).join('|') + ')(?=\\s|$)');
        };
        var builtins = {
            'kernel-builtin': [
                'or',
                '2nipd',
                '4drop',
                'tuck',
                'wrapper',
                'nip',
                'wrapper?',
                'callstack>array',
                'die',
                'dupd',
                'callstack',
                'callstack?',
                '3dup',
                'hashcode',
                'pick',
                '4nip',
                'build',
                '>boolean',
                'nipd',
                'clone',
                '5nip',
                'eq?',
                '?',
                '=',
                'swapd',
                '2over',
                'clear',
                '2dup',
                'get-retainstack',
                'not',
                'tuple?',
                'dup',
                '3nipd',
                'call',
                '-rotd',
                'object',
                'drop',
                'assert=',
                'assert?',
                '-rot',
                'execute',
                'boa',
                'get-callstack',
                'curried?',
                '3drop',
                'pickd',
                'overd',
                'over',
                'roll',
                '3nip',
                'swap',
                'and',
                '2nip',
                'rotd',
                'throw',
                '(clone)',
                'hashcode*',
                'spin',
                'reach',
                '4dup',
                'equal?',
                'get-datastack',
                'assert',
                '2drop',
                '<wrapper>',
                'boolean?',
                'identity-hashcode',
                'identity-tuple?',
                'null',
                'composed?',
                'new',
                '5drop',
                'rot',
                '-roll',
                'xor',
                'identity-tuple',
                'boolean'
            ],
            'other-builtin-syntax': [
                // syntax
                '=======',
                'recursive',
                'flushable',
                '>>',
                '<<<<<<',
                'M\\',
                'B',
                'PRIVATE>',
                '\\',
                '======',
                'final',
                'inline',
                'delimiter',
                'deprecated',
                '<PRIVATE',
                '>>>>>>',
                '<<<<<<<',
                'parse-complex',
                'malformed-complex',
                'read-only',
                '>>>>>>>',
                'call-next-method',
                '<<',
                'foldable',
                '$',
                '$[',
                '${'
            ],
            'sequences-builtin': [
                'member-eq?',
                'mismatch',
                'append',
                'assert-sequence=',
                'longer',
                'repetition',
                'clone-like',
                '3sequence',
                'assert-sequence?',
                'last-index-from',
                'reversed',
                'index-from',
                'cut*',
                'pad-tail',
                'join-as',
                'remove-eq!',
                'concat-as',
                'but-last',
                'snip',
                'nths',
                'nth',
                'sequence',
                'longest',
                'slice?',
                '<slice>',
                'remove-nth',
                'tail-slice',
                'empty?',
                'tail*',
                'member?',
                'virtual-sequence?',
                'set-length',
                'drop-prefix',
                'iota',
                'unclip',
                'bounds-error?',
                'unclip-last-slice',
                'non-negative-integer-expected',
                'non-negative-integer-expected?',
                'midpoint@',
                'longer?',
                '?set-nth',
                '?first',
                'rest-slice',
                'prepend-as',
                'prepend',
                'fourth',
                'sift',
                'subseq-start',
                'new-sequence',
                '?last',
                'like',
                'first4',
                '1sequence',
                'reverse',
                'slice',
                'virtual@',
                'repetition?',
                'set-last',
                'index',
                '4sequence',
                'max-length',
                'set-second',
                'immutable-sequence',
                'first2',
                'first3',
                'supremum',
                'unclip-slice',
                'suffix!',
                'insert-nth',
                'tail',
                '3append',
                'short',
                'suffix',
                'concat',
                'flip',
                'immutable?',
                'reverse!',
                '2sequence',
                'sum',
                'delete-all',
                'indices',
                'snip-slice',
                '<iota>',
                'check-slice',
                'sequence?',
                'head',
                'append-as',
                'halves',
                'sequence=',
                'collapse-slice',
                '?second',
                'slice-error?',
                'product',
                'bounds-check?',
                'bounds-check',
                'immutable',
                'virtual-exemplar',
                'harvest',
                'remove',
                'pad-head',
                'last',
                'set-fourth',
                'cartesian-product',
                'remove-eq',
                'shorten',
                'shorter',
                'reversed?',
                'shorter?',
                'shortest',
                'head-slice',
                'pop*',
                'tail-slice*',
                'but-last-slice',
                'iota?',
                'append!',
                'cut-slice',
                'new-resizable',
                'head-slice*',
                'sequence-hashcode',
                'pop',
                'set-nth',
                '?nth',
                'second',
                'join',
                'immutable-sequence?',
                '<reversed>',
                '3append-as',
                'virtual-sequence',
                'subseq?',
                'remove-nth!',
                'length',
                'last-index',
                'lengthen',
                'assert-sequence',
                'copy',
                'move',
                'third',
                'first',
                'tail?',
                'set-first',
                'prefix',
                'bounds-error',
                '<repetition>',
                'exchange',
                'surround',
                'cut',
                'min-length',
                'set-third',
                'push-all',
                'head?',
                'subseq-start-from',
                'delete-slice',
                'rest',
                'sum-lengths',
                'head*',
                'infimum',
                'remove!',
                'glue',
                'slice-error',
                'subseq',
                'push',
                'replace-slice',
                'subseq-as',
                'unclip-last'
            ],
            'math-builtin': [
                'number=',
                'next-power-of-2',
                '?1+',
                'fp-special?',
                'imaginary-part',
                'float>bits',
                'number?',
                'fp-infinity?',
                'bignum?',
                'fp-snan?',
                'denominator',
                'gcd',
                '*',
                '+',
                'fp-bitwise=',
                '-',
                'u>=',
                '/',
                '>=',
                'bitand',
                'power-of-2?',
                'log2-expects-positive',
                'neg?',
                '<',
                'log2',
                '>',
                'integer?',
                'number',
                'bits>double',
                '2/',
                'zero?',
                'bits>float',
                'float?',
                'shift',
                'ratio?',
                'rect>',
                'even?',
                'ratio',
                'fp-sign',
                'bitnot',
                '>fixnum',
                'complex?',
                '/i',
                'integer>fixnum',
                '/f',
                'sgn',
                '>bignum',
                'next-float',
                'u<',
                'u>',
                'mod',
                'recip',
                'rational',
                '>float',
                '2^',
                'integer',
                'fixnum?',
                'neg',
                'fixnum',
                'sq',
                'bignum',
                '>rect',
                'bit?',
                'fp-qnan?',
                'simple-gcd',
                'complex',
                '<fp-nan>',
                'real',
                '>fraction',
                'double>bits',
                'bitor',
                'rem',
                'fp-nan-payload',
                'real-part',
                'log2-expects-positive?',
                'prev-float',
                'align',
                'unordered?',
                'float',
                'fp-nan?',
                'abs',
                'bitxor',
                'integer>fixnum-strict',
                'u<=',
                'odd?',
                '<=',
                '/mod',
                '>integer',
                'real?',
                'rational?',
                'numerator'
            ] // that's all for now
        };
        Object.keys(builtins).forEach(function(k) {
            factor[k].pattern = arrToWordsRegExp(builtins[k]);
        });
        var combinators = [
            // kernel
            '2bi',
            'while',
            '2tri',
            'bi*',
            '4dip',
            'both?',
            'same?',
            'tri@',
            'curry',
            'prepose',
            '3bi',
            '?if',
            'tri*',
            '2keep',
            '3keep',
            'curried',
            '2keepd',
            'when',
            '2bi*',
            '2tri*',
            '4keep',
            'bi@',
            'keepdd',
            'do',
            'unless*',
            'tri-curry',
            'if*',
            'loop',
            'bi-curry*',
            'when*',
            '2bi@',
            '2tri@',
            'with',
            '2with',
            'either?',
            'bi',
            'until',
            '3dip',
            '3curry',
            'tri-curry*',
            'tri-curry@',
            'bi-curry',
            'keepd',
            'compose',
            '2dip',
            'if',
            '3tri',
            'unless',
            'tuple',
            'keep',
            '2curry',
            'tri',
            'most',
            'while*',
            'dip',
            'composed',
            'bi-curry@',
            'find-last-from',
            'trim-head-slice',
            'map-as',
            'each-from',
            'none?',
            'trim-tail',
            'partition',
            'if-empty',
            'accumulate*',
            'reject!',
            'find-from',
            'accumulate-as',
            'collector-for-as',
            'reject',
            'map',
            'map-sum',
            'accumulate!',
            '2each-from',
            'follow',
            'supremum-by',
            'map!',
            'unless-empty',
            'collector',
            'padding',
            'reduce-index',
            'replicate-as',
            'infimum-by',
            'trim-tail-slice',
            'count',
            'find-index',
            'filter',
            'accumulate*!',
            'reject-as',
            'map-integers',
            'map-find',
            'reduce',
            'selector',
            'interleave',
            '2map',
            'filter-as',
            'binary-reduce',
            'map-index-as',
            'find',
            'produce',
            'filter!',
            'replicate',
            'cartesian-map',
            'cartesian-each',
            'find-index-from',
            'map-find-last',
            '3map-as',
            '3map',
            'find-last',
            'selector-as',
            '2map-as',
            '2map-reduce',
            'accumulate',
            'each',
            'each-index',
            'accumulate*-as',
            'when-empty',
            'all?',
            'collector-as',
            'push-either',
            'new-like',
            'collector-for',
            '2selector',
            'push-if',
            '2all?',
            'map-reduce',
            '3each',
            'any?',
            'trim-slice',
            '2reduce',
            'change-nth',
            'produce-as',
            '2each',
            'trim',
            'trim-head',
            'cartesian-find',
            'map-index',
            'if-zero',
            'each-integer',
            'unless-zero',
            '(find-integer)',
            'when-zero',
            'find-last-integer',
            '(all-integers?)',
            'times',
            '(each-integer)',
            'find-integer',
            'all-integers?',
            'unless-negative',
            'if-positive',
            'when-positive',
            'when-negative',
            'unless-positive',
            'if-negative',
            'case',
            '2cleave',
            'cond>quot',
            'case>quot',
            '3cleave',
            'wrong-values',
            'to-fixed-point',
            'alist>quot',
            'cond',
            'cleave',
            'call-effect',
            'recursive-hashcode',
            'spread',
            'deep-spread>quot',
            '2||',
            '0||',
            'n||',
            '0&&',
            '2&&',
            '3||',
            '1||',
            '1&&',
            'n&&',
            '3&&',
            'smart-unless*',
            'keep-inputs',
            'reduce-outputs',
            'smart-when*',
            'cleave>array',
            'smart-with',
            'smart-apply',
            'smart-if',
            'inputs/outputs',
            'output>sequence-n',
            'map-outputs',
            'map-reduce-outputs',
            'dropping',
            'output>array',
            'smart-map-reduce',
            'smart-2map-reduce',
            'output>array-n',
            'nullary',
            'input<sequence',
            'append-outputs',
            'drop-inputs',
            'inputs',
            'smart-2reduce',
            'drop-outputs',
            'smart-reduce',
            'preserving',
            'smart-when',
            'outputs',
            'append-outputs-as',
            'smart-unless',
            'smart-if*',
            'sum-outputs',
            'input<sequence-unsafe',
            'output>sequence' // tafn
        ];
        factor.combinators.pattern = arrToWordsRegExp(combinators);
        Prism.languages.factor = factor;
    })(Prism);
}

});

parcelRegister("d02KX", function(module, exports) {
'use strict';
module.exports = $976d69cb272233e6$var$$false;
$976d69cb272233e6$var$$false.displayName = '$false';
$976d69cb272233e6$var$$false.aliases = [];
function $976d69cb272233e6$var$$false(Prism) {
    (function(Prism) {
        /**
     * Based on the manual by Wouter van Oortmerssen.
     *
     * @see {@link https://github.com/PrismJS/prism/issues/2801#issue-829717504}
     */ Prism.languages['false'] = {
            comment: {
                pattern: /\{[^}]*\}/
            },
            string: {
                pattern: /"[^"]*"/,
                greedy: true
            },
            'character-code': {
                pattern: /'(?:[^\r]|\r\n?)/,
                alias: 'number'
            },
            'assembler-code': {
                pattern: /\d+`/,
                alias: 'important'
            },
            number: /\d+/,
            operator: /[-!#$%&'*+,./:;=>?@\\^_`|~ßø]/,
            punctuation: /\[|\]/,
            variable: /[a-z]/,
            'non-standard': {
                pattern: /[()<BDO®]/,
                alias: 'bold'
            }
        };
    })(Prism);
}

});

parcelRegister("hOSVI", function(module, exports) {
'use strict';
module.exports = $cf91b71b942a241b$var$firestoreSecurityRules;
$cf91b71b942a241b$var$firestoreSecurityRules.displayName = 'firestoreSecurityRules';
$cf91b71b942a241b$var$firestoreSecurityRules.aliases = [];
function $cf91b71b942a241b$var$firestoreSecurityRules(Prism) {
    Prism.languages['firestore-security-rules'] = Prism.languages.extend('clike', {
        comment: /\/\/.*/,
        keyword: /\b(?:allow|function|if|match|null|return|rules_version|service)\b/,
        operator: /&&|\|\||[<>!=]=?|[-+*/%]|\b(?:in|is)\b/
    });
    delete Prism.languages['firestore-security-rules']['class-name'];
    Prism.languages.insertBefore('firestore-security-rules', 'keyword', {
        path: {
            pattern: /(^|[\s(),])(?:\/(?:[\w\xA0-\uFFFF]+|\{[\w\xA0-\uFFFF]+(?:=\*\*)?\}|\$\([\w\xA0-\uFFFF.]+\)))+/,
            lookbehind: true,
            greedy: true,
            inside: {
                variable: {
                    pattern: /\{[\w\xA0-\uFFFF]+(?:=\*\*)?\}|\$\([\w\xA0-\uFFFF.]+\)/,
                    inside: {
                        operator: /=/,
                        keyword: /\*\*/,
                        punctuation: /[.$(){}]/
                    }
                },
                punctuation: /\//
            }
        },
        method: {
            // to make the pattern shorter, the actual method names are omitted
            pattern: /(\ballow\s+)[a-z]+(?:\s*,\s*[a-z]+)*(?=\s*[:;])/,
            lookbehind: true,
            alias: 'builtin',
            inside: {
                punctuation: /,/
            }
        }
    });
}

});

parcelRegister("1aQjc", function(module, exports) {
'use strict';
module.exports = $0daf4d08cf4f9e5c$var$flow;
$0daf4d08cf4f9e5c$var$flow.displayName = 'flow';
$0daf4d08cf4f9e5c$var$flow.aliases = [];
function $0daf4d08cf4f9e5c$var$flow(Prism) {
    (function(Prism) {
        Prism.languages.flow = Prism.languages.extend('javascript', {});
        Prism.languages.insertBefore('flow', 'keyword', {
            type: [
                {
                    pattern: /\b(?:[Bb]oolean|Function|[Nn]umber|[Ss]tring|any|mixed|null|void)\b/,
                    alias: 'tag'
                }
            ]
        });
        Prism.languages.flow['function-variable'].pattern = /(?!\s)[_$a-z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*(?=\s*=\s*(?:function\b|(?:\([^()]*\)(?:\s*:\s*\w+)?|(?!\s)[_$a-z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*)\s*=>))/i;
        delete Prism.languages.flow['parameter'];
        Prism.languages.insertBefore('flow', 'operator', {
            'flow-punctuation': {
                pattern: /\{\||\|\}/,
                alias: 'punctuation'
            }
        });
        if (!Array.isArray(Prism.languages.flow.keyword)) Prism.languages.flow.keyword = [
            Prism.languages.flow.keyword
        ];
        Prism.languages.flow.keyword.unshift({
            pattern: /(^|[^$]\b)(?:Class|declare|opaque|type)\b(?!\$)/,
            lookbehind: true
        }, {
            pattern: /(^|[^$]\B)\$(?:Diff|Enum|Exact|Keys|ObjMap|PropertyType|Record|Shape|Subtype|Supertype|await)\b(?!\$)/,
            lookbehind: true
        });
    })(Prism);
}

});

parcelRegister("RraQ5", function(module, exports) {
'use strict';
module.exports = $0a0a0781e5c50878$var$fortran;
$0a0a0781e5c50878$var$fortran.displayName = 'fortran';
$0a0a0781e5c50878$var$fortran.aliases = [];
function $0a0a0781e5c50878$var$fortran(Prism) {
    Prism.languages.fortran = {
        'quoted-number': {
            pattern: /[BOZ](['"])[A-F0-9]+\1/i,
            alias: 'number'
        },
        string: {
            pattern: /(?:\b\w+_)?(['"])(?:\1\1|&(?:\r\n?|\n)(?:[ \t]*!.*(?:\r\n?|\n)|(?![ \t]*!))|(?!\1).)*(?:\1|&)/,
            inside: {
                comment: {
                    pattern: /(&(?:\r\n?|\n)\s*)!.*/,
                    lookbehind: true
                }
            }
        },
        comment: {
            pattern: /!.*/,
            greedy: true
        },
        boolean: /\.(?:FALSE|TRUE)\.(?:_\w+)?/i,
        number: /(?:\b\d+(?:\.\d*)?|\B\.\d+)(?:[ED][+-]?\d+)?(?:_\w+)?/i,
        keyword: [
            // Types
            /\b(?:CHARACTER|COMPLEX|DOUBLE ?PRECISION|INTEGER|LOGICAL|REAL)\b/i,
            /\b(?:END ?)?(?:BLOCK ?DATA|DO|FILE|FORALL|FUNCTION|IF|INTERFACE|MODULE(?! PROCEDURE)|PROGRAM|SELECT|SUBROUTINE|TYPE|WHERE)\b/i,
            /\b(?:ALLOCATABLE|ALLOCATE|BACKSPACE|CALL|CASE|CLOSE|COMMON|CONTAINS|CONTINUE|CYCLE|DATA|DEALLOCATE|DIMENSION|DO|END|EQUIVALENCE|EXIT|EXTERNAL|FORMAT|GO ?TO|IMPLICIT(?: NONE)?|INQUIRE|INTENT|INTRINSIC|MODULE PROCEDURE|NAMELIST|NULLIFY|OPEN|OPTIONAL|PARAMETER|POINTER|PRINT|PRIVATE|PUBLIC|READ|RETURN|REWIND|SAVE|SELECT|STOP|TARGET|WHILE|WRITE)\b/i,
            /\b(?:ASSIGNMENT|DEFAULT|ELEMENTAL|ELSE|ELSEIF|ELSEWHERE|ENTRY|IN|INCLUDE|INOUT|KIND|NULL|ONLY|OPERATOR|OUT|PURE|RECURSIVE|RESULT|SEQUENCE|STAT|THEN|USE)\b/i
        ],
        operator: [
            /\*\*|\/\/|=>|[=\/]=|[<>]=?|::|[+\-*=%]|\.[A-Z]+\./i,
            {
                // Use lookbehind to prevent confusion with (/ /)
                pattern: /(^|(?!\().)\/(?!\))/,
                lookbehind: true
            }
        ],
        punctuation: /\(\/|\/\)|[(),;:&]/
    };
}

});

parcelRegister("8o27y", function(module, exports) {
'use strict';
module.exports = $61b235c381cd43b8$var$fsharp;
$61b235c381cd43b8$var$fsharp.displayName = 'fsharp';
$61b235c381cd43b8$var$fsharp.aliases = [];
function $61b235c381cd43b8$var$fsharp(Prism) {
    Prism.languages.fsharp = Prism.languages.extend('clike', {
        comment: [
            {
                pattern: /(^|[^\\])\(\*(?!\))[\s\S]*?\*\)/,
                lookbehind: true,
                greedy: true
            },
            {
                pattern: /(^|[^\\:])\/\/.*/,
                lookbehind: true,
                greedy: true
            }
        ],
        string: {
            pattern: /(?:"""[\s\S]*?"""|@"(?:""|[^"])*"|"(?:\\[\s\S]|[^\\"])*")B?/,
            greedy: true
        },
        'class-name': {
            pattern: /(\b(?:exception|inherit|interface|new|of|type)\s+|\w\s*:\s*|\s:\??>\s*)[.\w]+\b(?:\s*(?:->|\*)\s*[.\w]+\b)*(?!\s*[:.])/,
            lookbehind: true,
            inside: {
                operator: /->|\*/,
                punctuation: /\./
            }
        },
        keyword: /\b(?:let|return|use|yield)(?:!\B|\b)|\b(?:abstract|and|as|asr|assert|atomic|base|begin|break|checked|class|component|const|constraint|constructor|continue|default|delegate|do|done|downcast|downto|eager|elif|else|end|event|exception|extern|external|false|finally|fixed|for|fun|function|functor|global|if|in|include|inherit|inline|interface|internal|land|lazy|lor|lsl|lsr|lxor|match|member|method|mixin|mod|module|mutable|namespace|new|not|null|object|of|open|or|override|parallel|private|process|protected|public|pure|rec|sealed|select|sig|static|struct|tailcall|then|to|trait|true|try|type|upcast|val|virtual|void|volatile|when|while|with)\b/,
        number: [
            /\b0x[\da-fA-F]+(?:LF|lf|un)?\b/,
            /\b0b[01]+(?:uy|y)?\b/,
            /(?:\b\d+(?:\.\d*)?|\B\.\d+)(?:[fm]|e[+-]?\d+)?\b/i,
            /\b\d+(?:[IlLsy]|UL|u[lsy]?)?\b/
        ],
        operator: /([<>~&^])\1\1|([*.:<>&])\2|<-|->|[!=:]=|<?\|{1,3}>?|\??(?:<=|>=|<>|[-+*/%=<>])\??|[!?^&]|~[+~-]|:>|:\?>?/
    });
    Prism.languages.insertBefore('fsharp', 'keyword', {
        preprocessor: {
            pattern: /(^[\t ]*)#.*/m,
            lookbehind: true,
            alias: 'property',
            inside: {
                directive: {
                    pattern: /(^#)\b(?:else|endif|if|light|line|nowarn)\b/,
                    lookbehind: true,
                    alias: 'keyword'
                }
            }
        }
    });
    Prism.languages.insertBefore('fsharp', 'punctuation', {
        'computation-expression': {
            pattern: /\b[_a-z]\w*(?=\s*\{)/i,
            alias: 'keyword'
        }
    });
    Prism.languages.insertBefore('fsharp', 'string', {
        annotation: {
            pattern: /\[<.+?>\]/,
            greedy: true,
            inside: {
                punctuation: /^\[<|>\]$/,
                'class-name': {
                    pattern: /^\w+$|(^|;\s*)[A-Z]\w*(?=\()/,
                    lookbehind: true
                },
                'annotation-content': {
                    pattern: /[\s\S]+/,
                    inside: Prism.languages.fsharp
                }
            }
        },
        char: {
            pattern: /'(?:[^\\']|\\(?:.|\d{3}|x[a-fA-F\d]{2}|u[a-fA-F\d]{4}|U[a-fA-F\d]{8}))'B?/,
            greedy: true
        }
    });
}

});

parcelRegister("6QKss", function(module, exports) {
'use strict';

var $949g8 = parcelRequire("949g8");
module.exports = $4fcba2fcdf49522c$var$ftl;
$4fcba2fcdf49522c$var$ftl.displayName = 'ftl';
$4fcba2fcdf49522c$var$ftl.aliases = [];
function $4fcba2fcdf49522c$var$ftl(Prism) {
    Prism.register($949g8);
    (function(Prism) {
        // https://freemarker.apache.org/docs/dgui_template_exp.html
        // FTL expression with 4 levels of nesting supported
        var FTL_EXPR = /[^<()"']|\((?:<expr>)*\)|<(?!#--)|<#--(?:[^-]|-(?!->))*-->|"(?:[^\\"]|\\.)*"|'(?:[^\\']|\\.)*'/.source;
        for(var i = 0; i < 2; i++)FTL_EXPR = FTL_EXPR.replace(/<expr>/g, function() {
            return FTL_EXPR;
        });
        FTL_EXPR = FTL_EXPR.replace(/<expr>/g, /[^\s\S]/.source);
        var ftl = {
            comment: /<#--[\s\S]*?-->/,
            string: [
                {
                    // raw string
                    pattern: /\br("|')(?:(?!\1)[^\\]|\\.)*\1/,
                    greedy: true
                },
                {
                    pattern: RegExp(/("|')(?:(?!\1|\$\{)[^\\]|\\.|\$\{(?:(?!\})(?:<expr>))*\})*\1/.source.replace(/<expr>/g, function() {
                        return FTL_EXPR;
                    })),
                    greedy: true,
                    inside: {
                        interpolation: {
                            pattern: RegExp(/((?:^|[^\\])(?:\\\\)*)\$\{(?:(?!\})(?:<expr>))*\}/.source.replace(/<expr>/g, function() {
                                return FTL_EXPR;
                            })),
                            lookbehind: true,
                            inside: {
                                'interpolation-punctuation': {
                                    pattern: /^\$\{|\}$/,
                                    alias: 'punctuation'
                                },
                                rest: null
                            }
                        }
                    }
                }
            ],
            keyword: /\b(?:as)\b/,
            boolean: /\b(?:false|true)\b/,
            'builtin-function': {
                pattern: /((?:^|[^?])\?\s*)\w+/,
                lookbehind: true,
                alias: 'function'
            },
            function: /\b\w+(?=\s*\()/,
            number: /\b\d+(?:\.\d+)?\b/,
            operator: /\.\.[<*!]?|->|--|\+\+|&&|\|\||\?{1,2}|[-+*/%!=<>]=?|\b(?:gt|gte|lt|lte)\b/,
            punctuation: /[,;.:()[\]{}]/
        };
        ftl.string[1].inside.interpolation.inside.rest = ftl;
        Prism.languages.ftl = {
            'ftl-comment': {
                // the pattern is shortened to be more efficient
                pattern: /^<#--[\s\S]*/,
                alias: 'comment'
            },
            'ftl-directive': {
                pattern: /^<[\s\S]+>$/,
                inside: {
                    directive: {
                        pattern: /(^<\/?)[#@][a-z]\w*/i,
                        lookbehind: true,
                        alias: 'keyword'
                    },
                    punctuation: /^<\/?|\/?>$/,
                    content: {
                        pattern: /\s*\S[\s\S]*/,
                        alias: 'ftl',
                        inside: ftl
                    }
                }
            },
            'ftl-interpolation': {
                pattern: /^\$\{[\s\S]*\}$/,
                inside: {
                    punctuation: /^\$\{|\}$/,
                    content: {
                        pattern: /\s*\S[\s\S]*/,
                        alias: 'ftl',
                        inside: ftl
                    }
                }
            }
        };
        Prism.hooks.add('before-tokenize', function(env) {
            // eslint-disable-next-line regexp/no-useless-lazy
            var pattern = RegExp(/<#--[\s\S]*?-->|<\/?[#@][a-zA-Z](?:<expr>)*?>|\$\{(?:<expr>)*?\}/.source.replace(/<expr>/g, function() {
                return FTL_EXPR;
            }), 'gi');
            Prism.languages['markup-templating'].buildPlaceholders(env, 'ftl', pattern);
        });
        Prism.hooks.add('after-tokenize', function(env) {
            Prism.languages['markup-templating'].tokenizePlaceholders(env, 'ftl');
        });
    })(Prism);
}

});

parcelRegister("50CB7", function(module, exports) {
'use strict';
module.exports = $3a5ae487cdac984f$var$gap;
$3a5ae487cdac984f$var$gap.displayName = 'gap';
$3a5ae487cdac984f$var$gap.aliases = [];
function $3a5ae487cdac984f$var$gap(Prism) {
    // https://www.gap-system.org/Manuals/doc/ref/chap4.html
    // https://www.gap-system.org/Manuals/doc/ref/chap27.html
    Prism.languages.gap = {
        shell: {
            pattern: /^gap>[\s\S]*?(?=^gap>|$(?![\s\S]))/m,
            greedy: true,
            inside: {
                gap: {
                    pattern: /^(gap>).+(?:(?:\r(?:\n|(?!\n))|\n)>.*)*/,
                    lookbehind: true,
                    inside: null // see below
                },
                punctuation: /^gap>/
            }
        },
        comment: {
            pattern: /#.*/,
            greedy: true
        },
        string: {
            pattern: /(^|[^\\'"])(?:'(?:[^\r\n\\']|\\.){1,10}'|"(?:[^\r\n\\"]|\\.)*"(?!")|"""[\s\S]*?""")/,
            lookbehind: true,
            greedy: true,
            inside: {
                continuation: {
                    pattern: /([\r\n])>/,
                    lookbehind: true,
                    alias: 'punctuation'
                }
            }
        },
        keyword: /\b(?:Assert|Info|IsBound|QUIT|TryNextMethod|Unbind|and|atomic|break|continue|do|elif|else|end|fi|for|function|if|in|local|mod|not|od|or|quit|readonly|readwrite|rec|repeat|return|then|until|while)\b/,
        boolean: /\b(?:false|true)\b/,
        function: /\b[a-z_]\w*(?=\s*\()/i,
        number: {
            pattern: /(^|[^\w.]|\.\.)(?:\d+(?:\.\d*)?|\.\d+)(?:[eE][+-]?\d+)?(?:_[a-z]?)?(?=$|[^\w.]|\.\.)/,
            lookbehind: true
        },
        continuation: {
            pattern: /([\r\n])>/,
            lookbehind: true,
            alias: 'punctuation'
        },
        operator: /->|[-+*/^~=!]|<>|[<>]=?|:=|\.\./,
        punctuation: /[()[\]{},;.:]/
    };
    Prism.languages.gap.shell.inside.gap.inside = Prism.languages.gap;
}

});

parcelRegister("17Zfk", function(module, exports) {
'use strict';
module.exports = $0d25f41eafbef018$var$gcode;
$0d25f41eafbef018$var$gcode.displayName = 'gcode';
$0d25f41eafbef018$var$gcode.aliases = [];
function $0d25f41eafbef018$var$gcode(Prism) {
    Prism.languages.gcode = {
        comment: /;.*|\B\(.*?\)\B/,
        string: {
            pattern: /"(?:""|[^"])*"/,
            greedy: true
        },
        keyword: /\b[GM]\d+(?:\.\d+)?\b/,
        property: /\b[A-Z]/,
        checksum: {
            pattern: /(\*)\d+/,
            lookbehind: true,
            alias: 'number'
        },
        // T0:0:0
        punctuation: /[:*]/
    };
}

});

parcelRegister("a9tsC", function(module, exports) {
'use strict';
module.exports = $764198e6d5abf439$var$gdscript;
$764198e6d5abf439$var$gdscript.displayName = 'gdscript';
$764198e6d5abf439$var$gdscript.aliases = [];
function $764198e6d5abf439$var$gdscript(Prism) {
    Prism.languages.gdscript = {
        comment: /#.*/,
        string: {
            pattern: /@?(?:("|')(?:(?!\1)[^\n\\]|\\[\s\S])*\1(?!"|')|"""(?:[^\\]|\\[\s\S])*?""")/,
            greedy: true
        },
        'class-name': {
            // class_name Foo, extends Bar, class InnerClass
            // export(int) var baz, export(int, 0) var i
            // as Node
            // const FOO: int = 9, var bar: bool = true
            // func add(reference: Item, amount: int) -> Item:
            pattern: /(^(?:class|class_name|extends)[ \t]+|^export\([ \t]*|\bas[ \t]+|(?:\b(?:const|var)[ \t]|[,(])[ \t]*\w+[ \t]*:[ \t]*|->[ \t]*)[a-zA-Z_]\w*/m,
            lookbehind: true
        },
        keyword: /\b(?:and|as|assert|break|breakpoint|class|class_name|const|continue|elif|else|enum|export|extends|for|func|if|in|is|master|mastersync|match|not|null|onready|or|pass|preload|puppet|puppetsync|remote|remotesync|return|self|setget|signal|static|tool|var|while|yield)\b/,
        function: /\b[a-z_]\w*(?=[ \t]*\()/i,
        variable: /\$\w+/,
        number: [
            /\b0b[01_]+\b|\b0x[\da-fA-F_]+\b|(?:\b\d[\d_]*(?:\.[\d_]*)?|\B\.[\d_]+)(?:e[+-]?[\d_]+)?\b/,
            /\b(?:INF|NAN|PI|TAU)\b/
        ],
        constant: /\b[A-Z][A-Z_\d]*\b/,
        boolean: /\b(?:false|true)\b/,
        operator: /->|:=|&&|\|\||<<|>>|[-+*/%&|!<>=]=?|[~^]/,
        punctuation: /[.:,;()[\]{}]/
    };
}

});

parcelRegister("ghQlc", function(module, exports) {
'use strict';
module.exports = $bdb6d5ac697a00cb$var$gedcom;
$bdb6d5ac697a00cb$var$gedcom.displayName = 'gedcom';
$bdb6d5ac697a00cb$var$gedcom.aliases = [];
function $bdb6d5ac697a00cb$var$gedcom(Prism) {
    Prism.languages.gedcom = {
        'line-value': {
            // Preceded by level, optional pointer, and tag
            pattern: /(^[\t ]*\d+ +(?:@\w[\w!"$%&'()*+,\-./:;<=>?[\\\]^`{|}~\x80-\xfe #]*@ +)?\w+ ).+/m,
            lookbehind: true,
            inside: {
                pointer: {
                    pattern: /^@\w[\w!"$%&'()*+,\-./:;<=>?[\\\]^`{|}~\x80-\xfe #]*@$/,
                    alias: 'variable'
                }
            }
        },
        tag: {
            // Preceded by level and optional pointer
            pattern: /(^[\t ]*\d+ +(?:@\w[\w!"$%&'()*+,\-./:;<=>?[\\\]^`{|}~\x80-\xfe #]*@ +)?)\w+/m,
            lookbehind: true,
            alias: 'string'
        },
        level: {
            pattern: /(^[\t ]*)\d+/m,
            lookbehind: true,
            alias: 'number'
        },
        pointer: {
            pattern: /@\w[\w!"$%&'()*+,\-./:;<=>?[\\\]^`{|}~\x80-\xfe #]*@/,
            alias: 'variable'
        }
    };
}

});

parcelRegister("gf4KM", function(module, exports) {
'use strict';
module.exports = $bd31bc001291a277$var$gherkin;
$bd31bc001291a277$var$gherkin.displayName = 'gherkin';
$bd31bc001291a277$var$gherkin.aliases = [];
function $bd31bc001291a277$var$gherkin(Prism) {
    (function(Prism) {
        var tableRow = /(?:\r?\n|\r)[ \t]*\|.+\|(?:(?!\|).)*/.source;
        Prism.languages.gherkin = {
            pystring: {
                pattern: /("""|''')[\s\S]+?\1/,
                alias: 'string'
            },
            comment: {
                pattern: /(^[ \t]*)#.*/m,
                lookbehind: true
            },
            tag: {
                pattern: /(^[ \t]*)@\S*/m,
                lookbehind: true
            },
            feature: {
                pattern: /((?:^|\r?\n|\r)[ \t]*)(?:Ability|Ahoy matey!|Arwedd|Aspekt|Besigheid Behoefte|Business Need|Caracteristica|Característica|Egenskab|Egenskap|Eiginleiki|Feature|Fīča|Fitur|Fonctionnalité|Fonksyonalite|Funcionalidade|Funcionalitat|Functionalitate|Funcţionalitate|Funcționalitate|Functionaliteit|Fungsi|Funkcia|Funkcija|Funkcionalitāte|Funkcionalnost|Funkcja|Funksie|Funktionalität|Funktionalitéit|Funzionalità|Hwaet|Hwæt|Jellemző|Karakteristik|Lastnost|Mak|Mogucnost|laH|Mogućnost|Moznosti|Možnosti|OH HAI|Omadus|Ominaisuus|Osobina|Özellik|Potrzeba biznesowa|perbogh|poQbogh malja'|Požadavek|Požiadavka|Pretty much|Qap|Qu'meH 'ut|Savybė|Tính năng|Trajto|Vermoë|Vlastnosť|Właściwość|Značilnost|Δυνατότητα|Λειτουργία|Могућност|Мөмкинлек|Особина|Свойство|Үзенчәлеклелек|Функционал|Функционалност|Функция|Функціонал|תכונה|خاصية|خصوصیت|صلاحیت|کاروبار کی ضرورت|وِیژگی|रूप लेख|ਖਾਸੀਅਤ|ਨਕਸ਼ ਨੁਹਾਰ|ਮੁਹਾਂਦਰਾ|గుణము|ಹೆಚ್ಚಳ|ความต้องการทางธุรกิจ|ความสามารถ|โครงหลัก|기능|フィーチャ|功能|機能):(?:[^:\r\n]+(?:\r?\n|\r|$))*/,
                lookbehind: true,
                inside: {
                    important: {
                        pattern: /(:)[^\r\n]+/,
                        lookbehind: true
                    },
                    keyword: /[^:\r\n]+:/
                }
            },
            scenario: {
                pattern: /(^[ \t]*)(?:Abstract Scenario|Abstrakt Scenario|Achtergrond|Aer|Ær|Agtergrond|All y'all|Antecedentes|Antecedents|Atburðarás|Atburðarásir|Awww, look mate|B4|Background|Baggrund|Bakgrund|Bakgrunn|Bakgrunnur|Beispiele|Beispiller|Bối cảnh|Cefndir|Cenario|Cenário|Cenario de Fundo|Cenário de Fundo|Cenarios|Cenários|Contesto|Context|Contexte|Contexto|Conto|Contoh|Contone|Dæmi|Dasar|Dead men tell no tales|Delineacao do Cenario|Delineação do Cenário|Dis is what went down|Dữ liệu|Dyagram Senaryo|Dyagram senaryo|Egzanp|Ejemplos|Eksempler|Ekzemploj|Enghreifftiau|Esbozo do escenario|Escenari|Escenario|Esempi|Esquema de l'escenari|Esquema del escenario|Esquema do Cenario|Esquema do Cenário|EXAMPLZ|Examples|Exempel|Exemple|Exemples|Exemplos|First off|Fono|Forgatókönyv|Forgatókönyv vázlat|Fundo|Geçmiş|Grundlage|Hannergrond|ghantoH|Háttér|Heave to|Istorik|Juhtumid|Keadaan|Khung kịch bản|Khung tình huống|Kịch bản|Koncept|Konsep skenario|Kontèks|Kontekst|Kontekstas|Konteksts|Kontext|Konturo de la scenaro|Latar Belakang|lut chovnatlh|lut|lutmey|Lýsing Atburðarásar|Lýsing Dæma|MISHUN SRSLY|MISHUN|Menggariskan Senario|mo'|Náčrt Scenára|Náčrt Scénáře|Náčrt Scenáru|Oris scenarija|Örnekler|Osnova|Osnova Scenára|Osnova scénáře|Osnutek|Ozadje|Paraugs|Pavyzdžiai|Példák|Piemēri|Plan du scénario|Plan du Scénario|Plan Senaryo|Plan senaryo|Plang vum Szenario|Pozadí|Pozadie|Pozadina|Príklady|Příklady|Primer|Primeri|Primjeri|Przykłady|Raamstsenaarium|Reckon it's like|Rerefons|Scenár|Scénář|Scenarie|Scenarij|Scenarijai|Scenarijaus šablonas|Scenariji|Scenārijs|Scenārijs pēc parauga|Scenarijus|Scenario|Scénario|Scenario Amlinellol|Scenario Outline|Scenario Template|Scenariomal|Scenariomall|Scenarios|Scenariu|Scenariusz|Scenaro|Schema dello scenario|Se ðe|Se the|Se þe|Senario|Senaryo Deskripsyon|Senaryo deskripsyon|Senaryo|Senaryo taslağı|Shiver me timbers|Situācija|Situai|Situasie Uiteensetting|Situasie|Skenario konsep|Skenario|Skica|Structura scenariu|Structură scenariu|Struktura scenarija|Stsenaarium|Swa hwaer swa|Swa|Swa hwær swa|Szablon scenariusza|Szenario|Szenariogrundriss|Tapaukset|Tapaus|Tapausaihio|Taust|Tausta|Template Keadaan|Template Senario|Template Situai|The thing of it is|Tình huống|Variantai|Voorbeelde|Voorbeelden|Wharrimean is|Yo-ho-ho|You'll wanna|Założenia|Παραδείγματα|Περιγραφή Σεναρίου|Σενάρια|Σενάριο|Υπόβαθρο|Кереш|Контекст|Концепт|Мисаллар|Мисоллар|Основа|Передумова|Позадина|Предистория|Предыстория|Приклади|Пример|Примери|Примеры|Рамка на сценарий|Скица|Структура сценарија|Структура сценария|Структура сценарію|Сценарий|Сценарий структураси|Сценарийның төзелеше|Сценарији|Сценарио|Сценарій|Тарих|Үрнәкләр|דוגמאות|רקע|תבנית תרחיש|תרחיש|الخلفية|الگوی سناریو|امثلة|پس منظر|زمینه|سناریو|سيناريو|سيناريو مخطط|مثالیں|منظر نامے کا خاکہ|منظرنامہ|نمونه ها|उदाहरण|परिदृश्य|परिदृश्य रूपरेखा|पृष्ठभूमि|ਉਦਾਹਰਨਾਂ|ਪਟਕਥਾ|ਪਟਕਥਾ ਢਾਂਚਾ|ਪਟਕਥਾ ਰੂਪ ਰੇਖਾ|ਪਿਛੋਕੜ|ఉదాహరణలు|కథనం|నేపథ్యం|సన్నివేశం|ಉದಾಹರಣೆಗಳು|ಕಥಾಸಾರಾಂಶ|ವಿವರಣೆ|ಹಿನ್ನೆಲೆ|โครงสร้างของเหตุการณ์|ชุดของตัวอย่าง|ชุดของเหตุการณ์|แนวคิด|สรุปเหตุการณ์|เหตุการณ์|배경|시나리오|시나리오 개요|예|サンプル|シナリオ|シナリオアウトライン|シナリオテンプレ|シナリオテンプレート|テンプレ|例|例子|剧本|剧本大纲|劇本|劇本大綱|场景|场景大纲|場景|場景大綱|背景):[^:\r\n]*/m,
                lookbehind: true,
                inside: {
                    important: {
                        pattern: /(:)[^\r\n]*/,
                        lookbehind: true
                    },
                    keyword: /[^:\r\n]+:/
                }
            },
            'table-body': {
                // Look-behind is used to skip the table head, which has the same format as any table row
                pattern: RegExp('(' + tableRow + ')(?:' + tableRow + ')+'),
                lookbehind: true,
                inside: {
                    outline: {
                        pattern: /<[^>]+>/,
                        alias: 'variable'
                    },
                    td: {
                        pattern: /\s*[^\s|][^|]*/,
                        alias: 'string'
                    },
                    punctuation: /\|/
                }
            },
            'table-head': {
                pattern: RegExp(tableRow),
                inside: {
                    th: {
                        pattern: /\s*[^\s|][^|]*/,
                        alias: 'variable'
                    },
                    punctuation: /\|/
                }
            },
            atrule: {
                pattern: /(^[ \t]+)(?:'a|'ach|'ej|7|a|A také|A taktiež|A tiež|A zároveň|Aber|Ac|Adott|Akkor|Ak|Aleshores|Ale|Ali|Allora|Alors|Als|Ama|Amennyiben|Amikor|Ampak|an|AN|Ananging|And y'all|And|Angenommen|Anrhegedig a|An|Apabila|Atès|Atesa|Atunci|Avast!|Aye|A|awer|Bagi|Banjur|Bet|Biết|Blimey!|Buh|But at the end of the day I reckon|But y'all|But|BUT|Cal|Când|Cand|Cando|Ce|Cuando|Če|Ða ðe|Ða|Dadas|Dada|Dados|Dado|DaH ghu' bejlu'|dann|Dann|Dano|Dan|Dar|Dat fiind|Data|Date fiind|Date|Dati fiind|Dati|Daţi fiind|Dați fiind|DEN|Dato|De|Den youse gotta|Dengan|Diberi|Diyelim ki|Donada|Donat|Donitaĵo|Do|Dun|Duota|Ðurh|Eeldades|Ef|Eğer ki|Entao|Então|Entón|E|En|Entonces|Epi|És|Etant donnée|Etant donné|Et|Étant données|Étant donnée|Étant donné|Etant données|Etant donnés|Étant donnés|Fakat|Gangway!|Gdy|Gegeben seien|Gegeben sei|Gegeven|Gegewe|ghu' noblu'|Gitt|Given y'all|Given|Givet|Givun|Ha|Cho|I CAN HAZ|In|Ir|It's just unbelievable|I|Ja|Jeśli|Jeżeli|Kad|Kada|Kadar|Kai|Kaj|Když|Keď|Kemudian|Ketika|Khi|Kiedy|Ko|Kuid|Kui|Kun|Lan|latlh|Le sa a|Let go and haul|Le|Lè sa a|Lè|Logo|Lorsqu'<|Lorsque|mä|Maar|Mais|Mając|Ma|Majd|Maka|Manawa|Mas|Men|Menawa|Mutta|Nalika|Nalikaning|Nanging|Når|När|Nato|Nhưng|Niin|Njuk|O zaman|Och|Og|Oletetaan|Ond|Onda|Oraz|Pak|Pero|Però|Podano|Pokiaľ|Pokud|Potem|Potom|Privzeto|Pryd|Quan|Quand|Quando|qaSDI'|Så|Sed|Se|Siis|Sipoze ke|Sipoze Ke|Sipoze|Si|Şi|Și|Soit|Stel|Tada|Tad|Takrat|Tak|Tapi|Ter|Tetapi|Tha the|Tha|Then y'all|Then|Thì|Thurh|Toda|Too right|Un|Und|ugeholl|Và|vaj|Vendar|Ve|wann|Wanneer|WEN|Wenn|When y'all|When|Wtedy|Wun|Y'know|Yeah nah|Yna|Youse know like when|Youse know when youse got|Y|Za predpokladu|Za předpokladu|Zadan|Zadani|Zadano|Zadate|Zadato|Zakładając|Zaradi|Zatati|Þa þe|Þa|Þá|Þegar|Þurh|Αλλά|Δεδομένου|Και|Όταν|Τότε|А також|Агар|Але|Али|Аммо|А|Әгәр|Әйтик|Әмма|Бирок|Ва|Вә|Дадено|Дано|Допустим|Если|Задате|Задати|Задато|И|І|К тому же|Када|Кад|Когато|Когда|Коли|Ләкин|Лекин|Нәтиҗәдә|Нехай|Но|Онда|Припустимо, що|Припустимо|Пусть|Также|Та|Тогда|Тоді|То|Унда|Һәм|Якщо|אבל|אזי|אז|בהינתן|וגם|כאשר|آنگاه|اذاً|اگر|اما|اور|با فرض|بالفرض|بفرض|پھر|تب|ثم|جب|عندما|فرض کیا|لكن|لیکن|متى|هنگامی|و|अगर|और|कदा|किन्तु|चूंकि|जब|तथा|तदा|तब|परन्तु|पर|यदि|ਅਤੇ|ਜਦੋਂ|ਜਿਵੇਂ ਕਿ|ਜੇਕਰ|ਤਦ|ਪਰ|అప్పుడు|ఈ పరిస్థితిలో|కాని|చెప్పబడినది|మరియు|ಆದರೆ|ನಂತರ|ನೀಡಿದ|ಮತ್ತು|ಸ್ಥಿತಿಯನ್ನು|กำหนดให้|ดังนั้น|แต่|เมื่อ|และ|그러면<|그리고<|단<|만약<|만일<|먼저<|조건<|하지만<|かつ<|しかし<|ただし<|ならば<|もし<|並且<|但し<|但是<|假如<|假定<|假設<|假设<|前提<|同时<|同時<|并且<|当<|當<|而且<|那么<|那麼<)(?=[ \t])/m,
                lookbehind: true
            },
            string: {
                pattern: /"(?:\\.|[^"\\\r\n])*"|'(?:\\.|[^'\\\r\n])*'/,
                inside: {
                    outline: {
                        pattern: /<[^>]+>/,
                        alias: 'variable'
                    }
                }
            },
            outline: {
                pattern: /<[^>]+>/,
                alias: 'variable'
            }
        };
    })(Prism);
}

});

parcelRegister("huKo5", function(module, exports) {
'use strict';
module.exports = $cbc938957480bb18$var$git;
$cbc938957480bb18$var$git.displayName = 'git';
$cbc938957480bb18$var$git.aliases = [];
function $cbc938957480bb18$var$git(Prism) {
    Prism.languages.git = {
        /*
     * A simple one line comment like in a git status command
     * For instance:
     * $ git status
     * # On branch infinite-scroll
     * # Your branch and 'origin/sharedBranches/frontendTeam/infinite-scroll' have diverged,
     * # and have 1 and 2 different commits each, respectively.
     * nothing to commit (working directory clean)
     */ comment: /^#.*/m,
        /*
     * Regexp to match the changed lines in a git diff output. Check the example below.
     */ deleted: /^[-–].*/m,
        inserted: /^\+.*/m,
        /*
     * a string (double and simple quote)
     */ string: /("|')(?:\\.|(?!\1)[^\\\r\n])*\1/,
        /*
     * a git command. It starts with a random prompt finishing by a $, then "git" then some other parameters
     * For instance:
     * $ git add file.txt
     */ command: {
            pattern: /^.*\$ git .*$/m,
            inside: {
                /*
         * A git command can contain a parameter starting by a single or a double dash followed by a string
         * For instance:
         * $ git diff --cached
         * $ git log -p
         */ parameter: /\s--?\w+/
            }
        },
        /*
     * Coordinates displayed in a git diff command
     * For instance:
     * $ git diff
     * diff --git file.txt file.txt
     * index 6214953..1d54a52 100644
     * --- file.txt
     * +++ file.txt
     * @@ -1 +1,2 @@
     * -Here's my tetx file
     * +Here's my text file
     * +And this is the second line
     */ coord: /^@@.*@@$/m,
        /*
     * Match a "commit [SHA1]" line in a git log output.
     * For instance:
     * $ git log
     * commit a11a14ef7e26f2ca62d4b35eac455ce636d0dc09
     * Author: lgiraudel
     * Date:   Mon Feb 17 11:18:34 2014 +0100
     *
     *     Add of a new line
     */ 'commit-sha1': /^commit \w{40}$/m
    };
}

});

parcelRegister("cE8LE", function(module, exports) {
'use strict';

var $c6Wvp = parcelRequire("c6Wvp");
module.exports = $935005819d0e5773$var$glsl;
$935005819d0e5773$var$glsl.displayName = 'glsl';
$935005819d0e5773$var$glsl.aliases = [];
function $935005819d0e5773$var$glsl(Prism) {
    Prism.register($c6Wvp);
    Prism.languages.glsl = Prism.languages.extend('c', {
        keyword: /\b(?:active|asm|atomic_uint|attribute|[ibdu]?vec[234]|bool|break|buffer|case|cast|centroid|class|coherent|common|const|continue|d?mat[234](?:x[234])?|default|discard|do|double|else|enum|extern|external|false|filter|fixed|flat|float|for|fvec[234]|goto|half|highp|hvec[234]|[iu]?sampler2DMS(?:Array)?|[iu]?sampler2DRect|[iu]?samplerBuffer|[iu]?samplerCube|[iu]?samplerCubeArray|[iu]?sampler[123]D|[iu]?sampler[12]DArray|[iu]?image2DMS(?:Array)?|[iu]?image2DRect|[iu]?imageBuffer|[iu]?imageCube|[iu]?imageCubeArray|[iu]?image[123]D|[iu]?image[12]DArray|if|in|inline|inout|input|int|interface|invariant|layout|long|lowp|mediump|namespace|noinline|noperspective|out|output|partition|patch|precise|precision|public|readonly|resource|restrict|return|sample|sampler[12]DArrayShadow|sampler[12]DShadow|sampler2DRectShadow|sampler3DRect|samplerCubeArrayShadow|samplerCubeShadow|shared|short|sizeof|smooth|static|struct|subroutine|superp|switch|template|this|true|typedef|uint|uniform|union|unsigned|using|varying|void|volatile|while|writeonly)\b/
    });
}

});

parcelRegister("jKuY2", function(module, exports) {
'use strict';
module.exports = $e60a55b13578aeb6$var$gml;
$e60a55b13578aeb6$var$gml.displayName = 'gml';
$e60a55b13578aeb6$var$gml.aliases = [];
function $e60a55b13578aeb6$var$gml(Prism) {
    Prism.languages.gamemakerlanguage = Prism.languages.gml = Prism.languages.extend('clike', {
        keyword: /\b(?:break|case|continue|default|do|else|enum|exit|for|globalvar|if|repeat|return|switch|until|var|while)\b/,
        number: /(?:\b0x[\da-f]+|(?:\b\d+(?:\.\d*)?|\B\.\d+)(?:e[+-]?\d+)?)[ulf]{0,4}/i,
        operator: /--|\+\+|[-+%/=]=?|!=|\*\*?=?|<[<=>]?|>[=>]?|&&?|\^\^?|\|\|?|~|\b(?:and|at|not|or|with|xor)\b/,
        constant: /\b(?:GM_build_date|GM_version|action_(?:continue|restart|reverse|stop)|all|gamespeed_(?:fps|microseconds)|global|local|noone|other|pi|pointer_(?:invalid|null)|self|timezone_(?:local|utc)|undefined|ev_(?:create|destroy|step|alarm|keyboard|mouse|collision|other|draw|draw_(?:begin|end|post|pre)|keypress|keyrelease|trigger|(?:left|middle|no|right)_button|(?:left|middle|right)_press|(?:left|middle|right)_release|mouse_(?:enter|leave|wheel_down|wheel_up)|global_(?:left|middle|right)_button|global_(?:left|middle|right)_press|global_(?:left|middle|right)_release|joystick(?:1|2)_(?:button1|button2|button3|button4|button5|button6|button7|button8|down|left|right|up)|outside|boundary|game_start|game_end|room_start|room_end|no_more_lives|animation_end|end_of_path|no_more_health|user\d|gui|gui_begin|gui_end|step_(?:begin|end|normal))|vk_(?:alt|anykey|backspace|control|delete|down|end|enter|escape|home|insert|left|nokey|pagedown|pageup|pause|printscreen|return|right|shift|space|tab|up|f\d|numpad\d|add|decimal|divide|lalt|lcontrol|lshift|multiply|ralt|rcontrol|rshift|subtract)|achievement_(?:filter_(?:all_players|favorites_only|friends_only)|friends_info|info|leaderboard_info|our_info|pic_loaded|show_(?:achievement|bank|friend_picker|leaderboard|profile|purchase_prompt|ui)|type_challenge|type_score_challenge)|asset_(?:font|object|path|room|script|shader|sound|sprite|tiles|timeline|unknown)|audio_(?:3d|falloff_(?:exponent_distance|exponent_distance_clamped|inverse_distance|inverse_distance_clamped|linear_distance|linear_distance_clamped|none)|mono|new_system|old_system|stereo)|bm_(?:add|complex|dest_alpha|dest_color|dest_colour|inv_dest_alpha|inv_dest_color|inv_dest_colour|inv_src_alpha|inv_src_color|inv_src_colour|max|normal|one|src_alpha|src_alpha_sat|src_color|src_colour|subtract|zero)|browser_(?:chrome|firefox|ie|ie_mobile|not_a_browser|opera|safari|safari_mobile|tizen|unknown|windows_store)|buffer_(?:bool|f16|f32|f64|fast|fixed|generalerror|grow|invalidtype|network|outofbounds|outofspace|s16|s32|s8|seek_end|seek_relative|seek_start|string|text|u16|u32|u64|u8|vbuffer|wrap)|c_(?:aqua|black|blue|dkgray|fuchsia|gray|green|lime|ltgray|maroon|navy|olive|orange|purple|red|silver|teal|white|yellow)|cmpfunc_(?:always|equal|greater|greaterequal|less|lessequal|never|notequal)|cr_(?:appstart|arrow|beam|cross|default|drag|handpoint|hourglass|none|size_all|size_nesw|size_ns|size_nwse|size_we|uparrow)|cull_(?:clockwise|counterclockwise|noculling)|device_(?:emulator|tablet)|device_ios_(?:ipad|ipad_retina|iphone|iphone5|iphone6|iphone6plus|iphone_retina|unknown)|display_(?:landscape|landscape_flipped|portrait|portrait_flipped)|dll_(?:cdecl|cdel|stdcall)|ds_type_(?:grid|list|map|priority|queue|stack)|ef_(?:cloud|ellipse|explosion|firework|flare|rain|ring|smoke|smokeup|snow|spark|star)|fa_(?:archive|bottom|center|directory|hidden|left|middle|readonly|right|sysfile|top|volumeid)|fb_login_(?:default|fallback_to_webview|forcing_safari|forcing_webview|no_fallback_to_webview|use_system_account)|iap_(?:available|canceled|ev_consume|ev_product|ev_purchase|ev_restore|ev_storeload|failed|purchased|refunded|status_available|status_loading|status_processing|status_restoring|status_unavailable|status_uninitialised|storeload_failed|storeload_ok|unavailable)|leaderboard_type_(?:number|time_mins_secs)|lighttype_(?:dir|point)|matrix_(?:projection|view|world)|mb_(?:any|left|middle|none|right)|network_(?:config_(?:connect_timeout|disable_reliable_udp|enable_reliable_udp|use_non_blocking_socket)|socket_(?:bluetooth|tcp|udp)|type_(?:connect|data|disconnect|non_blocking_connect))|of_challenge_(?:lose|tie|win)|os_(?:android|ios|linux|macosx|ps3|ps4|psvita|unknown|uwp|win32|win8native|windows|winphone|xboxone)|phy_debug_render_(?:aabb|collision_pairs|coms|core_shapes|joints|obb|shapes)|phy_joint_(?:anchor_1_x|anchor_1_y|anchor_2_x|anchor_2_y|angle|angle_limits|damping_ratio|frequency|length_1|length_2|lower_angle_limit|max_force|max_length|max_motor_force|max_motor_torque|max_torque|motor_force|motor_speed|motor_torque|reaction_force_x|reaction_force_y|reaction_torque|speed|translation|upper_angle_limit)|phy_particle_data_flag_(?:category|color|colour|position|typeflags|velocity)|phy_particle_flag_(?:colormixing|colourmixing|elastic|powder|spring|tensile|viscous|wall|water|zombie)|phy_particle_group_flag_(?:rigid|solid)|pr_(?:linelist|linestrip|pointlist|trianglefan|trianglelist|trianglestrip)|ps_(?:distr|shape)_(?:diamond|ellipse|gaussian|invgaussian|line|linear|rectangle)|pt_shape_(?:circle|cloud|disk|explosion|flare|line|pixel|ring|smoke|snow|spark|sphere|square|star)|ty_(?:real|string)|gp_(?:face\d|axislh|axislv|axisrh|axisrv|padd|padl|padr|padu|select|shoulderl|shoulderlb|shoulderr|shoulderrb|start|stickl|stickr)|lb_disp_(?:none|numeric|time_ms|time_sec)|lb_sort_(?:ascending|descending|none)|ov_(?:achievements|community|friends|gamegroup|players|settings)|ugc_(?:filetype_(?:community|microtrans)|list_(?:Favorited|Followed|Published|Subscribed|UsedOrPlayed|VotedDown|VotedOn|VotedUp|WillVoteLater)|match_(?:AllGuides|Artwork|Collections|ControllerBindings|IntegratedGuides|Items|Items_Mtx|Items_ReadyToUse|Screenshots|UsableInGame|Videos|WebGuides)|query_(?:AcceptedForGameRankedByAcceptanceDate|CreatedByFriendsRankedByPublicationDate|FavoritedByFriendsRankedByPublicationDate|NotYetRated)|query_RankedBy(?:NumTimesReported|PublicationDate|TextSearch|TotalVotesAsc|Trend|Vote|VotesUp)|result_success|sortorder_CreationOrder(?:Asc|Desc)|sortorder_(?:ForModeration|LastUpdatedDesc|SubscriptionDateDesc|TitleAsc|VoteScoreDesc)|visibility_(?:friends_only|private|public))|vertex_usage_(?:binormal|blendindices|blendweight|color|colour|depth|fog|normal|position|psize|sample|tangent|texcoord|textcoord)|vertex_type_(?:float\d|color|colour|ubyte4)|input_type|layerelementtype_(?:background|instance|oldtilemap|particlesystem|sprite|tile|tilemap|undefined)|se_(?:chorus|compressor|echo|equalizer|flanger|gargle|none|reverb)|text_type|tile_(?:flip|index_mask|mirror|rotate)|(?:obj|rm|scr|spr)\w+)\b/,
        variable: /\b(?:alarm|application_surface|async_load|background_(?:alpha|blend|color|colour|foreground|height|hspeed|htiled|index|showcolor|showcolour|visible|vspeed|vtiled|width|x|xscale|y|yscale)|bbox_(?:bottom|left|right|top)|browser_(?:height|width)|caption_(?:health|lives|score)|current_(?:day|hour|minute|month|second|time|weekday|year)|cursor_sprite|debug_mode|delta_time|direction|display_aa|error_(?:last|occurred)|event_(?:action|number|object|type)|fps|fps_real|friction|game_(?:display|project|save)_(?:id|name)|gamemaker_(?:pro|registered|version)|gravity|gravity_direction|(?:h|v)speed|health|iap_data|id|image_(?:alpha|angle|blend|depth|index|number|speed|xscale|yscale)|instance_(?:count|id)|keyboard_(?:key|lastchar|lastkey|string)|layer|lives|mask_index|mouse_(?:button|lastbutton|x|y)|object_index|os_(?:browser|device|type|version)|path_(?:endaction|index|orientation|position|positionprevious|scale|speed)|persistent|phy_(?:rotation|(?:col_normal|collision|com|linear_velocity|position|speed)_(?:x|y)|angular_(?:damping|velocity)|position_(?:x|y)previous|speed|linear_damping|bullet|fixed_rotation|active|mass|inertia|dynamic|kinematic|sleeping|collision_points)|pointer_(?:invalid|null)|room|room_(?:caption|first|height|last|persistent|speed|width)|score|secure_mode|show_(?:health|lives|score)|solid|speed|sprite_(?:height|index|width|xoffset|yoffset)|temp_directory|timeline_(?:index|loop|position|running|speed)|transition_(?:color|kind|steps)|undefined|view_(?:angle|current|enabled|(?:h|v)(?:border|speed)|(?:h|w|x|y)port|(?:h|w|x|y)view|object|surface_id|visible)|visible|webgl_enabled|working_directory|(?:x|y)(?:previous|start)|x|y|argument(?:_relitive|_count|\d)|argument|global|local|other|self)\b/
    });
}

});

parcelRegister("fX4qU", function(module, exports) {
'use strict';
module.exports = $b9cfcdff8d121b9c$var$gn;
$b9cfcdff8d121b9c$var$gn.displayName = 'gn';
$b9cfcdff8d121b9c$var$gn.aliases = [
    'gni'
];
function $b9cfcdff8d121b9c$var$gn(Prism) {
    // https://gn.googlesource.com/gn/+/refs/heads/main/docs/reference.md#grammar
    Prism.languages.gn = {
        comment: {
            pattern: /#.*/,
            greedy: true
        },
        'string-literal': {
            pattern: /(^|[^\\"])"(?:[^\r\n"\\]|\\.)*"/,
            lookbehind: true,
            greedy: true,
            inside: {
                interpolation: {
                    pattern: /((?:^|[^\\])(?:\\{2})*)\$(?:\{[\s\S]*?\}|[a-zA-Z_]\w*|0x[a-fA-F0-9]{2})/,
                    lookbehind: true,
                    inside: {
                        number: /^\$0x[\s\S]{2}$/,
                        variable: /^\$\w+$/,
                        'interpolation-punctuation': {
                            pattern: /^\$\{|\}$/,
                            alias: 'punctuation'
                        },
                        expression: {
                            pattern: /[\s\S]+/,
                            inside: null // see below
                        }
                    }
                },
                string: /[\s\S]+/
            }
        },
        keyword: /\b(?:else|if)\b/,
        boolean: /\b(?:false|true)\b/,
        'builtin-function': {
            // a few functions get special highlighting to improve readability
            pattern: /\b(?:assert|defined|foreach|import|pool|print|template|tool|toolchain)(?=\s*\()/i,
            alias: 'keyword'
        },
        function: /\b[a-z_]\w*(?=\s*\()/i,
        constant: /\b(?:current_cpu|current_os|current_toolchain|default_toolchain|host_cpu|host_os|root_build_dir|root_gen_dir|root_out_dir|target_cpu|target_gen_dir|target_os|target_out_dir)\b/,
        number: /-?\b\d+\b/,
        operator: /[-+!=<>]=?|&&|\|\|/,
        punctuation: /[(){}[\],.]/
    };
    Prism.languages.gn['string-literal'].inside['interpolation'].inside['expression'].inside = Prism.languages.gn;
    Prism.languages.gni = Prism.languages.gn;
}

});

parcelRegister("1Z2jf", function(module, exports) {
'use strict';
module.exports = $171d478c081bb962$var$goModule;
$171d478c081bb962$var$goModule.displayName = 'goModule';
$171d478c081bb962$var$goModule.aliases = [];
function $171d478c081bb962$var$goModule(Prism) {
    // https://go.dev/ref/mod#go-mod-file-module
    Prism.languages['go-mod'] = Prism.languages['go-module'] = {
        comment: {
            pattern: /\/\/.*/,
            greedy: true
        },
        version: {
            pattern: /(^|[\s()[\],])v\d+\.\d+\.\d+(?:[+-][-+.\w]*)?(?![^\s()[\],])/,
            lookbehind: true,
            alias: 'number'
        },
        'go-version': {
            pattern: /((?:^|\s)go\s+)\d+(?:\.\d+){1,2}/,
            lookbehind: true,
            alias: 'number'
        },
        keyword: {
            pattern: /^([ \t]*)(?:exclude|go|module|replace|require|retract)\b/m,
            lookbehind: true
        },
        operator: /=>/,
        punctuation: /[()[\],]/
    };
}

});

parcelRegister("2Nir4", function(module, exports) {
'use strict';
module.exports = $208e75503b842f18$var$go;
$208e75503b842f18$var$go.displayName = 'go';
$208e75503b842f18$var$go.aliases = [];
function $208e75503b842f18$var$go(Prism) {
    Prism.languages.go = Prism.languages.extend('clike', {
        string: {
            pattern: /(^|[^\\])"(?:\\.|[^"\\\r\n])*"|`[^`]*`/,
            lookbehind: true,
            greedy: true
        },
        keyword: /\b(?:break|case|chan|const|continue|default|defer|else|fallthrough|for|func|go(?:to)?|if|import|interface|map|package|range|return|select|struct|switch|type|var)\b/,
        boolean: /\b(?:_|false|iota|nil|true)\b/,
        number: [
            // binary and octal integers
            /\b0(?:b[01_]+|o[0-7_]+)i?\b/i,
            /\b0x(?:[a-f\d_]+(?:\.[a-f\d_]*)?|\.[a-f\d_]+)(?:p[+-]?\d+(?:_\d+)*)?i?(?!\w)/i,
            /(?:\b\d[\d_]*(?:\.[\d_]*)?|\B\.\d[\d_]*)(?:e[+-]?[\d_]+)?i?(?!\w)/i
        ],
        operator: /[*\/%^!=]=?|\+[=+]?|-[=-]?|\|[=|]?|&(?:=|&|\^=?)?|>(?:>=?|=)?|<(?:<=?|=|-)?|:=|\.\.\./,
        builtin: /\b(?:append|bool|byte|cap|close|complex|complex(?:64|128)|copy|delete|error|float(?:32|64)|u?int(?:8|16|32|64)?|imag|len|make|new|panic|print(?:ln)?|real|recover|rune|string|uintptr)\b/
    });
    Prism.languages.insertBefore('go', 'string', {
        char: {
            pattern: /'(?:\\.|[^'\\\r\n]){0,10}'/,
            greedy: true
        }
    });
    delete Prism.languages.go['class-name'];
}

});

parcelRegister("hOWv0", function(module, exports) {
'use strict';
module.exports = $cf947be224655730$var$graphql;
$cf947be224655730$var$graphql.displayName = 'graphql';
$cf947be224655730$var$graphql.aliases = [];
function $cf947be224655730$var$graphql(Prism) {
    Prism.languages.graphql = {
        comment: /#.*/,
        description: {
            pattern: /(?:"""(?:[^"]|(?!""")")*"""|"(?:\\.|[^\\"\r\n])*")(?=\s*[a-z_])/i,
            greedy: true,
            alias: 'string',
            inside: {
                'language-markdown': {
                    pattern: /(^"(?:"")?)(?!\1)[\s\S]+(?=\1$)/,
                    lookbehind: true,
                    inside: Prism.languages.markdown
                }
            }
        },
        string: {
            pattern: /"""(?:[^"]|(?!""")")*"""|"(?:\\.|[^\\"\r\n])*"/,
            greedy: true
        },
        number: /(?:\B-|\b)\d+(?:\.\d+)?(?:e[+-]?\d+)?\b/i,
        boolean: /\b(?:false|true)\b/,
        variable: /\$[a-z_]\w*/i,
        directive: {
            pattern: /@[a-z_]\w*/i,
            alias: 'function'
        },
        'attr-name': {
            pattern: /\b[a-z_]\w*(?=\s*(?:\((?:[^()"]|"(?:\\.|[^\\"\r\n])*")*\))?:)/i,
            greedy: true
        },
        'atom-input': {
            pattern: /\b[A-Z]\w*Input\b/,
            alias: 'class-name'
        },
        scalar: /\b(?:Boolean|Float|ID|Int|String)\b/,
        constant: /\b[A-Z][A-Z_\d]*\b/,
        'class-name': {
            pattern: /(\b(?:enum|implements|interface|on|scalar|type|union)\s+|&\s*|:\s*|\[)[A-Z_]\w*/,
            lookbehind: true
        },
        fragment: {
            pattern: /(\bfragment\s+|\.{3}\s*(?!on\b))[a-zA-Z_]\w*/,
            lookbehind: true,
            alias: 'function'
        },
        'definition-mutation': {
            pattern: /(\bmutation\s+)[a-zA-Z_]\w*/,
            lookbehind: true,
            alias: 'function'
        },
        'definition-query': {
            pattern: /(\bquery\s+)[a-zA-Z_]\w*/,
            lookbehind: true,
            alias: 'function'
        },
        keyword: /\b(?:directive|enum|extend|fragment|implements|input|interface|mutation|on|query|repeatable|scalar|schema|subscription|type|union)\b/,
        operator: /[!=|&]|\.{3}/,
        'property-query': /\w+(?=\s*\()/,
        object: /\w+(?=\s*\{)/,
        punctuation: /[!(){}\[\]:=,]/,
        property: /\w+/
    };
    Prism.hooks.add('after-tokenize', function afterTokenizeGraphql(env) {
        if (env.language !== 'graphql') return;
        /**
     * get the graphql token stream that we want to customize
     *
     * @typedef {InstanceType<import("./prism-core")["Token"]>} Token
     * @type {Token[]}
     */ var validTokens = env.tokens.filter(function(token) {
            return typeof token !== 'string' && token.type !== 'comment' && token.type !== 'scalar';
        });
        var currentIndex = 0;
        /**
     * Returns whether the token relative to the current index has the given type.
     *
     * @param {number} offset
     * @returns {Token | undefined}
     */ function getToken(offset) {
            return validTokens[currentIndex + offset];
        }
        /**
     * Returns whether the token relative to the current index has the given type.
     *
     * @param {readonly string[]} types
     * @param {number} [offset=0]
     * @returns {boolean}
     */ function isTokenType(types, offset) {
            offset = offset || 0;
            for(var i = 0; i < types.length; i++){
                var token = getToken(i + offset);
                if (!token || token.type !== types[i]) return false;
            }
            return true;
        }
        /**
     * Returns the index of the closing bracket to an opening bracket.
     *
     * It is assumed that `token[currentIndex - 1]` is an opening bracket.
     *
     * If no closing bracket could be found, `-1` will be returned.
     *
     * @param {RegExp} open
     * @param {RegExp} close
     * @returns {number}
     */ function findClosingBracket(open, close) {
            var stackHeight = 1;
            for(var i = currentIndex; i < validTokens.length; i++){
                var token = validTokens[i];
                var content = token.content;
                if (token.type === 'punctuation' && typeof content === 'string') {
                    if (open.test(content)) stackHeight++;
                    else if (close.test(content)) {
                        stackHeight--;
                        if (stackHeight === 0) return i;
                    }
                }
            }
            return -1;
        }
        /**
     * Adds an alias to the given token.
     *
     * @param {Token} token
     * @param {string} alias
     * @returns {void}
     */ function addAlias(token, alias) {
            var aliases = token.alias;
            if (!aliases) token.alias = aliases = [];
            else if (!Array.isArray(aliases)) token.alias = aliases = [
                aliases
            ];
            aliases.push(alias);
        }
        for(; currentIndex < validTokens.length;){
            var startToken = validTokens[currentIndex++] // add special aliases for mutation tokens
            ;
            if (startToken.type === 'keyword' && startToken.content === 'mutation') {
                // any array of the names of all input variables (if any)
                var inputVariables = [];
                if (isTokenType([
                    'definition-mutation',
                    'punctuation'
                ]) && getToken(1).content === '(') {
                    // definition
                    currentIndex += 2 // skip 'definition-mutation' and 'punctuation'
                    ;
                    var definitionEnd = findClosingBracket(/^\($/, /^\)$/);
                    if (definitionEnd === -1) continue;
                     // find all input variables
                    for(; currentIndex < definitionEnd; currentIndex++){
                        var t = getToken(0);
                        if (t.type === 'variable') {
                            addAlias(t, 'variable-input');
                            inputVariables.push(t.content);
                        }
                    }
                    currentIndex = definitionEnd + 1;
                }
                if (isTokenType([
                    'punctuation',
                    'property-query'
                ]) && getToken(0).content === '{') {
                    currentIndex++ // skip opening bracket
                    ;
                    addAlias(getToken(0), 'property-mutation');
                    if (inputVariables.length > 0) {
                        var mutationEnd = findClosingBracket(/^\{$/, /^\}$/);
                        if (mutationEnd === -1) continue;
                         // give references to input variables a special alias
                        for(var i = currentIndex; i < mutationEnd; i++){
                            var varToken = validTokens[i];
                            if (varToken.type === 'variable' && inputVariables.indexOf(varToken.content) >= 0) addAlias(varToken, 'variable-input');
                        }
                    }
                }
            }
        }
    });
}

});

parcelRegister("crKTD", function(module, exports) {
'use strict';
module.exports = $90fc6248b7f4b087$var$groovy;
$90fc6248b7f4b087$var$groovy.displayName = 'groovy';
$90fc6248b7f4b087$var$groovy.aliases = [];
function $90fc6248b7f4b087$var$groovy(Prism) {
    Prism.languages.groovy = Prism.languages.extend('clike', {
        string: [
            {
                // https://groovy-lang.org/syntax.html#_dollar_slashy_string
                pattern: /("""|''')(?:[^\\]|\\[\s\S])*?\1|\$\/(?:[^/$]|\$(?:[/$]|(?![/$]))|\/(?!\$))*\/\$/,
                greedy: true
            },
            {
                // TODO: Slash strings (e.g. /foo/) can contain line breaks but this will cause a lot of trouble with
                // simple division (see JS regex), so find a fix maybe?
                pattern: /(["'/])(?:\\.|(?!\1)[^\\\r\n])*\1/,
                greedy: true
            }
        ],
        keyword: /\b(?:abstract|as|assert|boolean|break|byte|case|catch|char|class|const|continue|def|default|do|double|else|enum|extends|final|finally|float|for|goto|if|implements|import|in|instanceof|int|interface|long|native|new|package|private|protected|public|return|short|static|strictfp|super|switch|synchronized|this|throw|throws|trait|transient|try|void|volatile|while)\b/,
        number: /\b(?:0b[01_]+|0x[\da-f_]+(?:\.[\da-f_p\-]+)?|[\d_]+(?:\.[\d_]+)?(?:e[+-]?\d+)?)[glidf]?\b/i,
        operator: {
            pattern: /(^|[^.])(?:~|==?~?|\?[.:]?|\*(?:[.=]|\*=?)?|\.[@&]|\.\.<|\.\.(?!\.)|-[-=>]?|\+[+=]?|!=?|<(?:<=?|=>?)?|>(?:>>?=?|=)?|&[&=]?|\|[|=]?|\/=?|\^=?|%=?)/,
            lookbehind: true
        },
        punctuation: /\.+|[{}[\];(),:$]/
    });
    Prism.languages.insertBefore('groovy', 'string', {
        shebang: {
            pattern: /#!.+/,
            alias: 'comment'
        }
    });
    Prism.languages.insertBefore('groovy', 'punctuation', {
        'spock-block': /\b(?:and|cleanup|expect|given|setup|then|when|where):/
    });
    Prism.languages.insertBefore('groovy', 'function', {
        annotation: {
            pattern: /(^|[^.])@\w+/,
            lookbehind: true,
            alias: 'punctuation'
        }
    }) // Handle string interpolation
    ;
    Prism.hooks.add('wrap', function(env) {
        if (env.language === 'groovy' && env.type === 'string') {
            var delimiter = env.content.value[0];
            if (delimiter != "'") {
                var pattern = /([^\\])(?:\$(?:\{.*?\}|[\w.]+))/;
                if (delimiter === '$') pattern = /([^\$])(?:\$(?:\{.*?\}|[\w.]+))/;
                 // To prevent double HTML-encoding we have to decode env.content first
                env.content.value = env.content.value.replace(/&lt;/g, '<').replace(/&amp;/g, '&');
                env.content = Prism.highlight(env.content.value, {
                    expression: {
                        pattern: pattern,
                        lookbehind: true,
                        inside: Prism.languages.groovy
                    }
                });
                env.classes.push(delimiter === '/' ? 'regex' : 'gstring');
            }
        }
    });
}

});

parcelRegister("97PDK", function(module, exports) {
'use strict';

var $2jpWm = parcelRequire("2jpWm");
module.exports = $6a4cd323fdf23082$var$haml;
$6a4cd323fdf23082$var$haml.displayName = 'haml';
$6a4cd323fdf23082$var$haml.aliases = [];
function $6a4cd323fdf23082$var$haml(Prism) {
    Prism.register($2jpWm);
    (function(Prism) {
        Prism.languages.haml = {
            // Multiline stuff should appear before the rest
            'multiline-comment': {
                pattern: /((?:^|\r?\n|\r)([\t ]*))(?:\/|-#).*(?:(?:\r?\n|\r)\2[\t ].+)*/,
                lookbehind: true,
                alias: 'comment'
            },
            'multiline-code': [
                {
                    pattern: /((?:^|\r?\n|\r)([\t ]*)(?:[~-]|[&!]?=)).*,[\t ]*(?:(?:\r?\n|\r)\2[\t ].*,[\t ]*)*(?:(?:\r?\n|\r)\2[\t ].+)/,
                    lookbehind: true,
                    inside: Prism.languages.ruby
                },
                {
                    pattern: /((?:^|\r?\n|\r)([\t ]*)(?:[~-]|[&!]?=)).*\|[\t ]*(?:(?:\r?\n|\r)\2[\t ].*\|[\t ]*)*/,
                    lookbehind: true,
                    inside: Prism.languages.ruby
                }
            ],
            // See at the end of the file for known filters
            filter: {
                pattern: /((?:^|\r?\n|\r)([\t ]*)):[\w-]+(?:(?:\r?\n|\r)(?:\2[\t ].+|\s*?(?=\r?\n|\r)))+/,
                lookbehind: true,
                inside: {
                    'filter-name': {
                        pattern: /^:[\w-]+/,
                        alias: 'symbol'
                    }
                }
            },
            markup: {
                pattern: /((?:^|\r?\n|\r)[\t ]*)<.+/,
                lookbehind: true,
                inside: Prism.languages.markup
            },
            doctype: {
                pattern: /((?:^|\r?\n|\r)[\t ]*)!!!(?: .+)?/,
                lookbehind: true
            },
            tag: {
                // Allows for one nested group of braces
                pattern: /((?:^|\r?\n|\r)[\t ]*)[%.#][\w\-#.]*[\w\-](?:\([^)]+\)|\{(?:\{[^}]+\}|[^{}])+\}|\[[^\]]+\])*[\/<>]*/,
                lookbehind: true,
                inside: {
                    attributes: [
                        {
                            // Lookbehind tries to prevent interpolations from breaking it all
                            // Allows for one nested group of braces
                            pattern: /(^|[^#])\{(?:\{[^}]+\}|[^{}])+\}/,
                            lookbehind: true,
                            inside: Prism.languages.ruby
                        },
                        {
                            pattern: /\([^)]+\)/,
                            inside: {
                                'attr-value': {
                                    pattern: /(=\s*)(?:"(?:\\.|[^\\"\r\n])*"|[^)\s]+)/,
                                    lookbehind: true
                                },
                                'attr-name': /[\w:-]+(?=\s*!?=|\s*[,)])/,
                                punctuation: /[=(),]/
                            }
                        },
                        {
                            pattern: /\[[^\]]+\]/,
                            inside: Prism.languages.ruby
                        }
                    ],
                    punctuation: /[<>]/
                }
            },
            code: {
                pattern: /((?:^|\r?\n|\r)[\t ]*(?:[~-]|[&!]?=)).+/,
                lookbehind: true,
                inside: Prism.languages.ruby
            },
            // Interpolations in plain text
            interpolation: {
                pattern: /#\{[^}]+\}/,
                inside: {
                    delimiter: {
                        pattern: /^#\{|\}$/,
                        alias: 'punctuation'
                    },
                    ruby: {
                        pattern: /[\s\S]+/,
                        inside: Prism.languages.ruby
                    }
                }
            },
            punctuation: {
                pattern: /((?:^|\r?\n|\r)[\t ]*)[~=\-&!]+/,
                lookbehind: true
            }
        };
        var filter_pattern = '((?:^|\\r?\\n|\\r)([\\t ]*)):{{filter_name}}(?:(?:\\r?\\n|\\r)(?:\\2[\\t ].+|\\s*?(?=\\r?\\n|\\r)))+' // Non exhaustive list of available filters and associated languages
        ;
        var filters = [
            'css',
            {
                filter: 'coffee',
                language: 'coffeescript'
            },
            'erb',
            'javascript',
            'less',
            'markdown',
            'ruby',
            'scss',
            'textile'
        ];
        var all_filters = {};
        for(var i = 0, l = filters.length; i < l; i++){
            var filter = filters[i];
            filter = typeof filter === 'string' ? {
                filter: filter,
                language: filter
            } : filter;
            if (Prism.languages[filter.language]) all_filters['filter-' + filter.filter] = {
                pattern: RegExp(filter_pattern.replace('{{filter_name}}', function() {
                    return filter.filter;
                })),
                lookbehind: true,
                inside: {
                    'filter-name': {
                        pattern: /^:[\w-]+/,
                        alias: 'symbol'
                    },
                    text: {
                        pattern: /[\s\S]+/,
                        alias: [
                            filter.language,
                            'language-' + filter.language
                        ],
                        inside: Prism.languages[filter.language]
                    }
                }
            };
        }
        Prism.languages.insertBefore('haml', 'filter', all_filters);
    })(Prism);
}

});

parcelRegister("67Bsn", function(module, exports) {
'use strict';

var $949g8 = parcelRequire("949g8");
module.exports = $475073aa8a758a0d$var$handlebars;
$475073aa8a758a0d$var$handlebars.displayName = 'handlebars';
$475073aa8a758a0d$var$handlebars.aliases = [
    'hbs'
];
function $475073aa8a758a0d$var$handlebars(Prism) {
    Prism.register($949g8);
    (function(Prism) {
        Prism.languages.handlebars = {
            comment: /\{\{![\s\S]*?\}\}/,
            delimiter: {
                pattern: /^\{\{\{?|\}\}\}?$/,
                alias: 'punctuation'
            },
            string: /(["'])(?:\\.|(?!\1)[^\\\r\n])*\1/,
            number: /\b0x[\dA-Fa-f]+\b|(?:\b\d+(?:\.\d*)?|\B\.\d+)(?:[Ee][+-]?\d+)?/,
            boolean: /\b(?:false|true)\b/,
            block: {
                pattern: /^(\s*(?:~\s*)?)[#\/]\S+?(?=\s*(?:~\s*)?$|\s)/,
                lookbehind: true,
                alias: 'keyword'
            },
            brackets: {
                pattern: /\[[^\]]+\]/,
                inside: {
                    punctuation: /\[|\]/,
                    variable: /[\s\S]+/
                }
            },
            punctuation: /[!"#%&':()*+,.\/;<=>@\[\\\]^`{|}~]/,
            variable: /[^!"#%&'()*+,\/;<=>@\[\\\]^`{|}~\s]+/
        };
        Prism.hooks.add('before-tokenize', function(env) {
            var handlebarsPattern = /\{\{\{[\s\S]+?\}\}\}|\{\{[\s\S]+?\}\}/g;
            Prism.languages['markup-templating'].buildPlaceholders(env, 'handlebars', handlebarsPattern);
        });
        Prism.hooks.add('after-tokenize', function(env) {
            Prism.languages['markup-templating'].tokenizePlaceholders(env, 'handlebars');
        });
        Prism.languages.hbs = Prism.languages.handlebars;
    })(Prism);
}

});

parcelRegister("f3xTx", function(module, exports) {
'use strict';
module.exports = $af616da64e23e4e6$var$haskell;
$af616da64e23e4e6$var$haskell.displayName = 'haskell';
$af616da64e23e4e6$var$haskell.aliases = [
    'hs'
];
function $af616da64e23e4e6$var$haskell(Prism) {
    Prism.languages.haskell = {
        comment: {
            pattern: /(^|[^-!#$%*+=?&@|~.:<>^\\\/])(?:--(?:(?=.)[^-!#$%*+=?&@|~.:<>^\\\/].*|$)|\{-[\s\S]*?-\})/m,
            lookbehind: true
        },
        char: {
            pattern: /'(?:[^\\']|\\(?:[abfnrtv\\"'&]|\^[A-Z@[\]^_]|ACK|BEL|BS|CAN|CR|DC1|DC2|DC3|DC4|DEL|DLE|EM|ENQ|EOT|ESC|ETB|ETX|FF|FS|GS|HT|LF|NAK|NUL|RS|SI|SO|SOH|SP|STX|SUB|SYN|US|VT|\d+|o[0-7]+|x[0-9a-fA-F]+))'/,
            alias: 'string'
        },
        string: {
            pattern: /"(?:[^\\"]|\\(?:\S|\s+\\))*"/,
            greedy: true
        },
        keyword: /\b(?:case|class|data|deriving|do|else|if|in|infixl|infixr|instance|let|module|newtype|of|primitive|then|type|where)\b/,
        'import-statement': {
            // The imported or hidden names are not included in this import
            // statement. This is because we want to highlight those exactly like
            // we do for the names in the program.
            pattern: /(^[\t ]*)import\s+(?:qualified\s+)?(?:[A-Z][\w']*)(?:\.[A-Z][\w']*)*(?:\s+as\s+(?:[A-Z][\w']*)(?:\.[A-Z][\w']*)*)?(?:\s+hiding\b)?/m,
            lookbehind: true,
            inside: {
                keyword: /\b(?:as|hiding|import|qualified)\b/,
                punctuation: /\./
            }
        },
        // These are builtin variables only. Constructors are highlighted later as a constant.
        builtin: /\b(?:abs|acos|acosh|all|and|any|appendFile|approxRational|asTypeOf|asin|asinh|atan|atan2|atanh|basicIORun|break|catch|ceiling|chr|compare|concat|concatMap|const|cos|cosh|curry|cycle|decodeFloat|denominator|digitToInt|div|divMod|drop|dropWhile|either|elem|encodeFloat|enumFrom|enumFromThen|enumFromThenTo|enumFromTo|error|even|exp|exponent|fail|filter|flip|floatDigits|floatRadix|floatRange|floor|fmap|foldl|foldl1|foldr|foldr1|fromDouble|fromEnum|fromInt|fromInteger|fromIntegral|fromRational|fst|gcd|getChar|getContents|getLine|group|head|id|inRange|index|init|intToDigit|interact|ioError|isAlpha|isAlphaNum|isAscii|isControl|isDenormalized|isDigit|isHexDigit|isIEEE|isInfinite|isLower|isNaN|isNegativeZero|isOctDigit|isPrint|isSpace|isUpper|iterate|last|lcm|length|lex|lexDigits|lexLitChar|lines|log|logBase|lookup|map|mapM|mapM_|max|maxBound|maximum|maybe|min|minBound|minimum|mod|negate|not|notElem|null|numerator|odd|or|ord|otherwise|pack|pi|pred|primExitWith|print|product|properFraction|putChar|putStr|putStrLn|quot|quotRem|range|rangeSize|read|readDec|readFile|readFloat|readHex|readIO|readInt|readList|readLitChar|readLn|readOct|readParen|readSigned|reads|readsPrec|realToFrac|recip|rem|repeat|replicate|return|reverse|round|scaleFloat|scanl|scanl1|scanr|scanr1|seq|sequence|sequence_|show|showChar|showInt|showList|showLitChar|showParen|showSigned|showString|shows|showsPrec|significand|signum|sin|sinh|snd|sort|span|splitAt|sqrt|subtract|succ|sum|tail|take|takeWhile|tan|tanh|threadToIOResult|toEnum|toInt|toInteger|toLower|toRational|toUpper|truncate|uncurry|undefined|unlines|until|unwords|unzip|unzip3|userError|words|writeFile|zip|zip3|zipWith|zipWith3)\b/,
        // decimal integers and floating point numbers | octal integers | hexadecimal integers
        number: /\b(?:\d+(?:\.\d+)?(?:e[+-]?\d+)?|0o[0-7]+|0x[0-9a-f]+)\b/i,
        operator: [
            {
                // infix operator
                pattern: /`(?:[A-Z][\w']*\.)*[_a-z][\w']*`/,
                greedy: true
            },
            {
                // function composition
                pattern: /(\s)\.(?=\s)/,
                lookbehind: true
            },
            // If it stands alone freely, it is the function composition.
            // It may also be a separator between a module name and an identifier => no
            // operator. If it comes together with other special characters it is an
            // operator too.
            //
            // This regex means: /[-!#$%*+=?&@|~.:<>^\\\/]+/ without /\./.
            /[-!#$%*+=?&@|~:<>^\\\/][-!#$%*+=?&@|~.:<>^\\\/]*|\.[-!#$%*+=?&@|~.:<>^\\\/]+/
        ],
        // In Haskell, nearly everything is a variable, do not highlight these.
        hvariable: {
            pattern: /\b(?:[A-Z][\w']*\.)*[_a-z][\w']*/,
            inside: {
                punctuation: /\./
            }
        },
        constant: {
            pattern: /\b(?:[A-Z][\w']*\.)*[A-Z][\w']*/,
            inside: {
                punctuation: /\./
            }
        },
        punctuation: /[{}[\];(),.:]/
    };
    Prism.languages.hs = Prism.languages.haskell;
}

});

parcelRegister("5xwo7", function(module, exports) {
'use strict';
module.exports = $408928690bdbba24$var$haxe;
$408928690bdbba24$var$haxe.displayName = 'haxe';
$408928690bdbba24$var$haxe.aliases = [];
function $408928690bdbba24$var$haxe(Prism) {
    Prism.languages.haxe = Prism.languages.extend('clike', {
        string: {
            // Strings can be multi-line
            pattern: /"(?:[^"\\]|\\[\s\S])*"/,
            greedy: true
        },
        'class-name': [
            {
                pattern: /(\b(?:abstract|class|enum|extends|implements|interface|new|typedef)\s+)[A-Z_]\w*/,
                lookbehind: true
            },
            /\b[A-Z]\w*/
        ],
        // The final look-ahead prevents highlighting of keywords if expressions such as "haxe.macro.Expr"
        keyword: /\bthis\b|\b(?:abstract|as|break|case|cast|catch|class|continue|default|do|dynamic|else|enum|extends|extern|final|for|from|function|if|implements|import|in|inline|interface|macro|new|null|operator|overload|override|package|private|public|return|static|super|switch|throw|to|try|typedef|untyped|using|var|while)(?!\.)\b/,
        function: {
            pattern: /\b[a-z_]\w*(?=\s*(?:<[^<>]*>\s*)?\()/i,
            greedy: true
        },
        operator: /\.{3}|\+\+|--|&&|\|\||->|=>|(?:<<?|>{1,3}|[-+*/%!=&|^])=?|[?:~]/
    });
    Prism.languages.insertBefore('haxe', 'string', {
        'string-interpolation': {
            pattern: /'(?:[^'\\]|\\[\s\S])*'/,
            greedy: true,
            inside: {
                interpolation: {
                    pattern: /(^|[^\\])\$(?:\w+|\{[^{}]+\})/,
                    lookbehind: true,
                    inside: {
                        'interpolation-punctuation': {
                            pattern: /^\$\{?|\}$/,
                            alias: 'punctuation'
                        },
                        expression: {
                            pattern: /[\s\S]+/,
                            inside: Prism.languages.haxe
                        }
                    }
                },
                string: /[\s\S]+/
            }
        }
    });
    Prism.languages.insertBefore('haxe', 'class-name', {
        regex: {
            pattern: /~\/(?:[^\/\\\r\n]|\\.)+\/[a-z]*/,
            greedy: true,
            inside: {
                'regex-flags': /\b[a-z]+$/,
                'regex-source': {
                    pattern: /^(~\/)[\s\S]+(?=\/$)/,
                    lookbehind: true,
                    alias: 'language-regex',
                    inside: Prism.languages.regex
                },
                'regex-delimiter': /^~\/|\/$/
            }
        }
    });
    Prism.languages.insertBefore('haxe', 'keyword', {
        preprocessor: {
            pattern: /#(?:else|elseif|end|if)\b.*/,
            alias: 'property'
        },
        metadata: {
            pattern: /@:?[\w.]+/,
            alias: 'symbol'
        },
        reification: {
            pattern: /\$(?:\w+|(?=\{))/,
            alias: 'important'
        }
    });
}

});

parcelRegister("dCw7g", function(module, exports) {
'use strict';
module.exports = $9ea7bc9115a844c6$var$hcl;
$9ea7bc9115a844c6$var$hcl.displayName = 'hcl';
$9ea7bc9115a844c6$var$hcl.aliases = [];
function $9ea7bc9115a844c6$var$hcl(Prism) {
    Prism.languages.hcl = {
        comment: /(?:\/\/|#).*|\/\*[\s\S]*?(?:\*\/|$)/,
        heredoc: {
            pattern: /<<-?(\w+\b)[\s\S]*?^[ \t]*\1/m,
            greedy: true,
            alias: 'string'
        },
        keyword: [
            {
                pattern: /(?:data|resource)\s+(?:"(?:\\[\s\S]|[^\\"])*")(?=\s+"[\w-]+"\s+\{)/i,
                inside: {
                    type: {
                        pattern: /(resource|data|\s+)(?:"(?:\\[\s\S]|[^\\"])*")/i,
                        lookbehind: true,
                        alias: 'variable'
                    }
                }
            },
            {
                pattern: /(?:backend|module|output|provider|provisioner|variable)\s+(?:[\w-]+|"(?:\\[\s\S]|[^\\"])*")\s+(?=\{)/i,
                inside: {
                    type: {
                        pattern: /(backend|module|output|provider|provisioner|variable)\s+(?:[\w-]+|"(?:\\[\s\S]|[^\\"])*")\s+/i,
                        lookbehind: true,
                        alias: 'variable'
                    }
                }
            },
            /[\w-]+(?=\s+\{)/
        ],
        property: [
            /[-\w\.]+(?=\s*=(?!=))/,
            /"(?:\\[\s\S]|[^\\"])+"(?=\s*[:=])/
        ],
        string: {
            pattern: /"(?:[^\\$"]|\\[\s\S]|\$(?:(?=")|\$+(?!\$)|[^"${])|\$\{(?:[^{}"]|"(?:[^\\"]|\\[\s\S])*")*\})*"/,
            greedy: true,
            inside: {
                interpolation: {
                    pattern: /(^|[^$])\$\{(?:[^{}"]|"(?:[^\\"]|\\[\s\S])*")*\}/,
                    lookbehind: true,
                    inside: {
                        type: {
                            pattern: /(\b(?:count|data|local|module|path|self|terraform|var)\b\.)[\w\*]+/i,
                            lookbehind: true,
                            alias: 'variable'
                        },
                        keyword: /\b(?:count|data|local|module|path|self|terraform|var)\b/i,
                        function: /\w+(?=\()/,
                        string: {
                            pattern: /"(?:\\[\s\S]|[^\\"])*"/,
                            greedy: true
                        },
                        number: /\b0x[\da-f]+\b|\b\d+(?:\.\d*)?(?:e[+-]?\d+)?/i,
                        punctuation: /[!\$#%&'()*+,.\/;<=>@\[\\\]^`{|}~?:]/
                    }
                }
            }
        },
        number: /\b0x[\da-f]+\b|\b\d+(?:\.\d*)?(?:e[+-]?\d+)?/i,
        boolean: /\b(?:false|true)\b/i,
        punctuation: /[=\[\]{}]/
    };
}

});

parcelRegister("g5gJJ", function(module, exports) {
'use strict';

var $c6Wvp = parcelRequire("c6Wvp");
module.exports = $bb5a188042d1b90b$var$hlsl;
$bb5a188042d1b90b$var$hlsl.displayName = 'hlsl';
$bb5a188042d1b90b$var$hlsl.aliases = [];
function $bb5a188042d1b90b$var$hlsl(Prism) {
    Prism.register($c6Wvp);
    Prism.languages.hlsl = Prism.languages.extend('c', {
        // Regarding keywords and class names:
        // The list of all keywords was split into 'keyword' and 'class-name' tokens based on whether they are capitalized.
        // https://docs.microsoft.com/en-us/windows/win32/direct3dhlsl/dx-graphics-hlsl-appendix-keywords
        // https://docs.microsoft.com/en-us/windows/win32/direct3dhlsl/dx-graphics-hlsl-appendix-reserved-words
        'class-name': [
            Prism.languages.c['class-name'],
            /\b(?:AppendStructuredBuffer|BlendState|Buffer|ByteAddressBuffer|CompileShader|ComputeShader|ConsumeStructuredBuffer|DepthStencilState|DepthStencilView|DomainShader|GeometryShader|Hullshader|InputPatch|LineStream|OutputPatch|PixelShader|PointStream|RWBuffer|RWByteAddressBuffer|RWStructuredBuffer|RWTexture(?:1D|1DArray|2D|2DArray|3D)|RasterizerState|RenderTargetView|SamplerComparisonState|SamplerState|StructuredBuffer|Texture(?:1D|1DArray|2D|2DArray|2DMS|2DMSArray|3D|Cube|CubeArray)|TriangleStream|VertexShader)\b/
        ],
        keyword: [
            // HLSL keyword
            /\b(?:asm|asm_fragment|auto|break|case|catch|cbuffer|centroid|char|class|column_major|compile|compile_fragment|const|const_cast|continue|default|delete|discard|do|dynamic_cast|else|enum|explicit|export|extern|for|friend|fxgroup|goto|groupshared|if|in|inline|inout|interface|line|lineadj|linear|long|matrix|mutable|namespace|new|nointerpolation|noperspective|operator|out|packoffset|pass|pixelfragment|point|precise|private|protected|public|register|reinterpret_cast|return|row_major|sample|sampler|shared|short|signed|sizeof|snorm|stateblock|stateblock_state|static|static_cast|string|struct|switch|tbuffer|technique|technique10|technique11|template|texture|this|throw|triangle|triangleadj|try|typedef|typename|uniform|union|unorm|unsigned|using|vector|vertexfragment|virtual|void|volatile|while)\b/,
            /\b(?:bool|double|dword|float|half|int|min(?:10float|12int|16(?:float|int|uint))|uint)(?:[1-4](?:x[1-4])?)?\b/
        ],
        // https://docs.microsoft.com/en-us/windows/win32/direct3dhlsl/dx-graphics-hlsl-appendix-grammar#floating-point-numbers
        number: /(?:(?:\b\d+(?:\.\d*)?|\B\.\d+)(?:[eE][+-]?\d+)?|\b0x[\da-fA-F]+)[fFhHlLuU]?\b/,
        boolean: /\b(?:false|true)\b/
    });
}

});

parcelRegister("8vj8A", function(module, exports) {
'use strict';
module.exports = $63101044b65d91e2$var$hoon;
$63101044b65d91e2$var$hoon.displayName = 'hoon';
$63101044b65d91e2$var$hoon.aliases = [];
function $63101044b65d91e2$var$hoon(Prism) {
    Prism.languages.hoon = {
        comment: {
            pattern: /::.*/,
            greedy: true
        },
        string: {
            pattern: /"[^"]*"|'[^']*'/,
            greedy: true
        },
        constant: /%(?:\.[ny]|[\w-]+)/,
        'class-name': /@(?:[a-z0-9-]*[a-z0-9])?|\*/i,
        function: /(?:\+[-+] {2})?(?:[a-z](?:[a-z0-9-]*[a-z0-9])?)/,
        keyword: /\.[\^\+\*=\?]|![><:\.=\?!]|=[>|:,\.\-\^<+;/~\*\?]|\?[>|:\.\-\^<\+&~=@!]|\|[\$_%:\.\-\^~\*=@\?]|\+[|\$\+\*]|:[_\-\^\+~\*]|%[_:\.\-\^\+~\*=]|\^[|:\.\-\+&~\*=\?]|\$[|_%:<>\-\^&~@=\?]|;[:<\+;\/~\*=]|~[>|\$_%<\+\/&=\?!]|--|==/
    };
}

});

parcelRegister("crLJd", function(module, exports) {
'use strict';
module.exports = $90fd078224ae5fe6$var$hpkp;
$90fd078224ae5fe6$var$hpkp.displayName = 'hpkp';
$90fd078224ae5fe6$var$hpkp.aliases = [];
function $90fd078224ae5fe6$var$hpkp(Prism) {
    /**
   * Original by Scott Helme.
   *
   * Reference: https://scotthelme.co.uk/hpkp-cheat-sheet/
   */ Prism.languages.hpkp = {
        directive: {
            pattern: /\b(?:includeSubDomains|max-age|pin-sha256|preload|report-to|report-uri|strict)(?=[\s;=]|$)/i,
            alias: 'property'
        },
        operator: /=/,
        punctuation: /;/
    };
}

});

parcelRegister("aamB2", function(module, exports) {
'use strict';
module.exports = $766c5db495a7b025$var$hsts;
$766c5db495a7b025$var$hsts.displayName = 'hsts';
$766c5db495a7b025$var$hsts.aliases = [];
function $766c5db495a7b025$var$hsts(Prism) {
    /**
   * Original by Scott Helme.
   *
   * Reference: https://scotthelme.co.uk/hsts-cheat-sheet/
   */ Prism.languages.hsts = {
        directive: {
            pattern: /\b(?:includeSubDomains|max-age|preload)(?=[\s;=]|$)/i,
            alias: 'property'
        },
        operator: /=/,
        punctuation: /;/
    };
}

});

parcelRegister("3iorT", function(module, exports) {
'use strict';
module.exports = $2666049977add711$var$http;
$2666049977add711$var$http.displayName = 'http';
$2666049977add711$var$http.aliases = [];
function $2666049977add711$var$http(Prism) {
    (function(Prism) {
        /**
     * @param {string} name
     * @returns {RegExp}
     */ function headerValueOf(name) {
            return RegExp('(^(?:' + name + '):[ \t]*(?![ \t]))[^]+', 'i');
        }
        Prism.languages.http = {
            'request-line': {
                pattern: /^(?:CONNECT|DELETE|GET|HEAD|OPTIONS|PATCH|POST|PRI|PUT|SEARCH|TRACE)\s(?:https?:\/\/|\/)\S*\sHTTP\/[\d.]+/m,
                inside: {
                    // HTTP Method
                    method: {
                        pattern: /^[A-Z]+\b/,
                        alias: 'property'
                    },
                    // Request Target e.g. http://example.com, /path/to/file
                    'request-target': {
                        pattern: /^(\s)(?:https?:\/\/|\/)\S*(?=\s)/,
                        lookbehind: true,
                        alias: 'url',
                        inside: Prism.languages.uri
                    },
                    // HTTP Version
                    'http-version': {
                        pattern: /^(\s)HTTP\/[\d.]+/,
                        lookbehind: true,
                        alias: 'property'
                    }
                }
            },
            'response-status': {
                pattern: /^HTTP\/[\d.]+ \d+ .+/m,
                inside: {
                    // HTTP Version
                    'http-version': {
                        pattern: /^HTTP\/[\d.]+/,
                        alias: 'property'
                    },
                    // Status Code
                    'status-code': {
                        pattern: /^(\s)\d+(?=\s)/,
                        lookbehind: true,
                        alias: 'number'
                    },
                    // Reason Phrase
                    'reason-phrase': {
                        pattern: /^(\s).+/,
                        lookbehind: true,
                        alias: 'string'
                    }
                }
            },
            header: {
                pattern: /^[\w-]+:.+(?:(?:\r\n?|\n)[ \t].+)*/m,
                inside: {
                    'header-value': [
                        {
                            pattern: headerValueOf(/Content-Security-Policy/.source),
                            lookbehind: true,
                            alias: [
                                'csp',
                                'languages-csp'
                            ],
                            inside: Prism.languages.csp
                        },
                        {
                            pattern: headerValueOf(/Public-Key-Pins(?:-Report-Only)?/.source),
                            lookbehind: true,
                            alias: [
                                'hpkp',
                                'languages-hpkp'
                            ],
                            inside: Prism.languages.hpkp
                        },
                        {
                            pattern: headerValueOf(/Strict-Transport-Security/.source),
                            lookbehind: true,
                            alias: [
                                'hsts',
                                'languages-hsts'
                            ],
                            inside: Prism.languages.hsts
                        },
                        {
                            pattern: headerValueOf(/[^:]+/.source),
                            lookbehind: true
                        }
                    ],
                    'header-name': {
                        pattern: /^[^:]+/,
                        alias: 'keyword'
                    },
                    punctuation: /^:/
                }
            }
        } // Create a mapping of Content-Type headers to language definitions
        ;
        var langs = Prism.languages;
        var httpLanguages = {
            'application/javascript': langs.javascript,
            'application/json': langs.json || langs.javascript,
            'application/xml': langs.xml,
            'text/xml': langs.xml,
            'text/html': langs.html,
            'text/css': langs.css,
            'text/plain': langs.plain
        } // Declare which types can also be suffixes
        ;
        var suffixTypes = {
            'application/json': true,
            'application/xml': true
        };
        /**
     * Returns a pattern for the given content type which matches it and any type which has it as a suffix.
     *
     * @param {string} contentType
     * @returns {string}
     */ function getSuffixPattern(contentType) {
            var suffix = contentType.replace(/^[a-z]+\//, '');
            var suffixPattern = '\\w+/(?:[\\w.-]+\\+)+' + suffix + '(?![+\\w.-])';
            return '(?:' + contentType + '|' + suffixPattern + ')';
        } // Insert each content type parser that has its associated language
        // currently loaded.
        var options;
        for(var contentType in httpLanguages)if (httpLanguages[contentType]) {
            options = options || {};
            var pattern = suffixTypes[contentType] ? getSuffixPattern(contentType) : contentType;
            options[contentType.replace(/\//g, '-')] = {
                pattern: RegExp('(' + /content-type:\s*/.source + pattern + /(?:(?:\r\n?|\n)[\w-].*)*(?:\r(?:\n|(?!\n))|\n)/.source + ')' + // This is a little interesting:
                // The HTTP format spec required 1 empty line before the body to make everything unambiguous.
                // However, when writing code by hand (e.g. to display on a website) people can forget about this,
                // so we want to be liberal here. We will allow the empty line to be omitted if the first line of
                // the body does not start with a [\w-] character (as headers do).
                /[^ \t\w-][\s\S]*/.source, 'i'),
                lookbehind: true,
                inside: httpLanguages[contentType]
            };
        }
        if (options) Prism.languages.insertBefore('http', 'header', options);
    })(Prism);
}

});

parcelRegister("50JWJ", function(module, exports) {
'use strict';
module.exports = $3a6097d13719267a$var$ichigojam;
$3a6097d13719267a$var$ichigojam.displayName = 'ichigojam';
$3a6097d13719267a$var$ichigojam.aliases = [];
function $3a6097d13719267a$var$ichigojam(Prism) {
    // according to the offical reference (EN)
    // https://ichigojam.net/IchigoJam-en.html
    Prism.languages.ichigojam = {
        comment: /(?:\B'|REM)(?:[^\n\r]*)/i,
        string: {
            pattern: /"(?:""|[!#$%&'()*,\/:;<=>?^\w +\-.])*"/,
            greedy: true
        },
        number: /\B#[0-9A-F]+|\B`[01]+|(?:\b\d+(?:\.\d*)?|\B\.\d+)(?:E[+-]?\d+)?/i,
        keyword: /\b(?:BEEP|BPS|CASE|CLEAR|CLK|CLO|CLP|CLS|CLT|CLV|CONT|COPY|ELSE|END|FILE|FILES|FOR|GOSUB|GOTO|GSB|IF|INPUT|KBD|LED|LET|LIST|LOAD|LOCATE|LRUN|NEW|NEXT|OUT|PLAY|POKE|PRINT|PWM|REM|RENUM|RESET|RETURN|RIGHT|RTN|RUN|SAVE|SCROLL|SLEEP|SRND|STEP|STOP|SUB|TEMPO|THEN|TO|UART|VIDEO|WAIT)(?:\$|\b)/i,
        function: /\b(?:ABS|ANA|ASC|BIN|BTN|DEC|END|FREE|HELP|HEX|I2CR|I2CW|IN|INKEY|LEN|LINE|PEEK|RND|SCR|SOUND|STR|TICK|USR|VER|VPEEK|ZER)(?:\$|\b)/i,
        label: /(?:\B@\S+)/,
        operator: /<[=>]?|>=?|\|\||&&|[+\-*\/=|&^~!]|\b(?:AND|NOT|OR)\b/i,
        punctuation: /[\[,;:()\]]/
    };
}

});

parcelRegister("j4rvn", function(module, exports) {
'use strict';
module.exports = $de23b9fbe2b7168a$var$icon;
$de23b9fbe2b7168a$var$icon.displayName = 'icon';
$de23b9fbe2b7168a$var$icon.aliases = [];
function $de23b9fbe2b7168a$var$icon(Prism) {
    Prism.languages.icon = {
        comment: /#.*/,
        string: {
            pattern: /(["'])(?:(?!\1)[^\\\r\n_]|\\.|_(?!\1)(?:\r\n|[\s\S]))*\1/,
            greedy: true
        },
        number: /\b(?:\d+r[a-z\d]+|\d+(?:\.\d+)?(?:e[+-]?\d+)?)\b|\.\d+\b/i,
        'builtin-keyword': {
            pattern: /&(?:allocated|ascii|clock|collections|cset|current|date|dateline|digits|dump|e|error(?:number|text|value)?|errout|fail|features|file|host|input|lcase|letters|level|line|main|null|output|phi|pi|pos|progname|random|regions|source|storage|subject|time|trace|ucase|version)\b/,
            alias: 'variable'
        },
        directive: {
            pattern: /\$\w+/,
            alias: 'builtin'
        },
        keyword: /\b(?:break|by|case|create|default|do|else|end|every|fail|global|if|initial|invocable|link|local|next|not|of|procedure|record|repeat|return|static|suspend|then|to|until|while)\b/,
        function: /\b(?!\d)\w+(?=\s*[({]|\s*!\s*\[)/,
        operator: /[+-]:(?!=)|(?:[\/?@^%&]|\+\+?|--?|==?=?|~==?=?|\*\*?|\|\|\|?|<(?:->?|<?=?)|>>?=?)(?::=)?|:(?:=:?)?|[!.\\|~]/,
        punctuation: /[\[\](){},;]/
    };
}

});

parcelRegister("8fv0R", function(module, exports) {
'use strict';
module.exports = $6017c7f82b642953$var$icuMessageFormat;
$6017c7f82b642953$var$icuMessageFormat.displayName = 'icuMessageFormat';
$6017c7f82b642953$var$icuMessageFormat.aliases = [];
function $6017c7f82b642953$var$icuMessageFormat(Prism) {
    (function(Prism) {
        /**
     * @param {string} source
     * @param {number} level
     * @returns {string}
     */ function nested(source, level) {
            if (level <= 0) return /[]/.source;
            else return source.replace(/<SELF>/g, function() {
                return nested(source, level - 1);
            });
        }
        var stringPattern = /'[{}:=,](?:[^']|'')*'(?!')/;
        var escape = {
            pattern: /''/,
            greedy: true,
            alias: 'operator'
        };
        var string = {
            pattern: stringPattern,
            greedy: true,
            inside: {
                escape: escape
            }
        };
        var argumentSource = nested(/\{(?:[^{}']|'(?![{},'])|''|<STR>|<SELF>)*\}/.source.replace(/<STR>/g, function() {
            return stringPattern.source;
        }), 8);
        var nestedMessage = {
            pattern: RegExp(argumentSource),
            inside: {
                message: {
                    pattern: /^(\{)[\s\S]+(?=\}$)/,
                    lookbehind: true,
                    inside: null // see below
                },
                'message-delimiter': {
                    pattern: /./,
                    alias: 'punctuation'
                }
            }
        };
        Prism.languages['icu-message-format'] = {
            argument: {
                pattern: RegExp(argumentSource),
                greedy: true,
                inside: {
                    content: {
                        pattern: /^(\{)[\s\S]+(?=\}$)/,
                        lookbehind: true,
                        inside: {
                            'argument-name': {
                                pattern: /^(\s*)[^{}:=,\s]+/,
                                lookbehind: true
                            },
                            'choice-style': {
                                // https://unicode-org.github.io/icu-docs/apidoc/released/icu4c/classicu_1_1ChoiceFormat.html#details
                                pattern: /^(\s*,\s*choice\s*,\s*)\S(?:[\s\S]*\S)?/,
                                lookbehind: true,
                                inside: {
                                    punctuation: /\|/,
                                    range: {
                                        pattern: /^(\s*)[+-]?(?:\d+(?:\.\d*)?|\u221e)\s*[<#\u2264]/,
                                        lookbehind: true,
                                        inside: {
                                            operator: /[<#\u2264]/,
                                            number: /\S+/
                                        }
                                    },
                                    rest: null // see below
                                }
                            },
                            'plural-style': {
                                // https://unicode-org.github.io/icu-docs/apidoc/released/icu4j/com/ibm/icu/text/PluralFormat.html#:~:text=Patterns%20and%20Their%20Interpretation
                                pattern: /^(\s*,\s*(?:plural|selectordinal)\s*,\s*)\S(?:[\s\S]*\S)?/,
                                lookbehind: true,
                                inside: {
                                    offset: /^offset:\s*\d+/,
                                    'nested-message': nestedMessage,
                                    selector: {
                                        pattern: /=\d+|[^{}:=,\s]+/,
                                        inside: {
                                            keyword: /^(?:few|many|one|other|two|zero)$/
                                        }
                                    }
                                }
                            },
                            'select-style': {
                                // https://unicode-org.github.io/icu-docs/apidoc/released/icu4j/com/ibm/icu/text/SelectFormat.html#:~:text=Patterns%20and%20Their%20Interpretation
                                pattern: /^(\s*,\s*select\s*,\s*)\S(?:[\s\S]*\S)?/,
                                lookbehind: true,
                                inside: {
                                    'nested-message': nestedMessage,
                                    selector: {
                                        pattern: /[^{}:=,\s]+/,
                                        inside: {
                                            keyword: /^other$/
                                        }
                                    }
                                }
                            },
                            keyword: /\b(?:choice|plural|select|selectordinal)\b/,
                            'arg-type': {
                                pattern: /\b(?:date|duration|number|ordinal|spellout|time)\b/,
                                alias: 'keyword'
                            },
                            'arg-skeleton': {
                                pattern: /(,\s*)::[^{}:=,\s]+/,
                                lookbehind: true
                            },
                            'arg-style': {
                                pattern: /(,\s*)(?:currency|full|integer|long|medium|percent|short)(?=\s*$)/,
                                lookbehind: true
                            },
                            'arg-style-text': {
                                pattern: RegExp(/(^\s*,\s*(?=\S))/.source + nested(/(?:[^{}']|'[^']*'|\{(?:<SELF>)?\})+/.source, 8) + '$'),
                                lookbehind: true,
                                alias: 'string'
                            },
                            punctuation: /,/
                        }
                    },
                    'argument-delimiter': {
                        pattern: /./,
                        alias: 'operator'
                    }
                }
            },
            escape: escape,
            string: string
        };
        nestedMessage.inside.message.inside = Prism.languages['icu-message-format'];
        Prism.languages['icu-message-format'].argument.inside.content.inside['choice-style'].inside.rest = Prism.languages['icu-message-format'];
    })(Prism);
}

});

parcelRegister("7atwR", function(module, exports) {
'use strict';

var $f3xTx = parcelRequire("f3xTx");
module.exports = $53805f669dbb7aaa$var$idris;
$53805f669dbb7aaa$var$idris.displayName = 'idris';
$53805f669dbb7aaa$var$idris.aliases = [
    'idr'
];
function $53805f669dbb7aaa$var$idris(Prism) {
    Prism.register($f3xTx);
    Prism.languages.idris = Prism.languages.extend('haskell', {
        comment: {
            pattern: /(?:(?:--|\|\|\|).*$|\{-[\s\S]*?-\})/m
        },
        keyword: /\b(?:Type|case|class|codata|constructor|corecord|data|do|dsl|else|export|if|implementation|implicit|import|impossible|in|infix|infixl|infixr|instance|interface|let|module|mutual|namespace|of|parameters|partial|postulate|private|proof|public|quoteGoal|record|rewrite|syntax|then|total|using|where|with)\b/,
        builtin: undefined
    });
    Prism.languages.insertBefore('idris', 'keyword', {
        'import-statement': {
            pattern: /(^\s*import\s+)(?:[A-Z][\w']*)(?:\.[A-Z][\w']*)*/m,
            lookbehind: true,
            inside: {
                punctuation: /\./
            }
        }
    });
    Prism.languages.idr = Prism.languages.idris;
}

});

parcelRegister("2v4Bz", function(module, exports) {
'use strict';
module.exports = $1d220c735f89b954$var$iecst;
$1d220c735f89b954$var$iecst.displayName = 'iecst';
$1d220c735f89b954$var$iecst.aliases = [];
function $1d220c735f89b954$var$iecst(Prism) {
    Prism.languages.iecst = {
        comment: [
            {
                pattern: /(^|[^\\])(?:\/\*[\s\S]*?(?:\*\/|$)|\(\*[\s\S]*?(?:\*\)|$)|\{[\s\S]*?(?:\}|$))/,
                lookbehind: true,
                greedy: true
            },
            {
                pattern: /(^|[^\\:])\/\/.*/,
                lookbehind: true,
                greedy: true
            }
        ],
        string: {
            pattern: /(["'])(?:\\(?:\r\n|[\s\S])|(?!\1)[^\\\r\n])*\1/,
            greedy: true
        },
        keyword: [
            /\b(?:END_)?(?:PROGRAM|CONFIGURATION|INTERFACE|FUNCTION_BLOCK|FUNCTION|ACTION|TRANSITION|TYPE|STRUCT|(?:INITIAL_)?STEP|NAMESPACE|LIBRARY|CHANNEL|FOLDER|RESOURCE|VAR_(?:ACCESS|CONFIG|EXTERNAL|GLOBAL|INPUT|IN_OUT|OUTPUT|TEMP)|VAR|METHOD|PROPERTY)\b/i,
            /\b(?:AT|BY|(?:END_)?(?:CASE|FOR|IF|REPEAT|WHILE)|CONSTANT|CONTINUE|DO|ELSE|ELSIF|EXIT|EXTENDS|FROM|GET|GOTO|IMPLEMENTS|JMP|NON_RETAIN|OF|PRIVATE|PROTECTED|PUBLIC|RETAIN|RETURN|SET|TASK|THEN|TO|UNTIL|USING|WITH|__CATCH|__ENDTRY|__FINALLY|__TRY)\b/
        ],
        'class-name': /\b(?:ANY|ARRAY|BOOL|BYTE|U?(?:D|L|S)?INT|(?:D|L)?WORD|DATE(?:_AND_TIME)?|DT|L?REAL|POINTER|STRING|TIME(?:_OF_DAY)?|TOD)\b/,
        address: {
            pattern: /%[IQM][XBWDL][\d.]*|%[IQ][\d.]*/,
            alias: 'symbol'
        },
        number: /\b(?:16#[\da-f]+|2#[01_]+|0x[\da-f]+)\b|\b(?:D|DT|T|TOD)#[\d_shmd:]*|\b[A-Z]*#[\d.,_]*|(?:\b\d+(?:\.\d*)?|\B\.\d+)(?:e[+-]?\d+)?/i,
        boolean: /\b(?:FALSE|NULL|TRUE)\b/,
        operator: /S?R?:?=>?|&&?|\*\*?|<[=>]?|>=?|[-:^/+#]|\b(?:AND|EQ|EXPT|GE|GT|LE|LT|MOD|NE|NOT|OR|XOR)\b/,
        function: /\b[a-z_]\w*(?=\s*\()/i,
        punctuation: /[()[\].,;]/
    };
}

});

parcelRegister("707au", function(module, exports) {
'use strict';
module.exports = $518e17f82f094799$var$ignore;
$518e17f82f094799$var$ignore.displayName = 'ignore';
$518e17f82f094799$var$ignore.aliases = [
    'gitignore',
    'hgignore',
    'npmignore'
];
function $518e17f82f094799$var$ignore(Prism) {
    (function(Prism) {
        Prism.languages.ignore = {
            // https://git-scm.com/docs/gitignore
            comment: /^#.*/m,
            entry: {
                pattern: /\S(?:.*(?:(?:\\ )|\S))?/,
                alias: 'string',
                inside: {
                    operator: /^!|\*\*?|\?/,
                    regex: {
                        pattern: /(^|[^\\])\[[^\[\]]*\]/,
                        lookbehind: true
                    },
                    punctuation: /\//
                }
            }
        };
        Prism.languages.gitignore = Prism.languages.ignore;
        Prism.languages.hgignore = Prism.languages.ignore;
        Prism.languages.npmignore = Prism.languages.ignore;
    })(Prism);
}

});

parcelRegister("cAXA9", function(module, exports) {
'use strict';
module.exports = $92b710954ddf4371$var$inform7;
$92b710954ddf4371$var$inform7.displayName = 'inform7';
$92b710954ddf4371$var$inform7.aliases = [];
function $92b710954ddf4371$var$inform7(Prism) {
    Prism.languages.inform7 = {
        string: {
            pattern: /"[^"]*"/,
            inside: {
                substitution: {
                    pattern: /\[[^\[\]]+\]/,
                    inside: {
                        delimiter: {
                            pattern: /\[|\]/,
                            alias: 'punctuation'
                        } // See rest below
                    }
                }
            }
        },
        comment: {
            pattern: /\[[^\[\]]+\]/,
            greedy: true
        },
        title: {
            pattern: /^[ \t]*(?:book|chapter|part(?! of)|section|table|volume)\b.+/im,
            alias: 'important'
        },
        number: {
            pattern: /(^|[^-])(?:\b\d+(?:\.\d+)?(?:\^\d+)?(?:(?!\d)\w+)?|\b(?:eight|eleven|five|four|nine|one|seven|six|ten|three|twelve|two))\b(?!-)/i,
            lookbehind: true
        },
        verb: {
            pattern: /(^|[^-])\b(?:answering|applying to|are|asking|attacking|be(?:ing)?|burning|buying|called|carries|carry(?! out)|carrying|climbing|closing|conceal(?:ing|s)?|consulting|contain(?:ing|s)?|cutting|drinking|dropping|eating|enclos(?:es?|ing)|entering|examining|exiting|getting|giving|going|ha(?:s|ve|ving)|hold(?:ing|s)?|impl(?:ies|y)|incorporat(?:es?|ing)|inserting|is|jumping|kissing|listening|locking|looking|mean(?:ing|s)?|opening|provid(?:es?|ing)|pulling|pushing|putting|relat(?:es?|ing)|removing|searching|see(?:ing|s)?|setting|showing|singing|sleeping|smelling|squeezing|support(?:ing|s)?|swearing|switching|taking|tasting|telling|thinking|throwing|touching|turning|tying|unlock(?:ing|s)?|var(?:ies|y|ying)|waiting|waking|waving|wear(?:ing|s)?)\b(?!-)/i,
            lookbehind: true,
            alias: 'operator'
        },
        keyword: {
            pattern: /(^|[^-])\b(?:after|before|carry out|check|continue the action|definition(?= *:)|do nothing|else|end (?:if|the story|unless)|every turn|if|include|instead(?: of)?|let|move|no|now|otherwise|repeat|report|resume the story|rule for|running through|say(?:ing)?|stop the action|test|try(?:ing)?|understand|unless|use|when|while|yes)\b(?!-)/i,
            lookbehind: true
        },
        property: {
            pattern: /(^|[^-])\b(?:adjacent(?! to)|carried|closed|concealed|contained|dark|described|edible|empty|enclosed|enterable|even|female|fixed in place|full|handled|held|improper-named|incorporated|inedible|invisible|lighted|lit|lock(?:able|ed)|male|marked for listing|mentioned|negative|neuter|non-(?:empty|full|recurring)|odd|opaque|open(?:able)?|plural-named|portable|positive|privately-named|proper-named|provided|publically-named|pushable between rooms|recurring|related|rubbing|scenery|seen|singular-named|supported|swinging|switch(?:able|ed(?: off| on)?)|touch(?:able|ed)|transparent|unconcealed|undescribed|unlit|unlocked|unmarked for listing|unmentioned|unopenable|untouchable|unvisited|variable|visible|visited|wearable|worn)\b(?!-)/i,
            lookbehind: true,
            alias: 'symbol'
        },
        position: {
            pattern: /(^|[^-])\b(?:above|adjacent to|back side of|below|between|down|east|everywhere|front side|here|in|inside(?: from)?|north(?:east|west)?|nowhere|on(?: top of)?|other side|outside(?: from)?|parts? of|regionally in|south(?:east|west)?|through|up|west|within)\b(?!-)/i,
            lookbehind: true,
            alias: 'keyword'
        },
        type: {
            pattern: /(^|[^-])\b(?:actions?|activit(?:ies|y)|actors?|animals?|backdrops?|containers?|devices?|directions?|doors?|holders?|kinds?|lists?|m[ae]n|nobody|nothing|nouns?|numbers?|objects?|people|persons?|player(?:'s holdall)?|regions?|relations?|rooms?|rule(?:book)?s?|scenes?|someone|something|supporters?|tables?|texts?|things?|time|vehicles?|wom[ae]n)\b(?!-)/i,
            lookbehind: true,
            alias: 'variable'
        },
        punctuation: /[.,:;(){}]/
    };
    Prism.languages.inform7['string'].inside['substitution'].inside.rest = Prism.languages.inform7 // We don't want the remaining text in the substitution to be highlighted as the string.
    ;
    Prism.languages.inform7['string'].inside['substitution'].inside.rest.text = {
        pattern: /\S(?:\s*\S)*/,
        alias: 'comment'
    };
}

});

parcelRegister("kAVHo", function(module, exports) {
'use strict';
module.exports = $efe3ed3ce77118bc$var$ini;
$efe3ed3ce77118bc$var$ini.displayName = 'ini';
$efe3ed3ce77118bc$var$ini.aliases = [];
function $efe3ed3ce77118bc$var$ini(Prism) {
    Prism.languages.ini = {
        /**
     * The component mimics the behavior of the Win32 API parser.
     *
     * @see {@link https://github.com/PrismJS/prism/issues/2775#issuecomment-787477723}
     */ comment: {
            pattern: /(^[ \f\t\v]*)[#;][^\n\r]*/m,
            lookbehind: true
        },
        section: {
            pattern: /(^[ \f\t\v]*)\[[^\n\r\]]*\]?/m,
            lookbehind: true,
            inside: {
                'section-name': {
                    pattern: /(^\[[ \f\t\v]*)[^ \f\t\v\]]+(?:[ \f\t\v]+[^ \f\t\v\]]+)*/,
                    lookbehind: true,
                    alias: 'selector'
                },
                punctuation: /\[|\]/
            }
        },
        key: {
            pattern: /(^[ \f\t\v]*)[^ \f\n\r\t\v=]+(?:[ \f\t\v]+[^ \f\n\r\t\v=]+)*(?=[ \f\t\v]*=)/m,
            lookbehind: true,
            alias: 'attr-name'
        },
        value: {
            pattern: /(=[ \f\t\v]*)[^ \f\n\r\t\v]+(?:[ \f\t\v]+[^ \f\n\r\t\v]+)*/,
            lookbehind: true,
            alias: 'attr-value',
            inside: {
                'inner-value': {
                    pattern: /^("|').+(?=\1$)/,
                    lookbehind: true
                }
            }
        },
        punctuation: /=/
    };
}

});

parcelRegister("8xZNk", function(module, exports) {
'use strict';
module.exports = $639156f0004e91cb$var$io;
$639156f0004e91cb$var$io.displayName = 'io';
$639156f0004e91cb$var$io.aliases = [];
function $639156f0004e91cb$var$io(Prism) {
    Prism.languages.io = {
        comment: {
            pattern: /(^|[^\\])(?:\/\*[\s\S]*?(?:\*\/|$)|\/\/.*|#.*)/,
            lookbehind: true,
            greedy: true
        },
        'triple-quoted-string': {
            pattern: /"""(?:\\[\s\S]|(?!""")[^\\])*"""/,
            greedy: true,
            alias: 'string'
        },
        string: {
            pattern: /"(?:\\.|[^\\\r\n"])*"/,
            greedy: true
        },
        keyword: /\b(?:activate|activeCoroCount|asString|block|break|call|catch|clone|collectGarbage|compileString|continue|do|doFile|doMessage|doString|else|elseif|exit|for|foreach|forward|getEnvironmentVariable|getSlot|hasSlot|if|ifFalse|ifNil|ifNilEval|ifTrue|isActive|isNil|isResumable|list|message|method|parent|pass|pause|perform|performWithArgList|print|println|proto|raise|raiseResumable|removeSlot|resend|resume|schedulerSleepSeconds|self|sender|setSchedulerSleepSeconds|setSlot|shallowCopy|slotNames|super|system|then|thisBlock|thisContext|try|type|uniqueId|updateSlot|wait|while|write|yield)\b/,
        builtin: /\b(?:Array|AudioDevice|AudioMixer|BigNum|Block|Box|Buffer|CFunction|CGI|Color|Curses|DBM|DNSResolver|DOConnection|DOProxy|DOServer|Date|Directory|Duration|DynLib|Error|Exception|FFT|File|Fnmatch|Font|Future|GL|GLE|GLScissor|GLU|GLUCylinder|GLUQuadric|GLUSphere|GLUT|Host|Image|Importer|LinkList|List|Lobby|Locals|MD5|MP3Decoder|MP3Encoder|Map|Message|Movie|Notification|Number|Object|OpenGL|Point|Protos|Random|Regex|SGML|SGMLElement|SGMLParser|SQLite|Sequence|Server|ShowMessage|SleepyCat|SleepyCatCursor|Socket|SocketManager|Sound|Soup|Store|String|Tree|UDPSender|UPDReceiver|URL|User|Warning|WeakLink)\b/,
        boolean: /\b(?:false|nil|true)\b/,
        number: /\b0x[\da-f]+\b|(?:\b\d+(?:\.\d*)?|\B\.\d+)(?:e-?\d+)?/i,
        operator: /[=!*/%+\-^&|]=|>>?=?|<<?=?|:?:?=|\+\+?|--?|\*\*?|\/\/?|%|\|\|?|&&?|\b(?:and|not|or|return)\b|@@?|\?\??|\.\./,
        punctuation: /[{}[\];(),.:]/
    };
}

});

parcelRegister("3dpZW", function(module, exports) {
'use strict';
module.exports = $2576c0ad202a32d1$var$j;
$2576c0ad202a32d1$var$j.displayName = 'j';
$2576c0ad202a32d1$var$j.aliases = [];
function $2576c0ad202a32d1$var$j(Prism) {
    Prism.languages.j = {
        comment: {
            pattern: /\bNB\..*/,
            greedy: true
        },
        string: {
            pattern: /'(?:''|[^'\r\n])*'/,
            greedy: true
        },
        keyword: /\b(?:(?:CR|LF|adverb|conjunction|def|define|dyad|monad|noun|verb)\b|(?:assert|break|case|catch[dt]?|continue|do|else|elseif|end|fcase|for|for_\w+|goto_\w+|if|label_\w+|return|select|throw|try|while|whilst)\.)/,
        verb: {
            // Negative look-ahead prevents bad highlighting
            // of ^: ;. =. =: !. !:
            pattern: /(?!\^:|;\.|[=!][.:])(?:\{(?:\.|::?)?|p(?:\.\.?|:)|[=!\]]|[<>+*\-%$|,#][.:]?|[?^]\.?|[;\[]:?|[~}"i][.:]|[ACeEIjLor]\.|(?:[_\/\\qsux]|_?\d):)/,
            alias: 'keyword'
        },
        number: /\b_?(?:(?!\d:)\d+(?:\.\d+)?(?:(?:ad|ar|[ejpx])_?\d+(?:\.\d+)?)*(?:b_?[\da-z]+(?:\.[\da-z]+)?)?|_\b(?!\.))/,
        adverb: {
            pattern: /[~}]|[\/\\]\.?|[bfM]\.|t[.:]/,
            alias: 'builtin'
        },
        operator: /[=a][.:]|_\./,
        conjunction: {
            pattern: /&(?:\.:?|:)?|[.:@][.:]?|[!D][.:]|[;dHT]\.|`:?|[\^LS]:|"/,
            alias: 'variable'
        },
        punctuation: /[()]/
    };
}

});

parcelRegister("3IbCO", function(module, exports) {
'use strict';
module.exports = $2b3e7fa5b1af129c$var$java;
$2b3e7fa5b1af129c$var$java.displayName = 'java';
$2b3e7fa5b1af129c$var$java.aliases = [];
function $2b3e7fa5b1af129c$var$java(Prism) {
    (function(Prism) {
        var keywords = /\b(?:abstract|assert|boolean|break|byte|case|catch|char|class|const|continue|default|do|double|else|enum|exports|extends|final|finally|float|for|goto|if|implements|import|instanceof|int|interface|long|module|native|new|non-sealed|null|open|opens|package|permits|private|protected|provides|public|record|requires|return|sealed|short|static|strictfp|super|switch|synchronized|this|throw|throws|to|transient|transitive|try|uses|var|void|volatile|while|with|yield)\b/ // full package (optional) + parent classes (optional)
        ;
        var classNamePrefix = /(^|[^\w.])(?:[a-z]\w*\s*\.\s*)*(?:[A-Z]\w*\s*\.\s*)*/.source // based on the java naming conventions
        ;
        var className = {
            pattern: RegExp(classNamePrefix + /[A-Z](?:[\d_A-Z]*[a-z]\w*)?\b/.source),
            lookbehind: true,
            inside: {
                namespace: {
                    pattern: /^[a-z]\w*(?:\s*\.\s*[a-z]\w*)*(?:\s*\.)?/,
                    inside: {
                        punctuation: /\./
                    }
                },
                punctuation: /\./
            }
        };
        Prism.languages.java = Prism.languages.extend('clike', {
            string: {
                pattern: /(^|[^\\])"(?:\\.|[^"\\\r\n])*"/,
                lookbehind: true,
                greedy: true
            },
            'class-name': [
                className,
                {
                    // variables and parameters
                    // this to support class names (or generic parameters) which do not contain a lower case letter (also works for methods)
                    pattern: RegExp(classNamePrefix + /[A-Z]\w*(?=\s+\w+\s*[;,=()])/.source),
                    lookbehind: true,
                    inside: className.inside
                }
            ],
            keyword: keywords,
            function: [
                Prism.languages.clike.function,
                {
                    pattern: /(::\s*)[a-z_]\w*/,
                    lookbehind: true
                }
            ],
            number: /\b0b[01][01_]*L?\b|\b0x(?:\.[\da-f_p+-]+|[\da-f_]+(?:\.[\da-f_p+-]+)?)\b|(?:\b\d[\d_]*(?:\.[\d_]*)?|\B\.\d[\d_]*)(?:e[+-]?\d[\d_]*)?[dfl]?/i,
            operator: {
                pattern: /(^|[^.])(?:<<=?|>>>?=?|->|--|\+\+|&&|\|\||::|[?:~]|[-+*/%&|^!=<>]=?)/m,
                lookbehind: true
            }
        });
        Prism.languages.insertBefore('java', 'string', {
            'triple-quoted-string': {
                // http://openjdk.java.net/jeps/355#Description
                pattern: /"""[ \t]*[\r\n](?:(?:"|"")?(?:\\.|[^"\\]))*"""/,
                greedy: true,
                alias: 'string'
            },
            char: {
                pattern: /'(?:\\.|[^'\\\r\n]){1,6}'/,
                greedy: true
            }
        });
        Prism.languages.insertBefore('java', 'class-name', {
            annotation: {
                pattern: /(^|[^.])@\w+(?:\s*\.\s*\w+)*/,
                lookbehind: true,
                alias: 'punctuation'
            },
            generics: {
                pattern: /<(?:[\w\s,.?]|&(?!&)|<(?:[\w\s,.?]|&(?!&)|<(?:[\w\s,.?]|&(?!&)|<(?:[\w\s,.?]|&(?!&))*>)*>)*>)*>/,
                inside: {
                    'class-name': className,
                    keyword: keywords,
                    punctuation: /[<>(),.:]/,
                    operator: /[?&|]/
                }
            },
            namespace: {
                pattern: RegExp(/(\b(?:exports|import(?:\s+static)?|module|open|opens|package|provides|requires|to|transitive|uses|with)\s+)(?!<keyword>)[a-z]\w*(?:\.[a-z]\w*)*\.?/.source.replace(/<keyword>/g, function() {
                    return keywords.source;
                })),
                lookbehind: true,
                inside: {
                    punctuation: /\./
                }
            }
        });
    })(Prism);
}

});

parcelRegister("f7qNG", function(module, exports) {
'use strict';

var $3IbCO = parcelRequire("3IbCO");

var $e9UW8 = parcelRequire("e9UW8");
module.exports = $b01c4c71633335c3$var$javadoc;
$b01c4c71633335c3$var$javadoc.displayName = 'javadoc';
$b01c4c71633335c3$var$javadoc.aliases = [];
function $b01c4c71633335c3$var$javadoc(Prism) {
    Prism.register($3IbCO);
    Prism.register($e9UW8);
    (function(Prism) {
        var codeLinePattern = /(^(?:[\t ]*(?:\*\s*)*))[^*\s].*$/m;
        var memberReference = /#\s*\w+(?:\s*\([^()]*\))?/.source;
        var reference = /(?:\b[a-zA-Z]\w+\s*\.\s*)*\b[A-Z]\w*(?:\s*<mem>)?|<mem>/.source.replace(/<mem>/g, function() {
            return memberReference;
        });
        Prism.languages.javadoc = Prism.languages.extend('javadoclike', {});
        Prism.languages.insertBefore('javadoc', 'keyword', {
            reference: {
                pattern: RegExp(/(@(?:exception|link|linkplain|see|throws|value)\s+(?:\*\s*)?)/.source + '(?:' + reference + ')'),
                lookbehind: true,
                inside: {
                    function: {
                        pattern: /(#\s*)\w+(?=\s*\()/,
                        lookbehind: true
                    },
                    field: {
                        pattern: /(#\s*)\w+/,
                        lookbehind: true
                    },
                    namespace: {
                        pattern: /\b(?:[a-z]\w*\s*\.\s*)+/,
                        inside: {
                            punctuation: /\./
                        }
                    },
                    'class-name': /\b[A-Z]\w*/,
                    keyword: Prism.languages.java.keyword,
                    punctuation: /[#()[\],.]/
                }
            },
            'class-name': {
                // @param <T> the first generic type parameter
                pattern: /(@param\s+)<[A-Z]\w*>/,
                lookbehind: true,
                inside: {
                    punctuation: /[.<>]/
                }
            },
            'code-section': [
                {
                    pattern: /(\{@code\s+(?!\s))(?:[^\s{}]|\s+(?![\s}])|\{(?:[^{}]|\{(?:[^{}]|\{(?:[^{}]|\{[^{}]*\})*\})*\})*\})+(?=\s*\})/,
                    lookbehind: true,
                    inside: {
                        code: {
                            // there can't be any HTML inside of {@code} tags
                            pattern: codeLinePattern,
                            lookbehind: true,
                            inside: Prism.languages.java,
                            alias: 'language-java'
                        }
                    }
                },
                {
                    pattern: /(<(code|pre|tt)>(?!<code>)\s*)\S(?:\S|\s+\S)*?(?=\s*<\/\2>)/,
                    lookbehind: true,
                    inside: {
                        line: {
                            pattern: codeLinePattern,
                            lookbehind: true,
                            inside: {
                                // highlight HTML tags and entities
                                tag: Prism.languages.markup.tag,
                                entity: Prism.languages.markup.entity,
                                code: {
                                    // everything else is Java code
                                    pattern: /.+/,
                                    inside: Prism.languages.java,
                                    alias: 'language-java'
                                }
                            }
                        }
                    }
                }
            ],
            tag: Prism.languages.markup.tag,
            entity: Prism.languages.markup.entity
        });
        Prism.languages.javadoclike.addSupport('java', Prism.languages.javadoc);
    })(Prism);
}

});
parcelRegister("e9UW8", function(module, exports) {
'use strict';
module.exports = $a4ee126286e053ea$var$javadoclike;
$a4ee126286e053ea$var$javadoclike.displayName = 'javadoclike';
$a4ee126286e053ea$var$javadoclike.aliases = [];
function $a4ee126286e053ea$var$javadoclike(Prism) {
    (function(Prism) {
        var javaDocLike = Prism.languages.javadoclike = {
            parameter: {
                pattern: /(^[\t ]*(?:\/{3}|\*|\/\*\*)\s*@(?:arg|arguments|param)\s+)\w+/m,
                lookbehind: true
            },
            keyword: {
                // keywords are the first word in a line preceded be an `@` or surrounded by curly braces.
                // @word, {@word}
                pattern: /(^[\t ]*(?:\/{3}|\*|\/\*\*)\s*|\{)@[a-z][a-zA-Z-]+\b/m,
                lookbehind: true
            },
            punctuation: /[{}]/
        };
        /**
     * Adds doc comment support to the given language and calls a given callback on each doc comment pattern.
     *
     * @param {string} lang the language add doc comment support to.
     * @param {(pattern: {inside: {rest: undefined}}) => void} callback the function called with each doc comment pattern as argument.
     */ function docCommentSupport(lang, callback) {
            var tokenName = 'doc-comment';
            var grammar = Prism.languages[lang];
            if (!grammar) return;
            var token = grammar[tokenName];
            if (!token) {
                // add doc comment: /** */
                var definition = {};
                definition[tokenName] = {
                    pattern: /(^|[^\\])\/\*\*[^/][\s\S]*?(?:\*\/|$)/,
                    lookbehind: true,
                    alias: 'comment'
                };
                grammar = Prism.languages.insertBefore(lang, 'comment', definition);
                token = grammar[tokenName];
            }
            if (token instanceof RegExp) // convert regex to object
            token = grammar[tokenName] = {
                pattern: token
            };
            if (Array.isArray(token)) for(var i = 0, l = token.length; i < l; i++){
                if (token[i] instanceof RegExp) token[i] = {
                    pattern: token[i]
                };
                callback(token[i]);
            }
            else callback(token);
        }
        /**
     * Adds doc-comment support to the given languages for the given documentation language.
     *
     * @param {string[]|string} languages
     * @param {Object} docLanguage
     */ function addSupport(languages, docLanguage) {
            if (typeof languages === 'string') languages = [
                languages
            ];
            languages.forEach(function(lang) {
                docCommentSupport(lang, function(pattern) {
                    if (!pattern.inside) pattern.inside = {};
                    pattern.inside.rest = docLanguage;
                });
            });
        }
        Object.defineProperty(javaDocLike, 'addSupport', {
            value: addSupport
        });
        javaDocLike.addSupport([
            'java',
            'javascript',
            'php'
        ], javaDocLike);
    })(Prism);
}

});


parcelRegister("2c62O", function(module, exports) {
'use strict';
module.exports = $1991640a3d3b7e67$var$javastacktrace;
$1991640a3d3b7e67$var$javastacktrace.displayName = 'javastacktrace';
$1991640a3d3b7e67$var$javastacktrace.aliases = [];
function $1991640a3d3b7e67$var$javastacktrace(Prism) {
    // Specification:
    // https://docs.oracle.com/en/java/javase/13/docs/api/java.base/java/lang/Throwable.html#printStackTrace()
    Prism.languages.javastacktrace = {
        // java.sql.SQLException: Violation of unique constraint MY_ENTITY_UK_1: duplicate value(s) for column(s) MY_COLUMN in statement [...]
        // Caused by: java.sql.SQLException: Violation of unique constraint MY_ENTITY_UK_1: duplicate value(s) for column(s) MY_COLUMN in statement [...]
        // Caused by: com.example.myproject.MyProjectServletException
        // Caused by: MidLevelException: LowLevelException
        // Suppressed: Resource$CloseFailException: Resource ID = 0
        summary: {
            pattern: /^([\t ]*)(?:(?:Caused by:|Suppressed:|Exception in thread "[^"]*")[\t ]+)?[\w$.]+(?::.*)?$/m,
            lookbehind: true,
            inside: {
                keyword: {
                    pattern: /^([\t ]*)(?:(?:Caused by|Suppressed)(?=:)|Exception in thread)/m,
                    lookbehind: true
                },
                // the current thread if the summary starts with 'Exception in thread'
                string: {
                    pattern: /^(\s*)"[^"]*"/,
                    lookbehind: true
                },
                exceptions: {
                    pattern: /^(:?\s*)[\w$.]+(?=:|$)/,
                    lookbehind: true,
                    inside: {
                        'class-name': /[\w$]+$/,
                        namespace: /\b[a-z]\w*\b/,
                        punctuation: /\./
                    }
                },
                message: {
                    pattern: /(:\s*)\S.*/,
                    lookbehind: true,
                    alias: 'string'
                },
                punctuation: /:/
            }
        },
        // at org.mortbay.jetty.servlet.ServletHandler$CachedChain.doFilter(ServletHandler.java:1166)
        // at org.hsqldb.jdbc.Util.throwError(Unknown Source) here could be some notes
        // at java.base/java.lang.Class.forName0(Native Method)
        // at Util.<init>(Unknown Source)
        // at com.foo.loader/foo@9.0/com.foo.Main.run(Main.java:101)
        // at com.foo.loader//com.foo.bar.App.run(App.java:12)
        // at acme@2.1/org.acme.Lib.test(Lib.java:80)
        // at MyClass.mash(MyClass.java:9)
        //
        // More information:
        // https://docs.oracle.com/en/java/javase/13/docs/api/java.base/java/lang/StackTraceElement.html#toString()
        //
        // A valid Java module name is defined as:
        //   "A module name consists of one or more Java identifiers (§3.8) separated by "." tokens."
        // https://docs.oracle.com/javase/specs/jls/se9/html/jls-6.html#jls-ModuleName
        //
        // A Java module version is defined by this class:
        // https://docs.oracle.com/javase/9/docs/api/java/lang/module/ModuleDescriptor.Version.html
        // This is the implementation of the `parse` method in JDK13:
        // https://github.com/matcdac/jdk/blob/2305df71d1b7710266ae0956d73927a225132c0f/src/java.base/share/classes/java/lang/module/ModuleDescriptor.java#L1108
        // However, to keep this simple, a version will be matched by the pattern /@[\w$.+-]*/.
        'stack-frame': {
            pattern: /^([\t ]*)at (?:[\w$./]|@[\w$.+-]*\/)+(?:<init>)?\([^()]*\)/m,
            lookbehind: true,
            inside: {
                keyword: {
                    pattern: /^(\s*)at(?= )/,
                    lookbehind: true
                },
                source: [
                    // (Main.java:15)
                    // (Main.scala:15)
                    {
                        pattern: /(\()\w+\.\w+:\d+(?=\))/,
                        lookbehind: true,
                        inside: {
                            file: /^\w+\.\w+/,
                            punctuation: /:/,
                            'line-number': {
                                pattern: /\b\d+\b/,
                                alias: 'number'
                            }
                        }
                    },
                    // (Native Method)
                    // (...something...)
                    {
                        pattern: /(\()[^()]*(?=\))/,
                        lookbehind: true,
                        inside: {
                            keyword: /^(?:Native Method|Unknown Source)$/
                        }
                    }
                ],
                'class-name': /[\w$]+(?=\.(?:<init>|[\w$]+)\()/,
                function: /(?:<init>|[\w$]+)(?=\()/,
                'class-loader': {
                    pattern: /(\s)[a-z]\w*(?:\.[a-z]\w*)*(?=\/[\w@$.]*\/)/,
                    lookbehind: true,
                    alias: 'namespace',
                    inside: {
                        punctuation: /\./
                    }
                },
                module: {
                    pattern: /([\s/])[a-z]\w*(?:\.[a-z]\w*)*(?:@[\w$.+-]*)?(?=\/)/,
                    lookbehind: true,
                    inside: {
                        version: {
                            pattern: /(@)[\s\S]+/,
                            lookbehind: true,
                            alias: 'number'
                        },
                        punctuation: /[@.]/
                    }
                },
                namespace: {
                    pattern: /(?:\b[a-z]\w*\.)+/,
                    inside: {
                        punctuation: /\./
                    }
                },
                punctuation: /[()/.]/
            }
        },
        // ... 32 more
        // ... 32 common frames omitted
        more: {
            pattern: /^([\t ]*)\.{3} \d+ [a-z]+(?: [a-z]+)*/m,
            lookbehind: true,
            inside: {
                punctuation: /\.{3}/,
                number: /\d+/,
                keyword: /\b[a-z]+(?: [a-z]+)*\b/
            }
        }
    };
}

});

parcelRegister("6jo5N", function(module, exports) {
'use strict';
module.exports = $498734b149b00586$var$jexl;
$498734b149b00586$var$jexl.displayName = 'jexl';
$498734b149b00586$var$jexl.aliases = [];
function $498734b149b00586$var$jexl(Prism) {
    Prism.languages.jexl = {
        string: /(["'])(?:\\[\s\S]|(?!\1)[^\\])*\1/,
        transform: {
            pattern: /(\|\s*)[a-zA-Zа-яА-Я_\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u00FF$][\wа-яА-Я\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u00FF$]*/,
            alias: 'function',
            lookbehind: true
        },
        function: /[a-zA-Zа-яА-Я_\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u00FF$][\wа-яА-Я\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u00FF$]*\s*(?=\()/,
        number: /\b\d+(?:\.\d+)?\b|\B\.\d+\b/,
        operator: /[<>!]=?|-|\+|&&|==|\|\|?|\/\/?|[?:*^%]/,
        boolean: /\b(?:false|true)\b/,
        keyword: /\bin\b/,
        punctuation: /[{}[\](),.]/
    };
}

});

parcelRegister("iPtcI", function(module, exports) {
'use strict';
module.exports = $db53a4c0f1f78204$var$jolie;
$db53a4c0f1f78204$var$jolie.displayName = 'jolie';
$db53a4c0f1f78204$var$jolie.aliases = [];
function $db53a4c0f1f78204$var$jolie(Prism) {
    Prism.languages.jolie = Prism.languages.extend('clike', {
        string: {
            pattern: /(^|[^\\])"(?:\\[\s\S]|[^"\\])*"/,
            lookbehind: true,
            greedy: true
        },
        'class-name': {
            pattern: /((?:\b(?:as|courier|embed|in|inputPort|outputPort|service)\b|@)[ \t]*)\w+/,
            lookbehind: true
        },
        keyword: /\b(?:as|cH|comp|concurrent|constants|courier|cset|csets|default|define|else|embed|embedded|execution|exit|extender|for|foreach|forward|from|global|if|import|in|include|init|inputPort|install|instanceof|interface|is_defined|linkIn|linkOut|main|new|nullProcess|outputPort|over|private|provide|public|scope|sequential|service|single|spawn|synchronized|this|throw|throws|type|undef|until|while|with)\b/,
        function: /\b[a-z_]\w*(?=[ \t]*[@(])/i,
        number: /(?:\b\d+(?:\.\d*)?|\B\.\d+)(?:e[+-]?\d+)?l?/i,
        operator: /-[-=>]?|\+[+=]?|<[<=]?|[>=*!]=?|&&|\|\||[?\/%^@|]/,
        punctuation: /[()[\]{},;.:]/,
        builtin: /\b(?:Byte|any|bool|char|double|enum|float|int|length|long|ranges|regex|string|undefined|void)\b/
    });
    Prism.languages.insertBefore('jolie', 'keyword', {
        aggregates: {
            pattern: /(\bAggregates\s*:\s*)(?:\w+(?:\s+with\s+\w+)?\s*,\s*)*\w+(?:\s+with\s+\w+)?/,
            lookbehind: true,
            inside: {
                keyword: /\bwith\b/,
                'class-name': /\w+/,
                punctuation: /,/
            }
        },
        redirects: {
            pattern: /(\bRedirects\s*:\s*)(?:\w+\s*=>\s*\w+\s*,\s*)*(?:\w+\s*=>\s*\w+)/,
            lookbehind: true,
            inside: {
                punctuation: /,/,
                'class-name': /\w+/,
                operator: /=>/
            }
        },
        property: {
            pattern: /\b(?:Aggregates|[Ii]nterfaces|Java|Javascript|Jolie|[Ll]ocation|OneWay|[Pp]rotocol|Redirects|RequestResponse)\b(?=[ \t]*:)/
        }
    });
}

});

parcelRegister("cHYNj", function(module, exports) {
'use strict';
module.exports = $9408a8b20e3153e8$var$jq;
$9408a8b20e3153e8$var$jq.displayName = 'jq';
$9408a8b20e3153e8$var$jq.aliases = [];
function $9408a8b20e3153e8$var$jq(Prism) {
    (function(Prism) {
        var interpolation = /\\\((?:[^()]|\([^()]*\))*\)/.source;
        var string = RegExp(/(^|[^\\])"(?:[^"\r\n\\]|\\[^\r\n(]|__)*"/.source.replace(/__/g, function() {
            return interpolation;
        }));
        var stringInterpolation = {
            interpolation: {
                pattern: RegExp(/((?:^|[^\\])(?:\\{2})*)/.source + interpolation),
                lookbehind: true,
                inside: {
                    content: {
                        pattern: /^(\\\()[\s\S]+(?=\)$)/,
                        lookbehind: true,
                        inside: null // see below
                    },
                    punctuation: /^\\\(|\)$/
                }
            }
        };
        var jq = Prism.languages.jq = {
            comment: /#.*/,
            property: {
                pattern: RegExp(string.source + /(?=\s*:(?!:))/.source),
                lookbehind: true,
                greedy: true,
                inside: stringInterpolation
            },
            string: {
                pattern: string,
                lookbehind: true,
                greedy: true,
                inside: stringInterpolation
            },
            function: {
                pattern: /(\bdef\s+)[a-z_]\w+/i,
                lookbehind: true
            },
            variable: /\B\$\w+/,
            'property-literal': {
                pattern: /\b[a-z_]\w*(?=\s*:(?!:))/i,
                alias: 'property'
            },
            keyword: /\b(?:as|break|catch|def|elif|else|end|foreach|if|import|include|label|module|modulemeta|null|reduce|then|try|while)\b/,
            boolean: /\b(?:false|true)\b/,
            number: /(?:\b\d+\.|\B\.)?\b\d+(?:[eE][+-]?\d+)?\b/,
            operator: [
                {
                    pattern: /\|=?/,
                    alias: 'pipe'
                },
                /\.\.|[!=<>]?=|\?\/\/|\/\/=?|[-+*/%]=?|[<>?]|\b(?:and|not|or)\b/
            ],
            'c-style-function': {
                pattern: /\b[a-z_]\w*(?=\s*\()/i,
                alias: 'function'
            },
            punctuation: /::|[()\[\]{},:;]|\.(?=\s*[\[\w$])/,
            dot: {
                pattern: /\./,
                alias: 'important'
            }
        };
        stringInterpolation.interpolation.inside.content.inside = jq;
    })(Prism);
}

});

parcelRegister("gZAtn", function(module, exports) {
'use strict';
module.exports = $c5eea29ad7be3482$var$jsExtras;
$c5eea29ad7be3482$var$jsExtras.displayName = 'jsExtras';
$c5eea29ad7be3482$var$jsExtras.aliases = [];
function $c5eea29ad7be3482$var$jsExtras(Prism) {
    (function(Prism) {
        Prism.languages.insertBefore('javascript', 'function-variable', {
            'method-variable': {
                pattern: RegExp('(\\.\\s*)' + Prism.languages.javascript['function-variable'].pattern.source),
                lookbehind: true,
                alias: [
                    'function-variable',
                    'method',
                    'function',
                    'property-access'
                ]
            }
        });
        Prism.languages.insertBefore('javascript', 'function', {
            method: {
                pattern: RegExp('(\\.\\s*)' + Prism.languages.javascript['function'].source),
                lookbehind: true,
                alias: [
                    'function',
                    'property-access'
                ]
            }
        });
        Prism.languages.insertBefore('javascript', 'constant', {
            'known-class-name': [
                {
                    // standard built-ins
                    // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects
                    pattern: /\b(?:(?:Float(?:32|64)|(?:Int|Uint)(?:8|16|32)|Uint8Clamped)?Array|ArrayBuffer|BigInt|Boolean|DataView|Date|Error|Function|Intl|JSON|(?:Weak)?(?:Map|Set)|Math|Number|Object|Promise|Proxy|Reflect|RegExp|String|Symbol|WebAssembly)\b/,
                    alias: 'class-name'
                },
                {
                    // errors
                    pattern: /\b(?:[A-Z]\w*)Error\b/,
                    alias: 'class-name'
                }
            ]
        });
        /**
     * Replaces the `<ID>` placeholder in the given pattern with a pattern for general JS identifiers.
     *
     * @param {string} source
     * @param {string} [flags]
     * @returns {RegExp}
     */ function withId(source, flags) {
            return RegExp(source.replace(/<ID>/g, function() {
                return /(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*/.source;
            }), flags);
        }
        Prism.languages.insertBefore('javascript', 'keyword', {
            imports: {
                // https://tc39.es/ecma262/#sec-imports
                pattern: withId(/(\bimport\b\s*)(?:<ID>(?:\s*,\s*(?:\*\s*as\s+<ID>|\{[^{}]*\}))?|\*\s*as\s+<ID>|\{[^{}]*\})(?=\s*\bfrom\b)/.source),
                lookbehind: true,
                inside: Prism.languages.javascript
            },
            exports: {
                // https://tc39.es/ecma262/#sec-exports
                pattern: withId(/(\bexport\b\s*)(?:\*(?:\s*as\s+<ID>)?(?=\s*\bfrom\b)|\{[^{}]*\})/.source),
                lookbehind: true,
                inside: Prism.languages.javascript
            }
        });
        Prism.languages.javascript['keyword'].unshift({
            pattern: /\b(?:as|default|export|from|import)\b/,
            alias: 'module'
        }, {
            pattern: /\b(?:await|break|catch|continue|do|else|finally|for|if|return|switch|throw|try|while|yield)\b/,
            alias: 'control-flow'
        }, {
            pattern: /\bnull\b/,
            alias: [
                'null',
                'nil'
            ]
        }, {
            pattern: /\bundefined\b/,
            alias: 'nil'
        });
        Prism.languages.insertBefore('javascript', 'operator', {
            spread: {
                pattern: /\.{3}/,
                alias: 'operator'
            },
            arrow: {
                pattern: /=>/,
                alias: 'operator'
            }
        });
        Prism.languages.insertBefore('javascript', 'punctuation', {
            'property-access': {
                pattern: withId(/(\.\s*)#?<ID>/.source),
                lookbehind: true
            },
            'maybe-class-name': {
                pattern: /(^|[^$\w\xA0-\uFFFF])[A-Z][$\w\xA0-\uFFFF]+/,
                lookbehind: true
            },
            dom: {
                // this contains only a few commonly used DOM variables
                pattern: /\b(?:document|(?:local|session)Storage|location|navigator|performance|window)\b/,
                alias: 'variable'
            },
            console: {
                pattern: /\bconsole(?=\s*\.)/,
                alias: 'class-name'
            }
        }) // add 'maybe-class-name' to tokens which might be a class name
        ;
        var maybeClassNameTokens = [
            'function',
            'function-variable',
            'method',
            'method-variable',
            'property-access'
        ];
        for(var i = 0; i < maybeClassNameTokens.length; i++){
            var token = maybeClassNameTokens[i];
            var value = Prism.languages.javascript[token] // convert regex to object
            ;
            if (Prism.util.type(value) === 'RegExp') value = Prism.languages.javascript[token] = {
                pattern: value
            };
             // keep in mind that we don't support arrays
            var inside = value.inside || {};
            value.inside = inside;
            inside['maybe-class-name'] = /^[A-Z][\s\S]*/;
        }
    })(Prism);
}

});

parcelRegister("btSLt", function(module, exports) {
'use strict';
module.exports = $85bce2472a5926a5$var$jsTemplates;
$85bce2472a5926a5$var$jsTemplates.displayName = 'jsTemplates';
$85bce2472a5926a5$var$jsTemplates.aliases = [];
function $85bce2472a5926a5$var$jsTemplates(Prism) {
    (function(Prism) {
        var templateString = Prism.languages.javascript['template-string'] // see the pattern in prism-javascript.js
        ;
        var templateLiteralPattern = templateString.pattern.source;
        var interpolationObject = templateString.inside['interpolation'];
        var interpolationPunctuationObject = interpolationObject.inside['interpolation-punctuation'];
        var interpolationPattern = interpolationObject.pattern.source;
        /**
     * Creates a new pattern to match a template string with a special tag.
     *
     * This will return `undefined` if there is no grammar with the given language id.
     *
     * @param {string} language The language id of the embedded language. E.g. `markdown`.
     * @param {string} tag The regex pattern to match the tag.
     * @returns {object | undefined}
     * @example
     * createTemplate('css', /\bcss/.source);
     */ function createTemplate(language, tag) {
            if (!Prism.languages[language]) return undefined;
            return {
                pattern: RegExp('((?:' + tag + ')\\s*)' + templateLiteralPattern),
                lookbehind: true,
                greedy: true,
                inside: {
                    'template-punctuation': {
                        pattern: /^`|`$/,
                        alias: 'string'
                    },
                    'embedded-code': {
                        pattern: /[\s\S]+/,
                        alias: language
                    }
                }
            };
        }
        Prism.languages.javascript['template-string'] = [
            // styled-jsx:
            //   css`a { color: #25F; }`
            // styled-components:
            //   styled.h1`color: red;`
            createTemplate('css', /\b(?:styled(?:\([^)]*\))?(?:\s*\.\s*\w+(?:\([^)]*\))*)*|css(?:\s*\.\s*(?:global|resolve))?|createGlobalStyle|keyframes)/.source),
            // div.innerHTML = `<p></p>`
            createTemplate('html', /\bhtml|\.\s*(?:inner|outer)HTML\s*\+?=/.source),
            createTemplate('svg', /\bsvg/.source),
            createTemplate('markdown', /\b(?:markdown|md)/.source),
            createTemplate('graphql', /\b(?:gql|graphql(?:\s*\.\s*experimental)?)/.source),
            createTemplate('sql', /\bsql/.source),
            templateString
        ].filter(Boolean);
        /**
     * Returns a specific placeholder literal for the given language.
     *
     * @param {number} counter
     * @param {string} language
     * @returns {string}
     */ function getPlaceholder(counter, language) {
            return '___' + language.toUpperCase() + '_' + counter + '___';
        }
        /**
     * Returns the tokens of `Prism.tokenize` but also runs the `before-tokenize` and `after-tokenize` hooks.
     *
     * @param {string} code
     * @param {any} grammar
     * @param {string} language
     * @returns {(string|Token)[]}
     */ function tokenizeWithHooks(code, grammar, language) {
            var env = {
                code: code,
                grammar: grammar,
                language: language
            };
            Prism.hooks.run('before-tokenize', env);
            env.tokens = Prism.tokenize(env.code, env.grammar);
            Prism.hooks.run('after-tokenize', env);
            return env.tokens;
        }
        /**
     * Returns the token of the given JavaScript interpolation expression.
     *
     * @param {string} expression The code of the expression. E.g. `"${42}"`
     * @returns {Token}
     */ function tokenizeInterpolationExpression(expression) {
            var tempGrammar = {};
            tempGrammar['interpolation-punctuation'] = interpolationPunctuationObject;
            /** @type {Array} */ var tokens = Prism.tokenize(expression, tempGrammar);
            if (tokens.length === 3) {
                /**
         * The token array will look like this
         * [
         *     ["interpolation-punctuation", "${"]
         *     "..." // JavaScript expression of the interpolation
         *     ["interpolation-punctuation", "}"]
         * ]
         */ var args = [
                    1,
                    1
                ];
                args.push.apply(args, tokenizeWithHooks(tokens[1], Prism.languages.javascript, 'javascript'));
                tokens.splice.apply(tokens, args);
            }
            return new Prism.Token('interpolation', tokens, interpolationObject.alias, expression);
        }
        /**
     * Tokenizes the given code with support for JavaScript interpolation expressions mixed in.
     *
     * This function has 3 phases:
     *
     * 1. Replace all JavaScript interpolation expression with a placeholder.
     *    The placeholder will have the syntax of a identify of the target language.
     * 2. Tokenize the code with placeholders.
     * 3. Tokenize the interpolation expressions and re-insert them into the tokenize code.
     *    The insertion only works if a placeholder hasn't been "ripped apart" meaning that the placeholder has been
     *    tokenized as two tokens by the grammar of the embedded language.
     *
     * @param {string} code
     * @param {object} grammar
     * @param {string} language
     * @returns {Token}
     */ function tokenizeEmbedded(code, grammar, language) {
            // 1. First filter out all interpolations
            // because they might be escaped, we need a lookbehind, so we use Prism
            /** @type {(Token|string)[]} */ var _tokens = Prism.tokenize(code, {
                interpolation: {
                    pattern: RegExp(interpolationPattern),
                    lookbehind: true
                }
            }) // replace all interpolations with a placeholder which is not in the code already
            ;
            var placeholderCounter = 0;
            /** @type {Object<string, string>} */ var placeholderMap = {};
            var embeddedCode = _tokens.map(function(token) {
                if (typeof token === 'string') return token;
                else {
                    var interpolationExpression = token.content;
                    var placeholder;
                    while(code.indexOf(placeholder = getPlaceholder(placeholderCounter++, language)) !== -1);
                    placeholderMap[placeholder] = interpolationExpression;
                    return placeholder;
                }
            }).join('') // 2. Tokenize the embedded code
            ;
            var embeddedTokens = tokenizeWithHooks(embeddedCode, grammar, language) // 3. Re-insert the interpolation
            ;
            var placeholders = Object.keys(placeholderMap);
            placeholderCounter = 0;
            /**
       *
       * @param {(Token|string)[]} tokens
       * @returns {void}
       */ function walkTokens(tokens) {
                for(var i = 0; i < tokens.length; i++){
                    if (placeholderCounter >= placeholders.length) return;
                    var token = tokens[i];
                    if (typeof token === 'string' || typeof token.content === 'string') {
                        var placeholder = placeholders[placeholderCounter];
                        var s = typeof token === 'string' ? token : /** @type {string} */ token.content;
                        var index = s.indexOf(placeholder);
                        if (index !== -1) {
                            ++placeholderCounter;
                            var before = s.substring(0, index);
                            var middle = tokenizeInterpolationExpression(placeholderMap[placeholder]);
                            var after = s.substring(index + placeholder.length);
                            var replacement = [];
                            if (before) replacement.push(before);
                            replacement.push(middle);
                            if (after) {
                                var afterTokens = [
                                    after
                                ];
                                walkTokens(afterTokens);
                                replacement.push.apply(replacement, afterTokens);
                            }
                            if (typeof token === 'string') {
                                tokens.splice.apply(tokens, [
                                    i,
                                    1
                                ].concat(replacement));
                                i += replacement.length - 1;
                            } else token.content = replacement;
                        }
                    } else {
                        var content = token.content;
                        if (Array.isArray(content)) walkTokens(content);
                        else walkTokens([
                            content
                        ]);
                    }
                }
            }
            walkTokens(embeddedTokens);
            return new Prism.Token(language, embeddedTokens, 'language-' + language, code);
        }
        /**
     * The languages for which JS templating will handle tagged template literals.
     *
     * JS templating isn't active for only JavaScript but also related languages like TypeScript, JSX, and TSX.
     */ var supportedLanguages = {
            javascript: true,
            js: true,
            typescript: true,
            ts: true,
            jsx: true,
            tsx: true
        };
        Prism.hooks.add('after-tokenize', function(env) {
            if (!(env.language in supportedLanguages)) return;
            /**
       * Finds and tokenizes all template strings with an embedded languages.
       *
       * @param {(Token | string)[]} tokens
       * @returns {void}
       */ function findTemplateStrings(tokens) {
                for(var i = 0, l = tokens.length; i < l; i++){
                    var token = tokens[i];
                    if (typeof token === 'string') continue;
                    var content = token.content;
                    if (!Array.isArray(content)) {
                        if (typeof content !== 'string') findTemplateStrings([
                            content
                        ]);
                        continue;
                    }
                    if (token.type === 'template-string') {
                        /**
             * A JavaScript template-string token will look like this:
             *
             * ["template-string", [
             *     ["template-punctuation", "`"],
             *     (
             *         An array of "string" and "interpolation" tokens. This is the simple string case.
             *         or
             *         ["embedded-code", "..."] This is the token containing the embedded code.
             *                                  It also has an alias which is the language of the embedded code.
             *     ),
             *     ["template-punctuation", "`"]
             * ]]
             */ var embedded = content[1];
                        if (content.length === 3 && typeof embedded !== 'string' && embedded.type === 'embedded-code') {
                            // get string content
                            var code = stringContent(embedded);
                            var alias = embedded.alias;
                            var language = Array.isArray(alias) ? alias[0] : alias;
                            var grammar = Prism.languages[language];
                            if (!grammar) continue;
                            content[1] = tokenizeEmbedded(code, grammar, language);
                        }
                    } else findTemplateStrings(content);
                }
            }
            findTemplateStrings(env.tokens);
        });
        /**
     * Returns the string content of a token or token stream.
     *
     * @param {string | Token | (string | Token)[]} value
     * @returns {string}
     */ function stringContent(value) {
            if (typeof value === 'string') return value;
            else if (Array.isArray(value)) return value.map(stringContent).join('');
            else return stringContent(value.content);
        }
    })(Prism);
}

});

parcelRegister("i7ijD", function(module, exports) {
'use strict';

var $e9UW8 = parcelRequire("e9UW8");

var $cQami = parcelRequire("cQami");
module.exports = $d3071688ffd04a11$var$jsdoc;
$d3071688ffd04a11$var$jsdoc.displayName = 'jsdoc';
$d3071688ffd04a11$var$jsdoc.aliases = [];
function $d3071688ffd04a11$var$jsdoc(Prism) {
    Prism.register($e9UW8);
    Prism.register($cQami);
    (function(Prism) {
        var javascript = Prism.languages.javascript;
        var type = /\{(?:[^{}]|\{(?:[^{}]|\{[^{}]*\})*\})+\}/.source;
        var parameterPrefix = '(@(?:arg|argument|param|property)\\s+(?:' + type + '\\s+)?)';
        Prism.languages.jsdoc = Prism.languages.extend('javadoclike', {
            parameter: {
                // @param {string} foo - foo bar
                pattern: RegExp(parameterPrefix + /(?:(?!\s)[$\w\xA0-\uFFFF.])+(?=\s|$)/.source),
                lookbehind: true,
                inside: {
                    punctuation: /\./
                }
            }
        });
        Prism.languages.insertBefore('jsdoc', 'keyword', {
            'optional-parameter': {
                // @param {string} [baz.foo="bar"] foo bar
                pattern: RegExp(parameterPrefix + /\[(?:(?!\s)[$\w\xA0-\uFFFF.])+(?:=[^[\]]+)?\](?=\s|$)/.source),
                lookbehind: true,
                inside: {
                    parameter: {
                        pattern: /(^\[)[$\w\xA0-\uFFFF\.]+/,
                        lookbehind: true,
                        inside: {
                            punctuation: /\./
                        }
                    },
                    code: {
                        pattern: /(=)[\s\S]*(?=\]$)/,
                        lookbehind: true,
                        inside: javascript,
                        alias: 'language-javascript'
                    },
                    punctuation: /[=[\]]/
                }
            },
            'class-name': [
                {
                    pattern: RegExp(/(@(?:augments|class|extends|interface|memberof!?|template|this|typedef)\s+(?:<TYPE>\s+)?)[A-Z]\w*(?:\.[A-Z]\w*)*/.source.replace(/<TYPE>/g, function() {
                        return type;
                    })),
                    lookbehind: true,
                    inside: {
                        punctuation: /\./
                    }
                },
                {
                    pattern: RegExp('(@[a-z]+\\s+)' + type),
                    lookbehind: true,
                    inside: {
                        string: javascript.string,
                        number: javascript.number,
                        boolean: javascript.boolean,
                        keyword: Prism.languages.typescript.keyword,
                        operator: /=>|\.\.\.|[&|?:*]/,
                        punctuation: /[.,;=<>{}()[\]]/
                    }
                }
            ],
            example: {
                pattern: /(@example\s+(?!\s))(?:[^@\s]|\s+(?!\s))+?(?=\s*(?:\*\s*)?(?:@\w|\*\/))/,
                lookbehind: true,
                inside: {
                    code: {
                        pattern: /^([\t ]*(?:\*\s*)?)\S.*$/m,
                        lookbehind: true,
                        inside: javascript,
                        alias: 'language-javascript'
                    }
                }
            }
        });
        Prism.languages.javadoclike.addSupport('javascript', Prism.languages.jsdoc);
    })(Prism);
}

});
parcelRegister("cQami", function(module, exports) {
'use strict';
module.exports = $959260597dd6ccce$var$typescript;
$959260597dd6ccce$var$typescript.displayName = 'typescript';
$959260597dd6ccce$var$typescript.aliases = [
    'ts'
];
function $959260597dd6ccce$var$typescript(Prism) {
    (function(Prism) {
        Prism.languages.typescript = Prism.languages.extend('javascript', {
            'class-name': {
                pattern: /(\b(?:class|extends|implements|instanceof|interface|new|type)\s+)(?!keyof\b)(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*(?:\s*<(?:[^<>]|<(?:[^<>]|<[^<>]*>)*>)*>)?/,
                lookbehind: true,
                greedy: true,
                inside: null // see below
            },
            builtin: /\b(?:Array|Function|Promise|any|boolean|console|never|number|string|symbol|unknown)\b/
        }) // The keywords TypeScript adds to JavaScript
        ;
        Prism.languages.typescript.keyword.push(/\b(?:abstract|declare|is|keyof|readonly|require)\b/, /\b(?:asserts|infer|interface|module|namespace|type)\b(?=\s*(?:[{_$a-zA-Z\xA0-\uFFFF]|$))/, /\btype\b(?=\s*(?:[\{*]|$))/) // doesn't work with TS because TS is too complex
        ;
        delete Prism.languages.typescript['parameter'];
        delete Prism.languages.typescript['literal-property'] // a version of typescript specifically for highlighting types
        ;
        var typeInside = Prism.languages.extend('typescript', {});
        delete typeInside['class-name'];
        Prism.languages.typescript['class-name'].inside = typeInside;
        Prism.languages.insertBefore('typescript', 'function', {
            decorator: {
                pattern: /@[$\w\xA0-\uFFFF]+/,
                inside: {
                    at: {
                        pattern: /^@/,
                        alias: 'operator'
                    },
                    function: /^[\s\S]+/
                }
            },
            'generic-function': {
                // e.g. foo<T extends "bar" | "baz">( ...
                pattern: /#?(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*\s*<(?:[^<>]|<(?:[^<>]|<[^<>]*>)*>)*>(?=\s*\()/,
                greedy: true,
                inside: {
                    function: /^#?(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*/,
                    generic: {
                        pattern: /<[\s\S]+/,
                        // everything after the first <
                        alias: 'class-name',
                        inside: typeInside
                    }
                }
            }
        });
        Prism.languages.ts = Prism.languages.typescript;
    })(Prism);
}

});


parcelRegister("ehQbF", function(module, exports) {
'use strict';
module.exports = $a66b227fa3b30f3a$var$json;
$a66b227fa3b30f3a$var$json.displayName = 'json';
$a66b227fa3b30f3a$var$json.aliases = [
    'webmanifest'
];
function $a66b227fa3b30f3a$var$json(Prism) {
    // https://www.json.org/json-en.html
    Prism.languages.json = {
        property: {
            pattern: /(^|[^\\])"(?:\\.|[^\\"\r\n])*"(?=\s*:)/,
            lookbehind: true,
            greedy: true
        },
        string: {
            pattern: /(^|[^\\])"(?:\\.|[^\\"\r\n])*"(?!\s*:)/,
            lookbehind: true,
            greedy: true
        },
        comment: {
            pattern: /\/\/.*|\/\*[\s\S]*?(?:\*\/|$)/,
            greedy: true
        },
        number: /-?\b\d+(?:\.\d+)?(?:e[+-]?\d+)?\b/i,
        punctuation: /[{}[\],]/,
        operator: /:/,
        boolean: /\b(?:false|true)\b/,
        null: {
            pattern: /\bnull\b/,
            alias: 'keyword'
        }
    };
    Prism.languages.webmanifest = Prism.languages.json;
}

});

parcelRegister("2S1bt", function(module, exports) {
'use strict';

var $ehQbF = parcelRequire("ehQbF");
module.exports = $21718b10b0432e1c$var$json5;
$21718b10b0432e1c$var$json5.displayName = 'json5';
$21718b10b0432e1c$var$json5.aliases = [];
function $21718b10b0432e1c$var$json5(Prism) {
    Prism.register($ehQbF);
    (function(Prism) {
        var string = /("|')(?:\\(?:\r\n?|\n|.)|(?!\1)[^\\\r\n])*\1/;
        Prism.languages.json5 = Prism.languages.extend('json', {
            property: [
                {
                    pattern: RegExp(string.source + '(?=\\s*:)'),
                    greedy: true
                },
                {
                    pattern: /(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*(?=\s*:)/,
                    alias: 'unquoted'
                }
            ],
            string: {
                pattern: string,
                greedy: true
            },
            number: /[+-]?\b(?:NaN|Infinity|0x[a-fA-F\d]+)\b|[+-]?(?:\b\d+(?:\.\d*)?|\B\.\d+)(?:[eE][+-]?\d+\b)?/
        });
    })(Prism);
}

});

parcelRegister("dEFCJ", function(module, exports) {
'use strict';

var $ehQbF = parcelRequire("ehQbF");
module.exports = $9f0f4c68be19e828$var$jsonp;
$9f0f4c68be19e828$var$jsonp.displayName = 'jsonp';
$9f0f4c68be19e828$var$jsonp.aliases = [];
function $9f0f4c68be19e828$var$jsonp(Prism) {
    Prism.register($ehQbF);
    Prism.languages.jsonp = Prism.languages.extend('json', {
        punctuation: /[{}[\]();,.]/
    });
    Prism.languages.insertBefore('jsonp', 'punctuation', {
        function: /(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*(?=\s*\()/
    });
}

});

parcelRegister("a4w6O", function(module, exports) {
'use strict';
module.exports = $75532f42ff3a5de3$var$jsstacktrace;
$75532f42ff3a5de3$var$jsstacktrace.displayName = 'jsstacktrace';
$75532f42ff3a5de3$var$jsstacktrace.aliases = [];
function $75532f42ff3a5de3$var$jsstacktrace(Prism) {
    Prism.languages.jsstacktrace = {
        'error-message': {
            pattern: /^\S.*/m,
            alias: 'string'
        },
        'stack-frame': {
            pattern: /(^[ \t]+)at[ \t].*/m,
            lookbehind: true,
            inside: {
                'not-my-code': {
                    pattern: /^at[ \t]+(?!\s)(?:node\.js|<unknown>|.*(?:node_modules|\(<anonymous>\)|\(<unknown>|<anonymous>$|\(internal\/|\(node\.js)).*/m,
                    alias: 'comment'
                },
                filename: {
                    pattern: /(\bat\s+(?!\s)|\()(?:[a-zA-Z]:)?[^():]+(?=:)/,
                    lookbehind: true,
                    alias: 'url'
                },
                function: {
                    pattern: /(\bat\s+(?:new\s+)?)(?!\s)[_$a-zA-Z\xA0-\uFFFF<][.$\w\xA0-\uFFFF<>]*/,
                    lookbehind: true,
                    inside: {
                        punctuation: /\./
                    }
                },
                punctuation: /[()]/,
                keyword: /\b(?:at|new)\b/,
                alias: {
                    pattern: /\[(?:as\s+)?(?!\s)[_$a-zA-Z\xA0-\uFFFF][$\w\xA0-\uFFFF]*\]/,
                    alias: 'variable'
                },
                'line-number': {
                    pattern: /:\d+(?::\d+)?\b/,
                    alias: 'number',
                    inside: {
                        punctuation: /:/
                    }
                }
            }
        }
    };
}

});

parcelRegister("jYji4", function(module, exports) {
'use strict';
module.exports = $e8a29597d08b2ff0$var$jsx;
$e8a29597d08b2ff0$var$jsx.displayName = 'jsx';
$e8a29597d08b2ff0$var$jsx.aliases = [];
function $e8a29597d08b2ff0$var$jsx(Prism) {
    (function(Prism) {
        var javascript = Prism.util.clone(Prism.languages.javascript);
        var space = /(?:\s|\/\/.*(?!.)|\/\*(?:[^*]|\*(?!\/))\*\/)/.source;
        var braces = /(?:\{(?:\{(?:\{[^{}]*\}|[^{}])*\}|[^{}])*\})/.source;
        var spread = /(?:\{<S>*\.{3}(?:[^{}]|<BRACES>)*\})/.source;
        /**
     * @param {string} source
     * @param {string} [flags]
     */ function re(source, flags) {
            source = source.replace(/<S>/g, function() {
                return space;
            }).replace(/<BRACES>/g, function() {
                return braces;
            }).replace(/<SPREAD>/g, function() {
                return spread;
            });
            return RegExp(source, flags);
        }
        spread = re(spread).source;
        Prism.languages.jsx = Prism.languages.extend('markup', javascript);
        Prism.languages.jsx.tag.pattern = re(/<\/?(?:[\w.:-]+(?:<S>+(?:[\w.:$-]+(?:=(?:"(?:\\[\s\S]|[^\\"])*"|'(?:\\[\s\S]|[^\\'])*'|[^\s{'"/>=]+|<BRACES>))?|<SPREAD>))*<S>*\/?)?>/.source);
        Prism.languages.jsx.tag.inside['tag'].pattern = /^<\/?[^\s>\/]*/;
        Prism.languages.jsx.tag.inside['attr-value'].pattern = /=(?!\{)(?:"(?:\\[\s\S]|[^\\"])*"|'(?:\\[\s\S]|[^\\'])*'|[^\s'">]+)/;
        Prism.languages.jsx.tag.inside['tag'].inside['class-name'] = /^[A-Z]\w*(?:\.[A-Z]\w*)*$/;
        Prism.languages.jsx.tag.inside['comment'] = javascript['comment'];
        Prism.languages.insertBefore('inside', 'attr-name', {
            spread: {
                pattern: re(/<SPREAD>/.source),
                inside: Prism.languages.jsx
            }
        }, Prism.languages.jsx.tag);
        Prism.languages.insertBefore('inside', 'special-attr', {
            script: {
                // Allow for two levels of nesting
                pattern: re(/=<BRACES>/.source),
                alias: 'language-javascript',
                inside: {
                    'script-punctuation': {
                        pattern: /^=(?=\{)/,
                        alias: 'punctuation'
                    },
                    rest: Prism.languages.jsx
                }
            }
        }, Prism.languages.jsx.tag) // The following will handle plain text inside tags
        ;
        var stringifyToken = function(token) {
            if (!token) return '';
            if (typeof token === 'string') return token;
            if (typeof token.content === 'string') return token.content;
            return token.content.map(stringifyToken).join('');
        };
        var walkTokens = function(tokens) {
            var openedTags = [];
            for(var i = 0; i < tokens.length; i++){
                var token = tokens[i];
                var notTagNorBrace = false;
                if (typeof token !== 'string') {
                    if (token.type === 'tag' && token.content[0] && token.content[0].type === 'tag') {
                        // We found a tag, now find its kind
                        if (token.content[0].content[0].content === '</') // Closing tag
                        {
                            if (openedTags.length > 0 && openedTags[openedTags.length - 1].tagName === stringifyToken(token.content[0].content[1])) // Pop matching opening tag
                            openedTags.pop();
                        } else {
                            if (token.content[token.content.length - 1].content === '/>') ;
                            else // Opening tag
                            openedTags.push({
                                tagName: stringifyToken(token.content[0].content[1]),
                                openedBraces: 0
                            });
                        }
                    } else if (openedTags.length > 0 && token.type === 'punctuation' && token.content === '{') // Here we might have entered a JSX context inside a tag
                    openedTags[openedTags.length - 1].openedBraces++;
                    else if (openedTags.length > 0 && openedTags[openedTags.length - 1].openedBraces > 0 && token.type === 'punctuation' && token.content === '}') // Here we might have left a JSX context inside a tag
                    openedTags[openedTags.length - 1].openedBraces--;
                    else notTagNorBrace = true;
                }
                if (notTagNorBrace || typeof token === 'string') {
                    if (openedTags.length > 0 && openedTags[openedTags.length - 1].openedBraces === 0) {
                        // Here we are inside a tag, and not inside a JSX context.
                        // That's plain text: drop any tokens matched.
                        var plainText = stringifyToken(token) // And merge text with adjacent text
                        ;
                        if (i < tokens.length - 1 && (typeof tokens[i + 1] === 'string' || tokens[i + 1].type === 'plain-text')) {
                            plainText += stringifyToken(tokens[i + 1]);
                            tokens.splice(i + 1, 1);
                        }
                        if (i > 0 && (typeof tokens[i - 1] === 'string' || tokens[i - 1].type === 'plain-text')) {
                            plainText = stringifyToken(tokens[i - 1]) + plainText;
                            tokens.splice(i - 1, 1);
                            i--;
                        }
                        tokens[i] = new Prism.Token('plain-text', plainText, null, plainText);
                    }
                }
                if (token.content && typeof token.content !== 'string') walkTokens(token.content);
            }
        };
        Prism.hooks.add('after-tokenize', function(env) {
            if (env.language !== 'jsx' && env.language !== 'tsx') return;
            walkTokens(env.tokens);
        });
    })(Prism);
}

});

parcelRegister("gmKNx", function(module, exports) {
'use strict';
module.exports = $bea3008c9bdf7c92$var$julia;
$bea3008c9bdf7c92$var$julia.displayName = 'julia';
$bea3008c9bdf7c92$var$julia.aliases = [];
function $bea3008c9bdf7c92$var$julia(Prism) {
    Prism.languages.julia = {
        comment: {
            // support one level of nested comments
            // https://github.com/JuliaLang/julia/pull/6128
            pattern: /(^|[^\\])(?:#=(?:[^#=]|=(?!#)|#(?!=)|#=(?:[^#=]|=(?!#)|#(?!=))*=#)*=#|#.*)/,
            lookbehind: true
        },
        regex: {
            // https://docs.julialang.org/en/v1/manual/strings/#Regular-Expressions-1
            pattern: /r"(?:\\.|[^"\\\r\n])*"[imsx]{0,4}/,
            greedy: true
        },
        string: {
            // https://docs.julialang.org/en/v1/manual/strings/#String-Basics-1
            // https://docs.julialang.org/en/v1/manual/strings/#non-standard-string-literals-1
            // https://docs.julialang.org/en/v1/manual/running-external-programs/#Running-External-Programs-1
            pattern: /"""[\s\S]+?"""|(?:\b\w+)?"(?:\\.|[^"\\\r\n])*"|`(?:[^\\`\r\n]|\\.)*`/,
            greedy: true
        },
        char: {
            // https://docs.julialang.org/en/v1/manual/strings/#man-characters-1
            pattern: /(^|[^\w'])'(?:\\[^\r\n][^'\r\n]*|[^\\\r\n])'/,
            lookbehind: true,
            greedy: true
        },
        keyword: /\b(?:abstract|baremodule|begin|bitstype|break|catch|ccall|const|continue|do|else|elseif|end|export|finally|for|function|global|if|immutable|import|importall|in|let|local|macro|module|print|println|quote|return|struct|try|type|typealias|using|while)\b/,
        boolean: /\b(?:false|true)\b/,
        number: /(?:\b(?=\d)|\B(?=\.))(?:0[box])?(?:[\da-f]+(?:_[\da-f]+)*(?:\.(?:\d+(?:_\d+)*)?)?|\.\d+(?:_\d+)*)(?:[efp][+-]?\d+(?:_\d+)*)?j?/i,
        // https://docs.julialang.org/en/v1/manual/mathematical-operations/
        // https://docs.julialang.org/en/v1/manual/mathematical-operations/#Operator-Precedence-and-Associativity-1
        operator: /&&|\|\||[-+*^%÷⊻&$\\]=?|\/[\/=]?|!=?=?|\|[=>]?|<(?:<=?|[=:|])?|>(?:=|>>?=?)?|==?=?|[~≠≤≥'√∛]/,
        punctuation: /::?|[{}[\]();,.?]/,
        // https://docs.julialang.org/en/v1/base/numbers/#Base.im
        constant: /\b(?:(?:Inf|NaN)(?:16|32|64)?|im|pi)\b|[πℯ]/
    };
}

});

parcelRegister("2XO4w", function(module, exports) {
'use strict';
module.exports = $2287eeadbe24bfe1$var$keepalived;
$2287eeadbe24bfe1$var$keepalived.displayName = 'keepalived';
$2287eeadbe24bfe1$var$keepalived.aliases = [];
function $2287eeadbe24bfe1$var$keepalived(Prism) {
    Prism.languages.keepalived = {
        comment: {
            pattern: /[#!].*/,
            greedy: true
        },
        string: {
            pattern: /(^|[^\\])(?:"(?:\\(?:\r\n|[\s\S])|[^"\\\r\n])*"|'(?:\\(?:\r\n|[\s\S])|[^'\\\r\n])*')/,
            lookbehind: true,
            greedy: true
        },
        // support IPv4, IPv6, subnet mask
        ip: {
            pattern: RegExp(/\b(?:(?:(?:[\da-f]{1,4}:){7}[\da-f]{1,4}|(?:[\da-f]{1,4}:){6}:[\da-f]{1,4}|(?:[\da-f]{1,4}:){5}:(?:[\da-f]{1,4}:)?[\da-f]{1,4}|(?:[\da-f]{1,4}:){4}:(?:[\da-f]{1,4}:){0,2}[\da-f]{1,4}|(?:[\da-f]{1,4}:){3}:(?:[\da-f]{1,4}:){0,3}[\da-f]{1,4}|(?:[\da-f]{1,4}:){2}:(?:[\da-f]{1,4}:){0,4}[\da-f]{1,4}|(?:[\da-f]{1,4}:){6}<ipv4>|(?:[\da-f]{1,4}:){0,5}:<ipv4>|::(?:[\da-f]{1,4}:){0,5}<ipv4>|[\da-f]{1,4}::(?:[\da-f]{1,4}:){0,5}[\da-f]{1,4}|::(?:[\da-f]{1,4}:){0,6}[\da-f]{1,4}|(?:[\da-f]{1,4}:){1,7}:)(?:\/\d{1,3})?|<ipv4>(?:\/\d{1,2})?)\b/.source.replace(/<ipv4>/g, function() {
                return /(?:(?:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]\d|\d)\.){3}(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]\d|\d))/.source;
            }), 'i'),
            alias: 'number'
        },
        // support *nix / Windows, directory / file
        path: {
            pattern: /(\s)\/(?:[^\/\s]+\/)*[^\/\s]*|\b[a-zA-Z]:\\(?:[^\\\s]+\\)*[^\\\s]*/,
            lookbehind: true,
            alias: 'string'
        },
        variable: /\$\{?\w+\}?/,
        email: {
            pattern: /[\w-]+@[\w-]+(?:\.[\w-]{2,3}){1,2}/,
            alias: 'string'
        },
        'conditional-configuration': {
            pattern: /@\^?[\w-]+/,
            alias: 'variable'
        },
        operator: /=/,
        property: /\b(?:BFD_CHECK|DNS_CHECK|FILE_CHECK|HTTP_GET|MISC_CHECK|NAME|PING_CHECK|SCRIPTS|SMTP_CHECK|SSL|SSL_GET|TCP_CHECK|UDP_CHECK|accept|advert_int|alpha|auth_pass|auth_type|authentication|bfd_cpu_affinity|bfd_instance|bfd_no_swap|bfd_priority|bfd_process_name|bfd_rlimit_rttime|bfd_rt_priority|bind_if|bind_port|bindto|ca|certificate|check_unicast_src|checker|checker_cpu_affinity|checker_log_all_failures|checker_no_swap|checker_priority|checker_rlimit_rttime|checker_rt_priority|child_wait_time|connect_ip|connect_port|connect_timeout|dbus_service_name|debug|default_interface|delay|delay_before_retry|delay_loop|digest|dont_track_primary|dynamic|dynamic_interfaces|enable_(?:dbus|script_security|sni|snmp_checker|snmp_rfc|snmp_rfcv2|snmp_rfcv3|snmp_vrrp|traps)|end|fall|fast_recovery|file|flag-[123]|fork_delay|full_command|fwmark|garp_group|garp_interval|garp_lower_prio_delay|garp_lower_prio_repeat|garp_master_delay|garp_master_refresh|garp_master_refresh_repeat|garp_master_repeat|global_defs|global_tracking|gna_interval|group|ha_suspend|hashed|helo_name|higher_prio_send_advert|hoplimit|http_protocol|hysteresis|idle_tx|include|inhibit_on_failure|init_fail|init_file|instance|interface|interfaces|interval|ip_family|ipvs_process_name|keepalived.conf|kernel_rx_buf_size|key|linkbeat_interfaces|linkbeat_use_polling|log_all_failures|log_unknown_vrids|lower_prio_no_advert|lthreshold|lvs_flush|lvs_flush_onstop|lvs_method|lvs_netlink_cmd_rcv_bufs|lvs_netlink_cmd_rcv_bufs_force|lvs_netlink_monitor_rcv_bufs|lvs_netlink_monitor_rcv_bufs_force|lvs_notify_fifo|lvs_notify_fifo_script|lvs_sched|lvs_sync_daemon|max_auto_priority|max_hops|mcast_src_ip|mh-fallback|mh-port|min_auto_priority_delay|min_rx|min_tx|misc_dynamic|misc_path|misc_timeout|multiplier|name|namespace_with_ipsets|native_ipv6|neighbor_ip|net_namespace|net_namespace_ipvs|nftables|nftables_counters|nftables_ifindex|nftables_priority|no_accept|no_checker_emails|no_email_faults|nopreempt|notification_email|notification_email_from|notify|notify_backup|notify_deleted|notify_down|notify_fault|notify_fifo|notify_fifo_script|notify_master|notify_master_rx_lower_pri|notify_priority_changes|notify_stop|notify_up|old_unicast_checksum|omega|ops|param_match|passive|password|path|persistence_engine|persistence_granularity|persistence_timeout|preempt|preempt_delay|priority|process|process_monitor_rcv_bufs|process_monitor_rcv_bufs_force|process_name|process_names|promote_secondaries|protocol|proxy_arp|proxy_arp_pvlan|quorum|quorum_down|quorum_max|quorum_up|random_seed|real_server|regex|regex_max_offset|regex_min_offset|regex_no_match|regex_options|regex_stack|reload_repeat|reload_time_file|require_reply|retry|rise|router_id|rs_init_notifies|script|script_user|sh-fallback|sh-port|shutdown_script|shutdown_script_timeout|skip_check_adv_addr|smtp_alert|smtp_alert_checker|smtp_alert_vrrp|smtp_connect_timeout|smtp_helo_name|smtp_server|snmp_socket|sorry_server|sorry_server_inhibit|sorry_server_lvs_method|source_ip|start|startup_script|startup_script_timeout|state|static_ipaddress|static_routes|static_rules|status_code|step|strict_mode|sync_group_tracking_weight|terminate_delay|timeout|track_bfd|track_file|track_group|track_interface|track_process|track_script|track_src_ip|ttl|type|umask|unicast_peer|unicast_src_ip|unicast_ttl|url|use_ipvlan|use_pid_dir|use_vmac|user|uthreshold|val[123]|version|virtual_ipaddress|virtual_ipaddress_excluded|virtual_router_id|virtual_routes|virtual_rules|virtual_server|virtual_server_group|virtualhost|vmac_xmit_base|vrrp|vrrp_(?:check_unicast_src|cpu_affinity|garp_interval|garp_lower_prio_delay|garp_lower_prio_repeat|garp_master_delay|garp_master_refresh|garp_master_refresh_repeat|garp_master_repeat|gna_interval|higher_prio_send_advert|instance|ipsets|iptables|lower_prio_no_advert|mcast_group4|mcast_group6|min_garp|netlink_cmd_rcv_bufs|netlink_cmd_rcv_bufs_force|netlink_monitor_rcv_bufs|netlink_monitor_rcv_bufs_force|no_swap|notify_fifo|notify_fifo_script|notify_priority_changes|priority|process_name|rlimit_rttime|rt_priority|rx_bufs_multiplier|rx_bufs_policy|script|skip_check_adv_addr|startup_delay|strict|sync_group|track_process|version)|warmup|weight)\b/,
        constant: /\b(?:A|AAAA|AH|BACKUP|CNAME|DR|MASTER|MX|NAT|NS|PASS|SCTP|SOA|TCP|TUN|TXT|UDP|dh|fo|lblc|lblcr|lc|mh|nq|ovf|rr|sed|sh|wlc|wrr)\b/,
        number: {
            pattern: /(^|[^\w.-])-?\d+(?:\.\d+)?/,
            lookbehind: true
        },
        boolean: /\b(?:false|no|off|on|true|yes)\b/,
        punctuation: /[\{\}]/
    };
}

});

parcelRegister("8Owu8", function(module, exports) {
'use strict';
module.exports = $66ac311af25d8d94$var$keyman;
$66ac311af25d8d94$var$keyman.displayName = 'keyman';
$66ac311af25d8d94$var$keyman.aliases = [];
function $66ac311af25d8d94$var$keyman(Prism) {
    Prism.languages.keyman = {
        comment: {
            pattern: /\bc .*/i,
            greedy: true
        },
        string: {
            pattern: /"[^"\r\n]*"|'[^'\r\n]*'/,
            greedy: true
        },
        'virtual-key': {
            pattern: /\[\s*(?:(?:ALT|CAPS|CTRL|LALT|LCTRL|NCAPS|RALT|RCTRL|SHIFT)\s+)*(?:[TKU]_[\w?]+|[A-E]\d\d?|"[^"\r\n]*"|'[^'\r\n]*')\s*\]/i,
            greedy: true,
            alias: 'function' // alias for styles
        },
        // https://help.keyman.com/developer/language/guide/headers
        'header-keyword': {
            pattern: /&\w+/,
            alias: 'bold' // alias for styles
        },
        'header-statement': {
            pattern: /\b(?:bitmap|bitmaps|caps always off|caps on only|copyright|hotkey|language|layout|message|name|shift frees caps|version)\b/i,
            alias: 'bold' // alias for styles
        },
        'rule-keyword': {
            pattern: /\b(?:any|baselayout|beep|call|context|deadkey|dk|if|index|layer|notany|nul|outs|platform|reset|return|save|set|store|use)\b/i,
            alias: 'keyword'
        },
        'structural-keyword': {
            pattern: /\b(?:ansi|begin|group|match|nomatch|unicode|using keys)\b/i,
            alias: 'keyword'
        },
        'compile-target': {
            pattern: /\$(?:keyman|keymanonly|keymanweb|kmfl|weaver):/i,
            alias: 'property'
        },
        // U+####, x###, d### characters and numbers
        number: /\b(?:U\+[\dA-F]+|d\d+|x[\da-f]+|\d+)\b/i,
        operator: /[+>\\$]|\.\./,
        punctuation: /[()=,]/
    };
}

});

parcelRegister("041AK", function(module, exports) {
'use strict';
module.exports = $00c19bf1df3976c2$var$kotlin;
$00c19bf1df3976c2$var$kotlin.displayName = 'kotlin';
$00c19bf1df3976c2$var$kotlin.aliases = [
    'kt',
    'kts'
];
function $00c19bf1df3976c2$var$kotlin(Prism) {
    (function(Prism) {
        Prism.languages.kotlin = Prism.languages.extend('clike', {
            keyword: {
                // The lookbehind prevents wrong highlighting of e.g. kotlin.properties.get
                pattern: /(^|[^.])\b(?:abstract|actual|annotation|as|break|by|catch|class|companion|const|constructor|continue|crossinline|data|do|dynamic|else|enum|expect|external|final|finally|for|fun|get|if|import|in|infix|init|inline|inner|interface|internal|is|lateinit|noinline|null|object|open|operator|out|override|package|private|protected|public|reified|return|sealed|set|super|suspend|tailrec|this|throw|to|try|typealias|val|var|vararg|when|where|while)\b/,
                lookbehind: true
            },
            function: [
                {
                    pattern: /(?:`[^\r\n`]+`|\b\w+)(?=\s*\()/,
                    greedy: true
                },
                {
                    pattern: /(\.)(?:`[^\r\n`]+`|\w+)(?=\s*\{)/,
                    lookbehind: true,
                    greedy: true
                }
            ],
            number: /\b(?:0[xX][\da-fA-F]+(?:_[\da-fA-F]+)*|0[bB][01]+(?:_[01]+)*|\d+(?:_\d+)*(?:\.\d+(?:_\d+)*)?(?:[eE][+-]?\d+(?:_\d+)*)?[fFL]?)\b/,
            operator: /\+[+=]?|-[-=>]?|==?=?|!(?:!|==?)?|[\/*%<>]=?|[?:]:?|\.\.|&&|\|\||\b(?:and|inv|or|shl|shr|ushr|xor)\b/
        });
        delete Prism.languages.kotlin['class-name'];
        var interpolationInside = {
            'interpolation-punctuation': {
                pattern: /^\$\{?|\}$/,
                alias: 'punctuation'
            },
            expression: {
                pattern: /[\s\S]+/,
                inside: Prism.languages.kotlin
            }
        };
        Prism.languages.insertBefore('kotlin', 'string', {
            // https://kotlinlang.org/spec/expressions.html#string-interpolation-expressions
            'string-literal': [
                {
                    pattern: /"""(?:[^$]|\$(?:(?!\{)|\{[^{}]*\}))*?"""/,
                    alias: 'multiline',
                    inside: {
                        interpolation: {
                            pattern: /\$(?:[a-z_]\w*|\{[^{}]*\})/i,
                            inside: interpolationInside
                        },
                        string: /[\s\S]+/
                    }
                },
                {
                    pattern: /"(?:[^"\\\r\n$]|\\.|\$(?:(?!\{)|\{[^{}]*\}))*"/,
                    alias: 'singleline',
                    inside: {
                        interpolation: {
                            pattern: /((?:^|[^\\])(?:\\{2})*)\$(?:[a-z_]\w*|\{[^{}]*\})/i,
                            lookbehind: true,
                            inside: interpolationInside
                        },
                        string: /[\s\S]+/
                    }
                }
            ],
            char: {
                // https://kotlinlang.org/spec/expressions.html#character-literals
                pattern: /'(?:[^'\\\r\n]|\\(?:.|u[a-fA-F0-9]{0,4}))'/,
                greedy: true
            }
        });
        delete Prism.languages.kotlin['string'];
        Prism.languages.insertBefore('kotlin', 'keyword', {
            annotation: {
                pattern: /\B@(?:\w+:)?(?:[A-Z]\w*|\[[^\]]+\])/,
                alias: 'builtin'
            }
        });
        Prism.languages.insertBefore('kotlin', 'function', {
            label: {
                pattern: /\b\w+@|@\w+\b/,
                alias: 'symbol'
            }
        });
        Prism.languages.kt = Prism.languages.kotlin;
        Prism.languages.kts = Prism.languages.kotlin;
    })(Prism);
}

});

parcelRegister("73T7k", function(module, exports) {
'use strict';
module.exports = $5243915c8fe2cf36$var$kumir;
$5243915c8fe2cf36$var$kumir.displayName = 'kumir';
$5243915c8fe2cf36$var$kumir.aliases = [
    'kum'
];
function $5243915c8fe2cf36$var$kumir(Prism) {
    (function(Prism) {
        /**
     * Regular expression for characters that are not allowed in identifiers.
     *
     * @type {string}
     */ var nonId = /\s\x00-\x1f\x22-\x2f\x3a-\x3f\x5b-\x5e\x60\x7b-\x7e/.source;
        /**
     * Surround a regular expression for IDs with patterns for non-ID sequences.
     *
     * @param {string} pattern A regular expression for identifiers.
     * @param {string} [flags] The regular expression flags.
     * @returns {RegExp} A wrapped regular expression for identifiers.
     */ function wrapId(pattern, flags) {
            return RegExp(pattern.replace(/<nonId>/g, nonId), flags);
        }
        Prism.languages.kumir = {
            comment: {
                pattern: /\|.*/
            },
            prolog: {
                pattern: /#.*/,
                greedy: true
            },
            string: {
                pattern: /"[^\n\r"]*"|'[^\n\r']*'/,
                greedy: true
            },
            boolean: {
                pattern: wrapId(/(^|[<nonId>])(?:да|нет)(?=[<nonId>]|$)/.source),
                lookbehind: true
            },
            'operator-word': {
                pattern: wrapId(/(^|[<nonId>])(?:и|или|не)(?=[<nonId>]|$)/.source),
                lookbehind: true,
                alias: 'keyword'
            },
            'system-variable': {
                pattern: wrapId(/(^|[<nonId>])знач(?=[<nonId>]|$)/.source),
                lookbehind: true,
                alias: 'keyword'
            },
            type: [
                {
                    pattern: wrapId(/(^|[<nonId>])(?:вещ|лит|лог|сим|цел)(?:\x20*таб)?(?=[<nonId>]|$)/.source),
                    lookbehind: true,
                    alias: 'builtin'
                },
                {
                    pattern: wrapId(/(^|[<nonId>])(?:компл|сканкод|файл|цвет)(?=[<nonId>]|$)/.source),
                    lookbehind: true,
                    alias: 'important'
                }
            ],
            /**
       * Should be performed after searching for type names because of "таб".
       * "таб" is a reserved word, but never used without a preceding type name.
       * "НАЗНАЧИТЬ", "Фввод", and "Фвывод" are not reserved words.
       */ keyword: {
                pattern: wrapId(/(^|[<nonId>])(?:алг|арг(?:\x20*рез)?|ввод|ВКЛЮЧИТЬ|вс[её]|выбор|вывод|выход|дано|для|до|дс|если|иначе|исп|использовать|кон(?:(?:\x20+|_)исп)?|кц(?:(?:\x20+|_)при)?|надо|нач|нс|нц|от|пауза|пока|при|раза?|рез|стоп|таб|то|утв|шаг)(?=[<nonId>]|$)/.source),
                lookbehind: true
            },
            /** Should be performed after searching for reserved words. */ name: {
                // eslint-disable-next-line regexp/no-super-linear-backtracking
                pattern: wrapId(/(^|[<nonId>])[^\d<nonId>][^<nonId>]*(?:\x20+[^<nonId>]+)*(?=[<nonId>]|$)/.source),
                lookbehind: true
            },
            /** Should be performed after searching for names. */ number: {
                pattern: wrapId(/(^|[<nonId>])(?:\B\$[\da-f]+\b|(?:\b\d+(?:\.\d*)?|\B\.\d+)(?:e[+-]?\d+)?)(?=[<nonId>]|$)/.source, 'i'),
                lookbehind: true
            },
            /** Should be performed after searching for words. */ punctuation: /:=|[(),:;\[\]]/,
            /**
       * Should be performed after searching for
       * - numeric constants (because of "+" and "-");
       * - punctuation marks (because of ":=" and "=").
       */ 'operator-char': {
                pattern: /\*\*?|<[=>]?|>=?|[-+/=]/,
                alias: 'operator'
            }
        };
        Prism.languages.kum = Prism.languages.kumir;
    })(Prism);
}

});

parcelRegister("lMzTm", function(module, exports) {
'use strict';
module.exports = $fdb9ec0eea750f97$var$kusto;
$fdb9ec0eea750f97$var$kusto.displayName = 'kusto';
$fdb9ec0eea750f97$var$kusto.aliases = [];
function $fdb9ec0eea750f97$var$kusto(Prism) {
    Prism.languages.kusto = {
        comment: {
            pattern: /\/\/.*/,
            greedy: true
        },
        string: {
            pattern: /```[\s\S]*?```|[hH]?(?:"(?:[^\r\n\\"]|\\.)*"|'(?:[^\r\n\\']|\\.)*'|@(?:"[^\r\n"]*"|'[^\r\n']*'))/,
            greedy: true
        },
        verb: {
            pattern: /(\|\s*)[a-z][\w-]*/i,
            lookbehind: true,
            alias: 'keyword'
        },
        command: {
            pattern: /\.[a-z][a-z\d-]*\b/,
            alias: 'keyword'
        },
        'class-name': /\b(?:bool|datetime|decimal|dynamic|guid|int|long|real|string|timespan)\b/,
        keyword: /\b(?:access|alias|and|anti|as|asc|auto|between|by|(?:contains|(?:ends|starts)with|has(?:perfix|suffix)?)(?:_cs)?|database|declare|desc|external|from|fullouter|has_all|in|ingestion|inline|inner|innerunique|into|(?:left|right)(?:anti(?:semi)?|inner|outer|semi)?|let|like|local|not|of|on|or|pattern|print|query_parameters|range|restrict|schema|set|step|table|tables|to|view|where|with|matches\s+regex|nulls\s+(?:first|last))(?![\w-])/,
        boolean: /\b(?:false|null|true)\b/,
        function: /\b[a-z_]\w*(?=\s*\()/,
        datetime: [
            {
                // RFC 822 + RFC 850
                pattern: /\b(?:(?:Fri|Friday|Mon|Monday|Sat|Saturday|Sun|Sunday|Thu|Thursday|Tue|Tuesday|Wed|Wednesday)\s*,\s*)?\d{1,2}(?:\s+|-)(?:Apr|Aug|Dec|Feb|Jan|Jul|Jun|Mar|May|Nov|Oct|Sep)(?:\s+|-)\d{2}\s+\d{2}:\d{2}(?::\d{2})?(?:\s*(?:\b(?:[A-Z]|(?:[ECMT][DS]|GM|U)T)|[+-]\d{4}))?\b/,
                alias: 'number'
            },
            {
                // ISO 8601
                pattern: /[+-]?\b(?:\d{4}-\d{2}-\d{2}(?:[ T]\d{2}:\d{2}(?::\d{2}(?:\.\d+)?)?)?|\d{2}:\d{2}(?::\d{2}(?:\.\d+)?)?)Z?/,
                alias: 'number'
            }
        ],
        number: /\b(?:0x[0-9A-Fa-f]+|\d+(?:\.\d+)?(?:[Ee][+-]?\d+)?)(?:(?:min|sec|[mnµ]s|[dhms]|microsecond|tick)\b)?|[+-]?\binf\b/,
        operator: /=>|[!=]~|[!=<>]=?|[-+*/%|]|\.\./,
        punctuation: /[()\[\]{},;.:]/
    };
}

});

parcelRegister("eEcQN", function(module, exports) {
'use strict';
module.exports = $aa9ec4fa15e06b85$var$latex;
$aa9ec4fa15e06b85$var$latex.displayName = 'latex';
$aa9ec4fa15e06b85$var$latex.aliases = [
    'tex',
    'context'
];
function $aa9ec4fa15e06b85$var$latex(Prism) {
    (function(Prism) {
        var funcPattern = /\\(?:[^a-z()[\]]|[a-z*]+)/i;
        var insideEqu = {
            'equation-command': {
                pattern: funcPattern,
                alias: 'regex'
            }
        };
        Prism.languages.latex = {
            comment: /%.*/,
            // the verbatim environment prints whitespace to the document
            cdata: {
                pattern: /(\\begin\{((?:lstlisting|verbatim)\*?)\})[\s\S]*?(?=\\end\{\2\})/,
                lookbehind: true
            },
            /*
       * equations can be between $$ $$ or $ $ or \( \) or \[ \]
       * (all are multiline)
       */ equation: [
                {
                    pattern: /\$\$(?:\\[\s\S]|[^\\$])+\$\$|\$(?:\\[\s\S]|[^\\$])+\$|\\\([\s\S]*?\\\)|\\\[[\s\S]*?\\\]/,
                    inside: insideEqu,
                    alias: 'string'
                },
                {
                    pattern: /(\\begin\{((?:align|eqnarray|equation|gather|math|multline)\*?)\})[\s\S]*?(?=\\end\{\2\})/,
                    lookbehind: true,
                    inside: insideEqu,
                    alias: 'string'
                }
            ],
            /*
       * arguments which are keywords or references are highlighted
       * as keywords
       */ keyword: {
                pattern: /(\\(?:begin|cite|documentclass|end|label|ref|usepackage)(?:\[[^\]]+\])?\{)[^}]+(?=\})/,
                lookbehind: true
            },
            url: {
                pattern: /(\\url\{)[^}]+(?=\})/,
                lookbehind: true
            },
            /*
       * section or chapter headlines are highlighted as bold so that
       * they stand out more
       */ headline: {
                pattern: /(\\(?:chapter|frametitle|paragraph|part|section|subparagraph|subsection|subsubparagraph|subsubsection|subsubsubparagraph)\*?(?:\[[^\]]+\])?\{)[^}]+(?=\})/,
                lookbehind: true,
                alias: 'class-name'
            },
            function: {
                pattern: funcPattern,
                alias: 'selector'
            },
            punctuation: /[[\]{}&]/
        };
        Prism.languages.tex = Prism.languages.latex;
        Prism.languages.context = Prism.languages.latex;
    })(Prism);
}

});

parcelRegister("7SWMi", function(module, exports) {
'use strict';

var $949g8 = parcelRequire("949g8");

var $antOF = parcelRequire("antOF");
module.exports = $5bdb2b9e4b4cb914$var$latte;
$5bdb2b9e4b4cb914$var$latte.displayName = 'latte';
$5bdb2b9e4b4cb914$var$latte.aliases = [];
function $5bdb2b9e4b4cb914$var$latte(Prism) {
    Prism.register($949g8);
    Prism.register($antOF);
    (function(Prism) {
        Prism.languages.latte = {
            comment: /^\{\*[\s\S]*/,
            'latte-tag': {
                // https://latte.nette.org/en/tags
                pattern: /(^\{(?:\/(?=[a-z]))?)(?:[=_]|[a-z]\w*\b(?!\())/i,
                lookbehind: true,
                alias: 'important'
            },
            delimiter: {
                pattern: /^\{\/?|\}$/,
                alias: 'punctuation'
            },
            php: {
                pattern: /\S(?:[\s\S]*\S)?/,
                alias: 'language-php',
                inside: Prism.languages.php
            }
        };
        var markupLatte = Prism.languages.extend('markup', {});
        Prism.languages.insertBefore('inside', 'attr-value', {
            'n-attr': {
                pattern: /n:[\w-]+(?:\s*=\s*(?:"[^"]*"|'[^']*'|[^\s'">=]+))?/,
                inside: {
                    'attr-name': {
                        pattern: /^[^\s=]+/,
                        alias: 'important'
                    },
                    'attr-value': {
                        pattern: /=[\s\S]+/,
                        inside: {
                            punctuation: [
                                /^=/,
                                {
                                    pattern: /^(\s*)["']|["']$/,
                                    lookbehind: true
                                }
                            ],
                            php: {
                                pattern: /\S(?:[\s\S]*\S)?/,
                                inside: Prism.languages.php
                            }
                        }
                    }
                }
            }
        }, markupLatte.tag);
        Prism.hooks.add('before-tokenize', function(env) {
            if (env.language !== 'latte') return;
            var lattePattern = /\{\*[\s\S]*?\*\}|\{[^'"\s{}*](?:[^"'/{}]|\/(?![*/])|("|')(?:\\[\s\S]|(?!\1)[^\\])*\1|\/\*(?:[^*]|\*(?!\/))*\*\/)*\}/g;
            Prism.languages['markup-templating'].buildPlaceholders(env, 'latte', lattePattern);
            env.grammar = markupLatte;
        });
        Prism.hooks.add('after-tokenize', function(env) {
            Prism.languages['markup-templating'].tokenizePlaceholders(env, 'latte');
        });
    })(Prism);
}

});
parcelRegister("antOF", function(module, exports) {
'use strict';

var $949g8 = parcelRequire("949g8");
module.exports = $78e32e43946b757c$var$php;
$78e32e43946b757c$var$php.displayName = 'php';
$78e32e43946b757c$var$php.aliases = [];
function $78e32e43946b757c$var$php(Prism) {
    Prism.register($949g8);
    (function(Prism) {
        var comment = /\/\*[\s\S]*?\*\/|\/\/.*|#(?!\[).*/;
        var constant = [
            {
                pattern: /\b(?:false|true)\b/i,
                alias: 'boolean'
            },
            {
                pattern: /(::\s*)\b[a-z_]\w*\b(?!\s*\()/i,
                greedy: true,
                lookbehind: true
            },
            {
                pattern: /(\b(?:case|const)\s+)\b[a-z_]\w*(?=\s*[;=])/i,
                greedy: true,
                lookbehind: true
            },
            /\b(?:null)\b/i,
            /\b[A-Z_][A-Z0-9_]*\b(?!\s*\()/
        ];
        var number = /\b0b[01]+(?:_[01]+)*\b|\b0o[0-7]+(?:_[0-7]+)*\b|\b0x[\da-f]+(?:_[\da-f]+)*\b|(?:\b\d+(?:_\d+)*\.?(?:\d+(?:_\d+)*)?|\B\.\d+)(?:e[+-]?\d+)?/i;
        var operator = /<?=>|\?\?=?|\.{3}|\??->|[!=]=?=?|::|\*\*=?|--|\+\+|&&|\|\||<<|>>|[?~]|[/^|%*&<>.+-]=?/;
        var punctuation = /[{}\[\](),:;]/;
        Prism.languages.php = {
            delimiter: {
                pattern: /\?>$|^<\?(?:php(?=\s)|=)?/i,
                alias: 'important'
            },
            comment: comment,
            variable: /\$+(?:\w+\b|(?=\{))/,
            package: {
                pattern: /(namespace\s+|use\s+(?:function\s+)?)(?:\\?\b[a-z_]\w*)+\b(?!\\)/i,
                lookbehind: true,
                inside: {
                    punctuation: /\\/
                }
            },
            'class-name-definition': {
                pattern: /(\b(?:class|enum|interface|trait)\s+)\b[a-z_]\w*(?!\\)\b/i,
                lookbehind: true,
                alias: 'class-name'
            },
            'function-definition': {
                pattern: /(\bfunction\s+)[a-z_]\w*(?=\s*\()/i,
                lookbehind: true,
                alias: 'function'
            },
            keyword: [
                {
                    pattern: /(\(\s*)\b(?:array|bool|boolean|float|int|integer|object|string)\b(?=\s*\))/i,
                    alias: 'type-casting',
                    greedy: true,
                    lookbehind: true
                },
                {
                    pattern: /([(,?]\s*)\b(?:array(?!\s*\()|bool|callable|(?:false|null)(?=\s*\|)|float|int|iterable|mixed|object|self|static|string)\b(?=\s*\$)/i,
                    alias: 'type-hint',
                    greedy: true,
                    lookbehind: true
                },
                {
                    pattern: /(\)\s*:\s*(?:\?\s*)?)\b(?:array(?!\s*\()|bool|callable|(?:false|null)(?=\s*\|)|float|int|iterable|mixed|object|self|static|string|void)\b/i,
                    alias: 'return-type',
                    greedy: true,
                    lookbehind: true
                },
                {
                    pattern: /\b(?:array(?!\s*\()|bool|float|int|iterable|mixed|object|string|void)\b/i,
                    alias: 'type-declaration',
                    greedy: true
                },
                {
                    pattern: /(\|\s*)(?:false|null)\b|\b(?:false|null)(?=\s*\|)/i,
                    alias: 'type-declaration',
                    greedy: true,
                    lookbehind: true
                },
                {
                    pattern: /\b(?:parent|self|static)(?=\s*::)/i,
                    alias: 'static-context',
                    greedy: true
                },
                {
                    // yield from
                    pattern: /(\byield\s+)from\b/i,
                    lookbehind: true
                },
                /\bclass\b/i,
                {
                    // https://www.php.net/manual/en/reserved.keywords.php
                    //
                    // keywords cannot be preceded by "->"
                    // the complex lookbehind means `(?<!(?:->|::)\s*)`
                    pattern: /((?:^|[^\s>:]|(?:^|[^-])>|(?:^|[^:]):)\s*)\b(?:abstract|and|array|as|break|callable|case|catch|clone|const|continue|declare|default|die|do|echo|else|elseif|empty|enddeclare|endfor|endforeach|endif|endswitch|endwhile|enum|eval|exit|extends|final|finally|fn|for|foreach|function|global|goto|if|implements|include|include_once|instanceof|insteadof|interface|isset|list|match|namespace|new|or|parent|print|private|protected|public|require|require_once|return|self|static|switch|throw|trait|try|unset|use|var|while|xor|yield|__halt_compiler)\b/i,
                    lookbehind: true
                }
            ],
            'argument-name': {
                pattern: /([(,]\s+)\b[a-z_]\w*(?=\s*:(?!:))/i,
                lookbehind: true
            },
            'class-name': [
                {
                    pattern: /(\b(?:extends|implements|instanceof|new(?!\s+self|\s+static))\s+|\bcatch\s*\()\b[a-z_]\w*(?!\\)\b/i,
                    greedy: true,
                    lookbehind: true
                },
                {
                    pattern: /(\|\s*)\b[a-z_]\w*(?!\\)\b/i,
                    greedy: true,
                    lookbehind: true
                },
                {
                    pattern: /\b[a-z_]\w*(?!\\)\b(?=\s*\|)/i,
                    greedy: true
                },
                {
                    pattern: /(\|\s*)(?:\\?\b[a-z_]\w*)+\b/i,
                    alias: 'class-name-fully-qualified',
                    greedy: true,
                    lookbehind: true,
                    inside: {
                        punctuation: /\\/
                    }
                },
                {
                    pattern: /(?:\\?\b[a-z_]\w*)+\b(?=\s*\|)/i,
                    alias: 'class-name-fully-qualified',
                    greedy: true,
                    inside: {
                        punctuation: /\\/
                    }
                },
                {
                    pattern: /(\b(?:extends|implements|instanceof|new(?!\s+self\b|\s+static\b))\s+|\bcatch\s*\()(?:\\?\b[a-z_]\w*)+\b(?!\\)/i,
                    alias: 'class-name-fully-qualified',
                    greedy: true,
                    lookbehind: true,
                    inside: {
                        punctuation: /\\/
                    }
                },
                {
                    pattern: /\b[a-z_]\w*(?=\s*\$)/i,
                    alias: 'type-declaration',
                    greedy: true
                },
                {
                    pattern: /(?:\\?\b[a-z_]\w*)+(?=\s*\$)/i,
                    alias: [
                        'class-name-fully-qualified',
                        'type-declaration'
                    ],
                    greedy: true,
                    inside: {
                        punctuation: /\\/
                    }
                },
                {
                    pattern: /\b[a-z_]\w*(?=\s*::)/i,
                    alias: 'static-context',
                    greedy: true
                },
                {
                    pattern: /(?:\\?\b[a-z_]\w*)+(?=\s*::)/i,
                    alias: [
                        'class-name-fully-qualified',
                        'static-context'
                    ],
                    greedy: true,
                    inside: {
                        punctuation: /\\/
                    }
                },
                {
                    pattern: /([(,?]\s*)[a-z_]\w*(?=\s*\$)/i,
                    alias: 'type-hint',
                    greedy: true,
                    lookbehind: true
                },
                {
                    pattern: /([(,?]\s*)(?:\\?\b[a-z_]\w*)+(?=\s*\$)/i,
                    alias: [
                        'class-name-fully-qualified',
                        'type-hint'
                    ],
                    greedy: true,
                    lookbehind: true,
                    inside: {
                        punctuation: /\\/
                    }
                },
                {
                    pattern: /(\)\s*:\s*(?:\?\s*)?)\b[a-z_]\w*(?!\\)\b/i,
                    alias: 'return-type',
                    greedy: true,
                    lookbehind: true
                },
                {
                    pattern: /(\)\s*:\s*(?:\?\s*)?)(?:\\?\b[a-z_]\w*)+\b(?!\\)/i,
                    alias: [
                        'class-name-fully-qualified',
                        'return-type'
                    ],
                    greedy: true,
                    lookbehind: true,
                    inside: {
                        punctuation: /\\/
                    }
                }
            ],
            constant: constant,
            function: {
                pattern: /(^|[^\\\w])\\?[a-z_](?:[\w\\]*\w)?(?=\s*\()/i,
                lookbehind: true,
                inside: {
                    punctuation: /\\/
                }
            },
            property: {
                pattern: /(->\s*)\w+/,
                lookbehind: true
            },
            number: number,
            operator: operator,
            punctuation: punctuation
        };
        var string_interpolation = {
            pattern: /\{\$(?:\{(?:\{[^{}]+\}|[^{}]+)\}|[^{}])+\}|(^|[^\\{])\$+(?:\w+(?:\[[^\r\n\[\]]+\]|->\w+)?)/,
            lookbehind: true,
            inside: Prism.languages.php
        };
        var string = [
            {
                pattern: /<<<'([^']+)'[\r\n](?:.*[\r\n])*?\1;/,
                alias: 'nowdoc-string',
                greedy: true,
                inside: {
                    delimiter: {
                        pattern: /^<<<'[^']+'|[a-z_]\w*;$/i,
                        alias: 'symbol',
                        inside: {
                            punctuation: /^<<<'?|[';]$/
                        }
                    }
                }
            },
            {
                pattern: /<<<(?:"([^"]+)"[\r\n](?:.*[\r\n])*?\1;|([a-z_]\w*)[\r\n](?:.*[\r\n])*?\2;)/i,
                alias: 'heredoc-string',
                greedy: true,
                inside: {
                    delimiter: {
                        pattern: /^<<<(?:"[^"]+"|[a-z_]\w*)|[a-z_]\w*;$/i,
                        alias: 'symbol',
                        inside: {
                            punctuation: /^<<<"?|[";]$/
                        }
                    },
                    interpolation: string_interpolation
                }
            },
            {
                pattern: /`(?:\\[\s\S]|[^\\`])*`/,
                alias: 'backtick-quoted-string',
                greedy: true
            },
            {
                pattern: /'(?:\\[\s\S]|[^\\'])*'/,
                alias: 'single-quoted-string',
                greedy: true
            },
            {
                pattern: /"(?:\\[\s\S]|[^\\"])*"/,
                alias: 'double-quoted-string',
                greedy: true,
                inside: {
                    interpolation: string_interpolation
                }
            }
        ];
        Prism.languages.insertBefore('php', 'variable', {
            string: string,
            attribute: {
                pattern: /#\[(?:[^"'\/#]|\/(?![*/])|\/\/.*$|#(?!\[).*$|\/\*(?:[^*]|\*(?!\/))*\*\/|"(?:\\[\s\S]|[^\\"])*"|'(?:\\[\s\S]|[^\\'])*')+\](?=\s*[a-z$#])/im,
                greedy: true,
                inside: {
                    'attribute-content': {
                        pattern: /^(#\[)[\s\S]+(?=\]$)/,
                        lookbehind: true,
                        // inside can appear subset of php
                        inside: {
                            comment: comment,
                            string: string,
                            'attribute-class-name': [
                                {
                                    pattern: /([^:]|^)\b[a-z_]\w*(?!\\)\b/i,
                                    alias: 'class-name',
                                    greedy: true,
                                    lookbehind: true
                                },
                                {
                                    pattern: /([^:]|^)(?:\\?\b[a-z_]\w*)+/i,
                                    alias: [
                                        'class-name',
                                        'class-name-fully-qualified'
                                    ],
                                    greedy: true,
                                    lookbehind: true,
                                    inside: {
                                        punctuation: /\\/
                                    }
                                }
                            ],
                            constant: constant,
                            number: number,
                            operator: operator,
                            punctuation: punctuation
                        }
                    },
                    delimiter: {
                        pattern: /^#\[|\]$/,
                        alias: 'punctuation'
                    }
                }
            }
        });
        Prism.hooks.add('before-tokenize', function(env) {
            if (!/<\?/.test(env.code)) return;
            var phpPattern = /<\?(?:[^"'/#]|\/(?![*/])|("|')(?:\\[\s\S]|(?!\1)[^\\])*\1|(?:\/\/|#(?!\[))(?:[^?\n\r]|\?(?!>))*(?=$|\?>|[\r\n])|#\[|\/\*(?:[^*]|\*(?!\/))*(?:\*\/|$))*?(?:\?>|$)/g;
            Prism.languages['markup-templating'].buildPlaceholders(env, 'php', phpPattern);
        });
        Prism.hooks.add('after-tokenize', function(env) {
            Prism.languages['markup-templating'].tokenizePlaceholders(env, 'php');
        });
    })(Prism);
}

});


parcelRegister("2VVeC", function(module, exports) {
'use strict';
module.exports = $222d4d453cce7441$var$less;
$222d4d453cce7441$var$less.displayName = 'less';
$222d4d453cce7441$var$less.aliases = [];
function $222d4d453cce7441$var$less(Prism) {
    /* FIXME :
:extend() is not handled specifically : its highlighting is buggy.
Mixin usage must be inside a ruleset to be highlighted.
At-rules (e.g. import) containing interpolations are buggy.
Detached rulesets are highlighted as at-rules.
A comment before a mixin usage prevents the latter to be properly highlighted.
*/ Prism.languages.less = Prism.languages.extend('css', {
        comment: [
            /\/\*[\s\S]*?\*\//,
            {
                pattern: /(^|[^\\])\/\/.*/,
                lookbehind: true
            }
        ],
        atrule: {
            pattern: /@[\w-](?:\((?:[^(){}]|\([^(){}]*\))*\)|[^(){};\s]|\s+(?!\s))*?(?=\s*\{)/,
            inside: {
                punctuation: /[:()]/
            }
        },
        // selectors and mixins are considered the same
        selector: {
            pattern: /(?:@\{[\w-]+\}|[^{};\s@])(?:@\{[\w-]+\}|\((?:[^(){}]|\([^(){}]*\))*\)|[^(){};@\s]|\s+(?!\s))*?(?=\s*\{)/,
            inside: {
                // mixin parameters
                variable: /@+[\w-]+/
            }
        },
        property: /(?:@\{[\w-]+\}|[\w-])+(?:\+_?)?(?=\s*:)/,
        operator: /[+\-*\/]/
    });
    Prism.languages.insertBefore('less', 'property', {
        variable: [
            // Variable declaration (the colon must be consumed!)
            {
                pattern: /@[\w-]+\s*:/,
                inside: {
                    punctuation: /:/
                }
            },
            /@@?[\w-]+/
        ],
        'mixin-usage': {
            pattern: /([{;]\s*)[.#](?!\d)[\w-].*?(?=[(;])/,
            lookbehind: true,
            alias: 'function'
        }
    });
}

});

parcelRegister("g6B7q", function(module, exports) {
'use strict';

var $edDH5 = parcelRequire("edDH5");
module.exports = $bb99ffe9d7187ec1$var$lilypond;
$bb99ffe9d7187ec1$var$lilypond.displayName = 'lilypond';
$bb99ffe9d7187ec1$var$lilypond.aliases = [];
function $bb99ffe9d7187ec1$var$lilypond(Prism) {
    Prism.register($edDH5);
    (function(Prism) {
        var schemeExpression = /\((?:[^();"#\\]|\\[\s\S]|;.*(?!.)|"(?:[^"\\]|\\.)*"|#(?:\{(?:(?!#\})[\s\S])*#\}|[^{])|<expr>)*\)/.source // allow for up to pow(2, recursivenessLog2) many levels of recursive brace expressions
        ;
        // For some reason, this can't be 4
        var recursivenessLog2 = 5;
        for(var i = 0; i < recursivenessLog2; i++)schemeExpression = schemeExpression.replace(/<expr>/g, function() {
            return schemeExpression;
        });
        schemeExpression = schemeExpression.replace(/<expr>/g, /[^\s\S]/.source);
        var lilypond = Prism.languages.lilypond = {
            comment: /%(?:(?!\{).*|\{[\s\S]*?%\})/,
            'embedded-scheme': {
                pattern: RegExp(/(^|[=\s])#(?:"(?:[^"\\]|\\.)*"|[^\s()"]*(?:[^\s()]|<expr>))/.source.replace(/<expr>/g, function() {
                    return schemeExpression;
                }), 'm'),
                lookbehind: true,
                greedy: true,
                inside: {
                    scheme: {
                        pattern: /^(#)[\s\S]+$/,
                        lookbehind: true,
                        alias: 'language-scheme',
                        inside: {
                            'embedded-lilypond': {
                                pattern: /#\{[\s\S]*?#\}/,
                                greedy: true,
                                inside: {
                                    punctuation: /^#\{|#\}$/,
                                    lilypond: {
                                        pattern: /[\s\S]+/,
                                        alias: 'language-lilypond',
                                        inside: null // see below
                                    }
                                }
                            },
                            rest: Prism.languages.scheme
                        }
                    },
                    punctuation: /#/
                }
            },
            string: {
                pattern: /"(?:[^"\\]|\\.)*"/,
                greedy: true
            },
            'class-name': {
                pattern: /(\\new\s+)[\w-]+/,
                lookbehind: true
            },
            keyword: {
                pattern: /\\[a-z][-\w]*/i,
                inside: {
                    punctuation: /^\\/
                }
            },
            operator: /[=|]|<<|>>/,
            punctuation: {
                pattern: /(^|[a-z\d])(?:'+|,+|[_^]?-[_^]?(?:[-+^!>._]|(?=\d))|[_^]\.?|[.!])|[{}()[\]<>^~]|\\[()[\]<>\\!]|--|__/,
                lookbehind: true
            },
            number: /\b\d+(?:\/\d+)?\b/
        };
        lilypond['embedded-scheme'].inside['scheme'].inside['embedded-lilypond'].inside['lilypond'].inside = lilypond;
        Prism.languages.ly = lilypond;
    })(Prism);
}

});
parcelRegister("edDH5", function(module, exports) {
'use strict';
module.exports = $a5a111fa0d838885$var$scheme;
$a5a111fa0d838885$var$scheme.displayName = 'scheme';
$a5a111fa0d838885$var$scheme.aliases = [];
function $a5a111fa0d838885$var$scheme(Prism) {
    (function(Prism) {
        Prism.languages.scheme = {
            // this supports "normal" single-line comments:
            //   ; comment
            // and (potentially nested) multiline comments:
            //   #| comment #| nested |# still comment |#
            // (only 1 level of nesting is supported)
            comment: /;.*|#;\s*(?:\((?:[^()]|\([^()]*\))*\)|\[(?:[^\[\]]|\[[^\[\]]*\])*\])|#\|(?:[^#|]|#(?!\|)|\|(?!#)|#\|(?:[^#|]|#(?!\|)|\|(?!#))*\|#)*\|#/,
            string: {
                pattern: /"(?:[^"\\]|\\.)*"/,
                greedy: true
            },
            symbol: {
                pattern: /'[^()\[\]#'\s]+/,
                greedy: true
            },
            char: {
                pattern: /#\\(?:[ux][a-fA-F\d]+\b|[-a-zA-Z]+\b|[\uD800-\uDBFF][\uDC00-\uDFFF]|\S)/,
                greedy: true
            },
            'lambda-parameter': [
                // https://www.cs.cmu.edu/Groups/AI/html/r4rs/r4rs_6.html#SEC30
                {
                    pattern: /((?:^|[^'`#])[(\[]lambda\s+)(?:[^|()\[\]'\s]+|\|(?:[^\\|]|\\.)*\|)/,
                    lookbehind: true
                },
                {
                    pattern: /((?:^|[^'`#])[(\[]lambda\s+[(\[])[^()\[\]']+/,
                    lookbehind: true
                }
            ],
            keyword: {
                pattern: /((?:^|[^'`#])[(\[])(?:begin|case(?:-lambda)?|cond(?:-expand)?|define(?:-library|-macro|-record-type|-syntax|-values)?|defmacro|delay(?:-force)?|do|else|except|export|guard|if|import|include(?:-ci|-library-declarations)?|lambda|let(?:rec)?(?:-syntax|-values|\*)?|let\*-values|only|parameterize|prefix|(?:quasi-?)?quote|rename|set!|syntax-(?:case|rules)|unless|unquote(?:-splicing)?|when)(?=[()\[\]\s]|$)/,
                lookbehind: true
            },
            builtin: {
                // all functions of the base library of R7RS plus some of built-ins of R5Rs
                pattern: /((?:^|[^'`#])[(\[])(?:abs|and|append|apply|assoc|ass[qv]|binary-port\?|boolean=?\?|bytevector(?:-append|-copy|-copy!|-length|-u8-ref|-u8-set!|\?)?|caar|cadr|call-with-(?:current-continuation|port|values)|call\/cc|car|cdar|cddr|cdr|ceiling|char(?:->integer|-ready\?|\?|<\?|<=\?|=\?|>\?|>=\?)|close-(?:input-port|output-port|port)|complex\?|cons|current-(?:error|input|output)-port|denominator|dynamic-wind|eof-object\??|eq\?|equal\?|eqv\?|error|error-object(?:-irritants|-message|\?)|eval|even\?|exact(?:-integer-sqrt|-integer\?|\?)?|expt|features|file-error\?|floor(?:-quotient|-remainder|\/)?|flush-output-port|for-each|gcd|get-output-(?:bytevector|string)|inexact\??|input-port(?:-open\?|\?)|integer(?:->char|\?)|lcm|length|list(?:->string|->vector|-copy|-ref|-set!|-tail|\?)?|make-(?:bytevector|list|parameter|string|vector)|map|max|member|memq|memv|min|modulo|negative\?|newline|not|null\?|number(?:->string|\?)|numerator|odd\?|open-(?:input|output)-(?:bytevector|string)|or|output-port(?:-open\?|\?)|pair\?|peek-char|peek-u8|port\?|positive\?|procedure\?|quotient|raise|raise-continuable|rational\?|rationalize|read-(?:bytevector|bytevector!|char|error\?|line|string|u8)|real\?|remainder|reverse|round|set-c[ad]r!|square|string(?:->list|->number|->symbol|->utf8|->vector|-append|-copy|-copy!|-fill!|-for-each|-length|-map|-ref|-set!|\?|<\?|<=\?|=\?|>\?|>=\?)?|substring|symbol(?:->string|\?|=\?)|syntax-error|textual-port\?|truncate(?:-quotient|-remainder|\/)?|u8-ready\?|utf8->string|values|vector(?:->list|->string|-append|-copy|-copy!|-fill!|-for-each|-length|-map|-ref|-set!|\?)?|with-exception-handler|write-(?:bytevector|char|string|u8)|zero\?)(?=[()\[\]\s]|$)/,
                lookbehind: true
            },
            operator: {
                pattern: /((?:^|[^'`#])[(\[])(?:[-+*%/]|[<>]=?|=>?)(?=[()\[\]\s]|$)/,
                lookbehind: true
            },
            number: {
                // The number pattern from [the R7RS spec](https://small.r7rs.org/attachment/r7rs.pdf).
                //
                // <number>      := <num 2>|<num 8>|<num 10>|<num 16>
                // <num R>       := <prefix R><complex R>
                // <complex R>   := <real R>(?:@<real R>|<imaginary R>)?|<imaginary R>
                // <imaginary R> := [+-](?:<ureal R>|(?:inf|nan)\.0)?i
                // <real R>      := [+-]?<ureal R>|[+-](?:inf|nan)\.0
                // <ureal R>     := <uint R>(?:\/<uint R>)?
                //                | <decimal R>
                //
                // <decimal 10>  := (?:\d+(?:\.\d*)?|\.\d+)(?:e[+-]?\d+)?
                // <uint R>      := <digit R>+
                // <prefix R>    := <radix R>(?:#[ei])?|(?:#[ei])?<radix R>
                // <radix 2>     := #b
                // <radix 8>     := #o
                // <radix 10>    := (?:#d)?
                // <radix 16>    := #x
                // <digit 2>     := [01]
                // <digit 8>     := [0-7]
                // <digit 10>    := \d
                // <digit 16>    := [0-9a-f]
                //
                // The problem with this grammar is that the resulting regex is way to complex, so we simplify by grouping all
                // non-decimal bases together. This results in a decimal (dec) and combined binary, octal, and hexadecimal (box)
                // pattern:
                pattern: RegExp(SortedBNF({
                    '<ureal dec>': /\d+(?:\/\d+)|(?:\d+(?:\.\d*)?|\.\d+)(?:[esfdl][+-]?\d+)?/.source,
                    '<real dec>': /[+-]?<ureal dec>|[+-](?:inf|nan)\.0/.source,
                    '<imaginary dec>': /[+-](?:<ureal dec>|(?:inf|nan)\.0)?i/.source,
                    '<complex dec>': /<real dec>(?:@<real dec>|<imaginary dec>)?|<imaginary dec>/.source,
                    '<num dec>': /(?:#d(?:#[ei])?|#[ei](?:#d)?)?<complex dec>/.source,
                    '<ureal box>': /[0-9a-f]+(?:\/[0-9a-f]+)?/.source,
                    '<real box>': /[+-]?<ureal box>|[+-](?:inf|nan)\.0/.source,
                    '<imaginary box>': /[+-](?:<ureal box>|(?:inf|nan)\.0)?i/.source,
                    '<complex box>': /<real box>(?:@<real box>|<imaginary box>)?|<imaginary box>/.source,
                    '<num box>': /#[box](?:#[ei])?|(?:#[ei])?#[box]<complex box>/.source,
                    '<number>': /(^|[()\[\]\s])(?:<num dec>|<num box>)(?=[()\[\]\s]|$)/.source
                }), 'i'),
                lookbehind: true
            },
            boolean: {
                pattern: /(^|[()\[\]\s])#(?:[ft]|false|true)(?=[()\[\]\s]|$)/,
                lookbehind: true
            },
            function: {
                pattern: /((?:^|[^'`#])[(\[])(?:[^|()\[\]'\s]+|\|(?:[^\\|]|\\.)*\|)(?=[()\[\]\s]|$)/,
                lookbehind: true
            },
            identifier: {
                pattern: /(^|[()\[\]\s])\|(?:[^\\|]|\\.)*\|(?=[()\[\]\s]|$)/,
                lookbehind: true,
                greedy: true
            },
            punctuation: /[()\[\]']/
        };
        /**
     * Given a topologically sorted BNF grammar, this will return the RegExp source of last rule of the grammar.
     *
     * @param {Record<string, string>} grammar
     * @returns {string}
     */ function SortedBNF(grammar) {
            for(var key in grammar)grammar[key] = grammar[key].replace(/<[\w\s]+>/g, function(key) {
                return '(?:' + grammar[key].trim() + ')';
            });
             // return the last item
            return grammar[key];
        }
    })(Prism);
}

});


parcelRegister("cjsmG", function(module, exports) {
'use strict';

var $949g8 = parcelRequire("949g8");
module.exports = $8f6d430c6713c0fc$var$liquid;
$8f6d430c6713c0fc$var$liquid.displayName = 'liquid';
$8f6d430c6713c0fc$var$liquid.aliases = [];
function $8f6d430c6713c0fc$var$liquid(Prism) {
    Prism.register($949g8);
    Prism.languages.liquid = {
        comment: {
            pattern: /(^\{%\s*comment\s*%\})[\s\S]+(?=\{%\s*endcomment\s*%\}$)/,
            lookbehind: true
        },
        delimiter: {
            pattern: /^\{(?:\{\{|[%\{])-?|-?(?:\}\}|[%\}])\}$/,
            alias: 'punctuation'
        },
        string: {
            pattern: /"[^"]*"|'[^']*'/,
            greedy: true
        },
        keyword: /\b(?:as|assign|break|(?:end)?(?:capture|case|comment|for|form|if|paginate|raw|style|tablerow|unless)|continue|cycle|decrement|echo|else|elsif|in|include|increment|limit|liquid|offset|range|render|reversed|section|when|with)\b/,
        object: /\b(?:address|all_country_option_tags|article|block|blog|cart|checkout|collection|color|country|country_option_tags|currency|current_page|current_tags|customer|customer_address|date|discount_allocation|discount_application|external_video|filter|filter_value|font|forloop|fulfillment|generic_file|gift_card|group|handle|image|line_item|link|linklist|localization|location|measurement|media|metafield|model|model_source|order|page|page_description|page_image|page_title|part|policy|product|product_option|recommendations|request|robots|routes|rule|script|search|selling_plan|selling_plan_allocation|selling_plan_group|shipping_method|shop|shop_locale|sitemap|store_availability|tax_line|template|theme|transaction|unit_price_measurement|user_agent|variant|video|video_source)\b/,
        function: [
            {
                pattern: /(\|\s*)\w+/,
                lookbehind: true,
                alias: 'filter'
            },
            {
                // array functions
                pattern: /(\.\s*)(?:first|last|size)/,
                lookbehind: true
            }
        ],
        boolean: /\b(?:false|nil|true)\b/,
        range: {
            pattern: /\.\./,
            alias: 'operator'
        },
        // https://github.com/Shopify/liquid/blob/698f5e0d967423e013f6169d9111bd969bd78337/lib/liquid/lexer.rb#L21
        number: /\b\d+(?:\.\d+)?\b/,
        operator: /[!=]=|<>|[<>]=?|[|?:=-]|\b(?:and|contains(?=\s)|or)\b/,
        punctuation: /[.,\[\]()]/,
        empty: {
            pattern: /\bempty\b/,
            alias: 'keyword'
        }
    };
    Prism.hooks.add('before-tokenize', function(env) {
        var liquidPattern = /\{%\s*comment\s*%\}[\s\S]*?\{%\s*endcomment\s*%\}|\{(?:%[\s\S]*?%|\{\{[\s\S]*?\}\}|\{[\s\S]*?\})\}/g;
        var insideRaw = false;
        Prism.languages['markup-templating'].buildPlaceholders(env, 'liquid', liquidPattern, function(match) {
            var tagMatch = /^\{%-?\s*(\w+)/.exec(match);
            if (tagMatch) {
                var tag = tagMatch[1];
                if (tag === 'raw' && !insideRaw) {
                    insideRaw = true;
                    return true;
                } else if (tag === 'endraw') {
                    insideRaw = false;
                    return true;
                }
            }
            return !insideRaw;
        });
    });
    Prism.hooks.add('after-tokenize', function(env) {
        Prism.languages['markup-templating'].tokenizePlaceholders(env, 'liquid');
    });
}

});

parcelRegister("3dkLW", function(module, exports) {
'use strict';
module.exports = $2572b2ef5c0ce969$var$lisp;
$2572b2ef5c0ce969$var$lisp.displayName = 'lisp';
$2572b2ef5c0ce969$var$lisp.aliases = [];
function $2572b2ef5c0ce969$var$lisp(Prism) {
    (function(Prism) {
        /**
     * Functions to construct regular expressions
     * e.g. (interactive ... or (interactive)
     *
     * @param {string} name
     * @returns {RegExp}
     */ function simple_form(name) {
            return RegExp(/(\()/.source + '(?:' + name + ')' + /(?=[\s\)])/.source);
        }
        /**
     * booleans and numbers
     *
     * @param {string} pattern
     * @returns {RegExp}
     */ function primitive(pattern) {
            return RegExp(/([\s([])/.source + '(?:' + pattern + ')' + /(?=[\s)])/.source);
        } // Patterns in regular expressions
        // Symbol name. See https://www.gnu.org/software/emacs/manual/html_node/elisp/Symbol-Type.html
        // & and : are excluded as they are usually used for special purposes
        var symbol = /(?!\d)[-+*/~!@$%^=<>{}\w]+/.source // symbol starting with & used in function arguments
        ;
        var marker = '&' + symbol // Open parenthesis for look-behind
        ;
        var par = '(\\()';
        var endpar = '(?=\\))' // End the pattern with look-ahead space
        ;
        var space = '(?=\\s)';
        var nestedPar = /(?:[^()]|\((?:[^()]|\((?:[^()]|\((?:[^()]|\((?:[^()]|\([^()]*\))*\))*\))*\))*\))*/.source;
        var language = {
            // Three or four semicolons are considered a heading.
            // See https://www.gnu.org/software/emacs/manual/html_node/elisp/Comment-Tips.html
            heading: {
                pattern: /;;;.*/,
                alias: [
                    'comment',
                    'title'
                ]
            },
            comment: /;.*/,
            string: {
                pattern: /"(?:[^"\\]|\\.)*"/,
                greedy: true,
                inside: {
                    argument: /[-A-Z]+(?=[.,\s])/,
                    symbol: RegExp('`' + symbol + "'")
                }
            },
            'quoted-symbol': {
                pattern: RegExp("#?'" + symbol),
                alias: [
                    'variable',
                    'symbol'
                ]
            },
            'lisp-property': {
                pattern: RegExp(':' + symbol),
                alias: 'property'
            },
            splice: {
                pattern: RegExp(',@?' + symbol),
                alias: [
                    'symbol',
                    'variable'
                ]
            },
            keyword: [
                {
                    pattern: RegExp(par + '(?:and|(?:cl-)?letf|cl-loop|cond|cons|error|if|(?:lexical-)?let\\*?|message|not|null|or|provide|require|setq|unless|use-package|when|while)' + space),
                    lookbehind: true
                },
                {
                    pattern: RegExp(par + '(?:append|by|collect|concat|do|finally|for|in|return)' + space),
                    lookbehind: true
                }
            ],
            declare: {
                pattern: simple_form(/declare/.source),
                lookbehind: true,
                alias: 'keyword'
            },
            interactive: {
                pattern: simple_form(/interactive/.source),
                lookbehind: true,
                alias: 'keyword'
            },
            boolean: {
                pattern: primitive(/nil|t/.source),
                lookbehind: true
            },
            number: {
                pattern: primitive(/[-+]?\d+(?:\.\d*)?/.source),
                lookbehind: true
            },
            defvar: {
                pattern: RegExp(par + 'def(?:const|custom|group|var)\\s+' + symbol),
                lookbehind: true,
                inside: {
                    keyword: /^def[a-z]+/,
                    variable: RegExp(symbol)
                }
            },
            defun: {
                pattern: RegExp(par + /(?:cl-)?(?:defmacro|defun\*?)\s+/.source + symbol + /\s+\(/.source + nestedPar + /\)/.source),
                lookbehind: true,
                greedy: true,
                inside: {
                    keyword: /^(?:cl-)?def\S+/,
                    // See below, this property needs to be defined later so that it can
                    // reference the language object.
                    arguments: null,
                    function: {
                        pattern: RegExp('(^\\s)' + symbol),
                        lookbehind: true
                    },
                    punctuation: /[()]/
                }
            },
            lambda: {
                pattern: RegExp(par + 'lambda\\s+\\(\\s*(?:&?' + symbol + '(?:\\s+&?' + symbol + ')*\\s*)?\\)'),
                lookbehind: true,
                greedy: true,
                inside: {
                    keyword: /^lambda/,
                    // See below, this property needs to be defined later so that it can
                    // reference the language object.
                    arguments: null,
                    punctuation: /[()]/
                }
            },
            car: {
                pattern: RegExp(par + symbol),
                lookbehind: true
            },
            punctuation: [
                // open paren, brackets, and close paren
                /(?:['`,]?\(|[)\[\]])/,
                {
                    pattern: /(\s)\.(?=\s)/,
                    lookbehind: true
                }
            ]
        };
        var arg = {
            'lisp-marker': RegExp(marker),
            varform: {
                pattern: RegExp(/\(/.source + symbol + /\s+(?=\S)/.source + nestedPar + /\)/.source),
                inside: language
            },
            argument: {
                pattern: RegExp(/(^|[\s(])/.source + symbol),
                lookbehind: true,
                alias: 'variable'
            },
            rest: language
        };
        var forms = '\\S+(?:\\s+\\S+)*';
        var arglist = {
            pattern: RegExp(par + nestedPar + endpar),
            lookbehind: true,
            inside: {
                'rest-vars': {
                    pattern: RegExp('&(?:body|rest)\\s+' + forms),
                    inside: arg
                },
                'other-marker-vars': {
                    pattern: RegExp('&(?:aux|optional)\\s+' + forms),
                    inside: arg
                },
                keys: {
                    pattern: RegExp('&key\\s+' + forms + '(?:\\s+&allow-other-keys)?'),
                    inside: arg
                },
                argument: {
                    pattern: RegExp(symbol),
                    alias: 'variable'
                },
                punctuation: /[()]/
            }
        };
        language['lambda'].inside.arguments = arglist;
        language['defun'].inside.arguments = Prism.util.clone(arglist);
        language['defun'].inside.arguments.inside.sublist = arglist;
        Prism.languages.lisp = language;
        Prism.languages.elisp = language;
        Prism.languages.emacs = language;
        Prism.languages['emacs-lisp'] = language;
    })(Prism);
}

});

parcelRegister("88xZb", function(module, exports) {
'use strict';
module.exports = $5ec96ef49b95e460$var$livescript;
$5ec96ef49b95e460$var$livescript.displayName = 'livescript';
$5ec96ef49b95e460$var$livescript.aliases = [];
function $5ec96ef49b95e460$var$livescript(Prism) {
    Prism.languages.livescript = {
        comment: [
            {
                pattern: /(^|[^\\])\/\*[\s\S]*?\*\//,
                lookbehind: true
            },
            {
                pattern: /(^|[^\\])#.*/,
                lookbehind: true
            }
        ],
        'interpolated-string': {
            /* Look-behind and look-ahead prevents wrong behavior of the greedy pattern
       * forcing it to match """-quoted string when it would otherwise match "-quoted first. */ pattern: /(^|[^"])("""|")(?:\\[\s\S]|(?!\2)[^\\])*\2(?!")/,
            lookbehind: true,
            greedy: true,
            inside: {
                variable: {
                    pattern: /(^|[^\\])#[a-z_](?:-?[a-z]|[\d_])*/m,
                    lookbehind: true
                },
                interpolation: {
                    pattern: /(^|[^\\])#\{[^}]+\}/m,
                    lookbehind: true,
                    inside: {
                        'interpolation-punctuation': {
                            pattern: /^#\{|\}$/,
                            alias: 'variable'
                        } // See rest below
                    }
                },
                string: /[\s\S]+/
            }
        },
        string: [
            {
                pattern: /('''|')(?:\\[\s\S]|(?!\1)[^\\])*\1/,
                greedy: true
            },
            {
                pattern: /<\[[\s\S]*?\]>/,
                greedy: true
            },
            /\\[^\s,;\])}]+/
        ],
        regex: [
            {
                pattern: /\/\/(?:\[[^\r\n\]]*\]|\\.|(?!\/\/)[^\\\[])+\/\/[gimyu]{0,5}/,
                greedy: true,
                inside: {
                    comment: {
                        pattern: /(^|[^\\])#.*/,
                        lookbehind: true
                    }
                }
            },
            {
                pattern: /\/(?:\[[^\r\n\]]*\]|\\.|[^/\\\r\n\[])+\/[gimyu]{0,5}/,
                greedy: true
            }
        ],
        keyword: {
            pattern: /(^|(?!-).)\b(?:break|case|catch|class|const|continue|default|do|else|extends|fallthrough|finally|for(?: ever)?|function|if|implements|it|let|loop|new|null|otherwise|own|return|super|switch|that|then|this|throw|try|unless|until|var|void|when|while|yield)(?!-)\b/m,
            lookbehind: true
        },
        'keyword-operator': {
            pattern: /(^|[^-])\b(?:(?:delete|require|typeof)!|(?:and|by|delete|export|from|import(?: all)?|in|instanceof|is(?: not|nt)?|not|of|or|til|to|typeof|with|xor)(?!-)\b)/m,
            lookbehind: true,
            alias: 'operator'
        },
        boolean: {
            pattern: /(^|[^-])\b(?:false|no|off|on|true|yes)(?!-)\b/m,
            lookbehind: true
        },
        argument: {
            // Don't match .&. nor &&
            pattern: /(^|(?!\.&\.)[^&])&(?!&)\d*/m,
            lookbehind: true,
            alias: 'variable'
        },
        number: /\b(?:\d+~[\da-z]+|\d[\d_]*(?:\.\d[\d_]*)?(?:[a-z]\w*)?)/i,
        identifier: /[a-z_](?:-?[a-z]|[\d_])*/i,
        operator: [
            // Spaced .
            {
                pattern: /( )\.(?= )/,
                lookbehind: true
            },
            // .= .~ .. ...
            // .&. .^. .<<. .>>. .>>>.
            // := :: ::=
            // &&
            // || |>
            // < << <<< <<<<
            // <- <-- <-! <--!
            // <~ <~~ <~! <~~!
            // <| <= <?
            // > >> >= >?
            // - -- -> -->
            // + ++
            // @ @@
            // % %%
            // * **
            // ! != !~=
            // !~> !~~>
            // !-> !-->
            // ~ ~> ~~> ~=
            // = ==
            // ^ ^^
            // / ?
            /\.(?:[=~]|\.\.?)|\.(?:[&|^]|<<|>>>?)\.|:(?:=|:=?)|&&|\|[|>]|<(?:<<?<?|--?!?|~~?!?|[|=?])?|>[>=?]?|-(?:->?|>)?|\+\+?|@@?|%%?|\*\*?|!(?:~?=|--?>|~?~>)?|~(?:~?>|=)?|==?|\^\^?|[\/?]/
        ],
        punctuation: /[(){}\[\]|.,:;`]/
    };
    Prism.languages.livescript['interpolated-string'].inside['interpolation'].inside.rest = Prism.languages.livescript;
}

});

parcelRegister("clCHb", function(module, exports) {
'use strict';
module.exports = $8fd57657bebf2b8c$var$llvm;
$8fd57657bebf2b8c$var$llvm.displayName = 'llvm';
$8fd57657bebf2b8c$var$llvm.aliases = [];
function $8fd57657bebf2b8c$var$llvm(Prism) {
    (function(Prism) {
        Prism.languages.llvm = {
            comment: /;.*/,
            string: {
                pattern: /"[^"]*"/,
                greedy: true
            },
            boolean: /\b(?:false|true)\b/,
            variable: /[%@!#](?:(?!\d)(?:[-$.\w]|\\[a-f\d]{2})+|\d+)/i,
            label: /(?!\d)(?:[-$.\w]|\\[a-f\d]{2})+:/i,
            type: {
                pattern: /\b(?:double|float|fp128|half|i[1-9]\d*|label|metadata|ppc_fp128|token|void|x86_fp80|x86_mmx)\b/,
                alias: 'class-name'
            },
            keyword: /\b[a-z_][a-z_0-9]*\b/,
            number: /[+-]?\b\d+(?:\.\d+)?(?:[eE][+-]?\d+)?\b|\b0x[\dA-Fa-f]+\b|\b0xK[\dA-Fa-f]{20}\b|\b0x[ML][\dA-Fa-f]{32}\b|\b0xH[\dA-Fa-f]{4}\b/,
            punctuation: /[{}[\];(),.!*=<>]/
        };
    })(Prism);
}

});

parcelRegister("6JaSX", function(module, exports) {
'use strict';
module.exports = $4e5f63a7879a957d$var$log;
$4e5f63a7879a957d$var$log.displayName = 'log';
$4e5f63a7879a957d$var$log.aliases = [];
function $4e5f63a7879a957d$var$log(Prism) {
    // This is a language definition for generic log files.
    // Since there is no one log format, this language definition has to support all formats to some degree.
    //
    // Based on https://github.com/MTDL9/vim-log-highlighting
    Prism.languages.log = {
        string: {
            // Single-quoted strings must not be confused with plain text. E.g. Can't isn't Susan's Chris' toy
            pattern: /"(?:[^"\\\r\n]|\\.)*"|'(?![st] | \w)(?:[^'\\\r\n]|\\.)*'/,
            greedy: true
        },
        exception: {
            pattern: /(^|[^\w.])[a-z][\w.]*(?:Error|Exception):.*(?:(?:\r\n?|\n)[ \t]*(?:at[ \t].+|\.{3}.*|Caused by:.*))+(?:(?:\r\n?|\n)[ \t]*\.\.\. .*)?/,
            lookbehind: true,
            greedy: true,
            alias: [
                'javastacktrace',
                'language-javastacktrace'
            ],
            inside: Prism.languages['javastacktrace'] || {
                keyword: /\bat\b/,
                function: /[a-z_][\w$]*(?=\()/,
                punctuation: /[.:()]/
            }
        },
        level: [
            {
                pattern: /\b(?:ALERT|CRIT|CRITICAL|EMERG|EMERGENCY|ERR|ERROR|FAILURE|FATAL|SEVERE)\b/,
                alias: [
                    'error',
                    'important'
                ]
            },
            {
                pattern: /\b(?:WARN|WARNING|WRN)\b/,
                alias: [
                    'warning',
                    'important'
                ]
            },
            {
                pattern: /\b(?:DISPLAY|INF|INFO|NOTICE|STATUS)\b/,
                alias: [
                    'info',
                    'keyword'
                ]
            },
            {
                pattern: /\b(?:DBG|DEBUG|FINE)\b/,
                alias: [
                    'debug',
                    'keyword'
                ]
            },
            {
                pattern: /\b(?:FINER|FINEST|TRACE|TRC|VERBOSE|VRB)\b/,
                alias: [
                    'trace',
                    'comment'
                ]
            }
        ],
        property: {
            pattern: /((?:^|[\]|])[ \t]*)[a-z_](?:[\w-]|\b\/\b)*(?:[. ]\(?\w(?:[\w-]|\b\/\b)*\)?)*:(?=\s)/im,
            lookbehind: true
        },
        separator: {
            pattern: /(^|[^-+])-{3,}|={3,}|\*{3,}|- - /m,
            lookbehind: true,
            alias: 'comment'
        },
        url: /\b(?:file|ftp|https?):\/\/[^\s|,;'"]*[^\s|,;'">.]/,
        email: {
            pattern: /(^|\s)[-\w+.]+@[a-z][a-z0-9-]*(?:\.[a-z][a-z0-9-]*)+(?=\s)/,
            lookbehind: true,
            alias: 'url'
        },
        'ip-address': {
            pattern: /\b(?:\d{1,3}(?:\.\d{1,3}){3})\b/,
            alias: 'constant'
        },
        'mac-address': {
            pattern: /\b[a-f0-9]{2}(?::[a-f0-9]{2}){5}\b/i,
            alias: 'constant'
        },
        domain: {
            pattern: /(^|\s)[a-z][a-z0-9-]*(?:\.[a-z][a-z0-9-]*)*\.[a-z][a-z0-9-]+(?=\s)/,
            lookbehind: true,
            alias: 'constant'
        },
        uuid: {
            pattern: /\b[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}\b/i,
            alias: 'constant'
        },
        hash: {
            pattern: /\b(?:[a-f0-9]{32}){1,2}\b/i,
            alias: 'constant'
        },
        'file-path': {
            pattern: /\b[a-z]:[\\/][^\s|,;:(){}\[\]"']+|(^|[\s:\[\](>|])\.{0,2}\/\w[^\s|,;:(){}\[\]"']*/i,
            lookbehind: true,
            greedy: true,
            alias: 'string'
        },
        date: {
            pattern: RegExp(/\b\d{4}[-/]\d{2}[-/]\d{2}(?:T(?=\d{1,2}:)|(?=\s\d{1,2}:))/.source + '|' + /\b\d{1,4}[-/ ](?:\d{1,2}|Apr|Aug|Dec|Feb|Jan|Jul|Jun|Mar|May|Nov|Oct|Sep)[-/ ]\d{2,4}T?\b/.source + '|' + /\b(?:(?:Fri|Mon|Sat|Sun|Thu|Tue|Wed)(?:\s{1,2}(?:Apr|Aug|Dec|Feb|Jan|Jul|Jun|Mar|May|Nov|Oct|Sep))?|Apr|Aug|Dec|Feb|Jan|Jul|Jun|Mar|May|Nov|Oct|Sep)\s{1,2}\d{1,2}\b/.source, 'i'),
            alias: 'number'
        },
        time: {
            pattern: /\b\d{1,2}:\d{1,2}:\d{1,2}(?:[.,:]\d+)?(?:\s?[+-]\d{2}:?\d{2}|Z)?\b/,
            alias: 'number'
        },
        boolean: /\b(?:false|null|true)\b/i,
        number: {
            pattern: /(^|[^.\w])(?:0x[a-f0-9]+|0o[0-7]+|0b[01]+|v?\d[\da-f]*(?:\.\d+)*(?:e[+-]?\d+)?[a-z]{0,3}\b)\b(?!\.\w)/i,
            lookbehind: true
        },
        operator: /[;:?<=>~/@!$%&+\-|^(){}*#]/,
        punctuation: /[\[\].,]/
    };
}

});

parcelRegister("1UNDH", function(module, exports) {
'use strict';
module.exports = $165186bdbaa2aa3e$var$lolcode;
$165186bdbaa2aa3e$var$lolcode.displayName = 'lolcode';
$165186bdbaa2aa3e$var$lolcode.aliases = [];
function $165186bdbaa2aa3e$var$lolcode(Prism) {
    Prism.languages.lolcode = {
        comment: [
            /\bOBTW\s[\s\S]*?\sTLDR\b/,
            /\bBTW.+/
        ],
        string: {
            pattern: /"(?::.|[^":])*"/,
            inside: {
                variable: /:\{[^}]+\}/,
                symbol: [
                    /:\([a-f\d]+\)/i,
                    /:\[[^\]]+\]/,
                    /:[)>o":]/
                ]
            },
            greedy: true
        },
        number: /(?:\B-)?(?:\b\d+(?:\.\d*)?|\B\.\d+)/,
        symbol: {
            pattern: /(^|\s)(?:A )?(?:BUKKIT|NOOB|NUMBAR|NUMBR|TROOF|YARN)(?=\s|,|$)/,
            lookbehind: true,
            inside: {
                keyword: /A(?=\s)/
            }
        },
        label: {
            pattern: /((?:^|\s)(?:IM IN YR|IM OUTTA YR) )[a-zA-Z]\w*/,
            lookbehind: true,
            alias: 'string'
        },
        function: {
            pattern: /((?:^|\s)(?:HOW IZ I|I IZ|IZ) )[a-zA-Z]\w*/,
            lookbehind: true
        },
        keyword: [
            {
                pattern: /(^|\s)(?:AN|FOUND YR|GIMMEH|GTFO|HAI|HAS A|HOW IZ I|I HAS A|I IZ|IF U SAY SO|IM IN YR|IM OUTTA YR|IS NOW(?: A)?|ITZ(?: A)?|IZ|KTHX|KTHXBYE|LIEK(?: A)?|MAEK|MEBBE|MKAY|NERFIN|NO WAI|O HAI IM|O RLY\?|OIC|OMG|OMGWTF|R|SMOOSH|SRS|TIL|UPPIN|VISIBLE|WILE|WTF\?|YA RLY|YR)(?=\s|,|$)/,
                lookbehind: true
            },
            /'Z(?=\s|,|$)/
        ],
        boolean: {
            pattern: /(^|\s)(?:FAIL|WIN)(?=\s|,|$)/,
            lookbehind: true
        },
        variable: {
            pattern: /(^|\s)IT(?=\s|,|$)/,
            lookbehind: true
        },
        operator: {
            pattern: /(^|\s)(?:NOT|BOTH SAEM|DIFFRINT|(?:ALL|ANY|BIGGR|BOTH|DIFF|EITHER|MOD|PRODUKT|QUOSHUNT|SMALLR|SUM|WON) OF)(?=\s|,|$)/,
            lookbehind: true
        },
        punctuation: /\.{3}|…|,|!/
    };
}

});

parcelRegister("ctJUb", function(module, exports) {
'use strict';
module.exports = $915bcd4301b10a4f$var$magma;
$915bcd4301b10a4f$var$magma.displayName = 'magma';
$915bcd4301b10a4f$var$magma.aliases = [];
function $915bcd4301b10a4f$var$magma(Prism) {
    Prism.languages.magma = {
        output: {
            pattern: /^(>.*(?:\r(?:\n|(?!\n))|\n))(?!>)(?:.+|(?:\r(?:\n|(?!\n))|\n)(?!>).*)(?:(?:\r(?:\n|(?!\n))|\n)(?!>).*)*/m,
            lookbehind: true,
            greedy: true
        },
        comment: {
            pattern: /\/\/.*|\/\*[\s\S]*?\*\//,
            greedy: true
        },
        string: {
            pattern: /(^|[^\\"])"(?:[^\r\n\\"]|\\.)*"/,
            lookbehind: true,
            greedy: true
        },
        // http://magma.maths.usyd.edu.au/magma/handbook/text/82
        keyword: /\b(?:_|adj|and|assert|assert2|assert3|assigned|break|by|case|cat|catch|clear|cmpeq|cmpne|continue|declare|default|delete|diff|div|do|elif|else|end|eq|error|eval|exists|exit|for|forall|forward|fprintf|freeze|function|ge|gt|if|iload|import|in|intrinsic|is|join|le|load|local|lt|meet|mod|ne|not|notadj|notin|notsubset|or|print|printf|procedure|quit|random|read|readi|repeat|require|requirege|requirerange|restore|return|save|sdiff|select|subset|then|time|to|try|until|vprint|vprintf|vtime|when|where|while|xor)\b/,
        boolean: /\b(?:false|true)\b/,
        generator: {
            pattern: /\b[a-z_]\w*(?=\s*<)/i,
            alias: 'class-name'
        },
        function: /\b[a-z_]\w*(?=\s*\()/i,
        number: {
            pattern: /(^|[^\w.]|\.\.)(?:\d+(?:\.\d*)?|\.\d+)(?:[eE][+-]?\d+)?(?:_[a-z]?)?(?=$|[^\w.]|\.\.)/,
            lookbehind: true
        },
        operator: /->|[-+*/^~!|#=]|:=|\.\./,
        punctuation: /[()[\]{}<>,;.:]/
    };
}

});

parcelRegister("lDTsy", function(module, exports) {
'use strict';
module.exports = $fc1842a01fa9d9bf$var$makefile;
$fc1842a01fa9d9bf$var$makefile.displayName = 'makefile';
$fc1842a01fa9d9bf$var$makefile.aliases = [];
function $fc1842a01fa9d9bf$var$makefile(Prism) {
    Prism.languages.makefile = {
        comment: {
            pattern: /(^|[^\\])#(?:\\(?:\r\n|[\s\S])|[^\\\r\n])*/,
            lookbehind: true
        },
        string: {
            pattern: /(["'])(?:\\(?:\r\n|[\s\S])|(?!\1)[^\\\r\n])*\1/,
            greedy: true
        },
        'builtin-target': {
            pattern: /\.[A-Z][^:#=\s]+(?=\s*:(?!=))/,
            alias: 'builtin'
        },
        target: {
            pattern: /^(?:[^:=\s]|[ \t]+(?![\s:]))+(?=\s*:(?!=))/m,
            alias: 'symbol',
            inside: {
                variable: /\$+(?:(?!\$)[^(){}:#=\s]+|(?=[({]))/
            }
        },
        variable: /\$+(?:(?!\$)[^(){}:#=\s]+|\([@*%<^+?][DF]\)|(?=[({]))/,
        // Directives
        keyword: /-include\b|\b(?:define|else|endef|endif|export|ifn?def|ifn?eq|include|override|private|sinclude|undefine|unexport|vpath)\b/,
        function: {
            pattern: /(\()(?:abspath|addsuffix|and|basename|call|dir|error|eval|file|filter(?:-out)?|findstring|firstword|flavor|foreach|guile|if|info|join|lastword|load|notdir|or|origin|patsubst|realpath|shell|sort|strip|subst|suffix|value|warning|wildcard|word(?:list|s)?)(?=[ \t])/,
            lookbehind: true
        },
        operator: /(?:::|[?:+!])?=|[|@]/,
        punctuation: /[:;(){}]/
    };
}

});

parcelRegister("4KOYm", function(module, exports) {
'use strict';
module.exports = $3762ff5eda31d99b$var$markdown;
$3762ff5eda31d99b$var$markdown.displayName = 'markdown';
$3762ff5eda31d99b$var$markdown.aliases = [
    'md'
];
function $3762ff5eda31d99b$var$markdown(Prism) {
    (function(Prism) {
        // Allow only one line break
        var inner = /(?:\\.|[^\\\n\r]|(?:\n|\r\n?)(?![\r\n]))/.source;
        /**
     * This function is intended for the creation of the bold or italic pattern.
     *
     * This also adds a lookbehind group to the given pattern to ensure that the pattern is not backslash-escaped.
     *
     * _Note:_ Keep in mind that this adds a capturing group.
     *
     * @param {string} pattern
     * @returns {RegExp}
     */ function createInline(pattern) {
            pattern = pattern.replace(/<inner>/g, function() {
                return inner;
            });
            return RegExp(/((?:^|[^\\])(?:\\{2})*)/.source + '(?:' + pattern + ')');
        }
        var tableCell = /(?:\\.|``(?:[^`\r\n]|`(?!`))+``|`[^`\r\n]+`|[^\\|\r\n`])+/.source;
        var tableRow = /\|?__(?:\|__)+\|?(?:(?:\n|\r\n?)|(?![\s\S]))/.source.replace(/__/g, function() {
            return tableCell;
        });
        var tableLine = /\|?[ \t]*:?-{3,}:?[ \t]*(?:\|[ \t]*:?-{3,}:?[ \t]*)+\|?(?:\n|\r\n?)/.source;
        Prism.languages.markdown = Prism.languages.extend('markup', {});
        Prism.languages.insertBefore('markdown', 'prolog', {
            'front-matter-block': {
                pattern: /(^(?:\s*[\r\n])?)---(?!.)[\s\S]*?[\r\n]---(?!.)/,
                lookbehind: true,
                greedy: true,
                inside: {
                    punctuation: /^---|---$/,
                    'front-matter': {
                        pattern: /\S+(?:\s+\S+)*/,
                        alias: [
                            'yaml',
                            'language-yaml'
                        ],
                        inside: Prism.languages.yaml
                    }
                }
            },
            blockquote: {
                // > ...
                pattern: /^>(?:[\t ]*>)*/m,
                alias: 'punctuation'
            },
            table: {
                pattern: RegExp('^' + tableRow + tableLine + '(?:' + tableRow + ')*', 'm'),
                inside: {
                    'table-data-rows': {
                        pattern: RegExp('^(' + tableRow + tableLine + ')(?:' + tableRow + ')*$'),
                        lookbehind: true,
                        inside: {
                            'table-data': {
                                pattern: RegExp(tableCell),
                                inside: Prism.languages.markdown
                            },
                            punctuation: /\|/
                        }
                    },
                    'table-line': {
                        pattern: RegExp('^(' + tableRow + ')' + tableLine + '$'),
                        lookbehind: true,
                        inside: {
                            punctuation: /\||:?-{3,}:?/
                        }
                    },
                    'table-header-row': {
                        pattern: RegExp('^' + tableRow + '$'),
                        inside: {
                            'table-header': {
                                pattern: RegExp(tableCell),
                                alias: 'important',
                                inside: Prism.languages.markdown
                            },
                            punctuation: /\|/
                        }
                    }
                }
            },
            code: [
                {
                    // Prefixed by 4 spaces or 1 tab and preceded by an empty line
                    pattern: /((?:^|\n)[ \t]*\n|(?:^|\r\n?)[ \t]*\r\n?)(?: {4}|\t).+(?:(?:\n|\r\n?)(?: {4}|\t).+)*/,
                    lookbehind: true,
                    alias: 'keyword'
                },
                {
                    // ```optional language
                    // code block
                    // ```
                    pattern: /^```[\s\S]*?^```$/m,
                    greedy: true,
                    inside: {
                        'code-block': {
                            pattern: /^(```.*(?:\n|\r\n?))[\s\S]+?(?=(?:\n|\r\n?)^```$)/m,
                            lookbehind: true
                        },
                        'code-language': {
                            pattern: /^(```).+/,
                            lookbehind: true
                        },
                        punctuation: /```/
                    }
                }
            ],
            title: [
                {
                    // title 1
                    // =======
                    // title 2
                    // -------
                    pattern: /\S.*(?:\n|\r\n?)(?:==+|--+)(?=[ \t]*$)/m,
                    alias: 'important',
                    inside: {
                        punctuation: /==+$|--+$/
                    }
                },
                {
                    // # title 1
                    // ###### title 6
                    pattern: /(^\s*)#.+/m,
                    lookbehind: true,
                    alias: 'important',
                    inside: {
                        punctuation: /^#+|#+$/
                    }
                }
            ],
            hr: {
                // ***
                // ---
                // * * *
                // -----------
                pattern: /(^\s*)([*-])(?:[\t ]*\2){2,}(?=\s*$)/m,
                lookbehind: true,
                alias: 'punctuation'
            },
            list: {
                // * item
                // + item
                // - item
                // 1. item
                pattern: /(^\s*)(?:[*+-]|\d+\.)(?=[\t ].)/m,
                lookbehind: true,
                alias: 'punctuation'
            },
            'url-reference': {
                // [id]: http://example.com "Optional title"
                // [id]: http://example.com 'Optional title'
                // [id]: http://example.com (Optional title)
                // [id]: <http://example.com> "Optional title"
                pattern: /!?\[[^\]]+\]:[\t ]+(?:\S+|<(?:\\.|[^>\\])+>)(?:[\t ]+(?:"(?:\\.|[^"\\])*"|'(?:\\.|[^'\\])*'|\((?:\\.|[^)\\])*\)))?/,
                inside: {
                    variable: {
                        pattern: /^(!?\[)[^\]]+/,
                        lookbehind: true
                    },
                    string: /(?:"(?:\\.|[^"\\])*"|'(?:\\.|[^'\\])*'|\((?:\\.|[^)\\])*\))$/,
                    punctuation: /^[\[\]!:]|[<>]/
                },
                alias: 'url'
            },
            bold: {
                // **strong**
                // __strong__
                // allow one nested instance of italic text using the same delimiter
                pattern: createInline(/\b__(?:(?!_)<inner>|_(?:(?!_)<inner>)+_)+__\b|\*\*(?:(?!\*)<inner>|\*(?:(?!\*)<inner>)+\*)+\*\*/.source),
                lookbehind: true,
                greedy: true,
                inside: {
                    content: {
                        pattern: /(^..)[\s\S]+(?=..$)/,
                        lookbehind: true,
                        inside: {} // see below
                    },
                    punctuation: /\*\*|__/
                }
            },
            italic: {
                // *em*
                // _em_
                // allow one nested instance of bold text using the same delimiter
                pattern: createInline(/\b_(?:(?!_)<inner>|__(?:(?!_)<inner>)+__)+_\b|\*(?:(?!\*)<inner>|\*\*(?:(?!\*)<inner>)+\*\*)+\*/.source),
                lookbehind: true,
                greedy: true,
                inside: {
                    content: {
                        pattern: /(^.)[\s\S]+(?=.$)/,
                        lookbehind: true,
                        inside: {} // see below
                    },
                    punctuation: /[*_]/
                }
            },
            strike: {
                // ~~strike through~~
                // ~strike~
                // eslint-disable-next-line regexp/strict
                pattern: createInline(/(~~?)(?:(?!~)<inner>)+\2/.source),
                lookbehind: true,
                greedy: true,
                inside: {
                    content: {
                        pattern: /(^~~?)[\s\S]+(?=\1$)/,
                        lookbehind: true,
                        inside: {} // see below
                    },
                    punctuation: /~~?/
                }
            },
            'code-snippet': {
                // `code`
                // ``code``
                pattern: /(^|[^\\`])(?:``[^`\r\n]+(?:`[^`\r\n]+)*``(?!`)|`[^`\r\n]+`(?!`))/,
                lookbehind: true,
                greedy: true,
                alias: [
                    'code',
                    'keyword'
                ]
            },
            url: {
                // [example](http://example.com "Optional title")
                // [example][id]
                // [example] [id]
                pattern: createInline(/!?\[(?:(?!\])<inner>)+\](?:\([^\s)]+(?:[\t ]+"(?:\\.|[^"\\])*")?\)|[ \t]?\[(?:(?!\])<inner>)+\])/.source),
                lookbehind: true,
                greedy: true,
                inside: {
                    operator: /^!/,
                    content: {
                        pattern: /(^\[)[^\]]+(?=\])/,
                        lookbehind: true,
                        inside: {} // see below
                    },
                    variable: {
                        pattern: /(^\][ \t]?\[)[^\]]+(?=\]$)/,
                        lookbehind: true
                    },
                    url: {
                        pattern: /(^\]\()[^\s)]+/,
                        lookbehind: true
                    },
                    string: {
                        pattern: /(^[ \t]+)"(?:\\.|[^"\\])*"(?=\)$)/,
                        lookbehind: true
                    }
                }
            }
        });
        [
            'url',
            'bold',
            'italic',
            'strike'
        ].forEach(function(token) {
            [
                'url',
                'bold',
                'italic',
                'strike',
                'code-snippet'
            ].forEach(function(inside) {
                if (token !== inside) Prism.languages.markdown[token].inside.content.inside[inside] = Prism.languages.markdown[inside];
            });
        });
        Prism.hooks.add('after-tokenize', function(env) {
            if (env.language !== 'markdown' && env.language !== 'md') return;
            function walkTokens(tokens) {
                if (!tokens || typeof tokens === 'string') return;
                for(var i = 0, l = tokens.length; i < l; i++){
                    var token = tokens[i];
                    if (token.type !== 'code') {
                        walkTokens(token.content);
                        continue;
                    }
                    /*
           * Add the correct `language-xxxx` class to this code block. Keep in mind that the `code-language` token
           * is optional. But the grammar is defined so that there is only one case we have to handle:
           *
           * token.content = [
           *     <span class="punctuation">```</span>,
           *     <span class="code-language">xxxx</span>,
           *     '\n', // exactly one new lines (\r or \n or \r\n)
           *     <span class="code-block">...</span>,
           *     '\n', // exactly one new lines again
           *     <span class="punctuation">```</span>
           * ];
           */ var codeLang = token.content[1];
                    var codeBlock = token.content[3];
                    if (codeLang && codeBlock && codeLang.type === 'code-language' && codeBlock.type === 'code-block' && typeof codeLang.content === 'string') {
                        // this might be a language that Prism does not support
                        // do some replacements to support C++, C#, and F#
                        var lang = codeLang.content.replace(/\b#/g, 'sharp').replace(/\b\+\+/g, 'pp') // only use the first word
                        ;
                        lang = (/[a-z][\w-]*/i.exec(lang) || [
                            ''
                        ])[0].toLowerCase();
                        var alias = 'language-' + lang // add alias
                        ;
                        if (!codeBlock.alias) codeBlock.alias = [
                            alias
                        ];
                        else if (typeof codeBlock.alias === 'string') codeBlock.alias = [
                            codeBlock.alias,
                            alias
                        ];
                        else codeBlock.alias.push(alias);
                    }
                }
            }
            walkTokens(env.tokens);
        });
        Prism.hooks.add('wrap', function(env) {
            if (env.type !== 'code-block') return;
            var codeLang = '';
            for(var i = 0, l = env.classes.length; i < l; i++){
                var cls = env.classes[i];
                var match = /language-(.+)/.exec(cls);
                if (match) {
                    codeLang = match[1];
                    break;
                }
            }
            var grammar = Prism.languages[codeLang];
            if (!grammar) {
                if (codeLang && codeLang !== 'none' && Prism.plugins.autoloader) {
                    var id = 'md-' + new Date().valueOf() + '-' + Math.floor(Math.random() * 1e16);
                    env.attributes['id'] = id;
                    Prism.plugins.autoloader.loadLanguages(codeLang, function() {
                        var ele = document.getElementById(id);
                        if (ele) ele.innerHTML = Prism.highlight(ele.textContent, Prism.languages[codeLang], codeLang);
                    });
                }
            } else env.content = Prism.highlight(textContent(env.content.value), grammar, codeLang);
        });
        var tagPattern = RegExp(Prism.languages.markup.tag.pattern.source, 'gi');
        /**
     * A list of known entity names.
     *
     * This will always be incomplete to save space. The current list is the one used by lowdash's unescape function.
     *
     * @see {@link https://github.com/lodash/lodash/blob/2da024c3b4f9947a48517639de7560457cd4ec6c/unescape.js#L2}
     */ var KNOWN_ENTITY_NAMES = {
            amp: '&',
            lt: '<',
            gt: '>',
            quot: '"'
        } // IE 11 doesn't support `String.fromCodePoint`
        ;
        var fromCodePoint = String.fromCodePoint || String.fromCharCode;
        /**
     * Returns the text content of a given HTML source code string.
     *
     * @param {string} html
     * @returns {string}
     */ function textContent(html) {
            // remove all tags
            var text = html.replace(tagPattern, '') // decode known entities
            ;
            text = text.replace(/&(\w{1,8}|#x?[\da-f]{1,8});/gi, function(m, code) {
                code = code.toLowerCase();
                if (code[0] === '#') {
                    var value;
                    if (code[1] === 'x') value = parseInt(code.slice(2), 16);
                    else value = Number(code.slice(1));
                    return fromCodePoint(value);
                } else {
                    var known = KNOWN_ENTITY_NAMES[code];
                    if (known) return known;
                     // unable to decode
                    return m;
                }
            });
            return text;
        }
        Prism.languages.md = Prism.languages.markdown;
    })(Prism);
}

});

parcelRegister("ln59X", function(module, exports) {
'use strict';
module.exports = $f8efbf863f81d1cf$var$matlab;
$f8efbf863f81d1cf$var$matlab.displayName = 'matlab';
$f8efbf863f81d1cf$var$matlab.aliases = [];
function $f8efbf863f81d1cf$var$matlab(Prism) {
    Prism.languages.matlab = {
        comment: [
            /%\{[\s\S]*?\}%/,
            /%.+/
        ],
        string: {
            pattern: /\B'(?:''|[^'\r\n])*'/,
            greedy: true
        },
        // FIXME We could handle imaginary numbers as a whole
        number: /(?:\b\d+(?:\.\d*)?|\B\.\d+)(?:[eE][+-]?\d+)?(?:[ij])?|\b[ij]\b/,
        keyword: /\b(?:NaN|break|case|catch|continue|else|elseif|end|for|function|if|inf|otherwise|parfor|pause|pi|return|switch|try|while)\b/,
        function: /\b(?!\d)\w+(?=\s*\()/,
        operator: /\.?[*^\/\\']|[+\-:@]|[<>=~]=?|&&?|\|\|?/,
        punctuation: /\.{3}|[.,;\[\](){}!]/
    };
}

});

parcelRegister("2npf9", function(module, exports) {
'use strict';
module.exports = $1bb14f93e706c05d$var$maxscript;
$1bb14f93e706c05d$var$maxscript.displayName = 'maxscript';
$1bb14f93e706c05d$var$maxscript.aliases = [];
function $1bb14f93e706c05d$var$maxscript(Prism) {
    (function(Prism) {
        var keywords = /\b(?:about|and|animate|as|at|attributes|by|case|catch|collect|continue|coordsys|do|else|exit|fn|for|from|function|global|if|in|local|macroscript|mapped|max|not|of|off|on|or|parameters|persistent|plugin|rcmenu|return|rollout|set|struct|then|throw|to|tool|try|undo|utility|when|where|while|with)\b/i;
        Prism.languages.maxscript = {
            comment: {
                pattern: /\/\*[\s\S]*?(?:\*\/|$)|--.*/,
                greedy: true
            },
            string: {
                pattern: /(^|[^"\\@])(?:"(?:[^"\\]|\\[\s\S])*"|@"[^"]*")/,
                lookbehind: true,
                greedy: true
            },
            path: {
                pattern: /\$(?:[\w/\\.*?]|'[^']*')*/,
                greedy: true,
                alias: 'string'
            },
            'function-call': {
                pattern: RegExp('((?:' + // start of line
                (/^/.source + '|' + // operators and other language constructs
                /[;=<>+\-*/^({\[]/.source + '|' + // keywords as part of statements
                /\b(?:and|by|case|catch|collect|do|else|if|in|not|or|return|then|to|try|where|while|with)\b/.source) + ')[ \t]*)' + '(?!' + keywords.source + ')' + /[a-z_]\w*\b/.source + '(?=[ \t]*(?:' + // variable
                ('(?!' + keywords.source + ')' + /[a-z_]/.source + '|' + // number
                /\d|-\.?\d/.source + '|' + // other expressions or literals
                /[({'"$@#?]/.source) + '))', 'im'),
                lookbehind: true,
                greedy: true,
                alias: 'function'
            },
            'function-definition': {
                pattern: /(\b(?:fn|function)\s+)\w+\b/i,
                lookbehind: true,
                alias: 'function'
            },
            argument: {
                pattern: /\b[a-z_]\w*(?=:)/i,
                alias: 'attr-name'
            },
            keyword: keywords,
            boolean: /\b(?:false|true)\b/,
            time: {
                pattern: /(^|[^\w.])(?:(?:(?:\d+(?:\.\d*)?|\.\d+)(?:[eEdD][+-]\d+|[LP])?[msft])+|\d+:\d+(?:\.\d*)?)(?![\w.:])/,
                lookbehind: true,
                alias: 'number'
            },
            number: [
                {
                    pattern: /(^|[^\w.])(?:(?:\d+(?:\.\d*)?|\.\d+)(?:[eEdD][+-]\d+|[LP])?|0x[a-fA-F0-9]+)(?![\w.:])/,
                    lookbehind: true
                },
                /\b(?:e|pi)\b/
            ],
            constant: /\b(?:dontcollect|ok|silentValue|undefined|unsupplied)\b/,
            color: {
                pattern: /\b(?:black|blue|brown|gray|green|orange|red|white|yellow)\b/i,
                alias: 'constant'
            },
            operator: /[-+*/<>=!]=?|[&^?]|#(?!\()/,
            punctuation: /[()\[\]{}.:,;]|#(?=\()|\\$/m
        };
    })(Prism);
}

});

parcelRegister("2SlBl", function(module, exports) {
'use strict';
module.exports = $2181617909d0d76e$var$mel;
$2181617909d0d76e$var$mel.displayName = 'mel';
$2181617909d0d76e$var$mel.aliases = [];
function $2181617909d0d76e$var$mel(Prism) {
    Prism.languages.mel = {
        comment: /\/\/.*/,
        code: {
            pattern: /`(?:\\.|[^\\`\r\n])*`/,
            greedy: true,
            alias: 'italic',
            inside: {
                delimiter: {
                    pattern: /^`|`$/,
                    alias: 'punctuation'
                } // See rest below
            }
        },
        string: {
            pattern: /"(?:\\.|[^\\"\r\n])*"/,
            greedy: true
        },
        variable: /\$\w+/,
        number: /\b0x[\da-fA-F]+\b|\b\d+(?:\.\d*)?|\B\.\d+/,
        flag: {
            pattern: /-[^\d\W]\w*/,
            alias: 'operator'
        },
        keyword: /\b(?:break|case|continue|default|do|else|float|for|global|if|in|int|matrix|proc|return|string|switch|vector|while)\b/,
        function: /\b\w+(?=\()|\b(?:CBG|HfAddAttractorToAS|HfAssignAS|HfBuildEqualMap|HfBuildFurFiles|HfBuildFurImages|HfCancelAFR|HfConnectASToHF|HfCreateAttractor|HfDeleteAS|HfEditAS|HfPerformCreateAS|HfRemoveAttractorFromAS|HfSelectAttached|HfSelectAttractors|HfUnAssignAS|Mayatomr|about|abs|addAttr|addAttributeEditorNodeHelp|addDynamic|addNewShelfTab|addPP|addPanelCategory|addPrefixToName|advanceToNextDrivenKey|affectedNet|affects|aimConstraint|air|alias|aliasAttr|align|alignCtx|alignCurve|alignSurface|allViewFit|ambientLight|angle|angleBetween|animCone|animCurveEditor|animDisplay|animView|annotate|appendStringArray|applicationName|applyAttrPreset|applyTake|arcLenDimContext|arcLengthDimension|arclen|arrayMapper|art3dPaintCtx|artAttrCtx|artAttrPaintVertexCtx|artAttrSkinPaintCtx|artAttrTool|artBuildPaintMenu|artFluidAttrCtx|artPuttyCtx|artSelectCtx|artSetPaintCtx|artUserPaintCtx|assignCommand|assignInputDevice|assignViewportFactories|attachCurve|attachDeviceAttr|attachSurface|attrColorSliderGrp|attrCompatibility|attrControlGrp|attrEnumOptionMenu|attrEnumOptionMenuGrp|attrFieldGrp|attrFieldSliderGrp|attrNavigationControlGrp|attrPresetEditWin|attributeExists|attributeInfo|attributeMenu|attributeQuery|autoKeyframe|autoPlace|bakeClip|bakeFluidShading|bakePartialHistory|bakeResults|bakeSimulation|basename|basenameEx|batchRender|bessel|bevel|bevelPlus|binMembership|bindSkin|blend2|blendShape|blendShapeEditor|blendShapePanel|blendTwoAttr|blindDataType|boneLattice|boundary|boxDollyCtx|boxZoomCtx|bufferCurve|buildBookmarkMenu|buildKeyframeMenu|button|buttonManip|cacheFile|cacheFileCombine|cacheFileMerge|cacheFileTrack|camera|cameraView|canCreateManip|canvas|capitalizeString|catch|catchQuiet|ceil|changeSubdivComponentDisplayLevel|changeSubdivRegion|channelBox|character|characterMap|characterOutlineEditor|characterize|chdir|checkBox|checkBoxGrp|checkDefaultRenderGlobals|choice|circle|circularFillet|clamp|clear|clearCache|clip|clipEditor|clipEditorCurrentTimeCtx|clipSchedule|clipSchedulerOutliner|clipTrimBefore|closeCurve|closeSurface|cluster|cmdFileOutput|cmdScrollFieldExecuter|cmdScrollFieldReporter|cmdShell|coarsenSubdivSelectionList|collision|color|colorAtPoint|colorEditor|colorIndex|colorIndexSliderGrp|colorSliderButtonGrp|colorSliderGrp|columnLayout|commandEcho|commandLine|commandPort|compactHairSystem|componentEditor|compositingInterop|computePolysetVolume|condition|cone|confirmDialog|connectAttr|connectControl|connectDynamic|connectJoint|connectionInfo|constrain|constrainValue|constructionHistory|container|containsMultibyte|contextInfo|control|convertFromOldLayers|convertIffToPsd|convertLightmap|convertSolidTx|convertTessellation|convertUnit|copyArray|copyFlexor|copyKey|copySkinWeights|cos|cpButton|cpCache|cpClothSet|cpCollision|cpConstraint|cpConvClothToMesh|cpForces|cpGetSolverAttr|cpPanel|cpProperty|cpRigidCollisionFilter|cpSeam|cpSetEdit|cpSetSolverAttr|cpSolver|cpSolverTypes|cpTool|cpUpdateClothUVs|createDisplayLayer|createDrawCtx|createEditor|createLayeredPsdFile|createMotionField|createNewShelf|createNode|createRenderLayer|createSubdivRegion|cross|crossProduct|ctxAbort|ctxCompletion|ctxEditMode|ctxTraverse|currentCtx|currentTime|currentTimeCtx|currentUnit|curve|curveAddPtCtx|curveCVCtx|curveEPCtx|curveEditorCtx|curveIntersect|curveMoveEPCtx|curveOnSurface|curveSketchCtx|cutKey|cycleCheck|cylinder|dagPose|date|defaultLightListCheckBox|defaultNavigation|defineDataServer|defineVirtualDevice|deformer|deg_to_rad|delete|deleteAttr|deleteShadingGroupsAndMaterials|deleteShelfTab|deleteUI|deleteUnusedBrushes|delrandstr|detachCurve|detachDeviceAttr|detachSurface|deviceEditor|devicePanel|dgInfo|dgdirty|dgeval|dgtimer|dimWhen|directKeyCtx|directionalLight|dirmap|dirname|disable|disconnectAttr|disconnectJoint|diskCache|displacementToPoly|displayAffected|displayColor|displayCull|displayLevelOfDetail|displayPref|displayRGBColor|displaySmoothness|displayStats|displayString|displaySurface|distanceDimContext|distanceDimension|doBlur|dolly|dollyCtx|dopeSheetEditor|dot|dotProduct|doubleProfileBirailSurface|drag|dragAttrContext|draggerContext|dropoffLocator|duplicate|duplicateCurve|duplicateSurface|dynCache|dynControl|dynExport|dynExpression|dynGlobals|dynPaintEditor|dynParticleCtx|dynPref|dynRelEdPanel|dynRelEditor|dynamicLoad|editAttrLimits|editDisplayLayerGlobals|editDisplayLayerMembers|editRenderLayerAdjustment|editRenderLayerGlobals|editRenderLayerMembers|editor|editorTemplate|effector|emit|emitter|enableDevice|encodeString|endString|endsWith|env|equivalent|equivalentTol|erf|error|eval|evalDeferred|evalEcho|event|exactWorldBoundingBox|exclusiveLightCheckBox|exec|executeForEachObject|exists|exp|expression|expressionEditorListen|extendCurve|extendSurface|extrude|fcheck|fclose|feof|fflush|fgetline|fgetword|file|fileBrowserDialog|fileDialog|fileExtension|fileInfo|filetest|filletCurve|filter|filterCurve|filterExpand|filterStudioImport|findAllIntersections|findAnimCurves|findKeyframe|findMenuItem|findRelatedSkinCluster|finder|firstParentOf|fitBspline|flexor|floatEq|floatField|floatFieldGrp|floatScrollBar|floatSlider|floatSlider2|floatSliderButtonGrp|floatSliderGrp|floor|flow|fluidCacheInfo|fluidEmitter|fluidVoxelInfo|flushUndo|fmod|fontDialog|fopen|formLayout|format|fprint|frameLayout|fread|freeFormFillet|frewind|fromNativePath|fwrite|gamma|gauss|geometryConstraint|getApplicationVersionAsFloat|getAttr|getClassification|getDefaultBrush|getFileList|getFluidAttr|getInputDeviceRange|getMayaPanelTypes|getModifiers|getPanel|getParticleAttr|getPluginResource|getenv|getpid|glRender|glRenderEditor|globalStitch|gmatch|goal|gotoBindPose|grabColor|gradientControl|gradientControlNoAttr|graphDollyCtx|graphSelectContext|graphTrackCtx|gravity|grid|gridLayout|group|groupObjectsByName|hardenPointCurve|hardware|hardwareRenderPanel|headsUpDisplay|headsUpMessage|help|helpLine|hermite|hide|hilite|hitTest|hotBox|hotkey|hotkeyCheck|hsv_to_rgb|hudButton|hudSlider|hudSliderButton|hwReflectionMap|hwRender|hwRenderLoad|hyperGraph|hyperPanel|hyperShade|hypot|iconTextButton|iconTextCheckBox|iconTextRadioButton|iconTextRadioCollection|iconTextScrollList|iconTextStaticLabel|ikHandle|ikHandleCtx|ikHandleDisplayScale|ikSolver|ikSplineHandleCtx|ikSystem|ikSystemInfo|ikfkDisplayMethod|illustratorCurves|image|imfPlugins|inheritTransform|insertJoint|insertJointCtx|insertKeyCtx|insertKnotCurve|insertKnotSurface|instance|instanceable|instancer|intField|intFieldGrp|intScrollBar|intSlider|intSliderGrp|interToUI|internalVar|intersect|iprEngine|isAnimCurve|isConnected|isDirty|isParentOf|isSameObject|isTrue|isValidObjectName|isValidString|isValidUiName|isolateSelect|itemFilter|itemFilterAttr|itemFilterRender|itemFilterType|joint|jointCluster|jointCtx|jointDisplayScale|jointLattice|keyTangent|keyframe|keyframeOutliner|keyframeRegionCurrentTimeCtx|keyframeRegionDirectKeyCtx|keyframeRegionDollyCtx|keyframeRegionInsertKeyCtx|keyframeRegionMoveKeyCtx|keyframeRegionScaleKeyCtx|keyframeRegionSelectKeyCtx|keyframeRegionSetKeyCtx|keyframeRegionTrackCtx|keyframeStats|lassoContext|lattice|latticeDeformKeyCtx|launch|launchImageEditor|layerButton|layeredShaderPort|layeredTexturePort|layout|layoutDialog|lightList|lightListEditor|lightListPanel|lightlink|lineIntersection|linearPrecision|linstep|listAnimatable|listAttr|listCameras|listConnections|listDeviceAttachments|listHistory|listInputDeviceAxes|listInputDeviceButtons|listInputDevices|listMenuAnnotation|listNodeTypes|listPanelCategories|listRelatives|listSets|listTransforms|listUnselected|listerEditor|loadFluid|loadNewShelf|loadPlugin|loadPluginLanguageResources|loadPrefObjects|localizedPanelLabel|lockNode|loft|log|longNameOf|lookThru|ls|lsThroughFilter|lsType|lsUI|mag|makeIdentity|makeLive|makePaintable|makeRoll|makeSingleSurface|makeTubeOn|makebot|manipMoveContext|manipMoveLimitsCtx|manipOptions|manipRotateContext|manipRotateLimitsCtx|manipScaleContext|manipScaleLimitsCtx|marker|match|max|memory|menu|menuBarLayout|menuEditor|menuItem|menuItemToShelf|menuSet|menuSetPref|messageLine|min|minimizeApp|mirrorJoint|modelCurrentTimeCtx|modelEditor|modelPanel|mouse|movIn|movOut|move|moveIKtoFK|moveKeyCtx|moveVertexAlongDirection|multiProfileBirailSurface|mute|nParticle|nameCommand|nameField|namespace|namespaceInfo|newPanelItems|newton|nodeCast|nodeIconButton|nodeOutliner|nodePreset|nodeType|noise|nonLinear|normalConstraint|normalize|nurbsBoolean|nurbsCopyUVSet|nurbsCube|nurbsEditUV|nurbsPlane|nurbsSelect|nurbsSquare|nurbsToPoly|nurbsToPolygonsPref|nurbsToSubdiv|nurbsToSubdivPref|nurbsUVSet|nurbsViewDirectionVector|objExists|objectCenter|objectLayer|objectType|objectTypeUI|obsoleteProc|oceanNurbsPreviewPlane|offsetCurve|offsetCurveOnSurface|offsetSurface|openGLExtension|openMayaPref|optionMenu|optionMenuGrp|optionVar|orbit|orbitCtx|orientConstraint|outlinerEditor|outlinerPanel|overrideModifier|paintEffectsDisplay|pairBlend|palettePort|paneLayout|panel|panelConfiguration|panelHistory|paramDimContext|paramDimension|paramLocator|parent|parentConstraint|particle|particleExists|particleInstancer|particleRenderInfo|partition|pasteKey|pathAnimation|pause|pclose|percent|performanceOptions|pfxstrokes|pickWalk|picture|pixelMove|planarSrf|plane|play|playbackOptions|playblast|plugAttr|plugNode|pluginInfo|pluginResourceUtil|pointConstraint|pointCurveConstraint|pointLight|pointMatrixMult|pointOnCurve|pointOnSurface|pointPosition|poleVectorConstraint|polyAppend|polyAppendFacetCtx|polyAppendVertex|polyAutoProjection|polyAverageNormal|polyAverageVertex|polyBevel|polyBlendColor|polyBlindData|polyBoolOp|polyBridgeEdge|polyCacheMonitor|polyCheck|polyChipOff|polyClipboard|polyCloseBorder|polyCollapseEdge|polyCollapseFacet|polyColorBlindData|polyColorDel|polyColorPerVertex|polyColorSet|polyCompare|polyCone|polyCopyUV|polyCrease|polyCreaseCtx|polyCreateFacet|polyCreateFacetCtx|polyCube|polyCut|polyCutCtx|polyCylinder|polyCylindricalProjection|polyDelEdge|polyDelFacet|polyDelVertex|polyDuplicateAndConnect|polyDuplicateEdge|polyEditUV|polyEditUVShell|polyEvaluate|polyExtrudeEdge|polyExtrudeFacet|polyExtrudeVertex|polyFlipEdge|polyFlipUV|polyForceUV|polyGeoSampler|polyHelix|polyInfo|polyInstallAction|polyLayoutUV|polyListComponentConversion|polyMapCut|polyMapDel|polyMapSew|polyMapSewMove|polyMergeEdge|polyMergeEdgeCtx|polyMergeFacet|polyMergeFacetCtx|polyMergeUV|polyMergeVertex|polyMirrorFace|polyMoveEdge|polyMoveFacet|polyMoveFacetUV|polyMoveUV|polyMoveVertex|polyNormal|polyNormalPerVertex|polyNormalizeUV|polyOptUvs|polyOptions|polyOutput|polyPipe|polyPlanarProjection|polyPlane|polyPlatonicSolid|polyPoke|polyPrimitive|polyPrism|polyProjection|polyPyramid|polyQuad|polyQueryBlindData|polyReduce|polySelect|polySelectConstraint|polySelectConstraintMonitor|polySelectCtx|polySelectEditCtx|polySeparate|polySetToFaceNormal|polySewEdge|polyShortestPathCtx|polySmooth|polySoftEdge|polySphere|polySphericalProjection|polySplit|polySplitCtx|polySplitEdge|polySplitRing|polySplitVertex|polyStraightenUVBorder|polySubdivideEdge|polySubdivideFacet|polyToSubdiv|polyTorus|polyTransfer|polyTriangulate|polyUVSet|polyUnite|polyWedgeFace|popen|popupMenu|pose|pow|preloadRefEd|print|progressBar|progressWindow|projFileViewer|projectCurve|projectTangent|projectionContext|projectionManip|promptDialog|propModCtx|propMove|psdChannelOutliner|psdEditTextureFile|psdExport|psdTextureFile|putenv|pwd|python|querySubdiv|quit|rad_to_deg|radial|radioButton|radioButtonGrp|radioCollection|radioMenuItemCollection|rampColorPort|rand|randomizeFollicles|randstate|rangeControl|readTake|rebuildCurve|rebuildSurface|recordAttr|recordDevice|redo|reference|referenceEdit|referenceQuery|refineSubdivSelectionList|refresh|refreshAE|registerPluginResource|rehash|reloadImage|removeJoint|removeMultiInstance|removePanelCategory|rename|renameAttr|renameSelectionList|renameUI|render|renderGlobalsNode|renderInfo|renderLayerButton|renderLayerParent|renderLayerPostProcess|renderLayerUnparent|renderManip|renderPartition|renderQualityNode|renderSettings|renderThumbnailUpdate|renderWindowEditor|renderWindowSelectContext|renderer|reorder|reorderDeformers|requires|reroot|resampleFluid|resetAE|resetPfxToPolyCamera|resetTool|resolutionNode|retarget|reverseCurve|reverseSurface|revolve|rgb_to_hsv|rigidBody|rigidSolver|roll|rollCtx|rootOf|rot|rotate|rotationInterpolation|roundConstantRadius|rowColumnLayout|rowLayout|runTimeCommand|runup|sampleImage|saveAllShelves|saveAttrPreset|saveFluid|saveImage|saveInitialState|saveMenu|savePrefObjects|savePrefs|saveShelf|saveToolSettings|scale|scaleBrushBrightness|scaleComponents|scaleConstraint|scaleKey|scaleKeyCtx|sceneEditor|sceneUIReplacement|scmh|scriptCtx|scriptEditorInfo|scriptJob|scriptNode|scriptTable|scriptToShelf|scriptedPanel|scriptedPanelType|scrollField|scrollLayout|sculpt|searchPathArray|seed|selLoadSettings|select|selectContext|selectCurveCV|selectKey|selectKeyCtx|selectKeyframeRegionCtx|selectMode|selectPref|selectPriority|selectType|selectedNodes|selectionConnection|separator|setAttr|setAttrEnumResource|setAttrMapping|setAttrNiceNameResource|setConstraintRestPosition|setDefaultShadingGroup|setDrivenKeyframe|setDynamic|setEditCtx|setEditor|setFluidAttr|setFocus|setInfinity|setInputDeviceMapping|setKeyCtx|setKeyPath|setKeyframe|setKeyframeBlendshapeTargetWts|setMenuMode|setNodeNiceNameResource|setNodeTypeFlag|setParent|setParticleAttr|setPfxToPolyCamera|setPluginResource|setProject|setStampDensity|setStartupMessage|setState|setToolTo|setUITemplate|setXformManip|sets|shadingConnection|shadingGeometryRelCtx|shadingLightRelCtx|shadingNetworkCompare|shadingNode|shapeCompare|shelfButton|shelfLayout|shelfTabLayout|shellField|shortNameOf|showHelp|showHidden|showManipCtx|showSelectionInTitle|showShadingGroupAttrEditor|showWindow|sign|simplify|sin|singleProfileBirailSurface|size|sizeBytes|skinCluster|skinPercent|smoothCurve|smoothTangentSurface|smoothstep|snap2to2|snapKey|snapMode|snapTogetherCtx|snapshot|soft|softMod|softModCtx|sort|sound|soundControl|source|spaceLocator|sphere|sphrand|spotLight|spotLightPreviewPort|spreadSheetEditor|spring|sqrt|squareSurface|srtContext|stackTrace|startString|startsWith|stitchAndExplodeShell|stitchSurface|stitchSurfacePoints|strcmp|stringArrayCatenate|stringArrayContains|stringArrayCount|stringArrayInsertAtIndex|stringArrayIntersector|stringArrayRemove|stringArrayRemoveAtIndex|stringArrayRemoveDuplicates|stringArrayRemoveExact|stringArrayToString|stringToStringArray|strip|stripPrefixFromName|stroke|subdAutoProjection|subdCleanTopology|subdCollapse|subdDuplicateAndConnect|subdEditUV|subdListComponentConversion|subdMapCut|subdMapSewMove|subdMatchTopology|subdMirror|subdToBlind|subdToPoly|subdTransferUVsToCache|subdiv|subdivCrease|subdivDisplaySmoothness|substitute|substituteAllString|substituteGeometry|substring|surface|surfaceSampler|surfaceShaderList|swatchDisplayPort|switchTable|symbolButton|symbolCheckBox|sysFile|system|tabLayout|tan|tangentConstraint|texLatticeDeformContext|texManipContext|texMoveContext|texMoveUVShellContext|texRotateContext|texScaleContext|texSelectContext|texSelectShortestPathCtx|texSmudgeUVContext|texWinToolCtx|text|textCurves|textField|textFieldButtonGrp|textFieldGrp|textManip|textScrollList|textToShelf|textureDisplacePlane|textureHairColor|texturePlacementContext|textureWindow|threadCount|threePointArcCtx|timeControl|timePort|timerX|toNativePath|toggle|toggleAxis|toggleWindowVisibility|tokenize|tokenizeList|tolerance|tolower|toolButton|toolCollection|toolDropped|toolHasOptions|toolPropertyWindow|torus|toupper|trace|track|trackCtx|transferAttributes|transformCompare|transformLimits|translator|trim|trunc|truncateFluidCache|truncateHairCache|tumble|tumbleCtx|turbulence|twoPointArcCtx|uiRes|uiTemplate|unassignInputDevice|undo|undoInfo|ungroup|uniform|unit|unloadPlugin|untangleUV|untitledFileName|untrim|upAxis|updateAE|userCtx|uvLink|uvSnapshot|validateShelfName|vectorize|view2dToolCtx|viewCamera|viewClipPlane|viewFit|viewHeadOn|viewLookAt|viewManip|viewPlace|viewSet|visor|volumeAxis|vortex|waitCursor|warning|webBrowser|webBrowserPrefs|whatIs|window|windowPref|wire|wireContext|workspace|wrinkle|wrinkleContext|writeTake|xbmLangPathList|xform)\b/,
        operator: [
            /\+[+=]?|-[-=]?|&&|\|\||[<>]=|[*\/!=]=?|[%^]/,
            {
                // We don't want to match <<
                pattern: /(^|[^<])<(?!<)/,
                lookbehind: true
            },
            {
                // We don't want to match >>
                pattern: /(^|[^>])>(?!>)/,
                lookbehind: true
            }
        ],
        punctuation: /<<|>>|[.,:;?\[\](){}]/
    };
    Prism.languages.mel['code'].inside.rest = Prism.languages.mel;
}

});

parcelRegister("cekQS", function(module, exports) {
'use strict';
module.exports = $8e76f798071e4d8c$var$mermaid;
$8e76f798071e4d8c$var$mermaid.displayName = 'mermaid';
$8e76f798071e4d8c$var$mermaid.aliases = [];
function $8e76f798071e4d8c$var$mermaid(Prism) {
    Prism.languages.mermaid = {
        comment: {
            pattern: /%%.*/,
            greedy: true
        },
        style: {
            pattern: /^([ \t]*(?:classDef|linkStyle|style)[ \t]+[\w$-]+[ \t]+)\w.*[^\s;]/m,
            lookbehind: true,
            inside: {
                property: /\b\w[\w-]*(?=[ \t]*:)/,
                operator: /:/,
                punctuation: /,/
            }
        },
        'inter-arrow-label': {
            pattern: /([^<>ox.=-])(?:-[-.]|==)(?![<>ox.=-])[ \t]*(?:"[^"\r\n]*"|[^\s".=-](?:[^\r\n.=-]*[^\s.=-])?)[ \t]*(?:\.+->?|--+[->]|==+[=>])(?![<>ox.=-])/,
            lookbehind: true,
            greedy: true,
            inside: {
                arrow: {
                    pattern: /(?:\.+->?|--+[->]|==+[=>])$/,
                    alias: 'operator'
                },
                label: {
                    pattern: /^([\s\S]{2}[ \t]*)\S(?:[\s\S]*\S)?/,
                    lookbehind: true,
                    alias: 'property'
                },
                'arrow-head': {
                    pattern: /^\S+/,
                    alias: [
                        'arrow',
                        'operator'
                    ]
                }
            }
        },
        arrow: [
            // This might look complex but it really isn't.
            // There are many possible arrows (see tests) and it's impossible to fit all of them into one pattern. The
            // problem is that we only have one lookbehind per pattern. However, we cannot disallow too many arrow
            // characters in the one lookbehind because that would create too many false negatives. So we have to split the
            // arrows into different patterns.
            {
                // ER diagram
                pattern: /(^|[^{}|o.-])[|}][|o](?:--|\.\.)[|o][|{](?![{}|o.-])/,
                lookbehind: true,
                alias: 'operator'
            },
            {
                // flow chart
                // (?:==+|--+|-\.*-)
                pattern: /(^|[^<>ox.=-])(?:[<ox](?:==+|--+|-\.*-)[>ox]?|(?:==+|--+|-\.*-)[>ox]|===+|---+|-\.+-)(?![<>ox.=-])/,
                lookbehind: true,
                alias: 'operator'
            },
            {
                // sequence diagram
                pattern: /(^|[^<>()x-])(?:--?(?:>>|[x>)])(?![<>()x])|(?:<<|[x<(])--?(?!-))/,
                lookbehind: true,
                alias: 'operator'
            },
            {
                // class diagram
                pattern: /(^|[^<>|*o.-])(?:[*o]--|--[*o]|<\|?(?:--|\.\.)|(?:--|\.\.)\|?>|--|\.\.)(?![<>|*o.-])/,
                lookbehind: true,
                alias: 'operator'
            }
        ],
        label: {
            pattern: /(^|[^|<])\|(?:[^\r\n"|]|"[^"\r\n]*")+\|/,
            lookbehind: true,
            greedy: true,
            alias: 'property'
        },
        text: {
            pattern: /(?:[(\[{]+|\b>)(?:[^\r\n"()\[\]{}]|"[^"\r\n]*")+(?:[)\]}]+|>)/,
            alias: 'string'
        },
        string: {
            pattern: /"[^"\r\n]*"/,
            greedy: true
        },
        annotation: {
            pattern: /<<(?:abstract|choice|enumeration|fork|interface|join|service)>>|\[\[(?:choice|fork|join)\]\]/i,
            alias: 'important'
        },
        keyword: [
            // This language has both case-sensitive and case-insensitive keywords
            {
                pattern: /(^[ \t]*)(?:action|callback|class|classDef|classDiagram|click|direction|erDiagram|flowchart|gantt|gitGraph|graph|journey|link|linkStyle|pie|requirementDiagram|sequenceDiagram|stateDiagram|stateDiagram-v2|style|subgraph)(?![\w$-])/m,
                lookbehind: true,
                greedy: true
            },
            {
                pattern: /(^[ \t]*)(?:activate|alt|and|as|autonumber|deactivate|else|end(?:[ \t]+note)?|loop|opt|par|participant|rect|state|note[ \t]+(?:over|(?:left|right)[ \t]+of))(?![\w$-])/im,
                lookbehind: true,
                greedy: true
            }
        ],
        entity: /#[a-z0-9]+;/,
        operator: {
            pattern: /(\w[ \t]*)&(?=[ \t]*\w)|:::|:/,
            lookbehind: true
        },
        punctuation: /[(){};]/
    };
}

});

parcelRegister("49xPA", function(module, exports) {
'use strict';
module.exports = $30623ed9b7f0bed4$var$mizar;
$30623ed9b7f0bed4$var$mizar.displayName = 'mizar';
$30623ed9b7f0bed4$var$mizar.aliases = [];
function $30623ed9b7f0bed4$var$mizar(Prism) {
    Prism.languages.mizar = {
        comment: /::.+/,
        keyword: /@proof\b|\b(?:according|aggregate|all|and|antonym|are|as|associativity|assume|asymmetry|attr|be|begin|being|by|canceled|case|cases|clusters?|coherence|commutativity|compatibility|connectedness|consider|consistency|constructors|contradiction|correctness|def|deffunc|define|definitions?|defpred|do|does|end|environ|equals|ex|exactly|existence|for|from|func|given|hence|hereby|holds|idempotence|identity|iff?|implies|involutiveness|irreflexivity|is|it|let|means|mode|non|not|notations?|now|of|or|otherwise|over|per|pred|prefix|projectivity|proof|provided|qua|reconsider|redefine|reduce|reducibility|reflexivity|registrations?|requirements|reserve|sch|schemes?|section|selector|set|sethood|st|struct|such|suppose|symmetry|synonym|take|that|the|then|theorems?|thesis|thus|to|transitivity|uniqueness|vocabular(?:ies|y)|when|where|with|wrt)\b/,
        parameter: {
            pattern: /\$(?:10|\d)/,
            alias: 'variable'
        },
        variable: /\b\w+(?=:)/,
        number: /(?:\b|-)\d+\b/,
        operator: /\.\.\.|->|&|\.?=/,
        punctuation: /\(#|#\)|[,:;\[\](){}]/
    };
}

});

parcelRegister("4kt0k", function(module, exports) {
'use strict';
module.exports = $326f875215cf56de$var$mongodb;
$326f875215cf56de$var$mongodb.displayName = 'mongodb';
$326f875215cf56de$var$mongodb.aliases = [];
function $326f875215cf56de$var$mongodb(Prism) {
    (function(Prism) {
        var operators = [
            // query and projection
            '$eq',
            '$gt',
            '$gte',
            '$in',
            '$lt',
            '$lte',
            '$ne',
            '$nin',
            '$and',
            '$not',
            '$nor',
            '$or',
            '$exists',
            '$type',
            '$expr',
            '$jsonSchema',
            '$mod',
            '$regex',
            '$text',
            '$where',
            '$geoIntersects',
            '$geoWithin',
            '$near',
            '$nearSphere',
            '$all',
            '$elemMatch',
            '$size',
            '$bitsAllClear',
            '$bitsAllSet',
            '$bitsAnyClear',
            '$bitsAnySet',
            '$comment',
            '$elemMatch',
            '$meta',
            '$slice',
            '$currentDate',
            '$inc',
            '$min',
            '$max',
            '$mul',
            '$rename',
            '$set',
            '$setOnInsert',
            '$unset',
            '$addToSet',
            '$pop',
            '$pull',
            '$push',
            '$pullAll',
            '$each',
            '$position',
            '$slice',
            '$sort',
            '$bit',
            '$addFields',
            '$bucket',
            '$bucketAuto',
            '$collStats',
            '$count',
            '$currentOp',
            '$facet',
            '$geoNear',
            '$graphLookup',
            '$group',
            '$indexStats',
            '$limit',
            '$listLocalSessions',
            '$listSessions',
            '$lookup',
            '$match',
            '$merge',
            '$out',
            '$planCacheStats',
            '$project',
            '$redact',
            '$replaceRoot',
            '$replaceWith',
            '$sample',
            '$set',
            '$skip',
            '$sort',
            '$sortByCount',
            '$unionWith',
            '$unset',
            '$unwind',
            '$setWindowFields',
            '$abs',
            '$accumulator',
            '$acos',
            '$acosh',
            '$add',
            '$addToSet',
            '$allElementsTrue',
            '$and',
            '$anyElementTrue',
            '$arrayElemAt',
            '$arrayToObject',
            '$asin',
            '$asinh',
            '$atan',
            '$atan2',
            '$atanh',
            '$avg',
            '$binarySize',
            '$bsonSize',
            '$ceil',
            '$cmp',
            '$concat',
            '$concatArrays',
            '$cond',
            '$convert',
            '$cos',
            '$dateFromParts',
            '$dateToParts',
            '$dateFromString',
            '$dateToString',
            '$dayOfMonth',
            '$dayOfWeek',
            '$dayOfYear',
            '$degreesToRadians',
            '$divide',
            '$eq',
            '$exp',
            '$filter',
            '$first',
            '$floor',
            '$function',
            '$gt',
            '$gte',
            '$hour',
            '$ifNull',
            '$in',
            '$indexOfArray',
            '$indexOfBytes',
            '$indexOfCP',
            '$isArray',
            '$isNumber',
            '$isoDayOfWeek',
            '$isoWeek',
            '$isoWeekYear',
            '$last',
            '$last',
            '$let',
            '$literal',
            '$ln',
            '$log',
            '$log10',
            '$lt',
            '$lte',
            '$ltrim',
            '$map',
            '$max',
            '$mergeObjects',
            '$meta',
            '$min',
            '$millisecond',
            '$minute',
            '$mod',
            '$month',
            '$multiply',
            '$ne',
            '$not',
            '$objectToArray',
            '$or',
            '$pow',
            '$push',
            '$radiansToDegrees',
            '$range',
            '$reduce',
            '$regexFind',
            '$regexFindAll',
            '$regexMatch',
            '$replaceOne',
            '$replaceAll',
            '$reverseArray',
            '$round',
            '$rtrim',
            '$second',
            '$setDifference',
            '$setEquals',
            '$setIntersection',
            '$setIsSubset',
            '$setUnion',
            '$size',
            '$sin',
            '$slice',
            '$split',
            '$sqrt',
            '$stdDevPop',
            '$stdDevSamp',
            '$strcasecmp',
            '$strLenBytes',
            '$strLenCP',
            '$substr',
            '$substrBytes',
            '$substrCP',
            '$subtract',
            '$sum',
            '$switch',
            '$tan',
            '$toBool',
            '$toDate',
            '$toDecimal',
            '$toDouble',
            '$toInt',
            '$toLong',
            '$toObjectId',
            '$toString',
            '$toLower',
            '$toUpper',
            '$trim',
            '$trunc',
            '$type',
            '$week',
            '$year',
            '$zip',
            '$count',
            '$dateAdd',
            '$dateDiff',
            '$dateSubtract',
            '$dateTrunc',
            '$getField',
            '$rand',
            '$sampleRate',
            '$setField',
            '$unsetField',
            '$comment',
            '$explain',
            '$hint',
            '$max',
            '$maxTimeMS',
            '$min',
            '$orderby',
            '$query',
            '$returnKey',
            '$showDiskLoc',
            '$natural'
        ];
        var builtinFunctions = [
            'ObjectId',
            'Code',
            'BinData',
            'DBRef',
            'Timestamp',
            'NumberLong',
            'NumberDecimal',
            'MaxKey',
            'MinKey',
            'RegExp',
            'ISODate',
            'UUID'
        ];
        operators = operators.map(function(operator) {
            return operator.replace('$', '\\$');
        });
        var operatorsSource = '(?:' + operators.join('|') + ')\\b';
        Prism.languages.mongodb = Prism.languages.extend('javascript', {});
        Prism.languages.insertBefore('mongodb', 'string', {
            property: {
                pattern: /(?:(["'])(?:\\(?:\r\n|[\s\S])|(?!\1)[^\\\r\n])*\1|(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*)(?=\s*:)/,
                greedy: true,
                inside: {
                    keyword: RegExp('^([\'"])?' + operatorsSource + '(?:\\1)?$')
                }
            }
        });
        Prism.languages.mongodb.string.inside = {
            url: {
                // url pattern
                pattern: /https?:\/\/[-\w@:%.+~#=]{1,256}\.[a-z0-9()]{1,6}\b[-\w()@:%+.~#?&/=]*/i,
                greedy: true
            },
            entity: {
                // ipv4
                pattern: /\b(?:(?:[01]?\d\d?|2[0-4]\d|25[0-5])\.){3}(?:[01]?\d\d?|2[0-4]\d|25[0-5])\b/,
                greedy: true
            }
        };
        Prism.languages.insertBefore('mongodb', 'constant', {
            builtin: {
                pattern: RegExp('\\b(?:' + builtinFunctions.join('|') + ')\\b'),
                alias: 'keyword'
            }
        });
    })(Prism);
}

});

parcelRegister("aE5bt", function(module, exports) {
'use strict';
module.exports = $7c01a93c1df19cad$var$monkey;
$7c01a93c1df19cad$var$monkey.displayName = 'monkey';
$7c01a93c1df19cad$var$monkey.aliases = [];
function $7c01a93c1df19cad$var$monkey(Prism) {
    Prism.languages.monkey = {
        comment: {
            pattern: /^#Rem\s[\s\S]*?^#End|'.+/im,
            greedy: true
        },
        string: {
            pattern: /"[^"\r\n]*"/,
            greedy: true
        },
        preprocessor: {
            pattern: /(^[ \t]*)#.+/m,
            lookbehind: true,
            greedy: true,
            alias: 'property'
        },
        function: /\b\w+(?=\()/,
        'type-char': {
            pattern: /\b[?%#$]/,
            alias: 'class-name'
        },
        number: {
            pattern: /((?:\.\.)?)(?:(?:\b|\B-\.?|\B\.)\d+(?:(?!\.\.)\.\d*)?|\$[\da-f]+)/i,
            lookbehind: true
        },
        keyword: /\b(?:Abstract|Array|Bool|Case|Catch|Class|Const|Continue|Default|Eachin|Else|ElseIf|End|EndIf|Exit|Extends|Extern|False|Field|Final|Float|For|Forever|Function|Global|If|Implements|Import|Inline|Int|Interface|Local|Method|Module|New|Next|Null|Object|Private|Property|Public|Repeat|Return|Select|Self|Step|Strict|String|Super|Then|Throw|To|True|Try|Until|Void|Wend|While)\b/i,
        operator: /\.\.|<[=>]?|>=?|:?=|(?:[+\-*\/&~|]|\b(?:Mod|Shl|Shr)\b)=?|\b(?:And|Not|Or)\b/i,
        punctuation: /[.,:;()\[\]]/
    };
}

});

parcelRegister("bU7yo", function(module, exports) {
'use strict';
module.exports = $8aaac8ada7b011fc$var$moonscript;
$8aaac8ada7b011fc$var$moonscript.displayName = 'moonscript';
$8aaac8ada7b011fc$var$moonscript.aliases = [
    'moon'
];
function $8aaac8ada7b011fc$var$moonscript(Prism) {
    Prism.languages.moonscript = {
        comment: /--.*/,
        string: [
            {
                pattern: /'[^']*'|\[(=*)\[[\s\S]*?\]\1\]/,
                greedy: true
            },
            {
                pattern: /"[^"]*"/,
                greedy: true,
                inside: {
                    interpolation: {
                        pattern: /#\{[^{}]*\}/,
                        inside: {
                            moonscript: {
                                pattern: /(^#\{)[\s\S]+(?=\})/,
                                lookbehind: true,
                                inside: null // see beow
                            },
                            'interpolation-punctuation': {
                                pattern: /#\{|\}/,
                                alias: 'punctuation'
                            }
                        }
                    }
                }
            }
        ],
        'class-name': [
            {
                pattern: /(\b(?:class|extends)[ \t]+)\w+/,
                lookbehind: true
            },
            /\b[A-Z]\w*/
        ],
        keyword: /\b(?:class|continue|do|else|elseif|export|extends|for|from|if|import|in|local|nil|return|self|super|switch|then|unless|using|when|while|with)\b/,
        variable: /@@?\w*/,
        property: {
            pattern: /\b(?!\d)\w+(?=:)|(:)(?!\d)\w+/,
            lookbehind: true
        },
        function: {
            pattern: /\b(?:_G|_VERSION|assert|collectgarbage|coroutine\.(?:create|resume|running|status|wrap|yield)|debug\.(?:debug|getfenv|gethook|getinfo|getlocal|getmetatable|getregistry|getupvalue|setfenv|sethook|setlocal|setmetatable|setupvalue|traceback)|dofile|error|getfenv|getmetatable|io\.(?:close|flush|input|lines|open|output|popen|read|stderr|stdin|stdout|tmpfile|type|write)|ipairs|load|loadfile|loadstring|math\.(?:abs|acos|asin|atan|atan2|ceil|cos|cosh|deg|exp|floor|fmod|frexp|ldexp|log|log10|max|min|modf|pi|pow|rad|random|randomseed|sin|sinh|sqrt|tan|tanh)|module|next|os\.(?:clock|date|difftime|execute|exit|getenv|remove|rename|setlocale|time|tmpname)|package\.(?:cpath|loaded|loadlib|path|preload|seeall)|pairs|pcall|print|rawequal|rawget|rawset|require|select|setfenv|setmetatable|string\.(?:byte|char|dump|find|format|gmatch|gsub|len|lower|match|rep|reverse|sub|upper)|table\.(?:concat|insert|maxn|remove|sort)|tonumber|tostring|type|unpack|xpcall)\b/,
            inside: {
                punctuation: /\./
            }
        },
        boolean: /\b(?:false|true)\b/,
        number: /(?:\B\.\d+|\b\d+\.\d+|\b\d+(?=[eE]))(?:[eE][-+]?\d+)?\b|\b(?:0x[a-fA-F\d]+|\d+)(?:U?LL)?\b/,
        operator: /\.{3}|[-=]>|~=|(?:[-+*/%<>!=]|\.\.)=?|[:#^]|\b(?:and|or)\b=?|\b(?:not)\b/,
        punctuation: /[.,()[\]{}\\]/
    };
    Prism.languages.moonscript.string[1].inside.interpolation.inside.moonscript.inside = Prism.languages.moonscript;
    Prism.languages.moon = Prism.languages.moonscript;
}

});

parcelRegister("5Gh0b", function(module, exports) {
'use strict';
module.exports = $422e1036236bb085$var$n1ql;
$422e1036236bb085$var$n1ql.displayName = 'n1ql';
$422e1036236bb085$var$n1ql.aliases = [];
function $422e1036236bb085$var$n1ql(Prism) {
    // https://docs.couchbase.com/server/current/n1ql/n1ql-language-reference/index.html
    Prism.languages.n1ql = {
        comment: {
            pattern: /\/\*[\s\S]*?(?:$|\*\/)|--.*/,
            greedy: true
        },
        string: {
            pattern: /(["'])(?:\\[\s\S]|(?!\1)[^\\]|\1\1)*\1/,
            greedy: true
        },
        identifier: {
            pattern: /`(?:\\[\s\S]|[^\\`]|``)*`/,
            greedy: true
        },
        parameter: /\$[\w.]+/,
        // https://docs.couchbase.com/server/current/n1ql/n1ql-language-reference/reservedwords.html#n1ql-reserved-words
        keyword: /\b(?:ADVISE|ALL|ALTER|ANALYZE|AS|ASC|AT|BEGIN|BINARY|BOOLEAN|BREAK|BUCKET|BUILD|BY|CALL|CAST|CLUSTER|COLLATE|COLLECTION|COMMIT|COMMITTED|CONNECT|CONTINUE|CORRELATE|CORRELATED|COVER|CREATE|CURRENT|DATABASE|DATASET|DATASTORE|DECLARE|DECREMENT|DELETE|DERIVED|DESC|DESCRIBE|DISTINCT|DO|DROP|EACH|ELEMENT|EXCEPT|EXCLUDE|EXECUTE|EXPLAIN|FETCH|FILTER|FLATTEN|FLUSH|FOLLOWING|FOR|FORCE|FROM|FTS|FUNCTION|GOLANG|GRANT|GROUP|GROUPS|GSI|HASH|HAVING|IF|IGNORE|ILIKE|INCLUDE|INCREMENT|INDEX|INFER|INLINE|INNER|INSERT|INTERSECT|INTO|IS|ISOLATION|JAVASCRIPT|JOIN|KEY|KEYS|KEYSPACE|KNOWN|LANGUAGE|LAST|LEFT|LET|LETTING|LEVEL|LIMIT|LSM|MAP|MAPPING|MATCHED|MATERIALIZED|MERGE|MINUS|MISSING|NAMESPACE|NEST|NL|NO|NTH_VALUE|NULL|NULLS|NUMBER|OBJECT|OFFSET|ON|OPTION|OPTIONS|ORDER|OTHERS|OUTER|OVER|PARSE|PARTITION|PASSWORD|PATH|POOL|PRECEDING|PREPARE|PRIMARY|PRIVATE|PRIVILEGE|PROBE|PROCEDURE|PUBLIC|RANGE|RAW|REALM|REDUCE|RENAME|RESPECT|RETURN|RETURNING|REVOKE|RIGHT|ROLE|ROLLBACK|ROW|ROWS|SATISFIES|SAVEPOINT|SCHEMA|SCOPE|SELECT|SELF|SEMI|SET|SHOW|SOME|START|STATISTICS|STRING|SYSTEM|TIES|TO|TRAN|TRANSACTION|TRIGGER|TRUNCATE|UNBOUNDED|UNDER|UNION|UNIQUE|UNKNOWN|UNNEST|UNSET|UPDATE|UPSERT|USE|USER|USING|VALIDATE|VALUE|VALUES|VIA|VIEW|WHERE|WHILE|WINDOW|WITH|WORK|XOR)\b/i,
        function: /\b[a-z_]\w*(?=\s*\()/i,
        boolean: /\b(?:FALSE|TRUE)\b/i,
        number: /(?:\b\d+\.|\B\.)\d+e[+\-]?\d+\b|\b\d+(?:\.\d*)?|\B\.\d+\b/i,
        operator: /[-+*\/%]|!=|==?|\|\||<[>=]?|>=?|\b(?:AND|ANY|ARRAY|BETWEEN|CASE|ELSE|END|EVERY|EXISTS|FIRST|IN|LIKE|NOT|OR|THEN|VALUED|WHEN|WITHIN)\b/i,
        punctuation: /[;[\](),.{}:]/
    };
}

});

parcelRegister("83Arx", function(module, exports) {
'use strict';
module.exports = $5ddadf5f16cbbb67$var$n4js;
$5ddadf5f16cbbb67$var$n4js.displayName = 'n4js';
$5ddadf5f16cbbb67$var$n4js.aliases = [
    'n4jsd'
];
function $5ddadf5f16cbbb67$var$n4js(Prism) {
    Prism.languages.n4js = Prism.languages.extend('javascript', {
        // Keywords from N4JS language spec: https://numberfour.github.io/n4js/spec/N4JSSpec.html
        keyword: /\b(?:Array|any|boolean|break|case|catch|class|const|constructor|continue|debugger|declare|default|delete|do|else|enum|export|extends|false|finally|for|from|function|get|if|implements|import|in|instanceof|interface|let|module|new|null|number|package|private|protected|public|return|set|static|string|super|switch|this|throw|true|try|typeof|var|void|while|with|yield)\b/
    });
    Prism.languages.insertBefore('n4js', 'constant', {
        // Annotations in N4JS spec: https://numberfour.github.io/n4js/spec/N4JSSpec.html#_annotations
        annotation: {
            pattern: /@+\w+/,
            alias: 'operator'
        }
    });
    Prism.languages.n4jsd = Prism.languages.n4js;
}

});

parcelRegister("kvYAn", function(module, exports) {
'use strict';
module.exports = $eef5b2f6c8952b7f$var$nand2tetrisHdl;
$eef5b2f6c8952b7f$var$nand2tetrisHdl.displayName = 'nand2tetrisHdl';
$eef5b2f6c8952b7f$var$nand2tetrisHdl.aliases = [];
function $eef5b2f6c8952b7f$var$nand2tetrisHdl(Prism) {
    Prism.languages['nand2tetris-hdl'] = {
        comment: /\/\/.*|\/\*[\s\S]*?(?:\*\/|$)/,
        keyword: /\b(?:BUILTIN|CHIP|CLOCKED|IN|OUT|PARTS)\b/,
        boolean: /\b(?:false|true)\b/,
        function: /\b[A-Za-z][A-Za-z0-9]*(?=\()/,
        number: /\b\d+\b/,
        operator: /=|\.\./,
        punctuation: /[{}[\];(),:]/
    };
}

});

parcelRegister("5Myz8", function(module, exports) {
'use strict';
module.exports = $435c3f72d5a4f0fc$var$naniscript;
$435c3f72d5a4f0fc$var$naniscript.displayName = 'naniscript';
$435c3f72d5a4f0fc$var$naniscript.aliases = [];
function $435c3f72d5a4f0fc$var$naniscript(Prism) {
    (function(Prism) {
        var expressionDef = /\{[^\r\n\[\]{}]*\}/;
        var params = {
            'quoted-string': {
                pattern: /"(?:[^"\\]|\\.)*"/,
                alias: 'operator'
            },
            'command-param-id': {
                pattern: /(\s)\w+:/,
                lookbehind: true,
                alias: 'property'
            },
            'command-param-value': [
                {
                    pattern: expressionDef,
                    alias: 'selector'
                },
                {
                    pattern: /([\t ])\S+/,
                    lookbehind: true,
                    greedy: true,
                    alias: 'operator'
                },
                {
                    pattern: /\S(?:.*\S)?/,
                    alias: 'operator'
                }
            ]
        };
        Prism.languages.naniscript = {
            // ; ...
            comment: {
                pattern: /^([\t ]*);.*/m,
                lookbehind: true
            },
            // > ...
            // Define is a control line starting with '>' followed by a word, a space and a text.
            define: {
                pattern: /^>.+/m,
                alias: 'tag',
                inside: {
                    value: {
                        pattern: /(^>\w+[\t ]+)(?!\s)[^{}\r\n]+/,
                        lookbehind: true,
                        alias: 'operator'
                    },
                    key: {
                        pattern: /(^>)\w+/,
                        lookbehind: true
                    }
                }
            },
            // # ...
            label: {
                pattern: /^([\t ]*)#[\t ]*\w+[\t ]*$/m,
                lookbehind: true,
                alias: 'regex'
            },
            command: {
                pattern: /^([\t ]*)@\w+(?=[\t ]|$).*/m,
                lookbehind: true,
                alias: 'function',
                inside: {
                    'command-name': /^@\w+/,
                    expression: {
                        pattern: expressionDef,
                        greedy: true,
                        alias: 'selector'
                    },
                    'command-params': {
                        pattern: /\s*\S[\s\S]*/,
                        inside: params
                    }
                }
            },
            // Generic is any line that doesn't start with operators: ;>#@
            'generic-text': {
                pattern: /(^[ \t]*)[^#@>;\s].*/m,
                lookbehind: true,
                alias: 'punctuation',
                inside: {
                    // \{ ... \} ... \[ ... \] ... \"
                    'escaped-char': /\\[{}\[\]"]/,
                    expression: {
                        pattern: expressionDef,
                        greedy: true,
                        alias: 'selector'
                    },
                    'inline-command': {
                        pattern: /\[[\t ]*\w[^\r\n\[\]]*\]/,
                        greedy: true,
                        alias: 'function',
                        inside: {
                            'command-params': {
                                pattern: /(^\[[\t ]*\w+\b)[\s\S]+(?=\]$)/,
                                lookbehind: true,
                                inside: params
                            },
                            'command-param-name': {
                                pattern: /^(\[[\t ]*)\w+/,
                                lookbehind: true,
                                alias: 'name'
                            },
                            'start-stop-char': /[\[\]]/
                        }
                    }
                }
            }
        };
        Prism.languages.nani = Prism.languages['naniscript'];
        /** @typedef {InstanceType<import("./prism-core")["Token"]>} Token */ /**
     * This hook is used to validate generic-text tokens for balanced brackets.
     * Mark token as bad-line when contains not balanced brackets: {},[]
     */ Prism.hooks.add('after-tokenize', function(env) {
            /** @type {(Token | string)[]} */ var tokens = env.tokens;
            tokens.forEach(function(token) {
                if (typeof token !== 'string' && token.type === 'generic-text') {
                    var content = getTextContent(token);
                    if (!isBracketsBalanced(content)) {
                        token.type = 'bad-line';
                        token.content = content;
                    }
                }
            });
        });
        /**
     * @param {string} input
     * @returns {boolean}
     */ function isBracketsBalanced(input) {
            var brackets = '[]{}';
            var stack = [];
            for(var i = 0; i < input.length; i++){
                var bracket = input[i];
                var bracketsIndex = brackets.indexOf(bracket);
                if (bracketsIndex !== -1) {
                    if (bracketsIndex % 2 === 0) stack.push(bracketsIndex + 1);
                    else if (stack.pop() !== bracketsIndex) return false;
                }
            }
            return stack.length === 0;
        }
        /**
     * @param {string | Token | (string | Token)[]} token
     * @returns {string}
     */ function getTextContent(token) {
            if (typeof token === 'string') return token;
            else if (Array.isArray(token)) return token.map(getTextContent).join('');
            else return getTextContent(token.content);
        }
    })(Prism);
}

});

parcelRegister("e6vHr", function(module, exports) {
'use strict';
module.exports = $a44a371968f11f4f$var$nasm;
$a44a371968f11f4f$var$nasm.displayName = 'nasm';
$a44a371968f11f4f$var$nasm.aliases = [];
function $a44a371968f11f4f$var$nasm(Prism) {
    Prism.languages.nasm = {
        comment: /;.*$/m,
        string: /(["'`])(?:\\.|(?!\1)[^\\\r\n])*\1/,
        label: {
            pattern: /(^\s*)[A-Za-z._?$][\w.?$@~#]*:/m,
            lookbehind: true,
            alias: 'function'
        },
        keyword: [
            /\[?BITS (?:16|32|64)\]?/,
            {
                pattern: /(^\s*)section\s*[a-z.]+:?/im,
                lookbehind: true
            },
            /(?:extern|global)[^;\r\n]*/i,
            /(?:CPU|DEFAULT|FLOAT).*$/m
        ],
        register: {
            pattern: /\b(?:st\d|[xyz]mm\d\d?|[cdt]r\d|r\d\d?[bwd]?|[er]?[abcd]x|[abcd][hl]|[er]?(?:bp|di|si|sp)|[cdefgs]s)\b/i,
            alias: 'variable'
        },
        number: /(?:\b|(?=\$))(?:0[hx](?:\.[\da-f]+|[\da-f]+(?:\.[\da-f]+)?)(?:p[+-]?\d+)?|\d[\da-f]+[hx]|\$\d[\da-f]*|0[oq][0-7]+|[0-7]+[oq]|0[by][01]+|[01]+[by]|0[dt]\d+|(?:\d+(?:\.\d+)?|\.\d+)(?:\.?e[+-]?\d+)?[dt]?)\b/i,
        operator: /[\[\]*+\-\/%<>=&|$!]/
    };
}

});

parcelRegister("6Q1VP", function(module, exports) {
'use strict';
module.exports = $4fa918ffe93f890a$var$neon;
$4fa918ffe93f890a$var$neon.displayName = 'neon';
$4fa918ffe93f890a$var$neon.aliases = [];
function $4fa918ffe93f890a$var$neon(Prism) {
    Prism.languages.neon = {
        comment: {
            pattern: /#.*/,
            greedy: true
        },
        datetime: {
            pattern: /(^|[[{(=:,\s])\d\d\d\d-\d\d?-\d\d?(?:(?:[Tt]| +)\d\d?:\d\d:\d\d(?:\.\d*)? *(?:Z|[-+]\d\d?(?::?\d\d)?)?)?(?=$|[\]}),\s])/,
            lookbehind: true,
            alias: 'number'
        },
        key: {
            pattern: /(^|[[{(,\s])[^,:=[\]{}()'"\s]+(?=\s*:(?:$|[\]}),\s])|\s*=)/,
            lookbehind: true,
            alias: 'atrule'
        },
        number: {
            pattern: /(^|[[{(=:,\s])[+-]?(?:0x[\da-fA-F]+|0o[0-7]+|0b[01]+|(?:\d+(?:\.\d*)?|\.?\d+)(?:[eE][+-]?\d+)?)(?=$|[\]}),:=\s])/,
            lookbehind: true
        },
        boolean: {
            pattern: /(^|[[{(=:,\s])(?:false|no|true|yes)(?=$|[\]}),:=\s])/i,
            lookbehind: true
        },
        null: {
            pattern: /(^|[[{(=:,\s])(?:null)(?=$|[\]}),:=\s])/i,
            lookbehind: true,
            alias: 'keyword'
        },
        string: {
            pattern: /(^|[[{(=:,\s])(?:('''|""")\r?\n(?:(?:[^\r\n]|\r?\n(?![\t ]*\2))*\r?\n)?[\t ]*\2|'[^'\r\n]*'|"(?:\\.|[^\\"\r\n])*")/,
            lookbehind: true,
            greedy: true
        },
        literal: {
            pattern: /(^|[[{(=:,\s])(?:[^#"',:=[\]{}()\s`-]|[:-][^"',=[\]{}()\s])(?:[^,:=\]})(\s]|:(?![\s,\]})]|$)|[ \t]+[^#,:=\]})(\s])*/,
            lookbehind: true,
            alias: 'string'
        },
        punctuation: /[,:=[\]{}()-]/
    };
}

});

parcelRegister("drRTk", function(module, exports) {
'use strict';
module.exports = $9ca799ac57a90c3e$var$nevod;
$9ca799ac57a90c3e$var$nevod.displayName = 'nevod';
$9ca799ac57a90c3e$var$nevod.aliases = [];
function $9ca799ac57a90c3e$var$nevod(Prism) {
    Prism.languages.nevod = {
        comment: /\/\/.*|(?:\/\*[\s\S]*?(?:\*\/|$))/,
        string: {
            pattern: /(?:"(?:""|[^"])*"(?!")|'(?:''|[^'])*'(?!'))!?\*?/,
            greedy: true,
            inside: {
                'string-attrs': /!$|!\*$|\*$/
            }
        },
        namespace: {
            pattern: /(@namespace\s+)[a-zA-Z0-9\-.]+(?=\s*\{)/,
            lookbehind: true
        },
        pattern: {
            pattern: /(@pattern\s+)?#?[a-zA-Z0-9\-.]+(?:\s*\(\s*(?:~\s*)?[a-zA-Z0-9\-.]+\s*(?:,\s*(?:~\s*)?[a-zA-Z0-9\-.]*)*\))?(?=\s*=)/,
            lookbehind: true,
            inside: {
                'pattern-name': {
                    pattern: /^#?[a-zA-Z0-9\-.]+/,
                    alias: 'class-name'
                },
                fields: {
                    pattern: /\(.*\)/,
                    inside: {
                        'field-name': {
                            pattern: /[a-zA-Z0-9\-.]+/,
                            alias: 'variable'
                        },
                        punctuation: /[,()]/,
                        operator: {
                            pattern: /~/,
                            alias: 'field-hidden-mark'
                        }
                    }
                }
            }
        },
        search: {
            pattern: /(@search\s+|#)[a-zA-Z0-9\-.]+(?:\.\*)?(?=\s*;)/,
            alias: 'function',
            lookbehind: true
        },
        keyword: /@(?:having|inside|namespace|outside|pattern|require|search|where)\b/,
        'standard-pattern': {
            pattern: /\b(?:Alpha|AlphaNum|Any|Blank|End|LineBreak|Num|NumAlpha|Punct|Space|Start|Symbol|Word|WordBreak)\b(?:\([a-zA-Z0-9\-.,\s+]*\))?/,
            inside: {
                'standard-pattern-name': {
                    pattern: /^[a-zA-Z0-9\-.]+/,
                    alias: 'builtin'
                },
                quantifier: {
                    pattern: /\b\d+(?:\s*\+|\s*-\s*\d+)?(?!\w)/,
                    alias: 'number'
                },
                'standard-pattern-attr': {
                    pattern: /[a-zA-Z0-9\-.]+/,
                    alias: 'builtin'
                },
                punctuation: /[,()]/
            }
        },
        quantifier: {
            pattern: /\b\d+(?:\s*\+|\s*-\s*\d+)?(?!\w)/,
            alias: 'number'
        },
        operator: [
            {
                pattern: /=/,
                alias: 'pattern-def'
            },
            {
                pattern: /&/,
                alias: 'conjunction'
            },
            {
                pattern: /~/,
                alias: 'exception'
            },
            {
                pattern: /\?/,
                alias: 'optionality'
            },
            {
                pattern: /[[\]]/,
                alias: 'repetition'
            },
            {
                pattern: /[{}]/,
                alias: 'variation'
            },
            {
                pattern: /[+_]/,
                alias: 'sequence'
            },
            {
                pattern: /\.{2,3}/,
                alias: 'span'
            }
        ],
        'field-capture': [
            {
                pattern: /([a-zA-Z0-9\-.]+\s*\()\s*[a-zA-Z0-9\-.]+\s*:\s*[a-zA-Z0-9\-.]+(?:\s*,\s*[a-zA-Z0-9\-.]+\s*:\s*[a-zA-Z0-9\-.]+)*(?=\s*\))/,
                lookbehind: true,
                inside: {
                    'field-name': {
                        pattern: /[a-zA-Z0-9\-.]+/,
                        alias: 'variable'
                    },
                    colon: /:/
                }
            },
            {
                pattern: /[a-zA-Z0-9\-.]+\s*:/,
                inside: {
                    'field-name': {
                        pattern: /[a-zA-Z0-9\-.]+/,
                        alias: 'variable'
                    },
                    colon: /:/
                }
            }
        ],
        punctuation: /[:;,()]/,
        name: /[a-zA-Z0-9\-.]+/
    };
}

});

parcelRegister("hG4kM", function(module, exports) {
'use strict';
module.exports = $cde9b89695717ed4$var$nginx;
$cde9b89695717ed4$var$nginx.displayName = 'nginx';
$cde9b89695717ed4$var$nginx.aliases = [];
function $cde9b89695717ed4$var$nginx(Prism) {
    (function(Prism) {
        var variable = /\$(?:\w[a-z\d]*(?:_[^\x00-\x1F\s"'\\()$]*)?|\{[^}\s"'\\]+\})/i;
        Prism.languages.nginx = {
            comment: {
                pattern: /(^|[\s{};])#.*/,
                lookbehind: true,
                greedy: true
            },
            directive: {
                pattern: /(^|\s)\w(?:[^;{}"'\\\s]|\\.|"(?:[^"\\]|\\.)*"|'(?:[^'\\]|\\.)*'|\s+(?:#.*(?!.)|(?![#\s])))*?(?=\s*[;{])/,
                lookbehind: true,
                greedy: true,
                inside: {
                    string: {
                        pattern: /((?:^|[^\\])(?:\\\\)*)(?:"(?:[^"\\]|\\.)*"|'(?:[^'\\]|\\.)*')/,
                        lookbehind: true,
                        greedy: true,
                        inside: {
                            escape: {
                                pattern: /\\["'\\nrt]/,
                                alias: 'entity'
                            },
                            variable: variable
                        }
                    },
                    comment: {
                        pattern: /(\s)#.*/,
                        lookbehind: true,
                        greedy: true
                    },
                    keyword: {
                        pattern: /^\S+/,
                        greedy: true
                    },
                    // other patterns
                    boolean: {
                        pattern: /(\s)(?:off|on)(?!\S)/,
                        lookbehind: true
                    },
                    number: {
                        pattern: /(\s)\d+[a-z]*(?!\S)/i,
                        lookbehind: true
                    },
                    variable: variable
                }
            },
            punctuation: /[{};]/
        };
    })(Prism);
}

});

parcelRegister("eXvh9", function(module, exports) {
'use strict';
module.exports = $ae3ed60ad8f08cf4$var$nim;
$ae3ed60ad8f08cf4$var$nim.displayName = 'nim';
$ae3ed60ad8f08cf4$var$nim.aliases = [];
function $ae3ed60ad8f08cf4$var$nim(Prism) {
    Prism.languages.nim = {
        comment: {
            pattern: /#.*/,
            greedy: true
        },
        string: {
            // Double-quoted strings can be prefixed by an identifier (Generalized raw string literals)
            pattern: /(?:\b(?!\d)(?:\w|\\x[89a-fA-F][0-9a-fA-F])+)?(?:"""[\s\S]*?"""(?!")|"(?:\\[\s\S]|""|[^"\\])*")/,
            greedy: true
        },
        char: {
            // Character literals are handled specifically to prevent issues with numeric type suffixes
            pattern: /'(?:\\(?:\d+|x[\da-fA-F]{0,2}|.)|[^'])'/,
            greedy: true
        },
        function: {
            pattern: /(?:(?!\d)(?:\w|\\x[89a-fA-F][0-9a-fA-F])+|`[^`\r\n]+`)\*?(?:\[[^\]]+\])?(?=\s*\()/,
            greedy: true,
            inside: {
                operator: /\*$/
            }
        },
        // We don't want to highlight operators (and anything really) inside backticks
        identifier: {
            pattern: /`[^`\r\n]+`/,
            greedy: true,
            inside: {
                punctuation: /`/
            }
        },
        // The negative look ahead prevents wrong highlighting of the .. operator
        number: /\b(?:0[xXoObB][\da-fA-F_]+|\d[\d_]*(?:(?!\.\.)\.[\d_]*)?(?:[eE][+-]?\d[\d_]*)?)(?:'?[iuf]\d*)?/,
        keyword: /\b(?:addr|as|asm|atomic|bind|block|break|case|cast|concept|const|continue|converter|defer|discard|distinct|do|elif|else|end|enum|except|export|finally|for|from|func|generic|if|import|include|interface|iterator|let|macro|method|mixin|nil|object|out|proc|ptr|raise|ref|return|static|template|try|tuple|type|using|var|when|while|with|without|yield)\b/,
        operator: {
            // Look behind and look ahead prevent wrong highlighting of punctuations [. .] {. .} (. .)
            // but allow the slice operator .. to take precedence over them
            // One can define his own operators in Nim so all combination of operators might be an operator.
            pattern: /(^|[({\[](?=\.\.)|(?![({\[]\.).)(?:(?:[=+\-*\/<>@$~&%|!?^:\\]|\.\.|\.(?![)}\]]))+|\b(?:and|div|in|is|isnot|mod|not|notin|of|or|shl|shr|xor)\b)/m,
            lookbehind: true
        },
        punctuation: /[({\[]\.|\.[)}\]]|[`(){}\[\],:]/
    };
}

});

parcelRegister("563y4", function(module, exports) {
'use strict';
module.exports = $3b6043f2aeaffd76$var$nix;
$3b6043f2aeaffd76$var$nix.displayName = 'nix';
$3b6043f2aeaffd76$var$nix.aliases = [];
function $3b6043f2aeaffd76$var$nix(Prism) {
    Prism.languages.nix = {
        comment: {
            pattern: /\/\*[\s\S]*?\*\/|#.*/,
            greedy: true
        },
        string: {
            pattern: /"(?:[^"\\]|\\[\s\S])*"|''(?:(?!'')[\s\S]|''(?:'|\\|\$\{))*''/,
            greedy: true,
            inside: {
                interpolation: {
                    // The lookbehind ensures the ${} is not preceded by \ or ''
                    pattern: /(^|(?:^|(?!'').)[^\\])\$\{(?:[^{}]|\{[^}]*\})*\}/,
                    lookbehind: true,
                    inside: null // see below
                }
            }
        },
        url: [
            /\b(?:[a-z]{3,7}:\/\/)[\w\-+%~\/.:#=?&]+/,
            {
                pattern: /([^\/])(?:[\w\-+%~.:#=?&]*(?!\/\/)[\w\-+%~\/.:#=?&])?(?!\/\/)\/[\w\-+%~\/.:#=?&]*/,
                lookbehind: true
            }
        ],
        antiquotation: {
            pattern: /\$(?=\{)/,
            alias: 'important'
        },
        number: /\b\d+\b/,
        keyword: /\b(?:assert|builtins|else|if|in|inherit|let|null|or|then|with)\b/,
        function: /\b(?:abort|add|all|any|attrNames|attrValues|baseNameOf|compareVersions|concatLists|currentSystem|deepSeq|derivation|dirOf|div|elem(?:At)?|fetch(?:Tarball|url)|filter(?:Source)?|fromJSON|genList|getAttr|getEnv|hasAttr|hashString|head|import|intersectAttrs|is(?:Attrs|Bool|Function|Int|List|Null|String)|length|lessThan|listToAttrs|map|mul|parseDrvName|pathExists|read(?:Dir|File)|removeAttrs|replaceStrings|seq|sort|stringLength|sub(?:string)?|tail|throw|to(?:File|JSON|Path|String|XML)|trace|typeOf)\b|\bfoldl'\B/,
        boolean: /\b(?:false|true)\b/,
        operator: /[=!<>]=?|\+\+?|\|\||&&|\/\/|->?|[?@]/,
        punctuation: /[{}()[\].,:;]/
    };
    Prism.languages.nix.string.inside.interpolation.inside = Prism.languages.nix;
}

});

parcelRegister("6ylzc", function(module, exports) {
'use strict';
module.exports = $4c56a5c6e2aff315$var$nsis;
$4c56a5c6e2aff315$var$nsis.displayName = 'nsis';
$4c56a5c6e2aff315$var$nsis.aliases = [];
function $4c56a5c6e2aff315$var$nsis(Prism) {
    /**
   * Original by Jan T. Sott (http://github.com/idleberg)
   *
   * Includes all commands and plug-ins shipped with NSIS 3.08
   */ Prism.languages.nsis = {
        comment: {
            pattern: /(^|[^\\])(?:\/\*[\s\S]*?\*\/|[#;].*)/,
            lookbehind: true,
            greedy: true
        },
        string: {
            pattern: /("|')(?:\\.|(?!\1)[^\\\r\n])*\1/,
            greedy: true
        },
        keyword: {
            pattern: /(^[\t ]*)(?:Abort|Add(?:BrandingImage|Size)|AdvSplash|Allow(?:RootDirInstall|SkipFiles)|AutoCloseWindow|BG(?:Font|Gradient|Image)|Banner|BrandingText|BringToFront|CRCCheck|Call(?:InstDLL)?|Caption|ChangeUI|CheckBitmap|ClearErrors|CompletedText|ComponentText|CopyFiles|Create(?:Directory|Font|ShortCut)|Delete(?:INISec|INIStr|RegKey|RegValue)?|Detail(?:Print|sButtonText)|Dialer|Dir(?:Text|Var|Verify)|EnableWindow|Enum(?:RegKey|RegValue)|Exch|Exec(?:Shell(?:Wait)?|Wait)?|ExpandEnvStrings|File(?:BufSize|Close|ErrorText|Open|Read|ReadByte|ReadUTF16LE|ReadWord|Seek|Write|WriteByte|WriteUTF16LE|WriteWord)?|Find(?:Close|First|Next|Window)|FlushINI|Get(?:CurInstType|CurrentAddress|DLLVersion(?:Local)?|DlgItem|ErrorLevel|FileTime(?:Local)?|FullPathName|Function(?:Address|End)?|InstDirError|LabelAddress|TempFileName)|Goto|HideWindow|Icon|If(?:Abort|Errors|FileExists|RebootFlag|Silent)|InitPluginsDir|InstProgressFlags|Inst(?:Type(?:GetText|SetText)?)|Install(?:ButtonText|Colors|Dir(?:RegKey)?)|Int(?:64|Ptr)?CmpU?|Int(?:64)?Fmt|Int(?:Ptr)?Op|IsWindow|Lang(?:DLL|String)|License(?:BkColor|Data|ForceSelection|LangString|Text)|LoadLanguageFile|LockWindow|Log(?:Set|Text)|Manifest(?:DPIAware|SupportedOS)|Math|MessageBox|MiscButtonText|NSISdl|Name|Nop|OutFile|PE(?:DllCharacteristics|SubsysVer)|Page(?:Callbacks)?|Pop|Push|Quit|RMDir|Read(?:EnvStr|INIStr|RegDWORD|RegStr)|Reboot|RegDLL|Rename|RequestExecutionLevel|ReserveFile|Return|SearchPath|Section(?:End|GetFlags|GetInstTypes|GetSize|GetText|Group|In|SetFlags|SetInstTypes|SetSize|SetText)?|SendMessage|Set(?:AutoClose|BrandingImage|Compress|Compressor(?:DictSize)?|CtlColors|CurInstType|DatablockOptimize|DateSave|Details(?:Print|View)|ErrorLevel|Errors|FileAttributes|Font|OutPath|Overwrite|PluginUnload|RebootFlag|RegView|ShellVarContext|Silent)|Show(?:InstDetails|UninstDetails|Window)|Silent(?:Install|UnInstall)|Sleep|SpaceTexts|Splash|StartMenu|Str(?:CmpS?|Cpy|Len)|SubCaption|System|UnRegDLL|Unicode|UninstPage|Uninstall(?:ButtonText|Caption|Icon|SubCaption|Text)|UserInfo|VI(?:AddVersionKey|FileVersion|ProductVersion)|VPatch|Var|WindowIcon|Write(?:INIStr|Reg(?:Bin|DWORD|ExpandStr|MultiStr|None|Str)|Uninstaller)|XPStyle|ns(?:Dialogs|Exec))\b/m,
            lookbehind: true
        },
        property: /\b(?:ARCHIVE|FILE_(?:ATTRIBUTE_ARCHIVE|ATTRIBUTE_NORMAL|ATTRIBUTE_OFFLINE|ATTRIBUTE_READONLY|ATTRIBUTE_SYSTEM|ATTRIBUTE_TEMPORARY)|HK(?:(?:CR|CU|LM)(?:32|64)?|DD|PD|U)|HKEY_(?:CLASSES_ROOT|CURRENT_CONFIG|CURRENT_USER|DYN_DATA|LOCAL_MACHINE|PERFORMANCE_DATA|USERS)|ID(?:ABORT|CANCEL|IGNORE|NO|OK|RETRY|YES)|MB_(?:ABORTRETRYIGNORE|DEFBUTTON1|DEFBUTTON2|DEFBUTTON3|DEFBUTTON4|ICONEXCLAMATION|ICONINFORMATION|ICONQUESTION|ICONSTOP|OK|OKCANCEL|RETRYCANCEL|RIGHT|RTLREADING|SETFOREGROUND|TOPMOST|USERICON|YESNO)|NORMAL|OFFLINE|READONLY|SHCTX|SHELL_CONTEXT|SYSTEM|TEMPORARY|admin|all|auto|both|colored|false|force|hide|highest|lastused|leave|listonly|none|normal|notset|off|on|open|print|show|silent|silentlog|smooth|textonly|true|user)\b/,
        constant: /\$\{[!\w\.:\^-]+\}|\$\([!\w\.:\^-]+\)/,
        variable: /\$\w[\w\.]*/,
        number: /\b0x[\dA-Fa-f]+\b|(?:\b\d+(?:\.\d*)?|\B\.\d+)(?:[Ee]-?\d+)?/,
        operator: /--?|\+\+?|<=?|>=?|==?=?|&&?|\|\|?|[?*\/~^%]/,
        punctuation: /[{}[\];(),.:]/,
        important: {
            pattern: /(^[\t ]*)!(?:addincludedir|addplugindir|appendfile|cd|define|delfile|echo|else|endif|error|execute|finalize|getdllversion|gettlbversion|if|ifdef|ifmacrodef|ifmacrondef|ifndef|include|insertmacro|macro|macroend|makensis|packhdr|pragma|searchparse|searchreplace|system|tempfile|undef|verbose|warning)\b/im,
            lookbehind: true
        }
    };
}

});

parcelRegister("5Zdog", function(module, exports) {
'use strict';

var $c6Wvp = parcelRequire("c6Wvp");
module.exports = $45bd095119d8a2f7$var$objectivec;
$45bd095119d8a2f7$var$objectivec.displayName = 'objectivec';
$45bd095119d8a2f7$var$objectivec.aliases = [
    'objc'
];
function $45bd095119d8a2f7$var$objectivec(Prism) {
    Prism.register($c6Wvp);
    Prism.languages.objectivec = Prism.languages.extend('c', {
        string: {
            pattern: /@?"(?:\\(?:\r\n|[\s\S])|[^"\\\r\n])*"/,
            greedy: true
        },
        keyword: /\b(?:asm|auto|break|case|char|const|continue|default|do|double|else|enum|extern|float|for|goto|if|in|inline|int|long|register|return|self|short|signed|sizeof|static|struct|super|switch|typedef|typeof|union|unsigned|void|volatile|while)\b|(?:@interface|@end|@implementation|@protocol|@class|@public|@protected|@private|@property|@try|@catch|@finally|@throw|@synthesize|@dynamic|@selector)\b/,
        operator: /-[->]?|\+\+?|!=?|<<?=?|>>?=?|==?|&&?|\|\|?|[~^%?*\/@]/
    });
    delete Prism.languages.objectivec['class-name'];
    Prism.languages.objc = Prism.languages.objectivec;
}

});

parcelRegister("cNqe1", function(module, exports) {
'use strict';
module.exports = $950e67625aa902b7$var$ocaml;
$950e67625aa902b7$var$ocaml.displayName = 'ocaml';
$950e67625aa902b7$var$ocaml.aliases = [];
function $950e67625aa902b7$var$ocaml(Prism) {
    // https://ocaml.org/manual/lex.html
    Prism.languages.ocaml = {
        comment: {
            pattern: /\(\*[\s\S]*?\*\)/,
            greedy: true
        },
        char: {
            pattern: /'(?:[^\\\r\n']|\\(?:.|[ox]?[0-9a-f]{1,3}))'/i,
            greedy: true
        },
        string: [
            {
                pattern: /"(?:\\(?:[\s\S]|\r\n)|[^\\\r\n"])*"/,
                greedy: true
            },
            {
                pattern: /\{([a-z_]*)\|[\s\S]*?\|\1\}/,
                greedy: true
            }
        ],
        number: [
            // binary and octal
            /\b(?:0b[01][01_]*|0o[0-7][0-7_]*)\b/i,
            /\b0x[a-f0-9][a-f0-9_]*(?:\.[a-f0-9_]*)?(?:p[+-]?\d[\d_]*)?(?!\w)/i,
            /\b\d[\d_]*(?:\.[\d_]*)?(?:e[+-]?\d[\d_]*)?(?!\w)/i
        ],
        directive: {
            pattern: /\B#\w+/,
            alias: 'property'
        },
        label: {
            pattern: /\B~\w+/,
            alias: 'property'
        },
        'type-variable': {
            pattern: /\B'\w+/,
            alias: 'function'
        },
        variant: {
            pattern: /`\w+/,
            alias: 'symbol'
        },
        // For the list of keywords and operators,
        // see: http://caml.inria.fr/pub/docs/manual-ocaml/lex.html#sec84
        keyword: /\b(?:as|assert|begin|class|constraint|do|done|downto|else|end|exception|external|for|fun|function|functor|if|in|include|inherit|initializer|lazy|let|match|method|module|mutable|new|nonrec|object|of|open|private|rec|sig|struct|then|to|try|type|val|value|virtual|when|where|while|with)\b/,
        boolean: /\b(?:false|true)\b/,
        'operator-like-punctuation': {
            pattern: /\[[<>|]|[>|]\]|\{<|>\}/,
            alias: 'punctuation'
        },
        // Custom operators are allowed
        operator: /\.[.~]|:[=>]|[=<>@^|&+\-*\/$%!?~][!$%&*+\-.\/:<=>?@^|~]*|\b(?:and|asr|land|lor|lsl|lsr|lxor|mod|or)\b/,
        punctuation: /;;|::|[(){}\[\].,:;#]|\b_\b/
    };
}

});

parcelRegister("7R3hJ", function(module, exports) {
'use strict';

var $c6Wvp = parcelRequire("c6Wvp");
module.exports = $5b8007fa23763196$var$opencl;
$5b8007fa23763196$var$opencl.displayName = 'opencl';
$5b8007fa23763196$var$opencl.aliases = [];
function $5b8007fa23763196$var$opencl(Prism) {
    Prism.register($c6Wvp);
    (function(Prism) {
        /* OpenCL kernel language */ Prism.languages.opencl = Prism.languages.extend('c', {
            // Extracted from the official specs (2.0) and http://streamcomputing.eu/downloads/?opencl.lang (opencl-keywords, opencl-types) and http://sourceforge.net/tracker/?func=detail&aid=2957794&group_id=95717&atid=612384 (Words2, partly Words3)
            keyword: /\b(?:(?:__)?(?:constant|global|kernel|local|private|read_only|read_write|write_only)|__attribute__|auto|(?:bool|u?(?:char|int|long|short)|half|quad)(?:2|3|4|8|16)?|break|case|complex|const|continue|(?:double|float)(?:16(?:x(?:1|2|4|8|16))?|1x(?:1|2|4|8|16)|2(?:x(?:1|2|4|8|16))?|3|4(?:x(?:1|2|4|8|16))?|8(?:x(?:1|2|4|8|16))?)?|default|do|else|enum|extern|for|goto|if|imaginary|inline|packed|pipe|register|restrict|return|signed|sizeof|static|struct|switch|typedef|uniform|union|unsigned|void|volatile|while)\b/,
            // Extracted from http://streamcomputing.eu/downloads/?opencl.lang (opencl-const)
            // Math Constants: https://www.khronos.org/registry/OpenCL/sdk/2.1/docs/man/xhtml/mathConstants.html
            // Macros and Limits: https://www.khronos.org/registry/OpenCL/sdk/2.1/docs/man/xhtml/macroLimits.html
            number: /(?:\b0x(?:[\da-f]+(?:\.[\da-f]*)?|\.[\da-f]+)(?:p[+-]?\d+)?|(?:\b\d+(?:\.\d*)?|\B\.\d+)(?:e[+-]?\d+)?)[fuhl]{0,4}/i,
            boolean: /\b(?:false|true)\b/,
            'constant-opencl-kernel': {
                pattern: /\b(?:CHAR_(?:BIT|MAX|MIN)|CLK_(?:ADDRESS_(?:CLAMP(?:_TO_EDGE)?|NONE|REPEAT)|FILTER_(?:LINEAR|NEAREST)|(?:GLOBAL|LOCAL)_MEM_FENCE|NORMALIZED_COORDS_(?:FALSE|TRUE))|CL_(?:BGRA|(?:HALF_)?FLOAT|INTENSITY|LUMINANCE|A?R?G?B?[Ax]?|(?:(?:UN)?SIGNED|[US]NORM)_(?:INT(?:8|16|32))|UNORM_(?:INT_101010|SHORT_(?:555|565)))|(?:DBL|FLT|HALF)_(?:DIG|EPSILON|(?:MAX|MIN)(?:(?:_10)?_EXP)?|MANT_DIG)|FLT_RADIX|HUGE_VALF?|(?:INT|LONG|SCHAR|SHRT)_(?:MAX|MIN)|INFINITY|MAXFLOAT|M_(?:[12]_PI|2_SQRTPI|E|LN(?:2|10)|LOG(?:2|10)E?|PI(?:_[24])?|SQRT(?:1_2|2))(?:_F|_H)?|NAN|(?:UCHAR|UINT|ULONG|USHRT)_MAX)\b/,
                alias: 'constant'
            }
        });
        Prism.languages.insertBefore('opencl', 'class-name', {
            // https://www.khronos.org/registry/OpenCL/sdk/2.1/docs/man/xhtml/scalarDataTypes.html
            // https://www.khronos.org/registry/OpenCL/sdk/2.1/docs/man/xhtml/otherDataTypes.html
            'builtin-type': {
                pattern: /\b(?:_cl_(?:command_queue|context|device_id|event|kernel|mem|platform_id|program|sampler)|cl_(?:image_format|mem_fence_flags)|clk_event_t|event_t|image(?:1d_(?:array_|buffer_)?t|2d_(?:array_(?:depth_|msaa_depth_|msaa_)?|depth_|msaa_depth_|msaa_)?t|3d_t)|intptr_t|ndrange_t|ptrdiff_t|queue_t|reserve_id_t|sampler_t|size_t|uintptr_t)\b/,
                alias: 'keyword'
            }
        });
        var attributes = {
            // Extracted from http://streamcomputing.eu/downloads/?opencl_host.lang (opencl-types and opencl-host)
            'type-opencl-host': {
                pattern: /\b(?:cl_(?:GLenum|GLint|GLuin|addressing_mode|bitfield|bool|buffer_create_type|build_status|channel_(?:order|type)|(?:u?(?:char|int|long|short)|double|float)(?:2|3|4|8|16)?|command_(?:queue(?:_info|_properties)?|type)|context(?:_info|_properties)?|device_(?:exec_capabilities|fp_config|id|info|local_mem_type|mem_cache_type|type)|(?:event|sampler)(?:_info)?|filter_mode|half|image_info|kernel(?:_info|_work_group_info)?|map_flags|mem(?:_flags|_info|_object_type)?|platform_(?:id|info)|profiling_info|program(?:_build_info|_info)?))\b/,
                alias: 'keyword'
            },
            'boolean-opencl-host': {
                pattern: /\bCL_(?:FALSE|TRUE)\b/,
                alias: 'boolean'
            },
            // Extracted from cl.h (2.0) and http://streamcomputing.eu/downloads/?opencl_host.lang (opencl-const)
            'constant-opencl-host': {
                pattern: /\bCL_(?:A|ABGR|ADDRESS_(?:CLAMP(?:_TO_EDGE)?|MIRRORED_REPEAT|NONE|REPEAT)|ARGB|BGRA|BLOCKING|BUFFER_CREATE_TYPE_REGION|BUILD_(?:ERROR|IN_PROGRESS|NONE|PROGRAM_FAILURE|SUCCESS)|COMMAND_(?:ACQUIRE_GL_OBJECTS|BARRIER|COPY_(?:BUFFER(?:_RECT|_TO_IMAGE)?|IMAGE(?:_TO_BUFFER)?)|FILL_(?:BUFFER|IMAGE)|MAP(?:_BUFFER|_IMAGE)|MARKER|MIGRATE(?:_SVM)?_MEM_OBJECTS|NATIVE_KERNEL|NDRANGE_KERNEL|READ_(?:BUFFER(?:_RECT)?|IMAGE)|RELEASE_GL_OBJECTS|SVM_(?:FREE|MAP|MEMCPY|MEMFILL|UNMAP)|TASK|UNMAP_MEM_OBJECT|USER|WRITE_(?:BUFFER(?:_RECT)?|IMAGE))|COMPILER_NOT_AVAILABLE|COMPILE_PROGRAM_FAILURE|COMPLETE|CONTEXT_(?:DEVICES|INTEROP_USER_SYNC|NUM_DEVICES|PLATFORM|PROPERTIES|REFERENCE_COUNT)|DEPTH(?:_STENCIL)?|DEVICE_(?:ADDRESS_BITS|AFFINITY_DOMAIN_(?:L[1-4]_CACHE|NEXT_PARTITIONABLE|NUMA)|AVAILABLE|BUILT_IN_KERNELS|COMPILER_AVAILABLE|DOUBLE_FP_CONFIG|ENDIAN_LITTLE|ERROR_CORRECTION_SUPPORT|EXECUTION_CAPABILITIES|EXTENSIONS|GLOBAL_(?:MEM_(?:CACHELINE_SIZE|CACHE_SIZE|CACHE_TYPE|SIZE)|VARIABLE_PREFERRED_TOTAL_SIZE)|HOST_UNIFIED_MEMORY|IL_VERSION|IMAGE(?:2D_MAX_(?:HEIGHT|WIDTH)|3D_MAX_(?:DEPTH|HEIGHT|WIDTH)|_BASE_ADDRESS_ALIGNMENT|_MAX_ARRAY_SIZE|_MAX_BUFFER_SIZE|_PITCH_ALIGNMENT|_SUPPORT)|LINKER_AVAILABLE|LOCAL_MEM_SIZE|LOCAL_MEM_TYPE|MAX_(?:CLOCK_FREQUENCY|COMPUTE_UNITS|CONSTANT_ARGS|CONSTANT_BUFFER_SIZE|GLOBAL_VARIABLE_SIZE|MEM_ALLOC_SIZE|NUM_SUB_GROUPS|ON_DEVICE_(?:EVENTS|QUEUES)|PARAMETER_SIZE|PIPE_ARGS|READ_IMAGE_ARGS|READ_WRITE_IMAGE_ARGS|SAMPLERS|WORK_GROUP_SIZE|WORK_ITEM_DIMENSIONS|WORK_ITEM_SIZES|WRITE_IMAGE_ARGS)|MEM_BASE_ADDR_ALIGN|MIN_DATA_TYPE_ALIGN_SIZE|NAME|NATIVE_VECTOR_WIDTH_(?:CHAR|DOUBLE|FLOAT|HALF|INT|LONG|SHORT)|NOT_(?:AVAILABLE|FOUND)|OPENCL_C_VERSION|PARENT_DEVICE|PARTITION_(?:AFFINITY_DOMAIN|BY_AFFINITY_DOMAIN|BY_COUNTS|BY_COUNTS_LIST_END|EQUALLY|FAILED|MAX_SUB_DEVICES|PROPERTIES|TYPE)|PIPE_MAX_(?:ACTIVE_RESERVATIONS|PACKET_SIZE)|PLATFORM|PREFERRED_(?:GLOBAL_ATOMIC_ALIGNMENT|INTEROP_USER_SYNC|LOCAL_ATOMIC_ALIGNMENT|PLATFORM_ATOMIC_ALIGNMENT|VECTOR_WIDTH_(?:CHAR|DOUBLE|FLOAT|HALF|INT|LONG|SHORT))|PRINTF_BUFFER_SIZE|PROFILE|PROFILING_TIMER_RESOLUTION|QUEUE_(?:ON_(?:DEVICE_(?:MAX_SIZE|PREFERRED_SIZE|PROPERTIES)|HOST_PROPERTIES)|PROPERTIES)|REFERENCE_COUNT|SINGLE_FP_CONFIG|SUB_GROUP_INDEPENDENT_FORWARD_PROGRESS|SVM_(?:ATOMICS|CAPABILITIES|COARSE_GRAIN_BUFFER|FINE_GRAIN_BUFFER|FINE_GRAIN_SYSTEM)|TYPE(?:_ACCELERATOR|_ALL|_CPU|_CUSTOM|_DEFAULT|_GPU)?|VENDOR(?:_ID)?|VERSION)|DRIVER_VERSION|EVENT_(?:COMMAND_(?:EXECUTION_STATUS|QUEUE|TYPE)|CONTEXT|REFERENCE_COUNT)|EXEC_(?:KERNEL|NATIVE_KERNEL|STATUS_ERROR_FOR_EVENTS_IN_WAIT_LIST)|FILTER_(?:LINEAR|NEAREST)|FLOAT|FP_(?:CORRECTLY_ROUNDED_DIVIDE_SQRT|DENORM|FMA|INF_NAN|ROUND_TO_INF|ROUND_TO_NEAREST|ROUND_TO_ZERO|SOFT_FLOAT)|GLOBAL|HALF_FLOAT|IMAGE_(?:ARRAY_SIZE|BUFFER|DEPTH|ELEMENT_SIZE|FORMAT|FORMAT_MISMATCH|FORMAT_NOT_SUPPORTED|HEIGHT|NUM_MIP_LEVELS|NUM_SAMPLES|ROW_PITCH|SLICE_PITCH|WIDTH)|INTENSITY|INVALID_(?:ARG_INDEX|ARG_SIZE|ARG_VALUE|BINARY|BUFFER_SIZE|BUILD_OPTIONS|COMMAND_QUEUE|COMPILER_OPTIONS|CONTEXT|DEVICE|DEVICE_PARTITION_COUNT|DEVICE_QUEUE|DEVICE_TYPE|EVENT|EVENT_WAIT_LIST|GLOBAL_OFFSET|GLOBAL_WORK_SIZE|GL_OBJECT|HOST_PTR|IMAGE_DESCRIPTOR|IMAGE_FORMAT_DESCRIPTOR|IMAGE_SIZE|KERNEL|KERNEL_ARGS|KERNEL_DEFINITION|KERNEL_NAME|LINKER_OPTIONS|MEM_OBJECT|MIP_LEVEL|OPERATION|PIPE_SIZE|PLATFORM|PROGRAM|PROGRAM_EXECUTABLE|PROPERTY|QUEUE_PROPERTIES|SAMPLER|VALUE|WORK_DIMENSION|WORK_GROUP_SIZE|WORK_ITEM_SIZE)|KERNEL_(?:ARG_(?:ACCESS_(?:NONE|QUALIFIER|READ_ONLY|READ_WRITE|WRITE_ONLY)|ADDRESS_(?:CONSTANT|GLOBAL|LOCAL|PRIVATE|QUALIFIER)|INFO_NOT_AVAILABLE|NAME|TYPE_(?:CONST|NAME|NONE|PIPE|QUALIFIER|RESTRICT|VOLATILE))|ATTRIBUTES|COMPILE_NUM_SUB_GROUPS|COMPILE_WORK_GROUP_SIZE|CONTEXT|EXEC_INFO_SVM_FINE_GRAIN_SYSTEM|EXEC_INFO_SVM_PTRS|FUNCTION_NAME|GLOBAL_WORK_SIZE|LOCAL_MEM_SIZE|LOCAL_SIZE_FOR_SUB_GROUP_COUNT|MAX_NUM_SUB_GROUPS|MAX_SUB_GROUP_SIZE_FOR_NDRANGE|NUM_ARGS|PREFERRED_WORK_GROUP_SIZE_MULTIPLE|PRIVATE_MEM_SIZE|PROGRAM|REFERENCE_COUNT|SUB_GROUP_COUNT_FOR_NDRANGE|WORK_GROUP_SIZE)|LINKER_NOT_AVAILABLE|LINK_PROGRAM_FAILURE|LOCAL|LUMINANCE|MAP_(?:FAILURE|READ|WRITE|WRITE_INVALIDATE_REGION)|MEM_(?:ALLOC_HOST_PTR|ASSOCIATED_MEMOBJECT|CONTEXT|COPY_HOST_PTR|COPY_OVERLAP|FLAGS|HOST_NO_ACCESS|HOST_PTR|HOST_READ_ONLY|HOST_WRITE_ONLY|KERNEL_READ_AND_WRITE|MAP_COUNT|OBJECT_(?:ALLOCATION_FAILURE|BUFFER|IMAGE1D|IMAGE1D_ARRAY|IMAGE1D_BUFFER|IMAGE2D|IMAGE2D_ARRAY|IMAGE3D|PIPE)|OFFSET|READ_ONLY|READ_WRITE|REFERENCE_COUNT|SIZE|SVM_ATOMICS|SVM_FINE_GRAIN_BUFFER|TYPE|USES_SVM_POINTER|USE_HOST_PTR|WRITE_ONLY)|MIGRATE_MEM_OBJECT_(?:CONTENT_UNDEFINED|HOST)|MISALIGNED_SUB_BUFFER_OFFSET|NONE|NON_BLOCKING|OUT_OF_(?:HOST_MEMORY|RESOURCES)|PIPE_(?:MAX_PACKETS|PACKET_SIZE)|PLATFORM_(?:EXTENSIONS|HOST_TIMER_RESOLUTION|NAME|PROFILE|VENDOR|VERSION)|PROFILING_(?:COMMAND_(?:COMPLETE|END|QUEUED|START|SUBMIT)|INFO_NOT_AVAILABLE)|PROGRAM_(?:BINARIES|BINARY_SIZES|BINARY_TYPE(?:_COMPILED_OBJECT|_EXECUTABLE|_LIBRARY|_NONE)?|BUILD_(?:GLOBAL_VARIABLE_TOTAL_SIZE|LOG|OPTIONS|STATUS)|CONTEXT|DEVICES|IL|KERNEL_NAMES|NUM_DEVICES|NUM_KERNELS|REFERENCE_COUNT|SOURCE)|QUEUED|QUEUE_(?:CONTEXT|DEVICE|DEVICE_DEFAULT|ON_DEVICE|ON_DEVICE_DEFAULT|OUT_OF_ORDER_EXEC_MODE_ENABLE|PROFILING_ENABLE|PROPERTIES|REFERENCE_COUNT|SIZE)|R|RA|READ_(?:ONLY|WRITE)_CACHE|RG|RGB|RGBA|RGBx|RGx|RUNNING|Rx|SAMPLER_(?:ADDRESSING_MODE|CONTEXT|FILTER_MODE|LOD_MAX|LOD_MIN|MIP_FILTER_MODE|NORMALIZED_COORDS|REFERENCE_COUNT)|(?:UN)?SIGNED_INT(?:8|16|32)|SNORM_INT(?:8|16)|SUBMITTED|SUCCESS|UNORM_INT(?:8|16|24|_101010|_101010_2)|UNORM_SHORT_(?:555|565)|VERSION_(?:1_0|1_1|1_2|2_0|2_1)|sBGRA|sRGB|sRGBA|sRGBx)\b/,
                alias: 'constant'
            },
            // Extracted from cl.h (2.0) and http://streamcomputing.eu/downloads/?opencl_host.lang (opencl-host)
            'function-opencl-host': {
                pattern: /\bcl(?:BuildProgram|CloneKernel|CompileProgram|Create(?:Buffer|CommandQueue(?:WithProperties)?|Context|ContextFromType|Image|Image2D|Image3D|Kernel|KernelsInProgram|Pipe|ProgramWith(?:Binary|BuiltInKernels|IL|Source)|Sampler|SamplerWithProperties|SubBuffer|SubDevices|UserEvent)|Enqueue(?:(?:Barrier|Marker)(?:WithWaitList)?|Copy(?:Buffer(?:Rect|ToImage)?|Image(?:ToBuffer)?)|(?:Fill|Map)(?:Buffer|Image)|MigrateMemObjects|NDRangeKernel|NativeKernel|(?:Read|Write)(?:Buffer(?:Rect)?|Image)|SVM(?:Free|Map|MemFill|Memcpy|MigrateMem|Unmap)|Task|UnmapMemObject|WaitForEvents)|Finish|Flush|Get(?:CommandQueueInfo|ContextInfo|Device(?:AndHostTimer|IDs|Info)|Event(?:Profiling)?Info|ExtensionFunctionAddress(?:ForPlatform)?|HostTimer|ImageInfo|Kernel(?:ArgInfo|Info|SubGroupInfo|WorkGroupInfo)|MemObjectInfo|PipeInfo|Platform(?:IDs|Info)|Program(?:Build)?Info|SamplerInfo|SupportedImageFormats)|LinkProgram|(?:Release|Retain)(?:CommandQueue|Context|Device|Event|Kernel|MemObject|Program|Sampler)|SVM(?:Alloc|Free)|Set(?:CommandQueueProperty|DefaultDeviceCommandQueue|EventCallback|Kernel|Kernel(?:Arg(?:SVMPointer)?|ExecInfo)|MemObjectDestructorCallback|UserEventStatus)|Unload(?:Platform)?Compiler|WaitForEvents)\b/,
                alias: 'function'
            }
        };
        /* OpenCL host API */ Prism.languages.insertBefore('c', 'keyword', attributes) // C++ includes everything from the OpenCL C host API plus the classes defined in cl2.h
        ;
        if (Prism.languages.cpp) {
            // Extracted from doxygen class list http://github.khronos.org/OpenCL-CLHPP/annotated.html
            attributes['type-opencl-host-cpp'] = {
                pattern: /\b(?:Buffer|BufferGL|BufferRenderGL|CommandQueue|Context|Device|DeviceCommandQueue|EnqueueArgs|Event|Image|Image1D|Image1DArray|Image1DBuffer|Image2D|Image2DArray|Image2DGL|Image3D|Image3DGL|ImageFormat|ImageGL|Kernel|KernelFunctor|LocalSpaceArg|Memory|NDRange|Pipe|Platform|Program|SVMAllocator|SVMTraitAtomic|SVMTraitCoarse|SVMTraitFine|SVMTraitReadOnly|SVMTraitReadWrite|SVMTraitWriteOnly|Sampler|UserEvent)\b/,
                alias: 'keyword'
            };
            Prism.languages.insertBefore('cpp', 'keyword', attributes);
        }
    })(Prism);
}

});

parcelRegister("a8Nds", function(module, exports) {
'use strict';
module.exports = $7620d403bfe30365$var$openqasm;
$7620d403bfe30365$var$openqasm.displayName = 'openqasm';
$7620d403bfe30365$var$openqasm.aliases = [
    'qasm'
];
function $7620d403bfe30365$var$openqasm(Prism) {
    // https://qiskit.github.io/openqasm/grammar/index.html
    Prism.languages.openqasm = {
        comment: /\/\*[\s\S]*?\*\/|\/\/.*/,
        string: {
            pattern: /"[^"\r\n\t]*"|'[^'\r\n\t]*'/,
            greedy: true
        },
        keyword: /\b(?:CX|OPENQASM|U|barrier|boxas|boxto|break|const|continue|ctrl|def|defcal|defcalgrammar|delay|else|end|for|gate|gphase|if|in|include|inv|kernel|lengthof|let|measure|pow|reset|return|rotary|stretchinf|while)\b|#pragma\b/,
        'class-name': /\b(?:angle|bit|bool|creg|fixed|float|int|length|qreg|qubit|stretch|uint)\b/,
        function: /\b(?:cos|exp|ln|popcount|rotl|rotr|sin|sqrt|tan)\b(?=\s*\()/,
        constant: /\b(?:euler|pi|tau)\b|π|𝜏|ℇ/,
        number: {
            pattern: /(^|[^.\w$])(?:\d+(?:\.\d*)?|\.\d+)(?:e[+-]?\d+)?(?:dt|ns|us|µs|ms|s)?/i,
            lookbehind: true
        },
        operator: /->|>>=?|<<=?|&&|\|\||\+\+|--|[!=<>&|~^+\-*/%]=?|@/,
        punctuation: /[(){}\[\];,:.]/
    };
    Prism.languages.qasm = Prism.languages.openqasm;
}

});

parcelRegister("ekCPT", function(module, exports) {
'use strict';
module.exports = $a6f10ef0003dc819$var$oz;
$a6f10ef0003dc819$var$oz.displayName = 'oz';
$a6f10ef0003dc819$var$oz.aliases = [];
function $a6f10ef0003dc819$var$oz(Prism) {
    Prism.languages.oz = {
        comment: {
            pattern: /\/\*[\s\S]*?\*\/|%.*/,
            greedy: true
        },
        string: {
            pattern: /"(?:[^"\\]|\\[\s\S])*"/,
            greedy: true
        },
        atom: {
            pattern: /'(?:[^'\\]|\\[\s\S])*'/,
            greedy: true,
            alias: 'builtin'
        },
        keyword: /\$|\[\]|\b(?:_|at|attr|case|catch|choice|class|cond|declare|define|dis|else(?:case|if)?|end|export|fail|false|feat|finally|from|fun|functor|if|import|in|local|lock|meth|nil|not|of|or|prepare|proc|prop|raise|require|self|skip|then|thread|true|try|unit)\b/,
        function: [
            /\b[a-z][A-Za-z\d]*(?=\()/,
            {
                pattern: /(\{)[A-Z][A-Za-z\d]*\b/,
                lookbehind: true
            }
        ],
        number: /\b(?:0[bx][\da-f]+|\d+(?:\.\d*)?(?:e~?\d+)?)\b|&(?:[^\\]|\\(?:\d{3}|.))/i,
        variable: /`(?:[^`\\]|\\.)+`/,
        'attr-name': /\b\w+(?=[ \t]*:(?![:=]))/,
        operator: /:(?:=|::?)|<[-:=]?|=(?:=|<?:?)|>=?:?|\\=:?|!!?|[|#+\-*\/,~^@]|\b(?:andthen|div|mod|orelse)\b/,
        punctuation: /[\[\](){}.:;?]/
    };
}

});

parcelRegister("lC7OV", function(module, exports) {
'use strict';
module.exports = $fbc33686560e5a4f$var$parigp;
$fbc33686560e5a4f$var$parigp.displayName = 'parigp';
$fbc33686560e5a4f$var$parigp.aliases = [];
function $fbc33686560e5a4f$var$parigp(Prism) {
    Prism.languages.parigp = {
        comment: /\/\*[\s\S]*?\*\/|\\\\.*/,
        string: {
            pattern: /"(?:[^"\\\r\n]|\\.)*"/,
            greedy: true
        },
        // PARI/GP does not care about white spaces at all
        // so let's process the keywords to build an appropriate regexp
        // (e.g. "b *r *e *a *k", etc.)
        keyword: function() {
            var keywords = [
                'breakpoint',
                'break',
                'dbg_down',
                'dbg_err',
                'dbg_up',
                'dbg_x',
                'forcomposite',
                'fordiv',
                'forell',
                'forpart',
                'forprime',
                'forstep',
                'forsubgroup',
                'forvec',
                'for',
                'iferr',
                'if',
                'local',
                'my',
                'next',
                'return',
                'until',
                'while'
            ];
            keywords = keywords.map(function(keyword) {
                return keyword.split('').join(' *');
            }).join('|');
            return RegExp('\\b(?:' + keywords + ')\\b');
        }(),
        function: /\b\w(?:[\w ]*\w)?(?= *\()/,
        number: {
            // The lookbehind and the negative lookahead prevent from breaking the .. operator
            pattern: /((?:\. *\. *)?)(?:\b\d(?: *\d)*(?: *(?!\. *\.)\.(?: *\d)*)?|\. *\d(?: *\d)*)(?: *e *(?:[+-] *)?\d(?: *\d)*)?/i,
            lookbehind: true
        },
        operator: /\. *\.|[*\/!](?: *=)?|%(?: *=|(?: *#)?(?: *')*)?|\+(?: *[+=])?|-(?: *[-=>])?|<(?: *>|(?: *<)?(?: *=)?)?|>(?: *>)?(?: *=)?|=(?: *=){0,2}|\\(?: *\/)?(?: *=)?|&(?: *&)?|\| *\||['#~^]/,
        punctuation: /[\[\]{}().,:;|]/
    };
}

});

parcelRegister("jksBg", function(module, exports) {
'use strict';
module.exports = $e12611f87a1949c1$var$parser;
$e12611f87a1949c1$var$parser.displayName = 'parser';
$e12611f87a1949c1$var$parser.aliases = [];
function $e12611f87a1949c1$var$parser(Prism) {
    (function(Prism) {
        var parser = Prism.languages.parser = Prism.languages.extend('markup', {
            keyword: {
                pattern: /(^|[^^])(?:\^(?:case|eval|for|if|switch|throw)\b|@(?:BASE|CLASS|GET(?:_DEFAULT)?|OPTIONS|SET_DEFAULT|USE)\b)/,
                lookbehind: true
            },
            variable: {
                pattern: /(^|[^^])\B\$(?:\w+|(?=[.{]))(?:(?:\.|::?)\w+)*(?:\.|::?)?/,
                lookbehind: true,
                inside: {
                    punctuation: /\.|:+/
                }
            },
            function: {
                pattern: /(^|[^^])\B[@^]\w+(?:(?:\.|::?)\w+)*(?:\.|::?)?/,
                lookbehind: true,
                inside: {
                    keyword: {
                        pattern: /(^@)(?:GET_|SET_)/,
                        lookbehind: true
                    },
                    punctuation: /\.|:+/
                }
            },
            escape: {
                pattern: /\^(?:[$^;@()\[\]{}"':]|#[a-f\d]*)/i,
                alias: 'builtin'
            },
            punctuation: /[\[\](){};]/
        });
        parser = Prism.languages.insertBefore('parser', 'keyword', {
            'parser-comment': {
                pattern: /(\s)#.*/,
                lookbehind: true,
                alias: 'comment'
            },
            expression: {
                // Allow for 3 levels of depth
                pattern: /(^|[^^])\((?:[^()]|\((?:[^()]|\((?:[^()])*\))*\))*\)/,
                greedy: true,
                lookbehind: true,
                inside: {
                    string: {
                        pattern: /(^|[^^])(["'])(?:(?!\2)[^^]|\^[\s\S])*\2/,
                        lookbehind: true
                    },
                    keyword: parser.keyword,
                    variable: parser.variable,
                    function: parser.function,
                    boolean: /\b(?:false|true)\b/,
                    number: /\b(?:0x[a-f\d]+|\d+(?:\.\d*)?(?:e[+-]?\d+)?)\b/i,
                    escape: parser.escape,
                    operator: /[~+*\/\\%]|!(?:\|\|?|=)?|&&?|\|\|?|==|<[<=]?|>[>=]?|-[fd]?|\b(?:def|eq|ge|gt|in|is|le|lt|ne)\b/,
                    punctuation: parser.punctuation
                }
            }
        });
        Prism.languages.insertBefore('inside', 'punctuation', {
            expression: parser.expression,
            keyword: parser.keyword,
            variable: parser.variable,
            function: parser.function,
            escape: parser.escape,
            'parser-punctuation': {
                pattern: parser.punctuation,
                alias: 'punctuation'
            }
        }, parser['tag'].inside['attr-value']);
    })(Prism);
}

});

parcelRegister("4EXaf", function(module, exports) {
'use strict';
module.exports = $3648caa38fe9cd70$var$pascal;
$3648caa38fe9cd70$var$pascal.displayName = 'pascal';
$3648caa38fe9cd70$var$pascal.aliases = [
    'objectpascal'
];
function $3648caa38fe9cd70$var$pascal(Prism) {
    // Based on Free Pascal
    /* TODO
Support inline asm ?
*/ Prism.languages.pascal = {
        directive: {
            pattern: /\{\$[\s\S]*?\}/,
            greedy: true,
            alias: [
                'marco',
                'property'
            ]
        },
        comment: {
            pattern: /\(\*[\s\S]*?\*\)|\{[\s\S]*?\}|\/\/.*/,
            greedy: true
        },
        string: {
            pattern: /(?:'(?:''|[^'\r\n])*'(?!')|#[&$%]?[a-f\d]+)+|\^[a-z]/i,
            greedy: true
        },
        asm: {
            pattern: /(\basm\b)[\s\S]+?(?=\bend\s*[;[])/i,
            lookbehind: true,
            greedy: true,
            inside: null // see below
        },
        keyword: [
            {
                // Turbo Pascal
                pattern: /(^|[^&])\b(?:absolute|array|asm|begin|case|const|constructor|destructor|do|downto|else|end|file|for|function|goto|if|implementation|inherited|inline|interface|label|nil|object|of|operator|packed|procedure|program|record|reintroduce|repeat|self|set|string|then|to|type|unit|until|uses|var|while|with)\b/i,
                lookbehind: true
            },
            {
                // Free Pascal
                pattern: /(^|[^&])\b(?:dispose|exit|false|new|true)\b/i,
                lookbehind: true
            },
            {
                // Object Pascal
                pattern: /(^|[^&])\b(?:class|dispinterface|except|exports|finalization|finally|initialization|inline|library|on|out|packed|property|raise|resourcestring|threadvar|try)\b/i,
                lookbehind: true
            },
            {
                // Modifiers
                pattern: /(^|[^&])\b(?:absolute|abstract|alias|assembler|bitpacked|break|cdecl|continue|cppdecl|cvar|default|deprecated|dynamic|enumerator|experimental|export|external|far|far16|forward|generic|helper|implements|index|interrupt|iochecks|local|message|name|near|nodefault|noreturn|nostackframe|oldfpccall|otherwise|overload|override|pascal|platform|private|protected|public|published|read|register|reintroduce|result|safecall|saveregisters|softfloat|specialize|static|stdcall|stored|strict|unaligned|unimplemented|varargs|virtual|write)\b/i,
                lookbehind: true
            }
        ],
        number: [
            // Hexadecimal, octal and binary
            /(?:[&%]\d+|\$[a-f\d]+)/i,
            /\b\d+(?:\.\d+)?(?:e[+-]?\d+)?/i
        ],
        operator: [
            /\.\.|\*\*|:=|<[<=>]?|>[>=]?|[+\-*\/]=?|[@^=]/,
            {
                pattern: /(^|[^&])\b(?:and|as|div|exclude|in|include|is|mod|not|or|shl|shr|xor)\b/,
                lookbehind: true
            }
        ],
        punctuation: /\(\.|\.\)|[()\[\]:;,.]/
    };
    Prism.languages.pascal.asm.inside = Prism.languages.extend('pascal', {
        asm: undefined,
        keyword: undefined,
        operator: undefined
    });
    Prism.languages.objectpascal = Prism.languages.pascal;
}

});

parcelRegister("kp3sJ", function(module, exports) {
'use strict';
module.exports = $eda8d3fdac846e99$var$pascaligo;
$eda8d3fdac846e99$var$pascaligo.displayName = 'pascaligo';
$eda8d3fdac846e99$var$pascaligo.aliases = [];
function $eda8d3fdac846e99$var$pascaligo(Prism) {
    (function(Prism) {
        // Pascaligo is a layer 2 smart contract language for the tezos blockchain
        var braces = /\((?:[^()]|\((?:[^()]|\([^()]*\))*\))*\)/.source;
        var type = /(?:\b\w+(?:<braces>)?|<braces>)/.source.replace(/<braces>/g, function() {
            return braces;
        });
        var pascaligo = Prism.languages.pascaligo = {
            comment: /\(\*[\s\S]+?\*\)|\/\/.*/,
            string: {
                pattern: /(["'`])(?:\\[\s\S]|(?!\1)[^\\])*\1|\^[a-z]/i,
                greedy: true
            },
            'class-name': [
                {
                    pattern: RegExp(/(\btype\s+\w+\s+is\s+)<type>/.source.replace(/<type>/g, function() {
                        return type;
                    }), 'i'),
                    lookbehind: true,
                    inside: null // see below
                },
                {
                    pattern: RegExp(/<type>(?=\s+is\b)/.source.replace(/<type>/g, function() {
                        return type;
                    }), 'i'),
                    inside: null // see below
                },
                {
                    pattern: RegExp(/(:\s*)<type>/.source.replace(/<type>/g, function() {
                        return type;
                    })),
                    lookbehind: true,
                    inside: null // see below
                }
            ],
            keyword: {
                pattern: /(^|[^&])\b(?:begin|block|case|const|else|end|fail|for|from|function|if|is|nil|of|remove|return|skip|then|type|var|while|with)\b/i,
                lookbehind: true
            },
            boolean: {
                pattern: /(^|[^&])\b(?:False|True)\b/i,
                lookbehind: true
            },
            builtin: {
                pattern: /(^|[^&])\b(?:bool|int|list|map|nat|record|string|unit)\b/i,
                lookbehind: true
            },
            function: /\b\w+(?=\s*\()/,
            number: [
                // Hexadecimal, octal and binary
                /%[01]+|&[0-7]+|\$[a-f\d]+/i,
                /\b\d+(?:\.\d+)?(?:e[+-]?\d+)?(?:mtz|n)?/i
            ],
            operator: /->|=\/=|\.\.|\*\*|:=|<[<=>]?|>[>=]?|[+\-*\/]=?|[@^=|]|\b(?:and|mod|or)\b/,
            punctuation: /\(\.|\.\)|[()\[\]:;,.{}]/
        };
        var classNameInside = [
            'comment',
            'keyword',
            'builtin',
            'operator',
            'punctuation'
        ].reduce(function(accum, key) {
            accum[key] = pascaligo[key];
            return accum;
        }, {});
        pascaligo['class-name'].forEach(function(p) {
            p.inside = classNameInside;
        });
    })(Prism);
}

});

parcelRegister("9RQU0", function(module, exports) {
'use strict';
module.exports = $72f21993ed841ba3$var$pcaxis;
$72f21993ed841ba3$var$pcaxis.displayName = 'pcaxis';
$72f21993ed841ba3$var$pcaxis.aliases = [
    'px'
];
function $72f21993ed841ba3$var$pcaxis(Prism) {
    Prism.languages.pcaxis = {
        string: /"[^"]*"/,
        keyword: {
            pattern: /((?:^|;)\s*)[-A-Z\d]+(?:\s*\[[-\w]+\])?(?:\s*\("[^"]*"(?:,\s*"[^"]*")*\))?(?=\s*=)/,
            lookbehind: true,
            greedy: true,
            inside: {
                keyword: /^[-A-Z\d]+/,
                language: {
                    pattern: /^(\s*)\[[-\w]+\]/,
                    lookbehind: true,
                    inside: {
                        punctuation: /^\[|\]$/,
                        property: /[-\w]+/
                    }
                },
                'sub-key': {
                    pattern: /^(\s*)\S[\s\S]*/,
                    lookbehind: true,
                    inside: {
                        parameter: {
                            pattern: /"[^"]*"/,
                            alias: 'property'
                        },
                        punctuation: /^\(|\)$|,/
                    }
                }
            }
        },
        operator: /=/,
        tlist: {
            pattern: /TLIST\s*\(\s*\w+(?:(?:\s*,\s*"[^"]*")+|\s*,\s*"[^"]*"-"[^"]*")?\s*\)/,
            greedy: true,
            inside: {
                function: /^TLIST/,
                property: {
                    pattern: /^(\s*\(\s*)\w+/,
                    lookbehind: true
                },
                string: /"[^"]*"/,
                punctuation: /[(),]/,
                operator: /-/
            }
        },
        punctuation: /[;,]/,
        number: {
            pattern: /(^|\s)\d+(?:\.\d+)?(?!\S)/,
            lookbehind: true
        },
        boolean: /NO|YES/
    };
    Prism.languages.px = Prism.languages.pcaxis;
}

});

parcelRegister("fnogL", function(module, exports) {
'use strict';
module.exports = $b31bd461e07d793d$var$peoplecode;
$b31bd461e07d793d$var$peoplecode.displayName = 'peoplecode';
$b31bd461e07d793d$var$peoplecode.aliases = [
    'pcode'
];
function $b31bd461e07d793d$var$peoplecode(Prism) {
    Prism.languages.peoplecode = {
        comment: RegExp([
            // C-style multiline comments
            /\/\*[\s\S]*?\*\//.source,
            /\bREM[^;]*;/.source,
            /<\*(?:[^<*]|\*(?!>)|<(?!\*)|<\*(?:(?!\*>)[\s\S])*\*>)*\*>/.source,
            /\/\+[\s\S]*?\+\//.source
        ].join('|')),
        string: {
            pattern: /'(?:''|[^'\r\n])*'(?!')|"(?:""|[^"\r\n])*"(?!")/,
            greedy: true
        },
        variable: /%\w+/,
        'function-definition': {
            pattern: /((?:^|[^\w-])(?:function|method)\s+)\w+/i,
            lookbehind: true,
            alias: 'function'
        },
        'class-name': {
            pattern: /((?:^|[^-\w])(?:as|catch|class|component|create|extends|global|implements|instance|local|of|property|returns)\s+)\w+(?::\w+)*/i,
            lookbehind: true,
            inside: {
                punctuation: /:/
            }
        },
        keyword: /\b(?:abstract|alias|as|catch|class|component|constant|create|declare|else|end-(?:class|evaluate|for|function|get|if|method|set|try|while)|evaluate|extends|for|function|get|global|if|implements|import|instance|library|local|method|null|of|out|peopleCode|private|program|property|protected|readonly|ref|repeat|returns?|set|step|then|throw|to|try|until|value|when(?:-other)?|while)\b/i,
        'operator-keyword': {
            pattern: /\b(?:and|not|or)\b/i,
            alias: 'operator'
        },
        function: /[_a-z]\w*(?=\s*\()/i,
        boolean: /\b(?:false|true)\b/i,
        number: /\b\d+(?:\.\d+)?\b/,
        operator: /<>|[<>]=?|!=|\*\*|[-+*/|=@]/,
        punctuation: /[:.;,()[\]]/
    };
    Prism.languages.pcode = Prism.languages.peoplecode;
}

});

parcelRegister("lPUlp", function(module, exports) {
'use strict';
module.exports = $fe5a11353e0cabb9$var$perl;
$fe5a11353e0cabb9$var$perl.displayName = 'perl';
$fe5a11353e0cabb9$var$perl.aliases = [];
function $fe5a11353e0cabb9$var$perl(Prism) {
    (function(Prism) {
        var brackets = /(?:\((?:[^()\\]|\\[\s\S])*\)|\{(?:[^{}\\]|\\[\s\S])*\}|\[(?:[^[\]\\]|\\[\s\S])*\]|<(?:[^<>\\]|\\[\s\S])*>)/.source;
        Prism.languages.perl = {
            comment: [
                {
                    // POD
                    pattern: /(^\s*)=\w[\s\S]*?=cut.*/m,
                    lookbehind: true,
                    greedy: true
                },
                {
                    pattern: /(^|[^\\$])#.*/,
                    lookbehind: true,
                    greedy: true
                }
            ],
            // TODO Could be nice to handle Heredoc too.
            string: [
                {
                    pattern: RegExp(/\b(?:q|qq|qw|qx)(?![a-zA-Z0-9])\s*/.source + '(?:' + [
                        // q/.../
                        /([^a-zA-Z0-9\s{(\[<])(?:(?!\1)[^\\]|\\[\s\S])*\1/.source,
                        // eslint-disable-next-line regexp/strict
                        /([a-zA-Z0-9])(?:(?!\2)[^\\]|\\[\s\S])*\2/.source,
                        // q{...}
                        // q[...]
                        // q<...>
                        brackets
                    ].join('|') + ')'),
                    greedy: true
                },
                {
                    pattern: /("|`)(?:(?!\1)[^\\]|\\[\s\S])*\1/,
                    greedy: true
                },
                // FIXME Multi-line single-quoted strings are not supported as they would break variables containing '
                {
                    pattern: /'(?:[^'\\\r\n]|\\.)*'/,
                    greedy: true
                }
            ],
            regex: [
                {
                    pattern: RegExp(/\b(?:m|qr)(?![a-zA-Z0-9])\s*/.source + '(?:' + [
                        // m/.../
                        /([^a-zA-Z0-9\s{(\[<])(?:(?!\1)[^\\]|\\[\s\S])*\1/.source,
                        // eslint-disable-next-line regexp/strict
                        /([a-zA-Z0-9])(?:(?!\2)[^\\]|\\[\s\S])*\2/.source,
                        // m{...}
                        // m[...]
                        // m<...>
                        brackets
                    ].join('|') + ')' + /[msixpodualngc]*/.source),
                    greedy: true
                },
                {
                    pattern: RegExp(/(^|[^-])\b(?:s|tr|y)(?![a-zA-Z0-9])\s*/.source + '(?:' + [
                        // s/.../.../
                        // eslint-disable-next-line regexp/strict
                        /([^a-zA-Z0-9\s{(\[<])(?:(?!\2)[^\\]|\\[\s\S])*\2(?:(?!\2)[^\\]|\\[\s\S])*\2/.source,
                        // eslint-disable-next-line regexp/strict
                        /([a-zA-Z0-9])(?:(?!\3)[^\\]|\\[\s\S])*\3(?:(?!\3)[^\\]|\\[\s\S])*\3/.source,
                        // s{...}{...}
                        // s[...][...]
                        // s<...><...>
                        // s(...)[...]
                        brackets + /\s*/.source + brackets
                    ].join('|') + ')' + /[msixpodualngcer]*/.source),
                    lookbehind: true,
                    greedy: true
                },
                // The look-ahead tries to prevent two divisions on
                // the same line from being highlighted as regex.
                // This does not support multi-line regex.
                {
                    pattern: /\/(?:[^\/\\\r\n]|\\.)*\/[msixpodualngc]*(?=\s*(?:$|[\r\n,.;})&|\-+*~<>!?^]|(?:and|cmp|eq|ge|gt|le|lt|ne|not|or|x|xor)\b))/,
                    greedy: true
                }
            ],
            // FIXME Not sure about the handling of ::, ', and #
            variable: [
                // ${^POSTMATCH}
                /[&*$@%]\{\^[A-Z]+\}/,
                /[&*$@%]\^[A-Z_]/,
                /[&*$@%]#?(?=\{)/,
                /[&*$@%]#?(?:(?:::)*'?(?!\d)[\w$]+(?![\w$]))+(?:::)*/,
                /[&*$@%]\d+/,
                // The negative lookahead prevents from breaking the %= operator
                /(?!%=)[$@%][!"#$%&'()*+,\-.\/:;<=>?@[\\\]^_`{|}~]/
            ],
            filehandle: {
                // <>, <FOO>, _
                pattern: /<(?![<=])\S*?>|\b_\b/,
                alias: 'symbol'
            },
            'v-string': {
                // v1.2, 1.2.3
                pattern: /v\d+(?:\.\d+)*|\d+(?:\.\d+){2,}/,
                alias: 'string'
            },
            function: {
                pattern: /(\bsub[ \t]+)\w+/,
                lookbehind: true
            },
            keyword: /\b(?:any|break|continue|default|delete|die|do|else|elsif|eval|for|foreach|given|goto|if|last|local|my|next|our|package|print|redo|require|return|say|state|sub|switch|undef|unless|until|use|when|while)\b/,
            number: /\b(?:0x[\dA-Fa-f](?:_?[\dA-Fa-f])*|0b[01](?:_?[01])*|(?:(?:\d(?:_?\d)*)?\.)?\d(?:_?\d)*(?:[Ee][+-]?\d+)?)\b/,
            operator: /-[rwxoRWXOezsfdlpSbctugkTBMAC]\b|\+[+=]?|-[-=>]?|\*\*?=?|\/\/?=?|=[=~>]?|~[~=]?|\|\|?=?|&&?=?|<(?:=>?|<=?)?|>>?=?|![~=]?|[%^]=?|\.(?:=|\.\.?)?|[\\?]|\bx(?:=|\b)|\b(?:and|cmp|eq|ge|gt|le|lt|ne|not|or|xor)\b/,
            punctuation: /[{}[\];(),:]/
        };
    })(Prism);
}

});

parcelRegister("fESM7", function(module, exports) {
'use strict';

var $antOF = parcelRequire("antOF");
module.exports = $b66514a75c0766d6$var$phpExtras;
$b66514a75c0766d6$var$phpExtras.displayName = 'phpExtras';
$b66514a75c0766d6$var$phpExtras.aliases = [];
function $b66514a75c0766d6$var$phpExtras(Prism) {
    Prism.register($antOF);
    Prism.languages.insertBefore('php', 'variable', {
        this: {
            pattern: /\$this\b/,
            alias: 'keyword'
        },
        global: /\$(?:GLOBALS|HTTP_RAW_POST_DATA|_(?:COOKIE|ENV|FILES|GET|POST|REQUEST|SERVER|SESSION)|argc|argv|http_response_header|php_errormsg)\b/,
        scope: {
            pattern: /\b[\w\\]+::/,
            inside: {
                keyword: /\b(?:parent|self|static)\b/,
                punctuation: /::|\\/
            }
        }
    });
}

});

parcelRegister("Eq0zv", function(module, exports) {
'use strict';

var $antOF = parcelRequire("antOF");

var $e9UW8 = parcelRequire("e9UW8");
module.exports = $0797e93b92c017f2$var$phpdoc;
$0797e93b92c017f2$var$phpdoc.displayName = 'phpdoc';
$0797e93b92c017f2$var$phpdoc.aliases = [];
function $0797e93b92c017f2$var$phpdoc(Prism) {
    Prism.register($antOF);
    Prism.register($e9UW8);
    (function(Prism) {
        var typeExpression = /(?:\b[a-zA-Z]\w*|[|\\[\]])+/.source;
        Prism.languages.phpdoc = Prism.languages.extend('javadoclike', {
            parameter: {
                pattern: RegExp('(@(?:global|param|property(?:-read|-write)?|var)\\s+(?:' + typeExpression + '\\s+)?)\\$\\w+'),
                lookbehind: true
            }
        });
        Prism.languages.insertBefore('phpdoc', 'keyword', {
            'class-name': [
                {
                    pattern: RegExp('(@(?:global|package|param|property(?:-read|-write)?|return|subpackage|throws|var)\\s+)' + typeExpression),
                    lookbehind: true,
                    inside: {
                        keyword: /\b(?:array|bool|boolean|callback|double|false|float|int|integer|mixed|null|object|resource|self|string|true|void)\b/,
                        punctuation: /[|\\[\]()]/
                    }
                }
            ]
        });
        Prism.languages.javadoclike.addSupport('php', Prism.languages.phpdoc);
    })(Prism);
}

});

parcelRegister("gBUFO", function(module, exports) {
'use strict';

var $4lsCO = parcelRequire("4lsCO");
module.exports = $c17c1033d63d5485$var$plsql;
$c17c1033d63d5485$var$plsql.displayName = 'plsql';
$c17c1033d63d5485$var$plsql.aliases = [];
function $c17c1033d63d5485$var$plsql(Prism) {
    Prism.register($4lsCO);
    Prism.languages.plsql = Prism.languages.extend('sql', {
        comment: {
            pattern: /\/\*[\s\S]*?\*\/|--.*/,
            greedy: true
        },
        // https://docs.oracle.com/en/database/oracle/oracle-database/21/lnpls/plsql-reserved-words-keywords.html
        keyword: /\b(?:A|ACCESSIBLE|ADD|AGENT|AGGREGATE|ALL|ALTER|AND|ANY|ARRAY|AS|ASC|AT|ATTRIBUTE|AUTHID|AVG|BEGIN|BETWEEN|BFILE_BASE|BINARY|BLOB_BASE|BLOCK|BODY|BOTH|BOUND|BULK|BY|BYTE|C|CALL|CALLING|CASCADE|CASE|CHAR|CHARACTER|CHARSET|CHARSETFORM|CHARSETID|CHAR_BASE|CHECK|CLOB_BASE|CLONE|CLOSE|CLUSTER|CLUSTERS|COLAUTH|COLLECT|COLUMNS|COMMENT|COMMIT|COMMITTED|COMPILED|COMPRESS|CONNECT|CONSTANT|CONSTRUCTOR|CONTEXT|CONTINUE|CONVERT|COUNT|CRASH|CREATE|CREDENTIAL|CURRENT|CURSOR|CUSTOMDATUM|DANGLING|DATA|DATE|DATE_BASE|DAY|DECLARE|DEFAULT|DEFINE|DELETE|DESC|DETERMINISTIC|DIRECTORY|DISTINCT|DOUBLE|DROP|DURATION|ELEMENT|ELSE|ELSIF|EMPTY|END|ESCAPE|EXCEPT|EXCEPTION|EXCEPTIONS|EXCLUSIVE|EXECUTE|EXISTS|EXIT|EXTERNAL|FETCH|FINAL|FIRST|FIXED|FLOAT|FOR|FORALL|FORCE|FROM|FUNCTION|GENERAL|GOTO|GRANT|GROUP|HASH|HAVING|HEAP|HIDDEN|HOUR|IDENTIFIED|IF|IMMEDIATE|IMMUTABLE|IN|INCLUDING|INDEX|INDEXES|INDICATOR|INDICES|INFINITE|INSERT|INSTANTIABLE|INT|INTERFACE|INTERSECT|INTERVAL|INTO|INVALIDATE|IS|ISOLATION|JAVA|LANGUAGE|LARGE|LEADING|LENGTH|LEVEL|LIBRARY|LIKE|LIKE2|LIKE4|LIKEC|LIMIT|LIMITED|LOCAL|LOCK|LONG|LOOP|MAP|MAX|MAXLEN|MEMBER|MERGE|MIN|MINUS|MINUTE|MOD|MODE|MODIFY|MONTH|MULTISET|MUTABLE|NAME|NAN|NATIONAL|NATIVE|NCHAR|NEW|NOCOMPRESS|NOCOPY|NOT|NOWAIT|NULL|NUMBER_BASE|OBJECT|OCICOLL|OCIDATE|OCIDATETIME|OCIDURATION|OCIINTERVAL|OCILOBLOCATOR|OCINUMBER|OCIRAW|OCIREF|OCIREFCURSOR|OCIROWID|OCISTRING|OCITYPE|OF|OLD|ON|ONLY|OPAQUE|OPEN|OPERATOR|OPTION|OR|ORACLE|ORADATA|ORDER|ORGANIZATION|ORLANY|ORLVARY|OTHERS|OUT|OVERLAPS|OVERRIDING|PACKAGE|PARALLEL_ENABLE|PARAMETER|PARAMETERS|PARENT|PARTITION|PASCAL|PERSISTABLE|PIPE|PIPELINED|PLUGGABLE|POLYMORPHIC|PRAGMA|PRECISION|PRIOR|PRIVATE|PROCEDURE|PUBLIC|RAISE|RANGE|RAW|READ|RECORD|REF|REFERENCE|RELIES_ON|REM|REMAINDER|RENAME|RESOURCE|RESULT|RESULT_CACHE|RETURN|RETURNING|REVERSE|REVOKE|ROLLBACK|ROW|SAMPLE|SAVE|SAVEPOINT|SB1|SB2|SB4|SECOND|SEGMENT|SELECT|SELF|SEPARATE|SEQUENCE|SERIALIZABLE|SET|SHARE|SHORT|SIZE|SIZE_T|SOME|SPARSE|SQL|SQLCODE|SQLDATA|SQLNAME|SQLSTATE|STANDARD|START|STATIC|STDDEV|STORED|STRING|STRUCT|STYLE|SUBMULTISET|SUBPARTITION|SUBSTITUTABLE|SUBTYPE|SUM|SYNONYM|TABAUTH|TABLE|TDO|THE|THEN|TIME|TIMESTAMP|TIMEZONE_ABBR|TIMEZONE_HOUR|TIMEZONE_MINUTE|TIMEZONE_REGION|TO|TRAILING|TRANSACTION|TRANSACTIONAL|TRUSTED|TYPE|UB1|UB2|UB4|UNDER|UNION|UNIQUE|UNPLUG|UNSIGNED|UNTRUSTED|UPDATE|USE|USING|VALIST|VALUE|VALUES|VARIABLE|VARIANCE|VARRAY|VARYING|VIEW|VIEWS|VOID|WHEN|WHERE|WHILE|WITH|WORK|WRAPPED|WRITE|YEAR|ZONE)\b/i,
        // https://docs.oracle.com/en/database/oracle/oracle-database/21/lnpls/plsql-language-fundamentals.html#GUID-96A42F7C-7A71-4B90-8255-CA9C8BD9722E
        operator: /:=?|=>|[<>^~!]=|\.\.|\|\||\*\*|[-+*/%<>=@]/
    });
    Prism.languages.insertBefore('plsql', 'operator', {
        label: {
            pattern: /<<\s*\w+\s*>>/,
            alias: 'symbol'
        }
    });
}

});

parcelRegister("jFhbb", function(module, exports) {
'use strict';
module.exports = $e50f2c200f99a3cf$var$powerquery;
$e50f2c200f99a3cf$var$powerquery.displayName = 'powerquery';
$e50f2c200f99a3cf$var$powerquery.aliases = [];
function $e50f2c200f99a3cf$var$powerquery(Prism) {
    // https://docs.microsoft.com/en-us/powerquery-m/power-query-m-language-specification
    Prism.languages.powerquery = {
        comment: {
            pattern: /(^|[^\\])(?:\/\*[\s\S]*?\*\/|\/\/.*)/,
            lookbehind: true,
            greedy: true
        },
        'quoted-identifier': {
            pattern: /#"(?:[^"\r\n]|"")*"(?!")/,
            greedy: true
        },
        string: {
            pattern: /(?:#!)?"(?:[^"\r\n]|"")*"(?!")/,
            greedy: true
        },
        constant: [
            /\bDay\.(?:Friday|Monday|Saturday|Sunday|Thursday|Tuesday|Wednesday)\b/,
            /\bTraceLevel\.(?:Critical|Error|Information|Verbose|Warning)\b/,
            /\bOccurrence\.(?:All|First|Last)\b/,
            /\bOrder\.(?:Ascending|Descending)\b/,
            /\bRoundingMode\.(?:AwayFromZero|Down|ToEven|TowardZero|Up)\b/,
            /\bMissingField\.(?:Error|Ignore|UseNull)\b/,
            /\bQuoteStyle\.(?:Csv|None)\b/,
            /\bJoinKind\.(?:FullOuter|Inner|LeftAnti|LeftOuter|RightAnti|RightOuter)\b/,
            /\bGroupKind\.(?:Global|Local)\b/,
            /\bExtraValues\.(?:Error|Ignore|List)\b/,
            /\bJoinAlgorithm\.(?:Dynamic|LeftHash|LeftIndex|PairwiseHash|RightHash|RightIndex|SortMerge)\b/,
            /\bJoinSide\.(?:Left|Right)\b/,
            /\bPrecision\.(?:Decimal|Double)\b/,
            /\bRelativePosition\.From(?:End|Start)\b/,
            /\bTextEncoding\.(?:Ascii|BigEndianUnicode|Unicode|Utf16|Utf8|Windows)\b/,
            /\b(?:Any|Binary|Date|DateTime|DateTimeZone|Duration|Function|Int16|Int32|Int64|Int8|List|Logical|None|Number|Record|Table|Text|Time)\.Type\b/,
            /\bnull\b/
        ],
        boolean: /\b(?:false|true)\b/,
        keyword: /\b(?:and|as|each|else|error|if|in|is|let|meta|not|nullable|optional|or|otherwise|section|shared|then|try|type)\b|#(?:binary|date|datetime|datetimezone|duration|infinity|nan|sections|shared|table|time)\b/,
        function: {
            pattern: /(^|[^#\w.])[a-z_][\w.]*(?=\s*\()/i,
            lookbehind: true
        },
        'data-type': {
            pattern: /\b(?:any|anynonnull|binary|date|datetime|datetimezone|duration|function|list|logical|none|number|record|table|text|time)\b/,
            alias: 'class-name'
        },
        number: {
            pattern: /\b0x[\da-f]+\b|(?:[+-]?(?:\b\d+\.)?\b\d+|[+-]\.\d+|(^|[^.])\B\.\d+)(?:e[+-]?\d+)?\b/i,
            lookbehind: true
        },
        operator: /[-+*\/&?@^]|<(?:=>?|>)?|>=?|=>?|\.\.\.?/,
        punctuation: /[,;\[\](){}]/
    };
    Prism.languages.pq = Prism.languages['powerquery'];
    Prism.languages.mscript = Prism.languages['powerquery'];
}

});

parcelRegister("aO3Fc", function(module, exports) {
'use strict';
module.exports = $7de16a6375f50edd$var$powershell;
$7de16a6375f50edd$var$powershell.displayName = 'powershell';
$7de16a6375f50edd$var$powershell.aliases = [];
function $7de16a6375f50edd$var$powershell(Prism) {
    (function(Prism) {
        var powershell = Prism.languages.powershell = {
            comment: [
                {
                    pattern: /(^|[^`])<#[\s\S]*?#>/,
                    lookbehind: true
                },
                {
                    pattern: /(^|[^`])#.*/,
                    lookbehind: true
                }
            ],
            string: [
                {
                    pattern: /"(?:`[\s\S]|[^`"])*"/,
                    greedy: true,
                    inside: null // see below
                },
                {
                    pattern: /'(?:[^']|'')*'/,
                    greedy: true
                }
            ],
            // Matches name spaces as well as casts, attribute decorators. Force starting with letter to avoid matching array indices
            // Supports two levels of nested brackets (e.g. `[OutputType([System.Collections.Generic.List[int]])]`)
            namespace: /\[[a-z](?:\[(?:\[[^\]]*\]|[^\[\]])*\]|[^\[\]])*\]/i,
            boolean: /\$(?:false|true)\b/i,
            variable: /\$\w+\b/,
            // Cmdlets and aliases. Aliases should come last, otherwise "write" gets preferred over "write-host" for example
            // Get-Command | ?{ $_.ModuleName -match "Microsoft.PowerShell.(Util|Core|Management)" }
            // Get-Alias | ?{ $_.ReferencedCommand.Module.Name -match "Microsoft.PowerShell.(Util|Core|Management)" }
            function: [
                /\b(?:Add|Approve|Assert|Backup|Block|Checkpoint|Clear|Close|Compare|Complete|Compress|Confirm|Connect|Convert|ConvertFrom|ConvertTo|Copy|Debug|Deny|Disable|Disconnect|Dismount|Edit|Enable|Enter|Exit|Expand|Export|Find|ForEach|Format|Get|Grant|Group|Hide|Import|Initialize|Install|Invoke|Join|Limit|Lock|Measure|Merge|Move|New|Open|Optimize|Out|Ping|Pop|Protect|Publish|Push|Read|Receive|Redo|Register|Remove|Rename|Repair|Request|Reset|Resize|Resolve|Restart|Restore|Resume|Revoke|Save|Search|Select|Send|Set|Show|Skip|Sort|Split|Start|Step|Stop|Submit|Suspend|Switch|Sync|Tee|Test|Trace|Unblock|Undo|Uninstall|Unlock|Unprotect|Unpublish|Unregister|Update|Use|Wait|Watch|Where|Write)-[a-z]+\b/i,
                /\b(?:ac|cat|chdir|clc|cli|clp|clv|compare|copy|cp|cpi|cpp|cvpa|dbp|del|diff|dir|ebp|echo|epal|epcsv|epsn|erase|fc|fl|ft|fw|gal|gbp|gc|gci|gcs|gdr|gi|gl|gm|gp|gps|group|gsv|gu|gv|gwmi|iex|ii|ipal|ipcsv|ipsn|irm|iwmi|iwr|kill|lp|ls|measure|mi|mount|move|mp|mv|nal|ndr|ni|nv|ogv|popd|ps|pushd|pwd|rbp|rd|rdr|ren|ri|rm|rmdir|rni|rnp|rp|rv|rvpa|rwmi|sal|saps|sasv|sbp|sc|select|set|shcm|si|sl|sleep|sls|sort|sp|spps|spsv|start|sv|swmi|tee|trcm|type|write)\b/i
            ],
            // per http://technet.microsoft.com/en-us/library/hh847744.aspx
            keyword: /\b(?:Begin|Break|Catch|Class|Continue|Data|Define|Do|DynamicParam|Else|ElseIf|End|Exit|Filter|Finally|For|ForEach|From|Function|If|InlineScript|Parallel|Param|Process|Return|Sequence|Switch|Throw|Trap|Try|Until|Using|Var|While|Workflow)\b/i,
            operator: {
                pattern: /(^|\W)(?:!|-(?:b?(?:and|x?or)|as|(?:Not)?(?:Contains|In|Like|Match)|eq|ge|gt|is(?:Not)?|Join|le|lt|ne|not|Replace|sh[lr])\b|-[-=]?|\+[+=]?|[*\/%]=?)/i,
                lookbehind: true
            },
            punctuation: /[|{}[\];(),.]/
        } // Variable interpolation inside strings, and nested expressions
        ;
        powershell.string[0].inside = {
            function: {
                // Allow for one level of nesting
                pattern: /(^|[^`])\$\((?:\$\([^\r\n()]*\)|(?!\$\()[^\r\n)])*\)/,
                lookbehind: true,
                inside: powershell
            },
            boolean: powershell.boolean,
            variable: powershell.variable
        };
    })(Prism);
}

});

parcelRegister("g2a1L", function(module, exports) {
'use strict';
module.exports = $bac49c76a7df206d$var$processing;
$bac49c76a7df206d$var$processing.displayName = 'processing';
$bac49c76a7df206d$var$processing.aliases = [];
function $bac49c76a7df206d$var$processing(Prism) {
    Prism.languages.processing = Prism.languages.extend('clike', {
        keyword: /\b(?:break|case|catch|class|continue|default|else|extends|final|for|if|implements|import|new|null|private|public|return|static|super|switch|this|try|void|while)\b/,
        // Spaces are allowed between function name and parenthesis
        function: /\b\w+(?=\s*\()/,
        operator: /<[<=]?|>[>=]?|&&?|\|\|?|[%?]|[!=+\-*\/]=?/
    });
    Prism.languages.insertBefore('processing', 'number', {
        // Special case: XML is a type
        constant: /\b(?!XML\b)[A-Z][A-Z\d_]+\b/,
        type: {
            pattern: /\b(?:boolean|byte|char|color|double|float|int|[A-Z]\w*)\b/,
            alias: 'class-name'
        }
    });
}

});

parcelRegister("lrCyl", function(module, exports) {
'use strict';
module.exports = $f9ca066828474109$var$prolog;
$f9ca066828474109$var$prolog.displayName = 'prolog';
$f9ca066828474109$var$prolog.aliases = [];
function $f9ca066828474109$var$prolog(Prism) {
    Prism.languages.prolog = {
        // Syntax depends on the implementation
        comment: {
            pattern: /\/\*[\s\S]*?\*\/|%.*/,
            greedy: true
        },
        // Depending on the implementation, strings may allow escaped newlines and quote-escape
        string: {
            pattern: /(["'])(?:\1\1|\\(?:\r\n|[\s\S])|(?!\1)[^\\\r\n])*\1(?!\1)/,
            greedy: true
        },
        builtin: /\b(?:fx|fy|xf[xy]?|yfx?)\b/,
        // FIXME: Should we list all null-ary predicates (not followed by a parenthesis) like halt, trace, etc.?
        function: /\b[a-z]\w*(?:(?=\()|\/\d+)/,
        number: /\b\d+(?:\.\d*)?/,
        // Custom operators are allowed
        operator: /[:\\=><\-?*@\/;+^|!$.]+|\b(?:is|mod|not|xor)\b/,
        punctuation: /[(){}\[\],]/
    };
}

});

parcelRegister("hQ4P8", function(module, exports) {
'use strict';
module.exports = $cfcb08e6d648f51e$var$promql;
$cfcb08e6d648f51e$var$promql.displayName = 'promql';
$cfcb08e6d648f51e$var$promql.aliases = [];
function $cfcb08e6d648f51e$var$promql(Prism) {
    (function(Prism) {
        // PromQL Aggregation Operators
        // (https://prometheus.io/docs/prometheus/latest/querying/operators/#aggregation-operators)
        var aggregations = [
            'sum',
            'min',
            'max',
            'avg',
            'group',
            'stddev',
            'stdvar',
            'count',
            'count_values',
            'bottomk',
            'topk',
            'quantile'
        ] // PromQL vector matching + the by and without clauses
        ;
        // (https://prometheus.io/docs/prometheus/latest/querying/operators/#vector-matching)
        var vectorMatching = [
            'on',
            'ignoring',
            'group_right',
            'group_left',
            'by',
            'without'
        ] // PromQL offset modifier
        ;
        // (https://prometheus.io/docs/prometheus/latest/querying/basics/#offset-modifier)
        var offsetModifier = [
            'offset'
        ];
        var keywords = aggregations.concat(vectorMatching, offsetModifier);
        Prism.languages.promql = {
            comment: {
                pattern: /(^[ \t]*)#.*/m,
                lookbehind: true
            },
            'vector-match': {
                // Match the comma-separated label lists inside vector matching:
                pattern: new RegExp('((?:' + vectorMatching.join('|') + ')\\s*)\\([^)]*\\)'),
                lookbehind: true,
                inside: {
                    'label-key': {
                        pattern: /\b[^,]+\b/,
                        alias: 'attr-name'
                    },
                    punctuation: /[(),]/
                }
            },
            'context-labels': {
                pattern: /\{[^{}]*\}/,
                inside: {
                    'label-key': {
                        pattern: /\b[a-z_]\w*(?=\s*(?:=|![=~]))/,
                        alias: 'attr-name'
                    },
                    'label-value': {
                        pattern: /(["'`])(?:\\[\s\S]|(?!\1)[^\\])*\1/,
                        greedy: true,
                        alias: 'attr-value'
                    },
                    punctuation: /\{|\}|=~?|![=~]|,/
                }
            },
            'context-range': [
                {
                    pattern: /\[[\w\s:]+\]/,
                    // [1m]
                    inside: {
                        punctuation: /\[|\]|:/,
                        'range-duration': {
                            pattern: /\b(?:\d+(?:[smhdwy]|ms))+\b/i,
                            alias: 'number'
                        }
                    }
                },
                {
                    pattern: /(\boffset\s+)\w+/,
                    // offset 1m
                    lookbehind: true,
                    inside: {
                        'range-duration': {
                            pattern: /\b(?:\d+(?:[smhdwy]|ms))+\b/i,
                            alias: 'number'
                        }
                    }
                }
            ],
            keyword: new RegExp('\\b(?:' + keywords.join('|') + ')\\b', 'i'),
            function: /\b[a-z_]\w*(?=\s*\()/i,
            number: /[-+]?(?:(?:\b\d+(?:\.\d+)?|\B\.\d+)(?:e[-+]?\d+)?\b|\b(?:0x[0-9a-f]+|nan|inf)\b)/i,
            operator: /[\^*/%+-]|==|!=|<=|<|>=|>|\b(?:and|or|unless)\b/i,
            punctuation: /[{};()`,.[\]]/
        };
    })(Prism);
}

});

parcelRegister("8i4O3", function(module, exports) {
'use strict';
module.exports = $6093bb97ca279e87$var$properties;
$6093bb97ca279e87$var$properties.displayName = 'properties';
$6093bb97ca279e87$var$properties.aliases = [];
function $6093bb97ca279e87$var$properties(Prism) {
    Prism.languages.properties = {
        comment: /^[ \t]*[#!].*$/m,
        'attr-value': {
            pattern: /(^[ \t]*(?:\\(?:\r\n|[\s\S])|[^\\\s:=])+(?: *[=:] *(?! )| ))(?:\\(?:\r\n|[\s\S])|[^\\\r\n])+/m,
            lookbehind: true
        },
        'attr-name': /^[ \t]*(?:\\(?:\r\n|[\s\S])|[^\\\s:=])+(?= *[=:]| )/m,
        punctuation: /[=:]/
    };
}

});

parcelRegister("4uTcK", function(module, exports) {
'use strict';
module.exports = $3464c93ff453f6b7$var$protobuf;
$3464c93ff453f6b7$var$protobuf.displayName = 'protobuf';
$3464c93ff453f6b7$var$protobuf.aliases = [];
function $3464c93ff453f6b7$var$protobuf(Prism) {
    (function(Prism) {
        var builtinTypes = /\b(?:bool|bytes|double|s?fixed(?:32|64)|float|[su]?int(?:32|64)|string)\b/;
        Prism.languages.protobuf = Prism.languages.extend('clike', {
            'class-name': [
                {
                    pattern: /(\b(?:enum|extend|message|service)\s+)[A-Za-z_]\w*(?=\s*\{)/,
                    lookbehind: true
                },
                {
                    pattern: /(\b(?:rpc\s+\w+|returns)\s*\(\s*(?:stream\s+)?)\.?[A-Za-z_]\w*(?:\.[A-Za-z_]\w*)*(?=\s*\))/,
                    lookbehind: true
                }
            ],
            keyword: /\b(?:enum|extend|extensions|import|message|oneof|option|optional|package|public|repeated|required|reserved|returns|rpc(?=\s+\w)|service|stream|syntax|to)\b(?!\s*=\s*\d)/,
            function: /\b[a-z_]\w*(?=\s*\()/i
        });
        Prism.languages.insertBefore('protobuf', 'operator', {
            map: {
                pattern: /\bmap<\s*[\w.]+\s*,\s*[\w.]+\s*>(?=\s+[a-z_]\w*\s*[=;])/i,
                alias: 'class-name',
                inside: {
                    punctuation: /[<>.,]/,
                    builtin: builtinTypes
                }
            },
            builtin: builtinTypes,
            'positional-class-name': {
                pattern: /(?:\b|\B\.)[a-z_]\w*(?:\.[a-z_]\w*)*(?=\s+[a-z_]\w*\s*[=;])/i,
                alias: 'class-name',
                inside: {
                    punctuation: /\./
                }
            },
            annotation: {
                pattern: /(\[\s*)[a-z_]\w*(?=\s*=)/i,
                lookbehind: true
            }
        });
    })(Prism);
}

});

parcelRegister("1Kzyd", function(module, exports) {
'use strict';
module.exports = $1465a9f7562ff322$var$psl;
$1465a9f7562ff322$var$psl.displayName = 'psl';
$1465a9f7562ff322$var$psl.aliases = [];
function $1465a9f7562ff322$var$psl(Prism) {
    Prism.languages.psl = {
        comment: {
            pattern: /#.*/,
            greedy: true
        },
        string: {
            pattern: /"(?:\\.|[^\\"])*"/,
            greedy: true,
            inside: {
                symbol: /\\[ntrbA-Z"\\]/
            }
        },
        'heredoc-string': {
            pattern: /<<<([a-zA-Z_]\w*)[\r\n](?:.*[\r\n])*?\1\b/,
            alias: 'string',
            greedy: true
        },
        keyword: /\b(?:__multi|__single|case|default|do|else|elsif|exit|export|for|foreach|function|if|last|line|local|next|requires|return|switch|until|while|word)\b/,
        constant: /\b(?:ALARM|CHART_ADD_GRAPH|CHART_DELETE_GRAPH|CHART_DESTROY|CHART_LOAD|CHART_PRINT|EOF|OFFLINE|OK|PSL_PROF_LOG|R_CHECK_HORIZ|R_CHECK_VERT|R_CLICKER|R_COLUMN|R_FRAME|R_ICON|R_LABEL|R_LABEL_CENTER|R_LIST_MULTIPLE|R_LIST_MULTIPLE_ND|R_LIST_SINGLE|R_LIST_SINGLE_ND|R_MENU|R_POPUP|R_POPUP_SCROLLED|R_RADIO_HORIZ|R_RADIO_VERT|R_ROW|R_SCALE_HORIZ|R_SCALE_VERT|R_SEP_HORIZ|R_SEP_VERT|R_SPINNER|R_TEXT_FIELD|R_TEXT_FIELD_LABEL|R_TOGGLE|TRIM_LEADING|TRIM_LEADING_AND_TRAILING|TRIM_REDUNDANT|TRIM_TRAILING|VOID|WARN)\b/,
        boolean: /\b(?:FALSE|False|NO|No|TRUE|True|YES|Yes|false|no|true|yes)\b/,
        variable: /\b(?:PslDebug|errno|exit_status)\b/,
        builtin: {
            pattern: /\b(?:PslExecute|PslFunctionCall|PslFunctionExists|PslSetOptions|_snmp_debug|acos|add_diary|annotate|annotate_get|ascii_to_ebcdic|asctime|asin|atan|atexit|batch_set|blackout|cat|ceil|chan_exists|change_state|close|code_cvt|cond_signal|cond_wait|console_type|convert_base|convert_date|convert_locale_date|cos|cosh|create|date|dcget_text|destroy|destroy_lock|dget_text|difference|dump_hist|ebcdic_to_ascii|encrypt|event_archive|event_catalog_get|event_check|event_query|event_range_manage|event_range_query|event_report|event_schedule|event_trigger|event_trigger2|execute|exists|exp|fabs|file|floor|fmod|fopen|fseek|ftell|full_discovery|get|get_chan_info|get_ranges|get_text|get_vars|getenv|gethostinfo|getpid|getpname|grep|history|history_get_retention|in_transition|index|int|internal|intersection|is_var|isnumber|join|kill|length|lines|lock|lock_info|log|log10|loge|matchline|msg_check|msg_get_format|msg_get_severity|msg_printf|msg_sprintf|ntharg|nthargf|nthline|nthlinef|num_bytes|num_consoles|pconfig|popen|poplines|pow|print|printf|proc_exists|process|random|read|readln|refresh_parameters|remote_check|remote_close|remote_event_query|remote_event_trigger|remote_file_send|remote_open|remove|replace|rindex|sec_check_priv|sec_store_get|sec_store_set|set|set_alarm_ranges|set_locale|share|sin|sinh|sleep|snmp_agent_config|snmp_agent_start|snmp_agent_stop|snmp_close|snmp_config|snmp_get|snmp_get_next|snmp_h_get|snmp_h_get_next|snmp_h_set|snmp_open|snmp_set|snmp_trap_ignore|snmp_trap_listen|snmp_trap_raise_std_trap|snmp_trap_receive|snmp_trap_register_im|snmp_trap_send|snmp_walk|sopen|sort|splitline|sprintf|sqrt|srandom|str_repeat|strcasecmp|subset|substr|system|tail|tan|tanh|text_domain|time|tmpnam|tolower|toupper|trace_psl_process|trim|union|unique|unlock|unset|va_arg|va_start|write)\b/,
            alias: 'builtin-function'
        },
        'foreach-variable': {
            pattern: /(\bforeach\s+(?:(?:\w+\b|"(?:\\.|[^\\"])*")\s+){0,2})[_a-zA-Z]\w*(?=\s*\()/,
            lookbehind: true,
            greedy: true
        },
        function: /\b[_a-z]\w*\b(?=\s*\()/i,
        number: /\b(?:0x[0-9a-f]+|\d+(?:\.\d+)?)\b/i,
        operator: /--|\+\+|&&=?|\|\|=?|<<=?|>>=?|[=!]~|[-+*/%&|^!=<>]=?|\.|[:?]/,
        punctuation: /[(){}\[\];,]/
    };
}

});

parcelRegister("7KD6t", function(module, exports) {
'use strict';
module.exports = $0174d33f81948b3a$var$pug;
$0174d33f81948b3a$var$pug.displayName = 'pug';
$0174d33f81948b3a$var$pug.aliases = [];
function $0174d33f81948b3a$var$pug(Prism) {
    (function(Prism) {
        // TODO:
        // - Add CSS highlighting inside <style> tags
        // - Add support for multi-line code blocks
        // - Add support for interpolation #{} and !{}
        // - Add support for tag interpolation #[]
        // - Add explicit support for plain text using |
        // - Add support for markup embedded in plain text
        Prism.languages.pug = {
            // Multiline stuff should appear before the rest
            // This handles both single-line and multi-line comments
            comment: {
                pattern: /(^([\t ]*))\/\/.*(?:(?:\r?\n|\r)\2[\t ].+)*/m,
                lookbehind: true
            },
            // All the tag-related part is in lookbehind
            // so that it can be highlighted by the "tag" pattern
            'multiline-script': {
                pattern: /(^([\t ]*)script\b.*\.[\t ]*)(?:(?:\r?\n|\r(?!\n))(?:\2[\t ].+|\s*?(?=\r?\n|\r)))+/m,
                lookbehind: true,
                inside: Prism.languages.javascript
            },
            // See at the end of the file for known filters
            filter: {
                pattern: /(^([\t ]*)):.+(?:(?:\r?\n|\r(?!\n))(?:\2[\t ].+|\s*?(?=\r?\n|\r)))+/m,
                lookbehind: true,
                inside: {
                    'filter-name': {
                        pattern: /^:[\w-]+/,
                        alias: 'variable'
                    },
                    text: /\S[\s\S]*/
                }
            },
            'multiline-plain-text': {
                pattern: /(^([\t ]*)[\w\-#.]+\.[\t ]*)(?:(?:\r?\n|\r(?!\n))(?:\2[\t ].+|\s*?(?=\r?\n|\r)))+/m,
                lookbehind: true
            },
            markup: {
                pattern: /(^[\t ]*)<.+/m,
                lookbehind: true,
                inside: Prism.languages.markup
            },
            doctype: {
                pattern: /((?:^|\n)[\t ]*)doctype(?: .+)?/,
                lookbehind: true
            },
            // This handle all conditional and loop keywords
            'flow-control': {
                pattern: /(^[\t ]*)(?:case|default|each|else|if|unless|when|while)\b(?: .+)?/m,
                lookbehind: true,
                inside: {
                    each: {
                        pattern: /^each .+? in\b/,
                        inside: {
                            keyword: /\b(?:each|in)\b/,
                            punctuation: /,/
                        }
                    },
                    branch: {
                        pattern: /^(?:case|default|else|if|unless|when|while)\b/,
                        alias: 'keyword'
                    },
                    rest: Prism.languages.javascript
                }
            },
            keyword: {
                pattern: /(^[\t ]*)(?:append|block|extends|include|prepend)\b.+/m,
                lookbehind: true
            },
            mixin: [
                // Declaration
                {
                    pattern: /(^[\t ]*)mixin .+/m,
                    lookbehind: true,
                    inside: {
                        keyword: /^mixin/,
                        function: /\w+(?=\s*\(|\s*$)/,
                        punctuation: /[(),.]/
                    }
                },
                {
                    pattern: /(^[\t ]*)\+.+/m,
                    lookbehind: true,
                    inside: {
                        name: {
                            pattern: /^\+\w+/,
                            alias: 'function'
                        },
                        rest: Prism.languages.javascript
                    }
                }
            ],
            script: {
                pattern: /(^[\t ]*script(?:(?:&[^(]+)?\([^)]+\))*[\t ]).+/m,
                lookbehind: true,
                inside: Prism.languages.javascript
            },
            'plain-text': {
                pattern: /(^[\t ]*(?!-)[\w\-#.]*[\w\-](?:(?:&[^(]+)?\([^)]+\))*\/?[\t ]).+/m,
                lookbehind: true
            },
            tag: {
                pattern: /(^[\t ]*)(?!-)[\w\-#.]*[\w\-](?:(?:&[^(]+)?\([^)]+\))*\/?:?/m,
                lookbehind: true,
                inside: {
                    attributes: [
                        {
                            pattern: /&[^(]+\([^)]+\)/,
                            inside: Prism.languages.javascript
                        },
                        {
                            pattern: /\([^)]+\)/,
                            inside: {
                                'attr-value': {
                                    pattern: /(=\s*(?!\s))(?:\{[^}]*\}|[^,)\r\n]+)/,
                                    lookbehind: true,
                                    inside: Prism.languages.javascript
                                },
                                'attr-name': /[\w-]+(?=\s*!?=|\s*[,)])/,
                                punctuation: /[!=(),]+/
                            }
                        }
                    ],
                    punctuation: /:/,
                    'attr-id': /#[\w\-]+/,
                    'attr-class': /\.[\w\-]+/
                }
            },
            code: [
                {
                    pattern: /(^[\t ]*(?:-|!?=)).+/m,
                    lookbehind: true,
                    inside: Prism.languages.javascript
                }
            ],
            punctuation: /[.\-!=|]+/
        };
        var filter_pattern = /(^([\t ]*)):<filter_name>(?:(?:\r?\n|\r(?!\n))(?:\2[\t ].+|\s*?(?=\r?\n|\r)))+/.source // Non exhaustive list of available filters and associated languages
        ;
        var filters = [
            {
                filter: 'atpl',
                language: 'twig'
            },
            {
                filter: 'coffee',
                language: 'coffeescript'
            },
            'ejs',
            'handlebars',
            'less',
            'livescript',
            'markdown',
            {
                filter: 'sass',
                language: 'scss'
            },
            'stylus'
        ];
        var all_filters = {};
        for(var i = 0, l = filters.length; i < l; i++){
            var filter = filters[i];
            filter = typeof filter === 'string' ? {
                filter: filter,
                language: filter
            } : filter;
            if (Prism.languages[filter.language]) all_filters['filter-' + filter.filter] = {
                pattern: RegExp(filter_pattern.replace('<filter_name>', function() {
                    return filter.filter;
                }), 'm'),
                lookbehind: true,
                inside: {
                    'filter-name': {
                        pattern: /^:[\w-]+/,
                        alias: 'variable'
                    },
                    text: {
                        pattern: /\S[\s\S]*/,
                        alias: [
                            filter.language,
                            'language-' + filter.language
                        ],
                        inside: Prism.languages[filter.language]
                    }
                }
            };
        }
        Prism.languages.insertBefore('pug', 'filter', all_filters);
    })(Prism);
}

});

parcelRegister("lv3Dh", function(module, exports) {
'use strict';
module.exports = $fa6f4f9140b17066$var$puppet;
$fa6f4f9140b17066$var$puppet.displayName = 'puppet';
$fa6f4f9140b17066$var$puppet.aliases = [];
function $fa6f4f9140b17066$var$puppet(Prism) {
    (function(Prism) {
        Prism.languages.puppet = {
            heredoc: [
                // Matches the content of a quoted heredoc string (subject to interpolation)
                {
                    pattern: /(@\("([^"\r\n\/):]+)"(?:\/[nrts$uL]*)?\).*(?:\r?\n|\r))(?:.*(?:\r?\n|\r(?!\n)))*?[ \t]*(?:\|[ \t]*)?(?:-[ \t]*)?\2/,
                    lookbehind: true,
                    alias: 'string',
                    inside: {
                        // Matches the end tag
                        punctuation: /(?=\S).*\S(?= *$)/ // See interpolation below
                    }
                },
                {
                    pattern: /(@\(([^"\r\n\/):]+)(?:\/[nrts$uL]*)?\).*(?:\r?\n|\r))(?:.*(?:\r?\n|\r(?!\n)))*?[ \t]*(?:\|[ \t]*)?(?:-[ \t]*)?\2/,
                    lookbehind: true,
                    greedy: true,
                    alias: 'string',
                    inside: {
                        // Matches the end tag
                        punctuation: /(?=\S).*\S(?= *$)/
                    }
                },
                {
                    pattern: /@\("?(?:[^"\r\n\/):]+)"?(?:\/[nrts$uL]*)?\)/,
                    alias: 'string',
                    inside: {
                        punctuation: {
                            pattern: /(\().+?(?=\))/,
                            lookbehind: true
                        }
                    }
                }
            ],
            'multiline-comment': {
                pattern: /(^|[^\\])\/\*[\s\S]*?\*\//,
                lookbehind: true,
                greedy: true,
                alias: 'comment'
            },
            regex: {
                // Must be prefixed with the keyword "node" or a non-word char
                pattern: /((?:\bnode\s+|[~=\(\[\{,]\s*|[=+]>\s*|^\s*))\/(?:[^\/\\]|\\[\s\S])+\/(?:[imx]+\b|\B)/,
                lookbehind: true,
                greedy: true,
                inside: {
                    // Extended regexes must have the x flag. They can contain single-line comments.
                    'extended-regex': {
                        pattern: /^\/(?:[^\/\\]|\\[\s\S])+\/[im]*x[im]*$/,
                        inside: {
                            comment: /#.*/
                        }
                    }
                }
            },
            comment: {
                pattern: /(^|[^\\])#.*/,
                lookbehind: true,
                greedy: true
            },
            string: {
                // Allow for one nested level of double quotes inside interpolation
                pattern: /(["'])(?:\$\{(?:[^'"}]|(["'])(?:(?!\2)[^\\]|\\[\s\S])*\2)+\}|\$(?!\{)|(?!\1)[^\\$]|\\[\s\S])*\1/,
                greedy: true,
                inside: {
                    'double-quoted': {
                        pattern: /^"[\s\S]*"$/,
                        inside: {
                        }
                    }
                }
            },
            variable: {
                pattern: /\$(?:::)?\w+(?:::\w+)*/,
                inside: {
                    punctuation: /::/
                }
            },
            'attr-name': /(?:\b\w+|\*)(?=\s*=>)/,
            function: [
                {
                    pattern: /(\.)(?!\d)\w+/,
                    lookbehind: true
                },
                /\b(?:contain|debug|err|fail|include|info|notice|realize|require|tag|warning)\b|\b(?!\d)\w+(?=\()/
            ],
            number: /\b(?:0x[a-f\d]+|\d+(?:\.\d+)?(?:e-?\d+)?)\b/i,
            boolean: /\b(?:false|true)\b/,
            // Includes words reserved for future use
            keyword: /\b(?:application|attr|case|class|consumes|default|define|else|elsif|function|if|import|inherits|node|private|produces|type|undef|unless)\b/,
            datatype: {
                pattern: /\b(?:Any|Array|Boolean|Callable|Catalogentry|Class|Collection|Data|Default|Enum|Float|Hash|Integer|NotUndef|Numeric|Optional|Pattern|Regexp|Resource|Runtime|Scalar|String|Struct|Tuple|Type|Undef|Variant)\b/,
                alias: 'symbol'
            },
            operator: /=[=~>]?|![=~]?|<(?:<\|?|[=~|-])?|>[>=]?|->?|~>|\|>?>?|[*\/%+?]|\b(?:and|in|or)\b/,
            punctuation: /[\[\]{}().,;]|:+/
        };
        var interpolation = [
            {
                // Allow for one nested level of braces inside interpolation
                pattern: /(^|[^\\])\$\{(?:[^'"{}]|\{[^}]*\}|(["'])(?:(?!\2)[^\\]|\\[\s\S])*\2)+\}/,
                lookbehind: true,
                inside: {
                    'short-variable': {
                        // Negative look-ahead prevent wrong highlighting of functions
                        pattern: /(^\$\{)(?!\w+\()(?:::)?\w+(?:::\w+)*/,
                        lookbehind: true,
                        alias: 'variable',
                        inside: {
                            punctuation: /::/
                        }
                    },
                    delimiter: {
                        pattern: /^\$/,
                        alias: 'variable'
                    },
                    rest: Prism.languages.puppet
                }
            },
            {
                pattern: /(^|[^\\])\$(?:::)?\w+(?:::\w+)*/,
                lookbehind: true,
                alias: 'variable',
                inside: {
                    punctuation: /::/
                }
            }
        ];
        Prism.languages.puppet['heredoc'][0].inside.interpolation = interpolation;
        Prism.languages.puppet['string'].inside['double-quoted'].inside.interpolation = interpolation;
    })(Prism);
}

});

parcelRegister("aHHNA", function(module, exports) {
'use strict';
module.exports = $0202d6465f6df533$var$pure;
$0202d6465f6df533$var$pure.displayName = 'pure';
$0202d6465f6df533$var$pure.aliases = [];
function $0202d6465f6df533$var$pure(Prism) {
    (function(Prism) {
        // https://agraef.github.io/pure-docs/pure.html#lexical-matters
        Prism.languages.pure = {
            comment: [
                {
                    pattern: /(^|[^\\])\/\*[\s\S]*?\*\//,
                    lookbehind: true
                },
                {
                    pattern: /(^|[^\\:])\/\/.*/,
                    lookbehind: true
                },
                /#!.+/
            ],
            'inline-lang': {
                pattern: /%<[\s\S]+?%>/,
                greedy: true,
                inside: {
                    lang: {
                        pattern: /(^%< *)-\*-.+?-\*-/,
                        lookbehind: true,
                        alias: 'comment'
                    },
                    delimiter: {
                        pattern: /^%<.*|%>$/,
                        alias: 'punctuation'
                    }
                }
            },
            string: {
                pattern: /"(?:\\.|[^"\\\r\n])*"/,
                greedy: true
            },
            number: {
                // The look-behind prevents wrong highlighting of the .. operator
                pattern: /((?:\.\.)?)(?:\b(?:inf|nan)\b|\b0x[\da-f]+|(?:\b(?:0b)?\d+(?:\.\d+)?|\B\.\d+)(?:e[+-]?\d+)?L?)/i,
                lookbehind: true
            },
            keyword: /\b(?:NULL|ans|break|bt|case|catch|cd|clear|const|def|del|dump|else|end|exit|extern|false|force|help|if|infix[lr]?|interface|let|ls|mem|namespace|nonfix|of|otherwise|outfix|override|postfix|prefix|private|public|pwd|quit|run|save|show|stats|then|throw|trace|true|type|underride|using|when|with)\b/,
            function: /\b(?:abs|add_(?:addr|constdef|(?:fundef|interface|macdef|typedef)(?:_at)?|vardef)|all|any|applp?|arity|bigintp?|blob(?:_crc|_size|p)?|boolp?|byte_c?string(?:_pointer)?|byte_(?:matrix|pointer)|calloc|cat|catmap|ceil|char[ps]?|check_ptrtag|chr|clear_sentry|clearsym|closurep?|cmatrixp?|cols?|colcat(?:map)?|colmap|colrev|colvector(?:p|seq)?|complex(?:_float_(?:matrix|pointer)|_matrix(?:_view)?|_pointer|p)?|conj|cookedp?|cst|cstring(?:_(?:dup|list|vector))?|curry3?|cyclen?|del_(?:constdef|fundef|interface|macdef|typedef|vardef)|delete|diag(?:mat)?|dim|dmatrixp?|do|double(?:_matrix(?:_view)?|_pointer|p)?|dowith3?|drop|dropwhile|eval(?:cmd)?|exactp|filter|fix|fixity|flip|float(?:_matrix|_pointer)|floor|fold[lr]1?|frac|free|funp?|functionp?|gcd|get(?:_(?:byte|constdef|double|float|fundef|int(?:64)?|interface(?:_typedef)?|long|macdef|pointer|ptrtag|sentry|short|string|typedef|vardef))?|globsym|hash|head|id|im|imatrixp?|index|inexactp|infp|init|insert|int(?:_matrix(?:_view)?|_pointer|p)?|int64_(?:matrix|pointer)|integerp?|iteraten?|iterwhile|join|keys?|lambdap?|last(?:err(?:pos)?)?|lcd|list[2p]?|listmap|make_ptrtag|malloc|map|matcat|matrixp?|max|member|min|nanp|nargs|nmatrixp?|null|numberp?|ord|pack(?:ed)?|pointer(?:_cast|_tag|_type|p)?|pow|pred|ptrtag|put(?:_(?:byte|double|float|int(?:64)?|long|pointer|short|string))?|rationalp?|re|realp?|realloc|recordp?|redim|reduce(?:_with)?|refp?|repeatn?|reverse|rlistp?|round|rows?|rowcat(?:map)?|rowmap|rowrev|rowvector(?:p|seq)?|same|scan[lr]1?|sentry|sgn|short_(?:matrix|pointer)|slice|smatrixp?|sort|split|str|strcat|stream|stride|string(?:_(?:dup|list|vector)|p)?|subdiag(?:mat)?|submat|subseq2?|substr|succ|supdiag(?:mat)?|symbolp?|tail|take|takewhile|thunkp?|transpose|trunc|tuplep?|typep|ubyte|uint(?:64)?|ulong|uncurry3?|unref|unzip3?|update|ushort|vals?|varp?|vector(?:p|seq)?|void|zip3?|zipwith3?)\b/,
            special: {
                pattern: /\b__[a-z]+__\b/i,
                alias: 'builtin'
            },
            // Any combination of operator chars can be an operator
            // eslint-disable-next-line no-misleading-character-class
            operator: /(?:[!"#$%&'*+,\-.\/:<=>?@\\^`|~\u00a1-\u00bf\u00d7-\u00f7\u20d0-\u2bff]|\b_+\b)+|\b(?:and|div|mod|not|or)\b/,
            // FIXME: How can we prevent | and , to be highlighted as operator when they are used alone?
            punctuation: /[(){}\[\];,|]/
        };
        var inlineLanguages = [
            'c',
            {
                lang: 'c++',
                alias: 'cpp'
            },
            'fortran'
        ];
        var inlineLanguageRe = /%< *-\*- *<lang>\d* *-\*-[\s\S]+?%>/.source;
        inlineLanguages.forEach(function(lang) {
            var alias = lang;
            if (typeof lang !== 'string') {
                alias = lang.alias;
                lang = lang.lang;
            }
            if (Prism.languages[alias]) {
                var o = {};
                o['inline-lang-' + alias] = {
                    pattern: RegExp(inlineLanguageRe.replace('<lang>', lang.replace(/([.+*?\/\\(){}\[\]])/g, '\\$1')), 'i'),
                    inside: Prism.util.clone(Prism.languages.pure['inline-lang'].inside)
                };
                o['inline-lang-' + alias].inside.rest = Prism.util.clone(Prism.languages[alias]);
                Prism.languages.insertBefore('pure', 'inline-lang', o);
            }
        }) // C is the default inline language
        ;
        if (Prism.languages.c) Prism.languages.pure['inline-lang'].inside.rest = Prism.util.clone(Prism.languages.c);
    })(Prism);
}

});

parcelRegister("huwdE", function(module, exports) {
'use strict';
module.exports = $cbbe3b1674a81c6a$var$purebasic;
$cbbe3b1674a81c6a$var$purebasic.displayName = 'purebasic';
$cbbe3b1674a81c6a$var$purebasic.aliases = [];
function $cbbe3b1674a81c6a$var$purebasic(Prism) {
    /*
Original Code by Bas Groothedde
!!MANY THANKS!! I never would have made this, regex and me will never be best friends ;)
==> https://codepen.io/ImagineProgramming/details/JYydBy/
slightly changed to pass all tests
*/ // PureBasic support, steal stuff from ansi-c
    Prism.languages.purebasic = Prism.languages.extend('clike', {
        comment: /;.*/,
        keyword: /\b(?:align|and|as|break|calldebugger|case|compilercase|compilerdefault|compilerelse|compilerelseif|compilerendif|compilerendselect|compilererror|compilerif|compilerselect|continue|data|datasection|debug|debuglevel|declare|declarec|declarecdll|declaredll|declaremodule|default|define|dim|disableasm|disabledebugger|disableexplicit|else|elseif|enableasm|enabledebugger|enableexplicit|end|enddatasection|enddeclaremodule|endenumeration|endif|endimport|endinterface|endmacro|endmodule|endprocedure|endselect|endstructure|endstructureunion|endwith|enumeration|extends|fakereturn|for|foreach|forever|global|gosub|goto|if|import|importc|includebinary|includefile|includepath|interface|macro|module|newlist|newmap|next|not|or|procedure|procedurec|procedurecdll|proceduredll|procedurereturn|protected|prototype|prototypec|read|redim|repeat|restore|return|runtime|select|shared|static|step|structure|structureunion|swap|threaded|to|until|wend|while|with|xincludefile|xor)\b/i,
        function: /\b\w+(?:\.\w+)?\s*(?=\()/,
        number: /(?:\$[\da-f]+|\b-?(?:\d+(?:\.\d+)?|\.\d+)(?:e[+-]?\d+)?)\b/i,
        operator: /(?:@\*?|\?|\*)\w+|-[>-]?|\+\+?|!=?|<<?=?|>>?=?|==?|&&?|\|?\||[~^%?*/@]/
    });
    Prism.languages.insertBefore('purebasic', 'keyword', {
        tag: /#\w+\$?/,
        asm: {
            pattern: /(^[\t ]*)!.*/m,
            lookbehind: true,
            alias: 'tag',
            inside: {
                comment: /;.*/,
                string: {
                    pattern: /(["'`])(?:\\.|(?!\1)[^\\\r\n])*\1/,
                    greedy: true
                },
                // Anonymous label references, i.e.: jmp @b
                'label-reference-anonymous': {
                    pattern: /(!\s*j[a-z]+\s+)@[fb]/i,
                    lookbehind: true,
                    alias: 'fasm-label'
                },
                // Named label reference, i.e.: jne label1
                'label-reference-addressed': {
                    pattern: /(!\s*j[a-z]+\s+)[A-Z._?$@][\w.?$@~#]*/i,
                    lookbehind: true,
                    alias: 'fasm-label'
                },
                keyword: [
                    /\b(?:extern|global)\b[^;\r\n]*/i,
                    /\b(?:CPU|DEFAULT|FLOAT)\b.*/
                ],
                function: {
                    pattern: /^([\t ]*!\s*)[\da-z]+(?=\s|$)/im,
                    lookbehind: true
                },
                'function-inline': {
                    pattern: /(:\s*)[\da-z]+(?=\s)/i,
                    lookbehind: true,
                    alias: 'function'
                },
                label: {
                    pattern: /^([\t ]*!\s*)[A-Za-z._?$@][\w.?$@~#]*(?=:)/m,
                    lookbehind: true,
                    alias: 'fasm-label'
                },
                register: /\b(?:st\d|[xyz]mm\d\d?|[cdt]r\d|r\d\d?[bwd]?|[er]?[abcd]x|[abcd][hl]|[er]?(?:bp|di|si|sp)|[cdefgs]s|mm\d+)\b/i,
                number: /(?:\b|-|(?=\$))(?:0[hx](?:[\da-f]*\.)?[\da-f]+(?:p[+-]?\d+)?|\d[\da-f]+[hx]|\$\d[\da-f]*|0[oq][0-7]+|[0-7]+[oq]|0[by][01]+|[01]+[by]|0[dt]\d+|(?:\d+(?:\.\d+)?|\.\d+)(?:\.?e[+-]?\d+)?[dt]?)\b/i,
                operator: /[\[\]*+\-/%<>=&|$!,.:]/
            }
        }
    });
    delete Prism.languages.purebasic['class-name'];
    delete Prism.languages.purebasic['boolean'];
    Prism.languages.pbfasm = Prism.languages['purebasic'];
}

});

parcelRegister("9jARG", function(module, exports) {
'use strict';

var $f3xTx = parcelRequire("f3xTx");
module.exports = $6c827c060753803b$var$purescript;
$6c827c060753803b$var$purescript.displayName = 'purescript';
$6c827c060753803b$var$purescript.aliases = [
    'purs'
];
function $6c827c060753803b$var$purescript(Prism) {
    Prism.register($f3xTx);
    Prism.languages.purescript = Prism.languages.extend('haskell', {
        keyword: /\b(?:ado|case|class|data|derive|do|else|forall|if|in|infixl|infixr|instance|let|module|newtype|of|primitive|then|type|where)\b|∀/,
        'import-statement': {
            // The imported or hidden names are not included in this import
            // statement. This is because we want to highlight those exactly like
            // we do for the names in the program.
            pattern: /(^[\t ]*)import\s+[A-Z][\w']*(?:\.[A-Z][\w']*)*(?:\s+as\s+[A-Z][\w']*(?:\.[A-Z][\w']*)*)?(?:\s+hiding\b)?/m,
            lookbehind: true,
            inside: {
                keyword: /\b(?:as|hiding|import)\b/,
                punctuation: /\./
            }
        },
        // These are builtin functions only. Constructors are highlighted later as a constant.
        builtin: /\b(?:absurd|add|ap|append|apply|between|bind|bottom|clamp|compare|comparing|compose|conj|const|degree|discard|disj|div|eq|flap|flip|gcd|identity|ifM|join|lcm|liftA1|liftM1|map|max|mempty|min|mod|mul|negate|not|notEq|one|otherwise|recip|show|sub|top|unit|unless|unlessM|void|when|whenM|zero)\b/,
        operator: [
            // Infix operators
            Prism.languages.haskell.operator[0],
            Prism.languages.haskell.operator[2],
            // This regex is equivalent to /(?=[\x80-\uFFFF])[\p{gc=Math_Symbol}\p{gc=Currency_Symbol}\p{Modifier_Symbol}\p{Other_Symbol}]/u
            // See https://github.com/PrismJS/prism/issues/3006 for more details.
            /[\xa2-\xa6\xa8\xa9\xac\xae-\xb1\xb4\xb8\xd7\xf7\u02c2-\u02c5\u02d2-\u02df\u02e5-\u02eb\u02ed\u02ef-\u02ff\u0375\u0384\u0385\u03f6\u0482\u058d-\u058f\u0606-\u0608\u060b\u060e\u060f\u06de\u06e9\u06fd\u06fe\u07f6\u07fe\u07ff\u09f2\u09f3\u09fa\u09fb\u0af1\u0b70\u0bf3-\u0bfa\u0c7f\u0d4f\u0d79\u0e3f\u0f01-\u0f03\u0f13\u0f15-\u0f17\u0f1a-\u0f1f\u0f34\u0f36\u0f38\u0fbe-\u0fc5\u0fc7-\u0fcc\u0fce\u0fcf\u0fd5-\u0fd8\u109e\u109f\u1390-\u1399\u166d\u17db\u1940\u19de-\u19ff\u1b61-\u1b6a\u1b74-\u1b7c\u1fbd\u1fbf-\u1fc1\u1fcd-\u1fcf\u1fdd-\u1fdf\u1fed-\u1fef\u1ffd\u1ffe\u2044\u2052\u207a-\u207c\u208a-\u208c\u20a0-\u20bf\u2100\u2101\u2103-\u2106\u2108\u2109\u2114\u2116-\u2118\u211e-\u2123\u2125\u2127\u2129\u212e\u213a\u213b\u2140-\u2144\u214a-\u214d\u214f\u218a\u218b\u2190-\u2307\u230c-\u2328\u232b-\u2426\u2440-\u244a\u249c-\u24e9\u2500-\u2767\u2794-\u27c4\u27c7-\u27e5\u27f0-\u2982\u2999-\u29d7\u29dc-\u29fb\u29fe-\u2b73\u2b76-\u2b95\u2b97-\u2bff\u2ce5-\u2cea\u2e50\u2e51\u2e80-\u2e99\u2e9b-\u2ef3\u2f00-\u2fd5\u2ff0-\u2ffb\u3004\u3012\u3013\u3020\u3036\u3037\u303e\u303f\u309b\u309c\u3190\u3191\u3196-\u319f\u31c0-\u31e3\u3200-\u321e\u322a-\u3247\u3250\u3260-\u327f\u328a-\u32b0\u32c0-\u33ff\u4dc0-\u4dff\ua490-\ua4c6\ua700-\ua716\ua720\ua721\ua789\ua78a\ua828-\ua82b\ua836-\ua839\uaa77-\uaa79\uab5b\uab6a\uab6b\ufb29\ufbb2-\ufbc1\ufdfc\ufdfd\ufe62\ufe64-\ufe66\ufe69\uff04\uff0b\uff1c-\uff1e\uff3e\uff40\uff5c\uff5e\uffe0-\uffe6\uffe8-\uffee\ufffc\ufffd]/
        ]
    });
    Prism.languages.purs = Prism.languages.purescript;
}

});

parcelRegister("3bEZu", function(module, exports) {
'use strict';
module.exports = $2522321392daf6bf$var$python;
$2522321392daf6bf$var$python.displayName = 'python';
$2522321392daf6bf$var$python.aliases = [
    'py'
];
function $2522321392daf6bf$var$python(Prism) {
    Prism.languages.python = {
        comment: {
            pattern: /(^|[^\\])#.*/,
            lookbehind: true,
            greedy: true
        },
        'string-interpolation': {
            pattern: /(?:f|fr|rf)(?:("""|''')[\s\S]*?\1|("|')(?:\\.|(?!\2)[^\\\r\n])*\2)/i,
            greedy: true,
            inside: {
                interpolation: {
                    // "{" <expression> <optional "!s", "!r", or "!a"> <optional ":" format specifier> "}"
                    pattern: /((?:^|[^{])(?:\{\{)*)\{(?!\{)(?:[^{}]|\{(?!\{)(?:[^{}]|\{(?!\{)(?:[^{}])+\})+\})+\}/,
                    lookbehind: true,
                    inside: {
                        'format-spec': {
                            pattern: /(:)[^:(){}]+(?=\}$)/,
                            lookbehind: true
                        },
                        'conversion-option': {
                            pattern: /![sra](?=[:}]$)/,
                            alias: 'punctuation'
                        },
                        rest: null
                    }
                },
                string: /[\s\S]+/
            }
        },
        'triple-quoted-string': {
            pattern: /(?:[rub]|br|rb)?("""|''')[\s\S]*?\1/i,
            greedy: true,
            alias: 'string'
        },
        string: {
            pattern: /(?:[rub]|br|rb)?("|')(?:\\.|(?!\1)[^\\\r\n])*\1/i,
            greedy: true
        },
        function: {
            pattern: /((?:^|\s)def[ \t]+)[a-zA-Z_]\w*(?=\s*\()/g,
            lookbehind: true
        },
        'class-name': {
            pattern: /(\bclass\s+)\w+/i,
            lookbehind: true
        },
        decorator: {
            pattern: /(^[\t ]*)@\w+(?:\.\w+)*/m,
            lookbehind: true,
            alias: [
                'annotation',
                'punctuation'
            ],
            inside: {
                punctuation: /\./
            }
        },
        keyword: /\b(?:_(?=\s*:)|and|as|assert|async|await|break|case|class|continue|def|del|elif|else|except|exec|finally|for|from|global|if|import|in|is|lambda|match|nonlocal|not|or|pass|print|raise|return|try|while|with|yield)\b/,
        builtin: /\b(?:__import__|abs|all|any|apply|ascii|basestring|bin|bool|buffer|bytearray|bytes|callable|chr|classmethod|cmp|coerce|compile|complex|delattr|dict|dir|divmod|enumerate|eval|execfile|file|filter|float|format|frozenset|getattr|globals|hasattr|hash|help|hex|id|input|int|intern|isinstance|issubclass|iter|len|list|locals|long|map|max|memoryview|min|next|object|oct|open|ord|pow|property|range|raw_input|reduce|reload|repr|reversed|round|set|setattr|slice|sorted|staticmethod|str|sum|super|tuple|type|unichr|unicode|vars|xrange|zip)\b/,
        boolean: /\b(?:False|None|True)\b/,
        number: /\b0(?:b(?:_?[01])+|o(?:_?[0-7])+|x(?:_?[a-f0-9])+)\b|(?:\b\d+(?:_\d+)*(?:\.(?:\d+(?:_\d+)*)?)?|\B\.\d+(?:_\d+)*)(?:e[+-]?\d+(?:_\d+)*)?j?(?!\w)/i,
        operator: /[-+%=]=?|!=|:=|\*\*?=?|\/\/?=?|<[<=>]?|>[=>]?|[&|^~]/,
        punctuation: /[{}[\];(),.:]/
    };
    Prism.languages.python['string-interpolation'].inside['interpolation'].inside.rest = Prism.languages.python;
    Prism.languages.py = Prism.languages.python;
}

});

parcelRegister("hNXLj", function(module, exports) {
'use strict';
module.exports = $cf655ec184fdae3d$var$q;
$cf655ec184fdae3d$var$q.displayName = 'q';
$cf655ec184fdae3d$var$q.aliases = [];
function $cf655ec184fdae3d$var$q(Prism) {
    Prism.languages.q = {
        string: /"(?:\\.|[^"\\\r\n])*"/,
        comment: [
            // From http://code.kx.com/wiki/Reference/Slash:
            // When / is following a space (or a right parenthesis, bracket, or brace), it is ignored with the rest of the line.
            {
                pattern: /([\t )\]}])\/.*/,
                lookbehind: true,
                greedy: true
            },
            // A line which has / as its first character and contains at least one other non-whitespace character is a whole-line comment and is ignored entirely.
            // A / on a line by itself begins a multiline comment which is terminated by the next \ on a line by itself.
            // If a / is not matched by a \, the multiline comment is unterminated and continues to end of file.
            // The / and \ must be the first char on the line, but may be followed by any amount of whitespace.
            {
                pattern: /(^|\r?\n|\r)\/[\t ]*(?:(?:\r?\n|\r)(?:.*(?:\r?\n|\r(?!\n)))*?(?:\\(?=[\t ]*(?:\r?\n|\r))|$)|\S.*)/,
                lookbehind: true,
                greedy: true
            },
            // A \ on a line by itself with no preceding matching / will comment to end of file.
            {
                pattern: /^\\[\t ]*(?:\r?\n|\r)[\s\S]+/m,
                greedy: true
            },
            {
                pattern: /^#!.+/m,
                greedy: true
            }
        ],
        symbol: /`(?::\S+|[\w.]*)/,
        datetime: {
            pattern: /0N[mdzuvt]|0W[dtz]|\d{4}\.\d\d(?:m|\.\d\d(?:T(?:\d\d(?::\d\d(?::\d\d(?:[.:]\d\d\d)?)?)?)?)?[dz]?)|\d\d:\d\d(?::\d\d(?:[.:]\d\d\d)?)?[uvt]?/,
            alias: 'number'
        },
        // The negative look-ahead prevents bad highlighting
        // of verbs 0: and 1:
        number: /\b(?![01]:)(?:0N[hje]?|0W[hj]?|0[wn]|0x[\da-fA-F]+|\d+(?:\.\d*)?(?:e[+-]?\d+)?[hjfeb]?)/,
        keyword: /\\\w+\b|\b(?:abs|acos|aj0?|all|and|any|asc|asin|asof|atan|attr|avgs?|binr?|by|ceiling|cols|cor|cos|count|cov|cross|csv|cut|delete|deltas|desc|dev|differ|distinct|div|do|dsave|ej|enlist|eval|except|exec|exit|exp|fby|fills|first|fkeys|flip|floor|from|get|getenv|group|gtime|hclose|hcount|hdel|hopen|hsym|iasc|identity|idesc|if|ij|in|insert|inter|inv|keys?|last|like|list|ljf?|load|log|lower|lsq|ltime|ltrim|mavg|maxs?|mcount|md5|mdev|med|meta|mins?|mmax|mmin|mmu|mod|msum|neg|next|not|null|or|over|parse|peach|pj|plist|prds?|prev|prior|rand|rank|ratios|raze|read0|read1|reciprocal|reval|reverse|rload|rotate|rsave|rtrim|save|scan|scov|sdev|select|set|setenv|show|signum|sin|sqrt|ssr?|string|sublist|sums?|sv|svar|system|tables|tan|til|trim|txf|type|uj|ungroup|union|update|upper|upsert|value|var|views?|vs|wavg|where|while|within|wj1?|wsum|ww|xasc|xbar|xcols?|xdesc|xexp|xgroup|xkey|xlog|xprev|xrank)\b/,
        adverb: {
            pattern: /['\/\\]:?|\beach\b/,
            alias: 'function'
        },
        verb: {
            pattern: /(?:\B\.\B|\b[01]:|<[=>]?|>=?|[:+\-*%,!?~=|$&#@^]):?|\b_\b:?/,
            alias: 'operator'
        },
        punctuation: /[(){}\[\];.]/
    };
}

});

parcelRegister("jQ2hF", function(module, exports) {
'use strict';
module.exports = $e714a53471c78e6e$var$qml;
$e714a53471c78e6e$var$qml.displayName = 'qml';
$e714a53471c78e6e$var$qml.aliases = [];
function $e714a53471c78e6e$var$qml(Prism) {
    (function(Prism) {
        var jsString = /"(?:\\.|[^\\"\r\n])*"|'(?:\\.|[^\\'\r\n])*'/.source;
        var jsComment = /\/\/.*(?!.)|\/\*(?:[^*]|\*(?!\/))*\*\//.source;
        var jsExpr = /(?:[^\\()[\]{}"'/]|<string>|\/(?![*/])|<comment>|\(<expr>*\)|\[<expr>*\]|\{<expr>*\}|\\[\s\S])/.source.replace(/<string>/g, function() {
            return jsString;
        }).replace(/<comment>/g, function() {
            return jsComment;
        }) // the pattern will blow up, so only a few iterations
        ;
        for(var i = 0; i < 2; i++)jsExpr = jsExpr.replace(/<expr>/g, function() {
            return jsExpr;
        });
        jsExpr = jsExpr.replace(/<expr>/g, '[^\\s\\S]');
        Prism.languages.qml = {
            comment: {
                pattern: /\/\/.*|\/\*[\s\S]*?\*\//,
                greedy: true
            },
            'javascript-function': {
                pattern: RegExp(/((?:^|;)[ \t]*)function\s+(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*\s*\(<js>*\)\s*\{<js>*\}/.source.replace(/<js>/g, function() {
                    return jsExpr;
                }), 'm'),
                lookbehind: true,
                greedy: true,
                alias: 'language-javascript',
                inside: Prism.languages.javascript
            },
            'class-name': {
                pattern: /((?:^|[:;])[ \t]*)(?!\d)\w+(?=[ \t]*\{|[ \t]+on\b)/m,
                lookbehind: true
            },
            property: [
                {
                    pattern: /((?:^|[;{])[ \t]*)(?!\d)\w+(?:\.\w+)*(?=[ \t]*:)/m,
                    lookbehind: true
                },
                {
                    pattern: /((?:^|[;{])[ \t]*)property[ \t]+(?!\d)\w+(?:\.\w+)*[ \t]+(?!\d)\w+(?:\.\w+)*(?=[ \t]*:)/m,
                    lookbehind: true,
                    inside: {
                        keyword: /^property/,
                        property: /\w+(?:\.\w+)*/
                    }
                }
            ],
            'javascript-expression': {
                pattern: RegExp(/(:[ \t]*)(?![\s;}[])(?:(?!$|[;}])<js>)+/.source.replace(/<js>/g, function() {
                    return jsExpr;
                }), 'm'),
                lookbehind: true,
                greedy: true,
                alias: 'language-javascript',
                inside: Prism.languages.javascript
            },
            string: {
                pattern: /"(?:\\.|[^\\"\r\n])*"/,
                greedy: true
            },
            keyword: /\b(?:as|import|on)\b/,
            punctuation: /[{}[\]:;,]/
        };
    })(Prism);
}

});

parcelRegister("WlExc", function(module, exports) {
'use strict';
module.exports = $0af636af7d994964$var$qore;
$0af636af7d994964$var$qore.displayName = 'qore';
$0af636af7d994964$var$qore.aliases = [];
function $0af636af7d994964$var$qore(Prism) {
    Prism.languages.qore = Prism.languages.extend('clike', {
        comment: {
            pattern: /(^|[^\\])(?:\/\*[\s\S]*?\*\/|(?:\/\/|#).*)/,
            lookbehind: true
        },
        // Overridden to allow unescaped multi-line strings
        string: {
            pattern: /("|')(?:\\[\s\S]|(?!\1)[^\\])*\1/,
            greedy: true
        },
        keyword: /\b(?:abstract|any|assert|binary|bool|boolean|break|byte|case|catch|char|class|code|const|continue|data|default|do|double|else|enum|extends|final|finally|float|for|goto|hash|if|implements|import|inherits|instanceof|int|interface|long|my|native|new|nothing|null|object|our|own|private|reference|rethrow|return|short|soft(?:bool|date|float|int|list|number|string)|static|strictfp|string|sub|super|switch|synchronized|this|throw|throws|transient|try|void|volatile|while)\b/,
        boolean: /\b(?:false|true)\b/i,
        function: /\$?\b(?!\d)\w+(?=\()/,
        number: /\b(?:0b[01]+|0x(?:[\da-f]*\.)?[\da-fp\-]+|(?:\d+(?:\.\d+)?|\.\d+)(?:e\d+)?[df]|(?:\d+(?:\.\d+)?|\.\d+))\b/i,
        operator: {
            pattern: /(^|[^.])(?:\+[+=]?|-[-=]?|[!=](?:==?|~)?|>>?=?|<(?:=>?|<=?)?|&[&=]?|\|[|=]?|[*\/%^]=?|[~?])/,
            lookbehind: true
        },
        variable: /\$(?!\d)\w+\b/
    });
}

});

parcelRegister("4KdNd", function(module, exports) {
'use strict';
module.exports = $3746283ff33aa4b1$var$qsharp;
$3746283ff33aa4b1$var$qsharp.displayName = 'qsharp';
$3746283ff33aa4b1$var$qsharp.aliases = [
    'qs'
];
function $3746283ff33aa4b1$var$qsharp(Prism) {
    (function(Prism) {
        /**
     * Replaces all placeholders "<<n>>" of given pattern with the n-th replacement (zero based).
     *
     * Note: This is a simple text based replacement. Be careful when using backreferences!
     *
     * @param {string} pattern the given pattern.
     * @param {string[]} replacements a list of replacement which can be inserted into the given pattern.
     * @returns {string} the pattern with all placeholders replaced with their corresponding replacements.
     * @example replace(/a<<0>>a/.source, [/b+/.source]) === /a(?:b+)a/.source
     */ function replace(pattern, replacements) {
            return pattern.replace(/<<(\d+)>>/g, function(m, index) {
                return '(?:' + replacements[+index] + ')';
            });
        }
        /**
     * @param {string} pattern
     * @param {string[]} replacements
     * @param {string} [flags]
     * @returns {RegExp}
     */ function re(pattern, replacements, flags) {
            return RegExp(replace(pattern, replacements), flags || '');
        }
        /**
     * Creates a nested pattern where all occurrences of the string `<<self>>` are replaced with the pattern itself.
     *
     * @param {string} pattern
     * @param {number} depthLog2
     * @returns {string}
     */ function nested(pattern, depthLog2) {
            for(var i = 0; i < depthLog2; i++)pattern = pattern.replace(/<<self>>/g, function() {
                return '(?:' + pattern + ')';
            });
            return pattern.replace(/<<self>>/g, '[^\\s\\S]');
        } // https://docs.microsoft.com/en-us/azure/quantum/user-guide/language/typesystem/
        // https://github.com/microsoft/qsharp-language/tree/main/Specifications/Language/5_Grammar
        var keywordKinds = {
            // keywords which represent a return or variable type
            type: 'Adj BigInt Bool Ctl Double false Int One Pauli PauliI PauliX PauliY PauliZ Qubit Range Result String true Unit Zero',
            // all other keywords
            other: 'Adjoint adjoint apply as auto body borrow borrowing Controlled controlled distribute elif else fail fixup for function if in internal intrinsic invert is let mutable namespace new newtype open operation repeat return self set until use using while within'
        } // keywords
        ;
        function keywordsToPattern(words) {
            return '\\b(?:' + words.trim().replace(/ /g, '|') + ')\\b';
        }
        var keywords = RegExp(keywordsToPattern(keywordKinds.type + ' ' + keywordKinds.other)) // types
        ;
        var identifier = /\b[A-Za-z_]\w*\b/.source;
        var qualifiedName = replace(/<<0>>(?:\s*\.\s*<<0>>)*/.source, [
            identifier
        ]);
        var typeInside = {
            keyword: keywords,
            punctuation: /[<>()?,.:[\]]/
        } // strings
        ;
        var regularString = /"(?:\\.|[^\\"])*"/.source;
        Prism.languages.qsharp = Prism.languages.extend('clike', {
            comment: /\/\/.*/,
            string: [
                {
                    pattern: re(/(^|[^$\\])<<0>>/.source, [
                        regularString
                    ]),
                    lookbehind: true,
                    greedy: true
                }
            ],
            'class-name': [
                {
                    // open Microsoft.Quantum.Canon;
                    // open Microsoft.Quantum.Canon as CN;
                    pattern: re(/(\b(?:as|open)\s+)<<0>>(?=\s*(?:;|as\b))/.source, [
                        qualifiedName
                    ]),
                    lookbehind: true,
                    inside: typeInside
                },
                {
                    // namespace Quantum.App1;
                    pattern: re(/(\bnamespace\s+)<<0>>(?=\s*\{)/.source, [
                        qualifiedName
                    ]),
                    lookbehind: true,
                    inside: typeInside
                }
            ],
            keyword: keywords,
            number: /(?:\b0(?:x[\da-f]+|b[01]+|o[0-7]+)|(?:\B\.\d+|\b\d+(?:\.\d*)?)(?:e[-+]?\d+)?)l?\b/i,
            operator: /\band=|\bor=|\band\b|\bnot\b|\bor\b|<[-=]|[-=]>|>>>=?|<<<=?|\^\^\^=?|\|\|\|=?|&&&=?|w\/=?|~~~|[*\/+\-^=!%]=?/,
            punctuation: /::|[{}[\];(),.:]/
        });
        Prism.languages.insertBefore('qsharp', 'number', {
            range: {
                pattern: /\.\./,
                alias: 'operator'
            }
        }) // single line
        ;
        var interpolationExpr = nested(replace(/\{(?:[^"{}]|<<0>>|<<self>>)*\}/.source, [
            regularString
        ]), 2);
        Prism.languages.insertBefore('qsharp', 'string', {
            'interpolation-string': {
                pattern: re(/\$"(?:\\.|<<0>>|[^\\"{])*"/.source, [
                    interpolationExpr
                ]),
                greedy: true,
                inside: {
                    interpolation: {
                        pattern: re(/((?:^|[^\\])(?:\\\\)*)<<0>>/.source, [
                            interpolationExpr
                        ]),
                        lookbehind: true,
                        inside: {
                            punctuation: /^\{|\}$/,
                            expression: {
                                pattern: /[\s\S]+/,
                                alias: 'language-qsharp',
                                inside: Prism.languages.qsharp
                            }
                        }
                    },
                    string: /[\s\S]+/
                }
            }
        });
    })(Prism);
    Prism.languages.qs = Prism.languages.qsharp;
}

});

parcelRegister("7NGHk", function(module, exports) {
'use strict';
module.exports = $5ade3ae7147ed958$var$r;
$5ade3ae7147ed958$var$r.displayName = 'r';
$5ade3ae7147ed958$var$r.aliases = [];
function $5ade3ae7147ed958$var$r(Prism) {
    Prism.languages.r = {
        comment: /#.*/,
        string: {
            pattern: /(['"])(?:\\.|(?!\1)[^\\\r\n])*\1/,
            greedy: true
        },
        'percent-operator': {
            // Includes user-defined operators
            // and %%, %*%, %/%, %in%, %o%, %x%
            pattern: /%[^%\s]*%/,
            alias: 'operator'
        },
        boolean: /\b(?:FALSE|TRUE)\b/,
        ellipsis: /\.\.(?:\.|\d+)/,
        number: [
            /\b(?:Inf|NaN)\b/,
            /(?:\b0x[\dA-Fa-f]+(?:\.\d*)?|\b\d+(?:\.\d*)?|\B\.\d+)(?:[EePp][+-]?\d+)?[iL]?/
        ],
        keyword: /\b(?:NA|NA_character_|NA_complex_|NA_integer_|NA_real_|NULL|break|else|for|function|if|in|next|repeat|while)\b/,
        operator: /->?>?|<(?:=|<?-)?|[>=!]=?|::?|&&?|\|\|?|[+*\/^$@~]/,
        punctuation: /[(){}\[\],;]/
    };
}

});

parcelRegister("frLRS", function(module, exports) {
'use strict';

var $edDH5 = parcelRequire("edDH5");
module.exports = $b3ee823c0f7697e4$var$racket;
$b3ee823c0f7697e4$var$racket.displayName = 'racket';
$b3ee823c0f7697e4$var$racket.aliases = [
    'rkt'
];
function $b3ee823c0f7697e4$var$racket(Prism) {
    Prism.register($edDH5);
    Prism.languages.racket = Prism.languages.extend('scheme', {
        'lambda-parameter': {
            // the racket lambda syntax is a lot more complex, so we won't even attempt to capture it.
            // this will just prevent false positives of the `function` pattern
            pattern: /([(\[]lambda\s+[(\[])[^()\[\]'\s]+/,
            lookbehind: true
        }
    });
    Prism.languages.insertBefore('racket', 'string', {
        lang: {
            pattern: /^#lang.+/m,
            greedy: true,
            alias: 'keyword'
        }
    });
    Prism.languages.rkt = Prism.languages.racket;
}

});

parcelRegister("b9hZW", function(module, exports) {
'use strict';
module.exports = $81de7f0130382ff6$var$reason;
$81de7f0130382ff6$var$reason.displayName = 'reason';
$81de7f0130382ff6$var$reason.aliases = [];
function $81de7f0130382ff6$var$reason(Prism) {
    Prism.languages.reason = Prism.languages.extend('clike', {
        string: {
            pattern: /"(?:\\(?:\r\n|[\s\S])|[^\\\r\n"])*"/,
            greedy: true
        },
        // 'class-name' must be matched *after* 'constructor' defined below
        'class-name': /\b[A-Z]\w*/,
        keyword: /\b(?:and|as|assert|begin|class|constraint|do|done|downto|else|end|exception|external|for|fun|function|functor|if|in|include|inherit|initializer|lazy|let|method|module|mutable|new|nonrec|object|of|open|or|private|rec|sig|struct|switch|then|to|try|type|val|virtual|when|while|with)\b/,
        operator: /\.{3}|:[:=]|\|>|->|=(?:==?|>)?|<=?|>=?|[|^?'#!~`]|[+\-*\/]\.?|\b(?:asr|land|lor|lsl|lsr|lxor|mod)\b/
    });
    Prism.languages.insertBefore('reason', 'class-name', {
        char: {
            pattern: /'(?:\\x[\da-f]{2}|\\o[0-3][0-7][0-7]|\\\d{3}|\\.|[^'\\\r\n])'/,
            greedy: true
        },
        // Negative look-ahead prevents from matching things like String.capitalize
        constructor: /\b[A-Z]\w*\b(?!\s*\.)/,
        label: {
            pattern: /\b[a-z]\w*(?=::)/,
            alias: 'symbol'
        }
    }) // We can't match functions property, so let's not even try.
    ;
    delete Prism.languages.reason.function;
}

});

parcelRegister("hvAJL", function(module, exports) {
'use strict';
module.exports = $cbf1d427389b151f$var$regex;
$cbf1d427389b151f$var$regex.displayName = 'regex';
$cbf1d427389b151f$var$regex.aliases = [];
function $cbf1d427389b151f$var$regex(Prism) {
    (function(Prism) {
        var specialEscape = {
            pattern: /\\[\\(){}[\]^$+*?|.]/,
            alias: 'escape'
        };
        var escape = /\\(?:x[\da-fA-F]{2}|u[\da-fA-F]{4}|u\{[\da-fA-F]+\}|0[0-7]{0,2}|[123][0-7]{2}|c[a-zA-Z]|.)/;
        var charSet = {
            pattern: /\.|\\[wsd]|\\p\{[^{}]+\}/i,
            alias: 'class-name'
        };
        var charSetWithoutDot = {
            pattern: /\\[wsd]|\\p\{[^{}]+\}/i,
            alias: 'class-name'
        };
        var rangeChar = '(?:[^\\\\-]|' + escape.source + ')';
        var range = RegExp(rangeChar + '-' + rangeChar) // the name of a capturing group
        ;
        var groupName = {
            pattern: /(<|')[^<>']+(?=[>']$)/,
            lookbehind: true,
            alias: 'variable'
        };
        Prism.languages.regex = {
            'char-class': {
                pattern: /((?:^|[^\\])(?:\\\\)*)\[(?:[^\\\]]|\\[\s\S])*\]/,
                lookbehind: true,
                inside: {
                    'char-class-negation': {
                        pattern: /(^\[)\^/,
                        lookbehind: true,
                        alias: 'operator'
                    },
                    'char-class-punctuation': {
                        pattern: /^\[|\]$/,
                        alias: 'punctuation'
                    },
                    range: {
                        pattern: range,
                        inside: {
                            escape: escape,
                            'range-punctuation': {
                                pattern: /-/,
                                alias: 'operator'
                            }
                        }
                    },
                    'special-escape': specialEscape,
                    'char-set': charSetWithoutDot,
                    escape: escape
                }
            },
            'special-escape': specialEscape,
            'char-set': charSet,
            backreference: [
                {
                    // a backreference which is not an octal escape
                    pattern: /\\(?![123][0-7]{2})[1-9]/,
                    alias: 'keyword'
                },
                {
                    pattern: /\\k<[^<>']+>/,
                    alias: 'keyword',
                    inside: {
                        'group-name': groupName
                    }
                }
            ],
            anchor: {
                pattern: /[$^]|\\[ABbGZz]/,
                alias: 'function'
            },
            escape: escape,
            group: [
                {
                    // https://docs.oracle.com/javase/10/docs/api/java/util/regex/Pattern.html
                    // https://docs.microsoft.com/en-us/dotnet/standard/base-types/regular-expression-language-quick-reference?view=netframework-4.7.2#grouping-constructs
                    // (), (?<name>), (?'name'), (?>), (?:), (?=), (?!), (?<=), (?<!), (?is-m), (?i-m:)
                    pattern: /\((?:\?(?:<[^<>']+>|'[^<>']+'|[>:]|<?[=!]|[idmnsuxU]+(?:-[idmnsuxU]+)?:?))?/,
                    alias: 'punctuation',
                    inside: {
                        'group-name': groupName
                    }
                },
                {
                    pattern: /\)/,
                    alias: 'punctuation'
                }
            ],
            quantifier: {
                pattern: /(?:[+*?]|\{\d+(?:,\d*)?\})[?+]?/,
                alias: 'number'
            },
            alternation: {
                pattern: /\|/,
                alias: 'keyword'
            }
        };
    })(Prism);
}

});

parcelRegister("ddrlh", function(module, exports) {
'use strict';
module.exports = $99f1b2dd30de2a76$var$rego;
$99f1b2dd30de2a76$var$rego.displayName = 'rego';
$99f1b2dd30de2a76$var$rego.aliases = [];
function $99f1b2dd30de2a76$var$rego(Prism) {
    // https://www.openpolicyagent.org/docs/latest/policy-reference/
    Prism.languages.rego = {
        comment: /#.*/,
        property: {
            pattern: /(^|[^\\.])(?:"(?:\\.|[^\\"\r\n])*"|`[^`]*`|\b[a-z_]\w*\b)(?=\s*:(?!=))/i,
            lookbehind: true,
            greedy: true
        },
        string: {
            pattern: /(^|[^\\])"(?:\\.|[^\\"\r\n])*"|`[^`]*`/,
            lookbehind: true,
            greedy: true
        },
        keyword: /\b(?:as|default|else|import|not|null|package|set(?=\s*\()|some|with)\b/,
        boolean: /\b(?:false|true)\b/,
        function: {
            pattern: /\b[a-z_]\w*\b(?:\s*\.\s*\b[a-z_]\w*\b)*(?=\s*\()/i,
            inside: {
                namespace: /\b\w+\b(?=\s*\.)/,
                punctuation: /\./
            }
        },
        number: /-?\b\d+(?:\.\d+)?(?:e[+-]?\d+)?\b/i,
        operator: /[-+*/%|&]|[<>:=]=?|!=|\b_\b/,
        punctuation: /[,;.\[\]{}()]/
    };
}

});

parcelRegister("44X48", function(module, exports) {
'use strict';
module.exports = $2f855a612288cf68$var$renpy;
$2f855a612288cf68$var$renpy.displayName = 'renpy';
$2f855a612288cf68$var$renpy.aliases = [
    'rpy'
];
function $2f855a612288cf68$var$renpy(Prism) {
    Prism.languages.renpy = {
        comment: {
            pattern: /(^|[^\\])#.+/,
            lookbehind: true
        },
        string: {
            pattern: /("""|''')[\s\S]+?\1|("|')(?:\\.|(?!\2)[^\\])*\2|(?:^#?(?:(?:[0-9a-fA-F]){3}|[0-9a-fA-F]{6})$)/m,
            greedy: true
        },
        function: /\b[a-z_]\w*(?=\()/i,
        property: /\b(?:Update|UpdateVersion|action|activate_sound|adv_nvl_transition|after_load_transition|align|alpha|alt|anchor|antialias|area|auto|background|bar_invert|bar_resizing|bar_vertical|black_color|bold|bottom_bar|bottom_gutter|bottom_margin|bottom_padding|box_reverse|box_wrap|can_update|caret|child|color|crop|default_afm_enable|default_afm_time|default_fullscreen|default_text_cps|developer|directory_name|drag_handle|drag_joined|drag_name|drag_raise|draggable|dragged|drop_shadow|drop_shadow_color|droppable|dropped|easein|easeout|edgescroll|end_game_transition|end_splash_transition|enter_replay_transition|enter_sound|enter_transition|enter_yesno_transition|executable_name|exit_replay_transition|exit_sound|exit_transition|exit_yesno_transition|fadein|fadeout|first_indent|first_spacing|fit_first|focus|focus_mask|font|foreground|game_main_transition|get_installed_packages|google_play_key|google_play_salt|ground|has_music|has_sound|has_voice|height|help|hinting|hover|hover_background|hover_color|hover_sound|hovered|hyperlink_functions|idle|idle_color|image_style|include_update|insensitive|insensitive_background|insensitive_color|inside|intra_transition|italic|justify|kerning|keyboard_focus|language|layer_clipping|layers|layout|left_bar|left_gutter|left_margin|left_padding|length|line_leading|line_overlap_split|line_spacing|linear|main_game_transition|main_menu_music|maximum|min_width|minimum|minwidth|modal|mouse|mousewheel|name|narrator_menu|newline_indent|nvl_adv_transition|offset|order_reverse|outlines|overlay_functions|pos|position|prefix|radius|range|rest_indent|right_bar|right_gutter|right_margin|right_padding|rotate|rotate_pad|ruby_style|sample_sound|save_directory|say_attribute_transition|screen_height|screen_width|scrollbars|selected_hover|selected_hover_color|selected_idle|selected_idle_color|selected_insensitive|show_side_image|show_two_window|side_spacing|side_xpos|side_ypos|size|size_group|slow_cps|slow_cps_multiplier|spacing|strikethrough|subpixel|text_align|text_style|text_xpos|text_y_fudge|text_ypos|thumb|thumb_offset|thumb_shadow|thumbnail_height|thumbnail_width|time|top_bar|top_gutter|top_margin|top_padding|translations|underline|unscrollable|update|value|version|version_name|version_tuple|vertical|width|window_hide_transition|window_icon|window_left_padding|window_show_transition|window_title|windows_icon|xadjustment|xalign|xanchor|xanchoraround|xaround|xcenter|xfill|xinitial|xmargin|xmaximum|xminimum|xoffset|xofsset|xpadding|xpos|xsize|xzoom|yadjustment|yalign|yanchor|yanchoraround|yaround|ycenter|yfill|yinitial|ymargin|ymaximum|yminimum|yoffset|ypadding|ypos|ysize|ysizexysize|yzoom|zoom|zorder)\b/,
        tag: /\b(?:bar|block|button|buttoscreenn|drag|draggroup|fixed|frame|grid|[hv]box|hotbar|hotspot|image|imagebutton|imagemap|input|key|label|menu|mm_menu_frame|mousearea|nvl|parallel|screen|self|side|tag|text|textbutton|timer|vbar|viewport|window)\b|\$/,
        keyword: /\b(?:None|add|adjustment|alignaround|allow|angle|animation|around|as|assert|behind|box_layout|break|build|cache|call|center|changed|child_size|choice|circles|class|clear|clicked|clipping|clockwise|config|contains|continue|corner1|corner2|counterclockwise|def|default|define|del|delay|disabled|disabled_text|dissolve|elif|else|event|except|exclude|exec|expression|fade|finally|for|from|function|global|gm_root|has|hide|id|if|import|in|init|is|jump|knot|lambda|left|less_rounded|mm_root|movie|music|null|on|onlayer|pass|pause|persistent|play|print|python|queue|raise|random|renpy|repeat|return|right|rounded_window|scene|scope|set|show|slow|slow_abortable|slow_done|sound|stop|store|style|style_group|substitute|suffix|theme|transform|transform_anchor|transpose|try|ui|unhovered|updater|use|voice|while|widget|widget_hover|widget_selected|widget_text|yield)\b/,
        boolean: /\b(?:[Ff]alse|[Tt]rue)\b/,
        number: /(?:\b(?:0[bo])?(?:(?:\d|0x[\da-f])[\da-f]*(?:\.\d*)?)|\B\.\d+)(?:e[+-]?\d+)?j?/i,
        operator: /[-+%=]=?|!=|\*\*?=?|\/\/?=?|<[<=>]?|>[=>]?|[&|^~]|\b(?:and|at|not|or|with)\b/,
        punctuation: /[{}[\];(),.:]/
    };
    Prism.languages.rpy = Prism.languages.renpy;
}

});

parcelRegister("dV9BH", function(module, exports) {
'use strict';
module.exports = $a2280cfdd0592ab8$var$rest;
$a2280cfdd0592ab8$var$rest.displayName = 'rest';
$a2280cfdd0592ab8$var$rest.aliases = [];
function $a2280cfdd0592ab8$var$rest(Prism) {
    Prism.languages.rest = {
        table: [
            {
                pattern: /(^[\t ]*)(?:\+[=-]+)+\+(?:\r?\n|\r)(?:\1[+|].+[+|](?:\r?\n|\r))+\1(?:\+[=-]+)+\+/m,
                lookbehind: true,
                inside: {
                    punctuation: /\||(?:\+[=-]+)+\+/
                }
            },
            {
                pattern: /(^[\t ]*)=+ [ =]*=(?:(?:\r?\n|\r)\1.+)+(?:\r?\n|\r)\1=+ [ =]*=(?=(?:\r?\n|\r){2}|\s*$)/m,
                lookbehind: true,
                inside: {
                    punctuation: /[=-]+/
                }
            }
        ],
        // Directive-like patterns
        'substitution-def': {
            pattern: /(^[\t ]*\.\. )\|(?:[^|\s](?:[^|]*[^|\s])?)\| [^:]+::/m,
            lookbehind: true,
            inside: {
                substitution: {
                    pattern: /^\|(?:[^|\s]|[^|\s][^|]*[^|\s])\|/,
                    alias: 'attr-value',
                    inside: {
                        punctuation: /^\||\|$/
                    }
                },
                directive: {
                    pattern: /( )(?! )[^:]+::/,
                    lookbehind: true,
                    alias: 'function',
                    inside: {
                        punctuation: /::$/
                    }
                }
            }
        },
        'link-target': [
            {
                pattern: /(^[\t ]*\.\. )\[[^\]]+\]/m,
                lookbehind: true,
                alias: 'string',
                inside: {
                    punctuation: /^\[|\]$/
                }
            },
            {
                pattern: /(^[\t ]*\.\. )_(?:`[^`]+`|(?:[^:\\]|\\.)+):/m,
                lookbehind: true,
                alias: 'string',
                inside: {
                    punctuation: /^_|:$/
                }
            }
        ],
        directive: {
            pattern: /(^[\t ]*\.\. )[^:]+::/m,
            lookbehind: true,
            alias: 'function',
            inside: {
                punctuation: /::$/
            }
        },
        comment: {
            // The two alternatives try to prevent highlighting of blank comments
            pattern: /(^[\t ]*\.\.)(?:(?: .+)?(?:(?:\r?\n|\r).+)+| .+)(?=(?:\r?\n|\r){2}|$)/m,
            lookbehind: true
        },
        title: [
            // Overlined and underlined
            {
                pattern: /^(([!"#$%&'()*+,\-.\/:;<=>?@\[\\\]^_`{|}~])\2+)(?:\r?\n|\r).+(?:\r?\n|\r)\1$/m,
                inside: {
                    punctuation: /^[!"#$%&'()*+,\-.\/:;<=>?@\[\\\]^_`{|}~]+|[!"#$%&'()*+,\-.\/:;<=>?@\[\\\]^_`{|}~]+$/,
                    important: /.+/
                }
            },
            {
                pattern: /(^|(?:\r?\n|\r){2}).+(?:\r?\n|\r)([!"#$%&'()*+,\-.\/:;<=>?@\[\\\]^_`{|}~])\2+(?=\r?\n|\r|$)/,
                lookbehind: true,
                inside: {
                    punctuation: /[!"#$%&'()*+,\-.\/:;<=>?@\[\\\]^_`{|}~]+$/,
                    important: /.+/
                }
            }
        ],
        hr: {
            pattern: /((?:\r?\n|\r){2})([!"#$%&'()*+,\-.\/:;<=>?@\[\\\]^_`{|}~])\2{3,}(?=(?:\r?\n|\r){2})/,
            lookbehind: true,
            alias: 'punctuation'
        },
        field: {
            pattern: /(^[\t ]*):[^:\r\n]+:(?= )/m,
            lookbehind: true,
            alias: 'attr-name'
        },
        'command-line-option': {
            pattern: /(^[\t ]*)(?:[+-][a-z\d]|(?:--|\/)[a-z\d-]+)(?:[ =](?:[a-z][\w-]*|<[^<>]+>))?(?:, (?:[+-][a-z\d]|(?:--|\/)[a-z\d-]+)(?:[ =](?:[a-z][\w-]*|<[^<>]+>))?)*(?=(?:\r?\n|\r)? {2,}\S)/im,
            lookbehind: true,
            alias: 'symbol'
        },
        'literal-block': {
            pattern: /::(?:\r?\n|\r){2}([ \t]+)(?![ \t]).+(?:(?:\r?\n|\r)\1.+)*/,
            inside: {
                'literal-block-punctuation': {
                    pattern: /^::/,
                    alias: 'punctuation'
                }
            }
        },
        'quoted-literal-block': {
            pattern: /::(?:\r?\n|\r){2}([!"#$%&'()*+,\-.\/:;<=>?@\[\\\]^_`{|}~]).*(?:(?:\r?\n|\r)\1.*)*/,
            inside: {
                'literal-block-punctuation': {
                    pattern: /^(?:::|([!"#$%&'()*+,\-.\/:;<=>?@\[\\\]^_`{|}~])\1*)/m,
                    alias: 'punctuation'
                }
            }
        },
        'list-bullet': {
            pattern: /(^[\t ]*)(?:[*+\-•‣⁃]|\(?(?:\d+|[a-z]|[ivxdclm]+)\)|(?:\d+|[a-z]|[ivxdclm]+)\.)(?= )/im,
            lookbehind: true,
            alias: 'punctuation'
        },
        'doctest-block': {
            pattern: /(^[\t ]*)>>> .+(?:(?:\r?\n|\r).+)*/m,
            lookbehind: true,
            inside: {
                punctuation: /^>>>/
            }
        },
        inline: [
            {
                pattern: /(^|[\s\-:\/'"<(\[{])(?::[^:]+:`.*?`|`.*?`:[^:]+:|(\*\*?|``?|\|)(?!\s)(?:(?!\2).)*\S\2(?=[\s\-.,:;!?\\\/'")\]}]|$))/m,
                lookbehind: true,
                inside: {
                    bold: {
                        pattern: /(^\*\*).+(?=\*\*$)/,
                        lookbehind: true
                    },
                    italic: {
                        pattern: /(^\*).+(?=\*$)/,
                        lookbehind: true
                    },
                    'inline-literal': {
                        pattern: /(^``).+(?=``$)/,
                        lookbehind: true,
                        alias: 'symbol'
                    },
                    role: {
                        pattern: /^:[^:]+:|:[^:]+:$/,
                        alias: 'function',
                        inside: {
                            punctuation: /^:|:$/
                        }
                    },
                    'interpreted-text': {
                        pattern: /(^`).+(?=`$)/,
                        lookbehind: true,
                        alias: 'attr-value'
                    },
                    substitution: {
                        pattern: /(^\|).+(?=\|$)/,
                        lookbehind: true,
                        alias: 'attr-value'
                    },
                    punctuation: /\*\*?|``?|\|/
                }
            }
        ],
        link: [
            {
                pattern: /\[[^\[\]]+\]_(?=[\s\-.,:;!?\\\/'")\]}]|$)/,
                alias: 'string',
                inside: {
                    punctuation: /^\[|\]_$/
                }
            },
            {
                pattern: /(?:\b[a-z\d]+(?:[_.:+][a-z\d]+)*_?_|`[^`]+`_?_|_`[^`]+`)(?=[\s\-.,:;!?\\\/'")\]}]|$)/i,
                alias: 'string',
                inside: {
                    punctuation: /^_?`|`$|`?_?_$/
                }
            }
        ],
        // Line block start,
        // quote attribution,
        // explicit markup start,
        // and anonymous hyperlink target shortcut (__)
        punctuation: {
            pattern: /(^[\t ]*)(?:\|(?= |$)|(?:---?|—|\.\.|__)(?= )|\.\.$)/m,
            lookbehind: true
        }
    };
}

});

parcelRegister("k19U6", function(module, exports) {
'use strict';
module.exports = $e92b955f4e30caee$var$rip;
$e92b955f4e30caee$var$rip.displayName = 'rip';
$e92b955f4e30caee$var$rip.aliases = [];
function $e92b955f4e30caee$var$rip(Prism) {
    Prism.languages.rip = {
        comment: {
            pattern: /#.*/,
            greedy: true
        },
        char: {
            pattern: /\B`[^\s`'",.:;#\/\\()<>\[\]{}]\b/,
            greedy: true
        },
        string: {
            pattern: /("|')(?:\\.|(?!\1)[^\\\r\n])*\1/,
            greedy: true
        },
        regex: {
            pattern: /(^|[^/])\/(?!\/)(?:\[[^\n\r\]]*\]|\\.|[^/\\\r\n\[])+\/(?=\s*(?:$|[\r\n,.;})]))/,
            lookbehind: true,
            greedy: true
        },
        keyword: /(?:=>|->)|\b(?:case|catch|class|else|exit|finally|if|raise|return|switch|try)\b/,
        builtin: /@|\bSystem\b/,
        boolean: /\b(?:false|true)\b/,
        date: /\b\d{4}-\d{2}-\d{2}\b/,
        time: /\b\d{2}:\d{2}:\d{2}\b/,
        datetime: /\b\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}\b/,
        symbol: /:[^\d\s`'",.:;#\/\\()<>\[\]{}][^\s`'",.:;#\/\\()<>\[\]{}]*/,
        number: /[+-]?\b(?:\d+\.\d+|\d+)\b/,
        punctuation: /(?:\.{2,3})|[`,.:;=\/\\()<>\[\]{}]/,
        reference: /[^\d\s`'",.:;#\/\\()<>\[\]{}][^\s`'",.:;#\/\\()<>\[\]{}]*/
    };
}

});

parcelRegister("lcFxt", function(module, exports) {
'use strict';
module.exports = $f6faf0bc3ae62f7b$var$roboconf;
$f6faf0bc3ae62f7b$var$roboconf.displayName = 'roboconf';
$f6faf0bc3ae62f7b$var$roboconf.aliases = [];
function $f6faf0bc3ae62f7b$var$roboconf(Prism) {
    Prism.languages.roboconf = {
        comment: /#.*/,
        keyword: {
            pattern: /(^|\s)(?:(?:external|import)\b|(?:facet|instance of)(?=[ \t]+[\w-]+[ \t]*\{))/,
            lookbehind: true
        },
        component: {
            pattern: /[\w-]+(?=[ \t]*\{)/,
            alias: 'variable'
        },
        property: /[\w.-]+(?=[ \t]*:)/,
        value: {
            pattern: /(=[ \t]*(?![ \t]))[^,;]+/,
            lookbehind: true,
            alias: 'attr-value'
        },
        optional: {
            pattern: /\(optional\)/,
            alias: 'builtin'
        },
        wildcard: {
            pattern: /(\.)\*/,
            lookbehind: true,
            alias: 'operator'
        },
        punctuation: /[{},.;:=]/
    };
}

});

parcelRegister("aiiP2", function(module, exports) {
'use strict';
module.exports = $77ea2f88950e5354$var$robotframework;
$77ea2f88950e5354$var$robotframework.displayName = 'robotframework';
$77ea2f88950e5354$var$robotframework.aliases = [];
function $77ea2f88950e5354$var$robotframework(Prism) {
    (function(Prism) {
        var comment = {
            pattern: /(^[ \t]*| {2}|\t)#.*/m,
            lookbehind: true,
            greedy: true
        };
        var variable = {
            pattern: /((?:^|[^\\])(?:\\{2})*)[$@&%]\{(?:[^{}\r\n]|\{[^{}\r\n]*\})*\}/,
            lookbehind: true,
            inside: {
                punctuation: /^[$@&%]\{|\}$/
            }
        };
        function createSection(name, inside) {
            var extendecInside = {};
            extendecInside['section-header'] = {
                pattern: /^ ?\*{3}.+?\*{3}/,
                alias: 'keyword'
            } // copy inside tokens
            ;
            for(var token in inside)extendecInside[token] = inside[token];
            extendecInside['tag'] = {
                pattern: /([\r\n](?: {2}|\t)[ \t]*)\[[-\w]+\]/,
                lookbehind: true,
                inside: {
                    punctuation: /\[|\]/
                }
            };
            extendecInside['variable'] = variable;
            extendecInside['comment'] = comment;
            return {
                pattern: RegExp(/^ ?\*{3}[ \t]*<name>[ \t]*\*{3}(?:.|[\r\n](?!\*{3}))*/.source.replace(/<name>/g, function() {
                    return name;
                }), 'im'),
                alias: 'section',
                inside: extendecInside
            };
        }
        var docTag = {
            pattern: /(\[Documentation\](?: {2}|\t)[ \t]*)(?![ \t]|#)(?:.|(?:\r\n?|\n)[ \t]*\.{3})+/,
            lookbehind: true,
            alias: 'string'
        };
        var testNameLike = {
            pattern: /([\r\n] ?)(?!#)(?:\S(?:[ \t]\S)*)+/,
            lookbehind: true,
            alias: 'function',
            inside: {
                variable: variable
            }
        };
        var testPropertyLike = {
            pattern: /([\r\n](?: {2}|\t)[ \t]*)(?!\[|\.{3}|#)(?:\S(?:[ \t]\S)*)+/,
            lookbehind: true,
            inside: {
                variable: variable
            }
        };
        Prism.languages['robotframework'] = {
            settings: createSection('Settings', {
                documentation: {
                    pattern: /([\r\n] ?Documentation(?: {2}|\t)[ \t]*)(?![ \t]|#)(?:.|(?:\r\n?|\n)[ \t]*\.{3})+/,
                    lookbehind: true,
                    alias: 'string'
                },
                property: {
                    pattern: /([\r\n] ?)(?!\.{3}|#)(?:\S(?:[ \t]\S)*)+/,
                    lookbehind: true
                }
            }),
            variables: createSection('Variables'),
            'test-cases': createSection('Test Cases', {
                'test-name': testNameLike,
                documentation: docTag,
                property: testPropertyLike
            }),
            keywords: createSection('Keywords', {
                'keyword-name': testNameLike,
                documentation: docTag,
                property: testPropertyLike
            }),
            tasks: createSection('Tasks', {
                'task-name': testNameLike,
                documentation: docTag,
                property: testPropertyLike
            }),
            comment: comment
        };
        Prism.languages.robot = Prism.languages['robotframework'];
    })(Prism);
}

});

parcelRegister("d2gPH", function(module, exports) {
'use strict';
module.exports = $97d884ec395e6539$var$rust;
$97d884ec395e6539$var$rust.displayName = 'rust';
$97d884ec395e6539$var$rust.aliases = [];
function $97d884ec395e6539$var$rust(Prism) {
    (function(Prism) {
        var multilineComment = /\/\*(?:[^*/]|\*(?!\/)|\/(?!\*)|<self>)*\*\//.source;
        for(var i = 0; i < 2; i++)// support 4 levels of nested comments
        multilineComment = multilineComment.replace(/<self>/g, function() {
            return multilineComment;
        });
        multilineComment = multilineComment.replace(/<self>/g, function() {
            return /[^\s\S]/.source;
        });
        Prism.languages.rust = {
            comment: [
                {
                    pattern: RegExp(/(^|[^\\])/.source + multilineComment),
                    lookbehind: true,
                    greedy: true
                },
                {
                    pattern: /(^|[^\\:])\/\/.*/,
                    lookbehind: true,
                    greedy: true
                }
            ],
            string: {
                pattern: /b?"(?:\\[\s\S]|[^\\"])*"|b?r(#*)"(?:[^"]|"(?!\1))*"\1/,
                greedy: true
            },
            char: {
                pattern: /b?'(?:\\(?:x[0-7][\da-fA-F]|u\{(?:[\da-fA-F]_*){1,6}\}|.)|[^\\\r\n\t'])'/,
                greedy: true
            },
            attribute: {
                pattern: /#!?\[(?:[^\[\]"]|"(?:\\[\s\S]|[^\\"])*")*\]/,
                greedy: true,
                alias: 'attr-name',
                inside: {
                    string: null // see below
                }
            },
            // Closure params should not be confused with bitwise OR |
            'closure-params': {
                pattern: /([=(,:]\s*|\bmove\s*)\|[^|]*\||\|[^|]*\|(?=\s*(?:\{|->))/,
                lookbehind: true,
                greedy: true,
                inside: {
                    'closure-punctuation': {
                        pattern: /^\||\|$/,
                        alias: 'punctuation'
                    },
                    rest: null // see below
                }
            },
            'lifetime-annotation': {
                pattern: /'\w+/,
                alias: 'symbol'
            },
            'fragment-specifier': {
                pattern: /(\$\w+:)[a-z]+/,
                lookbehind: true,
                alias: 'punctuation'
            },
            variable: /\$\w+/,
            'function-definition': {
                pattern: /(\bfn\s+)\w+/,
                lookbehind: true,
                alias: 'function'
            },
            'type-definition': {
                pattern: /(\b(?:enum|struct|trait|type|union)\s+)\w+/,
                lookbehind: true,
                alias: 'class-name'
            },
            'module-declaration': [
                {
                    pattern: /(\b(?:crate|mod)\s+)[a-z][a-z_\d]*/,
                    lookbehind: true,
                    alias: 'namespace'
                },
                {
                    pattern: /(\b(?:crate|self|super)\s*)::\s*[a-z][a-z_\d]*\b(?:\s*::(?:\s*[a-z][a-z_\d]*\s*::)*)?/,
                    lookbehind: true,
                    alias: 'namespace',
                    inside: {
                        punctuation: /::/
                    }
                }
            ],
            keyword: [
                // https://github.com/rust-lang/reference/blob/master/src/keywords.md
                /\b(?:Self|abstract|as|async|await|become|box|break|const|continue|crate|do|dyn|else|enum|extern|final|fn|for|if|impl|in|let|loop|macro|match|mod|move|mut|override|priv|pub|ref|return|self|static|struct|super|trait|try|type|typeof|union|unsafe|unsized|use|virtual|where|while|yield)\b/,
                // https://doc.rust-lang.org/stable/rust-by-example/primitives.html
                /\b(?:bool|char|f(?:32|64)|[ui](?:8|16|32|64|128|size)|str)\b/
            ],
            // functions can technically start with an upper-case letter, but this will introduce a lot of false positives
            // and Rust's naming conventions recommend snake_case anyway.
            // https://doc.rust-lang.org/1.0.0/style/style/naming/README.html
            function: /\b[a-z_]\w*(?=\s*(?:::\s*<|\())/,
            macro: {
                pattern: /\b\w+!/,
                alias: 'property'
            },
            constant: /\b[A-Z_][A-Z_\d]+\b/,
            'class-name': /\b[A-Z]\w*\b/,
            namespace: {
                pattern: /(?:\b[a-z][a-z_\d]*\s*::\s*)*\b[a-z][a-z_\d]*\s*::(?!\s*<)/,
                inside: {
                    punctuation: /::/
                }
            },
            // Hex, oct, bin, dec numbers with visual separators and type suffix
            number: /\b(?:0x[\dA-Fa-f](?:_?[\dA-Fa-f])*|0o[0-7](?:_?[0-7])*|0b[01](?:_?[01])*|(?:(?:\d(?:_?\d)*)?\.)?\d(?:_?\d)*(?:[Ee][+-]?\d+)?)(?:_?(?:f32|f64|[iu](?:8|16|32|64|size)?))?\b/,
            boolean: /\b(?:false|true)\b/,
            punctuation: /->|\.\.=|\.{1,3}|::|[{}[\];(),:]/,
            operator: /[-+*\/%!^]=?|=[=>]?|&[&=]?|\|[|=]?|<<?=?|>>?=?|[@?]/
        };
        Prism.languages.rust['closure-params'].inside.rest = Prism.languages.rust;
        Prism.languages.rust['attribute'].inside['string'] = Prism.languages.rust['string'];
    })(Prism);
}

});

parcelRegister("6RI1v", function(module, exports) {
'use strict';
module.exports = $4ff9d765a9fb2208$var$sas;
$4ff9d765a9fb2208$var$sas.displayName = 'sas';
$4ff9d765a9fb2208$var$sas.aliases = [];
function $4ff9d765a9fb2208$var$sas(Prism) {
    (function(Prism) {
        var stringPattern = /(?:"(?:""|[^"])*"(?!")|'(?:''|[^'])*'(?!'))/.source;
        var number = /\b(?:\d[\da-f]*x|\d+(?:\.\d+)?(?:e[+-]?\d+)?)\b/i;
        var numericConstant = {
            pattern: RegExp(stringPattern + '[bx]'),
            alias: 'number'
        };
        var macroVariable = {
            pattern: /&[a-z_]\w*/i
        };
        var macroKeyword = {
            pattern: /((?:^|\s|=|\())%(?:ABORT|BY|CMS|COPY|DISPLAY|DO|ELSE|END|EVAL|GLOBAL|GO|GOTO|IF|INC|INCLUDE|INDEX|INPUT|KTRIM|LENGTH|LET|LIST|LOCAL|PUT|QKTRIM|QSCAN|QSUBSTR|QSYSFUNC|QUPCASE|RETURN|RUN|SCAN|SUBSTR|SUPERQ|SYMDEL|SYMEXIST|SYMGLOBL|SYMLOCAL|SYSCALL|SYSEVALF|SYSEXEC|SYSFUNC|SYSGET|SYSRPUT|THEN|TO|TSO|UNQUOTE|UNTIL|UPCASE|WHILE|WINDOW)\b/i,
            lookbehind: true,
            alias: 'keyword'
        };
        var step = {
            pattern: /(^|\s)(?:proc\s+\w+|data(?!=)|quit|run)\b/i,
            alias: 'keyword',
            lookbehind: true
        };
        var comment = [
            /\/\*[\s\S]*?\*\//,
            {
                pattern: /(^[ \t]*|;\s*)\*[^;]*;/m,
                lookbehind: true
            }
        ];
        var string = {
            pattern: RegExp(stringPattern),
            greedy: true
        };
        var punctuation = /[$%@.(){}\[\];,\\]/;
        var func = {
            pattern: /%?\b\w+(?=\()/,
            alias: 'keyword'
        };
        var args = {
            function: func,
            'arg-value': {
                pattern: /(=\s*)[A-Z\.]+/i,
                lookbehind: true
            },
            operator: /=/,
            'macro-variable': macroVariable,
            arg: {
                pattern: /[A-Z]+/i,
                alias: 'keyword'
            },
            number: number,
            'numeric-constant': numericConstant,
            punctuation: punctuation,
            string: string
        };
        var format = {
            pattern: /\b(?:format|put)\b=?[\w'$.]+/i,
            inside: {
                keyword: /^(?:format|put)(?==)/i,
                equals: /=/,
                format: {
                    pattern: /(?:\w|\$\d)+\.\d?/,
                    alias: 'number'
                }
            }
        };
        var altformat = {
            pattern: /\b(?:format|put)\s+[\w']+(?:\s+[$.\w]+)+(?=;)/i,
            inside: {
                keyword: /^(?:format|put)/i,
                format: {
                    pattern: /[\w$]+\.\d?/,
                    alias: 'number'
                }
            }
        };
        var globalStatements = {
            pattern: /((?:^|\s)=?)(?:catname|checkpoint execute_always|dm|endsas|filename|footnote|%include|libname|%list|lock|missing|options|page|resetline|%run|sasfile|skip|sysecho|title\d?)\b/i,
            lookbehind: true,
            alias: 'keyword'
        };
        var submitStatement = {
            pattern: /(^|\s)(?:submit(?:\s+(?:load|norun|parseonly))?|endsubmit)\b/i,
            lookbehind: true,
            alias: 'keyword'
        };
        var actionSets = /aStore|accessControl|aggregation|audio|autotune|bayesianNetClassifier|bioMedImage|boolRule|builtins|cardinality|cdm|clustering|conditionalRandomFields|configuration|copula|countreg|dataDiscovery|dataPreprocess|dataSciencePilot|dataStep|decisionTree|deduplication|deepLearn|deepNeural|deepRnn|ds2|ecm|entityRes|espCluster|explainModel|factmac|fastKnn|fcmpact|fedSql|freqTab|gVarCluster|gam|gleam|graphSemiSupLearn|hiddenMarkovModel|hyperGroup|ica|image|iml|kernalPca|langModel|ldaTopic|loadStreams|mbc|mixed|mlTools|modelPublishing|network|neuralNet|nmf|nonParametricBayes|nonlinear|optNetwork|optimization|panel|pca|percentile|phreg|pls|qkb|qlim|quantreg|recommend|regression|reinforcementLearn|robustPca|ruleMining|sampling|sandwich|sccasl|search(?:Analytics)?|sentimentAnalysis|sequence|session(?:Prop)?|severity|simSystem|simple|smartData|sparkEmbeddedProcess|sparseML|spatialreg|spc|stabilityMonitoring|svDataDescription|svm|table|text(?:Filters|Frequency|Mining|Parse|Rule(?:Develop|Score)|Topic|Util)|timeData|transpose|tsInfo|tsReconcile|uniTimeSeries|varReduce/.source;
        var casActions = {
            pattern: RegExp(/(^|\s)(?:action\s+)?(?:<act>)\.[a-z]+\b[^;]+/.source.replace(/<act>/g, function() {
                return actionSets;
            }), 'i'),
            lookbehind: true,
            inside: {
                keyword: RegExp(/(?:<act>)\.[a-z]+\b/.source.replace(/<act>/g, function() {
                    return actionSets;
                }), 'i'),
                action: {
                    pattern: /(?:action)/i,
                    alias: 'keyword'
                },
                comment: comment,
                function: func,
                'arg-value': args['arg-value'],
                operator: args.operator,
                argument: args.arg,
                number: number,
                'numeric-constant': numericConstant,
                punctuation: punctuation,
                string: string
            }
        };
        var keywords = {
            pattern: /((?:^|\s)=?)(?:after|analysis|and|array|barchart|barwidth|begingraph|by|call|cas|cbarline|cfill|class(?:lev)?|close|column|computed?|contains|continue|data(?==)|define|delete|describe|document|do\s+over|do|dol|drop|dul|else|end(?:comp|source)?|entryTitle|eval(?:uate)?|exec(?:ute)?|exit|file(?:name)?|fill(?:attrs)?|flist|fnc|function(?:list)?|global|goto|group(?:by)?|headline|headskip|histogram|if|infile|keep|keylabel|keyword|label|layout|leave|legendlabel|length|libname|loadactionset|merge|midpoints|_?null_|name|noobs|nowd|ods|options|or|otherwise|out(?:put)?|over(?:lay)?|plot|print|put|raise|ranexp|rannor|rbreak|retain|return|select|session|sessref|set|source|statgraph|sum|summarize|table|temp|terminate|then\s+do|then|title\d?|to|var|when|where|xaxisopts|y2axisopts|yaxisopts)\b/i,
            lookbehind: true
        };
        Prism.languages.sas = {
            datalines: {
                pattern: /^([ \t]*)(?:cards|(?:data)?lines);[\s\S]+?^[ \t]*;/im,
                lookbehind: true,
                alias: 'string',
                inside: {
                    keyword: {
                        pattern: /^(?:cards|(?:data)?lines)/i
                    },
                    punctuation: /;/
                }
            },
            'proc-sql': {
                pattern: /(^proc\s+(?:fed)?sql(?:\s+[\w|=]+)?;)[\s\S]+?(?=^(?:proc\s+\w+|data|quit|run);|(?![\s\S]))/im,
                lookbehind: true,
                inside: {
                    sql: {
                        pattern: RegExp(/^[ \t]*(?:select|alter\s+table|(?:create|describe|drop)\s+(?:index|table(?:\s+constraints)?|view)|create\s+unique\s+index|insert\s+into|update)(?:<str>|[^;"'])+;/.source.replace(/<str>/g, function() {
                            return stringPattern;
                        }), 'im'),
                        alias: 'language-sql',
                        inside: Prism.languages.sql
                    },
                    'global-statements': globalStatements,
                    'sql-statements': {
                        pattern: /(^|\s)(?:disconnect\s+from|begin|commit|exec(?:ute)?|reset|rollback|validate)\b/i,
                        lookbehind: true,
                        alias: 'keyword'
                    },
                    number: number,
                    'numeric-constant': numericConstant,
                    punctuation: punctuation,
                    string: string
                }
            },
            'proc-groovy': {
                pattern: /(^proc\s+groovy(?:\s+[\w|=]+)?;)[\s\S]+?(?=^(?:proc\s+\w+|data|quit|run);|(?![\s\S]))/im,
                lookbehind: true,
                inside: {
                    comment: comment,
                    groovy: {
                        pattern: RegExp(/(^[ \t]*submit(?:\s+(?:load|norun|parseonly))?)(?:<str>|[^"'])+?(?=endsubmit;)/.source.replace(/<str>/g, function() {
                            return stringPattern;
                        }), 'im'),
                        lookbehind: true,
                        alias: 'language-groovy',
                        inside: Prism.languages.groovy
                    },
                    keyword: keywords,
                    'submit-statement': submitStatement,
                    'global-statements': globalStatements,
                    number: number,
                    'numeric-constant': numericConstant,
                    punctuation: punctuation,
                    string: string
                }
            },
            'proc-lua': {
                pattern: /(^proc\s+lua(?:\s+[\w|=]+)?;)[\s\S]+?(?=^(?:proc\s+\w+|data|quit|run);|(?![\s\S]))/im,
                lookbehind: true,
                inside: {
                    comment: comment,
                    lua: {
                        pattern: RegExp(/(^[ \t]*submit(?:\s+(?:load|norun|parseonly))?)(?:<str>|[^"'])+?(?=endsubmit;)/.source.replace(/<str>/g, function() {
                            return stringPattern;
                        }), 'im'),
                        lookbehind: true,
                        alias: 'language-lua',
                        inside: Prism.languages.lua
                    },
                    keyword: keywords,
                    'submit-statement': submitStatement,
                    'global-statements': globalStatements,
                    number: number,
                    'numeric-constant': numericConstant,
                    punctuation: punctuation,
                    string: string
                }
            },
            'proc-cas': {
                pattern: /(^proc\s+cas(?:\s+[\w|=]+)?;)[\s\S]+?(?=^(?:proc\s+\w+|quit|data);|(?![\s\S]))/im,
                lookbehind: true,
                inside: {
                    comment: comment,
                    'statement-var': {
                        pattern: /((?:^|\s)=?)saveresult\s[^;]+/im,
                        lookbehind: true,
                        inside: {
                            statement: {
                                pattern: /^saveresult\s+\S+/i,
                                inside: {
                                    keyword: /^(?:saveresult)/i
                                }
                            },
                            rest: args
                        }
                    },
                    'cas-actions': casActions,
                    statement: {
                        pattern: /((?:^|\s)=?)(?:default|(?:un)?set|on|output|upload)[^;]+/im,
                        lookbehind: true,
                        inside: args
                    },
                    step: step,
                    keyword: keywords,
                    function: func,
                    format: format,
                    altformat: altformat,
                    'global-statements': globalStatements,
                    number: number,
                    'numeric-constant': numericConstant,
                    punctuation: punctuation,
                    string: string
                }
            },
            'proc-args': {
                pattern: RegExp(/(^proc\s+\w+\s+)(?!\s)(?:[^;"']|<str>)+;/.source.replace(/<str>/g, function() {
                    return stringPattern;
                }), 'im'),
                lookbehind: true,
                inside: args
            },
            /*Special keywords within macros*/ 'macro-keyword': macroKeyword,
            'macro-variable': macroVariable,
            'macro-string-functions': {
                pattern: /((?:^|\s|=))%(?:BQUOTE|NRBQUOTE|NRQUOTE|NRSTR|QUOTE|STR)\(.*?(?:[^%]\))/i,
                lookbehind: true,
                inside: {
                    function: {
                        pattern: /%(?:BQUOTE|NRBQUOTE|NRQUOTE|NRSTR|QUOTE|STR)/i,
                        alias: 'keyword'
                    },
                    'macro-keyword': macroKeyword,
                    'macro-variable': macroVariable,
                    'escaped-char': {
                        pattern: /%['"()<>=¬^~;,#]/
                    },
                    punctuation: punctuation
                }
            },
            'macro-declaration': {
                pattern: /^%macro[^;]+(?=;)/im,
                inside: {
                    keyword: /%macro/i
                }
            },
            'macro-end': {
                pattern: /^%mend[^;]+(?=;)/im,
                inside: {
                    keyword: /%mend/i
                }
            },
            /*%_zscore(headcir, _lhc, _mhc, _shc, headcz, headcpct, _Fheadcz); */ macro: {
                pattern: /%_\w+(?=\()/,
                alias: 'keyword'
            },
            input: {
                pattern: /\binput\s[-\w\s/*.$&]+;/i,
                inside: {
                    input: {
                        alias: 'keyword',
                        pattern: /^input/i
                    },
                    comment: comment,
                    number: number,
                    'numeric-constant': numericConstant
                }
            },
            'options-args': {
                pattern: /(^options)[-'"|/\\<>*+=:()\w\s]*(?=;)/im,
                lookbehind: true,
                inside: args
            },
            'cas-actions': casActions,
            comment: comment,
            function: func,
            format: format,
            altformat: altformat,
            'numeric-constant': numericConstant,
            datetime: {
                // '1jan2013'd, '9:25:19pm't, '18jan2003:9:27:05am'dt
                pattern: RegExp(stringPattern + '(?:dt?|t)'),
                alias: 'number'
            },
            string: string,
            step: step,
            keyword: keywords,
            // In SAS Studio syntax highlighting, these operators are styled like keywords
            'operator-keyword': {
                pattern: /\b(?:eq|ge|gt|in|le|lt|ne|not)\b/i,
                alias: 'operator'
            },
            // Decimal (1.2e23), hexadecimal (0c1x)
            number: number,
            operator: /\*\*?|\|\|?|!!?|¦¦?|<[>=]?|>[<=]?|[-+\/=&]|[~¬^]=?/,
            punctuation: punctuation
        };
    })(Prism);
}

});

parcelRegister("7y0Pt", function(module, exports) {
'use strict';
module.exports = $57ec5a0f263c56b9$var$sass;
$57ec5a0f263c56b9$var$sass.displayName = 'sass';
$57ec5a0f263c56b9$var$sass.aliases = [];
function $57ec5a0f263c56b9$var$sass(Prism) {
    (function(Prism) {
        Prism.languages.sass = Prism.languages.extend('css', {
            // Sass comments don't need to be closed, only indented
            comment: {
                pattern: /^([ \t]*)\/[\/*].*(?:(?:\r?\n|\r)\1[ \t].+)*/m,
                lookbehind: true,
                greedy: true
            }
        });
        Prism.languages.insertBefore('sass', 'atrule', {
            // We want to consume the whole line
            'atrule-line': {
                // Includes support for = and + shortcuts
                pattern: /^(?:[ \t]*)[@+=].+/m,
                greedy: true,
                inside: {
                    atrule: /(?:@[\w-]+|[+=])/
                }
            }
        });
        delete Prism.languages.sass.atrule;
        var variable = /\$[-\w]+|#\{\$[-\w]+\}/;
        var operator = [
            /[+*\/%]|[=!]=|<=?|>=?|\b(?:and|not|or)\b/,
            {
                pattern: /(\s)-(?=\s)/,
                lookbehind: true
            }
        ];
        Prism.languages.insertBefore('sass', 'property', {
            // We want to consume the whole line
            'variable-line': {
                pattern: /^[ \t]*\$.+/m,
                greedy: true,
                inside: {
                    punctuation: /:/,
                    variable: variable,
                    operator: operator
                }
            },
            // We want to consume the whole line
            'property-line': {
                pattern: /^[ \t]*(?:[^:\s]+ *:.*|:[^:\s].*)/m,
                greedy: true,
                inside: {
                    property: [
                        /[^:\s]+(?=\s*:)/,
                        {
                            pattern: /(:)[^:\s]+/,
                            lookbehind: true
                        }
                    ],
                    punctuation: /:/,
                    variable: variable,
                    operator: operator,
                    important: Prism.languages.sass.important
                }
            }
        });
        delete Prism.languages.sass.property;
        delete Prism.languages.sass.important // Now that whole lines for other patterns are consumed,
        ;
        // what's left should be selectors
        Prism.languages.insertBefore('sass', 'punctuation', {
            selector: {
                pattern: /^([ \t]*)\S(?:,[^,\r\n]+|[^,\r\n]*)(?:,[^,\r\n]+)*(?:,(?:\r?\n|\r)\1[ \t]+\S(?:,[^,\r\n]+|[^,\r\n]*)(?:,[^,\r\n]+)*)*/m,
                lookbehind: true,
                greedy: true
            }
        });
    })(Prism);
}

});

parcelRegister("6ID3t", function(module, exports) {
'use strict';

var $3IbCO = parcelRequire("3IbCO");
module.exports = $4e4525a20668979c$var$scala;
$4e4525a20668979c$var$scala.displayName = 'scala';
$4e4525a20668979c$var$scala.aliases = [];
function $4e4525a20668979c$var$scala(Prism) {
    Prism.register($3IbCO);
    Prism.languages.scala = Prism.languages.extend('java', {
        'triple-quoted-string': {
            pattern: /"""[\s\S]*?"""/,
            greedy: true,
            alias: 'string'
        },
        string: {
            pattern: /("|')(?:\\.|(?!\1)[^\\\r\n])*\1/,
            greedy: true
        },
        keyword: /<-|=>|\b(?:abstract|case|catch|class|def|do|else|extends|final|finally|for|forSome|if|implicit|import|lazy|match|new|null|object|override|package|private|protected|return|sealed|self|super|this|throw|trait|try|type|val|var|while|with|yield)\b/,
        number: /\b0x(?:[\da-f]*\.)?[\da-f]+|(?:\b\d+(?:\.\d*)?|\B\.\d+)(?:e\d+)?[dfl]?/i,
        builtin: /\b(?:Any|AnyRef|AnyVal|Boolean|Byte|Char|Double|Float|Int|Long|Nothing|Short|String|Unit)\b/,
        symbol: /'[^\d\s\\]\w*/
    });
    Prism.languages.insertBefore('scala', 'triple-quoted-string', {
        'string-interpolation': {
            pattern: /\b[a-z]\w*(?:"""(?:[^$]|\$(?:[^{]|\{(?:[^{}]|\{[^{}]*\})*\}))*?"""|"(?:[^$"\r\n]|\$(?:[^{]|\{(?:[^{}]|\{[^{}]*\})*\}))*")/i,
            greedy: true,
            inside: {
                id: {
                    pattern: /^\w+/,
                    greedy: true,
                    alias: 'function'
                },
                escape: {
                    pattern: /\\\$"|\$[$"]/,
                    greedy: true,
                    alias: 'symbol'
                },
                interpolation: {
                    pattern: /\$(?:\w+|\{(?:[^{}]|\{[^{}]*\})*\})/,
                    greedy: true,
                    inside: {
                        punctuation: /^\$\{?|\}$/,
                        expression: {
                            pattern: /[\s\S]+/,
                            inside: Prism.languages.scala
                        }
                    }
                },
                string: /[\s\S]+/
            }
        }
    });
    delete Prism.languages.scala['class-name'];
    delete Prism.languages.scala['function'];
}

});

parcelRegister("9YjoD", function(module, exports) {
'use strict';
module.exports = $7428c35b87203830$var$scss;
$7428c35b87203830$var$scss.displayName = 'scss';
$7428c35b87203830$var$scss.aliases = [];
function $7428c35b87203830$var$scss(Prism) {
    Prism.languages.scss = Prism.languages.extend('css', {
        comment: {
            pattern: /(^|[^\\])(?:\/\*[\s\S]*?\*\/|\/\/.*)/,
            lookbehind: true
        },
        atrule: {
            pattern: /@[\w-](?:\([^()]+\)|[^()\s]|\s+(?!\s))*?(?=\s+[{;])/,
            inside: {
                rule: /@[\w-]+/ // See rest below
            }
        },
        // url, compassified
        url: /(?:[-a-z]+-)?url(?=\()/i,
        // CSS selector regex is not appropriate for Sass
        // since there can be lot more things (var, @ directive, nesting..)
        // a selector must start at the end of a property or after a brace (end of other rules or nesting)
        // it can contain some characters that aren't used for defining rules or end of selector, & (parent selector), or interpolated variable
        // the end of a selector is found when there is no rules in it ( {} or {\s}) or if there is a property (because an interpolated var
        // can "pass" as a selector- e.g: proper#{$erty})
        // this one was hard to do, so please be careful if you edit this one :)
        selector: {
            // Initial look-ahead is used to prevent matching of blank selectors
            pattern: /(?=\S)[^@;{}()]?(?:[^@;{}()\s]|\s+(?!\s)|#\{\$[-\w]+\})+(?=\s*\{(?:\}|\s|[^}][^:{}]*[:{][^}]))/,
            inside: {
                parent: {
                    pattern: /&/,
                    alias: 'important'
                },
                placeholder: /%[-\w]+/,
                variable: /\$[-\w]+|#\{\$[-\w]+\}/
            }
        },
        property: {
            pattern: /(?:[-\w]|\$[-\w]|#\{\$[-\w]+\})+(?=\s*:)/,
            inside: {
                variable: /\$[-\w]+|#\{\$[-\w]+\}/
            }
        }
    });
    Prism.languages.insertBefore('scss', 'atrule', {
        keyword: [
            /@(?:content|debug|each|else(?: if)?|extend|for|forward|function|if|import|include|mixin|return|use|warn|while)\b/i,
            {
                pattern: /( )(?:from|through)(?= )/,
                lookbehind: true
            }
        ]
    });
    Prism.languages.insertBefore('scss', 'important', {
        // var and interpolated vars
        variable: /\$[-\w]+|#\{\$[-\w]+\}/
    });
    Prism.languages.insertBefore('scss', 'function', {
        'module-modifier': {
            pattern: /\b(?:as|hide|show|with)\b/i,
            alias: 'keyword'
        },
        placeholder: {
            pattern: /%[-\w]+/,
            alias: 'selector'
        },
        statement: {
            pattern: /\B!(?:default|optional)\b/i,
            alias: 'keyword'
        },
        boolean: /\b(?:false|true)\b/,
        null: {
            pattern: /\bnull\b/,
            alias: 'keyword'
        },
        operator: {
            pattern: /(\s)(?:[-+*\/%]|[=!]=|<=?|>=?|and|not|or)(?=\s)/,
            lookbehind: true
        }
    });
    Prism.languages.scss['atrule'].inside.rest = Prism.languages.scss;
}

});

parcelRegister("LTFrQ", function(module, exports) {
'use strict';

var $92S56 = parcelRequire("92S56");
module.exports = $08ff924f5f2c041a$var$shellSession;
$08ff924f5f2c041a$var$shellSession.displayName = 'shellSession';
$08ff924f5f2c041a$var$shellSession.aliases = [];
function $08ff924f5f2c041a$var$shellSession(Prism) {
    Prism.register($92S56);
    (function(Prism) {
        // CAREFUL!
        // The following patterns are concatenated, so the group referenced by a back reference is non-obvious!
        var strings = [
            // normal string
            /"(?:\\[\s\S]|\$\([^)]+\)|\$(?!\()|`[^`]+`|[^"\\`$])*"/.source,
            /'[^']*'/.source,
            /\$'(?:[^'\\]|\\[\s\S])*'/.source,
            // 2 capturing groups
            /<<-?\s*(["']?)(\w+)\1\s[\s\S]*?[\r\n]\2/.source
        ].join('|');
        Prism.languages['shell-session'] = {
            command: {
                pattern: RegExp(// user info
                /^/.source + '(?:' + // <user> ":" ( <path> )?
                (/[^\s@:$#%*!/\\]+@[^\r\n@:$#%*!/\\]+(?::[^\0-\x1F$#%*?"<>:;|]+)?/.source + '|' + // <path>
                // Since the path pattern is quite general, we will require it to start with a special character to
                // prevent false positives.
                /[/~.][^\0-\x1F$#%*?"<>@:;|]*/.source) + ')?' + // shell symbol
                /[$#%](?=\s)/.source + // bash command
                /(?:[^\\\r\n \t'"<$]|[ \t](?:(?!#)|#.*$)|\\(?:[^\r]|\r\n?)|\$(?!')|<(?!<)|<<str>>)+/.source.replace(/<<str>>/g, function() {
                    return strings;
                }), 'm'),
                greedy: true,
                inside: {
                    info: {
                        // foo@bar:~/files$ exit
                        // foo@bar$ exit
                        // ~/files$ exit
                        pattern: /^[^#$%]+/,
                        alias: 'punctuation',
                        inside: {
                            user: /^[^\s@:$#%*!/\\]+@[^\r\n@:$#%*!/\\]+/,
                            punctuation: /:/,
                            path: /[\s\S]+/
                        }
                    },
                    bash: {
                        pattern: /(^[$#%]\s*)\S[\s\S]*/,
                        lookbehind: true,
                        alias: 'language-bash',
                        inside: Prism.languages.bash
                    },
                    'shell-symbol': {
                        pattern: /^[$#%]/,
                        alias: 'important'
                    }
                }
            },
            output: /.(?:.*(?:[\r\n]|.$))*/
        };
        Prism.languages['sh-session'] = Prism.languages['shellsession'] = Prism.languages['shell-session'];
    })(Prism);
}

});

parcelRegister("dSpBG", function(module, exports) {
'use strict';
module.exports = $a1a42e7e5b28c9f5$var$smali;
$a1a42e7e5b28c9f5$var$smali.displayName = 'smali';
$a1a42e7e5b28c9f5$var$smali.aliases = [];
function $a1a42e7e5b28c9f5$var$smali(Prism) {
    // Test files for the parser itself:
    // https://github.com/JesusFreke/smali/tree/master/smali/src/test/resources/LexerTest
    Prism.languages.smali = {
        comment: /#.*/,
        string: {
            pattern: /"(?:[^\r\n\\"]|\\.)*"|'(?:[^\r\n\\']|\\(?:.|u[\da-fA-F]{4}))'/,
            greedy: true
        },
        'class-name': {
            pattern: /(^|[^L])L(?:(?:\w+|`[^`\r\n]*`)\/)*(?:[\w$]+|`[^`\r\n]*`)(?=\s*;)/,
            lookbehind: true,
            inside: {
                'class-name': {
                    pattern: /(^L|\/)(?:[\w$]+|`[^`\r\n]*`)$/,
                    lookbehind: true
                },
                namespace: {
                    pattern: /^(L)(?:(?:\w+|`[^`\r\n]*`)\/)+/,
                    lookbehind: true,
                    inside: {
                        punctuation: /\//
                    }
                },
                builtin: /^L/
            }
        },
        builtin: [
            {
                // Reference: https://github.com/JesusFreke/smali/wiki/TypesMethodsAndFields#types
                pattern: /([();\[])[BCDFIJSVZ]+/,
                lookbehind: true
            },
            {
                // e.g. .field mWifiOnUid:I
                pattern: /([\w$>]:)[BCDFIJSVZ]/,
                lookbehind: true
            }
        ],
        keyword: [
            {
                pattern: /(\.end\s+)[\w-]+/,
                lookbehind: true
            },
            {
                pattern: /(^|[^\w.-])\.(?!\d)[\w-]+/,
                lookbehind: true
            },
            {
                pattern: /(^|[^\w.-])(?:abstract|annotation|bridge|constructor|enum|final|interface|private|protected|public|runtime|static|synthetic|system|transient)(?![\w.-])/,
                lookbehind: true
            }
        ],
        function: {
            pattern: /(^|[^\w.-])(?:\w+|<[\w$-]+>)(?=\()/,
            lookbehind: true
        },
        field: {
            pattern: /[\w$]+(?=:)/,
            alias: 'variable'
        },
        register: {
            pattern: /(^|[^\w.-])[vp]\d(?![\w.-])/,
            lookbehind: true,
            alias: 'variable'
        },
        boolean: {
            pattern: /(^|[^\w.-])(?:false|true)(?![\w.-])/,
            lookbehind: true
        },
        number: {
            pattern: /(^|[^/\w.-])-?(?:NAN|INFINITY|0x(?:[\dA-F]+(?:\.[\dA-F]*)?|\.[\dA-F]+)(?:p[+-]?[\dA-F]+)?|(?:\d+(?:\.\d*)?|\.\d+)(?:e[+-]?\d+)?)[dflst]?(?![\w.-])/i,
            lookbehind: true
        },
        label: {
            pattern: /(:)\w+/,
            lookbehind: true,
            alias: 'property'
        },
        operator: /->|\.\.|[\[=]/,
        punctuation: /[{}(),;:]/
    };
}

});

parcelRegister("6eb3Z", function(module, exports) {
'use strict';
module.exports = $488ca1da55a07562$var$smalltalk;
$488ca1da55a07562$var$smalltalk.displayName = 'smalltalk';
$488ca1da55a07562$var$smalltalk.aliases = [];
function $488ca1da55a07562$var$smalltalk(Prism) {
    Prism.languages.smalltalk = {
        comment: {
            pattern: /"(?:""|[^"])*"/,
            greedy: true
        },
        char: {
            pattern: /\$./,
            greedy: true
        },
        string: {
            pattern: /'(?:''|[^'])*'/,
            greedy: true
        },
        symbol: /#[\da-z]+|#(?:-|([+\/\\*~<>=@%|&?!])\1?)|#(?=\()/i,
        'block-arguments': {
            pattern: /(\[\s*):[^\[|]*\|/,
            lookbehind: true,
            inside: {
                variable: /:[\da-z]+/i,
                punctuation: /\|/
            }
        },
        'temporary-variables': {
            pattern: /\|[^|]+\|/,
            inside: {
                variable: /[\da-z]+/i,
                punctuation: /\|/
            }
        },
        keyword: /\b(?:new|nil|self|super)\b/,
        boolean: /\b(?:false|true)\b/,
        number: [
            /\d+r-?[\dA-Z]+(?:\.[\dA-Z]+)?(?:e-?\d+)?/,
            /\b\d+(?:\.\d+)?(?:e-?\d+)?/
        ],
        operator: /[<=]=?|:=|~[~=]|\/\/?|\\\\|>[>=]?|[!^+\-*&|,@]/,
        punctuation: /[.;:?\[\](){}]/
    };
}

});

parcelRegister("ctouF", function(module, exports) {
'use strict';

var $949g8 = parcelRequire("949g8");
module.exports = $914b315f55bb78dd$var$smarty;
$914b315f55bb78dd$var$smarty.displayName = 'smarty';
$914b315f55bb78dd$var$smarty.aliases = [];
function $914b315f55bb78dd$var$smarty(Prism) {
    Prism.register($949g8);
    (function(Prism) {
        Prism.languages.smarty = {
            comment: {
                pattern: /^\{\*[\s\S]*?\*\}/,
                greedy: true
            },
            'embedded-php': {
                pattern: /^\{php\}[\s\S]*?\{\/php\}/,
                greedy: true,
                inside: {
                    smarty: {
                        pattern: /^\{php\}|\{\/php\}$/,
                        inside: null // see below
                    },
                    php: {
                        pattern: /[\s\S]+/,
                        alias: 'language-php',
                        inside: Prism.languages.php
                    }
                }
            },
            string: [
                {
                    pattern: /"(?:\\.|[^"\\\r\n])*"/,
                    greedy: true,
                    inside: {
                        interpolation: {
                            pattern: /\{[^{}]*\}|`[^`]*`/,
                            inside: {
                                'interpolation-punctuation': {
                                    pattern: /^[{`]|[`}]$/,
                                    alias: 'punctuation'
                                },
                                expression: {
                                    pattern: /[\s\S]+/,
                                    inside: null // see below
                                }
                            }
                        },
                        variable: /\$\w+/
                    }
                },
                {
                    pattern: /'(?:\\.|[^'\\\r\n])*'/,
                    greedy: true
                }
            ],
            keyword: {
                pattern: /(^\{\/?)[a-z_]\w*\b(?!\()/i,
                lookbehind: true,
                greedy: true
            },
            delimiter: {
                pattern: /^\{\/?|\}$/,
                greedy: true,
                alias: 'punctuation'
            },
            number: /\b0x[\dA-Fa-f]+|(?:\b\d+(?:\.\d*)?|\B\.\d+)(?:[Ee][-+]?\d+)?/,
            variable: [
                /\$(?!\d)\w+/,
                /#(?!\d)\w+#/,
                {
                    pattern: /(\.|->|\w\s*=)(?!\d)\w+\b(?!\()/,
                    lookbehind: true
                },
                {
                    pattern: /(\[)(?!\d)\w+(?=\])/,
                    lookbehind: true
                }
            ],
            function: {
                pattern: /(\|\s*)@?[a-z_]\w*|\b[a-z_]\w*(?=\()/i,
                lookbehind: true
            },
            'attr-name': /\b[a-z_]\w*(?=\s*=)/i,
            boolean: /\b(?:false|no|off|on|true|yes)\b/,
            punctuation: /[\[\](){}.,:`]|->/,
            operator: [
                /[+\-*\/%]|==?=?|[!<>]=?|&&|\|\|?/,
                /\bis\s+(?:not\s+)?(?:div|even|odd)(?:\s+by)?\b/,
                /\b(?:and|eq|gt?e|gt|lt?e|lt|mod|neq?|not|or)\b/
            ]
        };
        Prism.languages.smarty['embedded-php'].inside.smarty.inside = Prism.languages.smarty;
        Prism.languages.smarty.string[0].inside.interpolation.inside.expression.inside = Prism.languages.smarty;
        var string = /"(?:\\.|[^"\\\r\n])*"|'(?:\\.|[^'\\\r\n])*'/;
        var smartyPattern = RegExp(// comments
        /\{\*[\s\S]*?\*\}/.source + '|' + // php tags
        /\{php\}[\s\S]*?\{\/php\}/.source + '|' + // smarty blocks
        /\{(?:[^{}"']|<str>|\{(?:[^{}"']|<str>|\{(?:[^{}"']|<str>)*\})*\})*\}/.source.replace(/<str>/g, function() {
            return string.source;
        }), 'g') // Tokenize all inline Smarty expressions
        ;
        Prism.hooks.add('before-tokenize', function(env) {
            var smartyLiteralStart = '{literal}';
            var smartyLiteralEnd = '{/literal}';
            var smartyLiteralMode = false;
            Prism.languages['markup-templating'].buildPlaceholders(env, 'smarty', smartyPattern, function(match) {
                // Smarty tags inside {literal} block are ignored
                if (match === smartyLiteralEnd) smartyLiteralMode = false;
                if (!smartyLiteralMode) {
                    if (match === smartyLiteralStart) smartyLiteralMode = true;
                    return true;
                }
                return false;
            });
        }) // Re-insert the tokens after tokenizing
        ;
        Prism.hooks.add('after-tokenize', function(env) {
            Prism.languages['markup-templating'].tokenizePlaceholders(env, 'smarty');
        });
    })(Prism);
}

});

parcelRegister("9glRX", function(module, exports) {
'use strict';
module.exports = $6be69271b30e30c2$var$sml;
$6be69271b30e30c2$var$sml.displayName = 'sml';
$6be69271b30e30c2$var$sml.aliases = [
    'smlnj'
];
function $6be69271b30e30c2$var$sml(Prism) {
    (function(Prism) {
        var keywords = /\b(?:abstype|and|andalso|as|case|datatype|do|else|end|eqtype|exception|fn|fun|functor|handle|if|in|include|infix|infixr|let|local|nonfix|of|op|open|orelse|raise|rec|sharing|sig|signature|struct|structure|then|type|val|where|while|with|withtype)\b/i;
        Prism.languages.sml = {
            // allow one level of nesting
            comment: /\(\*(?:[^*(]|\*(?!\))|\((?!\*)|\(\*(?:[^*(]|\*(?!\))|\((?!\*))*\*\))*\*\)/,
            string: {
                pattern: /#?"(?:[^"\\]|\\.)*"/,
                greedy: true
            },
            'class-name': [
                {
                    // This is only an approximation since the real grammar is context-free
                    //
                    // Why the main loop so complex?
                    // The main loop is approximately the same as /(?:\s*(?:[*,]|->)\s*<TERMINAL>)*/ which is, obviously, a lot
                    // simpler. The difference is that if a comma is the last iteration of the loop, then the terminal must be
                    // followed by a long identifier.
                    pattern: RegExp(/((?:^|[^:]):\s*)<TERMINAL>(?:\s*(?:(?:\*|->)\s*<TERMINAL>|,\s*<TERMINAL>(?:(?=<NOT-LAST>)|(?!<NOT-LAST>)\s+<LONG-ID>)))*/.source.replace(/<NOT-LAST>/g, function() {
                        return /\s*(?:[*,]|->)/.source;
                    }).replace(/<TERMINAL>/g, function() {
                        return /(?:'[\w']*|<LONG-ID>|\((?:[^()]|\([^()]*\))*\)|\{(?:[^{}]|\{[^{}]*\})*\})(?:\s+<LONG-ID>)*/.source;
                    }).replace(/<LONG-ID>/g, function() {
                        return /(?!<KEYWORD>)[a-z\d_][\w'.]*/.source;
                    }).replace(/<KEYWORD>/g, function() {
                        return keywords.source;
                    }), 'i'),
                    lookbehind: true,
                    greedy: true,
                    inside: null // see below
                },
                {
                    pattern: /((?:^|[^\w'])(?:datatype|exception|functor|signature|structure|type)\s+)[a-z_][\w'.]*/i,
                    lookbehind: true
                }
            ],
            function: {
                pattern: /((?:^|[^\w'])fun\s+)[a-z_][\w'.]*/i,
                lookbehind: true
            },
            keyword: keywords,
            variable: {
                pattern: /(^|[^\w'])'[\w']*/,
                lookbehind: true
            },
            number: /~?\b(?:\d+(?:\.\d+)?(?:e~?\d+)?|0x[\da-f]+)\b/i,
            word: {
                pattern: /\b0w(?:\d+|x[\da-f]+)\b/i,
                alias: 'constant'
            },
            boolean: /\b(?:false|true)\b/i,
            operator: /\.\.\.|:[>=:]|=>?|->|[<>]=?|[!+\-*/^#|@~]/,
            punctuation: /[(){}\[\].:,;]/
        };
        Prism.languages.sml['class-name'][0].inside = Prism.languages.sml;
        Prism.languages.smlnj = Prism.languages.sml;
    })(Prism);
}

});

parcelRegister("7QpSG", function(module, exports) {
'use strict';
module.exports = $5b61772679826861$var$solidity;
$5b61772679826861$var$solidity.displayName = 'solidity';
$5b61772679826861$var$solidity.aliases = [
    'sol'
];
function $5b61772679826861$var$solidity(Prism) {
    Prism.languages.solidity = Prism.languages.extend('clike', {
        'class-name': {
            pattern: /(\b(?:contract|enum|interface|library|new|struct|using)\s+)(?!\d)[\w$]+/,
            lookbehind: true
        },
        keyword: /\b(?:_|anonymous|as|assembly|assert|break|calldata|case|constant|constructor|continue|contract|default|delete|do|else|emit|enum|event|external|for|from|function|if|import|indexed|inherited|interface|internal|is|let|library|mapping|memory|modifier|new|payable|pragma|private|public|pure|require|returns?|revert|selfdestruct|solidity|storage|struct|suicide|switch|this|throw|using|var|view|while)\b/,
        operator: /=>|->|:=|=:|\*\*|\+\+|--|\|\||&&|<<=?|>>=?|[-+*/%^&|<>!=]=?|[~?]/
    });
    Prism.languages.insertBefore('solidity', 'keyword', {
        builtin: /\b(?:address|bool|byte|u?int(?:8|16|24|32|40|48|56|64|72|80|88|96|104|112|120|128|136|144|152|160|168|176|184|192|200|208|216|224|232|240|248|256)?|string|bytes(?:[1-9]|[12]\d|3[0-2])?)\b/
    });
    Prism.languages.insertBefore('solidity', 'number', {
        version: {
            pattern: /([<>]=?|\^)\d+\.\d+\.\d+\b/,
            lookbehind: true,
            alias: 'number'
        }
    });
    Prism.languages.sol = Prism.languages.solidity;
}

});

parcelRegister("lk7t0", function(module, exports) {
'use strict';
module.exports = $f86141fbf21ca9bf$var$solutionFile;
$f86141fbf21ca9bf$var$solutionFile.displayName = 'solutionFile';
$f86141fbf21ca9bf$var$solutionFile.aliases = [];
function $f86141fbf21ca9bf$var$solutionFile(Prism) {
    (function(Prism) {
        var guid = {
            // https://en.wikipedia.org/wiki/Universally_unique_identifier#Format
            pattern: /\{[\da-f]{8}-[\da-f]{4}-[\da-f]{4}-[\da-f]{4}-[\da-f]{12}\}/i,
            alias: 'constant',
            inside: {
                punctuation: /[{}]/
            }
        };
        Prism.languages['solution-file'] = {
            comment: {
                pattern: /#.*/,
                greedy: true
            },
            string: {
                pattern: /"[^"\r\n]*"|'[^'\r\n]*'/,
                greedy: true,
                inside: {
                    guid: guid
                }
            },
            object: {
                // Foo
                //   Bar("abs") = 9
                //   EndBar
                //   Prop = TRUE
                // EndFoo
                pattern: /^([ \t]*)(?:([A-Z]\w*)\b(?=.*(?:\r\n?|\n)(?:\1[ \t].*(?:\r\n?|\n))*\1End\2(?=[ \t]*$))|End[A-Z]\w*(?=[ \t]*$))/m,
                lookbehind: true,
                greedy: true,
                alias: 'keyword'
            },
            property: {
                pattern: /^([ \t]*)(?!\s)[^\r\n"#=()]*[^\s"#=()](?=\s*=)/m,
                lookbehind: true,
                inside: {
                    guid: guid
                }
            },
            guid: guid,
            number: /\b\d+(?:\.\d+)*\b/,
            boolean: /\b(?:FALSE|TRUE)\b/,
            operator: /=/,
            punctuation: /[(),]/
        };
        Prism.languages['sln'] = Prism.languages['solution-file'];
    })(Prism);
}

});

parcelRegister("7JMaL", function(module, exports) {
'use strict';

var $949g8 = parcelRequire("949g8");
module.exports = $5a221a716990a592$var$soy;
$5a221a716990a592$var$soy.displayName = 'soy';
$5a221a716990a592$var$soy.aliases = [];
function $5a221a716990a592$var$soy(Prism) {
    Prism.register($949g8);
    (function(Prism) {
        var stringPattern = /(["'])(?:\\(?:\r\n|[\s\S])|(?!\1)[^\\\r\n])*\1/;
        var numberPattern = /\b\d+(?:\.\d+)?(?:[eE][+-]?\d+)?\b|\b0x[\dA-F]+\b/;
        Prism.languages.soy = {
            comment: [
                /\/\*[\s\S]*?\*\//,
                {
                    pattern: /(\s)\/\/.*/,
                    lookbehind: true,
                    greedy: true
                }
            ],
            'command-arg': {
                pattern: /(\{+\/?\s*(?:alias|call|delcall|delpackage|deltemplate|namespace|template)\s+)\.?[\w.]+/,
                lookbehind: true,
                alias: 'string',
                inside: {
                    punctuation: /\./
                }
            },
            parameter: {
                pattern: /(\{+\/?\s*@?param\??\s+)\.?[\w.]+/,
                lookbehind: true,
                alias: 'variable'
            },
            keyword: [
                {
                    pattern: /(\{+\/?[^\S\r\n]*)(?:\\[nrt]|alias|call|case|css|default|delcall|delpackage|deltemplate|else(?:if)?|fallbackmsg|for(?:each)?|if(?:empty)?|lb|let|literal|msg|namespace|nil|@?param\??|rb|sp|switch|template|xid)/,
                    lookbehind: true
                },
                /\b(?:any|as|attributes|bool|css|float|html|in|int|js|list|map|null|number|string|uri)\b/
            ],
            delimiter: {
                pattern: /^\{+\/?|\/?\}+$/,
                alias: 'punctuation'
            },
            property: /\w+(?==)/,
            variable: {
                pattern: /\$[^\W\d]\w*(?:\??(?:\.\w+|\[[^\]]+\]))*/,
                inside: {
                    string: {
                        pattern: stringPattern,
                        greedy: true
                    },
                    number: numberPattern,
                    punctuation: /[\[\].?]/
                }
            },
            string: {
                pattern: stringPattern,
                greedy: true
            },
            function: [
                /\w+(?=\()/,
                {
                    pattern: /(\|[^\S\r\n]*)\w+/,
                    lookbehind: true
                }
            ],
            boolean: /\b(?:false|true)\b/,
            number: numberPattern,
            operator: /\?:?|<=?|>=?|==?|!=|[+*/%-]|\b(?:and|not|or)\b/,
            punctuation: /[{}()\[\]|.,:]/
        } // Tokenize all inline Soy expressions
        ;
        Prism.hooks.add('before-tokenize', function(env) {
            var soyPattern = /\{\{.+?\}\}|\{.+?\}|\s\/\/.*|\/\*[\s\S]*?\*\//g;
            var soyLitteralStart = '{literal}';
            var soyLitteralEnd = '{/literal}';
            var soyLitteralMode = false;
            Prism.languages['markup-templating'].buildPlaceholders(env, 'soy', soyPattern, function(match) {
                // Soy tags inside {literal} block are ignored
                if (match === soyLitteralEnd) soyLitteralMode = false;
                if (!soyLitteralMode) {
                    if (match === soyLitteralStart) soyLitteralMode = true;
                    return true;
                }
                return false;
            });
        }) // Re-insert the tokens after tokenizing
        ;
        Prism.hooks.add('after-tokenize', function(env) {
            Prism.languages['markup-templating'].tokenizePlaceholders(env, 'soy');
        });
    })(Prism);
}

});

parcelRegister("eBzjI", function(module, exports) {
'use strict';

var $7Q3ix = parcelRequire("7Q3ix");
module.exports = $aa1feaa0538bd057$var$sparql;
$aa1feaa0538bd057$var$sparql.displayName = 'sparql';
$aa1feaa0538bd057$var$sparql.aliases = [
    'rq'
];
function $aa1feaa0538bd057$var$sparql(Prism) {
    Prism.register($7Q3ix);
    Prism.languages.sparql = Prism.languages.extend('turtle', {
        boolean: /\b(?:false|true)\b/i,
        variable: {
            pattern: /[?$]\w+/,
            greedy: true
        }
    });
    Prism.languages.insertBefore('sparql', 'punctuation', {
        keyword: [
            /\b(?:A|ADD|ALL|AS|ASC|ASK|BNODE|BY|CLEAR|CONSTRUCT|COPY|CREATE|DATA|DEFAULT|DELETE|DESC|DESCRIBE|DISTINCT|DROP|EXISTS|FILTER|FROM|GROUP|HAVING|INSERT|INTO|LIMIT|LOAD|MINUS|MOVE|NAMED|NOT|NOW|OFFSET|OPTIONAL|ORDER|RAND|REDUCED|SELECT|SEPARATOR|SERVICE|SILENT|STRUUID|UNION|USING|UUID|VALUES|WHERE)\b/i,
            /\b(?:ABS|AVG|BIND|BOUND|CEIL|COALESCE|CONCAT|CONTAINS|COUNT|DATATYPE|DAY|ENCODE_FOR_URI|FLOOR|GROUP_CONCAT|HOURS|IF|IRI|isBLANK|isIRI|isLITERAL|isNUMERIC|isURI|LANG|LANGMATCHES|LCASE|MAX|MD5|MIN|MINUTES|MONTH|REGEX|REPLACE|ROUND|sameTerm|SAMPLE|SECONDS|SHA1|SHA256|SHA384|SHA512|STR|STRAFTER|STRBEFORE|STRDT|STRENDS|STRLANG|STRLEN|STRSTARTS|SUBSTR|SUM|TIMEZONE|TZ|UCASE|URI|YEAR)\b(?=\s*\()/i,
            /\b(?:BASE|GRAPH|PREFIX)\b/i
        ]
    });
    Prism.languages.rq = Prism.languages.sparql;
}

});
parcelRegister("7Q3ix", function(module, exports) {
'use strict';
module.exports = $5b4ff2ab059f4ed1$var$turtle;
$5b4ff2ab059f4ed1$var$turtle.displayName = 'turtle';
$5b4ff2ab059f4ed1$var$turtle.aliases = [];
function $5b4ff2ab059f4ed1$var$turtle(Prism) {
    Prism.languages.turtle = {
        comment: {
            pattern: /#.*/,
            greedy: true
        },
        'multiline-string': {
            pattern: /"""(?:(?:""?)?(?:[^"\\]|\\.))*"""|'''(?:(?:''?)?(?:[^'\\]|\\.))*'''/,
            greedy: true,
            alias: 'string',
            inside: {
                comment: /#.*/
            }
        },
        string: {
            pattern: /"(?:[^\\"\r\n]|\\.)*"|'(?:[^\\'\r\n]|\\.)*'/,
            greedy: true
        },
        url: {
            pattern: /<(?:[^\x00-\x20<>"{}|^`\\]|\\(?:u[\da-fA-F]{4}|U[\da-fA-F]{8}))*>/,
            greedy: true,
            inside: {
                punctuation: /[<>]/
            }
        },
        function: {
            pattern: /(?:(?![-.\d\xB7])[-.\w\xB7\xC0-\uFFFD]+)?:(?:(?![-.])(?:[-.:\w\xC0-\uFFFD]|%[\da-f]{2}|\\.)+)?/i,
            inside: {
                'local-name': {
                    pattern: /([^:]*:)[\s\S]+/,
                    lookbehind: true
                },
                prefix: {
                    pattern: /[\s\S]+/,
                    inside: {
                        punctuation: /:/
                    }
                }
            }
        },
        number: /[+-]?\b\d+(?:\.\d*)?(?:e[+-]?\d+)?/i,
        punctuation: /[{}.,;()[\]]|\^\^/,
        boolean: /\b(?:false|true)\b/,
        keyword: [
            /(?:\ba|@prefix|@base)\b|=/,
            /\b(?:base|graph|prefix)\b/i
        ],
        tag: {
            pattern: /@[a-z]+(?:-[a-z\d]+)*/i,
            inside: {
                punctuation: /@/
            }
        }
    };
    Prism.languages.trig = Prism.languages['turtle'];
}

});


parcelRegister("2tqTy", function(module, exports) {
'use strict';
module.exports = $1cd327028d67f4ae$var$splunkSpl;
$1cd327028d67f4ae$var$splunkSpl.displayName = 'splunkSpl';
$1cd327028d67f4ae$var$splunkSpl.aliases = [];
function $1cd327028d67f4ae$var$splunkSpl(Prism) {
    Prism.languages['splunk-spl'] = {
        comment: /`comment\("(?:\\.|[^\\"])*"\)`/,
        string: {
            pattern: /"(?:\\.|[^\\"])*"/,
            greedy: true
        },
        // https://docs.splunk.com/Documentation/Splunk/7.3.0/SearchReference/ListOfSearchCommands
        keyword: /\b(?:abstract|accum|addcoltotals|addinfo|addtotals|analyzefields|anomalies|anomalousvalue|anomalydetection|append|appendcols|appendcsv|appendlookup|appendpipe|arules|associate|audit|autoregress|bin|bucket|bucketdir|chart|cluster|cofilter|collect|concurrency|contingency|convert|correlate|datamodel|dbinspect|dedup|delete|delta|diff|erex|eval|eventcount|eventstats|extract|fieldformat|fields|fieldsummary|filldown|fillnull|findtypes|folderize|foreach|format|from|gauge|gentimes|geom|geomfilter|geostats|head|highlight|history|iconify|input|inputcsv|inputlookup|iplocation|join|kmeans|kv|kvform|loadjob|localize|localop|lookup|makecontinuous|makemv|makeresults|map|mcollect|metadata|metasearch|meventcollect|mstats|multikv|multisearch|mvcombine|mvexpand|nomv|outlier|outputcsv|outputlookup|outputtext|overlap|pivot|predict|rangemap|rare|regex|relevancy|reltime|rename|replace|rest|return|reverse|rex|rtorder|run|savedsearch|script|scrub|search|searchtxn|selfjoin|sendemail|set|setfields|sichart|sirare|sistats|sitimechart|sitop|sort|spath|stats|strcat|streamstats|table|tags|tail|timechart|timewrap|top|transaction|transpose|trendline|tscollect|tstats|typeahead|typelearner|typer|union|uniq|untable|where|x11|xmlkv|xmlunescape|xpath|xyseries)\b/i,
        'operator-word': {
            pattern: /\b(?:and|as|by|not|or|xor)\b/i,
            alias: 'operator'
        },
        function: /\b\w+(?=\s*\()/,
        property: /\b\w+(?=\s*=(?!=))/,
        date: {
            // MM/DD/YYYY(:HH:MM:SS)?
            pattern: /\b\d{1,2}\/\d{1,2}\/\d{1,4}(?:(?::\d{1,2}){3})?\b/,
            alias: 'number'
        },
        number: /\b\d+(?:\.\d+)?\b/,
        boolean: /\b(?:f|false|t|true)\b/i,
        operator: /[<>=]=?|[-+*/%|]/,
        punctuation: /[()[\],]/
    };
}

});

parcelRegister("9NMy0", function(module, exports) {
'use strict';
module.exports = $722e592ad8a6228c$var$sqf;
$722e592ad8a6228c$var$sqf.displayName = 'sqf';
$722e592ad8a6228c$var$sqf.aliases = [];
function $722e592ad8a6228c$var$sqf(Prism) {
    Prism.languages.sqf = Prism.languages.extend('clike', {
        string: {
            pattern: /"(?:(?:"")?[^"])*"(?!")|'(?:[^'])*'/,
            greedy: true
        },
        keyword: /\b(?:breakOut|breakTo|call|case|catch|default|do|echo|else|execFSM|execVM|exitWith|for|forEach|forEachMember|forEachMemberAgent|forEachMemberTeam|from|goto|if|nil|preprocessFile|preprocessFileLineNumbers|private|scopeName|spawn|step|switch|then|throw|to|try|while|with)\b/i,
        boolean: /\b(?:false|true)\b/i,
        function: /\b(?:abs|accTime|acos|action|actionIDs|actionKeys|actionKeysImages|actionKeysNames|actionKeysNamesArray|actionName|actionParams|activateAddons|activatedAddons|activateKey|add3DENConnection|add3DENEventHandler|add3DENLayer|addAction|addBackpack|addBackpackCargo|addBackpackCargoGlobal|addBackpackGlobal|addCamShake|addCuratorAddons|addCuratorCameraArea|addCuratorEditableObjects|addCuratorEditingArea|addCuratorPoints|addEditorObject|addEventHandler|addForce|addForceGeneratorRTD|addGoggles|addGroupIcon|addHandgunItem|addHeadgear|addItem|addItemCargo|addItemCargoGlobal|addItemPool|addItemToBackpack|addItemToUniform|addItemToVest|addLiveStats|addMagazine|addMagazineAmmoCargo|addMagazineCargo|addMagazineCargoGlobal|addMagazineGlobal|addMagazinePool|addMagazines|addMagazineTurret|addMenu|addMenuItem|addMissionEventHandler|addMPEventHandler|addMusicEventHandler|addOwnedMine|addPlayerScores|addPrimaryWeaponItem|addPublicVariableEventHandler|addRating|addResources|addScore|addScoreSide|addSecondaryWeaponItem|addSwitchableUnit|addTeamMember|addToRemainsCollector|addTorque|addUniform|addVehicle|addVest|addWaypoint|addWeapon|addWeaponCargo|addWeaponCargoGlobal|addWeaponGlobal|addWeaponItem|addWeaponPool|addWeaponTurret|admin|agent|agents|AGLToASL|aimedAtTarget|aimPos|airDensityCurveRTD|airDensityRTD|airplaneThrottle|airportSide|AISFinishHeal|alive|all3DENEntities|allAirports|allControls|allCurators|allCutLayers|allDead|allDeadMen|allDisplays|allGroups|allMapMarkers|allMines|allMissionObjects|allow3DMode|allowCrewInImmobile|allowCuratorLogicIgnoreAreas|allowDamage|allowDammage|allowFileOperations|allowFleeing|allowGetIn|allowSprint|allPlayers|allSimpleObjects|allSites|allTurrets|allUnits|allUnitsUAV|allVariables|ammo|ammoOnPylon|animate|animateBay|animateDoor|animatePylon|animateSource|animationNames|animationPhase|animationSourcePhase|animationState|append|apply|armoryPoints|arrayIntersect|asin|ASLToAGL|ASLToATL|assert|assignAsCargo|assignAsCargoIndex|assignAsCommander|assignAsDriver|assignAsGunner|assignAsTurret|assignCurator|assignedCargo|assignedCommander|assignedDriver|assignedGunner|assignedItems|assignedTarget|assignedTeam|assignedVehicle|assignedVehicleRole|assignItem|assignTeam|assignToAirport|atan|atan2|atg|ATLToASL|attachedObject|attachedObjects|attachedTo|attachObject|attachTo|attackEnabled|backpack|backpackCargo|backpackContainer|backpackItems|backpackMagazines|backpackSpaceFor|behaviour|benchmark|binocular|blufor|boundingBox|boundingBoxReal|boundingCenter|briefingName|buildingExit|buildingPos|buldozer_EnableRoadDiag|buldozer_IsEnabledRoadDiag|buldozer_LoadNewRoads|buldozer_reloadOperMap|buttonAction|buttonSetAction|cadetMode|callExtension|camCommand|camCommit|camCommitPrepared|camCommitted|camConstuctionSetParams|camCreate|camDestroy|cameraEffect|cameraEffectEnableHUD|cameraInterest|cameraOn|cameraView|campaignConfigFile|camPreload|camPreloaded|camPrepareBank|camPrepareDir|camPrepareDive|camPrepareFocus|camPrepareFov|camPrepareFovRange|camPreparePos|camPrepareRelPos|camPrepareTarget|camSetBank|camSetDir|camSetDive|camSetFocus|camSetFov|camSetFovRange|camSetPos|camSetRelPos|camSetTarget|camTarget|camUseNVG|canAdd|canAddItemToBackpack|canAddItemToUniform|canAddItemToVest|cancelSimpleTaskDestination|canFire|canMove|canSlingLoad|canStand|canSuspend|canTriggerDynamicSimulation|canUnloadInCombat|canVehicleCargo|captive|captiveNum|cbChecked|cbSetChecked|ceil|channelEnabled|cheatsEnabled|checkAIFeature|checkVisibility|civilian|className|clear3DENAttribute|clear3DENInventory|clearAllItemsFromBackpack|clearBackpackCargo|clearBackpackCargoGlobal|clearForcesRTD|clearGroupIcons|clearItemCargo|clearItemCargoGlobal|clearItemPool|clearMagazineCargo|clearMagazineCargoGlobal|clearMagazinePool|clearOverlay|clearRadio|clearVehicleInit|clearWeaponCargo|clearWeaponCargoGlobal|clearWeaponPool|clientOwner|closeDialog|closeDisplay|closeOverlay|collapseObjectTree|collect3DENHistory|collectiveRTD|combatMode|commandArtilleryFire|commandChat|commander|commandFire|commandFollow|commandFSM|commandGetOut|commandingMenu|commandMove|commandRadio|commandStop|commandSuppressiveFire|commandTarget|commandWatch|comment|commitOverlay|compile|compileFinal|completedFSM|composeText|configClasses|configFile|configHierarchy|configName|configNull|configProperties|configSourceAddonList|configSourceMod|configSourceModList|confirmSensorTarget|connectTerminalToUAV|controlNull|controlsGroupCtrl|copyFromClipboard|copyToClipboard|copyWaypoints|cos|count|countEnemy|countFriendly|countSide|countType|countUnknown|create3DENComposition|create3DENEntity|createAgent|createCenter|createDialog|createDiaryLink|createDiaryRecord|createDiarySubject|createDisplay|createGearDialog|createGroup|createGuardedPoint|createLocation|createMarker|createMarkerLocal|createMenu|createMine|createMissionDisplay|createMPCampaignDisplay|createSimpleObject|createSimpleTask|createSite|createSoundSource|createTask|createTeam|createTrigger|createUnit|createVehicle|createVehicleCrew|createVehicleLocal|crew|ctAddHeader|ctAddRow|ctClear|ctCurSel|ctData|ctFindHeaderRows|ctFindRowHeader|ctHeaderControls|ctHeaderCount|ctRemoveHeaders|ctRemoveRows|ctrlActivate|ctrlAddEventHandler|ctrlAngle|ctrlAutoScrollDelay|ctrlAutoScrollRewind|ctrlAutoScrollSpeed|ctrlChecked|ctrlClassName|ctrlCommit|ctrlCommitted|ctrlCreate|ctrlDelete|ctrlEnable|ctrlEnabled|ctrlFade|ctrlHTMLLoaded|ctrlIDC|ctrlIDD|ctrlMapAnimAdd|ctrlMapAnimClear|ctrlMapAnimCommit|ctrlMapAnimDone|ctrlMapCursor|ctrlMapMouseOver|ctrlMapScale|ctrlMapScreenToWorld|ctrlMapWorldToScreen|ctrlModel|ctrlModelDirAndUp|ctrlModelScale|ctrlParent|ctrlParentControlsGroup|ctrlPosition|ctrlRemoveAllEventHandlers|ctrlRemoveEventHandler|ctrlScale|ctrlSetActiveColor|ctrlSetAngle|ctrlSetAutoScrollDelay|ctrlSetAutoScrollRewind|ctrlSetAutoScrollSpeed|ctrlSetBackgroundColor|ctrlSetChecked|ctrlSetDisabledColor|ctrlSetEventHandler|ctrlSetFade|ctrlSetFocus|ctrlSetFont|ctrlSetFontH1|ctrlSetFontH1B|ctrlSetFontH2|ctrlSetFontH2B|ctrlSetFontH3|ctrlSetFontH3B|ctrlSetFontH4|ctrlSetFontH4B|ctrlSetFontH5|ctrlSetFontH5B|ctrlSetFontH6|ctrlSetFontH6B|ctrlSetFontHeight|ctrlSetFontHeightH1|ctrlSetFontHeightH2|ctrlSetFontHeightH3|ctrlSetFontHeightH4|ctrlSetFontHeightH5|ctrlSetFontHeightH6|ctrlSetFontHeightSecondary|ctrlSetFontP|ctrlSetFontPB|ctrlSetFontSecondary|ctrlSetForegroundColor|ctrlSetModel|ctrlSetModelDirAndUp|ctrlSetModelScale|ctrlSetPixelPrecision|ctrlSetPosition|ctrlSetScale|ctrlSetStructuredText|ctrlSetText|ctrlSetTextColor|ctrlSetTextColorSecondary|ctrlSetTextSecondary|ctrlSetTooltip|ctrlSetTooltipColorBox|ctrlSetTooltipColorShade|ctrlSetTooltipColorText|ctrlShow|ctrlShown|ctrlText|ctrlTextHeight|ctrlTextSecondary|ctrlTextWidth|ctrlType|ctrlVisible|ctRowControls|ctRowCount|ctSetCurSel|ctSetData|ctSetHeaderTemplate|ctSetRowTemplate|ctSetValue|ctValue|curatorAddons|curatorCamera|curatorCameraArea|curatorCameraAreaCeiling|curatorCoef|curatorEditableObjects|curatorEditingArea|curatorEditingAreaType|curatorMouseOver|curatorPoints|curatorRegisteredObjects|curatorSelected|curatorWaypointCost|current3DENOperation|currentChannel|currentCommand|currentMagazine|currentMagazineDetail|currentMagazineDetailTurret|currentMagazineTurret|currentMuzzle|currentNamespace|currentTask|currentTasks|currentThrowable|currentVisionMode|currentWaypoint|currentWeapon|currentWeaponMode|currentWeaponTurret|currentZeroing|cursorObject|cursorTarget|customChat|customRadio|cutFadeOut|cutObj|cutRsc|cutText|damage|date|dateToNumber|daytime|deActivateKey|debriefingText|debugFSM|debugLog|deg|delete3DENEntities|deleteAt|deleteCenter|deleteCollection|deleteEditorObject|deleteGroup|deleteGroupWhenEmpty|deleteIdentity|deleteLocation|deleteMarker|deleteMarkerLocal|deleteRange|deleteResources|deleteSite|deleteStatus|deleteTeam|deleteVehicle|deleteVehicleCrew|deleteWaypoint|detach|detectedMines|diag_activeMissionFSMs|diag_activeScripts|diag_activeSQFScripts|diag_activeSQSScripts|diag_captureFrame|diag_captureFrameToFile|diag_captureSlowFrame|diag_codePerformance|diag_drawMode|diag_dynamicSimulationEnd|diag_enable|diag_enabled|diag_fps|diag_fpsMin|diag_frameNo|diag_lightNewLoad|diag_list|diag_log|diag_logSlowFrame|diag_mergeConfigFile|diag_recordTurretLimits|diag_setLightNew|diag_tickTime|diag_toggle|dialog|diarySubjectExists|didJIP|didJIPOwner|difficulty|difficultyEnabled|difficultyEnabledRTD|difficultyOption|direction|directSay|disableAI|disableCollisionWith|disableConversation|disableDebriefingStats|disableMapIndicators|disableNVGEquipment|disableRemoteSensors|disableSerialization|disableTIEquipment|disableUAVConnectability|disableUserInput|displayAddEventHandler|displayCtrl|displayNull|displayParent|displayRemoveAllEventHandlers|displayRemoveEventHandler|displaySetEventHandler|dissolveTeam|distance|distance2D|distanceSqr|distributionRegion|do3DENAction|doArtilleryFire|doFire|doFollow|doFSM|doGetOut|doMove|doorPhase|doStop|doSuppressiveFire|doTarget|doWatch|drawArrow|drawEllipse|drawIcon|drawIcon3D|drawLine|drawLine3D|drawLink|drawLocation|drawPolygon|drawRectangle|drawTriangle|driver|drop|dynamicSimulationDistance|dynamicSimulationDistanceCoef|dynamicSimulationEnabled|dynamicSimulationSystemEnabled|east|edit3DENMissionAttributes|editObject|editorSetEventHandler|effectiveCommander|emptyPositions|enableAI|enableAIFeature|enableAimPrecision|enableAttack|enableAudioFeature|enableAutoStartUpRTD|enableAutoTrimRTD|enableCamShake|enableCaustics|enableChannel|enableCollisionWith|enableCopilot|enableDebriefingStats|enableDiagLegend|enableDynamicSimulation|enableDynamicSimulationSystem|enableEndDialog|enableEngineArtillery|enableEnvironment|enableFatigue|enableGunLights|enableInfoPanelComponent|enableIRLasers|enableMimics|enablePersonTurret|enableRadio|enableReload|enableRopeAttach|enableSatNormalOnDetail|enableSaving|enableSentences|enableSimulation|enableSimulationGlobal|enableStamina|enableStressDamage|enableTeamSwitch|enableTraffic|enableUAVConnectability|enableUAVWaypoints|enableVehicleCargo|enableVehicleSensor|enableWeaponDisassembly|endl|endLoadingScreen|endMission|engineOn|enginesIsOnRTD|enginesPowerRTD|enginesRpmRTD|enginesTorqueRTD|entities|environmentEnabled|estimatedEndServerTime|estimatedTimeLeft|evalObjectArgument|everyBackpack|everyContainer|exec|execEditorScript|exp|expectedDestination|exportJIPMessages|eyeDirection|eyePos|face|faction|fadeMusic|fadeRadio|fadeSound|fadeSpeech|failMission|fillWeaponsFromPool|find|findCover|findDisplay|findEditorObject|findEmptyPosition|findEmptyPositionReady|findIf|findNearestEnemy|finishMissionInit|finite|fire|fireAtTarget|firstBackpack|flag|flagAnimationPhase|flagOwner|flagSide|flagTexture|fleeing|floor|flyInHeight|flyInHeightASL|fog|fogForecast|fogParams|forceAddUniform|forceAtPositionRTD|forcedMap|forceEnd|forceFlagTexture|forceFollowRoad|forceGeneratorRTD|forceMap|forceRespawn|forceSpeed|forceWalk|forceWeaponFire|forceWeatherChange|forgetTarget|format|formation|formationDirection|formationLeader|formationMembers|formationPosition|formationTask|formatText|formLeader|freeLook|fromEditor|fuel|fullCrew|gearIDCAmmoCount|gearSlotAmmoCount|gearSlotData|get3DENActionState|get3DENAttribute|get3DENCamera|get3DENConnections|get3DENEntity|get3DENEntityID|get3DENGrid|get3DENIconsVisible|get3DENLayerEntities|get3DENLinesVisible|get3DENMissionAttribute|get3DENMouseOver|get3DENSelected|getAimingCoef|getAllEnvSoundControllers|getAllHitPointsDamage|getAllOwnedMines|getAllSoundControllers|getAmmoCargo|getAnimAimPrecision|getAnimSpeedCoef|getArray|getArtilleryAmmo|getArtilleryComputerSettings|getArtilleryETA|getAssignedCuratorLogic|getAssignedCuratorUnit|getBackpackCargo|getBleedingRemaining|getBurningValue|getCameraViewDirection|getCargoIndex|getCenterOfMass|getClientState|getClientStateNumber|getCompatiblePylonMagazines|getConnectedUAV|getContainerMaxLoad|getCursorObjectParams|getCustomAimCoef|getDammage|getDescription|getDir|getDirVisual|getDLCAssetsUsage|getDLCAssetsUsageByName|getDLCs|getDLCUsageTime|getEditorCamera|getEditorMode|getEditorObjectScope|getElevationOffset|getEngineTargetRpmRTD|getEnvSoundController|getFatigue|getFieldManualStartPage|getForcedFlagTexture|getFriend|getFSMVariable|getFuelCargo|getGroupIcon|getGroupIconParams|getGroupIcons|getHideFrom|getHit|getHitIndex|getHitPointDamage|getItemCargo|getMagazineCargo|getMarkerColor|getMarkerPos|getMarkerSize|getMarkerType|getMass|getMissionConfig|getMissionConfigValue|getMissionDLCs|getMissionLayerEntities|getMissionLayers|getModelInfo|getMousePosition|getMusicPlayedTime|getNumber|getObjectArgument|getObjectChildren|getObjectDLC|getObjectMaterials|getObjectProxy|getObjectTextures|getObjectType|getObjectViewDistance|getOxygenRemaining|getPersonUsedDLCs|getPilotCameraDirection|getPilotCameraPosition|getPilotCameraRotation|getPilotCameraTarget|getPlateNumber|getPlayerChannel|getPlayerScores|getPlayerUID|getPlayerUIDOld|getPos|getPosASL|getPosASLVisual|getPosASLW|getPosATL|getPosATLVisual|getPosVisual|getPosWorld|getPylonMagazines|getRelDir|getRelPos|getRemoteSensorsDisabled|getRepairCargo|getResolution|getRotorBrakeRTD|getShadowDistance|getShotParents|getSlingLoad|getSoundController|getSoundControllerResult|getSpeed|getStamina|getStatValue|getSuppression|getTerrainGrid|getTerrainHeightASL|getText|getTotalDLCUsageTime|getTrimOffsetRTD|getUnitLoadout|getUnitTrait|getUserMFDText|getUserMFDValue|getVariable|getVehicleCargo|getWeaponCargo|getWeaponSway|getWingsOrientationRTD|getWingsPositionRTD|getWPPos|glanceAt|globalChat|globalRadio|goggles|group|groupChat|groupFromNetId|groupIconSelectable|groupIconsVisible|groupId|groupOwner|groupRadio|groupSelectedUnits|groupSelectUnit|grpNull|gunner|gusts|halt|handgunItems|handgunMagazine|handgunWeapon|handsHit|hasInterface|hasPilotCamera|hasWeapon|hcAllGroups|hcGroupParams|hcLeader|hcRemoveAllGroups|hcRemoveGroup|hcSelected|hcSelectGroup|hcSetGroup|hcShowBar|hcShownBar|headgear|hideBody|hideObject|hideObjectGlobal|hideSelection|hint|hintC|hintCadet|hintSilent|hmd|hostMission|htmlLoad|HUDMovementLevels|humidity|image|importAllGroups|importance|in|inArea|inAreaArray|incapacitatedState|independent|inflame|inflamed|infoPanel|infoPanelComponentEnabled|infoPanelComponents|infoPanels|inGameUISetEventHandler|inheritsFrom|initAmbientLife|inPolygon|inputAction|inRangeOfArtillery|insertEditorObject|intersect|is3DEN|is3DENMultiplayer|isAbleToBreathe|isAgent|isAimPrecisionEnabled|isArray|isAutoHoverOn|isAutonomous|isAutoStartUpEnabledRTD|isAutotest|isAutoTrimOnRTD|isBleeding|isBurning|isClass|isCollisionLightOn|isCopilotEnabled|isDamageAllowed|isDedicated|isDLCAvailable|isEngineOn|isEqualTo|isEqualType|isEqualTypeAll|isEqualTypeAny|isEqualTypeArray|isEqualTypeParams|isFilePatchingEnabled|isFlashlightOn|isFlatEmpty|isForcedWalk|isFormationLeader|isGroupDeletedWhenEmpty|isHidden|isInRemainsCollector|isInstructorFigureEnabled|isIRLaserOn|isKeyActive|isKindOf|isLaserOn|isLightOn|isLocalized|isManualFire|isMarkedForCollection|isMultiplayer|isMultiplayerSolo|isNil|isNull|isNumber|isObjectHidden|isObjectRTD|isOnRoad|isPipEnabled|isPlayer|isRealTime|isRemoteExecuted|isRemoteExecutedJIP|isServer|isShowing3DIcons|isSimpleObject|isSprintAllowed|isStaminaEnabled|isSteamMission|isStreamFriendlyUIEnabled|isStressDamageEnabled|isText|isTouchingGround|isTurnedOut|isTutHintsEnabled|isUAVConnectable|isUAVConnected|isUIContext|isUniformAllowed|isVehicleCargo|isVehicleRadarOn|isVehicleSensorEnabled|isWalking|isWeaponDeployed|isWeaponRested|itemCargo|items|itemsWithMagazines|join|joinAs|joinAsSilent|joinSilent|joinString|kbAddDatabase|kbAddDatabaseTargets|kbAddTopic|kbHasTopic|kbReact|kbRemoveTopic|kbTell|kbWasSaid|keyImage|keyName|knowsAbout|land|landAt|landResult|language|laserTarget|lbAdd|lbClear|lbColor|lbColorRight|lbCurSel|lbData|lbDelete|lbIsSelected|lbPicture|lbPictureRight|lbSelection|lbSetColor|lbSetColorRight|lbSetCurSel|lbSetData|lbSetPicture|lbSetPictureColor|lbSetPictureColorDisabled|lbSetPictureColorSelected|lbSetPictureRight|lbSetPictureRightColor|lbSetPictureRightColorDisabled|lbSetPictureRightColorSelected|lbSetSelectColor|lbSetSelectColorRight|lbSetSelected|lbSetText|lbSetTextRight|lbSetTooltip|lbSetValue|lbSize|lbSort|lbSortByValue|lbText|lbTextRight|lbValue|leader|leaderboardDeInit|leaderboardGetRows|leaderboardInit|leaderboardRequestRowsFriends|leaderboardRequestRowsGlobal|leaderboardRequestRowsGlobalAroundUser|leaderboardsRequestUploadScore|leaderboardsRequestUploadScoreKeepBest|leaderboardState|leaveVehicle|libraryCredits|libraryDisclaimers|lifeState|lightAttachObject|lightDetachObject|lightIsOn|lightnings|limitSpeed|linearConversion|lineBreak|lineIntersects|lineIntersectsObjs|lineIntersectsSurfaces|lineIntersectsWith|linkItem|list|listObjects|listRemoteTargets|listVehicleSensors|ln|lnbAddArray|lnbAddColumn|lnbAddRow|lnbClear|lnbColor|lnbColorRight|lnbCurSelRow|lnbData|lnbDeleteColumn|lnbDeleteRow|lnbGetColumnsPosition|lnbPicture|lnbPictureRight|lnbSetColor|lnbSetColorRight|lnbSetColumnsPos|lnbSetCurSelRow|lnbSetData|lnbSetPicture|lnbSetPictureColor|lnbSetPictureColorRight|lnbSetPictureColorSelected|lnbSetPictureColorSelectedRight|lnbSetPictureRight|lnbSetText|lnbSetTextRight|lnbSetValue|lnbSize|lnbSort|lnbSortByValue|lnbText|lnbTextRight|lnbValue|load|loadAbs|loadBackpack|loadFile|loadGame|loadIdentity|loadMagazine|loadOverlay|loadStatus|loadUniform|loadVest|local|localize|locationNull|locationPosition|lock|lockCameraTo|lockCargo|lockDriver|locked|lockedCargo|lockedDriver|lockedTurret|lockIdentity|lockTurret|lockWP|log|logEntities|logNetwork|logNetworkTerminate|lookAt|lookAtPos|magazineCargo|magazines|magazinesAllTurrets|magazinesAmmo|magazinesAmmoCargo|magazinesAmmoFull|magazinesDetail|magazinesDetailBackpack|magazinesDetailUniform|magazinesDetailVest|magazinesTurret|magazineTurretAmmo|mapAnimAdd|mapAnimClear|mapAnimCommit|mapAnimDone|mapCenterOnCamera|mapGridPosition|markAsFinishedOnSteam|markerAlpha|markerBrush|markerColor|markerDir|markerPos|markerShape|markerSize|markerText|markerType|max|members|menuAction|menuAdd|menuChecked|menuClear|menuCollapse|menuData|menuDelete|menuEnable|menuEnabled|menuExpand|menuHover|menuPicture|menuSetAction|menuSetCheck|menuSetData|menuSetPicture|menuSetValue|menuShortcut|menuShortcutText|menuSize|menuSort|menuText|menuURL|menuValue|min|mineActive|mineDetectedBy|missionConfigFile|missionDifficulty|missionName|missionNamespace|missionStart|missionVersion|modelToWorld|modelToWorldVisual|modelToWorldVisualWorld|modelToWorldWorld|modParams|moonIntensity|moonPhase|morale|move|move3DENCamera|moveInAny|moveInCargo|moveInCommander|moveInDriver|moveInGunner|moveInTurret|moveObjectToEnd|moveOut|moveTime|moveTo|moveToCompleted|moveToFailed|musicVolume|name|nameSound|nearEntities|nearestBuilding|nearestLocation|nearestLocations|nearestLocationWithDubbing|nearestObject|nearestObjects|nearestTerrainObjects|nearObjects|nearObjectsReady|nearRoads|nearSupplies|nearTargets|needReload|netId|netObjNull|newOverlay|nextMenuItemIndex|nextWeatherChange|nMenuItems|numberOfEnginesRTD|numberToDate|objectCurators|objectFromNetId|objectParent|objNull|objStatus|onBriefingGear|onBriefingGroup|onBriefingNotes|onBriefingPlan|onBriefingTeamSwitch|onCommandModeChanged|onDoubleClick|onEachFrame|onGroupIconClick|onGroupIconOverEnter|onGroupIconOverLeave|onHCGroupSelectionChanged|onMapSingleClick|onPlayerConnected|onPlayerDisconnected|onPreloadFinished|onPreloadStarted|onShowNewObject|onTeamSwitch|openCuratorInterface|openDLCPage|openDSInterface|openMap|openSteamApp|openYoutubeVideo|opfor|orderGetIn|overcast|overcastForecast|owner|param|params|parseNumber|parseSimpleArray|parseText|parsingNamespace|particlesQuality|pi|pickWeaponPool|pitch|pixelGrid|pixelGridBase|pixelGridNoUIScale|pixelH|pixelW|playableSlotsNumber|playableUnits|playAction|playActionNow|player|playerRespawnTime|playerSide|playersNumber|playGesture|playMission|playMove|playMoveNow|playMusic|playScriptedMission|playSound|playSound3D|position|positionCameraToWorld|posScreenToWorld|posWorldToScreen|ppEffectAdjust|ppEffectCommit|ppEffectCommitted|ppEffectCreate|ppEffectDestroy|ppEffectEnable|ppEffectEnabled|ppEffectForceInNVG|precision|preloadCamera|preloadObject|preloadSound|preloadTitleObj|preloadTitleRsc|primaryWeapon|primaryWeaponItems|primaryWeaponMagazine|priority|processDiaryLink|processInitCommands|productVersion|profileName|profileNamespace|profileNameSteam|progressLoadingScreen|progressPosition|progressSetPosition|publicVariable|publicVariableClient|publicVariableServer|pushBack|pushBackUnique|putWeaponPool|queryItemsPool|queryMagazinePool|queryWeaponPool|rad|radioChannelAdd|radioChannelCreate|radioChannelRemove|radioChannelSetCallSign|radioChannelSetLabel|radioVolume|rain|rainbow|random|rank|rankId|rating|rectangular|registeredTasks|registerTask|reload|reloadEnabled|remoteControl|remoteExec|remoteExecCall|remoteExecutedOwner|remove3DENConnection|remove3DENEventHandler|remove3DENLayer|removeAction|removeAll3DENEventHandlers|removeAllActions|removeAllAssignedItems|removeAllContainers|removeAllCuratorAddons|removeAllCuratorCameraAreas|removeAllCuratorEditingAreas|removeAllEventHandlers|removeAllHandgunItems|removeAllItems|removeAllItemsWithMagazines|removeAllMissionEventHandlers|removeAllMPEventHandlers|removeAllMusicEventHandlers|removeAllOwnedMines|removeAllPrimaryWeaponItems|removeAllWeapons|removeBackpack|removeBackpackGlobal|removeCuratorAddons|removeCuratorCameraArea|removeCuratorEditableObjects|removeCuratorEditingArea|removeDrawIcon|removeDrawLinks|removeEventHandler|removeFromRemainsCollector|removeGoggles|removeGroupIcon|removeHandgunItem|removeHeadgear|removeItem|removeItemFromBackpack|removeItemFromUniform|removeItemFromVest|removeItems|removeMagazine|removeMagazineGlobal|removeMagazines|removeMagazinesTurret|removeMagazineTurret|removeMenuItem|removeMissionEventHandler|removeMPEventHandler|removeMusicEventHandler|removeOwnedMine|removePrimaryWeaponItem|removeSecondaryWeaponItem|removeSimpleTask|removeSwitchableUnit|removeTeamMember|removeUniform|removeVest|removeWeapon|removeWeaponAttachmentCargo|removeWeaponCargo|removeWeaponGlobal|removeWeaponTurret|reportRemoteTarget|requiredVersion|resetCamShake|resetSubgroupDirection|resistance|resize|resources|respawnVehicle|restartEditorCamera|reveal|revealMine|reverse|reversedMouseY|roadAt|roadsConnectedTo|roleDescription|ropeAttachedObjects|ropeAttachedTo|ropeAttachEnabled|ropeAttachTo|ropeCreate|ropeCut|ropeDestroy|ropeDetach|ropeEndPosition|ropeLength|ropes|ropeUnwind|ropeUnwound|rotorsForcesRTD|rotorsRpmRTD|round|runInitScript|safeZoneH|safeZoneW|safeZoneWAbs|safeZoneX|safeZoneXAbs|safeZoneY|save3DENInventory|saveGame|saveIdentity|saveJoysticks|saveOverlay|saveProfileNamespace|saveStatus|saveVar|savingEnabled|say|say2D|say3D|score|scoreSide|screenshot|screenToWorld|scriptDone|scriptName|scriptNull|scudState|secondaryWeapon|secondaryWeaponItems|secondaryWeaponMagazine|select|selectBestPlaces|selectDiarySubject|selectedEditorObjects|selectEditorObject|selectionNames|selectionPosition|selectLeader|selectMax|selectMin|selectNoPlayer|selectPlayer|selectRandom|selectRandomWeighted|selectWeapon|selectWeaponTurret|sendAUMessage|sendSimpleCommand|sendTask|sendTaskResult|sendUDPMessage|serverCommand|serverCommandAvailable|serverCommandExecutable|serverName|serverTime|set|set3DENAttribute|set3DENAttributes|set3DENGrid|set3DENIconsVisible|set3DENLayer|set3DENLinesVisible|set3DENLogicType|set3DENMissionAttribute|set3DENMissionAttributes|set3DENModelsVisible|set3DENObjectType|set3DENSelected|setAccTime|setActualCollectiveRTD|setAirplaneThrottle|setAirportSide|setAmmo|setAmmoCargo|setAmmoOnPylon|setAnimSpeedCoef|setAperture|setApertureNew|setArmoryPoints|setAttributes|setAutonomous|setBehaviour|setBleedingRemaining|setBrakesRTD|setCameraInterest|setCamShakeDefParams|setCamShakeParams|setCamUseTI|setCaptive|setCenterOfMass|setCollisionLight|setCombatMode|setCompassOscillation|setConvoySeparation|setCuratorCameraAreaCeiling|setCuratorCoef|setCuratorEditingAreaType|setCuratorWaypointCost|setCurrentChannel|setCurrentTask|setCurrentWaypoint|setCustomAimCoef|setCustomWeightRTD|setDamage|setDammage|setDate|setDebriefingText|setDefaultCamera|setDestination|setDetailMapBlendPars|setDir|setDirection|setDrawIcon|setDriveOnPath|setDropInterval|setDynamicSimulationDistance|setDynamicSimulationDistanceCoef|setEditorMode|setEditorObjectScope|setEffectCondition|setEngineRpmRTD|setFace|setFaceAnimation|setFatigue|setFeatureType|setFlagAnimationPhase|setFlagOwner|setFlagSide|setFlagTexture|setFog|setForceGeneratorRTD|setFormation|setFormationTask|setFormDir|setFriend|setFromEditor|setFSMVariable|setFuel|setFuelCargo|setGroupIcon|setGroupIconParams|setGroupIconsSelectable|setGroupIconsVisible|setGroupId|setGroupIdGlobal|setGroupOwner|setGusts|setHideBehind|setHit|setHitIndex|setHitPointDamage|setHorizonParallaxCoef|setHUDMovementLevels|setIdentity|setImportance|setInfoPanel|setLeader|setLightAmbient|setLightAttenuation|setLightBrightness|setLightColor|setLightDayLight|setLightFlareMaxDistance|setLightFlareSize|setLightIntensity|setLightnings|setLightUseFlare|setLocalWindParams|setMagazineTurretAmmo|setMarkerAlpha|setMarkerAlphaLocal|setMarkerBrush|setMarkerBrushLocal|setMarkerColor|setMarkerColorLocal|setMarkerDir|setMarkerDirLocal|setMarkerPos|setMarkerPosLocal|setMarkerShape|setMarkerShapeLocal|setMarkerSize|setMarkerSizeLocal|setMarkerText|setMarkerTextLocal|setMarkerType|setMarkerTypeLocal|setMass|setMimic|setMousePosition|setMusicEffect|setMusicEventHandler|setName|setNameSound|setObjectArguments|setObjectMaterial|setObjectMaterialGlobal|setObjectProxy|setObjectTexture|setObjectTextureGlobal|setObjectViewDistance|setOvercast|setOwner|setOxygenRemaining|setParticleCircle|setParticleClass|setParticleFire|setParticleParams|setParticleRandom|setPilotCameraDirection|setPilotCameraRotation|setPilotCameraTarget|setPilotLight|setPiPEffect|setPitch|setPlateNumber|setPlayable|setPlayerRespawnTime|setPos|setPosASL|setPosASL2|setPosASLW|setPosATL|setPosition|setPosWorld|setPylonLoadOut|setPylonsPriority|setRadioMsg|setRain|setRainbow|setRandomLip|setRank|setRectangular|setRepairCargo|setRotorBrakeRTD|setShadowDistance|setShotParents|setSide|setSimpleTaskAlwaysVisible|setSimpleTaskCustomData|setSimpleTaskDescription|setSimpleTaskDestination|setSimpleTaskTarget|setSimpleTaskType|setSimulWeatherLayers|setSize|setSkill|setSlingLoad|setSoundEffect|setSpeaker|setSpeech|setSpeedMode|setStamina|setStaminaScheme|setStatValue|setSuppression|setSystemOfUnits|setTargetAge|setTaskMarkerOffset|setTaskResult|setTaskState|setTerrainGrid|setText|setTimeMultiplier|setTitleEffect|setToneMapping|setToneMappingParams|setTrafficDensity|setTrafficDistance|setTrafficGap|setTrafficSpeed|setTriggerActivation|setTriggerArea|setTriggerStatements|setTriggerText|setTriggerTimeout|setTriggerType|setType|setUnconscious|setUnitAbility|setUnitLoadout|setUnitPos|setUnitPosWeak|setUnitRank|setUnitRecoilCoefficient|setUnitTrait|setUnloadInCombat|setUserActionText|setUserMFDText|setUserMFDValue|setVariable|setVectorDir|setVectorDirAndUp|setVectorUp|setVehicleAmmo|setVehicleAmmoDef|setVehicleArmor|setVehicleCargo|setVehicleId|setVehicleInit|setVehicleLock|setVehiclePosition|setVehicleRadar|setVehicleReceiveRemoteTargets|setVehicleReportOwnPosition|setVehicleReportRemoteTargets|setVehicleTIPars|setVehicleVarName|setVelocity|setVelocityModelSpace|setVelocityTransformation|setViewDistance|setVisibleIfTreeCollapsed|setWantedRpmRTD|setWaves|setWaypointBehaviour|setWaypointCombatMode|setWaypointCompletionRadius|setWaypointDescription|setWaypointForceBehaviour|setWaypointFormation|setWaypointHousePosition|setWaypointLoiterRadius|setWaypointLoiterType|setWaypointName|setWaypointPosition|setWaypointScript|setWaypointSpeed|setWaypointStatements|setWaypointTimeout|setWaypointType|setWaypointVisible|setWeaponReloadingTime|setWind|setWindDir|setWindForce|setWindStr|setWingForceScaleRTD|setWPPos|show3DIcons|showChat|showCinemaBorder|showCommandingMenu|showCompass|showCuratorCompass|showGPS|showHUD|showLegend|showMap|shownArtilleryComputer|shownChat|shownCompass|shownCuratorCompass|showNewEditorObject|shownGPS|shownHUD|shownMap|shownPad|shownRadio|shownScoretable|shownUAVFeed|shownWarrant|shownWatch|showPad|showRadio|showScoretable|showSubtitles|showUAVFeed|showWarrant|showWatch|showWaypoint|showWaypoints|side|sideAmbientLife|sideChat|sideEmpty|sideEnemy|sideFriendly|sideLogic|sideRadio|sideUnknown|simpleTasks|simulationEnabled|simulCloudDensity|simulCloudOcclusion|simulInClouds|simulWeatherSync|sin|size|sizeOf|skill|skillFinal|skipTime|sleep|sliderPosition|sliderRange|sliderSetPosition|sliderSetRange|sliderSetSpeed|sliderSpeed|slingLoadAssistantShown|soldierMagazines|someAmmo|sort|soundVolume|speaker|speed|speedMode|splitString|sqrt|squadParams|stance|startLoadingScreen|stop|stopEngineRTD|stopped|str|sunOrMoon|supportInfo|suppressFor|surfaceIsWater|surfaceNormal|surfaceType|swimInDepth|switchableUnits|switchAction|switchCamera|switchGesture|switchLight|switchMove|synchronizedObjects|synchronizedTriggers|synchronizedWaypoints|synchronizeObjectsAdd|synchronizeObjectsRemove|synchronizeTrigger|synchronizeWaypoint|systemChat|systemOfUnits|tan|targetKnowledge|targets|targetsAggregate|targetsQuery|taskAlwaysVisible|taskChildren|taskCompleted|taskCustomData|taskDescription|taskDestination|taskHint|taskMarkerOffset|taskNull|taskParent|taskResult|taskState|taskType|teamMember|teamMemberNull|teamName|teams|teamSwitch|teamSwitchEnabled|teamType|terminate|terrainIntersect|terrainIntersectASL|terrainIntersectAtASL|text|textLog|textLogFormat|tg|time|timeMultiplier|titleCut|titleFadeOut|titleObj|titleRsc|titleText|toArray|toFixed|toLower|toString|toUpper|triggerActivated|triggerActivation|triggerArea|triggerAttachedVehicle|triggerAttachObject|triggerAttachVehicle|triggerDynamicSimulation|triggerStatements|triggerText|triggerTimeout|triggerTimeoutCurrent|triggerType|turretLocal|turretOwner|turretUnit|tvAdd|tvClear|tvCollapse|tvCollapseAll|tvCount|tvCurSel|tvData|tvDelete|tvExpand|tvExpandAll|tvPicture|tvPictureRight|tvSetColor|tvSetCurSel|tvSetData|tvSetPicture|tvSetPictureColor|tvSetPictureColorDisabled|tvSetPictureColorSelected|tvSetPictureRight|tvSetPictureRightColor|tvSetPictureRightColorDisabled|tvSetPictureRightColorSelected|tvSetSelectColor|tvSetText|tvSetTooltip|tvSetValue|tvSort|tvSortByValue|tvText|tvTooltip|tvValue|type|typeName|typeOf|UAVControl|uiNamespace|uiSleep|unassignCurator|unassignItem|unassignTeam|unassignVehicle|underwater|uniform|uniformContainer|uniformItems|uniformMagazines|unitAddons|unitAimPosition|unitAimPositionVisual|unitBackpack|unitIsUAV|unitPos|unitReady|unitRecoilCoefficient|units|unitsBelowHeight|unlinkItem|unlockAchievement|unregisterTask|updateDrawIcon|updateMenuItem|updateObjectTree|useAIOperMapObstructionTest|useAISteeringComponent|useAudioTimeForMoves|userInputDisabled|vectorAdd|vectorCos|vectorCrossProduct|vectorDiff|vectorDir|vectorDirVisual|vectorDistance|vectorDistanceSqr|vectorDotProduct|vectorFromTo|vectorMagnitude|vectorMagnitudeSqr|vectorModelToWorld|vectorModelToWorldVisual|vectorMultiply|vectorNormalized|vectorUp|vectorUpVisual|vectorWorldToModel|vectorWorldToModelVisual|vehicle|vehicleCargoEnabled|vehicleChat|vehicleRadio|vehicleReceiveRemoteTargets|vehicleReportOwnPosition|vehicleReportRemoteTargets|vehicles|vehicleVarName|velocity|velocityModelSpace|verifySignature|vest|vestContainer|vestItems|vestMagazines|viewDistance|visibleCompass|visibleGPS|visibleMap|visiblePosition|visiblePositionASL|visibleScoretable|visibleWatch|waitUntil|waves|waypointAttachedObject|waypointAttachedVehicle|waypointAttachObject|waypointAttachVehicle|waypointBehaviour|waypointCombatMode|waypointCompletionRadius|waypointDescription|waypointForceBehaviour|waypointFormation|waypointHousePosition|waypointLoiterRadius|waypointLoiterType|waypointName|waypointPosition|waypoints|waypointScript|waypointsEnabledUAV|waypointShow|waypointSpeed|waypointStatements|waypointTimeout|waypointTimeoutCurrent|waypointType|waypointVisible|weaponAccessories|weaponAccessoriesCargo|weaponCargo|weaponDirection|weaponInertia|weaponLowered|weapons|weaponsItems|weaponsItemsCargo|weaponState|weaponsTurret|weightRTD|west|WFSideText|wind|windDir|windRTD|windStr|wingsForcesRTD|worldName|worldSize|worldToModel|worldToModelVisual|worldToScreen)\b/i,
        number: /(?:\$|\b0x)[\da-f]+\b|(?:\B\.\d+|\b\d+(?:\.\d+)?)(?:e[+-]?\d+)?\b/i,
        operator: /##|>>|&&|\|\||[!=<>]=?|[-+*/%#^]|\b(?:and|mod|not|or)\b/i,
        'magic-variable': {
            pattern: /\b(?:this|thisList|thisTrigger|_exception|_fnc_scriptName|_fnc_scriptNameParent|_forEachIndex|_this|_thisEventHandler|_thisFSM|_thisScript|_x)\b/i,
            alias: 'keyword'
        },
        constant: /\bDIK(?:_[a-z\d]+)+\b/i
    });
    Prism.languages.insertBefore('sqf', 'string', {
        macro: {
            pattern: /(^[ \t]*)#[a-z](?:[^\r\n\\]|\\(?:\r\n|[\s\S]))*/im,
            lookbehind: true,
            greedy: true,
            alias: 'property',
            inside: {
                directive: {
                    pattern: /#[a-z]+\b/i,
                    alias: 'keyword'
                },
                comment: Prism.languages.sqf.comment
            }
        }
    });
    delete Prism.languages.sqf['class-name'];
}

});

parcelRegister("91KrN", function(module, exports) {
'use strict';
module.exports = $69283c874f050b5d$var$squirrel;
$69283c874f050b5d$var$squirrel.displayName = 'squirrel';
$69283c874f050b5d$var$squirrel.aliases = [];
function $69283c874f050b5d$var$squirrel(Prism) {
    Prism.languages.squirrel = Prism.languages.extend('clike', {
        comment: [
            Prism.languages.clike['comment'][0],
            {
                pattern: /(^|[^\\:])(?:\/\/|#).*/,
                lookbehind: true,
                greedy: true
            }
        ],
        string: {
            pattern: /(^|[^\\"'@])(?:@"(?:[^"]|"")*"(?!")|"(?:[^\\\r\n"]|\\.)*")/,
            lookbehind: true,
            greedy: true
        },
        'class-name': {
            pattern: /(\b(?:class|enum|extends|instanceof)\s+)\w+(?:\.\w+)*/,
            lookbehind: true,
            inside: {
                punctuation: /\./
            }
        },
        keyword: /\b(?:__FILE__|__LINE__|base|break|case|catch|class|clone|const|constructor|continue|default|delete|else|enum|extends|for|foreach|function|if|in|instanceof|local|null|resume|return|static|switch|this|throw|try|typeof|while|yield)\b/,
        number: /\b(?:0x[0-9a-fA-F]+|\d+(?:\.(?:\d+|[eE][+-]?\d+))?)\b/,
        operator: /\+\+|--|<=>|<[-<]|>>>?|&&?|\|\|?|[-+*/%!=<>]=?|[~^]|::?/,
        punctuation: /[(){}\[\],;.]/
    });
    Prism.languages.insertBefore('squirrel', 'string', {
        char: {
            pattern: /(^|[^\\"'])'(?:[^\\']|\\(?:[xuU][0-9a-fA-F]{0,8}|[\s\S]))'/,
            lookbehind: true,
            greedy: true
        }
    });
    Prism.languages.insertBefore('squirrel', 'operator', {
        'attribute-punctuation': {
            pattern: /<\/|\/>/,
            alias: 'important'
        },
        lambda: {
            pattern: /@(?=\()/,
            alias: 'operator'
        }
    });
}

});

parcelRegister("Vrj3c", function(module, exports) {
'use strict';
module.exports = $0aca817137d98b02$var$stan;
$0aca817137d98b02$var$stan.displayName = 'stan';
$0aca817137d98b02$var$stan.aliases = [];
function $0aca817137d98b02$var$stan(Prism) {
    (function(Prism) {
        // https://mc-stan.org/docs/2_28/reference-manual/bnf-grammars.html
        var higherOrderFunctions = /\b(?:algebra_solver|algebra_solver_newton|integrate_1d|integrate_ode|integrate_ode_bdf|integrate_ode_rk45|map_rect|ode_(?:adams|bdf|ckrk|rk45)(?:_tol)?|ode_adjoint_tol_ctl|reduce_sum|reduce_sum_static)\b/;
        Prism.languages.stan = {
            comment: /\/\/.*|\/\*[\s\S]*?\*\/|#(?!include).*/,
            string: {
                // String literals can contain spaces and any printable ASCII characters except for " and \
                // https://mc-stan.org/docs/2_24/reference-manual/print-statements-section.html#string-literals
                pattern: /"[\x20\x21\x23-\x5B\x5D-\x7E]*"/,
                greedy: true
            },
            directive: {
                pattern: /^([ \t]*)#include\b.*/m,
                lookbehind: true,
                alias: 'property'
            },
            'function-arg': {
                pattern: RegExp('(' + higherOrderFunctions.source + /\s*\(\s*/.source + ')' + /[a-zA-Z]\w*/.source),
                lookbehind: true,
                alias: 'function'
            },
            constraint: {
                pattern: /(\b(?:int|matrix|real|row_vector|vector)\s*)<[^<>]*>/,
                lookbehind: true,
                inside: {
                    expression: {
                        pattern: /(=\s*)\S(?:\S|\s+(?!\s))*?(?=\s*(?:>$|,\s*\w+\s*=))/,
                        lookbehind: true,
                        inside: null // see below
                    },
                    property: /\b[a-z]\w*(?=\s*=)/i,
                    operator: /=/,
                    punctuation: /^<|>$|,/
                }
            },
            keyword: [
                {
                    pattern: /\bdata(?=\s*\{)|\b(?:functions|generated|model|parameters|quantities|transformed)\b/,
                    alias: 'program-block'
                },
                /\b(?:array|break|cholesky_factor_corr|cholesky_factor_cov|complex|continue|corr_matrix|cov_matrix|data|else|for|if|in|increment_log_prob|int|matrix|ordered|positive_ordered|print|real|reject|return|row_vector|simplex|target|unit_vector|vector|void|while)\b/,
                higherOrderFunctions
            ],
            function: /\b[a-z]\w*(?=\s*\()/i,
            number: /(?:\b\d+(?:_\d+)*(?:\.(?:\d+(?:_\d+)*)?)?|\B\.\d+(?:_\d+)*)(?:E[+-]?\d+(?:_\d+)*)?i?(?!\w)/i,
            boolean: /\b(?:false|true)\b/,
            operator: /<-|\.[*/]=?|\|\|?|&&|[!=<>+\-*/]=?|['^%~?:]/,
            punctuation: /[()\[\]{},;]/
        };
        Prism.languages.stan.constraint.inside.expression.inside = Prism.languages.stan;
    })(Prism);
}

});

parcelRegister("eIUn7", function(module, exports) {
'use strict';
module.exports = $ab80e70a8154e4ef$var$stylus;
$ab80e70a8154e4ef$var$stylus.displayName = 'stylus';
$ab80e70a8154e4ef$var$stylus.aliases = [];
function $ab80e70a8154e4ef$var$stylus(Prism) {
    (function(Prism) {
        var unit = {
            pattern: /(\b\d+)(?:%|[a-z]+)/,
            lookbehind: true
        } // 123 -123 .123 -.123 12.3 -12.3
        ;
        var number = {
            pattern: /(^|[^\w.-])-?(?:\d+(?:\.\d+)?|\.\d+)/,
            lookbehind: true
        };
        var inside = {
            comment: {
                pattern: /(^|[^\\])(?:\/\*[\s\S]*?\*\/|\/\/.*)/,
                lookbehind: true
            },
            url: {
                pattern: /\burl\((["']?).*?\1\)/i,
                greedy: true
            },
            string: {
                pattern: /("|')(?:(?!\1)[^\\\r\n]|\\(?:\r\n|[\s\S]))*\1/,
                greedy: true
            },
            interpolation: null,
            // See below
            func: null,
            // See below
            important: /\B!(?:important|optional)\b/i,
            keyword: {
                pattern: /(^|\s+)(?:(?:else|for|if|return|unless)(?=\s|$)|@[\w-]+)/,
                lookbehind: true
            },
            hexcode: /#[\da-f]{3,6}/i,
            color: [
                /\b(?:AliceBlue|AntiqueWhite|Aqua|Aquamarine|Azure|Beige|Bisque|Black|BlanchedAlmond|Blue|BlueViolet|Brown|BurlyWood|CadetBlue|Chartreuse|Chocolate|Coral|CornflowerBlue|Cornsilk|Crimson|Cyan|DarkBlue|DarkCyan|DarkGoldenRod|DarkGr[ae]y|DarkGreen|DarkKhaki|DarkMagenta|DarkOliveGreen|DarkOrange|DarkOrchid|DarkRed|DarkSalmon|DarkSeaGreen|DarkSlateBlue|DarkSlateGr[ae]y|DarkTurquoise|DarkViolet|DeepPink|DeepSkyBlue|DimGr[ae]y|DodgerBlue|FireBrick|FloralWhite|ForestGreen|Fuchsia|Gainsboro|GhostWhite|Gold|GoldenRod|Gr[ae]y|Green|GreenYellow|HoneyDew|HotPink|IndianRed|Indigo|Ivory|Khaki|Lavender|LavenderBlush|LawnGreen|LemonChiffon|LightBlue|LightCoral|LightCyan|LightGoldenRodYellow|LightGr[ae]y|LightGreen|LightPink|LightSalmon|LightSeaGreen|LightSkyBlue|LightSlateGr[ae]y|LightSteelBlue|LightYellow|Lime|LimeGreen|Linen|Magenta|Maroon|MediumAquaMarine|MediumBlue|MediumOrchid|MediumPurple|MediumSeaGreen|MediumSlateBlue|MediumSpringGreen|MediumTurquoise|MediumVioletRed|MidnightBlue|MintCream|MistyRose|Moccasin|NavajoWhite|Navy|OldLace|Olive|OliveDrab|Orange|OrangeRed|Orchid|PaleGoldenRod|PaleGreen|PaleTurquoise|PaleVioletRed|PapayaWhip|PeachPuff|Peru|Pink|Plum|PowderBlue|Purple|Red|RosyBrown|RoyalBlue|SaddleBrown|Salmon|SandyBrown|SeaGreen|SeaShell|Sienna|Silver|SkyBlue|SlateBlue|SlateGr[ae]y|Snow|SpringGreen|SteelBlue|Tan|Teal|Thistle|Tomato|Transparent|Turquoise|Violet|Wheat|White|WhiteSmoke|Yellow|YellowGreen)\b/i,
                {
                    pattern: /\b(?:hsl|rgb)\(\s*\d{1,3}\s*,\s*\d{1,3}%?\s*,\s*\d{1,3}%?\s*\)\B|\b(?:hsl|rgb)a\(\s*\d{1,3}\s*,\s*\d{1,3}%?\s*,\s*\d{1,3}%?\s*,\s*(?:0|0?\.\d+|1)\s*\)\B/i,
                    inside: {
                        unit: unit,
                        number: number,
                        function: /[\w-]+(?=\()/,
                        punctuation: /[(),]/
                    }
                }
            ],
            entity: /\\[\da-f]{1,8}/i,
            unit: unit,
            boolean: /\b(?:false|true)\b/,
            operator: [
                // We want non-word chars around "-" because it is
                // accepted in property names.
                /~|[+!\/%<>?=]=?|[-:]=|\*[*=]?|\.{2,3}|&&|\|\||\B-\B|\b(?:and|in|is(?: a| defined| not|nt)?|not|or)\b/
            ],
            number: number,
            punctuation: /[{}()\[\];:,]/
        };
        inside['interpolation'] = {
            pattern: /\{[^\r\n}:]+\}/,
            alias: 'variable',
            inside: {
                delimiter: {
                    pattern: /^\{|\}$/,
                    alias: 'punctuation'
                },
                rest: inside
            }
        };
        inside['func'] = {
            pattern: /[\w-]+\([^)]*\).*/,
            inside: {
                function: /^[^(]+/,
                rest: inside
            }
        };
        Prism.languages.stylus = {
            'atrule-declaration': {
                pattern: /(^[ \t]*)@.+/m,
                lookbehind: true,
                inside: {
                    atrule: /^@[\w-]+/,
                    rest: inside
                }
            },
            'variable-declaration': {
                pattern: /(^[ \t]*)[\w$-]+\s*.?=[ \t]*(?:\{[^{}]*\}|\S.*|$)/m,
                lookbehind: true,
                inside: {
                    variable: /^\S+/,
                    rest: inside
                }
            },
            statement: {
                pattern: /(^[ \t]*)(?:else|for|if|return|unless)[ \t].+/m,
                lookbehind: true,
                inside: {
                    keyword: /^\S+/,
                    rest: inside
                }
            },
            // A property/value pair cannot end with a comma or a brace
            // It cannot have indented content unless it ended with a semicolon
            'property-declaration': {
                pattern: /((?:^|\{)([ \t]*))(?:[\w-]|\{[^}\r\n]+\})+(?:\s*:\s*|[ \t]+)(?!\s)[^{\r\n]*(?:;|[^{\r\n,]$(?!(?:\r?\n|\r)(?:\{|\2[ \t])))/m,
                lookbehind: true,
                inside: {
                    property: {
                        pattern: /^[^\s:]+/,
                        inside: {
                            interpolation: inside.interpolation
                        }
                    },
                    rest: inside
                }
            },
            // A selector can contain parentheses only as part of a pseudo-element
            // It can span multiple lines.
            // It must end with a comma or an accolade or have indented content.
            selector: {
                pattern: /(^[ \t]*)(?:(?=\S)(?:[^{}\r\n:()]|::?[\w-]+(?:\([^)\r\n]*\)|(?![\w-]))|\{[^}\r\n]+\})+)(?:(?:\r?\n|\r)(?:\1(?:(?=\S)(?:[^{}\r\n:()]|::?[\w-]+(?:\([^)\r\n]*\)|(?![\w-]))|\{[^}\r\n]+\})+)))*(?:,$|\{|(?=(?:\r?\n|\r)(?:\{|\1[ \t])))/m,
                lookbehind: true,
                inside: {
                    interpolation: inside.interpolation,
                    comment: inside.comment,
                    punctuation: /[{},]/
                }
            },
            func: inside.func,
            string: inside.string,
            comment: {
                pattern: /(^|[^\\])(?:\/\*[\s\S]*?\*\/|\/\/.*)/,
                lookbehind: true,
                greedy: true
            },
            interpolation: inside.interpolation,
            punctuation: /[{}()\[\];:.]/
        };
    })(Prism);
}

});

parcelRegister("1KspJ", function(module, exports) {
'use strict';
module.exports = $146020c0d4eab090$var$swift;
$146020c0d4eab090$var$swift.displayName = 'swift';
$146020c0d4eab090$var$swift.aliases = [];
function $146020c0d4eab090$var$swift(Prism) {
    Prism.languages.swift = {
        comment: {
            // Nested comments are supported up to 2 levels
            pattern: /(^|[^\\:])(?:\/\/.*|\/\*(?:[^/*]|\/(?!\*)|\*(?!\/)|\/\*(?:[^*]|\*(?!\/))*\*\/)*\*\/)/,
            lookbehind: true,
            greedy: true
        },
        'string-literal': [
            // https://docs.swift.org/swift-book/LanguageGuide/StringsAndCharacters.html
            {
                pattern: RegExp(/(^|[^"#])/.source + '(?:' + // single-line string
                /"(?:\\(?:\((?:[^()]|\([^()]*\))*\)|\r\n|[^(])|[^\\\r\n"])*"/.source + '|' + // multi-line string
                /"""(?:\\(?:\((?:[^()]|\([^()]*\))*\)|[^(])|[^\\"]|"(?!""))*"""/.source + ')' + /(?!["#])/.source),
                lookbehind: true,
                greedy: true,
                inside: {
                    interpolation: {
                        pattern: /(\\\()(?:[^()]|\([^()]*\))*(?=\))/,
                        lookbehind: true,
                        inside: null // see below
                    },
                    'interpolation-punctuation': {
                        pattern: /^\)|\\\($/,
                        alias: 'punctuation'
                    },
                    punctuation: /\\(?=[\r\n])/,
                    string: /[\s\S]+/
                }
            },
            {
                pattern: RegExp(/(^|[^"#])(#+)/.source + '(?:' + // single-line string
                /"(?:\\(?:#+\((?:[^()]|\([^()]*\))*\)|\r\n|[^#])|[^\\\r\n])*?"/.source + '|' + // multi-line string
                /"""(?:\\(?:#+\((?:[^()]|\([^()]*\))*\)|[^#])|[^\\])*?"""/.source + ')' + '\\2'),
                lookbehind: true,
                greedy: true,
                inside: {
                    interpolation: {
                        pattern: /(\\#+\()(?:[^()]|\([^()]*\))*(?=\))/,
                        lookbehind: true,
                        inside: null // see below
                    },
                    'interpolation-punctuation': {
                        pattern: /^\)|\\#+\($/,
                        alias: 'punctuation'
                    },
                    string: /[\s\S]+/
                }
            }
        ],
        directive: {
            // directives with conditions
            pattern: RegExp(/#/.source + '(?:' + (/(?:elseif|if)\b/.source + '(?:[ \t]*' + // This regex is a little complex. It's equivalent to this:
            //   (?:![ \t]*)?(?:\b\w+\b(?:[ \t]*<round>)?|<round>)(?:[ \t]*(?:&&|\|\|))?
            // where <round> is a general parentheses expression.
            /(?:![ \t]*)?(?:\b\w+\b(?:[ \t]*\((?:[^()]|\([^()]*\))*\))?|\((?:[^()]|\([^()]*\))*\))(?:[ \t]*(?:&&|\|\|))?/.source + ')+') + '|' + /(?:else|endif)\b/.source + ')'),
            alias: 'property',
            inside: {
                'directive-name': /^#\w+/,
                boolean: /\b(?:false|true)\b/,
                number: /\b\d+(?:\.\d+)*\b/,
                operator: /!|&&|\|\||[<>]=?/,
                punctuation: /[(),]/
            }
        },
        literal: {
            pattern: /#(?:colorLiteral|column|dsohandle|file(?:ID|Literal|Path)?|function|imageLiteral|line)\b/,
            alias: 'constant'
        },
        'other-directive': {
            pattern: /#\w+\b/,
            alias: 'property'
        },
        attribute: {
            pattern: /@\w+/,
            alias: 'atrule'
        },
        'function-definition': {
            pattern: /(\bfunc\s+)\w+/,
            lookbehind: true,
            alias: 'function'
        },
        label: {
            // https://docs.swift.org/swift-book/LanguageGuide/ControlFlow.html#ID141
            pattern: /\b(break|continue)\s+\w+|\b[a-zA-Z_]\w*(?=\s*:\s*(?:for|repeat|while)\b)/,
            lookbehind: true,
            alias: 'important'
        },
        keyword: /\b(?:Any|Protocol|Self|Type|actor|as|assignment|associatedtype|associativity|async|await|break|case|catch|class|continue|convenience|default|defer|deinit|didSet|do|dynamic|else|enum|extension|fallthrough|fileprivate|final|for|func|get|guard|higherThan|if|import|in|indirect|infix|init|inout|internal|is|isolated|lazy|left|let|lowerThan|mutating|none|nonisolated|nonmutating|open|operator|optional|override|postfix|precedencegroup|prefix|private|protocol|public|repeat|required|rethrows|return|right|safe|self|set|some|static|struct|subscript|super|switch|throw|throws|try|typealias|unowned|unsafe|var|weak|where|while|willSet)\b/,
        boolean: /\b(?:false|true)\b/,
        nil: {
            pattern: /\bnil\b/,
            alias: 'constant'
        },
        'short-argument': /\$\d+\b/,
        omit: {
            pattern: /\b_\b/,
            alias: 'keyword'
        },
        number: /\b(?:[\d_]+(?:\.[\de_]+)?|0x[a-f0-9_]+(?:\.[a-f0-9p_]+)?|0b[01_]+|0o[0-7_]+)\b/i,
        // A class name must start with an upper-case letter and be either 1 letter long or contain a lower-case letter.
        'class-name': /\b[A-Z](?:[A-Z_\d]*[a-z]\w*)?\b/,
        function: /\b[a-z_]\w*(?=\s*\()/i,
        constant: /\b(?:[A-Z_]{2,}|k[A-Z][A-Za-z_]+)\b/,
        // Operators are generic in Swift. Developers can even create new operators (e.g. +++).
        // https://docs.swift.org/swift-book/ReferenceManual/zzSummaryOfTheGrammar.html#ID481
        // This regex only supports ASCII operators.
        operator: /[-+*/%=!<>&|^~?]+|\.[.\-+*/%=!<>&|^~?]+/,
        punctuation: /[{}[\]();,.:\\]/
    };
    Prism.languages.swift['string-literal'].forEach(function(rule) {
        rule.inside['interpolation'].inside = Prism.languages.swift;
    });
}

});

parcelRegister("305RV", function(module, exports) {
'use strict';
module.exports = $22f5ec9a014925e3$var$systemd;
$22f5ec9a014925e3$var$systemd.displayName = 'systemd';
$22f5ec9a014925e3$var$systemd.aliases = [];
function $22f5ec9a014925e3$var$systemd(Prism) {
    (function(Prism) {
        var comment = {
            pattern: /^[;#].*/m,
            greedy: true
        };
        var quotesSource = /"(?:[^\r\n"\\]|\\(?:[^\r]|\r\n?))*"(?!\S)/.source;
        Prism.languages.systemd = {
            comment: comment,
            section: {
                pattern: /^\[[^\n\r\[\]]*\](?=[ \t]*$)/m,
                greedy: true,
                inside: {
                    punctuation: /^\[|\]$/,
                    'section-name': {
                        pattern: /[\s\S]+/,
                        alias: 'selector'
                    }
                }
            },
            key: {
                pattern: /^[^\s=]+(?=[ \t]*=)/m,
                greedy: true,
                alias: 'attr-name'
            },
            value: {
                // This pattern is quite complex because of two properties:
                //  1) Quotes (strings) must be preceded by a space. Since we can't use lookbehinds, we have to "resolve"
                //     the lookbehind. You will see this in the main loop where spaces are handled separately.
                //  2) Line continuations.
                //     After line continuations, empty lines and comments are ignored so we have to consume them.
                pattern: RegExp(/(=[ \t]*(?!\s))/.source + // the value either starts with quotes or not
                '(?:' + quotesSource + '|(?=[^"\r\n]))' + // main loop
                '(?:' + (/[^\s\\]/.source + // handle spaces separately because of quotes
                '|' + '[ \t]+(?:(?![ \t"])|' + quotesSource + ')' + // line continuation
                '|' + /\\[\r\n]+(?:[#;].*[\r\n]+)*(?![#;])/.source) + ')*'),
                lookbehind: true,
                greedy: true,
                alias: 'attr-value',
                inside: {
                    comment: comment,
                    quoted: {
                        pattern: RegExp(/(^|\s)/.source + quotesSource),
                        lookbehind: true,
                        greedy: true
                    },
                    punctuation: /\\$/m,
                    boolean: {
                        pattern: /^(?:false|no|off|on|true|yes)$/,
                        greedy: true
                    }
                }
            },
            punctuation: /=/
        };
    })(Prism);
}

});

parcelRegister("cVzjE", function(module, exports) {
'use strict';

var $71Xdn = parcelRequire("71Xdn");

var $kR0BX = parcelRequire("kR0BX");
module.exports = $969633eb13aee10e$var$t4Cs;
$969633eb13aee10e$var$t4Cs.displayName = 't4Cs';
$969633eb13aee10e$var$t4Cs.aliases = [];
function $969633eb13aee10e$var$t4Cs(Prism) {
    Prism.register($71Xdn);
    Prism.register($kR0BX);
    Prism.languages.t4 = Prism.languages['t4-cs'] = Prism.languages['t4-templating'].createT4('csharp');
}

});
parcelRegister("71Xdn", function(module, exports) {
'use strict';
module.exports = $51e68f360f58fa37$var$t4Templating;
$51e68f360f58fa37$var$t4Templating.displayName = 't4Templating';
$51e68f360f58fa37$var$t4Templating.aliases = [];
function $51e68f360f58fa37$var$t4Templating(Prism) {
    (function(Prism) {
        function createBlock(prefix, inside, contentAlias) {
            return {
                pattern: RegExp('<#' + prefix + '[\\s\\S]*?#>'),
                alias: 'block',
                inside: {
                    delimiter: {
                        pattern: RegExp('^<#' + prefix + '|#>$'),
                        alias: 'important'
                    },
                    content: {
                        pattern: /[\s\S]+/,
                        inside: inside,
                        alias: contentAlias
                    }
                }
            };
        }
        function createT4(insideLang) {
            var grammar = Prism.languages[insideLang];
            var className = 'language-' + insideLang;
            return {
                block: {
                    pattern: /<#[\s\S]+?#>/,
                    inside: {
                        directive: createBlock('@', {
                            'attr-value': {
                                pattern: /=(?:("|')(?:\\[\s\S]|(?!\1)[^\\])*\1|[^\s'">=]+)/,
                                inside: {
                                    punctuation: /^=|^["']|["']$/
                                }
                            },
                            keyword: /\b\w+(?=\s)/,
                            'attr-name': /\b\w+/
                        }),
                        expression: createBlock('=', grammar, className),
                        'class-feature': createBlock('\\+', grammar, className),
                        standard: createBlock('', grammar, className)
                    }
                }
            };
        }
        Prism.languages['t4-templating'] = Object.defineProperty({}, 'createT4', {
            value: createT4
        });
    })(Prism);
}

});


parcelRegister("faIXs", function(module, exports) {
'use strict';

var $71Xdn = parcelRequire("71Xdn");

var $3av1E = parcelRequire("3av1E");
module.exports = $b0baa9e651256926$var$t4Vb;
$b0baa9e651256926$var$t4Vb.displayName = 't4Vb';
$b0baa9e651256926$var$t4Vb.aliases = [];
function $b0baa9e651256926$var$t4Vb(Prism) {
    Prism.register($71Xdn);
    Prism.register($3av1E);
    Prism.languages['t4-vb'] = Prism.languages['t4-templating'].createT4('vbnet');
}

});
parcelRegister("3av1E", function(module, exports) {
'use strict';

var $dzave = parcelRequire("dzave");
module.exports = $24ea5f4fab1693ed$var$vbnet;
$24ea5f4fab1693ed$var$vbnet.displayName = 'vbnet';
$24ea5f4fab1693ed$var$vbnet.aliases = [];
function $24ea5f4fab1693ed$var$vbnet(Prism) {
    Prism.register($dzave);
    Prism.languages.vbnet = Prism.languages.extend('basic', {
        comment: [
            {
                pattern: /(?:!|REM\b).+/i,
                inside: {
                    keyword: /^REM/i
                }
            },
            {
                pattern: /(^|[^\\:])'.*/,
                lookbehind: true,
                greedy: true
            }
        ],
        string: {
            pattern: /(^|[^"])"(?:""|[^"])*"(?!")/,
            lookbehind: true,
            greedy: true
        },
        keyword: /(?:\b(?:ADDHANDLER|ADDRESSOF|ALIAS|AND|ANDALSO|AS|BEEP|BLOAD|BOOLEAN|BSAVE|BYREF|BYTE|BYVAL|CALL(?: ABSOLUTE)?|CASE|CATCH|CBOOL|CBYTE|CCHAR|CDATE|CDBL|CDEC|CHAIN|CHAR|CHDIR|CINT|CLASS|CLEAR|CLNG|CLOSE|CLS|COBJ|COM|COMMON|CONST|CONTINUE|CSBYTE|CSHORT|CSNG|CSTR|CTYPE|CUINT|CULNG|CUSHORT|DATA|DATE|DECIMAL|DECLARE|DEF(?: FN| SEG|DBL|INT|LNG|SNG|STR)|DEFAULT|DELEGATE|DIM|DIRECTCAST|DO|DOUBLE|ELSE|ELSEIF|END|ENUM|ENVIRON|ERASE|ERROR|EVENT|EXIT|FALSE|FIELD|FILES|FINALLY|FOR(?: EACH)?|FRIEND|FUNCTION|GET|GETTYPE|GETXMLNAMESPACE|GLOBAL|GOSUB|GOTO|HANDLES|IF|IMPLEMENTS|IMPORTS|IN|INHERITS|INPUT|INTEGER|INTERFACE|IOCTL|IS|ISNOT|KEY|KILL|LET|LIB|LIKE|LINE INPUT|LOCATE|LOCK|LONG|LOOP|LSET|ME|MKDIR|MOD|MODULE|MUSTINHERIT|MUSTOVERRIDE|MYBASE|MYCLASS|NAME|NAMESPACE|NARROWING|NEW|NEXT|NOT|NOTHING|NOTINHERITABLE|NOTOVERRIDABLE|OBJECT|OF|OFF|ON(?: COM| ERROR| KEY| TIMER)?|OPEN|OPERATOR|OPTION(?: BASE)?|OPTIONAL|OR|ORELSE|OUT|OVERLOADS|OVERRIDABLE|OVERRIDES|PARAMARRAY|PARTIAL|POKE|PRIVATE|PROPERTY|PROTECTED|PUBLIC|PUT|RAISEEVENT|READ|READONLY|REDIM|REM|REMOVEHANDLER|RESTORE|RESUME|RETURN|RMDIR|RSET|RUN|SBYTE|SELECT(?: CASE)?|SET|SHADOWS|SHARED|SHELL|SHORT|SINGLE|SLEEP|STATIC|STEP|STOP|STRING|STRUCTURE|SUB|SWAP|SYNCLOCK|SYSTEM|THEN|THROW|TIMER|TO|TROFF|TRON|TRUE|TRY|TRYCAST|TYPE|TYPEOF|UINTEGER|ULONG|UNLOCK|UNTIL|USHORT|USING|VIEW PRINT|WAIT|WEND|WHEN|WHILE|WIDENING|WITH|WITHEVENTS|WRITE|WRITEONLY|XOR)|\B(?:#CONST|#ELSE|#ELSEIF|#END|#IF))(?:\$|\b)/i,
        punctuation: /[,;:(){}]/
    });
}

});


parcelRegister("71QBk", function(module, exports) {
'use strict';

var $1CDYv = parcelRequire("1CDYv");
module.exports = $51e16ddfcc455f0f$var$tap;
$51e16ddfcc455f0f$var$tap.displayName = 'tap';
$51e16ddfcc455f0f$var$tap.aliases = [];
function $51e16ddfcc455f0f$var$tap(Prism) {
    Prism.register($1CDYv);
    // https://en.wikipedia.org/wiki/Test_Anything_Protocol
    Prism.languages.tap = {
        fail: /not ok[^#{\n\r]*/,
        pass: /ok[^#{\n\r]*/,
        pragma: /pragma [+-][a-z]+/,
        bailout: /bail out!.*/i,
        version: /TAP version \d+/i,
        plan: /\b\d+\.\.\d+(?: +#.*)?/,
        subtest: {
            pattern: /# Subtest(?:: .*)?/,
            greedy: true
        },
        punctuation: /[{}]/,
        directive: /#.*/,
        yamlish: {
            pattern: /(^[ \t]*)---[\s\S]*?[\r\n][ \t]*\.\.\.$/m,
            lookbehind: true,
            inside: Prism.languages.yaml,
            alias: 'language-yaml'
        }
    };
}

});
parcelRegister("1CDYv", function(module, exports) {
'use strict';
module.exports = $12e85942b555d30e$var$yaml;
$12e85942b555d30e$var$yaml.displayName = 'yaml';
$12e85942b555d30e$var$yaml.aliases = [
    'yml'
];
function $12e85942b555d30e$var$yaml(Prism) {
    (function(Prism) {
        // https://yaml.org/spec/1.2/spec.html#c-ns-anchor-property
        // https://yaml.org/spec/1.2/spec.html#c-ns-alias-node
        var anchorOrAlias = /[*&][^\s[\]{},]+/ // https://yaml.org/spec/1.2/spec.html#c-ns-tag-property
        ;
        var tag = /!(?:<[\w\-%#;/?:@&=+$,.!~*'()[\]]+>|(?:[a-zA-Z\d-]*!)?[\w\-%#;/?:@&=+$.~*'()]+)?/ // https://yaml.org/spec/1.2/spec.html#c-ns-properties(n,c)
        ;
        var properties = '(?:' + tag.source + '(?:[ \t]+' + anchorOrAlias.source + ')?|' + anchorOrAlias.source + '(?:[ \t]+' + tag.source + ')?)' // https://yaml.org/spec/1.2/spec.html#ns-plain(n,c)
        ;
        // This is a simplified version that doesn't support "#" and multiline keys
        // All these long scarry character classes are simplified versions of YAML's characters
        var plainKey = /(?:[^\s\x00-\x08\x0e-\x1f!"#%&'*,\-:>?@[\]`{|}\x7f-\x84\x86-\x9f\ud800-\udfff\ufffe\uffff]|[?:-]<PLAIN>)(?:[ \t]*(?:(?![#:])<PLAIN>|:<PLAIN>))*/.source.replace(/<PLAIN>/g, function() {
            return /[^\s\x00-\x08\x0e-\x1f,[\]{}\x7f-\x84\x86-\x9f\ud800-\udfff\ufffe\uffff]/.source;
        });
        var string = /"(?:[^"\\\r\n]|\\.)*"|'(?:[^'\\\r\n]|\\.)*'/.source;
        /**
     *
     * @param {string} value
     * @param {string} [flags]
     * @returns {RegExp}
     */ function createValuePattern(value, flags) {
            flags = (flags || '').replace(/m/g, '') + 'm' // add m flag
            ;
            var pattern = /([:\-,[{]\s*(?:\s<<prop>>[ \t]+)?)(?:<<value>>)(?=[ \t]*(?:$|,|\]|\}|(?:[\r\n]\s*)?#))/.source.replace(/<<prop>>/g, function() {
                return properties;
            }).replace(/<<value>>/g, function() {
                return value;
            });
            return RegExp(pattern, flags);
        }
        Prism.languages.yaml = {
            scalar: {
                pattern: RegExp(/([\-:]\s*(?:\s<<prop>>[ \t]+)?[|>])[ \t]*(?:((?:\r?\n|\r)[ \t]+)\S[^\r\n]*(?:\2[^\r\n]+)*)/.source.replace(/<<prop>>/g, function() {
                    return properties;
                })),
                lookbehind: true,
                alias: 'string'
            },
            comment: /#.*/,
            key: {
                pattern: RegExp(/((?:^|[:\-,[{\r\n?])[ \t]*(?:<<prop>>[ \t]+)?)<<key>>(?=\s*:\s)/.source.replace(/<<prop>>/g, function() {
                    return properties;
                }).replace(/<<key>>/g, function() {
                    return '(?:' + plainKey + '|' + string + ')';
                })),
                lookbehind: true,
                greedy: true,
                alias: 'atrule'
            },
            directive: {
                pattern: /(^[ \t]*)%.+/m,
                lookbehind: true,
                alias: 'important'
            },
            datetime: {
                pattern: createValuePattern(/\d{4}-\d\d?-\d\d?(?:[tT]|[ \t]+)\d\d?:\d{2}:\d{2}(?:\.\d*)?(?:[ \t]*(?:Z|[-+]\d\d?(?::\d{2})?))?|\d{4}-\d{2}-\d{2}|\d\d?:\d{2}(?::\d{2}(?:\.\d*)?)?/.source),
                lookbehind: true,
                alias: 'number'
            },
            boolean: {
                pattern: createValuePattern(/false|true/.source, 'i'),
                lookbehind: true,
                alias: 'important'
            },
            null: {
                pattern: createValuePattern(/null|~/.source, 'i'),
                lookbehind: true,
                alias: 'important'
            },
            string: {
                pattern: createValuePattern(string),
                lookbehind: true,
                greedy: true
            },
            number: {
                pattern: createValuePattern(/[+-]?(?:0x[\da-f]+|0o[0-7]+|(?:\d+(?:\.\d*)?|\.\d+)(?:e[+-]?\d+)?|\.inf|\.nan)/.source, 'i'),
                lookbehind: true
            },
            tag: tag,
            important: anchorOrAlias,
            punctuation: /---|[:[\]{}\-,|>?]|\.\.\./
        };
        Prism.languages.yml = Prism.languages.yaml;
    })(Prism);
}

});


parcelRegister("6C2gd", function(module, exports) {
'use strict';
module.exports = $4d080b96aa343cf1$var$tcl;
$4d080b96aa343cf1$var$tcl.displayName = 'tcl';
$4d080b96aa343cf1$var$tcl.aliases = [];
function $4d080b96aa343cf1$var$tcl(Prism) {
    Prism.languages.tcl = {
        comment: {
            pattern: /(^|[^\\])#.*/,
            lookbehind: true
        },
        string: {
            pattern: /"(?:[^"\\\r\n]|\\(?:\r\n|[\s\S]))*"/,
            greedy: true
        },
        variable: [
            {
                pattern: /(\$)(?:::)?(?:[a-zA-Z0-9]+::)*\w+/,
                lookbehind: true
            },
            {
                pattern: /(\$)\{[^}]+\}/,
                lookbehind: true
            },
            {
                pattern: /(^[\t ]*set[ \t]+)(?:::)?(?:[a-zA-Z0-9]+::)*\w+/m,
                lookbehind: true
            }
        ],
        function: {
            pattern: /(^[\t ]*proc[ \t]+)\S+/m,
            lookbehind: true
        },
        builtin: [
            {
                pattern: /(^[\t ]*)(?:break|class|continue|error|eval|exit|for|foreach|if|proc|return|switch|while)\b/m,
                lookbehind: true
            },
            /\b(?:else|elseif)\b/
        ],
        scope: {
            pattern: /(^[\t ]*)(?:global|upvar|variable)\b/m,
            lookbehind: true,
            alias: 'constant'
        },
        keyword: {
            pattern: /(^[\t ]*|\[)(?:Safe_Base|Tcl|after|append|apply|array|auto_(?:execok|import|load|mkindex|qualify|reset)|automkindex_old|bgerror|binary|catch|cd|chan|clock|close|concat|dde|dict|encoding|eof|exec|expr|fblocked|fconfigure|fcopy|file(?:event|name)?|flush|gets|glob|history|http|incr|info|interp|join|lappend|lassign|lindex|linsert|list|llength|load|lrange|lrepeat|lreplace|lreverse|lsearch|lset|lsort|math(?:func|op)|memory|msgcat|namespace|open|package|parray|pid|pkg_mkIndex|platform|puts|pwd|re_syntax|read|refchan|regexp|registry|regsub|rename|scan|seek|set|socket|source|split|string|subst|tcl(?:_endOfWord|_findLibrary|startOf(?:Next|Previous)Word|test|vars|wordBreak(?:After|Before))|tell|time|tm|trace|unknown|unload|unset|update|uplevel|vwait)\b/m,
            lookbehind: true
        },
        operator: /!=?|\*\*?|==|&&?|\|\|?|<[=<]?|>[=>]?|[-+~\/%?^]|\b(?:eq|in|ne|ni)\b/,
        punctuation: /[{}()\[\]]/
    };
}

});

parcelRegister("iBtFX", function(module, exports) {
'use strict';
module.exports = $d8b2b3b11d9d0eee$var$textile;
$d8b2b3b11d9d0eee$var$textile.displayName = 'textile';
$d8b2b3b11d9d0eee$var$textile.aliases = [];
function $d8b2b3b11d9d0eee$var$textile(Prism) {
    (function(Prism) {
        // We don't allow for pipes inside parentheses
        // to not break table pattern |(. foo |). bar |
        var modifierRegex = /\([^|()\n]+\)|\[[^\]\n]+\]|\{[^}\n]+\}/.source // Opening and closing parentheses which are not a modifier
        ;
        // This pattern is necessary to prevent exponential backtracking
        var parenthesesRegex = /\)|\((?![^|()\n]+\))/.source;
        /**
     * @param {string} source
     * @param {string} [flags]
     */ function withModifier(source, flags) {
            return RegExp(source.replace(/<MOD>/g, function() {
                return '(?:' + modifierRegex + ')';
            }).replace(/<PAR>/g, function() {
                return '(?:' + parenthesesRegex + ')';
            }), flags || '');
        }
        var modifierTokens = {
            css: {
                pattern: /\{[^{}]+\}/,
                inside: {
                    rest: Prism.languages.css
                }
            },
            'class-id': {
                pattern: /(\()[^()]+(?=\))/,
                lookbehind: true,
                alias: 'attr-value'
            },
            lang: {
                pattern: /(\[)[^\[\]]+(?=\])/,
                lookbehind: true,
                alias: 'attr-value'
            },
            // Anything else is punctuation (the first pattern is for row/col spans inside tables)
            punctuation: /[\\\/]\d+|\S/
        };
        var textile = Prism.languages.textile = Prism.languages.extend('markup', {
            phrase: {
                pattern: /(^|\r|\n)\S[\s\S]*?(?=$|\r?\n\r?\n|\r\r)/,
                lookbehind: true,
                inside: {
                    // h1. Header 1
                    'block-tag': {
                        pattern: withModifier(/^[a-z]\w*(?:<MOD>|<PAR>|[<>=])*\./.source),
                        inside: {
                            modifier: {
                                pattern: withModifier(/(^[a-z]\w*)(?:<MOD>|<PAR>|[<>=])+(?=\.)/.source),
                                lookbehind: true,
                                inside: modifierTokens
                            },
                            tag: /^[a-z]\w*/,
                            punctuation: /\.$/
                        }
                    },
                    // # List item
                    // * List item
                    list: {
                        pattern: withModifier(/^[*#]+<MOD>*\s+\S.*/.source, 'm'),
                        inside: {
                            modifier: {
                                pattern: withModifier(/(^[*#]+)<MOD>+/.source),
                                lookbehind: true,
                                inside: modifierTokens
                            },
                            punctuation: /^[*#]+/
                        }
                    },
                    // | cell | cell | cell |
                    table: {
                        // Modifiers can be applied to the row: {color:red}.|1|2|3|
                        // or the cell: |{color:red}.1|2|3|
                        pattern: withModifier(/^(?:(?:<MOD>|<PAR>|[<>=^~])+\.\s*)?(?:\|(?:(?:<MOD>|<PAR>|[<>=^~_]|[\\/]\d+)+\.|(?!(?:<MOD>|<PAR>|[<>=^~_]|[\\/]\d+)+\.))[^|]*)+\|/.source, 'm'),
                        inside: {
                            modifier: {
                                // Modifiers for rows after the first one are
                                // preceded by a pipe and a line feed
                                pattern: withModifier(/(^|\|(?:\r?\n|\r)?)(?:<MOD>|<PAR>|[<>=^~_]|[\\/]\d+)+(?=\.)/.source),
                                lookbehind: true,
                                inside: modifierTokens
                            },
                            punctuation: /\||^\./
                        }
                    },
                    inline: {
                        // eslint-disable-next-line regexp/no-super-linear-backtracking
                        pattern: withModifier(/(^|[^a-zA-Z\d])(\*\*|__|\?\?|[*_%@+\-^~])<MOD>*.+?\2(?![a-zA-Z\d])/.source),
                        lookbehind: true,
                        inside: {
                            // Note: superscripts and subscripts are not handled specifically
                            // *bold*, **bold**
                            bold: {
                                // eslint-disable-next-line regexp/no-super-linear-backtracking
                                pattern: withModifier(/(^(\*\*?)<MOD>*).+?(?=\2)/.source),
                                lookbehind: true
                            },
                            // _italic_, __italic__
                            italic: {
                                // eslint-disable-next-line regexp/no-super-linear-backtracking
                                pattern: withModifier(/(^(__?)<MOD>*).+?(?=\2)/.source),
                                lookbehind: true
                            },
                            // ??cite??
                            cite: {
                                // eslint-disable-next-line regexp/no-super-linear-backtracking
                                pattern: withModifier(/(^\?\?<MOD>*).+?(?=\?\?)/.source),
                                lookbehind: true,
                                alias: 'string'
                            },
                            // @code@
                            code: {
                                // eslint-disable-next-line regexp/no-super-linear-backtracking
                                pattern: withModifier(/(^@<MOD>*).+?(?=@)/.source),
                                lookbehind: true,
                                alias: 'keyword'
                            },
                            // +inserted+
                            inserted: {
                                // eslint-disable-next-line regexp/no-super-linear-backtracking
                                pattern: withModifier(/(^\+<MOD>*).+?(?=\+)/.source),
                                lookbehind: true
                            },
                            // -deleted-
                            deleted: {
                                // eslint-disable-next-line regexp/no-super-linear-backtracking
                                pattern: withModifier(/(^-<MOD>*).+?(?=-)/.source),
                                lookbehind: true
                            },
                            // %span%
                            span: {
                                // eslint-disable-next-line regexp/no-super-linear-backtracking
                                pattern: withModifier(/(^%<MOD>*).+?(?=%)/.source),
                                lookbehind: true
                            },
                            modifier: {
                                pattern: withModifier(/(^\*\*|__|\?\?|[*_%@+\-^~])<MOD>+/.source),
                                lookbehind: true,
                                inside: modifierTokens
                            },
                            punctuation: /[*_%?@+\-^~]+/
                        }
                    },
                    // [alias]http://example.com
                    'link-ref': {
                        pattern: /^\[[^\]]+\]\S+$/m,
                        inside: {
                            string: {
                                pattern: /(^\[)[^\]]+(?=\])/,
                                lookbehind: true
                            },
                            url: {
                                pattern: /(^\])\S+$/,
                                lookbehind: true
                            },
                            punctuation: /[\[\]]/
                        }
                    },
                    // "text":http://example.com
                    // "text":link-ref
                    link: {
                        // eslint-disable-next-line regexp/no-super-linear-backtracking
                        pattern: withModifier(/"<MOD>*[^"]+":.+?(?=[^\w/]?(?:\s|$))/.source),
                        inside: {
                            text: {
                                // eslint-disable-next-line regexp/no-super-linear-backtracking
                                pattern: withModifier(/(^"<MOD>*)[^"]+(?=")/.source),
                                lookbehind: true
                            },
                            modifier: {
                                pattern: withModifier(/(^")<MOD>+/.source),
                                lookbehind: true,
                                inside: modifierTokens
                            },
                            url: {
                                pattern: /(:).+/,
                                lookbehind: true
                            },
                            punctuation: /[":]/
                        }
                    },
                    // !image.jpg!
                    // !image.jpg(Title)!:http://example.com
                    image: {
                        pattern: withModifier(/!(?:<MOD>|<PAR>|[<>=])*(?![<>=])[^!\s()]+(?:\([^)]+\))?!(?::.+?(?=[^\w/]?(?:\s|$)))?/.source),
                        inside: {
                            source: {
                                pattern: withModifier(/(^!(?:<MOD>|<PAR>|[<>=])*)(?![<>=])[^!\s()]+(?:\([^)]+\))?(?=!)/.source),
                                lookbehind: true,
                                alias: 'url'
                            },
                            modifier: {
                                pattern: withModifier(/(^!)(?:<MOD>|<PAR>|[<>=])+/.source),
                                lookbehind: true,
                                inside: modifierTokens
                            },
                            url: {
                                pattern: /(:).+/,
                                lookbehind: true
                            },
                            punctuation: /[!:]/
                        }
                    },
                    // Footnote[1]
                    footnote: {
                        pattern: /\b\[\d+\]/,
                        alias: 'comment',
                        inside: {
                            punctuation: /\[|\]/
                        }
                    },
                    // CSS(Cascading Style Sheet)
                    acronym: {
                        pattern: /\b[A-Z\d]+\([^)]+\)/,
                        inside: {
                            comment: {
                                pattern: /(\()[^()]+(?=\))/,
                                lookbehind: true
                            },
                            punctuation: /[()]/
                        }
                    },
                    // Prism(C)
                    mark: {
                        pattern: /\b\((?:C|R|TM)\)/,
                        alias: 'comment',
                        inside: {
                            punctuation: /[()]/
                        }
                    }
                }
            }
        });
        var phraseInside = textile['phrase'].inside;
        var nestedPatterns = {
            inline: phraseInside['inline'],
            link: phraseInside['link'],
            image: phraseInside['image'],
            footnote: phraseInside['footnote'],
            acronym: phraseInside['acronym'],
            mark: phraseInside['mark']
        } // Only allow alpha-numeric HTML tags, not XML tags
        ;
        textile.tag.pattern = /<\/?(?!\d)[a-z0-9]+(?:\s+[^\s>\/=]+(?:=(?:("|')(?:\\[\s\S]|(?!\1)[^\\])*\1|[^\s'">=]+))?)*\s*\/?>/i // Allow some nesting
        ;
        var phraseInlineInside = phraseInside['inline'].inside;
        phraseInlineInside['bold'].inside = nestedPatterns;
        phraseInlineInside['italic'].inside = nestedPatterns;
        phraseInlineInside['inserted'].inside = nestedPatterns;
        phraseInlineInside['deleted'].inside = nestedPatterns;
        phraseInlineInside['span'].inside = nestedPatterns // Allow some styles inside table cells
        ;
        var phraseTableInside = phraseInside['table'].inside;
        phraseTableInside['inline'] = nestedPatterns['inline'];
        phraseTableInside['link'] = nestedPatterns['link'];
        phraseTableInside['image'] = nestedPatterns['image'];
        phraseTableInside['footnote'] = nestedPatterns['footnote'];
        phraseTableInside['acronym'] = nestedPatterns['acronym'];
        phraseTableInside['mark'] = nestedPatterns['mark'];
    })(Prism);
}

});

parcelRegister("eJ1Tk", function(module, exports) {
'use strict';
module.exports = $ab86bc3c70c300db$var$toml;
$ab86bc3c70c300db$var$toml.displayName = 'toml';
$ab86bc3c70c300db$var$toml.aliases = [];
function $ab86bc3c70c300db$var$toml(Prism) {
    (function(Prism) {
        var key = /(?:[\w-]+|'[^'\n\r]*'|"(?:\\.|[^\\"\r\n])*")/.source;
        /**
     * @param {string} pattern
     */ function insertKey(pattern) {
            return pattern.replace(/__/g, function() {
                return key;
            });
        }
        Prism.languages.toml = {
            comment: {
                pattern: /#.*/,
                greedy: true
            },
            table: {
                pattern: RegExp(insertKey(/(^[\t ]*\[\s*(?:\[\s*)?)__(?:\s*\.\s*__)*(?=\s*\])/.source), 'm'),
                lookbehind: true,
                greedy: true,
                alias: 'class-name'
            },
            key: {
                pattern: RegExp(insertKey(/(^[\t ]*|[{,]\s*)__(?:\s*\.\s*__)*(?=\s*=)/.source), 'm'),
                lookbehind: true,
                greedy: true,
                alias: 'property'
            },
            string: {
                pattern: /"""(?:\\[\s\S]|[^\\])*?"""|'''[\s\S]*?'''|'[^'\n\r]*'|"(?:\\.|[^\\"\r\n])*"/,
                greedy: true
            },
            date: [
                {
                    // Offset Date-Time, Local Date-Time, Local Date
                    pattern: /\b\d{4}-\d{2}-\d{2}(?:[T\s]\d{2}:\d{2}:\d{2}(?:\.\d+)?(?:Z|[+-]\d{2}:\d{2})?)?\b/i,
                    alias: 'number'
                },
                {
                    // Local Time
                    pattern: /\b\d{2}:\d{2}:\d{2}(?:\.\d+)?\b/,
                    alias: 'number'
                }
            ],
            number: /(?:\b0(?:x[\da-zA-Z]+(?:_[\da-zA-Z]+)*|o[0-7]+(?:_[0-7]+)*|b[10]+(?:_[10]+)*))\b|[-+]?\b\d+(?:_\d+)*(?:\.\d+(?:_\d+)*)?(?:[eE][+-]?\d+(?:_\d+)*)?\b|[-+]?\b(?:inf|nan)\b/,
            boolean: /\b(?:false|true)\b/,
            punctuation: /[.,=[\]{}]/
        };
    })(Prism);
}

});

parcelRegister("hdHsr", function(module, exports) {
'use strict';
module.exports = $c8955c6226c5b617$var$tremor;
$c8955c6226c5b617$var$tremor.displayName = 'tremor';
$c8955c6226c5b617$var$tremor.aliases = [];
function $c8955c6226c5b617$var$tremor(Prism) {
    (function(Prism) {
        Prism.languages.tremor = {
            comment: {
                pattern: /(^|[^\\])(?:\/\*[\s\S]*?\*\/|(?:--|\/\/|#).*)/,
                lookbehind: true
            },
            'interpolated-string': null,
            // see below
            extractor: {
                pattern: /\b[a-z_]\w*\|(?:[^\r\n\\|]|\\(?:\r\n|[\s\S]))*\|/i,
                greedy: true,
                inside: {
                    regex: {
                        pattern: /(^re)\|[\s\S]+/,
                        lookbehind: true
                    },
                    function: /^\w+/,
                    value: /\|[\s\S]+/
                }
            },
            identifier: {
                pattern: /`[^`]*`/,
                greedy: true
            },
            function: /\b[a-z_]\w*(?=\s*(?:::\s*<|\())\b/,
            keyword: /\b(?:args|as|by|case|config|connect|connector|const|copy|create|default|define|deploy|drop|each|emit|end|erase|event|flow|fn|for|from|group|having|insert|into|intrinsic|let|links|match|merge|mod|move|of|operator|patch|pipeline|recur|script|select|set|sliding|state|stream|to|tumbling|update|use|when|where|window|with)\b/,
            boolean: /\b(?:false|null|true)\b/i,
            number: /\b(?:0b[01_]*|0x[0-9a-fA-F_]*|\d[\d_]*(?:\.\d[\d_]*)?(?:[Ee][+-]?[\d_]+)?)\b/,
            'pattern-punctuation': {
                pattern: /%(?=[({[])/,
                alias: 'punctuation'
            },
            operator: /[-+*\/%~!^]=?|=[=>]?|&[&=]?|\|[|=]?|<<?=?|>>?>?=?|(?:absent|and|not|or|present|xor)\b/,
            punctuation: /::|[;\[\]()\{\},.:]/
        };
        var interpolationPattern = /#\{(?:[^"{}]|\{[^{}]*\}|"(?:[^"\\\r\n]|\\(?:\r\n|[\s\S]))*")*\}/.source;
        Prism.languages.tremor['interpolated-string'] = {
            pattern: RegExp(/(^|[^\\])/.source + '(?:' + '"""(?:' + /[^"\\#]|\\[\s\S]|"(?!"")|#(?!\{)/.source + '|' + interpolationPattern + ')*"""' + '|' + '"(?:' + /[^"\\\r\n#]|\\(?:\r\n|[\s\S])|#(?!\{)/.source + '|' + interpolationPattern + ')*"' + ')'),
            lookbehind: true,
            greedy: true,
            inside: {
                interpolation: {
                    pattern: RegExp(interpolationPattern),
                    inside: {
                        punctuation: /^#\{|\}$/,
                        expression: {
                            pattern: /[\s\S]+/,
                            inside: Prism.languages.tremor
                        }
                    }
                },
                string: /[\s\S]+/
            }
        };
        Prism.languages.troy = Prism.languages['tremor'];
        Prism.languages.trickle = Prism.languages['tremor'];
    })(Prism);
}

});

parcelRegister("iAxx1", function(module, exports) {
'use strict';

var $jYji4 = parcelRequire("jYji4");

var $cQami = parcelRequire("cQami");
module.exports = $d8859979742e1f5e$var$tsx;
$d8859979742e1f5e$var$tsx.displayName = 'tsx';
$d8859979742e1f5e$var$tsx.aliases = [];
function $d8859979742e1f5e$var$tsx(Prism) {
    Prism.register($jYji4);
    Prism.register($cQami);
    (function(Prism) {
        var typescript = Prism.util.clone(Prism.languages.typescript);
        Prism.languages.tsx = Prism.languages.extend('jsx', typescript) // doesn't work with TS because TS is too complex
        ;
        delete Prism.languages.tsx['parameter'];
        delete Prism.languages.tsx['literal-property'] // This will prevent collisions between TSX tags and TS generic types.
        ;
        // Idea by https://github.com/karlhorky
        // Discussion: https://github.com/PrismJS/prism/issues/2594#issuecomment-710666928
        var tag = Prism.languages.tsx.tag;
        tag.pattern = RegExp(/(^|[^\w$]|(?=<\/))/.source + '(?:' + tag.pattern.source + ')', tag.pattern.flags);
        tag.lookbehind = true;
    })(Prism);
}

});

parcelRegister("3rXjk", function(module, exports) {
'use strict';

var $949g8 = parcelRequire("949g8");
module.exports = $2831e69aa961c5fc$var$tt2;
$2831e69aa961c5fc$var$tt2.displayName = 'tt2';
$2831e69aa961c5fc$var$tt2.aliases = [];
function $2831e69aa961c5fc$var$tt2(Prism) {
    Prism.register($949g8);
    (function(Prism) {
        Prism.languages.tt2 = Prism.languages.extend('clike', {
            comment: /#.*|\[%#[\s\S]*?%\]/,
            keyword: /\b(?:BLOCK|CALL|CASE|CATCH|CLEAR|DEBUG|DEFAULT|ELSE|ELSIF|END|FILTER|FINAL|FOREACH|GET|IF|IN|INCLUDE|INSERT|LAST|MACRO|META|NEXT|PERL|PROCESS|RAWPERL|RETURN|SET|STOP|SWITCH|TAGS|THROW|TRY|UNLESS|USE|WHILE|WRAPPER)\b/,
            punctuation: /[[\]{},()]/
        });
        Prism.languages.insertBefore('tt2', 'number', {
            operator: /=[>=]?|!=?|<=?|>=?|&&|\|\|?|\b(?:and|not|or)\b/,
            variable: {
                pattern: /\b[a-z]\w*(?:\s*\.\s*(?:\d+|\$?[a-z]\w*))*\b/i
            }
        });
        Prism.languages.insertBefore('tt2', 'keyword', {
            delimiter: {
                pattern: /^(?:\[%|%%)-?|-?%\]$/,
                alias: 'punctuation'
            }
        });
        Prism.languages.insertBefore('tt2', 'string', {
            'single-quoted-string': {
                pattern: /'[^\\']*(?:\\[\s\S][^\\']*)*'/,
                greedy: true,
                alias: 'string'
            },
            'double-quoted-string': {
                pattern: /"[^\\"]*(?:\\[\s\S][^\\"]*)*"/,
                greedy: true,
                alias: 'string',
                inside: {
                    variable: {
                        pattern: /\$(?:[a-z]\w*(?:\.(?:\d+|\$?[a-z]\w*))*)/i
                    }
                }
            }
        }) // The different types of TT2 strings "replace" the C-like standard string
        ;
        delete Prism.languages.tt2.string;
        Prism.hooks.add('before-tokenize', function(env) {
            var tt2Pattern = /\[%[\s\S]+?%\]/g;
            Prism.languages['markup-templating'].buildPlaceholders(env, 'tt2', tt2Pattern);
        });
        Prism.hooks.add('after-tokenize', function(env) {
            Prism.languages['markup-templating'].tokenizePlaceholders(env, 'tt2');
        });
    })(Prism);
}

});

parcelRegister("8Kcj1", function(module, exports) {
'use strict';

var $949g8 = parcelRequire("949g8");
module.exports = $65dc2a491735b4dd$var$twig;
$65dc2a491735b4dd$var$twig.displayName = 'twig';
$65dc2a491735b4dd$var$twig.aliases = [];
function $65dc2a491735b4dd$var$twig(Prism) {
    Prism.register($949g8);
    Prism.languages.twig = {
        comment: /^\{#[\s\S]*?#\}$/,
        'tag-name': {
            pattern: /(^\{%-?\s*)\w+/,
            lookbehind: true,
            alias: 'keyword'
        },
        delimiter: {
            pattern: /^\{[{%]-?|-?[%}]\}$/,
            alias: 'punctuation'
        },
        string: {
            pattern: /("|')(?:\\.|(?!\1)[^\\\r\n])*\1/,
            inside: {
                punctuation: /^['"]|['"]$/
            }
        },
        keyword: /\b(?:even|if|odd)\b/,
        boolean: /\b(?:false|null|true)\b/,
        number: /\b0x[\dA-Fa-f]+|(?:\b\d+(?:\.\d*)?|\B\.\d+)(?:[Ee][-+]?\d+)?/,
        operator: [
            {
                pattern: /(\s)(?:and|b-and|b-or|b-xor|ends with|in|is|matches|not|or|same as|starts with)(?=\s)/,
                lookbehind: true
            },
            /[=<>]=?|!=|\*\*?|\/\/?|\?:?|[-+~%|]/
        ],
        punctuation: /[()\[\]{}:.,]/
    };
    Prism.hooks.add('before-tokenize', function(env) {
        if (env.language !== 'twig') return;
        var pattern = /\{(?:#[\s\S]*?#|%[\s\S]*?%|\{[\s\S]*?\})\}/g;
        Prism.languages['markup-templating'].buildPlaceholders(env, 'twig', pattern);
    });
    Prism.hooks.add('after-tokenize', function(env) {
        Prism.languages['markup-templating'].tokenizePlaceholders(env, 'twig');
    });
}

});

parcelRegister("8QUf9", function(module, exports) {
'use strict';
module.exports = $671eced82eb1ef4e$var$typoscript;
$671eced82eb1ef4e$var$typoscript.displayName = 'typoscript';
$671eced82eb1ef4e$var$typoscript.aliases = [
    'tsconfig'
];
function $671eced82eb1ef4e$var$typoscript(Prism) {
    (function(Prism) {
        var keywords = /\b(?:ACT|ACTIFSUB|CARRAY|CASE|CLEARGIF|COA|COA_INT|CONSTANTS|CONTENT|CUR|EDITPANEL|EFFECT|EXT|FILE|FLUIDTEMPLATE|FORM|FRAME|FRAMESET|GIFBUILDER|GMENU|GMENU_FOLDOUT|GMENU_LAYERS|GP|HMENU|HRULER|HTML|IENV|IFSUB|IMAGE|IMGMENU|IMGMENUITEM|IMGTEXT|IMG_RESOURCE|INCLUDE_TYPOSCRIPT|JSMENU|JSMENUITEM|LLL|LOAD_REGISTER|NO|PAGE|RECORDS|RESTORE_REGISTER|TEMPLATE|TEXT|TMENU|TMENUITEM|TMENU_LAYERS|USER|USER_INT|_GIFBUILDER|global|globalString|globalVar)\b/;
        Prism.languages.typoscript = {
            comment: [
                {
                    // multiline comments /* */
                    pattern: /(^|[^\\])\/\*[\s\S]*?(?:\*\/|$)/,
                    lookbehind: true
                },
                {
                    // double-slash comments - ignored when backslashes or colon is found in front
                    // also ignored whenever directly after an equal-sign, because it would probably be an url without protocol
                    pattern: /(^|[^\\:= \t]|(?:^|[^= \t])[ \t]+)\/\/.*/,
                    lookbehind: true,
                    greedy: true
                },
                {
                    // hash comments - ignored when leading quote is found for hex colors in strings
                    pattern: /(^|[^"'])#.*/,
                    lookbehind: true,
                    greedy: true
                }
            ],
            function: [
                {
                    // old include style
                    pattern: /<INCLUDE_TYPOSCRIPT:\s*source\s*=\s*(?:"[^"\r\n]*"|'[^'\r\n]*')\s*>/,
                    inside: {
                        string: {
                            pattern: /"[^"\r\n]*"|'[^'\r\n]*'/,
                            inside: {
                                keyword: keywords
                            }
                        },
                        keyword: {
                            pattern: /INCLUDE_TYPOSCRIPT/
                        }
                    }
                },
                {
                    // new include style
                    pattern: /@import\s*(?:"[^"\r\n]*"|'[^'\r\n]*')/,
                    inside: {
                        string: /"[^"\r\n]*"|'[^'\r\n]*'/
                    }
                }
            ],
            string: {
                pattern: /^([^=]*=[< ]?)(?:(?!\]\n).)*/,
                lookbehind: true,
                inside: {
                    function: /\{\$.*\}/,
                    // constants include
                    keyword: keywords,
                    number: /^\d+$/,
                    punctuation: /[,|:]/
                }
            },
            keyword: keywords,
            number: {
                // special highlighting for indexes of arrays in tags
                pattern: /\b\d+\s*[.{=]/,
                inside: {
                    operator: /[.{=]/
                }
            },
            tag: {
                pattern: /\.?[-\w\\]+\.?/,
                inside: {
                    punctuation: /\./
                }
            },
            punctuation: /[{}[\];(),.:|]/,
            operator: /[<>]=?|[!=]=?=?|--?|\+\+?|&&?|\|\|?|[?*/~^%]/
        };
        Prism.languages.tsconfig = Prism.languages.typoscript;
    })(Prism);
}

});

parcelRegister("kUHcr", function(module, exports) {
'use strict';
module.exports = $f39a8c24d327eeaa$var$unrealscript;
$f39a8c24d327eeaa$var$unrealscript.displayName = 'unrealscript';
$f39a8c24d327eeaa$var$unrealscript.aliases = [
    'uc',
    'uscript'
];
function $f39a8c24d327eeaa$var$unrealscript(Prism) {
    Prism.languages.unrealscript = {
        comment: /\/\/.*|\/\*[\s\S]*?\*\//,
        string: {
            pattern: /(["'])(?:\\(?:\r\n|[\s\S])|(?!\1)[^\\\r\n])*\1/,
            greedy: true
        },
        category: {
            pattern: /(\b(?:(?:autoexpand|hide|show)categories|var)\s*\()[^()]+(?=\))/,
            lookbehind: true,
            greedy: true,
            alias: 'property'
        },
        metadata: {
            pattern: /(\w\s*)<\s*\w+\s*=[^<>|=\r\n]+(?:\|\s*\w+\s*=[^<>|=\r\n]+)*>/,
            lookbehind: true,
            greedy: true,
            inside: {
                property: /\b\w+(?=\s*=)/,
                operator: /=/,
                punctuation: /[<>|]/
            }
        },
        macro: {
            pattern: /`\w+/,
            alias: 'property'
        },
        'class-name': {
            pattern: /(\b(?:class|enum|extends|interface|state(?:\(\))?|struct|within)\s+)\w+/,
            lookbehind: true
        },
        keyword: /\b(?:abstract|actor|array|auto|autoexpandcategories|bool|break|byte|case|class|classgroup|client|coerce|collapsecategories|config|const|continue|default|defaultproperties|delegate|dependson|deprecated|do|dontcollapsecategories|editconst|editinlinenew|else|enum|event|exec|export|extends|final|float|for|forcescriptorder|foreach|function|goto|guid|hidecategories|hidedropdown|if|ignores|implements|inherits|input|int|interface|iterator|latent|local|material|name|native|nativereplication|noexport|nontransient|noteditinlinenew|notplaceable|operator|optional|out|pawn|perobjectconfig|perobjectlocalized|placeable|postoperator|preoperator|private|protected|reliable|replication|return|server|showcategories|simulated|singular|state|static|string|struct|structdefault|structdefaultproperties|switch|texture|transient|travel|unreliable|until|var|vector|while|within)\b/,
        function: /\b[a-z_]\w*(?=\s*\()/i,
        boolean: /\b(?:false|true)\b/,
        number: /\b0x[\da-f]+\b|(?:\b\d+(?:\.\d*)?|\B\.\d+)(?:e[+-]?\d+)?/i,
        // https://docs.unrealengine.com/udk/Three/UnrealScriptExpressions.html
        operator: />>|<<|--|\+\+|\*\*|[-+*/~!=<>$@]=?|&&?|\|\|?|\^\^?|[?:%]|\b(?:ClockwiseFrom|Cross|Dot)\b/,
        punctuation: /[()[\]{};,.]/
    };
    Prism.languages.uc = Prism.languages.uscript = Prism.languages.unrealscript;
}

});

parcelRegister("buNor", function(module, exports) {
'use strict';
module.exports = $85e8cf8089b41437$var$uorazor;
$85e8cf8089b41437$var$uorazor.displayName = 'uorazor';
$85e8cf8089b41437$var$uorazor.aliases = [];
function $85e8cf8089b41437$var$uorazor(Prism) {
    Prism.languages.uorazor = {
        'comment-hash': {
            pattern: /#.*/,
            alias: 'comment',
            greedy: true
        },
        'comment-slash': {
            pattern: /\/\/.*/,
            alias: 'comment',
            greedy: true
        },
        string: {
            pattern: /("|')(?:\\.|(?!\1)[^\\\r\n])*\1/,
            inside: {
                punctuation: /^['"]|['"]$/
            },
            greedy: true
        },
        'source-layers': {
            pattern: /\b(?:arms|backpack|blue|bracelet|cancel|clear|cloak|criminal|earrings|enemy|facialhair|friend|friendly|gloves|gray|grey|ground|hair|head|innerlegs|innertorso|innocent|lefthand|middletorso|murderer|neck|nonfriendly|onehandedsecondary|outerlegs|outertorso|pants|red|righthand|ring|self|shirt|shoes|talisman|waist)\b/i,
            alias: 'function'
        },
        'source-commands': {
            pattern: /\b(?:alliance|attack|cast|clearall|clearignore|clearjournal|clearlist|clearsysmsg|createlist|createtimer|dclick|dclicktype|dclickvar|dress|dressconfig|drop|droprelloc|emote|getlabel|guild|gumpclose|gumpresponse|hotkey|ignore|lasttarget|lift|lifttype|menu|menuresponse|msg|org|organize|organizer|overhead|pause|poplist|potion|promptresponse|pushlist|removelist|removetimer|rename|restock|say|scav|scavenger|script|setability|setlasttarget|setskill|settimer|setvar|sysmsg|target|targetloc|targetrelloc|targettype|undress|unignore|unsetvar|useobject|useonce|useskill|usetype|virtue|wait|waitforgump|waitformenu|waitforprompt|waitforstat|waitforsysmsg|waitfortarget|walk|wfsysmsg|wft|whisper|yell)\b/,
            alias: 'function'
        },
        'tag-name': {
            pattern: /(^\{%-?\s*)\w+/,
            lookbehind: true,
            alias: 'keyword'
        },
        delimiter: {
            pattern: /^\{[{%]-?|-?[%}]\}$/,
            alias: 'punctuation'
        },
        function: /\b(?:atlist|close|closest|count|counter|counttype|dead|dex|diffhits|diffmana|diffstam|diffweight|find|findbuff|finddebuff|findlayer|findtype|findtypelist|followers|gumpexists|hidden|hits|hp|hue|human|humanoid|ingump|inlist|insysmessage|insysmsg|int|invul|lhandempty|list|listexists|mana|maxhits|maxhp|maxmana|maxstam|maxweight|monster|mounted|name|next|noto|paralyzed|poisoned|position|prev|previous|queued|rand|random|rhandempty|skill|stam|str|targetexists|timer|timerexists|varexist|warmode|weight)\b/,
        keyword: /\b(?:and|as|break|continue|else|elseif|endfor|endif|endwhile|for|if|loop|not|or|replay|stop|while)\b/,
        boolean: /\b(?:false|null|true)\b/,
        number: /\b0x[\dA-Fa-f]+|(?:\b\d+(?:\.\d*)?|\B\.\d+)(?:[Ee][-+]?\d+)?/,
        operator: [
            {
                pattern: /(\s)(?:and|b-and|b-or|b-xor|ends with|in|is|matches|not|or|same as|starts with)(?=\s)/,
                lookbehind: true
            },
            /[=<>]=?|!=|\*\*?|\/\/?|\?:?|[-+~%|]/
        ],
        punctuation: /[()\[\]{}:.,]/
    };
}

});

parcelRegister("3tuCM", function(module, exports) {
'use strict';
module.exports = $287bd5e71385d328$var$uri;
$287bd5e71385d328$var$uri.displayName = 'uri';
$287bd5e71385d328$var$uri.aliases = [
    'url'
];
function $287bd5e71385d328$var$uri(Prism) {
    // https://tools.ietf.org/html/rfc3986#appendix-A
    Prism.languages.uri = {
        scheme: {
            pattern: /^[a-z][a-z0-9+.-]*:/im,
            greedy: true,
            inside: {
                'scheme-delimiter': /:$/
            }
        },
        fragment: {
            pattern: /#[\w\-.~!$&'()*+,;=%:@/?]*/,
            inside: {
                'fragment-delimiter': /^#/
            }
        },
        query: {
            pattern: /\?[\w\-.~!$&'()*+,;=%:@/?]*/,
            inside: {
                'query-delimiter': {
                    pattern: /^\?/,
                    greedy: true
                },
                'pair-delimiter': /[&;]/,
                pair: {
                    pattern: /^[^=][\s\S]*/,
                    inside: {
                        key: /^[^=]+/,
                        value: {
                            pattern: /(^=)[\s\S]+/,
                            lookbehind: true
                        }
                    }
                }
            }
        },
        authority: {
            pattern: RegExp(/^\/\//.source + // [ userinfo "@" ]
            /(?:[\w\-.~!$&'()*+,;=%:]*@)?/.source + // host
            ('(?:' + // IP-literal
            /\[(?:[0-9a-fA-F:.]{2,48}|v[0-9a-fA-F]+\.[\w\-.~!$&'()*+,;=]+)\]/.source + '|' + // IPv4address or registered name
            /[\w\-.~!$&'()*+,;=%]*/.source + ')') + // [ ":" port ]
            /(?::\d*)?/.source, 'm'),
            inside: {
                'authority-delimiter': /^\/\//,
                'user-info-segment': {
                    pattern: /^[\w\-.~!$&'()*+,;=%:]*@/,
                    inside: {
                        'user-info-delimiter': /@$/,
                        'user-info': /^[\w\-.~!$&'()*+,;=%:]+/
                    }
                },
                'port-segment': {
                    pattern: /:\d*$/,
                    inside: {
                        'port-delimiter': /^:/,
                        port: /^\d+/
                    }
                },
                host: {
                    pattern: /[\s\S]+/,
                    inside: {
                        'ip-literal': {
                            pattern: /^\[[\s\S]+\]$/,
                            inside: {
                                'ip-literal-delimiter': /^\[|\]$/,
                                'ipv-future': /^v[\s\S]+/,
                                'ipv6-address': /^[\s\S]+/
                            }
                        },
                        'ipv4-address': /^(?:(?:[03-9]\d?|[12]\d{0,2})\.){3}(?:[03-9]\d?|[12]\d{0,2})$/
                    }
                }
            }
        },
        path: {
            pattern: /^[\w\-.~!$&'()*+,;=%:@/]+/m,
            inside: {
                'path-separator': /\//
            }
        }
    };
    Prism.languages.url = Prism.languages.uri;
}

});

parcelRegister("6cZ4Y", function(module, exports) {
'use strict';
module.exports = $48533e248bcfaa00$var$v;
$48533e248bcfaa00$var$v.displayName = 'v';
$48533e248bcfaa00$var$v.aliases = [];
function $48533e248bcfaa00$var$v(Prism) {
    (function(Prism) {
        var interpolationExpr = {
            pattern: /[\s\S]+/,
            inside: null
        };
        Prism.languages.v = Prism.languages.extend('clike', {
            string: {
                pattern: /r?(["'])(?:\\(?:\r\n|[\s\S])|(?!\1)[^\\\r\n])*\1/,
                alias: 'quoted-string',
                greedy: true,
                inside: {
                    interpolation: {
                        pattern: /((?:^|[^\\])(?:\\{2})*)\$(?:\{[^{}]*\}|\w+(?:\.\w+(?:\([^\(\)]*\))?|\[[^\[\]]+\])*)/,
                        lookbehind: true,
                        inside: {
                            'interpolation-variable': {
                                pattern: /^\$\w[\s\S]*$/,
                                alias: 'variable'
                            },
                            'interpolation-punctuation': {
                                pattern: /^\$\{|\}$/,
                                alias: 'punctuation'
                            },
                            'interpolation-expression': interpolationExpr
                        }
                    }
                }
            },
            'class-name': {
                pattern: /(\b(?:enum|interface|struct|type)\s+)(?:C\.)?\w+/,
                lookbehind: true
            },
            keyword: /(?:\b(?:__global|as|asm|assert|atomic|break|chan|const|continue|defer|else|embed|enum|fn|for|go(?:to)?|if|import|in|interface|is|lock|match|module|mut|none|or|pub|return|rlock|select|shared|sizeof|static|struct|type(?:of)?|union|unsafe)|\$(?:else|for|if)|#(?:flag|include))\b/,
            number: /\b(?:0x[a-f\d]+(?:_[a-f\d]+)*|0b[01]+(?:_[01]+)*|0o[0-7]+(?:_[0-7]+)*|\d+(?:_\d+)*(?:\.\d+(?:_\d+)*)?)\b/i,
            operator: /~|\?|[*\/%^!=]=?|\+[=+]?|-[=-]?|\|[=|]?|&(?:=|&|\^=?)?|>(?:>=?|=)?|<(?:<=?|=|-)?|:=|\.\.\.?/,
            builtin: /\b(?:any(?:_float|_int)?|bool|byte(?:ptr)?|charptr|f(?:32|64)|i(?:8|16|64|128|nt)|rune|size_t|string|u(?:16|32|64|128)|voidptr)\b/
        });
        interpolationExpr.inside = Prism.languages.v;
        Prism.languages.insertBefore('v', 'string', {
            char: {
                pattern: /`(?:\\`|\\?[^`]{1,2})`/,
                // using {1,2} instead of `u` flag for compatibility
                alias: 'rune'
            }
        });
        Prism.languages.insertBefore('v', 'operator', {
            attribute: {
                pattern: /(^[\t ]*)\[(?:deprecated|direct_array_access|flag|inline|live|ref_only|typedef|unsafe_fn|windows_stdcall)\]/m,
                lookbehind: true,
                alias: 'annotation',
                inside: {
                    punctuation: /[\[\]]/,
                    keyword: /\w+/
                }
            },
            generic: {
                pattern: /<\w+>(?=\s*[\)\{])/,
                inside: {
                    punctuation: /[<>]/,
                    'class-name': /\w+/
                }
            }
        });
        Prism.languages.insertBefore('v', 'function', {
            'generic-function': {
                // e.g. foo<T>( ...
                pattern: /\b\w+\s*<\w+>(?=\()/,
                inside: {
                    function: /^\w+/,
                    generic: {
                        pattern: /<\w+>/,
                        inside: Prism.languages.v.generic.inside
                    }
                }
            }
        });
    })(Prism);
}

});

parcelRegister("l5f2Q", function(module, exports) {
'use strict';
module.exports = $f595bc30cef883f3$var$vala;
$f595bc30cef883f3$var$vala.displayName = 'vala';
$f595bc30cef883f3$var$vala.aliases = [];
function $f595bc30cef883f3$var$vala(Prism) {
    Prism.languages.vala = Prism.languages.extend('clike', {
        // Classes copied from prism-csharp
        'class-name': [
            {
                // (Foo bar, Bar baz)
                pattern: /\b[A-Z]\w*(?:\.\w+)*\b(?=(?:\?\s+|\*?\s+\*?)\w)/,
                inside: {
                    punctuation: /\./
                }
            },
            {
                // [Foo]
                pattern: /(\[)[A-Z]\w*(?:\.\w+)*\b/,
                lookbehind: true,
                inside: {
                    punctuation: /\./
                }
            },
            {
                // class Foo : Bar
                pattern: /(\b(?:class|interface)\s+[A-Z]\w*(?:\.\w+)*\s*:\s*)[A-Z]\w*(?:\.\w+)*\b/,
                lookbehind: true,
                inside: {
                    punctuation: /\./
                }
            },
            {
                // class Foo
                pattern: /((?:\b(?:class|enum|interface|new|struct)\s+)|(?:catch\s+\())[A-Z]\w*(?:\.\w+)*\b/,
                lookbehind: true,
                inside: {
                    punctuation: /\./
                }
            }
        ],
        keyword: /\b(?:abstract|as|assert|async|base|bool|break|case|catch|char|class|const|construct|continue|default|delegate|delete|do|double|dynamic|else|ensures|enum|errordomain|extern|finally|float|for|foreach|get|if|in|inline|int|int16|int32|int64|int8|interface|internal|is|lock|long|namespace|new|null|out|override|owned|params|private|protected|public|ref|requires|return|set|short|signal|sizeof|size_t|ssize_t|static|string|struct|switch|this|throw|throws|try|typeof|uchar|uint|uint16|uint32|uint64|uint8|ulong|unichar|unowned|ushort|using|value|var|virtual|void|volatile|weak|while|yield)\b/i,
        function: /\b\w+(?=\s*\()/,
        number: /(?:\b0x[\da-f]+\b|(?:\b\d+(?:\.\d*)?|\B\.\d+)(?:e[+-]?\d+)?)(?:f|u?l?)?/i,
        operator: /\+\+|--|&&|\|\||<<=?|>>=?|=>|->|~|[+\-*\/%&^|=!<>]=?|\?\??|\.\.\./,
        punctuation: /[{}[\];(),.:]/,
        constant: /\b[A-Z0-9_]+\b/
    });
    Prism.languages.insertBefore('vala', 'string', {
        'raw-string': {
            pattern: /"""[\s\S]*?"""/,
            greedy: true,
            alias: 'string'
        },
        'template-string': {
            pattern: /@"[\s\S]*?"/,
            greedy: true,
            inside: {
                interpolation: {
                    pattern: /\$(?:\([^)]*\)|[a-zA-Z]\w*)/,
                    inside: {
                        delimiter: {
                            pattern: /^\$\(?|\)$/,
                            alias: 'punctuation'
                        },
                        rest: Prism.languages.vala
                    }
                },
                string: /[\s\S]+/
            }
        }
    });
    Prism.languages.insertBefore('vala', 'keyword', {
        regex: {
            pattern: /\/(?:\[(?:[^\]\\\r\n]|\\.)*\]|\\.|[^/\\\[\r\n])+\/[imsx]{0,4}(?=\s*(?:$|[\r\n,.;})\]]))/,
            greedy: true,
            inside: {
                'regex-source': {
                    pattern: /^(\/)[\s\S]+(?=\/[a-z]*$)/,
                    lookbehind: true,
                    alias: 'language-regex',
                    inside: Prism.languages.regex
                },
                'regex-delimiter': /^\//,
                'regex-flags': /^[a-z]+$/
            }
        }
    });
}

});

parcelRegister("bo5oF", function(module, exports) {
'use strict';
module.exports = $84a61f4fd7b97094$var$velocity;
$84a61f4fd7b97094$var$velocity.displayName = 'velocity';
$84a61f4fd7b97094$var$velocity.aliases = [];
function $84a61f4fd7b97094$var$velocity(Prism) {
    (function(Prism) {
        Prism.languages.velocity = Prism.languages.extend('markup', {});
        var velocity = {
            variable: {
                pattern: /(^|[^\\](?:\\\\)*)\$!?(?:[a-z][\w-]*(?:\([^)]*\))?(?:\.[a-z][\w-]*(?:\([^)]*\))?|\[[^\]]+\])*|\{[^}]+\})/i,
                lookbehind: true,
                inside: {} // See below
            },
            string: {
                pattern: /"[^"]*"|'[^']*'/,
                greedy: true
            },
            number: /\b\d+\b/,
            boolean: /\b(?:false|true)\b/,
            operator: /[=!<>]=?|[+*/%-]|&&|\|\||\.\.|\b(?:eq|g[et]|l[et]|n(?:e|ot))\b/,
            punctuation: /[(){}[\]:,.]/
        };
        velocity.variable.inside = {
            string: velocity['string'],
            function: {
                pattern: /([^\w-])[a-z][\w-]*(?=\()/,
                lookbehind: true
            },
            number: velocity['number'],
            boolean: velocity['boolean'],
            punctuation: velocity['punctuation']
        };
        Prism.languages.insertBefore('velocity', 'comment', {
            unparsed: {
                pattern: /(^|[^\\])#\[\[[\s\S]*?\]\]#/,
                lookbehind: true,
                greedy: true,
                inside: {
                    punctuation: /^#\[\[|\]\]#$/
                }
            },
            'velocity-comment': [
                {
                    pattern: /(^|[^\\])#\*[\s\S]*?\*#/,
                    lookbehind: true,
                    greedy: true,
                    alias: 'comment'
                },
                {
                    pattern: /(^|[^\\])##.*/,
                    lookbehind: true,
                    greedy: true,
                    alias: 'comment'
                }
            ],
            directive: {
                pattern: /(^|[^\\](?:\\\\)*)#@?(?:[a-z][\w-]*|\{[a-z][\w-]*\})(?:\s*\((?:[^()]|\([^()]*\))*\))?/i,
                lookbehind: true,
                inside: {
                    keyword: {
                        pattern: /^#@?(?:[a-z][\w-]*|\{[a-z][\w-]*\})|\bin\b/,
                        inside: {
                            punctuation: /[{}]/
                        }
                    },
                    rest: velocity
                }
            },
            variable: velocity['variable']
        });
        Prism.languages.velocity['tag'].inside['attr-value'].inside.rest = Prism.languages.velocity;
    })(Prism);
}

});

parcelRegister("8NhMH", function(module, exports) {
'use strict';
module.exports = $6670b1fb810b9014$var$verilog;
$6670b1fb810b9014$var$verilog.displayName = 'verilog';
$6670b1fb810b9014$var$verilog.aliases = [];
function $6670b1fb810b9014$var$verilog(Prism) {
    Prism.languages.verilog = {
        comment: {
            pattern: /\/\/.*|\/\*[\s\S]*?\*\//,
            greedy: true
        },
        string: {
            pattern: /"(?:\\(?:\r\n|[\s\S])|[^"\\\r\n])*"/,
            greedy: true
        },
        'kernel-function': {
            // support for any kernel function (ex: $display())
            pattern: /\B\$\w+\b/,
            alias: 'property'
        },
        // support for user defined constants (ex: `define)
        constant: /\B`\w+\b/,
        function: /\b\w+(?=\()/,
        // support for verilog and system verilog keywords
        keyword: /\b(?:alias|and|assert|assign|assume|automatic|before|begin|bind|bins|binsof|bit|break|buf|bufif0|bufif1|byte|case|casex|casez|cell|chandle|class|clocking|cmos|config|const|constraint|context|continue|cover|covergroup|coverpoint|cross|deassign|default|defparam|design|disable|dist|do|edge|else|end|endcase|endclass|endclocking|endconfig|endfunction|endgenerate|endgroup|endinterface|endmodule|endpackage|endprimitive|endprogram|endproperty|endsequence|endspecify|endtable|endtask|enum|event|expect|export|extends|extern|final|first_match|for|force|foreach|forever|fork|forkjoin|function|generate|genvar|highz0|highz1|if|iff|ifnone|ignore_bins|illegal_bins|import|incdir|include|initial|inout|input|inside|instance|int|integer|interface|intersect|join|join_any|join_none|large|liblist|library|local|localparam|logic|longint|macromodule|matches|medium|modport|module|nand|negedge|new|nmos|nor|noshowcancelled|not|notif0|notif1|null|or|output|package|packed|parameter|pmos|posedge|primitive|priority|program|property|protected|pull0|pull1|pulldown|pullup|pulsestyle_ondetect|pulsestyle_onevent|pure|rand|randc|randcase|randsequence|rcmos|real|realtime|ref|reg|release|repeat|return|rnmos|rpmos|rtran|rtranif0|rtranif1|scalared|sequence|shortint|shortreal|showcancelled|signed|small|solve|specify|specparam|static|string|strong0|strong1|struct|super|supply0|supply1|table|tagged|task|this|throughout|time|timeprecision|timeunit|tran|tranif0|tranif1|tri|tri0|tri1|triand|trior|trireg|type|typedef|union|unique|unsigned|use|uwire|var|vectored|virtual|void|wait|wait_order|wand|weak0|weak1|while|wildcard|wire|with|within|wor|xnor|xor)\b/,
        // bold highlighting for all verilog and system verilog logic blocks
        important: /\b(?:always|always_comb|always_ff|always_latch)\b(?: *@)?/,
        // support for time ticks, vectors, and real numbers
        number: /\B##?\d+|(?:\b\d+)?'[odbh] ?[\da-fzx_?]+|\b(?:\d*[._])?\d+(?:e[-+]?\d+)?/i,
        operator: /[-+{}^~%*\/?=!<>&|]+/,
        punctuation: /[[\];(),.:]/
    };
}

});

parcelRegister("k195P", function(module, exports) {
'use strict';
module.exports = $e92af4533c60f30a$var$vhdl;
$e92af4533c60f30a$var$vhdl.displayName = 'vhdl';
$e92af4533c60f30a$var$vhdl.aliases = [];
function $e92af4533c60f30a$var$vhdl(Prism) {
    Prism.languages.vhdl = {
        comment: /--.+/,
        // support for all logic vectors
        'vhdl-vectors': {
            pattern: /\b[oxb]"[\da-f_]+"|"[01uxzwlh-]+"/i,
            alias: 'number'
        },
        // support for operator overloading included
        'quoted-function': {
            pattern: /"\S+?"(?=\()/,
            alias: 'function'
        },
        string: /"(?:[^\\"\r\n]|\\(?:\r\n|[\s\S]))*"/,
        constant: /\b(?:library|use)\b/i,
        // support for predefined attributes included
        keyword: /\b(?:'active|'ascending|'base|'delayed|'driving|'driving_value|'event|'high|'image|'instance_name|'last_active|'last_event|'last_value|'left|'leftof|'length|'low|'path_name|'pos|'pred|'quiet|'range|'reverse_range|'right|'rightof|'simple_name|'stable|'succ|'transaction|'val|'value|access|after|alias|all|architecture|array|assert|attribute|begin|block|body|buffer|bus|case|component|configuration|constant|disconnect|downto|else|elsif|end|entity|exit|file|for|function|generate|generic|group|guarded|if|impure|in|inertial|inout|is|label|library|linkage|literal|loop|map|new|next|null|of|on|open|others|out|package|port|postponed|procedure|process|pure|range|record|register|reject|report|return|select|severity|shared|signal|subtype|then|to|transport|type|unaffected|units|until|use|variable|wait|when|while|with)\b/i,
        boolean: /\b(?:false|true)\b/i,
        function: /\w+(?=\()/,
        // decimal, based, physical, and exponential numbers supported
        number: /'[01uxzwlh-]'|\b(?:\d+#[\da-f_.]+#|\d[\d_.]*)(?:e[-+]?\d+)?/i,
        operator: /[<>]=?|:=|[-+*/&=]|\b(?:abs|and|mod|nand|nor|not|or|rem|rol|ror|sla|sll|sra|srl|xnor|xor)\b/i,
        punctuation: /[{}[\];(),.:]/
    };
}

});

parcelRegister("9Mghs", function(module, exports) {
'use strict';
module.exports = $71e539bec430c93f$var$vim;
$71e539bec430c93f$var$vim.displayName = 'vim';
$71e539bec430c93f$var$vim.aliases = [];
function $71e539bec430c93f$var$vim(Prism) {
    Prism.languages.vim = {
        string: /"(?:[^"\\\r\n]|\\.)*"|'(?:[^'\r\n]|'')*'/,
        comment: /".*/,
        function: /\b\w+(?=\()/,
        keyword: /\b(?:N|Next|P|Print|X|XMLent|XMLns|ab|abbreviate|abc|abclear|abo|aboveleft|al|all|ar|arga|argadd|argd|argdelete|argdo|arge|argedit|argg|argglobal|argl|arglocal|args|argu|argument|as|ascii|b|bN|bNext|ba|bad|badd|ball|bd|bdelete|be|bel|belowright|bf|bfirst|bl|blast|bm|bmodified|bn|bnext|bo|botright|bp|bprevious|br|brea|break|breaka|breakadd|breakd|breakdel|breakl|breaklist|brewind|bro|browse|bufdo|buffer|buffers|bun|bunload|bw|bwipeout|c|cN|cNext|cNfcNfile|ca|cabbrev|cabc|cabclear|cad|caddb|caddbuffer|caddexpr|caddf|caddfile|cal|call|cat|catch|cb|cbuffer|cc|ccl|cclose|cd|ce|center|cex|cexpr|cf|cfile|cfir|cfirst|cg|cgetb|cgetbuffer|cgete|cgetexpr|cgetfile|change|changes|chd|chdir|che|checkpath|checkt|checktime|cl|cla|clast|clist|clo|close|cmapc|cmapclear|cn|cnew|cnewer|cnext|cnf|cnfile|cnorea|cnoreabbrev|co|col|colder|colo|colorscheme|comc|comclear|comp|compiler|con|conf|confirm|continue|cope|copen|copy|cp|cpf|cpfile|cprevious|cq|cquit|cr|crewind|cu|cuna|cunabbrev|cunmap|cw|cwindow|d|debugg|debuggreedy|delc|delcommand|delete|delf|delfunction|delm|delmarks|di|diffg|diffget|diffoff|diffpatch|diffpu|diffput|diffsplit|diffthis|diffu|diffupdate|dig|digraphs|display|dj|djump|dl|dlist|dr|drop|ds|dsearch|dsp|dsplit|e|earlier|echoe|echoerr|echom|echomsg|echon|edit|el|else|elsei|elseif|em|emenu|en|endf|endfo|endfor|endfun|endfunction|endif|endt|endtry|endw|endwhile|ene|enew|ex|exi|exit|exu|exusage|f|file|files|filetype|fin|fina|finally|find|fini|finish|fir|first|fix|fixdel|fo|fold|foldc|foldclose|foldd|folddoc|folddoclosed|folddoopen|foldo|foldopen|for|fu|fun|function|go|goto|gr|grep|grepa|grepadd|h|ha|hardcopy|help|helpf|helpfind|helpg|helpgrep|helpt|helptags|hid|hide|his|history|ia|iabbrev|iabc|iabclear|if|ij|ijump|il|ilist|imapc|imapclear|in|inorea|inoreabbrev|isearch|isp|isplit|iu|iuna|iunabbrev|iunmap|j|join|ju|jumps|k|kee|keepalt|keepj|keepjumps|keepmarks|l|lN|lNext|lNf|lNfile|la|lad|laddb|laddbuffer|laddexpr|laddf|laddfile|lan|language|last|later|lb|lbuffer|lc|lcd|lch|lchdir|lcl|lclose|left|lefta|leftabove|let|lex|lexpr|lf|lfile|lfir|lfirst|lg|lgetb|lgetbuffer|lgete|lgetexpr|lgetfile|lgr|lgrep|lgrepa|lgrepadd|lh|lhelpgrep|list|ll|lla|llast|lli|llist|lm|lmak|lmake|lmap|lmapc|lmapclear|ln|lne|lnew|lnewer|lnext|lnf|lnfile|lnoremap|lo|loadview|loc|lockmarks|lockv|lockvar|lol|lolder|lop|lopen|lp|lpf|lpfile|lprevious|lr|lrewind|ls|lt|ltag|lu|lunmap|lv|lvimgrep|lvimgrepa|lvimgrepadd|lw|lwindow|m|ma|mak|make|mark|marks|mat|match|menut|menutranslate|mk|mkexrc|mks|mksession|mksp|mkspell|mkv|mkvie|mkview|mkvimrc|mod|mode|move|mz|mzf|mzfile|mzscheme|n|nbkey|new|next|nmapc|nmapclear|noh|nohlsearch|norea|noreabbrev|nu|number|nun|nunmap|o|omapc|omapclear|on|only|open|opt|options|ou|ounmap|p|pc|pclose|pe|ped|pedit|perl|perld|perldo|po|pop|popu|popup|pp|ppop|pre|preserve|prev|previous|print|prof|profd|profdel|profile|promptf|promptfind|promptr|promptrepl|ps|psearch|ptN|ptNext|pta|ptag|ptf|ptfirst|ptj|ptjump|ptl|ptlast|ptn|ptnext|ptp|ptprevious|ptr|ptrewind|pts|ptselect|pu|put|pw|pwd|py|pyf|pyfile|python|q|qa|qall|quit|quita|quitall|r|read|rec|recover|red|redi|redir|redo|redr|redraw|redraws|redrawstatus|reg|registers|res|resize|ret|retab|retu|return|rew|rewind|ri|right|rightb|rightbelow|ru|rub|ruby|rubyd|rubydo|rubyf|rubyfile|runtime|rv|rviminfo|sN|sNext|sa|sal|sall|san|sandbox|sargument|sav|saveas|sb|sbN|sbNext|sba|sball|sbf|sbfirst|sbl|sblast|sbm|sbmodified|sbn|sbnext|sbp|sbprevious|sbr|sbrewind|sbuffer|scrip|scripte|scriptencoding|scriptnames|se|set|setf|setfiletype|setg|setglobal|setl|setlocal|sf|sfind|sfir|sfirst|sh|shell|sign|sil|silent|sim|simalt|sl|sla|slast|sleep|sm|smagic|smap|smapc|smapclear|sme|smenu|sn|snext|sni|sniff|sno|snomagic|snor|snoremap|snoreme|snoremenu|so|sor|sort|source|sp|spe|spelld|spelldump|spellgood|spelli|spellinfo|spellr|spellrepall|spellu|spellundo|spellw|spellwrong|split|spr|sprevious|sre|srewind|st|sta|stag|star|startg|startgreplace|startinsert|startr|startreplace|stj|stjump|stop|stopi|stopinsert|sts|stselect|sun|sunhide|sunm|sunmap|sus|suspend|sv|sview|syncbind|t|tN|tNext|ta|tab|tabN|tabNext|tabc|tabclose|tabd|tabdo|tabe|tabedit|tabf|tabfind|tabfir|tabfirst|tabl|tablast|tabm|tabmove|tabn|tabnew|tabnext|tabo|tabonly|tabp|tabprevious|tabr|tabrewind|tabs|tag|tags|tc|tcl|tcld|tcldo|tclf|tclfile|te|tearoff|tf|tfirst|th|throw|tj|tjump|tl|tlast|tm|tmenu|tn|tnext|to|topleft|tp|tprevious|tr|trewind|try|ts|tselect|tu|tunmenu|u|una|unabbreviate|undo|undoj|undojoin|undol|undolist|unh|unhide|unlet|unlo|unlockvar|unm|unmap|up|update|ve|verb|verbose|version|vert|vertical|vi|vie|view|vim|vimgrep|vimgrepa|vimgrepadd|visual|viu|viusage|vmapc|vmapclear|vne|vnew|vs|vsplit|vu|vunmap|w|wN|wNext|wa|wall|wh|while|win|winc|wincmd|windo|winp|winpos|winsize|wn|wnext|wp|wprevious|wq|wqa|wqall|write|ws|wsverb|wv|wviminfo|x|xa|xall|xit|xm|xmap|xmapc|xmapclear|xme|xmenu|xn|xnoremap|xnoreme|xnoremenu|xu|xunmap|y|yank)\b/,
        builtin: /\b(?:acd|ai|akm|aleph|allowrevins|altkeymap|ambiwidth|ambw|anti|antialias|arab|arabic|arabicshape|ari|arshape|autochdir|autocmd|autoindent|autoread|autowrite|autowriteall|aw|awa|background|backspace|backup|backupcopy|backupdir|backupext|backupskip|balloondelay|ballooneval|balloonexpr|bdir|bdlay|beval|bex|bexpr|bg|bh|bin|binary|biosk|bioskey|bk|bkc|bomb|breakat|brk|browsedir|bs|bsdir|bsk|bt|bufhidden|buflisted|buftype|casemap|ccv|cdpath|cedit|cfu|ch|charconvert|ci|cin|cindent|cink|cinkeys|cino|cinoptions|cinw|cinwords|clipboard|cmdheight|cmdwinheight|cmp|cms|columns|com|comments|commentstring|compatible|complete|completefunc|completeopt|consk|conskey|copyindent|cot|cpo|cpoptions|cpt|cscopepathcomp|cscopeprg|cscopequickfix|cscopetag|cscopetagorder|cscopeverbose|cspc|csprg|csqf|cst|csto|csverb|cuc|cul|cursorcolumn|cursorline|cwh|debug|deco|def|define|delcombine|dex|dg|dict|dictionary|diff|diffexpr|diffopt|digraph|dip|dir|directory|dy|ea|ead|eadirection|eb|ed|edcompatible|ef|efm|ei|ek|enc|encoding|endofline|eol|ep|equalalways|equalprg|errorbells|errorfile|errorformat|esckeys|et|eventignore|expandtab|exrc|fcl|fcs|fdc|fde|fdi|fdl|fdls|fdm|fdn|fdo|fdt|fen|fenc|fencs|fex|ff|ffs|fileencoding|fileencodings|fileformat|fileformats|fillchars|fk|fkmap|flp|fml|fmr|foldcolumn|foldenable|foldexpr|foldignore|foldlevel|foldlevelstart|foldmarker|foldmethod|foldminlines|foldnestmax|foldtext|formatexpr|formatlistpat|formatoptions|formatprg|fp|fs|fsync|ft|gcr|gd|gdefault|gfm|gfn|gfs|gfw|ghr|gp|grepformat|grepprg|gtl|gtt|guicursor|guifont|guifontset|guifontwide|guiheadroom|guioptions|guipty|guitablabel|guitabtooltip|helpfile|helpheight|helplang|hf|hh|hi|hidden|highlight|hk|hkmap|hkmapp|hkp|hl|hlg|hls|hlsearch|ic|icon|iconstring|ignorecase|im|imactivatekey|imak|imc|imcmdline|imd|imdisable|imi|iminsert|ims|imsearch|inc|include|includeexpr|incsearch|inde|indentexpr|indentkeys|indk|inex|inf|infercase|insertmode|invacd|invai|invakm|invallowrevins|invaltkeymap|invanti|invantialias|invar|invarab|invarabic|invarabicshape|invari|invarshape|invautochdir|invautoindent|invautoread|invautowrite|invautowriteall|invaw|invawa|invbackup|invballooneval|invbeval|invbin|invbinary|invbiosk|invbioskey|invbk|invbl|invbomb|invbuflisted|invcf|invci|invcin|invcindent|invcompatible|invconfirm|invconsk|invconskey|invcopyindent|invcp|invcscopetag|invcscopeverbose|invcst|invcsverb|invcuc|invcul|invcursorcolumn|invcursorline|invdeco|invdelcombine|invdg|invdiff|invdigraph|invdisable|invea|inveb|inved|invedcompatible|invek|invendofline|inveol|invequalalways|inverrorbells|invesckeys|invet|invex|invexpandtab|invexrc|invfen|invfk|invfkmap|invfoldenable|invgd|invgdefault|invguipty|invhid|invhidden|invhk|invhkmap|invhkmapp|invhkp|invhls|invhlsearch|invic|invicon|invignorecase|invim|invimc|invimcmdline|invimd|invincsearch|invinf|invinfercase|invinsertmode|invis|invjoinspaces|invjs|invlazyredraw|invlbr|invlinebreak|invlisp|invlist|invloadplugins|invlpl|invlz|invma|invmacatsui|invmagic|invmh|invml|invmod|invmodeline|invmodifiable|invmodified|invmore|invmousef|invmousefocus|invmousehide|invnu|invnumber|invodev|invopendevice|invpaste|invpi|invpreserveindent|invpreviewwindow|invprompt|invpvw|invreadonly|invremap|invrestorescreen|invrevins|invri|invrightleft|invrightleftcmd|invrl|invrlc|invro|invrs|invru|invruler|invsb|invsc|invscb|invscrollbind|invscs|invsecure|invsft|invshellslash|invshelltemp|invshiftround|invshortname|invshowcmd|invshowfulltag|invshowmatch|invshowmode|invsi|invsm|invsmartcase|invsmartindent|invsmarttab|invsmd|invsn|invsol|invspell|invsplitbelow|invsplitright|invspr|invsr|invssl|invsta|invstartofline|invstmp|invswapfile|invswf|invta|invtagbsearch|invtagrelative|invtagstack|invtbi|invtbidi|invtbs|invtermbidi|invterse|invtextauto|invtextmode|invtf|invtgst|invtildeop|invtimeout|invtitle|invto|invtop|invtr|invttimeout|invttybuiltin|invttyfast|invtx|invvb|invvisualbell|invwa|invwarn|invwb|invweirdinvert|invwfh|invwfw|invwildmenu|invwinfixheight|invwinfixwidth|invwiv|invwmnu|invwrap|invwrapscan|invwrite|invwriteany|invwritebackup|invws|isf|isfname|isi|isident|isk|iskeyword|isprint|joinspaces|js|key|keymap|keymodel|keywordprg|km|kmp|kp|langmap|langmenu|laststatus|lazyredraw|lbr|lcs|linebreak|lines|linespace|lisp|lispwords|listchars|loadplugins|lpl|lsp|lz|macatsui|magic|makeef|makeprg|matchpairs|matchtime|maxcombine|maxfuncdepth|maxmapdepth|maxmem|maxmempattern|maxmemtot|mco|mef|menuitems|mfd|mh|mis|mkspellmem|ml|mls|mm|mmd|mmp|mmt|modeline|modelines|modifiable|modified|more|mouse|mousef|mousefocus|mousehide|mousem|mousemodel|mouses|mouseshape|mouset|mousetime|mp|mps|msm|mzq|mzquantum|nf|noacd|noai|noakm|noallowrevins|noaltkeymap|noanti|noantialias|noar|noarab|noarabic|noarabicshape|noari|noarshape|noautochdir|noautoindent|noautoread|noautowrite|noautowriteall|noaw|noawa|nobackup|noballooneval|nobeval|nobin|nobinary|nobiosk|nobioskey|nobk|nobl|nobomb|nobuflisted|nocf|noci|nocin|nocindent|nocompatible|noconfirm|noconsk|noconskey|nocopyindent|nocp|nocscopetag|nocscopeverbose|nocst|nocsverb|nocuc|nocul|nocursorcolumn|nocursorline|nodeco|nodelcombine|nodg|nodiff|nodigraph|nodisable|noea|noeb|noed|noedcompatible|noek|noendofline|noeol|noequalalways|noerrorbells|noesckeys|noet|noex|noexpandtab|noexrc|nofen|nofk|nofkmap|nofoldenable|nogd|nogdefault|noguipty|nohid|nohidden|nohk|nohkmap|nohkmapp|nohkp|nohls|noic|noicon|noignorecase|noim|noimc|noimcmdline|noimd|noincsearch|noinf|noinfercase|noinsertmode|nois|nojoinspaces|nojs|nolazyredraw|nolbr|nolinebreak|nolisp|nolist|noloadplugins|nolpl|nolz|noma|nomacatsui|nomagic|nomh|noml|nomod|nomodeline|nomodifiable|nomodified|nomore|nomousef|nomousefocus|nomousehide|nonu|nonumber|noodev|noopendevice|nopaste|nopi|nopreserveindent|nopreviewwindow|noprompt|nopvw|noreadonly|noremap|norestorescreen|norevins|nori|norightleft|norightleftcmd|norl|norlc|noro|nors|noru|noruler|nosb|nosc|noscb|noscrollbind|noscs|nosecure|nosft|noshellslash|noshelltemp|noshiftround|noshortname|noshowcmd|noshowfulltag|noshowmatch|noshowmode|nosi|nosm|nosmartcase|nosmartindent|nosmarttab|nosmd|nosn|nosol|nospell|nosplitbelow|nosplitright|nospr|nosr|nossl|nosta|nostartofline|nostmp|noswapfile|noswf|nota|notagbsearch|notagrelative|notagstack|notbi|notbidi|notbs|notermbidi|noterse|notextauto|notextmode|notf|notgst|notildeop|notimeout|notitle|noto|notop|notr|nottimeout|nottybuiltin|nottyfast|notx|novb|novisualbell|nowa|nowarn|nowb|noweirdinvert|nowfh|nowfw|nowildmenu|nowinfixheight|nowinfixwidth|nowiv|nowmnu|nowrap|nowrapscan|nowrite|nowriteany|nowritebackup|nows|nrformats|numberwidth|nuw|odev|oft|ofu|omnifunc|opendevice|operatorfunc|opfunc|osfiletype|pa|para|paragraphs|paste|pastetoggle|patchexpr|patchmode|path|pdev|penc|pex|pexpr|pfn|ph|pheader|pi|pm|pmbcs|pmbfn|popt|preserveindent|previewheight|previewwindow|printdevice|printencoding|printexpr|printfont|printheader|printmbcharset|printmbfont|printoptions|prompt|pt|pumheight|pvh|pvw|qe|quoteescape|readonly|remap|report|restorescreen|revins|rightleft|rightleftcmd|rl|rlc|ro|rs|rtp|ruf|ruler|rulerformat|runtimepath|sbo|sc|scb|scr|scroll|scrollbind|scrolljump|scrolloff|scrollopt|scs|sect|sections|secure|sel|selection|selectmode|sessionoptions|sft|shcf|shellcmdflag|shellpipe|shellquote|shellredir|shellslash|shelltemp|shelltype|shellxquote|shiftround|shiftwidth|shm|shortmess|shortname|showbreak|showcmd|showfulltag|showmatch|showmode|showtabline|shq|si|sidescroll|sidescrolloff|siso|sj|slm|smartcase|smartindent|smarttab|smc|smd|softtabstop|sol|spc|spell|spellcapcheck|spellfile|spelllang|spellsuggest|spf|spl|splitbelow|splitright|sps|sr|srr|ss|ssl|ssop|stal|startofline|statusline|stl|stmp|su|sua|suffixes|suffixesadd|sw|swapfile|swapsync|swb|swf|switchbuf|sws|sxq|syn|synmaxcol|syntax|t_AB|t_AF|t_AL|t_CS|t_CV|t_Ce|t_Co|t_Cs|t_DL|t_EI|t_F1|t_F2|t_F3|t_F4|t_F5|t_F6|t_F7|t_F8|t_F9|t_IE|t_IS|t_K1|t_K3|t_K4|t_K5|t_K6|t_K7|t_K8|t_K9|t_KA|t_KB|t_KC|t_KD|t_KE|t_KF|t_KG|t_KH|t_KI|t_KJ|t_KK|t_KL|t_RI|t_RV|t_SI|t_Sb|t_Sf|t_WP|t_WS|t_ZH|t_ZR|t_al|t_bc|t_cd|t_ce|t_cl|t_cm|t_cs|t_da|t_db|t_dl|t_fs|t_k1|t_k2|t_k3|t_k4|t_k5|t_k6|t_k7|t_k8|t_k9|t_kB|t_kD|t_kI|t_kN|t_kP|t_kb|t_kd|t_ke|t_kh|t_kl|t_kr|t_ks|t_ku|t_le|t_mb|t_md|t_me|t_mr|t_ms|t_nd|t_op|t_se|t_so|t_sr|t_te|t_ti|t_ts|t_ue|t_us|t_ut|t_vb|t_ve|t_vi|t_vs|t_xs|tabline|tabpagemax|tabstop|tagbsearch|taglength|tagrelative|tagstack|tal|tb|tbi|tbidi|tbis|tbs|tenc|term|termbidi|termencoding|terse|textauto|textmode|textwidth|tgst|thesaurus|tildeop|timeout|timeoutlen|title|titlelen|titleold|titlestring|toolbar|toolbariconsize|top|tpm|tsl|tsr|ttimeout|ttimeoutlen|ttm|tty|ttybuiltin|ttyfast|ttym|ttymouse|ttyscroll|ttytype|tw|tx|uc|ul|undolevels|updatecount|updatetime|ut|vb|vbs|vdir|verbosefile|vfile|viewdir|viewoptions|viminfo|virtualedit|visualbell|vop|wak|warn|wb|wc|wcm|wd|weirdinvert|wfh|wfw|whichwrap|wi|wig|wildchar|wildcharm|wildignore|wildmenu|wildmode|wildoptions|wim|winaltkeys|window|winfixheight|winfixwidth|winheight|winminheight|winminwidth|winwidth|wiv|wiw|wm|wmh|wmnu|wmw|wop|wrap|wrapmargin|wrapscan|writeany|writebackup|writedelay|ww)\b/,
        number: /\b(?:0x[\da-f]+|\d+(?:\.\d+)?)\b/i,
        operator: /\|\||&&|[-+.]=?|[=!](?:[=~][#?]?)?|[<>]=?[#?]?|[*\/%?]|\b(?:is(?:not)?)\b/,
        punctuation: /[{}[\](),;:]/
    };
}

});

parcelRegister("8fjLw", function(module, exports) {
'use strict';
module.exports = $600f0e794c0c0fac$var$visualBasic;
$600f0e794c0c0fac$var$visualBasic.displayName = 'visualBasic';
$600f0e794c0c0fac$var$visualBasic.aliases = [];
function $600f0e794c0c0fac$var$visualBasic(Prism) {
    Prism.languages['visual-basic'] = {
        comment: {
            pattern: /(?:['‘’]|REM\b)(?:[^\r\n_]|_(?:\r\n?|\n)?)*/i,
            inside: {
                keyword: /^REM/i
            }
        },
        directive: {
            pattern: /#(?:Const|Else|ElseIf|End|ExternalChecksum|ExternalSource|If|Region)(?:\b_[ \t]*(?:\r\n?|\n)|.)+/i,
            alias: 'property',
            greedy: true
        },
        string: {
            pattern: /\$?["“”](?:["“”]{2}|[^"“”])*["“”]C?/i,
            greedy: true
        },
        date: {
            pattern: /#[ \t]*(?:\d+([/-])\d+\1\d+(?:[ \t]+(?:\d+[ \t]*(?:AM|PM)|\d+:\d+(?::\d+)?(?:[ \t]*(?:AM|PM))?))?|\d+[ \t]*(?:AM|PM)|\d+:\d+(?::\d+)?(?:[ \t]*(?:AM|PM))?)[ \t]*#/i,
            alias: 'number'
        },
        number: /(?:(?:\b\d+(?:\.\d+)?|\.\d+)(?:E[+-]?\d+)?|&[HO][\dA-F]+)(?:[FRD]|U?[ILS])?/i,
        boolean: /\b(?:False|Nothing|True)\b/i,
        keyword: /\b(?:AddHandler|AddressOf|Alias|And(?:Also)?|As|Boolean|ByRef|Byte|ByVal|Call|Case|Catch|C(?:Bool|Byte|Char|Date|Dbl|Dec|Int|Lng|Obj|SByte|Short|Sng|Str|Type|UInt|ULng|UShort)|Char|Class|Const|Continue|Currency|Date|Decimal|Declare|Default|Delegate|Dim|DirectCast|Do|Double|Each|Else(?:If)?|End(?:If)?|Enum|Erase|Error|Event|Exit|Finally|For|Friend|Function|Get(?:Type|XMLNamespace)?|Global|GoSub|GoTo|Handles|If|Implements|Imports|In|Inherits|Integer|Interface|Is|IsNot|Let|Lib|Like|Long|Loop|Me|Mod|Module|Must(?:Inherit|Override)|My(?:Base|Class)|Namespace|Narrowing|New|Next|Not(?:Inheritable|Overridable)?|Object|Of|On|Operator|Option(?:al)?|Or(?:Else)?|Out|Overloads|Overridable|Overrides|ParamArray|Partial|Private|Property|Protected|Public|RaiseEvent|ReadOnly|ReDim|RemoveHandler|Resume|Return|SByte|Select|Set|Shadows|Shared|short|Single|Static|Step|Stop|String|Structure|Sub|SyncLock|Then|Throw|To|Try|TryCast|Type|TypeOf|U(?:Integer|Long|Short)|Until|Using|Variant|Wend|When|While|Widening|With(?:Events)?|WriteOnly|Xor)\b/i,
        operator: /[+\-*/\\^<=>&#@$%!]|\b_(?=[ \t]*[\r\n])/,
        punctuation: /[{}().,:?]/
    };
    Prism.languages.vb = Prism.languages['visual-basic'];
    Prism.languages.vba = Prism.languages['visual-basic'];
}

});

parcelRegister("imGum", function(module, exports) {
'use strict';
module.exports = $d5eb3d6a0e52590c$var$warpscript;
$d5eb3d6a0e52590c$var$warpscript.displayName = 'warpscript';
$d5eb3d6a0e52590c$var$warpscript.aliases = [];
function $d5eb3d6a0e52590c$var$warpscript(Prism) {
    Prism.languages.warpscript = {
        comment: /#.*|\/\/.*|\/\*[\s\S]*?\*\//,
        string: {
            pattern: /"(?:[^"\\\r\n]|\\.)*"|'(?:[^'\\\r\n]|\\.)*'|<'(?:[^\\']|'(?!>)|\\.)*'>/,
            greedy: true
        },
        variable: /\$\S+/,
        macro: {
            pattern: /@\S+/,
            alias: 'property'
        },
        // WarpScript doesn't have any keywords, these are all functions under the control category
        // https://www.warp10.io/tags/control
        keyword: /\b(?:BREAK|CHECKMACRO|CONTINUE|CUDF|DEFINED|DEFINEDMACRO|EVAL|FAIL|FOR|FOREACH|FORSTEP|IFT|IFTE|MSGFAIL|NRETURN|RETHROW|RETURN|SWITCH|TRY|UDF|UNTIL|WHILE)\b/,
        number: /[+-]?\b(?:NaN|Infinity|\d+(?:\.\d*)?(?:[Ee][+-]?\d+)?|0x[\da-fA-F]+|0b[01]+)\b/,
        boolean: /\b(?:F|T|false|true)\b/,
        punctuation: /<%|%>|[{}[\]()]/,
        // Some operators from the "operators" category
        // https://www.warp10.io/tags/operators
        operator: /==|&&?|\|\|?|\*\*?|>>>?|<<|[<>!~]=?|[-/%^]|\+!?|\b(?:AND|NOT|OR)\b/
    };
}

});

parcelRegister("deKUl", function(module, exports) {
'use strict';
module.exports = $9a30f813434cd2c8$var$wasm;
$9a30f813434cd2c8$var$wasm.displayName = 'wasm';
$9a30f813434cd2c8$var$wasm.aliases = [];
function $9a30f813434cd2c8$var$wasm(Prism) {
    Prism.languages.wasm = {
        comment: [
            /\(;[\s\S]*?;\)/,
            {
                pattern: /;;.*/,
                greedy: true
            }
        ],
        string: {
            pattern: /"(?:\\[\s\S]|[^"\\])*"/,
            greedy: true
        },
        keyword: [
            {
                pattern: /\b(?:align|offset)=/,
                inside: {
                    operator: /=/
                }
            },
            {
                pattern: /\b(?:(?:f32|f64|i32|i64)(?:\.(?:abs|add|and|ceil|clz|const|convert_[su]\/i(?:32|64)|copysign|ctz|demote\/f64|div(?:_[su])?|eqz?|extend_[su]\/i32|floor|ge(?:_[su])?|gt(?:_[su])?|le(?:_[su])?|load(?:(?:8|16|32)_[su])?|lt(?:_[su])?|max|min|mul|neg?|nearest|or|popcnt|promote\/f32|reinterpret\/[fi](?:32|64)|rem_[su]|rot[lr]|shl|shr_[su]|sqrt|store(?:8|16|32)?|sub|trunc(?:_[su]\/f(?:32|64))?|wrap\/i64|xor))?|memory\.(?:grow|size))\b/,
                inside: {
                    punctuation: /\./
                }
            },
            /\b(?:anyfunc|block|br(?:_if|_table)?|call(?:_indirect)?|data|drop|elem|else|end|export|func|get_(?:global|local)|global|if|import|local|loop|memory|module|mut|nop|offset|param|result|return|select|set_(?:global|local)|start|table|tee_local|then|type|unreachable)\b/
        ],
        variable: /\$[\w!#$%&'*+\-./:<=>?@\\^`|~]+/,
        number: /[+-]?\b(?:\d(?:_?\d)*(?:\.\d(?:_?\d)*)?(?:[eE][+-]?\d(?:_?\d)*)?|0x[\da-fA-F](?:_?[\da-fA-F])*(?:\.[\da-fA-F](?:_?[\da-fA-D])*)?(?:[pP][+-]?\d(?:_?\d)*)?)\b|\binf\b|\bnan(?::0x[\da-fA-F](?:_?[\da-fA-D])*)?\b/,
        punctuation: /[()]/
    };
}

});

parcelRegister("0210y", function(module, exports) {
'use strict';
module.exports = $0060f8272af7055f$var$webIdl;
$0060f8272af7055f$var$webIdl.displayName = 'webIdl';
$0060f8272af7055f$var$webIdl.aliases = [];
function $0060f8272af7055f$var$webIdl(Prism) {
    (function(Prism) {
        var id = /(?:\B-|\b_|\b)[A-Za-z][\w-]*(?![\w-])/.source;
        var type = '(?:' + /\b(?:unsigned\s+)?long\s+long(?![\w-])/.source + '|' + /\b(?:unrestricted|unsigned)\s+[a-z]+(?![\w-])/.source + '|' + /(?!(?:unrestricted|unsigned)\b)/.source + id + /(?:\s*<(?:[^<>]|<[^<>]*>)*>)?/.source + ')' + /(?:\s*\?)?/.source;
        var typeInside = {};
        Prism.languages['web-idl'] = {
            comment: {
                pattern: /\/\/.*|\/\*[\s\S]*?\*\//,
                greedy: true
            },
            string: {
                pattern: /"[^"]*"/,
                greedy: true
            },
            namespace: {
                pattern: RegExp(/(\bnamespace\s+)/.source + id),
                lookbehind: true
            },
            'class-name': [
                {
                    pattern: /(^|[^\w-])(?:iterable|maplike|setlike)\s*<(?:[^<>]|<[^<>]*>)*>/,
                    lookbehind: true,
                    inside: typeInside
                },
                {
                    pattern: RegExp(/(\b(?:attribute|const|deleter|getter|optional|setter)\s+)/.source + type),
                    lookbehind: true,
                    inside: typeInside
                },
                {
                    // callback return type
                    pattern: RegExp('(' + /\bcallback\s+/.source + id + /\s*=\s*/.source + ')' + type),
                    lookbehind: true,
                    inside: typeInside
                },
                {
                    // typedef
                    pattern: RegExp(/(\btypedef\b\s*)/.source + type),
                    lookbehind: true,
                    inside: typeInside
                },
                {
                    pattern: RegExp(/(\b(?:callback|dictionary|enum|interface(?:\s+mixin)?)\s+)(?!(?:interface|mixin)\b)/.source + id),
                    lookbehind: true
                },
                {
                    // inheritance
                    pattern: RegExp(/(:\s*)/.source + id),
                    lookbehind: true
                },
                RegExp(id + /(?=\s+(?:implements|includes)\b)/.source),
                {
                    pattern: RegExp(/(\b(?:implements|includes)\s+)/.source + id),
                    lookbehind: true
                },
                {
                    // function return type, parameter types, and dictionary members
                    pattern: RegExp(type + '(?=' + /\s*(?:\.{3}\s*)?/.source + id + /\s*[(),;=]/.source + ')'),
                    inside: typeInside
                }
            ],
            builtin: /\b(?:ArrayBuffer|BigInt64Array|BigUint64Array|ByteString|DOMString|DataView|Float32Array|Float64Array|FrozenArray|Int16Array|Int32Array|Int8Array|ObservableArray|Promise|USVString|Uint16Array|Uint32Array|Uint8Array|Uint8ClampedArray)\b/,
            keyword: [
                /\b(?:async|attribute|callback|const|constructor|deleter|dictionary|enum|getter|implements|includes|inherit|interface|mixin|namespace|null|optional|or|partial|readonly|required|setter|static|stringifier|typedef|unrestricted)\b/,
                /\b(?:any|bigint|boolean|byte|double|float|iterable|long|maplike|object|octet|record|sequence|setlike|short|symbol|undefined|unsigned|void)\b/
            ],
            boolean: /\b(?:false|true)\b/,
            number: {
                pattern: /(^|[^\w-])-?(?:0x[0-9a-f]+|(?:\d+(?:\.\d*)?|\.\d+)(?:e[+-]?\d+)?|NaN|Infinity)(?![\w-])/i,
                lookbehind: true
            },
            operator: /\.{3}|[=:?<>-]/,
            punctuation: /[(){}[\].,;]/
        };
        for(var key in Prism.languages['web-idl'])if (key !== 'class-name') typeInside[key] = Prism.languages['web-idl'][key];
        Prism.languages['webidl'] = Prism.languages['web-idl'];
    })(Prism);
}

});

parcelRegister("7m8BP", function(module, exports) {
'use strict';
module.exports = $55b144174292dd44$var$wiki;
$55b144174292dd44$var$wiki.displayName = 'wiki';
$55b144174292dd44$var$wiki.aliases = [];
function $55b144174292dd44$var$wiki(Prism) {
    Prism.languages.wiki = Prism.languages.extend('markup', {
        'block-comment': {
            pattern: /(^|[^\\])\/\*[\s\S]*?\*\//,
            lookbehind: true,
            alias: 'comment'
        },
        heading: {
            pattern: /^(=+)[^=\r\n].*?\1/m,
            inside: {
                punctuation: /^=+|=+$/,
                important: /.+/
            }
        },
        emphasis: {
            // TODO Multi-line
            pattern: /('{2,5}).+?\1/,
            inside: {
                'bold-italic': {
                    pattern: /(''''').+?(?=\1)/,
                    lookbehind: true,
                    alias: [
                        'bold',
                        'italic'
                    ]
                },
                bold: {
                    pattern: /(''')[^'](?:.*?[^'])?(?=\1)/,
                    lookbehind: true
                },
                italic: {
                    pattern: /('')[^'](?:.*?[^'])?(?=\1)/,
                    lookbehind: true
                },
                punctuation: /^''+|''+$/
            }
        },
        hr: {
            pattern: /^-{4,}/m,
            alias: 'punctuation'
        },
        url: [
            /ISBN +(?:97[89][ -]?)?(?:\d[ -]?){9}[\dx]\b|(?:PMID|RFC) +\d+/i,
            /\[\[.+?\]\]|\[.+?\]/
        ],
        variable: [
            /__[A-Z]+__/,
            // {{formatnum:{{#expr:{{{3}}}}}}}
            /\{{3}.+?\}{3}/,
            /\{\{.+?\}\}/
        ],
        symbol: [
            /^#redirect/im,
            /~{3,5}/
        ],
        // Handle table attrs:
        // {|
        // ! style="text-align:left;"| Item
        // |}
        'table-tag': {
            pattern: /((?:^|[|!])[|!])[^|\r\n]+\|(?!\|)/m,
            lookbehind: true,
            inside: {
                'table-bar': {
                    pattern: /\|$/,
                    alias: 'punctuation'
                },
                rest: Prism.languages.markup['tag'].inside
            }
        },
        punctuation: /^(?:\{\||\|\}|\|-|[*#:;!|])|\|\||!!/m
    });
    Prism.languages.insertBefore('wiki', 'tag', {
        // Prevent highlighting inside <nowiki>, <source> and <pre> tags
        nowiki: {
            pattern: /<(nowiki|pre|source)\b[^>]*>[\s\S]*?<\/\1>/i,
            inside: {
                tag: {
                    pattern: /<(?:nowiki|pre|source)\b[^>]*>|<\/(?:nowiki|pre|source)>/i,
                    inside: Prism.languages.markup['tag'].inside
                }
            }
        }
    });
}

});

parcelRegister("3JhJn", function(module, exports) {
'use strict';
module.exports = $2b73540f6b00822d$var$wolfram;
$2b73540f6b00822d$var$wolfram.displayName = 'wolfram';
$2b73540f6b00822d$var$wolfram.aliases = [
    'mathematica',
    'wl',
    'nb'
];
function $2b73540f6b00822d$var$wolfram(Prism) {
    Prism.languages.wolfram = {
        // Allow one level of nesting - note: regex taken from applescipt
        comment: /\(\*(?:\(\*(?:[^*]|\*(?!\)))*\*\)|(?!\(\*)[\s\S])*?\*\)/,
        string: {
            pattern: /"(?:\\.|[^"\\\r\n])*"/,
            greedy: true
        },
        keyword: /\b(?:Abs|AbsArg|Accuracy|Block|Do|For|Function|If|Manipulate|Module|Nest|NestList|None|Return|Switch|Table|Which|While)\b/,
        context: {
            pattern: /\b\w+`+\w*/,
            alias: 'class-name'
        },
        blank: {
            pattern: /\b\w+_\b/,
            alias: 'regex'
        },
        'global-variable': {
            pattern: /\$\w+/,
            alias: 'variable'
        },
        boolean: /\b(?:False|True)\b/,
        number: /(?:\b(?=\d)|\B(?=\.))(?:0[bo])?(?:(?:\d|0x[\da-f])[\da-f]*(?:\.\d*)?|\.\d+)(?:e[+-]?\d+)?j?\b/i,
        operator: /\/\.|;|=\.|\^=|\^:=|:=|<<|>>|<\||\|>|:>|\|->|->|<-|@@@|@@|@|\/@|=!=|===|==|=|\+|-|\^|\[\/-+%=\]=?|!=|\*\*?=?|\/\/?=?|<[<=>]?|>[=>]?|[&|^~]/,
        punctuation: /[{}[\];(),.:]/
    };
    Prism.languages.mathematica = Prism.languages.wolfram;
    Prism.languages.wl = Prism.languages.wolfram;
    Prism.languages.nb = Prism.languages.wolfram;
}

});

parcelRegister("1eWdu", function(module, exports) {
'use strict';
module.exports = $0e7441dd53f87c8c$var$wren;
$0e7441dd53f87c8c$var$wren.displayName = 'wren';
$0e7441dd53f87c8c$var$wren.aliases = [];
function $0e7441dd53f87c8c$var$wren(Prism) {
    // https://wren.io/
    Prism.languages.wren = {
        // Multiline comments in Wren can have nested multiline comments
        // Comments: // and /* */
        comment: [
            {
                // support 3 levels of nesting
                // regex: \/\*(?:[^*/]|\*(?!\/)|\/(?!\*)|<self>)*\*\/
                pattern: /\/\*(?:[^*/]|\*(?!\/)|\/(?!\*)|\/\*(?:[^*/]|\*(?!\/)|\/(?!\*)|\/\*(?:[^*/]|\*(?!\/)|\/(?!\*))*\*\/)*\*\/)*\*\//,
                greedy: true
            },
            {
                pattern: /(^|[^\\:])\/\/.*/,
                lookbehind: true,
                greedy: true
            }
        ],
        // Triple quoted strings are multiline but cannot have interpolation (raw strings)
        // Based on prism-python.js
        'triple-quoted-string': {
            pattern: /"""[\s\S]*?"""/,
            greedy: true,
            alias: 'string'
        },
        // see below
        'string-literal': null,
        // #!/usr/bin/env wren on the first line
        hashbang: {
            pattern: /^#!\/.+/,
            greedy: true,
            alias: 'comment'
        },
        // Attributes are special keywords to add meta data to classes
        attribute: {
            // #! attributes are stored in class properties
            // #!myvar = true
            // #attributes are not stored and dismissed at compilation
            pattern: /#!?[ \t\u3000]*\w+/,
            alias: 'keyword'
        },
        'class-name': [
            {
                // class definition
                // class Meta {}
                pattern: /(\bclass\s+)\w+/,
                lookbehind: true
            },
            // File.read
            /\b[A-Z][a-z\d_]*\b/
        ],
        // A constant can be a variable, class, property or method. Just named in all uppercase letters
        constant: /\b[A-Z][A-Z\d_]*\b/,
        null: {
            pattern: /\bnull\b/,
            alias: 'keyword'
        },
        keyword: /\b(?:as|break|class|construct|continue|else|for|foreign|if|import|in|is|return|static|super|this|var|while)\b/,
        boolean: /\b(?:false|true)\b/,
        number: /\b(?:0x[\da-f]+|\d+(?:\.\d+)?(?:e[+-]?\d+)?)\b/i,
        // Functions can be Class.method()
        function: /\b[a-z_]\w*(?=\s*[({])/i,
        operator: /<<|>>|[=!<>]=?|&&|\|\||[-+*/%~^&|?:]|\.{2,3}/,
        punctuation: /[\[\](){}.,;]/
    };
    Prism.languages.wren['string-literal'] = {
        // A single quote string is multiline and can have interpolation (similar to JS backticks ``)
        pattern: /(^|[^\\"])"(?:[^\\"%]|\\[\s\S]|%(?!\()|%\((?:[^()]|\((?:[^()]|\([^)]*\))*\))*\))*"/,
        lookbehind: true,
        greedy: true,
        inside: {
            interpolation: {
                // "%(interpolation)"
                pattern: /((?:^|[^\\])(?:\\{2})*)%\((?:[^()]|\((?:[^()]|\([^)]*\))*\))*\)/,
                lookbehind: true,
                inside: {
                    expression: {
                        pattern: /^(%\()[\s\S]+(?=\)$)/,
                        lookbehind: true,
                        inside: Prism.languages.wren
                    },
                    'interpolation-punctuation': {
                        pattern: /^%\(|\)$/,
                        alias: 'punctuation'
                    }
                }
            },
            string: /[\s\S]+/
        }
    };
}

});

parcelRegister("kbSLp", function(module, exports) {
'use strict';
module.exports = $eb2f50a89980a540$var$xeora;
$eb2f50a89980a540$var$xeora.displayName = 'xeora';
$eb2f50a89980a540$var$xeora.aliases = [
    'xeoracube'
];
function $eb2f50a89980a540$var$xeora(Prism) {
    (function(Prism) {
        Prism.languages.xeora = Prism.languages.extend('markup', {
            constant: {
                pattern: /\$(?:DomainContents|PageRenderDuration)\$/,
                inside: {
                    punctuation: {
                        pattern: /\$/
                    }
                }
            },
            variable: {
                pattern: /\$@?(?:#+|[-+*~=^])?[\w.]+\$/,
                inside: {
                    punctuation: {
                        pattern: /[$.]/
                    },
                    operator: {
                        pattern: /#+|[-+*~=^@]/
                    }
                }
            },
            'function-inline': {
                pattern: /\$F:[-\w.]+\?[-\w.]+(?:,(?:(?:@[-#]*\w+\.[\w+.]\.*)*\|)*(?:(?:[\w+]|[-#*.~^]+[\w+]|=\S)(?:[^$=]|=+[^=])*=*|(?:@[-#]*\w+\.[\w+.]\.*)+(?:(?:[\w+]|[-#*~^][-#*.~^]*[\w+]|=\S)(?:[^$=]|=+[^=])*=*)?)?)?\$/,
                inside: {
                    variable: {
                        pattern: /(?:[,|])@?(?:#+|[-+*~=^])?[\w.]+/,
                        inside: {
                            punctuation: {
                                pattern: /[,.|]/
                            },
                            operator: {
                                pattern: /#+|[-+*~=^@]/
                            }
                        }
                    },
                    punctuation: {
                        pattern: /\$\w:|[$:?.,|]/
                    }
                },
                alias: 'function'
            },
            'function-block': {
                pattern: /\$XF:\{[-\w.]+\?[-\w.]+(?:,(?:(?:@[-#]*\w+\.[\w+.]\.*)*\|)*(?:(?:[\w+]|[-#*.~^]+[\w+]|=\S)(?:[^$=]|=+[^=])*=*|(?:@[-#]*\w+\.[\w+.]\.*)+(?:(?:[\w+]|[-#*~^][-#*.~^]*[\w+]|=\S)(?:[^$=]|=+[^=])*=*)?)?)?\}:XF\$/,
                inside: {
                    punctuation: {
                        pattern: /[$:{}?.,|]/
                    }
                },
                alias: 'function'
            },
            'directive-inline': {
                pattern: /\$\w(?:#\d+\+?)?(?:\[[-\w.]+\])?:[-\/\w.]+\$/,
                inside: {
                    punctuation: {
                        pattern: /\$(?:\w:|C(?:\[|#\d))?|[:{[\]]/,
                        inside: {
                            tag: {
                                pattern: /#\d/
                            }
                        }
                    }
                },
                alias: 'function'
            },
            'directive-block-open': {
                pattern: /\$\w+:\{|\$\w(?:#\d+\+?)?(?:\[[-\w.]+\])?:[-\w.]+:\{(?:![A-Z]+)?/,
                inside: {
                    punctuation: {
                        pattern: /\$(?:\w:|C(?:\[|#\d))?|[:{[\]]/,
                        inside: {
                            tag: {
                                pattern: /#\d/
                            }
                        }
                    },
                    attribute: {
                        pattern: /![A-Z]+$/,
                        inside: {
                            punctuation: {
                                pattern: /!/
                            }
                        },
                        alias: 'keyword'
                    }
                },
                alias: 'function'
            },
            'directive-block-separator': {
                pattern: /\}:[-\w.]+:\{/,
                inside: {
                    punctuation: {
                        pattern: /[:{}]/
                    }
                },
                alias: 'function'
            },
            'directive-block-close': {
                pattern: /\}:[-\w.]+\$/,
                inside: {
                    punctuation: {
                        pattern: /[:{}$]/
                    }
                },
                alias: 'function'
            }
        });
        Prism.languages.insertBefore('inside', 'punctuation', {
            variable: Prism.languages.xeora['function-inline'].inside['variable']
        }, Prism.languages.xeora['function-block']);
        Prism.languages.xeoracube = Prism.languages.xeora;
    })(Prism);
}

});

parcelRegister("7YPe8", function(module, exports) {
'use strict';
module.exports = $5cf5df9b2be042c9$var$xmlDoc;
$5cf5df9b2be042c9$var$xmlDoc.displayName = 'xmlDoc';
$5cf5df9b2be042c9$var$xmlDoc.aliases = [];
function $5cf5df9b2be042c9$var$xmlDoc(Prism) {
    (function(Prism) {
        /**
     * If the given language is present, it will insert the given doc comment grammar token into it.
     *
     * @param {string} lang
     * @param {any} docComment
     */ function insertDocComment(lang, docComment) {
            if (Prism.languages[lang]) Prism.languages.insertBefore(lang, 'comment', {
                'doc-comment': docComment
            });
        }
        var tag = Prism.languages.markup.tag;
        var slashDocComment = {
            pattern: /\/\/\/.*/,
            greedy: true,
            alias: 'comment',
            inside: {
                tag: tag
            }
        };
        var tickDocComment = {
            pattern: /'''.*/,
            greedy: true,
            alias: 'comment',
            inside: {
                tag: tag
            }
        };
        insertDocComment('csharp', slashDocComment);
        insertDocComment('fsharp', slashDocComment);
        insertDocComment('vbnet', tickDocComment);
    })(Prism);
}

});

parcelRegister("9Q9rd", function(module, exports) {
'use strict';
module.exports = $72a04a96ccdd7eeb$var$xojo;
$72a04a96ccdd7eeb$var$xojo.displayName = 'xojo';
$72a04a96ccdd7eeb$var$xojo.aliases = [];
function $72a04a96ccdd7eeb$var$xojo(Prism) {
    Prism.languages.xojo = {
        comment: {
            pattern: /(?:'|\/\/|Rem\b).+/i,
            greedy: true
        },
        string: {
            pattern: /"(?:""|[^"])*"/,
            greedy: true
        },
        number: [
            /(?:\b\d+(?:\.\d*)?|\B\.\d+)(?:E[+-]?\d+)?/i,
            /&[bchou][a-z\d]+/i
        ],
        directive: {
            pattern: /#(?:Else|ElseIf|Endif|If|Pragma)\b/i,
            alias: 'property'
        },
        keyword: /\b(?:AddHandler|App|Array|As(?:signs)?|Auto|Boolean|Break|By(?:Ref|Val)|Byte|Call|Case|Catch|CFStringRef|CGFloat|Class|Color|Const|Continue|CString|Currency|CurrentMethodName|Declare|Delegate|Dim|Do(?:uble|wnTo)?|Each|Else(?:If)?|End|Enumeration|Event|Exception|Exit|Extends|False|Finally|For|Function|Get|GetTypeInfo|Global|GOTO|If|Implements|In|Inherits|Int(?:8|16|32|64|eger|erface)?|Lib|Loop|Me|Module|Next|Nil|Object|Optional|OSType|ParamArray|Private|Property|Protected|PString|Ptr|Raise(?:Event)?|ReDim|RemoveHandler|Return|Select(?:or)?|Self|Set|Shared|Short|Single|Soft|Static|Step|String|Sub|Super|Text|Then|To|True|Try|Ubound|UInt(?:8|16|32|64|eger)?|Until|Using|Var(?:iant)?|Wend|While|WindowPtr|WString)\b/i,
        operator: /<[=>]?|>=?|[+\-*\/\\^=]|\b(?:AddressOf|And|Ctype|IsA?|Mod|New|Not|Or|WeakAddressOf|Xor)\b/i,
        punctuation: /[.,;:()]/
    };
}

});

parcelRegister("edxZc", function(module, exports) {
'use strict';
module.exports = $a59ca48375427b83$var$xquery;
$a59ca48375427b83$var$xquery.displayName = 'xquery';
$a59ca48375427b83$var$xquery.aliases = [];
function $a59ca48375427b83$var$xquery(Prism) {
    (function(Prism) {
        Prism.languages.xquery = Prism.languages.extend('markup', {
            'xquery-comment': {
                pattern: /\(:[\s\S]*?:\)/,
                greedy: true,
                alias: 'comment'
            },
            string: {
                pattern: /(["'])(?:\1\1|(?!\1)[\s\S])*\1/,
                greedy: true
            },
            extension: {
                pattern: /\(#.+?#\)/,
                alias: 'symbol'
            },
            variable: /\$[-\w:]+/,
            axis: {
                pattern: /(^|[^-])(?:ancestor(?:-or-self)?|attribute|child|descendant(?:-or-self)?|following(?:-sibling)?|parent|preceding(?:-sibling)?|self)(?=::)/,
                lookbehind: true,
                alias: 'operator'
            },
            'keyword-operator': {
                pattern: /(^|[^:-])\b(?:and|castable as|div|eq|except|ge|gt|idiv|instance of|intersect|is|le|lt|mod|ne|or|union)\b(?=$|[^:-])/,
                lookbehind: true,
                alias: 'operator'
            },
            keyword: {
                pattern: /(^|[^:-])\b(?:as|ascending|at|base-uri|boundary-space|case|cast as|collation|construction|copy-namespaces|declare|default|descending|else|empty (?:greatest|least)|encoding|every|external|for|function|if|import|in|inherit|lax|let|map|module|namespace|no-inherit|no-preserve|option|order(?: by|ed|ing)?|preserve|return|satisfies|schema|some|stable|strict|strip|then|to|treat as|typeswitch|unordered|validate|variable|version|where|xquery)\b(?=$|[^:-])/,
                lookbehind: true
            },
            function: /[\w-]+(?::[\w-]+)*(?=\s*\()/,
            'xquery-element': {
                pattern: /(element\s+)[\w-]+(?::[\w-]+)*/,
                lookbehind: true,
                alias: 'tag'
            },
            'xquery-attribute': {
                pattern: /(attribute\s+)[\w-]+(?::[\w-]+)*/,
                lookbehind: true,
                alias: 'attr-name'
            },
            builtin: {
                pattern: /(^|[^:-])\b(?:attribute|comment|document|element|processing-instruction|text|xs:(?:ENTITIES|ENTITY|ID|IDREFS?|NCName|NMTOKENS?|NOTATION|Name|QName|anyAtomicType|anyType|anyURI|base64Binary|boolean|byte|date|dateTime|dayTimeDuration|decimal|double|duration|float|gDay|gMonth|gMonthDay|gYear|gYearMonth|hexBinary|int|integer|language|long|negativeInteger|nonNegativeInteger|nonPositiveInteger|normalizedString|positiveInteger|short|string|time|token|unsigned(?:Byte|Int|Long|Short)|untyped(?:Atomic)?|yearMonthDuration))\b(?=$|[^:-])/,
                lookbehind: true
            },
            number: /\b\d+(?:\.\d+)?(?:E[+-]?\d+)?/,
            operator: [
                /[+*=?|@]|\.\.?|:=|!=|<[=<]?|>[=>]?/,
                {
                    pattern: /(\s)-(?=\s)/,
                    lookbehind: true
                }
            ],
            punctuation: /[[\](){},;:/]/
        });
        Prism.languages.xquery.tag.pattern = /<\/?(?!\d)[^\s>\/=$<%]+(?:\s+[^\s>\/=]+(?:=(?:("|')(?:\\[\s\S]|\{(?!\{)(?:\{(?:\{[^{}]*\}|[^{}])*\}|[^{}])+\}|(?!\1)[^\\])*\1|[^\s'">=]+))?)*\s*\/?>/;
        Prism.languages.xquery['tag'].inside['attr-value'].pattern = /=(?:("|')(?:\\[\s\S]|\{(?!\{)(?:\{(?:\{[^{}]*\}|[^{}])*\}|[^{}])+\}|(?!\1)[^\\])*\1|[^\s'">=]+)/;
        Prism.languages.xquery['tag'].inside['attr-value'].inside['punctuation'] = /^="|"$/;
        Prism.languages.xquery['tag'].inside['attr-value'].inside['expression'] = {
            // Allow for two levels of nesting
            pattern: /\{(?!\{)(?:\{(?:\{[^{}]*\}|[^{}])*\}|[^{}])+\}/,
            inside: Prism.languages.xquery,
            alias: 'language-xquery'
        } // The following will handle plain text inside tags
        ;
        var stringifyToken = function(token) {
            if (typeof token === 'string') return token;
            if (typeof token.content === 'string') return token.content;
            return token.content.map(stringifyToken).join('');
        };
        var walkTokens = function(tokens) {
            var openedTags = [];
            for(var i = 0; i < tokens.length; i++){
                var token = tokens[i];
                var notTagNorBrace = false;
                if (typeof token !== 'string') {
                    if (token.type === 'tag' && token.content[0] && token.content[0].type === 'tag') {
                        // We found a tag, now find its kind
                        if (token.content[0].content[0].content === '</') // Closing tag
                        {
                            if (openedTags.length > 0 && openedTags[openedTags.length - 1].tagName === stringifyToken(token.content[0].content[1])) // Pop matching opening tag
                            openedTags.pop();
                        } else {
                            if (token.content[token.content.length - 1].content === '/>') ;
                            else // Opening tag
                            openedTags.push({
                                tagName: stringifyToken(token.content[0].content[1]),
                                openedBraces: 0
                            });
                        }
                    } else if (openedTags.length > 0 && token.type === 'punctuation' && token.content === '{' && // Ignore `{{`
                    (!tokens[i + 1] || tokens[i + 1].type !== 'punctuation' || tokens[i + 1].content !== '{') && (!tokens[i - 1] || tokens[i - 1].type !== 'plain-text' || tokens[i - 1].content !== '{')) // Here we might have entered an XQuery expression inside a tag
                    openedTags[openedTags.length - 1].openedBraces++;
                    else if (openedTags.length > 0 && openedTags[openedTags.length - 1].openedBraces > 0 && token.type === 'punctuation' && token.content === '}') // Here we might have left an XQuery expression inside a tag
                    openedTags[openedTags.length - 1].openedBraces--;
                    else if (token.type !== 'comment') notTagNorBrace = true;
                }
                if (notTagNorBrace || typeof token === 'string') {
                    if (openedTags.length > 0 && openedTags[openedTags.length - 1].openedBraces === 0) {
                        // Here we are inside a tag, and not inside an XQuery expression.
                        // That's plain text: drop any tokens matched.
                        var plainText = stringifyToken(token) // And merge text with adjacent text
                        ;
                        if (i < tokens.length - 1 && (typeof tokens[i + 1] === 'string' || tokens[i + 1].type === 'plain-text')) {
                            plainText += stringifyToken(tokens[i + 1]);
                            tokens.splice(i + 1, 1);
                        }
                        if (i > 0 && (typeof tokens[i - 1] === 'string' || tokens[i - 1].type === 'plain-text')) {
                            plainText = stringifyToken(tokens[i - 1]) + plainText;
                            tokens.splice(i - 1, 1);
                            i--;
                        }
                        if (/^\s+$/.test(plainText)) tokens[i] = plainText;
                        else tokens[i] = new Prism.Token('plain-text', plainText, null, plainText);
                    }
                }
                if (token.content && typeof token.content !== 'string') walkTokens(token.content);
            }
        };
        Prism.hooks.add('after-tokenize', function(env) {
            if (env.language !== 'xquery') return;
            walkTokens(env.tokens);
        });
    })(Prism);
}

});

parcelRegister("bZzKD", function(module, exports) {
'use strict';
module.exports = $8bb11fa55e5c465a$var$yang;
$8bb11fa55e5c465a$var$yang.displayName = 'yang';
$8bb11fa55e5c465a$var$yang.aliases = [];
function $8bb11fa55e5c465a$var$yang(Prism) {
    Prism.languages.yang = {
        // https://tools.ietf.org/html/rfc6020#page-34
        // http://www.yang-central.org/twiki/bin/view/Main/YangExamples
        comment: /\/\*[\s\S]*?\*\/|\/\/.*/,
        string: {
            pattern: /"(?:[^\\"]|\\.)*"|'[^']*'/,
            greedy: true
        },
        keyword: {
            pattern: /(^|[{};\r\n][ \t]*)[a-z_][\w.-]*/i,
            lookbehind: true
        },
        namespace: {
            pattern: /(\s)[a-z_][\w.-]*(?=:)/i,
            lookbehind: true
        },
        boolean: /\b(?:false|true)\b/,
        operator: /\+/,
        punctuation: /[{};:]/
    };
}

});

parcelRegister("02tNy", function(module, exports) {
'use strict';
module.exports = $00774d5a4b50007e$var$zig;
$00774d5a4b50007e$var$zig.displayName = 'zig';
$00774d5a4b50007e$var$zig.aliases = [];
function $00774d5a4b50007e$var$zig(Prism) {
    (function(Prism) {
        function literal(str) {
            return function() {
                return str;
            };
        }
        var keyword = /\b(?:align|allowzero|and|anyframe|anytype|asm|async|await|break|cancel|catch|comptime|const|continue|defer|else|enum|errdefer|error|export|extern|fn|for|if|inline|linksection|nakedcc|noalias|nosuspend|null|or|orelse|packed|promise|pub|resume|return|stdcallcc|struct|suspend|switch|test|threadlocal|try|undefined|union|unreachable|usingnamespace|var|volatile|while)\b/;
        var IDENTIFIER = '\\b(?!' + keyword.source + ')(?!\\d)\\w+\\b';
        var ALIGN = /align\s*\((?:[^()]|\([^()]*\))*\)/.source;
        var PREFIX_TYPE_OP = /(?:\?|\bpromise->|(?:\[[^[\]]*\]|\*(?!\*)|\*\*)(?:\s*<ALIGN>|\s*const\b|\s*volatile\b|\s*allowzero\b)*)/.source.replace(/<ALIGN>/g, literal(ALIGN));
        var SUFFIX_EXPR = /(?:\bpromise\b|(?:\berror\.)?<ID>(?:\.<ID>)*(?!\s+<ID>))/.source.replace(/<ID>/g, literal(IDENTIFIER));
        var TYPE = '(?!\\s)(?:!?\\s*(?:' + PREFIX_TYPE_OP + '\\s*)*' + SUFFIX_EXPR + ')+';
        /*
     * A simplified grammar for Zig compile time type literals:
     *
     * TypeExpr = ( "!"? PREFIX_TYPE_OP* SUFFIX_EXPR )+
     *
     * SUFFIX_EXPR = ( \b "promise" \b | ( \b "error" "." )? IDENTIFIER ( "." IDENTIFIER )* (?! \s+ IDENTIFIER ) )
     *
     * PREFIX_TYPE_OP = "?"
     *                | \b "promise" "->"
     *                | ( "[" [^\[\]]* "]" | "*" | "**" ) ( ALIGN | "const" \b | "volatile" \b | "allowzero" \b )*
     *
     * ALIGN = "align" "(" ( [^()] | "(" [^()]* ")" )* ")"
     *
     * IDENTIFIER = \b (?! KEYWORD ) [a-zA-Z_] \w* \b
     *
     */ Prism.languages.zig = {
            comment: [
                {
                    pattern: /\/\/[/!].*/,
                    alias: 'doc-comment'
                },
                /\/{2}.*/
            ],
            string: [
                {
                    // "string" and c"string"
                    pattern: /(^|[^\\@])c?"(?:[^"\\\r\n]|\\.)*"/,
                    lookbehind: true,
                    greedy: true
                },
                {
                    // multiline strings and c-strings
                    pattern: /([\r\n])([ \t]+c?\\{2}).*(?:(?:\r\n?|\n)\2.*)*/,
                    lookbehind: true,
                    greedy: true
                }
            ],
            char: {
                // characters 'a', '\n', '\xFF', '\u{10FFFF}'
                pattern: /(^|[^\\])'(?:[^'\\\r\n]|[\uD800-\uDFFF]{2}|\\(?:.|x[a-fA-F\d]{2}|u\{[a-fA-F\d]{1,6}\}))'/,
                lookbehind: true,
                greedy: true
            },
            builtin: /\B@(?!\d)\w+(?=\s*\()/,
            label: {
                pattern: /(\b(?:break|continue)\s*:\s*)\w+\b|\b(?!\d)\w+\b(?=\s*:\s*(?:\{|while\b))/,
                lookbehind: true
            },
            'class-name': [
                // const Foo = struct {};
                /\b(?!\d)\w+(?=\s*=\s*(?:(?:extern|packed)\s+)?(?:enum|struct|union)\s*[({])/,
                {
                    // const x: i32 = 9;
                    // var x: Bar;
                    // fn foo(x: bool, y: f32) void {}
                    pattern: RegExp(/(:\s*)<TYPE>(?=\s*(?:<ALIGN>\s*)?[=;,)])|<TYPE>(?=\s*(?:<ALIGN>\s*)?\{)/.source.replace(/<TYPE>/g, literal(TYPE)).replace(/<ALIGN>/g, literal(ALIGN))),
                    lookbehind: true,
                    inside: null // see below
                },
                {
                    // extern fn foo(x: f64) f64; (optional alignment)
                    pattern: RegExp(/(\)\s*)<TYPE>(?=\s*(?:<ALIGN>\s*)?;)/.source.replace(/<TYPE>/g, literal(TYPE)).replace(/<ALIGN>/g, literal(ALIGN))),
                    lookbehind: true,
                    inside: null // see below
                }
            ],
            'builtin-type': {
                pattern: /\b(?:anyerror|bool|c_u?(?:int|long|longlong|short)|c_longdouble|c_void|comptime_(?:float|int)|f(?:16|32|64|128)|[iu](?:8|16|32|64|128|size)|noreturn|type|void)\b/,
                alias: 'keyword'
            },
            keyword: keyword,
            function: /\b(?!\d)\w+(?=\s*\()/,
            number: /\b(?:0b[01]+|0o[0-7]+|0x[a-fA-F\d]+(?:\.[a-fA-F\d]*)?(?:[pP][+-]?[a-fA-F\d]+)?|\d+(?:\.\d*)?(?:[eE][+-]?\d+)?)\b/,
            boolean: /\b(?:false|true)\b/,
            operator: /\.[*?]|\.{2,3}|[-=]>|\*\*|\+\+|\|\||(?:<<|>>|[-+*]%|[-+*/%^&|<>!=])=?|[?~]/,
            punctuation: /[.:,;(){}[\]]/
        };
        Prism.languages.zig['class-name'].forEach(function(obj) {
            if (obj.inside === null) obj.inside = Prism.languages.zig;
        });
    })(Prism);
}

});

var $7b02d682eb115277$exports = {};
'use strict';

$7b02d682eb115277$exports = (parcelRequire("1b2ls"));


parcelRequire("acw62");
var $7e96a608cb33bf79$export$882461b6382ed46c;
var $7e96a608cb33bf79$export$757ceba2d55c277e;
'use strict';
var $11492dca620dcaa5$exports = {};
'use strict';
function $11492dca620dcaa5$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function') return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($11492dca620dcaa5$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$11492dca620dcaa5$var$checkDCE();

$11492dca620dcaa5$exports = (parcelRequire("Xw6Mv"));


var $7e96a608cb33bf79$var$i;
$7e96a608cb33bf79$export$882461b6382ed46c = $11492dca620dcaa5$exports.createRoot;
$7e96a608cb33bf79$export$757ceba2d55c277e = $11492dca620dcaa5$exports.hydrateRoot;




var $acw62 = parcelRequire("acw62");


var $acw62 = parcelRequire("acw62");

const $b1b44af3c77a62f9$export$98d92b1aa79f8cc7 = (customFetch)=>{
    let _fetch;
    if (customFetch) _fetch = customFetch;
    else if (typeof fetch === 'undefined') _fetch = (...args)=>Promise.resolve((parcelRequire("979Ct"))).then(({ default: fetch1 })=>fetch1(...args));
    else _fetch = fetch;
    return (...args)=>_fetch(...args);
};


class $103cafb5d5f4c571$export$738689d52335bb3c extends Error {
    constructor(message, name = 'FunctionsError', context){
        super(message);
        this.name = name;
        this.context = context;
    }
}
class $103cafb5d5f4c571$export$14f2b6540d498ce extends $103cafb5d5f4c571$export$738689d52335bb3c {
    constructor(context){
        super('Failed to send a request to the Edge Function', 'FunctionsFetchError', context);
    }
}
class $103cafb5d5f4c571$export$d08a45df86040161 extends $103cafb5d5f4c571$export$738689d52335bb3c {
    constructor(context){
        super('Relay Error invoking the Edge Function', 'FunctionsRelayError', context);
    }
}
class $103cafb5d5f4c571$export$761f8c0e0fa4624f extends $103cafb5d5f4c571$export$738689d52335bb3c {
    constructor(context){
        super('Edge Function returned a non-2xx status code', 'FunctionsHttpError', context);
    }
}
var $103cafb5d5f4c571$export$9b19f1a5abf91e06;
(function(FunctionRegion) {
    FunctionRegion["Any"] = "any";
    FunctionRegion["ApNortheast1"] = "ap-northeast-1";
    FunctionRegion["ApNortheast2"] = "ap-northeast-2";
    FunctionRegion["ApSouth1"] = "ap-south-1";
    FunctionRegion["ApSoutheast1"] = "ap-southeast-1";
    FunctionRegion["ApSoutheast2"] = "ap-southeast-2";
    FunctionRegion["CaCentral1"] = "ca-central-1";
    FunctionRegion["EuCentral1"] = "eu-central-1";
    FunctionRegion["EuWest1"] = "eu-west-1";
    FunctionRegion["EuWest2"] = "eu-west-2";
    FunctionRegion["EuWest3"] = "eu-west-3";
    FunctionRegion["SaEast1"] = "sa-east-1";
    FunctionRegion["UsEast1"] = "us-east-1";
    FunctionRegion["UsWest1"] = "us-west-1";
    FunctionRegion["UsWest2"] = "us-west-2";
})($103cafb5d5f4c571$export$9b19f1a5abf91e06 || ($103cafb5d5f4c571$export$9b19f1a5abf91e06 = {}));


var $6f9d627d4ebb0255$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
class $6f9d627d4ebb0255$export$1d0b400bf8a0fa55 {
    constructor(url, { headers: headers = {}, customFetch: customFetch, region: region = (0, $103cafb5d5f4c571$export$9b19f1a5abf91e06).Any } = {}){
        this.url = url;
        this.headers = headers;
        this.region = region;
        this.fetch = (0, $b1b44af3c77a62f9$export$98d92b1aa79f8cc7)(customFetch);
    }
    /**
     * Updates the authorization header
     * @param token - the new jwt token sent in the authorisation header
     */ setAuth(token) {
        this.headers.Authorization = `Bearer ${token}`;
    }
    /**
     * Invokes a function
     * @param functionName - The name of the Function to invoke.
     * @param options - Options for invoking the Function.
     */ invoke(functionName, options = {}) {
        var _a;
        return $6f9d627d4ebb0255$var$__awaiter(this, void 0, void 0, function*() {
            try {
                const { headers: headers, method: method, body: functionArgs } = options;
                let _headers = {};
                let { region: region } = options;
                if (!region) region = this.region;
                // Add region as query parameter using URL API
                const url = new URL(`${this.url}/${functionName}`);
                if (region && region !== 'any') {
                    _headers['x-region'] = region;
                    url.searchParams.set('forceFunctionRegion', region);
                }
                let body;
                if (functionArgs && (headers && !Object.prototype.hasOwnProperty.call(headers, 'Content-Type') || !headers)) {
                    if (typeof Blob !== 'undefined' && functionArgs instanceof Blob || functionArgs instanceof ArrayBuffer) {
                        // will work for File as File inherits Blob
                        // also works for ArrayBuffer as it is the same underlying structure as a Blob
                        _headers['Content-Type'] = 'application/octet-stream';
                        body = functionArgs;
                    } else if (typeof functionArgs === 'string') {
                        // plain string
                        _headers['Content-Type'] = 'text/plain';
                        body = functionArgs;
                    } else if (typeof FormData !== 'undefined' && functionArgs instanceof FormData) // don't set content-type headers
                    // Request will automatically add the right boundary value
                    body = functionArgs;
                    else {
                        // default, assume this is JSON
                        _headers['Content-Type'] = 'application/json';
                        body = JSON.stringify(functionArgs);
                    }
                }
                const response = yield this.fetch(url.toString(), {
                    method: method || 'POST',
                    // headers priority is (high to low):
                    // 1. invoke-level headers
                    // 2. client-level headers
                    // 3. default Content-Type header
                    headers: Object.assign(Object.assign(Object.assign({}, _headers), this.headers), headers),
                    body: body
                }).catch((fetchError)=>{
                    throw new (0, $103cafb5d5f4c571$export$14f2b6540d498ce)(fetchError);
                });
                const isRelayError = response.headers.get('x-relay-error');
                if (isRelayError && isRelayError === 'true') throw new (0, $103cafb5d5f4c571$export$d08a45df86040161)(response);
                if (!response.ok) throw new (0, $103cafb5d5f4c571$export$761f8c0e0fa4624f)(response);
                let responseType = ((_a = response.headers.get('Content-Type')) !== null && _a !== void 0 ? _a : 'text/plain').split(';')[0].trim();
                let data;
                if (responseType === 'application/json') data = yield response.json();
                else if (responseType === 'application/octet-stream') data = yield response.blob();
                else if (responseType === 'text/event-stream') data = response;
                else if (responseType === 'multipart/form-data') data = yield response.formData();
                else // default to text
                data = yield response.text();
                return {
                    data: data,
                    error: null,
                    response: response
                };
            } catch (error) {
                return {
                    data: null,
                    error: error,
                    response: error instanceof (0, $103cafb5d5f4c571$export$761f8c0e0fa4624f) || error instanceof (0, $103cafb5d5f4c571$export$d08a45df86040161) ? error.context : undefined
                };
            }
        });
    }
}


var $02d76e8b98cdd913$exports = {};
"use strict";
var $02d76e8b98cdd913$var$__importDefault = $02d76e8b98cdd913$exports && $02d76e8b98cdd913$exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty($02d76e8b98cdd913$exports, "__esModule", {
    value: true
});
$02d76e8b98cdd913$exports.PostgrestError = $02d76e8b98cdd913$exports.PostgrestBuilder = $02d76e8b98cdd913$exports.PostgrestTransformBuilder = $02d76e8b98cdd913$exports.PostgrestFilterBuilder = $02d76e8b98cdd913$exports.PostgrestQueryBuilder = $02d76e8b98cdd913$exports.PostgrestClient = void 0;

// Always update wrapper.mjs when updating this file.
const $02d76e8b98cdd913$var$PostgrestClient_1 = $02d76e8b98cdd913$var$__importDefault((parcelRequire("jreHA")));
$02d76e8b98cdd913$exports.PostgrestClient = $02d76e8b98cdd913$var$PostgrestClient_1.default;

const $02d76e8b98cdd913$var$PostgrestQueryBuilder_1 = $02d76e8b98cdd913$var$__importDefault((parcelRequire("dBXeq")));
$02d76e8b98cdd913$exports.PostgrestQueryBuilder = $02d76e8b98cdd913$var$PostgrestQueryBuilder_1.default;

const $02d76e8b98cdd913$var$PostgrestFilterBuilder_1 = $02d76e8b98cdd913$var$__importDefault((parcelRequire("dSHX3")));
$02d76e8b98cdd913$exports.PostgrestFilterBuilder = $02d76e8b98cdd913$var$PostgrestFilterBuilder_1.default;

const $02d76e8b98cdd913$var$PostgrestTransformBuilder_1 = $02d76e8b98cdd913$var$__importDefault((parcelRequire("kkZ1b")));
$02d76e8b98cdd913$exports.PostgrestTransformBuilder = $02d76e8b98cdd913$var$PostgrestTransformBuilder_1.default;

const $02d76e8b98cdd913$var$PostgrestBuilder_1 = $02d76e8b98cdd913$var$__importDefault((parcelRequire("9WNOL")));
$02d76e8b98cdd913$exports.PostgrestBuilder = $02d76e8b98cdd913$var$PostgrestBuilder_1.default;

const $02d76e8b98cdd913$var$PostgrestError_1 = $02d76e8b98cdd913$var$__importDefault((parcelRequire("iN95t")));
$02d76e8b98cdd913$exports.PostgrestError = $02d76e8b98cdd913$var$PostgrestError_1.default;
$02d76e8b98cdd913$exports.default = {
    PostgrestClient: $02d76e8b98cdd913$var$PostgrestClient_1.default,
    PostgrestQueryBuilder: $02d76e8b98cdd913$var$PostgrestQueryBuilder_1.default,
    PostgrestFilterBuilder: $02d76e8b98cdd913$var$PostgrestFilterBuilder_1.default,
    PostgrestTransformBuilder: $02d76e8b98cdd913$var$PostgrestTransformBuilder_1.default,
    PostgrestBuilder: $02d76e8b98cdd913$var$PostgrestBuilder_1.default,
    PostgrestError: $02d76e8b98cdd913$var$PostgrestError_1.default
};


const { PostgrestClient: $fa98774720195011$export$796f32e2ee984aaa, PostgrestQueryBuilder: $fa98774720195011$export$a81993b50ca081ad, PostgrestFilterBuilder: $fa98774720195011$export$3158317c13bdc93a, PostgrestTransformBuilder: $fa98774720195011$export$7b4361bb87e3030c, PostgrestBuilder: $fa98774720195011$export$3106e21688a06353, PostgrestError: $fa98774720195011$export$445b7e3a323f992f } = (0, (/*@__PURE__*/$parcel$interopDefault($02d76e8b98cdd913$exports)));
var // compatibility with CJS output
$fa98774720195011$export$2e2bcd8739ae039 = {
    PostgrestClient: $fa98774720195011$export$796f32e2ee984aaa,
    PostgrestQueryBuilder: $fa98774720195011$export$a81993b50ca081ad,
    PostgrestFilterBuilder: $fa98774720195011$export$3158317c13bdc93a,
    PostgrestTransformBuilder: $fa98774720195011$export$7b4361bb87e3030c,
    PostgrestBuilder: $fa98774720195011$export$3106e21688a06353,
    PostgrestError: $fa98774720195011$export$445b7e3a323f992f
};


function $224ae407b70ac65d$export$f67cfa4655f7ea21() {
    if (typeof WebSocket !== "undefined") return WebSocket;
    if (typeof $parcel$global.WebSocket !== "undefined") return $parcel$global.WebSocket;
    if (typeof window.WebSocket !== "undefined") return window.WebSocket;
    if (typeof self.WebSocket !== "undefined") return self.WebSocket;
    throw new Error("`WebSocket` is not supported in this environment");
}


const $5c2f14c4e1a690d9$export$3909fb301d3dc8c9 = (0, $224ae407b70ac65d$export$f67cfa4655f7ea21)();


const $4cff20d240de2de4$export$83d89fbfd8236492 = '2.11.15';


const $3d531e63e1ea7f53$export$363ebe89e6e7aeef = `realtime-js/${(0, $4cff20d240de2de4$export$83d89fbfd8236492)}`;
const $3d531e63e1ea7f53$export$df3f558bb9a9c991 = '1.0.0';
const $3d531e63e1ea7f53$export$a4ad2735b021c132 = (0, $4cff20d240de2de4$export$83d89fbfd8236492);
const $3d531e63e1ea7f53$export$7bd623b29ec8e1eb = 10000;
const $3d531e63e1ea7f53$export$5e80cf62e56a877b = 1000;
var $3d531e63e1ea7f53$export$a6d0320a1563d49e;
(function(SOCKET_STATES) {
    SOCKET_STATES[SOCKET_STATES["connecting"] = 0] = "connecting";
    SOCKET_STATES[SOCKET_STATES["open"] = 1] = "open";
    SOCKET_STATES[SOCKET_STATES["closing"] = 2] = "closing";
    SOCKET_STATES[SOCKET_STATES["closed"] = 3] = "closed";
})($3d531e63e1ea7f53$export$a6d0320a1563d49e || ($3d531e63e1ea7f53$export$a6d0320a1563d49e = {}));
var $3d531e63e1ea7f53$export$b83816118db74fe7;
(function(CHANNEL_STATES) {
    CHANNEL_STATES["closed"] = "closed";
    CHANNEL_STATES["errored"] = "errored";
    CHANNEL_STATES["joined"] = "joined";
    CHANNEL_STATES["joining"] = "joining";
    CHANNEL_STATES["leaving"] = "leaving";
})($3d531e63e1ea7f53$export$b83816118db74fe7 || ($3d531e63e1ea7f53$export$b83816118db74fe7 = {}));
var $3d531e63e1ea7f53$export$8db7548e65d6ea55;
(function(CHANNEL_EVENTS) {
    CHANNEL_EVENTS["close"] = "phx_close";
    CHANNEL_EVENTS["error"] = "phx_error";
    CHANNEL_EVENTS["join"] = "phx_join";
    CHANNEL_EVENTS["reply"] = "phx_reply";
    CHANNEL_EVENTS["leave"] = "phx_leave";
    CHANNEL_EVENTS["access_token"] = "access_token";
})($3d531e63e1ea7f53$export$8db7548e65d6ea55 || ($3d531e63e1ea7f53$export$8db7548e65d6ea55 = {}));
var $3d531e63e1ea7f53$export$b2688bfb999f5751;
(function(TRANSPORTS) {
    TRANSPORTS["websocket"] = "websocket";
})($3d531e63e1ea7f53$export$b2688bfb999f5751 || ($3d531e63e1ea7f53$export$b2688bfb999f5751 = {}));
var $3d531e63e1ea7f53$export$deda39003d27273;
(function(CONNECTION_STATE) {
    CONNECTION_STATE["Connecting"] = "connecting";
    CONNECTION_STATE["Open"] = "open";
    CONNECTION_STATE["Closing"] = "closing";
    CONNECTION_STATE["Closed"] = "closed";
})($3d531e63e1ea7f53$export$deda39003d27273 || ($3d531e63e1ea7f53$export$deda39003d27273 = {}));


// This file draws heavily from https://github.com/phoenixframework/phoenix/commit/cf098e9cf7a44ee6479d31d911a97d3c7430c6fe
// License: https://github.com/phoenixframework/phoenix/blob/master/LICENSE.md
class $6805f7080ae1d67f$export$2e2bcd8739ae039 {
    constructor(){
        this.HEADER_LENGTH = 1;
    }
    decode(rawPayload, callback) {
        if (rawPayload.constructor === ArrayBuffer) return callback(this._binaryDecode(rawPayload));
        if (typeof rawPayload === 'string') return callback(JSON.parse(rawPayload));
        return callback({});
    }
    _binaryDecode(buffer) {
        const view = new DataView(buffer);
        const decoder = new TextDecoder();
        return this._decodeBroadcast(buffer, view, decoder);
    }
    _decodeBroadcast(buffer, view, decoder) {
        const topicSize = view.getUint8(1);
        const eventSize = view.getUint8(2);
        let offset = this.HEADER_LENGTH + 2;
        const topic = decoder.decode(buffer.slice(offset, offset + topicSize));
        offset = offset + topicSize;
        const event = decoder.decode(buffer.slice(offset, offset + eventSize));
        offset = offset + eventSize;
        const data = JSON.parse(decoder.decode(buffer.slice(offset, buffer.byteLength)));
        return {
            ref: null,
            topic: topic,
            event: event,
            payload: data
        };
    }
}


/**
 * Creates a timer that accepts a `timerCalc` function to perform calculated timeout retries, such as exponential backoff.
 *
 * @example
 *    let reconnectTimer = new Timer(() => this.connect(), function(tries){
 *      return [1000, 5000, 10000][tries - 1] || 10000
 *    })
 *    reconnectTimer.scheduleTimeout() // fires after 1000
 *    reconnectTimer.scheduleTimeout() // fires after 5000
 *    reconnectTimer.reset()
 *    reconnectTimer.scheduleTimeout() // fires after 1000
 */ class $505c2b2d07197e20$export$2e2bcd8739ae039 {
    constructor(callback, timerCalc){
        this.callback = callback;
        this.timerCalc = timerCalc;
        this.timer = undefined;
        this.tries = 0;
        this.callback = callback;
        this.timerCalc = timerCalc;
    }
    reset() {
        this.tries = 0;
        clearTimeout(this.timer);
    }
    // Cancels any previous scheduleTimeout and schedules callback
    scheduleTimeout() {
        clearTimeout(this.timer);
        this.timer = setTimeout(()=>{
            this.tries = this.tries + 1;
            this.callback();
        }, this.timerCalc(this.tries + 1));
    }
}


/**
 * Helpers to convert the change Payload into native JS types.
 */ // Adapted from epgsql (src/epgsql_binary.erl), this module licensed under
// 3-clause BSD found here: https://raw.githubusercontent.com/epgsql/epgsql/devel/LICENSE
var $3f01feefa94fd48b$export$4d213a7d364021dc;
(function(PostgresTypes) {
    PostgresTypes["abstime"] = "abstime";
    PostgresTypes["bool"] = "bool";
    PostgresTypes["date"] = "date";
    PostgresTypes["daterange"] = "daterange";
    PostgresTypes["float4"] = "float4";
    PostgresTypes["float8"] = "float8";
    PostgresTypes["int2"] = "int2";
    PostgresTypes["int4"] = "int4";
    PostgresTypes["int4range"] = "int4range";
    PostgresTypes["int8"] = "int8";
    PostgresTypes["int8range"] = "int8range";
    PostgresTypes["json"] = "json";
    PostgresTypes["jsonb"] = "jsonb";
    PostgresTypes["money"] = "money";
    PostgresTypes["numeric"] = "numeric";
    PostgresTypes["oid"] = "oid";
    PostgresTypes["reltime"] = "reltime";
    PostgresTypes["text"] = "text";
    PostgresTypes["time"] = "time";
    PostgresTypes["timestamp"] = "timestamp";
    PostgresTypes["timestamptz"] = "timestamptz";
    PostgresTypes["timetz"] = "timetz";
    PostgresTypes["tsrange"] = "tsrange";
    PostgresTypes["tstzrange"] = "tstzrange";
})($3f01feefa94fd48b$export$4d213a7d364021dc || ($3f01feefa94fd48b$export$4d213a7d364021dc = {}));
const $3f01feefa94fd48b$export$20ce708a1f594c5e = (columns, record, options = {})=>{
    var _a;
    const skipTypes = (_a = options.skipTypes) !== null && _a !== void 0 ? _a : [];
    return Object.keys(record).reduce((acc, rec_key)=>{
        acc[rec_key] = $3f01feefa94fd48b$export$c054edfec1afa88d(rec_key, columns, record, skipTypes);
        return acc;
    }, {});
};
const $3f01feefa94fd48b$export$c054edfec1afa88d = (columnName, columns, record, skipTypes)=>{
    const column = columns.find((x)=>x.name === columnName);
    const colType = column === null || column === void 0 ? void 0 : column.type;
    const value = record[columnName];
    if (colType && !skipTypes.includes(colType)) return $3f01feefa94fd48b$export$3df02a362b86a91(colType, value);
    return $3f01feefa94fd48b$var$noop(value);
};
const $3f01feefa94fd48b$export$3df02a362b86a91 = (type, value)=>{
    // if data type is an array
    if (type.charAt(0) === '_') {
        const dataType = type.slice(1, type.length);
        return $3f01feefa94fd48b$export$45b10814cc054894(value, dataType);
    }
    // If not null, convert to correct type.
    switch(type){
        case $3f01feefa94fd48b$export$4d213a7d364021dc.bool:
            return $3f01feefa94fd48b$export$3c2e6d1b7583eee6(value);
        case $3f01feefa94fd48b$export$4d213a7d364021dc.float4:
        case $3f01feefa94fd48b$export$4d213a7d364021dc.float8:
        case $3f01feefa94fd48b$export$4d213a7d364021dc.int2:
        case $3f01feefa94fd48b$export$4d213a7d364021dc.int4:
        case $3f01feefa94fd48b$export$4d213a7d364021dc.int8:
        case $3f01feefa94fd48b$export$4d213a7d364021dc.numeric:
        case $3f01feefa94fd48b$export$4d213a7d364021dc.oid:
            return $3f01feefa94fd48b$export$a0a81dc3380ce7d3(value);
        case $3f01feefa94fd48b$export$4d213a7d364021dc.json:
        case $3f01feefa94fd48b$export$4d213a7d364021dc.jsonb:
            return $3f01feefa94fd48b$export$d5b7a8bf56ee1fe2(value);
        case $3f01feefa94fd48b$export$4d213a7d364021dc.timestamp:
            return $3f01feefa94fd48b$export$eccf8c5d91d19e3a(value); // Format to be consistent with PostgREST
        case $3f01feefa94fd48b$export$4d213a7d364021dc.abstime:
        case $3f01feefa94fd48b$export$4d213a7d364021dc.date:
        case $3f01feefa94fd48b$export$4d213a7d364021dc.daterange:
        case $3f01feefa94fd48b$export$4d213a7d364021dc.int4range:
        case $3f01feefa94fd48b$export$4d213a7d364021dc.int8range:
        case $3f01feefa94fd48b$export$4d213a7d364021dc.money:
        case $3f01feefa94fd48b$export$4d213a7d364021dc.reltime:
        case $3f01feefa94fd48b$export$4d213a7d364021dc.text:
        case $3f01feefa94fd48b$export$4d213a7d364021dc.time:
        case $3f01feefa94fd48b$export$4d213a7d364021dc.timestamptz:
        case $3f01feefa94fd48b$export$4d213a7d364021dc.timetz:
        case $3f01feefa94fd48b$export$4d213a7d364021dc.tsrange:
        case $3f01feefa94fd48b$export$4d213a7d364021dc.tstzrange:
            return $3f01feefa94fd48b$var$noop(value);
        default:
            // Return the value for remaining types
            return $3f01feefa94fd48b$var$noop(value);
    }
};
const $3f01feefa94fd48b$var$noop = (value)=>{
    return value;
};
const $3f01feefa94fd48b$export$3c2e6d1b7583eee6 = (value)=>{
    switch(value){
        case 't':
            return true;
        case 'f':
            return false;
        default:
            return value;
    }
};
const $3f01feefa94fd48b$export$a0a81dc3380ce7d3 = (value)=>{
    if (typeof value === 'string') {
        const parsedValue = parseFloat(value);
        if (!Number.isNaN(parsedValue)) return parsedValue;
    }
    return value;
};
const $3f01feefa94fd48b$export$d5b7a8bf56ee1fe2 = (value)=>{
    if (typeof value === 'string') try {
        return JSON.parse(value);
    } catch (error) {
        console.log(`JSON parse error: ${error}`);
        return value;
    }
    return value;
};
const $3f01feefa94fd48b$export$45b10814cc054894 = (value, type)=>{
    if (typeof value !== 'string') return value;
    const lastIdx = value.length - 1;
    const closeBrace = value[lastIdx];
    const openBrace = value[0];
    // Confirm value is a Postgres array by checking curly brackets
    if (openBrace === '{' && closeBrace === '}') {
        let arr;
        const valTrim = value.slice(1, lastIdx);
        // TODO: find a better solution to separate Postgres array data
        try {
            arr = JSON.parse('[' + valTrim + ']');
        } catch (_) {
            // WARNING: splitting on comma does not cover all edge cases
            arr = valTrim ? valTrim.split(',') : [];
        }
        return arr.map((val)=>$3f01feefa94fd48b$export$3df02a362b86a91(type, val));
    }
    return value;
};
const $3f01feefa94fd48b$export$eccf8c5d91d19e3a = (value)=>{
    if (typeof value === 'string') return value.replace(' ', 'T');
    return value;
};
const $3f01feefa94fd48b$export$976fda7151b30cae = (socketUrl)=>{
    let url = socketUrl;
    url = url.replace(/^ws/i, 'http');
    url = url.replace(/(\/socket\/websocket|\/socket|\/websocket)\/?$/i, '');
    return url.replace(/\/+$/, '');
};




class $9b541112b15eb31d$export$2e2bcd8739ae039 {
    /**
     * Initializes the Push
     *
     * @param channel The Channel
     * @param event The event, for example `"phx_join"`
     * @param payload The payload, for example `{user_id: 123}`
     * @param timeout The push timeout in milliseconds
     */ constructor(channel, event, payload = {}, timeout = (0, $3d531e63e1ea7f53$export$7bd623b29ec8e1eb)){
        this.channel = channel;
        this.event = event;
        this.payload = payload;
        this.timeout = timeout;
        this.sent = false;
        this.timeoutTimer = undefined;
        this.ref = '';
        this.receivedResp = null;
        this.recHooks = [];
        this.refEvent = null;
    }
    resend(timeout) {
        this.timeout = timeout;
        this._cancelRefEvent();
        this.ref = '';
        this.refEvent = null;
        this.receivedResp = null;
        this.sent = false;
        this.send();
    }
    send() {
        if (this._hasReceived('timeout')) return;
        this.startTimeout();
        this.sent = true;
        this.channel.socket.push({
            topic: this.channel.topic,
            event: this.event,
            payload: this.payload,
            ref: this.ref,
            join_ref: this.channel._joinRef()
        });
    }
    updatePayload(payload) {
        this.payload = Object.assign(Object.assign({}, this.payload), payload);
    }
    receive(status, callback) {
        var _a;
        if (this._hasReceived(status)) callback((_a = this.receivedResp) === null || _a === void 0 ? void 0 : _a.response);
        this.recHooks.push({
            status: status,
            callback: callback
        });
        return this;
    }
    startTimeout() {
        if (this.timeoutTimer) return;
        this.ref = this.channel.socket._makeRef();
        this.refEvent = this.channel._replyEventName(this.ref);
        const callback = (payload)=>{
            this._cancelRefEvent();
            this._cancelTimeout();
            this.receivedResp = payload;
            this._matchReceive(payload);
        };
        this.channel._on(this.refEvent, {}, callback);
        this.timeoutTimer = setTimeout(()=>{
            this.trigger('timeout', {});
        }, this.timeout);
    }
    trigger(status, response) {
        if (this.refEvent) this.channel._trigger(this.refEvent, {
            status: status,
            response: response
        });
    }
    destroy() {
        this._cancelRefEvent();
        this._cancelTimeout();
    }
    _cancelRefEvent() {
        if (!this.refEvent) return;
        this.channel._off(this.refEvent, {});
    }
    _cancelTimeout() {
        clearTimeout(this.timeoutTimer);
        this.timeoutTimer = undefined;
    }
    _matchReceive({ status: status, response: response }) {
        this.recHooks.filter((h)=>h.status === status).forEach((h)=>h.callback(response));
    }
    _hasReceived(status) {
        return this.receivedResp && this.receivedResp.status === status;
    }
}



/*
  This file draws heavily from https://github.com/phoenixframework/phoenix/blob/d344ec0a732ab4ee204215b31de69cf4be72e3bf/assets/js/phoenix/presence.js
  License: https://github.com/phoenixframework/phoenix/blob/d344ec0a732ab4ee204215b31de69cf4be72e3bf/LICENSE.md
*/ var $4c897aa496ab948f$export$f1ce049df2794fb4;
(function(REALTIME_PRESENCE_LISTEN_EVENTS) {
    REALTIME_PRESENCE_LISTEN_EVENTS["SYNC"] = "sync";
    REALTIME_PRESENCE_LISTEN_EVENTS["JOIN"] = "join";
    REALTIME_PRESENCE_LISTEN_EVENTS["LEAVE"] = "leave";
})($4c897aa496ab948f$export$f1ce049df2794fb4 || ($4c897aa496ab948f$export$f1ce049df2794fb4 = {}));
class $4c897aa496ab948f$export$2e2bcd8739ae039 {
    /**
     * Initializes the Presence.
     *
     * @param channel - The RealtimeChannel
     * @param opts - The options,
     *        for example `{events: {state: 'state', diff: 'diff'}}`
     */ constructor(channel, opts){
        this.channel = channel;
        this.state = {};
        this.pendingDiffs = [];
        this.joinRef = null;
        this.caller = {
            onJoin: ()=>{},
            onLeave: ()=>{},
            onSync: ()=>{}
        };
        const events = (opts === null || opts === void 0 ? void 0 : opts.events) || {
            state: 'presence_state',
            diff: 'presence_diff'
        };
        this.channel._on(events.state, {}, (newState)=>{
            const { onJoin: onJoin, onLeave: onLeave, onSync: onSync } = this.caller;
            this.joinRef = this.channel._joinRef();
            this.state = $4c897aa496ab948f$export$2e2bcd8739ae039.syncState(this.state, newState, onJoin, onLeave);
            this.pendingDiffs.forEach((diff)=>{
                this.state = $4c897aa496ab948f$export$2e2bcd8739ae039.syncDiff(this.state, diff, onJoin, onLeave);
            });
            this.pendingDiffs = [];
            onSync();
        });
        this.channel._on(events.diff, {}, (diff)=>{
            const { onJoin: onJoin, onLeave: onLeave, onSync: onSync } = this.caller;
            if (this.inPendingSyncState()) this.pendingDiffs.push(diff);
            else {
                this.state = $4c897aa496ab948f$export$2e2bcd8739ae039.syncDiff(this.state, diff, onJoin, onLeave);
                onSync();
            }
        });
        this.onJoin((key, currentPresences, newPresences)=>{
            this.channel._trigger('presence', {
                event: 'join',
                key: key,
                currentPresences: currentPresences,
                newPresences: newPresences
            });
        });
        this.onLeave((key, currentPresences, leftPresences)=>{
            this.channel._trigger('presence', {
                event: 'leave',
                key: key,
                currentPresences: currentPresences,
                leftPresences: leftPresences
            });
        });
        this.onSync(()=>{
            this.channel._trigger('presence', {
                event: 'sync'
            });
        });
    }
    /**
     * Used to sync the list of presences on the server with the
     * client's state.
     *
     * An optional `onJoin` and `onLeave` callback can be provided to
     * react to changes in the client's local presences across
     * disconnects and reconnects with the server.
     *
     * @internal
     */ static syncState(currentState, newState, onJoin, onLeave) {
        const state = this.cloneDeep(currentState);
        const transformedState = this.transformState(newState);
        const joins = {};
        const leaves = {};
        this.map(state, (key, presences)=>{
            if (!transformedState[key]) leaves[key] = presences;
        });
        this.map(transformedState, (key, newPresences)=>{
            const currentPresences = state[key];
            if (currentPresences) {
                const newPresenceRefs = newPresences.map((m)=>m.presence_ref);
                const curPresenceRefs = currentPresences.map((m)=>m.presence_ref);
                const joinedPresences = newPresences.filter((m)=>curPresenceRefs.indexOf(m.presence_ref) < 0);
                const leftPresences = currentPresences.filter((m)=>newPresenceRefs.indexOf(m.presence_ref) < 0);
                if (joinedPresences.length > 0) joins[key] = joinedPresences;
                if (leftPresences.length > 0) leaves[key] = leftPresences;
            } else joins[key] = newPresences;
        });
        return this.syncDiff(state, {
            joins: joins,
            leaves: leaves
        }, onJoin, onLeave);
    }
    /**
     * Used to sync a diff of presence join and leave events from the
     * server, as they happen.
     *
     * Like `syncState`, `syncDiff` accepts optional `onJoin` and
     * `onLeave` callbacks to react to a user joining or leaving from a
     * device.
     *
     * @internal
     */ static syncDiff(state, diff, onJoin, onLeave) {
        const { joins: joins, leaves: leaves } = {
            joins: this.transformState(diff.joins),
            leaves: this.transformState(diff.leaves)
        };
        if (!onJoin) onJoin = ()=>{};
        if (!onLeave) onLeave = ()=>{};
        this.map(joins, (key, newPresences)=>{
            var _a;
            const currentPresences = (_a = state[key]) !== null && _a !== void 0 ? _a : [];
            state[key] = this.cloneDeep(newPresences);
            if (currentPresences.length > 0) {
                const joinedPresenceRefs = state[key].map((m)=>m.presence_ref);
                const curPresences = currentPresences.filter((m)=>joinedPresenceRefs.indexOf(m.presence_ref) < 0);
                state[key].unshift(...curPresences);
            }
            onJoin(key, currentPresences, newPresences);
        });
        this.map(leaves, (key, leftPresences)=>{
            let currentPresences = state[key];
            if (!currentPresences) return;
            const presenceRefsToRemove = leftPresences.map((m)=>m.presence_ref);
            currentPresences = currentPresences.filter((m)=>presenceRefsToRemove.indexOf(m.presence_ref) < 0);
            state[key] = currentPresences;
            onLeave(key, currentPresences, leftPresences);
            if (currentPresences.length === 0) delete state[key];
        });
        return state;
    }
    /** @internal */ static map(obj, func) {
        return Object.getOwnPropertyNames(obj).map((key)=>func(key, obj[key]));
    }
    /**
     * Remove 'metas' key
     * Change 'phx_ref' to 'presence_ref'
     * Remove 'phx_ref' and 'phx_ref_prev'
     *
     * @example
     * // returns {
     *  abc123: [
     *    { presence_ref: '2', user_id: 1 },
     *    { presence_ref: '3', user_id: 2 }
     *  ]
     * }
     * RealtimePresence.transformState({
     *  abc123: {
     *    metas: [
     *      { phx_ref: '2', phx_ref_prev: '1' user_id: 1 },
     *      { phx_ref: '3', user_id: 2 }
     *    ]
     *  }
     * })
     *
     * @internal
     */ static transformState(state) {
        state = this.cloneDeep(state);
        return Object.getOwnPropertyNames(state).reduce((newState, key)=>{
            const presences = state[key];
            if ('metas' in presences) newState[key] = presences.metas.map((presence)=>{
                presence['presence_ref'] = presence['phx_ref'];
                delete presence['phx_ref'];
                delete presence['phx_ref_prev'];
                return presence;
            });
            else newState[key] = presences;
            return newState;
        }, {});
    }
    /** @internal */ static cloneDeep(obj) {
        return JSON.parse(JSON.stringify(obj));
    }
    /** @internal */ onJoin(callback) {
        this.caller.onJoin = callback;
    }
    /** @internal */ onLeave(callback) {
        this.caller.onLeave = callback;
    }
    /** @internal */ onSync(callback) {
        this.caller.onSync = callback;
    }
    /** @internal */ inPendingSyncState() {
        return !this.joinRef || this.joinRef !== this.channel._joinRef();
    }
}



var $0851918337283a61$export$bc171c571098b6c4;
(function(REALTIME_POSTGRES_CHANGES_LISTEN_EVENT) {
    REALTIME_POSTGRES_CHANGES_LISTEN_EVENT["ALL"] = "*";
    REALTIME_POSTGRES_CHANGES_LISTEN_EVENT["INSERT"] = "INSERT";
    REALTIME_POSTGRES_CHANGES_LISTEN_EVENT["UPDATE"] = "UPDATE";
    REALTIME_POSTGRES_CHANGES_LISTEN_EVENT["DELETE"] = "DELETE";
})($0851918337283a61$export$bc171c571098b6c4 || ($0851918337283a61$export$bc171c571098b6c4 = {}));
var $0851918337283a61$export$9e3fe8e487ef792e;
(function(REALTIME_LISTEN_TYPES) {
    REALTIME_LISTEN_TYPES["BROADCAST"] = "broadcast";
    REALTIME_LISTEN_TYPES["PRESENCE"] = "presence";
    REALTIME_LISTEN_TYPES["POSTGRES_CHANGES"] = "postgres_changes";
    REALTIME_LISTEN_TYPES["SYSTEM"] = "system";
})($0851918337283a61$export$9e3fe8e487ef792e || ($0851918337283a61$export$9e3fe8e487ef792e = {}));
var $0851918337283a61$export$a6885b926af646a2;
(function(REALTIME_SUBSCRIBE_STATES) {
    REALTIME_SUBSCRIBE_STATES["SUBSCRIBED"] = "SUBSCRIBED";
    REALTIME_SUBSCRIBE_STATES["TIMED_OUT"] = "TIMED_OUT";
    REALTIME_SUBSCRIBE_STATES["CLOSED"] = "CLOSED";
    REALTIME_SUBSCRIBE_STATES["CHANNEL_ERROR"] = "CHANNEL_ERROR";
})($0851918337283a61$export$a6885b926af646a2 || ($0851918337283a61$export$a6885b926af646a2 = {}));
const $0851918337283a61$export$154db638d9c0559e = (0, $3d531e63e1ea7f53$export$b83816118db74fe7);
class $0851918337283a61$export$2e2bcd8739ae039 {
    constructor(/** Topic name can be any string. */ topic, params = {
        config: {}
    }, socket){
        this.topic = topic;
        this.params = params;
        this.socket = socket;
        this.bindings = {};
        this.state = (0, $3d531e63e1ea7f53$export$b83816118db74fe7).closed;
        this.joinedOnce = false;
        this.pushBuffer = [];
        this.subTopic = topic.replace(/^realtime:/i, '');
        this.params.config = Object.assign({
            broadcast: {
                ack: false,
                self: false
            },
            presence: {
                key: ''
            },
            private: false
        }, params.config);
        this.timeout = this.socket.timeout;
        this.joinPush = new (0, $9b541112b15eb31d$export$2e2bcd8739ae039)(this, (0, $3d531e63e1ea7f53$export$8db7548e65d6ea55).join, this.params, this.timeout);
        this.rejoinTimer = new (0, $505c2b2d07197e20$export$2e2bcd8739ae039)(()=>this._rejoinUntilConnected(), this.socket.reconnectAfterMs);
        this.joinPush.receive('ok', ()=>{
            this.state = (0, $3d531e63e1ea7f53$export$b83816118db74fe7).joined;
            this.rejoinTimer.reset();
            this.pushBuffer.forEach((pushEvent)=>pushEvent.send());
            this.pushBuffer = [];
        });
        this._onClose(()=>{
            this.rejoinTimer.reset();
            this.socket.log('channel', `close ${this.topic} ${this._joinRef()}`);
            this.state = (0, $3d531e63e1ea7f53$export$b83816118db74fe7).closed;
            this.socket._remove(this);
        });
        this._onError((reason)=>{
            if (this._isLeaving() || this._isClosed()) return;
            this.socket.log('channel', `error ${this.topic}`, reason);
            this.state = (0, $3d531e63e1ea7f53$export$b83816118db74fe7).errored;
            this.rejoinTimer.scheduleTimeout();
        });
        this.joinPush.receive('timeout', ()=>{
            if (!this._isJoining()) return;
            this.socket.log('channel', `timeout ${this.topic}`, this.joinPush.timeout);
            this.state = (0, $3d531e63e1ea7f53$export$b83816118db74fe7).errored;
            this.rejoinTimer.scheduleTimeout();
        });
        this._on((0, $3d531e63e1ea7f53$export$8db7548e65d6ea55).reply, {}, (payload, ref)=>{
            this._trigger(this._replyEventName(ref), payload);
        });
        this.presence = new (0, $4c897aa496ab948f$export$2e2bcd8739ae039)(this);
        this.broadcastEndpointURL = (0, $3f01feefa94fd48b$export$976fda7151b30cae)(this.socket.endPoint) + '/api/broadcast';
        this.private = this.params.config.private || false;
    }
    /** Subscribe registers your client with the server */ subscribe(callback, timeout = this.timeout) {
        var _a, _b;
        if (!this.socket.isConnected()) this.socket.connect();
        if (this.state == (0, $3d531e63e1ea7f53$export$b83816118db74fe7).closed) {
            const { config: { broadcast: broadcast, presence: presence, private: isPrivate } } = this.params;
            this._onError((e)=>callback === null || callback === void 0 ? void 0 : callback($0851918337283a61$export$a6885b926af646a2.CHANNEL_ERROR, e));
            this._onClose(()=>callback === null || callback === void 0 ? void 0 : callback($0851918337283a61$export$a6885b926af646a2.CLOSED));
            const accessTokenPayload = {};
            const config = {
                broadcast: broadcast,
                presence: presence,
                postgres_changes: (_b = (_a = this.bindings.postgres_changes) === null || _a === void 0 ? void 0 : _a.map((r)=>r.filter)) !== null && _b !== void 0 ? _b : [],
                private: isPrivate
            };
            if (this.socket.accessTokenValue) accessTokenPayload.access_token = this.socket.accessTokenValue;
            this.updateJoinPayload(Object.assign({
                config: config
            }, accessTokenPayload));
            this.joinedOnce = true;
            this._rejoin(timeout);
            this.joinPush.receive('ok', async ({ postgres_changes: postgres_changes })=>{
                var _a;
                this.socket.setAuth();
                if (postgres_changes === undefined) {
                    callback === null || callback === void 0 || callback($0851918337283a61$export$a6885b926af646a2.SUBSCRIBED);
                    return;
                } else {
                    const clientPostgresBindings = this.bindings.postgres_changes;
                    const bindingsLen = (_a = clientPostgresBindings === null || clientPostgresBindings === void 0 ? void 0 : clientPostgresBindings.length) !== null && _a !== void 0 ? _a : 0;
                    const newPostgresBindings = [];
                    for(let i = 0; i < bindingsLen; i++){
                        const clientPostgresBinding = clientPostgresBindings[i];
                        const { filter: { event: event, schema: schema, table: table, filter: filter } } = clientPostgresBinding;
                        const serverPostgresFilter = postgres_changes && postgres_changes[i];
                        if (serverPostgresFilter && serverPostgresFilter.event === event && serverPostgresFilter.schema === schema && serverPostgresFilter.table === table && serverPostgresFilter.filter === filter) newPostgresBindings.push(Object.assign(Object.assign({}, clientPostgresBinding), {
                            id: serverPostgresFilter.id
                        }));
                        else {
                            this.unsubscribe();
                            this.state = (0, $3d531e63e1ea7f53$export$b83816118db74fe7).errored;
                            callback === null || callback === void 0 || callback($0851918337283a61$export$a6885b926af646a2.CHANNEL_ERROR, new Error('mismatch between server and client bindings for postgres changes'));
                            return;
                        }
                    }
                    this.bindings.postgres_changes = newPostgresBindings;
                    callback && callback($0851918337283a61$export$a6885b926af646a2.SUBSCRIBED);
                    return;
                }
            }).receive('error', (error)=>{
                this.state = (0, $3d531e63e1ea7f53$export$b83816118db74fe7).errored;
                callback === null || callback === void 0 || callback($0851918337283a61$export$a6885b926af646a2.CHANNEL_ERROR, new Error(JSON.stringify(Object.values(error).join(', ') || 'error')));
                return;
            }).receive('timeout', ()=>{
                callback === null || callback === void 0 || callback($0851918337283a61$export$a6885b926af646a2.TIMED_OUT);
                return;
            });
        }
        return this;
    }
    presenceState() {
        return this.presence.state;
    }
    async track(payload, opts = {}) {
        return await this.send({
            type: 'presence',
            event: 'track',
            payload: payload
        }, opts.timeout || this.timeout);
    }
    async untrack(opts = {}) {
        return await this.send({
            type: 'presence',
            event: 'untrack'
        }, opts);
    }
    on(type, filter, callback) {
        return this._on(type, filter, callback);
    }
    /**
     * Sends a message into the channel.
     *
     * @param args Arguments to send to channel
     * @param args.type The type of event to send
     * @param args.event The name of the event being sent
     * @param args.payload Payload to be sent
     * @param opts Options to be used during the send process
     */ async send(args, opts = {}) {
        var _a, _b;
        if (!this._canPush() && args.type === 'broadcast') {
            const { event: event, payload: endpoint_payload } = args;
            const authorization = this.socket.accessTokenValue ? `Bearer ${this.socket.accessTokenValue}` : '';
            const options = {
                method: 'POST',
                headers: {
                    Authorization: authorization,
                    apikey: this.socket.apiKey ? this.socket.apiKey : '',
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    messages: [
                        {
                            topic: this.subTopic,
                            event: event,
                            payload: endpoint_payload,
                            private: this.private
                        }
                    ]
                })
            };
            try {
                const response = await this._fetchWithTimeout(this.broadcastEndpointURL, options, (_a = opts.timeout) !== null && _a !== void 0 ? _a : this.timeout);
                await ((_b = response.body) === null || _b === void 0 ? void 0 : _b.cancel());
                return response.ok ? 'ok' : 'error';
            } catch (error) {
                if (error.name === 'AbortError') return 'timed out';
                else return 'error';
            }
        } else return new Promise((resolve)=>{
            var _a, _b, _c;
            const push = this._push(args.type, args, opts.timeout || this.timeout);
            if (args.type === 'broadcast' && !((_c = (_b = (_a = this.params) === null || _a === void 0 ? void 0 : _a.config) === null || _b === void 0 ? void 0 : _b.broadcast) === null || _c === void 0 ? void 0 : _c.ack)) resolve('ok');
            push.receive('ok', ()=>resolve('ok'));
            push.receive('error', ()=>resolve('error'));
            push.receive('timeout', ()=>resolve('timed out'));
        });
    }
    updateJoinPayload(payload) {
        this.joinPush.updatePayload(payload);
    }
    /**
     * Leaves the channel.
     *
     * Unsubscribes from server events, and instructs channel to terminate on server.
     * Triggers onClose() hooks.
     *
     * To receive leave acknowledgements, use the a `receive` hook to bind to the server ack, ie:
     * channel.unsubscribe().receive("ok", () => alert("left!") )
     */ unsubscribe(timeout = this.timeout) {
        this.state = (0, $3d531e63e1ea7f53$export$b83816118db74fe7).leaving;
        const onClose = ()=>{
            this.socket.log('channel', `leave ${this.topic}`);
            this._trigger((0, $3d531e63e1ea7f53$export$8db7548e65d6ea55).close, 'leave', this._joinRef());
        };
        this.joinPush.destroy();
        let leavePush = null;
        return new Promise((resolve)=>{
            leavePush = new (0, $9b541112b15eb31d$export$2e2bcd8739ae039)(this, (0, $3d531e63e1ea7f53$export$8db7548e65d6ea55).leave, {}, timeout);
            leavePush.receive('ok', ()=>{
                onClose();
                resolve('ok');
            }).receive('timeout', ()=>{
                onClose();
                resolve('timed out');
            }).receive('error', ()=>{
                resolve('error');
            });
            leavePush.send();
            if (!this._canPush()) leavePush.trigger('ok', {});
        }).finally(()=>{
            leavePush === null || leavePush === void 0 || leavePush.destroy();
        });
    }
    /**
     * Teardown the channel.
     *
     * Destroys and stops related timers.
     */ teardown() {
        this.pushBuffer.forEach((push)=>push.destroy());
        this.rejoinTimer && clearTimeout(this.rejoinTimer.timer);
        this.joinPush.destroy();
    }
    /** @internal */ async _fetchWithTimeout(url, options, timeout) {
        const controller = new AbortController();
        const id = setTimeout(()=>controller.abort(), timeout);
        const response = await this.socket.fetch(url, Object.assign(Object.assign({}, options), {
            signal: controller.signal
        }));
        clearTimeout(id);
        return response;
    }
    /** @internal */ _push(event, payload, timeout = this.timeout) {
        if (!this.joinedOnce) throw `tried to push '${event}' to '${this.topic}' before joining. Use channel.subscribe() before pushing events`;
        let pushEvent = new (0, $9b541112b15eb31d$export$2e2bcd8739ae039)(this, event, payload, timeout);
        if (this._canPush()) pushEvent.send();
        else {
            pushEvent.startTimeout();
            this.pushBuffer.push(pushEvent);
        }
        return pushEvent;
    }
    /**
     * Overridable message hook
     *
     * Receives all events for specialized message handling before dispatching to the channel callbacks.
     * Must return the payload, modified or unmodified.
     *
     * @internal
     */ _onMessage(_event, payload, _ref) {
        return payload;
    }
    /** @internal */ _isMember(topic) {
        return this.topic === topic;
    }
    /** @internal */ _joinRef() {
        return this.joinPush.ref;
    }
    /** @internal */ _trigger(type, payload, ref) {
        var _a, _b;
        const typeLower = type.toLocaleLowerCase();
        const { close: close, error: error, leave: leave, join: join } = (0, $3d531e63e1ea7f53$export$8db7548e65d6ea55);
        const events = [
            close,
            error,
            leave,
            join
        ];
        if (ref && events.indexOf(typeLower) >= 0 && ref !== this._joinRef()) return;
        let handledPayload = this._onMessage(typeLower, payload, ref);
        if (payload && !handledPayload) throw 'channel onMessage callbacks must return the payload, modified or unmodified';
        if ([
            'insert',
            'update',
            'delete'
        ].includes(typeLower)) (_a = this.bindings.postgres_changes) === null || _a === void 0 || _a.filter((bind)=>{
            var _a, _b, _c;
            return ((_a = bind.filter) === null || _a === void 0 ? void 0 : _a.event) === '*' || ((_c = (_b = bind.filter) === null || _b === void 0 ? void 0 : _b.event) === null || _c === void 0 ? void 0 : _c.toLocaleLowerCase()) === typeLower;
        }).map((bind)=>bind.callback(handledPayload, ref));
        else (_b = this.bindings[typeLower]) === null || _b === void 0 || _b.filter((bind)=>{
            var _a, _b, _c, _d, _e, _f;
            if ([
                'broadcast',
                'presence',
                'postgres_changes'
            ].includes(typeLower)) {
                if ('id' in bind) {
                    const bindId = bind.id;
                    const bindEvent = (_a = bind.filter) === null || _a === void 0 ? void 0 : _a.event;
                    return bindId && ((_b = payload.ids) === null || _b === void 0 ? void 0 : _b.includes(bindId)) && (bindEvent === '*' || (bindEvent === null || bindEvent === void 0 ? void 0 : bindEvent.toLocaleLowerCase()) === ((_c = payload.data) === null || _c === void 0 ? void 0 : _c.type.toLocaleLowerCase()));
                } else {
                    const bindEvent = (_e = (_d = bind === null || bind === void 0 ? void 0 : bind.filter) === null || _d === void 0 ? void 0 : _d.event) === null || _e === void 0 ? void 0 : _e.toLocaleLowerCase();
                    return bindEvent === '*' || bindEvent === ((_f = payload === null || payload === void 0 ? void 0 : payload.event) === null || _f === void 0 ? void 0 : _f.toLocaleLowerCase());
                }
            } else return bind.type.toLocaleLowerCase() === typeLower;
        }).map((bind)=>{
            if (typeof handledPayload === 'object' && 'ids' in handledPayload) {
                const postgresChanges = handledPayload.data;
                const { schema: schema, table: table, commit_timestamp: commit_timestamp, type: type, errors: errors } = postgresChanges;
                const enrichedPayload = {
                    schema: schema,
                    table: table,
                    commit_timestamp: commit_timestamp,
                    eventType: type,
                    new: {},
                    old: {},
                    errors: errors
                };
                handledPayload = Object.assign(Object.assign({}, enrichedPayload), this._getPayloadRecords(postgresChanges));
            }
            bind.callback(handledPayload, ref);
        });
    }
    /** @internal */ _isClosed() {
        return this.state === (0, $3d531e63e1ea7f53$export$b83816118db74fe7).closed;
    }
    /** @internal */ _isJoined() {
        return this.state === (0, $3d531e63e1ea7f53$export$b83816118db74fe7).joined;
    }
    /** @internal */ _isJoining() {
        return this.state === (0, $3d531e63e1ea7f53$export$b83816118db74fe7).joining;
    }
    /** @internal */ _isLeaving() {
        return this.state === (0, $3d531e63e1ea7f53$export$b83816118db74fe7).leaving;
    }
    /** @internal */ _replyEventName(ref) {
        return `chan_reply_${ref}`;
    }
    /** @internal */ _on(type, filter, callback) {
        const typeLower = type.toLocaleLowerCase();
        const binding = {
            type: typeLower,
            filter: filter,
            callback: callback
        };
        if (this.bindings[typeLower]) this.bindings[typeLower].push(binding);
        else this.bindings[typeLower] = [
            binding
        ];
        return this;
    }
    /** @internal */ _off(type, filter) {
        const typeLower = type.toLocaleLowerCase();
        this.bindings[typeLower] = this.bindings[typeLower].filter((bind)=>{
            var _a;
            return !(((_a = bind.type) === null || _a === void 0 ? void 0 : _a.toLocaleLowerCase()) === typeLower && $0851918337283a61$export$2e2bcd8739ae039.isEqual(bind.filter, filter));
        });
        return this;
    }
    /** @internal */ static isEqual(obj1, obj2) {
        if (Object.keys(obj1).length !== Object.keys(obj2).length) return false;
        for(const k in obj1){
            if (obj1[k] !== obj2[k]) return false;
        }
        return true;
    }
    /** @internal */ _rejoinUntilConnected() {
        this.rejoinTimer.scheduleTimeout();
        if (this.socket.isConnected()) this._rejoin();
    }
    /**
     * Registers a callback that will be executed when the channel closes.
     *
     * @internal
     */ _onClose(callback) {
        this._on((0, $3d531e63e1ea7f53$export$8db7548e65d6ea55).close, {}, callback);
    }
    /**
     * Registers a callback that will be executed when the channel encounteres an error.
     *
     * @internal
     */ _onError(callback) {
        this._on((0, $3d531e63e1ea7f53$export$8db7548e65d6ea55).error, {}, (reason)=>callback(reason));
    }
    /**
     * Returns `true` if the socket is connected and the channel has been joined.
     *
     * @internal
     */ _canPush() {
        return this.socket.isConnected() && this._isJoined();
    }
    /** @internal */ _rejoin(timeout = this.timeout) {
        if (this._isLeaving()) return;
        this.socket._leaveOpenTopic(this.topic);
        this.state = (0, $3d531e63e1ea7f53$export$b83816118db74fe7).joining;
        this.joinPush.resend(timeout);
    }
    /** @internal */ _getPayloadRecords(payload) {
        const records = {
            new: {},
            old: {}
        };
        if (payload.type === 'INSERT' || payload.type === 'UPDATE') records.new = $3f01feefa94fd48b$export$20ce708a1f594c5e(payload.columns, payload.record);
        if (payload.type === 'UPDATE' || payload.type === 'DELETE') records.old = $3f01feefa94fd48b$export$20ce708a1f594c5e(payload.columns, payload.old_record);
        return records;
    }
}


const $ae049384a7d1c7c8$var$noop = ()=>{};
const $ae049384a7d1c7c8$var$WORKER_SCRIPT = `
  addEventListener("message", (e) => {
    if (e.data.event === "start") {
      setInterval(() => postMessage({ event: "keepAlive" }), e.data.interval);
    }
  });`;

class $ae049384a7d1c7c8$export$2e2bcd8739ae039 {
    /**
     * Initializes the Socket.
     *
     * @param endPoint The string WebSocket endpoint, ie, "ws://example.com/socket", "wss://example.com", "/socket" (inherited host & protocol)
     * @param httpEndpoint The string HTTP endpoint, ie, "https://example.com", "/" (inherited host & protocol)
     * @param options.transport The Websocket Transport, for example WebSocket. This can be a custom implementation
     * @param options.timeout The default timeout in milliseconds to trigger push timeouts.
     * @param options.params The optional params to pass when connecting.
     * @param options.headers Deprecated: headers cannot be set on websocket connections and this option will be removed in the future.
     * @param options.heartbeatIntervalMs The millisec interval to send a heartbeat message.
     * @param options.logger The optional function for specialized logging, ie: logger: (kind, msg, data) => { console.log(`${kind}: ${msg}`, data) }
     * @param options.logLevel Sets the log level for Realtime
     * @param options.encode The function to encode outgoing messages. Defaults to JSON: (payload, callback) => callback(JSON.stringify(payload))
     * @param options.decode The function to decode incoming messages. Defaults to Serializer's decode.
     * @param options.reconnectAfterMs he optional function that returns the millsec reconnect interval. Defaults to stepped backoff off.
     * @param options.worker Use Web Worker to set a side flow. Defaults to false.
     * @param options.workerUrl The URL of the worker script. Defaults to https://realtime.supabase.com/worker.js that includes a heartbeat event call to keep the connection alive.
     */ constructor(endPoint, options){
        var _a;
        this.accessTokenValue = null;
        this.apiKey = null;
        this.channels = new Array();
        this.endPoint = '';
        this.httpEndpoint = '';
        /** @deprecated headers cannot be set on websocket connections */ this.headers = {};
        this.params = {};
        this.timeout = (0, $3d531e63e1ea7f53$export$7bd623b29ec8e1eb);
        this.heartbeatIntervalMs = 25000;
        this.heartbeatTimer = undefined;
        this.pendingHeartbeatRef = null;
        this.heartbeatCallback = $ae049384a7d1c7c8$var$noop;
        this.ref = 0;
        this.logger = $ae049384a7d1c7c8$var$noop;
        this.conn = null;
        this.sendBuffer = [];
        this.serializer = new (0, $6805f7080ae1d67f$export$2e2bcd8739ae039)();
        this.stateChangeCallbacks = {
            open: [],
            close: [],
            error: [],
            message: []
        };
        this.accessToken = null;
        /**
         * Use either custom fetch, if provided, or default fetch to make HTTP requests
         *
         * @internal
         */ this._resolveFetch = (customFetch)=>{
            let _fetch;
            if (customFetch) _fetch = customFetch;
            else if (typeof fetch === 'undefined') _fetch = (...args)=>Promise.resolve((parcelRequire("979Ct"))).then(({ default: fetch1 })=>fetch1(...args));
            else _fetch = fetch;
            return (...args)=>_fetch(...args);
        };
        this.endPoint = `${endPoint}/${(0, $3d531e63e1ea7f53$export$b2688bfb999f5751).websocket}`;
        this.httpEndpoint = (0, $3f01feefa94fd48b$export$976fda7151b30cae)(endPoint);
        if (options === null || options === void 0 ? void 0 : options.transport) this.transport = options.transport;
        else this.transport = null;
        if (options === null || options === void 0 ? void 0 : options.params) this.params = options.params;
        if (options === null || options === void 0 ? void 0 : options.timeout) this.timeout = options.timeout;
        if (options === null || options === void 0 ? void 0 : options.logger) this.logger = options.logger;
        if ((options === null || options === void 0 ? void 0 : options.logLevel) || (options === null || options === void 0 ? void 0 : options.log_level)) {
            this.logLevel = options.logLevel || options.log_level;
            this.params = Object.assign(Object.assign({}, this.params), {
                log_level: this.logLevel
            });
        }
        if (options === null || options === void 0 ? void 0 : options.heartbeatIntervalMs) this.heartbeatIntervalMs = options.heartbeatIntervalMs;
        const accessTokenValue = (_a = options === null || options === void 0 ? void 0 : options.params) === null || _a === void 0 ? void 0 : _a.apikey;
        if (accessTokenValue) {
            this.accessTokenValue = accessTokenValue;
            this.apiKey = accessTokenValue;
        }
        this.reconnectAfterMs = (options === null || options === void 0 ? void 0 : options.reconnectAfterMs) ? options.reconnectAfterMs : (tries)=>{
            return [
                1000,
                2000,
                5000,
                10000
            ][tries - 1] || 10000;
        };
        this.encode = (options === null || options === void 0 ? void 0 : options.encode) ? options.encode : (payload, callback)=>{
            return callback(JSON.stringify(payload));
        };
        this.decode = (options === null || options === void 0 ? void 0 : options.decode) ? options.decode : this.serializer.decode.bind(this.serializer);
        this.reconnectTimer = new (0, $505c2b2d07197e20$export$2e2bcd8739ae039)(async ()=>{
            this.disconnect();
            this.connect();
        }, this.reconnectAfterMs);
        this.fetch = this._resolveFetch(options === null || options === void 0 ? void 0 : options.fetch);
        if (options === null || options === void 0 ? void 0 : options.worker) {
            if (typeof window !== 'undefined' && !window.Worker) throw new Error('Web Worker is not supported');
            this.worker = (options === null || options === void 0 ? void 0 : options.worker) || false;
            this.workerUrl = options === null || options === void 0 ? void 0 : options.workerUrl;
        }
        this.accessToken = (options === null || options === void 0 ? void 0 : options.accessToken) || null;
    }
    /**
     * Connects the socket, unless already connected.
     */ connect() {
        if (this.conn) return;
        if (!this.transport) this.transport = (0, $5c2f14c4e1a690d9$export$3909fb301d3dc8c9);
        if (!this.transport) throw new Error('No transport provided');
        this.conn = new this.transport(this.endpointURL());
        this.setupConnection();
    }
    /**
     * Returns the URL of the websocket.
     * @returns string The URL of the websocket.
     */ endpointURL() {
        return this._appendParams(this.endPoint, Object.assign({}, this.params, {
            vsn: (0, $3d531e63e1ea7f53$export$df3f558bb9a9c991)
        }));
    }
    /**
     * Disconnects the socket.
     *
     * @param code A numeric status code to send on disconnect.
     * @param reason A custom reason for the disconnect.
     */ disconnect(code, reason) {
        if (this.conn) {
            this.conn.onclose = function() {}; // noop
            if (code) this.conn.close(code, reason !== null && reason !== void 0 ? reason : '');
            else this.conn.close();
            this.conn = null;
            // remove open handles
            this.heartbeatTimer && clearInterval(this.heartbeatTimer);
            this.reconnectTimer.reset();
            this.channels.forEach((channel)=>channel.teardown());
        }
    }
    /**
     * Returns all created channels
     */ getChannels() {
        return this.channels;
    }
    /**
     * Unsubscribes and removes a single channel
     * @param channel A RealtimeChannel instance
     */ async removeChannel(channel) {
        const status = await channel.unsubscribe();
        if (this.channels.length === 0) this.disconnect();
        return status;
    }
    /**
     * Unsubscribes and removes all channels
     */ async removeAllChannels() {
        const values_1 = await Promise.all(this.channels.map((channel)=>channel.unsubscribe()));
        this.channels = [];
        this.disconnect();
        return values_1;
    }
    /**
     * Logs the message.
     *
     * For customized logging, `this.logger` can be overridden.
     */ log(kind, msg, data) {
        this.logger(kind, msg, data);
    }
    /**
     * Returns the current state of the socket.
     */ connectionState() {
        switch(this.conn && this.conn.readyState){
            case (0, $3d531e63e1ea7f53$export$a6d0320a1563d49e).connecting:
                return (0, $3d531e63e1ea7f53$export$deda39003d27273).Connecting;
            case (0, $3d531e63e1ea7f53$export$a6d0320a1563d49e).open:
                return (0, $3d531e63e1ea7f53$export$deda39003d27273).Open;
            case (0, $3d531e63e1ea7f53$export$a6d0320a1563d49e).closing:
                return (0, $3d531e63e1ea7f53$export$deda39003d27273).Closing;
            default:
                return (0, $3d531e63e1ea7f53$export$deda39003d27273).Closed;
        }
    }
    /**
     * Returns `true` is the connection is open.
     */ isConnected() {
        return this.connectionState() === (0, $3d531e63e1ea7f53$export$deda39003d27273).Open;
    }
    channel(topic, params = {
        config: {}
    }) {
        const realtimeTopic = `realtime:${topic}`;
        const exists = this.getChannels().find((c)=>c.topic === realtimeTopic);
        if (!exists) {
            const chan = new (0, $0851918337283a61$export$2e2bcd8739ae039)(`realtime:${topic}`, params, this);
            this.channels.push(chan);
            return chan;
        } else return exists;
    }
    /**
     * Push out a message if the socket is connected.
     *
     * If the socket is not connected, the message gets enqueued within a local buffer, and sent out when a connection is next established.
     */ push(data) {
        const { topic: topic, event: event, payload: payload, ref: ref } = data;
        const callback = ()=>{
            this.encode(data, (result)=>{
                var _a;
                (_a = this.conn) === null || _a === void 0 || _a.send(result);
            });
        };
        this.log('push', `${topic} ${event} (${ref})`, payload);
        if (this.isConnected()) callback();
        else this.sendBuffer.push(callback);
    }
    /**
     * Sets the JWT access token used for channel subscription authorization and Realtime RLS.
     *
     * If param is null it will use the `accessToken` callback function or the token set on the client.
     *
     * On callback used, it will set the value of the token internal to the client.
     *
     * @param token A JWT string to override the token set on the client.
     */ async setAuth(token = null) {
        let tokenToSend = token || this.accessToken && await this.accessToken() || this.accessTokenValue;
        if (this.accessTokenValue != tokenToSend) {
            this.accessTokenValue = tokenToSend;
            this.channels.forEach((channel)=>{
                const payload = {
                    access_token: tokenToSend,
                    version: (0, $3d531e63e1ea7f53$export$363ebe89e6e7aeef)
                };
                tokenToSend && channel.updateJoinPayload(payload);
                if (channel.joinedOnce && channel._isJoined()) channel._push((0, $3d531e63e1ea7f53$export$8db7548e65d6ea55).access_token, {
                    access_token: tokenToSend
                });
            });
        }
    }
    /**
     * Sends a heartbeat message if the socket is connected.
     */ async sendHeartbeat() {
        var _a;
        if (!this.isConnected()) {
            this.heartbeatCallback('disconnected');
            return;
        }
        if (this.pendingHeartbeatRef) {
            this.pendingHeartbeatRef = null;
            this.log('transport', 'heartbeat timeout. Attempting to re-establish connection');
            this.heartbeatCallback('timeout');
            (_a = this.conn) === null || _a === void 0 || _a.close((0, $3d531e63e1ea7f53$export$5e80cf62e56a877b), 'hearbeat timeout');
            return;
        }
        this.pendingHeartbeatRef = this._makeRef();
        this.push({
            topic: 'phoenix',
            event: 'heartbeat',
            payload: {},
            ref: this.pendingHeartbeatRef
        });
        this.heartbeatCallback('sent');
        await this.setAuth();
    }
    onHeartbeat(callback) {
        this.heartbeatCallback = callback;
    }
    /**
     * Flushes send buffer
     */ flushSendBuffer() {
        if (this.isConnected() && this.sendBuffer.length > 0) {
            this.sendBuffer.forEach((callback)=>callback());
            this.sendBuffer = [];
        }
    }
    /**
     * Return the next message ref, accounting for overflows
     *
     * @internal
     */ _makeRef() {
        let newRef = this.ref + 1;
        if (newRef === this.ref) this.ref = 0;
        else this.ref = newRef;
        return this.ref.toString();
    }
    /**
     * Unsubscribe from channels with the specified topic.
     *
     * @internal
     */ _leaveOpenTopic(topic) {
        let dupChannel = this.channels.find((c)=>c.topic === topic && (c._isJoined() || c._isJoining()));
        if (dupChannel) {
            this.log('transport', `leaving duplicate topic "${topic}"`);
            dupChannel.unsubscribe();
        }
    }
    /**
     * Removes a subscription from the socket.
     *
     * @param channel An open subscription.
     *
     * @internal
     */ _remove(channel) {
        this.channels = this.channels.filter((c)=>c.topic !== channel.topic);
    }
    /**
     * Sets up connection handlers.
     *
     * @internal
     */ setupConnection() {
        if (this.conn) {
            this.conn.binaryType = 'arraybuffer';
            this.conn.onopen = ()=>this._onConnOpen();
            this.conn.onerror = (error)=>this._onConnError(error);
            this.conn.onmessage = (event)=>this._onConnMessage(event);
            this.conn.onclose = (event)=>this._onConnClose(event);
        }
    }
    /** @internal */ _onConnMessage(rawMessage) {
        this.decode(rawMessage.data, (msg)=>{
            let { topic: topic, event: event, payload: payload, ref: ref } = msg;
            if (topic === 'phoenix' && event === 'phx_reply') this.heartbeatCallback(msg.payload.status == 'ok' ? 'ok' : 'error');
            if (ref && ref === this.pendingHeartbeatRef) this.pendingHeartbeatRef = null;
            this.log('receive', `${payload.status || ''} ${topic} ${event} ${ref && '(' + ref + ')' || ''}`, payload);
            Array.from(this.channels).filter((channel)=>channel._isMember(topic)).forEach((channel)=>channel._trigger(event, payload, ref));
            this.stateChangeCallbacks.message.forEach((callback)=>callback(msg));
        });
    }
    /** @internal */ _onConnOpen() {
        this.log('transport', `connected to ${this.endpointURL()}`);
        this.flushSendBuffer();
        this.reconnectTimer.reset();
        if (!this.worker) this._startHeartbeat();
        else if (!this.workerRef) this._startWorkerHeartbeat();
        this.stateChangeCallbacks.open.forEach((callback)=>callback());
    }
    /** @internal */ _startHeartbeat() {
        this.heartbeatTimer && clearInterval(this.heartbeatTimer);
        this.heartbeatTimer = setInterval(()=>this.sendHeartbeat(), this.heartbeatIntervalMs);
    }
    /** @internal */ _startWorkerHeartbeat() {
        if (this.workerUrl) this.log('worker', `starting worker for from ${this.workerUrl}`);
        else this.log('worker', `starting default worker`);
        const objectUrl = this._workerObjectUrl(this.workerUrl);
        this.workerRef = new Worker(objectUrl);
        this.workerRef.onerror = (error)=>{
            this.log('worker', 'worker error', error.message);
            this.workerRef.terminate();
        };
        this.workerRef.onmessage = (event)=>{
            if (event.data.event === 'keepAlive') this.sendHeartbeat();
        };
        this.workerRef.postMessage({
            event: 'start',
            interval: this.heartbeatIntervalMs
        });
    }
    /** @internal */ _onConnClose(event) {
        this.log('transport', 'close', event);
        this._triggerChanError();
        this.heartbeatTimer && clearInterval(this.heartbeatTimer);
        this.reconnectTimer.scheduleTimeout();
        this.stateChangeCallbacks.close.forEach((callback)=>callback(event));
    }
    /** @internal */ _onConnError(error) {
        this.log('transport', `${error}`);
        this._triggerChanError();
        this.stateChangeCallbacks.error.forEach((callback)=>callback(error));
    }
    /** @internal */ _triggerChanError() {
        this.channels.forEach((channel)=>channel._trigger((0, $3d531e63e1ea7f53$export$8db7548e65d6ea55).error));
    }
    /** @internal */ _appendParams(url, params) {
        if (Object.keys(params).length === 0) return url;
        const prefix = url.match(/\?/) ? '&' : '?';
        const query = new URLSearchParams(params);
        return `${url}${prefix}${query}`;
    }
    _workerObjectUrl(url) {
        let result_url;
        if (url) result_url = url;
        else {
            const blob = new Blob([
                $ae049384a7d1c7c8$var$WORKER_SCRIPT
            ], {
                type: 'application/javascript'
            });
            result_url = URL.createObjectURL(blob);
        }
        return result_url;
    }
}






class $abe02471d8456f7f$export$697502632950e9d3 extends Error {
    constructor(message){
        super(message);
        this.__isStorageError = true;
        this.name = 'StorageError';
    }
}
function $abe02471d8456f7f$export$5a322e77e5eb0561(error) {
    return typeof error === 'object' && error !== null && '__isStorageError' in error;
}
class $abe02471d8456f7f$export$ca9ecfd959b3871c extends $abe02471d8456f7f$export$697502632950e9d3 {
    constructor(message, status){
        super(message);
        this.name = 'StorageApiError';
        this.status = status;
    }
    toJSON() {
        return {
            name: this.name,
            message: this.message,
            status: this.status
        };
    }
}
class $abe02471d8456f7f$export$29127ca2e1a271d extends $abe02471d8456f7f$export$697502632950e9d3 {
    constructor(message, originalError){
        super(message);
        this.name = 'StorageUnknownError';
        this.originalError = originalError;
    }
}



var $b8abd4fb4763e533$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};

const $b8abd4fb4763e533$export$98d92b1aa79f8cc7 = (customFetch)=>{
    let _fetch;
    if (customFetch) _fetch = customFetch;
    else if (typeof fetch === 'undefined') _fetch = (...args)=>Promise.resolve((parcelRequire("979Ct"))).then(({ default: fetch1 })=>fetch1(...args));
    else _fetch = fetch;
    return (...args)=>_fetch(...args);
};

const $b8abd4fb4763e533$export$ace1d6afc438cf26 = ()=>$b8abd4fb4763e533$var$__awaiter(void 0, void 0, void 0, function*() {
        if (typeof Response === 'undefined') // @ts-ignore
        return (yield Promise.resolve((parcelRequire("979Ct")))).Response;
        return Response;
    });
const $b8abd4fb4763e533$export$69d519e35e6fc3d4 = (item)=>{
    if (Array.isArray(item)) return item.map((el)=>$b8abd4fb4763e533$export$69d519e35e6fc3d4(el));
    else if (typeof item === 'function' || item !== Object(item)) return item;
    const result = {};
    Object.entries(item).forEach(([key, value])=>{
        const newKey = key.replace(/([-_][a-z])/gi, (c)=>c.toUpperCase().replace(/[-_]/g, ''));
        result[newKey] = $b8abd4fb4763e533$export$69d519e35e6fc3d4(value);
    });
    return result;
};


var $2ad35efa1b333042$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
const $2ad35efa1b333042$var$_getErrorMessage = (err)=>err.msg || err.message || err.error_description || err.error || JSON.stringify(err);
const $2ad35efa1b333042$var$handleError = (error, reject, options)=>$2ad35efa1b333042$var$__awaiter(void 0, void 0, void 0, function*() {
        const Res = yield (0, $b8abd4fb4763e533$export$ace1d6afc438cf26)();
        if (error instanceof Res && !(options === null || options === void 0 ? void 0 : options.noResolveJson)) error.json().then((err)=>{
            reject(new (0, $abe02471d8456f7f$export$ca9ecfd959b3871c)($2ad35efa1b333042$var$_getErrorMessage(err), error.status || 500));
        }).catch((err)=>{
            reject(new (0, $abe02471d8456f7f$export$29127ca2e1a271d)($2ad35efa1b333042$var$_getErrorMessage(err), err));
        });
        else reject(new (0, $abe02471d8456f7f$export$29127ca2e1a271d)($2ad35efa1b333042$var$_getErrorMessage(error), error));
    });
const $2ad35efa1b333042$var$_getRequestParams = (method, options, parameters, body)=>{
    const params = {
        method: method,
        headers: (options === null || options === void 0 ? void 0 : options.headers) || {}
    };
    if (method === 'GET') return params;
    params.headers = Object.assign({
        'Content-Type': 'application/json'
    }, options === null || options === void 0 ? void 0 : options.headers);
    if (body) params.body = JSON.stringify(body);
    return Object.assign(Object.assign({}, params), parameters);
};
function $2ad35efa1b333042$var$_handleRequest(fetcher, method, url, options, parameters, body) {
    return $2ad35efa1b333042$var$__awaiter(this, void 0, void 0, function*() {
        return new Promise((resolve, reject)=>{
            fetcher(url, $2ad35efa1b333042$var$_getRequestParams(method, options, parameters, body)).then((result)=>{
                if (!result.ok) throw result;
                if (options === null || options === void 0 ? void 0 : options.noResolveJson) return result;
                return result.json();
            }).then((data)=>resolve(data)).catch((error)=>$2ad35efa1b333042$var$handleError(error, reject, options));
        });
    });
}
function $2ad35efa1b333042$export$3988ae62b71be9a3(fetcher, url, options, parameters) {
    return $2ad35efa1b333042$var$__awaiter(this, void 0, void 0, function*() {
        return $2ad35efa1b333042$var$_handleRequest(fetcher, 'GET', url, options, parameters);
    });
}
function $2ad35efa1b333042$export$299ba2dee77727e9(fetcher, url, body, options, parameters) {
    return $2ad35efa1b333042$var$__awaiter(this, void 0, void 0, function*() {
        return $2ad35efa1b333042$var$_handleRequest(fetcher, 'POST', url, options, parameters, body);
    });
}
function $2ad35efa1b333042$export$327f7b26ebf455db(fetcher, url, body, options, parameters) {
    return $2ad35efa1b333042$var$__awaiter(this, void 0, void 0, function*() {
        return $2ad35efa1b333042$var$_handleRequest(fetcher, 'PUT', url, options, parameters, body);
    });
}
function $2ad35efa1b333042$export$5fd5031fecdacec3(fetcher, url, options, parameters) {
    return $2ad35efa1b333042$var$__awaiter(this, void 0, void 0, function*() {
        return $2ad35efa1b333042$var$_handleRequest(fetcher, 'HEAD', url, Object.assign(Object.assign({}, options), {
            noResolveJson: true
        }), parameters);
    });
}
function $2ad35efa1b333042$export$cd7f480d6b8286c3(fetcher, url, body, options, parameters) {
    return $2ad35efa1b333042$var$__awaiter(this, void 0, void 0, function*() {
        return $2ad35efa1b333042$var$_handleRequest(fetcher, 'DELETE', url, options, parameters, body);
    });
}



/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ var $51861dfc7ca9d588$export$a143d493d941bafc;
var $51861dfc7ca9d588$export$e4cf37d7f6fb9e0a;
var $51861dfc7ca9d588$export$f99ded8fe4b79145;
var $51861dfc7ca9d588$export$599f31c3813fae4d;
'use strict';
var $eeb0961446aae8e3$export$a48f0734ac7c2329;
var $eeb0961446aae8e3$export$d622b2ad8d90c771;
var $eeb0961446aae8e3$export$6100ba28696e12de;
'use strict';
$eeb0961446aae8e3$export$a48f0734ac7c2329 = $eeb0961446aae8e3$var$byteLength;
$eeb0961446aae8e3$export$d622b2ad8d90c771 = $eeb0961446aae8e3$var$toByteArray;
$eeb0961446aae8e3$export$6100ba28696e12de = $eeb0961446aae8e3$var$fromByteArray;
var $eeb0961446aae8e3$var$lookup = [];
var $eeb0961446aae8e3$var$revLookup = [];
var $eeb0961446aae8e3$var$Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array;
var $eeb0961446aae8e3$var$code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
for(var $eeb0961446aae8e3$var$i = 0, $eeb0961446aae8e3$var$len = $eeb0961446aae8e3$var$code.length; $eeb0961446aae8e3$var$i < $eeb0961446aae8e3$var$len; ++$eeb0961446aae8e3$var$i){
    $eeb0961446aae8e3$var$lookup[$eeb0961446aae8e3$var$i] = $eeb0961446aae8e3$var$code[$eeb0961446aae8e3$var$i];
    $eeb0961446aae8e3$var$revLookup[$eeb0961446aae8e3$var$code.charCodeAt($eeb0961446aae8e3$var$i)] = $eeb0961446aae8e3$var$i;
}
// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
$eeb0961446aae8e3$var$revLookup['-'.charCodeAt(0)] = 62;
$eeb0961446aae8e3$var$revLookup['_'.charCodeAt(0)] = 63;
function $eeb0961446aae8e3$var$getLens(b64) {
    var len = b64.length;
    if (len % 4 > 0) throw new Error('Invalid string. Length must be a multiple of 4');
    // Trim off extra bytes after placeholder bytes are found
    // See: https://github.com/beatgammit/base64-js/issues/42
    var validLen = b64.indexOf('=');
    if (validLen === -1) validLen = len;
    var placeHoldersLen = validLen === len ? 0 : 4 - validLen % 4;
    return [
        validLen,
        placeHoldersLen
    ];
}
// base64 is 4/3 + up to two characters of the original data
function $eeb0961446aae8e3$var$byteLength(b64) {
    var lens = $eeb0961446aae8e3$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $eeb0961446aae8e3$var$_byteLength(b64, validLen, placeHoldersLen) {
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $eeb0961446aae8e3$var$toByteArray(b64) {
    var tmp;
    var lens = $eeb0961446aae8e3$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    var arr = new $eeb0961446aae8e3$var$Arr($eeb0961446aae8e3$var$_byteLength(b64, validLen, placeHoldersLen));
    var curByte = 0;
    // if there are placeholders, only get up to the last complete 4 chars
    var len = placeHoldersLen > 0 ? validLen - 4 : validLen;
    var i;
    for(i = 0; i < len; i += 4){
        tmp = $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i)] << 18 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 1)] << 12 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 2)] << 6 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 3)];
        arr[curByte++] = tmp >> 16 & 0xFF;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 2) {
        tmp = $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i)] << 2 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 1)] >> 4;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 1) {
        tmp = $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i)] << 10 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 1)] << 4 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 2)] >> 2;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    return arr;
}
function $eeb0961446aae8e3$var$tripletToBase64(num) {
    return $eeb0961446aae8e3$var$lookup[num >> 18 & 0x3F] + $eeb0961446aae8e3$var$lookup[num >> 12 & 0x3F] + $eeb0961446aae8e3$var$lookup[num >> 6 & 0x3F] + $eeb0961446aae8e3$var$lookup[num & 0x3F];
}
function $eeb0961446aae8e3$var$encodeChunk(uint8, start, end) {
    var tmp;
    var output = [];
    for(var i = start; i < end; i += 3){
        tmp = (uint8[i] << 16 & 0xFF0000) + (uint8[i + 1] << 8 & 0xFF00) + (uint8[i + 2] & 0xFF);
        output.push($eeb0961446aae8e3$var$tripletToBase64(tmp));
    }
    return output.join('');
}
function $eeb0961446aae8e3$var$fromByteArray(uint8) {
    var tmp;
    var len = uint8.length;
    var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
    ;
    var parts = [];
    var maxChunkLength = 16383 // must be multiple of 3
    ;
    // go through the array every three bytes, we'll deal with trailing stuff later
    for(var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength)parts.push($eeb0961446aae8e3$var$encodeChunk(uint8, i, i + maxChunkLength > len2 ? len2 : i + maxChunkLength));
    // pad the end with zeros, but make sure to not forget the extra bytes
    if (extraBytes === 1) {
        tmp = uint8[len - 1];
        parts.push($eeb0961446aae8e3$var$lookup[tmp >> 2] + $eeb0961446aae8e3$var$lookup[tmp << 4 & 0x3F] + '==');
    } else if (extraBytes === 2) {
        tmp = (uint8[len - 2] << 8) + uint8[len - 1];
        parts.push($eeb0961446aae8e3$var$lookup[tmp >> 10] + $eeb0961446aae8e3$var$lookup[tmp >> 4 & 0x3F] + $eeb0961446aae8e3$var$lookup[tmp << 2 & 0x3F] + '=');
    }
    return parts.join('');
}


/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */ var $7221566bd4d49f44$export$aafa59e2e03f2942;
var $7221566bd4d49f44$export$68d8715fc104d294;
$7221566bd4d49f44$export$aafa59e2e03f2942 = function(buffer, offset, isLE, mLen, nBytes) {
    var e, m;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var nBits = -7;
    var i = isLE ? nBytes - 1 : 0;
    var d = isLE ? -1 : 1;
    var s = buffer[offset + i];
    i += d;
    e = s & (1 << -nBits) - 1;
    s >>= -nBits;
    nBits += eLen;
    for(; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8);
    m = e & (1 << -nBits) - 1;
    e >>= -nBits;
    nBits += mLen;
    for(; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8);
    if (e === 0) e = 1 - eBias;
    else if (e === eMax) return m ? NaN : (s ? -1 : 1) * Infinity;
    else {
        m = m + Math.pow(2, mLen);
        e = e - eBias;
    }
    return (s ? -1 : 1) * m * Math.pow(2, e - mLen);
};
$7221566bd4d49f44$export$68d8715fc104d294 = function(buffer, value, offset, isLE, mLen, nBytes) {
    var e, m, c;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var rt = mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0;
    var i = isLE ? 0 : nBytes - 1;
    var d = isLE ? 1 : -1;
    var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
    value = Math.abs(value);
    if (isNaN(value) || value === Infinity) {
        m = isNaN(value) ? 1 : 0;
        e = eMax;
    } else {
        e = Math.floor(Math.log(value) / Math.LN2);
        if (value * (c = Math.pow(2, -e)) < 1) {
            e--;
            c *= 2;
        }
        if (e + eBias >= 1) value += rt / c;
        else value += rt * Math.pow(2, 1 - eBias);
        if (value * c >= 2) {
            e++;
            c /= 2;
        }
        if (e + eBias >= eMax) {
            m = 0;
            e = eMax;
        } else if (e + eBias >= 1) {
            m = (value * c - 1) * Math.pow(2, mLen);
            e = e + eBias;
        } else {
            m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
            e = 0;
        }
    }
    for(; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8);
    e = e << mLen | m;
    eLen += mLen;
    for(; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8);
    buffer[offset + i - d] |= s * 128;
};


const $51861dfc7ca9d588$var$customInspectSymbol = typeof Symbol === 'function' && typeof Symbol['for'] === 'function' // eslint-disable-line dot-notation
 ? Symbol['for']('nodejs.util.inspect.custom') // eslint-disable-line dot-notation
 : null;
$51861dfc7ca9d588$export$a143d493d941bafc = $51861dfc7ca9d588$var$Buffer;
$51861dfc7ca9d588$export$e4cf37d7f6fb9e0a = $51861dfc7ca9d588$var$SlowBuffer;
$51861dfc7ca9d588$export$f99ded8fe4b79145 = 50;
const $51861dfc7ca9d588$var$K_MAX_LENGTH = 0x7fffffff;
$51861dfc7ca9d588$export$599f31c3813fae4d = $51861dfc7ca9d588$var$K_MAX_LENGTH;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */ $51861dfc7ca9d588$var$Buffer.TYPED_ARRAY_SUPPORT = $51861dfc7ca9d588$var$typedArraySupport();
if (!$51861dfc7ca9d588$var$Buffer.TYPED_ARRAY_SUPPORT && typeof console !== 'undefined' && typeof console.error === 'function') console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
function $51861dfc7ca9d588$var$typedArraySupport() {
    // Can typed array instances can be augmented?
    try {
        const arr = new Uint8Array(1);
        const proto = {
            foo: function() {
                return 42;
            }
        };
        Object.setPrototypeOf(proto, Uint8Array.prototype);
        Object.setPrototypeOf(arr, proto);
        return arr.foo() === 42;
    } catch (e) {
        return false;
    }
}
Object.defineProperty($51861dfc7ca9d588$var$Buffer.prototype, 'parent', {
    enumerable: true,
    get: function() {
        if (!$51861dfc7ca9d588$var$Buffer.isBuffer(this)) return undefined;
        return this.buffer;
    }
});
Object.defineProperty($51861dfc7ca9d588$var$Buffer.prototype, 'offset', {
    enumerable: true,
    get: function() {
        if (!$51861dfc7ca9d588$var$Buffer.isBuffer(this)) return undefined;
        return this.byteOffset;
    }
});
function $51861dfc7ca9d588$var$createBuffer(length) {
    if (length > $51861dfc7ca9d588$var$K_MAX_LENGTH) throw new RangeError('The value "' + length + '" is invalid for option "size"');
    // Return an augmented `Uint8Array` instance
    const buf = new Uint8Array(length);
    Object.setPrototypeOf(buf, $51861dfc7ca9d588$var$Buffer.prototype);
    return buf;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function $51861dfc7ca9d588$var$Buffer(arg, encodingOrOffset, length) {
    // Common case.
    if (typeof arg === 'number') {
        if (typeof encodingOrOffset === 'string') throw new TypeError('The "string" argument must be of type string. Received type number');
        return $51861dfc7ca9d588$var$allocUnsafe(arg);
    }
    return $51861dfc7ca9d588$var$from(arg, encodingOrOffset, length);
}
$51861dfc7ca9d588$var$Buffer.poolSize = 8192 // not used by this implementation
;
function $51861dfc7ca9d588$var$from(value, encodingOrOffset, length) {
    if (typeof value === 'string') return $51861dfc7ca9d588$var$fromString(value, encodingOrOffset);
    if (ArrayBuffer.isView(value)) return $51861dfc7ca9d588$var$fromArrayView(value);
    if (value == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
    if ($51861dfc7ca9d588$var$isInstance(value, ArrayBuffer) || value && $51861dfc7ca9d588$var$isInstance(value.buffer, ArrayBuffer)) return $51861dfc7ca9d588$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof SharedArrayBuffer !== 'undefined' && ($51861dfc7ca9d588$var$isInstance(value, SharedArrayBuffer) || value && $51861dfc7ca9d588$var$isInstance(value.buffer, SharedArrayBuffer))) return $51861dfc7ca9d588$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof value === 'number') throw new TypeError('The "value" argument must not be of type number. Received type number');
    const valueOf = value.valueOf && value.valueOf();
    if (valueOf != null && valueOf !== value) return $51861dfc7ca9d588$var$Buffer.from(valueOf, encodingOrOffset, length);
    const b = $51861dfc7ca9d588$var$fromObject(value);
    if (b) return b;
    if (typeof Symbol !== 'undefined' && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === 'function') return $51861dfc7ca9d588$var$Buffer.from(value[Symbol.toPrimitive]('string'), encodingOrOffset, length);
    throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ $51861dfc7ca9d588$var$Buffer.from = function(value, encodingOrOffset, length) {
    return $51861dfc7ca9d588$var$from(value, encodingOrOffset, length);
};
// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf($51861dfc7ca9d588$var$Buffer.prototype, Uint8Array.prototype);
Object.setPrototypeOf($51861dfc7ca9d588$var$Buffer, Uint8Array);
function $51861dfc7ca9d588$var$assertSize(size) {
    if (typeof size !== 'number') throw new TypeError('"size" argument must be of type number');
    else if (size < 0) throw new RangeError('The value "' + size + '" is invalid for option "size"');
}
function $51861dfc7ca9d588$var$alloc(size, fill, encoding) {
    $51861dfc7ca9d588$var$assertSize(size);
    if (size <= 0) return $51861dfc7ca9d588$var$createBuffer(size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === 'string' ? $51861dfc7ca9d588$var$createBuffer(size).fill(fill, encoding) : $51861dfc7ca9d588$var$createBuffer(size).fill(fill);
    return $51861dfc7ca9d588$var$createBuffer(size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ $51861dfc7ca9d588$var$Buffer.alloc = function(size, fill, encoding) {
    return $51861dfc7ca9d588$var$alloc(size, fill, encoding);
};
function $51861dfc7ca9d588$var$allocUnsafe(size) {
    $51861dfc7ca9d588$var$assertSize(size);
    return $51861dfc7ca9d588$var$createBuffer(size < 0 ? 0 : $51861dfc7ca9d588$var$checked(size) | 0);
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ $51861dfc7ca9d588$var$Buffer.allocUnsafe = function(size) {
    return $51861dfc7ca9d588$var$allocUnsafe(size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ $51861dfc7ca9d588$var$Buffer.allocUnsafeSlow = function(size) {
    return $51861dfc7ca9d588$var$allocUnsafe(size);
};
function $51861dfc7ca9d588$var$fromString(string, encoding) {
    if (typeof encoding !== 'string' || encoding === '') encoding = 'utf8';
    if (!$51861dfc7ca9d588$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
    const length = $51861dfc7ca9d588$var$byteLength(string, encoding) | 0;
    let buf = $51861dfc7ca9d588$var$createBuffer(length);
    const actual = buf.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual);
    return buf;
}
function $51861dfc7ca9d588$var$fromArrayLike(array) {
    const length = array.length < 0 ? 0 : $51861dfc7ca9d588$var$checked(array.length) | 0;
    const buf = $51861dfc7ca9d588$var$createBuffer(length);
    for(let i = 0; i < length; i += 1)buf[i] = array[i] & 255;
    return buf;
}
function $51861dfc7ca9d588$var$fromArrayView(arrayView) {
    if ($51861dfc7ca9d588$var$isInstance(arrayView, Uint8Array)) {
        const copy = new Uint8Array(arrayView);
        return $51861dfc7ca9d588$var$fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
    }
    return $51861dfc7ca9d588$var$fromArrayLike(arrayView);
}
function $51861dfc7ca9d588$var$fromArrayBuffer(array, byteOffset, length) {
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('"offset" is outside of buffer bounds');
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('"length" is outside of buffer bounds');
    let buf;
    if (byteOffset === undefined && length === undefined) buf = new Uint8Array(array);
    else if (length === undefined) buf = new Uint8Array(array, byteOffset);
    else buf = new Uint8Array(array, byteOffset, length);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(buf, $51861dfc7ca9d588$var$Buffer.prototype);
    return buf;
}
function $51861dfc7ca9d588$var$fromObject(obj) {
    if ($51861dfc7ca9d588$var$Buffer.isBuffer(obj)) {
        const len = $51861dfc7ca9d588$var$checked(obj.length) | 0;
        const buf = $51861dfc7ca9d588$var$createBuffer(len);
        if (buf.length === 0) return buf;
        obj.copy(buf, 0, 0, len);
        return buf;
    }
    if (obj.length !== undefined) {
        if (typeof obj.length !== 'number' || $51861dfc7ca9d588$var$numberIsNaN(obj.length)) return $51861dfc7ca9d588$var$createBuffer(0);
        return $51861dfc7ca9d588$var$fromArrayLike(obj);
    }
    if (obj.type === 'Buffer' && Array.isArray(obj.data)) return $51861dfc7ca9d588$var$fromArrayLike(obj.data);
}
function $51861dfc7ca9d588$var$checked(length) {
    // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= $51861dfc7ca9d588$var$K_MAX_LENGTH) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + $51861dfc7ca9d588$var$K_MAX_LENGTH.toString(16) + ' bytes');
    return length | 0;
}
function $51861dfc7ca9d588$var$SlowBuffer(length) {
    if (+length != length) length = 0;
    return $51861dfc7ca9d588$var$Buffer.alloc(+length);
}
$51861dfc7ca9d588$var$Buffer.isBuffer = function isBuffer(b) {
    return b != null && b._isBuffer === true && b !== $51861dfc7ca9d588$var$Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
    ;
};
$51861dfc7ca9d588$var$Buffer.compare = function compare(a, b) {
    if ($51861dfc7ca9d588$var$isInstance(a, Uint8Array)) a = $51861dfc7ca9d588$var$Buffer.from(a, a.offset, a.byteLength);
    if ($51861dfc7ca9d588$var$isInstance(b, Uint8Array)) b = $51861dfc7ca9d588$var$Buffer.from(b, b.offset, b.byteLength);
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(a) || !$51861dfc7ca9d588$var$Buffer.isBuffer(b)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
    if (a === b) return 0;
    let x = a.length;
    let y = b.length;
    for(let i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
$51861dfc7ca9d588$var$Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case 'hex':
        case 'utf8':
        case 'utf-8':
        case 'ascii':
        case 'latin1':
        case 'binary':
        case 'base64':
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return true;
        default:
            return false;
    }
};
$51861dfc7ca9d588$var$Buffer.concat = function concat(list, length) {
    if (!Array.isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return $51861dfc7ca9d588$var$Buffer.alloc(0);
    let i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    const buffer = $51861dfc7ca9d588$var$Buffer.allocUnsafe(length);
    let pos = 0;
    for(i = 0; i < list.length; ++i){
        let buf = list[i];
        if ($51861dfc7ca9d588$var$isInstance(buf, Uint8Array)) {
            if (pos + buf.length > buffer.length) {
                if (!$51861dfc7ca9d588$var$Buffer.isBuffer(buf)) buf = $51861dfc7ca9d588$var$Buffer.from(buf);
                buf.copy(buffer, pos);
            } else Uint8Array.prototype.set.call(buffer, buf, pos);
        } else if (!$51861dfc7ca9d588$var$Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        else buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function $51861dfc7ca9d588$var$byteLength(string, encoding) {
    if ($51861dfc7ca9d588$var$Buffer.isBuffer(string)) return string.length;
    if (ArrayBuffer.isView(string) || $51861dfc7ca9d588$var$isInstance(string, ArrayBuffer)) return string.byteLength;
    if (typeof string !== 'string') throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof string);
    const len = string.length;
    const mustMatch = arguments.length > 2 && arguments[2] === true;
    if (!mustMatch && len === 0) return 0;
    // Use a for loop to avoid recursion
    let loweredCase = false;
    for(;;)switch(encoding){
        case 'ascii':
        case 'latin1':
        case 'binary':
            return len;
        case 'utf8':
        case 'utf-8':
            return $51861dfc7ca9d588$var$utf8ToBytes(string).length;
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return len * 2;
        case 'hex':
            return len >>> 1;
        case 'base64':
            return $51861dfc7ca9d588$var$base64ToBytes(string).length;
        default:
            if (loweredCase) return mustMatch ? -1 : $51861dfc7ca9d588$var$utf8ToBytes(string).length // assume utf8
            ;
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
}
$51861dfc7ca9d588$var$Buffer.byteLength = $51861dfc7ca9d588$var$byteLength;
function $51861dfc7ca9d588$var$slowToString(encoding, start, end) {
    let loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return '';
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return '';
    // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return '';
    if (!encoding) encoding = 'utf8';
    while(true)switch(encoding){
        case 'hex':
            return $51861dfc7ca9d588$var$hexSlice(this, start, end);
        case 'utf8':
        case 'utf-8':
            return $51861dfc7ca9d588$var$utf8Slice(this, start, end);
        case 'ascii':
            return $51861dfc7ca9d588$var$asciiSlice(this, start, end);
        case 'latin1':
        case 'binary':
            return $51861dfc7ca9d588$var$latin1Slice(this, start, end);
        case 'base64':
            return $51861dfc7ca9d588$var$base64Slice(this, start, end);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $51861dfc7ca9d588$var$utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = (encoding + '').toLowerCase();
            loweredCase = true;
    }
}
// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
$51861dfc7ca9d588$var$Buffer.prototype._isBuffer = true;
function $51861dfc7ca9d588$var$swap(b, n, m) {
    const i = b[n];
    b[n] = b[m];
    b[m] = i;
}
$51861dfc7ca9d588$var$Buffer.prototype.swap16 = function swap16() {
    const len = this.length;
    if (len % 2 !== 0) throw new RangeError('Buffer size must be a multiple of 16-bits');
    for(let i = 0; i < len; i += 2)$51861dfc7ca9d588$var$swap(this, i, i + 1);
    return this;
};
$51861dfc7ca9d588$var$Buffer.prototype.swap32 = function swap32() {
    const len = this.length;
    if (len % 4 !== 0) throw new RangeError('Buffer size must be a multiple of 32-bits');
    for(let i = 0; i < len; i += 4){
        $51861dfc7ca9d588$var$swap(this, i, i + 3);
        $51861dfc7ca9d588$var$swap(this, i + 1, i + 2);
    }
    return this;
};
$51861dfc7ca9d588$var$Buffer.prototype.swap64 = function swap64() {
    const len = this.length;
    if (len % 8 !== 0) throw new RangeError('Buffer size must be a multiple of 64-bits');
    for(let i = 0; i < len; i += 8){
        $51861dfc7ca9d588$var$swap(this, i, i + 7);
        $51861dfc7ca9d588$var$swap(this, i + 1, i + 6);
        $51861dfc7ca9d588$var$swap(this, i + 2, i + 5);
        $51861dfc7ca9d588$var$swap(this, i + 3, i + 4);
    }
    return this;
};
$51861dfc7ca9d588$var$Buffer.prototype.toString = function toString() {
    const length = this.length;
    if (length === 0) return '';
    if (arguments.length === 0) return $51861dfc7ca9d588$var$utf8Slice(this, 0, length);
    return $51861dfc7ca9d588$var$slowToString.apply(this, arguments);
};
$51861dfc7ca9d588$var$Buffer.prototype.toLocaleString = $51861dfc7ca9d588$var$Buffer.prototype.toString;
$51861dfc7ca9d588$var$Buffer.prototype.equals = function equals(b) {
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer');
    if (this === b) return true;
    return $51861dfc7ca9d588$var$Buffer.compare(this, b) === 0;
};
$51861dfc7ca9d588$var$Buffer.prototype.inspect = function inspect() {
    let str = '';
    const max = $51861dfc7ca9d588$export$f99ded8fe4b79145;
    str = this.toString('hex', 0, max).replace(/(.{2})/g, '$1 ').trim();
    if (this.length > max) str += ' ... ';
    return '<Buffer ' + str + '>';
};
if ($51861dfc7ca9d588$var$customInspectSymbol) $51861dfc7ca9d588$var$Buffer.prototype[$51861dfc7ca9d588$var$customInspectSymbol] = $51861dfc7ca9d588$var$Buffer.prototype.inspect;
$51861dfc7ca9d588$var$Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if ($51861dfc7ca9d588$var$isInstance(target, Uint8Array)) target = $51861dfc7ca9d588$var$Buffer.from(target, target.offset, target.byteLength);
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(target)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof target);
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError('out of range index');
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    let x = thisEnd - thisStart;
    let y = end - start;
    const len = Math.min(x, y);
    const thisCopy = this.slice(thisStart, thisEnd);
    const targetCopy = target.slice(start, end);
    for(let i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function $51861dfc7ca9d588$var$bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === 'string') {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset // Coerce to Number.
    ;
    if ($51861dfc7ca9d588$var$numberIsNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === 'string') val = $51861dfc7ca9d588$var$Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if ($51861dfc7ca9d588$var$Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return $51861dfc7ca9d588$var$arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === 'number') {
        val = val & 0xFF // Search for a byte value [0-255]
        ;
        if (typeof Uint8Array.prototype.indexOf === 'function') {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return $51861dfc7ca9d588$var$arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError('val must be string, number or Buffer');
}
function $51861dfc7ca9d588$var$arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    let indexSize = 1;
    let arrLength = arr.length;
    let valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === 'ucs2' || encoding === 'ucs-2' || encoding === 'utf16le' || encoding === 'utf-16le') {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    let i;
    if (dir) {
        let foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            let found = true;
            for(let j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
$51861dfc7ca9d588$var$Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
$51861dfc7ca9d588$var$Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return $51861dfc7ca9d588$var$bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
$51861dfc7ca9d588$var$Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return $51861dfc7ca9d588$var$bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function $51861dfc7ca9d588$var$hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    const remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    const strLen = string.length;
    if (length > strLen / 2) length = strLen / 2;
    let i;
    for(i = 0; i < length; ++i){
        const parsed = parseInt(string.substr(i * 2, 2), 16);
        if ($51861dfc7ca9d588$var$numberIsNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function $51861dfc7ca9d588$var$utf8Write(buf, string, offset, length) {
    return $51861dfc7ca9d588$var$blitBuffer($51861dfc7ca9d588$var$utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function $51861dfc7ca9d588$var$asciiWrite(buf, string, offset, length) {
    return $51861dfc7ca9d588$var$blitBuffer($51861dfc7ca9d588$var$asciiToBytes(string), buf, offset, length);
}
function $51861dfc7ca9d588$var$base64Write(buf, string, offset, length) {
    return $51861dfc7ca9d588$var$blitBuffer($51861dfc7ca9d588$var$base64ToBytes(string), buf, offset, length);
}
function $51861dfc7ca9d588$var$ucs2Write(buf, string, offset, length) {
    return $51861dfc7ca9d588$var$blitBuffer($51861dfc7ca9d588$var$utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
$51861dfc7ca9d588$var$Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = 'utf8';
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === 'string') {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset >>> 0;
        if (isFinite(length)) {
            length = length >>> 0;
            if (encoding === undefined) encoding = 'utf8';
        } else {
            encoding = length;
            length = undefined;
        }
    } else throw new Error('Buffer.write(string, encoding, offset[, length]) is no longer supported');
    const remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError('Attempt to write outside buffer bounds');
    if (!encoding) encoding = 'utf8';
    let loweredCase = false;
    for(;;)switch(encoding){
        case 'hex':
            return $51861dfc7ca9d588$var$hexWrite(this, string, offset, length);
        case 'utf8':
        case 'utf-8':
            return $51861dfc7ca9d588$var$utf8Write(this, string, offset, length);
        case 'ascii':
        case 'latin1':
        case 'binary':
            return $51861dfc7ca9d588$var$asciiWrite(this, string, offset, length);
        case 'base64':
            // Warning: maxLength not taken into account in base64Write
            return $51861dfc7ca9d588$var$base64Write(this, string, offset, length);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $51861dfc7ca9d588$var$ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
};
$51861dfc7ca9d588$var$Buffer.prototype.toJSON = function toJSON() {
    return {
        type: 'Buffer',
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function $51861dfc7ca9d588$var$base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return $eeb0961446aae8e3$export$6100ba28696e12de(buf);
    else return $eeb0961446aae8e3$export$6100ba28696e12de(buf.slice(start, end));
}
function $51861dfc7ca9d588$var$utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    const res = [];
    let i = start;
    while(i < end){
        const firstByte = buf[i];
        let codePoint = null;
        let bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            let secondByte, thirdByte, fourthByte, tempCodePoint;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return $51861dfc7ca9d588$var$decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
const $51861dfc7ca9d588$var$MAX_ARGUMENTS_LENGTH = 0x1000;
function $51861dfc7ca9d588$var$decodeCodePointsArray(codePoints) {
    const len = codePoints.length;
    if (len <= $51861dfc7ca9d588$var$MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    let res = '';
    let i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += $51861dfc7ca9d588$var$MAX_ARGUMENTS_LENGTH));
    return res;
}
function $51861dfc7ca9d588$var$asciiSlice(buf, start, end) {
    let ret = '';
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function $51861dfc7ca9d588$var$latin1Slice(buf, start, end) {
    let ret = '';
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function $51861dfc7ca9d588$var$hexSlice(buf, start, end) {
    const len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    let out = '';
    for(let i = start; i < end; ++i)out += $51861dfc7ca9d588$var$hexSliceLookupTable[buf[i]];
    return out;
}
function $51861dfc7ca9d588$var$utf16leSlice(buf, start, end) {
    const bytes = buf.slice(start, end);
    let res = '';
    // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
    for(let i = 0; i < bytes.length - 1; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
$51861dfc7ca9d588$var$Buffer.prototype.slice = function slice(start, end) {
    const len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    const newBuf = this.subarray(start, end);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(newBuf, $51861dfc7ca9d588$var$Buffer.prototype);
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function $51861dfc7ca9d588$var$checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError('offset is not uint');
    if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length');
}
$51861dfc7ca9d588$var$Buffer.prototype.readUintLE = $51861dfc7ca9d588$var$Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readUintBE = $51861dfc7ca9d588$var$Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset + --byteLength];
    let mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint8 = $51861dfc7ca9d588$var$Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 1, this.length);
    return this[offset];
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint16LE = $51861dfc7ca9d588$var$Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint16BE = $51861dfc7ca9d588$var$Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint32LE = $51861dfc7ca9d588$var$Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint32BE = $51861dfc7ca9d588$var$Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
$51861dfc7ca9d588$var$Buffer.prototype.readBigUInt64LE = $51861dfc7ca9d588$var$defineBigIntMethod(function readBigUInt64LE(offset) {
    offset = offset >>> 0;
    $51861dfc7ca9d588$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $51861dfc7ca9d588$var$boundsError(offset, this.length - 8);
    const lo = first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24;
    const hi = this[++offset] + this[++offset] * 256 + this[++offset] * 2 ** 16 + last * 2 ** 24;
    return BigInt(lo) + (BigInt(hi) << BigInt(32));
});
$51861dfc7ca9d588$var$Buffer.prototype.readBigUInt64BE = $51861dfc7ca9d588$var$defineBigIntMethod(function readBigUInt64BE(offset) {
    offset = offset >>> 0;
    $51861dfc7ca9d588$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $51861dfc7ca9d588$var$boundsError(offset, this.length - 8);
    const hi = first * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    const lo = this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last;
    return (BigInt(hi) << BigInt(32)) + BigInt(lo);
});
$51861dfc7ca9d588$var$Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, byteLength, this.length);
    let i = byteLength;
    let mul = 1;
    let val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 2, this.length);
    const val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 2, this.length);
    const val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
$51861dfc7ca9d588$var$Buffer.prototype.readBigInt64LE = $51861dfc7ca9d588$var$defineBigIntMethod(function readBigInt64LE(offset) {
    offset = offset >>> 0;
    $51861dfc7ca9d588$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $51861dfc7ca9d588$var$boundsError(offset, this.length - 8);
    const val = this[offset + 4] + this[offset + 5] * 256 + this[offset + 6] * 2 ** 16 + (last << 24 // Overflow
    );
    return (BigInt(val) << BigInt(32)) + BigInt(first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24);
});
$51861dfc7ca9d588$var$Buffer.prototype.readBigInt64BE = $51861dfc7ca9d588$var$defineBigIntMethod(function readBigInt64BE(offset) {
    offset = offset >>> 0;
    $51861dfc7ca9d588$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $51861dfc7ca9d588$var$boundsError(offset, this.length - 8);
    const val = (first << 24) + // Overflow
    this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    return (BigInt(val) << BigInt(32)) + BigInt(this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last);
});
$51861dfc7ca9d588$var$Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return $7221566bd4d49f44$export$aafa59e2e03f2942(this, offset, true, 23, 4);
};
$51861dfc7ca9d588$var$Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return $7221566bd4d49f44$export$aafa59e2e03f2942(this, offset, false, 23, 4);
};
$51861dfc7ca9d588$var$Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 8, this.length);
    return $7221566bd4d49f44$export$aafa59e2e03f2942(this, offset, true, 52, 8);
};
$51861dfc7ca9d588$var$Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 8, this.length);
    return $7221566bd4d49f44$export$aafa59e2e03f2942(this, offset, false, 52, 8);
};
function $51861dfc7ca9d588$var$checkInt(buf, value, offset, ext, max, min) {
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
}
$51861dfc7ca9d588$var$Buffer.prototype.writeUintLE = $51861dfc7ca9d588$var$Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $51861dfc7ca9d588$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let mul = 1;
    let i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUintBE = $51861dfc7ca9d588$var$Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $51861dfc7ca9d588$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let i = byteLength - 1;
    let mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint8 = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 1, 0xff, 0);
    this[offset] = value & 0xff;
    return offset + 1;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint16LE = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint16BE = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint32LE = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset + 3] = value >>> 24;
    this[offset + 2] = value >>> 16;
    this[offset + 1] = value >>> 8;
    this[offset] = value & 0xff;
    return offset + 4;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint32BE = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
function $51861dfc7ca9d588$var$wrtBigUInt64LE(buf, value, offset, min, max) {
    $51861dfc7ca9d588$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    return offset;
}
function $51861dfc7ca9d588$var$wrtBigUInt64BE(buf, value, offset, min, max) {
    $51861dfc7ca9d588$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset + 7] = lo;
    lo = lo >> 8;
    buf[offset + 6] = lo;
    lo = lo >> 8;
    buf[offset + 5] = lo;
    lo = lo >> 8;
    buf[offset + 4] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset + 3] = hi;
    hi = hi >> 8;
    buf[offset + 2] = hi;
    hi = hi >> 8;
    buf[offset + 1] = hi;
    hi = hi >> 8;
    buf[offset] = hi;
    return offset + 8;
}
$51861dfc7ca9d588$var$Buffer.prototype.writeBigUInt64LE = $51861dfc7ca9d588$var$defineBigIntMethod(function writeBigUInt64LE(value, offset = 0) {
    return $51861dfc7ca9d588$var$wrtBigUInt64LE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'));
});
$51861dfc7ca9d588$var$Buffer.prototype.writeBigUInt64BE = $51861dfc7ca9d588$var$defineBigIntMethod(function writeBigUInt64BE(value, offset = 0) {
    return $51861dfc7ca9d588$var$wrtBigUInt64BE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'));
});
$51861dfc7ca9d588$var$Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $51861dfc7ca9d588$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = 0;
    let mul = 1;
    let sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $51861dfc7ca9d588$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = byteLength - 1;
    let mul = 1;
    let sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 1, 0x7f, -128);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    this[offset + 2] = value >>> 16;
    this[offset + 3] = value >>> 24;
    return offset + 4;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeBigInt64LE = $51861dfc7ca9d588$var$defineBigIntMethod(function writeBigInt64LE(value, offset = 0) {
    return $51861dfc7ca9d588$var$wrtBigUInt64LE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'));
});
$51861dfc7ca9d588$var$Buffer.prototype.writeBigInt64BE = $51861dfc7ca9d588$var$defineBigIntMethod(function writeBigInt64BE(value, offset = 0) {
    return $51861dfc7ca9d588$var$wrtBigUInt64BE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'));
});
function $51861dfc7ca9d588$var$checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
    if (offset < 0) throw new RangeError('Index out of range');
}
function $51861dfc7ca9d588$var$writeFloat(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
    $7221566bd4d49f44$export$68d8715fc104d294(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
$51861dfc7ca9d588$var$Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return $51861dfc7ca9d588$var$writeFloat(this, value, offset, true, noAssert);
};
$51861dfc7ca9d588$var$Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return $51861dfc7ca9d588$var$writeFloat(this, value, offset, false, noAssert);
};
function $51861dfc7ca9d588$var$writeDouble(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
    $7221566bd4d49f44$export$68d8715fc104d294(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
$51861dfc7ca9d588$var$Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return $51861dfc7ca9d588$var$writeDouble(this, value, offset, true, noAssert);
};
$51861dfc7ca9d588$var$Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return $51861dfc7ca9d588$var$writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
$51861dfc7ca9d588$var$Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(target)) throw new TypeError('argument should be a Buffer');
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError('targetStart out of bounds');
    if (start < 0 || start >= this.length) throw new RangeError('Index out of range');
    if (end < 0) throw new RangeError('sourceEnd out of bounds');
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    const len = end - start;
    if (this === target && typeof Uint8Array.prototype.copyWithin === 'function') // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end);
    else Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
$51861dfc7ca9d588$var$Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === 'string') {
        if (typeof start === 'string') {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === 'string') {
            encoding = end;
            end = this.length;
        }
        if (encoding !== undefined && typeof encoding !== 'string') throw new TypeError('encoding must be a string');
        if (typeof encoding === 'string' && !$51861dfc7ca9d588$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
        if (val.length === 1) {
            const code = val.charCodeAt(0);
            if (encoding === 'utf8' && code < 128 || encoding === 'latin1') // Fast path: If `val` fits into a single byte, use that numeric value.
            val = code;
        }
    } else if (typeof val === 'number') val = val & 255;
    else if (typeof val === 'boolean') val = Number(val);
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError('Out of range index');
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    let i;
    if (typeof val === 'number') for(i = start; i < end; ++i)this[i] = val;
    else {
        const bytes = $51861dfc7ca9d588$var$Buffer.isBuffer(val) ? val : $51861dfc7ca9d588$var$Buffer.from(val, encoding);
        const len = bytes.length;
        if (len === 0) throw new TypeError('The value "' + val + '" is invalid for argument "value"');
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// CUSTOM ERRORS
// =============
// Simplified versions from Node, changed for Buffer-only usage
const $51861dfc7ca9d588$var$errors = {};
function $51861dfc7ca9d588$var$E(sym, getMessage, Base) {
    $51861dfc7ca9d588$var$errors[sym] = class NodeError extends Base {
        constructor(){
            super();
            Object.defineProperty(this, 'message', {
                value: getMessage.apply(this, arguments),
                writable: true,
                configurable: true
            });
            // Add the error code to the name to include it in the stack trace.
            this.name = `${this.name} [${sym}]`;
            // Access the stack to generate the error message including the error code
            // from the name.
            this.stack // eslint-disable-line no-unused-expressions
            ;
            // Reset the name to the actual name.
            delete this.name;
        }
        get code() {
            return sym;
        }
        set code(value) {
            Object.defineProperty(this, 'code', {
                configurable: true,
                enumerable: true,
                value: value,
                writable: true
            });
        }
        toString() {
            return `${this.name} [${sym}]: ${this.message}`;
        }
    };
}
$51861dfc7ca9d588$var$E('ERR_BUFFER_OUT_OF_BOUNDS', function(name) {
    if (name) return `${name} is outside of buffer bounds`;
    return 'Attempt to access memory outside buffer bounds';
}, RangeError);
$51861dfc7ca9d588$var$E('ERR_INVALID_ARG_TYPE', function(name, actual) {
    return `The "${name}" argument must be of type number. Received type ${typeof actual}`;
}, TypeError);
$51861dfc7ca9d588$var$E('ERR_OUT_OF_RANGE', function(str, range, input) {
    let msg = `The value of "${str}" is out of range.`;
    let received = input;
    if (Number.isInteger(input) && Math.abs(input) > 2 ** 32) received = $51861dfc7ca9d588$var$addNumericalSeparator(String(input));
    else if (typeof input === 'bigint') {
        received = String(input);
        if (input > BigInt(2) ** BigInt(32) || input < -(BigInt(2) ** BigInt(32))) received = $51861dfc7ca9d588$var$addNumericalSeparator(received);
        received += 'n';
    }
    msg += ` It must be ${range}. Received ${received}`;
    return msg;
}, RangeError);
function $51861dfc7ca9d588$var$addNumericalSeparator(val) {
    let res = '';
    let i = val.length;
    const start = val[0] === '-' ? 1 : 0;
    for(; i >= start + 4; i -= 3)res = `_${val.slice(i - 3, i)}${res}`;
    return `${val.slice(0, i)}${res}`;
}
// CHECK FUNCTIONS
// ===============
function $51861dfc7ca9d588$var$checkBounds(buf, offset, byteLength) {
    $51861dfc7ca9d588$var$validateNumber(offset, 'offset');
    if (buf[offset] === undefined || buf[offset + byteLength] === undefined) $51861dfc7ca9d588$var$boundsError(offset, buf.length - (byteLength + 1));
}
function $51861dfc7ca9d588$var$checkIntBI(value, min, max, buf, offset, byteLength) {
    if (value > max || value < min) {
        const n = typeof min === 'bigint' ? 'n' : '';
        let range;
        if (byteLength > 3) {
            if (min === 0 || min === BigInt(0)) range = `>= 0${n} and < 2${n} ** ${(byteLength + 1) * 8}${n}`;
            else range = `>= -(2${n} ** ${(byteLength + 1) * 8 - 1}${n}) and < 2 ** ` + `${(byteLength + 1) * 8 - 1}${n}`;
        } else range = `>= ${min}${n} and <= ${max}${n}`;
        throw new $51861dfc7ca9d588$var$errors.ERR_OUT_OF_RANGE('value', range, value);
    }
    $51861dfc7ca9d588$var$checkBounds(buf, offset, byteLength);
}
function $51861dfc7ca9d588$var$validateNumber(value, name) {
    if (typeof value !== 'number') throw new $51861dfc7ca9d588$var$errors.ERR_INVALID_ARG_TYPE(name, 'number', value);
}
function $51861dfc7ca9d588$var$boundsError(value, length, type) {
    if (Math.floor(value) !== value) {
        $51861dfc7ca9d588$var$validateNumber(value, type);
        throw new $51861dfc7ca9d588$var$errors.ERR_OUT_OF_RANGE(type || 'offset', 'an integer', value);
    }
    if (length < 0) throw new $51861dfc7ca9d588$var$errors.ERR_BUFFER_OUT_OF_BOUNDS();
    throw new $51861dfc7ca9d588$var$errors.ERR_OUT_OF_RANGE(type || 'offset', `>= ${type ? 1 : 0} and <= ${length}`, value);
}
// HELPER FUNCTIONS
// ================
const $51861dfc7ca9d588$var$INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
function $51861dfc7ca9d588$var$base64clean(str) {
    // Node takes equal signs as end of the Base64 encoding
    str = str.split('=')[0];
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = str.trim().replace($51861dfc7ca9d588$var$INVALID_BASE64_RE, '');
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return '';
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + '=';
    return str;
}
function $51861dfc7ca9d588$var$utf8ToBytes(string, units) {
    units = units || Infinity;
    let codePoint;
    const length = string.length;
    let leadSurrogate = null;
    const bytes = [];
    for(let i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error('Invalid code point');
    }
    return bytes;
}
function $51861dfc7ca9d588$var$asciiToBytes(str) {
    const byteArray = [];
    for(let i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function $51861dfc7ca9d588$var$utf16leToBytes(str, units) {
    let c, hi, lo;
    const byteArray = [];
    for(let i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function $51861dfc7ca9d588$var$base64ToBytes(str) {
    return $eeb0961446aae8e3$export$d622b2ad8d90c771($51861dfc7ca9d588$var$base64clean(str));
}
function $51861dfc7ca9d588$var$blitBuffer(src, dst, offset, length) {
    let i;
    for(i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function $51861dfc7ca9d588$var$isInstance(obj, type) {
    return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
}
function $51861dfc7ca9d588$var$numberIsNaN(obj) {
    // For IE11 support
    return obj !== obj // eslint-disable-line no-self-compare
    ;
}
// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
const $51861dfc7ca9d588$var$hexSliceLookupTable = function() {
    const alphabet = '0123456789abcdef';
    const table = new Array(256);
    for(let i = 0; i < 16; ++i){
        const i16 = i * 16;
        for(let j = 0; j < 16; ++j)table[i16 + j] = alphabet[i] + alphabet[j];
    }
    return table;
}();
// Return not function with Error if BigInt not supported
function $51861dfc7ca9d588$var$defineBigIntMethod(fn) {
    return typeof BigInt === 'undefined' ? $51861dfc7ca9d588$var$BufferBigIntNotDefined : fn;
}
function $51861dfc7ca9d588$var$BufferBigIntNotDefined() {
    throw new Error('BigInt not supported');
}


var $21597b612ea06b11$require$Buffer = $51861dfc7ca9d588$export$a143d493d941bafc;
var $21597b612ea06b11$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
const $21597b612ea06b11$var$DEFAULT_SEARCH_OPTIONS = {
    limit: 100,
    offset: 0,
    sortBy: {
        column: 'name',
        order: 'asc'
    }
};
const $21597b612ea06b11$var$DEFAULT_FILE_OPTIONS = {
    cacheControl: '3600',
    contentType: 'text/plain;charset=UTF-8',
    upsert: false
};
class $21597b612ea06b11$export$2e2bcd8739ae039 {
    constructor(url, headers = {}, bucketId, fetch){
        this.url = url;
        this.headers = headers;
        this.bucketId = bucketId;
        this.fetch = (0, $b8abd4fb4763e533$export$98d92b1aa79f8cc7)(fetch);
    }
    /**
     * Uploads a file to an existing bucket or replaces an existing file at the specified path with a new one.
     *
     * @param method HTTP method.
     * @param path The relative file path. Should be of the format `folder/subfolder/filename.png`. The bucket must already exist before attempting to upload.
     * @param fileBody The body of the file to be stored in the bucket.
     */ uploadOrUpdate(method, path, fileBody, fileOptions) {
        return $21597b612ea06b11$var$__awaiter(this, void 0, void 0, function*() {
            try {
                let body;
                const options = Object.assign(Object.assign({}, $21597b612ea06b11$var$DEFAULT_FILE_OPTIONS), fileOptions);
                let headers = Object.assign(Object.assign({}, this.headers), method === 'POST' && {
                    'x-upsert': String(options.upsert)
                });
                const metadata = options.metadata;
                if (typeof Blob !== 'undefined' && fileBody instanceof Blob) {
                    body = new FormData();
                    body.append('cacheControl', options.cacheControl);
                    if (metadata) body.append('metadata', this.encodeMetadata(metadata));
                    body.append('', fileBody);
                } else if (typeof FormData !== 'undefined' && fileBody instanceof FormData) {
                    body = fileBody;
                    body.append('cacheControl', options.cacheControl);
                    if (metadata) body.append('metadata', this.encodeMetadata(metadata));
                } else {
                    body = fileBody;
                    headers['cache-control'] = `max-age=${options.cacheControl}`;
                    headers['content-type'] = options.contentType;
                    if (metadata) headers['x-metadata'] = this.toBase64(this.encodeMetadata(metadata));
                }
                if (fileOptions === null || fileOptions === void 0 ? void 0 : fileOptions.headers) headers = Object.assign(Object.assign({}, headers), fileOptions.headers);
                const cleanPath = this._removeEmptyFolders(path);
                const _path = this._getFinalPath(cleanPath);
                const res = yield this.fetch(`${this.url}/object/${_path}`, Object.assign({
                    method: method,
                    body: body,
                    headers: headers
                }, (options === null || options === void 0 ? void 0 : options.duplex) ? {
                    duplex: options.duplex
                } : {}));
                const data = yield res.json();
                if (res.ok) return {
                    data: {
                        path: cleanPath,
                        id: data.Id,
                        fullPath: data.Key
                    },
                    error: null
                };
                else {
                    const error = data;
                    return {
                        data: null,
                        error: error
                    };
                }
            } catch (error) {
                if ((0, $abe02471d8456f7f$export$5a322e77e5eb0561)(error)) return {
                    data: null,
                    error: error
                };
                throw error;
            }
        });
    }
    /**
     * Uploads a file to an existing bucket.
     *
     * @param path The file path, including the file name. Should be of the format `folder/subfolder/filename.png`. The bucket must already exist before attempting to upload.
     * @param fileBody The body of the file to be stored in the bucket.
     */ upload(path, fileBody, fileOptions) {
        return $21597b612ea06b11$var$__awaiter(this, void 0, void 0, function*() {
            return this.uploadOrUpdate('POST', path, fileBody, fileOptions);
        });
    }
    /**
     * Upload a file with a token generated from `createSignedUploadUrl`.
     * @param path The file path, including the file name. Should be of the format `folder/subfolder/filename.png`. The bucket must already exist before attempting to upload.
     * @param token The token generated from `createSignedUploadUrl`
     * @param fileBody The body of the file to be stored in the bucket.
     */ uploadToSignedUrl(path, token, fileBody, fileOptions) {
        return $21597b612ea06b11$var$__awaiter(this, void 0, void 0, function*() {
            const cleanPath = this._removeEmptyFolders(path);
            const _path = this._getFinalPath(cleanPath);
            const url = new URL(this.url + `/object/upload/sign/${_path}`);
            url.searchParams.set('token', token);
            try {
                let body;
                const options = Object.assign({
                    upsert: $21597b612ea06b11$var$DEFAULT_FILE_OPTIONS.upsert
                }, fileOptions);
                const headers = Object.assign(Object.assign({}, this.headers), {
                    'x-upsert': String(options.upsert)
                });
                if (typeof Blob !== 'undefined' && fileBody instanceof Blob) {
                    body = new FormData();
                    body.append('cacheControl', options.cacheControl);
                    body.append('', fileBody);
                } else if (typeof FormData !== 'undefined' && fileBody instanceof FormData) {
                    body = fileBody;
                    body.append('cacheControl', options.cacheControl);
                } else {
                    body = fileBody;
                    headers['cache-control'] = `max-age=${options.cacheControl}`;
                    headers['content-type'] = options.contentType;
                }
                const res = yield this.fetch(url.toString(), {
                    method: 'PUT',
                    body: body,
                    headers: headers
                });
                const data = yield res.json();
                if (res.ok) return {
                    data: {
                        path: cleanPath,
                        fullPath: data.Key
                    },
                    error: null
                };
                else {
                    const error = data;
                    return {
                        data: null,
                        error: error
                    };
                }
            } catch (error) {
                if ((0, $abe02471d8456f7f$export$5a322e77e5eb0561)(error)) return {
                    data: null,
                    error: error
                };
                throw error;
            }
        });
    }
    /**
     * Creates a signed upload URL.
     * Signed upload URLs can be used to upload files to the bucket without further authentication.
     * They are valid for 2 hours.
     * @param path The file path, including the current file name. For example `folder/image.png`.
     * @param options.upsert If set to true, allows the file to be overwritten if it already exists.
     */ createSignedUploadUrl(path, options) {
        return $21597b612ea06b11$var$__awaiter(this, void 0, void 0, function*() {
            try {
                let _path = this._getFinalPath(path);
                const headers = Object.assign({}, this.headers);
                if (options === null || options === void 0 ? void 0 : options.upsert) headers['x-upsert'] = 'true';
                const data = yield (0, $2ad35efa1b333042$export$299ba2dee77727e9)(this.fetch, `${this.url}/object/upload/sign/${_path}`, {}, {
                    headers: headers
                });
                const url = new URL(this.url + data.url);
                const token = url.searchParams.get('token');
                if (!token) throw new (0, $abe02471d8456f7f$export$697502632950e9d3)('No token returned by API');
                return {
                    data: {
                        signedUrl: url.toString(),
                        path: path,
                        token: token
                    },
                    error: null
                };
            } catch (error) {
                if ((0, $abe02471d8456f7f$export$5a322e77e5eb0561)(error)) return {
                    data: null,
                    error: error
                };
                throw error;
            }
        });
    }
    /**
     * Replaces an existing file at the specified path with a new one.
     *
     * @param path The relative file path. Should be of the format `folder/subfolder/filename.png`. The bucket must already exist before attempting to update.
     * @param fileBody The body of the file to be stored in the bucket.
     */ update(path, fileBody, fileOptions) {
        return $21597b612ea06b11$var$__awaiter(this, void 0, void 0, function*() {
            return this.uploadOrUpdate('PUT', path, fileBody, fileOptions);
        });
    }
    /**
     * Moves an existing file to a new path in the same bucket.
     *
     * @param fromPath The original file path, including the current file name. For example `folder/image.png`.
     * @param toPath The new file path, including the new file name. For example `folder/image-new.png`.
     * @param options The destination options.
     */ move(fromPath, toPath, options) {
        return $21597b612ea06b11$var$__awaiter(this, void 0, void 0, function*() {
            try {
                const data = yield (0, $2ad35efa1b333042$export$299ba2dee77727e9)(this.fetch, `${this.url}/object/move`, {
                    bucketId: this.bucketId,
                    sourceKey: fromPath,
                    destinationKey: toPath,
                    destinationBucket: options === null || options === void 0 ? void 0 : options.destinationBucket
                }, {
                    headers: this.headers
                });
                return {
                    data: data,
                    error: null
                };
            } catch (error) {
                if ((0, $abe02471d8456f7f$export$5a322e77e5eb0561)(error)) return {
                    data: null,
                    error: error
                };
                throw error;
            }
        });
    }
    /**
     * Copies an existing file to a new path in the same bucket.
     *
     * @param fromPath The original file path, including the current file name. For example `folder/image.png`.
     * @param toPath The new file path, including the new file name. For example `folder/image-copy.png`.
     * @param options The destination options.
     */ copy(fromPath, toPath, options) {
        return $21597b612ea06b11$var$__awaiter(this, void 0, void 0, function*() {
            try {
                const data = yield (0, $2ad35efa1b333042$export$299ba2dee77727e9)(this.fetch, `${this.url}/object/copy`, {
                    bucketId: this.bucketId,
                    sourceKey: fromPath,
                    destinationKey: toPath,
                    destinationBucket: options === null || options === void 0 ? void 0 : options.destinationBucket
                }, {
                    headers: this.headers
                });
                return {
                    data: {
                        path: data.Key
                    },
                    error: null
                };
            } catch (error) {
                if ((0, $abe02471d8456f7f$export$5a322e77e5eb0561)(error)) return {
                    data: null,
                    error: error
                };
                throw error;
            }
        });
    }
    /**
     * Creates a signed URL. Use a signed URL to share a file for a fixed amount of time.
     *
     * @param path The file path, including the current file name. For example `folder/image.png`.
     * @param expiresIn The number of seconds until the signed URL expires. For example, `60` for a URL which is valid for one minute.
     * @param options.download triggers the file as a download if set to true. Set this parameter as the name of the file if you want to trigger the download with a different filename.
     * @param options.transform Transform the asset before serving it to the client.
     */ createSignedUrl(path, expiresIn, options) {
        return $21597b612ea06b11$var$__awaiter(this, void 0, void 0, function*() {
            try {
                let _path = this._getFinalPath(path);
                let data = yield (0, $2ad35efa1b333042$export$299ba2dee77727e9)(this.fetch, `${this.url}/object/sign/${_path}`, Object.assign({
                    expiresIn: expiresIn
                }, (options === null || options === void 0 ? void 0 : options.transform) ? {
                    transform: options.transform
                } : {}), {
                    headers: this.headers
                });
                const downloadQueryParam = (options === null || options === void 0 ? void 0 : options.download) ? `&download=${options.download === true ? '' : options.download}` : '';
                const signedUrl = encodeURI(`${this.url}${data.signedURL}${downloadQueryParam}`);
                data = {
                    signedUrl: signedUrl
                };
                return {
                    data: data,
                    error: null
                };
            } catch (error) {
                if ((0, $abe02471d8456f7f$export$5a322e77e5eb0561)(error)) return {
                    data: null,
                    error: error
                };
                throw error;
            }
        });
    }
    /**
     * Creates multiple signed URLs. Use a signed URL to share a file for a fixed amount of time.
     *
     * @param paths The file paths to be downloaded, including the current file names. For example `['folder/image.png', 'folder2/image2.png']`.
     * @param expiresIn The number of seconds until the signed URLs expire. For example, `60` for URLs which are valid for one minute.
     * @param options.download triggers the file as a download if set to true. Set this parameter as the name of the file if you want to trigger the download with a different filename.
     */ createSignedUrls(paths, expiresIn, options) {
        return $21597b612ea06b11$var$__awaiter(this, void 0, void 0, function*() {
            try {
                const data = yield (0, $2ad35efa1b333042$export$299ba2dee77727e9)(this.fetch, `${this.url}/object/sign/${this.bucketId}`, {
                    expiresIn: expiresIn,
                    paths: paths
                }, {
                    headers: this.headers
                });
                const downloadQueryParam = (options === null || options === void 0 ? void 0 : options.download) ? `&download=${options.download === true ? '' : options.download}` : '';
                return {
                    data: data.map((datum)=>Object.assign(Object.assign({}, datum), {
                            signedUrl: datum.signedURL ? encodeURI(`${this.url}${datum.signedURL}${downloadQueryParam}`) : null
                        })),
                    error: null
                };
            } catch (error) {
                if ((0, $abe02471d8456f7f$export$5a322e77e5eb0561)(error)) return {
                    data: null,
                    error: error
                };
                throw error;
            }
        });
    }
    /**
     * Downloads a file from a private bucket. For public buckets, make a request to the URL returned from `getPublicUrl` instead.
     *
     * @param path The full path and file name of the file to be downloaded. For example `folder/image.png`.
     * @param options.transform Transform the asset before serving it to the client.
     */ download(path, options) {
        return $21597b612ea06b11$var$__awaiter(this, void 0, void 0, function*() {
            const wantsTransformation = typeof (options === null || options === void 0 ? void 0 : options.transform) !== 'undefined';
            const renderPath = wantsTransformation ? 'render/image/authenticated' : 'object';
            const transformationQuery = this.transformOptsToQueryString((options === null || options === void 0 ? void 0 : options.transform) || {});
            const queryString = transformationQuery ? `?${transformationQuery}` : '';
            try {
                const _path = this._getFinalPath(path);
                const res = yield (0, $2ad35efa1b333042$export$3988ae62b71be9a3)(this.fetch, `${this.url}/${renderPath}/${_path}${queryString}`, {
                    headers: this.headers,
                    noResolveJson: true
                });
                const data = yield res.blob();
                return {
                    data: data,
                    error: null
                };
            } catch (error) {
                if ((0, $abe02471d8456f7f$export$5a322e77e5eb0561)(error)) return {
                    data: null,
                    error: error
                };
                throw error;
            }
        });
    }
    /**
     * Retrieves the details of an existing file.
     * @param path
     */ info(path) {
        return $21597b612ea06b11$var$__awaiter(this, void 0, void 0, function*() {
            const _path = this._getFinalPath(path);
            try {
                const data = yield (0, $2ad35efa1b333042$export$3988ae62b71be9a3)(this.fetch, `${this.url}/object/info/${_path}`, {
                    headers: this.headers
                });
                return {
                    data: (0, $b8abd4fb4763e533$export$69d519e35e6fc3d4)(data),
                    error: null
                };
            } catch (error) {
                if ((0, $abe02471d8456f7f$export$5a322e77e5eb0561)(error)) return {
                    data: null,
                    error: error
                };
                throw error;
            }
        });
    }
    /**
     * Checks the existence of a file.
     * @param path
     */ exists(path) {
        return $21597b612ea06b11$var$__awaiter(this, void 0, void 0, function*() {
            const _path = this._getFinalPath(path);
            try {
                yield (0, $2ad35efa1b333042$export$5fd5031fecdacec3)(this.fetch, `${this.url}/object/${_path}`, {
                    headers: this.headers
                });
                return {
                    data: true,
                    error: null
                };
            } catch (error) {
                if ((0, $abe02471d8456f7f$export$5a322e77e5eb0561)(error) && error instanceof (0, $abe02471d8456f7f$export$29127ca2e1a271d)) {
                    const originalError = error.originalError;
                    if ([
                        400,
                        404
                    ].includes(originalError === null || originalError === void 0 ? void 0 : originalError.status)) return {
                        data: false,
                        error: error
                    };
                }
                throw error;
            }
        });
    }
    /**
     * A simple convenience function to get the URL for an asset in a public bucket. If you do not want to use this function, you can construct the public URL by concatenating the bucket URL with the path to the asset.
     * This function does not verify if the bucket is public. If a public URL is created for a bucket which is not public, you will not be able to download the asset.
     *
     * @param path The path and name of the file to generate the public URL for. For example `folder/image.png`.
     * @param options.download Triggers the file as a download if set to true. Set this parameter as the name of the file if you want to trigger the download with a different filename.
     * @param options.transform Transform the asset before serving it to the client.
     */ getPublicUrl(path, options) {
        const _path = this._getFinalPath(path);
        const _queryString = [];
        const downloadQueryParam = (options === null || options === void 0 ? void 0 : options.download) ? `download=${options.download === true ? '' : options.download}` : '';
        if (downloadQueryParam !== '') _queryString.push(downloadQueryParam);
        const wantsTransformation = typeof (options === null || options === void 0 ? void 0 : options.transform) !== 'undefined';
        const renderPath = wantsTransformation ? 'render/image' : 'object';
        const transformationQuery = this.transformOptsToQueryString((options === null || options === void 0 ? void 0 : options.transform) || {});
        if (transformationQuery !== '') _queryString.push(transformationQuery);
        let queryString = _queryString.join('&');
        if (queryString !== '') queryString = `?${queryString}`;
        return {
            data: {
                publicUrl: encodeURI(`${this.url}/${renderPath}/public/${_path}${queryString}`)
            }
        };
    }
    /**
     * Deletes files within the same bucket
     *
     * @param paths An array of files to delete, including the path and file name. For example [`'folder/image.png'`].
     */ remove(paths) {
        return $21597b612ea06b11$var$__awaiter(this, void 0, void 0, function*() {
            try {
                const data = yield (0, $2ad35efa1b333042$export$cd7f480d6b8286c3)(this.fetch, `${this.url}/object/${this.bucketId}`, {
                    prefixes: paths
                }, {
                    headers: this.headers
                });
                return {
                    data: data,
                    error: null
                };
            } catch (error) {
                if ((0, $abe02471d8456f7f$export$5a322e77e5eb0561)(error)) return {
                    data: null,
                    error: error
                };
                throw error;
            }
        });
    }
    /**
     * Get file metadata
     * @param id the file id to retrieve metadata
     */ // async getMetadata(
    //   id: string
    // ): Promise<
    //   | {
    //       data: Metadata
    //       error: null
    //     }
    //   | {
    //       data: null
    //       error: StorageError
    //     }
    // > {
    //   try {
    //     const data = await get(this.fetch, `${this.url}/metadata/${id}`, { headers: this.headers })
    //     return { data, error: null }
    //   } catch (error) {
    //     if (isStorageError(error)) {
    //       return { data: null, error }
    //     }
    //     throw error
    //   }
    // }
    /**
     * Update file metadata
     * @param id the file id to update metadata
     * @param meta the new file metadata
     */ // async updateMetadata(
    //   id: string,
    //   meta: Metadata
    // ): Promise<
    //   | {
    //       data: Metadata
    //       error: null
    //     }
    //   | {
    //       data: null
    //       error: StorageError
    //     }
    // > {
    //   try {
    //     const data = await post(
    //       this.fetch,
    //       `${this.url}/metadata/${id}`,
    //       { ...meta },
    //       { headers: this.headers }
    //     )
    //     return { data, error: null }
    //   } catch (error) {
    //     if (isStorageError(error)) {
    //       return { data: null, error }
    //     }
    //     throw error
    //   }
    // }
    /**
     * Lists all the files within a bucket.
     * @param path The folder path.
     */ list(path, options, parameters) {
        return $21597b612ea06b11$var$__awaiter(this, void 0, void 0, function*() {
            try {
                const body = Object.assign(Object.assign(Object.assign({}, $21597b612ea06b11$var$DEFAULT_SEARCH_OPTIONS), options), {
                    prefix: path || ''
                });
                const data = yield (0, $2ad35efa1b333042$export$299ba2dee77727e9)(this.fetch, `${this.url}/object/list/${this.bucketId}`, body, {
                    headers: this.headers
                }, parameters);
                return {
                    data: data,
                    error: null
                };
            } catch (error) {
                if ((0, $abe02471d8456f7f$export$5a322e77e5eb0561)(error)) return {
                    data: null,
                    error: error
                };
                throw error;
            }
        });
    }
    encodeMetadata(metadata) {
        return JSON.stringify(metadata);
    }
    toBase64(data) {
        if (typeof $21597b612ea06b11$require$Buffer !== 'undefined') return $21597b612ea06b11$require$Buffer.from(data).toString('base64');
        return btoa(data);
    }
    _getFinalPath(path) {
        return `${this.bucketId}/${path}`;
    }
    _removeEmptyFolders(path) {
        return path.replace(/^\/|\/$/g, '').replace(/\/+/g, '/');
    }
    transformOptsToQueryString(transform) {
        const params = [];
        if (transform.width) params.push(`width=${transform.width}`);
        if (transform.height) params.push(`height=${transform.height}`);
        if (transform.resize) params.push(`resize=${transform.resize}`);
        if (transform.format) params.push(`format=${transform.format}`);
        if (transform.quality) params.push(`quality=${transform.quality}`);
        return params.join('&');
    }
}


// generated by genversion
const $a02d8046733ee147$export$83d89fbfd8236492 = '2.7.1';


const $f4c4e1deae4025ef$export$88a84136db6a4b64 = {
    'X-Client-Info': `storage-js/${(0, $a02d8046733ee147$export$83d89fbfd8236492)}`
};





var $316874d7d88ac643$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
class $316874d7d88ac643$export$2e2bcd8739ae039 {
    constructor(url, headers = {}, fetch){
        this.url = url;
        this.headers = Object.assign(Object.assign({}, (0, $f4c4e1deae4025ef$export$88a84136db6a4b64)), headers);
        this.fetch = (0, $b8abd4fb4763e533$export$98d92b1aa79f8cc7)(fetch);
    }
    /**
     * Retrieves the details of all Storage buckets within an existing project.
     */ listBuckets() {
        return $316874d7d88ac643$var$__awaiter(this, void 0, void 0, function*() {
            try {
                const data = yield (0, $2ad35efa1b333042$export$3988ae62b71be9a3)(this.fetch, `${this.url}/bucket`, {
                    headers: this.headers
                });
                return {
                    data: data,
                    error: null
                };
            } catch (error) {
                if ((0, $abe02471d8456f7f$export$5a322e77e5eb0561)(error)) return {
                    data: null,
                    error: error
                };
                throw error;
            }
        });
    }
    /**
     * Retrieves the details of an existing Storage bucket.
     *
     * @param id The unique identifier of the bucket you would like to retrieve.
     */ getBucket(id) {
        return $316874d7d88ac643$var$__awaiter(this, void 0, void 0, function*() {
            try {
                const data = yield (0, $2ad35efa1b333042$export$3988ae62b71be9a3)(this.fetch, `${this.url}/bucket/${id}`, {
                    headers: this.headers
                });
                return {
                    data: data,
                    error: null
                };
            } catch (error) {
                if ((0, $abe02471d8456f7f$export$5a322e77e5eb0561)(error)) return {
                    data: null,
                    error: error
                };
                throw error;
            }
        });
    }
    /**
     * Creates a new Storage bucket
     *
     * @param id A unique identifier for the bucket you are creating.
     * @param options.public The visibility of the bucket. Public buckets don't require an authorization token to download objects, but still require a valid token for all other operations. By default, buckets are private.
     * @param options.fileSizeLimit specifies the max file size in bytes that can be uploaded to this bucket.
     * The global file size limit takes precedence over this value.
     * The default value is null, which doesn't set a per bucket file size limit.
     * @param options.allowedMimeTypes specifies the allowed mime types that this bucket can accept during upload.
     * The default value is null, which allows files with all mime types to be uploaded.
     * Each mime type specified can be a wildcard, e.g. image/*, or a specific mime type, e.g. image/png.
     * @returns newly created bucket id
     */ createBucket(id, options = {
        public: false
    }) {
        return $316874d7d88ac643$var$__awaiter(this, void 0, void 0, function*() {
            try {
                const data = yield (0, $2ad35efa1b333042$export$299ba2dee77727e9)(this.fetch, `${this.url}/bucket`, {
                    id: id,
                    name: id,
                    public: options.public,
                    file_size_limit: options.fileSizeLimit,
                    allowed_mime_types: options.allowedMimeTypes
                }, {
                    headers: this.headers
                });
                return {
                    data: data,
                    error: null
                };
            } catch (error) {
                if ((0, $abe02471d8456f7f$export$5a322e77e5eb0561)(error)) return {
                    data: null,
                    error: error
                };
                throw error;
            }
        });
    }
    /**
     * Updates a Storage bucket
     *
     * @param id A unique identifier for the bucket you are updating.
     * @param options.public The visibility of the bucket. Public buckets don't require an authorization token to download objects, but still require a valid token for all other operations.
     * @param options.fileSizeLimit specifies the max file size in bytes that can be uploaded to this bucket.
     * The global file size limit takes precedence over this value.
     * The default value is null, which doesn't set a per bucket file size limit.
     * @param options.allowedMimeTypes specifies the allowed mime types that this bucket can accept during upload.
     * The default value is null, which allows files with all mime types to be uploaded.
     * Each mime type specified can be a wildcard, e.g. image/*, or a specific mime type, e.g. image/png.
     */ updateBucket(id, options) {
        return $316874d7d88ac643$var$__awaiter(this, void 0, void 0, function*() {
            try {
                const data = yield (0, $2ad35efa1b333042$export$327f7b26ebf455db)(this.fetch, `${this.url}/bucket/${id}`, {
                    id: id,
                    name: id,
                    public: options.public,
                    file_size_limit: options.fileSizeLimit,
                    allowed_mime_types: options.allowedMimeTypes
                }, {
                    headers: this.headers
                });
                return {
                    data: data,
                    error: null
                };
            } catch (error) {
                if ((0, $abe02471d8456f7f$export$5a322e77e5eb0561)(error)) return {
                    data: null,
                    error: error
                };
                throw error;
            }
        });
    }
    /**
     * Removes all objects inside a single bucket.
     *
     * @param id The unique identifier of the bucket you would like to empty.
     */ emptyBucket(id) {
        return $316874d7d88ac643$var$__awaiter(this, void 0, void 0, function*() {
            try {
                const data = yield (0, $2ad35efa1b333042$export$299ba2dee77727e9)(this.fetch, `${this.url}/bucket/${id}/empty`, {}, {
                    headers: this.headers
                });
                return {
                    data: data,
                    error: null
                };
            } catch (error) {
                if ((0, $abe02471d8456f7f$export$5a322e77e5eb0561)(error)) return {
                    data: null,
                    error: error
                };
                throw error;
            }
        });
    }
    /**
     * Deletes an existing bucket. A bucket can't be deleted with existing objects inside it.
     * You must first `empty()` the bucket.
     *
     * @param id The unique identifier of the bucket you would like to delete.
     */ deleteBucket(id) {
        return $316874d7d88ac643$var$__awaiter(this, void 0, void 0, function*() {
            try {
                const data = yield (0, $2ad35efa1b333042$export$cd7f480d6b8286c3)(this.fetch, `${this.url}/bucket/${id}`, {}, {
                    headers: this.headers
                });
                return {
                    data: data,
                    error: null
                };
            } catch (error) {
                if ((0, $abe02471d8456f7f$export$5a322e77e5eb0561)(error)) return {
                    data: null,
                    error: error
                };
                throw error;
            }
        });
    }
}


class $3ac213f23af4773a$export$6c85f5032e75eff9 extends (0, $316874d7d88ac643$export$2e2bcd8739ae039) {
    constructor(url, headers = {}, fetch){
        super(url, headers, fetch);
    }
    /**
     * Perform file operation in a bucket.
     *
     * @param id The bucket id to operate on.
     */ from(id) {
        return new (0, $21597b612ea06b11$export$2e2bcd8739ae039)(this.url, this.headers, id, this.fetch);
    }
}


const $7ab8bdf3e5c9b693$export$83d89fbfd8236492 = '2.52.0';


let $c0fdce55fc03ad18$var$JS_ENV = '';
// @ts-ignore
if (typeof Deno !== 'undefined') $c0fdce55fc03ad18$var$JS_ENV = 'deno';
else if (typeof document !== 'undefined') $c0fdce55fc03ad18$var$JS_ENV = 'web';
else if (typeof navigator !== 'undefined' && navigator.product === 'ReactNative') $c0fdce55fc03ad18$var$JS_ENV = 'react-native';
else $c0fdce55fc03ad18$var$JS_ENV = 'node';
const $c0fdce55fc03ad18$export$88a84136db6a4b64 = {
    'X-Client-Info': `supabase-js-${$c0fdce55fc03ad18$var$JS_ENV}/${(0, $7ab8bdf3e5c9b693$export$83d89fbfd8236492)}`
};
const $c0fdce55fc03ad18$export$b63a5c3a2e5becd2 = {
    headers: $c0fdce55fc03ad18$export$88a84136db6a4b64
};
const $c0fdce55fc03ad18$export$b31378ae815bea6b = {
    schema: 'public'
};
const $c0fdce55fc03ad18$export$af122550cc2345b3 = {
    autoRefreshToken: true,
    persistSession: true,
    detectSessionInUrl: true,
    flowType: 'implicit'
};
const $c0fdce55fc03ad18$export$59685507ca0a3912 = {};



var $979Ct = parcelRequire("979Ct");
var $7846a7cc5c362d25$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
const $7846a7cc5c362d25$export$98d92b1aa79f8cc7 = (customFetch)=>{
    let _fetch;
    if (customFetch) _fetch = customFetch;
    else if (typeof fetch === 'undefined') _fetch = (0, $979Ct.default);
    else _fetch = fetch;
    return (...args)=>_fetch(...args);
};
const $7846a7cc5c362d25$export$3d2cf54f85b7fc8a = ()=>{
    if (typeof Headers === 'undefined') return 0, $979Ct.Headers;
    return Headers;
};
const $7846a7cc5c362d25$export$651dd5aef824521f = (supabaseKey, getAccessToken, customFetch)=>{
    const fetch1 = $7846a7cc5c362d25$export$98d92b1aa79f8cc7(customFetch);
    const HeadersConstructor = $7846a7cc5c362d25$export$3d2cf54f85b7fc8a();
    return (input, init)=>$7846a7cc5c362d25$var$__awaiter(void 0, void 0, void 0, function*() {
            var _a;
            const accessToken = (_a = yield getAccessToken()) !== null && _a !== void 0 ? _a : supabaseKey;
            let headers = new HeadersConstructor(init === null || init === void 0 ? void 0 : init.headers);
            if (!headers.has('apikey')) headers.set('apikey', supabaseKey);
            if (!headers.has('Authorization')) headers.set('Authorization', `Bearer ${accessToken}`);
            return fetch1(input, Object.assign(Object.assign({}, init), {
                headers: headers
            }));
        });
};


var $0c30a5a89f4b6341$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
function $0c30a5a89f4b6341$export$31b40729666a4ae0() {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
        var r = Math.random() * 16 | 0, v = c == 'x' ? r : r & 0x3 | 0x8;
        return v.toString(16);
    });
}
function $0c30a5a89f4b6341$export$a896b865588a414b(url) {
    return url.endsWith('/') ? url : url + '/';
}
const $0c30a5a89f4b6341$export$4e09c449d6c407f7 = ()=>typeof window !== 'undefined';
function $0c30a5a89f4b6341$export$da186dc3f8eace71(options, defaults) {
    var _a, _b;
    const { db: dbOptions, auth: authOptions, realtime: realtimeOptions, global: globalOptions } = options;
    const { db: DEFAULT_DB_OPTIONS, auth: DEFAULT_AUTH_OPTIONS, realtime: DEFAULT_REALTIME_OPTIONS, global: DEFAULT_GLOBAL_OPTIONS } = defaults;
    const result = {
        db: Object.assign(Object.assign({}, DEFAULT_DB_OPTIONS), dbOptions),
        auth: Object.assign(Object.assign({}, DEFAULT_AUTH_OPTIONS), authOptions),
        realtime: Object.assign(Object.assign({}, DEFAULT_REALTIME_OPTIONS), realtimeOptions),
        global: Object.assign(Object.assign(Object.assign({}, DEFAULT_GLOBAL_OPTIONS), globalOptions), {
            headers: Object.assign(Object.assign({}, (_a = DEFAULT_GLOBAL_OPTIONS === null || DEFAULT_GLOBAL_OPTIONS === void 0 ? void 0 : DEFAULT_GLOBAL_OPTIONS.headers) !== null && _a !== void 0 ? _a : {}), (_b = globalOptions === null || globalOptions === void 0 ? void 0 : globalOptions.headers) !== null && _b !== void 0 ? _b : {})
        }),
        accessToken: ()=>$0c30a5a89f4b6341$var$__awaiter(this, void 0, void 0, function*() {
                return '';
            })
    };
    if (options.accessToken) result.accessToken = options.accessToken;
    else // hack around Required<>
    delete result.accessToken;
    return result;
}


const $da0e74438356dc28$export$83d89fbfd8236492 = '2.71.1';


const $2f82a590c21cea7a$export$a4558fee79d6c8ae = 30000;
const $2f82a590c21cea7a$export$f20a97df8f5fe223 = 3;
const $2f82a590c21cea7a$export$a36ad0026e55ac00 = $2f82a590c21cea7a$export$f20a97df8f5fe223 * $2f82a590c21cea7a$export$a4558fee79d6c8ae;
const $2f82a590c21cea7a$export$7fedf552187f0c3d = 'http://localhost:9999';
const $2f82a590c21cea7a$export$86880b4b2e1a2384 = 'supabase.auth.token';
const $2f82a590c21cea7a$export$2f9161bad044dacb = '';
const $2f82a590c21cea7a$export$88a84136db6a4b64 = {
    'X-Client-Info': `gotrue-js/${(0, $da0e74438356dc28$export$83d89fbfd8236492)}`
};
const $2f82a590c21cea7a$export$5615c708618ee858 = {
    MAX_RETRIES: 10,
    RETRY_INTERVAL: 2
};
const $2f82a590c21cea7a$export$e4f5507f88977535 = 'X-Supabase-Api-Version';
const $2f82a590c21cea7a$export$1f9a66038489bdeb = {
    '2024-01-01': {
        timestamp: Date.parse('2024-01-01T00:00:00.0Z'),
        name: '2024-01-01'
    }
};
const $2f82a590c21cea7a$export$7a68c9e70b9d3911 = /^([a-z0-9_-]{4})*($|[a-z0-9_-]{3}$|[a-z0-9_-]{2}$)$/i;
const $2f82a590c21cea7a$export$5bd768495200f133 = 600000; // 10 minutes



class $b92ec9013174409a$export$145273558d58e0ac extends Error {
    constructor(message, status, code){
        super(message);
        this.__isAuthError = true;
        this.name = 'AuthError';
        this.status = status;
        this.code = code;
    }
}
function $b92ec9013174409a$export$cde1786a482f9a1c(error) {
    return typeof error === 'object' && error !== null && '__isAuthError' in error;
}
class $b92ec9013174409a$export$45fde0b55b14f37b extends $b92ec9013174409a$export$145273558d58e0ac {
    constructor(message, status, code){
        super(message, status, code);
        this.name = 'AuthApiError';
        this.status = status;
        this.code = code;
    }
}
function $b92ec9013174409a$export$4fe744aeb810d543(error) {
    return $b92ec9013174409a$export$cde1786a482f9a1c(error) && error.name === 'AuthApiError';
}
class $b92ec9013174409a$export$f7559805d4a50078 extends $b92ec9013174409a$export$145273558d58e0ac {
    constructor(message, originalError){
        super(message);
        this.name = 'AuthUnknownError';
        this.originalError = originalError;
    }
}
class $b92ec9013174409a$export$823c745ae0673c5e extends $b92ec9013174409a$export$145273558d58e0ac {
    constructor(message, name, status, code){
        super(message, status, code);
        this.name = name;
        this.status = status;
    }
}
class $b92ec9013174409a$export$403b3fc0d3ad5f0c extends $b92ec9013174409a$export$823c745ae0673c5e {
    constructor(){
        super('Auth session missing!', 'AuthSessionMissingError', 400, undefined);
    }
}
function $b92ec9013174409a$export$3e849aa4db565c1d(error) {
    return $b92ec9013174409a$export$cde1786a482f9a1c(error) && error.name === 'AuthSessionMissingError';
}
class $b92ec9013174409a$export$7e277b620449c1b4 extends $b92ec9013174409a$export$823c745ae0673c5e {
    constructor(){
        super('Auth session or user missing', 'AuthInvalidTokenResponseError', 500, undefined);
    }
}
class $b92ec9013174409a$export$9ef583f0381b4cc extends $b92ec9013174409a$export$823c745ae0673c5e {
    constructor(message){
        super(message, 'AuthInvalidCredentialsError', 400, undefined);
    }
}
class $b92ec9013174409a$export$bf5df8e043856ef5 extends $b92ec9013174409a$export$823c745ae0673c5e {
    constructor(message, details = null){
        super(message, 'AuthImplicitGrantRedirectError', 500, undefined);
        this.details = null;
        this.details = details;
    }
    toJSON() {
        return {
            name: this.name,
            message: this.message,
            status: this.status,
            details: this.details
        };
    }
}
function $b92ec9013174409a$export$45edea3999507afd(error) {
    return $b92ec9013174409a$export$cde1786a482f9a1c(error) && error.name === 'AuthImplicitGrantRedirectError';
}
class $b92ec9013174409a$export$39583657eb2a7027 extends $b92ec9013174409a$export$823c745ae0673c5e {
    constructor(message, details = null){
        super(message, 'AuthPKCEGrantCodeExchangeError', 500, undefined);
        this.details = null;
        this.details = details;
    }
    toJSON() {
        return {
            name: this.name,
            message: this.message,
            status: this.status,
            details: this.details
        };
    }
}
class $b92ec9013174409a$export$2423b763f68be1b4 extends $b92ec9013174409a$export$823c745ae0673c5e {
    constructor(message, status){
        super(message, 'AuthRetryableFetchError', status, undefined);
    }
}
function $b92ec9013174409a$export$a77af358da5fb874(error) {
    return $b92ec9013174409a$export$cde1786a482f9a1c(error) && error.name === 'AuthRetryableFetchError';
}
class $b92ec9013174409a$export$b034076aa04913a6 extends $b92ec9013174409a$export$823c745ae0673c5e {
    constructor(message, status, reasons){
        super(message, 'AuthWeakPasswordError', status, 'weak_password');
        this.reasons = reasons;
    }
}
function $b92ec9013174409a$export$dac36143fd8a46ef(error) {
    return $b92ec9013174409a$export$cde1786a482f9a1c(error) && error.name === 'AuthWeakPasswordError';
}
class $b92ec9013174409a$export$d04cb18528f2043e extends $b92ec9013174409a$export$823c745ae0673c5e {
    constructor(message){
        super(message, 'AuthInvalidJwtError', 400, 'invalid_jwt');
    }
}


/**
 * Avoid modifying this file. It's part of
 * https://github.com/supabase-community/base64url-js.  Submit all fixes on
 * that repo!
 */ /**
 * An array of characters that encode 6 bits into a Base64-URL alphabet
 * character.
 */ const $dbf67752838ebc66$var$TO_BASE64URL = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-_'.split('');
/**
 * An array of characters that can appear in a Base64-URL encoded string but
 * should be ignored.
 */ const $dbf67752838ebc66$var$IGNORE_BASE64URL = ' \t\n\r='.split('');
/**
 * An array of 128 numbers that map a Base64-URL character to 6 bits, or if -2
 * used to skip the character, or if -1 used to error out.
 */ const $dbf67752838ebc66$var$FROM_BASE64URL = (()=>{
    const charMap = new Array(128);
    for(let i = 0; i < charMap.length; i += 1)charMap[i] = -1;
    for(let i = 0; i < $dbf67752838ebc66$var$IGNORE_BASE64URL.length; i += 1)charMap[$dbf67752838ebc66$var$IGNORE_BASE64URL[i].charCodeAt(0)] = -2;
    for(let i = 0; i < $dbf67752838ebc66$var$TO_BASE64URL.length; i += 1)charMap[$dbf67752838ebc66$var$TO_BASE64URL[i].charCodeAt(0)] = i;
    return charMap;
})();
function $dbf67752838ebc66$export$744f452403189a3e(byte, state, emit) {
    if (byte !== null) {
        state.queue = state.queue << 8 | byte;
        state.queuedBits += 8;
        while(state.queuedBits >= 6){
            const pos = state.queue >> state.queuedBits - 6 & 63;
            emit($dbf67752838ebc66$var$TO_BASE64URL[pos]);
            state.queuedBits -= 6;
        }
    } else if (state.queuedBits > 0) {
        state.queue = state.queue << 6 - state.queuedBits;
        state.queuedBits = 6;
        while(state.queuedBits >= 6){
            const pos = state.queue >> state.queuedBits - 6 & 63;
            emit($dbf67752838ebc66$var$TO_BASE64URL[pos]);
            state.queuedBits -= 6;
        }
    }
}
function $dbf67752838ebc66$export$403e86c86002a137(charCode, state, emit) {
    const bits = $dbf67752838ebc66$var$FROM_BASE64URL[charCode];
    if (bits > -1) {
        // valid Base64-URL character
        state.queue = state.queue << 6 | bits;
        state.queuedBits += 6;
        while(state.queuedBits >= 8){
            emit(state.queue >> state.queuedBits - 8 & 0xff);
            state.queuedBits -= 8;
        }
    } else if (bits === -2) // ignore spaces, tabs, newlines, =
    return;
    else throw new Error(`Invalid Base64-URL character "${String.fromCharCode(charCode)}"`);
}
function $dbf67752838ebc66$export$abe65c864cc3fd34(str) {
    const base64 = [];
    const emitter = (char)=>{
        base64.push(char);
    };
    const state = {
        queue: 0,
        queuedBits: 0
    };
    $dbf67752838ebc66$export$caccae6095ceb6da(str, (byte)=>{
        $dbf67752838ebc66$export$744f452403189a3e(byte, state, emitter);
    });
    $dbf67752838ebc66$export$744f452403189a3e(null, state, emitter);
    return base64.join('');
}
function $dbf67752838ebc66$export$bd5d476f823ea024(str) {
    const conv = [];
    const utf8Emit = (codepoint)=>{
        conv.push(String.fromCodePoint(codepoint));
    };
    const utf8State = {
        utf8seq: 0,
        codepoint: 0
    };
    const b64State = {
        queue: 0,
        queuedBits: 0
    };
    const byteEmit = (byte)=>{
        $dbf67752838ebc66$export$719b4117b3270757(byte, utf8State, utf8Emit);
    };
    for(let i = 0; i < str.length; i += 1)$dbf67752838ebc66$export$403e86c86002a137(str.charCodeAt(i), b64State, byteEmit);
    return conv.join('');
}
function $dbf67752838ebc66$export$d203cd9136753332(codepoint, emit) {
    if (codepoint <= 0x7f) {
        emit(codepoint);
        return;
    } else if (codepoint <= 0x7ff) {
        emit(0xc0 | codepoint >> 6);
        emit(0x80 | codepoint & 0x3f);
        return;
    } else if (codepoint <= 0xffff) {
        emit(0xe0 | codepoint >> 12);
        emit(0x80 | codepoint >> 6 & 0x3f);
        emit(0x80 | codepoint & 0x3f);
        return;
    } else if (codepoint <= 0x10ffff) {
        emit(0xf0 | codepoint >> 18);
        emit(0x80 | codepoint >> 12 & 0x3f);
        emit(0x80 | codepoint >> 6 & 0x3f);
        emit(0x80 | codepoint & 0x3f);
        return;
    }
    throw new Error(`Unrecognized Unicode codepoint: ${codepoint.toString(16)}`);
}
function $dbf67752838ebc66$export$caccae6095ceb6da(str, emit) {
    for(let i = 0; i < str.length; i += 1){
        let codepoint = str.charCodeAt(i);
        if (codepoint > 0xd7ff && codepoint <= 0xdbff) {
            // most UTF-16 codepoints are Unicode codepoints, except values in this
            // range where the next UTF-16 codepoint needs to be combined with the
            // current one to get the Unicode codepoint
            const highSurrogate = (codepoint - 0xd800) * 0x400 & 0xffff;
            const lowSurrogate = str.charCodeAt(i + 1) - 0xdc00 & 0xffff;
            codepoint = (lowSurrogate | highSurrogate) + 0x10000;
            i += 1;
        }
        $dbf67752838ebc66$export$d203cd9136753332(codepoint, emit);
    }
}
function $dbf67752838ebc66$export$719b4117b3270757(byte, state, emit) {
    if (state.utf8seq === 0) {
        if (byte <= 0x7f) {
            emit(byte);
            return;
        }
        // count the number of 1 leading bits until you reach 0
        for(let leadingBit = 1; leadingBit < 6; leadingBit += 1)if ((byte >> 7 - leadingBit & 1) === 0) {
            state.utf8seq = leadingBit;
            break;
        }
        if (state.utf8seq === 2) state.codepoint = byte & 31;
        else if (state.utf8seq === 3) state.codepoint = byte & 15;
        else if (state.utf8seq === 4) state.codepoint = byte & 7;
        else throw new Error('Invalid UTF-8 sequence');
        state.utf8seq -= 1;
    } else if (state.utf8seq > 0) {
        if (byte <= 0x7f) throw new Error('Invalid UTF-8 sequence');
        state.codepoint = state.codepoint << 6 | byte & 63;
        state.utf8seq -= 1;
        if (state.utf8seq === 0) emit(state.codepoint);
    }
}
function $dbf67752838ebc66$export$9cae2cd6076b8fb6(str) {
    const result = [];
    const state = {
        queue: 0,
        queuedBits: 0
    };
    const onByte = (byte)=>{
        result.push(byte);
    };
    for(let i = 0; i < str.length; i += 1)$dbf67752838ebc66$export$403e86c86002a137(str.charCodeAt(i), state, onByte);
    return new Uint8Array(result);
}
function $dbf67752838ebc66$export$a098e7b533f96db3(str) {
    const result = [];
    $dbf67752838ebc66$export$caccae6095ceb6da(str, (byte)=>result.push(byte));
    return new Uint8Array(result);
}
function $dbf67752838ebc66$export$3f156efe462a835e(bytes) {
    const result = [];
    const state = {
        queue: 0,
        queuedBits: 0
    };
    const onChar = (char)=>{
        result.push(char);
    };
    bytes.forEach((byte)=>$dbf67752838ebc66$export$744f452403189a3e(byte, state, onChar));
    // always call with `null` after processing all bytes
    $dbf67752838ebc66$export$744f452403189a3e(null, state, onChar);
    return result.join('');
}


function $6a62ca85cf697dd5$export$e02d0a488392f690(expiresIn) {
    const timeNow = Math.round(Date.now() / 1000);
    return timeNow + expiresIn;
}
function $6a62ca85cf697dd5$export$31b40729666a4ae0() {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
        const r = Math.random() * 16 | 0, v = c == 'x' ? r : r & 0x3 | 0x8;
        return v.toString(16);
    });
}
const $6a62ca85cf697dd5$export$4e09c449d6c407f7 = ()=>typeof window !== 'undefined' && typeof document !== 'undefined';
const $6a62ca85cf697dd5$var$localStorageWriteTests = {
    tested: false,
    writable: false
};
const $6a62ca85cf697dd5$export$9ec034ee80211814 = ()=>{
    if (!$6a62ca85cf697dd5$export$4e09c449d6c407f7()) return false;
    try {
        if (typeof globalThis.localStorage !== 'object') return false;
    } catch (e) {
        // DOM exception when accessing `localStorage`
        return false;
    }
    if ($6a62ca85cf697dd5$var$localStorageWriteTests.tested) return $6a62ca85cf697dd5$var$localStorageWriteTests.writable;
    const randomKey = `lswt-${Math.random()}${Math.random()}`;
    try {
        globalThis.localStorage.setItem(randomKey, randomKey);
        globalThis.localStorage.removeItem(randomKey);
        $6a62ca85cf697dd5$var$localStorageWriteTests.tested = true;
        $6a62ca85cf697dd5$var$localStorageWriteTests.writable = true;
    } catch (e) {
        // localStorage can't be written to
        // https://www.chromium.org/for-testers/bug-reporting-guidelines/uncaught-securityerror-failed-to-read-the-localstorage-property-from-window-access-is-denied-for-this-document
        $6a62ca85cf697dd5$var$localStorageWriteTests.tested = true;
        $6a62ca85cf697dd5$var$localStorageWriteTests.writable = false;
    }
    return $6a62ca85cf697dd5$var$localStorageWriteTests.writable;
};
function $6a62ca85cf697dd5$export$7a29392fb778224c(href) {
    const result = {};
    const url = new URL(href);
    if (url.hash && url.hash[0] === '#') try {
        const hashSearchParams = new URLSearchParams(url.hash.substring(1));
        hashSearchParams.forEach((value, key)=>{
            result[key] = value;
        });
    } catch (e) {
    // hash is not a query string
    }
    // search parameters take precedence over hash parameters
    url.searchParams.forEach((value, key)=>{
        result[key] = value;
    });
    return result;
}

const $6a62ca85cf697dd5$export$98d92b1aa79f8cc7 = (customFetch)=>{
    let _fetch;
    if (customFetch) _fetch = customFetch;
    else if (typeof fetch === 'undefined') _fetch = (...args)=>Promise.resolve((parcelRequire("979Ct"))).then(({ default: fetch1 })=>fetch1(...args));
    else _fetch = fetch;
    return (...args)=>_fetch(...args);
};
const $6a62ca85cf697dd5$export$e8ad6599be1036a7 = (maybeResponse)=>{
    return typeof maybeResponse === 'object' && maybeResponse !== null && 'status' in maybeResponse && 'ok' in maybeResponse && 'json' in maybeResponse && typeof maybeResponse.json === 'function';
};
const $6a62ca85cf697dd5$export$e82c36d29078a87f = async (storage, key, data)=>{
    await storage.setItem(key, JSON.stringify(data));
};
const $6a62ca85cf697dd5$export$ba6fcb7c333d32c0 = async (storage, key)=>{
    const value = await storage.getItem(key);
    if (!value) return null;
    try {
        return JSON.parse(value);
    } catch (_a) {
        return value;
    }
};
const $6a62ca85cf697dd5$export$d35c645d585317ec = async (storage, key)=>{
    await storage.removeItem(key);
};
class $6a62ca85cf697dd5$export$85f6557964517f1a {
    constructor(){
        this.promise = new $6a62ca85cf697dd5$export$85f6557964517f1a.promiseConstructor((res, rej)=>{
            this.resolve = res;
            this.reject = rej;
        });
    }
}
$6a62ca85cf697dd5$export$85f6557964517f1a.promiseConstructor = Promise;
function $6a62ca85cf697dd5$export$9a62e6c0a30e00bc(token) {
    const parts = token.split('.');
    if (parts.length !== 3) throw new (0, $b92ec9013174409a$export$d04cb18528f2043e)('Invalid JWT structure');
    // Regex checks for base64url format
    for(let i = 0; i < parts.length; i++){
        if (!(0, $2f82a590c21cea7a$export$7a68c9e70b9d3911).test(parts[i])) throw new (0, $b92ec9013174409a$export$d04cb18528f2043e)('JWT not in base64url format');
    }
    const data = {
        // using base64url lib
        header: JSON.parse((0, $dbf67752838ebc66$export$bd5d476f823ea024)(parts[0])),
        payload: JSON.parse((0, $dbf67752838ebc66$export$bd5d476f823ea024)(parts[1])),
        signature: (0, $dbf67752838ebc66$export$9cae2cd6076b8fb6)(parts[2]),
        raw: {
            header: parts[0],
            payload: parts[1]
        }
    };
    return data;
}
async function $6a62ca85cf697dd5$export$e772c8ff12451969(time) {
    return await new Promise((accept)=>{
        setTimeout(()=>accept(null), time);
    });
}
function $6a62ca85cf697dd5$export$9e1b8e833f44ff21(fn, isRetryable) {
    const promise = new Promise((accept, reject)=>{
        (async ()=>{
            for(let attempt = 0; attempt < Infinity; attempt++)try {
                const result = await fn(attempt);
                if (!isRetryable(attempt, null, result)) {
                    accept(result);
                    return;
                }
            } catch (e) {
                if (!isRetryable(attempt, e)) {
                    reject(e);
                    return;
                }
            }
        })();
    });
    return promise;
}
function $6a62ca85cf697dd5$var$dec2hex(dec) {
    return ('0' + dec.toString(16)).substr(-2);
}
function $6a62ca85cf697dd5$export$b6c3b8498f152f15() {
    const verifierLength = 56;
    const array = new Uint32Array(verifierLength);
    if (typeof crypto === 'undefined') {
        const charSet = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-._~';
        const charSetLen = charSet.length;
        let verifier = '';
        for(let i = 0; i < verifierLength; i++)verifier += charSet.charAt(Math.floor(Math.random() * charSetLen));
        return verifier;
    }
    crypto.getRandomValues(array);
    return Array.from(array, $6a62ca85cf697dd5$var$dec2hex).join('');
}
async function $6a62ca85cf697dd5$var$sha256(randomString) {
    const encoder = new TextEncoder();
    const encodedData = encoder.encode(randomString);
    const hash = await crypto.subtle.digest('SHA-256', encodedData);
    const bytes = new Uint8Array(hash);
    return Array.from(bytes).map((c)=>String.fromCharCode(c)).join('');
}
async function $6a62ca85cf697dd5$export$eb79e16bb8189148(verifier) {
    const hasCryptoSupport = typeof crypto !== 'undefined' && typeof crypto.subtle !== 'undefined' && typeof TextEncoder !== 'undefined';
    if (!hasCryptoSupport) {
        console.warn('WebCrypto API is not supported. Code challenge method will default to use plain instead of sha256.');
        return verifier;
    }
    const hashed = await $6a62ca85cf697dd5$var$sha256(verifier);
    return btoa(hashed).replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');
}
async function $6a62ca85cf697dd5$export$81b177cadfcf873c(storage, storageKey, isPasswordRecovery = false) {
    const codeVerifier = $6a62ca85cf697dd5$export$b6c3b8498f152f15();
    let storedCodeVerifier = codeVerifier;
    if (isPasswordRecovery) storedCodeVerifier += '/PASSWORD_RECOVERY';
    await $6a62ca85cf697dd5$export$e82c36d29078a87f(storage, `${storageKey}-code-verifier`, storedCodeVerifier);
    const codeChallenge = await $6a62ca85cf697dd5$export$eb79e16bb8189148(codeVerifier);
    const codeChallengeMethod = codeVerifier === codeChallenge ? 'plain' : 's256';
    return [
        codeChallenge,
        codeChallengeMethod
    ];
}
/** Parses the API version which is 2YYY-MM-DD. */ const $6a62ca85cf697dd5$var$API_VERSION_REGEX = /^2[0-9]{3}-(0[1-9]|1[0-2])-(0[1-9]|1[0-9]|2[0-9]|3[0-1])$/i;
function $6a62ca85cf697dd5$export$5f69ecf1c14d56fd(response) {
    const apiVersion = response.headers.get((0, $2f82a590c21cea7a$export$e4f5507f88977535));
    if (!apiVersion) return null;
    if (!apiVersion.match($6a62ca85cf697dd5$var$API_VERSION_REGEX)) return null;
    try {
        const date = new Date(`${apiVersion}T00:00:00.0Z`);
        return date;
    } catch (e) {
        return null;
    }
}
function $6a62ca85cf697dd5$export$a5850868adeb9253(exp) {
    if (!exp) throw new Error('Missing exp claim');
    const timeNow = Math.floor(Date.now() / 1000);
    if (exp <= timeNow) throw new Error('JWT has expired');
}
function $6a62ca85cf697dd5$export$fa59f625ab60cb91(alg) {
    switch(alg){
        case 'RS256':
            return {
                name: 'RSASSA-PKCS1-v1_5',
                hash: {
                    name: 'SHA-256'
                }
            };
        case 'ES256':
            return {
                name: 'ECDSA',
                namedCurve: 'P-256',
                hash: {
                    name: 'SHA-256'
                }
            };
        default:
            throw new Error('Invalid alg claim');
    }
}
const $6a62ca85cf697dd5$var$UUID_REGEX = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/;
function $6a62ca85cf697dd5$export$a4c72ae47296db0c(str) {
    if (!$6a62ca85cf697dd5$var$UUID_REGEX.test(str)) throw new Error('@supabase/auth-js: Expected parameter to be UUID but is not');
}
function $6a62ca85cf697dd5$export$52c7f0d8a78626b() {
    const proxyTarget = {};
    return new Proxy(proxyTarget, {
        get: (target, prop)=>{
            if (prop === '__isUserNotAvailableProxy') return true;
            // Preventative check for common problematic symbols during cloning/inspection
            // These symbols might be accessed by structuredClone or other internal mechanisms.
            if (typeof prop === 'symbol') {
                const sProp = prop.toString();
                if (sProp === 'Symbol(Symbol.toPrimitive)' || sProp === 'Symbol(Symbol.toStringTag)' || sProp === 'Symbol(util.inspect.custom)') // Node.js util.inspect
                return undefined;
            }
            throw new Error(`@supabase/auth-js: client was created with userStorage option and there was no user stored in the user storage. Accessing the "${prop}" property of the session object is not supported. Please use getUser() instead.`);
        },
        set: (_target, prop)=>{
            throw new Error(`@supabase/auth-js: client was created with userStorage option and there was no user stored in the user storage. Setting the "${prop}" property of the session object is not supported. Please use getUser() to fetch a user object you can manipulate.`);
        },
        deleteProperty: (_target, prop)=>{
            throw new Error(`@supabase/auth-js: client was created with userStorage option and there was no user stored in the user storage. Deleting the "${prop}" property of the session object is not supported. Please use getUser() to fetch a user object you can manipulate.`);
        }
    });
}
function $6a62ca85cf697dd5$export$b7d58db314e0ac27(obj) {
    return JSON.parse(JSON.stringify(obj));
}



var $9c1b37c8edd4ca2b$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
const $9c1b37c8edd4ca2b$var$_getErrorMessage = (err)=>err.msg || err.message || err.error_description || err.error || JSON.stringify(err);
const $9c1b37c8edd4ca2b$var$NETWORK_ERROR_CODES = [
    502,
    503,
    504
];
async function $9c1b37c8edd4ca2b$export$d3da1ecaf1206c58(error) {
    var _a;
    if (!(0, $6a62ca85cf697dd5$export$e8ad6599be1036a7)(error)) throw new (0, $b92ec9013174409a$export$2423b763f68be1b4)($9c1b37c8edd4ca2b$var$_getErrorMessage(error), 0);
    if ($9c1b37c8edd4ca2b$var$NETWORK_ERROR_CODES.includes(error.status)) // status in 500...599 range - server had an error, request might be retryed.
    throw new (0, $b92ec9013174409a$export$2423b763f68be1b4)($9c1b37c8edd4ca2b$var$_getErrorMessage(error), error.status);
    let data;
    try {
        data = await error.json();
    } catch (e) {
        throw new (0, $b92ec9013174409a$export$f7559805d4a50078)($9c1b37c8edd4ca2b$var$_getErrorMessage(e), e);
    }
    let errorCode = undefined;
    const responseAPIVersion = (0, $6a62ca85cf697dd5$export$5f69ecf1c14d56fd)(error);
    if (responseAPIVersion && responseAPIVersion.getTime() >= (0, $2f82a590c21cea7a$export$1f9a66038489bdeb)['2024-01-01'].timestamp && typeof data === 'object' && data && typeof data.code === 'string') errorCode = data.code;
    else if (typeof data === 'object' && data && typeof data.error_code === 'string') errorCode = data.error_code;
    if (!errorCode) {
        // Legacy support for weak password errors, when there were no error codes
        if (typeof data === 'object' && data && typeof data.weak_password === 'object' && data.weak_password && Array.isArray(data.weak_password.reasons) && data.weak_password.reasons.length && data.weak_password.reasons.reduce((a, i)=>a && typeof i === 'string', true)) throw new (0, $b92ec9013174409a$export$b034076aa04913a6)($9c1b37c8edd4ca2b$var$_getErrorMessage(data), error.status, data.weak_password.reasons);
    } else if (errorCode === 'weak_password') throw new (0, $b92ec9013174409a$export$b034076aa04913a6)($9c1b37c8edd4ca2b$var$_getErrorMessage(data), error.status, ((_a = data.weak_password) === null || _a === void 0 ? void 0 : _a.reasons) || []);
    else if (errorCode === 'session_not_found') // The `session_id` inside the JWT does not correspond to a row in the
    // `sessions` table. This usually means the user has signed out, has been
    // deleted, or their session has somehow been terminated.
    throw new (0, $b92ec9013174409a$export$403b3fc0d3ad5f0c)();
    throw new (0, $b92ec9013174409a$export$45fde0b55b14f37b)($9c1b37c8edd4ca2b$var$_getErrorMessage(data), error.status || 500, errorCode);
}
const $9c1b37c8edd4ca2b$var$_getRequestParams = (method, options, parameters, body)=>{
    const params = {
        method: method,
        headers: (options === null || options === void 0 ? void 0 : options.headers) || {}
    };
    if (method === 'GET') return params;
    params.headers = Object.assign({
        'Content-Type': 'application/json;charset=UTF-8'
    }, options === null || options === void 0 ? void 0 : options.headers);
    params.body = JSON.stringify(body);
    return Object.assign(Object.assign({}, params), parameters);
};
async function $9c1b37c8edd4ca2b$export$8969b3850ca2cdfd(fetcher, method, url, options) {
    var _a;
    const headers = Object.assign({}, options === null || options === void 0 ? void 0 : options.headers);
    if (!headers[0, $2f82a590c21cea7a$export$e4f5507f88977535]) headers[0, $2f82a590c21cea7a$export$e4f5507f88977535] = (0, $2f82a590c21cea7a$export$1f9a66038489bdeb)['2024-01-01'].name;
    if (options === null || options === void 0 ? void 0 : options.jwt) headers['Authorization'] = `Bearer ${options.jwt}`;
    const qs = (_a = options === null || options === void 0 ? void 0 : options.query) !== null && _a !== void 0 ? _a : {};
    if (options === null || options === void 0 ? void 0 : options.redirectTo) qs['redirect_to'] = options.redirectTo;
    const queryString = Object.keys(qs).length ? '?' + new URLSearchParams(qs).toString() : '';
    const data = await $9c1b37c8edd4ca2b$var$_handleRequest(fetcher, method, url + queryString, {
        headers: headers,
        noResolveJson: options === null || options === void 0 ? void 0 : options.noResolveJson
    }, {}, options === null || options === void 0 ? void 0 : options.body);
    return (options === null || options === void 0 ? void 0 : options.xform) ? options === null || options === void 0 ? void 0 : options.xform(data) : {
        data: Object.assign({}, data),
        error: null
    };
}
async function $9c1b37c8edd4ca2b$var$_handleRequest(fetcher, method, url, options, parameters, body) {
    const requestParams = $9c1b37c8edd4ca2b$var$_getRequestParams(method, options, parameters, body);
    let result;
    try {
        result = await fetcher(url, Object.assign({}, requestParams));
    } catch (e) {
        console.error(e);
        // fetch failed, likely due to a network or CORS error
        throw new (0, $b92ec9013174409a$export$2423b763f68be1b4)($9c1b37c8edd4ca2b$var$_getErrorMessage(e), 0);
    }
    if (!result.ok) await $9c1b37c8edd4ca2b$export$d3da1ecaf1206c58(result);
    if (options === null || options === void 0 ? void 0 : options.noResolveJson) return result;
    try {
        return await result.json();
    } catch (e) {
        await $9c1b37c8edd4ca2b$export$d3da1ecaf1206c58(e);
    }
}
function $9c1b37c8edd4ca2b$export$273fe4673a018c2e(data) {
    var _a;
    let session = null;
    if ($9c1b37c8edd4ca2b$var$hasSession(data)) {
        session = Object.assign({}, data);
        if (!data.expires_at) session.expires_at = (0, $6a62ca85cf697dd5$export$e02d0a488392f690)(data.expires_in);
    }
    const user = (_a = data.user) !== null && _a !== void 0 ? _a : data;
    return {
        data: {
            session: session,
            user: user
        },
        error: null
    };
}
function $9c1b37c8edd4ca2b$export$db83aade1c2922c7(data) {
    const response = $9c1b37c8edd4ca2b$export$273fe4673a018c2e(data);
    if (!response.error && data.weak_password && typeof data.weak_password === 'object' && Array.isArray(data.weak_password.reasons) && data.weak_password.reasons.length && data.weak_password.message && typeof data.weak_password.message === 'string' && data.weak_password.reasons.reduce((a, i)=>a && typeof i === 'string', true)) response.data.weak_password = data.weak_password;
    return response;
}
function $9c1b37c8edd4ca2b$export$e20f488897843593(data) {
    var _a;
    const user = (_a = data.user) !== null && _a !== void 0 ? _a : data;
    return {
        data: {
            user: user
        },
        error: null
    };
}
function $9c1b37c8edd4ca2b$export$b04785c46dcd8f8b(data) {
    return {
        data: data,
        error: null
    };
}
function $9c1b37c8edd4ca2b$export$f5eaa950605b2146(data) {
    const { action_link: action_link, email_otp: email_otp, hashed_token: hashed_token, redirect_to: redirect_to, verification_type: verification_type } = data, rest = $9c1b37c8edd4ca2b$var$__rest(data, [
        "action_link",
        "email_otp",
        "hashed_token",
        "redirect_to",
        "verification_type"
    ]);
    const properties = {
        action_link: action_link,
        email_otp: email_otp,
        hashed_token: hashed_token,
        redirect_to: redirect_to,
        verification_type: verification_type
    };
    const user = Object.assign({}, rest);
    return {
        data: {
            properties: properties,
            user: user
        },
        error: null
    };
}
function $9c1b37c8edd4ca2b$export$7aed01df6e045e31(data) {
    return data;
}
/**
 * hasSession checks if the response object contains a valid session
 * @param data A response object
 * @returns true if a session is in the response
 */ function $9c1b37c8edd4ca2b$var$hasSession(data) {
    return data.access_token && data.refresh_token && data.expires_in;
}



const $24cb06f66874b0a4$export$9a0f1d0c97ce73ca = [
    'global',
    'local',
    'others'
];



var $b042d08e69f8c3c9$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
class $b042d08e69f8c3c9$export$2e2bcd8739ae039 {
    constructor({ url: url = '', headers: headers = {}, fetch: fetch }){
        this.url = url;
        this.headers = headers;
        this.fetch = (0, $6a62ca85cf697dd5$export$98d92b1aa79f8cc7)(fetch);
        this.mfa = {
            listFactors: this._listFactors.bind(this),
            deleteFactor: this._deleteFactor.bind(this)
        };
    }
    /**
     * Removes a logged-in session.
     * @param jwt A valid, logged-in JWT.
     * @param scope The logout sope.
     */ async signOut(jwt, scope = (0, $24cb06f66874b0a4$export$9a0f1d0c97ce73ca)[0]) {
        if ((0, $24cb06f66874b0a4$export$9a0f1d0c97ce73ca).indexOf(scope) < 0) throw new Error(`@supabase/auth-js: Parameter scope must be one of ${(0, $24cb06f66874b0a4$export$9a0f1d0c97ce73ca).join(', ')}`);
        try {
            await (0, $9c1b37c8edd4ca2b$export$8969b3850ca2cdfd)(this.fetch, 'POST', `${this.url}/logout?scope=${scope}`, {
                headers: this.headers,
                jwt: jwt,
                noResolveJson: true
            });
            return {
                data: null,
                error: null
            };
        } catch (error) {
            if ((0, $b92ec9013174409a$export$cde1786a482f9a1c)(error)) return {
                data: null,
                error: error
            };
            throw error;
        }
    }
    /**
     * Sends an invite link to an email address.
     * @param email The email address of the user.
     * @param options Additional options to be included when inviting.
     */ async inviteUserByEmail(email, options = {}) {
        try {
            return await (0, $9c1b37c8edd4ca2b$export$8969b3850ca2cdfd)(this.fetch, 'POST', `${this.url}/invite`, {
                body: {
                    email: email,
                    data: options.data
                },
                headers: this.headers,
                redirectTo: options.redirectTo,
                xform: (0, $9c1b37c8edd4ca2b$export$e20f488897843593)
            });
        } catch (error) {
            if ((0, $b92ec9013174409a$export$cde1786a482f9a1c)(error)) return {
                data: {
                    user: null
                },
                error: error
            };
            throw error;
        }
    }
    /**
     * Generates email links and OTPs to be sent via a custom email provider.
     * @param email The user's email.
     * @param options.password User password. For signup only.
     * @param options.data Optional user metadata. For signup only.
     * @param options.redirectTo The redirect url which should be appended to the generated link
     */ async generateLink(params) {
        try {
            const { options: options } = params, rest = $b042d08e69f8c3c9$var$__rest(params, [
                "options"
            ]);
            const body = Object.assign(Object.assign({}, rest), options);
            if ('newEmail' in rest) {
                // replace newEmail with new_email in request body
                body.new_email = rest === null || rest === void 0 ? void 0 : rest.newEmail;
                delete body['newEmail'];
            }
            return await (0, $9c1b37c8edd4ca2b$export$8969b3850ca2cdfd)(this.fetch, 'POST', `${this.url}/admin/generate_link`, {
                body: body,
                headers: this.headers,
                xform: (0, $9c1b37c8edd4ca2b$export$f5eaa950605b2146),
                redirectTo: options === null || options === void 0 ? void 0 : options.redirectTo
            });
        } catch (error) {
            if ((0, $b92ec9013174409a$export$cde1786a482f9a1c)(error)) return {
                data: {
                    properties: null,
                    user: null
                },
                error: error
            };
            throw error;
        }
    }
    // User Admin API
    /**
     * Creates a new user.
     * This function should only be called on a server. Never expose your `service_role` key in the browser.
     */ async createUser(attributes) {
        try {
            return await (0, $9c1b37c8edd4ca2b$export$8969b3850ca2cdfd)(this.fetch, 'POST', `${this.url}/admin/users`, {
                body: attributes,
                headers: this.headers,
                xform: (0, $9c1b37c8edd4ca2b$export$e20f488897843593)
            });
        } catch (error) {
            if ((0, $b92ec9013174409a$export$cde1786a482f9a1c)(error)) return {
                data: {
                    user: null
                },
                error: error
            };
            throw error;
        }
    }
    /**
     * Get a list of users.
     *
     * This function should only be called on a server. Never expose your `service_role` key in the browser.
     * @param params An object which supports `page` and `perPage` as numbers, to alter the paginated results.
     */ async listUsers(params) {
        var _a, _b, _c, _d, _e, _f, _g;
        try {
            const pagination = {
                nextPage: null,
                lastPage: 0,
                total: 0
            };
            const response = await (0, $9c1b37c8edd4ca2b$export$8969b3850ca2cdfd)(this.fetch, 'GET', `${this.url}/admin/users`, {
                headers: this.headers,
                noResolveJson: true,
                query: {
                    page: (_b = (_a = params === null || params === void 0 ? void 0 : params.page) === null || _a === void 0 ? void 0 : _a.toString()) !== null && _b !== void 0 ? _b : '',
                    per_page: (_d = (_c = params === null || params === void 0 ? void 0 : params.perPage) === null || _c === void 0 ? void 0 : _c.toString()) !== null && _d !== void 0 ? _d : ''
                },
                xform: (0, $9c1b37c8edd4ca2b$export$7aed01df6e045e31)
            });
            if (response.error) throw response.error;
            const users = await response.json();
            const total = (_e = response.headers.get('x-total-count')) !== null && _e !== void 0 ? _e : 0;
            const links = (_g = (_f = response.headers.get('link')) === null || _f === void 0 ? void 0 : _f.split(',')) !== null && _g !== void 0 ? _g : [];
            if (links.length > 0) {
                links.forEach((link)=>{
                    const page = parseInt(link.split(';')[0].split('=')[1].substring(0, 1));
                    const rel = JSON.parse(link.split(';')[1].split('=')[1]);
                    pagination[`${rel}Page`] = page;
                });
                pagination.total = parseInt(total);
            }
            return {
                data: Object.assign(Object.assign({}, users), pagination),
                error: null
            };
        } catch (error) {
            if ((0, $b92ec9013174409a$export$cde1786a482f9a1c)(error)) return {
                data: {
                    users: []
                },
                error: error
            };
            throw error;
        }
    }
    /**
     * Get user by id.
     *
     * @param uid The user's unique identifier
     *
     * This function should only be called on a server. Never expose your `service_role` key in the browser.
     */ async getUserById(uid) {
        (0, $6a62ca85cf697dd5$export$a4c72ae47296db0c)(uid);
        try {
            return await (0, $9c1b37c8edd4ca2b$export$8969b3850ca2cdfd)(this.fetch, 'GET', `${this.url}/admin/users/${uid}`, {
                headers: this.headers,
                xform: (0, $9c1b37c8edd4ca2b$export$e20f488897843593)
            });
        } catch (error) {
            if ((0, $b92ec9013174409a$export$cde1786a482f9a1c)(error)) return {
                data: {
                    user: null
                },
                error: error
            };
            throw error;
        }
    }
    /**
     * Updates the user data.
     *
     * @param attributes The data you want to update.
     *
     * This function should only be called on a server. Never expose your `service_role` key in the browser.
     */ async updateUserById(uid, attributes) {
        (0, $6a62ca85cf697dd5$export$a4c72ae47296db0c)(uid);
        try {
            return await (0, $9c1b37c8edd4ca2b$export$8969b3850ca2cdfd)(this.fetch, 'PUT', `${this.url}/admin/users/${uid}`, {
                body: attributes,
                headers: this.headers,
                xform: (0, $9c1b37c8edd4ca2b$export$e20f488897843593)
            });
        } catch (error) {
            if ((0, $b92ec9013174409a$export$cde1786a482f9a1c)(error)) return {
                data: {
                    user: null
                },
                error: error
            };
            throw error;
        }
    }
    /**
     * Delete a user. Requires a `service_role` key.
     *
     * @param id The user id you want to remove.
     * @param shouldSoftDelete If true, then the user will be soft-deleted from the auth schema. Soft deletion allows user identification from the hashed user ID but is not reversible.
     * Defaults to false for backward compatibility.
     *
     * This function should only be called on a server. Never expose your `service_role` key in the browser.
     */ async deleteUser(id, shouldSoftDelete = false) {
        (0, $6a62ca85cf697dd5$export$a4c72ae47296db0c)(id);
        try {
            return await (0, $9c1b37c8edd4ca2b$export$8969b3850ca2cdfd)(this.fetch, 'DELETE', `${this.url}/admin/users/${id}`, {
                headers: this.headers,
                body: {
                    should_soft_delete: shouldSoftDelete
                },
                xform: (0, $9c1b37c8edd4ca2b$export$e20f488897843593)
            });
        } catch (error) {
            if ((0, $b92ec9013174409a$export$cde1786a482f9a1c)(error)) return {
                data: {
                    user: null
                },
                error: error
            };
            throw error;
        }
    }
    async _listFactors(params) {
        (0, $6a62ca85cf697dd5$export$a4c72ae47296db0c)(params.userId);
        try {
            const { data: data, error: error } = await (0, $9c1b37c8edd4ca2b$export$8969b3850ca2cdfd)(this.fetch, 'GET', `${this.url}/admin/users/${params.userId}/factors`, {
                headers: this.headers,
                xform: (factors)=>{
                    return {
                        data: {
                            factors: factors
                        },
                        error: null
                    };
                }
            });
            return {
                data: data,
                error: error
            };
        } catch (error) {
            if ((0, $b92ec9013174409a$export$cde1786a482f9a1c)(error)) return {
                data: null,
                error: error
            };
            throw error;
        }
    }
    async _deleteFactor(params) {
        (0, $6a62ca85cf697dd5$export$a4c72ae47296db0c)(params.userId);
        (0, $6a62ca85cf697dd5$export$a4c72ae47296db0c)(params.id);
        try {
            const data = await (0, $9c1b37c8edd4ca2b$export$8969b3850ca2cdfd)(this.fetch, 'DELETE', `${this.url}/admin/users/${params.userId}/factors/${params.id}`, {
                headers: this.headers
            });
            return {
                data: data,
                error: null
            };
        } catch (error) {
            if ((0, $b92ec9013174409a$export$cde1786a482f9a1c)(error)) return {
                data: null,
                error: error
            };
            throw error;
        }
    }
}







/**
 * Returns a localStorage-like object that stores the key-value pairs in
 * memory.
 */ function $75e7b709645121aa$export$d791f66d7e5710cf(store = {}) {
    return {
        getItem: (key)=>{
            return store[key] || null;
        },
        setItem: (key, value)=>{
            store[key] = value;
        },
        removeItem: (key)=>{
            delete store[key];
        }
    };
}


/**
 * https://mathiasbynens.be/notes/globalthis
 */ function $68327ffe4e2befb5$export$ad067ce270531206() {
    if (typeof globalThis === 'object') return;
    try {
        Object.defineProperty(Object.prototype, '__magic__', {
            get: function() {
                return this;
            },
            configurable: true
        });
        // @ts-expect-error 'Allow access to magic'
        __magic__.globalThis = __magic__;
        // @ts-expect-error 'Allow access to magic'
        delete Object.prototype.__magic__;
    } catch (e) {
        if (typeof self !== 'undefined') // @ts-expect-error 'Allow access to globals'
        self.globalThis = self;
    }
}




const $031357f45f79c67e$export$e368aba7747330f2 = {
    /**
     * @experimental
     */ debug: !!(globalThis && (0, $6a62ca85cf697dd5$export$9ec034ee80211814)() && globalThis.localStorage && globalThis.localStorage.getItem('supabase.gotrue-js.locks.debug') === 'true')
};
class $031357f45f79c67e$export$23e9464cc010dff9 extends Error {
    constructor(message){
        super(message);
        this.isAcquireTimeout = true;
    }
}
class $031357f45f79c67e$export$4aa56776043a4631 extends $031357f45f79c67e$export$23e9464cc010dff9 {
}
class $031357f45f79c67e$export$4b982ee840d3d915 extends $031357f45f79c67e$export$23e9464cc010dff9 {
}
async function $031357f45f79c67e$export$f4ff21938fb7af3c(name, acquireTimeout, fn) {
    if ($031357f45f79c67e$export$e368aba7747330f2.debug) console.log('@supabase/gotrue-js: navigatorLock: acquire lock', name, acquireTimeout);
    const abortController = new globalThis.AbortController();
    if (acquireTimeout > 0) setTimeout(()=>{
        abortController.abort();
        if ($031357f45f79c67e$export$e368aba7747330f2.debug) console.log('@supabase/gotrue-js: navigatorLock acquire timed out', name);
    }, acquireTimeout);
    // MDN article: https://developer.mozilla.org/en-US/docs/Web/API/LockManager/request
    // Wrapping navigator.locks.request() with a plain Promise is done as some
    // libraries like zone.js patch the Promise object to track the execution
    // context. However, it appears that most browsers use an internal promise
    // implementation when using the navigator.locks.request() API causing them
    // to lose context and emit confusing log messages or break certain features.
    // This wrapping is believed to help zone.js track the execution context
    // better.
    return await Promise.resolve().then(()=>globalThis.navigator.locks.request(name, acquireTimeout === 0 ? {
            mode: 'exclusive',
            ifAvailable: true
        } : {
            mode: 'exclusive',
            signal: abortController.signal
        }, async (lock)=>{
            if (lock) {
                if ($031357f45f79c67e$export$e368aba7747330f2.debug) console.log('@supabase/gotrue-js: navigatorLock: acquired', name, lock.name);
                try {
                    return await fn();
                } finally{
                    if ($031357f45f79c67e$export$e368aba7747330f2.debug) console.log('@supabase/gotrue-js: navigatorLock: released', name, lock.name);
                }
            } else if (acquireTimeout === 0) {
                if ($031357f45f79c67e$export$e368aba7747330f2.debug) console.log('@supabase/gotrue-js: navigatorLock: not immediately available', name);
                throw new $031357f45f79c67e$export$4aa56776043a4631(`Acquiring an exclusive Navigator LockManager lock "${name}" immediately failed`);
            } else {
                if ($031357f45f79c67e$export$e368aba7747330f2.debug) try {
                    const result = await globalThis.navigator.locks.query();
                    console.log('@supabase/gotrue-js: Navigator LockManager state', JSON.stringify(result, null, '  '));
                } catch (e) {
                    console.warn('@supabase/gotrue-js: Error when querying Navigator LockManager state', e);
                }
                // Browser is not following the Navigator LockManager spec, it
                // returned a null lock when we didn't use ifAvailable. So we can
                // pretend the lock is acquired in the name of backward compatibility
                // and user experience and just run the function.
                console.warn('@supabase/gotrue-js: Navigator LockManager returned a null lock when using #request without ifAvailable set to true, it appears this browser is not following the LockManager spec https://developer.mozilla.org/en-US/docs/Web/API/LockManager/request');
                return await fn();
            }
        }));
}
const $031357f45f79c67e$var$PROCESS_LOCKS = {};
async function $031357f45f79c67e$export$b21ec9b2268372c7(name, acquireTimeout, fn) {
    var _a;
    const previousOperation = (_a = $031357f45f79c67e$var$PROCESS_LOCKS[name]) !== null && _a !== void 0 ? _a : Promise.resolve();
    const currentOperation = Promise.race([
        previousOperation.catch(()=>{
            // ignore error of previous operation that we're waiting to finish
            return null;
        }),
        acquireTimeout >= 0 ? new Promise((_, reject)=>{
            setTimeout(()=>{
                reject(new $031357f45f79c67e$export$4b982ee840d3d915(`Acquring process lock with name "${name}" timed out`));
            }, acquireTimeout);
        }) : null
    ].filter((x)=>x)).catch((e)=>{
        if (e && e.isAcquireTimeout) throw e;
        return null;
    }).then(async ()=>{
        // previous operations finished and we didn't get a race on the acquire
        // timeout, so the current operation can finally start
        return await fn();
    });
    $031357f45f79c67e$var$PROCESS_LOCKS[name] = currentOperation.catch(async (e)=>{
        if (e && e.isAcquireTimeout) {
            // if the current operation timed out, it doesn't mean that the previous
            // operation finished, so we need contnue waiting for it to finish
            await previousOperation;
            return null;
        }
        throw e;
    });
    // finally wait for the current operation to finish successfully, with an
    // error or with an acquire timeout error
    return await currentOperation;
}



(0, $68327ffe4e2befb5$export$ad067ce270531206)(); // Make "globalThis" available
const $8025f0dcbc879582$var$DEFAULT_OPTIONS = {
    url: (0, $2f82a590c21cea7a$export$7fedf552187f0c3d),
    storageKey: (0, $2f82a590c21cea7a$export$86880b4b2e1a2384),
    autoRefreshToken: true,
    persistSession: true,
    detectSessionInUrl: true,
    headers: (0, $2f82a590c21cea7a$export$88a84136db6a4b64),
    flowType: 'implicit',
    debug: false,
    hasCustomAuthorizationHeader: false
};
async function $8025f0dcbc879582$var$lockNoOp(name, acquireTimeout, fn) {
    return await fn();
}
/**
 * Caches JWKS values for all clients created in the same environment. This is
 * especially useful for shared-memory execution environments such as Vercel's
 * Fluid Compute, AWS Lambda or Supabase's Edge Functions. Regardless of how
 * many clients are created, if they share the same storage key they will use
 * the same JWKS cache, significantly speeding up getClaims() with asymmetric
 * JWTs.
 */ const $8025f0dcbc879582$var$GLOBAL_JWKS = {};
class $8025f0dcbc879582$export$2e2bcd8739ae039 {
    /**
     * Create a new client for use in the browser.
     */ constructor(options){
        var _a, _b;
        /**
         * @experimental
         */ this.userStorage = null;
        this.memoryStorage = null;
        this.stateChangeEmitters = new Map();
        this.autoRefreshTicker = null;
        this.visibilityChangedCallback = null;
        this.refreshingDeferred = null;
        /**
         * Keeps track of the async client initialization.
         * When null or not yet resolved the auth state is `unknown`
         * Once resolved the the auth state is known and it's save to call any further client methods.
         * Keep extra care to never reject or throw uncaught errors
         */ this.initializePromise = null;
        this.detectSessionInUrl = true;
        this.hasCustomAuthorizationHeader = false;
        this.suppressGetSessionWarning = false;
        this.lockAcquired = false;
        this.pendingInLock = [];
        /**
         * Used to broadcast state change events to other tabs listening.
         */ this.broadcastChannel = null;
        this.logger = console.log;
        this.instanceID = $8025f0dcbc879582$export$2e2bcd8739ae039.nextInstanceID;
        $8025f0dcbc879582$export$2e2bcd8739ae039.nextInstanceID += 1;
        if (this.instanceID > 0 && (0, $6a62ca85cf697dd5$export$4e09c449d6c407f7)()) console.warn('Multiple GoTrueClient instances detected in the same browser context. It is not an error, but this should be avoided as it may produce undefined behavior when used concurrently under the same storage key.');
        const settings = Object.assign(Object.assign({}, $8025f0dcbc879582$var$DEFAULT_OPTIONS), options);
        this.logDebugMessages = !!settings.debug;
        if (typeof settings.debug === 'function') this.logger = settings.debug;
        this.persistSession = settings.persistSession;
        this.storageKey = settings.storageKey;
        this.autoRefreshToken = settings.autoRefreshToken;
        this.admin = new (0, $b042d08e69f8c3c9$export$2e2bcd8739ae039)({
            url: settings.url,
            headers: settings.headers,
            fetch: settings.fetch
        });
        this.url = settings.url;
        this.headers = settings.headers;
        this.fetch = (0, $6a62ca85cf697dd5$export$98d92b1aa79f8cc7)(settings.fetch);
        this.lock = settings.lock || $8025f0dcbc879582$var$lockNoOp;
        this.detectSessionInUrl = settings.detectSessionInUrl;
        this.flowType = settings.flowType;
        this.hasCustomAuthorizationHeader = settings.hasCustomAuthorizationHeader;
        if (settings.lock) this.lock = settings.lock;
        else if ((0, $6a62ca85cf697dd5$export$4e09c449d6c407f7)() && ((_a = globalThis === null || globalThis === void 0 ? void 0 : globalThis.navigator) === null || _a === void 0 ? void 0 : _a.locks)) this.lock = (0, $031357f45f79c67e$export$f4ff21938fb7af3c);
        else this.lock = $8025f0dcbc879582$var$lockNoOp;
        if (!this.jwks) {
            this.jwks = {
                keys: []
            };
            this.jwks_cached_at = Number.MIN_SAFE_INTEGER;
        }
        this.mfa = {
            verify: this._verify.bind(this),
            enroll: this._enroll.bind(this),
            unenroll: this._unenroll.bind(this),
            challenge: this._challenge.bind(this),
            listFactors: this._listFactors.bind(this),
            challengeAndVerify: this._challengeAndVerify.bind(this),
            getAuthenticatorAssuranceLevel: this._getAuthenticatorAssuranceLevel.bind(this)
        };
        if (this.persistSession) {
            if (settings.storage) this.storage = settings.storage;
            else if ((0, $6a62ca85cf697dd5$export$9ec034ee80211814)()) this.storage = globalThis.localStorage;
            else {
                this.memoryStorage = {};
                this.storage = (0, $75e7b709645121aa$export$d791f66d7e5710cf)(this.memoryStorage);
            }
            if (settings.userStorage) this.userStorage = settings.userStorage;
        } else {
            this.memoryStorage = {};
            this.storage = (0, $75e7b709645121aa$export$d791f66d7e5710cf)(this.memoryStorage);
        }
        if ((0, $6a62ca85cf697dd5$export$4e09c449d6c407f7)() && globalThis.BroadcastChannel && this.persistSession && this.storageKey) {
            try {
                this.broadcastChannel = new globalThis.BroadcastChannel(this.storageKey);
            } catch (e) {
                console.error('Failed to create a new BroadcastChannel, multi-tab state changes will not be available', e);
            }
            (_b = this.broadcastChannel) === null || _b === void 0 || _b.addEventListener('message', async (event)=>{
                this._debug('received broadcast notification from other tab or client', event);
                await this._notifyAllSubscribers(event.data.event, event.data.session, false); // broadcast = false so we don't get an endless loop of messages
            });
        }
        this.initialize();
    }
    /**
     * The JWKS used for verifying asymmetric JWTs
     */ get jwks() {
        var _a, _b;
        return (_b = (_a = $8025f0dcbc879582$var$GLOBAL_JWKS[this.storageKey]) === null || _a === void 0 ? void 0 : _a.jwks) !== null && _b !== void 0 ? _b : {
            keys: []
        };
    }
    set jwks(value) {
        $8025f0dcbc879582$var$GLOBAL_JWKS[this.storageKey] = Object.assign(Object.assign({}, $8025f0dcbc879582$var$GLOBAL_JWKS[this.storageKey]), {
            jwks: value
        });
    }
    get jwks_cached_at() {
        var _a, _b;
        return (_b = (_a = $8025f0dcbc879582$var$GLOBAL_JWKS[this.storageKey]) === null || _a === void 0 ? void 0 : _a.cachedAt) !== null && _b !== void 0 ? _b : Number.MIN_SAFE_INTEGER;
    }
    set jwks_cached_at(value) {
        $8025f0dcbc879582$var$GLOBAL_JWKS[this.storageKey] = Object.assign(Object.assign({}, $8025f0dcbc879582$var$GLOBAL_JWKS[this.storageKey]), {
            cachedAt: value
        });
    }
    _debug(...args) {
        if (this.logDebugMessages) this.logger(`GoTrueClient@${this.instanceID} (${(0, $da0e74438356dc28$export$83d89fbfd8236492)}) ${new Date().toISOString()}`, ...args);
        return this;
    }
    /**
     * Initializes the client session either from the url or from storage.
     * This method is automatically called when instantiating the client, but should also be called
     * manually when checking for an error from an auth redirect (oauth, magiclink, password recovery, etc).
     */ async initialize() {
        if (this.initializePromise) return await this.initializePromise;
        this.initializePromise = (async ()=>{
            return await this._acquireLock(-1, async ()=>{
                return await this._initialize();
            });
        })();
        return await this.initializePromise;
    }
    /**
     * IMPORTANT:
     * 1. Never throw in this method, as it is called from the constructor
     * 2. Never return a session from this method as it would be cached over
     *    the whole lifetime of the client
     */ async _initialize() {
        var _a;
        try {
            const params = (0, $6a62ca85cf697dd5$export$7a29392fb778224c)(window.location.href);
            let callbackUrlType = 'none';
            if (this._isImplicitGrantCallback(params)) callbackUrlType = 'implicit';
            else if (await this._isPKCECallback(params)) callbackUrlType = 'pkce';
            /**
             * Attempt to get the session from the URL only if these conditions are fulfilled
             *
             * Note: If the URL isn't one of the callback url types (implicit or pkce),
             * then there could be an existing session so we don't want to prematurely remove it
             */ if ((0, $6a62ca85cf697dd5$export$4e09c449d6c407f7)() && this.detectSessionInUrl && callbackUrlType !== 'none') {
                const { data: data, error: error } = await this._getSessionFromURL(params, callbackUrlType);
                if (error) {
                    this._debug('#_initialize()', 'error detecting session from URL', error);
                    if ((0, $b92ec9013174409a$export$45edea3999507afd)(error)) {
                        const errorCode = (_a = error.details) === null || _a === void 0 ? void 0 : _a.code;
                        if (errorCode === 'identity_already_exists' || errorCode === 'identity_not_found' || errorCode === 'single_identity_not_deletable') return {
                            error: error
                        };
                    }
                    // failed login attempt via url,
                    // remove old session as in verifyOtp, signUp and signInWith*
                    await this._removeSession();
                    return {
                        error: error
                    };
                }
                const { session: session, redirectType: redirectType } = data;
                this._debug('#_initialize()', 'detected session in URL', session, 'redirect type', redirectType);
                await this._saveSession(session);
                setTimeout(async ()=>{
                    if (redirectType === 'recovery') await this._notifyAllSubscribers('PASSWORD_RECOVERY', session);
                    else await this._notifyAllSubscribers('SIGNED_IN', session);
                }, 0);
                return {
                    error: null
                };
            }
            // no login attempt via callback url try to recover session from storage
            await this._recoverAndRefresh();
            return {
                error: null
            };
        } catch (error) {
            if ((0, $b92ec9013174409a$export$cde1786a482f9a1c)(error)) return {
                error: error
            };
            return {
                error: new (0, $b92ec9013174409a$export$f7559805d4a50078)('Unexpected error during initialization', error)
            };
        } finally{
            await this._handleVisibilityChange();
            this._debug('#_initialize()', 'end');
        }
    }
    /**
     * Creates a new anonymous user.
     *
     * @returns A session where the is_anonymous claim in the access token JWT set to true
     */ async signInAnonymously(credentials) {
        var _a, _b, _c;
        try {
            const res = await (0, $9c1b37c8edd4ca2b$export$8969b3850ca2cdfd)(this.fetch, 'POST', `${this.url}/signup`, {
                headers: this.headers,
                body: {
                    data: (_b = (_a = credentials === null || credentials === void 0 ? void 0 : credentials.options) === null || _a === void 0 ? void 0 : _a.data) !== null && _b !== void 0 ? _b : {},
                    gotrue_meta_security: {
                        captcha_token: (_c = credentials === null || credentials === void 0 ? void 0 : credentials.options) === null || _c === void 0 ? void 0 : _c.captchaToken
                    }
                },
                xform: (0, $9c1b37c8edd4ca2b$export$273fe4673a018c2e)
            });
            const { data: data, error: error } = res;
            if (error || !data) return {
                data: {
                    user: null,
                    session: null
                },
                error: error
            };
            const session = data.session;
            const user = data.user;
            if (data.session) {
                await this._saveSession(data.session);
                await this._notifyAllSubscribers('SIGNED_IN', session);
            }
            return {
                data: {
                    user: user,
                    session: session
                },
                error: null
            };
        } catch (error) {
            if ((0, $b92ec9013174409a$export$cde1786a482f9a1c)(error)) return {
                data: {
                    user: null,
                    session: null
                },
                error: error
            };
            throw error;
        }
    }
    /**
     * Creates a new user.
     *
     * Be aware that if a user account exists in the system you may get back an
     * error message that attempts to hide this information from the user.
     * This method has support for PKCE via email signups. The PKCE flow cannot be used when autoconfirm is enabled.
     *
     * @returns A logged-in session if the server has "autoconfirm" ON
     * @returns A user if the server has "autoconfirm" OFF
     */ async signUp(credentials) {
        var _a, _b, _c;
        try {
            let res;
            if ('email' in credentials) {
                const { email: email, password: password, options: options } = credentials;
                let codeChallenge = null;
                let codeChallengeMethod = null;
                if (this.flowType === 'pkce') [codeChallenge, codeChallengeMethod] = await (0, $6a62ca85cf697dd5$export$81b177cadfcf873c)(this.storage, this.storageKey);
                res = await (0, $9c1b37c8edd4ca2b$export$8969b3850ca2cdfd)(this.fetch, 'POST', `${this.url}/signup`, {
                    headers: this.headers,
                    redirectTo: options === null || options === void 0 ? void 0 : options.emailRedirectTo,
                    body: {
                        email: email,
                        password: password,
                        data: (_a = options === null || options === void 0 ? void 0 : options.data) !== null && _a !== void 0 ? _a : {},
                        gotrue_meta_security: {
                            captcha_token: options === null || options === void 0 ? void 0 : options.captchaToken
                        },
                        code_challenge: codeChallenge,
                        code_challenge_method: codeChallengeMethod
                    },
                    xform: (0, $9c1b37c8edd4ca2b$export$273fe4673a018c2e)
                });
            } else if ('phone' in credentials) {
                const { phone: phone, password: password, options: options } = credentials;
                res = await (0, $9c1b37c8edd4ca2b$export$8969b3850ca2cdfd)(this.fetch, 'POST', `${this.url}/signup`, {
                    headers: this.headers,
                    body: {
                        phone: phone,
                        password: password,
                        data: (_b = options === null || options === void 0 ? void 0 : options.data) !== null && _b !== void 0 ? _b : {},
                        channel: (_c = options === null || options === void 0 ? void 0 : options.channel) !== null && _c !== void 0 ? _c : 'sms',
                        gotrue_meta_security: {
                            captcha_token: options === null || options === void 0 ? void 0 : options.captchaToken
                        }
                    },
                    xform: (0, $9c1b37c8edd4ca2b$export$273fe4673a018c2e)
                });
            } else throw new (0, $b92ec9013174409a$export$9ef583f0381b4cc)('You must provide either an email or phone number and a password');
            const { data: data, error: error } = res;
            if (error || !data) return {
                data: {
                    user: null,
                    session: null
                },
                error: error
            };
            const session = data.session;
            const user = data.user;
            if (data.session) {
                await this._saveSession(data.session);
                await this._notifyAllSubscribers('SIGNED_IN', session);
            }
            return {
                data: {
                    user: user,
                    session: session
                },
                error: null
            };
        } catch (error) {
            if ((0, $b92ec9013174409a$export$cde1786a482f9a1c)(error)) return {
                data: {
                    user: null,
                    session: null
                },
                error: error
            };
            throw error;
        }
    }
    /**
     * Log in an existing user with an email and password or phone and password.
     *
     * Be aware that you may get back an error message that will not distinguish
     * between the cases where the account does not exist or that the
     * email/phone and password combination is wrong or that the account can only
     * be accessed via social login.
     */ async signInWithPassword(credentials) {
        try {
            let res;
            if ('email' in credentials) {
                const { email: email, password: password, options: options } = credentials;
                res = await (0, $9c1b37c8edd4ca2b$export$8969b3850ca2cdfd)(this.fetch, 'POST', `${this.url}/token?grant_type=password`, {
                    headers: this.headers,
                    body: {
                        email: email,
                        password: password,
                        gotrue_meta_security: {
                            captcha_token: options === null || options === void 0 ? void 0 : options.captchaToken
                        }
                    },
                    xform: (0, $9c1b37c8edd4ca2b$export$db83aade1c2922c7)
                });
            } else if ('phone' in credentials) {
                const { phone: phone, password: password, options: options } = credentials;
                res = await (0, $9c1b37c8edd4ca2b$export$8969b3850ca2cdfd)(this.fetch, 'POST', `${this.url}/token?grant_type=password`, {
                    headers: this.headers,
                    body: {
                        phone: phone,
                        password: password,
                        gotrue_meta_security: {
                            captcha_token: options === null || options === void 0 ? void 0 : options.captchaToken
                        }
                    },
                    xform: (0, $9c1b37c8edd4ca2b$export$db83aade1c2922c7)
                });
            } else throw new (0, $b92ec9013174409a$export$9ef583f0381b4cc)('You must provide either an email or phone number and a password');
            const { data: data, error: error } = res;
            if (error) return {
                data: {
                    user: null,
                    session: null
                },
                error: error
            };
            else if (!data || !data.session || !data.user) return {
                data: {
                    user: null,
                    session: null
                },
                error: new (0, $b92ec9013174409a$export$7e277b620449c1b4)()
            };
            if (data.session) {
                await this._saveSession(data.session);
                await this._notifyAllSubscribers('SIGNED_IN', data.session);
            }
            return {
                data: Object.assign({
                    user: data.user,
                    session: data.session
                }, data.weak_password ? {
                    weakPassword: data.weak_password
                } : null),
                error: error
            };
        } catch (error) {
            if ((0, $b92ec9013174409a$export$cde1786a482f9a1c)(error)) return {
                data: {
                    user: null,
                    session: null
                },
                error: error
            };
            throw error;
        }
    }
    /**
     * Log in an existing user via a third-party provider.
     * This method supports the PKCE flow.
     */ async signInWithOAuth(credentials) {
        var _a, _b, _c, _d;
        return await this._handleProviderSignIn(credentials.provider, {
            redirectTo: (_a = credentials.options) === null || _a === void 0 ? void 0 : _a.redirectTo,
            scopes: (_b = credentials.options) === null || _b === void 0 ? void 0 : _b.scopes,
            queryParams: (_c = credentials.options) === null || _c === void 0 ? void 0 : _c.queryParams,
            skipBrowserRedirect: (_d = credentials.options) === null || _d === void 0 ? void 0 : _d.skipBrowserRedirect
        });
    }
    /**
     * Log in an existing user by exchanging an Auth Code issued during the PKCE flow.
     */ async exchangeCodeForSession(authCode) {
        await this.initializePromise;
        return this._acquireLock(-1, async ()=>{
            return this._exchangeCodeForSession(authCode);
        });
    }
    /**
     * Signs in a user by verifying a message signed by the user's private key.
     * Only Solana supported at this time, using the Sign in with Solana standard.
     */ async signInWithWeb3(credentials) {
        const { chain: chain } = credentials;
        if (chain === 'solana') return await this.signInWithSolana(credentials);
        throw new Error(`@supabase/auth-js: Unsupported chain "${chain}"`);
    }
    async signInWithSolana(credentials) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m;
        let message;
        let signature;
        if ('message' in credentials) {
            message = credentials.message;
            signature = credentials.signature;
        } else {
            const { chain: chain, wallet: wallet, statement: statement, options: options } = credentials;
            let resolvedWallet;
            if (!(0, $6a62ca85cf697dd5$export$4e09c449d6c407f7)()) {
                if (typeof wallet !== 'object' || !(options === null || options === void 0 ? void 0 : options.url)) throw new Error('@supabase/auth-js: Both wallet and url must be specified in non-browser environments.');
                resolvedWallet = wallet;
            } else if (typeof wallet === 'object') resolvedWallet = wallet;
            else {
                const windowAny = window;
                if ('solana' in windowAny && typeof windowAny.solana === 'object' && ('signIn' in windowAny.solana && typeof windowAny.solana.signIn === 'function' || 'signMessage' in windowAny.solana && typeof windowAny.solana.signMessage === 'function')) resolvedWallet = windowAny.solana;
                else throw new Error(`@supabase/auth-js: No compatible Solana wallet interface on the window object (window.solana) detected. Make sure the user already has a wallet installed and connected for this app. Prefer passing the wallet interface object directly to signInWithWeb3({ chain: 'solana', wallet: resolvedUserWallet }) instead.`);
            }
            const url = new URL((_a = options === null || options === void 0 ? void 0 : options.url) !== null && _a !== void 0 ? _a : window.location.href);
            if ('signIn' in resolvedWallet && resolvedWallet.signIn) {
                const output = await resolvedWallet.signIn(Object.assign(Object.assign(Object.assign({
                    issuedAt: new Date().toISOString()
                }, options === null || options === void 0 ? void 0 : options.signInWithSolana), {
                    // non-overridable properties
                    version: '1',
                    domain: url.host,
                    uri: url.href
                }), statement ? {
                    statement: statement
                } : null));
                let outputToProcess;
                if (Array.isArray(output) && output[0] && typeof output[0] === 'object') outputToProcess = output[0];
                else if (output && typeof output === 'object' && 'signedMessage' in output && 'signature' in output) outputToProcess = output;
                else throw new Error('@supabase/auth-js: Wallet method signIn() returned unrecognized value');
                if ('signedMessage' in outputToProcess && 'signature' in outputToProcess && (typeof outputToProcess.signedMessage === 'string' || outputToProcess.signedMessage instanceof Uint8Array) && outputToProcess.signature instanceof Uint8Array) {
                    message = typeof outputToProcess.signedMessage === 'string' ? outputToProcess.signedMessage : new TextDecoder().decode(outputToProcess.signedMessage);
                    signature = outputToProcess.signature;
                } else throw new Error('@supabase/auth-js: Wallet method signIn() API returned object without signedMessage and signature fields');
            } else {
                if (!('signMessage' in resolvedWallet) || typeof resolvedWallet.signMessage !== 'function' || !('publicKey' in resolvedWallet) || typeof resolvedWallet !== 'object' || !resolvedWallet.publicKey || !('toBase58' in resolvedWallet.publicKey) || typeof resolvedWallet.publicKey.toBase58 !== 'function') throw new Error('@supabase/auth-js: Wallet does not have a compatible signMessage() and publicKey.toBase58() API');
                message = [
                    `${url.host} wants you to sign in with your Solana account:`,
                    resolvedWallet.publicKey.toBase58(),
                    ...statement ? [
                        '',
                        statement,
                        ''
                    ] : [
                        ''
                    ],
                    'Version: 1',
                    `URI: ${url.href}`,
                    `Issued At: ${(_c = (_b = options === null || options === void 0 ? void 0 : options.signInWithSolana) === null || _b === void 0 ? void 0 : _b.issuedAt) !== null && _c !== void 0 ? _c : new Date().toISOString()}`,
                    ...((_d = options === null || options === void 0 ? void 0 : options.signInWithSolana) === null || _d === void 0 ? void 0 : _d.notBefore) ? [
                        `Not Before: ${options.signInWithSolana.notBefore}`
                    ] : [],
                    ...((_e = options === null || options === void 0 ? void 0 : options.signInWithSolana) === null || _e === void 0 ? void 0 : _e.expirationTime) ? [
                        `Expiration Time: ${options.signInWithSolana.expirationTime}`
                    ] : [],
                    ...((_f = options === null || options === void 0 ? void 0 : options.signInWithSolana) === null || _f === void 0 ? void 0 : _f.chainId) ? [
                        `Chain ID: ${options.signInWithSolana.chainId}`
                    ] : [],
                    ...((_g = options === null || options === void 0 ? void 0 : options.signInWithSolana) === null || _g === void 0 ? void 0 : _g.nonce) ? [
                        `Nonce: ${options.signInWithSolana.nonce}`
                    ] : [],
                    ...((_h = options === null || options === void 0 ? void 0 : options.signInWithSolana) === null || _h === void 0 ? void 0 : _h.requestId) ? [
                        `Request ID: ${options.signInWithSolana.requestId}`
                    ] : [],
                    ...((_k = (_j = options === null || options === void 0 ? void 0 : options.signInWithSolana) === null || _j === void 0 ? void 0 : _j.resources) === null || _k === void 0 ? void 0 : _k.length) ? [
                        'Resources',
                        ...options.signInWithSolana.resources.map((resource)=>`- ${resource}`)
                    ] : []
                ].join('\n');
                const maybeSignature = await resolvedWallet.signMessage(new TextEncoder().encode(message), 'utf8');
                if (!maybeSignature || !(maybeSignature instanceof Uint8Array)) throw new Error('@supabase/auth-js: Wallet signMessage() API returned an recognized value');
                signature = maybeSignature;
            }
        }
        try {
            const { data: data, error: error } = await (0, $9c1b37c8edd4ca2b$export$8969b3850ca2cdfd)(this.fetch, 'POST', `${this.url}/token?grant_type=web3`, {
                headers: this.headers,
                body: Object.assign({
                    chain: 'solana',
                    message: message,
                    signature: (0, $dbf67752838ebc66$export$3f156efe462a835e)(signature)
                }, ((_l = credentials.options) === null || _l === void 0 ? void 0 : _l.captchaToken) ? {
                    gotrue_meta_security: {
                        captcha_token: (_m = credentials.options) === null || _m === void 0 ? void 0 : _m.captchaToken
                    }
                } : null),
                xform: (0, $9c1b37c8edd4ca2b$export$273fe4673a018c2e)
            });
            if (error) throw error;
            if (!data || !data.session || !data.user) return {
                data: {
                    user: null,
                    session: null
                },
                error: new (0, $b92ec9013174409a$export$7e277b620449c1b4)()
            };
            if (data.session) {
                await this._saveSession(data.session);
                await this._notifyAllSubscribers('SIGNED_IN', data.session);
            }
            return {
                data: Object.assign({}, data),
                error: error
            };
        } catch (error) {
            if ((0, $b92ec9013174409a$export$cde1786a482f9a1c)(error)) return {
                data: {
                    user: null,
                    session: null
                },
                error: error
            };
            throw error;
        }
    }
    async _exchangeCodeForSession(authCode) {
        const storageItem = await (0, $6a62ca85cf697dd5$export$ba6fcb7c333d32c0)(this.storage, `${this.storageKey}-code-verifier`);
        const [codeVerifier, redirectType] = (storageItem !== null && storageItem !== void 0 ? storageItem : '').split('/');
        try {
            const { data: data, error: error } = await (0, $9c1b37c8edd4ca2b$export$8969b3850ca2cdfd)(this.fetch, 'POST', `${this.url}/token?grant_type=pkce`, {
                headers: this.headers,
                body: {
                    auth_code: authCode,
                    code_verifier: codeVerifier
                },
                xform: (0, $9c1b37c8edd4ca2b$export$273fe4673a018c2e)
            });
            await (0, $6a62ca85cf697dd5$export$d35c645d585317ec)(this.storage, `${this.storageKey}-code-verifier`);
            if (error) throw error;
            if (!data || !data.session || !data.user) return {
                data: {
                    user: null,
                    session: null,
                    redirectType: null
                },
                error: new (0, $b92ec9013174409a$export$7e277b620449c1b4)()
            };
            if (data.session) {
                await this._saveSession(data.session);
                await this._notifyAllSubscribers('SIGNED_IN', data.session);
            }
            return {
                data: Object.assign(Object.assign({}, data), {
                    redirectType: redirectType !== null && redirectType !== void 0 ? redirectType : null
                }),
                error: error
            };
        } catch (error) {
            if ((0, $b92ec9013174409a$export$cde1786a482f9a1c)(error)) return {
                data: {
                    user: null,
                    session: null,
                    redirectType: null
                },
                error: error
            };
            throw error;
        }
    }
    /**
     * Allows signing in with an OIDC ID token. The authentication provider used
     * should be enabled and configured.
     */ async signInWithIdToken(credentials) {
        try {
            const { options: options, provider: provider, token: token, access_token: access_token, nonce: nonce } = credentials;
            const res = await (0, $9c1b37c8edd4ca2b$export$8969b3850ca2cdfd)(this.fetch, 'POST', `${this.url}/token?grant_type=id_token`, {
                headers: this.headers,
                body: {
                    provider: provider,
                    id_token: token,
                    access_token: access_token,
                    nonce: nonce,
                    gotrue_meta_security: {
                        captcha_token: options === null || options === void 0 ? void 0 : options.captchaToken
                    }
                },
                xform: (0, $9c1b37c8edd4ca2b$export$273fe4673a018c2e)
            });
            const { data: data, error: error } = res;
            if (error) return {
                data: {
                    user: null,
                    session: null
                },
                error: error
            };
            else if (!data || !data.session || !data.user) return {
                data: {
                    user: null,
                    session: null
                },
                error: new (0, $b92ec9013174409a$export$7e277b620449c1b4)()
            };
            if (data.session) {
                await this._saveSession(data.session);
                await this._notifyAllSubscribers('SIGNED_IN', data.session);
            }
            return {
                data: data,
                error: error
            };
        } catch (error) {
            if ((0, $b92ec9013174409a$export$cde1786a482f9a1c)(error)) return {
                data: {
                    user: null,
                    session: null
                },
                error: error
            };
            throw error;
        }
    }
    /**
     * Log in a user using magiclink or a one-time password (OTP).
     *
     * If the `{{ .ConfirmationURL }}` variable is specified in the email template, a magiclink will be sent.
     * If the `{{ .Token }}` variable is specified in the email template, an OTP will be sent.
     * If you're using phone sign-ins, only an OTP will be sent. You won't be able to send a magiclink for phone sign-ins.
     *
     * Be aware that you may get back an error message that will not distinguish
     * between the cases where the account does not exist or, that the account
     * can only be accessed via social login.
     *
     * Do note that you will need to configure a Whatsapp sender on Twilio
     * if you are using phone sign in with the 'whatsapp' channel. The whatsapp
     * channel is not supported on other providers
     * at this time.
     * This method supports PKCE when an email is passed.
     */ async signInWithOtp(credentials) {
        var _a, _b, _c, _d, _e;
        try {
            if ('email' in credentials) {
                const { email: email, options: options } = credentials;
                let codeChallenge = null;
                let codeChallengeMethod = null;
                if (this.flowType === 'pkce') [codeChallenge, codeChallengeMethod] = await (0, $6a62ca85cf697dd5$export$81b177cadfcf873c)(this.storage, this.storageKey);
                const { error: error } = await (0, $9c1b37c8edd4ca2b$export$8969b3850ca2cdfd)(this.fetch, 'POST', `${this.url}/otp`, {
                    headers: this.headers,
                    body: {
                        email: email,
                        data: (_a = options === null || options === void 0 ? void 0 : options.data) !== null && _a !== void 0 ? _a : {},
                        create_user: (_b = options === null || options === void 0 ? void 0 : options.shouldCreateUser) !== null && _b !== void 0 ? _b : true,
                        gotrue_meta_security: {
                            captcha_token: options === null || options === void 0 ? void 0 : options.captchaToken
                        },
                        code_challenge: codeChallenge,
                        code_challenge_method: codeChallengeMethod
                    },
                    redirectTo: options === null || options === void 0 ? void 0 : options.emailRedirectTo
                });
                return {
                    data: {
                        user: null,
                        session: null
                    },
                    error: error
                };
            }
            if ('phone' in credentials) {
                const { phone: phone, options: options } = credentials;
                const { data: data, error: error } = await (0, $9c1b37c8edd4ca2b$export$8969b3850ca2cdfd)(this.fetch, 'POST', `${this.url}/otp`, {
                    headers: this.headers,
                    body: {
                        phone: phone,
                        data: (_c = options === null || options === void 0 ? void 0 : options.data) !== null && _c !== void 0 ? _c : {},
                        create_user: (_d = options === null || options === void 0 ? void 0 : options.shouldCreateUser) !== null && _d !== void 0 ? _d : true,
                        gotrue_meta_security: {
                            captcha_token: options === null || options === void 0 ? void 0 : options.captchaToken
                        },
                        channel: (_e = options === null || options === void 0 ? void 0 : options.channel) !== null && _e !== void 0 ? _e : 'sms'
                    }
                });
                return {
                    data: {
                        user: null,
                        session: null,
                        messageId: data === null || data === void 0 ? void 0 : data.message_id
                    },
                    error: error
                };
            }
            throw new (0, $b92ec9013174409a$export$9ef583f0381b4cc)('You must provide either an email or phone number.');
        } catch (error) {
            if ((0, $b92ec9013174409a$export$cde1786a482f9a1c)(error)) return {
                data: {
                    user: null,
                    session: null
                },
                error: error
            };
            throw error;
        }
    }
    /**
     * Log in a user given a User supplied OTP or TokenHash received through mobile or email.
     */ async verifyOtp(params) {
        var _a, _b;
        try {
            let redirectTo = undefined;
            let captchaToken = undefined;
            if ('options' in params) {
                redirectTo = (_a = params.options) === null || _a === void 0 ? void 0 : _a.redirectTo;
                captchaToken = (_b = params.options) === null || _b === void 0 ? void 0 : _b.captchaToken;
            }
            const { data: data, error: error } = await (0, $9c1b37c8edd4ca2b$export$8969b3850ca2cdfd)(this.fetch, 'POST', `${this.url}/verify`, {
                headers: this.headers,
                body: Object.assign(Object.assign({}, params), {
                    gotrue_meta_security: {
                        captcha_token: captchaToken
                    }
                }),
                redirectTo: redirectTo,
                xform: (0, $9c1b37c8edd4ca2b$export$273fe4673a018c2e)
            });
            if (error) throw error;
            if (!data) throw new Error('An error occurred on token verification.');
            const session = data.session;
            const user = data.user;
            if (session === null || session === void 0 ? void 0 : session.access_token) {
                await this._saveSession(session);
                await this._notifyAllSubscribers(params.type == 'recovery' ? 'PASSWORD_RECOVERY' : 'SIGNED_IN', session);
            }
            return {
                data: {
                    user: user,
                    session: session
                },
                error: null
            };
        } catch (error) {
            if ((0, $b92ec9013174409a$export$cde1786a482f9a1c)(error)) return {
                data: {
                    user: null,
                    session: null
                },
                error: error
            };
            throw error;
        }
    }
    /**
     * Attempts a single-sign on using an enterprise Identity Provider. A
     * successful SSO attempt will redirect the current page to the identity
     * provider authorization page. The redirect URL is implementation and SSO
     * protocol specific.
     *
     * You can use it by providing a SSO domain. Typically you can extract this
     * domain by asking users for their email address. If this domain is
     * registered on the Auth instance the redirect will use that organization's
     * currently active SSO Identity Provider for the login.
     *
     * If you have built an organization-specific login page, you can use the
     * organization's SSO Identity Provider UUID directly instead.
     */ async signInWithSSO(params) {
        var _a, _b, _c;
        try {
            let codeChallenge = null;
            let codeChallengeMethod = null;
            if (this.flowType === 'pkce') [codeChallenge, codeChallengeMethod] = await (0, $6a62ca85cf697dd5$export$81b177cadfcf873c)(this.storage, this.storageKey);
            return await (0, $9c1b37c8edd4ca2b$export$8969b3850ca2cdfd)(this.fetch, 'POST', `${this.url}/sso`, {
                body: Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({}, 'providerId' in params ? {
                    provider_id: params.providerId
                } : null), 'domain' in params ? {
                    domain: params.domain
                } : null), {
                    redirect_to: (_b = (_a = params.options) === null || _a === void 0 ? void 0 : _a.redirectTo) !== null && _b !== void 0 ? _b : undefined
                }), ((_c = params === null || params === void 0 ? void 0 : params.options) === null || _c === void 0 ? void 0 : _c.captchaToken) ? {
                    gotrue_meta_security: {
                        captcha_token: params.options.captchaToken
                    }
                } : null), {
                    skip_http_redirect: true,
                    code_challenge: codeChallenge,
                    code_challenge_method: codeChallengeMethod
                }),
                headers: this.headers,
                xform: (0, $9c1b37c8edd4ca2b$export$b04785c46dcd8f8b)
            });
        } catch (error) {
            if ((0, $b92ec9013174409a$export$cde1786a482f9a1c)(error)) return {
                data: null,
                error: error
            };
            throw error;
        }
    }
    /**
     * Sends a reauthentication OTP to the user's email or phone number.
     * Requires the user to be signed-in.
     */ async reauthenticate() {
        await this.initializePromise;
        return await this._acquireLock(-1, async ()=>{
            return await this._reauthenticate();
        });
    }
    async _reauthenticate() {
        try {
            return await this._useSession(async (result)=>{
                const { data: { session: session }, error: sessionError } = result;
                if (sessionError) throw sessionError;
                if (!session) throw new (0, $b92ec9013174409a$export$403b3fc0d3ad5f0c)();
                const { error: error } = await (0, $9c1b37c8edd4ca2b$export$8969b3850ca2cdfd)(this.fetch, 'GET', `${this.url}/reauthenticate`, {
                    headers: this.headers,
                    jwt: session.access_token
                });
                return {
                    data: {
                        user: null,
                        session: null
                    },
                    error: error
                };
            });
        } catch (error) {
            if ((0, $b92ec9013174409a$export$cde1786a482f9a1c)(error)) return {
                data: {
                    user: null,
                    session: null
                },
                error: error
            };
            throw error;
        }
    }
    /**
     * Resends an existing signup confirmation email, email change email, SMS OTP or phone change OTP.
     */ async resend(credentials) {
        try {
            const endpoint = `${this.url}/resend`;
            if ('email' in credentials) {
                const { email: email, type: type, options: options } = credentials;
                const { error: error } = await (0, $9c1b37c8edd4ca2b$export$8969b3850ca2cdfd)(this.fetch, 'POST', endpoint, {
                    headers: this.headers,
                    body: {
                        email: email,
                        type: type,
                        gotrue_meta_security: {
                            captcha_token: options === null || options === void 0 ? void 0 : options.captchaToken
                        }
                    },
                    redirectTo: options === null || options === void 0 ? void 0 : options.emailRedirectTo
                });
                return {
                    data: {
                        user: null,
                        session: null
                    },
                    error: error
                };
            } else if ('phone' in credentials) {
                const { phone: phone, type: type, options: options } = credentials;
                const { data: data, error: error } = await (0, $9c1b37c8edd4ca2b$export$8969b3850ca2cdfd)(this.fetch, 'POST', endpoint, {
                    headers: this.headers,
                    body: {
                        phone: phone,
                        type: type,
                        gotrue_meta_security: {
                            captcha_token: options === null || options === void 0 ? void 0 : options.captchaToken
                        }
                    }
                });
                return {
                    data: {
                        user: null,
                        session: null,
                        messageId: data === null || data === void 0 ? void 0 : data.message_id
                    },
                    error: error
                };
            }
            throw new (0, $b92ec9013174409a$export$9ef583f0381b4cc)('You must provide either an email or phone number and a type');
        } catch (error) {
            if ((0, $b92ec9013174409a$export$cde1786a482f9a1c)(error)) return {
                data: {
                    user: null,
                    session: null
                },
                error: error
            };
            throw error;
        }
    }
    /**
     * Returns the session, refreshing it if necessary.
     *
     * The session returned can be null if the session is not detected which can happen in the event a user is not signed-in or has logged out.
     *
     * **IMPORTANT:** This method loads values directly from the storage attached
     * to the client. If that storage is based on request cookies for example,
     * the values in it may not be authentic and therefore it's strongly advised
     * against using this method and its results in such circumstances. A warning
     * will be emitted if this is detected. Use {@link #getUser()} instead.
     */ async getSession() {
        await this.initializePromise;
        const result = await this._acquireLock(-1, async ()=>{
            return this._useSession(async (result)=>{
                return result;
            });
        });
        return result;
    }
    /**
     * Acquires a global lock based on the storage key.
     */ async _acquireLock(acquireTimeout, fn) {
        this._debug('#_acquireLock', 'begin', acquireTimeout);
        try {
            if (this.lockAcquired) {
                const last = this.pendingInLock.length ? this.pendingInLock[this.pendingInLock.length - 1] : Promise.resolve();
                const result = (async ()=>{
                    await last;
                    return await fn();
                })();
                this.pendingInLock.push((async ()=>{
                    try {
                        await result;
                    } catch (e) {
                    // we just care if it finished
                    }
                })());
                return result;
            }
            return await this.lock(`lock:${this.storageKey}`, acquireTimeout, async ()=>{
                this._debug('#_acquireLock', 'lock acquired for storage key', this.storageKey);
                try {
                    this.lockAcquired = true;
                    const result = fn();
                    this.pendingInLock.push((async ()=>{
                        try {
                            await result;
                        } catch (e) {
                        // we just care if it finished
                        }
                    })());
                    await result;
                    // keep draining the queue until there's nothing to wait on
                    while(this.pendingInLock.length){
                        const waitOn = [
                            ...this.pendingInLock
                        ];
                        await Promise.all(waitOn);
                        this.pendingInLock.splice(0, waitOn.length);
                    }
                    return await result;
                } finally{
                    this._debug('#_acquireLock', 'lock released for storage key', this.storageKey);
                    this.lockAcquired = false;
                }
            });
        } finally{
            this._debug('#_acquireLock', 'end');
        }
    }
    /**
     * Use instead of {@link #getSession} inside the library. It is
     * semantically usually what you want, as getting a session involves some
     * processing afterwards that requires only one client operating on the
     * session at once across multiple tabs or processes.
     */ async _useSession(fn) {
        this._debug('#_useSession', 'begin');
        try {
            // the use of __loadSession here is the only correct use of the function!
            const result = await this.__loadSession();
            return await fn(result);
        } finally{
            this._debug('#_useSession', 'end');
        }
    }
    /**
     * NEVER USE DIRECTLY!
     *
     * Always use {@link #_useSession}.
     */ async __loadSession() {
        this._debug('#__loadSession()', 'begin');
        if (!this.lockAcquired) this._debug('#__loadSession()', 'used outside of an acquired lock!', new Error().stack);
        try {
            let currentSession = null;
            const maybeSession = await (0, $6a62ca85cf697dd5$export$ba6fcb7c333d32c0)(this.storage, this.storageKey);
            this._debug('#getSession()', 'session from storage', maybeSession);
            if (maybeSession !== null) {
                if (this._isValidSession(maybeSession)) currentSession = maybeSession;
                else {
                    this._debug('#getSession()', 'session from storage is not valid');
                    await this._removeSession();
                }
            }
            if (!currentSession) return {
                data: {
                    session: null
                },
                error: null
            };
            // A session is considered expired before the access token _actually_
            // expires. When the autoRefreshToken option is off (or when the tab is
            // in the background), very eager users of getSession() -- like
            // realtime-js -- might send a valid JWT which will expire by the time it
            // reaches the server.
            const hasExpired = currentSession.expires_at ? currentSession.expires_at * 1000 - Date.now() < (0, $2f82a590c21cea7a$export$a36ad0026e55ac00) : false;
            this._debug('#__loadSession()', `session has${hasExpired ? '' : ' not'} expired`, 'expires_at', currentSession.expires_at);
            if (!hasExpired) {
                if (this.userStorage) {
                    const maybeUser = await (0, $6a62ca85cf697dd5$export$ba6fcb7c333d32c0)(this.userStorage, this.storageKey + '-user');
                    if (maybeUser === null || maybeUser === void 0 ? void 0 : maybeUser.user) currentSession.user = maybeUser.user;
                    else currentSession.user = (0, $6a62ca85cf697dd5$export$52c7f0d8a78626b)();
                }
                if (this.storage.isServer && currentSession.user) {
                    let suppressWarning = this.suppressGetSessionWarning;
                    const proxySession = new Proxy(currentSession, {
                        get: (target, prop, receiver)=>{
                            if (!suppressWarning && prop === 'user') {
                                // only show warning when the user object is being accessed from the server
                                console.warn('Using the user object as returned from supabase.auth.getSession() or from some supabase.auth.onAuthStateChange() events could be insecure! This value comes directly from the storage medium (usually cookies on the server) and may not be authentic. Use supabase.auth.getUser() instead which authenticates the data by contacting the Supabase Auth server.');
                                suppressWarning = true; // keeps this proxy instance from logging additional warnings
                                this.suppressGetSessionWarning = true; // keeps this client's future proxy instances from warning
                            }
                            return Reflect.get(target, prop, receiver);
                        }
                    });
                    currentSession = proxySession;
                }
                return {
                    data: {
                        session: currentSession
                    },
                    error: null
                };
            }
            const { session: session, error: error } = await this._callRefreshToken(currentSession.refresh_token);
            if (error) return {
                data: {
                    session: null
                },
                error: error
            };
            return {
                data: {
                    session: session
                },
                error: null
            };
        } finally{
            this._debug('#__loadSession()', 'end');
        }
    }
    /**
     * Gets the current user details if there is an existing session. This method
     * performs a network request to the Supabase Auth server, so the returned
     * value is authentic and can be used to base authorization rules on.
     *
     * @param jwt Takes in an optional access token JWT. If no JWT is provided, the JWT from the current session is used.
     */ async getUser(jwt) {
        if (jwt) return await this._getUser(jwt);
        await this.initializePromise;
        const result = await this._acquireLock(-1, async ()=>{
            return await this._getUser();
        });
        return result;
    }
    async _getUser(jwt) {
        try {
            if (jwt) return await (0, $9c1b37c8edd4ca2b$export$8969b3850ca2cdfd)(this.fetch, 'GET', `${this.url}/user`, {
                headers: this.headers,
                jwt: jwt,
                xform: (0, $9c1b37c8edd4ca2b$export$e20f488897843593)
            });
            return await this._useSession(async (result)=>{
                var _a, _b, _c;
                const { data: data, error: error } = result;
                if (error) throw error;
                // returns an error if there is no access_token or custom authorization header
                if (!((_a = data.session) === null || _a === void 0 ? void 0 : _a.access_token) && !this.hasCustomAuthorizationHeader) return {
                    data: {
                        user: null
                    },
                    error: new (0, $b92ec9013174409a$export$403b3fc0d3ad5f0c)()
                };
                return await (0, $9c1b37c8edd4ca2b$export$8969b3850ca2cdfd)(this.fetch, 'GET', `${this.url}/user`, {
                    headers: this.headers,
                    jwt: (_c = (_b = data.session) === null || _b === void 0 ? void 0 : _b.access_token) !== null && _c !== void 0 ? _c : undefined,
                    xform: (0, $9c1b37c8edd4ca2b$export$e20f488897843593)
                });
            });
        } catch (error) {
            if ((0, $b92ec9013174409a$export$cde1786a482f9a1c)(error)) {
                if ((0, $b92ec9013174409a$export$3e849aa4db565c1d)(error)) {
                    // JWT contains a `session_id` which does not correspond to an active
                    // session in the database, indicating the user is signed out.
                    await this._removeSession();
                    await (0, $6a62ca85cf697dd5$export$d35c645d585317ec)(this.storage, `${this.storageKey}-code-verifier`);
                }
                return {
                    data: {
                        user: null
                    },
                    error: error
                };
            }
            throw error;
        }
    }
    /**
     * Updates user data for a logged in user.
     */ async updateUser(attributes, options = {}) {
        await this.initializePromise;
        return await this._acquireLock(-1, async ()=>{
            return await this._updateUser(attributes, options);
        });
    }
    async _updateUser(attributes, options = {}) {
        try {
            return await this._useSession(async (result)=>{
                const { data: sessionData, error: sessionError } = result;
                if (sessionError) throw sessionError;
                if (!sessionData.session) throw new (0, $b92ec9013174409a$export$403b3fc0d3ad5f0c)();
                const session = sessionData.session;
                let codeChallenge = null;
                let codeChallengeMethod = null;
                if (this.flowType === 'pkce' && attributes.email != null) [codeChallenge, codeChallengeMethod] = await (0, $6a62ca85cf697dd5$export$81b177cadfcf873c)(this.storage, this.storageKey);
                const { data: data, error: userError } = await (0, $9c1b37c8edd4ca2b$export$8969b3850ca2cdfd)(this.fetch, 'PUT', `${this.url}/user`, {
                    headers: this.headers,
                    redirectTo: options === null || options === void 0 ? void 0 : options.emailRedirectTo,
                    body: Object.assign(Object.assign({}, attributes), {
                        code_challenge: codeChallenge,
                        code_challenge_method: codeChallengeMethod
                    }),
                    jwt: session.access_token,
                    xform: (0, $9c1b37c8edd4ca2b$export$e20f488897843593)
                });
                if (userError) throw userError;
                session.user = data.user;
                await this._saveSession(session);
                await this._notifyAllSubscribers('USER_UPDATED', session);
                return {
                    data: {
                        user: session.user
                    },
                    error: null
                };
            });
        } catch (error) {
            if ((0, $b92ec9013174409a$export$cde1786a482f9a1c)(error)) return {
                data: {
                    user: null
                },
                error: error
            };
            throw error;
        }
    }
    /**
     * Sets the session data from the current session. If the current session is expired, setSession will take care of refreshing it to obtain a new session.
     * If the refresh token or access token in the current session is invalid, an error will be thrown.
     * @param currentSession The current session that minimally contains an access token and refresh token.
     */ async setSession(currentSession) {
        await this.initializePromise;
        return await this._acquireLock(-1, async ()=>{
            return await this._setSession(currentSession);
        });
    }
    async _setSession(currentSession) {
        try {
            if (!currentSession.access_token || !currentSession.refresh_token) throw new (0, $b92ec9013174409a$export$403b3fc0d3ad5f0c)();
            const timeNow = Date.now() / 1000;
            let expiresAt = timeNow;
            let hasExpired = true;
            let session = null;
            const { payload: payload } = (0, $6a62ca85cf697dd5$export$9a62e6c0a30e00bc)(currentSession.access_token);
            if (payload.exp) {
                expiresAt = payload.exp;
                hasExpired = expiresAt <= timeNow;
            }
            if (hasExpired) {
                const { session: refreshedSession, error: error } = await this._callRefreshToken(currentSession.refresh_token);
                if (error) return {
                    data: {
                        user: null,
                        session: null
                    },
                    error: error
                };
                if (!refreshedSession) return {
                    data: {
                        user: null,
                        session: null
                    },
                    error: null
                };
                session = refreshedSession;
            } else {
                const { data: data, error: error } = await this._getUser(currentSession.access_token);
                if (error) throw error;
                session = {
                    access_token: currentSession.access_token,
                    refresh_token: currentSession.refresh_token,
                    user: data.user,
                    token_type: 'bearer',
                    expires_in: expiresAt - timeNow,
                    expires_at: expiresAt
                };
                await this._saveSession(session);
                await this._notifyAllSubscribers('SIGNED_IN', session);
            }
            return {
                data: {
                    user: session.user,
                    session: session
                },
                error: null
            };
        } catch (error) {
            if ((0, $b92ec9013174409a$export$cde1786a482f9a1c)(error)) return {
                data: {
                    session: null,
                    user: null
                },
                error: error
            };
            throw error;
        }
    }
    /**
     * Returns a new session, regardless of expiry status.
     * Takes in an optional current session. If not passed in, then refreshSession() will attempt to retrieve it from getSession().
     * If the current session's refresh token is invalid, an error will be thrown.
     * @param currentSession The current session. If passed in, it must contain a refresh token.
     */ async refreshSession(currentSession) {
        await this.initializePromise;
        return await this._acquireLock(-1, async ()=>{
            return await this._refreshSession(currentSession);
        });
    }
    async _refreshSession(currentSession) {
        try {
            return await this._useSession(async (result)=>{
                var _a;
                if (!currentSession) {
                    const { data: data, error: error } = result;
                    if (error) throw error;
                    currentSession = (_a = data.session) !== null && _a !== void 0 ? _a : undefined;
                }
                if (!(currentSession === null || currentSession === void 0 ? void 0 : currentSession.refresh_token)) throw new (0, $b92ec9013174409a$export$403b3fc0d3ad5f0c)();
                const { session: session, error: error } = await this._callRefreshToken(currentSession.refresh_token);
                if (error) return {
                    data: {
                        user: null,
                        session: null
                    },
                    error: error
                };
                if (!session) return {
                    data: {
                        user: null,
                        session: null
                    },
                    error: null
                };
                return {
                    data: {
                        user: session.user,
                        session: session
                    },
                    error: null
                };
            });
        } catch (error) {
            if ((0, $b92ec9013174409a$export$cde1786a482f9a1c)(error)) return {
                data: {
                    user: null,
                    session: null
                },
                error: error
            };
            throw error;
        }
    }
    /**
     * Gets the session data from a URL string
     */ async _getSessionFromURL(params, callbackUrlType) {
        try {
            if (!(0, $6a62ca85cf697dd5$export$4e09c449d6c407f7)()) throw new (0, $b92ec9013174409a$export$bf5df8e043856ef5)('No browser detected.');
            // If there's an error in the URL, it doesn't matter what flow it is, we just return the error.
            if (params.error || params.error_description || params.error_code) // The error class returned implies that the redirect is from an implicit grant flow
            // but it could also be from a redirect error from a PKCE flow.
            throw new (0, $b92ec9013174409a$export$bf5df8e043856ef5)(params.error_description || 'Error in URL with unspecified error_description', {
                error: params.error || 'unspecified_error',
                code: params.error_code || 'unspecified_code'
            });
            // Checks for mismatches between the flowType initialised in the client and the URL parameters
            switch(callbackUrlType){
                case 'implicit':
                    if (this.flowType === 'pkce') throw new (0, $b92ec9013174409a$export$39583657eb2a7027)('Not a valid PKCE flow url.');
                    break;
                case 'pkce':
                    if (this.flowType === 'implicit') throw new (0, $b92ec9013174409a$export$bf5df8e043856ef5)('Not a valid implicit grant flow url.');
                    break;
                default:
            }
            // Since this is a redirect for PKCE, we attempt to retrieve the code from the URL for the code exchange
            if (callbackUrlType === 'pkce') {
                this._debug('#_initialize()', 'begin', 'is PKCE flow', true);
                if (!params.code) throw new (0, $b92ec9013174409a$export$39583657eb2a7027)('No code detected.');
                const { data: data, error: error } = await this._exchangeCodeForSession(params.code);
                if (error) throw error;
                const url = new URL(window.location.href);
                url.searchParams.delete('code');
                window.history.replaceState(window.history.state, '', url.toString());
                return {
                    data: {
                        session: data.session,
                        redirectType: null
                    },
                    error: null
                };
            }
            const { provider_token: provider_token, provider_refresh_token: provider_refresh_token, access_token: access_token, refresh_token: refresh_token, expires_in: expires_in, expires_at: expires_at, token_type: token_type } = params;
            if (!access_token || !expires_in || !refresh_token || !token_type) throw new (0, $b92ec9013174409a$export$bf5df8e043856ef5)('No session defined in URL');
            const timeNow = Math.round(Date.now() / 1000);
            const expiresIn = parseInt(expires_in);
            let expiresAt = timeNow + expiresIn;
            if (expires_at) expiresAt = parseInt(expires_at);
            const actuallyExpiresIn = expiresAt - timeNow;
            if (actuallyExpiresIn * 1000 <= (0, $2f82a590c21cea7a$export$a4558fee79d6c8ae)) console.warn(`@supabase/gotrue-js: Session as retrieved from URL expires in ${actuallyExpiresIn}s, should have been closer to ${expiresIn}s`);
            const issuedAt = expiresAt - expiresIn;
            if (timeNow - issuedAt >= 120) console.warn('@supabase/gotrue-js: Session as retrieved from URL was issued over 120s ago, URL could be stale', issuedAt, expiresAt, timeNow);
            else if (timeNow - issuedAt < 0) console.warn('@supabase/gotrue-js: Session as retrieved from URL was issued in the future? Check the device clock for skew', issuedAt, expiresAt, timeNow);
            const { data: data, error: error } = await this._getUser(access_token);
            if (error) throw error;
            const session = {
                provider_token: provider_token,
                provider_refresh_token: provider_refresh_token,
                access_token: access_token,
                expires_in: expiresIn,
                expires_at: expiresAt,
                refresh_token: refresh_token,
                token_type: token_type,
                user: data.user
            };
            // Remove tokens from URL
            window.location.hash = '';
            this._debug('#_getSessionFromURL()', 'clearing window.location.hash');
            return {
                data: {
                    session: session,
                    redirectType: params.type
                },
                error: null
            };
        } catch (error) {
            if ((0, $b92ec9013174409a$export$cde1786a482f9a1c)(error)) return {
                data: {
                    session: null,
                    redirectType: null
                },
                error: error
            };
            throw error;
        }
    }
    /**
     * Checks if the current URL contains parameters given by an implicit oauth grant flow (https://www.rfc-editor.org/rfc/rfc6749.html#section-4.2)
     */ _isImplicitGrantCallback(params) {
        return Boolean(params.access_token || params.error_description);
    }
    /**
     * Checks if the current URL and backing storage contain parameters given by a PKCE flow
     */ async _isPKCECallback(params) {
        const currentStorageContent = await (0, $6a62ca85cf697dd5$export$ba6fcb7c333d32c0)(this.storage, `${this.storageKey}-code-verifier`);
        return !!(params.code && currentStorageContent);
    }
    /**
     * Inside a browser context, `signOut()` will remove the logged in user from the browser session and log them out - removing all items from localstorage and then trigger a `"SIGNED_OUT"` event.
     *
     * For server-side management, you can revoke all refresh tokens for a user by passing a user's JWT through to `auth.api.signOut(JWT: string)`.
     * There is no way to revoke a user's access token jwt until it expires. It is recommended to set a shorter expiry on the jwt for this reason.
     *
     * If using `others` scope, no `SIGNED_OUT` event is fired!
     */ async signOut(options = {
        scope: 'global'
    }) {
        await this.initializePromise;
        return await this._acquireLock(-1, async ()=>{
            return await this._signOut(options);
        });
    }
    async _signOut({ scope: scope } = {
        scope: 'global'
    }) {
        return await this._useSession(async (result)=>{
            var _a;
            const { data: data, error: sessionError } = result;
            if (sessionError) return {
                error: sessionError
            };
            const accessToken = (_a = data.session) === null || _a === void 0 ? void 0 : _a.access_token;
            if (accessToken) {
                const { error: error } = await this.admin.signOut(accessToken, scope);
                if (error) {
                    // ignore 404s since user might not exist anymore
                    // ignore 401s since an invalid or expired JWT should sign out the current session
                    if (!((0, $b92ec9013174409a$export$4fe744aeb810d543)(error) && (error.status === 404 || error.status === 401 || error.status === 403))) return {
                        error: error
                    };
                }
            }
            if (scope !== 'others') {
                await this._removeSession();
                await (0, $6a62ca85cf697dd5$export$d35c645d585317ec)(this.storage, `${this.storageKey}-code-verifier`);
            }
            return {
                error: null
            };
        });
    }
    /**
     * Receive a notification every time an auth event happens.
     * @param callback A callback function to be invoked when an auth event happens.
     */ onAuthStateChange(callback) {
        const id = (0, $6a62ca85cf697dd5$export$31b40729666a4ae0)();
        const subscription = {
            id: id,
            callback: callback,
            unsubscribe: ()=>{
                this._debug('#unsubscribe()', 'state change callback with id removed', id);
                this.stateChangeEmitters.delete(id);
            }
        };
        this._debug('#onAuthStateChange()', 'registered callback with id', id);
        this.stateChangeEmitters.set(id, subscription);
        (async ()=>{
            await this.initializePromise;
            await this._acquireLock(-1, async ()=>{
                this._emitInitialSession(id);
            });
        })();
        return {
            data: {
                subscription: subscription
            }
        };
    }
    async _emitInitialSession(id) {
        return await this._useSession(async (result)=>{
            var _a, _b;
            try {
                const { data: { session: session }, error: error } = result;
                if (error) throw error;
                await ((_a = this.stateChangeEmitters.get(id)) === null || _a === void 0 ? void 0 : _a.callback('INITIAL_SESSION', session));
                this._debug('INITIAL_SESSION', 'callback id', id, 'session', session);
            } catch (err) {
                await ((_b = this.stateChangeEmitters.get(id)) === null || _b === void 0 ? void 0 : _b.callback('INITIAL_SESSION', null));
                this._debug('INITIAL_SESSION', 'callback id', id, 'error', err);
                console.error(err);
            }
        });
    }
    /**
     * Sends a password reset request to an email address. This method supports the PKCE flow.
     *
     * @param email The email address of the user.
     * @param options.redirectTo The URL to send the user to after they click the password reset link.
     * @param options.captchaToken Verification token received when the user completes the captcha on the site.
     */ async resetPasswordForEmail(email, options = {}) {
        let codeChallenge = null;
        let codeChallengeMethod = null;
        if (this.flowType === 'pkce') [codeChallenge, codeChallengeMethod] = await (0, $6a62ca85cf697dd5$export$81b177cadfcf873c)(this.storage, this.storageKey, true // isPasswordRecovery
        );
        try {
            return await (0, $9c1b37c8edd4ca2b$export$8969b3850ca2cdfd)(this.fetch, 'POST', `${this.url}/recover`, {
                body: {
                    email: email,
                    code_challenge: codeChallenge,
                    code_challenge_method: codeChallengeMethod,
                    gotrue_meta_security: {
                        captcha_token: options.captchaToken
                    }
                },
                headers: this.headers,
                redirectTo: options.redirectTo
            });
        } catch (error) {
            if ((0, $b92ec9013174409a$export$cde1786a482f9a1c)(error)) return {
                data: null,
                error: error
            };
            throw error;
        }
    }
    /**
     * Gets all the identities linked to a user.
     */ async getUserIdentities() {
        var _a;
        try {
            const { data: data, error: error } = await this.getUser();
            if (error) throw error;
            return {
                data: {
                    identities: (_a = data.user.identities) !== null && _a !== void 0 ? _a : []
                },
                error: null
            };
        } catch (error) {
            if ((0, $b92ec9013174409a$export$cde1786a482f9a1c)(error)) return {
                data: null,
                error: error
            };
            throw error;
        }
    }
    /**
     * Links an oauth identity to an existing user.
     * This method supports the PKCE flow.
     */ async linkIdentity(credentials) {
        var _a;
        try {
            const { data: data, error: error } = await this._useSession(async (result)=>{
                var _a, _b, _c, _d, _e;
                const { data: data, error: error } = result;
                if (error) throw error;
                const url = await this._getUrlForProvider(`${this.url}/user/identities/authorize`, credentials.provider, {
                    redirectTo: (_a = credentials.options) === null || _a === void 0 ? void 0 : _a.redirectTo,
                    scopes: (_b = credentials.options) === null || _b === void 0 ? void 0 : _b.scopes,
                    queryParams: (_c = credentials.options) === null || _c === void 0 ? void 0 : _c.queryParams,
                    skipBrowserRedirect: true
                });
                return await (0, $9c1b37c8edd4ca2b$export$8969b3850ca2cdfd)(this.fetch, 'GET', url, {
                    headers: this.headers,
                    jwt: (_e = (_d = data.session) === null || _d === void 0 ? void 0 : _d.access_token) !== null && _e !== void 0 ? _e : undefined
                });
            });
            if (error) throw error;
            if ((0, $6a62ca85cf697dd5$export$4e09c449d6c407f7)() && !((_a = credentials.options) === null || _a === void 0 ? void 0 : _a.skipBrowserRedirect)) window.location.assign(data === null || data === void 0 ? void 0 : data.url);
            return {
                data: {
                    provider: credentials.provider,
                    url: data === null || data === void 0 ? void 0 : data.url
                },
                error: null
            };
        } catch (error) {
            if ((0, $b92ec9013174409a$export$cde1786a482f9a1c)(error)) return {
                data: {
                    provider: credentials.provider,
                    url: null
                },
                error: error
            };
            throw error;
        }
    }
    /**
     * Unlinks an identity from a user by deleting it. The user will no longer be able to sign in with that identity once it's unlinked.
     */ async unlinkIdentity(identity) {
        try {
            return await this._useSession(async (result)=>{
                var _a, _b;
                const { data: data, error: error } = result;
                if (error) throw error;
                return await (0, $9c1b37c8edd4ca2b$export$8969b3850ca2cdfd)(this.fetch, 'DELETE', `${this.url}/user/identities/${identity.identity_id}`, {
                    headers: this.headers,
                    jwt: (_b = (_a = data.session) === null || _a === void 0 ? void 0 : _a.access_token) !== null && _b !== void 0 ? _b : undefined
                });
            });
        } catch (error) {
            if ((0, $b92ec9013174409a$export$cde1786a482f9a1c)(error)) return {
                data: null,
                error: error
            };
            throw error;
        }
    }
    /**
     * Generates a new JWT.
     * @param refreshToken A valid refresh token that was returned on login.
     */ async _refreshAccessToken(refreshToken) {
        const debugName = `#_refreshAccessToken(${refreshToken.substring(0, 5)}...)`;
        this._debug(debugName, 'begin');
        try {
            const startedAt = Date.now();
            // will attempt to refresh the token with exponential backoff
            return await (0, $6a62ca85cf697dd5$export$9e1b8e833f44ff21)(async (attempt)=>{
                if (attempt > 0) await (0, $6a62ca85cf697dd5$export$e772c8ff12451969)(200 * Math.pow(2, attempt - 1)); // 200, 400, 800, ...
                this._debug(debugName, 'refreshing attempt', attempt);
                return await (0, $9c1b37c8edd4ca2b$export$8969b3850ca2cdfd)(this.fetch, 'POST', `${this.url}/token?grant_type=refresh_token`, {
                    body: {
                        refresh_token: refreshToken
                    },
                    headers: this.headers,
                    xform: (0, $9c1b37c8edd4ca2b$export$273fe4673a018c2e)
                });
            }, (attempt, error)=>{
                const nextBackOffInterval = 200 * Math.pow(2, attempt);
                return error && (0, $b92ec9013174409a$export$a77af358da5fb874)(error) && // retryable only if the request can be sent before the backoff overflows the tick duration
                Date.now() + nextBackOffInterval - startedAt < (0, $2f82a590c21cea7a$export$a4558fee79d6c8ae);
            });
        } catch (error) {
            this._debug(debugName, 'error', error);
            if ((0, $b92ec9013174409a$export$cde1786a482f9a1c)(error)) return {
                data: {
                    session: null,
                    user: null
                },
                error: error
            };
            throw error;
        } finally{
            this._debug(debugName, 'end');
        }
    }
    _isValidSession(maybeSession) {
        const isValidSession = typeof maybeSession === 'object' && maybeSession !== null && 'access_token' in maybeSession && 'refresh_token' in maybeSession && 'expires_at' in maybeSession;
        return isValidSession;
    }
    async _handleProviderSignIn(provider, options) {
        const url = await this._getUrlForProvider(`${this.url}/authorize`, provider, {
            redirectTo: options.redirectTo,
            scopes: options.scopes,
            queryParams: options.queryParams
        });
        this._debug('#_handleProviderSignIn()', 'provider', provider, 'options', options, 'url', url);
        // try to open on the browser
        if ((0, $6a62ca85cf697dd5$export$4e09c449d6c407f7)() && !options.skipBrowserRedirect) window.location.assign(url);
        return {
            data: {
                provider: provider,
                url: url
            },
            error: null
        };
    }
    /**
     * Recovers the session from LocalStorage and refreshes the token
     * Note: this method is async to accommodate for AsyncStorage e.g. in React native.
     */ async _recoverAndRefresh() {
        var _a, _b;
        const debugName = '#_recoverAndRefresh()';
        this._debug(debugName, 'begin');
        try {
            const currentSession = await (0, $6a62ca85cf697dd5$export$ba6fcb7c333d32c0)(this.storage, this.storageKey);
            if (currentSession && this.userStorage) {
                let maybeUser = await (0, $6a62ca85cf697dd5$export$ba6fcb7c333d32c0)(this.userStorage, this.storageKey + '-user');
                if (!this.storage.isServer && Object.is(this.storage, this.userStorage) && !maybeUser) {
                    // storage and userStorage are the same storage medium, for example
                    // window.localStorage if userStorage does not have the user from
                    // storage stored, store it first thereby migrating the user object
                    // from storage -> userStorage
                    maybeUser = {
                        user: currentSession.user
                    };
                    await (0, $6a62ca85cf697dd5$export$e82c36d29078a87f)(this.userStorage, this.storageKey + '-user', maybeUser);
                }
                currentSession.user = (_a = maybeUser === null || maybeUser === void 0 ? void 0 : maybeUser.user) !== null && _a !== void 0 ? _a : (0, $6a62ca85cf697dd5$export$52c7f0d8a78626b)();
            } else if (currentSession && !currentSession.user) // user storage is not set, let's check if it was previously enabled so
            // we bring back the storage as it should be
            {
                if (!currentSession.user) {
                    // test if userStorage was previously enabled and the storage medium was the same, to move the user back under the same key
                    const separateUser = await (0, $6a62ca85cf697dd5$export$ba6fcb7c333d32c0)(this.storage, this.storageKey + '-user');
                    if (separateUser && (separateUser === null || separateUser === void 0 ? void 0 : separateUser.user)) {
                        currentSession.user = separateUser.user;
                        await (0, $6a62ca85cf697dd5$export$d35c645d585317ec)(this.storage, this.storageKey + '-user');
                        await (0, $6a62ca85cf697dd5$export$e82c36d29078a87f)(this.storage, this.storageKey, currentSession);
                    } else currentSession.user = (0, $6a62ca85cf697dd5$export$52c7f0d8a78626b)();
                }
            }
            this._debug(debugName, 'session from storage', currentSession);
            if (!this._isValidSession(currentSession)) {
                this._debug(debugName, 'session is not valid');
                if (currentSession !== null) await this._removeSession();
                return;
            }
            const expiresWithMargin = ((_b = currentSession.expires_at) !== null && _b !== void 0 ? _b : Infinity) * 1000 - Date.now() < (0, $2f82a590c21cea7a$export$a36ad0026e55ac00);
            this._debug(debugName, `session has${expiresWithMargin ? '' : ' not'} expired with margin of ${(0, $2f82a590c21cea7a$export$a36ad0026e55ac00)}s`);
            if (expiresWithMargin) {
                if (this.autoRefreshToken && currentSession.refresh_token) {
                    const { error: error } = await this._callRefreshToken(currentSession.refresh_token);
                    if (error) {
                        console.error(error);
                        if (!(0, $b92ec9013174409a$export$a77af358da5fb874)(error)) {
                            this._debug(debugName, 'refresh failed with a non-retryable error, removing the session', error);
                            await this._removeSession();
                        }
                    }
                }
            } else if (currentSession.user && currentSession.user.__isUserNotAvailableProxy === true) // If we have a proxy user, try to get the real user data
            try {
                const { data: data, error: userError } = await this._getUser(currentSession.access_token);
                if (!userError && (data === null || data === void 0 ? void 0 : data.user)) {
                    currentSession.user = data.user;
                    await this._saveSession(currentSession);
                    await this._notifyAllSubscribers('SIGNED_IN', currentSession);
                } else this._debug(debugName, 'could not get user data, skipping SIGNED_IN notification');
            } catch (getUserError) {
                console.error('Error getting user data:', getUserError);
                this._debug(debugName, 'error getting user data, skipping SIGNED_IN notification', getUserError);
            }
            else // no need to persist currentSession again, as we just loaded it from
            // local storage; persisting it again may overwrite a value saved by
            // another client with access to the same local storage
            await this._notifyAllSubscribers('SIGNED_IN', currentSession);
        } catch (err) {
            this._debug(debugName, 'error', err);
            console.error(err);
            return;
        } finally{
            this._debug(debugName, 'end');
        }
    }
    async _callRefreshToken(refreshToken) {
        var _a, _b;
        if (!refreshToken) throw new (0, $b92ec9013174409a$export$403b3fc0d3ad5f0c)();
        // refreshing is already in progress
        if (this.refreshingDeferred) return this.refreshingDeferred.promise;
        const debugName = `#_callRefreshToken(${refreshToken.substring(0, 5)}...)`;
        this._debug(debugName, 'begin');
        try {
            this.refreshingDeferred = new (0, $6a62ca85cf697dd5$export$85f6557964517f1a)();
            const { data: data, error: error } = await this._refreshAccessToken(refreshToken);
            if (error) throw error;
            if (!data.session) throw new (0, $b92ec9013174409a$export$403b3fc0d3ad5f0c)();
            await this._saveSession(data.session);
            await this._notifyAllSubscribers('TOKEN_REFRESHED', data.session);
            const result = {
                session: data.session,
                error: null
            };
            this.refreshingDeferred.resolve(result);
            return result;
        } catch (error) {
            this._debug(debugName, 'error', error);
            if ((0, $b92ec9013174409a$export$cde1786a482f9a1c)(error)) {
                const result = {
                    session: null,
                    error: error
                };
                if (!(0, $b92ec9013174409a$export$a77af358da5fb874)(error)) await this._removeSession();
                (_a = this.refreshingDeferred) === null || _a === void 0 || _a.resolve(result);
                return result;
            }
            (_b = this.refreshingDeferred) === null || _b === void 0 || _b.reject(error);
            throw error;
        } finally{
            this.refreshingDeferred = null;
            this._debug(debugName, 'end');
        }
    }
    async _notifyAllSubscribers(event, session, broadcast = true) {
        const debugName = `#_notifyAllSubscribers(${event})`;
        this._debug(debugName, 'begin', session, `broadcast = ${broadcast}`);
        try {
            if (this.broadcastChannel && broadcast) this.broadcastChannel.postMessage({
                event: event,
                session: session
            });
            const errors = [];
            const promises = Array.from(this.stateChangeEmitters.values()).map(async (x)=>{
                try {
                    await x.callback(event, session);
                } catch (e) {
                    errors.push(e);
                }
            });
            await Promise.all(promises);
            if (errors.length > 0) {
                for(let i = 0; i < errors.length; i += 1)console.error(errors[i]);
                throw errors[0];
            }
        } finally{
            this._debug(debugName, 'end');
        }
    }
    /**
     * set currentSession and currentUser
     * process to _startAutoRefreshToken if possible
     */ async _saveSession(session) {
        this._debug('#_saveSession()', session);
        // _saveSession is always called whenever a new session has been acquired
        // so we can safely suppress the warning returned by future getSession calls
        this.suppressGetSessionWarning = true;
        // Create a shallow copy to work with, to avoid mutating the original session object if it's used elsewhere
        const sessionToProcess = Object.assign({}, session);
        const userIsProxy = sessionToProcess.user && sessionToProcess.user.__isUserNotAvailableProxy === true;
        if (this.userStorage) {
            if (!userIsProxy && sessionToProcess.user) // If it's a real user object, save it to userStorage.
            await (0, $6a62ca85cf697dd5$export$e82c36d29078a87f)(this.userStorage, this.storageKey + '-user', {
                user: sessionToProcess.user
            });
            else userIsProxy;
            // Prepare the main session data for primary storage: remove the user property before cloning
            // This is important because the original session.user might be the proxy
            const mainSessionData = Object.assign({}, sessionToProcess);
            delete mainSessionData.user; // Remove user (real or proxy) before cloning for main storage
            const clonedMainSessionData = (0, $6a62ca85cf697dd5$export$b7d58db314e0ac27)(mainSessionData);
            await (0, $6a62ca85cf697dd5$export$e82c36d29078a87f)(this.storage, this.storageKey, clonedMainSessionData);
        } else {
            // No userStorage is configured.
            // In this case, session.user should ideally not be a proxy.
            // If it were, structuredClone would fail. This implies an issue elsewhere if user is a proxy here
            const clonedSession = (0, $6a62ca85cf697dd5$export$b7d58db314e0ac27)(sessionToProcess); // sessionToProcess still has its original user property
            await (0, $6a62ca85cf697dd5$export$e82c36d29078a87f)(this.storage, this.storageKey, clonedSession);
        }
    }
    async _removeSession() {
        this._debug('#_removeSession()');
        await (0, $6a62ca85cf697dd5$export$d35c645d585317ec)(this.storage, this.storageKey);
        await (0, $6a62ca85cf697dd5$export$d35c645d585317ec)(this.storage, this.storageKey + '-code-verifier');
        await (0, $6a62ca85cf697dd5$export$d35c645d585317ec)(this.storage, this.storageKey + '-user');
        if (this.userStorage) await (0, $6a62ca85cf697dd5$export$d35c645d585317ec)(this.userStorage, this.storageKey + '-user');
        await this._notifyAllSubscribers('SIGNED_OUT', null);
    }
    /**
     * Removes any registered visibilitychange callback.
     *
     * {@see #startAutoRefresh}
     * {@see #stopAutoRefresh}
     */ _removeVisibilityChangedCallback() {
        this._debug('#_removeVisibilityChangedCallback()');
        const callback = this.visibilityChangedCallback;
        this.visibilityChangedCallback = null;
        try {
            if (callback && (0, $6a62ca85cf697dd5$export$4e09c449d6c407f7)() && (window === null || window === void 0 ? void 0 : window.removeEventListener)) window.removeEventListener('visibilitychange', callback);
        } catch (e) {
            console.error('removing visibilitychange callback failed', e);
        }
    }
    /**
     * This is the private implementation of {@link #startAutoRefresh}. Use this
     * within the library.
     */ async _startAutoRefresh() {
        await this._stopAutoRefresh();
        this._debug('#_startAutoRefresh()');
        const ticker = setInterval(()=>this._autoRefreshTokenTick(), (0, $2f82a590c21cea7a$export$a4558fee79d6c8ae));
        this.autoRefreshTicker = ticker;
        if (ticker && typeof ticker === 'object' && typeof ticker.unref === 'function') // ticker is a NodeJS Timeout object that has an `unref` method
        // https://nodejs.org/api/timers.html#timeoutunref
        // When auto refresh is used in NodeJS (like for testing) the
        // `setInterval` is preventing the process from being marked as
        // finished and tests run endlessly. This can be prevented by calling
        // `unref()` on the returned object.
        ticker.unref();
        else if (typeof Deno !== 'undefined' && typeof Deno.unrefTimer === 'function') // similar like for NodeJS, but with the Deno API
        // https://deno.land/api@latest?unstable&s=Deno.unrefTimer
        // @ts-expect-error TS has no context of Deno
        Deno.unrefTimer(ticker);
        // run the tick immediately, but in the next pass of the event loop so that
        // #_initialize can be allowed to complete without recursively waiting on
        // itself
        setTimeout(async ()=>{
            await this.initializePromise;
            await this._autoRefreshTokenTick();
        }, 0);
    }
    /**
     * This is the private implementation of {@link #stopAutoRefresh}. Use this
     * within the library.
     */ async _stopAutoRefresh() {
        this._debug('#_stopAutoRefresh()');
        const ticker = this.autoRefreshTicker;
        this.autoRefreshTicker = null;
        if (ticker) clearInterval(ticker);
    }
    /**
     * Starts an auto-refresh process in the background. The session is checked
     * every few seconds. Close to the time of expiration a process is started to
     * refresh the session. If refreshing fails it will be retried for as long as
     * necessary.
     *
     * If you set the {@link GoTrueClientOptions#autoRefreshToken} you don't need
     * to call this function, it will be called for you.
     *
     * On browsers the refresh process works only when the tab/window is in the
     * foreground to conserve resources as well as prevent race conditions and
     * flooding auth with requests. If you call this method any managed
     * visibility change callback will be removed and you must manage visibility
     * changes on your own.
     *
     * On non-browser platforms the refresh process works *continuously* in the
     * background, which may not be desirable. You should hook into your
     * platform's foreground indication mechanism and call these methods
     * appropriately to conserve resources.
     *
     * {@see #stopAutoRefresh}
     */ async startAutoRefresh() {
        this._removeVisibilityChangedCallback();
        await this._startAutoRefresh();
    }
    /**
     * Stops an active auto refresh process running in the background (if any).
     *
     * If you call this method any managed visibility change callback will be
     * removed and you must manage visibility changes on your own.
     *
     * See {@link #startAutoRefresh} for more details.
     */ async stopAutoRefresh() {
        this._removeVisibilityChangedCallback();
        await this._stopAutoRefresh();
    }
    /**
     * Runs the auto refresh token tick.
     */ async _autoRefreshTokenTick() {
        this._debug('#_autoRefreshTokenTick()', 'begin');
        try {
            await this._acquireLock(0, async ()=>{
                try {
                    const now = Date.now();
                    try {
                        return await this._useSession(async (result)=>{
                            const { data: { session: session } } = result;
                            if (!session || !session.refresh_token || !session.expires_at) {
                                this._debug('#_autoRefreshTokenTick()', 'no session');
                                return;
                            }
                            // session will expire in this many ticks (or has already expired if <= 0)
                            const expiresInTicks = Math.floor((session.expires_at * 1000 - now) / (0, $2f82a590c21cea7a$export$a4558fee79d6c8ae));
                            this._debug('#_autoRefreshTokenTick()', `access token expires in ${expiresInTicks} ticks, a tick lasts ${(0, $2f82a590c21cea7a$export$a4558fee79d6c8ae)}ms, refresh threshold is ${(0, $2f82a590c21cea7a$export$f20a97df8f5fe223)} ticks`);
                            if (expiresInTicks <= (0, $2f82a590c21cea7a$export$f20a97df8f5fe223)) await this._callRefreshToken(session.refresh_token);
                        });
                    } catch (e) {
                        console.error('Auto refresh tick failed with error. This is likely a transient error.', e);
                    }
                } finally{
                    this._debug('#_autoRefreshTokenTick()', 'end');
                }
            });
        } catch (e) {
            if (e.isAcquireTimeout || e instanceof (0, $031357f45f79c67e$export$23e9464cc010dff9)) this._debug('auto refresh token tick lock not available');
            else throw e;
        }
    }
    /**
     * Registers callbacks on the browser / platform, which in-turn run
     * algorithms when the browser window/tab are in foreground. On non-browser
     * platforms it assumes always foreground.
     */ async _handleVisibilityChange() {
        this._debug('#_handleVisibilityChange()');
        if (!(0, $6a62ca85cf697dd5$export$4e09c449d6c407f7)() || !(window === null || window === void 0 ? void 0 : window.addEventListener)) {
            if (this.autoRefreshToken) // in non-browser environments the refresh token ticker runs always
            this.startAutoRefresh();
            return false;
        }
        try {
            this.visibilityChangedCallback = async ()=>await this._onVisibilityChanged(false);
            window === null || window === void 0 || window.addEventListener('visibilitychange', this.visibilityChangedCallback);
            // now immediately call the visbility changed callback to setup with the
            // current visbility state
            await this._onVisibilityChanged(true); // initial call
        } catch (error) {
            console.error('_handleVisibilityChange', error);
        }
    }
    /**
     * Callback registered with `window.addEventListener('visibilitychange')`.
     */ async _onVisibilityChanged(calledFromInitialize) {
        const methodName = `#_onVisibilityChanged(${calledFromInitialize})`;
        this._debug(methodName, 'visibilityState', document.visibilityState);
        if (document.visibilityState === 'visible') {
            if (this.autoRefreshToken) // in browser environments the refresh token ticker runs only on focused tabs
            // which prevents race conditions
            this._startAutoRefresh();
            if (!calledFromInitialize) {
                // called when the visibility has changed, i.e. the browser
                // transitioned from hidden -> visible so we need to see if the session
                // should be recovered immediately... but to do that we need to acquire
                // the lock first asynchronously
                await this.initializePromise;
                await this._acquireLock(-1, async ()=>{
                    if (document.visibilityState !== 'visible') {
                        this._debug(methodName, 'acquired the lock to recover the session, but the browser visibilityState is no longer visible, aborting');
                        // visibility has changed while waiting for the lock, abort
                        return;
                    }
                    // recover the session
                    await this._recoverAndRefresh();
                });
            }
        } else if (document.visibilityState === 'hidden') {
            if (this.autoRefreshToken) this._stopAutoRefresh();
        }
    }
    /**
     * Generates the relevant login URL for a third-party provider.
     * @param options.redirectTo A URL or mobile address to send the user to after they are confirmed.
     * @param options.scopes A space-separated list of scopes granted to the OAuth application.
     * @param options.queryParams An object of key-value pairs containing query parameters granted to the OAuth application.
     */ async _getUrlForProvider(url, provider, options) {
        const urlParams = [
            `provider=${encodeURIComponent(provider)}`
        ];
        if (options === null || options === void 0 ? void 0 : options.redirectTo) urlParams.push(`redirect_to=${encodeURIComponent(options.redirectTo)}`);
        if (options === null || options === void 0 ? void 0 : options.scopes) urlParams.push(`scopes=${encodeURIComponent(options.scopes)}`);
        if (this.flowType === 'pkce') {
            const [codeChallenge, codeChallengeMethod] = await (0, $6a62ca85cf697dd5$export$81b177cadfcf873c)(this.storage, this.storageKey);
            const flowParams = new URLSearchParams({
                code_challenge: `${encodeURIComponent(codeChallenge)}`,
                code_challenge_method: `${encodeURIComponent(codeChallengeMethod)}`
            });
            urlParams.push(flowParams.toString());
        }
        if (options === null || options === void 0 ? void 0 : options.queryParams) {
            const query = new URLSearchParams(options.queryParams);
            urlParams.push(query.toString());
        }
        if (options === null || options === void 0 ? void 0 : options.skipBrowserRedirect) urlParams.push(`skip_http_redirect=${options.skipBrowserRedirect}`);
        return `${url}?${urlParams.join('&')}`;
    }
    async _unenroll(params) {
        try {
            return await this._useSession(async (result)=>{
                var _a;
                const { data: sessionData, error: sessionError } = result;
                if (sessionError) return {
                    data: null,
                    error: sessionError
                };
                return await (0, $9c1b37c8edd4ca2b$export$8969b3850ca2cdfd)(this.fetch, 'DELETE', `${this.url}/factors/${params.factorId}`, {
                    headers: this.headers,
                    jwt: (_a = sessionData === null || sessionData === void 0 ? void 0 : sessionData.session) === null || _a === void 0 ? void 0 : _a.access_token
                });
            });
        } catch (error) {
            if ((0, $b92ec9013174409a$export$cde1786a482f9a1c)(error)) return {
                data: null,
                error: error
            };
            throw error;
        }
    }
    async _enroll(params) {
        try {
            return await this._useSession(async (result)=>{
                var _a, _b;
                const { data: sessionData, error: sessionError } = result;
                if (sessionError) return {
                    data: null,
                    error: sessionError
                };
                const body = Object.assign({
                    friendly_name: params.friendlyName,
                    factor_type: params.factorType
                }, params.factorType === 'phone' ? {
                    phone: params.phone
                } : {
                    issuer: params.issuer
                });
                const { data: data, error: error } = await (0, $9c1b37c8edd4ca2b$export$8969b3850ca2cdfd)(this.fetch, 'POST', `${this.url}/factors`, {
                    body: body,
                    headers: this.headers,
                    jwt: (_a = sessionData === null || sessionData === void 0 ? void 0 : sessionData.session) === null || _a === void 0 ? void 0 : _a.access_token
                });
                if (error) return {
                    data: null,
                    error: error
                };
                if (params.factorType === 'totp' && ((_b = data === null || data === void 0 ? void 0 : data.totp) === null || _b === void 0 ? void 0 : _b.qr_code)) data.totp.qr_code = `data:image/svg+xml;utf-8,${data.totp.qr_code}`;
                return {
                    data: data,
                    error: null
                };
            });
        } catch (error) {
            if ((0, $b92ec9013174409a$export$cde1786a482f9a1c)(error)) return {
                data: null,
                error: error
            };
            throw error;
        }
    }
    /**
     * {@see GoTrueMFAApi#verify}
     */ async _verify(params) {
        return this._acquireLock(-1, async ()=>{
            try {
                return await this._useSession(async (result)=>{
                    var _a;
                    const { data: sessionData, error: sessionError } = result;
                    if (sessionError) return {
                        data: null,
                        error: sessionError
                    };
                    const { data: data, error: error } = await (0, $9c1b37c8edd4ca2b$export$8969b3850ca2cdfd)(this.fetch, 'POST', `${this.url}/factors/${params.factorId}/verify`, {
                        body: {
                            code: params.code,
                            challenge_id: params.challengeId
                        },
                        headers: this.headers,
                        jwt: (_a = sessionData === null || sessionData === void 0 ? void 0 : sessionData.session) === null || _a === void 0 ? void 0 : _a.access_token
                    });
                    if (error) return {
                        data: null,
                        error: error
                    };
                    await this._saveSession(Object.assign({
                        expires_at: Math.round(Date.now() / 1000) + data.expires_in
                    }, data));
                    await this._notifyAllSubscribers('MFA_CHALLENGE_VERIFIED', data);
                    return {
                        data: data,
                        error: error
                    };
                });
            } catch (error) {
                if ((0, $b92ec9013174409a$export$cde1786a482f9a1c)(error)) return {
                    data: null,
                    error: error
                };
                throw error;
            }
        });
    }
    /**
     * {@see GoTrueMFAApi#challenge}
     */ async _challenge(params) {
        return this._acquireLock(-1, async ()=>{
            try {
                return await this._useSession(async (result)=>{
                    var _a;
                    const { data: sessionData, error: sessionError } = result;
                    if (sessionError) return {
                        data: null,
                        error: sessionError
                    };
                    return await (0, $9c1b37c8edd4ca2b$export$8969b3850ca2cdfd)(this.fetch, 'POST', `${this.url}/factors/${params.factorId}/challenge`, {
                        body: {
                            channel: params.channel
                        },
                        headers: this.headers,
                        jwt: (_a = sessionData === null || sessionData === void 0 ? void 0 : sessionData.session) === null || _a === void 0 ? void 0 : _a.access_token
                    });
                });
            } catch (error) {
                if ((0, $b92ec9013174409a$export$cde1786a482f9a1c)(error)) return {
                    data: null,
                    error: error
                };
                throw error;
            }
        });
    }
    /**
     * {@see GoTrueMFAApi#challengeAndVerify}
     */ async _challengeAndVerify(params) {
        // both _challenge and _verify independently acquire the lock, so no need
        // to acquire it here
        const { data: challengeData, error: challengeError } = await this._challenge({
            factorId: params.factorId
        });
        if (challengeError) return {
            data: null,
            error: challengeError
        };
        return await this._verify({
            factorId: params.factorId,
            challengeId: challengeData.id,
            code: params.code
        });
    }
    /**
     * {@see GoTrueMFAApi#listFactors}
     */ async _listFactors() {
        // use #getUser instead of #_getUser as the former acquires a lock
        const { data: { user: user }, error: userError } = await this.getUser();
        if (userError) return {
            data: null,
            error: userError
        };
        const factors = (user === null || user === void 0 ? void 0 : user.factors) || [];
        const totp = factors.filter((factor)=>factor.factor_type === 'totp' && factor.status === 'verified');
        const phone = factors.filter((factor)=>factor.factor_type === 'phone' && factor.status === 'verified');
        return {
            data: {
                all: factors,
                totp: totp,
                phone: phone
            },
            error: null
        };
    }
    /**
     * {@see GoTrueMFAApi#getAuthenticatorAssuranceLevel}
     */ async _getAuthenticatorAssuranceLevel() {
        return this._acquireLock(-1, async ()=>{
            return await this._useSession(async (result)=>{
                var _a, _b;
                const { data: { session: session }, error: sessionError } = result;
                if (sessionError) return {
                    data: null,
                    error: sessionError
                };
                if (!session) return {
                    data: {
                        currentLevel: null,
                        nextLevel: null,
                        currentAuthenticationMethods: []
                    },
                    error: null
                };
                const { payload: payload } = (0, $6a62ca85cf697dd5$export$9a62e6c0a30e00bc)(session.access_token);
                let currentLevel = null;
                if (payload.aal) currentLevel = payload.aal;
                let nextLevel = currentLevel;
                const verifiedFactors = (_b = (_a = session.user.factors) === null || _a === void 0 ? void 0 : _a.filter((factor)=>factor.status === 'verified')) !== null && _b !== void 0 ? _b : [];
                if (verifiedFactors.length > 0) nextLevel = 'aal2';
                const currentAuthenticationMethods = payload.amr || [];
                return {
                    data: {
                        currentLevel: currentLevel,
                        nextLevel: nextLevel,
                        currentAuthenticationMethods: currentAuthenticationMethods
                    },
                    error: null
                };
            });
        });
    }
    async fetchJwk(kid, jwks = {
        keys: []
    }) {
        // try fetching from the supplied jwks
        let jwk = jwks.keys.find((key)=>key.kid === kid);
        if (jwk) return jwk;
        const now = Date.now();
        // try fetching from cache
        jwk = this.jwks.keys.find((key)=>key.kid === kid);
        // jwk exists and jwks isn't stale
        if (jwk && this.jwks_cached_at + (0, $2f82a590c21cea7a$export$5bd768495200f133) > now) return jwk;
        // jwk isn't cached in memory so we need to fetch it from the well-known endpoint
        const { data: data, error: error } = await (0, $9c1b37c8edd4ca2b$export$8969b3850ca2cdfd)(this.fetch, 'GET', `${this.url}/.well-known/jwks.json`, {
            headers: this.headers
        });
        if (error) throw error;
        if (!data.keys || data.keys.length === 0) return null;
        this.jwks = data;
        this.jwks_cached_at = now;
        // Find the signing key
        jwk = data.keys.find((key)=>key.kid === kid);
        if (!jwk) return null;
        return jwk;
    }
    /**
     * Extracts the JWT claims present in the access token by first verifying the
     * JWT against the server's JSON Web Key Set endpoint
     * `/.well-known/jwks.json` which is often cached, resulting in significantly
     * faster responses. Prefer this method over {@link #getUser} which always
     * sends a request to the Auth server for each JWT.
     *
     * If the project is not using an asymmetric JWT signing key (like ECC or
     * RSA) it always sends a request to the Auth server (similar to {@link
     * #getUser}) to verify the JWT.
     *
     * @param jwt An optional specific JWT you wish to verify, not the one you
     *            can obtain from {@link #getSession}.
     * @param options Various additional options that allow you to customize the
     *                behavior of this method.
     */ async getClaims(jwt, options = {}) {
        try {
            let token = jwt;
            if (!token) {
                const { data: data, error: error } = await this.getSession();
                if (error || !data.session) return {
                    data: null,
                    error: error
                };
                token = data.session.access_token;
            }
            const { header: header, payload: payload, signature: signature, raw: { header: rawHeader, payload: rawPayload } } = (0, $6a62ca85cf697dd5$export$9a62e6c0a30e00bc)(token);
            if (!(options === null || options === void 0 ? void 0 : options.allowExpired)) // Reject expired JWTs should only happen if jwt argument was passed
            (0, $6a62ca85cf697dd5$export$a5850868adeb9253)(payload.exp);
            const signingKey = !header.alg || header.alg.startsWith('HS') || !header.kid || !('crypto' in globalThis && 'subtle' in globalThis.crypto) ? null : await this.fetchJwk(header.kid, (options === null || options === void 0 ? void 0 : options.keys) ? {
                keys: options.keys
            } : options === null || options === void 0 ? void 0 : options.jwks);
            // If symmetric algorithm or WebCrypto API is unavailable, fallback to getUser()
            if (!signingKey) {
                const { error: error } = await this.getUser(token);
                if (error) throw error;
                // getUser succeeds so the claims in the JWT can be trusted
                return {
                    data: {
                        claims: payload,
                        header: header,
                        signature: signature
                    },
                    error: null
                };
            }
            const algorithm = (0, $6a62ca85cf697dd5$export$fa59f625ab60cb91)(header.alg);
            // Convert JWK to CryptoKey
            const publicKey = await crypto.subtle.importKey('jwk', signingKey, algorithm, true, [
                'verify'
            ]);
            // Verify the signature
            const isValid = await crypto.subtle.verify(algorithm, publicKey, signature, (0, $dbf67752838ebc66$export$a098e7b533f96db3)(`${rawHeader}.${rawPayload}`));
            if (!isValid) throw new (0, $b92ec9013174409a$export$d04cb18528f2043e)('Invalid JWT signature');
            // If verification succeeds, decode and return claims
            return {
                data: {
                    claims: payload,
                    header: header,
                    signature: signature
                },
                error: null
            };
        } catch (error) {
            if ((0, $b92ec9013174409a$export$cde1786a482f9a1c)(error)) return {
                data: null,
                error: error
            };
            throw error;
        }
    }
}
$8025f0dcbc879582$export$2e2bcd8739ae039.nextInstanceID = 0;



const $b5e8a3473c3df521$var$AuthAdminApi = (0, $b042d08e69f8c3c9$export$2e2bcd8739ae039);
var $b5e8a3473c3df521$export$2e2bcd8739ae039 = $b5e8a3473c3df521$var$AuthAdminApi;



const $7b62653534e595bb$var$AuthClient = (0, $8025f0dcbc879582$export$2e2bcd8739ae039);
var $7b62653534e595bb$export$2e2bcd8739ae039 = $7b62653534e595bb$var$AuthClient;







class $b6000684d7c6c56c$export$8199a418bb09bd56 extends (0, $7b62653534e595bb$export$2e2bcd8739ae039) {
    constructor(options){
        super(options);
    }
}


var $adb6551412d48394$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
class $adb6551412d48394$export$2e2bcd8739ae039 {
    /**
     * Create a new client for use in the browser.
     * @param supabaseUrl The unique Supabase URL which is supplied when you create a new project in your project dashboard.
     * @param supabaseKey The unique Supabase Key which is supplied when you create a new project in your project dashboard.
     * @param options.db.schema You can switch in between schemas. The schema needs to be on the list of exposed schemas inside Supabase.
     * @param options.auth.autoRefreshToken Set to "true" if you want to automatically refresh the token before expiring.
     * @param options.auth.persistSession Set to "true" if you want to automatically save the user session into local storage.
     * @param options.auth.detectSessionInUrl Set to "true" if you want to automatically detects OAuth grants in the URL and signs in the user.
     * @param options.realtime Options passed along to realtime-js constructor.
     * @param options.global.fetch A custom fetch implementation.
     * @param options.global.headers Any additional headers to send with each network request.
     */ constructor(supabaseUrl, supabaseKey, options){
        var _a, _b, _c;
        this.supabaseUrl = supabaseUrl;
        this.supabaseKey = supabaseKey;
        if (!supabaseUrl) throw new Error('supabaseUrl is required.');
        if (!supabaseKey) throw new Error('supabaseKey is required.');
        const _supabaseUrl = (0, $0c30a5a89f4b6341$export$a896b865588a414b)(supabaseUrl);
        const baseUrl = new URL(_supabaseUrl);
        this.realtimeUrl = new URL('realtime/v1', baseUrl);
        this.realtimeUrl.protocol = this.realtimeUrl.protocol.replace('http', 'ws');
        this.authUrl = new URL('auth/v1', baseUrl);
        this.storageUrl = new URL('storage/v1', baseUrl);
        this.functionsUrl = new URL('functions/v1', baseUrl);
        // default storage key uses the supabase project ref as a namespace
        const defaultStorageKey = `sb-${baseUrl.hostname.split('.')[0]}-auth-token`;
        const DEFAULTS = {
            db: (0, $c0fdce55fc03ad18$export$b31378ae815bea6b),
            realtime: (0, $c0fdce55fc03ad18$export$59685507ca0a3912),
            auth: Object.assign(Object.assign({}, (0, $c0fdce55fc03ad18$export$af122550cc2345b3)), {
                storageKey: defaultStorageKey
            }),
            global: (0, $c0fdce55fc03ad18$export$b63a5c3a2e5becd2)
        };
        const settings = (0, $0c30a5a89f4b6341$export$da186dc3f8eace71)(options !== null && options !== void 0 ? options : {}, DEFAULTS);
        this.storageKey = (_a = settings.auth.storageKey) !== null && _a !== void 0 ? _a : '';
        this.headers = (_b = settings.global.headers) !== null && _b !== void 0 ? _b : {};
        if (!settings.accessToken) this.auth = this._initSupabaseAuthClient((_c = settings.auth) !== null && _c !== void 0 ? _c : {}, this.headers, settings.global.fetch);
        else {
            this.accessToken = settings.accessToken;
            this.auth = new Proxy({}, {
                get: (_, prop)=>{
                    throw new Error(`@supabase/supabase-js: Supabase Client is configured with the accessToken option, accessing supabase.auth.${String(prop)} is not possible`);
                }
            });
        }
        this.fetch = (0, $7846a7cc5c362d25$export$651dd5aef824521f)(supabaseKey, this._getAccessToken.bind(this), settings.global.fetch);
        this.realtime = this._initRealtimeClient(Object.assign({
            headers: this.headers,
            accessToken: this._getAccessToken.bind(this)
        }, settings.realtime));
        this.rest = new (0, $fa98774720195011$export$796f32e2ee984aaa)(new URL('rest/v1', baseUrl).href, {
            headers: this.headers,
            schema: settings.db.schema,
            fetch: this.fetch
        });
        if (!settings.accessToken) this._listenForAuthEvents();
    }
    /**
     * Supabase Functions allows you to deploy and invoke edge functions.
     */ get functions() {
        return new (0, $6f9d627d4ebb0255$export$1d0b400bf8a0fa55)(this.functionsUrl.href, {
            headers: this.headers,
            customFetch: this.fetch
        });
    }
    /**
     * Supabase Storage allows you to manage user-generated content, such as photos or videos.
     */ get storage() {
        return new (0, $3ac213f23af4773a$export$6c85f5032e75eff9)(this.storageUrl.href, this.headers, this.fetch);
    }
    /**
     * Perform a query on a table or a view.
     *
     * @param relation - The table or view name to query
     */ from(relation) {
        return this.rest.from(relation);
    }
    // NOTE: signatures must be kept in sync with PostgrestClient.schema
    /**
     * Select a schema to query or perform an function (rpc) call.
     *
     * The schema needs to be on the list of exposed schemas inside Supabase.
     *
     * @param schema - The schema to query
     */ schema(schema) {
        return this.rest.schema(schema);
    }
    // NOTE: signatures must be kept in sync with PostgrestClient.rpc
    /**
     * Perform a function call.
     *
     * @param fn - The function name to call
     * @param args - The arguments to pass to the function call
     * @param options - Named parameters
     * @param options.head - When set to `true`, `data` will not be returned.
     * Useful if you only need the count.
     * @param options.get - When set to `true`, the function will be called with
     * read-only access mode.
     * @param options.count - Count algorithm to use to count rows returned by the
     * function. Only applicable for [set-returning
     * functions](https://www.postgresql.org/docs/current/functions-srf.html).
     *
     * `"exact"`: Exact but slow count algorithm. Performs a `COUNT(*)` under the
     * hood.
     *
     * `"planned"`: Approximated but fast count algorithm. Uses the Postgres
     * statistics under the hood.
     *
     * `"estimated"`: Uses exact count for low numbers and planned count for high
     * numbers.
     */ rpc(fn, args = {}, options = {}) {
        return this.rest.rpc(fn, args, options);
    }
    /**
     * Creates a Realtime channel with Broadcast, Presence, and Postgres Changes.
     *
     * @param {string} name - The name of the Realtime channel.
     * @param {Object} opts - The options to pass to the Realtime channel.
     *
     */ channel(name, opts = {
        config: {}
    }) {
        return this.realtime.channel(name, opts);
    }
    /**
     * Returns all Realtime channels.
     */ getChannels() {
        return this.realtime.getChannels();
    }
    /**
     * Unsubscribes and removes Realtime channel from Realtime client.
     *
     * @param {RealtimeChannel} channel - The name of the Realtime channel.
     *
     */ removeChannel(channel) {
        return this.realtime.removeChannel(channel);
    }
    /**
     * Unsubscribes and removes all Realtime channels from Realtime client.
     */ removeAllChannels() {
        return this.realtime.removeAllChannels();
    }
    _getAccessToken() {
        var _a, _b;
        return $adb6551412d48394$var$__awaiter(this, void 0, void 0, function*() {
            if (this.accessToken) return yield this.accessToken();
            const { data: data } = yield this.auth.getSession();
            return (_b = (_a = data.session) === null || _a === void 0 ? void 0 : _a.access_token) !== null && _b !== void 0 ? _b : null;
        });
    }
    _initSupabaseAuthClient({ autoRefreshToken: autoRefreshToken, persistSession: persistSession, detectSessionInUrl: detectSessionInUrl, storage: storage, storageKey: storageKey, flowType: flowType, lock: lock, debug: debug }, headers, fetch) {
        const authHeaders = {
            Authorization: `Bearer ${this.supabaseKey}`,
            apikey: `${this.supabaseKey}`
        };
        return new (0, $b6000684d7c6c56c$export$8199a418bb09bd56)({
            url: this.authUrl.href,
            headers: Object.assign(Object.assign({}, authHeaders), headers),
            storageKey: storageKey,
            autoRefreshToken: autoRefreshToken,
            persistSession: persistSession,
            detectSessionInUrl: detectSessionInUrl,
            storage: storage,
            flowType: flowType,
            lock: lock,
            debug: debug,
            fetch: fetch,
            // auth checks if there is a custom authorizaiton header using this flag
            // so it knows whether to return an error when getUser is called with no session
            hasCustomAuthorizationHeader: 'Authorization' in this.headers
        });
    }
    _initRealtimeClient(options) {
        return new (0, $ae049384a7d1c7c8$export$2e2bcd8739ae039)(this.realtimeUrl.href, Object.assign(Object.assign({}, options), {
            params: Object.assign({
                apikey: this.supabaseKey
            }, options === null || options === void 0 ? void 0 : options.params)
        }));
    }
    _listenForAuthEvents() {
        let data = this.auth.onAuthStateChange((event, session)=>{
            this._handleTokenChanged(event, 'CLIENT', session === null || session === void 0 ? void 0 : session.access_token);
        });
        return data;
    }
    _handleTokenChanged(event, source, token) {
        if ((event === 'TOKEN_REFRESHED' || event === 'SIGNED_IN') && this.changedAccessToken !== token) this.changedAccessToken = token;
        else if (event === 'SIGNED_OUT') {
            this.realtime.setAuth();
            if (source == 'STORAGE') this.auth.signOut();
            this.changedAccessToken = undefined;
        }
    }
}






const $99dc17f4947b5a7e$export$5d730b7aed1a3eb0 = (supabaseUrl, supabaseKey, options)=>{
    return new (0, $adb6551412d48394$export$2e2bcd8739ae039)(supabaseUrl, supabaseKey, options);
};


const $6a4ffa14d090abce$var$SUPABASE_URL = "https://aqbuonhljsbcrlrabcaa.supabase.co";
const $6a4ffa14d090abce$var$SUPABASE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImFxYnVvbmhsanNiY3JscmFiY2FhIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTI4MTQwMDEsImV4cCI6MjA2ODM5MDAwMX0.YLFrPsGgZIOYZeEH4vV2Zgl1UOj3r_k0PhFDLUz0acU";
const $6a4ffa14d090abce$export$a0b632a28672d3c0 = (0, $99dc17f4947b5a7e$export$5d730b7aed1a3eb0)($6a4ffa14d090abce$var$SUPABASE_URL, $6a4ffa14d090abce$var$SUPABASE_KEY);
function $6a4ffa14d090abce$export$1617268687ac763c() {
    let id = localStorage.getItem('anonUserId');
    if (!id) {
        id = crypto.randomUUID();
        localStorage.setItem('anonUserId', id);
    }
    return id;
}


const $f9e32f66a2bf4d69$var$TABS = [
    'note',
    'image',
    'link',
    'code'
];
function $f9e32f66a2bf4d69$export$2e2bcd8739ae039() {
    const [visible, setVisible] = (0, $acw62.useState)(false);
    const [scrapType, setType] = (0, $acw62.useState)('note');
    const [formData, setFormData] = (0, $acw62.useState)({
        note: '',
        imageUrl: '',
        imageTitle: '',
        linkUrl: '',
        linkTitle: '',
        codeLang: '',
        codeContent: ''
    });
    const [saving, setSaving] = (0, $acw62.useState)(false);
    const userId = (0, $6a4ffa14d090abce$export$1617268687ac763c)();
    const handleChange = (e)=>{
        const { name: name, value: value } = e.target;
        setFormData((f)=>({
                ...f,
                [name]: value
            }));
    };
    const reset = ()=>{
        setFormData({
            note: '',
            imageUrl: '',
            imageTitle: '',
            linkUrl: '',
            linkTitle: '',
            codeLang: '',
            codeContent: ''
        });
        setType('note');
    };
    const handleSubmit = async (e)=>{
        e.preventDefault();
        if (saving) return;
        setSaving(true);
        const record = {
            user_id: userId,
            type: scrapType,
            content: scrapType === 'note' ? formData.note.trim() : null,
            image_url: scrapType === 'image' ? formData.imageUrl.trim() : null,
            image_title: scrapType === 'image' ? formData.imageTitle.trim() : null,
            url: scrapType === 'link' ? formData.linkUrl.trim() : null,
            title: scrapType === 'link' ? formData.linkTitle.trim() : null,
            language: scrapType === 'code' ? formData.codeLang.trim() : null,
            code: scrapType === 'code' ? formData.codeContent : null
        };
        const { data: data, error: error } = await (0, $6a4ffa14d090abce$export$a0b632a28672d3c0).from('scraps').insert(record);
        if (error) console.error('Insert failed:', error);
        else {
            reset();
            setVisible(false);
        }
        setSaving(false);
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "bg-white border border-gray-200 rounded-lg p-6 shadow mb-8 sticky top-4",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "flex justify-between items-center mb-4",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                        className: "text-xl font-semibold text-gray-900",
                        children: "My Collection"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                        type: "button",
                        onClick: ()=>setVisible((v)=>!v),
                        className: "bg-blue-600 px-4 py-2 rounded text-white hover:bg-blue-700 transition",
                        children: visible ? 'Cancel' : 'Add New'
                    })
                ]
            }),
            visible && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("form", {
                onSubmit: handleSubmit,
                className: "space-y-4",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "flex gap-2",
                        children: $f9e32f66a2bf4d69$var$TABS.map((t)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                type: "button",
                                onClick: ()=>setType(t),
                                className: `px-3 py-1 rounded text-sm font-medium transition ${scrapType === t ? 'bg-blue-600 text-white shadow' : 'bg-gray-200 text-gray-700 hover:bg-gray-300'}`,
                                children: t.charAt(0).toUpperCase() + t.slice(1)
                            }, t))
                    }),
                    scrapType === 'note' && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("textarea", {
                        name: "note",
                        value: formData.note,
                        onChange: handleChange,
                        placeholder: "Your note\u2026",
                        rows: 4,
                        className: "w-full rounded border border-gray-300 p-2 focus:outline-none focus:ring-2 focus:ring-blue-600 text-gray-900"
                    }),
                    scrapType === 'image' && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                name: "imageUrl",
                                value: formData.imageUrl,
                                onChange: handleChange,
                                placeholder: "Image URL",
                                className: "w-full rounded border border-gray-300 p-2 focus:outline-none focus:ring-2 focus:ring-blue-600 text-gray-900"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                name: "imageTitle",
                                value: formData.imageTitle,
                                onChange: handleChange,
                                placeholder: "Image title (optional)",
                                className: "w-full rounded border border-gray-300 p-2 focus:outline-none focus:ring-2 focus:ring-blue-600 text-gray-900"
                            })
                        ]
                    }),
                    scrapType === 'link' && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                name: "linkUrl",
                                value: formData.linkUrl,
                                onChange: handleChange,
                                placeholder: "Link URL",
                                className: "w-full rounded border border-gray-300 p-2 focus:outline-none focus:ring-2 focus:ring-blue-600 text-gray-900"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                name: "linkTitle",
                                value: formData.linkTitle,
                                onChange: handleChange,
                                placeholder: "Link title (optional)",
                                className: "w-full rounded border border-gray-300 p-2 focus:outline-none focus:ring-2 focus:ring-blue-600 text-gray-900"
                            })
                        ]
                    }),
                    scrapType === 'code' && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                name: "codeLang",
                                value: formData.codeLang,
                                onChange: handleChange,
                                placeholder: "Language (e.g. javascript)",
                                className: "w-full rounded border border-gray-300 p-2 focus:outline-none focus:ring-2 focus:ring-blue-600 text-gray-900"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("textarea", {
                                name: "codeContent",
                                value: formData.codeContent,
                                onChange: handleChange,
                                rows: 4,
                                placeholder: "Your code\u2026",
                                className: "w-full rounded border border-gray-300 p-2 focus:outline-none focus:ring-2 focus:ring-blue-600 font-mono text-sm text-gray-900"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                        type: "submit",
                        disabled: saving,
                        className: "w-full bg-emerald-600 hover:bg-emerald-700 disabled:opacity-50 text-white font-semibold py-2 rounded transition",
                        children: saving ? "Saving\u2026" : 'Save Curation'
                    })
                ]
            })
        ]
    });
}




var $acw62 = parcelRequire("acw62");
var $c5fdcdd8d5286ae7$exports = {};
var $8bc9a7bbcf9a2a3b$exports = {};
function $8bc9a7bbcf9a2a3b$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
$8bc9a7bbcf9a2a3b$exports = $8bc9a7bbcf9a2a3b$var$_objectWithoutPropertiesLoose, $8bc9a7bbcf9a2a3b$exports.__esModule = true, $8bc9a7bbcf9a2a3b$exports["default"] = $8bc9a7bbcf9a2a3b$exports;


function $c5fdcdd8d5286ae7$var$_objectWithoutProperties(e, t) {
    if (null == e) return {};
    var o, r, i = $8bc9a7bbcf9a2a3b$exports(e, t);
    if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        for(r = 0; r < n.length; r++)o = n[r], -1 === t.indexOf(o) && ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}
$c5fdcdd8d5286ae7$exports = $c5fdcdd8d5286ae7$var$_objectWithoutProperties, $c5fdcdd8d5286ae7$exports.__esModule = true, $c5fdcdd8d5286ae7$exports["default"] = $c5fdcdd8d5286ae7$exports;


var $b95e04f2d4c66124$exports = {};
var $41f5c206613f56c9$exports = {};
var $1e0ecff44bad0ea1$exports = {};
function $1e0ecff44bad0ea1$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
$1e0ecff44bad0ea1$exports = $1e0ecff44bad0ea1$var$_arrayLikeToArray, $1e0ecff44bad0ea1$exports.__esModule = true, $1e0ecff44bad0ea1$exports["default"] = $1e0ecff44bad0ea1$exports;


function $41f5c206613f56c9$var$_arrayWithoutHoles(r) {
    if (Array.isArray(r)) return $1e0ecff44bad0ea1$exports(r);
}
$41f5c206613f56c9$exports = $41f5c206613f56c9$var$_arrayWithoutHoles, $41f5c206613f56c9$exports.__esModule = true, $41f5c206613f56c9$exports["default"] = $41f5c206613f56c9$exports;


var $cce79e023a3a67e7$exports = {};
function $cce79e023a3a67e7$var$_iterableToArray(r) {
    if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
}
$cce79e023a3a67e7$exports = $cce79e023a3a67e7$var$_iterableToArray, $cce79e023a3a67e7$exports.__esModule = true, $cce79e023a3a67e7$exports["default"] = $cce79e023a3a67e7$exports;


var $51f08ebed50a2438$exports = {};

function $51f08ebed50a2438$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $1e0ecff44bad0ea1$exports(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $1e0ecff44bad0ea1$exports(r, a) : void 0;
    }
}
$51f08ebed50a2438$exports = $51f08ebed50a2438$var$_unsupportedIterableToArray, $51f08ebed50a2438$exports.__esModule = true, $51f08ebed50a2438$exports["default"] = $51f08ebed50a2438$exports;


var $67c90abe6042aecd$exports = {};
function $67c90abe6042aecd$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
$67c90abe6042aecd$exports = $67c90abe6042aecd$var$_nonIterableSpread, $67c90abe6042aecd$exports.__esModule = true, $67c90abe6042aecd$exports["default"] = $67c90abe6042aecd$exports;


function $b95e04f2d4c66124$var$_toConsumableArray(r) {
    return $41f5c206613f56c9$exports(r) || $cce79e023a3a67e7$exports(r) || $51f08ebed50a2438$exports(r) || $67c90abe6042aecd$exports();
}
$b95e04f2d4c66124$exports = $b95e04f2d4c66124$var$_toConsumableArray, $b95e04f2d4c66124$exports.__esModule = true, $b95e04f2d4c66124$exports["default"] = $b95e04f2d4c66124$exports;


var $bb7ca61ce45563c4$exports = {};
var $010f4e0e13c82e16$exports = {};
var $2ef66ab8c52ac1c0$exports = {};
function $2ef66ab8c52ac1c0$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $2ef66ab8c52ac1c0$exports = $2ef66ab8c52ac1c0$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $2ef66ab8c52ac1c0$exports.__esModule = true, $2ef66ab8c52ac1c0$exports["default"] = $2ef66ab8c52ac1c0$exports, $2ef66ab8c52ac1c0$var$_typeof(o);
}
$2ef66ab8c52ac1c0$exports = $2ef66ab8c52ac1c0$var$_typeof, $2ef66ab8c52ac1c0$exports.__esModule = true, $2ef66ab8c52ac1c0$exports["default"] = $2ef66ab8c52ac1c0$exports;


var $010f4e0e13c82e16$var$_typeof = $2ef66ab8c52ac1c0$exports.default;
var $b77c8068776c2a21$exports = {};

var $b77c8068776c2a21$var$_typeof = $2ef66ab8c52ac1c0$exports.default;
function $b77c8068776c2a21$var$toPrimitive(t, r) {
    if ("object" != $b77c8068776c2a21$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $b77c8068776c2a21$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
$b77c8068776c2a21$exports = $b77c8068776c2a21$var$toPrimitive, $b77c8068776c2a21$exports.__esModule = true, $b77c8068776c2a21$exports["default"] = $b77c8068776c2a21$exports;


function $010f4e0e13c82e16$var$toPropertyKey(t) {
    var i = $b77c8068776c2a21$exports(t, "string");
    return "symbol" == $010f4e0e13c82e16$var$_typeof(i) ? i : i + "";
}
$010f4e0e13c82e16$exports = $010f4e0e13c82e16$var$toPropertyKey, $010f4e0e13c82e16$exports.__esModule = true, $010f4e0e13c82e16$exports["default"] = $010f4e0e13c82e16$exports;


function $bb7ca61ce45563c4$var$_defineProperty(e, r, t) {
    return (r = $010f4e0e13c82e16$exports(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
$bb7ca61ce45563c4$exports = $bb7ca61ce45563c4$var$_defineProperty, $bb7ca61ce45563c4$exports.__esModule = true, $bb7ca61ce45563c4$exports["default"] = $bb7ca61ce45563c4$exports;



var $acw62 = parcelRequire("acw62");
var $27ab08c24269de64$exports = {};
function $27ab08c24269de64$var$_extends() {
    return $27ab08c24269de64$exports = $27ab08c24269de64$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $27ab08c24269de64$exports.__esModule = true, $27ab08c24269de64$exports["default"] = $27ab08c24269de64$exports, $27ab08c24269de64$var$_extends.apply(null, arguments);
}
$27ab08c24269de64$exports = $27ab08c24269de64$var$_extends, $27ab08c24269de64$exports.__esModule = true, $27ab08c24269de64$exports["default"] = $27ab08c24269de64$exports;




var $acw62 = parcelRequire("acw62");
function $35b076aa3d5f5fcb$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $35b076aa3d5f5fcb$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $35b076aa3d5f5fcb$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($bb7ca61ce45563c4$exports)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $35b076aa3d5f5fcb$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
// Get all possible permutations of all power sets
//
// Super simple, non-algorithmic solution since the
// number of class names will not be greater than 4
function $35b076aa3d5f5fcb$var$powerSetPermutations(arr) {
    var arrLength = arr.length;
    if (arrLength === 0 || arrLength === 1) return arr;
    if (arrLength === 2) // prettier-ignore
    return [
        arr[0],
        arr[1],
        "".concat(arr[0], ".").concat(arr[1]),
        "".concat(arr[1], ".").concat(arr[0])
    ];
    if (arrLength === 3) return [
        arr[0],
        arr[1],
        arr[2],
        "".concat(arr[0], ".").concat(arr[1]),
        "".concat(arr[0], ".").concat(arr[2]),
        "".concat(arr[1], ".").concat(arr[0]),
        "".concat(arr[1], ".").concat(arr[2]),
        "".concat(arr[2], ".").concat(arr[0]),
        "".concat(arr[2], ".").concat(arr[1]),
        "".concat(arr[0], ".").concat(arr[1], ".").concat(arr[2]),
        "".concat(arr[0], ".").concat(arr[2], ".").concat(arr[1]),
        "".concat(arr[1], ".").concat(arr[0], ".").concat(arr[2]),
        "".concat(arr[1], ".").concat(arr[2], ".").concat(arr[0]),
        "".concat(arr[2], ".").concat(arr[0], ".").concat(arr[1]),
        "".concat(arr[2], ".").concat(arr[1], ".").concat(arr[0])
    ];
    if (arrLength >= 4) // Currently does not support more than 4 extra
    // class names (after `.token` has been removed)
    return [
        arr[0],
        arr[1],
        arr[2],
        arr[3],
        "".concat(arr[0], ".").concat(arr[1]),
        "".concat(arr[0], ".").concat(arr[2]),
        "".concat(arr[0], ".").concat(arr[3]),
        "".concat(arr[1], ".").concat(arr[0]),
        "".concat(arr[1], ".").concat(arr[2]),
        "".concat(arr[1], ".").concat(arr[3]),
        "".concat(arr[2], ".").concat(arr[0]),
        "".concat(arr[2], ".").concat(arr[1]),
        "".concat(arr[2], ".").concat(arr[3]),
        "".concat(arr[3], ".").concat(arr[0]),
        "".concat(arr[3], ".").concat(arr[1]),
        "".concat(arr[3], ".").concat(arr[2]),
        "".concat(arr[0], ".").concat(arr[1], ".").concat(arr[2]),
        "".concat(arr[0], ".").concat(arr[1], ".").concat(arr[3]),
        "".concat(arr[0], ".").concat(arr[2], ".").concat(arr[1]),
        "".concat(arr[0], ".").concat(arr[2], ".").concat(arr[3]),
        "".concat(arr[0], ".").concat(arr[3], ".").concat(arr[1]),
        "".concat(arr[0], ".").concat(arr[3], ".").concat(arr[2]),
        "".concat(arr[1], ".").concat(arr[0], ".").concat(arr[2]),
        "".concat(arr[1], ".").concat(arr[0], ".").concat(arr[3]),
        "".concat(arr[1], ".").concat(arr[2], ".").concat(arr[0]),
        "".concat(arr[1], ".").concat(arr[2], ".").concat(arr[3]),
        "".concat(arr[1], ".").concat(arr[3], ".").concat(arr[0]),
        "".concat(arr[1], ".").concat(arr[3], ".").concat(arr[2]),
        "".concat(arr[2], ".").concat(arr[0], ".").concat(arr[1]),
        "".concat(arr[2], ".").concat(arr[0], ".").concat(arr[3]),
        "".concat(arr[2], ".").concat(arr[1], ".").concat(arr[0]),
        "".concat(arr[2], ".").concat(arr[1], ".").concat(arr[3]),
        "".concat(arr[2], ".").concat(arr[3], ".").concat(arr[0]),
        "".concat(arr[2], ".").concat(arr[3], ".").concat(arr[1]),
        "".concat(arr[3], ".").concat(arr[0], ".").concat(arr[1]),
        "".concat(arr[3], ".").concat(arr[0], ".").concat(arr[2]),
        "".concat(arr[3], ".").concat(arr[1], ".").concat(arr[0]),
        "".concat(arr[3], ".").concat(arr[1], ".").concat(arr[2]),
        "".concat(arr[3], ".").concat(arr[2], ".").concat(arr[0]),
        "".concat(arr[3], ".").concat(arr[2], ".").concat(arr[1]),
        "".concat(arr[0], ".").concat(arr[1], ".").concat(arr[2], ".").concat(arr[3]),
        "".concat(arr[0], ".").concat(arr[1], ".").concat(arr[3], ".").concat(arr[2]),
        "".concat(arr[0], ".").concat(arr[2], ".").concat(arr[1], ".").concat(arr[3]),
        "".concat(arr[0], ".").concat(arr[2], ".").concat(arr[3], ".").concat(arr[1]),
        "".concat(arr[0], ".").concat(arr[3], ".").concat(arr[1], ".").concat(arr[2]),
        "".concat(arr[0], ".").concat(arr[3], ".").concat(arr[2], ".").concat(arr[1]),
        "".concat(arr[1], ".").concat(arr[0], ".").concat(arr[2], ".").concat(arr[3]),
        "".concat(arr[1], ".").concat(arr[0], ".").concat(arr[3], ".").concat(arr[2]),
        "".concat(arr[1], ".").concat(arr[2], ".").concat(arr[0], ".").concat(arr[3]),
        "".concat(arr[1], ".").concat(arr[2], ".").concat(arr[3], ".").concat(arr[0]),
        "".concat(arr[1], ".").concat(arr[3], ".").concat(arr[0], ".").concat(arr[2]),
        "".concat(arr[1], ".").concat(arr[3], ".").concat(arr[2], ".").concat(arr[0]),
        "".concat(arr[2], ".").concat(arr[0], ".").concat(arr[1], ".").concat(arr[3]),
        "".concat(arr[2], ".").concat(arr[0], ".").concat(arr[3], ".").concat(arr[1]),
        "".concat(arr[2], ".").concat(arr[1], ".").concat(arr[0], ".").concat(arr[3]),
        "".concat(arr[2], ".").concat(arr[1], ".").concat(arr[3], ".").concat(arr[0]),
        "".concat(arr[2], ".").concat(arr[3], ".").concat(arr[0], ".").concat(arr[1]),
        "".concat(arr[2], ".").concat(arr[3], ".").concat(arr[1], ".").concat(arr[0]),
        "".concat(arr[3], ".").concat(arr[0], ".").concat(arr[1], ".").concat(arr[2]),
        "".concat(arr[3], ".").concat(arr[0], ".").concat(arr[2], ".").concat(arr[1]),
        "".concat(arr[3], ".").concat(arr[1], ".").concat(arr[0], ".").concat(arr[2]),
        "".concat(arr[3], ".").concat(arr[1], ".").concat(arr[2], ".").concat(arr[0]),
        "".concat(arr[3], ".").concat(arr[2], ".").concat(arr[0], ".").concat(arr[1]),
        "".concat(arr[3], ".").concat(arr[2], ".").concat(arr[1], ".").concat(arr[0])
    ];
}
var $35b076aa3d5f5fcb$var$classNameCombinations = {};
function $35b076aa3d5f5fcb$var$getClassNameCombinations(classNames) {
    if (classNames.length === 0 || classNames.length === 1) return classNames;
    var key = classNames.join('.');
    if (!$35b076aa3d5f5fcb$var$classNameCombinations[key]) $35b076aa3d5f5fcb$var$classNameCombinations[key] = $35b076aa3d5f5fcb$var$powerSetPermutations(classNames);
    return $35b076aa3d5f5fcb$var$classNameCombinations[key];
}
function $35b076aa3d5f5fcb$export$28a8c6cb018dfadc(classNames) {
    var elementStyle = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var stylesheet = arguments.length > 2 ? arguments[2] : undefined;
    var nonTokenClassNames = classNames.filter(function(className) {
        return className !== 'token';
    });
    var classNamesCombinations = $35b076aa3d5f5fcb$var$getClassNameCombinations(nonTokenClassNames);
    return classNamesCombinations.reduce(function(styleObject, className) {
        return $35b076aa3d5f5fcb$var$_objectSpread($35b076aa3d5f5fcb$var$_objectSpread({}, styleObject), stylesheet[className]);
    }, elementStyle);
}
function $35b076aa3d5f5fcb$export$d0f1f443a3b7b5(classNames) {
    return classNames.join(' ');
}
function $35b076aa3d5f5fcb$export$86fb3c3a621e8db6(stylesheet, useInlineStyles) {
    var childrenCount = 0;
    return function(children) {
        childrenCount += 1;
        return children.map(function(child, i) {
            return $35b076aa3d5f5fcb$export$2e2bcd8739ae039({
                node: child,
                stylesheet: stylesheet,
                useInlineStyles: useInlineStyles,
                key: "code-segment-".concat(childrenCount, "-").concat(i)
            });
        });
    };
}
function $35b076aa3d5f5fcb$export$2e2bcd8739ae039(_ref) {
    var node = _ref.node, stylesheet = _ref.stylesheet, _ref$style = _ref.style, style = _ref$style === void 0 ? {} : _ref$style, useInlineStyles = _ref.useInlineStyles, key = _ref.key;
    var properties = node.properties, type = node.type, TagName = node.tagName, value = node.value;
    if (type === 'text') return value;
    else if (TagName) {
        var childrenCreator = $35b076aa3d5f5fcb$export$86fb3c3a621e8db6(stylesheet, useInlineStyles);
        var props;
        if (!useInlineStyles) props = $35b076aa3d5f5fcb$var$_objectSpread($35b076aa3d5f5fcb$var$_objectSpread({}, properties), {}, {
            className: $35b076aa3d5f5fcb$export$d0f1f443a3b7b5(properties.className)
        });
        else {
            var allStylesheetSelectors = Object.keys(stylesheet).reduce(function(classes, selector) {
                selector.split('.').forEach(function(className) {
                    if (!classes.includes(className)) classes.push(className);
                });
                return classes;
            }, []);
            // For compatibility with older versions of react-syntax-highlighter
            var startingClassName = properties.className && properties.className.includes('token') ? [
                'token'
            ] : [];
            var className = properties.className && startingClassName.concat(properties.className.filter(function(className) {
                return !allStylesheetSelectors.includes(className);
            }));
            props = $35b076aa3d5f5fcb$var$_objectSpread($35b076aa3d5f5fcb$var$_objectSpread({}, properties), {}, {
                className: $35b076aa3d5f5fcb$export$d0f1f443a3b7b5(className) || undefined,
                style: $35b076aa3d5f5fcb$export$28a8c6cb018dfadc(properties.className, Object.assign({}, properties.style, style), stylesheet)
            });
        }
        var children = childrenCreator(node.children);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(TagName, (0, (/*@__PURE__*/$parcel$interopDefault($27ab08c24269de64$exports)))({
            key: key
        }, props), children);
    }
}


var $20f4867013ee8e7f$export$2e2bcd8739ae039 = function(astGenerator, language) {
    var langs = astGenerator.listLanguages();
    return langs.indexOf(language) !== -1;
};


var $b94dbc74b29e9f13$var$_excluded = [
    "language",
    "children",
    "style",
    "customStyle",
    "codeTagProps",
    "useInlineStyles",
    "showLineNumbers",
    "showInlineLineNumbers",
    "startingLineNumber",
    "lineNumberContainerStyle",
    "lineNumberStyle",
    "wrapLines",
    "wrapLongLines",
    "lineProps",
    "renderer",
    "PreTag",
    "CodeTag",
    "code",
    "astGenerator"
];
function $b94dbc74b29e9f13$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $b94dbc74b29e9f13$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $b94dbc74b29e9f13$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($bb7ca61ce45563c4$exports)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $b94dbc74b29e9f13$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $b94dbc74b29e9f13$var$newLineRegex = /\n/g;
function $b94dbc74b29e9f13$var$getNewLines(str) {
    return str.match($b94dbc74b29e9f13$var$newLineRegex);
}
function $b94dbc74b29e9f13$var$getAllLineNumbers(_ref) {
    var lines = _ref.lines, startingLineNumber = _ref.startingLineNumber, style = _ref.style;
    return lines.map(function(_, i) {
        var number = i + startingLineNumber;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            key: "line-".concat(i),
            className: "react-syntax-highlighter-line-number",
            style: typeof style === 'function' ? style(number) : style
        }, "".concat(number, "\n"));
    });
}
function $b94dbc74b29e9f13$var$AllLineNumbers(_ref2) {
    var codeString = _ref2.codeString, codeStyle = _ref2.codeStyle, _ref2$containerStyle = _ref2.containerStyle, containerStyle = _ref2$containerStyle === void 0 ? {
        "float": 'left',
        paddingRight: '10px'
    } : _ref2$containerStyle, _ref2$numberStyle = _ref2.numberStyle, numberStyle = _ref2$numberStyle === void 0 ? {} : _ref2$numberStyle, startingLineNumber = _ref2.startingLineNumber;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("code", {
        style: Object.assign({}, codeStyle, containerStyle)
    }, $b94dbc74b29e9f13$var$getAllLineNumbers({
        lines: codeString.replace(/\n$/, '').split('\n'),
        style: numberStyle,
        startingLineNumber: startingLineNumber
    }));
}
function $b94dbc74b29e9f13$var$getEmWidthOfNumber(num) {
    return "".concat(num.toString().length, ".25em");
}
function $b94dbc74b29e9f13$var$getInlineLineNumber(lineNumber, inlineLineNumberStyle) {
    return {
        type: 'element',
        tagName: 'span',
        properties: {
            key: "line-number--".concat(lineNumber),
            className: [
                'comment',
                'linenumber',
                'react-syntax-highlighter-line-number'
            ],
            style: inlineLineNumberStyle
        },
        children: [
            {
                type: 'text',
                value: lineNumber
            }
        ]
    };
}
function $b94dbc74b29e9f13$var$assembleLineNumberStyles(lineNumberStyle, lineNumber, largestLineNumber) {
    // minimally necessary styling for line numbers
    var defaultLineNumberStyle = {
        display: 'inline-block',
        minWidth: $b94dbc74b29e9f13$var$getEmWidthOfNumber(largestLineNumber),
        paddingRight: '1em',
        textAlign: 'right',
        userSelect: 'none'
    };
    // prep custom styling
    var customLineNumberStyle = typeof lineNumberStyle === 'function' ? lineNumberStyle(lineNumber) : lineNumberStyle;
    // combine
    var assembledStyle = $b94dbc74b29e9f13$var$_objectSpread($b94dbc74b29e9f13$var$_objectSpread({}, defaultLineNumberStyle), customLineNumberStyle);
    return assembledStyle;
}
function $b94dbc74b29e9f13$var$createLineElement(_ref3) {
    var children = _ref3.children, lineNumber = _ref3.lineNumber, lineNumberStyle = _ref3.lineNumberStyle, largestLineNumber = _ref3.largestLineNumber, showInlineLineNumbers = _ref3.showInlineLineNumbers, _ref3$lineProps = _ref3.lineProps, lineProps = _ref3$lineProps === void 0 ? {} : _ref3$lineProps, _ref3$className = _ref3.className, className = _ref3$className === void 0 ? [] : _ref3$className, showLineNumbers = _ref3.showLineNumbers, wrapLongLines = _ref3.wrapLongLines, _ref3$wrapLines = _ref3.wrapLines, wrapLines = _ref3$wrapLines === void 0 ? false : _ref3$wrapLines;
    var properties = wrapLines ? $b94dbc74b29e9f13$var$_objectSpread({}, typeof lineProps === 'function' ? lineProps(lineNumber) : lineProps) : {};
    properties['className'] = properties['className'] ? [].concat((0, (/*@__PURE__*/$parcel$interopDefault($b95e04f2d4c66124$exports)))(properties['className'].trim().split(/\s+/)), (0, (/*@__PURE__*/$parcel$interopDefault($b95e04f2d4c66124$exports)))(className)) : className;
    if (lineNumber && showInlineLineNumbers) {
        var inlineLineNumberStyle = $b94dbc74b29e9f13$var$assembleLineNumberStyles(lineNumberStyle, lineNumber, largestLineNumber);
        children.unshift($b94dbc74b29e9f13$var$getInlineLineNumber(lineNumber, inlineLineNumberStyle));
    }
    if (wrapLongLines & showLineNumbers) properties.style = $b94dbc74b29e9f13$var$_objectSpread({
        display: 'flex'
    }, properties.style);
    return {
        type: 'element',
        tagName: 'span',
        properties: properties,
        children: children
    };
}
function $b94dbc74b29e9f13$var$flattenCodeTree(tree) {
    var className = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
    var newTree = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
    for(var i = 0; i < tree.length; i++){
        var node = tree[i];
        if (node.type === 'text') newTree.push($b94dbc74b29e9f13$var$createLineElement({
            children: [
                node
            ],
            className: (0, (/*@__PURE__*/$parcel$interopDefault($b95e04f2d4c66124$exports)))(new Set(className))
        }));
        else if (node.children) {
            var classNames = className.concat(node.properties.className);
            $b94dbc74b29e9f13$var$flattenCodeTree(node.children, classNames).forEach(function(i) {
                return newTree.push(i);
            });
        }
    }
    return newTree;
}
function $b94dbc74b29e9f13$var$processLines(codeTree, wrapLines, lineProps, showLineNumbers, showInlineLineNumbers, startingLineNumber, largestLineNumber, lineNumberStyle, wrapLongLines) {
    var _ref4;
    var tree = $b94dbc74b29e9f13$var$flattenCodeTree(codeTree.value);
    var newTree = [];
    var lastLineBreakIndex = -1;
    var index = 0;
    function createWrappedLine(children, lineNumber) {
        var className = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
        return $b94dbc74b29e9f13$var$createLineElement({
            children: children,
            lineNumber: lineNumber,
            lineNumberStyle: lineNumberStyle,
            largestLineNumber: largestLineNumber,
            showInlineLineNumbers: showInlineLineNumbers,
            lineProps: lineProps,
            className: className,
            showLineNumbers: showLineNumbers,
            wrapLongLines: wrapLongLines,
            wrapLines: wrapLines
        });
    }
    function createUnwrappedLine(children, lineNumber) {
        if (showLineNumbers && lineNumber && showInlineLineNumbers) {
            var inlineLineNumberStyle = $b94dbc74b29e9f13$var$assembleLineNumberStyles(lineNumberStyle, lineNumber, largestLineNumber);
            children.unshift($b94dbc74b29e9f13$var$getInlineLineNumber(lineNumber, inlineLineNumberStyle));
        }
        return children;
    }
    function createLine(children, lineNumber) {
        var className = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
        return wrapLines || className.length > 0 ? createWrappedLine(children, lineNumber, className) : createUnwrappedLine(children, lineNumber);
    }
    var _loop = function _loop() {
        var node = tree[index];
        var value = node.children[0].value;
        var newLines = $b94dbc74b29e9f13$var$getNewLines(value);
        if (newLines) {
            var splitValue = value.split('\n');
            splitValue.forEach(function(text, i) {
                var lineNumber = showLineNumbers && newTree.length + startingLineNumber;
                var newChild = {
                    type: 'text',
                    value: "".concat(text, "\n")
                };
                // if it's the first line
                if (i === 0) {
                    var _children = tree.slice(lastLineBreakIndex + 1, index).concat($b94dbc74b29e9f13$var$createLineElement({
                        children: [
                            newChild
                        ],
                        className: node.properties.className
                    }));
                    var _line = createLine(_children, lineNumber);
                    newTree.push(_line);
                // if it's the last line
                } else if (i === splitValue.length - 1) {
                    var stringChild = tree[index + 1] && tree[index + 1].children && tree[index + 1].children[0];
                    var lastLineInPreviousSpan = {
                        type: 'text',
                        value: "".concat(text)
                    };
                    if (stringChild) {
                        var newElem = $b94dbc74b29e9f13$var$createLineElement({
                            children: [
                                lastLineInPreviousSpan
                            ],
                            className: node.properties.className
                        });
                        tree.splice(index + 1, 0, newElem);
                    } else {
                        var _children2 = [
                            lastLineInPreviousSpan
                        ];
                        var _line2 = createLine(_children2, lineNumber, node.properties.className);
                        newTree.push(_line2);
                    }
                // if it's neither the first nor the last line
                } else {
                    var _children3 = [
                        newChild
                    ];
                    var _line3 = createLine(_children3, lineNumber, node.properties.className);
                    newTree.push(_line3);
                }
            });
            lastLineBreakIndex = index;
        }
        index++;
    };
    while(index < tree.length)_loop();
    if (lastLineBreakIndex !== tree.length - 1) {
        var children = tree.slice(lastLineBreakIndex + 1, tree.length);
        if (children && children.length) {
            var lineNumber = showLineNumbers && newTree.length + startingLineNumber;
            var line = createLine(children, lineNumber);
            newTree.push(line);
        }
    }
    return wrapLines ? newTree : (_ref4 = []).concat.apply(_ref4, newTree);
}
function $b94dbc74b29e9f13$var$defaultRenderer(_ref5) {
    var rows = _ref5.rows, stylesheet = _ref5.stylesheet, useInlineStyles = _ref5.useInlineStyles;
    return rows.map(function(node, i) {
        return (0, $35b076aa3d5f5fcb$export$2e2bcd8739ae039)({
            node: node,
            stylesheet: stylesheet,
            useInlineStyles: useInlineStyles,
            key: "code-segement".concat(i)
        });
    });
}
// only highlight.js has the highlightAuto method
function $b94dbc74b29e9f13$var$isHighlightJs(astGenerator) {
    return astGenerator && typeof astGenerator.highlightAuto !== 'undefined';
}
function $b94dbc74b29e9f13$var$getCodeTree(_ref6) {
    var astGenerator = _ref6.astGenerator, language = _ref6.language, code = _ref6.code, defaultCodeValue = _ref6.defaultCodeValue;
    // figure out whether we're using lowlight/highlight or refractor/prism
    // then attempt highlighting accordingly
    // lowlight/highlight?
    if ($b94dbc74b29e9f13$var$isHighlightJs(astGenerator)) {
        var hasLanguage = (0, $20f4867013ee8e7f$export$2e2bcd8739ae039)(astGenerator, language);
        if (language === 'text') return {
            value: defaultCodeValue,
            language: 'text'
        };
        else if (hasLanguage) return astGenerator.highlight(language, code);
        else return astGenerator.highlightAuto(code);
    }
    // must be refractor/prism, then
    try {
        return language && language !== 'text' ? {
            value: astGenerator.highlight(code, language)
        } : {
            value: defaultCodeValue
        };
    } catch (e) {
        return {
            value: defaultCodeValue
        };
    }
}
function $b94dbc74b29e9f13$export$2e2bcd8739ae039(defaultAstGenerator, defaultStyle) {
    return function SyntaxHighlighter(_ref7) {
        var language = _ref7.language, children = _ref7.children, _ref7$style = _ref7.style, style = _ref7$style === void 0 ? defaultStyle : _ref7$style, _ref7$customStyle = _ref7.customStyle, customStyle = _ref7$customStyle === void 0 ? {} : _ref7$customStyle, _ref7$codeTagProps = _ref7.codeTagProps, codeTagProps = _ref7$codeTagProps === void 0 ? {
            className: language ? "language-".concat(language) : undefined,
            style: $b94dbc74b29e9f13$var$_objectSpread($b94dbc74b29e9f13$var$_objectSpread({}, style['code[class*="language-"]']), style["code[class*=\"language-".concat(language, "\"]")])
        } : _ref7$codeTagProps, _ref7$useInlineStyles = _ref7.useInlineStyles, useInlineStyles = _ref7$useInlineStyles === void 0 ? true : _ref7$useInlineStyles, _ref7$showLineNumbers = _ref7.showLineNumbers, showLineNumbers = _ref7$showLineNumbers === void 0 ? false : _ref7$showLineNumbers, _ref7$showInlineLineN = _ref7.showInlineLineNumbers, showInlineLineNumbers = _ref7$showInlineLineN === void 0 ? true : _ref7$showInlineLineN, _ref7$startingLineNum = _ref7.startingLineNumber, startingLineNumber = _ref7$startingLineNum === void 0 ? 1 : _ref7$startingLineNum, lineNumberContainerStyle = _ref7.lineNumberContainerStyle, _ref7$lineNumberStyle = _ref7.lineNumberStyle, lineNumberStyle = _ref7$lineNumberStyle === void 0 ? {} : _ref7$lineNumberStyle, wrapLines = _ref7.wrapLines, _ref7$wrapLongLines = _ref7.wrapLongLines, wrapLongLines = _ref7$wrapLongLines === void 0 ? false : _ref7$wrapLongLines, _ref7$lineProps = _ref7.lineProps, lineProps = _ref7$lineProps === void 0 ? {} : _ref7$lineProps, renderer = _ref7.renderer, _ref7$PreTag = _ref7.PreTag, PreTag = _ref7$PreTag === void 0 ? 'pre' : _ref7$PreTag, _ref7$CodeTag = _ref7.CodeTag, CodeTag = _ref7$CodeTag === void 0 ? 'code' : _ref7$CodeTag, _ref7$code = _ref7.code, code = _ref7$code === void 0 ? (Array.isArray(children) ? children[0] : children) || '' : _ref7$code, astGenerator = _ref7.astGenerator, rest = (0, (/*@__PURE__*/$parcel$interopDefault($c5fdcdd8d5286ae7$exports)))(_ref7, $b94dbc74b29e9f13$var$_excluded);
        astGenerator = astGenerator || defaultAstGenerator;
        var allLineNumbers = showLineNumbers ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($b94dbc74b29e9f13$var$AllLineNumbers, {
            containerStyle: lineNumberContainerStyle,
            codeStyle: codeTagProps.style || {},
            numberStyle: lineNumberStyle,
            startingLineNumber: startingLineNumber,
            codeString: code
        }) : null;
        var defaultPreStyle = style.hljs || style['pre[class*="language-"]'] || {
            backgroundColor: '#fff'
        };
        var generatorClassName = $b94dbc74b29e9f13$var$isHighlightJs(astGenerator) ? 'hljs' : 'prismjs';
        var preProps = useInlineStyles ? Object.assign({}, rest, {
            style: Object.assign({}, defaultPreStyle, customStyle)
        }) : Object.assign({}, rest, {
            className: rest.className ? "".concat(generatorClassName, " ").concat(rest.className) : generatorClassName,
            style: Object.assign({}, customStyle)
        });
        if (wrapLongLines) codeTagProps.style = $b94dbc74b29e9f13$var$_objectSpread({
            whiteSpace: 'pre-wrap'
        }, codeTagProps.style);
        else codeTagProps.style = $b94dbc74b29e9f13$var$_objectSpread({
            whiteSpace: 'pre'
        }, codeTagProps.style);
        if (!astGenerator) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(PreTag, preProps, allLineNumbers, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(CodeTag, codeTagProps, code));
        /*
     * Some custom renderers rely on individual row elements so we need to turn wrapLines on
     * if renderer is provided and wrapLines is undefined.
     */ if (wrapLines === undefined && renderer || wrapLongLines) wrapLines = true;
        renderer = renderer || $b94dbc74b29e9f13$var$defaultRenderer;
        var defaultCodeValue = [
            {
                type: 'text',
                value: code
            }
        ];
        var codeTree = $b94dbc74b29e9f13$var$getCodeTree({
            astGenerator: astGenerator,
            language: language,
            code: code,
            defaultCodeValue: defaultCodeValue
        });
        if (codeTree.language === null) codeTree.value = defaultCodeValue;
        // determine largest line number so that we can force minWidth on all linenumber elements
        var lineCount = codeTree.value.length;
        if (lineCount === 1 && codeTree.value[0].type === 'text') // Since codeTree for an unparsable text (e.g. 'a\na\na') is [{ type: 'text', value: 'a\na\na' }]
        lineCount = codeTree.value[0].value.split('\n').length;
        var largestLineNumber = lineCount + startingLineNumber;
        var rows = $b94dbc74b29e9f13$var$processLines(codeTree, wrapLines, lineProps, showLineNumbers, showInlineLineNumbers, startingLineNumber, largestLineNumber, lineNumberStyle, wrapLongLines);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(PreTag, preProps, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(CodeTag, codeTagProps, !showInlineLineNumbers && allLineNumbers, renderer({
            rows: rows,
            stylesheet: style,
            useInlineStyles: useInlineStyles
        })));
    };
}


var $55200e5f7077bb8a$export$2e2bcd8739ae039 = {
    "code[class*=\"language-\"]": {
        "color": "black",
        "background": "none",
        "textShadow": "0 1px white",
        "fontFamily": "Consolas, Monaco, 'Andale Mono', 'Ubuntu Mono', monospace",
        "fontSize": "1em",
        "textAlign": "left",
        "whiteSpace": "pre",
        "wordSpacing": "normal",
        "wordBreak": "normal",
        "wordWrap": "normal",
        "lineHeight": "1.5",
        "MozTabSize": "4",
        "OTabSize": "4",
        "tabSize": "4",
        "WebkitHyphens": "none",
        "MozHyphens": "none",
        "msHyphens": "none",
        "hyphens": "none"
    },
    "pre[class*=\"language-\"]": {
        "color": "black",
        "background": "#f5f2f0",
        "textShadow": "0 1px white",
        "fontFamily": "Consolas, Monaco, 'Andale Mono', 'Ubuntu Mono', monospace",
        "fontSize": "1em",
        "textAlign": "left",
        "whiteSpace": "pre",
        "wordSpacing": "normal",
        "wordBreak": "normal",
        "wordWrap": "normal",
        "lineHeight": "1.5",
        "MozTabSize": "4",
        "OTabSize": "4",
        "tabSize": "4",
        "WebkitHyphens": "none",
        "MozHyphens": "none",
        "msHyphens": "none",
        "hyphens": "none",
        "padding": "1em",
        "margin": ".5em 0",
        "overflow": "auto"
    },
    "pre[class*=\"language-\"]::-moz-selection": {
        "textShadow": "none",
        "background": "#b3d4fc"
    },
    "pre[class*=\"language-\"] ::-moz-selection": {
        "textShadow": "none",
        "background": "#b3d4fc"
    },
    "code[class*=\"language-\"]::-moz-selection": {
        "textShadow": "none",
        "background": "#b3d4fc"
    },
    "code[class*=\"language-\"] ::-moz-selection": {
        "textShadow": "none",
        "background": "#b3d4fc"
    },
    "pre[class*=\"language-\"]::selection": {
        "textShadow": "none",
        "background": "#b3d4fc"
    },
    "pre[class*=\"language-\"] ::selection": {
        "textShadow": "none",
        "background": "#b3d4fc"
    },
    "code[class*=\"language-\"]::selection": {
        "textShadow": "none",
        "background": "#b3d4fc"
    },
    "code[class*=\"language-\"] ::selection": {
        "textShadow": "none",
        "background": "#b3d4fc"
    },
    ":not(pre) > code[class*=\"language-\"]": {
        "background": "#f5f2f0",
        "padding": ".1em",
        "borderRadius": ".3em",
        "whiteSpace": "normal"
    },
    "comment": {
        "color": "slategray"
    },
    "prolog": {
        "color": "slategray"
    },
    "doctype": {
        "color": "slategray"
    },
    "cdata": {
        "color": "slategray"
    },
    "punctuation": {
        "color": "#999"
    },
    "namespace": {
        "Opacity": ".7"
    },
    "property": {
        "color": "#905"
    },
    "tag": {
        "color": "#905"
    },
    "boolean": {
        "color": "#905"
    },
    "number": {
        "color": "#905"
    },
    "constant": {
        "color": "#905"
    },
    "symbol": {
        "color": "#905"
    },
    "deleted": {
        "color": "#905"
    },
    "selector": {
        "color": "#690"
    },
    "attr-name": {
        "color": "#690"
    },
    "string": {
        "color": "#690"
    },
    "char": {
        "color": "#690"
    },
    "builtin": {
        "color": "#690"
    },
    "inserted": {
        "color": "#690"
    },
    "operator": {
        "color": "#9a6e3a",
        "background": "hsla(0, 0%, 100%, .5)"
    },
    "entity": {
        "color": "#9a6e3a",
        "background": "hsla(0, 0%, 100%, .5)",
        "cursor": "help"
    },
    "url": {
        "color": "#9a6e3a",
        "background": "hsla(0, 0%, 100%, .5)"
    },
    ".language-css .token.string": {
        "color": "#9a6e3a",
        "background": "hsla(0, 0%, 100%, .5)"
    },
    ".style .token.string": {
        "color": "#9a6e3a",
        "background": "hsla(0, 0%, 100%, .5)"
    },
    "atrule": {
        "color": "#07a"
    },
    "attr-value": {
        "color": "#07a"
    },
    "keyword": {
        "color": "#07a"
    },
    "function": {
        "color": "#DD4A68"
    },
    "class-name": {
        "color": "#DD4A68"
    },
    "regex": {
        "color": "#e90"
    },
    "important": {
        "color": "#e90",
        "fontWeight": "bold"
    },
    "variable": {
        "color": "#e90"
    },
    "bold": {
        "fontWeight": "bold"
    },
    "italic": {
        "fontStyle": "italic"
    }
};


var $6755ad9567008392$exports = {};
'use strict';
var $b4d53a600b5ecb49$exports = {};
'use strict';
/* global window, self */ // istanbul ignore next - Don't allow Prism to run on page load in browser or
// to start messaging from workers.
var $b4d53a600b5ecb49$var$ctx = typeof globalThis === 'object' ? globalThis : typeof self === 'object' ? self : typeof window === 'object' ? window : typeof $parcel$global === 'object' ? $parcel$global : {};
var $b4d53a600b5ecb49$var$restore = $b4d53a600b5ecb49$var$capture();
$b4d53a600b5ecb49$var$ctx.Prism = {
    manual: true,
    disableWorkerMessageHandler: true
};
var $5c2172766957d4c5$exports = {};
'use strict';

$5c2172766957d4c5$exports = (parcelRequire("8Ue2z"));


var $496020f194f4a349$exports = {};
'use strict';
var $dd39b8b84b411298$exports = {};
$dd39b8b84b411298$exports = JSON.parse('{"AElig":"\xc6","AMP":"&","Aacute":"\xc1","Acirc":"\xc2","Agrave":"\xc0","Aring":"\xc5","Atilde":"\xc3","Auml":"\xc4","COPY":"\xa9","Ccedil":"\xc7","ETH":"\xd0","Eacute":"\xc9","Ecirc":"\xca","Egrave":"\xc8","Euml":"\xcb","GT":">","Iacute":"\xcd","Icirc":"\xce","Igrave":"\xcc","Iuml":"\xcf","LT":"<","Ntilde":"\xd1","Oacute":"\xd3","Ocirc":"\xd4","Ograve":"\xd2","Oslash":"\xd8","Otilde":"\xd5","Ouml":"\xd6","QUOT":"\\"","REG":"\xae","THORN":"\xde","Uacute":"\xda","Ucirc":"\xdb","Ugrave":"\xd9","Uuml":"\xdc","Yacute":"\xdd","aacute":"\xe1","acirc":"\xe2","acute":"\xb4","aelig":"\xe6","agrave":"\xe0","amp":"&","aring":"\xe5","atilde":"\xe3","auml":"\xe4","brvbar":"\xa6","ccedil":"\xe7","cedil":"\xb8","cent":"\xa2","copy":"\xa9","curren":"\xa4","deg":"\xb0","divide":"\xf7","eacute":"\xe9","ecirc":"\xea","egrave":"\xe8","eth":"\xf0","euml":"\xeb","frac12":"\xbd","frac14":"\xbc","frac34":"\xbe","gt":">","iacute":"\xed","icirc":"\xee","iexcl":"\xa1","igrave":"\xec","iquest":"\xbf","iuml":"\xef","laquo":"\xab","lt":"<","macr":"\xaf","micro":"\xb5","middot":"\xb7","nbsp":"\xa0","not":"\xac","ntilde":"\xf1","oacute":"\xf3","ocirc":"\xf4","ograve":"\xf2","ordf":"\xaa","ordm":"\xba","oslash":"\xf8","otilde":"\xf5","ouml":"\xf6","para":"\xb6","plusmn":"\xb1","pound":"\xa3","quot":"\\"","raquo":"\xbb","reg":"\xae","sect":"\xa7","shy":"\xad","sup1":"\xb9","sup2":"\xb2","sup3":"\xb3","szlig":"\xdf","thorn":"\xfe","times":"\xd7","uacute":"\xfa","ucirc":"\xfb","ugrave":"\xf9","uml":"\xa8","uuml":"\xfc","yacute":"\xfd","yen":"\xa5","yuml":"\xff"}');


var $15b84fa219619ea9$exports = {};
$15b84fa219619ea9$exports = JSON.parse('{"0":"\uFFFD","128":"\u20AC","130":"\u201A","131":"\u0192","132":"\u201E","133":"\u2026","134":"\u2020","135":"\u2021","136":"\u02C6","137":"\u2030","138":"\u0160","139":"\u2039","140":"\u0152","142":"\u017D","145":"\u2018","146":"\u2019","147":"\u201C","148":"\u201D","149":"\u2022","150":"\u2013","151":"\u2014","152":"\u02DC","153":"\u2122","154":"\u0161","155":"\u203A","156":"\u0153","158":"\u017E","159":"\u0178"}');


var $31377cf288d1a51e$exports = {};
'use strict';
$31377cf288d1a51e$exports = $31377cf288d1a51e$var$decimal;
// Check if the given character code, or the character code at the first
// character, is decimal.
function $31377cf288d1a51e$var$decimal(character) {
    var code = typeof character === 'string' ? character.charCodeAt(0) : character;
    return code >= 48 && code <= 57 /* 0-9 */ ;
}


var $ad7c663e7aea0a3f$exports = {};
'use strict';
$ad7c663e7aea0a3f$exports = $ad7c663e7aea0a3f$var$hexadecimal;
// Check if the given character code, or the character code at the first
// character, is hexadecimal.
function $ad7c663e7aea0a3f$var$hexadecimal(character) {
    var code = typeof character === 'string' ? character.charCodeAt(0) : character;
    return code >= 97 /* a */  && code <= 102 || code >= 65 /* A */  && code <= 70 || code >= 48 /* A */  && code <= 57;
}


var $1ebd1cdbd9c00de1$exports = {};
'use strict';
var $40e61c71ff643b48$exports = {};
'use strict';
$40e61c71ff643b48$exports = $40e61c71ff643b48$var$alphabetical;
// Check if the given character code, or the character code at the first
// character, is alphabetical.
function $40e61c71ff643b48$var$alphabetical(character) {
    var code = typeof character === 'string' ? character.charCodeAt(0) : character;
    return code >= 97 && code <= 122 || code >= 65 && code <= 90;
}



$1ebd1cdbd9c00de1$exports = $1ebd1cdbd9c00de1$var$alphanumerical;
// Check if the given character code, or the character code at the first
// character, is alphanumerical.
function $1ebd1cdbd9c00de1$var$alphanumerical(character) {
    return $40e61c71ff643b48$exports(character) || $31377cf288d1a51e$exports(character);
}


var $5568a845e49a3b88$exports = {};
'use strict';
/* eslint-env browser */ var $5568a845e49a3b88$var$el;
var $5568a845e49a3b88$var$semicolon = 59 //  ';'
;
$5568a845e49a3b88$exports = $5568a845e49a3b88$var$decodeEntity;
function $5568a845e49a3b88$var$decodeEntity(characters) {
    var entity = '&' + characters + ';';
    var char;
    $5568a845e49a3b88$var$el = $5568a845e49a3b88$var$el || document.createElement('i');
    $5568a845e49a3b88$var$el.innerHTML = entity;
    char = $5568a845e49a3b88$var$el.textContent;
    // Some entities do not require the closing semicolon (`&not` - for instance),
    // which leads to situations where parsing the assumed entity of &notit; will
    // result in the string `¬it;`.  When we encounter a trailing semicolon after
    // parsing and the entity to decode was not a semicolon (`&semi;`), we can
    // assume that the matching was incomplete
    if (char.charCodeAt(char.length - 1) === $5568a845e49a3b88$var$semicolon && characters !== 'semi') return false;
    // If the decoded string is equal to the input, the entity was not valid
    return char === entity ? false : char;
}


$496020f194f4a349$exports = $496020f194f4a349$var$parseEntities;
var $496020f194f4a349$var$own = {}.hasOwnProperty;
var $496020f194f4a349$var$fromCharCode = String.fromCharCode;
var $496020f194f4a349$var$noop = Function.prototype;
// Default settings.
var $496020f194f4a349$var$defaults = {
    warning: null,
    reference: null,
    text: null,
    warningContext: null,
    referenceContext: null,
    textContext: null,
    position: {},
    additional: null,
    attribute: false,
    nonTerminated: true
};
// Characters.
var $496020f194f4a349$var$tab = 9 // '\t'
;
var $496020f194f4a349$var$lineFeed = 10 // '\n'
;
var $496020f194f4a349$var$formFeed = 12 // '\f'
;
var $496020f194f4a349$var$space = 32 // ' '
;
var $496020f194f4a349$var$ampersand = 38 // '&'
;
var $496020f194f4a349$var$semicolon = 59 // ';'
;
var $496020f194f4a349$var$lessThan = 60 // '<'
;
var $496020f194f4a349$var$equalsTo = 61 // '='
;
var $496020f194f4a349$var$numberSign = 35 // '#'
;
var $496020f194f4a349$var$uppercaseX = 88 // 'X'
;
var $496020f194f4a349$var$lowercaseX = 120 // 'x'
;
var $496020f194f4a349$var$replacementCharacter = 65533 // '�'
;
// Reference types.
var $496020f194f4a349$var$name = 'named';
var $496020f194f4a349$var$hexa = 'hexadecimal';
var $496020f194f4a349$var$deci = 'decimal';
// Map of bases.
var $496020f194f4a349$var$bases = {};
$496020f194f4a349$var$bases[$496020f194f4a349$var$hexa] = 16;
$496020f194f4a349$var$bases[$496020f194f4a349$var$deci] = 10;
// Map of types to tests.
// Each type of character reference accepts different characters.
// This test is used to detect whether a reference has ended (as the semicolon
// is not strictly needed).
var $496020f194f4a349$var$tests = {};
$496020f194f4a349$var$tests[$496020f194f4a349$var$name] = $1ebd1cdbd9c00de1$exports;
$496020f194f4a349$var$tests[$496020f194f4a349$var$deci] = $31377cf288d1a51e$exports;
$496020f194f4a349$var$tests[$496020f194f4a349$var$hexa] = $ad7c663e7aea0a3f$exports;
// Warning types.
var $496020f194f4a349$var$namedNotTerminated = 1;
var $496020f194f4a349$var$numericNotTerminated = 2;
var $496020f194f4a349$var$namedEmpty = 3;
var $496020f194f4a349$var$numericEmpty = 4;
var $496020f194f4a349$var$namedUnknown = 5;
var $496020f194f4a349$var$numericDisallowed = 6;
var $496020f194f4a349$var$numericProhibited = 7;
// Warning messages.
var $496020f194f4a349$var$messages = {};
$496020f194f4a349$var$messages[$496020f194f4a349$var$namedNotTerminated] = 'Named character references must be terminated by a semicolon';
$496020f194f4a349$var$messages[$496020f194f4a349$var$numericNotTerminated] = 'Numeric character references must be terminated by a semicolon';
$496020f194f4a349$var$messages[$496020f194f4a349$var$namedEmpty] = 'Named character references cannot be empty';
$496020f194f4a349$var$messages[$496020f194f4a349$var$numericEmpty] = 'Numeric character references cannot be empty';
$496020f194f4a349$var$messages[$496020f194f4a349$var$namedUnknown] = 'Named character references must be known';
$496020f194f4a349$var$messages[$496020f194f4a349$var$numericDisallowed] = 'Numeric character references cannot be disallowed';
$496020f194f4a349$var$messages[$496020f194f4a349$var$numericProhibited] = 'Numeric character references cannot be outside the permissible Unicode range';
// Wrap to ensure clean parameters are given to `parse`.
function $496020f194f4a349$var$parseEntities(value, options) {
    var settings = {};
    var option;
    var key;
    if (!options) options = {};
    for(key in $496020f194f4a349$var$defaults){
        option = options[key];
        settings[key] = option === null || option === undefined ? $496020f194f4a349$var$defaults[key] : option;
    }
    if (settings.position.indent || settings.position.start) {
        settings.indent = settings.position.indent || [];
        settings.position = settings.position.start;
    }
    return $496020f194f4a349$var$parse(value, settings);
}
// Parse entities.
// eslint-disable-next-line complexity
function $496020f194f4a349$var$parse(value, settings) {
    var additional = settings.additional;
    var nonTerminated = settings.nonTerminated;
    var handleText = settings.text;
    var handleReference = settings.reference;
    var handleWarning = settings.warning;
    var textContext = settings.textContext;
    var referenceContext = settings.referenceContext;
    var warningContext = settings.warningContext;
    var pos = settings.position;
    var indent = settings.indent || [];
    var length = value.length;
    var index = 0;
    var lines = -1;
    var column = pos.column || 1;
    var line = pos.line || 1;
    var queue = '';
    var result = [];
    var entityCharacters;
    var namedEntity;
    var terminated;
    var characters;
    var character;
    var reference;
    var following;
    var warning;
    var reason;
    var output;
    var entity;
    var begin;
    var start;
    var type;
    var test;
    var prev;
    var next;
    var diff;
    var end;
    if (typeof additional === 'string') additional = additional.charCodeAt(0);
    // Cache the current point.
    prev = now();
    // Wrap `handleWarning`.
    warning = handleWarning ? parseError : $496020f194f4a349$var$noop;
    // Ensure the algorithm walks over the first character and the end
    // (inclusive).
    index--;
    length++;
    while(++index < length){
        // If the previous character was a newline.
        if (character === $496020f194f4a349$var$lineFeed) column = indent[lines] || 1;
        character = value.charCodeAt(index);
        if (character === $496020f194f4a349$var$ampersand) {
            following = value.charCodeAt(index + 1);
            // The behaviour depends on the identity of the next character.
            if (following === $496020f194f4a349$var$tab || following === $496020f194f4a349$var$lineFeed || following === $496020f194f4a349$var$formFeed || following === $496020f194f4a349$var$space || following === $496020f194f4a349$var$ampersand || following === $496020f194f4a349$var$lessThan || following !== following || additional && following === additional) {
                // Not a character reference.
                // No characters are consumed, and nothing is returned.
                // This is not an error, either.
                queue += $496020f194f4a349$var$fromCharCode(character);
                column++;
                continue;
            }
            start = index + 1;
            begin = start;
            end = start;
            if (following === $496020f194f4a349$var$numberSign) {
                // Numerical entity.
                end = ++begin;
                // The behaviour further depends on the next character.
                following = value.charCodeAt(end);
                if (following === $496020f194f4a349$var$uppercaseX || following === $496020f194f4a349$var$lowercaseX) {
                    // ASCII hex digits.
                    type = $496020f194f4a349$var$hexa;
                    end = ++begin;
                } else // ASCII digits.
                type = $496020f194f4a349$var$deci;
            } else // Named entity.
            type = $496020f194f4a349$var$name;
            entityCharacters = '';
            entity = '';
            characters = '';
            test = $496020f194f4a349$var$tests[type];
            end--;
            while(++end < length){
                following = value.charCodeAt(end);
                if (!test(following)) break;
                characters += $496020f194f4a349$var$fromCharCode(following);
                // Check if we can match a legacy named reference.
                // If so, we cache that as the last viable named reference.
                // This ensures we do not need to walk backwards later.
                if (type === $496020f194f4a349$var$name && $496020f194f4a349$var$own.call($dd39b8b84b411298$exports, characters)) {
                    entityCharacters = characters;
                    entity = $dd39b8b84b411298$exports[characters];
                }
            }
            terminated = value.charCodeAt(end) === $496020f194f4a349$var$semicolon;
            if (terminated) {
                end++;
                namedEntity = type === $496020f194f4a349$var$name ? $5568a845e49a3b88$exports(characters) : false;
                if (namedEntity) {
                    entityCharacters = characters;
                    entity = namedEntity;
                }
            }
            diff = 1 + end - start;
            if (!terminated && !nonTerminated) ;
            else if (!characters) // An empty (possible) entity is valid, unless it’s numeric (thus an
            // ampersand followed by an octothorp).
            {
                if (type !== $496020f194f4a349$var$name) warning($496020f194f4a349$var$numericEmpty, diff);
            } else if (type === $496020f194f4a349$var$name) {
                // An ampersand followed by anything unknown, and not terminated, is
                // invalid.
                if (terminated && !entity) warning($496020f194f4a349$var$namedUnknown, 1);
                else {
                    // If theres something after an entity name which is not known, cap
                    // the reference.
                    if (entityCharacters !== characters) {
                        end = begin + entityCharacters.length;
                        diff = 1 + end - begin;
                        terminated = false;
                    }
                    // If the reference is not terminated, warn.
                    if (!terminated) {
                        reason = entityCharacters ? $496020f194f4a349$var$namedNotTerminated : $496020f194f4a349$var$namedEmpty;
                        if (settings.attribute) {
                            following = value.charCodeAt(end);
                            if (following === $496020f194f4a349$var$equalsTo) {
                                warning(reason, diff);
                                entity = null;
                            } else if ($1ebd1cdbd9c00de1$exports(following)) entity = null;
                            else warning(reason, diff);
                        } else warning(reason, diff);
                    }
                }
                reference = entity;
            } else {
                if (!terminated) // All non-terminated numeric entities are not rendered, and trigger a
                // warning.
                warning($496020f194f4a349$var$numericNotTerminated, diff);
                // When terminated and number, parse as either hexadecimal or decimal.
                reference = parseInt(characters, $496020f194f4a349$var$bases[type]);
                // Trigger a warning when the parsed number is prohibited, and replace
                // with replacement character.
                if ($496020f194f4a349$var$prohibited(reference)) {
                    warning($496020f194f4a349$var$numericProhibited, diff);
                    reference = $496020f194f4a349$var$fromCharCode($496020f194f4a349$var$replacementCharacter);
                } else if (reference in $15b84fa219619ea9$exports) {
                    // Trigger a warning when the parsed number is disallowed, and replace
                    // by an alternative.
                    warning($496020f194f4a349$var$numericDisallowed, diff);
                    reference = $15b84fa219619ea9$exports[reference];
                } else {
                    // Parse the number.
                    output = '';
                    // Trigger a warning when the parsed number should not be used.
                    if ($496020f194f4a349$var$disallowed(reference)) warning($496020f194f4a349$var$numericDisallowed, diff);
                    // Stringify the number.
                    if (reference > 0xffff) {
                        reference -= 0x10000;
                        output += $496020f194f4a349$var$fromCharCode(reference >>> 10 | 0xd800);
                        reference = 0xdc00 | reference & 0x3ff;
                    }
                    reference = output + $496020f194f4a349$var$fromCharCode(reference);
                }
            }
            // Found it!
            // First eat the queued characters as normal text, then eat an entity.
            if (reference) {
                flush();
                prev = now();
                index = end - 1;
                column += end - start + 1;
                result.push(reference);
                next = now();
                next.offset++;
                if (handleReference) handleReference.call(referenceContext, reference, {
                    start: prev,
                    end: next
                }, value.slice(start - 1, end));
                prev = next;
            } else {
                // If we could not find a reference, queue the checked characters (as
                // normal characters), and move the pointer to their end.
                // This is possible because we can be certain neither newlines nor
                // ampersands are included.
                characters = value.slice(start - 1, end);
                queue += characters;
                column += characters.length;
                index = end - 1;
            }
        } else {
            // Handle anything other than an ampersand, including newlines and EOF.
            if (character === 10 // Line feed
            ) {
                line++;
                lines++;
                column = 0;
            }
            if (character === character) {
                queue += $496020f194f4a349$var$fromCharCode(character);
                column++;
            } else flush();
        }
    }
    // Return the reduced nodes.
    return result.join('');
    // Get current position.
    function now() {
        return {
            line: line,
            column: column,
            offset: index + (pos.offset || 0)
        };
    }
    // “Throw” a parse-error: a warning.
    function parseError(code, offset) {
        var position = now();
        position.column += offset;
        position.offset += offset;
        handleWarning.call(warningContext, $496020f194f4a349$var$messages[code], position, code);
    }
    // Flush `queue` (normal text).
    // Macro invoked before each entity and at the end of `value`.
    // Does nothing when `queue` is empty.
    function flush() {
        if (queue) {
            result.push(queue);
            if (handleText) handleText.call(textContext, queue, {
                start: prev,
                end: now()
            });
            queue = '';
        }
    }
}
// Check if `character` is outside the permissible unicode range.
function $496020f194f4a349$var$prohibited(code) {
    return code >= 0xd800 && code <= 0xdfff || code > 0x10ffff;
}
// Check if `character` is disallowed.
function $496020f194f4a349$var$disallowed(code) {
    return code >= 0x0001 && code <= 0x0008 || code === 0x000b || code >= 0x000d && code <= 0x001f || code >= 0x007f && code <= 0x009f || code >= 0xfdd0 && code <= 0xfdef || (code & 0xffff) === 0xffff || (code & 0xffff) === 0xfffe;
}


var $a122b3f1b6a231c4$exports = {};
/// <reference lib="WebWorker"/>
var $a122b3f1b6a231c4$var$_self = typeof window !== 'undefined' ? window // if in browser
 : typeof WorkerGlobalScope !== 'undefined' && self instanceof WorkerGlobalScope ? self // if in worker
 : {} // if in node js
;
/**
 * Prism: Lightweight, robust, elegant syntax highlighting
 *
 * @license MIT <https://opensource.org/licenses/MIT>
 * @author Lea Verou <https://lea.verou.me>
 * @namespace
 * @public
 */ var $a122b3f1b6a231c4$var$Prism = function(_self) {
    // Private helper vars
    var lang = /(?:^|\s)lang(?:uage)?-([\w-]+)(?=\s|$)/i;
    var uniqueId = 0;
    // The grammar object for plaintext
    var plainTextGrammar = {};
    var _ = {
        /**
		 * By default, Prism will attempt to highlight all code elements (by calling {@link Prism.highlightAll}) on the
		 * current page after the page finished loading. This might be a problem if e.g. you wanted to asynchronously load
		 * additional languages or plugins yourself.
		 *
		 * By setting this value to `true`, Prism will not automatically highlight all code elements on the page.
		 *
		 * You obviously have to change this value before the automatic highlighting started. To do this, you can add an
		 * empty Prism object into the global scope before loading the Prism script like this:
		 *
		 * ```js
		 * window.Prism = window.Prism || {};
		 * Prism.manual = true;
		 * // add a new <script> to load Prism's script
		 * ```
		 *
		 * @default false
		 * @type {boolean}
		 * @memberof Prism
		 * @public
		 */ manual: _self.Prism && _self.Prism.manual,
        /**
		 * By default, if Prism is in a web worker, it assumes that it is in a worker it created itself, so it uses
		 * `addEventListener` to communicate with its parent instance. However, if you're using Prism manually in your
		 * own worker, you don't want it to do this.
		 *
		 * By setting this value to `true`, Prism will not add its own listeners to the worker.
		 *
		 * You obviously have to change this value before Prism executes. To do this, you can add an
		 * empty Prism object into the global scope before loading the Prism script like this:
		 *
		 * ```js
		 * window.Prism = window.Prism || {};
		 * Prism.disableWorkerMessageHandler = true;
		 * // Load Prism's script
		 * ```
		 *
		 * @default false
		 * @type {boolean}
		 * @memberof Prism
		 * @public
		 */ disableWorkerMessageHandler: _self.Prism && _self.Prism.disableWorkerMessageHandler,
        /**
		 * A namespace for utility methods.
		 *
		 * All function in this namespace that are not explicitly marked as _public_ are for __internal use only__ and may
		 * change or disappear at any time.
		 *
		 * @namespace
		 * @memberof Prism
		 */ util: {
            encode: function encode(tokens) {
                if (tokens instanceof Token) return new Token(tokens.type, encode(tokens.content), tokens.alias);
                else if (Array.isArray(tokens)) return tokens.map(encode);
                else return tokens.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/\u00a0/g, ' ');
            },
            /**
			 * Returns the name of the type of the given value.
			 *
			 * @param {any} o
			 * @returns {string}
			 * @example
			 * type(null)      === 'Null'
			 * type(undefined) === 'Undefined'
			 * type(123)       === 'Number'
			 * type('foo')     === 'String'
			 * type(true)      === 'Boolean'
			 * type([1, 2])    === 'Array'
			 * type({})        === 'Object'
			 * type(String)    === 'Function'
			 * type(/abc+/)    === 'RegExp'
			 */ type: function(o) {
                return Object.prototype.toString.call(o).slice(8, -1);
            },
            /**
			 * Returns a unique number for the given object. Later calls will still return the same number.
			 *
			 * @param {Object} obj
			 * @returns {number}
			 */ objId: function(obj) {
                if (!obj['__id']) Object.defineProperty(obj, '__id', {
                    value: ++uniqueId
                });
                return obj['__id'];
            },
            /**
			 * Creates a deep clone of the given object.
			 *
			 * The main intended use of this function is to clone language definitions.
			 *
			 * @param {T} o
			 * @param {Record<number, any>} [visited]
			 * @returns {T}
			 * @template T
			 */ clone: function deepClone(o, visited) {
                visited = visited || {};
                var clone;
                var id;
                switch(_.util.type(o)){
                    case 'Object':
                        id = _.util.objId(o);
                        if (visited[id]) return visited[id];
                        clone = /** @type {Record<string, any>} */ {};
                        visited[id] = clone;
                        for(var key in o)if (o.hasOwnProperty(key)) clone[key] = deepClone(o[key], visited);
                        return /** @type {any} */ clone;
                    case 'Array':
                        id = _.util.objId(o);
                        if (visited[id]) return visited[id];
                        clone = [];
                        visited[id] = clone;
                        /** @type {any} */ o.forEach(function(v, i) {
                            clone[i] = deepClone(v, visited);
                        });
                        return /** @type {any} */ clone;
                    default:
                        return o;
                }
            },
            /**
			 * Returns the Prism language of the given element set by a `language-xxxx` or `lang-xxxx` class.
			 *
			 * If no language is set for the element or the element is `null` or `undefined`, `none` will be returned.
			 *
			 * @param {Element} element
			 * @returns {string}
			 */ getLanguage: function(element) {
                while(element){
                    var m = lang.exec(element.className);
                    if (m) return m[1].toLowerCase();
                    element = element.parentElement;
                }
                return 'none';
            },
            /**
			 * Sets the Prism `language-xxxx` class of the given element.
			 *
			 * @param {Element} element
			 * @param {string} language
			 * @returns {void}
			 */ setLanguage: function(element, language) {
                // remove all `language-xxxx` classes
                // (this might leave behind a leading space)
                element.className = element.className.replace(RegExp(lang, 'gi'), '');
                // add the new `language-xxxx` class
                // (using `classList` will automatically clean up spaces for us)
                element.classList.add('language-' + language);
            },
            /**
			 * Returns the script element that is currently executing.
			 *
			 * This does __not__ work for line script element.
			 *
			 * @returns {HTMLScriptElement | null}
			 */ currentScript: function() {
                if (typeof document === 'undefined') return null;
                if ('currentScript' in document && true /* hack to trip TS' flow analysis */ ) return /** @type {any} */ document.currentScript;
                // IE11 workaround
                // we'll get the src of the current script by parsing IE11's error stack trace
                // this will not work for inline scripts
                try {
                    throw new Error();
                } catch (err) {
                    // Get file src url from stack. Specifically works with the format of stack traces in IE.
                    // A stack will look like this:
                    //
                    // Error
                    //    at _.util.currentScript (http://localhost/components/prism-core.js:119:5)
                    //    at Global code (http://localhost/components/prism-core.js:606:1)
                    var src = (/at [^(\r\n]*\((.*):[^:]+:[^:]+\)$/i.exec(err.stack) || [])[1];
                    if (src) {
                        var scripts = document.getElementsByTagName('script');
                        for(var i in scripts){
                            if (scripts[i].src == src) return scripts[i];
                        }
                    }
                    return null;
                }
            },
            /**
			 * Returns whether a given class is active for `element`.
			 *
			 * The class can be activated if `element` or one of its ancestors has the given class and it can be deactivated
			 * if `element` or one of its ancestors has the negated version of the given class. The _negated version_ of the
			 * given class is just the given class with a `no-` prefix.
			 *
			 * Whether the class is active is determined by the closest ancestor of `element` (where `element` itself is
			 * closest ancestor) that has the given class or the negated version of it. If neither `element` nor any of its
			 * ancestors have the given class or the negated version of it, then the default activation will be returned.
			 *
			 * In the paradoxical situation where the closest ancestor contains __both__ the given class and the negated
			 * version of it, the class is considered active.
			 *
			 * @param {Element} element
			 * @param {string} className
			 * @param {boolean} [defaultActivation=false]
			 * @returns {boolean}
			 */ isActive: function(element, className, defaultActivation) {
                var no = 'no-' + className;
                while(element){
                    var classList = element.classList;
                    if (classList.contains(className)) return true;
                    if (classList.contains(no)) return false;
                    element = element.parentElement;
                }
                return !!defaultActivation;
            }
        },
        /**
		 * This namespace contains all currently loaded languages and the some helper functions to create and modify languages.
		 *
		 * @namespace
		 * @memberof Prism
		 * @public
		 */ languages: {
            /**
			 * The grammar for plain, unformatted text.
			 */ plain: plainTextGrammar,
            plaintext: plainTextGrammar,
            text: plainTextGrammar,
            txt: plainTextGrammar,
            /**
			 * Creates a deep copy of the language with the given id and appends the given tokens.
			 *
			 * If a token in `redef` also appears in the copied language, then the existing token in the copied language
			 * will be overwritten at its original position.
			 *
			 * ## Best practices
			 *
			 * Since the position of overwriting tokens (token in `redef` that overwrite tokens in the copied language)
			 * doesn't matter, they can technically be in any order. However, this can be confusing to others that trying to
			 * understand the language definition because, normally, the order of tokens matters in Prism grammars.
			 *
			 * Therefore, it is encouraged to order overwriting tokens according to the positions of the overwritten tokens.
			 * Furthermore, all non-overwriting tokens should be placed after the overwriting ones.
			 *
			 * @param {string} id The id of the language to extend. This has to be a key in `Prism.languages`.
			 * @param {Grammar} redef The new tokens to append.
			 * @returns {Grammar} The new language created.
			 * @public
			 * @example
			 * Prism.languages['css-with-colors'] = Prism.languages.extend('css', {
			 *     // Prism.languages.css already has a 'comment' token, so this token will overwrite CSS' 'comment' token
			 *     // at its original position
			 *     'comment': { ... },
			 *     // CSS doesn't have a 'color' token, so this token will be appended
			 *     'color': /\b(?:red|green|blue)\b/
			 * });
			 */ extend: function(id, redef) {
                var lang = _.util.clone(_.languages[id]);
                for(var key in redef)lang[key] = redef[key];
                return lang;
            },
            /**
			 * Inserts tokens _before_ another token in a language definition or any other grammar.
			 *
			 * ## Usage
			 *
			 * This helper method makes it easy to modify existing languages. For example, the CSS language definition
			 * not only defines CSS highlighting for CSS documents, but also needs to define highlighting for CSS embedded
			 * in HTML through `<style>` elements. To do this, it needs to modify `Prism.languages.markup` and add the
			 * appropriate tokens. However, `Prism.languages.markup` is a regular JavaScript object literal, so if you do
			 * this:
			 *
			 * ```js
			 * Prism.languages.markup.style = {
			 *     // token
			 * };
			 * ```
			 *
			 * then the `style` token will be added (and processed) at the end. `insertBefore` allows you to insert tokens
			 * before existing tokens. For the CSS example above, you would use it like this:
			 *
			 * ```js
			 * Prism.languages.insertBefore('markup', 'cdata', {
			 *     'style': {
			 *         // token
			 *     }
			 * });
			 * ```
			 *
			 * ## Special cases
			 *
			 * If the grammars of `inside` and `insert` have tokens with the same name, the tokens in `inside`'s grammar
			 * will be ignored.
			 *
			 * This behavior can be used to insert tokens after `before`:
			 *
			 * ```js
			 * Prism.languages.insertBefore('markup', 'comment', {
			 *     'comment': Prism.languages.markup.comment,
			 *     // tokens after 'comment'
			 * });
			 * ```
			 *
			 * ## Limitations
			 *
			 * The main problem `insertBefore` has to solve is iteration order. Since ES2015, the iteration order for object
			 * properties is guaranteed to be the insertion order (except for integer keys) but some browsers behave
			 * differently when keys are deleted and re-inserted. So `insertBefore` can't be implemented by temporarily
			 * deleting properties which is necessary to insert at arbitrary positions.
			 *
			 * To solve this problem, `insertBefore` doesn't actually insert the given tokens into the target object.
			 * Instead, it will create a new object and replace all references to the target object with the new one. This
			 * can be done without temporarily deleting properties, so the iteration order is well-defined.
			 *
			 * However, only references that can be reached from `Prism.languages` or `insert` will be replaced. I.e. if
			 * you hold the target object in a variable, then the value of the variable will not change.
			 *
			 * ```js
			 * var oldMarkup = Prism.languages.markup;
			 * var newMarkup = Prism.languages.insertBefore('markup', 'comment', { ... });
			 *
			 * assert(oldMarkup !== Prism.languages.markup);
			 * assert(newMarkup === Prism.languages.markup);
			 * ```
			 *
			 * @param {string} inside The property of `root` (e.g. a language id in `Prism.languages`) that contains the
			 * object to be modified.
			 * @param {string} before The key to insert before.
			 * @param {Grammar} insert An object containing the key-value pairs to be inserted.
			 * @param {Object<string, any>} [root] The object containing `inside`, i.e. the object that contains the
			 * object to be modified.
			 *
			 * Defaults to `Prism.languages`.
			 * @returns {Grammar} The new grammar object.
			 * @public
			 */ insertBefore: function(inside, before, insert, root) {
                root = root || /** @type {any} */ _.languages;
                var grammar = root[inside];
                /** @type {Grammar} */ var ret = {};
                for(var token in grammar)if (grammar.hasOwnProperty(token)) {
                    if (token == before) {
                        for(var newToken in insert)if (insert.hasOwnProperty(newToken)) ret[newToken] = insert[newToken];
                    }
                    // Do not insert token which also occur in insert. See #1525
                    if (!insert.hasOwnProperty(token)) ret[token] = grammar[token];
                }
                var old = root[inside];
                root[inside] = ret;
                // Update references in other language definitions
                _.languages.DFS(_.languages, function(key, value) {
                    if (value === old && key != inside) this[key] = ret;
                });
                return ret;
            },
            // Traverse a language definition with Depth First Search
            DFS: function DFS(o, callback, type, visited) {
                visited = visited || {};
                var objId = _.util.objId;
                for(var i in o)if (o.hasOwnProperty(i)) {
                    callback.call(o, i, o[i], type || i);
                    var property = o[i];
                    var propertyType = _.util.type(property);
                    if (propertyType === 'Object' && !visited[objId(property)]) {
                        visited[objId(property)] = true;
                        DFS(property, callback, null, visited);
                    } else if (propertyType === 'Array' && !visited[objId(property)]) {
                        visited[objId(property)] = true;
                        DFS(property, callback, i, visited);
                    }
                }
            }
        },
        plugins: {},
        /**
		 * This is the most high-level function in Prism’s API.
		 * It fetches all the elements that have a `.language-xxxx` class and then calls {@link Prism.highlightElement} on
		 * each one of them.
		 *
		 * This is equivalent to `Prism.highlightAllUnder(document, async, callback)`.
		 *
		 * @param {boolean} [async=false] Same as in {@link Prism.highlightAllUnder}.
		 * @param {HighlightCallback} [callback] Same as in {@link Prism.highlightAllUnder}.
		 * @memberof Prism
		 * @public
		 */ highlightAll: function(async, callback) {
            _.highlightAllUnder(document, async, callback);
        },
        /**
		 * Fetches all the descendants of `container` that have a `.language-xxxx` class and then calls
		 * {@link Prism.highlightElement} on each one of them.
		 *
		 * The following hooks will be run:
		 * 1. `before-highlightall`
		 * 2. `before-all-elements-highlight`
		 * 3. All hooks of {@link Prism.highlightElement} for each element.
		 *
		 * @param {ParentNode} container The root element, whose descendants that have a `.language-xxxx` class will be highlighted.
		 * @param {boolean} [async=false] Whether each element is to be highlighted asynchronously using Web Workers.
		 * @param {HighlightCallback} [callback] An optional callback to be invoked on each element after its highlighting is done.
		 * @memberof Prism
		 * @public
		 */ highlightAllUnder: function(container, async, callback) {
            var env = {
                callback: callback,
                container: container,
                selector: 'code[class*="language-"], [class*="language-"] code, code[class*="lang-"], [class*="lang-"] code'
            };
            _.hooks.run('before-highlightall', env);
            env.elements = Array.prototype.slice.apply(env.container.querySelectorAll(env.selector));
            _.hooks.run('before-all-elements-highlight', env);
            for(var i = 0, element; element = env.elements[i++];)_.highlightElement(element, async === true, env.callback);
        },
        /**
		 * Highlights the code inside a single element.
		 *
		 * The following hooks will be run:
		 * 1. `before-sanity-check`
		 * 2. `before-highlight`
		 * 3. All hooks of {@link Prism.highlight}. These hooks will be run by an asynchronous worker if `async` is `true`.
		 * 4. `before-insert`
		 * 5. `after-highlight`
		 * 6. `complete`
		 *
		 * Some the above hooks will be skipped if the element doesn't contain any text or there is no grammar loaded for
		 * the element's language.
		 *
		 * @param {Element} element The element containing the code.
		 * It must have a class of `language-xxxx` to be processed, where `xxxx` is a valid language identifier.
		 * @param {boolean} [async=false] Whether the element is to be highlighted asynchronously using Web Workers
		 * to improve performance and avoid blocking the UI when highlighting very large chunks of code. This option is
		 * [disabled by default](https://prismjs.com/faq.html#why-is-asynchronous-highlighting-disabled-by-default).
		 *
		 * Note: All language definitions required to highlight the code must be included in the main `prism.js` file for
		 * asynchronous highlighting to work. You can build your own bundle on the
		 * [Download page](https://prismjs.com/download.html).
		 * @param {HighlightCallback} [callback] An optional callback to be invoked after the highlighting is done.
		 * Mostly useful when `async` is `true`, since in that case, the highlighting is done asynchronously.
		 * @memberof Prism
		 * @public
		 */ highlightElement: function(element, async, callback) {
            // Find language
            var language = _.util.getLanguage(element);
            var grammar = _.languages[language];
            // Set language on the element, if not present
            _.util.setLanguage(element, language);
            // Set language on the parent, for styling
            var parent = element.parentElement;
            if (parent && parent.nodeName.toLowerCase() === 'pre') _.util.setLanguage(parent, language);
            var code = element.textContent;
            var env = {
                element: element,
                language: language,
                grammar: grammar,
                code: code
            };
            function insertHighlightedCode(highlightedCode) {
                env.highlightedCode = highlightedCode;
                _.hooks.run('before-insert', env);
                env.element.innerHTML = env.highlightedCode;
                _.hooks.run('after-highlight', env);
                _.hooks.run('complete', env);
                callback && callback.call(env.element);
            }
            _.hooks.run('before-sanity-check', env);
            // plugins may change/add the parent/element
            parent = env.element.parentElement;
            if (parent && parent.nodeName.toLowerCase() === 'pre' && !parent.hasAttribute('tabindex')) parent.setAttribute('tabindex', '0');
            if (!env.code) {
                _.hooks.run('complete', env);
                callback && callback.call(env.element);
                return;
            }
            _.hooks.run('before-highlight', env);
            if (!env.grammar) {
                insertHighlightedCode(_.util.encode(env.code));
                return;
            }
            if (async && _self.Worker) {
                var worker = new Worker(_.filename);
                worker.onmessage = function(evt) {
                    insertHighlightedCode(evt.data);
                };
                worker.postMessage(JSON.stringify({
                    language: env.language,
                    code: env.code,
                    immediateClose: true
                }));
            } else insertHighlightedCode(_.highlight(env.code, env.grammar, env.language));
        },
        /**
		 * Low-level function, only use if you know what you’re doing. It accepts a string of text as input
		 * and the language definitions to use, and returns a string with the HTML produced.
		 *
		 * The following hooks will be run:
		 * 1. `before-tokenize`
		 * 2. `after-tokenize`
		 * 3. `wrap`: On each {@link Token}.
		 *
		 * @param {string} text A string with the code to be highlighted.
		 * @param {Grammar} grammar An object containing the tokens to use.
		 *
		 * Usually a language definition like `Prism.languages.markup`.
		 * @param {string} language The name of the language definition passed to `grammar`.
		 * @returns {string} The highlighted HTML.
		 * @memberof Prism
		 * @public
		 * @example
		 * Prism.highlight('var foo = true;', Prism.languages.javascript, 'javascript');
		 */ highlight: function(text, grammar, language) {
            var env = {
                code: text,
                grammar: grammar,
                language: language
            };
            _.hooks.run('before-tokenize', env);
            if (!env.grammar) throw new Error('The language "' + env.language + '" has no grammar.');
            env.tokens = _.tokenize(env.code, env.grammar);
            _.hooks.run('after-tokenize', env);
            return Token.stringify(_.util.encode(env.tokens), env.language);
        },
        /**
		 * This is the heart of Prism, and the most low-level function you can use. It accepts a string of text as input
		 * and the language definitions to use, and returns an array with the tokenized code.
		 *
		 * When the language definition includes nested tokens, the function is called recursively on each of these tokens.
		 *
		 * This method could be useful in other contexts as well, as a very crude parser.
		 *
		 * @param {string} text A string with the code to be highlighted.
		 * @param {Grammar} grammar An object containing the tokens to use.
		 *
		 * Usually a language definition like `Prism.languages.markup`.
		 * @returns {TokenStream} An array of strings and tokens, a token stream.
		 * @memberof Prism
		 * @public
		 * @example
		 * let code = `var foo = 0;`;
		 * let tokens = Prism.tokenize(code, Prism.languages.javascript);
		 * tokens.forEach(token => {
		 *     if (token instanceof Prism.Token && token.type === 'number') {
		 *         console.log(`Found numeric literal: ${token.content}`);
		 *     }
		 * });
		 */ tokenize: function(text, grammar) {
            var rest = grammar.rest;
            if (rest) {
                for(var token in rest)grammar[token] = rest[token];
                delete grammar.rest;
            }
            var tokenList = new LinkedList();
            addAfter(tokenList, tokenList.head, text);
            matchGrammar(text, tokenList, grammar, tokenList.head, 0);
            return toArray(tokenList);
        },
        /**
		 * @namespace
		 * @memberof Prism
		 * @public
		 */ hooks: {
            all: {},
            /**
			 * Adds the given callback to the list of callbacks for the given hook.
			 *
			 * The callback will be invoked when the hook it is registered for is run.
			 * Hooks are usually directly run by a highlight function but you can also run hooks yourself.
			 *
			 * One callback function can be registered to multiple hooks and the same hook multiple times.
			 *
			 * @param {string} name The name of the hook.
			 * @param {HookCallback} callback The callback function which is given environment variables.
			 * @public
			 */ add: function(name, callback) {
                var hooks = _.hooks.all;
                hooks[name] = hooks[name] || [];
                hooks[name].push(callback);
            },
            /**
			 * Runs a hook invoking all registered callbacks with the given environment variables.
			 *
			 * Callbacks will be invoked synchronously and in the order in which they were registered.
			 *
			 * @param {string} name The name of the hook.
			 * @param {Object<string, any>} env The environment variables of the hook passed to all callbacks registered.
			 * @public
			 */ run: function(name, env) {
                var callbacks = _.hooks.all[name];
                if (!callbacks || !callbacks.length) return;
                for(var i = 0, callback; callback = callbacks[i++];)callback(env);
            }
        },
        Token: Token
    };
    _self.Prism = _;
    // Typescript note:
    // The following can be used to import the Token type in JSDoc:
    //
    //   @typedef {InstanceType<import("./prism-core")["Token"]>} Token
    /**
	 * Creates a new token.
	 *
	 * @param {string} type See {@link Token#type type}
	 * @param {string | TokenStream} content See {@link Token#content content}
	 * @param {string|string[]} [alias] The alias(es) of the token.
	 * @param {string} [matchedStr=""] A copy of the full string this token was created from.
	 * @class
	 * @global
	 * @public
	 */ function Token(type, content, alias, matchedStr) {
        /**
		 * The type of the token.
		 *
		 * This is usually the key of a pattern in a {@link Grammar}.
		 *
		 * @type {string}
		 * @see GrammarToken
		 * @public
		 */ this.type = type;
        /**
		 * The strings or tokens contained by this token.
		 *
		 * This will be a token stream if the pattern matched also defined an `inside` grammar.
		 *
		 * @type {string | TokenStream}
		 * @public
		 */ this.content = content;
        /**
		 * The alias(es) of the token.
		 *
		 * @type {string|string[]}
		 * @see GrammarToken
		 * @public
		 */ this.alias = alias;
        // Copy of the full string this token was created from
        this.length = (matchedStr || '').length | 0;
    }
    /**
	 * A token stream is an array of strings and {@link Token Token} objects.
	 *
	 * Token streams have to fulfill a few properties that are assumed by most functions (mostly internal ones) that process
	 * them.
	 *
	 * 1. No adjacent strings.
	 * 2. No empty strings.
	 *
	 *    The only exception here is the token stream that only contains the empty string and nothing else.
	 *
	 * @typedef {Array<string | Token>} TokenStream
	 * @global
	 * @public
	 */ /**
	 * Converts the given token or token stream to an HTML representation.
	 *
	 * The following hooks will be run:
	 * 1. `wrap`: On each {@link Token}.
	 *
	 * @param {string | Token | TokenStream} o The token or token stream to be converted.
	 * @param {string} language The name of current language.
	 * @returns {string} The HTML representation of the token or token stream.
	 * @memberof Token
	 * @static
	 */ Token.stringify = function stringify(o, language) {
        if (typeof o == 'string') return o;
        if (Array.isArray(o)) {
            var s = '';
            o.forEach(function(e) {
                s += stringify(e, language);
            });
            return s;
        }
        var env = {
            type: o.type,
            content: stringify(o.content, language),
            tag: 'span',
            classes: [
                'token',
                o.type
            ],
            attributes: {},
            language: language
        };
        var aliases = o.alias;
        if (aliases) {
            if (Array.isArray(aliases)) Array.prototype.push.apply(env.classes, aliases);
            else env.classes.push(aliases);
        }
        _.hooks.run('wrap', env);
        var attributes = '';
        for(var name in env.attributes)attributes += ' ' + name + '="' + (env.attributes[name] || '').replace(/"/g, '&quot;') + '"';
        return '<' + env.tag + ' class="' + env.classes.join(' ') + '"' + attributes + '>' + env.content + '</' + env.tag + '>';
    };
    /**
	 * @param {RegExp} pattern
	 * @param {number} pos
	 * @param {string} text
	 * @param {boolean} lookbehind
	 * @returns {RegExpExecArray | null}
	 */ function matchPattern(pattern, pos, text, lookbehind) {
        pattern.lastIndex = pos;
        var match = pattern.exec(text);
        if (match && lookbehind && match[1]) {
            // change the match to remove the text matched by the Prism lookbehind group
            var lookbehindLength = match[1].length;
            match.index += lookbehindLength;
            match[0] = match[0].slice(lookbehindLength);
        }
        return match;
    }
    /**
	 * @param {string} text
	 * @param {LinkedList<string | Token>} tokenList
	 * @param {any} grammar
	 * @param {LinkedListNode<string | Token>} startNode
	 * @param {number} startPos
	 * @param {RematchOptions} [rematch]
	 * @returns {void}
	 * @private
	 *
	 * @typedef RematchOptions
	 * @property {string} cause
	 * @property {number} reach
	 */ function matchGrammar(text, tokenList, grammar, startNode, startPos, rematch) {
        for(var token in grammar){
            if (!grammar.hasOwnProperty(token) || !grammar[token]) continue;
            var patterns = grammar[token];
            patterns = Array.isArray(patterns) ? patterns : [
                patterns
            ];
            for(var j = 0; j < patterns.length; ++j){
                if (rematch && rematch.cause == token + ',' + j) return;
                var patternObj = patterns[j];
                var inside = patternObj.inside;
                var lookbehind = !!patternObj.lookbehind;
                var greedy = !!patternObj.greedy;
                var alias = patternObj.alias;
                if (greedy && !patternObj.pattern.global) {
                    // Without the global flag, lastIndex won't work
                    var flags = patternObj.pattern.toString().match(/[imsuy]*$/)[0];
                    patternObj.pattern = RegExp(patternObj.pattern.source, flags + 'g');
                }
                /** @type {RegExp} */ var pattern = patternObj.pattern || patternObj;
                for(var currentNode = startNode.next, pos = startPos; currentNode !== tokenList.tail; pos += currentNode.value.length, currentNode = currentNode.next){
                    if (rematch && pos >= rematch.reach) break;
                    var str = currentNode.value;
                    if (tokenList.length > text.length) // Something went terribly wrong, ABORT, ABORT!
                    return;
                    if (str instanceof Token) continue;
                    var removeCount = 1; // this is the to parameter of removeBetween
                    var match;
                    if (greedy) {
                        match = matchPattern(pattern, pos, text, lookbehind);
                        if (!match || match.index >= text.length) break;
                        var from = match.index;
                        var to = match.index + match[0].length;
                        var p = pos;
                        // find the node that contains the match
                        p += currentNode.value.length;
                        while(from >= p){
                            currentNode = currentNode.next;
                            p += currentNode.value.length;
                        }
                        // adjust pos (and p)
                        p -= currentNode.value.length;
                        pos = p;
                        // the current node is a Token, then the match starts inside another Token, which is invalid
                        if (currentNode.value instanceof Token) continue;
                        // find the last node which is affected by this match
                        for(var k = currentNode; k !== tokenList.tail && (p < to || typeof k.value === 'string'); k = k.next){
                            removeCount++;
                            p += k.value.length;
                        }
                        removeCount--;
                        // replace with the new match
                        str = text.slice(pos, p);
                        match.index -= pos;
                    } else {
                        match = matchPattern(pattern, 0, str, lookbehind);
                        if (!match) continue;
                    }
                    // eslint-disable-next-line no-redeclare
                    var from = match.index;
                    var matchStr = match[0];
                    var before = str.slice(0, from);
                    var after = str.slice(from + matchStr.length);
                    var reach = pos + str.length;
                    if (rematch && reach > rematch.reach) rematch.reach = reach;
                    var removeFrom = currentNode.prev;
                    if (before) {
                        removeFrom = addAfter(tokenList, removeFrom, before);
                        pos += before.length;
                    }
                    removeRange(tokenList, removeFrom, removeCount);
                    var wrapped = new Token(token, inside ? _.tokenize(matchStr, inside) : matchStr, alias, matchStr);
                    currentNode = addAfter(tokenList, removeFrom, wrapped);
                    if (after) addAfter(tokenList, currentNode, after);
                    if (removeCount > 1) {
                        // at least one Token object was removed, so we have to do some rematching
                        // this can only happen if the current pattern is greedy
                        /** @type {RematchOptions} */ var nestedRematch = {
                            cause: token + ',' + j,
                            reach: reach
                        };
                        matchGrammar(text, tokenList, grammar, currentNode.prev, pos, nestedRematch);
                        // the reach might have been extended because of the rematching
                        if (rematch && nestedRematch.reach > rematch.reach) rematch.reach = nestedRematch.reach;
                    }
                }
            }
        }
    }
    /**
	 * @typedef LinkedListNode
	 * @property {T} value
	 * @property {LinkedListNode<T> | null} prev The previous node.
	 * @property {LinkedListNode<T> | null} next The next node.
	 * @template T
	 * @private
	 */ /**
	 * @template T
	 * @private
	 */ function LinkedList() {
        /** @type {LinkedListNode<T>} */ var head = {
            value: null,
            prev: null,
            next: null
        };
        /** @type {LinkedListNode<T>} */ var tail = {
            value: null,
            prev: head,
            next: null
        };
        head.next = tail;
        /** @type {LinkedListNode<T>} */ this.head = head;
        /** @type {LinkedListNode<T>} */ this.tail = tail;
        this.length = 0;
    }
    /**
	 * Adds a new node with the given value to the list.
	 *
	 * @param {LinkedList<T>} list
	 * @param {LinkedListNode<T>} node
	 * @param {T} value
	 * @returns {LinkedListNode<T>} The added node.
	 * @template T
	 */ function addAfter(list, node, value) {
        // assumes that node != list.tail && values.length >= 0
        var next = node.next;
        var newNode = {
            value: value,
            prev: node,
            next: next
        };
        node.next = newNode;
        next.prev = newNode;
        list.length++;
        return newNode;
    }
    /**
	 * Removes `count` nodes after the given node. The given node will not be removed.
	 *
	 * @param {LinkedList<T>} list
	 * @param {LinkedListNode<T>} node
	 * @param {number} count
	 * @template T
	 */ function removeRange(list, node, count) {
        var next = node.next;
        for(var i = 0; i < count && next !== list.tail; i++)next = next.next;
        node.next = next;
        next.prev = node;
        list.length -= i;
    }
    /**
	 * @param {LinkedList<T>} list
	 * @returns {T[]}
	 * @template T
	 */ function toArray(list) {
        var array = [];
        var node = list.head.next;
        while(node !== list.tail){
            array.push(node.value);
            node = node.next;
        }
        return array;
    }
    if (!_self.document) {
        if (!_self.addEventListener) // in Node.js
        return _;
        if (!_.disableWorkerMessageHandler) // In worker
        _self.addEventListener('message', function(evt) {
            var message = JSON.parse(evt.data);
            var lang = message.language;
            var code = message.code;
            var immediateClose = message.immediateClose;
            _self.postMessage(_.highlight(code, _.languages[lang], lang));
            if (immediateClose) _self.close();
        }, false);
        return _;
    }
    // Get current script and highlight
    var script = _.util.currentScript();
    if (script) {
        _.filename = script.src;
        if (script.hasAttribute('data-manual')) _.manual = true;
    }
    function highlightAutomaticallyCallback() {
        if (!_.manual) _.highlightAll();
    }
    if (!_.manual) {
        // If the document state is "loading", then we'll use DOMContentLoaded.
        // If the document state is "interactive" and the prism.js script is deferred, then we'll also use the
        // DOMContentLoaded event because there might be some plugins or languages which have also been deferred and they
        // might take longer one animation frame to execute which can create a race condition where only some plugins have
        // been loaded when Prism.highlightAll() is executed, depending on how fast resources are loaded.
        // See https://github.com/PrismJS/prism/issues/2102
        var readyState = document.readyState;
        if (readyState === 'loading' || readyState === 'interactive' && script && script.defer) document.addEventListener('DOMContentLoaded', highlightAutomaticallyCallback);
        else if (window.requestAnimationFrame) window.requestAnimationFrame(highlightAutomaticallyCallback);
        else window.setTimeout(highlightAutomaticallyCallback, 16);
    }
    return _;
}($a122b3f1b6a231c4$var$_self);
if ($a122b3f1b6a231c4$exports) $a122b3f1b6a231c4$exports = $a122b3f1b6a231c4$var$Prism;
// hack for components to work correctly in node.js
if (typeof $parcel$global !== 'undefined') $parcel$global.Prism = $a122b3f1b6a231c4$var$Prism;
 // some additional documentation/types
 /**
 * The expansion of a simple `RegExp` literal to support additional properties.
 *
 * @typedef GrammarToken
 * @property {RegExp} pattern The regular expression of the token.
 * @property {boolean} [lookbehind=false] If `true`, then the first capturing group of `pattern` will (effectively)
 * behave as a lookbehind group meaning that the captured text will not be part of the matched text of the new token.
 * @property {boolean} [greedy=false] Whether the token is greedy.
 * @property {string|string[]} [alias] An optional alias or list of aliases.
 * @property {Grammar} [inside] The nested grammar of this token.
 *
 * The `inside` grammar will be used to tokenize the text value of each token of this kind.
 *
 * This can be used to make nested and even recursive language definitions.
 *
 * Note: This can cause infinite recursion. Be careful when you embed different languages or even the same language into
 * each another.
 * @global
 * @public
 */  /**
 * @typedef Grammar
 * @type {Object<string, RegExp | GrammarToken | Array<RegExp | GrammarToken>>}
 * @property {Grammar} [rest] An optional grammar object that will be appended to this grammar.
 * @global
 * @public
 */  /**
 * A function which will invoked after an element was successfully highlighted.
 *
 * @callback HighlightCallback
 * @param {Element} element The element successfully highlighted.
 * @returns {void}
 * @global
 * @public
 */  /**
 * @callback HookCallback
 * @param {Object<string, any>} env The environment variables of the hook.
 * @returns {void}
 * @global
 * @public
 */ 


var $eef4155429abb4f7$exports = {};
'use strict';
$eef4155429abb4f7$exports = $eef4155429abb4f7$var$markup;
$eef4155429abb4f7$var$markup.displayName = 'markup';
$eef4155429abb4f7$var$markup.aliases = [
    'html',
    'mathml',
    'svg',
    'xml',
    'ssml',
    'atom',
    'rss'
];
function $eef4155429abb4f7$var$markup(Prism) {
    Prism.languages.markup = {
        comment: {
            pattern: /<!--(?:(?!<!--)[\s\S])*?-->/,
            greedy: true
        },
        prolog: {
            pattern: /<\?[\s\S]+?\?>/,
            greedy: true
        },
        doctype: {
            // https://www.w3.org/TR/xml/#NT-doctypedecl
            pattern: /<!DOCTYPE(?:[^>"'[\]]|"[^"]*"|'[^']*')+(?:\[(?:[^<"'\]]|"[^"]*"|'[^']*'|<(?!!--)|<!--(?:[^-]|-(?!->))*-->)*\]\s*)?>/i,
            greedy: true,
            inside: {
                'internal-subset': {
                    pattern: /(^[^\[]*\[)[\s\S]+(?=\]>$)/,
                    lookbehind: true,
                    greedy: true,
                    inside: null // see below
                },
                string: {
                    pattern: /"[^"]*"|'[^']*'/,
                    greedy: true
                },
                punctuation: /^<!|>$|[[\]]/,
                'doctype-tag': /^DOCTYPE/i,
                name: /[^\s<>'"]+/
            }
        },
        cdata: {
            pattern: /<!\[CDATA\[[\s\S]*?\]\]>/i,
            greedy: true
        },
        tag: {
            pattern: /<\/?(?!\d)[^\s>\/=$<%]+(?:\s(?:\s*[^\s>\/=]+(?:\s*=\s*(?:"[^"]*"|'[^']*'|[^\s'">=]+(?=[\s>]))|(?=[\s/>])))+)?\s*\/?>/,
            greedy: true,
            inside: {
                tag: {
                    pattern: /^<\/?[^\s>\/]+/,
                    inside: {
                        punctuation: /^<\/?/,
                        namespace: /^[^\s>\/:]+:/
                    }
                },
                'special-attr': [],
                'attr-value': {
                    pattern: /=\s*(?:"[^"]*"|'[^']*'|[^\s'">=]+)/,
                    inside: {
                        punctuation: [
                            {
                                pattern: /^=/,
                                alias: 'attr-equals'
                            },
                            /"|'/
                        ]
                    }
                },
                punctuation: /\/?>/,
                'attr-name': {
                    pattern: /[^\s>\/]+/,
                    inside: {
                        namespace: /^[^\s>\/:]+:/
                    }
                }
            }
        },
        entity: [
            {
                pattern: /&[\da-z]{1,8};/i,
                alias: 'named-entity'
            },
            /&#x?[\da-f]{1,8};/i
        ]
    };
    Prism.languages.markup['tag'].inside['attr-value'].inside['entity'] = Prism.languages.markup['entity'];
    Prism.languages.markup['doctype'].inside['internal-subset'].inside = Prism.languages.markup // Plugin to make entity title show the real entity, idea by Roman Komarov
    ;
    Prism.hooks.add('wrap', function(env) {
        if (env.type === 'entity') env.attributes['title'] = env.content.value.replace(/&amp;/, '&');
    });
    Object.defineProperty(Prism.languages.markup.tag, 'addInlined', {
        /**
     * Adds an inlined language to markup.
     *
     * An example of an inlined language is CSS with `<style>` tags.
     *
     * @param {string} tagName The name of the tag that contains the inlined language. This name will be treated as
     * case insensitive.
     * @param {string} lang The language key.
     * @example
     * addInlined('style', 'css');
     */ value: function addInlined(tagName, lang) {
            var includedCdataInside = {};
            includedCdataInside['language-' + lang] = {
                pattern: /(^<!\[CDATA\[)[\s\S]+?(?=\]\]>$)/i,
                lookbehind: true,
                inside: Prism.languages[lang]
            };
            includedCdataInside['cdata'] = /^<!\[CDATA\[|\]\]>$/i;
            var inside = {
                'included-cdata': {
                    pattern: /<!\[CDATA\[[\s\S]*?\]\]>/i,
                    inside: includedCdataInside
                }
            };
            inside['language-' + lang] = {
                pattern: /[\s\S]+/,
                inside: Prism.languages[lang]
            };
            var def = {};
            def[tagName] = {
                pattern: RegExp(/(<__[^>]*>)(?:<!\[CDATA\[(?:[^\]]|\](?!\]>))*\]\]>|(?!<!\[CDATA\[)[\s\S])*?(?=<\/__>)/.source.replace(/__/g, function() {
                    return tagName;
                }), 'i'),
                lookbehind: true,
                greedy: true,
                inside: inside
            };
            Prism.languages.insertBefore('markup', 'cdata', def);
        }
    });
    Object.defineProperty(Prism.languages.markup.tag, 'addAttribute', {
        /**
     * Adds an pattern to highlight languages embedded in HTML attributes.
     *
     * An example of an inlined language is CSS with `style` attributes.
     *
     * @param {string} attrName The name of the tag that contains the inlined language. This name will be treated as
     * case insensitive.
     * @param {string} lang The language key.
     * @example
     * addAttribute('style', 'css');
     */ value: function(attrName, lang) {
            Prism.languages.markup.tag.inside['special-attr'].push({
                pattern: RegExp(/(^|["'\s])/.source + '(?:' + attrName + ')' + /\s*=\s*(?:"[^"]*"|'[^']*'|[^\s'">=]+(?=[\s>]))/.source, 'i'),
                lookbehind: true,
                inside: {
                    'attr-name': /^[^\s=]+/,
                    'attr-value': {
                        pattern: /=[\s\S]+/,
                        inside: {
                            value: {
                                pattern: /(^=\s*(["']|(?!["'])))\S[\s\S]*(?=\2$)/,
                                lookbehind: true,
                                alias: [
                                    lang,
                                    'language-' + lang
                                ],
                                inside: Prism.languages[lang]
                            },
                            punctuation: [
                                {
                                    pattern: /^=/,
                                    alias: 'attr-equals'
                                },
                                /"|'/
                            ]
                        }
                    }
                }
            });
        }
    });
    Prism.languages.html = Prism.languages.markup;
    Prism.languages.mathml = Prism.languages.markup;
    Prism.languages.svg = Prism.languages.markup;
    Prism.languages.xml = Prism.languages.extend('markup', {});
    Prism.languages.ssml = Prism.languages.xml;
    Prism.languages.atom = Prism.languages.xml;
    Prism.languages.rss = Prism.languages.xml;
}


var $094c415870e851aa$exports = {};
'use strict';
$094c415870e851aa$exports = $094c415870e851aa$var$css;
$094c415870e851aa$var$css.displayName = 'css';
$094c415870e851aa$var$css.aliases = [];
function $094c415870e851aa$var$css(Prism) {
    (function(Prism) {
        var string = /(?:"(?:\\(?:\r\n|[\s\S])|[^"\\\r\n])*"|'(?:\\(?:\r\n|[\s\S])|[^'\\\r\n])*')/;
        Prism.languages.css = {
            comment: /\/\*[\s\S]*?\*\//,
            atrule: {
                pattern: /@[\w-](?:[^;{\s]|\s+(?![\s{]))*(?:;|(?=\s*\{))/,
                inside: {
                    rule: /^@[\w-]+/,
                    'selector-function-argument': {
                        pattern: /(\bselector\s*\(\s*(?![\s)]))(?:[^()\s]|\s+(?![\s)])|\((?:[^()]|\([^()]*\))*\))+(?=\s*\))/,
                        lookbehind: true,
                        alias: 'selector'
                    },
                    keyword: {
                        pattern: /(^|[^\w-])(?:and|not|only|or)(?![\w-])/,
                        lookbehind: true
                    } // See rest below
                }
            },
            url: {
                // https://drafts.csswg.org/css-values-3/#urls
                pattern: RegExp('\\burl\\((?:' + string.source + '|' + /(?:[^\\\r\n()"']|\\[\s\S])*/.source + ')\\)', 'i'),
                greedy: true,
                inside: {
                    function: /^url/i,
                    punctuation: /^\(|\)$/,
                    string: {
                        pattern: RegExp('^' + string.source + '$'),
                        alias: 'url'
                    }
                }
            },
            selector: {
                pattern: RegExp('(^|[{}\\s])[^{}\\s](?:[^{};"\'\\s]|\\s+(?![\\s{])|' + string.source + ')*(?=\\s*\\{)'),
                lookbehind: true
            },
            string: {
                pattern: string,
                greedy: true
            },
            property: {
                pattern: /(^|[^-\w\xA0-\uFFFF])(?!\s)[-_a-z\xA0-\uFFFF](?:(?!\s)[-\w\xA0-\uFFFF])*(?=\s*:)/i,
                lookbehind: true
            },
            important: /!important\b/i,
            function: {
                pattern: /(^|[^-a-z0-9])[-a-z0-9]+(?=\()/i,
                lookbehind: true
            },
            punctuation: /[(){};:,]/
        };
        Prism.languages.css['atrule'].inside.rest = Prism.languages.css;
        var markup = Prism.languages.markup;
        if (markup) {
            markup.tag.addInlined('style', 'css');
            markup.tag.addAttribute('style', 'css');
        }
    })(Prism);
}


var $8b43b7f7c2b7b0b1$exports = {};
'use strict';
$8b43b7f7c2b7b0b1$exports = $8b43b7f7c2b7b0b1$var$clike;
$8b43b7f7c2b7b0b1$var$clike.displayName = 'clike';
$8b43b7f7c2b7b0b1$var$clike.aliases = [];
function $8b43b7f7c2b7b0b1$var$clike(Prism) {
    Prism.languages.clike = {
        comment: [
            {
                pattern: /(^|[^\\])\/\*[\s\S]*?(?:\*\/|$)/,
                lookbehind: true,
                greedy: true
            },
            {
                pattern: /(^|[^\\:])\/\/.*/,
                lookbehind: true,
                greedy: true
            }
        ],
        string: {
            pattern: /(["'])(?:\\(?:\r\n|[\s\S])|(?!\1)[^\\\r\n])*\1/,
            greedy: true
        },
        'class-name': {
            pattern: /(\b(?:class|extends|implements|instanceof|interface|new|trait)\s+|\bcatch\s+\()[\w.\\]+/i,
            lookbehind: true,
            inside: {
                punctuation: /[.\\]/
            }
        },
        keyword: /\b(?:break|catch|continue|do|else|finally|for|function|if|in|instanceof|new|null|return|throw|try|while)\b/,
        boolean: /\b(?:false|true)\b/,
        function: /\b\w+(?=\()/,
        number: /\b0x[\da-f]+\b|(?:\b\d+(?:\.\d*)?|\B\.\d+)(?:e[+-]?\d+)?/i,
        operator: /[<>]=?|[!=]=?=?|--?|\+\+?|&&?|\|\|?|[?*/~^%]/,
        punctuation: /[{}[\];(),.:]/
    };
}


var $0b8fd5808a52bd72$exports = {};
'use strict';
$0b8fd5808a52bd72$exports = $0b8fd5808a52bd72$var$javascript;
$0b8fd5808a52bd72$var$javascript.displayName = 'javascript';
$0b8fd5808a52bd72$var$javascript.aliases = [
    'js'
];
function $0b8fd5808a52bd72$var$javascript(Prism) {
    Prism.languages.javascript = Prism.languages.extend('clike', {
        'class-name': [
            Prism.languages.clike['class-name'],
            {
                pattern: /(^|[^$\w\xA0-\uFFFF])(?!\s)[_$A-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*(?=\.(?:constructor|prototype))/,
                lookbehind: true
            }
        ],
        keyword: [
            {
                pattern: /((?:^|\})\s*)catch\b/,
                lookbehind: true
            },
            {
                pattern: /(^|[^.]|\.\.\.\s*)\b(?:as|assert(?=\s*\{)|async(?=\s*(?:function\b|\(|[$\w\xA0-\uFFFF]|$))|await|break|case|class|const|continue|debugger|default|delete|do|else|enum|export|extends|finally(?=\s*(?:\{|$))|for|from(?=\s*(?:['"]|$))|function|(?:get|set)(?=\s*(?:[#\[$\w\xA0-\uFFFF]|$))|if|implements|import|in|instanceof|interface|let|new|null|of|package|private|protected|public|return|static|super|switch|this|throw|try|typeof|undefined|var|void|while|with|yield)\b/,
                lookbehind: true
            }
        ],
        // Allow for all non-ASCII characters (See http://stackoverflow.com/a/2008444)
        function: /#?(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*(?=\s*(?:\.\s*(?:apply|bind|call)\s*)?\()/,
        number: {
            pattern: RegExp(/(^|[^\w$])/.source + '(?:' + // constant
            (/NaN|Infinity/.source + '|' + // binary integer
            /0[bB][01]+(?:_[01]+)*n?/.source + '|' + // octal integer
            /0[oO][0-7]+(?:_[0-7]+)*n?/.source + '|' + // hexadecimal integer
            /0[xX][\dA-Fa-f]+(?:_[\dA-Fa-f]+)*n?/.source + '|' + // decimal bigint
            /\d+(?:_\d+)*n/.source + '|' + // decimal number (integer or float) but no bigint
            /(?:\d+(?:_\d+)*(?:\.(?:\d+(?:_\d+)*)?)?|\.\d+(?:_\d+)*)(?:[Ee][+-]?\d+(?:_\d+)*)?/.source) + ')' + /(?![\w$])/.source),
            lookbehind: true
        },
        operator: /--|\+\+|\*\*=?|=>|&&=?|\|\|=?|[!=]==|<<=?|>>>?=?|[-+*/%&|^!=<>]=?|\.{3}|\?\?=?|\?\.?|[~:]/
    });
    Prism.languages.javascript['class-name'][0].pattern = /(\b(?:class|extends|implements|instanceof|interface|new)\s+)[\w.\\]+/;
    Prism.languages.insertBefore('javascript', 'keyword', {
        regex: {
            // eslint-disable-next-line regexp/no-dupe-characters-character-class
            pattern: /((?:^|[^$\w\xA0-\uFFFF."'\])\s]|\b(?:return|yield))\s*)\/(?:\[(?:[^\]\\\r\n]|\\.)*\]|\\.|[^/\\\[\r\n])+\/[dgimyus]{0,7}(?=(?:\s|\/\*(?:[^*]|\*(?!\/))*\*\/)*(?:$|[\r\n,.;:})\]]|\/\/))/,
            lookbehind: true,
            greedy: true,
            inside: {
                'regex-source': {
                    pattern: /^(\/)[\s\S]+(?=\/[a-z]*$)/,
                    lookbehind: true,
                    alias: 'language-regex',
                    inside: Prism.languages.regex
                },
                'regex-delimiter': /^\/|\/$/,
                'regex-flags': /^[a-z]+$/
            }
        },
        // This must be declared before keyword because we use "function" inside the look-forward
        'function-variable': {
            pattern: /#?(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*(?=\s*[=:]\s*(?:async\s*)?(?:\bfunction\b|(?:\((?:[^()]|\([^()]*\))*\)|(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*)\s*=>))/,
            alias: 'function'
        },
        parameter: [
            {
                pattern: /(function(?:\s+(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*)?\s*\(\s*)(?!\s)(?:[^()\s]|\s+(?![\s)])|\([^()]*\))+(?=\s*\))/,
                lookbehind: true,
                inside: Prism.languages.javascript
            },
            {
                pattern: /(^|[^$\w\xA0-\uFFFF])(?!\s)[_$a-z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*(?=\s*=>)/i,
                lookbehind: true,
                inside: Prism.languages.javascript
            },
            {
                pattern: /(\(\s*)(?!\s)(?:[^()\s]|\s+(?![\s)])|\([^()]*\))+(?=\s*\)\s*=>)/,
                lookbehind: true,
                inside: Prism.languages.javascript
            },
            {
                pattern: /((?:\b|\s|^)(?!(?:as|async|await|break|case|catch|class|const|continue|debugger|default|delete|do|else|enum|export|extends|finally|for|from|function|get|if|implements|import|in|instanceof|interface|let|new|null|of|package|private|protected|public|return|set|static|super|switch|this|throw|try|typeof|undefined|var|void|while|with|yield)(?![$\w\xA0-\uFFFF]))(?:(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*\s*)\(\s*|\]\s*\(\s*)(?!\s)(?:[^()\s]|\s+(?![\s)])|\([^()]*\))+(?=\s*\)\s*\{)/,
                lookbehind: true,
                inside: Prism.languages.javascript
            }
        ],
        constant: /\b[A-Z](?:[A-Z_]|\dx?)*\b/
    });
    Prism.languages.insertBefore('javascript', 'string', {
        hashbang: {
            pattern: /^#!.*/,
            greedy: true,
            alias: 'comment'
        },
        'template-string': {
            pattern: /`(?:\\[\s\S]|\$\{(?:[^{}]|\{(?:[^{}]|\{[^}]*\})*\})+\}|(?!\$\{)[^\\`])*`/,
            greedy: true,
            inside: {
                'template-punctuation': {
                    pattern: /^`|`$/,
                    alias: 'string'
                },
                interpolation: {
                    pattern: /((?:^|[^\\])(?:\\{2})*)\$\{(?:[^{}]|\{(?:[^{}]|\{[^}]*\})*\})+\}/,
                    lookbehind: true,
                    inside: {
                        'interpolation-punctuation': {
                            pattern: /^\$\{|\}$/,
                            alias: 'punctuation'
                        },
                        rest: Prism.languages.javascript
                    }
                },
                string: /[\s\S]+/
            }
        },
        'string-property': {
            pattern: /((?:^|[,{])[ \t]*)(["'])(?:\\(?:\r\n|[\s\S])|(?!\2)[^\\\r\n])*\2(?=\s*:)/m,
            lookbehind: true,
            greedy: true,
            alias: 'property'
        }
    });
    Prism.languages.insertBefore('javascript', 'operator', {
        'literal-property': {
            pattern: /((?:^|[,{])[ \t]*)(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*(?=\s*:)/m,
            lookbehind: true,
            alias: 'property'
        }
    });
    if (Prism.languages.markup) {
        Prism.languages.markup.tag.addInlined('script', 'javascript') // add attribute support for all DOM events.
        ;
        // https://developer.mozilla.org/en-US/docs/Web/Events#Standard_events
        Prism.languages.markup.tag.addAttribute(/on(?:abort|blur|change|click|composition(?:end|start|update)|dblclick|error|focus(?:in|out)?|key(?:down|up)|load|mouse(?:down|enter|leave|move|out|over|up)|reset|resize|scroll|select|slotchange|submit|unload|wheel)/.source, 'javascript');
    }
    Prism.languages.js = Prism.languages.javascript;
}


$b4d53a600b5ecb49$var$restore();
var $b4d53a600b5ecb49$var$own = {}.hasOwnProperty;
// Inherit.
function $b4d53a600b5ecb49$var$Refractor() {}
$b4d53a600b5ecb49$var$Refractor.prototype = $a122b3f1b6a231c4$exports;
// Construct.
var $b4d53a600b5ecb49$var$refract = new $b4d53a600b5ecb49$var$Refractor();
// Expose.
$b4d53a600b5ecb49$exports = $b4d53a600b5ecb49$var$refract;
// Create.
$b4d53a600b5ecb49$var$refract.highlight = $b4d53a600b5ecb49$var$highlight;
$b4d53a600b5ecb49$var$refract.register = $b4d53a600b5ecb49$var$register;
$b4d53a600b5ecb49$var$refract.alias = $b4d53a600b5ecb49$var$alias;
$b4d53a600b5ecb49$var$refract.registered = $b4d53a600b5ecb49$var$registered;
$b4d53a600b5ecb49$var$refract.listLanguages = $b4d53a600b5ecb49$var$listLanguages;
// Register bundled grammars.
$b4d53a600b5ecb49$var$register($eef4155429abb4f7$exports);
$b4d53a600b5ecb49$var$register($094c415870e851aa$exports);
$b4d53a600b5ecb49$var$register($8b43b7f7c2b7b0b1$exports);
$b4d53a600b5ecb49$var$register($0b8fd5808a52bd72$exports);
$b4d53a600b5ecb49$var$refract.util.encode = $b4d53a600b5ecb49$var$encode;
$b4d53a600b5ecb49$var$refract.Token.stringify = $b4d53a600b5ecb49$var$stringify;
function $b4d53a600b5ecb49$var$register(grammar) {
    if (typeof grammar !== 'function' || !grammar.displayName) throw new Error('Expected `function` for `grammar`, got `' + grammar + '`');
    // Do not duplicate registrations.
    if ($b4d53a600b5ecb49$var$refract.languages[grammar.displayName] === undefined) grammar($b4d53a600b5ecb49$var$refract);
}
function $b4d53a600b5ecb49$var$alias(name, alias) {
    var languages = $b4d53a600b5ecb49$var$refract.languages;
    var map = name;
    var key;
    var list;
    var length;
    var index;
    if (alias) {
        map = {};
        map[name] = alias;
    }
    for(key in map){
        list = map[key];
        list = typeof list === 'string' ? [
            list
        ] : list;
        length = list.length;
        index = -1;
        while(++index < length)languages[list[index]] = languages[key];
    }
}
function $b4d53a600b5ecb49$var$highlight(value, name) {
    var sup = $a122b3f1b6a231c4$exports.highlight;
    var grammar;
    if (typeof value !== 'string') throw new Error('Expected `string` for `value`, got `' + value + '`');
    // `name` is a grammar object.
    if ($b4d53a600b5ecb49$var$refract.util.type(name) === 'Object') {
        grammar = name;
        name = null;
    } else {
        if (typeof name !== 'string') throw new Error('Expected `string` for `name`, got `' + name + '`');
        if ($b4d53a600b5ecb49$var$own.call($b4d53a600b5ecb49$var$refract.languages, name)) grammar = $b4d53a600b5ecb49$var$refract.languages[name];
        else throw new Error('Unknown language: `' + name + '` is not registered');
    }
    return sup.call(this, value, grammar, name);
}
function $b4d53a600b5ecb49$var$registered(language) {
    if (typeof language !== 'string') throw new Error('Expected `string` for `language`, got `' + language + '`');
    return $b4d53a600b5ecb49$var$own.call($b4d53a600b5ecb49$var$refract.languages, language);
}
function $b4d53a600b5ecb49$var$listLanguages() {
    var languages = $b4d53a600b5ecb49$var$refract.languages;
    var list = [];
    var language;
    for(language in languages)if ($b4d53a600b5ecb49$var$own.call(languages, language) && typeof languages[language] === 'object') list.push(language);
    return list;
}
function $b4d53a600b5ecb49$var$stringify(value, language, parent) {
    var env;
    if (typeof value === 'string') return {
        type: 'text',
        value: value
    };
    if ($b4d53a600b5ecb49$var$refract.util.type(value) === 'Array') return $b4d53a600b5ecb49$var$stringifyAll(value, language);
    env = {
        type: value.type,
        content: $b4d53a600b5ecb49$var$refract.Token.stringify(value.content, language, parent),
        tag: 'span',
        classes: [
            'token',
            value.type
        ],
        attributes: {},
        language: language,
        parent: parent
    };
    if (value.alias) env.classes = env.classes.concat(value.alias);
    $b4d53a600b5ecb49$var$refract.hooks.run('wrap', env);
    return $5c2172766957d4c5$exports(env.tag + '.' + env.classes.join('.'), $b4d53a600b5ecb49$var$attributes(env.attributes), env.content);
}
function $b4d53a600b5ecb49$var$stringifyAll(values, language) {
    var result = [];
    var length = values.length;
    var index = -1;
    var value;
    while(++index < length){
        value = values[index];
        if (value !== '' && value !== null && value !== undefined) result.push(value);
    }
    index = -1;
    length = result.length;
    while(++index < length){
        value = result[index];
        result[index] = $b4d53a600b5ecb49$var$refract.Token.stringify(value, language, result);
    }
    return result;
}
function $b4d53a600b5ecb49$var$encode(tokens) {
    return tokens;
}
function $b4d53a600b5ecb49$var$attributes(attrs) {
    var key;
    for(key in attrs)attrs[key] = $496020f194f4a349$exports(attrs[key]);
    return attrs;
}
function $b4d53a600b5ecb49$var$capture() {
    var defined = 'Prism' in $b4d53a600b5ecb49$var$ctx;
    /* istanbul ignore next */ var current = defined ? $b4d53a600b5ecb49$var$ctx.Prism : undefined;
    return restore;
    function restore() {
        /* istanbul ignore else - Clean leaks after Prism. */ if (defined) $b4d53a600b5ecb49$var$ctx.Prism = current;
        else delete $b4d53a600b5ecb49$var$ctx.Prism;
        defined = undefined;
        current = undefined;
    }
}


$6755ad9567008392$exports = $b4d53a600b5ecb49$exports;

$b4d53a600b5ecb49$exports.register((parcelRequire("Txy2b")));

$b4d53a600b5ecb49$exports.register((parcelRequire("hm5YG")));

$b4d53a600b5ecb49$exports.register((parcelRequire("kHzqh")));

$b4d53a600b5ecb49$exports.register((parcelRequire("6aOpc")));

$b4d53a600b5ecb49$exports.register((parcelRequire("9TMK5")));

$b4d53a600b5ecb49$exports.register((parcelRequire("1DSDX")));

$b4d53a600b5ecb49$exports.register((parcelRequire("6vMTf")));

$b4d53a600b5ecb49$exports.register((parcelRequire("gM0NZ")));

$b4d53a600b5ecb49$exports.register((parcelRequire("d5uoG")));

$b4d53a600b5ecb49$exports.register((parcelRequire("iJzzr")));

$b4d53a600b5ecb49$exports.register((parcelRequire("6mLRz")));

$b4d53a600b5ecb49$exports.register((parcelRequire("7PjhR")));

$b4d53a600b5ecb49$exports.register((parcelRequire("gU0QR")));

$b4d53a600b5ecb49$exports.register((parcelRequire("8r1Sk")));

$b4d53a600b5ecb49$exports.register((parcelRequire("7jp9x")));

$b4d53a600b5ecb49$exports.register((parcelRequire("4JCZg")));

$b4d53a600b5ecb49$exports.register((parcelRequire("7DBd5")));

$b4d53a600b5ecb49$exports.register((parcelRequire("kWo46")));

$b4d53a600b5ecb49$exports.register((parcelRequire("aiaTs")));

$b4d53a600b5ecb49$exports.register((parcelRequire("cJe6k")));

$b4d53a600b5ecb49$exports.register((parcelRequire("9Xvjt")));

$b4d53a600b5ecb49$exports.register((parcelRequire("fulTr")));

$b4d53a600b5ecb49$exports.register((parcelRequire("92S56")));

$b4d53a600b5ecb49$exports.register((parcelRequire("dzave")));

$b4d53a600b5ecb49$exports.register((parcelRequire("3JA2F")));

$b4d53a600b5ecb49$exports.register((parcelRequire("1LS19")));

$b4d53a600b5ecb49$exports.register((parcelRequire("4fsTq")));

$b4d53a600b5ecb49$exports.register((parcelRequire("h0Bo3")));

$b4d53a600b5ecb49$exports.register((parcelRequire("ltfJv")));

$b4d53a600b5ecb49$exports.register((parcelRequire("jCr9w")));

$b4d53a600b5ecb49$exports.register((parcelRequire("fKsqK")));

$b4d53a600b5ecb49$exports.register((parcelRequire("2zD35")));

$b4d53a600b5ecb49$exports.register((parcelRequire("dYSlH")));

$b4d53a600b5ecb49$exports.register((parcelRequire("kW91c")));

$b4d53a600b5ecb49$exports.register((parcelRequire("c6Wvp")));

$b4d53a600b5ecb49$exports.register((parcelRequire("9BRi5")));

$b4d53a600b5ecb49$exports.register((parcelRequire("dSVGO")));

$b4d53a600b5ecb49$exports.register((parcelRequire("3A63E")));

$b4d53a600b5ecb49$exports.register((parcelRequire("bzHaH")));

$b4d53a600b5ecb49$exports.register((parcelRequire("5e0Fa")));

$b4d53a600b5ecb49$exports.register((parcelRequire("i3jhi")));

$b4d53a600b5ecb49$exports.register((parcelRequire("juLmo")));

$b4d53a600b5ecb49$exports.register((parcelRequire("lJWMS")));

$b4d53a600b5ecb49$exports.register((parcelRequire("1hYUn")));

$b4d53a600b5ecb49$exports.register((parcelRequire("4TKG9")));

$b4d53a600b5ecb49$exports.register((parcelRequire("fSH4P")));

$b4d53a600b5ecb49$exports.register((parcelRequire("kR0BX")));

$b4d53a600b5ecb49$exports.register((parcelRequire("ftjau")));

$b4d53a600b5ecb49$exports.register((parcelRequire("bylrX")));

$b4d53a600b5ecb49$exports.register((parcelRequire("j4tOO")));

$b4d53a600b5ecb49$exports.register((parcelRequire("5bKmo")));

$b4d53a600b5ecb49$exports.register((parcelRequire("ibnGi")));

$b4d53a600b5ecb49$exports.register((parcelRequire("i1Hs3")));

$b4d53a600b5ecb49$exports.register((parcelRequire("dCoif")));

$b4d53a600b5ecb49$exports.register((parcelRequire("gZhLI")));

$b4d53a600b5ecb49$exports.register((parcelRequire("34JIo")));

$b4d53a600b5ecb49$exports.register((parcelRequire("lSMkw")));

$b4d53a600b5ecb49$exports.register((parcelRequire("gB6T3")));

$b4d53a600b5ecb49$exports.register((parcelRequire("a5PBj")));

$b4d53a600b5ecb49$exports.register((parcelRequire("jRQNP")));

$b4d53a600b5ecb49$exports.register((parcelRequire("etxi4")));

$b4d53a600b5ecb49$exports.register((parcelRequire("4nlhg")));

$b4d53a600b5ecb49$exports.register((parcelRequire("fa7lQ")));

$b4d53a600b5ecb49$exports.register((parcelRequire("1TWWp")));

$b4d53a600b5ecb49$exports.register((parcelRequire("7EtQM")));

$b4d53a600b5ecb49$exports.register((parcelRequire("aeSQQ")));

$b4d53a600b5ecb49$exports.register((parcelRequire("iDMCu")));

$b4d53a600b5ecb49$exports.register((parcelRequire("fCvJP")));

$b4d53a600b5ecb49$exports.register((parcelRequire("fpVPL")));

$b4d53a600b5ecb49$exports.register((parcelRequire("jxciR")));

$b4d53a600b5ecb49$exports.register((parcelRequire("1NsmQ")));

$b4d53a600b5ecb49$exports.register((parcelRequire("9eFBf")));

$b4d53a600b5ecb49$exports.register((parcelRequire("8qlwl")));

$b4d53a600b5ecb49$exports.register((parcelRequire("d02KX")));

$b4d53a600b5ecb49$exports.register((parcelRequire("hOSVI")));

$b4d53a600b5ecb49$exports.register((parcelRequire("1aQjc")));

$b4d53a600b5ecb49$exports.register((parcelRequire("RraQ5")));

$b4d53a600b5ecb49$exports.register((parcelRequire("8o27y")));

$b4d53a600b5ecb49$exports.register((parcelRequire("6QKss")));

$b4d53a600b5ecb49$exports.register((parcelRequire("50CB7")));

$b4d53a600b5ecb49$exports.register((parcelRequire("17Zfk")));

$b4d53a600b5ecb49$exports.register((parcelRequire("a9tsC")));

$b4d53a600b5ecb49$exports.register((parcelRequire("ghQlc")));

$b4d53a600b5ecb49$exports.register((parcelRequire("gf4KM")));

$b4d53a600b5ecb49$exports.register((parcelRequire("huKo5")));

$b4d53a600b5ecb49$exports.register((parcelRequire("cE8LE")));

$b4d53a600b5ecb49$exports.register((parcelRequire("jKuY2")));

$b4d53a600b5ecb49$exports.register((parcelRequire("fX4qU")));

$b4d53a600b5ecb49$exports.register((parcelRequire("1Z2jf")));

$b4d53a600b5ecb49$exports.register((parcelRequire("2Nir4")));

$b4d53a600b5ecb49$exports.register((parcelRequire("hOWv0")));

$b4d53a600b5ecb49$exports.register((parcelRequire("crKTD")));

$b4d53a600b5ecb49$exports.register((parcelRequire("97PDK")));

$b4d53a600b5ecb49$exports.register((parcelRequire("67Bsn")));

$b4d53a600b5ecb49$exports.register((parcelRequire("f3xTx")));

$b4d53a600b5ecb49$exports.register((parcelRequire("5xwo7")));

$b4d53a600b5ecb49$exports.register((parcelRequire("dCw7g")));

$b4d53a600b5ecb49$exports.register((parcelRequire("g5gJJ")));

$b4d53a600b5ecb49$exports.register((parcelRequire("8vj8A")));

$b4d53a600b5ecb49$exports.register((parcelRequire("crLJd")));

$b4d53a600b5ecb49$exports.register((parcelRequire("aamB2")));

$b4d53a600b5ecb49$exports.register((parcelRequire("3iorT")));

$b4d53a600b5ecb49$exports.register((parcelRequire("50JWJ")));

$b4d53a600b5ecb49$exports.register((parcelRequire("j4rvn")));

$b4d53a600b5ecb49$exports.register((parcelRequire("8fv0R")));

$b4d53a600b5ecb49$exports.register((parcelRequire("7atwR")));

$b4d53a600b5ecb49$exports.register((parcelRequire("2v4Bz")));

$b4d53a600b5ecb49$exports.register((parcelRequire("707au")));

$b4d53a600b5ecb49$exports.register((parcelRequire("cAXA9")));

$b4d53a600b5ecb49$exports.register((parcelRequire("kAVHo")));

$b4d53a600b5ecb49$exports.register((parcelRequire("8xZNk")));

$b4d53a600b5ecb49$exports.register((parcelRequire("3dpZW")));

$b4d53a600b5ecb49$exports.register((parcelRequire("3IbCO")));

$b4d53a600b5ecb49$exports.register((parcelRequire("f7qNG")));

$b4d53a600b5ecb49$exports.register((parcelRequire("e9UW8")));

$b4d53a600b5ecb49$exports.register((parcelRequire("2c62O")));

$b4d53a600b5ecb49$exports.register((parcelRequire("6jo5N")));

$b4d53a600b5ecb49$exports.register((parcelRequire("iPtcI")));

$b4d53a600b5ecb49$exports.register((parcelRequire("cHYNj")));

$b4d53a600b5ecb49$exports.register((parcelRequire("gZAtn")));

$b4d53a600b5ecb49$exports.register((parcelRequire("btSLt")));

$b4d53a600b5ecb49$exports.register((parcelRequire("i7ijD")));

$b4d53a600b5ecb49$exports.register((parcelRequire("ehQbF")));

$b4d53a600b5ecb49$exports.register((parcelRequire("2S1bt")));

$b4d53a600b5ecb49$exports.register((parcelRequire("dEFCJ")));

$b4d53a600b5ecb49$exports.register((parcelRequire("a4w6O")));

$b4d53a600b5ecb49$exports.register((parcelRequire("jYji4")));

$b4d53a600b5ecb49$exports.register((parcelRequire("gmKNx")));

$b4d53a600b5ecb49$exports.register((parcelRequire("2XO4w")));

$b4d53a600b5ecb49$exports.register((parcelRequire("8Owu8")));

$b4d53a600b5ecb49$exports.register((parcelRequire("041AK")));

$b4d53a600b5ecb49$exports.register((parcelRequire("73T7k")));

$b4d53a600b5ecb49$exports.register((parcelRequire("lMzTm")));

$b4d53a600b5ecb49$exports.register((parcelRequire("eEcQN")));

$b4d53a600b5ecb49$exports.register((parcelRequire("7SWMi")));

$b4d53a600b5ecb49$exports.register((parcelRequire("2VVeC")));

$b4d53a600b5ecb49$exports.register((parcelRequire("g6B7q")));

$b4d53a600b5ecb49$exports.register((parcelRequire("cjsmG")));

$b4d53a600b5ecb49$exports.register((parcelRequire("3dkLW")));

$b4d53a600b5ecb49$exports.register((parcelRequire("88xZb")));

$b4d53a600b5ecb49$exports.register((parcelRequire("clCHb")));

$b4d53a600b5ecb49$exports.register((parcelRequire("6JaSX")));

$b4d53a600b5ecb49$exports.register((parcelRequire("1UNDH")));

$b4d53a600b5ecb49$exports.register((parcelRequire("cPF7D")));

$b4d53a600b5ecb49$exports.register((parcelRequire("ctJUb")));

$b4d53a600b5ecb49$exports.register((parcelRequire("lDTsy")));

$b4d53a600b5ecb49$exports.register((parcelRequire("4KOYm")));

$b4d53a600b5ecb49$exports.register((parcelRequire("949g8")));

$b4d53a600b5ecb49$exports.register((parcelRequire("ln59X")));

$b4d53a600b5ecb49$exports.register((parcelRequire("2npf9")));

$b4d53a600b5ecb49$exports.register((parcelRequire("2SlBl")));

$b4d53a600b5ecb49$exports.register((parcelRequire("cekQS")));

$b4d53a600b5ecb49$exports.register((parcelRequire("49xPA")));

$b4d53a600b5ecb49$exports.register((parcelRequire("4kt0k")));

$b4d53a600b5ecb49$exports.register((parcelRequire("aE5bt")));

$b4d53a600b5ecb49$exports.register((parcelRequire("bU7yo")));

$b4d53a600b5ecb49$exports.register((parcelRequire("5Gh0b")));

$b4d53a600b5ecb49$exports.register((parcelRequire("83Arx")));

$b4d53a600b5ecb49$exports.register((parcelRequire("kvYAn")));

$b4d53a600b5ecb49$exports.register((parcelRequire("5Myz8")));

$b4d53a600b5ecb49$exports.register((parcelRequire("e6vHr")));

$b4d53a600b5ecb49$exports.register((parcelRequire("6Q1VP")));

$b4d53a600b5ecb49$exports.register((parcelRequire("drRTk")));

$b4d53a600b5ecb49$exports.register((parcelRequire("hG4kM")));

$b4d53a600b5ecb49$exports.register((parcelRequire("eXvh9")));

$b4d53a600b5ecb49$exports.register((parcelRequire("563y4")));

$b4d53a600b5ecb49$exports.register((parcelRequire("6ylzc")));

$b4d53a600b5ecb49$exports.register((parcelRequire("5Zdog")));

$b4d53a600b5ecb49$exports.register((parcelRequire("cNqe1")));

$b4d53a600b5ecb49$exports.register((parcelRequire("7R3hJ")));

$b4d53a600b5ecb49$exports.register((parcelRequire("a8Nds")));

$b4d53a600b5ecb49$exports.register((parcelRequire("ekCPT")));

$b4d53a600b5ecb49$exports.register((parcelRequire("lC7OV")));

$b4d53a600b5ecb49$exports.register((parcelRequire("jksBg")));

$b4d53a600b5ecb49$exports.register((parcelRequire("4EXaf")));

$b4d53a600b5ecb49$exports.register((parcelRequire("kp3sJ")));

$b4d53a600b5ecb49$exports.register((parcelRequire("9RQU0")));

$b4d53a600b5ecb49$exports.register((parcelRequire("fnogL")));

$b4d53a600b5ecb49$exports.register((parcelRequire("lPUlp")));

$b4d53a600b5ecb49$exports.register((parcelRequire("fESM7")));

$b4d53a600b5ecb49$exports.register((parcelRequire("antOF")));

$b4d53a600b5ecb49$exports.register((parcelRequire("Eq0zv")));

$b4d53a600b5ecb49$exports.register((parcelRequire("gBUFO")));

$b4d53a600b5ecb49$exports.register((parcelRequire("jFhbb")));

$b4d53a600b5ecb49$exports.register((parcelRequire("aO3Fc")));

$b4d53a600b5ecb49$exports.register((parcelRequire("g2a1L")));

$b4d53a600b5ecb49$exports.register((parcelRequire("lrCyl")));

$b4d53a600b5ecb49$exports.register((parcelRequire("hQ4P8")));

$b4d53a600b5ecb49$exports.register((parcelRequire("8i4O3")));

$b4d53a600b5ecb49$exports.register((parcelRequire("4uTcK")));

$b4d53a600b5ecb49$exports.register((parcelRequire("1Kzyd")));

$b4d53a600b5ecb49$exports.register((parcelRequire("7KD6t")));

$b4d53a600b5ecb49$exports.register((parcelRequire("lv3Dh")));

$b4d53a600b5ecb49$exports.register((parcelRequire("aHHNA")));

$b4d53a600b5ecb49$exports.register((parcelRequire("huwdE")));

$b4d53a600b5ecb49$exports.register((parcelRequire("9jARG")));

$b4d53a600b5ecb49$exports.register((parcelRequire("3bEZu")));

$b4d53a600b5ecb49$exports.register((parcelRequire("hNXLj")));

$b4d53a600b5ecb49$exports.register((parcelRequire("jQ2hF")));

$b4d53a600b5ecb49$exports.register((parcelRequire("WlExc")));

$b4d53a600b5ecb49$exports.register((parcelRequire("4KdNd")));

$b4d53a600b5ecb49$exports.register((parcelRequire("7NGHk")));

$b4d53a600b5ecb49$exports.register((parcelRequire("frLRS")));

$b4d53a600b5ecb49$exports.register((parcelRequire("b9hZW")));

$b4d53a600b5ecb49$exports.register((parcelRequire("hvAJL")));

$b4d53a600b5ecb49$exports.register((parcelRequire("ddrlh")));

$b4d53a600b5ecb49$exports.register((parcelRequire("44X48")));

$b4d53a600b5ecb49$exports.register((parcelRequire("dV9BH")));

$b4d53a600b5ecb49$exports.register((parcelRequire("k19U6")));

$b4d53a600b5ecb49$exports.register((parcelRequire("lcFxt")));

$b4d53a600b5ecb49$exports.register((parcelRequire("aiiP2")));

$b4d53a600b5ecb49$exports.register((parcelRequire("2jpWm")));

$b4d53a600b5ecb49$exports.register((parcelRequire("d2gPH")));

$b4d53a600b5ecb49$exports.register((parcelRequire("6RI1v")));

$b4d53a600b5ecb49$exports.register((parcelRequire("7y0Pt")));

$b4d53a600b5ecb49$exports.register((parcelRequire("6ID3t")));

$b4d53a600b5ecb49$exports.register((parcelRequire("edDH5")));

$b4d53a600b5ecb49$exports.register((parcelRequire("9YjoD")));

$b4d53a600b5ecb49$exports.register((parcelRequire("LTFrQ")));

$b4d53a600b5ecb49$exports.register((parcelRequire("dSpBG")));

$b4d53a600b5ecb49$exports.register((parcelRequire("6eb3Z")));

$b4d53a600b5ecb49$exports.register((parcelRequire("ctouF")));

$b4d53a600b5ecb49$exports.register((parcelRequire("9glRX")));

$b4d53a600b5ecb49$exports.register((parcelRequire("7QpSG")));

$b4d53a600b5ecb49$exports.register((parcelRequire("lk7t0")));

$b4d53a600b5ecb49$exports.register((parcelRequire("7JMaL")));

$b4d53a600b5ecb49$exports.register((parcelRequire("eBzjI")));

$b4d53a600b5ecb49$exports.register((parcelRequire("2tqTy")));

$b4d53a600b5ecb49$exports.register((parcelRequire("9NMy0")));

$b4d53a600b5ecb49$exports.register((parcelRequire("4lsCO")));

$b4d53a600b5ecb49$exports.register((parcelRequire("91KrN")));

$b4d53a600b5ecb49$exports.register((parcelRequire("Vrj3c")));

$b4d53a600b5ecb49$exports.register((parcelRequire("eIUn7")));

$b4d53a600b5ecb49$exports.register((parcelRequire("1KspJ")));

$b4d53a600b5ecb49$exports.register((parcelRequire("305RV")));

$b4d53a600b5ecb49$exports.register((parcelRequire("cVzjE")));

$b4d53a600b5ecb49$exports.register((parcelRequire("71Xdn")));

$b4d53a600b5ecb49$exports.register((parcelRequire("faIXs")));

$b4d53a600b5ecb49$exports.register((parcelRequire("71QBk")));

$b4d53a600b5ecb49$exports.register((parcelRequire("6C2gd")));

$b4d53a600b5ecb49$exports.register((parcelRequire("iBtFX")));

$b4d53a600b5ecb49$exports.register((parcelRequire("eJ1Tk")));

$b4d53a600b5ecb49$exports.register((parcelRequire("hdHsr")));

$b4d53a600b5ecb49$exports.register((parcelRequire("iAxx1")));

$b4d53a600b5ecb49$exports.register((parcelRequire("3rXjk")));

$b4d53a600b5ecb49$exports.register((parcelRequire("7Q3ix")));

$b4d53a600b5ecb49$exports.register((parcelRequire("8Kcj1")));

$b4d53a600b5ecb49$exports.register((parcelRequire("cQami")));

$b4d53a600b5ecb49$exports.register((parcelRequire("8QUf9")));

$b4d53a600b5ecb49$exports.register((parcelRequire("kUHcr")));

$b4d53a600b5ecb49$exports.register((parcelRequire("buNor")));

$b4d53a600b5ecb49$exports.register((parcelRequire("3tuCM")));

$b4d53a600b5ecb49$exports.register((parcelRequire("6cZ4Y")));

$b4d53a600b5ecb49$exports.register((parcelRequire("l5f2Q")));

$b4d53a600b5ecb49$exports.register((parcelRequire("3av1E")));

$b4d53a600b5ecb49$exports.register((parcelRequire("bo5oF")));

$b4d53a600b5ecb49$exports.register((parcelRequire("8NhMH")));

$b4d53a600b5ecb49$exports.register((parcelRequire("k195P")));

$b4d53a600b5ecb49$exports.register((parcelRequire("9Mghs")));

$b4d53a600b5ecb49$exports.register((parcelRequire("8fjLw")));

$b4d53a600b5ecb49$exports.register((parcelRequire("imGum")));

$b4d53a600b5ecb49$exports.register((parcelRequire("deKUl")));

$b4d53a600b5ecb49$exports.register((parcelRequire("0210y")));

$b4d53a600b5ecb49$exports.register((parcelRequire("7m8BP")));

$b4d53a600b5ecb49$exports.register((parcelRequire("3JhJn")));

$b4d53a600b5ecb49$exports.register((parcelRequire("1eWdu")));

$b4d53a600b5ecb49$exports.register((parcelRequire("kbSLp")));

$b4d53a600b5ecb49$exports.register((parcelRequire("7YPe8")));

$b4d53a600b5ecb49$exports.register((parcelRequire("9Q9rd")));

$b4d53a600b5ecb49$exports.register((parcelRequire("edxZc")));

$b4d53a600b5ecb49$exports.register((parcelRequire("1CDYv")));

$b4d53a600b5ecb49$exports.register((parcelRequire("bZzKD")));

$b4d53a600b5ecb49$exports.register((parcelRequire("02tNy")));


//
// This file has been auto-generated by the `npm run build-languages-prism` task
//
var $e6819ed1ebbd4778$export$2e2bcd8739ae039 = [
    'abap',
    'abnf',
    'actionscript',
    'ada',
    'agda',
    'al',
    'antlr4',
    'apacheconf',
    'apex',
    'apl',
    'applescript',
    'aql',
    'arduino',
    'arff',
    'asciidoc',
    'asm6502',
    'asmatmel',
    'aspnet',
    'autohotkey',
    'autoit',
    'avisynth',
    'avro-idl',
    'bash',
    'basic',
    'batch',
    'bbcode',
    'bicep',
    'birb',
    'bison',
    'bnf',
    'brainfuck',
    'brightscript',
    'bro',
    'bsl',
    'c',
    'cfscript',
    'chaiscript',
    'cil',
    'clike',
    'clojure',
    'cmake',
    'cobol',
    'coffeescript',
    'concurnas',
    'coq',
    'cpp',
    'crystal',
    'csharp',
    'cshtml',
    'csp',
    'css-extras',
    'css',
    'csv',
    'cypher',
    'd',
    'dart',
    'dataweave',
    'dax',
    'dhall',
    'diff',
    'django',
    'dns-zone-file',
    'docker',
    'dot',
    'ebnf',
    'editorconfig',
    'eiffel',
    'ejs',
    'elixir',
    'elm',
    'erb',
    'erlang',
    'etlua',
    'excel-formula',
    'factor',
    'false',
    'firestore-security-rules',
    'flow',
    'fortran',
    'fsharp',
    'ftl',
    'gap',
    'gcode',
    'gdscript',
    'gedcom',
    'gherkin',
    'git',
    'glsl',
    'gml',
    'gn',
    'go-module',
    'go',
    'graphql',
    'groovy',
    'haml',
    'handlebars',
    'haskell',
    'haxe',
    'hcl',
    'hlsl',
    'hoon',
    'hpkp',
    'hsts',
    'http',
    'ichigojam',
    'icon',
    'icu-message-format',
    'idris',
    'iecst',
    'ignore',
    'inform7',
    'ini',
    'io',
    'j',
    'java',
    'javadoc',
    'javadoclike',
    'javascript',
    'javastacktrace',
    'jexl',
    'jolie',
    'jq',
    'js-extras',
    'js-templates',
    'jsdoc',
    'json',
    'json5',
    'jsonp',
    'jsstacktrace',
    'jsx',
    'julia',
    'keepalived',
    'keyman',
    'kotlin',
    'kumir',
    'kusto',
    'latex',
    'latte',
    'less',
    'lilypond',
    'liquid',
    'lisp',
    'livescript',
    'llvm',
    'log',
    'lolcode',
    'lua',
    'magma',
    'makefile',
    'markdown',
    'markup-templating',
    'markup',
    'matlab',
    'maxscript',
    'mel',
    'mermaid',
    'mizar',
    'mongodb',
    'monkey',
    'moonscript',
    'n1ql',
    'n4js',
    'nand2tetris-hdl',
    'naniscript',
    'nasm',
    'neon',
    'nevod',
    'nginx',
    'nim',
    'nix',
    'nsis',
    'objectivec',
    'ocaml',
    'opencl',
    'openqasm',
    'oz',
    'parigp',
    'parser',
    'pascal',
    'pascaligo',
    'pcaxis',
    'peoplecode',
    'perl',
    'php-extras',
    'php',
    'phpdoc',
    'plsql',
    'powerquery',
    'powershell',
    'processing',
    'prolog',
    'promql',
    'properties',
    'protobuf',
    'psl',
    'pug',
    'puppet',
    'pure',
    'purebasic',
    'purescript',
    'python',
    'q',
    'qml',
    'qore',
    'qsharp',
    'r',
    'racket',
    'reason',
    'regex',
    'rego',
    'renpy',
    'rest',
    'rip',
    'roboconf',
    'robotframework',
    'ruby',
    'rust',
    'sas',
    'sass',
    'scala',
    'scheme',
    'scss',
    'shell-session',
    'smali',
    'smalltalk',
    'smarty',
    'sml',
    'solidity',
    'solution-file',
    'soy',
    'sparql',
    'splunk-spl',
    'sqf',
    'sql',
    'squirrel',
    'stan',
    'stylus',
    'swift',
    'systemd',
    't4-cs',
    't4-templating',
    't4-vb',
    'tap',
    'tcl',
    'textile',
    'toml',
    'tremor',
    'tsx',
    'tt2',
    'turtle',
    'twig',
    'typescript',
    'typoscript',
    'unrealscript',
    'uorazor',
    'uri',
    'v',
    'vala',
    'vbnet',
    'velocity',
    'verilog',
    'vhdl',
    'vim',
    'visual-basic',
    'warpscript',
    'wasm',
    'web-idl',
    'wiki',
    'wolfram',
    'wren',
    'xeora',
    'xml-doc',
    'xojo',
    'xquery',
    'yaml',
    'yang',
    'zig'
];


var $d3fd299bfad8cd9f$var$highlighter = (0, $b94dbc74b29e9f13$export$2e2bcd8739ae039)((0, (/*@__PURE__*/$parcel$interopDefault($6755ad9567008392$exports))), (0, $55200e5f7077bb8a$export$2e2bcd8739ae039));
$d3fd299bfad8cd9f$var$highlighter.supportedLanguages = (0, $e6819ed1ebbd4778$export$2e2bcd8739ae039);
var $d3fd299bfad8cd9f$export$2e2bcd8739ae039 = $d3fd299bfad8cd9f$var$highlighter;


var $f4ae7f1b877c1baf$export$2e2bcd8739ae039 = {
    "code[class*=\"language-\"]": {
        "color": "#ccc",
        "background": "none",
        "fontFamily": "Consolas, Monaco, 'Andale Mono', 'Ubuntu Mono', monospace",
        "fontSize": "1em",
        "textAlign": "left",
        "whiteSpace": "pre",
        "wordSpacing": "normal",
        "wordBreak": "normal",
        "wordWrap": "normal",
        "lineHeight": "1.5",
        "MozTabSize": "4",
        "OTabSize": "4",
        "tabSize": "4",
        "WebkitHyphens": "none",
        "MozHyphens": "none",
        "msHyphens": "none",
        "hyphens": "none"
    },
    "pre[class*=\"language-\"]": {
        "color": "#ccc",
        "background": "#2d2d2d",
        "fontFamily": "Consolas, Monaco, 'Andale Mono', 'Ubuntu Mono', monospace",
        "fontSize": "1em",
        "textAlign": "left",
        "whiteSpace": "pre",
        "wordSpacing": "normal",
        "wordBreak": "normal",
        "wordWrap": "normal",
        "lineHeight": "1.5",
        "MozTabSize": "4",
        "OTabSize": "4",
        "tabSize": "4",
        "WebkitHyphens": "none",
        "MozHyphens": "none",
        "msHyphens": "none",
        "hyphens": "none",
        "padding": "1em",
        "margin": ".5em 0",
        "overflow": "auto"
    },
    ":not(pre) > code[class*=\"language-\"]": {
        "background": "#2d2d2d",
        "padding": ".1em",
        "borderRadius": ".3em",
        "whiteSpace": "normal"
    },
    "comment": {
        "color": "#999"
    },
    "block-comment": {
        "color": "#999"
    },
    "prolog": {
        "color": "#999"
    },
    "doctype": {
        "color": "#999"
    },
    "cdata": {
        "color": "#999"
    },
    "punctuation": {
        "color": "#ccc"
    },
    "tag": {
        "color": "#e2777a"
    },
    "attr-name": {
        "color": "#e2777a"
    },
    "namespace": {
        "color": "#e2777a"
    },
    "deleted": {
        "color": "#e2777a"
    },
    "function-name": {
        "color": "#6196cc"
    },
    "boolean": {
        "color": "#f08d49"
    },
    "number": {
        "color": "#f08d49"
    },
    "function": {
        "color": "#f08d49"
    },
    "property": {
        "color": "#f8c555"
    },
    "class-name": {
        "color": "#f8c555"
    },
    "constant": {
        "color": "#f8c555"
    },
    "symbol": {
        "color": "#f8c555"
    },
    "selector": {
        "color": "#cc99cd"
    },
    "important": {
        "color": "#cc99cd",
        "fontWeight": "bold"
    },
    "atrule": {
        "color": "#cc99cd"
    },
    "keyword": {
        "color": "#cc99cd"
    },
    "builtin": {
        "color": "#cc99cd"
    },
    "string": {
        "color": "#7ec699"
    },
    "char": {
        "color": "#7ec699"
    },
    "attr-value": {
        "color": "#7ec699"
    },
    "regex": {
        "color": "#7ec699"
    },
    "variable": {
        "color": "#7ec699"
    },
    "operator": {
        "color": "#67cdcc"
    },
    "entity": {
        "color": "#67cdcc",
        "cursor": "help"
    },
    "url": {
        "color": "#67cdcc"
    },
    "bold": {
        "fontWeight": "bold"
    },
    "italic": {
        "fontStyle": "italic"
    },
    "inserted": {
        "color": "green"
    }
};


function $41de2e525937c3d0$export$2e2bcd8739ae039({ scrap: scrap, onCardClick: onCardClick = ()=>{}, onDeleteClick: onDeleteClick = ()=>{} }) {
    const timestamp = scrap.created_at ? new Date(scrap.created_at).toLocaleString() : 'Just now';
    const [imgError, setImgError] = (0, $acw62.useState)(false);
    const [linkImgError, setLinkImgError] = (0, $acw62.useState)(false);
    (0, $acw62.useEffect)(()=>{
        setImgError(false);
    }, [
        scrap.image_url
    ]);
    (0, $acw62.useEffect)(()=>{
        setLinkImgError(false);
    }, [
        scrap.url,
        scrap.preview_image
    ]);
    (0, $acw62.useEffect)(()=>{
        if (scrap.embed_html && window.twttr?.widgets) window.twttr.widgets.load();
    }, [
        scrap.embed_html
    ]);
    const renderContent = ()=>{
        switch(scrap.type){
            case 'note':
                return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($41de2e525937c3d0$var$NoteContent, {
                    text: scrap.content
                });
            case 'image':
                return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($41de2e525937c3d0$var$ImageContent, {
                    src: scrap.image_url,
                    title: scrap.title
                });
            case 'link':
                {
                    const attemptDirectImage = !scrap.embed_html && !scrap.cfTitle;
                    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "p-5 flex-grow",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                                className: "font-bold mb-2 truncate text-gray-800",
                                children: scrap.title || scrap.url
                            }),
                            attemptDirectImage && !linkImgError && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($41de2e525937c3d0$var$SafeImg, {
                                src: scrap.url,
                                alt: scrap.title || 'Image',
                                className: "w-full h-32 object-cover rounded-lg",
                                setError: setLinkImgError
                            }),
                            linkImgError && scrap.embed_html && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "twitter-tweet-container",
                                dangerouslySetInnerHTML: {
                                    __html: scrap.embed_html
                                }
                            }),
                            linkImgError && !scrap.embed_html && scrap.cfTitle && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "bg-gray-100 p-4 rounded",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("h4", {
                                        className: "text-gray-800 font-semibold",
                                        children: [
                                            scrap.cfTitle,
                                            " (",
                                            scrap.cfRating,
                                            ")"
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                        className: "text-gray-600 text-sm mt-1",
                                        children: [
                                            "Tags: ",
                                            scrap.cfTags.join(', ')
                                        ]
                                    })
                                ]
                            }),
                            linkImgError && !scrap.embed_html && !scrap.cfTitle && scrap.preview_image && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($41de2e525937c3d0$var$SafeImg, {
                                src: scrap.preview_image,
                                alt: scrap.title || scrap.url,
                                className: "w-full h-32 object-cover rounded-lg",
                                setError: setLinkImgError
                            }),
                            linkImgError && !scrap.embed_html && !scrap.cfTitle && !scrap.preview_image && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("a", {
                                href: scrap.url,
                                target: "_blank",
                                rel: "noopener noreferrer",
                                className: "text-blue-600 hover:underline truncate block",
                                children: scrap.url
                            })
                        ]
                    });
                }
            case 'code':
                return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($41de2e525937c3d0$var$CodeContent, {
                    code: scrap.code,
                    language: scrap.language
                });
            default:
                return null;
        }
    };
    const clickable = scrap.type !== 'link';
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: " scrap-card bg-white rounded-xl shadow-md flex flex-col overflow-hidden border border-gray-200 hover:border-blue-500 transition cursor-pointer ",
        onClick: ()=>clickable && onCardClick(scrap),
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "flex flex-col flex-grow min-h-0",
                children: renderContent()
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "bg-white p-3 flex justify-between items-center border-t border-gray-200",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        className: "text-xs text-gray-500",
                        children: timestamp
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                        type: "button",
                        onClick: (e)=>{
                            e.stopPropagation();
                            console.log('Deleting:', scrap.id);
                            onDeleteClick(scrap.id);
                        },
                        className: "text-gray-500 hover:text-red-600 p-1 rounded-full hover:bg-red-100 cursor-pointer",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("svg", {
                            className: "w-5 h-5",
                            fill: "none",
                            stroke: "currentColor",
                            viewBox: "0 0 24 24",
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                strokeLinecap: "round",
                                strokeLinejoin: "round",
                                strokeWidth: "2",
                                d: "M6 18L18 6M6 6l12 12"
                            })
                        })
                    })
                ]
            })
        ]
    });
}
/* -------------------- independent containers -------------------- */ // New component for truncated and highlighted code
function $41de2e525937c3d0$var$CodeContent({ code: code, language: language }) {
    const LINES_TO_SHOW = 5;
    const codeLines = code.split('\n');
    const isTruncated = codeLines.length > LINES_TO_SHOW;
    const displayCode = isTruncated ? codeLines.slice(0, LINES_TO_SHOW).join('\n') + '\n...' : code;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: "p-4 flex-grow bg-gray-900 rounded-lg text-white",
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $d3fd299bfad8cd9f$export$2e2bcd8739ae039), {
            language: language || 'text',
            style: (0, $f4ae7f1b877c1baf$export$2e2bcd8739ae039),
            customStyle: {
                background: 'transparent',
                padding: 0,
                margin: 0,
                overflow: 'hidden',
                maxHeight: `${LINES_TO_SHOW * 1.5}rem`
            },
            children: displayCode
        })
    });
}
// Reusable image component for consistency
function $41de2e525937c3d0$var$ImageContent({ src: src, title: title }) {
    const [imgError, setImgError] = (0, $acw62.useState)(false);
    const SafeImg = ({ src: src, alt: alt, className: className })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
            src: src,
            alt: alt,
            className: className,
            onError: ()=>setImgError(true),
            onLoad: ()=>setImgError(false)
        });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "p-5 flex-grow",
        children: [
            !imgError ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "w-full max-h-48 overflow-hidden rounded-lg",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(SafeImg, {
                    src: src,
                    alt: title || 'Image',
                    className: "w-full h-full object-cover"
                })
            }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "w-full h-48 flex items-center justify-center bg-gray-100 rounded-lg",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                    className: "text-gray-500",
                    children: "Image not available"
                })
            }),
            title && !imgError && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                className: "text-gray-800 mt-2 truncate",
                children: title
            })
        ]
    });
}
// Existing NoteContent for consistency
function $41de2e525937c3d0$var$NoteContent({ text: text }) {
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: "p-5 flex-grow",
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
            style: {
                display: '-webkit-box',
                WebkitBoxOrient: 'vertical',
                WebkitLineClamp: 3,
                overflow: 'hidden',
                textOverflow: 'ellipsis'
            },
            className: "text-gray-800",
            children: text
        })
    });
}
// Existing SafeImg component, now internal to the main component
const $41de2e525937c3d0$var$SafeImg = ({ src: src, alt: alt, className: className, setError: setError })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
        src: src,
        alt: alt,
        className: className,
        onError: ()=>setError(true),
        onLoad: ()=>setError(false)
    });




var $acw62 = parcelRequire("acw62");

var $c055f0430a1d27c8$export$2e2bcd8739ae039 = {
    "code[class*=\"language-\"]": {
        "color": "#f8f8f2",
        "background": "none",
        "textShadow": "0 1px rgba(0, 0, 0, 0.3)",
        "fontFamily": "Consolas, Monaco, 'Andale Mono', 'Ubuntu Mono', monospace",
        "textAlign": "left",
        "whiteSpace": "pre",
        "wordSpacing": "normal",
        "wordBreak": "normal",
        "wordWrap": "normal",
        "lineHeight": "1.5",
        "MozTabSize": "4",
        "OTabSize": "4",
        "tabSize": "4",
        "WebkitHyphens": "none",
        "MozHyphens": "none",
        "msHyphens": "none",
        "hyphens": "none"
    },
    "pre[class*=\"language-\"]": {
        "color": "#f8f8f2",
        "background": "#282a36",
        "textShadow": "0 1px rgba(0, 0, 0, 0.3)",
        "fontFamily": "Consolas, Monaco, 'Andale Mono', 'Ubuntu Mono', monospace",
        "textAlign": "left",
        "whiteSpace": "pre",
        "wordSpacing": "normal",
        "wordBreak": "normal",
        "wordWrap": "normal",
        "lineHeight": "1.5",
        "MozTabSize": "4",
        "OTabSize": "4",
        "tabSize": "4",
        "WebkitHyphens": "none",
        "MozHyphens": "none",
        "msHyphens": "none",
        "hyphens": "none",
        "padding": "1em",
        "margin": ".5em 0",
        "overflow": "auto",
        "borderRadius": "0.3em"
    },
    ":not(pre) > code[class*=\"language-\"]": {
        "background": "#282a36",
        "padding": ".1em",
        "borderRadius": ".3em",
        "whiteSpace": "normal"
    },
    "comment": {
        "color": "#6272a4"
    },
    "prolog": {
        "color": "#6272a4"
    },
    "doctype": {
        "color": "#6272a4"
    },
    "cdata": {
        "color": "#6272a4"
    },
    "punctuation": {
        "color": "#f8f8f2"
    },
    ".namespace": {
        "Opacity": ".7"
    },
    "property": {
        "color": "#ff79c6"
    },
    "tag": {
        "color": "#ff79c6"
    },
    "constant": {
        "color": "#ff79c6"
    },
    "symbol": {
        "color": "#ff79c6"
    },
    "deleted": {
        "color": "#ff79c6"
    },
    "boolean": {
        "color": "#bd93f9"
    },
    "number": {
        "color": "#bd93f9"
    },
    "selector": {
        "color": "#50fa7b"
    },
    "attr-name": {
        "color": "#50fa7b"
    },
    "string": {
        "color": "#50fa7b"
    },
    "char": {
        "color": "#50fa7b"
    },
    "builtin": {
        "color": "#50fa7b"
    },
    "inserted": {
        "color": "#50fa7b"
    },
    "operator": {
        "color": "#f8f8f2"
    },
    "entity": {
        "color": "#f8f8f2",
        "cursor": "help"
    },
    "url": {
        "color": "#f8f8f2"
    },
    ".language-css .token.string": {
        "color": "#f8f8f2"
    },
    ".style .token.string": {
        "color": "#f8f8f2"
    },
    "variable": {
        "color": "#f8f8f2"
    },
    "atrule": {
        "color": "#f1fa8c"
    },
    "attr-value": {
        "color": "#f1fa8c"
    },
    "function": {
        "color": "#f1fa8c"
    },
    "class-name": {
        "color": "#f1fa8c"
    },
    "keyword": {
        "color": "#8be9fd"
    },
    "regex": {
        "color": "#ffb86c"
    },
    "important": {
        "color": "#ffb86c",
        "fontWeight": "bold"
    },
    "bold": {
        "fontWeight": "bold"
    },
    "italic": {
        "fontStyle": "italic"
    }
};


function $3d98f708848f1f0f$export$2e2bcd8739ae039({ scrap: scrap, onClose: onClose }) {
    if (!scrap) return null;
    (0, $acw62.useEffect)(()=>{
        const onKey = (e)=>e.key === 'Escape' && onClose();
        document.addEventListener('keydown', onKey);
        const prev = document.body.style.overflow;
        document.body.style.overflow = 'hidden';
        return ()=>{
            document.removeEventListener('keydown', onKey);
            document.body.style.overflow = prev;
        };
    }, [
        onClose
    ]);
    const title = scrap && scrap.title || (scrap.type === 'code' ? scrap.language : undefined) || scrap.type.charAt(0).toUpperCase() + scrap.type.slice(1);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: "fixed inset-0 z-[100] flex items-center justify-center p-4 bg-black/60 backdrop-blur-[2px]",
        onClick: onClose,
        "aria-modal": "true",
        role: "dialog",
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
            className: "w-full max-w-3xl max-h-[90vh] overflow-hidden",
            onClick: (e)=>e.stopPropagation(),
            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "bg-white text-gray-900 rounded-2xl border border-gray-200 shadow-lg",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "px-5 py-4 border-b border-gray-200 flex items-center justify-between",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                                className: "text-lg font-semibold truncate",
                                children: title
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                onClick: onClose,
                                "aria-label": "Close",
                                className: "p-2 rounded-lg hover:bg-gray-100 text-gray-500 hover:text-gray-800 transition",
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("svg", {
                                    className: "w-5 h-5",
                                    fill: "none",
                                    stroke: "currentColor",
                                    viewBox: "0 0 24 24",
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                        strokeLinecap: "round",
                                        strokeLinejoin: "round",
                                        strokeWidth: "2",
                                        d: "M6 18L18 6M6 6l12 12"
                                    })
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "p-6 overflow-y-auto",
                        children: [
                            scrap.type === 'note' && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($3d98f708848f1f0f$var$NoteContent, {
                                text: scrap.content
                            }),
                            scrap.type === 'code' && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($3d98f708848f1f0f$var$CodeContent, {
                                code: scrap.code,
                                language: scrap.language
                            }),
                            scrap.type === 'image' && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($3d98f708848f1f0f$var$ImageContent, {
                                src: scrap.image_url || scrap.imageUrl,
                                alt: title || 'Image'
                            })
                        ]
                    })
                ]
            })
        })
    });
}
// -------------------- independent containers --------------------
function $3d98f708848f1f0f$var$NoteContent({ text: text }) {
    const LINES = 10;
    const LINE_PX = 28;
    const [expanded, setExpanded] = (0, $acw62.useState)(false);
    const [overflow, setOverflow] = (0, $acw62.useState)(false);
    const [maxHeight, setMaxHeight] = (0, $acw62.useState)(`${LINES * LINE_PX}px`);
    const pId = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useId();
    (0, $acw62.useEffect)(()=>{
        setExpanded(false);
    }, [
        text
    ]);
    (0, $acw62.useEffect)(()=>{
        const el = document.getElementById(pId);
        if (!el) return;
        const prev = el.style.maxHeight;
        el.style.maxHeight = 'none';
        const full = el.scrollHeight;
        const clampH = LINES * LINE_PX;
        setOverflow(full > clampH + 1);
        el.style.maxHeight = expanded ? 'none' : `${clampH}px`;
        setMaxHeight(expanded ? 'none' : `${clampH}px`);
        return ()=>{
            el.style.maxHeight = prev;
        };
    }, [
        text,
        expanded,
        pId
    ]);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "rounded-2xl border border-gray-200 bg-white p-4",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "relative",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                        id: pId,
                        className: "text-[15px] leading-7 text-gray-800 whitespace-pre-wrap break-words",
                        style: {
                            maxHeight: maxHeight,
                            overflow: 'hidden'
                        },
                        children: text
                    }),
                    !expanded && overflow && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "pointer-events-none absolute bottom-0 left-0 right-0 h-10 bg-gradient-to-t from-white to-transparent"
                    })
                ]
            }),
            overflow && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                className: "mt-3 text-sm text-blue-600 hover:underline",
                onClick: ()=>setExpanded((v)=>!v),
                children: expanded ? 'Show less' : 'Show more'
            })
        ]
    });
}
/* Code content with truncation and syntax highlighting */ function $3d98f708848f1f0f$var$CodeContent({ code: code, language: language }) {
    const [expanded, setExpanded] = (0, $acw62.useState)(false);
    const LINES = 15; // Set a line limit for truncation
    const codeLines = code.split('\n');
    const shouldTruncate = codeLines.length > LINES;
    const displayedCode = expanded ? code : codeLines.slice(0, LINES).join('\n');
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "rounded-2xl border border-gray-200 bg-white overflow-hidden",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "bg-[#111214] text-white text-[13px] leading-6 rounded-2xl m-0 overflow-x-auto",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $d3fd299bfad8cd9f$export$2e2bcd8739ae039), {
                    language: language,
                    style: (0, $c055f0430a1d27c8$export$2e2bcd8739ae039),
                    showLineNumbers: true,
                    customStyle: {
                        maxHeight: expanded ? '65vh' : `${LINES * 24}px`,
                        overflowY: expanded ? 'auto' : 'hidden',
                        padding: '1rem',
                        backgroundColor: 'transparent',
                        margin: 0
                    },
                    children: displayedCode
                })
            }),
            shouldTruncate && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                className: "w-full mt-2 py-2 text-sm text-blue-600 hover:bg-gray-100 transition rounded-b-2xl",
                onClick: ()=>setExpanded(!expanded),
                children: expanded ? 'Show less' : 'Show more'
            })
        ]
    });
}
/*  in-modal image preview */ function $3d98f708848f1f0f$var$ImageContent({ src: src, alt: alt }) {
    const [broken, setBroken] = (0, $acw62.useState)(false);
    const url = src;
    if (!url) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: "rounded-2xl border border-gray-200 bg-white p-4 text-sm text-gray-600",
        children: "No image URL provided."
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: "rounded-2xl border border-gray-200 bg-white overflow-hidden",
        style: {
            minHeight: 260,
            maxHeight: '65vh'
        },
        children: !broken ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
            src: url,
            alt: alt,
            className: "block w-full h-full object-contain mx-auto select-none",
            onError: ()=>setBroken(true),
            draggable: false,
            style: {
                maxHeight: '60vh'
            }
        }, url) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
            className: "flex items-center justify-center h-[260px] text-sm text-gray-500",
            children: "Image failed to load"
        })
    });
}


// // src/hooks/useScraps.js

var $acw62 = parcelRequire("acw62");

function $97b4b2def9b837aa$export$2e2bcd8739ae039() {
    const [scraps, setScraps] = (0, $acw62.useState)([]);
    const [loading, setLoading] = (0, $acw62.useState)(true);
    const userId = (0, $6a4ffa14d090abce$export$1617268687ac763c)(); // or supabase.auth.user().id
    (0, $acw62.useEffect)(()=>{
        if (!userId) return;
        // 1) Fetch only this user's scraps
        (0, $6a4ffa14d090abce$export$a0b632a28672d3c0).from('scraps').select('*').eq('user_id', userId).order('created_at', {
            ascending: false
        }).then(({ data: data })=>{
            setScraps(data ?? []);
            setLoading(false);
        });
        // 2) Subscribe only to this user's inserts
        const channel = (0, $6a4ffa14d090abce$export$a0b632a28672d3c0).channel(`realtime:scraps:user=${userId}`).on('postgres_changes', {
            event: 'INSERT',
            schema: 'public',
            table: 'scraps',
            filter: `user_id=eq.${userId}`
        }, ({ new: newScrap })=>{
            setScraps((prev)=>[
                    newScrap,
                    ...prev
                ]);
        }).subscribe();
        return ()=>{
            (0, $6a4ffa14d090abce$export$a0b632a28672d3c0).removeChannel(channel);
        };
    }, [
        userId
    ]);
    const addScrap = async (scrap)=>{
        // ensure you include user_id in the record
        const { data: data, error: error } = await (0, $6a4ffa14d090abce$export$a0b632a28672d3c0).from('scraps').insert({
            ...scrap,
            user_id: userId
        }).select().single();
        if (!error && data) setScraps((prev)=>[
                data,
                ...prev
            ]);
        return {
            data: data,
            error: error
        };
    };
    const deleteScrap = async (id)=>{
        await (0, $6a4ffa14d090abce$export$a0b632a28672d3c0).from('scraps').delete().eq('id', id).eq('user_id', userId); // extra safety
        setScraps((prev)=>prev.filter((s)=>s.id !== id));
    };
    return {
        scraps: scraps,
        loading: loading,
        addScrap: addScrap,
        deleteScrap: deleteScrap
    };
}



function $1b8e0994176c9ade$export$2e2bcd8739ae039() {
    const { scraps: scraps, addScrap: addScrap, deleteScrap: deleteScrap } = (0, $97b4b2def9b837aa$export$2e2bcd8739ae039)();
    const [selectedScrap, setSelectedScrap] = (0, $acw62.useState)(null);
    const handleCardClick = (scrap)=>{
        setSelectedScrap(scrap);
    };
    const handleDeleteClick = (id)=>{
        deleteScrap(id);
    };
    const handleCloseModal = ()=>{
        setSelectedScrap(null);
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "min-h-screen bg-gray-50 text-gray-900",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "max-w-5xl mx-auto p-6",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("header", {
                        className: "mb-8",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h1", {
                                className: "text-4xl font-extrabold",
                                children: " Curations. "
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                className: "mt-2 text-gray-500",
                                children: "Save your notes, images, links & code snippets."
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("section", {
                        className: "mb-10",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f9e32f66a2bf4d69$export$2e2bcd8739ae039), {
                            onAdd: addScrap
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("section", {
                        children: scraps.length > 0 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                            className: "grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6",
                            children: scraps.map((scrap)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $41de2e525937c3d0$export$2e2bcd8739ae039), {
                                    scrap: scrap,
                                    onCardClick: handleCardClick,
                                    onDeleteClick: handleDeleteClick
                                }, scrap.id))
                        }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                            className: "text-gray-500",
                            children: "No scraps yet. Add one above!"
                        })
                    })
                ]
            }),
            selectedScrap && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3d98f708848f1f0f$export$2e2bcd8739ae039), {
                scrap: selectedScrap,
                onClose: handleCloseModal
            })
        ]
    });
}



const $39d14b5bb153e2a5$var$root = (0, $7e96a608cb33bf79$export$882461b6382ed46c)(document.getElementById('root'));
$39d14b5bb153e2a5$var$root.render(/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1b8e0994176c9ade$export$2e2bcd8739ae039), {}));


//# sourceMappingURL=public.e55a99d8.js.map
